/*! For license information please see salesteam-bo.js.LICENSE.txt */
!(function () {
  var e,
    t,
    n = {
      5053: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return re;
          },
        });
        var r = (function () {
            function e(e) {
              var t = this;
              (this._insertTag = function (e) {
                var n;
                (n =
                  0 === t.tags.length
                    ? t.insertionPoint
                      ? t.insertionPoint.nextSibling
                      : t.prepend
                      ? t.container.firstChild
                      : t.before
                    : t.tags[t.tags.length - 1].nextSibling),
                  t.container.insertBefore(e, n),
                  t.tags.push(e);
              }),
                (this.isSpeedy = void 0 === e.speedy || e.speedy),
                (this.tags = []),
                (this.ctr = 0),
                (this.nonce = e.nonce),
                (this.key = e.key),
                (this.container = e.container),
                (this.prepend = e.prepend),
                (this.insertionPoint = e.insertionPoint),
                (this.before = null);
            }
            var t = e.prototype;
            return (
              (t.hydrate = function (e) {
                e.forEach(this._insertTag);
              }),
              (t.insert = function (e) {
                this.ctr % (this.isSpeedy ? 65e3 : 1) == 0 &&
                  this._insertTag(
                    (function (e) {
                      var t = document.createElement("style");
                      return (
                        t.setAttribute("data-emotion", e.key),
                        void 0 !== e.nonce && t.setAttribute("nonce", e.nonce),
                        t.appendChild(document.createTextNode("")),
                        t.setAttribute("data-s", ""),
                        t
                      );
                    })(this)
                  );
                var t = this.tags[this.tags.length - 1];
                if (this.isSpeedy) {
                  var n = (function (e) {
                    if (e.sheet) return e.sheet;
                    for (var t = 0; t < document.styleSheets.length; t++)
                      if (document.styleSheets[t].ownerNode === e)
                        return document.styleSheets[t];
                  })(t);
                  try {
                    n.insertRule(e, n.cssRules.length);
                  } catch (e) {}
                } else t.appendChild(document.createTextNode(e));
                this.ctr++;
              }),
              (t.flush = function () {
                this.tags.forEach(function (e) {
                  var t;
                  return null == (t = e.parentNode) ? void 0 : t.removeChild(e);
                }),
                  (this.tags = []),
                  (this.ctr = 0);
              }),
              e
            );
          })(),
          o = Math.abs,
          a = String.fromCharCode,
          i = Object.assign;
        function s(e) {
          return e.trim();
        }
        function l(e, t, n) {
          return e.replace(t, n);
        }
        function d(e, t) {
          return e.indexOf(t);
        }
        function c(e, t) {
          return 0 | e.charCodeAt(t);
        }
        function u(e, t, n) {
          return e.slice(t, n);
        }
        function p(e) {
          return e.length;
        }
        function m(e) {
          return e.length;
        }
        function h(e, t) {
          return t.push(e), e;
        }
        var f = 1,
          g = 1,
          v = 0,
          b = 0,
          _ = 0,
          y = "";
        function C(e, t, n, r, o, a, i) {
          return {
            value: e,
            root: t,
            parent: n,
            type: r,
            props: o,
            children: a,
            line: f,
            column: g,
            length: i,
            return: "",
          };
        }
        function x(e, t) {
          return i(
            C("", null, null, "", null, null, 0),
            e,
            { length: -e.length },
            t
          );
        }
        function S() {
          return (
            (_ = b > 0 ? c(y, --b) : 0), g--, 10 === _ && ((g = 1), f--), _
          );
        }
        function k() {
          return (
            (_ = b < v ? c(y, b++) : 0), g++, 10 === _ && ((g = 1), f++), _
          );
        }
        function P() {
          return c(y, b);
        }
        function w() {
          return b;
        }
        function O(e, t) {
          return u(y, e, t);
        }
        function T(e) {
          switch (e) {
            case 0:
            case 9:
            case 10:
            case 13:
            case 32:
              return 5;
            case 33:
            case 43:
            case 44:
            case 47:
            case 62:
            case 64:
            case 126:
            case 59:
            case 123:
            case 125:
              return 4;
            case 58:
              return 3;
            case 34:
            case 39:
            case 40:
            case 91:
              return 2;
            case 41:
            case 93:
              return 1;
          }
          return 0;
        }
        function I(e) {
          return (f = g = 1), (v = p((y = e))), (b = 0), [];
        }
        function M(e) {
          return (y = ""), e;
        }
        function j(e) {
          return s(O(b - 1, A(91 === e ? e + 2 : 40 === e ? e + 1 : e)));
        }
        function N(e) {
          for (; (_ = P()) && _ < 33; ) k();
          return T(e) > 2 || T(_) > 3 ? "" : " ";
        }
        function D(e, t) {
          for (
            ;
            --t &&
            k() &&
            !(_ < 48 || _ > 102 || (_ > 57 && _ < 65) || (_ > 70 && _ < 97));

          );
          return O(e, w() + (t < 6 && 32 == P() && 32 == k()));
        }
        function A(e) {
          for (; k(); )
            switch (_) {
              case e:
                return b;
              case 34:
              case 39:
                34 !== e && 39 !== e && A(_);
                break;
              case 40:
                41 === e && A(e);
                break;
              case 92:
                k();
            }
          return b;
        }
        function E(e, t) {
          for (; k() && e + _ !== 57 && (e + _ !== 84 || 47 !== P()); );
          return "/*" + O(t, b - 1) + "*" + a(47 === e ? e : k());
        }
        function R(e) {
          for (; !T(P()); ) k();
          return O(e, b);
        }
        var L = "-ms-",
          B = "-moz-",
          z = "-webkit-",
          F = "comm",
          Z = "rule",
          H = "decl",
          V = "@keyframes";
        function W(e, t) {
          for (var n = "", r = m(e), o = 0; o < r; o++)
            n += t(e[o], o, e, t) || "";
          return n;
        }
        function U(e, t, n, r) {
          switch (e.type) {
            case "@layer":
              if (e.children.length) break;
            case "@import":
            case H:
              return (e.return = e.return || e.value);
            case F:
              return "";
            case V:
              return (e.return = e.value + "{" + W(e.children, r) + "}");
            case Z:
              e.value = e.props.join(",");
          }
          return p((n = W(e.children, r)))
            ? (e.return = e.value + "{" + n + "}")
            : "";
        }
        function $(e) {
          return M(K("", null, null, null, [""], (e = I(e)), 0, [0], e));
        }
        function K(e, t, n, r, o, i, s, u, m) {
          for (
            var f = 0,
              g = 0,
              v = s,
              b = 0,
              _ = 0,
              y = 0,
              C = 1,
              x = 1,
              O = 1,
              T = 0,
              I = "",
              M = o,
              A = i,
              L = r,
              B = I;
            x;

          )
            switch (((y = T), (T = k()))) {
              case 40:
                if (108 != y && 58 == c(B, v - 1)) {
                  -1 != d((B += l(j(T), "&", "&\f")), "&\f") && (O = -1);
                  break;
                }
              case 34:
              case 39:
              case 91:
                B += j(T);
                break;
              case 9:
              case 10:
              case 13:
              case 32:
                B += N(y);
                break;
              case 92:
                B += D(w() - 1, 7);
                continue;
              case 47:
                switch (P()) {
                  case 42:
                  case 47:
                    h(q(E(k(), w()), t, n), m);
                    break;
                  default:
                    B += "/";
                }
                break;
              case 123 * C:
                u[f++] = p(B) * O;
              case 125 * C:
              case 59:
              case 0:
                switch (T) {
                  case 0:
                  case 125:
                    x = 0;
                  case 59 + g:
                    -1 == O && (B = l(B, /\f/g, "")),
                      _ > 0 &&
                        p(B) - v &&
                        h(
                          _ > 32
                            ? Q(B + ";", r, n, v - 1)
                            : Q(l(B, " ", "") + ";", r, n, v - 2),
                          m
                        );
                    break;
                  case 59:
                    B += ";";
                  default:
                    if (
                      (h(
                        (L = G(B, t, n, f, g, o, u, I, (M = []), (A = []), v)),
                        i
                      ),
                      123 === T)
                    )
                      if (0 === g) K(B, t, L, L, M, i, v, u, A);
                      else
                        switch (99 === b && 110 === c(B, 3) ? 100 : b) {
                          case 100:
                          case 108:
                          case 109:
                          case 115:
                            K(
                              e,
                              L,
                              L,
                              r &&
                                h(G(e, L, L, 0, 0, o, u, I, o, (M = []), v), A),
                              o,
                              A,
                              v,
                              u,
                              r ? M : A
                            );
                            break;
                          default:
                            K(B, L, L, L, [""], A, 0, u, A);
                        }
                }
                (f = g = _ = 0), (C = O = 1), (I = B = ""), (v = s);
                break;
              case 58:
                (v = 1 + p(B)), (_ = y);
              default:
                if (C < 1)
                  if (123 == T) --C;
                  else if (125 == T && 0 == C++ && 125 == S()) continue;
                switch (((B += a(T)), T * C)) {
                  case 38:
                    O = g > 0 ? 1 : ((B += "\f"), -1);
                    break;
                  case 44:
                    (u[f++] = (p(B) - 1) * O), (O = 1);
                    break;
                  case 64:
                    45 === P() && (B += j(k())),
                      (b = P()),
                      (g = v = p((I = B += R(w())))),
                      T++;
                    break;
                  case 45:
                    45 === y && 2 == p(B) && (C = 0);
                }
            }
          return i;
        }
        function G(e, t, n, r, a, i, d, c, p, h, f) {
          for (
            var g = a - 1,
              v = 0 === a ? i : [""],
              b = m(v),
              _ = 0,
              y = 0,
              x = 0;
            _ < r;
            ++_
          )
            for (
              var S = 0, k = u(e, g + 1, (g = o((y = d[_])))), P = e;
              S < b;
              ++S
            )
              (P = s(y > 0 ? v[S] + " " + k : l(k, /&\f/g, v[S]))) &&
                (p[x++] = P);
          return C(e, t, n, 0 === a ? Z : c, p, h, f);
        }
        function q(e, t, n) {
          return C(e, t, n, F, a(_), u(e, 2, -2), 0);
        }
        function Q(e, t, n, r) {
          return C(e, t, n, H, u(e, 0, r), u(e, r + 1, -1), r);
        }
        var Y = function (e, t, n) {
            for (
              var r = 0, o = 0;
              (r = o), (o = P()), 38 === r && 12 === o && (t[n] = 1), !T(o);

            )
              k();
            return O(e, b);
          },
          J = new WeakMap(),
          X = function (e) {
            if ("rule" === e.type && e.parent && !(e.length < 1)) {
              for (
                var t = e.value,
                  n = e.parent,
                  r = e.column === n.column && e.line === n.line;
                "rule" !== n.type;

              )
                if (!(n = n.parent)) return;
              if (
                (1 !== e.props.length || 58 === t.charCodeAt(0) || J.get(n)) &&
                !r
              ) {
                J.set(e, !0);
                for (
                  var o = [],
                    i = (function (e, t) {
                      return M(
                        (function (e, t) {
                          var n = -1,
                            r = 44;
                          do {
                            switch (T(r)) {
                              case 0:
                                38 === r && 12 === P() && (t[n] = 1),
                                  (e[n] += Y(b - 1, t, n));
                                break;
                              case 2:
                                e[n] += j(r);
                                break;
                              case 4:
                                if (44 === r) {
                                  (e[++n] = 58 === P() ? "&\f" : ""),
                                    (t[n] = e[n].length);
                                  break;
                                }
                              default:
                                e[n] += a(r);
                            }
                          } while ((r = k()));
                          return e;
                        })(I(e), t)
                      );
                    })(t, o),
                    s = n.props,
                    l = 0,
                    d = 0;
                  l < i.length;
                  l++
                )
                  for (var c = 0; c < s.length; c++, d++)
                    e.props[d] = o[l]
                      ? i[l].replace(/&\f/g, s[c])
                      : s[c] + " " + i[l];
              }
            }
          },
          ee = function (e) {
            if ("decl" === e.type) {
              var t = e.value;
              108 === t.charCodeAt(0) &&
                98 === t.charCodeAt(2) &&
                ((e.return = ""), (e.value = ""));
            }
          };
        function te(e, t) {
          switch (
            (function (e, t) {
              return 45 ^ c(e, 0)
                ? (((((((t << 2) ^ c(e, 0)) << 2) ^ c(e, 1)) << 2) ^ c(e, 2)) <<
                    2) ^
                    c(e, 3)
                : 0;
            })(e, t)
          ) {
            case 5103:
              return z + "print-" + e + e;
            case 5737:
            case 4201:
            case 3177:
            case 3433:
            case 1641:
            case 4457:
            case 2921:
            case 5572:
            case 6356:
            case 5844:
            case 3191:
            case 6645:
            case 3005:
            case 6391:
            case 5879:
            case 5623:
            case 6135:
            case 4599:
            case 4855:
            case 4215:
            case 6389:
            case 5109:
            case 5365:
            case 5621:
            case 3829:
              return z + e + e;
            case 5349:
            case 4246:
            case 4810:
            case 6968:
            case 2756:
              return z + e + B + e + L + e + e;
            case 6828:
            case 4268:
              return z + e + L + e + e;
            case 6165:
              return z + e + L + "flex-" + e + e;
            case 5187:
              return (
                z +
                e +
                l(e, /(\w+).+(:[^]+)/, z + "box-$1$2" + L + "flex-$1$2") +
                e
              );
            case 5443:
              return z + e + L + "flex-item-" + l(e, /flex-|-self/, "") + e;
            case 4675:
              return (
                z +
                e +
                L +
                "flex-line-pack" +
                l(e, /align-content|flex-|-self/, "") +
                e
              );
            case 5548:
              return z + e + L + l(e, "shrink", "negative") + e;
            case 5292:
              return z + e + L + l(e, "basis", "preferred-size") + e;
            case 6060:
              return (
                z +
                "box-" +
                l(e, "-grow", "") +
                z +
                e +
                L +
                l(e, "grow", "positive") +
                e
              );
            case 4554:
              return z + l(e, /([^-])(transform)/g, "$1" + z + "$2") + e;
            case 6187:
              return (
                l(
                  l(l(e, /(zoom-|grab)/, z + "$1"), /(image-set)/, z + "$1"),
                  e,
                  ""
                ) + e
              );
            case 5495:
            case 3959:
              return l(e, /(image-set\([^]*)/, z + "$1$`$1");
            case 4968:
              return (
                l(
                  l(
                    e,
                    /(.+:)(flex-)?(.*)/,
                    z + "box-pack:$3" + L + "flex-pack:$3"
                  ),
                  /s.+-b[^;]+/,
                  "justify"
                ) +
                z +
                e +
                e
              );
            case 4095:
            case 3583:
            case 4068:
            case 2532:
              return l(e, /(.+)-inline(.+)/, z + "$1$2") + e;
            case 8116:
            case 7059:
            case 5753:
            case 5535:
            case 5445:
            case 5701:
            case 4933:
            case 4677:
            case 5533:
            case 5789:
            case 5021:
            case 4765:
              if (p(e) - 1 - t > 6)
                switch (c(e, t + 1)) {
                  case 109:
                    if (45 !== c(e, t + 4)) break;
                  case 102:
                    return (
                      l(
                        e,
                        /(.+:)(.+)-([^]+)/,
                        "$1" +
                          z +
                          "$2-$3$1" +
                          B +
                          (108 == c(e, t + 3) ? "$3" : "$2-$3")
                      ) + e
                    );
                  case 115:
                    return ~d(e, "stretch")
                      ? te(l(e, "stretch", "fill-available"), t) + e
                      : e;
                }
              break;
            case 4949:
              if (115 !== c(e, t + 1)) break;
            case 6444:
              switch (c(e, p(e) - 3 - (~d(e, "!important") && 10))) {
                case 107:
                  return l(e, ":", ":" + z) + e;
                case 101:
                  return (
                    l(
                      e,
                      /(.+:)([^;!]+)(;|!.+)?/,
                      "$1" +
                        z +
                        (45 === c(e, 14) ? "inline-" : "") +
                        "box$3$1" +
                        z +
                        "$2$3$1" +
                        L +
                        "$2box$3"
                    ) + e
                  );
              }
              break;
            case 5936:
              switch (c(e, t + 11)) {
                case 114:
                  return z + e + L + l(e, /[svh]\w+-[tblr]{2}/, "tb") + e;
                case 108:
                  return z + e + L + l(e, /[svh]\w+-[tblr]{2}/, "tb-rl") + e;
                case 45:
                  return z + e + L + l(e, /[svh]\w+-[tblr]{2}/, "lr") + e;
              }
              return z + e + L + e + e;
          }
          return e;
        }
        var ne = [
            function (e, t, n, r) {
              if (e.length > -1 && !e.return)
                switch (e.type) {
                  case H:
                    e.return = te(e.value, e.length);
                    break;
                  case V:
                    return W([x(e, { value: l(e.value, "@", "@" + z) })], r);
                  case Z:
                    if (e.length)
                      return (function (e, t) {
                        return e.map(t).join("");
                      })(e.props, function (t) {
                        switch (
                          (function (e, t) {
                            return (e = /(::plac\w+|:read-\w+)/.exec(e))
                              ? e[0]
                              : e;
                          })(t)
                        ) {
                          case ":read-only":
                          case ":read-write":
                            return W(
                              [
                                x(e, {
                                  props: [l(t, /:(read-\w+)/, ":-moz-$1")],
                                }),
                              ],
                              r
                            );
                          case "::placeholder":
                            return W(
                              [
                                x(e, {
                                  props: [
                                    l(t, /:(plac\w+)/, ":" + z + "input-$1"),
                                  ],
                                }),
                                x(e, {
                                  props: [l(t, /:(plac\w+)/, ":-moz-$1")],
                                }),
                                x(e, {
                                  props: [l(t, /:(plac\w+)/, L + "input-$1")],
                                }),
                              ],
                              r
                            );
                        }
                        return "";
                      });
                }
            },
          ],
          re = function (e) {
            var t = e.key;
            if ("css" === t) {
              var n = document.querySelectorAll(
                "style[data-emotion]:not([data-s])"
              );
              Array.prototype.forEach.call(n, function (e) {
                -1 !== e.getAttribute("data-emotion").indexOf(" ") &&
                  (document.head.appendChild(e), e.setAttribute("data-s", ""));
              });
            }
            var o,
              a,
              i = e.stylisPlugins || ne,
              s = {},
              l = [];
            (o = e.container || document.head),
              Array.prototype.forEach.call(
                document.querySelectorAll('style[data-emotion^="' + t + ' "]'),
                function (e) {
                  for (
                    var t = e.getAttribute("data-emotion").split(" "), n = 1;
                    n < t.length;
                    n++
                  )
                    s[t[n]] = !0;
                  l.push(e);
                }
              );
            var d,
              c,
              u,
              p,
              h = [
                U,
                ((p = function (e) {
                  d.insert(e);
                }),
                function (e) {
                  e.root || ((e = e.return) && p(e));
                }),
              ],
              f =
                ((c = [X, ee].concat(i, h)),
                (u = m(c)),
                function (e, t, n, r) {
                  for (var o = "", a = 0; a < u; a++)
                    o += c[a](e, t, n, r) || "";
                  return o;
                });
            a = function (e, t, n, r) {
              (d = n),
                W($(e ? e + "{" + t.styles + "}" : t.styles), f),
                r && (g.inserted[t.name] = !0);
            };
            var g = {
              key: t,
              sheet: new r({
                key: t,
                container: o,
                nonce: e.nonce,
                speedy: e.speedy,
                prepend: e.prepend,
                insertionPoint: e.insertionPoint,
              }),
              nonce: e.nonce,
              inserted: s,
              registered: {},
              insert: a,
            };
            return g.sheet.hydrate(l), g;
          };
      },
      5042: function (e, t, n) {
        "use strict";
        function r(e) {
          var t = Object.create(null);
          return function (n) {
            return void 0 === t[n] && (t[n] = e(n)), t[n];
          };
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      5260: function (e, t, n) {
        "use strict";
        n.d(t, {
          C: function () {
            return s;
          },
          T: function () {
            return d;
          },
          i: function () {
            return a;
          },
          w: function () {
            return l;
          },
        });
        var r = n(7294),
          o = n(5053),
          a = (n(6797), n(7278), !0),
          i = r.createContext(
            "undefined" != typeof HTMLElement ? (0, o.Z)({ key: "css" }) : null
          ),
          s = i.Provider,
          l = function (e) {
            return (0, r.forwardRef)(function (t, n) {
              var o = (0, r.useContext)(i);
              return e(t, o, n);
            });
          };
        a ||
          (l = function (e) {
            return function (t) {
              var n = (0, r.useContext)(i);
              return null === n
                ? ((n = (0, o.Z)({ key: "css" })),
                  r.createElement(i.Provider, { value: n }, e(t, n)))
                : e(t, n);
            };
          });
        var d = r.createContext({});
      },
      917: function (e, t, n) {
        "use strict";
        n.d(t, {
          F4: function () {
            return c;
          },
          iv: function () {
            return d;
          },
          xB: function () {
            return l;
          },
        });
        var r = n(5260),
          o = n(7294),
          a = n(444),
          i = n(7278),
          s = n(6797),
          l =
            (n(5053),
            n(8679),
            (0, r.w)(function (e, t) {
              var n = e.styles,
                l = (0, s.O)([n], void 0, o.useContext(r.T));
              if (!r.i) {
                for (
                  var d, c = l.name, u = l.styles, p = l.next;
                  void 0 !== p;

                )
                  (c += " " + p.name), (u += p.styles), (p = p.next);
                var m = !0 === t.compat,
                  h = t.insert("", { name: c, styles: u }, t.sheet, m);
                return m
                  ? null
                  : o.createElement(
                      "style",
                      (((d = {})["data-emotion"] = t.key + "-global " + c),
                      (d.dangerouslySetInnerHTML = { __html: h }),
                      (d.nonce = t.sheet.nonce),
                      d)
                    );
              }
              var f = o.useRef();
              return (
                (0, i.j)(
                  function () {
                    var e = t.key + "-global",
                      n = new t.sheet.constructor({
                        key: e,
                        nonce: t.sheet.nonce,
                        container: t.sheet.container,
                        speedy: t.sheet.isSpeedy,
                      }),
                      r = !1,
                      o = document.querySelector(
                        'style[data-emotion="' + e + " " + l.name + '"]'
                      );
                    return (
                      t.sheet.tags.length && (n.before = t.sheet.tags[0]),
                      null !== o &&
                        ((r = !0),
                        o.setAttribute("data-emotion", e),
                        n.hydrate([o])),
                      (f.current = [n, r]),
                      function () {
                        n.flush();
                      }
                    );
                  },
                  [t]
                ),
                (0, i.j)(
                  function () {
                    var e = f.current,
                      n = e[0];
                    if (e[1]) e[1] = !1;
                    else {
                      if (
                        (void 0 !== l.next && (0, a.My)(t, l.next, !0),
                        n.tags.length)
                      ) {
                        var r = n.tags[n.tags.length - 1].nextElementSibling;
                        (n.before = r), n.flush();
                      }
                      t.insert("", l, n, !1);
                    }
                  },
                  [t, l.name]
                ),
                null
              );
            }));
        function d() {
          for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
            t[n] = arguments[n];
          return (0, s.O)(t);
        }
        var c = function () {
          var e = d.apply(void 0, arguments),
            t = "animation-" + e.name;
          return {
            name: t,
            styles: "@keyframes " + t + "{" + e.styles + "}",
            anim: 1,
            toString: function () {
              return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
            },
          };
        };
      },
      6797: function (e, t, n) {
        "use strict";
        n.d(t, {
          O: function () {
            return h;
          },
        });
        var r = {
            animationIterationCount: 1,
            aspectRatio: 1,
            borderImageOutset: 1,
            borderImageSlice: 1,
            borderImageWidth: 1,
            boxFlex: 1,
            boxFlexGroup: 1,
            boxOrdinalGroup: 1,
            columnCount: 1,
            columns: 1,
            flex: 1,
            flexGrow: 1,
            flexPositive: 1,
            flexShrink: 1,
            flexNegative: 1,
            flexOrder: 1,
            gridRow: 1,
            gridRowEnd: 1,
            gridRowSpan: 1,
            gridRowStart: 1,
            gridColumn: 1,
            gridColumnEnd: 1,
            gridColumnSpan: 1,
            gridColumnStart: 1,
            msGridRow: 1,
            msGridRowSpan: 1,
            msGridColumn: 1,
            msGridColumnSpan: 1,
            fontWeight: 1,
            lineHeight: 1,
            opacity: 1,
            order: 1,
            orphans: 1,
            tabSize: 1,
            widows: 1,
            zIndex: 1,
            zoom: 1,
            WebkitLineClamp: 1,
            fillOpacity: 1,
            floodOpacity: 1,
            stopOpacity: 1,
            strokeDasharray: 1,
            strokeDashoffset: 1,
            strokeMiterlimit: 1,
            strokeOpacity: 1,
            strokeWidth: 1,
          },
          o = n(5042),
          a = /[A-Z]|^ms/g,
          i = /_EMO_([^_]+?)_([^]*?)_EMO_/g,
          s = function (e) {
            return 45 === e.charCodeAt(1);
          },
          l = function (e) {
            return null != e && "boolean" != typeof e;
          },
          d = (0, o.Z)(function (e) {
            return s(e) ? e : e.replace(a, "-$&").toLowerCase();
          }),
          c = function (e, t) {
            switch (e) {
              case "animation":
              case "animationName":
                if ("string" == typeof t)
                  return t.replace(i, function (e, t, n) {
                    return (p = { name: t, styles: n, next: p }), t;
                  });
            }
            return 1 === r[e] || s(e) || "number" != typeof t || 0 === t
              ? t
              : t + "px";
          };
        function u(e, t, n) {
          if (null == n) return "";
          if (void 0 !== n.__emotion_styles) return n;
          switch (typeof n) {
            case "boolean":
              return "";
            case "object":
              if (1 === n.anim)
                return (
                  (p = { name: n.name, styles: n.styles, next: p }), n.name
                );
              if (void 0 !== n.styles) {
                var r = n.next;
                if (void 0 !== r)
                  for (; void 0 !== r; )
                    (p = { name: r.name, styles: r.styles, next: p }),
                      (r = r.next);
                return n.styles + ";";
              }
              return (function (e, t, n) {
                var r = "";
                if (Array.isArray(n))
                  for (var o = 0; o < n.length; o++) r += u(e, t, n[o]) + ";";
                else
                  for (var a in n) {
                    var i = n[a];
                    if ("object" != typeof i)
                      null != t && void 0 !== t[i]
                        ? (r += a + "{" + t[i] + "}")
                        : l(i) && (r += d(a) + ":" + c(a, i) + ";");
                    else if (
                      !Array.isArray(i) ||
                      "string" != typeof i[0] ||
                      (null != t && void 0 !== t[i[0]])
                    ) {
                      var s = u(e, t, i);
                      switch (a) {
                        case "animation":
                        case "animationName":
                          r += d(a) + ":" + s + ";";
                          break;
                        default:
                          r += a + "{" + s + "}";
                      }
                    } else
                      for (var p = 0; p < i.length; p++)
                        l(i[p]) && (r += d(a) + ":" + c(a, i[p]) + ";");
                  }
                return r;
              })(e, t, n);
            case "function":
              if (void 0 !== e) {
                var o = p,
                  a = n(e);
                return (p = o), u(e, t, a);
              }
          }
          if (null == t) return n;
          var i = t[n];
          return void 0 !== i ? i : n;
        }
        var p,
          m = /label:\s*([^\s;\n{]+)\s*(;|$)/g,
          h = function (e, t, n) {
            if (
              1 === e.length &&
              "object" == typeof e[0] &&
              null !== e[0] &&
              void 0 !== e[0].styles
            )
              return e[0];
            var r = !0,
              o = "";
            p = void 0;
            var a = e[0];
            null == a || void 0 === a.raw
              ? ((r = !1), (o += u(n, t, a)))
              : (o += a[0]);
            for (var i = 1; i < e.length; i++)
              (o += u(n, t, e[i])), r && (o += a[i]);
            m.lastIndex = 0;
            for (var s, l = ""; null !== (s = m.exec(o)); ) l += "-" + s[1];
            var d =
              (function (e) {
                for (var t, n = 0, r = 0, o = e.length; o >= 4; ++r, o -= 4)
                  (t =
                    1540483477 *
                      (65535 &
                        (t =
                          (255 & e.charCodeAt(r)) |
                          ((255 & e.charCodeAt(++r)) << 8) |
                          ((255 & e.charCodeAt(++r)) << 16) |
                          ((255 & e.charCodeAt(++r)) << 24))) +
                    ((59797 * (t >>> 16)) << 16)),
                    (n =
                      (1540483477 * (65535 & (t ^= t >>> 24)) +
                        ((59797 * (t >>> 16)) << 16)) ^
                      (1540483477 * (65535 & n) +
                        ((59797 * (n >>> 16)) << 16)));
                switch (o) {
                  case 3:
                    n ^= (255 & e.charCodeAt(r + 2)) << 16;
                  case 2:
                    n ^= (255 & e.charCodeAt(r + 1)) << 8;
                  case 1:
                    n =
                      1540483477 * (65535 & (n ^= 255 & e.charCodeAt(r))) +
                      ((59797 * (n >>> 16)) << 16);
                }
                return (
                  ((n =
                    1540483477 * (65535 & (n ^= n >>> 13)) +
                    ((59797 * (n >>> 16)) << 16)) ^
                    (n >>> 15)) >>>
                  0
                ).toString(36);
              })(o) + l;
            return { name: d, styles: o, next: p };
          };
      },
      7278: function (e, t, n) {
        "use strict";
        var r;
        n.d(t, {
          L: function () {
            return i;
          },
          j: function () {
            return s;
          },
        });
        var o = n(7294),
          a =
            !!(r || (r = n.t(o, 2))).useInsertionEffect &&
            (r || (r = n.t(o, 2))).useInsertionEffect,
          i =
            a ||
            function (e) {
              return e();
            },
          s = a || o.useLayoutEffect;
      },
      444: function (e, t, n) {
        "use strict";
        function r(e, t, n) {
          var r = "";
          return (
            n.split(" ").forEach(function (n) {
              void 0 !== e[n] ? t.push(e[n] + ";") : n && (r += n + " ");
            }),
            r
          );
        }
        n.d(t, {
          My: function () {
            return a;
          },
          fp: function () {
            return r;
          },
          hC: function () {
            return o;
          },
        });
        var o = function (e, t, n) {
            var r = e.key + "-" + t.name;
            !1 === n &&
              void 0 === e.registered[r] &&
              (e.registered[r] = t.styles);
          },
          a = function (e, t, n) {
            o(e, t, n);
            var r = e.key + "-" + t.name;
            if (void 0 === e.inserted[t.name]) {
              var a = t;
              do {
                e.insert(t === a ? "." + r : "", a, e.sheet, !0), (a = a.next);
              } while (void 0 !== a);
            }
          };
      },
      6693: function (e, t, n) {
        "use strict";
        var r = n(4836);
        t.Z = void 0;
        var o = r(n(4938)),
          a = n(5893);
        t.Z = (0, o.default)(
          (0, a.jsx)("path", {
            d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z",
          }),
          "Image"
        );
      },
      4938: function (e, t, n) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          Object.defineProperty(t, "default", {
            enumerable: !0,
            get: function () {
              return r.createSvgIcon;
            },
          });
        var r = n(1730);
      },
      8628: function (e, t, n) {
        "use strict";
        n.d(t, {
          i: function () {
            return o;
          },
        }),
          n(7294);
        var r = n(2842);
        function o(e) {
          return (0, r.i)(e);
        }
        n(5893);
      },
      3502: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return b;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(7294),
          i = n(3961),
          s = n(4780),
          l = n(8216),
          d = n(8628),
          c = n(948),
          u = n(1588),
          p = n(5677);
        function m(e) {
          return (0, p.ZP)("MuiSvgIcon", e);
        }
        (0, u.Z)("MuiSvgIcon", [
          "root",
          "colorPrimary",
          "colorSecondary",
          "colorAction",
          "colorError",
          "colorDisabled",
          "fontSizeInherit",
          "fontSizeSmall",
          "fontSizeMedium",
          "fontSizeLarge",
        ]);
        var h = n(5893);
        const f = [
            "children",
            "className",
            "color",
            "component",
            "fontSize",
            "htmlColor",
            "inheritViewBox",
            "titleAccess",
            "viewBox",
          ],
          g = (0, c.ZP)("svg", {
            name: "MuiSvgIcon",
            slot: "Root",
            overridesResolver: (e, t) => {
              const { ownerState: n } = e;
              return [
                t.root,
                "inherit" !== n.color && t[`color${(0, l.Z)(n.color)}`],
                t[`fontSize${(0, l.Z)(n.fontSize)}`],
              ];
            },
          })(({ theme: e, ownerState: t }) => {
            var n, r, o, a, i, s, l, d, c, u, p, m, h;
            return {
              userSelect: "none",
              width: "1em",
              height: "1em",
              display: "inline-block",
              fill: t.hasSvgAsChild ? void 0 : "currentColor",
              flexShrink: 0,
              transition:
                null == (n = e.transitions) || null == (r = n.create)
                  ? void 0
                  : r.call(n, "fill", {
                      duration:
                        null == (o = e.transitions) || null == (o = o.duration)
                          ? void 0
                          : o.shorter,
                    }),
              fontSize: {
                inherit: "inherit",
                small:
                  (null == (a = e.typography) || null == (i = a.pxToRem)
                    ? void 0
                    : i.call(a, 20)) || "1.25rem",
                medium:
                  (null == (s = e.typography) || null == (l = s.pxToRem)
                    ? void 0
                    : l.call(s, 24)) || "1.5rem",
                large:
                  (null == (d = e.typography) || null == (c = d.pxToRem)
                    ? void 0
                    : c.call(d, 35)) || "2.1875rem",
              }[t.fontSize],
              color:
                null !=
                (u =
                  null == (p = (e.vars || e).palette) ||
                  null == (p = p[t.color])
                    ? void 0
                    : p.main)
                  ? u
                  : {
                      action:
                        null == (m = (e.vars || e).palette) ||
                        null == (m = m.action)
                          ? void 0
                          : m.active,
                      disabled:
                        null == (h = (e.vars || e).palette) ||
                        null == (h = h.action)
                          ? void 0
                          : h.disabled,
                      inherit: void 0,
                    }[t.color],
            };
          }),
          v = a.forwardRef(function (e, t) {
            const n = (0, d.i)({ props: e, name: "MuiSvgIcon" }),
              {
                children: c,
                className: u,
                color: p = "inherit",
                component: v = "svg",
                fontSize: b = "medium",
                htmlColor: _,
                inheritViewBox: y = !1,
                titleAccess: C,
                viewBox: x = "0 0 24 24",
              } = n,
              S = (0, o.Z)(n, f),
              k = a.isValidElement(c) && "svg" === c.type,
              P = (0, r.Z)({}, n, {
                color: p,
                component: v,
                fontSize: b,
                instanceFontSize: e.fontSize,
                inheritViewBox: y,
                viewBox: x,
                hasSvgAsChild: k,
              }),
              w = {};
            y || (w.viewBox = x);
            const O = ((e) => {
              const { color: t, fontSize: n, classes: r } = e,
                o = {
                  root: [
                    "root",
                    "inherit" !== t && `color${(0, l.Z)(t)}`,
                    `fontSize${(0, l.Z)(n)}`,
                  ],
                };
              return (0, s.Z)(o, m, r);
            })(P);
            return (0,
            h.jsxs)(g, (0, r.Z)({ as: v, className: (0, i.Z)(O.root, u), focusable: "false", color: _, "aria-hidden": !C || void 0, role: C ? "img" : void 0, ref: t }, w, S, k && c.props, { ownerState: P, children: [k ? c.props.children : c, C ? (0, h.jsx)("title", { children: C }) : null] }));
          });
        v.muiName = "SvgIcon";
        var b = v;
      },
      6949: function (e, t) {
        "use strict";
        t.Z = {
          50: "#e3f2fd",
          100: "#bbdefb",
          200: "#90caf9",
          300: "#64b5f6",
          400: "#42a5f5",
          500: "#2196f3",
          600: "#1e88e5",
          700: "#1976d2",
          800: "#1565c0",
          900: "#0d47a1",
          A100: "#82b1ff",
          A200: "#448aff",
          A400: "#2979ff",
          A700: "#2962ff",
        };
      },
      3486: function (e, t) {
        "use strict";
        t.Z = {
          50: "#e8f5e9",
          100: "#c8e6c9",
          200: "#a5d6a7",
          300: "#81c784",
          400: "#66bb6a",
          500: "#4caf50",
          600: "#43a047",
          700: "#388e3c",
          800: "#2e7d32",
          900: "#1b5e20",
          A100: "#b9f6ca",
          A200: "#69f0ae",
          A400: "#00e676",
          A700: "#00c853",
        };
      },
      7036: function (e, t) {
        "use strict";
        t.Z = {
          50: "#fafafa",
          100: "#f5f5f5",
          200: "#eeeeee",
          300: "#e0e0e0",
          400: "#bdbdbd",
          500: "#9e9e9e",
          600: "#757575",
          700: "#616161",
          800: "#424242",
          900: "#212121",
          A100: "#f5f5f5",
          A200: "#eeeeee",
          A400: "#bdbdbd",
          A700: "#616161",
        };
      },
      5137: function (e, t) {
        "use strict";
        t.Z = {
          50: "#fff3e0",
          100: "#ffe0b2",
          200: "#ffcc80",
          300: "#ffb74d",
          400: "#ffa726",
          500: "#ff9800",
          600: "#fb8c00",
          700: "#f57c00",
          800: "#ef6c00",
          900: "#e65100",
          A100: "#ffd180",
          A200: "#ffab40",
          A400: "#ff9100",
          A700: "#ff6d00",
        };
      },
      5932: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return L;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(6535),
          i = n(4953),
          s = n(8010),
          l = n(6523),
          d = n(7408),
          c = n(2101),
          u = { black: "#000", white: "#fff" },
          p = n(7036),
          m = {
            50: "#f3e5f5",
            100: "#e1bee7",
            200: "#ce93d8",
            300: "#ba68c8",
            400: "#ab47bc",
            500: "#9c27b0",
            600: "#8e24aa",
            700: "#7b1fa2",
            800: "#6a1b9a",
            900: "#4a148c",
            A100: "#ea80fc",
            A200: "#e040fb",
            A400: "#d500f9",
            A700: "#aa00ff",
          },
          h = {
            50: "#ffebee",
            100: "#ffcdd2",
            200: "#ef9a9a",
            300: "#e57373",
            400: "#ef5350",
            500: "#f44336",
            600: "#e53935",
            700: "#d32f2f",
            800: "#c62828",
            900: "#b71c1c",
            A100: "#ff8a80",
            A200: "#ff5252",
            A400: "#ff1744",
            A700: "#d50000",
          },
          f = n(5137),
          g = n(6949),
          v = {
            50: "#e1f5fe",
            100: "#b3e5fc",
            200: "#81d4fa",
            300: "#4fc3f7",
            400: "#29b6f6",
            500: "#03a9f4",
            600: "#039be5",
            700: "#0288d1",
            800: "#0277bd",
            900: "#01579b",
            A100: "#80d8ff",
            A200: "#40c4ff",
            A400: "#00b0ff",
            A700: "#0091ea",
          },
          b = n(3486);
        const _ = ["mode", "contrastThreshold", "tonalOffset"],
          y = {
            text: {
              primary: "rgba(0, 0, 0, 0.87)",
              secondary: "rgba(0, 0, 0, 0.6)",
              disabled: "rgba(0, 0, 0, 0.38)",
            },
            divider: "rgba(0, 0, 0, 0.12)",
            background: { paper: u.white, default: u.white },
            action: {
              active: "rgba(0, 0, 0, 0.54)",
              hover: "rgba(0, 0, 0, 0.04)",
              hoverOpacity: 0.04,
              selected: "rgba(0, 0, 0, 0.08)",
              selectedOpacity: 0.08,
              disabled: "rgba(0, 0, 0, 0.26)",
              disabledBackground: "rgba(0, 0, 0, 0.12)",
              disabledOpacity: 0.38,
              focus: "rgba(0, 0, 0, 0.12)",
              focusOpacity: 0.12,
              activatedOpacity: 0.12,
            },
          },
          C = {
            text: {
              primary: u.white,
              secondary: "rgba(255, 255, 255, 0.7)",
              disabled: "rgba(255, 255, 255, 0.5)",
              icon: "rgba(255, 255, 255, 0.5)",
            },
            divider: "rgba(255, 255, 255, 0.12)",
            background: { paper: "#121212", default: "#121212" },
            action: {
              active: u.white,
              hover: "rgba(255, 255, 255, 0.08)",
              hoverOpacity: 0.08,
              selected: "rgba(255, 255, 255, 0.16)",
              selectedOpacity: 0.16,
              disabled: "rgba(255, 255, 255, 0.3)",
              disabledBackground: "rgba(255, 255, 255, 0.12)",
              disabledOpacity: 0.38,
              focus: "rgba(255, 255, 255, 0.12)",
              focusOpacity: 0.12,
              activatedOpacity: 0.24,
            },
          };
        function x(e, t, n, r) {
          const o = r.light || r,
            a = r.dark || 1.5 * r;
          e[t] ||
            (e.hasOwnProperty(n)
              ? (e[t] = e[n])
              : "light" === t
              ? (e.light = (0, c.$n)(e.main, o))
              : "dark" === t && (e.dark = (0, c._j)(e.main, a)));
        }
        const S = [
            "fontFamily",
            "fontSize",
            "fontWeightLight",
            "fontWeightRegular",
            "fontWeightMedium",
            "fontWeightBold",
            "htmlFontSize",
            "allVariants",
            "pxToRem",
          ],
          k = { textTransform: "uppercase" },
          P = '"Roboto", "Helvetica", "Arial", sans-serif';
        function w(e, t) {
          const n = "function" == typeof t ? t(e) : t,
            {
              fontFamily: a = P,
              fontSize: s = 14,
              fontWeightLight: l = 300,
              fontWeightRegular: d = 400,
              fontWeightMedium: c = 500,
              fontWeightBold: u = 700,
              htmlFontSize: p = 16,
              allVariants: m,
              pxToRem: h,
            } = n,
            f = (0, o.Z)(n, S),
            g = s / 14,
            v = h || ((e) => (e / p) * g + "rem"),
            b = (e, t, n, o, i) => {
              return (0, r.Z)(
                { fontFamily: a, fontWeight: e, fontSize: v(t), lineHeight: n },
                a === P
                  ? {
                      letterSpacing:
                        ((s = o / t), Math.round(1e5 * s) / 1e5 + "em"),
                    }
                  : {},
                i,
                m
              );
              var s;
            },
            _ = {
              h1: b(l, 96, 1.167, -1.5),
              h2: b(l, 60, 1.2, -0.5),
              h3: b(d, 48, 1.167, 0),
              h4: b(d, 34, 1.235, 0.25),
              h5: b(d, 24, 1.334, 0),
              h6: b(c, 20, 1.6, 0.15),
              subtitle1: b(d, 16, 1.75, 0.15),
              subtitle2: b(c, 14, 1.57, 0.1),
              body1: b(d, 16, 1.5, 0.15),
              body2: b(d, 14, 1.43, 0.15),
              button: b(c, 14, 1.75, 0.4, k),
              caption: b(d, 12, 1.66, 0.4),
              overline: b(d, 12, 2.66, 1, k),
              inherit: {
                fontFamily: "inherit",
                fontWeight: "inherit",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              },
            };
          return (0, i.Z)(
            (0, r.Z)(
              {
                htmlFontSize: p,
                pxToRem: v,
                fontFamily: a,
                fontSize: s,
                fontWeightLight: l,
                fontWeightRegular: d,
                fontWeightMedium: c,
                fontWeightBold: u,
              },
              _
            ),
            f,
            { clone: !1 }
          );
        }
        function O(...e) {
          return [
            `${e[0]}px ${e[1]}px ${e[2]}px ${e[3]}px rgba(0,0,0,0.2)`,
            `${e[4]}px ${e[5]}px ${e[6]}px ${e[7]}px rgba(0,0,0,0.14)`,
            `${e[8]}px ${e[9]}px ${e[10]}px ${e[11]}px rgba(0,0,0,0.12)`,
          ].join(",");
        }
        var T = [
          "none",
          O(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0),
          O(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0),
          O(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0),
          O(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0),
          O(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0),
          O(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0),
          O(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1),
          O(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2),
          O(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2),
          O(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3),
          O(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3),
          O(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4),
          O(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4),
          O(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4),
          O(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5),
          O(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5),
          O(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5),
          O(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6),
          O(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6),
          O(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7),
          O(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7),
          O(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7),
          O(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8),
          O(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8),
        ];
        const I = ["duration", "easing", "delay"],
          M = {
            easeInOut: "cubic-bezier(0.4, 0, 0.2, 1)",
            easeOut: "cubic-bezier(0.0, 0, 0.2, 1)",
            easeIn: "cubic-bezier(0.4, 0, 1, 1)",
            sharp: "cubic-bezier(0.4, 0, 0.6, 1)",
          },
          j = {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195,
          };
        function N(e) {
          return `${Math.round(e)}ms`;
        }
        function D(e) {
          if (!e) return 0;
          const t = e / 36;
          return Math.round(10 * (4 + 15 * t ** 0.25 + t / 5));
        }
        function A(e) {
          const t = (0, r.Z)({}, M, e.easing),
            n = (0, r.Z)({}, j, e.duration);
          return (0, r.Z)(
            {
              getAutoHeightDuration: D,
              create: (e = ["all"], r = {}) => {
                const {
                  duration: a = n.standard,
                  easing: i = t.easeInOut,
                  delay: s = 0,
                } = r;
                return (
                  (0, o.Z)(r, I),
                  (Array.isArray(e) ? e : [e])
                    .map(
                      (e) =>
                        `${e} ${"string" == typeof a ? a : N(a)} ${i} ${
                          "string" == typeof s ? s : N(s)
                        }`
                    )
                    .join(",")
                );
              },
            },
            e,
            { easing: t, duration: n }
          );
        }
        var E = {
          mobileStepper: 1e3,
          fab: 1050,
          speedDial: 1050,
          appBar: 1100,
          drawer: 1200,
          modal: 1300,
          snackbar: 1400,
          tooltip: 1500,
        };
        const R = [
          "breakpoints",
          "mixins",
          "spacing",
          "palette",
          "transitions",
          "typography",
          "shape",
        ];
        var L = function (e = {}, ...t) {
          const {
              mixins: n = {},
              palette: S = {},
              transitions: k = {},
              typography: P = {},
            } = e,
            O = (0, o.Z)(e, R);
          if (e.vars) throw new Error((0, a.Z)(18));
          const I = (function (e) {
              const {
                  mode: t = "light",
                  contrastThreshold: n = 3,
                  tonalOffset: s = 0.2,
                } = e,
                l = (0, o.Z)(e, _),
                d =
                  e.primary ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: g.Z[200], light: g.Z[50], dark: g.Z[400] }
                      : { main: g.Z[700], light: g.Z[400], dark: g.Z[800] };
                  })(t),
                S =
                  e.secondary ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: m[200], light: m[50], dark: m[400] }
                      : { main: m[500], light: m[300], dark: m[700] };
                  })(t),
                k =
                  e.error ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: h[500], light: h[300], dark: h[700] }
                      : { main: h[700], light: h[400], dark: h[800] };
                  })(t),
                P =
                  e.info ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: v[400], light: v[300], dark: v[700] }
                      : { main: v[700], light: v[500], dark: v[900] };
                  })(t),
                w =
                  e.success ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: b.Z[400], light: b.Z[300], dark: b.Z[700] }
                      : { main: b.Z[800], light: b.Z[500], dark: b.Z[900] };
                  })(t),
                O =
                  e.warning ||
                  (function (e = "light") {
                    return "dark" === e
                      ? { main: f.Z[400], light: f.Z[300], dark: f.Z[700] }
                      : { main: "#ed6c02", light: f.Z[500], dark: f.Z[900] };
                  })(t);
              function T(e) {
                return (0, c.mi)(e, C.text.primary) >= n
                  ? C.text.primary
                  : y.text.primary;
              }
              const I = ({
                  color: e,
                  name: t,
                  mainShade: n = 500,
                  lightShade: o = 300,
                  darkShade: i = 700,
                }) => {
                  if (
                    (!(e = (0, r.Z)({}, e)).main && e[n] && (e.main = e[n]),
                    !e.hasOwnProperty("main"))
                  )
                    throw new Error((0, a.Z)(11, t ? ` (${t})` : "", n));
                  if ("string" != typeof e.main)
                    throw new Error(
                      (0, a.Z)(12, t ? ` (${t})` : "", JSON.stringify(e.main))
                    );
                  return (
                    x(e, "light", o, s),
                    x(e, "dark", i, s),
                    e.contrastText || (e.contrastText = T(e.main)),
                    e
                  );
                },
                M = { dark: C, light: y };
              return (0, i.Z)(
                (0, r.Z)(
                  {
                    common: (0, r.Z)({}, u),
                    mode: t,
                    primary: I({ color: d, name: "primary" }),
                    secondary: I({
                      color: S,
                      name: "secondary",
                      mainShade: "A400",
                      lightShade: "A200",
                      darkShade: "A700",
                    }),
                    error: I({ color: k, name: "error" }),
                    warning: I({ color: O, name: "warning" }),
                    info: I({ color: P, name: "info" }),
                    success: I({ color: w, name: "success" }),
                    grey: p.Z,
                    contrastThreshold: n,
                    getContrastText: T,
                    augmentColor: I,
                    tonalOffset: s,
                  },
                  M[t]
                ),
                l
              );
            })(S),
            M = (0, d.Z)(e);
          let j = (0, i.Z)(M, {
            mixins:
              ((N = M.breakpoints),
              (D = n),
              (0, r.Z)(
                {
                  toolbar: {
                    minHeight: 56,
                    [N.up("xs")]: {
                      "@media (orientation: landscape)": { minHeight: 48 },
                    },
                    [N.up("sm")]: { minHeight: 64 },
                  },
                },
                D
              )),
            palette: I,
            shadows: T.slice(),
            typography: w(I, P),
            transitions: A(k),
            zIndex: (0, r.Z)({}, E),
          });
          var N, D;
          return (
            (j = (0, i.Z)(j, O)),
            (j = t.reduce((e, t) => (0, i.Z)(e, t), j)),
            (j.unstable_sxConfig = (0, r.Z)(
              {},
              s.Z,
              null == O ? void 0 : O.unstable_sxConfig
            )),
            (j.unstable_sx = function (e) {
              return (0, l.Z)({ sx: e, theme: this });
            }),
            j
          );
        };
      },
      247: function (e, t, n) {
        "use strict";
        const r = (0, n(5932).Z)();
        t.Z = r;
      },
      606: function (e, t) {
        "use strict";
        t.Z = "$$material";
      },
      4136: function (e, t, n) {
        "use strict";
        var r = n(5536);
        t.Z = (e) => (0, r.Z)(e) && "classes" !== e;
      },
      5536: function (e, t) {
        "use strict";
        t.Z = function (e) {
          return (
            "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e
          );
        };
      },
      948: function (e, t, n) {
        "use strict";
        var r = n(8128),
          o = n(247),
          a = n(606),
          i = n(4136);
        const s = (0, r.ZP)({
          themeId: a.Z,
          defaultTheme: o.Z,
          rootShouldForwardProp: i.Z,
        });
        t.ZP = s;
      },
      8216: function (e, t, n) {
        "use strict";
        var r = n(4142);
        t.Z = r.Z;
      },
      7450: function (e, t, n) {
        "use strict";
        var r = n(1476);
        t.Z = r.Z;
      },
      2066: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var r = n(7462),
          o = n(7294),
          a = n(3502),
          i = n(5893);
        function s(e, t) {
          function n(n, o) {
            return (0, i.jsx)(
              a.Z,
              (0, r.Z)({ "data-testid": `${t}Icon`, ref: o }, n, {
                children: e,
              })
            );
          }
          return (n.muiName = a.Z.muiName), o.memo(o.forwardRef(n));
        }
      },
      7144: function (e, t, n) {
        "use strict";
        var r = n(9336);
        t.Z = r.Z;
      },
      1730: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            capitalize: function () {
              return o.Z;
            },
            createChainedFunction: function () {
              return a.Z;
            },
            createSvgIcon: function () {
              return i.Z;
            },
            debounce: function () {
              return s.Z;
            },
            deprecatedPropType: function () {
              return l;
            },
            isMuiElement: function () {
              return d.Z;
            },
            ownerDocument: function () {
              return c.Z;
            },
            ownerWindow: function () {
              return u.Z;
            },
            requirePropFactory: function () {
              return p;
            },
            setRef: function () {
              return m;
            },
            unstable_ClassNameGenerator: function () {
              return C;
            },
            unstable_useEnhancedEffect: function () {
              return h.Z;
            },
            unstable_useId: function () {
              return f.Z;
            },
            unsupportedProp: function () {
              return g;
            },
            useControlled: function () {
              return v.Z;
            },
            useEventCallback: function () {
              return b.Z;
            },
            useForkRef: function () {
              return _.Z;
            },
            useIsFocusVisible: function () {
              return y.Z;
            },
          });
        var r = n(7078),
          o = n(8216),
          a = n(7450),
          i = n(2066),
          s = n(7144),
          l = function (e, t) {
            return () => null;
          },
          d = n(1829),
          c = n(8038),
          u = n(5340);
        n(7462);
        var p = function (e, t) {
            return () => null;
          },
          m = n(7364).Z,
          h = n(8974),
          f = n(7909),
          g = function (e, t, n, r, o) {
            return null;
          },
          v = n(9299),
          b = n(2068),
          _ = n(1705),
          y = n(6601);
        const C = {
          configure: (e) => {
            r.Z.configure(e);
          },
        };
      },
      1829: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7294),
          o = function (e, t) {
            var n, o;
            return (
              r.isValidElement(e) &&
              -1 !==
                t.indexOf(
                  null != (n = e.type.muiName)
                    ? n
                    : null == (o = e.type) ||
                      null == (o = o._payload) ||
                      null == (o = o.value)
                    ? void 0
                    : o.muiName
                )
            );
          };
      },
      8038: function (e, t, n) {
        "use strict";
        var r = n(2690);
        t.Z = r.Z;
      },
      5340: function (e, t, n) {
        "use strict";
        var r = n(4161);
        t.Z = r.Z;
      },
      9299: function (e, t, n) {
        "use strict";
        var r = n(9032);
        t.Z = r.Z;
      },
      8974: function (e, t, n) {
        "use strict";
        var r = n(3546);
        t.Z = r.Z;
      },
      2068: function (e, t, n) {
        "use strict";
        var r = n(9948);
        t.Z = r.Z;
      },
      1705: function (e, t, n) {
        "use strict";
        var r = n(3703);
        t.Z = r.Z;
      },
      7909: function (e, t, n) {
        "use strict";
        var r = n(2996);
        t.Z = r.Z;
      },
      6601: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return p;
          },
        });
        var r = n(7294),
          o = n(1818);
        let a = !0,
          i = !1;
        const s = new o.V(),
          l = {
            text: !0,
            search: !0,
            url: !0,
            tel: !0,
            email: !0,
            password: !0,
            number: !0,
            date: !0,
            month: !0,
            week: !0,
            time: !0,
            datetime: !0,
            "datetime-local": !0,
          };
        function d(e) {
          e.metaKey || e.altKey || e.ctrlKey || (a = !0);
        }
        function c() {
          a = !1;
        }
        function u() {
          "hidden" === this.visibilityState && i && (a = !0);
        }
        var p = function () {
          const e = r.useCallback((e) => {
              var t;
              null != e &&
                ((t = e.ownerDocument).addEventListener("keydown", d, !0),
                t.addEventListener("mousedown", c, !0),
                t.addEventListener("pointerdown", c, !0),
                t.addEventListener("touchstart", c, !0),
                t.addEventListener("visibilitychange", u, !0));
            }, []),
            t = r.useRef(!1);
          return {
            isFocusVisibleRef: t,
            onFocus: function (e) {
              return (
                !!(function (e) {
                  const { target: t } = e;
                  try {
                    return t.matches(":focus-visible");
                  } catch (e) {}
                  return (
                    a ||
                    (function (e) {
                      const { type: t, tagName: n } = e;
                      return (
                        !("INPUT" !== n || !l[t] || e.readOnly) ||
                        ("TEXTAREA" === n && !e.readOnly) ||
                        !!e.isContentEditable
                      );
                    })(t)
                  );
                })(e) && ((t.current = !0), !0)
              );
            },
            onBlur: function () {
              return (
                !!t.current &&
                ((i = !0),
                s.start(100, () => {
                  i = !1;
                }),
                (t.current = !1),
                !0)
              );
            },
            ref: e,
          };
        };
      },
      1234: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return a;
          },
        }),
          n(7294);
        var r = n(917),
          o = n(5893);
        function a(e) {
          const { styles: t, defaultTheme: n = {} } = e,
            a =
              "function" == typeof t
                ? (e) => {
                    return t(
                      null == (r = e) || 0 === Object.keys(r).length ? n : e
                    );
                    var r;
                  }
                : t;
          return (0, o.jsx)(r.xB, { styles: a });
        }
      },
      4742: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            GlobalStyles: function () {
              return S.Z;
            },
            StyledEngineProvider: function () {
              return x;
            },
            ThemeContext: function () {
              return l.T;
            },
            css: function () {
              return b.iv;
            },
            default: function () {
              return k;
            },
            internal_processStyles: function () {
              return P;
            },
            keyframes: function () {
              return b.F4;
            },
          });
        var r = n(7462),
          o = n(7294),
          a = n(5042),
          i =
            /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|abbr|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|enterKeyHint|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|incremental|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/,
          s = (0, a.Z)(function (e) {
            return (
              i.test(e) ||
              (111 === e.charCodeAt(0) &&
                110 === e.charCodeAt(1) &&
                e.charCodeAt(2) < 91)
            );
          }),
          l = n(5260),
          d = n(444),
          c = n(6797),
          u = n(7278),
          p = s,
          m = function (e) {
            return "theme" !== e;
          },
          h = function (e) {
            return "string" == typeof e && e.charCodeAt(0) > 96 ? p : m;
          },
          f = function (e, t, n) {
            var r;
            if (t) {
              var o = t.shouldForwardProp;
              r =
                e.__emotion_forwardProp && o
                  ? function (t) {
                      return e.__emotion_forwardProp(t) && o(t);
                    }
                  : o;
            }
            return (
              "function" != typeof r && n && (r = e.__emotion_forwardProp), r
            );
          },
          g = function (e) {
            var t = e.cache,
              n = e.serialized,
              r = e.isStringTag;
            return (
              (0, d.hC)(t, n, r),
              (0, u.L)(function () {
                return (0, d.My)(t, n, r);
              }),
              null
            );
          },
          v = function e(t, n) {
            var a,
              i,
              s = t.__emotion_real === t,
              u = (s && t.__emotion_base) || t;
            void 0 !== n && ((a = n.label), (i = n.target));
            var p = f(t, n, s),
              m = p || h(u),
              v = !m("as");
            return function () {
              var b = arguments,
                _ =
                  s && void 0 !== t.__emotion_styles
                    ? t.__emotion_styles.slice(0)
                    : [];
              if (
                (void 0 !== a && _.push("label:" + a + ";"),
                null == b[0] || void 0 === b[0].raw)
              )
                _.push.apply(_, b);
              else {
                _.push(b[0][0]);
                for (var y = b.length, C = 1; C < y; C++) _.push(b[C], b[0][C]);
              }
              var x = (0, l.w)(function (e, t, n) {
                var r = (v && e.as) || u,
                  a = "",
                  s = [],
                  f = e;
                if (null == e.theme) {
                  for (var b in ((f = {}), e)) f[b] = e[b];
                  f.theme = o.useContext(l.T);
                }
                "string" == typeof e.className
                  ? (a = (0, d.fp)(t.registered, s, e.className))
                  : null != e.className && (a = e.className + " ");
                var y = (0, c.O)(_.concat(s), t.registered, f);
                (a += t.key + "-" + y.name), void 0 !== i && (a += " " + i);
                var C = v && void 0 === p ? h(r) : m,
                  x = {};
                for (var S in e) (v && "as" === S) || (C(S) && (x[S] = e[S]));
                return (
                  (x.className = a),
                  (x.ref = n),
                  o.createElement(
                    o.Fragment,
                    null,
                    o.createElement(g, {
                      cache: t,
                      serialized: y,
                      isStringTag: "string" == typeof r,
                    }),
                    o.createElement(r, x)
                  )
                );
              });
              return (
                (x.displayName =
                  void 0 !== a
                    ? a
                    : "Styled(" +
                      ("string" == typeof u
                        ? u
                        : u.displayName || u.name || "Component") +
                      ")"),
                (x.defaultProps = t.defaultProps),
                (x.__emotion_real = x),
                (x.__emotion_base = u),
                (x.__emotion_styles = _),
                (x.__emotion_forwardProp = p),
                Object.defineProperty(x, "toString", {
                  value: function () {
                    return "." + i;
                  },
                }),
                (x.withComponent = function (t, o) {
                  return e(
                    t,
                    (0, r.Z)({}, n, o, { shouldForwardProp: f(x, o, !0) })
                  ).apply(void 0, _);
                }),
                x
              );
            };
          }.bind();
        [
          "a",
          "abbr",
          "address",
          "area",
          "article",
          "aside",
          "audio",
          "b",
          "base",
          "bdi",
          "bdo",
          "big",
          "blockquote",
          "body",
          "br",
          "button",
          "canvas",
          "caption",
          "cite",
          "code",
          "col",
          "colgroup",
          "data",
          "datalist",
          "dd",
          "del",
          "details",
          "dfn",
          "dialog",
          "div",
          "dl",
          "dt",
          "em",
          "embed",
          "fieldset",
          "figcaption",
          "figure",
          "footer",
          "form",
          "h1",
          "h2",
          "h3",
          "h4",
          "h5",
          "h6",
          "head",
          "header",
          "hgroup",
          "hr",
          "html",
          "i",
          "iframe",
          "img",
          "input",
          "ins",
          "kbd",
          "keygen",
          "label",
          "legend",
          "li",
          "link",
          "main",
          "map",
          "mark",
          "marquee",
          "menu",
          "menuitem",
          "meta",
          "meter",
          "nav",
          "noscript",
          "object",
          "ol",
          "optgroup",
          "option",
          "output",
          "p",
          "param",
          "picture",
          "pre",
          "progress",
          "q",
          "rp",
          "rt",
          "ruby",
          "s",
          "samp",
          "script",
          "section",
          "select",
          "small",
          "source",
          "span",
          "strong",
          "style",
          "sub",
          "summary",
          "sup",
          "table",
          "tbody",
          "td",
          "textarea",
          "tfoot",
          "th",
          "thead",
          "time",
          "title",
          "tr",
          "track",
          "u",
          "ul",
          "var",
          "video",
          "wbr",
          "circle",
          "clipPath",
          "defs",
          "ellipse",
          "foreignObject",
          "g",
          "image",
          "line",
          "linearGradient",
          "mask",
          "path",
          "pattern",
          "polygon",
          "polyline",
          "radialGradient",
          "rect",
          "stop",
          "svg",
          "text",
          "tspan",
        ].forEach(function (e) {
          v[e] = v(e);
        });
        var b = n(917),
          _ = n(5053),
          y = n(5893);
        let C;
        function x(e) {
          const { injectFirst: t, children: n } = e;
          return t && C ? (0, y.jsx)(l.C, { value: C, children: n }) : n;
        }
        "object" == typeof document &&
          (C = (0, _.Z)({ key: "css", prepend: !0 }));
        var S = n(1234);
        function k(e, t) {
          return v(e, t);
        }
        const P = (e, t) => {
          Array.isArray(e.__emotion_styles) &&
            (e.__emotion_styles = t(e.__emotion_styles));
        };
      },
      2101: function (e, t, n) {
        "use strict";
        var r = n(4836);
        (t.Fq = function (e, t) {
          return (
            (e = s(e)),
            (t = i(t)),
            ("rgb" !== e.type && "hsl" !== e.type) || (e.type += "a"),
            "color" === e.type ? (e.values[3] = `/${t}`) : (e.values[3] = t),
            l(e)
          );
        }),
          (t._j = c),
          (t._4 = function (e, t = 0.15) {
            return d(e) > 0.5 ? c(e, t) : u(e, t);
          }),
          (t.mi = function (e, t) {
            const n = d(e),
              r = d(t);
            return (Math.max(n, r) + 0.05) / (Math.min(n, r) + 0.05);
          }),
          (t.$n = u);
        var o = r(n(5480)),
          a = r(n(9681));
        function i(e, t = 0, n = 1) {
          return (0, a.default)(e, t, n);
        }
        function s(e) {
          if (e.type) return e;
          if ("#" === e.charAt(0))
            return s(
              (function (e) {
                e = e.slice(1);
                const t = new RegExp(`.{1,${e.length >= 6 ? 2 : 1}}`, "g");
                let n = e.match(t);
                return (
                  n && 1 === n[0].length && (n = n.map((e) => e + e)),
                  n
                    ? `rgb${4 === n.length ? "a" : ""}(${n
                        .map((e, t) =>
                          t < 3
                            ? parseInt(e, 16)
                            : Math.round((parseInt(e, 16) / 255) * 1e3) / 1e3
                        )
                        .join(", ")})`
                    : ""
                );
              })(e)
            );
          const t = e.indexOf("("),
            n = e.substring(0, t);
          if (-1 === ["rgb", "rgba", "hsl", "hsla", "color"].indexOf(n))
            throw new Error((0, o.default)(9, e));
          let r,
            a = e.substring(t + 1, e.length - 1);
          if ("color" === n) {
            if (
              ((a = a.split(" ")),
              (r = a.shift()),
              4 === a.length &&
                "/" === a[3].charAt(0) &&
                (a[3] = a[3].slice(1)),
              -1 ===
                [
                  "srgb",
                  "display-p3",
                  "a98-rgb",
                  "prophoto-rgb",
                  "rec-2020",
                ].indexOf(r))
            )
              throw new Error((0, o.default)(10, r));
          } else a = a.split(",");
          return (
            (a = a.map((e) => parseFloat(e))),
            { type: n, values: a, colorSpace: r }
          );
        }
        function l(e) {
          const { type: t, colorSpace: n } = e;
          let { values: r } = e;
          return (
            -1 !== t.indexOf("rgb")
              ? (r = r.map((e, t) => (t < 3 ? parseInt(e, 10) : e)))
              : -1 !== t.indexOf("hsl") &&
                ((r[1] = `${r[1]}%`), (r[2] = `${r[2]}%`)),
            (r =
              -1 !== t.indexOf("color")
                ? `${n} ${r.join(" ")}`
                : `${r.join(", ")}`),
            `${t}(${r})`
          );
        }
        function d(e) {
          let t =
            "hsl" === (e = s(e)).type || "hsla" === e.type
              ? s(
                  (function (e) {
                    e = s(e);
                    const { values: t } = e,
                      n = t[0],
                      r = t[1] / 100,
                      o = t[2] / 100,
                      a = r * Math.min(o, 1 - o),
                      i = (e, t = (e + n / 30) % 12) =>
                        o - a * Math.max(Math.min(t - 3, 9 - t, 1), -1);
                    let d = "rgb";
                    const c = [
                      Math.round(255 * i(0)),
                      Math.round(255 * i(8)),
                      Math.round(255 * i(4)),
                    ];
                    return (
                      "hsla" === e.type && ((d += "a"), c.push(t[3])),
                      l({ type: d, values: c })
                    );
                  })(e)
                ).values
              : e.values;
          return (
            (t = t.map(
              (t) => (
                "color" !== e.type && (t /= 255),
                t <= 0.03928 ? t / 12.92 : ((t + 0.055) / 1.055) ** 2.4
              )
            )),
            Number((0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2]).toFixed(3))
          );
        }
        function c(e, t) {
          if (((e = s(e)), (t = i(t)), -1 !== e.type.indexOf("hsl")))
            e.values[2] *= 1 - t;
          else if (
            -1 !== e.type.indexOf("rgb") ||
            -1 !== e.type.indexOf("color")
          )
            for (let n = 0; n < 3; n += 1) e.values[n] *= 1 - t;
          return l(e);
        }
        function u(e, t) {
          if (((e = s(e)), (t = i(t)), -1 !== e.type.indexOf("hsl")))
            e.values[2] += (100 - e.values[2]) * t;
          else if (-1 !== e.type.indexOf("rgb"))
            for (let n = 0; n < 3; n += 1)
              e.values[n] += (255 - e.values[n]) * t;
          else if (-1 !== e.type.indexOf("color"))
            for (let n = 0; n < 3; n += 1) e.values[n] += (1 - e.values[n]) * t;
          return l(e);
        }
      },
      8128: function (e, t, n) {
        "use strict";
        var r = n(4836);
        t.ZP = function (e = {}) {
          const {
              themeId: t,
              defaultTheme: n = f,
              rootShouldForwardProp: r = h,
              slotShouldForwardProp: l = h,
            } = e,
            c = (e) =>
              (0, d.default)(
                (0, o.default)({}, e, {
                  theme: v(
                    (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                  ),
                })
              );
          return (
            (c.__mui_systemSx = !0),
            (e, d = {}) => {
              (0, i.internal_processStyles)(e, (e) =>
                e.filter((e) => !(null != e && e.__mui_systemSx))
              );
              const {
                  name: u,
                  slot: m,
                  skipVariantsResolver: f,
                  skipSx: y,
                  overridesResolver: C = b(g(m)),
                } = d,
                x = (0, a.default)(d, p),
                S =
                  void 0 !== f ? f : (m && "Root" !== m && "root" !== m) || !1,
                k = y || !1;
              let P = h;
              "Root" === m || "root" === m
                ? (P = r)
                : m
                ? (P = l)
                : (function (e) {
                    return "string" == typeof e && e.charCodeAt(0) > 96;
                  })(e) && (P = void 0);
              const w = (0, i.default)(
                  e,
                  (0, o.default)({ shouldForwardProp: P, label: void 0 }, x)
                ),
                O = (e) =>
                  ("function" == typeof e && e.__emotion_real !== e) ||
                  (0, s.isPlainObject)(e)
                    ? (r) =>
                        _(
                          e,
                          (0, o.default)({}, r, {
                            theme: v({
                              theme: r.theme,
                              defaultTheme: n,
                              themeId: t,
                            }),
                          })
                        )
                    : e,
                T = (r, ...a) => {
                  let i = O(r);
                  const s = a ? a.map(O) : [];
                  u &&
                    C &&
                    s.push((e) => {
                      const r = v(
                        (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                      );
                      if (
                        !r.components ||
                        !r.components[u] ||
                        !r.components[u].styleOverrides
                      )
                        return null;
                      const a = r.components[u].styleOverrides,
                        i = {};
                      return (
                        Object.entries(a).forEach(([t, n]) => {
                          i[t] = _(n, (0, o.default)({}, e, { theme: r }));
                        }),
                        C(e, i)
                      );
                    }),
                    u &&
                      !S &&
                      s.push((e) => {
                        var r;
                        const a = v(
                          (0, o.default)({}, e, { defaultTheme: n, themeId: t })
                        );
                        return _(
                          {
                            variants:
                              null == a ||
                              null == (r = a.components) ||
                              null == (r = r[u])
                                ? void 0
                                : r.variants,
                          },
                          (0, o.default)({}, e, { theme: a })
                        );
                      }),
                    k || s.push(c);
                  const l = s.length - a.length;
                  if (Array.isArray(r) && l > 0) {
                    const e = new Array(l).fill("");
                    (i = [...r, ...e]), (i.raw = [...r.raw, ...e]);
                  }
                  const d = w(i, ...s);
                  return e.muiName && (d.muiName = e.muiName), d;
                };
              return w.withConfig && (T.withConfig = w.withConfig), T;
            }
          );
        };
        var o = r(n(434)),
          a = r(n(7071)),
          i = (function (e, t) {
            if (e && e.__esModule) return e;
            if (null === e || ("object" != typeof e && "function" != typeof e))
              return { default: e };
            var n = m(t);
            if (n && n.has(e)) return n.get(e);
            var r = { __proto__: null },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var a in e)
              if (
                "default" !== a &&
                Object.prototype.hasOwnProperty.call(e, a)
              ) {
                var i = o ? Object.getOwnPropertyDescriptor(e, a) : null;
                i && (i.get || i.set)
                  ? Object.defineProperty(r, a, i)
                  : (r[a] = e[a]);
              }
            return (r.default = e), n && n.set(e, r), r;
          })(n(4742)),
          s = n(8524),
          l = (r(n(7641)), r(n(3163)), r(n(9926))),
          d = r(n(386));
        const c = ["ownerState"],
          u = ["variants"],
          p = [
            "name",
            "slot",
            "skipVariantsResolver",
            "skipSx",
            "overridesResolver",
          ];
        function m(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
            n = new WeakMap();
          return (m = function (e) {
            return e ? n : t;
          })(e);
        }
        function h(e) {
          return (
            "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e
          );
        }
        const f = (0, l.default)(),
          g = (e) => (e ? e.charAt(0).toLowerCase() + e.slice(1) : e);
        function v({ defaultTheme: e, theme: t, themeId: n }) {
          return (r = t), 0 === Object.keys(r).length ? e : t[n] || t;
          var r;
        }
        function b(e) {
          return e ? (t, n) => n[e] : null;
        }
        function _(e, t) {
          let { ownerState: n } = t,
            r = (0, a.default)(t, c);
          const i =
            "function" == typeof e
              ? e((0, o.default)({ ownerState: n }, r))
              : e;
          if (Array.isArray(i))
            return i.flatMap((e) => _(e, (0, o.default)({ ownerState: n }, r)));
          if (i && "object" == typeof i && Array.isArray(i.variants)) {
            const { variants: e = [] } = i;
            let t = (0, a.default)(i, u);
            return (
              e.forEach((e) => {
                let a = !0;
                "function" == typeof e.props
                  ? (a = e.props((0, o.default)({ ownerState: n }, r, n)))
                  : Object.keys(e.props).forEach((t) => {
                      (null == n ? void 0 : n[t]) !== e.props[t] &&
                        r[t] !== e.props[t] &&
                        (a = !1);
                    }),
                  a &&
                    (Array.isArray(t) || (t = [t]),
                    t.push(
                      "function" == typeof e.style
                        ? e.style((0, o.default)({ ownerState: n }, r, n))
                        : e.style
                    ));
              }),
              t
            );
          }
          return i;
        }
      },
      2842: function (e, t, n) {
        "use strict";
        n.d(t, {
          i: function () {
            return s;
          },
        });
        var r = n(7294),
          o = n(5971),
          a = n(5893);
        const i = r.createContext(void 0);
        function s({ props: e, name: t }) {
          return (function (e) {
            const { theme: t, name: n, props: r } = e;
            if (!t || !t.components || !t.components[n]) return r;
            const a = t.components[n];
            return a.defaultProps
              ? (0, o.Z)(a.defaultProps, r)
              : a.styleOverrides || a.variants
              ? r
              : (0, o.Z)(a, r);
          })({ props: e, name: t, theme: { components: r.useContext(i) } });
        }
        t.Z = function ({ value: e, children: t }) {
          return (0, a.jsx)(i.Provider, { value: e, children: t });
        };
      },
      5408: function (e, t, n) {
        "use strict";
        n.d(t, {
          L7: function () {
            return l;
          },
          P$: function () {
            return c;
          },
          VO: function () {
            return o;
          },
          W8: function () {
            return s;
          },
          dt: function () {
            return d;
          },
          k9: function () {
            return i;
          },
        });
        var r = n(4953);
        const o = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
          a = {
            keys: ["xs", "sm", "md", "lg", "xl"],
            up: (e) => `@media (min-width:${o[e]}px)`,
          };
        function i(e, t, n) {
          const r = e.theme || {};
          if (Array.isArray(t)) {
            const e = r.breakpoints || a;
            return t.reduce(
              (r, o, a) => ((r[e.up(e.keys[a])] = n(t[a])), r),
              {}
            );
          }
          if ("object" == typeof t) {
            const e = r.breakpoints || a;
            return Object.keys(t).reduce((r, a) => {
              if (-1 !== Object.keys(e.values || o).indexOf(a))
                r[e.up(a)] = n(t[a], a);
              else {
                const e = a;
                r[e] = t[e];
              }
              return r;
            }, {});
          }
          return n(t);
        }
        function s(e = {}) {
          var t;
          return (
            (null == (t = e.keys)
              ? void 0
              : t.reduce((t, n) => ((t[e.up(n)] = {}), t), {})) || {}
          );
        }
        function l(e, t) {
          return e.reduce((e, t) => {
            const n = e[t];
            return (!n || 0 === Object.keys(n).length) && delete e[t], e;
          }, t);
        }
        function d(e, ...t) {
          const n = s(e),
            o = [n, ...t].reduce((e, t) => (0, r.Z)(e, t), {});
          return l(Object.keys(n), o);
        }
        function c({ values: e, breakpoints: t, base: n }) {
          const r =
              n ||
              (function (e, t) {
                if ("object" != typeof e) return {};
                const n = {},
                  r = Object.keys(t);
                return (
                  Array.isArray(e)
                    ? r.forEach((t, r) => {
                        r < e.length && (n[t] = !0);
                      })
                    : r.forEach((t) => {
                        null != e[t] && (n[t] = !0);
                      }),
                  n
                );
              })(e, t),
            o = Object.keys(r);
          if (0 === o.length) return e;
          let a;
          return o.reduce(
            (t, n, r) => (
              Array.isArray(e)
                ? ((t[n] = null != e[r] ? e[r] : e[a]), (a = r))
                : "object" == typeof e
                ? ((t[n] = null != e[n] ? e[n] : e[a]), (a = n))
                : (t[n] = e),
              t
            ),
            {}
          );
        }
      },
      7064: function (e, t, n) {
        "use strict";
        function r(e, t) {
          const n = this;
          return n.vars && "function" == typeof n.getColorSchemeSelector
            ? {
                [n
                  .getColorSchemeSelector(e)
                  .replace(/(\[[^\]]+\])/, "*:where($1)")]: t,
              }
            : n.palette.mode === e
            ? t
            : {};
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      1512: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var r = n(3366),
          o = n(7462);
        const a = ["values", "unit", "step"],
          i = (e) => {
            const t = Object.keys(e).map((t) => ({ key: t, val: e[t] })) || [];
            return (
              t.sort((e, t) => e.val - t.val),
              t.reduce((e, t) => (0, o.Z)({}, e, { [t.key]: t.val }), {})
            );
          };
        function s(e) {
          const {
              values: t = { xs: 0, sm: 600, md: 900, lg: 1200, xl: 1536 },
              unit: n = "px",
              step: s = 5,
            } = e,
            l = (0, r.Z)(e, a),
            d = i(t),
            c = Object.keys(d);
          function u(e) {
            return `@media (min-width:${
              "number" == typeof t[e] ? t[e] : e
            }${n})`;
          }
          function p(e) {
            return `@media (max-width:${
              ("number" == typeof t[e] ? t[e] : e) - s / 100
            }${n})`;
          }
          function m(e, r) {
            const o = c.indexOf(r);
            return `@media (min-width:${
              "number" == typeof t[e] ? t[e] : e
            }${n}) and (max-width:${
              (-1 !== o && "number" == typeof t[c[o]] ? t[c[o]] : r) - s / 100
            }${n})`;
          }
          return (0, o.Z)(
            {
              keys: c,
              values: d,
              up: u,
              down: p,
              between: m,
              only: function (e) {
                return c.indexOf(e) + 1 < c.length
                  ? m(e, c[c.indexOf(e) + 1])
                  : u(e);
              },
              not: function (e) {
                const t = c.indexOf(e);
                return 0 === t
                  ? u(c[1])
                  : t === c.length - 1
                  ? p(c[t])
                  : m(e, c[c.indexOf(e) + 1]).replace(
                      "@media",
                      "@media not all and"
                    );
              },
              unit: n,
            },
            l
          );
        }
      },
      7408: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return m;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(4953),
          i = n(1512),
          s = { borderRadius: 4 },
          l = n(2605),
          d = n(6523),
          c = n(8010),
          u = n(7064);
        const p = ["breakpoints", "palette", "spacing", "shape"];
        var m = function (e = {}, ...t) {
          const {
              breakpoints: n = {},
              palette: m = {},
              spacing: h,
              shape: f = {},
            } = e,
            g = (0, o.Z)(e, p),
            v = (0, i.Z)(n),
            b = (function (e = 8) {
              if (e.mui) return e;
              const t = (0, l.hB)({ spacing: e }),
                n = (...e) =>
                  (0 === e.length ? [1] : e)
                    .map((e) => {
                      const n = t(e);
                      return "number" == typeof n ? `${n}px` : n;
                    })
                    .join(" ");
              return (n.mui = !0), n;
            })(h);
          let _ = (0, a.Z)(
            {
              breakpoints: v,
              direction: "ltr",
              components: {},
              palette: (0, r.Z)({ mode: "light" }, m),
              spacing: b,
              shape: (0, r.Z)({}, s, f),
            },
            g
          );
          return (
            (_.applyStyles = u.Z),
            (_ = t.reduce((e, t) => (0, a.Z)(e, t), _)),
            (_.unstable_sxConfig = (0, r.Z)(
              {},
              c.Z,
              null == g ? void 0 : g.unstable_sxConfig
            )),
            (_.unstable_sx = function (e) {
              return (0, d.Z)({ sx: e, theme: this });
            }),
            _
          );
        };
      },
      9926: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            private_createBreakpoints: function () {
              return o.Z;
            },
            unstable_applyStyles: function () {
              return a.Z;
            },
          });
        var r = n(7408),
          o = n(1512),
          a = n(7064);
      },
      7730: function (e, t, n) {
        "use strict";
        var r = n(4953);
        t.Z = function (e, t) {
          return t ? (0, r.Z)(e, t, { clone: !1 }) : e;
        };
      },
      2605: function (e, t, n) {
        "use strict";
        n.d(t, {
          hB: function () {
            return h;
          },
          eI: function () {
            return m;
          },
          NA: function () {
            return f;
          },
          e6: function () {
            return v;
          },
          o3: function () {
            return b;
          },
        });
        var r = n(5408),
          o = n(4844),
          a = n(7730);
        const i = { m: "margin", p: "padding" },
          s = {
            t: "Top",
            r: "Right",
            b: "Bottom",
            l: "Left",
            x: ["Left", "Right"],
            y: ["Top", "Bottom"],
          },
          l = { marginX: "mx", marginY: "my", paddingX: "px", paddingY: "py" },
          d = (function (e) {
            const t = {};
            return (e) => (
              void 0 === t[e] &&
                (t[e] = ((e) => {
                  if (e.length > 2) {
                    if (!l[e]) return [e];
                    e = l[e];
                  }
                  const [t, n] = e.split(""),
                    r = i[t],
                    o = s[n] || "";
                  return Array.isArray(o) ? o.map((e) => r + e) : [r + o];
                })(e)),
              t[e]
            );
          })(),
          c = [
            "m",
            "mt",
            "mr",
            "mb",
            "ml",
            "mx",
            "my",
            "margin",
            "marginTop",
            "marginRight",
            "marginBottom",
            "marginLeft",
            "marginX",
            "marginY",
            "marginInline",
            "marginInlineStart",
            "marginInlineEnd",
            "marginBlock",
            "marginBlockStart",
            "marginBlockEnd",
          ],
          u = [
            "p",
            "pt",
            "pr",
            "pb",
            "pl",
            "px",
            "py",
            "padding",
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
            "paddingX",
            "paddingY",
            "paddingInline",
            "paddingInlineStart",
            "paddingInlineEnd",
            "paddingBlock",
            "paddingBlockStart",
            "paddingBlockEnd",
          ],
          p = [...c, ...u];
        function m(e, t, n, r) {
          var a;
          const i = null != (a = (0, o.DW)(e, t, !1)) ? a : n;
          return "number" == typeof i
            ? (e) => ("string" == typeof e ? e : i * e)
            : Array.isArray(i)
            ? (e) => ("string" == typeof e ? e : i[e])
            : "function" == typeof i
            ? i
            : () => {};
        }
        function h(e) {
          return m(e, "spacing", 8);
        }
        function f(e, t) {
          if ("string" == typeof t || null == t) return t;
          const n = e(Math.abs(t));
          return t >= 0 ? n : "number" == typeof n ? -n : `-${n}`;
        }
        function g(e, t) {
          const n = h(e.theme);
          return Object.keys(e)
            .map((o) =>
              (function (e, t, n, o) {
                if (-1 === t.indexOf(n)) return null;
                const a = (function (e, t) {
                    return (n) => e.reduce((e, r) => ((e[r] = f(t, n)), e), {});
                  })(d(n), o),
                  i = e[n];
                return (0, r.k9)(e, i, a);
              })(e, t, o, n)
            )
            .reduce(a.Z, {});
        }
        function v(e) {
          return g(e, c);
        }
        function b(e) {
          return g(e, u);
        }
        function _(e) {
          return g(e, p);
        }
        (v.propTypes = {}),
          (v.filterProps = c),
          (b.propTypes = {}),
          (b.filterProps = u),
          (_.propTypes = {}),
          (_.filterProps = p);
      },
      4844: function (e, t, n) {
        "use strict";
        n.d(t, {
          DW: function () {
            return a;
          },
          Jq: function () {
            return i;
          },
        });
        var r = n(4142),
          o = n(5408);
        function a(e, t, n = !0) {
          if (!t || "string" != typeof t) return null;
          if (e && e.vars && n) {
            const n = `vars.${t}`
              .split(".")
              .reduce((e, t) => (e && e[t] ? e[t] : null), e);
            if (null != n) return n;
          }
          return t
            .split(".")
            .reduce((e, t) => (e && null != e[t] ? e[t] : null), e);
        }
        function i(e, t, n, r = n) {
          let o;
          return (
            (o =
              "function" == typeof e
                ? e(n)
                : Array.isArray(e)
                ? e[n] || r
                : a(e, n) || r),
            t && (o = t(o, r, e)),
            o
          );
        }
        t.ZP = function (e) {
          const {
              prop: t,
              cssProperty: n = e.prop,
              themeKey: s,
              transform: l,
            } = e,
            d = (e) => {
              if (null == e[t]) return null;
              const d = e[t],
                c = a(e.theme, s) || {};
              return (0, o.k9)(e, d, (e) => {
                let o = i(c, l, e);
                return (
                  e === o &&
                    "string" == typeof e &&
                    (o = i(
                      c,
                      l,
                      `${t}${"default" === e ? "" : (0, r.Z)(e)}`,
                      e
                    )),
                  !1 === n ? o : { [n]: o }
                );
              });
            };
          return (d.propTypes = {}), (d.filterProps = [t]), d;
        };
      },
      8010: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return A;
          },
        });
        var r = n(2605),
          o = n(4844),
          a = n(7730),
          i = function (...e) {
            const t = e.reduce(
                (e, t) => (
                  t.filterProps.forEach((n) => {
                    e[n] = t;
                  }),
                  e
                ),
                {}
              ),
              n = (e) =>
                Object.keys(e).reduce(
                  (n, r) => (t[r] ? (0, a.Z)(n, t[r](e)) : n),
                  {}
                );
            return (
              (n.propTypes = {}),
              (n.filterProps = e.reduce((e, t) => e.concat(t.filterProps), [])),
              n
            );
          },
          s = n(5408);
        function l(e) {
          return "number" != typeof e ? e : `${e}px solid`;
        }
        function d(e, t) {
          return (0, o.ZP)({ prop: e, themeKey: "borders", transform: t });
        }
        const c = d("border", l),
          u = d("borderTop", l),
          p = d("borderRight", l),
          m = d("borderBottom", l),
          h = d("borderLeft", l),
          f = d("borderColor"),
          g = d("borderTopColor"),
          v = d("borderRightColor"),
          b = d("borderBottomColor"),
          _ = d("borderLeftColor"),
          y = d("outline", l),
          C = d("outlineColor"),
          x = (e) => {
            if (void 0 !== e.borderRadius && null !== e.borderRadius) {
              const t = (0, r.eI)(
                  e.theme,
                  "shape.borderRadius",
                  4,
                  "borderRadius"
                ),
                n = (e) => ({ borderRadius: (0, r.NA)(t, e) });
              return (0, s.k9)(e, e.borderRadius, n);
            }
            return null;
          };
        (x.propTypes = {}),
          (x.filterProps = ["borderRadius"]),
          i(c, u, p, m, h, f, g, v, b, _, x, y, C);
        const S = (e) => {
          if (void 0 !== e.gap && null !== e.gap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "gap"),
              n = (e) => ({ gap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.gap, n);
          }
          return null;
        };
        (S.propTypes = {}), (S.filterProps = ["gap"]);
        const k = (e) => {
          if (void 0 !== e.columnGap && null !== e.columnGap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "columnGap"),
              n = (e) => ({ columnGap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.columnGap, n);
          }
          return null;
        };
        (k.propTypes = {}), (k.filterProps = ["columnGap"]);
        const P = (e) => {
          if (void 0 !== e.rowGap && null !== e.rowGap) {
            const t = (0, r.eI)(e.theme, "spacing", 8, "rowGap"),
              n = (e) => ({ rowGap: (0, r.NA)(t, e) });
            return (0, s.k9)(e, e.rowGap, n);
          }
          return null;
        };
        function w(e, t) {
          return "grey" === t ? t : e;
        }
        function O(e) {
          return e <= 1 && 0 !== e ? 100 * e + "%" : e;
        }
        (P.propTypes = {}),
          (P.filterProps = ["rowGap"]),
          i(
            S,
            k,
            P,
            (0, o.ZP)({ prop: "gridColumn" }),
            (0, o.ZP)({ prop: "gridRow" }),
            (0, o.ZP)({ prop: "gridAutoFlow" }),
            (0, o.ZP)({ prop: "gridAutoColumns" }),
            (0, o.ZP)({ prop: "gridAutoRows" }),
            (0, o.ZP)({ prop: "gridTemplateColumns" }),
            (0, o.ZP)({ prop: "gridTemplateRows" }),
            (0, o.ZP)({ prop: "gridTemplateAreas" }),
            (0, o.ZP)({ prop: "gridArea" })
          ),
          i(
            (0, o.ZP)({ prop: "color", themeKey: "palette", transform: w }),
            (0, o.ZP)({
              prop: "bgcolor",
              cssProperty: "backgroundColor",
              themeKey: "palette",
              transform: w,
            }),
            (0, o.ZP)({
              prop: "backgroundColor",
              themeKey: "palette",
              transform: w,
            })
          );
        const T = (0, o.ZP)({ prop: "width", transform: O }),
          I = (e) => {
            if (void 0 !== e.maxWidth && null !== e.maxWidth) {
              const t = (t) => {
                var n, r;
                const o =
                  (null == (n = e.theme) ||
                  null == (n = n.breakpoints) ||
                  null == (n = n.values)
                    ? void 0
                    : n[t]) || s.VO[t];
                return o
                  ? "px" !==
                    (null == (r = e.theme) || null == (r = r.breakpoints)
                      ? void 0
                      : r.unit)
                    ? { maxWidth: `${o}${e.theme.breakpoints.unit}` }
                    : { maxWidth: o }
                  : { maxWidth: O(t) };
              };
              return (0, s.k9)(e, e.maxWidth, t);
            }
            return null;
          };
        I.filterProps = ["maxWidth"];
        const M = (0, o.ZP)({ prop: "minWidth", transform: O }),
          j = (0, o.ZP)({ prop: "height", transform: O }),
          N = (0, o.ZP)({ prop: "maxHeight", transform: O }),
          D = (0, o.ZP)({ prop: "minHeight", transform: O });
        (0, o.ZP)({ prop: "size", cssProperty: "width", transform: O }),
          (0, o.ZP)({ prop: "size", cssProperty: "height", transform: O }),
          i(T, I, M, j, N, D, (0, o.ZP)({ prop: "boxSizing" }));
        var A = {
          border: { themeKey: "borders", transform: l },
          borderTop: { themeKey: "borders", transform: l },
          borderRight: { themeKey: "borders", transform: l },
          borderBottom: { themeKey: "borders", transform: l },
          borderLeft: { themeKey: "borders", transform: l },
          borderColor: { themeKey: "palette" },
          borderTopColor: { themeKey: "palette" },
          borderRightColor: { themeKey: "palette" },
          borderBottomColor: { themeKey: "palette" },
          borderLeftColor: { themeKey: "palette" },
          outline: { themeKey: "borders", transform: l },
          outlineColor: { themeKey: "palette" },
          borderRadius: { themeKey: "shape.borderRadius", style: x },
          color: { themeKey: "palette", transform: w },
          bgcolor: {
            themeKey: "palette",
            cssProperty: "backgroundColor",
            transform: w,
          },
          backgroundColor: { themeKey: "palette", transform: w },
          p: { style: r.o3 },
          pt: { style: r.o3 },
          pr: { style: r.o3 },
          pb: { style: r.o3 },
          pl: { style: r.o3 },
          px: { style: r.o3 },
          py: { style: r.o3 },
          padding: { style: r.o3 },
          paddingTop: { style: r.o3 },
          paddingRight: { style: r.o3 },
          paddingBottom: { style: r.o3 },
          paddingLeft: { style: r.o3 },
          paddingX: { style: r.o3 },
          paddingY: { style: r.o3 },
          paddingInline: { style: r.o3 },
          paddingInlineStart: { style: r.o3 },
          paddingInlineEnd: { style: r.o3 },
          paddingBlock: { style: r.o3 },
          paddingBlockStart: { style: r.o3 },
          paddingBlockEnd: { style: r.o3 },
          m: { style: r.e6 },
          mt: { style: r.e6 },
          mr: { style: r.e6 },
          mb: { style: r.e6 },
          ml: { style: r.e6 },
          mx: { style: r.e6 },
          my: { style: r.e6 },
          margin: { style: r.e6 },
          marginTop: { style: r.e6 },
          marginRight: { style: r.e6 },
          marginBottom: { style: r.e6 },
          marginLeft: { style: r.e6 },
          marginX: { style: r.e6 },
          marginY: { style: r.e6 },
          marginInline: { style: r.e6 },
          marginInlineStart: { style: r.e6 },
          marginInlineEnd: { style: r.e6 },
          marginBlock: { style: r.e6 },
          marginBlockStart: { style: r.e6 },
          marginBlockEnd: { style: r.e6 },
          displayPrint: {
            cssProperty: !1,
            transform: (e) => ({ "@media print": { display: e } }),
          },
          display: {},
          overflow: {},
          textOverflow: {},
          visibility: {},
          whiteSpace: {},
          flexBasis: {},
          flexDirection: {},
          flexWrap: {},
          justifyContent: {},
          alignItems: {},
          alignContent: {},
          order: {},
          flex: {},
          flexGrow: {},
          flexShrink: {},
          alignSelf: {},
          justifyItems: {},
          justifySelf: {},
          gap: { style: S },
          rowGap: { style: P },
          columnGap: { style: k },
          gridColumn: {},
          gridRow: {},
          gridAutoFlow: {},
          gridAutoColumns: {},
          gridAutoRows: {},
          gridTemplateColumns: {},
          gridTemplateRows: {},
          gridTemplateAreas: {},
          gridArea: {},
          position: {},
          zIndex: { themeKey: "zIndex" },
          top: {},
          right: {},
          bottom: {},
          left: {},
          boxShadow: { themeKey: "shadows" },
          width: { transform: O },
          maxWidth: { style: I },
          minWidth: { transform: O },
          height: { transform: O },
          maxHeight: { transform: O },
          minHeight: { transform: O },
          boxSizing: {},
          fontFamily: { themeKey: "typography" },
          fontSize: { themeKey: "typography" },
          fontStyle: { themeKey: "typography" },
          fontWeight: { themeKey: "typography" },
          letterSpacing: {},
          textTransform: {},
          lineHeight: {},
          textAlign: {},
          typography: { cssProperty: !1, themeKey: "typography" },
        };
      },
      9707: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return d;
          },
        });
        var r = n(7462),
          o = n(3366),
          a = n(4953),
          i = n(8010);
        const s = ["sx"],
          l = (e) => {
            var t, n;
            const r = { systemProps: {}, otherProps: {} },
              o =
                null !=
                (t =
                  null == e || null == (n = e.theme)
                    ? void 0
                    : n.unstable_sxConfig)
                  ? t
                  : i.Z;
            return (
              Object.keys(e).forEach((t) => {
                o[t] ? (r.systemProps[t] = e[t]) : (r.otherProps[t] = e[t]);
              }),
              r
            );
          };
        function d(e) {
          const { sx: t } = e,
            n = (0, o.Z)(e, s),
            { systemProps: i, otherProps: d } = l(n);
          let c;
          return (
            (c = Array.isArray(t)
              ? [i, ...t]
              : "function" == typeof t
              ? (...e) => {
                  const n = t(...e);
                  return (0, a.P)(n) ? (0, r.Z)({}, i, n) : i;
                }
              : (0, r.Z)({}, i, t)),
            (0, r.Z)({}, d, { sx: c })
          );
        }
      },
      386: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            extendSxProp: function () {
              return o.Z;
            },
            unstable_createStyleFunctionSx: function () {
              return r.n;
            },
            unstable_defaultSxConfig: function () {
              return a.Z;
            },
          });
        var r = n(6523),
          o = n(9707),
          a = n(8010);
      },
      6523: function (e, t, n) {
        "use strict";
        n.d(t, {
          n: function () {
            return l;
          },
        });
        var r = n(4142),
          o = n(7730),
          a = n(4844),
          i = n(5408),
          s = n(8010);
        function l() {
          function e(e, t, n, o) {
            const s = { [e]: t, theme: n },
              l = o[e];
            if (!l) return { [e]: t };
            const {
              cssProperty: d = e,
              themeKey: c,
              transform: u,
              style: p,
            } = l;
            if (null == t) return null;
            if ("typography" === c && "inherit" === t) return { [e]: t };
            const m = (0, a.DW)(n, c) || {};
            return p
              ? p(s)
              : (0, i.k9)(s, t, (t) => {
                  let n = (0, a.Jq)(m, u, t);
                  return (
                    t === n &&
                      "string" == typeof t &&
                      (n = (0, a.Jq)(
                        m,
                        u,
                        `${e}${"default" === t ? "" : (0, r.Z)(t)}`,
                        t
                      )),
                    !1 === d ? n : { [d]: n }
                  );
                });
          }
          return function t(n) {
            var r;
            const { sx: a, theme: l = {} } = n || {};
            if (!a) return null;
            const d = null != (r = l.unstable_sxConfig) ? r : s.Z;
            function c(n) {
              let r = n;
              if ("function" == typeof n) r = n(l);
              else if ("object" != typeof n) return n;
              if (!r) return null;
              const a = (0, i.W8)(l.breakpoints),
                s = Object.keys(a);
              let c = a;
              return (
                Object.keys(r).forEach((n) => {
                  const a = "function" == typeof (s = r[n]) ? s(l) : s;
                  var s;
                  if (null != a)
                    if ("object" == typeof a)
                      if (d[n]) c = (0, o.Z)(c, e(n, a, l, d));
                      else {
                        const e = (0, i.k9)({ theme: l }, a, (e) => ({
                          [n]: e,
                        }));
                        !(function (...e) {
                          const t = e.reduce(
                              (e, t) => e.concat(Object.keys(t)),
                              []
                            ),
                            n = new Set(t);
                          return e.every(
                            (e) => n.size === Object.keys(e).length
                          );
                        })(e, a)
                          ? (c = (0, o.Z)(c, e))
                          : (c[n] = t({ sx: a, theme: l }));
                      }
                    else c = (0, o.Z)(c, e(n, a, l, d));
                }),
                (0, i.L7)(s, c)
              );
            }
            return Array.isArray(a) ? a.map(c) : c(a);
          };
        }
        const d = l();
        (d.filterProps = ["sx"]), (t.Z = d);
      },
      1070: function (e, t, n) {
        "use strict";
        t.Z = void 0;
        var r = (function (e, t) {
            if (e && e.__esModule) return e;
            if (null === e || ("object" != typeof e && "function" != typeof e))
              return { default: e };
            var n = a(t);
            if (n && n.has(e)) return n.get(e);
            var r = { __proto__: null },
              o = Object.defineProperty && Object.getOwnPropertyDescriptor;
            for (var i in e)
              if (
                "default" !== i &&
                Object.prototype.hasOwnProperty.call(e, i)
              ) {
                var s = o ? Object.getOwnPropertyDescriptor(e, i) : null;
                s && (s.get || s.set)
                  ? Object.defineProperty(r, i, s)
                  : (r[i] = e[i]);
              }
            return (r.default = e), n && n.set(e, r), r;
          })(n(7294)),
          o = n(4742);
        function a(e) {
          if ("function" != typeof WeakMap) return null;
          var t = new WeakMap(),
            n = new WeakMap();
          return (a = function (e) {
            return e ? n : t;
          })(e);
        }
        t.Z = function (e = null) {
          const t = r.useContext(o.ThemeContext);
          return t && ((n = t), 0 !== Object.keys(n).length) ? t : e;
          var n;
        };
      },
      7078: function (e, t) {
        "use strict";
        const n = (e) => e,
          r = (() => {
            let e = n;
            return {
              configure(t) {
                e = t;
              },
              generate(t) {
                return e(t);
              },
              reset() {
                e = n;
              },
            };
          })();
        t.Z = r;
      },
      4142: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(6535);
        function o(e) {
          if ("string" != typeof e) throw new Error((0, r.Z)(7));
          return e.charAt(0).toUpperCase() + e.slice(1);
        }
      },
      7641: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
          });
        var r = n(4142);
      },
      9681: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r;
            },
          });
        var r = function (
          e,
          t = Number.MIN_SAFE_INTEGER,
          n = Number.MAX_SAFE_INTEGER
        ) {
          return Math.max(t, Math.min(e, n));
        };
      },
      4780: function (e, t, n) {
        "use strict";
        function r(e, t, n = void 0) {
          const r = {};
          return (
            Object.keys(e).forEach((o) => {
              r[o] = e[o]
                .reduce((e, r) => {
                  if (r) {
                    const o = t(r);
                    "" !== o && e.push(o), n && n[r] && e.push(n[r]);
                  }
                  return e;
                }, [])
                .join(" ");
            }),
            r
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      1476: function (e, t, n) {
        "use strict";
        function r(...e) {
          return e.reduce(
            (e, t) =>
              null == t
                ? e
                : function (...n) {
                    e.apply(this, n), t.apply(this, n);
                  },
            () => {}
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      9336: function (e, t, n) {
        "use strict";
        function r(e, t = 166) {
          let n;
          function r(...r) {
            clearTimeout(n),
              (n = setTimeout(() => {
                e.apply(this, r);
              }, t));
          }
          return (
            (r.clear = () => {
              clearTimeout(n);
            }),
            r
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      4953: function (e, t, n) {
        "use strict";
        n.d(t, {
          P: function () {
            return a;
          },
          Z: function () {
            return s;
          },
        });
        var r = n(7462),
          o = n(7294);
        function a(e) {
          if ("object" != typeof e || null === e) return !1;
          const t = Object.getPrototypeOf(e);
          return !(
            (null !== t &&
              t !== Object.prototype &&
              null !== Object.getPrototypeOf(t)) ||
            Symbol.toStringTag in e ||
            Symbol.iterator in e
          );
        }
        function i(e) {
          if (o.isValidElement(e) || !a(e)) return e;
          const t = {};
          return (
            Object.keys(e).forEach((n) => {
              t[n] = i(e[n]);
            }),
            t
          );
        }
        function s(e, t, n = { clone: !0 }) {
          const l = n.clone ? (0, r.Z)({}, e) : e;
          return (
            a(e) &&
              a(t) &&
              Object.keys(t).forEach((r) => {
                o.isValidElement(t[r])
                  ? (l[r] = t[r])
                  : a(t[r]) &&
                    Object.prototype.hasOwnProperty.call(e, r) &&
                    a(e[r])
                  ? (l[r] = s(e[r], t[r], n))
                  : n.clone
                  ? (l[r] = a(t[r]) ? i(t[r]) : t[r])
                  : (l[r] = t[r]);
              }),
            l
          );
        }
      },
      8524: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
            isPlainObject: function () {
              return r.P;
            },
          });
        var r = n(4953);
      },
      6535: function (e, t, n) {
        "use strict";
        function r(e) {
          let t = "https://mui.com/production-error/?code=" + e;
          for (let e = 1; e < arguments.length; e += 1)
            t += "&args[]=" + encodeURIComponent(arguments[e]);
          return (
            "Minified MUI error #" +
            e +
            "; visit " +
            t +
            " for the full message."
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      5480: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return r.Z;
            },
          });
        var r = n(6535);
      },
      5677: function (e, t, n) {
        "use strict";
        n.d(t, {
          ZP: function () {
            return a;
          },
        });
        var r = n(7078);
        const o = {
          active: "active",
          checked: "checked",
          completed: "completed",
          disabled: "disabled",
          error: "error",
          expanded: "expanded",
          focused: "focused",
          focusVisible: "focusVisible",
          open: "open",
          readOnly: "readOnly",
          required: "required",
          selected: "selected",
        };
        function a(e, t, n = "Mui") {
          const a = o[t];
          return a ? `${n}-${a}` : `${r.Z.generate(e)}-${t}`;
        }
      },
      1588: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(5677);
        function o(e, t, n = "Mui") {
          const o = {};
          return (
            t.forEach((t) => {
              o[t] = (0, r.ZP)(e, t, n);
            }),
            o
          );
        }
      },
      3163: function (e, t, n) {
        "use strict";
        n.r(t),
          n.d(t, {
            default: function () {
              return l;
            },
            getFunctionName: function () {
              return a;
            },
          });
        var r = n(8055);
        const o = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
        function a(e) {
          const t = `${e}`.match(o);
          return (t && t[1]) || "";
        }
        function i(e, t = "") {
          return e.displayName || e.name || a(e) || t;
        }
        function s(e, t, n) {
          const r = i(t);
          return e.displayName || ("" !== r ? `${n}(${r})` : n);
        }
        function l(e) {
          if (null != e) {
            if ("string" == typeof e) return e;
            if ("function" == typeof e) return i(e, "Component");
            if ("object" == typeof e)
              switch (e.$$typeof) {
                case r.A4:
                  return s(e, e.render, "ForwardRef");
                case r._Y:
                  return s(e, e.type, "memo");
                default:
                  return;
              }
          }
        }
      },
      2690: function (e, t, n) {
        "use strict";
        function r(e) {
          return (e && e.ownerDocument) || document;
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      4161: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(2690);
        function o(e) {
          return (0, r.Z)(e).defaultView || window;
        }
      },
      5971: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7462);
        function o(e, t) {
          const n = (0, r.Z)({}, t);
          return (
            Object.keys(e).forEach((a) => {
              if (a.toString().match(/^(components|slots)$/))
                n[a] = (0, r.Z)({}, e[a], n[a]);
              else if (a.toString().match(/^(componentsProps|slotProps)$/)) {
                const i = e[a] || {},
                  s = t[a];
                (n[a] = {}),
                  s && Object.keys(s)
                    ? i && Object.keys(i)
                      ? ((n[a] = (0, r.Z)({}, s)),
                        Object.keys(i).forEach((e) => {
                          n[a][e] = o(i[e], s[e]);
                        }))
                      : (n[a] = s)
                    : (n[a] = i);
              } else void 0 === n[a] && (n[a] = e[a]);
            }),
            n
          );
        }
      },
      7364: function (e, t, n) {
        "use strict";
        function r(e, t) {
          "function" == typeof e ? e(t) : e && (e.current = t);
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      9032: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return o;
          },
        });
        var r = n(7294);
        function o({ controlled: e, default: t, name: n, state: o = "value" }) {
          const { current: a } = r.useRef(void 0 !== e),
            [i, s] = r.useState(t);
          return [
            a ? e : i,
            r.useCallback((e) => {
              a || s(e);
            }, []),
          ];
        }
      },
      3546: function (e, t, n) {
        "use strict";
        var r = n(7294);
        const o =
          "undefined" != typeof window ? r.useLayoutEffect : r.useEffect;
        t.Z = o;
      },
      9948: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = n(3546);
        t.Z = function (e) {
          const t = r.useRef(e);
          return (
            (0, o.Z)(() => {
              t.current = e;
            }),
            r.useRef((...e) => (0, t.current)(...e)).current
          );
        };
      },
      3703: function (e, t, n) {
        "use strict";
        n.d(t, {
          Z: function () {
            return a;
          },
        });
        var r = n(7294),
          o = n(7364);
        function a(...e) {
          return r.useMemo(
            () =>
              e.every((e) => null == e)
                ? null
                : (t) => {
                    e.forEach((e) => {
                      (0, o.Z)(e, t);
                    });
                  },
            e
          );
        }
      },
      2996: function (e, t, n) {
        "use strict";
        var r;
        n.d(t, {
          Z: function () {
            return s;
          },
        });
        var o = n(7294);
        let a = 0;
        const i = (r || (r = n.t(o, 2)))["useId".toString()];
        function s(e) {
          if (void 0 !== i) {
            const t = i();
            return null != e ? e : t;
          }
          return (function (e) {
            const [t, n] = o.useState(e),
              r = e || t;
            return (
              o.useEffect(() => {
                null == t && ((a += 1), n(`mui-${a}`));
              }, [t]),
              r
            );
          })(e);
        }
      },
      1818: function (e, t, n) {
        "use strict";
        n.d(t, {
          V: function () {
            return i;
          },
          Z: function () {
            return s;
          },
        });
        var r = n(7294);
        const o = {},
          a = [];
        class i {
          constructor() {
            (this.currentId = null),
              (this.clear = () => {
                null !== this.currentId &&
                  (clearTimeout(this.currentId), (this.currentId = null));
              }),
              (this.disposeEffect = () => this.clear);
          }
          static create() {
            return new i();
          }
          start(e, t) {
            this.clear(),
              (this.currentId = setTimeout(() => {
                (this.currentId = null), t();
              }, e));
          }
        }
        function s() {
          const e = (function (e, t) {
            const n = r.useRef(o);
            return n.current === o && (n.current = e(void 0)), n;
          })(i.create).current;
          var t;
          return (t = e.disposeEffect), r.useEffect(t, a), e;
        }
      },
      8055: function (e, t) {
        "use strict";
        Symbol.for("react.transitional.element"),
          Symbol.for("react.portal"),
          Symbol.for("react.fragment"),
          Symbol.for("react.strict_mode"),
          Symbol.for("react.profiler");
        Symbol.for("react.provider");
        Symbol.for("react.consumer"), Symbol.for("react.context");
        var n = Symbol.for("react.forward_ref"),
          r =
            (Symbol.for("react.suspense"),
            Symbol.for("react.suspense_list"),
            Symbol.for("react.memo"));
        Symbol.for("react.lazy"),
          Symbol.for("react.offscreen"),
          Symbol.for("react.client.reference");
        (t.A4 = n), (t._Y = r);
      },
      9669: function (e, t, n) {
        e.exports = n(1609);
      },
      5448: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(6026),
          a = n(4372),
          i = n(5327),
          s = n(4097),
          l = n(4109),
          d = n(7985),
          c = n(5061),
          u = n(7874),
          p = n(5263);
        e.exports = function (e) {
          return new Promise(function (t, n) {
            var m,
              h = e.data,
              f = e.headers,
              g = e.responseType;
            function v() {
              e.cancelToken && e.cancelToken.unsubscribe(m),
                e.signal && e.signal.removeEventListener("abort", m);
            }
            r.isFormData(h) && delete f["Content-Type"];
            var b = new XMLHttpRequest();
            if (e.auth) {
              var _ = e.auth.username || "",
                y = e.auth.password
                  ? unescape(encodeURIComponent(e.auth.password))
                  : "";
              f.Authorization = "Basic " + btoa(_ + ":" + y);
            }
            var C = s(e.baseURL, e.url);
            function x() {
              if (b) {
                var r =
                    "getAllResponseHeaders" in b
                      ? l(b.getAllResponseHeaders())
                      : null,
                  a = {
                    data:
                      g && "text" !== g && "json" !== g
                        ? b.response
                        : b.responseText,
                    status: b.status,
                    statusText: b.statusText,
                    headers: r,
                    config: e,
                    request: b,
                  };
                o(
                  function (e) {
                    t(e), v();
                  },
                  function (e) {
                    n(e), v();
                  },
                  a
                ),
                  (b = null);
              }
            }
            if (
              (b.open(
                e.method.toUpperCase(),
                i(C, e.params, e.paramsSerializer),
                !0
              ),
              (b.timeout = e.timeout),
              "onloadend" in b
                ? (b.onloadend = x)
                : (b.onreadystatechange = function () {
                    b &&
                      4 === b.readyState &&
                      (0 !== b.status ||
                        (b.responseURL &&
                          0 === b.responseURL.indexOf("file:"))) &&
                      setTimeout(x);
                  }),
              (b.onabort = function () {
                b &&
                  (n(c("Request aborted", e, "ECONNABORTED", b)), (b = null));
              }),
              (b.onerror = function () {
                n(c("Network Error", e, null, b)), (b = null);
              }),
              (b.ontimeout = function () {
                var t = e.timeout
                    ? "timeout of " + e.timeout + "ms exceeded"
                    : "timeout exceeded",
                  r = e.transitional || u;
                e.timeoutErrorMessage && (t = e.timeoutErrorMessage),
                  n(
                    c(
                      t,
                      e,
                      r.clarifyTimeoutError ? "ETIMEDOUT" : "ECONNABORTED",
                      b
                    )
                  ),
                  (b = null);
              }),
              r.isStandardBrowserEnv())
            ) {
              var S =
                (e.withCredentials || d(C)) && e.xsrfCookieName
                  ? a.read(e.xsrfCookieName)
                  : void 0;
              S && (f[e.xsrfHeaderName] = S);
            }
            "setRequestHeader" in b &&
              r.forEach(f, function (e, t) {
                void 0 === h && "content-type" === t.toLowerCase()
                  ? delete f[t]
                  : b.setRequestHeader(t, e);
              }),
              r.isUndefined(e.withCredentials) ||
                (b.withCredentials = !!e.withCredentials),
              g && "json" !== g && (b.responseType = e.responseType),
              "function" == typeof e.onDownloadProgress &&
                b.addEventListener("progress", e.onDownloadProgress),
              "function" == typeof e.onUploadProgress &&
                b.upload &&
                b.upload.addEventListener("progress", e.onUploadProgress),
              (e.cancelToken || e.signal) &&
                ((m = function (e) {
                  b &&
                    (n(!e || (e && e.type) ? new p("canceled") : e),
                    b.abort(),
                    (b = null));
                }),
                e.cancelToken && e.cancelToken.subscribe(m),
                e.signal &&
                  (e.signal.aborted
                    ? m()
                    : e.signal.addEventListener("abort", m))),
              h || (h = null),
              b.send(h);
          });
        };
      },
      1609: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(1849),
          a = n(321),
          i = n(7185),
          s = (function e(t) {
            var n = new a(t),
              s = o(a.prototype.request, n);
            return (
              r.extend(s, a.prototype, n),
              r.extend(s, n),
              (s.create = function (n) {
                return e(i(t, n));
              }),
              s
            );
          })(n(5546));
        (s.Axios = a),
          (s.Cancel = n(5263)),
          (s.CancelToken = n(4972)),
          (s.isCancel = n(6502)),
          (s.VERSION = n(7288).version),
          (s.all = function (e) {
            return Promise.all(e);
          }),
          (s.spread = n(8713)),
          (s.isAxiosError = n(6268)),
          (e.exports = s),
          (e.exports.default = s);
      },
      5263: function (e) {
        "use strict";
        function t(e) {
          this.message = e;
        }
        (t.prototype.toString = function () {
          return "Cancel" + (this.message ? ": " + this.message : "");
        }),
          (t.prototype.__CANCEL__ = !0),
          (e.exports = t);
      },
      4972: function (e, t, n) {
        "use strict";
        var r = n(5263);
        function o(e) {
          if ("function" != typeof e)
            throw new TypeError("executor must be a function.");
          var t;
          this.promise = new Promise(function (e) {
            t = e;
          });
          var n = this;
          this.promise.then(function (e) {
            if (n._listeners) {
              var t,
                r = n._listeners.length;
              for (t = 0; t < r; t++) n._listeners[t](e);
              n._listeners = null;
            }
          }),
            (this.promise.then = function (e) {
              var t,
                r = new Promise(function (e) {
                  n.subscribe(e), (t = e);
                }).then(e);
              return (
                (r.cancel = function () {
                  n.unsubscribe(t);
                }),
                r
              );
            }),
            e(function (e) {
              n.reason || ((n.reason = new r(e)), t(n.reason));
            });
        }
        (o.prototype.throwIfRequested = function () {
          if (this.reason) throw this.reason;
        }),
          (o.prototype.subscribe = function (e) {
            this.reason
              ? e(this.reason)
              : this._listeners
              ? this._listeners.push(e)
              : (this._listeners = [e]);
          }),
          (o.prototype.unsubscribe = function (e) {
            if (this._listeners) {
              var t = this._listeners.indexOf(e);
              -1 !== t && this._listeners.splice(t, 1);
            }
          }),
          (o.source = function () {
            var e;
            return {
              token: new o(function (t) {
                e = t;
              }),
              cancel: e,
            };
          }),
          (e.exports = o);
      },
      6502: function (e) {
        "use strict";
        e.exports = function (e) {
          return !(!e || !e.__CANCEL__);
        };
      },
      321: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(5327),
          a = n(782),
          i = n(3572),
          s = n(7185),
          l = n(4875),
          d = l.validators;
        function c(e) {
          (this.defaults = e),
            (this.interceptors = { request: new a(), response: new a() });
        }
        (c.prototype.request = function (e, t) {
          "string" == typeof e ? ((t = t || {}).url = e) : (t = e || {}),
            (t = s(this.defaults, t)).method
              ? (t.method = t.method.toLowerCase())
              : this.defaults.method
              ? (t.method = this.defaults.method.toLowerCase())
              : (t.method = "get");
          var n = t.transitional;
          void 0 !== n &&
            l.assertOptions(
              n,
              {
                silentJSONParsing: d.transitional(d.boolean),
                forcedJSONParsing: d.transitional(d.boolean),
                clarifyTimeoutError: d.transitional(d.boolean),
              },
              !1
            );
          var r = [],
            o = !0;
          this.interceptors.request.forEach(function (e) {
            ("function" == typeof e.runWhen && !1 === e.runWhen(t)) ||
              ((o = o && e.synchronous), r.unshift(e.fulfilled, e.rejected));
          });
          var a,
            c = [];
          if (
            (this.interceptors.response.forEach(function (e) {
              c.push(e.fulfilled, e.rejected);
            }),
            !o)
          ) {
            var u = [i, void 0];
            for (
              Array.prototype.unshift.apply(u, r),
                u = u.concat(c),
                a = Promise.resolve(t);
              u.length;

            )
              a = a.then(u.shift(), u.shift());
            return a;
          }
          for (var p = t; r.length; ) {
            var m = r.shift(),
              h = r.shift();
            try {
              p = m(p);
            } catch (e) {
              h(e);
              break;
            }
          }
          try {
            a = i(p);
          } catch (e) {
            return Promise.reject(e);
          }
          for (; c.length; ) a = a.then(c.shift(), c.shift());
          return a;
        }),
          (c.prototype.getUri = function (e) {
            return (
              (e = s(this.defaults, e)),
              o(e.url, e.params, e.paramsSerializer).replace(/^\?/, "")
            );
          }),
          r.forEach(["delete", "get", "head", "options"], function (e) {
            c.prototype[e] = function (t, n) {
              return this.request(
                s(n || {}, { method: e, url: t, data: (n || {}).data })
              );
            };
          }),
          r.forEach(["post", "put", "patch"], function (e) {
            c.prototype[e] = function (t, n, r) {
              return this.request(s(r || {}, { method: e, url: t, data: n }));
            };
          }),
          (e.exports = c);
      },
      782: function (e, t, n) {
        "use strict";
        var r = n(4867);
        function o() {
          this.handlers = [];
        }
        (o.prototype.use = function (e, t, n) {
          return (
            this.handlers.push({
              fulfilled: e,
              rejected: t,
              synchronous: !!n && n.synchronous,
              runWhen: n ? n.runWhen : null,
            }),
            this.handlers.length - 1
          );
        }),
          (o.prototype.eject = function (e) {
            this.handlers[e] && (this.handlers[e] = null);
          }),
          (o.prototype.forEach = function (e) {
            r.forEach(this.handlers, function (t) {
              null !== t && e(t);
            });
          }),
          (e.exports = o);
      },
      4097: function (e, t, n) {
        "use strict";
        var r = n(1793),
          o = n(7303);
        e.exports = function (e, t) {
          return e && !r(t) ? o(e, t) : t;
        };
      },
      5061: function (e, t, n) {
        "use strict";
        var r = n(481);
        e.exports = function (e, t, n, o, a) {
          var i = new Error(e);
          return r(i, t, n, o, a);
        };
      },
      3572: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(8527),
          a = n(6502),
          i = n(5546),
          s = n(5263);
        function l(e) {
          if (
            (e.cancelToken && e.cancelToken.throwIfRequested(),
            e.signal && e.signal.aborted)
          )
            throw new s("canceled");
        }
        e.exports = function (e) {
          return (
            l(e),
            (e.headers = e.headers || {}),
            (e.data = o.call(e, e.data, e.headers, e.transformRequest)),
            (e.headers = r.merge(
              e.headers.common || {},
              e.headers[e.method] || {},
              e.headers
            )),
            r.forEach(
              ["delete", "get", "head", "post", "put", "patch", "common"],
              function (t) {
                delete e.headers[t];
              }
            ),
            (e.adapter || i.adapter)(e).then(
              function (t) {
                return (
                  l(e),
                  (t.data = o.call(e, t.data, t.headers, e.transformResponse)),
                  t
                );
              },
              function (t) {
                return (
                  a(t) ||
                    (l(e),
                    t &&
                      t.response &&
                      (t.response.data = o.call(
                        e,
                        t.response.data,
                        t.response.headers,
                        e.transformResponse
                      ))),
                  Promise.reject(t)
                );
              }
            )
          );
        };
      },
      481: function (e) {
        "use strict";
        e.exports = function (e, t, n, r, o) {
          return (
            (e.config = t),
            n && (e.code = n),
            (e.request = r),
            (e.response = o),
            (e.isAxiosError = !0),
            (e.toJSON = function () {
              return {
                message: this.message,
                name: this.name,
                description: this.description,
                number: this.number,
                fileName: this.fileName,
                lineNumber: this.lineNumber,
                columnNumber: this.columnNumber,
                stack: this.stack,
                config: this.config,
                code: this.code,
                status:
                  this.response && this.response.status
                    ? this.response.status
                    : null,
              };
            }),
            e
          );
        };
      },
      7185: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e, t) {
          t = t || {};
          var n = {};
          function o(e, t) {
            return r.isPlainObject(e) && r.isPlainObject(t)
              ? r.merge(e, t)
              : r.isPlainObject(t)
              ? r.merge({}, t)
              : r.isArray(t)
              ? t.slice()
              : t;
          }
          function a(n) {
            return r.isUndefined(t[n])
              ? r.isUndefined(e[n])
                ? void 0
                : o(void 0, e[n])
              : o(e[n], t[n]);
          }
          function i(e) {
            if (!r.isUndefined(t[e])) return o(void 0, t[e]);
          }
          function s(n) {
            return r.isUndefined(t[n])
              ? r.isUndefined(e[n])
                ? void 0
                : o(void 0, e[n])
              : o(void 0, t[n]);
          }
          function l(n) {
            return n in t ? o(e[n], t[n]) : n in e ? o(void 0, e[n]) : void 0;
          }
          var d = {
            url: i,
            method: i,
            data: i,
            baseURL: s,
            transformRequest: s,
            transformResponse: s,
            paramsSerializer: s,
            timeout: s,
            timeoutMessage: s,
            withCredentials: s,
            adapter: s,
            responseType: s,
            xsrfCookieName: s,
            xsrfHeaderName: s,
            onUploadProgress: s,
            onDownloadProgress: s,
            decompress: s,
            maxContentLength: s,
            maxBodyLength: s,
            transport: s,
            httpAgent: s,
            httpsAgent: s,
            cancelToken: s,
            socketPath: s,
            responseEncoding: s,
            validateStatus: l,
          };
          return (
            r.forEach(Object.keys(e).concat(Object.keys(t)), function (e) {
              var t = d[e] || a,
                o = t(e);
              (r.isUndefined(o) && t !== l) || (n[e] = o);
            }),
            n
          );
        };
      },
      6026: function (e, t, n) {
        "use strict";
        var r = n(5061);
        e.exports = function (e, t, n) {
          var o = n.config.validateStatus;
          n.status && o && !o(n.status)
            ? t(
                r(
                  "Request failed with status code " + n.status,
                  n.config,
                  null,
                  n.request,
                  n
                )
              )
            : e(n);
        };
      },
      8527: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(5546);
        e.exports = function (e, t, n) {
          var a = this || o;
          return (
            r.forEach(n, function (n) {
              e = n.call(a, e, t);
            }),
            e
          );
        };
      },
      5546: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = n(6016),
          a = n(481),
          i = n(7874),
          s = { "Content-Type": "application/x-www-form-urlencoded" };
        function l(e, t) {
          !r.isUndefined(e) &&
            r.isUndefined(e["Content-Type"]) &&
            (e["Content-Type"] = t);
        }
        var d,
          c = {
            transitional: i,
            adapter:
              (("undefined" != typeof XMLHttpRequest ||
                ("undefined" != typeof process &&
                  "[object process]" ===
                    Object.prototype.toString.call(process))) &&
                (d = n(5448)),
              d),
            transformRequest: [
              function (e, t) {
                return (
                  o(t, "Accept"),
                  o(t, "Content-Type"),
                  r.isFormData(e) ||
                  r.isArrayBuffer(e) ||
                  r.isBuffer(e) ||
                  r.isStream(e) ||
                  r.isFile(e) ||
                  r.isBlob(e)
                    ? e
                    : r.isArrayBufferView(e)
                    ? e.buffer
                    : r.isURLSearchParams(e)
                    ? (l(t, "application/x-www-form-urlencoded;charset=utf-8"),
                      e.toString())
                    : r.isObject(e) ||
                      (t && "application/json" === t["Content-Type"])
                    ? (l(t, "application/json"),
                      (function (e, t, n) {
                        if (r.isString(e))
                          try {
                            return (0, JSON.parse)(e), r.trim(e);
                          } catch (e) {
                            if ("SyntaxError" !== e.name) throw e;
                          }
                        return (0, JSON.stringify)(e);
                      })(e))
                    : e
                );
              },
            ],
            transformResponse: [
              function (e) {
                var t = this.transitional || c.transitional,
                  n = t && t.silentJSONParsing,
                  o = t && t.forcedJSONParsing,
                  i = !n && "json" === this.responseType;
                if (i || (o && r.isString(e) && e.length))
                  try {
                    return JSON.parse(e);
                  } catch (e) {
                    if (i) {
                      if ("SyntaxError" === e.name)
                        throw a(e, this, "E_JSON_PARSE");
                      throw e;
                    }
                  }
                return e;
              },
            ],
            timeout: 0,
            xsrfCookieName: "XSRF-TOKEN",
            xsrfHeaderName: "X-XSRF-TOKEN",
            maxContentLength: -1,
            maxBodyLength: -1,
            validateStatus: function (e) {
              return e >= 200 && e < 300;
            },
            headers: {
              common: { Accept: "application/json, text/plain, */*" },
            },
          };
        r.forEach(["delete", "get", "head"], function (e) {
          c.headers[e] = {};
        }),
          r.forEach(["post", "put", "patch"], function (e) {
            c.headers[e] = r.merge(s);
          }),
          (e.exports = c);
      },
      7874: function (e) {
        "use strict";
        e.exports = {
          silentJSONParsing: !0,
          forcedJSONParsing: !0,
          clarifyTimeoutError: !1,
        };
      },
      7288: function (e) {
        e.exports = { version: "0.26.1" };
      },
      1849: function (e) {
        "use strict";
        e.exports = function (e, t) {
          return function () {
            for (var n = new Array(arguments.length), r = 0; r < n.length; r++)
              n[r] = arguments[r];
            return e.apply(t, n);
          };
        };
      },
      5327: function (e, t, n) {
        "use strict";
        var r = n(4867);
        function o(e) {
          return encodeURIComponent(e)
            .replace(/%3A/gi, ":")
            .replace(/%24/g, "$")
            .replace(/%2C/gi, ",")
            .replace(/%20/g, "+")
            .replace(/%5B/gi, "[")
            .replace(/%5D/gi, "]");
        }
        e.exports = function (e, t, n) {
          if (!t) return e;
          var a;
          if (n) a = n(t);
          else if (r.isURLSearchParams(t)) a = t.toString();
          else {
            var i = [];
            r.forEach(t, function (e, t) {
              null != e &&
                (r.isArray(e) ? (t += "[]") : (e = [e]),
                r.forEach(e, function (e) {
                  r.isDate(e)
                    ? (e = e.toISOString())
                    : r.isObject(e) && (e = JSON.stringify(e)),
                    i.push(o(t) + "=" + o(e));
                }));
            }),
              (a = i.join("&"));
          }
          if (a) {
            var s = e.indexOf("#");
            -1 !== s && (e = e.slice(0, s)),
              (e += (-1 === e.indexOf("?") ? "?" : "&") + a);
          }
          return e;
        };
      },
      7303: function (e) {
        "use strict";
        e.exports = function (e, t) {
          return t ? e.replace(/\/+$/, "") + "/" + t.replace(/^\/+/, "") : e;
        };
      },
      4372: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = r.isStandardBrowserEnv()
          ? {
              write: function (e, t, n, o, a, i) {
                var s = [];
                s.push(e + "=" + encodeURIComponent(t)),
                  r.isNumber(n) &&
                    s.push("expires=" + new Date(n).toGMTString()),
                  r.isString(o) && s.push("path=" + o),
                  r.isString(a) && s.push("domain=" + a),
                  !0 === i && s.push("secure"),
                  (document.cookie = s.join("; "));
              },
              read: function (e) {
                var t = document.cookie.match(
                  new RegExp("(^|;\\s*)(" + e + ")=([^;]*)")
                );
                return t ? decodeURIComponent(t[3]) : null;
              },
              remove: function (e) {
                this.write(e, "", Date.now() - 864e5);
              },
            }
          : {
              write: function () {},
              read: function () {
                return null;
              },
              remove: function () {},
            };
      },
      1793: function (e) {
        "use strict";
        e.exports = function (e) {
          return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
        };
      },
      6268: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e) {
          return r.isObject(e) && !0 === e.isAxiosError;
        };
      },
      7985: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = r.isStandardBrowserEnv()
          ? (function () {
              var e,
                t = /(msie|trident)/i.test(navigator.userAgent),
                n = document.createElement("a");
              function o(e) {
                var r = e;
                return (
                  t && (n.setAttribute("href", r), (r = n.href)),
                  n.setAttribute("href", r),
                  {
                    href: n.href,
                    protocol: n.protocol ? n.protocol.replace(/:$/, "") : "",
                    host: n.host,
                    search: n.search ? n.search.replace(/^\?/, "") : "",
                    hash: n.hash ? n.hash.replace(/^#/, "") : "",
                    hostname: n.hostname,
                    port: n.port,
                    pathname:
                      "/" === n.pathname.charAt(0)
                        ? n.pathname
                        : "/" + n.pathname,
                  }
                );
              }
              return (
                (e = o(window.location.href)),
                function (t) {
                  var n = r.isString(t) ? o(t) : t;
                  return n.protocol === e.protocol && n.host === e.host;
                }
              );
            })()
          : function () {
              return !0;
            };
      },
      6016: function (e, t, n) {
        "use strict";
        var r = n(4867);
        e.exports = function (e, t) {
          r.forEach(e, function (n, r) {
            r !== t &&
              r.toUpperCase() === t.toUpperCase() &&
              ((e[t] = n), delete e[r]);
          });
        };
      },
      4109: function (e, t, n) {
        "use strict";
        var r = n(4867),
          o = [
            "age",
            "authorization",
            "content-length",
            "content-type",
            "etag",
            "expires",
            "from",
            "host",
            "if-modified-since",
            "if-unmodified-since",
            "last-modified",
            "location",
            "max-forwards",
            "proxy-authorization",
            "referer",
            "retry-after",
            "user-agent",
          ];
        e.exports = function (e) {
          var t,
            n,
            a,
            i = {};
          return e
            ? (r.forEach(e.split("\n"), function (e) {
                if (
                  ((a = e.indexOf(":")),
                  (t = r.trim(e.substr(0, a)).toLowerCase()),
                  (n = r.trim(e.substr(a + 1))),
                  t)
                ) {
                  if (i[t] && o.indexOf(t) >= 0) return;
                  i[t] =
                    "set-cookie" === t
                      ? (i[t] ? i[t] : []).concat([n])
                      : i[t]
                      ? i[t] + ", " + n
                      : n;
                }
              }),
              i)
            : i;
        };
      },
      8713: function (e) {
        "use strict";
        e.exports = function (e) {
          return function (t) {
            return e.apply(null, t);
          };
        };
      },
      4875: function (e, t, n) {
        "use strict";
        var r = n(7288).version,
          o = {};
        ["object", "boolean", "number", "function", "string", "symbol"].forEach(
          function (e, t) {
            o[e] = function (n) {
              return typeof n === e || "a" + (t < 1 ? "n " : " ") + e;
            };
          }
        );
        var a = {};
        (o.transitional = function (e, t, n) {
          function o(e, t) {
            return (
              "[Axios v" +
              r +
              "] Transitional option '" +
              e +
              "'" +
              t +
              (n ? ". " + n : "")
            );
          }
          return function (n, r, i) {
            if (!1 === e)
              throw new Error(
                o(r, " has been removed" + (t ? " in " + t : ""))
              );
            return (
              t &&
                !a[r] &&
                ((a[r] = !0),
                console.warn(
                  o(
                    r,
                    " has been deprecated since v" +
                      t +
                      " and will be removed in the near future"
                  )
                )),
              !e || e(n, r, i)
            );
          };
        }),
          (e.exports = {
            assertOptions: function (e, t, n) {
              if ("object" != typeof e)
                throw new TypeError("options must be an object");
              for (var r = Object.keys(e), o = r.length; o-- > 0; ) {
                var a = r[o],
                  i = t[a];
                if (i) {
                  var s = e[a],
                    l = void 0 === s || i(s, a, e);
                  if (!0 !== l)
                    throw new TypeError("option " + a + " must be " + l);
                } else if (!0 !== n) throw Error("Unknown option " + a);
              }
            },
            validators: o,
          });
      },
      4867: function (e, t, n) {
        "use strict";
        var r = n(1849),
          o = Object.prototype.toString;
        function a(e) {
          return Array.isArray(e);
        }
        function i(e) {
          return void 0 === e;
        }
        function s(e) {
          return "[object ArrayBuffer]" === o.call(e);
        }
        function l(e) {
          return null !== e && "object" == typeof e;
        }
        function d(e) {
          if ("[object Object]" !== o.call(e)) return !1;
          var t = Object.getPrototypeOf(e);
          return null === t || t === Object.prototype;
        }
        function c(e) {
          return "[object Function]" === o.call(e);
        }
        function u(e, t) {
          if (null != e)
            if (("object" != typeof e && (e = [e]), a(e)))
              for (var n = 0, r = e.length; n < r; n++)
                t.call(null, e[n], n, e);
            else
              for (var o in e)
                Object.prototype.hasOwnProperty.call(e, o) &&
                  t.call(null, e[o], o, e);
        }
        e.exports = {
          isArray: a,
          isArrayBuffer: s,
          isBuffer: function (e) {
            return (
              null !== e &&
              !i(e) &&
              null !== e.constructor &&
              !i(e.constructor) &&
              "function" == typeof e.constructor.isBuffer &&
              e.constructor.isBuffer(e)
            );
          },
          isFormData: function (e) {
            return "[object FormData]" === o.call(e);
          },
          isArrayBufferView: function (e) {
            return "undefined" != typeof ArrayBuffer && ArrayBuffer.isView
              ? ArrayBuffer.isView(e)
              : e && e.buffer && s(e.buffer);
          },
          isString: function (e) {
            return "string" == typeof e;
          },
          isNumber: function (e) {
            return "number" == typeof e;
          },
          isObject: l,
          isPlainObject: d,
          isUndefined: i,
          isDate: function (e) {
            return "[object Date]" === o.call(e);
          },
          isFile: function (e) {
            return "[object File]" === o.call(e);
          },
          isBlob: function (e) {
            return "[object Blob]" === o.call(e);
          },
          isFunction: c,
          isStream: function (e) {
            return l(e) && c(e.pipe);
          },
          isURLSearchParams: function (e) {
            return "[object URLSearchParams]" === o.call(e);
          },
          isStandardBrowserEnv: function () {
            return (
              ("undefined" == typeof navigator ||
                ("ReactNative" !== navigator.product &&
                  "NativeScript" !== navigator.product &&
                  "NS" !== navigator.product)) &&
              "undefined" != typeof window &&
              "undefined" != typeof document
            );
          },
          forEach: u,
          merge: function e() {
            var t = {};
            function n(n, r) {
              d(t[r]) && d(n)
                ? (t[r] = e(t[r], n))
                : d(n)
                ? (t[r] = e({}, n))
                : a(n)
                ? (t[r] = n.slice())
                : (t[r] = n);
            }
            for (var r = 0, o = arguments.length; r < o; r++)
              u(arguments[r], n);
            return t;
          },
          extend: function (e, t, n) {
            return (
              u(t, function (t, o) {
                e[o] = n && "function" == typeof t ? r(t, n) : t;
              }),
              e
            );
          },
          trim: function (e) {
            return e.trim ? e.trim() : e.replace(/^\s+|\s+$/g, "");
          },
          stripBOM: function (e) {
            return 65279 === e.charCodeAt(0) && (e = e.slice(1)), e;
          },
        };
      },
      4929: function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.default = [
            { name: "Afghanistan", code: "af", dial_code: "+93" },
            { name: "Albania", code: "al", dial_code: "+355" },
            { name: "Algeria", code: "dz", dial_code: "+213" },
            { name: "Andorra", code: "ad", dial_code: "+376" },
            { name: "Angola", code: "ao", dial_code: "+244" },
            { name: "Anguilla", code: "ai", dial_code: "+1264" },
            { name: "Antigua and Barbuda", code: "ag", dial_code: "+1268" },
            { name: "Argentina", code: "ar", dial_code: "+54" },
            { name: "Armenia", code: "am", dial_code: "+374" },
            { name: "Aruba", code: "aw", dial_code: "+297" },
            { name: "Australia", code: "au", dial_code: "+61" },
            { name: "Austria", code: "at", dial_code: "+43" },
            { name: "Azerbaijan", code: "az", dial_code: "+994" },
            { name: "Bahamas", code: "bs", dial_code: "+1242" },
            { name: "Bahrain", code: "bh", dial_code: "+973" },
            { name: "Bangladesh", code: "bd", dial_code: "+880" },
            { name: "Barbados", code: "bb", dial_code: "+1246" },
            { name: "Belarus", code: "by", dial_code: "+375" },
            { name: "Belgium", code: "be", dial_code: "+32" },
            { name: "Belize", code: "bz", dial_code: "+501" },
            { name: "Benin", code: "bj", dial_code: "+229" },
            { name: "Bermuda", code: "bm", dial_code: "+1441" },
            { name: "Bhutan", code: "bt", dial_code: "+975" },
            { name: "Bolivia", code: "bo", dial_code: "+591" },
            { name: "Bosnia and Herzegovina", code: "ba", dial_code: "+387" },
            { name: "Botswana", code: "bw", dial_code: "+267" },
            { name: "Brazil", code: "br", dial_code: "+55" },
            { name: "Brunei Darussalam", code: "bn", dial_code: "+673" },
            { name: "Bulgaria", code: "bg", dial_code: "+359" },
            { name: "Burkina Faso", code: "bf", dial_code: "+226" },
            { name: "Burundi", code: "bi", dial_code: "+257" },
            { name: "Cambodia", code: "kh", dial_code: "+855" },
            { name: "Cameroon", code: "cm", dial_code: "+237" },
            { name: "Canada", code: "ca", dial_code: "+1" },
            { name: "Cape Verde", code: "cv", dial_code: "+238" },
            { name: "Cayman Islands", code: "ky", dial_code: "+ 345" },
            { name: "Central African Republic", code: "cf", dial_code: "+236" },
            { name: "Chad", code: "td", dial_code: "+235" },
            { name: "Chile", code: "cl", dial_code: "+56" },
            { name: "China", code: "cn", dial_code: "+86" },
            { name: "Christmas Island", code: "cx", dial_code: "+61" },
            { name: "Cocos (Keeling) Islands", code: "cc", dial_code: "+61" },
            { name: "Colombia", code: "co", dial_code: "+57" },
            { name: "Comoros", code: "km", dial_code: "+269" },
            { name: "Congo", code: "cg", dial_code: "+242" },
            { name: "Cook Islands", code: "ck", dial_code: "+682" },
            { name: "Costa Rica", code: "cr", dial_code: "+506" },
            { name: "Cote D'Ivoire", code: "ci", dial_code: "+225" },
            { name: "Croatia", code: "hr", dial_code: "+385" },
            { name: "Cuba", code: "cu", dial_code: "+53" },
            { name: "Cyprus", code: "cy", dial_code: "+537" },
            { name: "Czech Republic", code: "cz", dial_code: "+420" },
            {
              name: "Democratic Republic of the Congo",
              code: "cd",
              dial_code: "+243",
            },
            { name: "Denmark", code: "dk", dial_code: "+45" },
            { name: "Djibouti", code: "dj", dial_code: "+253" },
            { name: "Dominica", code: "dm", dial_code: "+1767" },
            { name: "Dominican Republic", code: "do", dial_code: "+1849" },
            { name: "Ecuador", code: "ec", dial_code: "+593" },
            { name: "Egypt", code: "eg", dial_code: "+20" },
            { name: "El Salvador", code: "sv", dial_code: "+503" },
            { name: "Equatorial Guinea", code: "gq", dial_code: "+240" },
            { name: "Eritrea", code: "er", dial_code: "+291" },
            { name: "Estonia", code: "ee", dial_code: "+372" },
            { name: "Ethiopia", code: "et", dial_code: "+251" },
            { name: "Falkland Islands", code: "fk", dial_code: "+500" },
            { name: "Faroe Islands", code: "fo", dial_code: "+298" },
            {
              name: "Federated States of Micronesia",
              code: "fm",
              dial_code: "+691",
            },
            { name: "Fiji", code: "fj", dial_code: "+679" },
            { name: "Finland", code: "fi", dial_code: "+358" },
            { name: "France", code: "fr", dial_code: "+33" },
            { name: "French Guiana", code: "gf", dial_code: "+594" },
            { name: "French Polynesia", code: "pf", dial_code: "+689" },
            {
              name: "French Southern Territories",
              code: "tf",
              dial_code: "+262",
            },
            { name: "Gabon", code: "ga", dial_code: "+241" },
            { name: "Gambia", code: "gm", dial_code: "+220" },
            { name: "Georgia", code: "ge", dial_code: "+995" },
            { name: "Germany", code: "de", dial_code: "+49" },
            { name: "Ghana", code: "gh", dial_code: "+233" },
            { name: "Gibraltar", code: "gi", dial_code: "+350" },
            { name: "Great Britain (UK)", code: "gb", dial_code: "+44" },
            { name: "Greece", code: "gr", dial_code: "+30" },
            { name: "Greenland", code: "gl", dial_code: "+299" },
            { name: "Grenada", code: "gd", dial_code: "+1473" },
            { name: "Guadeloupe", code: "gp", dial_code: "+590" },
            { name: "Guatemala", code: "gt", dial_code: "+502" },
            { name: "Guinea", code: "gn", dial_code: "+224" },
            { name: "Guinea-Bissau", code: "gw", dial_code: "+245" },
            { name: "Guyana", code: "gy", dial_code: "+595" },
            { name: "Haiti", code: "ht", dial_code: "+509" },
            { name: "Honduras", code: "hn", dial_code: "+504" },
            { name: "Hong Kong", code: "hk", dial_code: "+852" },
            { name: "Hungary", code: "hu", dial_code: "+36" },
            { name: "Iceland", code: "is", dial_code: "+354" },
            { name: "India", code: "in", dial_code: "+91" },
            { name: "Indonesia", code: "id", dial_code: "+62" },
            { name: "Iran", code: "ir", dial_code: "+98" },
            { name: "Iraq", code: "iq", dial_code: "+964" },
            { name: "Ireland", code: "ie", dial_code: "+353" },
            { name: "Israel", code: "il", dial_code: "+972" },
            { name: "Italy", code: "it", dial_code: "+39" },
            { name: "Jamaica", code: "jm", dial_code: "+1876" },
            { name: "Japan", code: "jp", dial_code: "+81" },
            { name: "Jordan", code: "jo", dial_code: "+962" },
            { name: "Kazakhstan", code: "kz", dial_code: "+7 7" },
            { name: "Kenya", code: "ke", dial_code: "+254" },
            { name: "Kiribati", code: "ki", dial_code: "+686" },
            { name: "North Korea", code: "kp", dial_code: "+850" },
            { name: "South Korea", code: "kr", dial_code: "+82" },
            { name: "Kuwait", code: "kw", dial_code: "+965" },
            { name: "Kyrgyzstan", code: "kg", dial_code: "+996" },
            { name: "Laos", code: "la", dial_code: "+856" },
            { name: "Latvia", code: "lv", dial_code: "+371" },
            { name: "Lebanon", code: "lb", dial_code: "+961" },
            { name: "Lesotho", code: "ls", dial_code: "+266" },
            { name: "Liberia", code: "lr", dial_code: "+231" },
            { name: "Libya", code: "ly", dial_code: "+218" },
            { name: "Liechtenstein", code: "li", dial_code: "+423" },
            { name: "Lithuania", code: "lt", dial_code: "+370" },
            { name: "Luxembourg", code: "lu", dial_code: "+352" },
            { name: "Macao", code: "mo", dial_code: "+853" },
            { name: "Macedonia", code: "mk", dial_code: "+389" },
            { name: "Madagascar", code: "mg", dial_code: "+261" },
            { name: "Malawi", code: "mw", dial_code: "+265" },
            { name: "Malaysia", code: "my", dial_code: "+60" },
            { name: "Maldives", code: "mv", dial_code: "+960" },
            { name: "Mali", code: "ml", dial_code: "+223" },
            { name: "Malta", code: "mt", dial_code: "+356" },
            { name: "Marshall Islands", code: "mh", dial_code: "+692" },
            { name: "Martinique", code: "mq", dial_code: "+596" },
            { name: "Mauritania", code: "mr", dial_code: "+222" },
            { name: "Mauritius", code: "mu", dial_code: "+230" },
            { name: "Mayotte", code: "yt", dial_code: "+262" },
            { name: "Mexico", code: "mx", dial_code: "+52" },
            { name: "Moldova", code: "md", dial_code: "+373" },
            { name: "Monaco", code: "mc", dial_code: "+377" },
            { name: "Mongolia", code: "mn", dial_code: "+976" },
            { name: "Montserrat", code: "ms", dial_code: "+1664" },
            { name: "Morocco", code: "ma", dial_code: "+212" },
            { name: "Mozambique", code: "mz", dial_code: "+258" },
            { name: "Myanmar", code: "mm", dial_code: "+95" },
            { name: "Namibia", code: "na", dial_code: "+264" },
            { name: "Nauru", code: "nr", dial_code: "+674" },
            { name: "Nepal", code: "np", dial_code: "+977" },
            { name: "Netherlands", code: "nl", dial_code: "+31" },
            { name: "Netherlands Antilles", code: "an", dial_code: "+599" },
            { name: "New Caledonia", code: "nc", dial_code: "+687" },
            { name: "New Zealand", code: "nz", dial_code: "+64" },
            { name: "Nicaragua", code: "ni", dial_code: "+505" },
            { name: "Niger", code: "ne", dial_code: "+227" },
            { name: "Nigeria", code: "ng", dial_code: "+234" },
            { name: "Niue", code: "nu", dial_code: "+683" },
            { name: "Norfolk Island", code: "nf", dial_code: "+672" },
            {
              name: "Northern Mariana Islands",
              code: "mp",
              dial_code: "+1670",
            },
            { name: "Norway", code: "no", dial_code: "+47" },
            { name: "NULL", code: "gg", dial_code: "+44" },
            { name: "Oman", code: "om", dial_code: "+968" },
            { name: "Pakistan", code: "pk", dial_code: "+92" },
            { name: "Palau", code: "pw", dial_code: "+680" },
            { name: "Palestinian Territory", code: "ps", dial_code: "+970" },
            { name: "Panama", code: "pa", dial_code: "+507" },
            { name: "Papua New Guinea", code: "pg", dial_code: "+675" },
            { name: "Paraguay", code: "py", dial_code: "+595" },
            { name: "Peru", code: "pe", dial_code: "+51" },
            { name: "Philippines", code: "ph", dial_code: "+63" },
            { name: "Pitcairn", code: "pn", dial_code: "+872" },
            { name: "Poland", code: "pl", dial_code: "+48" },
            { name: "Portugal", code: "pt", dial_code: "+351" },
            { name: "Qatar", code: "qa", dial_code: "+974" },
            { name: "Reunion", code: "re", dial_code: "+262" },
            { name: "Romania", code: "ro", dial_code: "+40" },
            { name: "Russian Federation", code: "ru", dial_code: "+7" },
            { name: "Rwanda", code: "rw", dial_code: "+250" },
            {
              name: "S. Georgia and S. Sandwich Islands",
              code: "gs",
              dial_code: "+500",
            },
            { name: "Saint Helena", code: "sh", dial_code: "+290" },
            { name: "Saint Kitts and Nevis", code: "kn", dial_code: "+1869" },
            { name: "Saint Lucia", code: "lc", dial_code: "+1758" },
            {
              name: "Saint Pierre and Miquelon",
              code: "pm",
              dial_code: "+508",
            },
            {
              name: "Saint Vincent and the Grenadines",
              code: "vc",
              dial_code: "+1784",
            },
            { name: "Samoa", code: "ws", dial_code: "+685" },
            { name: "San Marino", code: "sm", dial_code: "+378" },
            { name: "Sao Tome and Principe", code: "st", dial_code: "+239" },
            { name: "Saudi Arabia", code: "sa", dial_code: "+966" },
            { name: "Senegal", code: "sn", dial_code: "+221" },
            { name: "Seychelles", code: "sc", dial_code: "+248" },
            { name: "Sierra Leone", code: "sl", dial_code: "+232" },
            { name: "Singapore", code: "sg", dial_code: "+65" },
            { name: "Slovakia", code: "sk", dial_code: "+421" },
            { name: "Slovenia", code: "si", dial_code: "+386" },
            { name: "Solomon Islands", code: "sb", dial_code: "+677" },
            { name: "Somalia", code: "so", dial_code: "+252" },
            { name: "South Africa", code: "za", dial_code: "+27" },
            { name: "Spain", code: "es", dial_code: "+34" },
            { name: "Sri Lanka", code: "lk", dial_code: "+94" },
            { name: "Sudan", code: "sd", dial_code: "+249" },
            { name: "Suriname", code: "sr", dial_code: "+597" },
            { name: "Svalbard and Jan Mayen", code: "sj", dial_code: "+47" },
            { name: "Swaziland", code: "sz", dial_code: "+268" },
            { name: "Sweden", code: "se", dial_code: "+46" },
            { name: "Switzerland", code: "ch", dial_code: "+41" },
            { name: "Syria", code: "sy", dial_code: "+963" },
            { name: "Taiwan", code: "tw", dial_code: "+886" },
            { name: "Tajikistan", code: "tj", dial_code: "+992" },
            { name: "Tanzania", code: "tz", dial_code: "+255" },
            { name: "Thailand", code: "th", dial_code: "+66" },
            { name: "Togo", code: "tg", dial_code: "+228" },
            { name: "Tokelau", code: "tk", dial_code: "+690" },
            { name: "Tonga", code: "to", dial_code: "+676" },
            { name: "Trinidad and Tobago", code: "tt", dial_code: "+1868" },
            { name: "Tunisia", code: "tn", dial_code: "+216" },
            { name: "Turkey", code: "tr", dial_code: "+90" },
            { name: "Turkmenistan", code: "tm", dial_code: "+993" },
            {
              name: "Turks and Caicos Islands",
              code: "tc",
              dial_code: "+1649",
            },
            { name: "Tuvalu", code: "tv", dial_code: "+688" },
            { name: "Uganda", code: "ug", dial_code: "+256" },
            { name: "Ukraine", code: "ua", dial_code: "+380" },
            { name: "United Arab Emirates", code: "ae", dial_code: "+971" },
            { name: "United States of America", code: "us", dial_code: "+1" },
            { name: "Uruguay", code: "uy", dial_code: "+598" },
            { name: "Uzbekistan", code: "uz", dial_code: "+998" },
            { name: "Vanuatu", code: "vu", dial_code: "+678" },
            { name: "Venezuela", code: "ve", dial_code: "+58" },
            { name: "Vietnam", code: "vn", dial_code: "+84" },
            {
              name: "Virgin Islands (British)",
              code: "vg",
              dial_code: "+1284",
            },
            { name: "Virgin Islands (U.S.)", code: "vi", dial_code: "+1340" },
            { name: "Wallis and Futuna", code: "wf", dial_code: "+681" },
            { name: "Western Sahara", code: "eh", dial_code: "+212" },
            { name: "Yemen", code: "ye", dial_code: "+967" },
            { name: "Zambia", code: "zm", dial_code: "+260" },
            { name: "Zimbabwe", code: "zw", dial_code: "+263" },
          ]);
      },
      1564: function (e, t) {
        "use strict";
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.default = {
            af: [
              "Badakhshan",
              "Badghis",
              "Balkh",
              "Daykundi Province",
              "Farah",
              "Faryab Province",
              "Helmand",
              "Herat",
              "Kandahar",
              "Kunduz",
              "Nangarhar",
              "Panjshir",
              "Parwan",
              "Samangan",
              "Sar-e Pul",
              "Uruzgan",
              "Velayat-e Khowst",
              "Velayat-e Nurestan",
              "Wardak",
              "Wilayat-e Baghlan",
              "Wilayat-e Bamyan",
              "Wilayat-e Ghazni",
              "Wilayat-e Ghor",
              "Wilayat-e Jowzjan",
              "Wilayat-e Kabul",
              "Wilayat-e Kapisa",
              "Wilayat-e Kunar",
              "Wilayat-e Laghman",
              "Wilayat-e Logar",
              "Wilayat-e Nimroz",
              "Wilayat-e Paktika",
              "Wilayat-e Paktiya",
              "Wilayat-e Takhar",
              "Wilayat-e Zabul",
            ],
            al: [
              "Qarku i Beratit",
              "Qarku i Dibres",
              "Qarku i Durresit",
              "Qarku i Elbasanit",
              "Qarku i Fierit",
              "Qarku i Gjirokastres",
              "Qarku i Korces",
              "Qarku i Kukesit",
              "Qarku i Lezhes",
              "Qarku i Shkodres",
              "Qarku i Tiranes",
              "Qarku i Vlores",
            ],
            dz: [
              "Adrar",
              "Annaba",
              "El Bayadh",
              "El Oued",
              "El Tarf",
              "Illizi",
              "Oran",
              "Oum el Bouaghi",
              "Wilaya d' Alger",
              "Wilaya de Ain Defla",
              "Wilaya de Ain Temouchent",
              "Wilaya de Batna",
              "Wilaya de Bechar",
              "Wilaya de Bejaia",
              "Wilaya de Biskra",
              "Wilaya de Blida",
              "Wilaya de Bordj Bou Arreridj",
              "Wilaya de Bouira",
              "Wilaya de Boumerdes",
              "Wilaya de Chlef",
              "Wilaya de Constantine",
              "Wilaya de Djelfa",
              "Wilaya de Ghardaia",
              "Wilaya de Guelma",
              "Wilaya de Jijel",
              "Wilaya de Khenchela",
              "Wilaya de Laghouat",
              "Wilaya de M'Sila",
              "Wilaya de Mascara",
              "Wilaya de Medea",
              "Wilaya de Mila",
              "Wilaya de Mostaganem",
              "Wilaya de Naama",
              "Wilaya de Ouargla",
              "Wilaya de Relizane",
              "Wilaya de Saida",
              "Wilaya de Setif",
              "Wilaya de Sidi Bel Abbes",
              "Wilaya de Skikda",
              "Wilaya de Souk Ahras",
              "Wilaya de Tamanrasset",
              "Wilaya de Tebessa",
              "Wilaya de Tiaret",
              "Wilaya de Tindouf",
              "Wilaya de Tipaza",
              "Wilaya de Tissemsilt",
              "Wilaya de Tizi Ouzo",
              "Wilaya de Tlemcen",
            ],
            ad: [
              "Andorra la Vella",
              "Canillo",
              "Encamp",
              "Escaldes-Engordany",
              "La Massana",
              "Ordino",
              "Sant Julia de Loria",
            ],
            ao: [
              "Bengo Province",
              "Benguela",
              "Cabinda",
              "Cuanza Norte Province",
              "Cunene Province",
              "Huambo",
              "Huila Province",
              "Kuando Kubango",
              "Kwanza Sul",
              "Luanda Province",
              "Lunda Norte Province",
              "Lunda Sul",
              "Malanje Province",
              "Moxico",
              "Namibe Province",
              "Provincia do Bie",
              "Provincia do Uige",
              "Zaire",
            ],
            ai: [
              "Blowing Point",
              "East End",
              "George Hill",
              "Island Harbour",
              "North Hill",
              "North Side",
              "Sandy Ground",
              "Sandy Hill",
              "South Hill",
              "Stoney Ground",
              "The Farrington",
              "The Quarter",
              "The Valley",
              "West End",
            ],
            ag: [
              "Barbuda",
              "Parish of Saint George",
              "Parish of Saint John",
              "Parish of Saint Mary",
              "Parish of Saint Paul",
              "Parish of Saint Peter",
              "Parish of Saint Philip",
              "Redonda",
            ],
            ar: [
              "Catamarca Province",
              "Chaco Province",
              "Chubut Province",
              "Ciudad Autonoma de Buenos Aires",
              "Cordoba Province",
              "Corrientes Province",
              "Entre Rios Province",
              "Formosa Province",
              "Jujuy Province",
              "La Pampa Province",
              "La Rioja Province",
              "Mendoza Province",
              "Misiones Province",
              "Neuquen Province",
              "Provincia de Buenos Aires",
              "Rio Negro Province",
              "Salta Province",
              "San Juan Province",
              "San Luis Province",
              "Santa Cruz Province",
              "Santa Fe Province",
              "Santiago del Estero Province",
              "Tierra del Fuego Province",
              "Tucuman Province",
            ],
            am: [
              "Aragatsotni Marz",
              "Ararati Marz",
              "Armaviri Marz",
              "Geghark'unik'i Marz",
              "Kotayk'i Marz",
              "Lorru Marz",
              "Shiraki Marz",
              "Syunik'i Marz",
              "Tavushi Marz",
              "Vayots' Dzor",
              "Yerevan",
            ],
            aw: [],
            au: [
              "Australian Capital Territory",
              "Northern Territory",
              "New South Wales",
              "Queensland",
              "South Australia",
              "Tasmania",
              "Victoria",
              "Western Australia",
            ],
            at: [
              "Burgenland",
              "Kaernten",
              "Niederoesterreich",
              "Oberoesterreich",
              "Salzburg",
              "Steiermark",
              "Tirol",
              "Vorarlberg",
              "Wien",
            ],
            az: [
              "Absheron Rayon",
              "Aghdam Rayon",
              "Aghdash Rayon",
              "Aghjabadi Rayon",
              "Aghstafa Rayon",
              "Aghsu Rayon",
              "Astara District",
              "Baku City",
              "Balakan Rayon",
              "Barda Rayon",
              "Beylagan Rayon",
              "Bilasuvar Rayon",
              "Dashkasan Rayon",
              "Fizuli Rayon",
              "Gadabay Rayon",
              "Ganja City",
              "Gobustan Rayon",
              "Goranboy Rayon",
              "Goychay Rayon",
              "Goygol Rayon",
              "Hajigabul Rayon",
              "Imishli Rayon",
              "Ismayilli Rayon",
              "Jabrayil District",
              "Jalilabad",
              "Kalbajar District",
              "Khachmaz Rayon",
              "Khizi Rayon",
              "Khojavend District",
              "Kurdamir Rayon",
              "Lacin Rayon",
              "Lankaran Rayon",
              "Lankaran Sahari",
              "Lerik Rayon",
              "Masally District",
              "Mingacevir City",
              "Naftalan City",
              "Nakhchivan",
              "Nakhchivan Autonomous Republic",
              "Neftchala Rayon",
              "Oghuz Rayon",
              "Qabala Rayon",
              "Qakh Rayon",
              "Qazakh Rayon",
              "Quba Rayon",
              "Qubadli Rayon",
              "Qusar Rayon",
              "Saatly Rayon",
              "Sabirabad Rayon",
              "Salyan Rayon",
              "Samukh Rayon",
              "Shabran Rayon",
              "Shaki city",
              "Shaki Rayon",
              "Shamakhi Rayon",
              "Shamkir Rayon",
              "Shirvan",
              "Shusha",
              "Siazan Rayon",
              "Sumqayit City",
              "Susa Rayon",
              "Tartar Rayon",
              "Tovuz Rayon",
              "Ujar Rayon",
              "Xankandi Sahari",
              "Xocali Rayon",
              "Yardymli Rayon",
              "Yevlakh City",
              "Yevlakh Rayon",
              "Zangilan Rayon",
              "Zaqatala Rayon",
              "Zardab Rayon",
            ],
            bs: [
              "Acklins Island District",
              "Berry Islands District",
              "Bimini District",
              "Black Point District",
              "Cat Island",
              "Central Abaco District",
              "Central Andros District",
              "Central Eleuthera District",
              "City of Freeport District",
              "Crooked Island and Long Cay District",
              "East Grand Bahama District",
              "Exuma District",
              "Grand Cay District",
              "Harbour Island District",
              "Hope Town District",
              "Inagua",
              "Long Island",
              "Mangrove Cay",
              "Mayaguana District",
              "Moore's Island District",
              "New Providence District",
              "North Abaco District",
              "North Andros District",
              "North Eleuthera District",
              "Ragged Island District",
              "Rum Cay",
              "San Salvador District",
              "South Abaco District",
              "South Andros",
              "South Eleuthera",
              "Spanish Wells District",
              "West Grand Bahama District",
            ],
            bh: [
              "Capital Governorate",
              "Muharraq Governorate",
              "Northern Governorate",
              "Southern Governorate",
            ],
            bd: [
              "Barisal Division",
              "Chittagong",
              "Dhaka Division",
              "Khulna Division",
              "Mymensingh Division",
              "Rajshahi Division",
              "Rangpur Division",
              "Sylhet Division",
            ],
            bb: [
              "Christ Church",
              "Saint Andrew",
              "Saint George",
              "Saint James",
              "Saint John",
              "Saint Joseph",
              "Saint Lucy",
              "Saint Michael",
              "Saint Peter",
              "Saint Philip",
              "Saint Thomas",
            ],
            by: [
              "Brest Oblast",
              "Gomel Oblast",
              "Grodno Oblast",
              "Horad Minsk",
              "Minsk Oblast",
              "Mogilyov Oblast",
              "Vitebsk Oblast",
            ],
            be: ["Bruxelles-Capitale", "Flanders", "Wallonia"],
            bz: [
              "Belize District",
              "Cayo District",
              "Corozal District",
              "Orange Walk District",
              "Stann Creek District",
              "Toledo District",
            ],
            bj: [
              "Alibori",
              "Atakora Department",
              "Atlantique Department",
              "Borgou Department",
              "Collines Department",
              "Departement de l'Oueme",
              "Donga",
              "Kouffo Department",
              "Littoral",
              "Mono",
              "Plateau Department",
              "Zou Department",
            ],
            bm: [
              "Devonshire Parish",
              "Hamilton",
              "Paget Parish",
              "Pembroke Parish",
              "Saint George",
              "Saint George's Parish",
              "Sandys Parish",
              "Smith's Parish",
              "Southampton Parish",
              "Warwick Parish",
            ],
            bt: [
              "Bumthang Dzongkhag",
              "Chhukha Dzongkhag",
              "Dagana Dzongkhag",
              "Gasa",
              "Haa Dzongkhag",
              "Lhuentse Dzongkhag",
              "Mongar Dzongkhag",
              "Paro Dzongkhag",
              "Pemagatshel Dzongkhag",
              "Punakha Dzongkhag",
              "Samdrup Jongkhar Dzongkhag",
              "Samtse Dzongkhag",
              "Sarpang Dzongkhag",
              "Thimphu Dzongkhag",
              "Trashi Yangste",
              "Trashigang Dzongkhag",
              "Trongsa Dzongkhag",
              "Tsirang Dzongkhag",
              "Wangdue Phodrang Dzongkhag",
              "Zhemgang Dzongkhag",
            ],
            bo: [
              "Departamento de Chuquisaca",
              "Departamento de Cochabamba",
              "Departamento de La Paz",
              "Departamento de Oruro",
              "Departamento de Pando",
              "Departamento de Potosi",
              "Departamento de Santa Cruz",
              "Departamento de Tarija",
              "El Beni",
            ],
            ba: [
              "Brcko",
              "Federation of Bosnia and Herzegovina",
              "Republika Srpska",
            ],
            bw: [
              "Central District",
              "Ghanzi District",
              "Kgalagadi District",
              "Kgatleng District",
              "Kweneng District",
              "North East District",
              "North West District",
              "South East District",
              "Southern District",
            ],
            br: [
              "Acre",
              "Alagoas",
              "Amapa",
              "Amazonas",
              "Bahia",
              "Ceara",
              "Espirito Santo",
              "Federal District",
              "Goias",
              "Maranhao",
              "Mato Grosso",
              "Mato Grosso do Sul",
              "Minas Gerais",
              "Para",
              "Paraiba",
              "Parana",
              "Pernambuco",
              "Piaui",
              "Rio de Janeiro",
              "Rio Grande do Norte",
              "Rio Grande do Sul",
              "Rondonia",
              "Roraima",
              "Santa Catarina",
              "Sao Paulo",
              "Sergipe",
              "Tocantins",
            ],
            bn: [
              "Belait District",
              "Brunei and Muara District",
              "Temburong District",
              "Tutong District",
            ],
            bg: [
              "Blagoevgrad",
              "Burgas",
              "Gabrovo",
              "Haskovo",
              "Lovech",
              "Oblast Dobrich",
              "Oblast Kardzhali",
              "Oblast Kyustendil",
              "Oblast Montana",
              "Oblast Pleven",
              "Oblast Razgrad",
              "Oblast Ruse",
              "Oblast Shumen",
              "Oblast Silistra",
              "Oblast Sliven",
              "Oblast Smolyan",
              "Oblast Stara Zagora",
              "Oblast Targovishte",
              "Oblast Veliko Tarnovo",
              "Oblast Vidin",
              "Oblast Vratsa",
              "Oblast Yambol",
              "Pazardzhik",
              "Pernik",
              "Plovdiv",
              "Sofia",
              "Sofia-Grad",
              "Varna",
            ],
            bf: [
              "Boucle du Mouhoun Region",
              "Cascades Region",
              "Centre",
              "Centre-Est",
              "Centre-Nord",
              "Centre-Ouest",
              "Centre-Sud",
              "Est",
              "High-Basins Region",
              "Nord",
              "Plateau-Central",
              "Sahel",
              "Southwest Region",
            ],
            bi: [
              "Bubanza Province",
              "Bujumbura Mairie Province",
              "Bujumbura Rural Province",
              "Bururi Province",
              "Cankuzo Province",
              "Cibitoke Province",
              "Gitega Province",
              "Karuzi Province",
              "Kayanza Province",
              "Kirundo Province",
              "Makamba Province",
              "Muramvya Province",
              "Muyinga Province",
              "Ngozi Province",
              "Province de Mwaro",
              "Rumonge Province",
              "Rutana Province",
              "Ruyigi Province",
            ],
            kh: [
              "Banteay Meanchey",
              "Battambang",
              "Kampong Cham",
              "Kampong Chhnang",
              "Kampong Spe",
              "Kampong Thom",
              "Kampot",
              "Kandal",
              "Kep",
              "Koh Kong",
              "Kratie",
              "Mondolkiri",
              "Otar Meanchey",
              "Pailin",
              "Phnom Penh",
              "Preah Vihear",
              "Prey Veng",
              "Pursat",
              "Ratanakiri",
              "Siem Reap",
              "Sihanoukville",
              "Stung Treng",
              "Svay Rieng",
              "Takeo",
              "Tboung Khmum",
            ],
            cm: [
              "Adamaoua Region",
              "Centre Region",
              "East Region",
              "Far North Region",
              "Littoral Region",
              "North Region",
              "North-West Region",
              "South Region",
              "South-West Region",
              "West Region",
            ],
            ca: [
              "Alberta",
              "British Columbia",
              "Manitoba",
              "New Brunswick/Nouveau-Brunswick",
              "Newfoundland and Labrador",
              "Northwest Territories",
              "Nova Scotia",
              "Nunavut",
              "Ontario",
              "Prince Edward Island",
              "Quebec",
              "Saskatchewan",
              "Yukon",
            ],
            cv: [
              "Concelho da Boa Vista",
              "Concelho da Brava",
              "Concelho da Praia",
              "Concelho da Ribeira Brava",
              "Concelho da Ribeira Grande",
              "Concelho de Ribeira Grande de Santiago",
              "Concelho de Santa Catarina",
              "Concelho de Santa Catarina do Fogo",
              "Concelho de Santa Cruz",
              "Concelho de Sao Domingos",
              "Concelho de Sao Miguel",
              "Concelho de Sao Salvador do Mundo",
              "Concelho de Sao Vicente",
              "Concelho do Maio",
              "Concelho do Paul",
              "Concelho do Porto Novo",
              "Concelho do Sao Filipe",
              "Concelho do Tarrafal",
              "Concelho do Tarrafal de Sao Nicola",
              "Concelho dos Mosteiros",
              "Sal Municipality",
              "Sao Lourenco dos Orgaos",
            ],
            ky: [
              "Bodden Town",
              "East End",
              "George Town",
              "North Side",
              "Sister Island",
              "West Bay",
            ],
            cf: [
              "Bamingui-Bangoran",
              "Basse-Kotto",
              "Commune de Bangui",
              "Haut-Mbomo",
              "Haute-Kotto",
              "Lobaye",
              "Mambere-Kadei",
              "Mbomo",
              "Ombella-Mpoko",
              "Ouaka",
              "Ouham",
              "Prefecture de l'Ouham-Pende",
              "Prefecture de la Kemo",
              "Prefecture de la Nana-Grebizi",
              "Prefecture de la Nana-Mambere",
              "Prefecture de la Sangha-Mbaere",
              "Vakaga",
            ],
            td: [
              "Barh el Gazel",
              "Batha Region",
              "Borkou Region",
              "Chari-Baguirmi Region",
              "Ennedi-Est",
              "Ennedi-Ouest",
              "Guera Region",
              "Hadjer-Lamis",
              "Kanem Region",
              "Lac Region",
              "Logone Occidental Region",
              "Logone Oriental Region",
              "Mandoul",
              "Mayo-Kebbi East Region",
              "Mayo-Kebbi West Region",
              "Moyen-Chari Region",
              "Ouaddai Region",
              "Region de la Ville de N'Djamena",
              "Salamat Region",
              "Sila",
              "Tandjile Region",
              "Tibesti Region",
              "Wadi Fira Region",
            ],
            cl: [
              "Antofagasta",
              "Atacama",
              "Aysen",
              "Coquimbo",
              "Los Lagos",
              "Maule",
              "Region de Arica y Parinacota",
              "Region de la Araucania",
              "Region de Los Rios",
              "Region de Magallanes y de la Antartica Chilena",
              "Region de Tarapaca",
              "Region de Valparaiso",
              "Region del Biobio",
              "Region del Libertador General Bernardo O'Higgins",
              "Region Metropolitana de Santiago",
            ],
            cn: [
              "Anhui Sheng",
              "Beijing Shi",
              "Chongqing Shi",
              "Fujian Sheng",
              "Gansu Sheng",
              "Guangdong Sheng",
              "Guangxi Zhuangzu Zizhiq",
              "Guizhou Sheng",
              "Hainan Sheng",
              "Hebei Sheng",
              "Heilongjiang Sheng",
              "Henan Sheng",
              "Hubei Sheng",
              "Hunan Sheng",
              "Inner Mongolia Autonomous Region",
              "Jiangsu Sheng",
              "Jiangxi Sheng",
              "Jilin Sheng",
              "Liaoning Sheng",
              "Ningxia Huizu Zizhiq",
              "Qinghai Sheng",
              "Shaanxi",
              "Shandong Sheng",
              "Shanghai Shi",
              "Shanxi Sheng",
              "Sichuan Sheng",
              "Tianjin Shi",
              "Tibet Autonomous Region",
              "Xinjiang Uygur Zizhiq",
              "Yunnan Sheng",
              "Zhejiang Sheng",
            ],
            cx: [],
            cc: [],
            co: [
              "Amazonas",
              "Departamento de Antioquia",
              "Departamento de Arauca",
              "Departamento de Bolivar",
              "Departamento de Boyaca",
              "Departamento de Caldas",
              "Departamento de Casanare",
              "Departamento de Cordoba",
              "Departamento de Cundinamarca",
              "Departamento de La Guajira",
              "Departamento de Narino",
              "Departamento de Norte de Santander",
              "Departamento de Risaralda",
              "Departamento de Santander",
              "Departamento de Sucre",
              "Departamento de Tolima",
              "Departamento del Atlantico",
              "Departamento del Caqueta",
              "Departamento del Cauca",
              "Departamento del Cesar",
              "Departamento del Choco",
              "Departamento del Guainia",
              "Departamento del Guaviare",
              "Departamento del Huila",
              "Departamento del Magdalena",
              "Departamento del Meta",
              "Departamento del Putumayo",
              "Departamento del Valle del Cauca",
              "Departamento del Vaupes",
              "Departamento del Vichada",
              "Distrito Capital de Bogota",
              "Providencia y Santa Catalina, Departamento de Archipielago de San Andres",
              "Quindio Department",
            ],
            km: ["Grande Comore", "Moheli", "Ndzuwani"],
            cg: [
              "Commune de Brazzaville",
              "Cuvette",
              "Cuvette-Ouest",
              "Lekoumo",
              "Likouala",
              "Plateaux",
              "Pointe-Noire",
              "Pool",
              "Region de la Bouenza",
              "Region du Kouilo",
              "Region du Niari",
              "Sangha",
            ],
            ck: [
              "Aitutaki",
              "Ati",
              "Ma'uke",
              "Mangaia",
              "Manihiki",
              "Mitiaro",
              "Palmerston",
              "Penrhyn",
              "Pukapuka",
              "Rakahanga",
              "Rarotonga",
            ],
            cr: [
              "Provincia de Alajuela",
              "Provincia de Cartago",
              "Provincia de Guanacaste",
              "Provincia de Heredia",
              "Provincia de Limon",
              "Provincia de Puntarenas",
              "Provincia de San Jose",
            ],
            ci: [
              "Abidjan",
              "Bas-Sassandra",
              "Comoe",
              "Denguele",
              "Goh-Djiboua",
              "Lacs",
              "Lagunes",
              "Montagnes",
              "Sassandra-Marahoue",
              "Savanes",
              "Vallee du Bandama",
              "Woroba",
              "Yamoussoukro Autonomous District",
              "Zanzan",
            ],
            hr: [
              "Bjelovarsko-Bilogorska Zupanija",
              "Brodsko-Posavska Zupanija",
              "Dubrovacko-Neretvanska Zupanija",
              "Grad Zagreb",
              "Istarska Zupanija",
              "Karlovacka Zupanija",
              "Koprivnicko-Krizevacka Zupanija",
              "Krapinsko-Zagorska Zupanija",
              "Licko-Senjska Zupanija",
              "Megimurska Zupanija",
              "Osjecko-Baranjska Zupanija",
              "Pozesko-Slavonska Zupanija",
              "Primorsko-Goranska Zupanija",
              "Sibensko-Kninska Zupanija",
              "Sisacko-Moslavacka Zupanija",
              "Splitsko-Dalmatinska Zupanija",
              "Varazdinska Zupanija",
              "Viroviticko-Podravska Zupanija",
              "Vukovarsko-Srijemska Zupanija",
              "Zadarska Zupanija",
              "Zagreb County",
            ],
            cu: [
              "Artemisa",
              "La Habana",
              "Las Tunas",
              "Municipio Especial Isla de la Juventud",
              "Provincia de Camagueey",
              "Provincia de Ciego de Avila",
              "Provincia de Cienfuegos",
              "Provincia de Guantanamo",
              "Provincia de Holguin",
              "Provincia de Matanzas",
              "Provincia de Pinar del Rio",
              "Provincia de Sancti Spiritus",
              "Provincia de Santiago de Cuba",
              "Provincia de Villa Clara",
              "Provincia Granma",
              "Provincia Mayabeque",
            ],
            cy: [
              "Eparchia Ammochosto",
              "Eparchia Keryneias",
              "Eparchia Larnakas",
              "Eparchia Lefkosias",
              "Eparchia Lemeso",
              "Eparchia Pafo",
            ],
            cz: [
              "Hlavni mesto Praha",
              "Jihocesky kraj",
              "Jihomoravsky kraj",
              "Karlovarsky kraj",
              "Kraj Vysocina",
              "Kralovehradecky kraj",
              "Liberecky kraj",
              "Moravskoslezsky kraj",
              "Olomoucky kraj",
              "Pardubicky kraj",
              "Plzensky kraj",
              "Stredocesky kraj",
              "Ustecky kraj",
              "Zlinsky kraj",
            ],
            cd: [
              "Bas Uele",
              "Haut Uele",
              "Haut-Lomani",
              "Ituri",
              "Kasai District",
              "Kasai-Central",
              "Kinshasa City",
              "Kwango",
              "Kwil",
              "Lomami",
              "Lualaba",
              "Mai Ndombe",
              "Mongala",
              "Province de l'Equateur",
              "Province du Haut-Katanga",
              "Province du Kasai Oriental",
              "Province du Kongo Central",
              "Province du Maniema",
              "Province du Nord-Kiv",
              "Province du Nord-Ubangi",
              "Province du Sud-Ubangi",
              "Sankur",
              "South Kivu Province",
              "Tanganika",
              "Tshopo",
              "Tshuapa",
            ],
            dk: [
              "North Denmark Region",
              "Region Hovedstaden",
              "Region Midtjylland",
              "Region Sjaelland",
              "Region Syddanmark",
            ],
            dj: [
              "Ali Sabieh Region",
              "Arta Region",
              "Dikhil",
              "Djibouti Region",
              "Obock",
              "Tadjourah",
            ],
            dm: [
              "Saint Andrew",
              "Saint David",
              "Saint George",
              "Saint John",
              "Saint Joseph",
              "Saint Luke",
              "Saint Mark",
              "Saint Patrick",
              "Saint Paul",
              "Saint Peter",
            ],
            do: [
              "Distrito Nacional",
              "Provincia de Azua",
              "Provincia de Baoruco",
              "Provincia de Barahona",
              "Provincia de Dajabon",
              "Provincia de El Seibo",
              "Provincia de Elias Pina",
              "Provincia de Hato Mayor",
              "Provincia de Hermanas Mirabal",
              "Provincia de Independencia",
              "Provincia de La Altagracia",
              "Provincia de La Romana",
              "Provincia de La Vega",
              "Provincia de Monsenor Nouel",
              "Provincia de Monte Cristi",
              "Provincia de Monte Plata",
              "Provincia de Pedernales",
              "Provincia de Peravia",
              "Provincia de Puerto Plata",
              "Provincia de San Cristobal",
              "Provincia de San Jose de Ocoa",
              "Provincia de San Juan",
              "Provincia de San Pedro de Macoris",
              "Provincia de Santiago",
              "Provincia de Santiago Rodriguez",
              "Provincia de Santo Domingo",
              "Provincia de Valverde",
              "Provincia Duarte",
              "Provincia Espaillat",
              "Provincia Maria Trinidad Sanchez",
              "Provincia Sanchez Ramirez",
              "Samana Province",
            ],
            ec: [
              "Provincia de Bolivar",
              "Provincia de Cotopaxi",
              "Provincia de El Oro",
              "Provincia de Esmeraldas",
              "Provincia de Francisco de Orellana",
              "Provincia de Galapagos",
              "Provincia de Imbabura",
              "Provincia de Loja",
              "Provincia de Los Rios",
              "Provincia de Manabi",
              "Provincia de Morona-Santiago",
              "Provincia de Napo",
              "Provincia de Pichincha",
              "Provincia de Santa Elena",
              "Provincia de Santo Domingo de los Tsachilas",
              "Provincia de Sucumbios",
              "Provincia de Zamora-Chinchipe",
              "Provincia del Azuay",
              "Provincia del Canar",
              "Provincia del Carchi",
              "Provincia del Chimborazo",
              "Provincia del Guayas",
              "Provincia del Pastaza",
              "Provincia del Tungurahua",
            ],
            eg: [
              "As Suways",
              "Beheira Governorate",
              "Cairo Governorate",
              "Damietta Governorate",
              "Ismailia Governorate",
              "Kafr ash Shaykh",
              "Muhafazat ad Daqahliyah",
              "Muhafazat al Fayyum",
              "Muhafazat al Gharbiyah",
              "Muhafazat al Iskandariyah",
              "Muhafazat al Jizah",
              "Muhafazat al Minufiyah",
              "Muhafazat al Minya",
              "Muhafazat al Qalyubiyah",
              "Muhafazat al Uqsur",
              "Muhafazat al Wadi al Jadid",
              "Muhafazat ash Sharqiyah",
              "Muhafazat Aswan",
              "Muhafazat Asyut",
              "Muhafazat Bani Suwayf",
              "Muhafazat Bur Sa'id",
              "Muhafazat Matruh",
              "Muhafazat Qina",
              "Muhafazat Shamal Sina'",
              "Muhafazat Suhaj",
              "Red Sea Governorate",
              "South Sinai Governorate",
            ],
            sv: [
              "Departamento de Ahuachapan",
              "Departamento de Cabanas",
              "Departamento de Chalatenango",
              "Departamento de Cuscatlan",
              "Departamento de La Libertad",
              "Departamento de La Paz",
              "Departamento de La Union",
              "Departamento de Morazan",
              "Departamento de San Miguel",
              "Departamento de San Salvador",
              "Departamento de San Vicente",
              "Departamento de Santa Ana",
              "Departamento de Sonsonate",
              "Departamento de Usulutan",
            ],
            gq: [
              "Provincia de Annobon",
              "Provincia de Bioko Norte",
              "Provincia de Bioko Sur",
              "Provincia de Centro Sur",
              "Provincia de Kie-Ntem",
              "Provincia de Litoral",
              "Provincia de Wele-Nzas",
            ],
            er: [
              "Anseba Region",
              "Debub Region",
              "Gash-Barka Region",
              "Maekel Region",
              "Northern Red Sea Region",
              "Southern Red Sea Region",
            ],
            ee: [
              "Harjumaa",
              "Hiiumaa",
              "Ida-Virumaa",
              "Jarvamaa",
              "Jogevamaa",
              "Laane-Virumaa",
              "Laeaenemaa",
              "Paernumaa",
              "Polvamaa",
              "Raplamaa",
              "Saaremaa",
              "Tartumaa",
              "Valgamaa",
              "Viljandimaa",
              "Vorumaa",
            ],
            et: [
              "Adis Abeba Astedader",
              "Afar Region",
              "Amhara Region",
              "Benishangul-Gumuz Region",
              "Dire Dawa Region",
              "Gambela Region",
              "Harari Region",
              "Oromiya Region",
              "Somali Region",
              "Southern Nations, Nationalities, and People's Region",
              "Tigray Region",
            ],
            fk: [],
            fo: [
              "Eysturoyar sysla",
              "Nordoyar sysla",
              "Sandoyar Sysla",
              "Streymoyar Sysla",
              "Suduroyar sysla",
              "Vaga Sysla",
            ],
            fm: ["Chuuk", "Kosrae", "Pohnpei", "Yap"],
            fj: [
              "Central Division",
              "Eastern Division",
              "Northern Division",
              "Rotuma",
              "Western Division",
            ],
            fi: [
              "Etela-Pohjanmaa",
              "Etelae-Karjala",
              "Kainu",
              "Kanta-Haeme",
              "Keski-Pohjanmaa",
              "Keski-Suomi",
              "Kymenlaakso",
              "Lapland",
              "Paijanne-Tavastland",
              "Pirkanmaa",
              "Pohjanmaa",
              "Pohjois-Karjala",
              "Pohjois-Pohjanmaa",
              "Pohjois-Savo",
              "Satakunta",
              "Southern Savonia",
              "Uusimaa",
              "Varsinais-Suomi",
            ],
            fr: [
              "Auvergne-Rhone-Alpes",
              "Bourgogne-Franche-Comte",
              "Bretagne",
              "Centre-Val de Loire",
              "Corse",
              "Grand-Est",
              "Hauts-de-France",
              "Ile-de-France",
              "Normandy",
              "Nouvelle-Aquitaine",
              "Occitanie",
              "Pays de la Loire",
              "Provence-Alpes-Cote d'Azur",
            ],
            gf: ["Guyane"],
            pf: [
              "Iles Australes",
              "Iles du Vent",
              "Iles Marquises",
              "Iles Sous-le-Vent",
              "Iles Tuamotu-Gambier",
            ],
            tf: [
              "Archipel des Crozet",
              "Archipel des Kerguelen",
              "Iles Eparses de l'ocean Indien",
              "Iles Saint-Paul et Nouvelle-Amsterdam",
              "La Terre-Adelie",
            ],
            ga: [
              "Estuaire",
              "Province de l'Ogooue-Ivindo",
              "Province de l'Ogooue-Lolo",
              "Province de l'Ogooue-Maritime",
              "Province de la Ngounie",
              "Province de la Nyanga",
              "Province du Haut-Ogooue",
              "Province du Moyen-Ogooue",
              "Province du Woleu-Ntem",
            ],
            gm: [
              "Banjul",
              "Central River",
              "Lower River Division",
              "North Bank",
              "Upper River",
              "West Coast",
            ],
            ge: [
              "Abkhazia",
              "Ajaria",
              "Guria",
              "Imereti",
              "K'alak'i T'bilisi",
              "Kakheti",
              "Kvemo Kartli",
              "Mtskheta-Mtianeti",
              "Racha-Lechkhumi and Kvemo Svaneti",
              "Samegrelo-Zemo Svanetis Mkhare",
              "Samtskhe-Javakheti",
              "Shida Kartli",
            ],
            de: [
              "Baden-Wuerttemberg Region",
              "Bavaria",
              "Brandenburg",
              "Bremen",
              "Free and Hanseatic City of Hamburg",
              "Hessen",
              "Land Berlin",
              "Lower Saxony",
              "Mecklenburg-Western Pomerania",
              "Nordrhein-Westfalen",
              "Rheinland-Pfalz",
              "Saarland",
              "Saxony",
              "Saxony-Anhalt",
              "Schleswig-Holstein",
              "Thuringia",
            ],
            gh: [
              "Ashanti Region",
              "Brong-Ahafo Region",
              "Central Region",
              "Eastern Region",
              "Greater Accra Region",
              "Northern Region",
              "Upper East Region",
              "Upper West Region",
              "Volta Region",
              "Western Region",
            ],
            gi: [],
            gb: ["England", "Northern Ireland", "Scotland", "Wales"],
            gr: [
              "Attica",
              "Central Greece",
              "Central Macedonia",
              "Crete",
              "Eastern Macedonia and Thrace",
              "Epirus",
              "Ionian Islands",
              "Mount Athos",
              "North Aegean",
              "Peloponnese",
              "South Aegean",
              "Thessaly",
              "Western Greece",
              "Western Macedonia",
            ],
            gl: ["Kujalleq", "Qaasuitsup", "Qeqqata", "Sermersooq"],
            gd: [
              "Carriacou and Petite Martinique",
              "Saint Andrew",
              "Saint David",
              "Saint George",
              "Saint John",
              "Saint Mark",
              "Saint Patrick",
            ],
            gp: ["Guadeloupe"],
            gt: [
              "Departamento de Alta Verapaz",
              "Departamento de Baja Verapaz",
              "Departamento de Chimaltenango",
              "Departamento de Chiquimula",
              "Departamento de El Progreso",
              "Departamento de Escuintla",
              "Departamento de Guatemala",
              "Departamento de Huehuetenango",
              "Departamento de Izabal",
              "Departamento de Jalapa",
              "Departamento de Jutiapa",
              "Departamento de Quetzaltenango",
              "Departamento de Retalhule",
              "Departamento de Sacatepequez",
              "Departamento de San Marcos",
              "Departamento de Santa Rosa",
              "Departamento de Solola",
              "Departamento de Suchitepequez",
              "Departamento de Totonicapan",
              "Departamento de Zacapa",
              "Departamento del Peten",
              "Departamento del Quiche",
            ],
            gn: [
              "Boke Region",
              "Conakry Region",
              "Faranah Region",
              "Kankan Region",
              "Kindia Region",
              "Labe Region",
              "Mamou Region",
              "Nzerekore Region",
            ],
            gw: [
              "Bafata",
              "Biombo",
              "Bissau Region",
              "Bolama",
              "Cacheu Region",
              "Gab",
              "Oio Region",
              "Quinara",
              "Tombali",
            ],
            gy: [
              "Barima-Waini Region",
              "Cuyuni-Mazaruni Region",
              "Demerara-Mahaica Region",
              "East Berbice-Corentyne Region",
              "Essequibo Islands-West Demerara Region",
              "Mahaica-Berbice Region",
              "Pomeroon-Supenaam Region",
              "Potaro-Siparuni Region",
              "Upper Demerara-Berbice Region",
              "Upper Takutu-Upper Essequibo Region",
            ],
            ht: [
              "Centre",
              "Departement de l'Artibonite",
              "Departement de l'Ouest",
              "Departement de Nippes",
              "Departement du Nord-Est",
              "Grandans",
              "Nord",
              "Nord-Ouest",
              "Sud",
              "Sud-Est",
            ],
            hn: [
              "Departamento de Atlantida",
              "Departamento de Choluteca",
              "Departamento de Colon",
              "Departamento de Comayagua",
              "Departamento de Copan",
              "Departamento de Cortes",
              "Departamento de El Paraiso",
              "Departamento de Francisco Morazan",
              "Departamento de Gracias a Dios",
              "Departamento de Intibuca",
              "Departamento de Islas de la Bahia",
              "Departamento de La Paz",
              "Departamento de Lempira",
              "Departamento de Ocotepeque",
              "Departamento de Olancho",
              "Departamento de Santa Barbara",
              "Departamento de Valle",
              "Departamento de Yoro",
            ],
            hk: [
              "Central and Western District",
              "Eastern",
              "Islands District",
              "Kowloon City",
              "Kwai Tsing",
              "Kwun Tong",
              "North",
              "Sai Kung District",
              "Sha Tin",
              "Sham Shui Po",
              "Southern",
              "Tai Po District",
              "Tsuen Wan District",
              "Tuen Mun",
              "Wan Chai",
              "Wong Tai Sin",
              "Yau Tsim Mong",
              "Yuen Long District",
            ],
            hu: [
              "Bacs-Kiskun county",
              "Baranya county",
              "Bekes County",
              "Borsod-Abauj Zemplen county",
              "Budapest",
              "Csongrad megye",
              "Fejer megye",
              "Gyor-Moson-Sopron megye",
              "Hajdu-Bihar",
              "Heves megye",
              "Jasz-Nagykun-Szolnok",
              "Komarom-Esztergom",
              "Nograd megye",
              "Pest megye",
              "Somogy megye",
              "Szabolcs-Szatmar-Bereg",
              "Tolna megye",
              "Vas megye",
              "Veszprem megye",
              "Zala megye",
            ],
            is: [
              "Austurland",
              "Hoefudborgarsvaedi",
              "Nordurland Eystra",
              "Nordurland Vestra",
              "Sudurland",
              "Sudurnes",
              "Vestfirdir",
              "Vesturland",
            ],
            in: [
              "Andaman and Nicobar Islands",
              "Andhra Pradesh",
              "Arunachal Pradesh",
              "Assam",
              "Bihar",
              "Chandigarh",
              "Chhattisgarh",
              "Dadra and Nagar Haveli and Daman and Diu",
              "Delhi",
              "Gujarat",
              "Goa",
              "Haryana",
              "Himachal Pradesh",
              "Jammu and Kashmir",
              "Jharkhand",
              "Karnataka",
              "Kerala",
              "Ladhak",
              "Lakshadweep",
              "Madhya Pradesh",
              "Maharashtra",
              "Manipur",
              "Meghalaya",
              "Mizoram",
              "Nagaland",
              "Odisha",
              "Puducherry",
              "Punjab",
              "Rajasthan",
              "Sikkim",
              "Tamil Nadu",
              "Telangana",
              "Tripura",
              "Uttarakhand",
              "Uttar Pradesh",
              "West Bengal",
            ],
            id: [
              "Banten",
              "Daerah Istimewa Yogyakarta",
              "Daerah Khusus Ibukota Jakarta",
              "Jawa Barat",
              "Jawa Timur",
              "Kepulauan Bangka Belitung",
              "Nanggroe Aceh Darussalam Province",
              "North Kalimantan",
              "Propinsi Bengkul",
              "Provinsi Bali",
              "Provinsi Gorontalo",
              "Provinsi Jambi",
              "Provinsi Jawa Tengah",
              "Provinsi Kalimantan Barat",
              "Provinsi Kalimantan Selatan",
              "Provinsi Kalimantan Tengah",
              "Provinsi Kalimantan Timur",
              "Provinsi Kepulauan Ria",
              "Provinsi Lampung",
              "Provinsi Maluk",
              "Provinsi Maluku Utara",
              "Provinsi Nusa Tenggara Timur",
              "Provinsi Papua",
              "Provinsi Papua Barat",
              "Provinsi Ria",
              "Provinsi Sulawesi Barat",
              "Provinsi Sulawesi Selatan",
              "Provinsi Sumatera Barat",
              "Sulawesi Tengah",
              "Sulawesi Tenggara",
              "Sulawesi Utara",
              "Sumatera Selatan",
              "Sumatera Utara",
              "West Nusa Tenggara",
            ],
            ir: [
              "Alborz",
              "Bushehr",
              "East Azerbaijan",
              "Fars",
              "Hormozgan",
              "Isfahan",
              "Kerman",
              "Khuzestan",
              "Ostan-e Ardabil",
              "Ostan-e Azarbayjan-e Gharbi",
              "Ostan-e Chahar Mahal va Bakhtiari",
              "Ostan-e Gilan",
              "Ostan-e Golestan",
              "Ostan-e Hamadan",
              "Ostan-e Ilam",
              "Ostan-e Kermanshah",
              "Ostan-e Khorasan-e Jonubi",
              "Ostan-e Khorasan-e Razavi",
              "Ostan-e Khorasan-e Shomali",
              "Ostan-e Kohgiluyeh va Bowyer Ahmad",
              "Ostan-e Kordestan",
              "Ostan-e Lorestan",
              "Ostan-e Markazi",
              "Ostan-e Mazandaran",
              "Ostan-e Qazvin",
              "Ostan-e Semnan",
              "Ostan-e Tehran",
              "Ostan-e Zanjan",
              "Qom",
              "Sistan and Baluchestan",
              "Yazd",
            ],
            iq: [
              "An Najaf",
              "Dihok",
              "Diyala",
              "Muhafazat al Anbar",
              "Muhafazat al Basrah",
              "Muhafazat al Muthanna",
              "Muhafazat al Qadisiyah",
              "Muhafazat Arbil",
              "Muhafazat as Sulaymaniyah",
              "Muhafazat Babil",
              "Muhafazat Baghdad",
              "Muhafazat Dhi Qar",
              "Muhafazat Karbala'",
              "Muhafazat Kirkuk",
              "Muhafazat Maysan",
              "Muhafazat Ninawa",
              "Muhafazat Salah ad Din",
              "Muhafazat Wasit",
            ],
            ie: ["Connaught", "Leinster", "Munster", "Ulster"],
            il: [
              "Central District",
              "Haifa",
              "Jerusalem",
              "Northern District",
              "Southern District",
              "Tel Aviv District",
            ],
            it: [
              "Abruzzo",
              "Basilicata",
              "Calabria",
              "Campania",
              "Emilia-Romagna",
              "Friuli Venezia Giulia",
              "Lazio",
              "Liguria",
              "Lombardia",
              "Marche",
              "Molise",
              "Piemonte",
              "Puglia",
              "Regione Autonoma Valle d'Aosta",
              "Sardegna",
              "Sicilia",
              "Toscana",
              "Trentino-Alto Adige",
              "Umbria",
              "Veneto",
            ],
            jm: [
              "Clarendon",
              "Kingston",
              "Manchester",
              "Parish of Hanover",
              "Parish of Saint Ann",
              "Portland",
              "Saint Andrew",
              "Saint Catherine",
              "Saint Elizabeth",
              "Saint James",
              "Saint Mary",
              "Saint Thomas",
              "Trelawny",
              "Westmoreland",
            ],
            jp: [
              "Aichi-ken",
              "Akita",
              "Aomori-ken",
              "Chiba-ken",
              "Ehime",
              "Fukui",
              "Fukuoka Prefecture",
              "Fukushima-ken",
              "Gif",
              "Gunma-ken",
              "Hiroshima-ken",
              "Hokkaido",
              "Hyogo",
              "Ibaraki",
              "Ishikawa-ken",
              "Iwate",
              "Kagawa-ken",
              "Kagoshima-ken",
              "Kanagawa",
              "Kochi Prefecture",
              "Kumamoto",
              "Kyoto Prefecture",
              "Mie-ken",
              "Miyagi-ken",
              "Miyazaki",
              "Nagano-ken",
              "Nagasaki Prefecture",
              "Nara-ken",
              "Niigata-ken",
              "Oita Prefecture",
              "Okayama-ken",
              "Okinawa",
              "Osaka-f",
              "Saga-ken",
              "Saitama-ken",
              "Shiga",
              "Shimane-ken",
              "Shizuoka",
              "Tochigi",
              "Tokushima-ken",
              "Tokyo Prefecture",
              "Tottori",
              "Toyama-ken",
              "Wakayama",
              "Yamagata-ken",
              "Yamaguchi",
              "Yamanashi",
            ],
            jo: [
              "Ajloun",
              "Al Karak",
              "Al Mafraq",
              "Amman Governorate",
              "Irbid",
              "Jerash",
              "Muhafazat al 'Aqabah",
              "Muhafazat al Balqa'",
              "Muhafazat at Tafilah",
              "Muhafazat az Zarqa'",
              "Muhafazat Ma'an",
              "Muhafazat Madaba",
            ],
            kz: [
              "Aktyubinskaya Oblast'",
              "Almaty Oblysy",
              "Almaty Qalasy",
              "Aqmola Oblysy",
              "Astana Qalasy",
              "Atyrau Oblysy",
              "Baikonur",
              "East Kazakhstan",
              "Mangistauskaya Oblast'",
              "North Kazakhstan",
              "Pavlodar Oblysy",
              "Qaraghandy Oblysy",
              "Qostanay Oblysy",
              "Qyzylorda Oblysy",
              "South Kazakhstan",
              "West Kazakhstan",
              "Zhambyl Oblysy",
            ],
            ke: [
              "Baringo District",
              "Bomet District",
              "Bungoma District",
              "Busia District",
              "Embu District",
              "Garissa District",
              "Homa Bay District",
              "Isiolo District",
              "Kajiado District",
              "Kakamega District",
              "Kericho District",
              "Kiambu District",
              "Kilifi District",
              "Kirinyaga District",
              "Kisii District",
              "Kisum",
              "Kitui District",
              "Kwale District",
              "Laikipia District",
              "Lam",
              "Machakos District",
              "Makueni District",
              "Mandera District",
              "Marakwet District",
              "Marsabit District",
              "Mer",
              "Migori District",
              "Mombasa District",
              "Murang'a District",
              "Nairobi Province",
              "Nakuru District",
              "Nandi South District",
              "Narok District",
              "Nyamira District",
              "Nyandarua District",
              "Nyeri District",
              "Samburu District",
              "Siaya District",
              "Taita Taveta District",
              "Tana River District",
              "Tharaka District",
              "Trans Nzoia District",
              "Turkana District",
              "Uasin Gish",
              "Vihiga District",
              "Wajir District",
              "West Pokot District",
            ],
            ki: ["Gilbert Islands", "Line Islands", "Phoenix Islands"],
            kp: [
              "Chagang-do",
              "Hambuk",
              "Hamnam",
              "Hwanghae-bukto",
              "Hwanghae-namdo",
              "Kangwon-do",
              "P'yongan-bukto",
              "P'yongan-namdo",
              "Pyongyang",
              "Rason",
              "Ryanggang",
            ],
            kr: [
              "Busan",
              "Chungcheongbuk-do",
              "Chungcheongnam-do",
              "Daeg",
              "Daejeon",
              "Gangwon-do",
              "Gwangj",
              "Gyeonggi-do",
              "Gyeongsangbuk-do",
              "Gyeongsangnam-do",
              "Incheon",
              "Jeju-do",
              "Jeollabuk-do",
              "Jeollanam-do",
              "Sejong-si",
              "Seoul",
              "Ulsan",
            ],
            kw: [
              "Al Asimah Governorate",
              "Muhafazat al Ahmadi",
              "Muhafazat al Farwaniyah",
              "Muhafazat al Jahra'",
              "Muhafazat Hawalli",
              "Muhafazat Mubarak al Kabir",
            ],
            kg: [
              "Batken",
              "Chuyskaya Oblast'",
              "Gorod Bishkek",
              "Issyk-Kul Region",
              "Jalal-Abad oblast",
              "Naryn oblast",
              "Osh City",
              "Osh Oblasty",
              "Talas",
            ],
            la: [
              "Attap",
              "Bolikhamxai",
              "Champasak",
              "Houaphan",
              "Khammouan",
              "Khoueng Bokeo",
              "Khoueng Oudomxai",
              "Khoueng Phongsali",
              "Khoueng Savannakhet",
              "Khoueng Xekong",
              "Louangnamtha",
              "Luang Prabang Province",
              "Salavan",
              "Vientiane Prefecture",
              "Vientiane Province",
              "Xaignabouli",
              "Xaisomboun Province",
              "Xiangkhouang",
            ],
            lv: [
              "Adazu Novads",
              "Aglonas Novads",
              "Aizkraukles Rajons",
              "Aizputes Novads",
              "Aknistes Novads",
              "Alojas Novads",
              "Alsungas Novads",
              "Aluksnes Novads",
              "Amatas Novads",
              "Apes Novads",
              "Auces Novads",
              "Babites Novads",
              "Baldones Novads",
              "Baltinavas Novads",
              "Balvu Novads",
              "Bauskas Novads",
              "Beverinas Novads",
              "Brocenu Novads",
              "Burtnieku Novads",
              "Carnikavas Novads",
              "Cesu Novads",
              "Cesvaines Novads",
              "Ciblas Novads",
              "Dagdas Novads",
              "Daugavpils",
              "Daugavpils municipality",
              "Dobeles Rajons",
              "Dundagas Novads",
              "Durbes Novads",
              "Engures Novads",
              "Erglu Novads",
              "Garkalne Municipality",
              "Grobinas Novads",
              "Gulbenes Rajons",
              "Iecavas Novads",
              "Ikskiles Novads",
              "Ilukstes Novads",
              "Incukalna Novads",
              "Jaunjelgavas Novads",
              "Jaunpiebalgas Novads",
              "Jaunpils Novads",
              "Jekabpils",
              "Jekabpils Municipality",
              "Jelgava",
              "Jelgavas Rajons",
              "Jurmala",
              "Kandavas Novads",
              "Karsavas Novads",
              "Keguma Novads",
              "Kekavas Novads",
              "Kocenu Novads",
              "Kokneses Novads",
              "Kraslavas Rajons",
              "Krimuldas Novads",
              "Krustpils Novads",
              "Kuldigas Rajons",
              "Lielvardes Novads",
              "Liepaja",
              "Ligatnes Novads",
              "Limbazu Rajons",
              "Livanu Novads",
              "Lubanas Novads",
              "Ludzas Rajons",
              "Madona Municipality",
              "Malpils Novads",
              "Marupes Novads",
              "Mazsalacas Novads",
              "Mersraga Novads",
              "Nauksenu Novads",
              "Neretas Novads",
              "Nicas Novads",
              "Ogres novads",
              "Olaines Novads",
              "Ozolnieku Novads",
              "Pargaujas Novads",
              "Pavilostas Novads",
              "Plavinu Novads",
              "Preili Municipality",
              "Priekules Novads",
              "Priekuli Municipality",
              "Raunas Novads",
              "Rezekne",
              "Rezeknes Novads",
              "Riebinu Novads",
              "Riga",
              "Rojas Novads",
              "Ropazu Novads",
              "Rucavas Novads",
              "Rugaju Novads",
              "Rujienas Novads",
              "Rundales Novads",
              "Salacgrivas Novads",
              "Salas Novads",
              "Salaspils Novads",
              "Saldus Municipality",
              "Saulkrastu Novads",
              "Sejas Novads",
              "Siguldas Novads",
              "Skriveru Novads",
              "Skrundas Novads",
              "Smiltenes Novads",
              "Stopinu Novads",
              "Strencu Novads",
              "Talsi Municipality",
              "Tervetes Novads",
              "Tukuma Rajons",
              "Vainodes Novads",
              "Valka Municipality",
              "Valmiera District",
              "Varaklanu Novads",
              "Varkavas Novads",
              "Vecpiebalgas Novads",
              "Vecumnieku Novads",
              "Ventspils",
              "Ventspils Municipality",
              "Viesites Novads",
              "Vilakas Novads",
              "Vilanu Novads",
              "Zilupes Novads",
            ],
            lb: [
              "Beyrouth",
              "Mohafazat Aakkar",
              "Mohafazat Baalbek-Hermel",
              "Mohafazat Beqaa",
              "Mohafazat Liban-Nord",
              "Mohafazat Liban-Sud",
              "Mohafazat Mont-Liban",
              "Mohafazat Nabatiye",
            ],
            ls: [
              "Berea",
              "Butha-Buthe",
              "Leribe District",
              "Mafeteng District",
              "Maser",
              "Mohale's Hoek District",
              "Mokhotlong",
              "Qacha's Nek",
              "Quthing",
              "Thaba-Tseka",
            ],
            lr: [
              "Bomi County",
              "Bong County",
              "Gbarpolu County",
              "Grand Bassa County",
              "Grand Cape Mount County",
              "Grand Gedeh County",
              "Grand Kru County",
              "Lofa County",
              "Margibi County",
              "Maryland County",
              "Montserrado County",
              "Nimba County",
              "River Cess County",
              "River Gee County",
              "Sinoe County",
            ],
            ly: [
              "Al Jufrah",
              "Al Kufrah",
              "Al Marj",
              "Al Marqab",
              "Darnah",
              "Jabal al Gharbi District",
              "Murzuq",
              "Sha`biyat Nalut",
              "Sha'biyat al Butnan",
              "Sha'biyat al Jabal al Akhdar",
              "Sha'biyat al Jafarah",
              "Sha'biyat al Wahat",
              "Sha'biyat an Nuqat al Khams",
              "Sha'biyat az Zawiyah",
              "Sha'biyat Banghazi",
              "Sha'biyat Ghat",
              "Sha'biyat Misratah",
              "Sha'biyat Sabha",
              "Sha'biyat Wadi al Hayat",
              "Sha'biyat Wadi ash Shati'",
              "Surt",
              "Tripoli",
            ],
            li: [
              "Balzers",
              "Eschen",
              "Gamprin",
              "Mauren",
              "Planken",
              "Ruggell",
              "Schaan",
              "Schellenberg",
              "Triesen",
              "Triesenberg",
              "Vaduz",
            ],
            lt: [
              "Alytus County",
              "Kaunas County",
              "Klaipeda County",
              "Marijampole County",
              "Panevezys",
              "Siauliai County",
              "Taurage County",
              "Telsiu apskritis",
              "Utena County",
              "Vilniaus apskritis",
            ],
            lu: [
              "Canton d'Echternach",
              "Canton d'Esch-sur-Alzette",
              "Capellen",
              "Clervaux",
              "Diekirch",
              "Grevenmacher",
              "Luxembourg",
              "Mersch",
              "Redange",
              "Remich",
              "Vianden",
              "Wiltz",
            ],
            mo: [],
            mk: [
              "Aerodrom",
              "Berovo",
              "Bitola",
              "Bogdanci",
              "Bogovinje",
              "Bosilovo",
              "Brvenica",
              "Butel",
              "Cair",
              "Cesinovo-Oblesevo",
              "Debar",
              "Debarca",
              "Demir Hisar",
              "Demir Kapija",
              "Dolneni",
              "Drugovo",
              "Gazi Baba",
              "Gevgelija",
              "Gostivar",
              "Grad Skopje",
              "Gradsko",
              "Ilinden",
              "Jegunovce",
              "Karbinci",
              "Kavadarci",
              "Kisela Voda",
              "Kratovo",
              "Kriva Palanka",
              "Kumanovo",
              "Lozovo",
              "Makedonska Kamenica",
              "Makedonski Brod",
              "Mogila",
              "Negotino",
              "Novaci",
              "Novo Selo",
              "Ohrid",
              "Opstina Aracinovo",
              "Opstina Caska",
              "Opstina Centar",
              "Opstina Centar Zupa",
              "Opstina Cucer-Sandevo",
              "Opstina Delcevo",
              "Opstina Dojran",
              "Opstina Gjorce Petrov",
              "Opstina Karpos",
              "Opstina Kicevo",
              "Opstina Kocani",
              "Opstina Konce",
              "Opstina Krivogastani",
              "Opstina Krusevo",
              "Opstina Lipkovo",
              "Opstina Mavrovo i Rostusa",
              "Opstina Pehcevo",
              "Opstina Probistip",
              "Opstina Radovis",
              "Opstina Rankovce",
              "Opstina Sopiste",
              "Opstina Staro Nagoricane",
              "Opstina Stip",
              "Opstina Studenicani",
              "Opstina Vevcani",
              "Opstina Vranestica",
              "Opstina Vrapciste",
              "Opstina Zelino",
              "Oslomej",
              "Petrovec",
              "Plasnica",
              "Prilep",
              "Resen",
              "Rosoman",
              "Saraj",
              "Struga",
              "Strumica",
              "Suto Orizari",
              "Sveti Nikole",
              "Tearce",
              "Tetovo",
              "Valandovo",
              "Vasilevo",
              "Veles",
              "Vinica",
              "Zajas",
              "Zelenikovo",
              "Zrnovci",
            ],
            mg: [
              "Alaotra Mangoro Region",
              "Amoron'i Mania Region",
              "Analamanga Region",
              "Analanjirofo Region",
              "Androy Region",
              "Anosy Region",
              "Atsimo-Andrefana Region",
              "Atsimo-Atsinanana Region",
              "Atsinanana Region",
              "Betsiboka Region",
              "Boeny Region",
              "Bongolava Region",
              "Diana Region",
              "Haute Matsiatra Region",
              "Ihorombe Region",
              "Itasy Region",
              "Melaky Region",
              "Menabe Region",
              "Sava Region",
              "Sofia Region",
              "Vakinankaratra Region",
              "Vatovavy Fitovinany Region",
            ],
            mw: ["Central Region", "Northern Region", "Southern Region"],
            my: [
              "Johor",
              "Kedah",
              "Kelantan",
              "Kuala Lumpur",
              "Labuan",
              "Melaka",
              "Negeri Sembilan",
              "Pahang",
              "Perak",
              "Perlis",
              "Pulau Pinang",
              "Putrajaya",
              "Sabah",
              "Sarawak",
              "Selangor",
              "Terenggan",
            ],
            mv: [
              "Alifu Atholh",
              "Baa Atholh",
              "Dhaalu Atholh",
              "Faafu Atholh",
              "Gaafu Alifu Atholh",
              "Gaafu Dhaalu Atholh",
              "Gnaviyani Atholh",
              "Haa Alifu Atholh",
              "Haa Dhaalu Atholh",
              "Kaafu Atoll",
              "Laamu Atholh",
              "Lhaviyani Atholh",
              "Meemu Atholh",
              "Noonu Atoll",
              "Raa Atholh",
              "Seenu Atholh",
              "Shaviyani Atholh",
              "Southern Ari Atoll",
              "Thaa Atholh",
              "Vaavu Atholh",
            ],
            ml: [
              "Bamako Region",
              "Gao Region",
              "Kayes Region",
              "Kidal Region",
              "Koulikoro Region",
              "Mopti Region",
              "Segou Region",
              "Sikasso Region",
              "Tombouctou Region",
            ],
            mt: [
              "Attard",
              "Balzan",
              "Birkirkara",
              "Birzebbuga",
              "Bormla",
              "Dingli",
              "Ghajnsielem",
              "Hal Gharghur",
              "Hal Ghaxaq",
              "Haz-Zabbar",
              "Haz-Zebbug",
              "Il-Belt Valletta",
              "Il-Birg",
              "Il-Fgura",
              "Il-Fontana",
              "Il-Furjana",
              "Il-Gudja",
              "Il-Gzira",
              "Il-Hamrun",
              "Il-Kalkara",
              "Il-Marsa",
              "Il-Mellieha",
              "Il-Mosta",
              "Il-Munxar",
              "Il-Qala",
              "Il-Qrendi",
              "In-Nadur",
              "In-Naxxar",
              "Ir-Rabat",
              "Is-Siggiewi",
              "Is-Swieqi",
              "Ix-Xaghra",
              "Ix-Xewkija",
              "Ix-Xghajra",
              "Iz-Zebbug",
              "Iz-Zejtun",
              "Iz-Zurrieq",
              "Kirkop",
              "L-Gharb",
              "L-Ghasri",
              "L-Iklin",
              "L-Imdina",
              "L-Imgarr",
              "L-Imqabba",
              "L-Imsida",
              "L-Imtarfa",
              "L-Isla",
              "Lija",
              "Luqa",
              "Marsaskala",
              "Marsaxlokk",
              "Paola",
              "Pembroke",
              "Qormi",
              "Safi",
              "Saint John",
              "Saint Julian's",
              "Saint Lawrence",
              "Saint Lucia",
              "Saint Paul's Bay",
              "Saint Venera",
              "Sannat",
              "Ta' Kercem",
              "Ta' Xbiex",
              "Tal-Pieta",
              "Tarxien",
              "Tas-Sliema",
              "Victoria",
            ],
            mh: [
              "Ailinginae Atoll",
              "Ailinglaplap Atoll",
              "Ailuk Atoll",
              "Arno Atoll",
              "Aur Atoll",
              "Bikar Atoll",
              "Bikini Atoll",
              "Bokak Atoll",
              "Ebon Atoll",
              "Enewetak Atoll",
              "Erikub Atoll",
              "Jabat Island",
              "Jaluit Atoll",
              "Jemo Island",
              "Kili Island",
              "Kwajalein Atoll",
              "Lae Atoll",
              "Lib Island",
              "Likiep Atoll",
              "Majuro Atoll",
              "Maloelap Atoll",
              "Mejit Island",
              "Mili Atoll",
              "Namdrik Atoll",
              "Namu Atoll",
              "Rongelap Atoll",
              "Rongrik Atoll",
              "Taka Atoll",
              "Ujae Atoll",
              "Ujelang Atoll",
              "Utrik Atoll",
              "Wotho Atoll",
              "Wotje Atoll",
            ],
            mq: ["Martinique"],
            mr: [
              "Adrar",
              "Assaba",
              "Brakna",
              "Dakhlet Nouadhibo",
              "Gorgol",
              "Guidimaka",
              "Hodh ech Chargui",
              "Hodh El Gharbi",
              "Inchiri",
              "Nouakchott Nord",
              "Nouakchott Ouest",
              "Nouakchott Sud",
              "Tagant",
              "Tiris Zemmour",
              "Wilaya du Trarza",
            ],
            mu: [
              "Agalega Islands",
              "Black River District",
              "Cargados Carajos",
              "Flacq District",
              "Grand Port District",
              "Moka District",
              "Pamplemousses District",
              "Plaines Wilhems District",
              "Port Louis District",
              "Riviere du Rempart District",
              "Rodrigues",
              "Savanne District",
            ],
            yt: [
              "Acoua",
              "Bandraboua",
              "Bandrele",
              "Boueni",
              "Chiconi",
              "Chirongui",
              "Dembeni",
              "Dzaoudzi",
              "Kani-Keli",
              "Koungo",
              "M'Tsangamouji",
              "Mamoudzo",
              "Mtsamboro",
              "Ouangani",
              "Pamandzi",
              "Sada",
              "Tsingoni",
            ],
            mx: [
              "Ciudad de Mexico",
              "Estado de Aguascalientes",
              "Estado de Baja California",
              "Estado de Baja California Sur",
              "Estado de Campeche",
              "Estado de Chiapas",
              "Estado de Chihuahua",
              "Estado de Coahuila de Zaragoza",
              "Estado de Colima",
              "Estado de Durango",
              "Estado de Guanajuato",
              "Estado de Guerrero",
              "Estado de Hidalgo",
              "Estado de Jalisco",
              "Estado de Mexico",
              "Estado de Michoacan de Ocampo",
              "Estado de Morelos",
              "Estado de Nayarit",
              "Estado de Nuevo Leon",
              "Estado de Oaxaca",
              "Estado de Puebla",
              "Estado de Queretaro",
              "Estado de Quintana Roo",
              "Estado de San Luis Potosi",
              "Estado de Sinaloa",
              "Estado de Sonora",
              "Estado de Tabasco",
              "Estado de Tamaulipas",
              "Estado de Tlaxcala",
              "Estado de Veracruz-Llave",
              "Estado de Yucatan",
              "Estado de Zacatecas",
            ],
            md: [
              "Anenii Noi",
              "Basarabeasca",
              "Briceni",
              "Cantemir",
              "Cimislia",
              "Criuleni",
              "Donduseni",
              "Falesti",
              "Floresti",
              "Gagauzia",
              "Glodeni",
              "Hincesti",
              "Ialoveni",
              "Leova",
              "Municipiul Balti",
              "Municipiul Bender",
              "Municipiul Chisina",
              "Nisporeni",
              "Orhei",
              "Raionul Cahul",
              "Raionul Calarasi",
              "Raionul Causeni",
              "Raionul Drochia",
              "Raionul Dubasari",
              "Raionul Edinet",
              "Raionul Ocnita",
              "Raionul Soroca",
              "Raionul Stefan Voda",
              "Raionul Straseni",
              "Raionul Ungheni",
              "Rezina",
              "Riscani",
              "Singerei",
              "Soldanesti",
              "Taraclia",
              "Telenesti",
              "Unitatea Teritoriala din Stinga Nistrului",
            ],
            mc: ["Commune de Monaco"],
            mn: [
              "Arhangay Aymag",
              "Bayan-OElgiy Aymag",
              "Bayanhongor Aymag",
              "Bulgan",
              "Darhan-Uul Aymag",
              "Dornod Aymag",
              "Dornogovi Aymag",
              "Dundgovi Aymag",
              "Dzavhan Aymag",
              "Govi-Altay Aymag",
              "Govi-Sumber",
              "Hentiy Aymag",
              "Hovd",
              "Hovsgol Aymag",
              "OEmnoegovi Province",
              "OEvoerhangay Aymag",
              "Orhon Aymag",
              "Selenge Aymag",
              "Suhbaatar Aymag",
              "Tov Aymag",
              "Ulaanbaatar Hot",
              "Uvs Aymag",
            ],
            ms: [
              "Parish of Saint Anthony",
              "Parish of Saint Georges",
              "Parish of Saint Peter",
            ],
            ma: [
              "Beni Mellal-Khenifra",
              "Casablanca-Settat",
              "Dakhla-Oued Ed-Dahab",
              "Draa-Tafilalet",
              "Fes-Meknes",
              "Guelmim-Oued Noun",
              "Laayoune-Sakia El Hamra",
              "Marrakesh-Safi",
              "Oriental",
              "Rabat-Sale-Kenitra",
              "Souss-Massa",
              "Tanger-Tetouan-Al Hoceima",
            ],
            mz: [
              "Cabo Delgado Province",
              "Cidade de Maputo",
              "Gaza Province",
              "Inhambane Province",
              "Manica Province",
              "Maputo Province",
              "Nampula",
              "Niassa Province",
              "Provincia de Zambezia",
              "Sofala Province",
              "Tete",
            ],
            mm: [
              "Ayeyawady Region",
              "Bago Region",
              "Chin State",
              "Kachin State",
              "Kayah State",
              "Kayin State",
              "Magway Region",
              "Mandalay Region",
              "Mon State",
              "Nay Pyi Taw",
              "Rakhine State",
              "Sagaing Region",
              "Shan State",
              "Taninthayi Region",
              "Yangon Region",
            ],
            na: [
              "Erongo",
              "Hardap",
              "Karas",
              "Kavango East Region",
              "Kavango West Region",
              "Khomas",
              "Kunene",
              "Ohangwena",
              "Omaheke",
              "Omusati",
              "Oshana",
              "Oshikoto",
              "Otjozondjupa",
              "Zambezi Region",
            ],
            nr: [
              "Aiwo District",
              "Anabar District",
              "Anetan District",
              "Anibare District",
              "Baiti District",
              "Boe District",
              "Buada District",
              "Denigomodu District",
              "Ewa District",
              "Ijuw District",
              "Meneng District",
              "Nibok District",
              "Uaboe District",
              "Yaren",
            ],
            np: [
              "Madhya Pashchimanchal",
              "Madhyamanchal",
              "Pashchimanchal",
              "Patheka",
              "Purwanchal",
              "Sudur Pashchimanchal",
            ],
            nl: [
              "Provincie Drenthe",
              "Provincie Flevoland",
              "Provincie Friesland",
              "Provincie Gelderland",
              "Provincie Groningen",
              "Provincie Limburg",
              "Provincie Noord-Brabant",
              "Provincie Noord-Holland",
              "Provincie Overijssel",
              "Provincie Utrecht",
              "Provincie Zeeland",
              "Provincie Zuid-Holland",
            ],
            an: [],
            nc: ["Province des iles Loyaute", "Province Nord", "Province Sud"],
            nz: [
              "Auckland",
              "Bay of Plenty",
              "Canterbury",
              "Chatham Islands",
              "Gisborne",
              "Hawke's Bay",
              "Manawatu-Wanganui",
              "Marlborough",
              "Nelson",
              "Northland",
              "Otago",
              "Southland",
              "Taranaki",
              "Tasman",
              "Waikato",
              "Wellington",
              "West Coast",
            ],
            ni: [
              "Costa Caribe Sur",
              "Departamento de Boaco",
              "Departamento de Carazo",
              "Departamento de Chinandega",
              "Departamento de Chontales",
              "Departamento de Esteli",
              "Departamento de Granada",
              "Departamento de Jinotega",
              "Departamento de Leon",
              "Departamento de Madriz",
              "Departamento de Managua",
              "Departamento de Masaya",
              "Departamento de Matagalpa",
              "Departamento de Nueva Segovia",
              "Departamento de Rio San Juan",
              "Departamento de Rivas",
              "North Atlantic Autonomous Region (RAAN)",
            ],
            ne: [
              "Agadez",
              "Diffa",
              "Dosso Region",
              "Maradi",
              "Niamey",
              "Tahoua",
              "Tillaberi Region",
              "Zinder",
            ],
            ng: [
              "Abia State",
              "Adamawa State",
              "Akwa Ibom State",
              "Anambra State",
              "Bauchi State",
              "Bayelsa State",
              "Benue State",
              "Borno State",
              "Cross River State",
              "Delta State",
              "Ebonyi State",
              "Edo",
              "Ekiti State",
              "Enugu State",
              "Federal Capital Territory",
              "Gombe State",
              "Imo State",
              "Jigawa State",
              "Kaduna State",
              "Kano State",
              "Katsina State",
              "Kebbi State",
              "Kogi State",
              "Kwara State",
              "Lagos State",
              "Nasarawa State",
              "Niger State",
              "Ogun State",
              "Ondo State",
              "Osun State",
              "Oyo State",
              "Plateau State",
              "Rivers State",
              "Sokoto State",
              "Taraba State",
              "Yobe State",
              "Zamfara State",
            ],
            nu: [],
            nf: [],
            mp: [
              "Northern Islands Municipality",
              "Rota Municipality",
              "Saipan Municipality",
              "Tinian Municipality",
            ],
            no: [
              "Akershus fylke",
              "Aust-Agder fylke",
              "Buskerud fylke",
              "Finnmark Fylke",
              "Hedmark fylke",
              "Hordaland Fylke",
              "More og Romsdal fylke",
              "Nord-Trondelag Fylke",
              "Nordland Fylke",
              "Oppland fylke",
              "Oslo County",
              "Ostfold fylke",
              "Rogaland Fylke",
              "Sogn og Fjordane Fylke",
              "Sor-Trondelag Fylke",
              "Telemark fylke",
              "Troms Fylke",
              "Vest-Agder Fylke",
              "Vestfold fylke",
            ],
            gg: [
              "Alderney",
              "Castel",
              "Forest",
              "Saint Andrew",
              "Saint Martin",
              "Saint Peter Port",
              "Saint Pierre du Bois",
              "Saint Sampson",
              "Saint Saviour",
              "Torteval",
              "Vale",
            ],
            om: [
              "Al Batinah North Governorate",
              "Al Batinah South Governorate",
              "Ash Sharqiyah South",
              "Az Zahirah",
              "Muhafazat ad Dakhiliyah",
              "Muhafazat al Buraymi",
              "Muhafazat al Wusta",
              "Muhafazat Masqat",
              "Muhafazat Shamal ash Sharqiyah",
              "Muhafazat Zufar",
              "Musandam",
            ],
            pk: [
              "Azad Kashmir",
              "Balochistan",
              "Federally Administered Tribal Areas",
              "Gilgit-Baltistan",
              "Islamabad",
              "Khyber Pakhtunkhwa Province",
              "Punjab Province",
              "Sindh",
            ],
            pw: [
              "Aimeliik",
              "Airai",
              "Angaur",
              "Hatohobei",
              "Kayangel",
              "Koror",
              "Melekeok",
              "Ngaraard",
              "Ngarchelong",
              "Ngardma",
              "Ngatpang",
              "Ngchesar",
              "Ngeremlengui",
              "Ngiwal",
              "Peleli",
              "Sonsorol",
            ],
            ps: ["Gaza Strip", "West Bank"],
            pa: [
              "Embera-Wounaan",
              "Guna Yala",
              "Ngoebe-Bugle",
              "Panama Oeste",
              "Provincia de Bocas del Toro",
              "Provincia de Chiriqui",
              "Provincia de Cocle",
              "Provincia de Colon",
              "Provincia de Herrera",
              "Provincia de Los Santos",
              "Provincia de Panama",
              "Provincia de Veraguas",
              "Provincia del Darien",
            ],
            pg: [
              "Bougainville",
              "Central Province",
              "Chimbu Province",
              "East New Britain Province",
              "East Sepik Province",
              "Eastern Highlands Province",
              "Enga Province",
              "Gulf Province",
              "Hela",
              "Jiwaka",
              "Madang Province",
              "Manus Province",
              "Milne Bay Province",
              "Morobe Province",
              "National Capital District",
              "New Ireland Province",
              "Northern Province",
              "Southern Highlands Province",
              "West New Britain Province",
              "West Sepik Province",
              "Western Highlands Province",
              "Western Province",
            ],
            py: [
              "Asuncion",
              "Departamento Central",
              "Departamento de Alto Paraguay",
              "Departamento de Boqueron",
              "Departamento de Caaguaz",
              "Departamento de Caazapa",
              "Departamento de Canindey",
              "Departamento de Concepcion",
              "Departamento de Itapua",
              "Departamento de la Cordillera",
              "Departamento de Misiones",
              "Departamento de Neembuc",
              "Departamento de Paraguari",
              "Departamento de Presidente Hayes",
              "Departamento de San Pedro",
              "Departamento del Alto Parana",
              "Departamento del Amambay",
              "Departamento del Guaira",
            ],
            pe: [
              "Amazonas",
              "Ancash",
              "Apurimac",
              "Arequipa",
              "Ayacucho",
              "Cajamarca",
              "Callao",
              "Cusco",
              "Departamento de Moquegua",
              "Huancavelica",
              "Ica",
              "Junin",
              "La Libertad",
              "Lambayeque",
              "Lima",
              "Loreto",
              "Madre de Dios",
              "Pasco",
              "Piura",
              "Provincia de Lima",
              "Puno",
              "Region de Huanuco",
              "Region de San Martin",
              "Tacna",
              "Tumbes",
              "Ucayali",
            ],
            ph: [
              "Autonomous Region in Muslim Mindanao",
              "Bicol",
              "Cagayan Valley",
              "Calabarzon",
              "Caraga",
              "Central Luzon",
              "Central Visayas",
              "Cordillera Administrative Region",
              "Davao",
              "Eastern Visayas",
              "Ilocos",
              "Mimaropa",
              "National Capital Region",
              "Negros Island Region",
              "Northern Mindanao",
              "Soccsksargen",
              "Western Visayas",
              "Zamboanga Peninsula",
            ],
            pn: [],
            pl: [
              "Wojewodztwo Dolnoslaskie",
              "Wojewodztwo Kujawsko-Pomorskie",
              "Wojewodztwo Lodzkie",
              "Wojewodztwo Lubelskie",
              "Wojewodztwo Lubuskie",
              "Wojewodztwo Malopolskie",
              "Wojewodztwo Mazowieckie",
              "Wojewodztwo Opolskie",
              "Wojewodztwo Podkarpackie",
              "Wojewodztwo Podlaskie",
              "Wojewodztwo Pomorskie",
              "Wojewodztwo Slaskie",
              "Wojewodztwo Swietokrzyskie",
              "Wojewodztwo Warminsko-Mazurskie",
              "Wojewodztwo Wielkopolskie",
              "Wojewodztwo Zachodniopomorskie",
            ],
            pt: [
              "Azores",
              "Distrito da Guarda",
              "Distrito de Aveiro",
              "Distrito de Beja",
              "Distrito de Braga",
              "Distrito de Braganca",
              "Distrito de Castelo Branco",
              "Distrito de Coimbra",
              "Distrito de Evora",
              "Distrito de Faro",
              "Distrito de Leiria",
              "Distrito de Lisboa",
              "Distrito de Portalegre",
              "Distrito de Santarem",
              "Distrito de Setubal",
              "Distrito de Viana do Castelo",
              "Distrito de Vila Real",
              "Distrito de Vise",
              "Distrito do Porto",
              "Madeira",
            ],
            qa: [
              "Al Wakrah",
              "Baladiyat ad Dawhah",
              "Baladiyat al Khawr wa adh Dhakhirah",
              "Baladiyat ar Rayyan",
              "Baladiyat ash Shamal",
              "Baladiyat az Za'ayin",
              "Baladiyat Umm Salal",
            ],
            re: ["Reunion"],
            ro: [
              "Arad",
              "Bihor",
              "Bucuresti",
              "Constanta",
              "Covasna",
              "Dolj",
              "Giurgi",
              "Gorj",
              "Harghita",
              "Hunedoara",
              "Ilfov",
              "Judetul Alba",
              "Judetul Arges",
              "Judetul Baca",
              "Judetul Bistrita-Nasaud",
              "Judetul Botosani",
              "Judetul Braila",
              "Judetul Brasov",
              "Judetul Buza",
              "Judetul Calarasi",
              "Judetul Caras-Severin",
              "Judetul Cluj",
              "Judetul Dambovita",
              "Judetul Galati",
              "Judetul Ialomita",
              "Judetul Iasi",
              "Judetul Maramures",
              "Judetul Mehedinti",
              "Judetul Mures",
              "Judetul Neamt",
              "Judetul Salaj",
              "Judetul Sibi",
              "Judetul Timis",
              "Judetul Valcea",
              "Olt",
              "Prahova",
              "Satu Mare",
              "Suceava",
              "Teleorman",
              "Tulcea",
              "Vaslui",
              "Vrancea",
            ],
            ru: [
              "Altayskiy Kray",
              "Amurskaya Oblast'",
              "Arkhangel'skaya Oblast'",
              "Astrakhanskaya Oblast'",
              "Bashkortostan",
              "Belgorodskaya Oblast'",
              "Bryanskaya Oblast'",
              "Chechenskaya Respublika",
              "Chelyabinskaya Oblast'",
              "Chukotskiy Avtonomnyy Okrug",
              "Chuvashskaya Respublika",
              "Dagestan",
              "Irkutskaya Oblast'",
              "Ivanovskaya Oblast'",
              "Kabardino-Balkarskaya Respublika",
              "Kaliningradskaya Oblast'",
              "Kalmykiya",
              "Kaluzhskaya Oblast'",
              "Kamtchatski Kray",
              "Karachayevo-Cherkesiya",
              "Kemerovskaya Oblast'",
              "Khabarovskiy Kray",
              "Khanty-Mansiyskiy Avtonomnyy Okrug-Yugra",
              "Kirovskaya Oblast'",
              "Komi",
              "Kostromskaya Oblast'",
              "Krasnodarskiy Kray",
              "Krasnoyarskiy Kray",
              "Kurganskaya Oblast'",
              "Kurskaya Oblast'",
              "Leningradskaya Oblast'",
              "Lipetskaya Oblast'",
              "Magadanskaya Oblast'",
              "Moscow Oblast",
              "Moskva",
              "Murmanskaya Oblast'",
              "Nenetskiy Avtonomnyy Okrug",
              "Nizhegorodskaya Oblast'",
              "North Ossetia",
              "Novgorodskaya Oblast'",
              "Novosibirskaya Oblast'",
              "Omskaya Oblast'",
              "Orenburgskaya Oblast'",
              "Orlovskaya Oblast'",
              "Penzenskaya Oblast'",
              "Perm Krai",
              "Primorskiy Kray",
              "Pskovskaya Oblast'",
              "Respublika Adygeya",
              "Respublika Altay",
              "Respublika Buryatiya",
              "Respublika Ingushetiya",
              "Respublika Kareliya",
              "Respublika Khakasiya",
              "Respublika Mariy-El",
              "Respublika Mordoviya",
              "Respublika Sakha (Yakutiya)",
              "Respublika Tyva",
              "Rostovskaya Oblast'",
              "Ryazanskaya Oblast'",
              "Sakhalinskaya Oblast'",
              "Samarskaya Oblast'",
              "Sankt-Peterburg",
              "Saratovskaya Oblast'",
              "Smolenskaya Oblast'",
              "Stavropol'skiy Kray",
              "Sverdlovskaya Oblast'",
              "Tambovskaya Oblast'",
              "Tatarstan",
              "Tomskaya Oblast'",
              "Tul'skaya Oblast'",
              "Tverskaya Oblast'",
              "Tyumenskaya Oblast'",
              "Udmurtskaya Respublika",
              "Ulyanovsk Oblast",
              "Vladimirskaya Oblast'",
              "Volgogradskaya Oblast'",
              "Vologodskaya Oblast'",
              "Voronezhskaya Oblast'",
              "Yamalo-Nenetskiy Avtonomnyy Okrug",
              "Yaroslavskaya Oblast'",
              "Yevreyskaya Avtonomnaya Oblast'",
              "Zabaykal'skiy Kray",
            ],
            rw: [
              "Eastern Province",
              "Kigali Province",
              "Northern Province",
              "Southern Province",
              "Western Province",
            ],
            gs: [],
            sh: ["Ascension", "Saint Helena", "Tristan da Cunha"],
            kn: [
              "Christ Church Nichola Town",
              "Saint Anne Sandy Point",
              "Saint George Basseterre",
              "Saint George Gingerland",
              "Saint James Windward",
              "Saint John Capesterre",
              "Saint John Figtree",
              "Saint Mary Cayon",
              "Saint Paul Capesterre",
              "Saint Paul Charlestown",
              "Saint Peter Basseterre",
              "Saint Thomas Lowland",
              "Saint Thomas Middle Island",
              "Trinity Palmetto Point",
            ],
            lc: [
              "Anse-la-Raye",
              "Canaries",
              "Castries",
              "Choiseul",
              "Dennery",
              "Gros-Islet",
              "Laborie",
              "Micoud",
              "Soufriere",
              "Vieux-Fort",
            ],
            pm: ["Commune de Saint-Pierre", "Miquelon-Langlade"],
            vc: [
              "Grenadines",
              "Parish of Charlotte",
              "Parish of Saint Andrew",
              "Parish of Saint David",
              "Parish of Saint George",
              "Parish of Saint Patrick",
            ],
            ws: [
              "A'ana",
              "Aiga-i-le-Tai",
              "Atua",
              "Fa'asaleleaga",
              "Gaga'emauga",
              "Gagaifomauga",
              "Palauli",
              "Satupa'itea",
              "Tuamasaga",
              "Va'a-o-Fonoti",
              "Vaisigano",
            ],
            sm: [
              "Castello di Acquaviva",
              "Castello di Borgo Maggiore",
              "Castello di Domagnano",
              "Castello di Faetano",
              "Castello di Fiorentino",
              "Castello di Montegiardino",
              "Castello di San Marino Citta",
              "Chiesanuova",
              "Serravalle",
            ],
            st: ["Principe", "Sao Tome"],
            sa: [
              "Al Jawf",
              "Al Madinah al Munawwarah",
              "Al Mintaqah ash Sharqiyah",
              "Al-Qassim Province",
              "Hai'l Region",
              "Jizan Region",
              "Makkah Province",
              "Mintaqat 'Asir",
              "Mintaqat al Bahah",
              "Mintaqat al Hudud ash Shamaliyah",
              "Mintaqat ar Riyad",
              "Mintaqat Najran",
              "Mintaqat Tabuk",
            ],
            sn: [
              "Dakar",
              "Diourbel",
              "Fatick",
              "Kaolack",
              "Kolda",
              "Louga",
              "Matam",
              "Region de Kaffrine",
              "Region de Kedougo",
              "Region de Sedhio",
              "Region de Thies",
              "Saint-Louis",
              "Tambacounda",
              "Ziguinchor",
            ],
            sc: [
              "Anse aux Pins",
              "Anse Boilea",
              "Anse Etoile",
              "Anse Royale",
              "Au Cap",
              "Baie Lazare",
              "Baie Sainte Anne",
              "Beau Vallon",
              "Bel Air",
              "Bel Ombre",
              "Cascade",
              "English River",
              "Glacis",
              "Grand Anse Mahe",
              "Grand Anse Praslin",
              "Inner Islands",
              "Les Mamelles",
              "Mont Buxton",
              "Mont Fleuri",
              "Plaisance",
              "Pointe Larue",
              "Port Glaud",
              "Roche Caiman",
              "Saint Louis",
              "Takamaka",
            ],
            sl: [
              "Eastern Province",
              "Northern Province",
              "Southern Province",
              "Western Area",
            ],
            sg: [
              "Central Singapore Community Development Council",
              "North East Community Development Region",
              "North West Community Development Council",
              "South East Community Development Council",
              "South West Community Development Council",
            ],
            sk: [
              "Banska Bystrica",
              "Bratislava",
              "Kosice",
              "Nitra",
              "Presov",
              "Trencin",
              "Trnava",
              "Zilina",
            ],
            si: [
              "Ankaran",
              "Beltinci",
              "Benedikt",
              "Bistrica ob Sotli",
              "Bloke",
              "Bohinj",
              "Borovnica",
              "Brda",
              "Brezovica",
              "Cankova",
              "Celje",
              "Cerklje na Gorenjskem",
              "Cerknica",
              "Cerkno",
              "Cerkvenjak",
              "Cirkulane",
              "Destrnik",
              "Dobje",
              "Dobrepolje",
              "Dobrna",
              "Dobrova-Polhov Gradec",
              "Dobrovnik",
              "Dol pri Ljubljani",
              "Dolenjske Toplice",
              "Dornava",
              "Dravograd",
              "Duplek",
              "Gorenja Vas-Poljane",
              "Gorje",
              "Gornja Radgona",
              "Gornji Grad",
              "Gornji Petrovci",
              "Grad",
              "Grosuplje",
              "Hajdina",
              "Hodos",
              "Horjul",
              "Hrastnik",
              "Hrpelje-Kozina",
              "Idrija",
              "Ig",
              "Ilirska Bistrica",
              "Izola",
              "Jesenice",
              "Jezersko",
              "Kamnik",
              "Kanal",
              "Kobilje",
              "Komen",
              "Komenda",
              "Koper",
              "Kostanjevica na Krki",
              "Kostel",
              "Kozje",
              "Kranj",
              "Kranjska Gora",
              "Kungota",
              "Kuzma",
              "Lenart",
              "Lendava",
              "Litija",
              "Ljubno",
              "Ljutomer",
              "Log-Dragomer",
              "Logatec",
              "Lovrenc na Pohorj",
              "Lukovica",
              "Makole",
              "Maribor",
              "Markovci",
              "Medvode",
              "Mestna Obcina Ljubljana",
              "Mestna Obcina Novo mesto",
              "Metlika",
              "Miren-Kostanjevica",
              "Mirna",
              "Mislinja",
              "Mokronog-Trebelno",
              "Moravske Toplice",
              "Mozirje",
              "Murska Sobota",
              "Muta",
              "Naklo",
              "Nazarje",
              "Nova Gorica",
              "Obcina Ajdovscina",
              "Obcina Apace",
              "Obcina Bled",
              "Obcina Bovec",
              "Obcina Braslovce",
              "Obcina Brezice",
              "Obcina Crensovci",
              "Obcina Crna na Koroskem",
              "Obcina Crnomelj",
              "Obcina Divaca",
              "Obcina Domzale",
              "Obcina Gorisnica",
              "Obcina Hoce-Slivnica",
              "Obcina Ivancna Gorica",
              "Obcina Jursinci",
              "Obcina Kidricevo",
              "Obcina Kobarid",
              "Obcina Kocevje",
              "Obcina Krizevci",
              "Obcina Krsko",
              "Obcina Lasko",
              "Obcina Loska Dolina",
              "Obcina Loski Potok",
              "Obcina Luce",
              "Obcina Majsperk",
              "Obcina Menges",
              "Obcina Mezica",
              "Obcina Miklavz na Dravskem Polj",
              "Obcina Mirna Pec",
              "Obcina Moravce",
              "Obcina Ormoz",
              "Obcina Podcetrtek",
              "Obcina Poljcane",
              "Obcina Race-Fram",
              "Obcina Radece",
              "Obcina Ravne na Koroskem",
              "Obcina Razkrizje",
              "Obcina Recica ob Savinji",
              "Obcina Rence-Vogrsko",
              "Obcina Rogaska Slatina",
              "Obcina Rogasovci",
              "Obcina Ruse",
              "Obcina Salovci",
              "Obcina Semic",
              "Obcina Sempeter-Vrtojba",
              "Obcina Sencur",
              "Obcina Sentilj",
              "Obcina Sentjernej",
              "Obcina Sentjur",
              "Obcina Sentrupert",
              "Obcina Sezana",
              "Obcina Skocjan",
              "Obcina Skofja Loka",
              "Obcina Skofljica",
              "Obcina Smarje pri Jelsah",
              "Obcina Smarjeske Toplice",
              "Obcina Smartno ob Paki",
              "Obcina Smartno pri Litiji",
              "Obcina Sodrazica",
              "Obcina Solcava",
              "Obcina Sostanj",
              "Obcina Sredisce ob Dravi",
              "Obcina Starse",
              "Obcina Store",
              "Obcina Straza",
              "Obcina Sveti Andraz v Slovenskih Goricah",
              "Obcina Sveti Jurij ob Scavnici",
              "Obcina Sveti Tomaz",
              "Obcina Tisina",
              "Obcina Tolmin",
              "Obcina Trnovska vas",
              "Obcina Trzic",
              "Obcina Turnisce",
              "Obcina Velike Lasce",
              "Obcina Verzej",
              "Obcina Zalec",
              "Obcina Zavrc",
              "Obcina Zelezniki",
              "Obcina Zetale",
              "Obcina Ziri",
              "Obcina Zirovnica",
              "Obcina Zrece",
              "Obcina Zuzemberk",
              "Odranci",
              "Oplotnica",
              "Osilnica",
              "Pesnica",
              "Piran",
              "Pivka",
              "Podlehnik",
              "Podvelka",
              "Polzela",
              "Postojna",
              "Prebold",
              "Preddvor",
              "Prevalje",
              "Ptuj",
              "Puconci",
              "Radenci",
              "Radlje ob Dravi",
              "Radovljica",
              "Ribnica",
              "Ribnica na Pohorj",
              "Rogatec",
              "Selnica ob Dravi",
              "Sevnica",
              "Slovenj Gradec",
              "Slovenska Bistrica",
              "Slovenske Konjice",
              "Sveta Ana",
              "Sveta Trojica v Slovenskih Goricah",
              "Sveti Jurij v Slovenskih Goricah",
              "Tabor",
              "Trbovlje",
              "Trebnje",
              "Trzin",
              "Velenje",
              "Velika Polana",
              "Videm",
              "Vipava",
              "Vitanje",
              "Vodice",
              "Vojnik",
              "Vransko",
              "Vrhnika",
              "Vuzenica",
              "Zagorje ob Savi",
            ],
            sb: [
              "Central Province",
              "Choiseul",
              "Guadalcanal Province",
              "Honiara",
              "Isabel Province",
              "Makira-Ulawa Province",
              "Malaita Province",
              "Rennell and Bellona",
              "Temotu Province",
              "Western Province",
            ],
            so: [
              "Gobolka Awdal",
              "Gobolka Bakool",
              "Gobolka Banaadir",
              "Gobolka Bari",
              "Gobolka Bay",
              "Gobolka Galguduud",
              "Gobolka Gedo",
              "Gobolka Hiiraan",
              "Gobolka Jubbada Dhexe",
              "Gobolka Jubbada Hoose",
              "Gobolka Mudug",
              "Gobolka Nugaal",
              "Gobolka Sanaag",
              "Gobolka Shabeellaha Dhexe",
              "Gobolka Shabeellaha Hoose",
              "Gobolka Sool",
              "Gobolka Togdheer",
              "Gobolka Woqooyi Galbeed",
            ],
            za: [
              "Eastern Cape",
              "Free State",
              "Gauteng",
              "Limpopo",
              "Mpumalanga",
              "Province of KwaZulu-Natal",
              "Province of North West",
              "Province of Northern Cape",
              "Western Cape",
            ],
            es: [
              "Andalucia",
              "Aragon",
              "Canary Islands",
              "Cantabria",
              "Castilla y Leon",
              "Castilla-La Mancha",
              "Catalunya",
              "Ceuta",
              "Comunidad de Madrid",
              "Comunitat Autonoma de les Illes Balears",
              "Comunitat Valenciana",
              "Euskal Autonomia Erkidegoa",
              "Extremadura",
              "Galicia",
              "La Rioja",
              "Melilla",
              "Navarra",
              "Principality of Asturias",
              "Region de Murcia",
            ],
            lk: [
              "Central Province",
              "Eastern Province",
              "North Central Province",
              "North Western Province",
              "Northern Province",
              "Province of Sabaragamuwa",
              "Province of Uva",
              "Southern Province",
              "Western Province",
            ],
            sd: [
              "Al Jazirah State",
              "Al Qadarif State",
              "Blue Nile",
              "Central Darfur State",
              "East Darfur",
              "Kassala State",
              "Khartoum",
              "North Darfur",
              "North Kordofan",
              "Northern",
              "Red Sea",
              "River Nile",
              "Sennar",
              "South Darfur",
              "South Kordofan",
              "West Darfur",
              "West Kordofan State",
              "White Nile",
            ],
            sr: [
              "Distrikt Brokopondo",
              "Distrikt Commewijne",
              "Distrikt Coronie",
              "Distrikt Marowijne",
              "Distrikt Nickerie",
              "Distrikt Para",
              "Distrikt Paramaribo",
              "Distrikt Saramacca",
              "Distrikt Sipaliwini",
              "Distrikt Wanica",
            ],
            sj: ["Jan Mayen", "Svalbard"],
            sz: [
              "Hhohho District",
              "Lubombo District",
              "Manzini District",
              "Shiselweni District",
            ],
            se: [
              "Blekinge",
              "Dalarna",
              "Gaevleborgs laen",
              "Gotland",
              "Halland",
              "Jaemtlands laen",
              "Joenkoepings laen",
              "Kalmar",
              "Kronoberg",
              "Norrbotten",
              "OErebro laen",
              "OEstergoetlands laen",
              "Skane laen",
              "Soedermanlands laen",
              "Stockholm",
              "Uppsala",
              "Vaermlands laen",
              "Vaesterbottens laen",
              "Vaesternorrlands laen",
              "Vaestmanlands laen",
              "Vaestra Goetalands laen",
            ],
            ch: [
              "Canton de Berne",
              "Canton de Fribourg",
              "Canton de Vaud",
              "Canton du Valais",
              "Geneve",
              "Jura",
              "Kanton Aarga",
              "Kanton Appenzell Ausserrhoden",
              "Kanton Appenzell Innerrhoden",
              "Kanton Basel-Landschaft",
              "Kanton Basel-Stadt",
              "Kanton Glarus",
              "Kanton Graubunden",
              "Kanton Luzern",
              "Kanton Nidwalden",
              "Kanton Obwalden",
              "Kanton Schaffhausen",
              "Kanton Schwyz",
              "Kanton Solothurn",
              "Kanton St. Gallen",
              "Kanton Thurga",
              "Kanton Uri",
              "Kanton Zug",
              "Kanton Zurich",
              "Neuchatel",
              "Ticino",
            ],
            sy: [
              "Al-Hasakah Governorate",
              "Aleppo Governorate",
              "Ar-Raqqah Governorate",
              "As-Suwayda Governorate",
              "Damascus Governorate",
              "Daraa Governorate",
              "Deir ez-Zor Governorate",
              "Hama Governorate",
              "Homs Governorate",
              "Idlib Governorate",
              "Latakia Governorate",
              "Muhafazat Rif Dimashq",
              "Quneitra Governorate",
              "Tartus Governorate",
            ],
            tw: ["Fukien", "Kaohsiung", "Taipei", "Taiwan"],
            tj: [
              "Districts of Republican Subordination",
              "Dushanbe",
              "Viloyati Khatlon",
              "Viloyati Mukhtori Kuhistoni Badakhshon",
              "Viloyati Sughd",
            ],
            tz: [
              "Arusha Region",
              "Coast Region",
              "Dar es Salaam Region",
              "Dodoma Region",
              "Geita Region",
              "Iringa Region",
              "Kagera Region",
              "Katavi Region",
              "Kigoma Region",
              "Kilimanjaro Region",
              "Lindi Region",
              "Manyara Region",
              "Mara Region",
              "Mbeya Region",
              "Morogoro Region",
              "Mtwara Region",
              "Mwanza Region",
              "Njombe Region",
              "Pemba North Region",
              "Pemba South Region",
              "Rukwa Region",
              "Ruvuma Region",
              "Shinyanga Region",
              "Simiyu Region",
              "Singida Region",
              "Tabora Region",
              "Tanga Region",
              "Zanzibar Central/South Region",
              "Zanzibar North Region",
              "Zanzibar Urban/West Region",
            ],
            th: [
              "Bangkok",
              "Changwat Amnat Charoen",
              "Changwat Ang Thong",
              "Changwat Bueng Kan",
              "Changwat Buri Ram",
              "Changwat Chachoengsao",
              "Changwat Chai Nat",
              "Changwat Chaiyaphum",
              "Changwat Chanthaburi",
              "Changwat Chiang Rai",
              "Changwat Chon Buri",
              "Changwat Chumphon",
              "Changwat Kalasin",
              "Changwat Kamphaeng Phet",
              "Changwat Kanchanaburi",
              "Changwat Khon Kaen",
              "Changwat Krabi",
              "Changwat Lampang",
              "Changwat Lamphun",
              "Changwat Loei",
              "Changwat Lop Buri",
              "Changwat Mae Hong Son",
              "Changwat Maha Sarakham",
              "Changwat Mukdahan",
              "Changwat Nakhon Nayok",
              "Changwat Nakhon Pathom",
              "Changwat Nakhon Phanom",
              "Changwat Nakhon Ratchasima",
              "Changwat Nakhon Sawan",
              "Changwat Nakhon Si Thammarat",
              "Changwat Nan",
              "Changwat Narathiwat",
              "Changwat Nong Bua Lamph",
              "Changwat Nong Khai",
              "Changwat Nonthaburi",
              "Changwat Pathum Thani",
              "Changwat Pattani",
              "Changwat Phangnga",
              "Changwat Phatthalung",
              "Changwat Phayao",
              "Changwat Phetchabun",
              "Changwat Phetchaburi",
              "Changwat Phichit",
              "Changwat Phitsanulok",
              "Changwat Phra Nakhon Si Ayutthaya",
              "Changwat Phrae",
              "Changwat Prachin Buri",
              "Changwat Prachuap Khiri Khan",
              "Changwat Ranong",
              "Changwat Ratchaburi",
              "Changwat Rayong",
              "Changwat Roi Et",
              "Changwat Sa Kaeo",
              "Changwat Sakon Nakhon",
              "Changwat Samut Prakan",
              "Changwat Samut Sakhon",
              "Changwat Samut Songkhram",
              "Changwat Saraburi",
              "Changwat Satun",
              "Changwat Si Sa Ket",
              "Changwat Sing Buri",
              "Changwat Songkhla",
              "Changwat Sukhothai",
              "Changwat Suphan Buri",
              "Changwat Surat Thani",
              "Changwat Surin",
              "Changwat Tak",
              "Changwat Trang",
              "Changwat Trat",
              "Changwat Ubon Ratchathani",
              "Changwat Udon Thani",
              "Changwat Uthai Thani",
              "Changwat Uttaradit",
              "Changwat Yala",
              "Changwat Yasothon",
              "Chiang Mai Province",
              "Phuket Province",
            ],
            tg: ["Centrale", "Kara", "Maritime", "Plateaux", "Savanes"],
            tk: ["Ataf", "Fakaofo", "Nukunon"],
            to: ["Eua", "Ha`apai", "Niuas", "Tongatap", "Vava'"],
            tt: [
              "Arima",
              "Chaguanas",
              "City of Port of Spain",
              "Couva-Tabaquite-Talparo",
              "Diego Martin",
              "Mayaro",
              "Penal/Debe",
              "Point Fortin",
              "Princes Town",
              "San Fernando",
              "San Juan/Laventille",
              "Sangre Grande",
              "Siparia",
              "Tobago",
              "Tunapuna/Piarco",
            ],
            tn: [
              "Gafsa Governorate",
              "Gouvernorat de Beja",
              "Gouvernorat de Ben Arous",
              "Gouvernorat de Bizerte",
              "Gouvernorat de Gabes",
              "Gouvernorat de Jendouba",
              "Gouvernorat de Kairouan",
              "Gouvernorat de Kasserine",
              "Gouvernorat de Kebili",
              "Gouvernorat de Kef",
              "Gouvernorat de l'Ariana",
              "Gouvernorat de Mahdia",
              "Gouvernorat de Medenine",
              "Gouvernorat de Monastir",
              "Gouvernorat de Nabeul",
              "Gouvernorat de Sfax",
              "Gouvernorat de Sidi Bouzid",
              "Gouvernorat de Siliana",
              "Gouvernorat de Sousse",
              "Gouvernorat de Tozeur",
              "Gouvernorat de Tunis",
              "Gouvernorat de Zaghouan",
              "Manouba",
              "Tataouine",
            ],
            tr: [
              "Adana",
              "Adiyaman",
              "Afyonkarahisar",
              "Agri",
              "Aksaray",
              "Amasya",
              "Ankara",
              "Antalya",
              "Ardahan",
              "Artvin",
              "Aydin",
              "Balikesir",
              "Bartin",
              "Batman",
              "Bayburt",
              "Bilecik",
              "Bingoel",
              "Bitlis",
              "Bol",
              "Burdur",
              "Bursa",
              "Canakkale",
              "Cankiri",
              "Corum",
              "Denizli",
              "Diyarbakir",
              "Duezce",
              "Edirne",
              "Elazig",
              "Erzincan",
              "Erzurum",
              "Eskisehir",
              "Gaziantep",
              "Giresun",
              "Guemueshane",
              "Hakkari",
              "Hatay",
              "Igdir",
              "Isparta",
              "Istanbul",
              "Izmir",
              "Kahramanmaras",
              "Karabuek",
              "Karaman",
              "Kars",
              "Kastamon",
              "Kayseri",
              "Kilis",
              "Kirikkale",
              "Kirklareli",
              "Kirsehir",
              "Kocaeli",
              "Konya",
              "Kuetahya",
              "Malatya",
              "Manisa",
              "Mardin",
              "Mersin",
              "Mugla",
              "Mus",
              "Nevsehir",
              "Nigde",
              "Ord",
              "Osmaniye",
              "Rize",
              "Sakarya",
              "Samsun",
              "Sanliurfa",
              "Siirt",
              "Sinop",
              "Sirnak",
              "Sivas",
              "Tekirdag",
              "Tokat",
              "Trabzon",
              "Tunceli",
              "Usak",
              "Van",
              "Yalova",
              "Yozgat",
              "Zonguldak",
            ],
            tm: [
              "Ahal",
              "Ashgabat",
              "Balkan",
              "Dasoguz Welayaty",
              "Lebap",
              "Mary",
            ],
            tc: [],
            tv: [
              "Funafuti",
              "Nanumanga",
              "Nanumea",
              "Niutao",
              "Nui",
              "Nukufeta",
              "Nukulaelae",
              "Vaitup",
            ],
            ug: [
              "Central Region",
              "Eastern Region",
              "Northern Region",
              "Western Region",
            ],
            ua: [
              "Cherkas'ka Oblast'",
              "Chernihivs'ka Oblast'",
              "Chernivets'ka Oblast'",
              "Dnipropetrovska Oblast'",
              "Donets'ka Oblast'",
              "Gorod Sevastopol",
              "Ivano-Frankivs'ka Oblast'",
              "Kharkivs'ka Oblast'",
              "Khersons'ka Oblast'",
              "Khmel'nyts'ka Oblast'",
              "Kirovohrads'ka Oblast'",
              "Kyiv Oblast",
              "L'vivs'ka Oblast'",
              "Luhans'ka Oblast'",
              "Misto Kyyiv",
              "Mykolayivs'ka Oblast'",
              "Odes'ka Oblast'",
              "Poltavs'ka Oblast'",
              "Republic of Crimea",
              "Rivnens'ka Oblast'",
              "Sums'ka Oblast'",
              "Ternopil's'ka Oblast'",
              "Vinnyts'ka Oblast'",
              "Volyns'ka Oblast'",
              "Zakarpattia Oblast",
              "Zaporiz'ka Oblast'",
              "Zhytomyrs'ka Oblast'",
            ],
            ae: [
              "`Ajman",
              "Abu Zaby",
              "Al Fujayrah",
              "Ash Shariqah",
              "Dubai",
              "Ra's al Khaymah",
              "Umm al Qaywayn",
            ],
            us: [
              "Alabama",
              "Alaska",
              "Arizona",
              "Arkansas",
              "California",
              "Colorado",
              "Connecticut",
              "Delaware",
              "District of Columbia",
              "Florida",
              "Georgia",
              "Hawaii",
              "Idaho",
              "Illinois",
              "Indiana",
              "Iowa",
              "Kansas",
              "Kentucky",
              "Louisiana",
              "Maine",
              "Maryland",
              "Massachusetts",
              "Michigan",
              "Minnesota",
              "Mississippi",
              "Missouri",
              "Montana",
              "Nebraska",
              "Nevada",
              "New Hampshire",
              "New Jersey",
              "New Mexico",
              "New York",
              "North Carolina",
              "North Dakota",
              "Ohio",
              "Oklahoma",
              "Oregon",
              "Pennsylvania",
              "Rhode Island",
              "South Carolina",
              "South Dakota",
              "Tennessee",
              "Texas",
              "Utah",
              "Vermont",
              "Virginia",
              "Washington",
              "West Virginia",
              "Wisconsin",
              "Wyoming",
            ],
            uy: [
              "Departamento de Artigas",
              "Departamento de Canelones",
              "Departamento de Cerro Largo",
              "Departamento de Colonia",
              "Departamento de Durazno",
              "Departamento de Flores",
              "Departamento de Florida",
              "Departamento de Lavalleja",
              "Departamento de Maldonado",
              "Departamento de Montevideo",
              "Departamento de Paysand",
              "Departamento de Rio Negro",
              "Departamento de Rivera",
              "Departamento de Rocha",
              "Departamento de Salto",
              "Departamento de San Jose",
              "Departamento de Soriano",
              "Departamento de Tacuarembo",
              "Departamento de Treinta y Tres",
            ],
            uz: [
              "Andijan",
              "Bukhara Province",
              "Fergana",
              "Jizzakh Province",
              "Karakalpakstan",
              "Namangan Province",
              "Navoiy Province",
              "Qashqadaryo Province",
              "Samarqand Viloyati",
              "Sirdaryo",
              "Surxondaryo Viloyati",
              "Toshkent Shahri",
              "Toshkent Viloyati",
              "Xorazm Viloyati",
            ],
            vu: [
              "Malampa Province",
              "Penama Province",
              "Sanma Province",
              "Shefa Province",
              "Tafea Province",
              "Torba Province",
            ],
            ve: [
              "Delta Amacuro",
              "Dependencias Federales",
              "Distrito Capital",
              "Estado Amazonas",
              "Estado Anzoategui",
              "Estado Apure",
              "Estado Aragua",
              "Estado Barinas",
              "Estado Bolivar",
              "Estado Carabobo",
              "Estado Cojedes",
              "Estado Falcon",
              "Estado Guarico",
              "Estado Lara",
              "Estado Merida",
              "Estado Monagas",
              "Estado Nueva Esparta",
              "Estado Portuguesa",
              "Estado Sucre",
              "Estado Tachira",
              "Estado Trujillo",
              "Estado Vargas",
              "Estado Yaracuy",
              "Estado Zulia",
              "Miranda",
            ],
            vn: [
              "An Giang",
              "Bà Rịa-Vũng Tàu",
              "Bình Dương",
              "Bình Phước",
              "Bình Thuận",
              "Bình Định",
              "Bạc Liêu",
              "Bắc Giang",
              "Bắc Kạn",
              "Bắc Ninh",
              "Bến Tre",
              "Cao Bằng",
              "Cà Mau",
              "Da Nang",
              "Gia Lai",
              "Haiphong",
              "Hanoi",
              "Ho Chi Minh City",
              "Hà Giang",
              "Hà Nam",
              "Hà Tây",
              "Hà Tĩnh",
              "Hòa Bình",
              "Hưng Yên",
              "Hải Dương",
              "Hậu Giang",
              "Khánh Hòa",
              "Kiên Giang",
              "Kon Tum",
              "Lai Châu",
              "Long An",
              "Lào Cai",
              "Lâm Đồng",
              "Lạng Sơn",
              "Nam Định",
              "Nghệ An",
              "Ninh Bình",
              "Ninh Thuận",
              "Phú Thọ",
              "Phú Yên",
              "Quảng Bình",
              "Quảng Nam",
              "Quảng Ngãi",
              "Quảng Ninh",
              "Quảng Trị",
              "Sóc Trăng",
              "Sơn La",
              "Thanh Hóa",
              "Thái Bình",
              "Thái Nguyên",
              "Thừa Thiên-Huế",
              "Tiền Giang",
              "Trà Vinh",
              "Tuyên Quang",
              "Tây Ninh",
              "Vĩnh Long",
              "Vĩnh Phúc",
              "Yên Bái",
              "Điện Biên",
              "Đắk Lắk",
              "Đắk Nông",
              "Đồng Nai",
              "Đồng Tháp",
            ],
            vg: [],
            vi: [
              "Saint Croix Island",
              "Saint John Island",
              "Saint Thomas Island",
            ],
            wf: ["Alo", "Sigave", "Uvea"],
            eh: [],
            ye: [
              "Al Bayda Governorate",
              "Al Mahrah",
              "Al Mahwit",
              "Amanat Al Asimah",
              "Ibb",
              "Muhafazat `Amran",
              "Muhafazat 'Adan",
              "Muhafazat Abyan",
              "Muhafazat ad Dali'",
              "Muhafazat al Hudaydah",
              "Muhafazat al Jawf",
              "Muhafazat Dhamar",
              "Muhafazat Hadramawt",
              "Muhafazat Hajjah",
              "Muhafazat Lahij",
              "Muhafazat Ma'rib",
              "Muhafazat Raymah",
              "Muhafazat Sa'dah",
              "Muhafazat Ta`izz",
              "Sanaa",
              "Shabwah",
              "Socotra",
            ],
            zm: [
              "Central Province",
              "Copperbelt Province",
              "Eastern Province",
              "Luapula Province",
              "Lusaka Province",
              "Muchinga Province",
              "North-Western Province",
              "Northern Province",
              "Southern Province",
              "Western Province",
            ],
            zw: [
              "Bulawayo Province",
              "Harare Province",
              "Manicaland Province",
              "Mashonaland Central Province",
              "Mashonaland East Province",
              "Mashonaland West Province",
              "Masvingo Province",
              "Matabeleland North Province",
              "Matabeleland South Province",
              "Midlands Province",
            ],
          });
      },
      8699: function (e, t, n) {
        "use strict";
        var r =
          (this && this.__importDefault) ||
          function (e) {
            return e && e.__esModule ? e : { default: e };
          };
        Object.defineProperty(t, "__esModule", { value: !0 }),
          (t.getStates =
            t.getFilteredCountries =
            t.getCountry =
            t.getCountries =
              void 0);
        var o = r(n(4929)),
          a = r(n(1564)),
          i = function (e, t) {
            return (
              (t = t.toLowerCase()),
              e.code.toLowerCase() === t ||
                e.name.toLowerCase() === t ||
                e.dial_code.toLowerCase() === t
            );
          };
        (t.getCountries = function () {
          return o.default;
        }),
          (t.getCountry = function (e) {
            for (var n = 0, r = t.getCountries(); n < r.length; n++) {
              var o = r[n];
              if (i(o, e)) return o;
            }
            return null;
          }),
          (t.getFilteredCountries = function (e) {
            for (
              var n = t.getCountries(), r = [], o = 0, a = e;
              o < a.length;
              o++
            )
              for (var s = a[o], l = 0, d = n; l < d.length; l++) {
                var c = d[l];
                if (i(c, s)) {
                  r.push(c);
                  break;
                }
              }
            return r;
          }),
          (t.getStates = function (e) {
            try {
              return a.default[e];
            } catch (e) {
              return "Invalid country code";
            }
          });
      },
      3162: function (e, t, n) {
        var r, o;
        void 0 ===
          (o =
            "function" ==
            typeof (r = function () {
              "use strict";
              function t(e, t, n) {
                var r = new XMLHttpRequest();
                r.open("GET", e),
                  (r.responseType = "blob"),
                  (r.onload = function () {
                    s(r.response, t, n);
                  }),
                  (r.onerror = function () {
                    console.error("could not download file");
                  }),
                  r.send();
              }
              function r(e) {
                var t = new XMLHttpRequest();
                t.open("HEAD", e, !1);
                try {
                  t.send();
                } catch (e) {}
                return 200 <= t.status && 299 >= t.status;
              }
              function o(e) {
                try {
                  e.dispatchEvent(new MouseEvent("click"));
                } catch (n) {
                  var t = document.createEvent("MouseEvents");
                  t.initMouseEvent(
                    "click",
                    !0,
                    !0,
                    window,
                    0,
                    0,
                    0,
                    80,
                    20,
                    !1,
                    !1,
                    !1,
                    !1,
                    0,
                    null
                  ),
                    e.dispatchEvent(t);
                }
              }
              var a =
                  "object" == typeof window && window.window === window
                    ? window
                    : "object" == typeof self && self.self === self
                    ? self
                    : "object" == typeof n.g && n.g.global === n.g
                    ? n.g
                    : void 0,
                i =
                  a.navigator &&
                  /Macintosh/.test(navigator.userAgent) &&
                  /AppleWebKit/.test(navigator.userAgent) &&
                  !/Safari/.test(navigator.userAgent),
                s =
                  a.saveAs ||
                  ("object" != typeof window || window !== a
                    ? function () {}
                    : "download" in HTMLAnchorElement.prototype && !i
                    ? function (e, n, i) {
                        var s = a.URL || a.webkitURL,
                          l = document.createElement("a");
                        (n = n || e.name || "download"),
                          (l.download = n),
                          (l.rel = "noopener"),
                          "string" == typeof e
                            ? ((l.href = e),
                              l.origin === location.origin
                                ? o(l)
                                : r(l.href)
                                ? t(e, n, i)
                                : o(l, (l.target = "_blank")))
                            : ((l.href = s.createObjectURL(e)),
                              setTimeout(function () {
                                s.revokeObjectURL(l.href);
                              }, 4e4),
                              setTimeout(function () {
                                o(l);
                              }, 0));
                      }
                    : "msSaveOrOpenBlob" in navigator
                    ? function (e, n, a) {
                        if (
                          ((n = n || e.name || "download"),
                          "string" != typeof e)
                        )
                          navigator.msSaveOrOpenBlob(
                            (function (e, t) {
                              return (
                                void 0 === t
                                  ? (t = { autoBom: !1 })
                                  : "object" != typeof t &&
                                    (console.warn(
                                      "Deprecated: Expected third argument to be a object"
                                    ),
                                    (t = { autoBom: !t })),
                                t.autoBom &&
                                /^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(
                                  e.type
                                )
                                  ? new Blob(["\ufeff", e], { type: e.type })
                                  : e
                              );
                            })(e, a),
                            n
                          );
                        else if (r(e)) t(e, n, a);
                        else {
                          var i = document.createElement("a");
                          (i.href = e),
                            (i.target = "_blank"),
                            setTimeout(function () {
                              o(i);
                            });
                        }
                      }
                    : function (e, n, r, o) {
                        if (
                          ((o = o || open("", "_blank")) &&
                            (o.document.title = o.document.body.innerText =
                              "downloading..."),
                          "string" == typeof e)
                        )
                          return t(e, n, r);
                        var s = "application/octet-stream" === e.type,
                          l = /constructor/i.test(a.HTMLElement) || a.safari,
                          d = /CriOS\/[\d]+/.test(navigator.userAgent);
                        if (
                          (d || (s && l) || i) &&
                          "undefined" != typeof FileReader
                        ) {
                          var c = new FileReader();
                          (c.onloadend = function () {
                            var e = c.result;
                            (e = d
                              ? e
                              : e.replace(
                                  /^data:[^;]*;/,
                                  "data:attachment/file;"
                                )),
                              o ? (o.location.href = e) : (location = e),
                              (o = null);
                          }),
                            c.readAsDataURL(e);
                        } else {
                          var u = a.URL || a.webkitURL,
                            p = u.createObjectURL(e);
                          o ? (o.location = p) : (location.href = p),
                            (o = null),
                            setTimeout(function () {
                              u.revokeObjectURL(p);
                            }, 4e4);
                        }
                      });
              (a.saveAs = s.saveAs = s), (e.exports = s);
            })
              ? r.apply(t, [])
              : r) || (e.exports = o);
      },
      8679: function (e, t, n) {
        "use strict";
        var r = n(1296),
          o = {
            childContextTypes: !0,
            contextType: !0,
            contextTypes: !0,
            defaultProps: !0,
            displayName: !0,
            getDefaultProps: !0,
            getDerivedStateFromError: !0,
            getDerivedStateFromProps: !0,
            mixins: !0,
            propTypes: !0,
            type: !0,
          },
          a = {
            name: !0,
            length: !0,
            prototype: !0,
            caller: !0,
            callee: !0,
            arguments: !0,
            arity: !0,
          },
          i = {
            $$typeof: !0,
            compare: !0,
            defaultProps: !0,
            displayName: !0,
            propTypes: !0,
            type: !0,
          },
          s = {};
        function l(e) {
          return r.isMemo(e) ? i : s[e.$$typeof] || o;
        }
        (s[r.ForwardRef] = {
          $$typeof: !0,
          render: !0,
          defaultProps: !0,
          displayName: !0,
          propTypes: !0,
        }),
          (s[r.Memo] = i);
        var d = Object.defineProperty,
          c = Object.getOwnPropertyNames,
          u = Object.getOwnPropertySymbols,
          p = Object.getOwnPropertyDescriptor,
          m = Object.getPrototypeOf,
          h = Object.prototype;
        e.exports = function e(t, n, r) {
          if ("string" != typeof n) {
            if (h) {
              var o = m(n);
              o && o !== h && e(t, o, r);
            }
            var i = c(n);
            u && (i = i.concat(u(n)));
            for (var s = l(t), f = l(n), g = 0; g < i.length; ++g) {
              var v = i[g];
              if (!(a[v] || (r && r[v]) || (f && f[v]) || (s && s[v]))) {
                var b = p(n, v);
                try {
                  d(t, v, b);
                } catch (e) {}
              }
            }
          }
          return t;
        };
      },
      6103: function (e, t) {
        "use strict";
        var n = "function" == typeof Symbol && Symbol.for,
          r = n ? Symbol.for("react.element") : 60103,
          o = n ? Symbol.for("react.portal") : 60106,
          a = n ? Symbol.for("react.fragment") : 60107,
          i = n ? Symbol.for("react.strict_mode") : 60108,
          s = n ? Symbol.for("react.profiler") : 60114,
          l = n ? Symbol.for("react.provider") : 60109,
          d = n ? Symbol.for("react.context") : 60110,
          c = n ? Symbol.for("react.async_mode") : 60111,
          u = n ? Symbol.for("react.concurrent_mode") : 60111,
          p = n ? Symbol.for("react.forward_ref") : 60112,
          m = n ? Symbol.for("react.suspense") : 60113,
          h = n ? Symbol.for("react.suspense_list") : 60120,
          f = n ? Symbol.for("react.memo") : 60115,
          g = n ? Symbol.for("react.lazy") : 60116,
          v = n ? Symbol.for("react.block") : 60121,
          b = n ? Symbol.for("react.fundamental") : 60117,
          _ = n ? Symbol.for("react.responder") : 60118,
          y = n ? Symbol.for("react.scope") : 60119;
        function C(e) {
          if ("object" == typeof e && null !== e) {
            var t = e.$$typeof;
            switch (t) {
              case r:
                switch ((e = e.type)) {
                  case c:
                  case u:
                  case a:
                  case s:
                  case i:
                  case m:
                    return e;
                  default:
                    switch ((e = e && e.$$typeof)) {
                      case d:
                      case p:
                      case g:
                      case f:
                      case l:
                        return e;
                      default:
                        return t;
                    }
                }
              case o:
                return t;
            }
          }
        }
        function x(e) {
          return C(e) === u;
        }
        (t.AsyncMode = c),
          (t.ConcurrentMode = u),
          (t.ContextConsumer = d),
          (t.ContextProvider = l),
          (t.Element = r),
          (t.ForwardRef = p),
          (t.Fragment = a),
          (t.Lazy = g),
          (t.Memo = f),
          (t.Portal = o),
          (t.Profiler = s),
          (t.StrictMode = i),
          (t.Suspense = m),
          (t.isAsyncMode = function (e) {
            return x(e) || C(e) === c;
          }),
          (t.isConcurrentMode = x),
          (t.isContextConsumer = function (e) {
            return C(e) === d;
          }),
          (t.isContextProvider = function (e) {
            return C(e) === l;
          }),
          (t.isElement = function (e) {
            return "object" == typeof e && null !== e && e.$$typeof === r;
          }),
          (t.isForwardRef = function (e) {
            return C(e) === p;
          }),
          (t.isFragment = function (e) {
            return C(e) === a;
          }),
          (t.isLazy = function (e) {
            return C(e) === g;
          }),
          (t.isMemo = function (e) {
            return C(e) === f;
          }),
          (t.isPortal = function (e) {
            return C(e) === o;
          }),
          (t.isProfiler = function (e) {
            return C(e) === s;
          }),
          (t.isStrictMode = function (e) {
            return C(e) === i;
          }),
          (t.isSuspense = function (e) {
            return C(e) === m;
          }),
          (t.isValidElementType = function (e) {
            return (
              "string" == typeof e ||
              "function" == typeof e ||
              e === a ||
              e === u ||
              e === s ||
              e === i ||
              e === m ||
              e === h ||
              ("object" == typeof e &&
                null !== e &&
                (e.$$typeof === g ||
                  e.$$typeof === f ||
                  e.$$typeof === l ||
                  e.$$typeof === d ||
                  e.$$typeof === p ||
                  e.$$typeof === b ||
                  e.$$typeof === _ ||
                  e.$$typeof === y ||
                  e.$$typeof === v))
            );
          }),
          (t.typeOf = C);
      },
      1296: function (e, t, n) {
        "use strict";
        e.exports = n(6103);
      },
      4448: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = n(3840);
        function a(e) {
          for (
            var t =
                "https://reactjs.org/docs/error-decoder.html?invariant=" + e,
              n = 1;
            n < arguments.length;
            n++
          )
            t += "&args[]=" + encodeURIComponent(arguments[n]);
          return (
            "Minified React error #" +
            e +
            "; visit " +
            t +
            " for the full message or use the non-minified dev environment for full errors and additional helpful warnings."
          );
        }
        var i = new Set(),
          s = {};
        function l(e, t) {
          d(e, t), d(e + "Capture", t);
        }
        function d(e, t) {
          for (s[e] = t, e = 0; e < t.length; e++) i.add(t[e]);
        }
        var c = !(
            "undefined" == typeof window ||
            void 0 === window.document ||
            void 0 === window.document.createElement
          ),
          u = Object.prototype.hasOwnProperty,
          p =
            /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,
          m = {},
          h = {};
        function f(e, t, n, r, o, a, i) {
          (this.acceptsBooleans = 2 === t || 3 === t || 4 === t),
            (this.attributeName = r),
            (this.attributeNamespace = o),
            (this.mustUseProperty = n),
            (this.propertyName = e),
            (this.type = t),
            (this.sanitizeURL = a),
            (this.removeEmptyString = i);
        }
        var g = {};
        "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style"
          .split(" ")
          .forEach(function (e) {
            g[e] = new f(e, 0, !1, e, null, !1, !1);
          }),
          [
            ["acceptCharset", "accept-charset"],
            ["className", "class"],
            ["htmlFor", "for"],
            ["httpEquiv", "http-equiv"],
          ].forEach(function (e) {
            var t = e[0];
            g[t] = new f(t, 1, !1, e[1], null, !1, !1);
          }),
          ["contentEditable", "draggable", "spellCheck", "value"].forEach(
            function (e) {
              g[e] = new f(e, 2, !1, e.toLowerCase(), null, !1, !1);
            }
          ),
          [
            "autoReverse",
            "externalResourcesRequired",
            "focusable",
            "preserveAlpha",
          ].forEach(function (e) {
            g[e] = new f(e, 2, !1, e, null, !1, !1);
          }),
          "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope"
            .split(" ")
            .forEach(function (e) {
              g[e] = new f(e, 3, !1, e.toLowerCase(), null, !1, !1);
            }),
          ["checked", "multiple", "muted", "selected"].forEach(function (e) {
            g[e] = new f(e, 3, !0, e, null, !1, !1);
          }),
          ["capture", "download"].forEach(function (e) {
            g[e] = new f(e, 4, !1, e, null, !1, !1);
          }),
          ["cols", "rows", "size", "span"].forEach(function (e) {
            g[e] = new f(e, 6, !1, e, null, !1, !1);
          }),
          ["rowSpan", "start"].forEach(function (e) {
            g[e] = new f(e, 5, !1, e.toLowerCase(), null, !1, !1);
          });
        var v = /[\-:]([a-z])/g;
        function b(e) {
          return e[1].toUpperCase();
        }
        function _(e, t, n, r) {
          var o = g.hasOwnProperty(t) ? g[t] : null;
          (null !== o
            ? 0 !== o.type
            : r ||
              !(2 < t.length) ||
              ("o" !== t[0] && "O" !== t[0]) ||
              ("n" !== t[1] && "N" !== t[1])) &&
            ((function (e, t, n, r) {
              if (
                null == t ||
                (function (e, t, n, r) {
                  if (null !== n && 0 === n.type) return !1;
                  switch (typeof t) {
                    case "function":
                    case "symbol":
                      return !0;
                    case "boolean":
                      return (
                        !r &&
                        (null !== n
                          ? !n.acceptsBooleans
                          : "data-" !== (e = e.toLowerCase().slice(0, 5)) &&
                            "aria-" !== e)
                      );
                    default:
                      return !1;
                  }
                })(e, t, n, r)
              )
                return !0;
              if (r) return !1;
              if (null !== n)
                switch (n.type) {
                  case 3:
                    return !t;
                  case 4:
                    return !1 === t;
                  case 5:
                    return isNaN(t);
                  case 6:
                    return isNaN(t) || 1 > t;
                }
              return !1;
            })(t, n, o, r) && (n = null),
            r || null === o
              ? (function (e) {
                  return (
                    !!u.call(h, e) ||
                    (!u.call(m, e) &&
                      (p.test(e) ? (h[e] = !0) : ((m[e] = !0), !1)))
                  );
                })(t) &&
                (null === n ? e.removeAttribute(t) : e.setAttribute(t, "" + n))
              : o.mustUseProperty
              ? (e[o.propertyName] = null === n ? 3 !== o.type && "" : n)
              : ((t = o.attributeName),
                (r = o.attributeNamespace),
                null === n
                  ? e.removeAttribute(t)
                  : ((n =
                      3 === (o = o.type) || (4 === o && !0 === n)
                        ? ""
                        : "" + n),
                    r ? e.setAttributeNS(r, t, n) : e.setAttribute(t, n))));
        }
        "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height"
          .split(" ")
          .forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new f(t, 1, !1, e, null, !1, !1);
          }),
          "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type"
            .split(" ")
            .forEach(function (e) {
              var t = e.replace(v, b);
              g[t] = new f(t, 1, !1, e, "http://www.w3.org/1999/xlink", !1, !1);
            }),
          ["xml:base", "xml:lang", "xml:space"].forEach(function (e) {
            var t = e.replace(v, b);
            g[t] = new f(
              t,
              1,
              !1,
              e,
              "http://www.w3.org/XML/1998/namespace",
              !1,
              !1
            );
          }),
          ["tabIndex", "crossOrigin"].forEach(function (e) {
            g[e] = new f(e, 1, !1, e.toLowerCase(), null, !1, !1);
          }),
          (g.xlinkHref = new f(
            "xlinkHref",
            1,
            !1,
            "xlink:href",
            "http://www.w3.org/1999/xlink",
            !0,
            !1
          )),
          ["src", "href", "action", "formAction"].forEach(function (e) {
            g[e] = new f(e, 1, !1, e.toLowerCase(), null, !0, !0);
          });
        var y = r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,
          C = Symbol.for("react.element"),
          x = Symbol.for("react.portal"),
          S = Symbol.for("react.fragment"),
          k = Symbol.for("react.strict_mode"),
          P = Symbol.for("react.profiler"),
          w = Symbol.for("react.provider"),
          O = Symbol.for("react.context"),
          T = Symbol.for("react.forward_ref"),
          I = Symbol.for("react.suspense"),
          M = Symbol.for("react.suspense_list"),
          j = Symbol.for("react.memo"),
          N = Symbol.for("react.lazy");
        Symbol.for("react.scope"), Symbol.for("react.debug_trace_mode");
        var D = Symbol.for("react.offscreen");
        Symbol.for("react.legacy_hidden"),
          Symbol.for("react.cache"),
          Symbol.for("react.tracing_marker");
        var A = Symbol.iterator;
        function E(e) {
          return null === e || "object" != typeof e
            ? null
            : "function" == typeof (e = (A && e[A]) || e["@@iterator"])
            ? e
            : null;
        }
        var R,
          L = Object.assign;
        function B(e) {
          if (void 0 === R)
            try {
              throw Error();
            } catch (e) {
              var t = e.stack.trim().match(/\n( *(at )?)/);
              R = (t && t[1]) || "";
            }
          return "\n" + R + e;
        }
        var z = !1;
        function F(e, t) {
          if (!e || z) return "";
          z = !0;
          var n = Error.prepareStackTrace;
          Error.prepareStackTrace = void 0;
          try {
            if (t)
              if (
                ((t = function () {
                  throw Error();
                }),
                Object.defineProperty(t.prototype, "props", {
                  set: function () {
                    throw Error();
                  },
                }),
                "object" == typeof Reflect && Reflect.construct)
              ) {
                try {
                  Reflect.construct(t, []);
                } catch (e) {
                  var r = e;
                }
                Reflect.construct(e, [], t);
              } else {
                try {
                  t.call();
                } catch (e) {
                  r = e;
                }
                e.call(t.prototype);
              }
            else {
              try {
                throw Error();
              } catch (e) {
                r = e;
              }
              e();
            }
          } catch (t) {
            if (t && r && "string" == typeof t.stack) {
              for (
                var o = t.stack.split("\n"),
                  a = r.stack.split("\n"),
                  i = o.length - 1,
                  s = a.length - 1;
                1 <= i && 0 <= s && o[i] !== a[s];

              )
                s--;
              for (; 1 <= i && 0 <= s; i--, s--)
                if (o[i] !== a[s]) {
                  if (1 !== i || 1 !== s)
                    do {
                      if ((i--, 0 > --s || o[i] !== a[s])) {
                        var l = "\n" + o[i].replace(" at new ", " at ");
                        return (
                          e.displayName &&
                            l.includes("<anonymous>") &&
                            (l = l.replace("<anonymous>", e.displayName)),
                          l
                        );
                      }
                    } while (1 <= i && 0 <= s);
                  break;
                }
            }
          } finally {
            (z = !1), (Error.prepareStackTrace = n);
          }
          return (e = e ? e.displayName || e.name : "") ? B(e) : "";
        }
        function Z(e) {
          switch (e.tag) {
            case 5:
              return B(e.type);
            case 16:
              return B("Lazy");
            case 13:
              return B("Suspense");
            case 19:
              return B("SuspenseList");
            case 0:
            case 2:
            case 15:
              return F(e.type, !1);
            case 11:
              return F(e.type.render, !1);
            case 1:
              return F(e.type, !0);
            default:
              return "";
          }
        }
        function H(e) {
          if (null == e) return null;
          if ("function" == typeof e) return e.displayName || e.name || null;
          if ("string" == typeof e) return e;
          switch (e) {
            case S:
              return "Fragment";
            case x:
              return "Portal";
            case P:
              return "Profiler";
            case k:
              return "StrictMode";
            case I:
              return "Suspense";
            case M:
              return "SuspenseList";
          }
          if ("object" == typeof e)
            switch (e.$$typeof) {
              case O:
                return (e.displayName || "Context") + ".Consumer";
              case w:
                return (e._context.displayName || "Context") + ".Provider";
              case T:
                var t = e.render;
                return (
                  (e = e.displayName) ||
                    (e =
                      "" !== (e = t.displayName || t.name || "")
                        ? "ForwardRef(" + e + ")"
                        : "ForwardRef"),
                  e
                );
              case j:
                return null !== (t = e.displayName || null)
                  ? t
                  : H(e.type) || "Memo";
              case N:
                (t = e._payload), (e = e._init);
                try {
                  return H(e(t));
                } catch (e) {}
            }
          return null;
        }
        function V(e) {
          var t = e.type;
          switch (e.tag) {
            case 24:
              return "Cache";
            case 9:
              return (t.displayName || "Context") + ".Consumer";
            case 10:
              return (t._context.displayName || "Context") + ".Provider";
            case 18:
              return "DehydratedFragment";
            case 11:
              return (
                (e = (e = t.render).displayName || e.name || ""),
                t.displayName ||
                  ("" !== e ? "ForwardRef(" + e + ")" : "ForwardRef")
              );
            case 7:
              return "Fragment";
            case 5:
              return t;
            case 4:
              return "Portal";
            case 3:
              return "Root";
            case 6:
              return "Text";
            case 16:
              return H(t);
            case 8:
              return t === k ? "StrictMode" : "Mode";
            case 22:
              return "Offscreen";
            case 12:
              return "Profiler";
            case 21:
              return "Scope";
            case 13:
              return "Suspense";
            case 19:
              return "SuspenseList";
            case 25:
              return "TracingMarker";
            case 1:
            case 0:
            case 17:
            case 2:
            case 14:
            case 15:
              if ("function" == typeof t)
                return t.displayName || t.name || null;
              if ("string" == typeof t) return t;
          }
          return null;
        }
        function W(e) {
          switch (typeof e) {
            case "boolean":
            case "number":
            case "string":
            case "undefined":
            case "object":
              return e;
            default:
              return "";
          }
        }
        function U(e) {
          var t = e.type;
          return (
            (e = e.nodeName) &&
            "input" === e.toLowerCase() &&
            ("checkbox" === t || "radio" === t)
          );
        }
        function $(e) {
          e._valueTracker ||
            (e._valueTracker = (function (e) {
              var t = U(e) ? "checked" : "value",
                n = Object.getOwnPropertyDescriptor(e.constructor.prototype, t),
                r = "" + e[t];
              if (
                !e.hasOwnProperty(t) &&
                void 0 !== n &&
                "function" == typeof n.get &&
                "function" == typeof n.set
              ) {
                var o = n.get,
                  a = n.set;
                return (
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    get: function () {
                      return o.call(this);
                    },
                    set: function (e) {
                      (r = "" + e), a.call(this, e);
                    },
                  }),
                  Object.defineProperty(e, t, { enumerable: n.enumerable }),
                  {
                    getValue: function () {
                      return r;
                    },
                    setValue: function (e) {
                      r = "" + e;
                    },
                    stopTracking: function () {
                      (e._valueTracker = null), delete e[t];
                    },
                  }
                );
              }
            })(e));
        }
        function K(e) {
          if (!e) return !1;
          var t = e._valueTracker;
          if (!t) return !0;
          var n = t.getValue(),
            r = "";
          return (
            e && (r = U(e) ? (e.checked ? "true" : "false") : e.value),
            (e = r) !== n && (t.setValue(e), !0)
          );
        }
        function G(e) {
          if (
            void 0 ===
            (e = e || ("undefined" != typeof document ? document : void 0))
          )
            return null;
          try {
            return e.activeElement || e.body;
          } catch (t) {
            return e.body;
          }
        }
        function q(e, t) {
          var n = t.checked;
          return L({}, t, {
            defaultChecked: void 0,
            defaultValue: void 0,
            value: void 0,
            checked: null != n ? n : e._wrapperState.initialChecked,
          });
        }
        function Q(e, t) {
          var n = null == t.defaultValue ? "" : t.defaultValue,
            r = null != t.checked ? t.checked : t.defaultChecked;
          (n = W(null != t.value ? t.value : n)),
            (e._wrapperState = {
              initialChecked: r,
              initialValue: n,
              controlled:
                "checkbox" === t.type || "radio" === t.type
                  ? null != t.checked
                  : null != t.value,
            });
        }
        function Y(e, t) {
          null != (t = t.checked) && _(e, "checked", t, !1);
        }
        function J(e, t) {
          Y(e, t);
          var n = W(t.value),
            r = t.type;
          if (null != n)
            "number" === r
              ? ((0 === n && "" === e.value) || e.value != n) &&
                (e.value = "" + n)
              : e.value !== "" + n && (e.value = "" + n);
          else if ("submit" === r || "reset" === r)
            return void e.removeAttribute("value");
          t.hasOwnProperty("value")
            ? ee(e, t.type, n)
            : t.hasOwnProperty("defaultValue") &&
              ee(e, t.type, W(t.defaultValue)),
            null == t.checked &&
              null != t.defaultChecked &&
              (e.defaultChecked = !!t.defaultChecked);
        }
        function X(e, t, n) {
          if (t.hasOwnProperty("value") || t.hasOwnProperty("defaultValue")) {
            var r = t.type;
            if (
              !(
                ("submit" !== r && "reset" !== r) ||
                (void 0 !== t.value && null !== t.value)
              )
            )
              return;
            (t = "" + e._wrapperState.initialValue),
              n || t === e.value || (e.value = t),
              (e.defaultValue = t);
          }
          "" !== (n = e.name) && (e.name = ""),
            (e.defaultChecked = !!e._wrapperState.initialChecked),
            "" !== n && (e.name = n);
        }
        function ee(e, t, n) {
          ("number" === t && G(e.ownerDocument) === e) ||
            (null == n
              ? (e.defaultValue = "" + e._wrapperState.initialValue)
              : e.defaultValue !== "" + n && (e.defaultValue = "" + n));
        }
        var te = Array.isArray;
        function ne(e, t, n, r) {
          if (((e = e.options), t)) {
            t = {};
            for (var o = 0; o < n.length; o++) t["$" + n[o]] = !0;
            for (n = 0; n < e.length; n++)
              (o = t.hasOwnProperty("$" + e[n].value)),
                e[n].selected !== o && (e[n].selected = o),
                o && r && (e[n].defaultSelected = !0);
          } else {
            for (n = "" + W(n), t = null, o = 0; o < e.length; o++) {
              if (e[o].value === n)
                return (
                  (e[o].selected = !0), void (r && (e[o].defaultSelected = !0))
                );
              null !== t || e[o].disabled || (t = e[o]);
            }
            null !== t && (t.selected = !0);
          }
        }
        function re(e, t) {
          if (null != t.dangerouslySetInnerHTML) throw Error(a(91));
          return L({}, t, {
            value: void 0,
            defaultValue: void 0,
            children: "" + e._wrapperState.initialValue,
          });
        }
        function oe(e, t) {
          var n = t.value;
          if (null == n) {
            if (((n = t.children), (t = t.defaultValue), null != n)) {
              if (null != t) throw Error(a(92));
              if (te(n)) {
                if (1 < n.length) throw Error(a(93));
                n = n[0];
              }
              t = n;
            }
            null == t && (t = ""), (n = t);
          }
          e._wrapperState = { initialValue: W(n) };
        }
        function ae(e, t) {
          var n = W(t.value),
            r = W(t.defaultValue);
          null != n &&
            ((n = "" + n) !== e.value && (e.value = n),
            null == t.defaultValue &&
              e.defaultValue !== n &&
              (e.defaultValue = n)),
            null != r && (e.defaultValue = "" + r);
        }
        function ie(e) {
          var t = e.textContent;
          t === e._wrapperState.initialValue &&
            "" !== t &&
            null !== t &&
            (e.value = t);
        }
        function se(e) {
          switch (e) {
            case "svg":
              return "http://www.w3.org/2000/svg";
            case "math":
              return "http://www.w3.org/1998/Math/MathML";
            default:
              return "http://www.w3.org/1999/xhtml";
          }
        }
        function le(e, t) {
          return null == e || "http://www.w3.org/1999/xhtml" === e
            ? se(t)
            : "http://www.w3.org/2000/svg" === e && "foreignObject" === t
            ? "http://www.w3.org/1999/xhtml"
            : e;
        }
        var de,
          ce,
          ue =
            ((ce = function (e, t) {
              if (
                "http://www.w3.org/2000/svg" !== e.namespaceURI ||
                "innerHTML" in e
              )
                e.innerHTML = t;
              else {
                for (
                  (de = de || document.createElement("div")).innerHTML =
                    "<svg>" + t.valueOf().toString() + "</svg>",
                    t = de.firstChild;
                  e.firstChild;

                )
                  e.removeChild(e.firstChild);
                for (; t.firstChild; ) e.appendChild(t.firstChild);
              }
            }),
            "undefined" != typeof MSApp && MSApp.execUnsafeLocalFunction
              ? function (e, t, n, r) {
                  MSApp.execUnsafeLocalFunction(function () {
                    return ce(e, t);
                  });
                }
              : ce);
        function pe(e, t) {
          if (t) {
            var n = e.firstChild;
            if (n && n === e.lastChild && 3 === n.nodeType)
              return void (n.nodeValue = t);
          }
          e.textContent = t;
        }
        var me = {
            animationIterationCount: !0,
            aspectRatio: !0,
            borderImageOutset: !0,
            borderImageSlice: !0,
            borderImageWidth: !0,
            boxFlex: !0,
            boxFlexGroup: !0,
            boxOrdinalGroup: !0,
            columnCount: !0,
            columns: !0,
            flex: !0,
            flexGrow: !0,
            flexPositive: !0,
            flexShrink: !0,
            flexNegative: !0,
            flexOrder: !0,
            gridArea: !0,
            gridRow: !0,
            gridRowEnd: !0,
            gridRowSpan: !0,
            gridRowStart: !0,
            gridColumn: !0,
            gridColumnEnd: !0,
            gridColumnSpan: !0,
            gridColumnStart: !0,
            fontWeight: !0,
            lineClamp: !0,
            lineHeight: !0,
            opacity: !0,
            order: !0,
            orphans: !0,
            tabSize: !0,
            widows: !0,
            zIndex: !0,
            zoom: !0,
            fillOpacity: !0,
            floodOpacity: !0,
            stopOpacity: !0,
            strokeDasharray: !0,
            strokeDashoffset: !0,
            strokeMiterlimit: !0,
            strokeOpacity: !0,
            strokeWidth: !0,
          },
          he = ["Webkit", "ms", "Moz", "O"];
        function fe(e, t, n) {
          return null == t || "boolean" == typeof t || "" === t
            ? ""
            : n ||
              "number" != typeof t ||
              0 === t ||
              (me.hasOwnProperty(e) && me[e])
            ? ("" + t).trim()
            : t + "px";
        }
        function ge(e, t) {
          for (var n in ((e = e.style), t))
            if (t.hasOwnProperty(n)) {
              var r = 0 === n.indexOf("--"),
                o = fe(n, t[n], r);
              "float" === n && (n = "cssFloat"),
                r ? e.setProperty(n, o) : (e[n] = o);
            }
        }
        Object.keys(me).forEach(function (e) {
          he.forEach(function (t) {
            (t = t + e.charAt(0).toUpperCase() + e.substring(1)),
              (me[t] = me[e]);
          });
        });
        var ve = L(
          { menuitem: !0 },
          {
            area: !0,
            base: !0,
            br: !0,
            col: !0,
            embed: !0,
            hr: !0,
            img: !0,
            input: !0,
            keygen: !0,
            link: !0,
            meta: !0,
            param: !0,
            source: !0,
            track: !0,
            wbr: !0,
          }
        );
        function be(e, t) {
          if (t) {
            if (
              ve[e] &&
              (null != t.children || null != t.dangerouslySetInnerHTML)
            )
              throw Error(a(137, e));
            if (null != t.dangerouslySetInnerHTML) {
              if (null != t.children) throw Error(a(60));
              if (
                "object" != typeof t.dangerouslySetInnerHTML ||
                !("__html" in t.dangerouslySetInnerHTML)
              )
                throw Error(a(61));
            }
            if (null != t.style && "object" != typeof t.style)
              throw Error(a(62));
          }
        }
        function _e(e, t) {
          if (-1 === e.indexOf("-")) return "string" == typeof t.is;
          switch (e) {
            case "annotation-xml":
            case "color-profile":
            case "font-face":
            case "font-face-src":
            case "font-face-uri":
            case "font-face-format":
            case "font-face-name":
            case "missing-glyph":
              return !1;
            default:
              return !0;
          }
        }
        var ye = null;
        function Ce(e) {
          return (
            (e = e.target || e.srcElement || window).correspondingUseElement &&
              (e = e.correspondingUseElement),
            3 === e.nodeType ? e.parentNode : e
          );
        }
        var xe = null,
          Se = null,
          ke = null;
        function Pe(e) {
          if ((e = yo(e))) {
            if ("function" != typeof xe) throw Error(a(280));
            var t = e.stateNode;
            t && ((t = xo(t)), xe(e.stateNode, e.type, t));
          }
        }
        function we(e) {
          Se ? (ke ? ke.push(e) : (ke = [e])) : (Se = e);
        }
        function Oe() {
          if (Se) {
            var e = Se,
              t = ke;
            if (((ke = Se = null), Pe(e), t))
              for (e = 0; e < t.length; e++) Pe(t[e]);
          }
        }
        function Te(e, t) {
          return e(t);
        }
        function Ie() {}
        var Me = !1;
        function je(e, t, n) {
          if (Me) return e(t, n);
          Me = !0;
          try {
            return Te(e, t, n);
          } finally {
            (Me = !1), (null !== Se || null !== ke) && (Ie(), Oe());
          }
        }
        function Ne(e, t) {
          var n = e.stateNode;
          if (null === n) return null;
          var r = xo(n);
          if (null === r) return null;
          n = r[t];
          e: switch (t) {
            case "onClick":
            case "onClickCapture":
            case "onDoubleClick":
            case "onDoubleClickCapture":
            case "onMouseDown":
            case "onMouseDownCapture":
            case "onMouseMove":
            case "onMouseMoveCapture":
            case "onMouseUp":
            case "onMouseUpCapture":
            case "onMouseEnter":
              (r = !r.disabled) ||
                (r = !(
                  "button" === (e = e.type) ||
                  "input" === e ||
                  "select" === e ||
                  "textarea" === e
                )),
                (e = !r);
              break e;
            default:
              e = !1;
          }
          if (e) return null;
          if (n && "function" != typeof n) throw Error(a(231, t, typeof n));
          return n;
        }
        var De = !1;
        if (c)
          try {
            var Ae = {};
            Object.defineProperty(Ae, "passive", {
              get: function () {
                De = !0;
              },
            }),
              window.addEventListener("test", Ae, Ae),
              window.removeEventListener("test", Ae, Ae);
          } catch (ce) {
            De = !1;
          }
        function Ee(e, t, n, r, o, a, i, s, l) {
          var d = Array.prototype.slice.call(arguments, 3);
          try {
            t.apply(n, d);
          } catch (e) {
            this.onError(e);
          }
        }
        var Re = !1,
          Le = null,
          Be = !1,
          ze = null,
          Fe = {
            onError: function (e) {
              (Re = !0), (Le = e);
            },
          };
        function Ze(e, t, n, r, o, a, i, s, l) {
          (Re = !1), (Le = null), Ee.apply(Fe, arguments);
        }
        function He(e) {
          var t = e,
            n = e;
          if (e.alternate) for (; t.return; ) t = t.return;
          else {
            e = t;
            do {
              0 != (4098 & (t = e).flags) && (n = t.return), (e = t.return);
            } while (e);
          }
          return 3 === t.tag ? n : null;
        }
        function Ve(e) {
          if (13 === e.tag) {
            var t = e.memoizedState;
            if (
              (null === t &&
                null !== (e = e.alternate) &&
                (t = e.memoizedState),
              null !== t)
            )
              return t.dehydrated;
          }
          return null;
        }
        function We(e) {
          if (He(e) !== e) throw Error(a(188));
        }
        function Ue(e) {
          return null !==
            (e = (function (e) {
              var t = e.alternate;
              if (!t) {
                if (null === (t = He(e))) throw Error(a(188));
                return t !== e ? null : e;
              }
              for (var n = e, r = t; ; ) {
                var o = n.return;
                if (null === o) break;
                var i = o.alternate;
                if (null === i) {
                  if (null !== (r = o.return)) {
                    n = r;
                    continue;
                  }
                  break;
                }
                if (o.child === i.child) {
                  for (i = o.child; i; ) {
                    if (i === n) return We(o), e;
                    if (i === r) return We(o), t;
                    i = i.sibling;
                  }
                  throw Error(a(188));
                }
                if (n.return !== r.return) (n = o), (r = i);
                else {
                  for (var s = !1, l = o.child; l; ) {
                    if (l === n) {
                      (s = !0), (n = o), (r = i);
                      break;
                    }
                    if (l === r) {
                      (s = !0), (r = o), (n = i);
                      break;
                    }
                    l = l.sibling;
                  }
                  if (!s) {
                    for (l = i.child; l; ) {
                      if (l === n) {
                        (s = !0), (n = i), (r = o);
                        break;
                      }
                      if (l === r) {
                        (s = !0), (r = i), (n = o);
                        break;
                      }
                      l = l.sibling;
                    }
                    if (!s) throw Error(a(189));
                  }
                }
                if (n.alternate !== r) throw Error(a(190));
              }
              if (3 !== n.tag) throw Error(a(188));
              return n.stateNode.current === n ? e : t;
            })(e))
            ? $e(e)
            : null;
        }
        function $e(e) {
          if (5 === e.tag || 6 === e.tag) return e;
          for (e = e.child; null !== e; ) {
            var t = $e(e);
            if (null !== t) return t;
            e = e.sibling;
          }
          return null;
        }
        var Ke = o.unstable_scheduleCallback,
          Ge = o.unstable_cancelCallback,
          qe = o.unstable_shouldYield,
          Qe = o.unstable_requestPaint,
          Ye = o.unstable_now,
          Je = o.unstable_getCurrentPriorityLevel,
          Xe = o.unstable_ImmediatePriority,
          et = o.unstable_UserBlockingPriority,
          tt = o.unstable_NormalPriority,
          nt = o.unstable_LowPriority,
          rt = o.unstable_IdlePriority,
          ot = null,
          at = null,
          it = Math.clz32
            ? Math.clz32
            : function (e) {
                return 0 === (e >>>= 0) ? 32 : (31 - ((st(e) / lt) | 0)) | 0;
              },
          st = Math.log,
          lt = Math.LN2,
          dt = 64,
          ct = 4194304;
        function ut(e) {
          switch (e & -e) {
            case 1:
              return 1;
            case 2:
              return 2;
            case 4:
              return 4;
            case 8:
              return 8;
            case 16:
              return 16;
            case 32:
              return 32;
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return 4194240 & e;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
            case 67108864:
              return 130023424 & e;
            case 134217728:
              return 134217728;
            case 268435456:
              return 268435456;
            case 536870912:
              return 536870912;
            case 1073741824:
              return 1073741824;
            default:
              return e;
          }
        }
        function pt(e, t) {
          var n = e.pendingLanes;
          if (0 === n) return 0;
          var r = 0,
            o = e.suspendedLanes,
            a = e.pingedLanes,
            i = 268435455 & n;
          if (0 !== i) {
            var s = i & ~o;
            0 !== s ? (r = ut(s)) : 0 != (a &= i) && (r = ut(a));
          } else 0 != (i = n & ~o) ? (r = ut(i)) : 0 !== a && (r = ut(a));
          if (0 === r) return 0;
          if (
            0 !== t &&
            t !== r &&
            0 == (t & o) &&
            ((o = r & -r) >= (a = t & -t) || (16 === o && 0 != (4194240 & a)))
          )
            return t;
          if ((0 != (4 & r) && (r |= 16 & n), 0 !== (t = e.entangledLanes)))
            for (e = e.entanglements, t &= r; 0 < t; )
              (o = 1 << (n = 31 - it(t))), (r |= e[n]), (t &= ~o);
          return r;
        }
        function mt(e, t) {
          switch (e) {
            case 1:
            case 2:
            case 4:
              return t + 250;
            case 8:
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
              return t + 5e3;
            default:
              return -1;
          }
        }
        function ht(e) {
          return 0 != (e = -1073741825 & e.pendingLanes)
            ? e
            : 1073741824 & e
            ? 1073741824
            : 0;
        }
        function ft() {
          var e = dt;
          return 0 == (4194240 & (dt <<= 1)) && (dt = 64), e;
        }
        function gt(e) {
          for (var t = [], n = 0; 31 > n; n++) t.push(e);
          return t;
        }
        function vt(e, t, n) {
          (e.pendingLanes |= t),
            536870912 !== t && ((e.suspendedLanes = 0), (e.pingedLanes = 0)),
            ((e = e.eventTimes)[(t = 31 - it(t))] = n);
        }
        function bt(e, t) {
          var n = (e.entangledLanes |= t);
          for (e = e.entanglements; n; ) {
            var r = 31 - it(n),
              o = 1 << r;
            (o & t) | (e[r] & t) && (e[r] |= t), (n &= ~o);
          }
        }
        var _t = 0;
        function yt(e) {
          return 1 < (e &= -e)
            ? 4 < e
              ? 0 != (268435455 & e)
                ? 16
                : 536870912
              : 4
            : 1;
        }
        var Ct,
          xt,
          St,
          kt,
          Pt,
          wt = !1,
          Ot = [],
          Tt = null,
          It = null,
          Mt = null,
          jt = new Map(),
          Nt = new Map(),
          Dt = [],
          At =
            "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(
              " "
            );
        function Et(e, t) {
          switch (e) {
            case "focusin":
            case "focusout":
              Tt = null;
              break;
            case "dragenter":
            case "dragleave":
              It = null;
              break;
            case "mouseover":
            case "mouseout":
              Mt = null;
              break;
            case "pointerover":
            case "pointerout":
              jt.delete(t.pointerId);
              break;
            case "gotpointercapture":
            case "lostpointercapture":
              Nt.delete(t.pointerId);
          }
        }
        function Rt(e, t, n, r, o, a) {
          return null === e || e.nativeEvent !== a
            ? ((e = {
                blockedOn: t,
                domEventName: n,
                eventSystemFlags: r,
                nativeEvent: a,
                targetContainers: [o],
              }),
              null !== t && null !== (t = yo(t)) && xt(t),
              e)
            : ((e.eventSystemFlags |= r),
              (t = e.targetContainers),
              null !== o && -1 === t.indexOf(o) && t.push(o),
              e);
        }
        function Lt(e) {
          var t = _o(e.target);
          if (null !== t) {
            var n = He(t);
            if (null !== n)
              if (13 === (t = n.tag)) {
                if (null !== (t = Ve(n)))
                  return (
                    (e.blockedOn = t),
                    void Pt(e.priority, function () {
                      St(n);
                    })
                  );
              } else if (
                3 === t &&
                n.stateNode.current.memoizedState.isDehydrated
              )
                return void (e.blockedOn =
                  3 === n.tag ? n.stateNode.containerInfo : null);
          }
          e.blockedOn = null;
        }
        function Bt(e) {
          if (null !== e.blockedOn) return !1;
          for (var t = e.targetContainers; 0 < t.length; ) {
            var n = qt(e.domEventName, e.eventSystemFlags, t[0], e.nativeEvent);
            if (null !== n)
              return null !== (t = yo(n)) && xt(t), (e.blockedOn = n), !1;
            var r = new (n = e.nativeEvent).constructor(n.type, n);
            (ye = r), n.target.dispatchEvent(r), (ye = null), t.shift();
          }
          return !0;
        }
        function zt(e, t, n) {
          Bt(e) && n.delete(t);
        }
        function Ft() {
          (wt = !1),
            null !== Tt && Bt(Tt) && (Tt = null),
            null !== It && Bt(It) && (It = null),
            null !== Mt && Bt(Mt) && (Mt = null),
            jt.forEach(zt),
            Nt.forEach(zt);
        }
        function Zt(e, t) {
          e.blockedOn === t &&
            ((e.blockedOn = null),
            wt ||
              ((wt = !0),
              o.unstable_scheduleCallback(o.unstable_NormalPriority, Ft)));
        }
        function Ht(e) {
          function t(t) {
            return Zt(t, e);
          }
          if (0 < Ot.length) {
            Zt(Ot[0], e);
            for (var n = 1; n < Ot.length; n++) {
              var r = Ot[n];
              r.blockedOn === e && (r.blockedOn = null);
            }
          }
          for (
            null !== Tt && Zt(Tt, e),
              null !== It && Zt(It, e),
              null !== Mt && Zt(Mt, e),
              jt.forEach(t),
              Nt.forEach(t),
              n = 0;
            n < Dt.length;
            n++
          )
            (r = Dt[n]).blockedOn === e && (r.blockedOn = null);
          for (; 0 < Dt.length && null === (n = Dt[0]).blockedOn; )
            Lt(n), null === n.blockedOn && Dt.shift();
        }
        var Vt = y.ReactCurrentBatchConfig,
          Wt = !0;
        function Ut(e, t, n, r) {
          var o = _t,
            a = Vt.transition;
          Vt.transition = null;
          try {
            (_t = 1), Kt(e, t, n, r);
          } finally {
            (_t = o), (Vt.transition = a);
          }
        }
        function $t(e, t, n, r) {
          var o = _t,
            a = Vt.transition;
          Vt.transition = null;
          try {
            (_t = 4), Kt(e, t, n, r);
          } finally {
            (_t = o), (Vt.transition = a);
          }
        }
        function Kt(e, t, n, r) {
          if (Wt) {
            var o = qt(e, t, n, r);
            if (null === o) Wr(e, t, r, Gt, n), Et(e, r);
            else if (
              (function (e, t, n, r, o) {
                switch (t) {
                  case "focusin":
                    return (Tt = Rt(Tt, e, t, n, r, o)), !0;
                  case "dragenter":
                    return (It = Rt(It, e, t, n, r, o)), !0;
                  case "mouseover":
                    return (Mt = Rt(Mt, e, t, n, r, o)), !0;
                  case "pointerover":
                    var a = o.pointerId;
                    return jt.set(a, Rt(jt.get(a) || null, e, t, n, r, o)), !0;
                  case "gotpointercapture":
                    return (
                      (a = o.pointerId),
                      Nt.set(a, Rt(Nt.get(a) || null, e, t, n, r, o)),
                      !0
                    );
                }
                return !1;
              })(o, e, t, n, r)
            )
              r.stopPropagation();
            else if ((Et(e, r), 4 & t && -1 < At.indexOf(e))) {
              for (; null !== o; ) {
                var a = yo(o);
                if (
                  (null !== a && Ct(a),
                  null === (a = qt(e, t, n, r)) && Wr(e, t, r, Gt, n),
                  a === o)
                )
                  break;
                o = a;
              }
              null !== o && r.stopPropagation();
            } else Wr(e, t, r, null, n);
          }
        }
        var Gt = null;
        function qt(e, t, n, r) {
          if (((Gt = null), null !== (e = _o((e = Ce(r))))))
            if (null === (t = He(e))) e = null;
            else if (13 === (n = t.tag)) {
              if (null !== (e = Ve(t))) return e;
              e = null;
            } else if (3 === n) {
              if (t.stateNode.current.memoizedState.isDehydrated)
                return 3 === t.tag ? t.stateNode.containerInfo : null;
              e = null;
            } else t !== e && (e = null);
          return (Gt = e), null;
        }
        function Qt(e) {
          switch (e) {
            case "cancel":
            case "click":
            case "close":
            case "contextmenu":
            case "copy":
            case "cut":
            case "auxclick":
            case "dblclick":
            case "dragend":
            case "dragstart":
            case "drop":
            case "focusin":
            case "focusout":
            case "input":
            case "invalid":
            case "keydown":
            case "keypress":
            case "keyup":
            case "mousedown":
            case "mouseup":
            case "paste":
            case "pause":
            case "play":
            case "pointercancel":
            case "pointerdown":
            case "pointerup":
            case "ratechange":
            case "reset":
            case "resize":
            case "seeked":
            case "submit":
            case "touchcancel":
            case "touchend":
            case "touchstart":
            case "volumechange":
            case "change":
            case "selectionchange":
            case "textInput":
            case "compositionstart":
            case "compositionend":
            case "compositionupdate":
            case "beforeblur":
            case "afterblur":
            case "beforeinput":
            case "blur":
            case "fullscreenchange":
            case "focus":
            case "hashchange":
            case "popstate":
            case "select":
            case "selectstart":
              return 1;
            case "drag":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "mousemove":
            case "mouseout":
            case "mouseover":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "scroll":
            case "toggle":
            case "touchmove":
            case "wheel":
            case "mouseenter":
            case "mouseleave":
            case "pointerenter":
            case "pointerleave":
              return 4;
            case "message":
              switch (Je()) {
                case Xe:
                  return 1;
                case et:
                  return 4;
                case tt:
                case nt:
                  return 16;
                case rt:
                  return 536870912;
                default:
                  return 16;
              }
            default:
              return 16;
          }
        }
        var Yt = null,
          Jt = null,
          Xt = null;
        function en() {
          if (Xt) return Xt;
          var e,
            t,
            n = Jt,
            r = n.length,
            o = "value" in Yt ? Yt.value : Yt.textContent,
            a = o.length;
          for (e = 0; e < r && n[e] === o[e]; e++);
          var i = r - e;
          for (t = 1; t <= i && n[r - t] === o[a - t]; t++);
          return (Xt = o.slice(e, 1 < t ? 1 - t : void 0));
        }
        function tn(e) {
          var t = e.keyCode;
          return (
            "charCode" in e
              ? 0 === (e = e.charCode) && 13 === t && (e = 13)
              : (e = t),
            10 === e && (e = 13),
            32 <= e || 13 === e ? e : 0
          );
        }
        function nn() {
          return !0;
        }
        function rn() {
          return !1;
        }
        function on(e) {
          function t(t, n, r, o, a) {
            for (var i in ((this._reactName = t),
            (this._targetInst = r),
            (this.type = n),
            (this.nativeEvent = o),
            (this.target = a),
            (this.currentTarget = null),
            e))
              e.hasOwnProperty(i) && ((t = e[i]), (this[i] = t ? t(o) : o[i]));
            return (
              (this.isDefaultPrevented = (
                null != o.defaultPrevented
                  ? o.defaultPrevented
                  : !1 === o.returnValue
              )
                ? nn
                : rn),
              (this.isPropagationStopped = rn),
              this
            );
          }
          return (
            L(t.prototype, {
              preventDefault: function () {
                this.defaultPrevented = !0;
                var e = this.nativeEvent;
                e &&
                  (e.preventDefault
                    ? e.preventDefault()
                    : "unknown" != typeof e.returnValue && (e.returnValue = !1),
                  (this.isDefaultPrevented = nn));
              },
              stopPropagation: function () {
                var e = this.nativeEvent;
                e &&
                  (e.stopPropagation
                    ? e.stopPropagation()
                    : "unknown" != typeof e.cancelBubble &&
                      (e.cancelBubble = !0),
                  (this.isPropagationStopped = nn));
              },
              persist: function () {},
              isPersistent: nn,
            }),
            t
          );
        }
        var an,
          sn,
          ln,
          dn = {
            eventPhase: 0,
            bubbles: 0,
            cancelable: 0,
            timeStamp: function (e) {
              return e.timeStamp || Date.now();
            },
            defaultPrevented: 0,
            isTrusted: 0,
          },
          cn = on(dn),
          un = L({}, dn, { view: 0, detail: 0 }),
          pn = on(un),
          mn = L({}, un, {
            screenX: 0,
            screenY: 0,
            clientX: 0,
            clientY: 0,
            pageX: 0,
            pageY: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            getModifierState: Pn,
            button: 0,
            buttons: 0,
            relatedTarget: function (e) {
              return void 0 === e.relatedTarget
                ? e.fromElement === e.srcElement
                  ? e.toElement
                  : e.fromElement
                : e.relatedTarget;
            },
            movementX: function (e) {
              return "movementX" in e
                ? e.movementX
                : (e !== ln &&
                    (ln && "mousemove" === e.type
                      ? ((an = e.screenX - ln.screenX),
                        (sn = e.screenY - ln.screenY))
                      : (sn = an = 0),
                    (ln = e)),
                  an);
            },
            movementY: function (e) {
              return "movementY" in e ? e.movementY : sn;
            },
          }),
          hn = on(mn),
          fn = on(L({}, mn, { dataTransfer: 0 })),
          gn = on(L({}, un, { relatedTarget: 0 })),
          vn = on(
            L({}, dn, { animationName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          bn = L({}, dn, {
            clipboardData: function (e) {
              return "clipboardData" in e
                ? e.clipboardData
                : window.clipboardData;
            },
          }),
          _n = on(bn),
          yn = on(L({}, dn, { data: 0 })),
          Cn = {
            Esc: "Escape",
            Spacebar: " ",
            Left: "ArrowLeft",
            Up: "ArrowUp",
            Right: "ArrowRight",
            Down: "ArrowDown",
            Del: "Delete",
            Win: "OS",
            Menu: "ContextMenu",
            Apps: "ContextMenu",
            Scroll: "ScrollLock",
            MozPrintableKey: "Unidentified",
          },
          xn = {
            8: "Backspace",
            9: "Tab",
            12: "Clear",
            13: "Enter",
            16: "Shift",
            17: "Control",
            18: "Alt",
            19: "Pause",
            20: "CapsLock",
            27: "Escape",
            32: " ",
            33: "PageUp",
            34: "PageDown",
            35: "End",
            36: "Home",
            37: "ArrowLeft",
            38: "ArrowUp",
            39: "ArrowRight",
            40: "ArrowDown",
            45: "Insert",
            46: "Delete",
            112: "F1",
            113: "F2",
            114: "F3",
            115: "F4",
            116: "F5",
            117: "F6",
            118: "F7",
            119: "F8",
            120: "F9",
            121: "F10",
            122: "F11",
            123: "F12",
            144: "NumLock",
            145: "ScrollLock",
            224: "Meta",
          },
          Sn = {
            Alt: "altKey",
            Control: "ctrlKey",
            Meta: "metaKey",
            Shift: "shiftKey",
          };
        function kn(e) {
          var t = this.nativeEvent;
          return t.getModifierState
            ? t.getModifierState(e)
            : !!(e = Sn[e]) && !!t[e];
        }
        function Pn() {
          return kn;
        }
        var wn = L({}, un, {
            key: function (e) {
              if (e.key) {
                var t = Cn[e.key] || e.key;
                if ("Unidentified" !== t) return t;
              }
              return "keypress" === e.type
                ? 13 === (e = tn(e))
                  ? "Enter"
                  : String.fromCharCode(e)
                : "keydown" === e.type || "keyup" === e.type
                ? xn[e.keyCode] || "Unidentified"
                : "";
            },
            code: 0,
            location: 0,
            ctrlKey: 0,
            shiftKey: 0,
            altKey: 0,
            metaKey: 0,
            repeat: 0,
            locale: 0,
            getModifierState: Pn,
            charCode: function (e) {
              return "keypress" === e.type ? tn(e) : 0;
            },
            keyCode: function (e) {
              return "keydown" === e.type || "keyup" === e.type ? e.keyCode : 0;
            },
            which: function (e) {
              return "keypress" === e.type
                ? tn(e)
                : "keydown" === e.type || "keyup" === e.type
                ? e.keyCode
                : 0;
            },
          }),
          On = on(wn),
          Tn = on(
            L({}, mn, {
              pointerId: 0,
              width: 0,
              height: 0,
              pressure: 0,
              tangentialPressure: 0,
              tiltX: 0,
              tiltY: 0,
              twist: 0,
              pointerType: 0,
              isPrimary: 0,
            })
          ),
          In = on(
            L({}, un, {
              touches: 0,
              targetTouches: 0,
              changedTouches: 0,
              altKey: 0,
              metaKey: 0,
              ctrlKey: 0,
              shiftKey: 0,
              getModifierState: Pn,
            })
          ),
          Mn = on(
            L({}, dn, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 })
          ),
          jn = L({}, mn, {
            deltaX: function (e) {
              return "deltaX" in e
                ? e.deltaX
                : "wheelDeltaX" in e
                ? -e.wheelDeltaX
                : 0;
            },
            deltaY: function (e) {
              return "deltaY" in e
                ? e.deltaY
                : "wheelDeltaY" in e
                ? -e.wheelDeltaY
                : "wheelDelta" in e
                ? -e.wheelDelta
                : 0;
            },
            deltaZ: 0,
            deltaMode: 0,
          }),
          Nn = on(jn),
          Dn = [9, 13, 27, 32],
          An = c && "CompositionEvent" in window,
          En = null;
        c && "documentMode" in document && (En = document.documentMode);
        var Rn = c && "TextEvent" in window && !En,
          Ln = c && (!An || (En && 8 < En && 11 >= En)),
          Bn = String.fromCharCode(32),
          zn = !1;
        function Fn(e, t) {
          switch (e) {
            case "keyup":
              return -1 !== Dn.indexOf(t.keyCode);
            case "keydown":
              return 229 !== t.keyCode;
            case "keypress":
            case "mousedown":
            case "focusout":
              return !0;
            default:
              return !1;
          }
        }
        function Zn(e) {
          return "object" == typeof (e = e.detail) && "data" in e
            ? e.data
            : null;
        }
        var Hn = !1,
          Vn = {
            color: !0,
            date: !0,
            datetime: !0,
            "datetime-local": !0,
            email: !0,
            month: !0,
            number: !0,
            password: !0,
            range: !0,
            search: !0,
            tel: !0,
            text: !0,
            time: !0,
            url: !0,
            week: !0,
          };
        function Wn(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return "input" === t ? !!Vn[e.type] : "textarea" === t;
        }
        function Un(e, t, n, r) {
          we(r),
            0 < (t = $r(t, "onChange")).length &&
              ((n = new cn("onChange", "change", null, n, r)),
              e.push({ event: n, listeners: t }));
        }
        var $n = null,
          Kn = null;
        function Gn(e) {
          Br(e, 0);
        }
        function qn(e) {
          if (K(Co(e))) return e;
        }
        function Qn(e, t) {
          if ("change" === e) return t;
        }
        var Yn = !1;
        if (c) {
          var Jn;
          if (c) {
            var Xn = "oninput" in document;
            if (!Xn) {
              var er = document.createElement("div");
              er.setAttribute("oninput", "return;"),
                (Xn = "function" == typeof er.oninput);
            }
            Jn = Xn;
          } else Jn = !1;
          Yn = Jn && (!document.documentMode || 9 < document.documentMode);
        }
        function tr() {
          $n && ($n.detachEvent("onpropertychange", nr), (Kn = $n = null));
        }
        function nr(e) {
          if ("value" === e.propertyName && qn(Kn)) {
            var t = [];
            Un(t, Kn, e, Ce(e)), je(Gn, t);
          }
        }
        function rr(e, t, n) {
          "focusin" === e
            ? (tr(), (Kn = n), ($n = t).attachEvent("onpropertychange", nr))
            : "focusout" === e && tr();
        }
        function or(e) {
          if ("selectionchange" === e || "keyup" === e || "keydown" === e)
            return qn(Kn);
        }
        function ar(e, t) {
          if ("click" === e) return qn(t);
        }
        function ir(e, t) {
          if ("input" === e || "change" === e) return qn(t);
        }
        var sr =
          "function" == typeof Object.is
            ? Object.is
            : function (e, t) {
                return (
                  (e === t && (0 !== e || 1 / e == 1 / t)) || (e != e && t != t)
                );
              };
        function lr(e, t) {
          if (sr(e, t)) return !0;
          if (
            "object" != typeof e ||
            null === e ||
            "object" != typeof t ||
            null === t
          )
            return !1;
          var n = Object.keys(e),
            r = Object.keys(t);
          if (n.length !== r.length) return !1;
          for (r = 0; r < n.length; r++) {
            var o = n[r];
            if (!u.call(t, o) || !sr(e[o], t[o])) return !1;
          }
          return !0;
        }
        function dr(e) {
          for (; e && e.firstChild; ) e = e.firstChild;
          return e;
        }
        function cr(e, t) {
          var n,
            r = dr(e);
          for (e = 0; r; ) {
            if (3 === r.nodeType) {
              if (((n = e + r.textContent.length), e <= t && n >= t))
                return { node: r, offset: t - e };
              e = n;
            }
            e: {
              for (; r; ) {
                if (r.nextSibling) {
                  r = r.nextSibling;
                  break e;
                }
                r = r.parentNode;
              }
              r = void 0;
            }
            r = dr(r);
          }
        }
        function ur(e, t) {
          return (
            !(!e || !t) &&
            (e === t ||
              ((!e || 3 !== e.nodeType) &&
                (t && 3 === t.nodeType
                  ? ur(e, t.parentNode)
                  : "contains" in e
                  ? e.contains(t)
                  : !!e.compareDocumentPosition &&
                    !!(16 & e.compareDocumentPosition(t)))))
          );
        }
        function pr() {
          for (var e = window, t = G(); t instanceof e.HTMLIFrameElement; ) {
            try {
              var n = "string" == typeof t.contentWindow.location.href;
            } catch (e) {
              n = !1;
            }
            if (!n) break;
            t = G((e = t.contentWindow).document);
          }
          return t;
        }
        function mr(e) {
          var t = e && e.nodeName && e.nodeName.toLowerCase();
          return (
            t &&
            (("input" === t &&
              ("text" === e.type ||
                "search" === e.type ||
                "tel" === e.type ||
                "url" === e.type ||
                "password" === e.type)) ||
              "textarea" === t ||
              "true" === e.contentEditable)
          );
        }
        function hr(e) {
          var t = pr(),
            n = e.focusedElem,
            r = e.selectionRange;
          if (
            t !== n &&
            n &&
            n.ownerDocument &&
            ur(n.ownerDocument.documentElement, n)
          ) {
            if (null !== r && mr(n))
              if (
                ((t = r.start),
                void 0 === (e = r.end) && (e = t),
                "selectionStart" in n)
              )
                (n.selectionStart = t),
                  (n.selectionEnd = Math.min(e, n.value.length));
              else if (
                (e =
                  ((t = n.ownerDocument || document) && t.defaultView) ||
                  window).getSelection
              ) {
                e = e.getSelection();
                var o = n.textContent.length,
                  a = Math.min(r.start, o);
                (r = void 0 === r.end ? a : Math.min(r.end, o)),
                  !e.extend && a > r && ((o = r), (r = a), (a = o)),
                  (o = cr(n, a));
                var i = cr(n, r);
                o &&
                  i &&
                  (1 !== e.rangeCount ||
                    e.anchorNode !== o.node ||
                    e.anchorOffset !== o.offset ||
                    e.focusNode !== i.node ||
                    e.focusOffset !== i.offset) &&
                  ((t = t.createRange()).setStart(o.node, o.offset),
                  e.removeAllRanges(),
                  a > r
                    ? (e.addRange(t), e.extend(i.node, i.offset))
                    : (t.setEnd(i.node, i.offset), e.addRange(t)));
              }
            for (t = [], e = n; (e = e.parentNode); )
              1 === e.nodeType &&
                t.push({ element: e, left: e.scrollLeft, top: e.scrollTop });
            for (
              "function" == typeof n.focus && n.focus(), n = 0;
              n < t.length;
              n++
            )
              ((e = t[n]).element.scrollLeft = e.left),
                (e.element.scrollTop = e.top);
          }
        }
        var fr = c && "documentMode" in document && 11 >= document.documentMode,
          gr = null,
          vr = null,
          br = null,
          _r = !1;
        function yr(e, t, n) {
          var r =
            n.window === n
              ? n.document
              : 9 === n.nodeType
              ? n
              : n.ownerDocument;
          _r ||
            null == gr ||
            gr !== G(r) ||
            ((r =
              "selectionStart" in (r = gr) && mr(r)
                ? { start: r.selectionStart, end: r.selectionEnd }
                : {
                    anchorNode: (r = (
                      (r.ownerDocument && r.ownerDocument.defaultView) ||
                      window
                    ).getSelection()).anchorNode,
                    anchorOffset: r.anchorOffset,
                    focusNode: r.focusNode,
                    focusOffset: r.focusOffset,
                  }),
            (br && lr(br, r)) ||
              ((br = r),
              0 < (r = $r(vr, "onSelect")).length &&
                ((t = new cn("onSelect", "select", null, t, n)),
                e.push({ event: t, listeners: r }),
                (t.target = gr))));
        }
        function Cr(e, t) {
          var n = {};
          return (
            (n[e.toLowerCase()] = t.toLowerCase()),
            (n["Webkit" + e] = "webkit" + t),
            (n["Moz" + e] = "moz" + t),
            n
          );
        }
        var xr = {
            animationend: Cr("Animation", "AnimationEnd"),
            animationiteration: Cr("Animation", "AnimationIteration"),
            animationstart: Cr("Animation", "AnimationStart"),
            transitionend: Cr("Transition", "TransitionEnd"),
          },
          Sr = {},
          kr = {};
        function Pr(e) {
          if (Sr[e]) return Sr[e];
          if (!xr[e]) return e;
          var t,
            n = xr[e];
          for (t in n)
            if (n.hasOwnProperty(t) && t in kr) return (Sr[e] = n[t]);
          return e;
        }
        c &&
          ((kr = document.createElement("div").style),
          "AnimationEvent" in window ||
            (delete xr.animationend.animation,
            delete xr.animationiteration.animation,
            delete xr.animationstart.animation),
          "TransitionEvent" in window || delete xr.transitionend.transition);
        var wr = Pr("animationend"),
          Or = Pr("animationiteration"),
          Tr = Pr("animationstart"),
          Ir = Pr("transitionend"),
          Mr = new Map(),
          jr =
            "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
              " "
            );
        function Nr(e, t) {
          Mr.set(e, t), l(t, [e]);
        }
        for (var Dr = 0; Dr < jr.length; Dr++) {
          var Ar = jr[Dr];
          Nr(Ar.toLowerCase(), "on" + (Ar[0].toUpperCase() + Ar.slice(1)));
        }
        Nr(wr, "onAnimationEnd"),
          Nr(Or, "onAnimationIteration"),
          Nr(Tr, "onAnimationStart"),
          Nr("dblclick", "onDoubleClick"),
          Nr("focusin", "onFocus"),
          Nr("focusout", "onBlur"),
          Nr(Ir, "onTransitionEnd"),
          d("onMouseEnter", ["mouseout", "mouseover"]),
          d("onMouseLeave", ["mouseout", "mouseover"]),
          d("onPointerEnter", ["pointerout", "pointerover"]),
          d("onPointerLeave", ["pointerout", "pointerover"]),
          l(
            "onChange",
            "change click focusin focusout input keydown keyup selectionchange".split(
              " "
            )
          ),
          l(
            "onSelect",
            "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
              " "
            )
          ),
          l("onBeforeInput", [
            "compositionend",
            "keypress",
            "textInput",
            "paste",
          ]),
          l(
            "onCompositionEnd",
            "compositionend focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          l(
            "onCompositionStart",
            "compositionstart focusout keydown keypress keyup mousedown".split(
              " "
            )
          ),
          l(
            "onCompositionUpdate",
            "compositionupdate focusout keydown keypress keyup mousedown".split(
              " "
            )
          );
        var Er =
            "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
              " "
            ),
          Rr = new Set(
            "cancel close invalid load scroll toggle".split(" ").concat(Er)
          );
        function Lr(e, t, n) {
          var r = e.type || "unknown-event";
          (e.currentTarget = n),
            (function (e, t, n, r, o, i, s, l, d) {
              if ((Ze.apply(this, arguments), Re)) {
                if (!Re) throw Error(a(198));
                var c = Le;
                (Re = !1), (Le = null), Be || ((Be = !0), (ze = c));
              }
            })(r, t, void 0, e),
            (e.currentTarget = null);
        }
        function Br(e, t) {
          t = 0 != (4 & t);
          for (var n = 0; n < e.length; n++) {
            var r = e[n],
              o = r.event;
            r = r.listeners;
            e: {
              var a = void 0;
              if (t)
                for (var i = r.length - 1; 0 <= i; i--) {
                  var s = r[i],
                    l = s.instance,
                    d = s.currentTarget;
                  if (((s = s.listener), l !== a && o.isPropagationStopped()))
                    break e;
                  Lr(o, s, d), (a = l);
                }
              else
                for (i = 0; i < r.length; i++) {
                  if (
                    ((l = (s = r[i]).instance),
                    (d = s.currentTarget),
                    (s = s.listener),
                    l !== a && o.isPropagationStopped())
                  )
                    break e;
                  Lr(o, s, d), (a = l);
                }
            }
          }
          if (Be) throw ((e = ze), (Be = !1), (ze = null), e);
        }
        function zr(e, t) {
          var n = t[go];
          void 0 === n && (n = t[go] = new Set());
          var r = e + "__bubble";
          n.has(r) || (Vr(t, e, 2, !1), n.add(r));
        }
        function Fr(e, t, n) {
          var r = 0;
          t && (r |= 4), Vr(n, e, r, t);
        }
        var Zr = "_reactListening" + Math.random().toString(36).slice(2);
        function Hr(e) {
          if (!e[Zr]) {
            (e[Zr] = !0),
              i.forEach(function (t) {
                "selectionchange" !== t &&
                  (Rr.has(t) || Fr(t, !1, e), Fr(t, !0, e));
              });
            var t = 9 === e.nodeType ? e : e.ownerDocument;
            null === t || t[Zr] || ((t[Zr] = !0), Fr("selectionchange", !1, t));
          }
        }
        function Vr(e, t, n, r) {
          switch (Qt(t)) {
            case 1:
              var o = Ut;
              break;
            case 4:
              o = $t;
              break;
            default:
              o = Kt;
          }
          (n = o.bind(null, t, n, e)),
            (o = void 0),
            !De ||
              ("touchstart" !== t && "touchmove" !== t && "wheel" !== t) ||
              (o = !0),
            r
              ? void 0 !== o
                ? e.addEventListener(t, n, { capture: !0, passive: o })
                : e.addEventListener(t, n, !0)
              : void 0 !== o
              ? e.addEventListener(t, n, { passive: o })
              : e.addEventListener(t, n, !1);
        }
        function Wr(e, t, n, r, o) {
          var a = r;
          if (0 == (1 & t) && 0 == (2 & t) && null !== r)
            e: for (;;) {
              if (null === r) return;
              var i = r.tag;
              if (3 === i || 4 === i) {
                var s = r.stateNode.containerInfo;
                if (s === o || (8 === s.nodeType && s.parentNode === o)) break;
                if (4 === i)
                  for (i = r.return; null !== i; ) {
                    var l = i.tag;
                    if (
                      (3 === l || 4 === l) &&
                      ((l = i.stateNode.containerInfo) === o ||
                        (8 === l.nodeType && l.parentNode === o))
                    )
                      return;
                    i = i.return;
                  }
                for (; null !== s; ) {
                  if (null === (i = _o(s))) return;
                  if (5 === (l = i.tag) || 6 === l) {
                    r = a = i;
                    continue e;
                  }
                  s = s.parentNode;
                }
              }
              r = r.return;
            }
          je(function () {
            var r = a,
              o = Ce(n),
              i = [];
            e: {
              var s = Mr.get(e);
              if (void 0 !== s) {
                var l = cn,
                  d = e;
                switch (e) {
                  case "keypress":
                    if (0 === tn(n)) break e;
                  case "keydown":
                  case "keyup":
                    l = On;
                    break;
                  case "focusin":
                    (d = "focus"), (l = gn);
                    break;
                  case "focusout":
                    (d = "blur"), (l = gn);
                    break;
                  case "beforeblur":
                  case "afterblur":
                    l = gn;
                    break;
                  case "click":
                    if (2 === n.button) break e;
                  case "auxclick":
                  case "dblclick":
                  case "mousedown":
                  case "mousemove":
                  case "mouseup":
                  case "mouseout":
                  case "mouseover":
                  case "contextmenu":
                    l = hn;
                    break;
                  case "drag":
                  case "dragend":
                  case "dragenter":
                  case "dragexit":
                  case "dragleave":
                  case "dragover":
                  case "dragstart":
                  case "drop":
                    l = fn;
                    break;
                  case "touchcancel":
                  case "touchend":
                  case "touchmove":
                  case "touchstart":
                    l = In;
                    break;
                  case wr:
                  case Or:
                  case Tr:
                    l = vn;
                    break;
                  case Ir:
                    l = Mn;
                    break;
                  case "scroll":
                    l = pn;
                    break;
                  case "wheel":
                    l = Nn;
                    break;
                  case "copy":
                  case "cut":
                  case "paste":
                    l = _n;
                    break;
                  case "gotpointercapture":
                  case "lostpointercapture":
                  case "pointercancel":
                  case "pointerdown":
                  case "pointermove":
                  case "pointerout":
                  case "pointerover":
                  case "pointerup":
                    l = Tn;
                }
                var c = 0 != (4 & t),
                  u = !c && "scroll" === e,
                  p = c ? (null !== s ? s + "Capture" : null) : s;
                c = [];
                for (var m, h = r; null !== h; ) {
                  var f = (m = h).stateNode;
                  if (
                    (5 === m.tag &&
                      null !== f &&
                      ((m = f),
                      null !== p &&
                        null != (f = Ne(h, p)) &&
                        c.push(Ur(h, f, m))),
                    u)
                  )
                    break;
                  h = h.return;
                }
                0 < c.length &&
                  ((s = new l(s, d, null, n, o)),
                  i.push({ event: s, listeners: c }));
              }
            }
            if (0 == (7 & t)) {
              if (
                ((l = "mouseout" === e || "pointerout" === e),
                (!(s = "mouseover" === e || "pointerover" === e) ||
                  n === ye ||
                  !(d = n.relatedTarget || n.fromElement) ||
                  (!_o(d) && !d[fo])) &&
                  (l || s) &&
                  ((s =
                    o.window === o
                      ? o
                      : (s = o.ownerDocument)
                      ? s.defaultView || s.parentWindow
                      : window),
                  l
                    ? ((l = r),
                      null !==
                        (d = (d = n.relatedTarget || n.toElement)
                          ? _o(d)
                          : null) &&
                        (d !== (u = He(d)) || (5 !== d.tag && 6 !== d.tag)) &&
                        (d = null))
                    : ((l = null), (d = r)),
                  l !== d))
              ) {
                if (
                  ((c = hn),
                  (f = "onMouseLeave"),
                  (p = "onMouseEnter"),
                  (h = "mouse"),
                  ("pointerout" !== e && "pointerover" !== e) ||
                    ((c = Tn),
                    (f = "onPointerLeave"),
                    (p = "onPointerEnter"),
                    (h = "pointer")),
                  (u = null == l ? s : Co(l)),
                  (m = null == d ? s : Co(d)),
                  ((s = new c(f, h + "leave", l, n, o)).target = u),
                  (s.relatedTarget = m),
                  (f = null),
                  _o(o) === r &&
                    (((c = new c(p, h + "enter", d, n, o)).target = m),
                    (c.relatedTarget = u),
                    (f = c)),
                  (u = f),
                  l && d)
                )
                  e: {
                    for (p = d, h = 0, m = c = l; m; m = Kr(m)) h++;
                    for (m = 0, f = p; f; f = Kr(f)) m++;
                    for (; 0 < h - m; ) (c = Kr(c)), h--;
                    for (; 0 < m - h; ) (p = Kr(p)), m--;
                    for (; h--; ) {
                      if (c === p || (null !== p && c === p.alternate)) break e;
                      (c = Kr(c)), (p = Kr(p));
                    }
                    c = null;
                  }
                else c = null;
                null !== l && Gr(i, s, l, c, !1),
                  null !== d && null !== u && Gr(i, u, d, c, !0);
              }
              if (
                "select" ===
                  (l =
                    (s = r ? Co(r) : window).nodeName &&
                    s.nodeName.toLowerCase()) ||
                ("input" === l && "file" === s.type)
              )
                var g = Qn;
              else if (Wn(s))
                if (Yn) g = ir;
                else {
                  g = or;
                  var v = rr;
                }
              else
                (l = s.nodeName) &&
                  "input" === l.toLowerCase() &&
                  ("checkbox" === s.type || "radio" === s.type) &&
                  (g = ar);
              switch (
                (g && (g = g(e, r))
                  ? Un(i, g, n, o)
                  : (v && v(e, s, r),
                    "focusout" === e &&
                      (v = s._wrapperState) &&
                      v.controlled &&
                      "number" === s.type &&
                      ee(s, "number", s.value)),
                (v = r ? Co(r) : window),
                e)
              ) {
                case "focusin":
                  (Wn(v) || "true" === v.contentEditable) &&
                    ((gr = v), (vr = r), (br = null));
                  break;
                case "focusout":
                  br = vr = gr = null;
                  break;
                case "mousedown":
                  _r = !0;
                  break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                  (_r = !1), yr(i, n, o);
                  break;
                case "selectionchange":
                  if (fr) break;
                case "keydown":
                case "keyup":
                  yr(i, n, o);
              }
              var b;
              if (An)
                e: {
                  switch (e) {
                    case "compositionstart":
                      var _ = "onCompositionStart";
                      break e;
                    case "compositionend":
                      _ = "onCompositionEnd";
                      break e;
                    case "compositionupdate":
                      _ = "onCompositionUpdate";
                      break e;
                  }
                  _ = void 0;
                }
              else
                Hn
                  ? Fn(e, n) && (_ = "onCompositionEnd")
                  : "keydown" === e &&
                    229 === n.keyCode &&
                    (_ = "onCompositionStart");
              _ &&
                (Ln &&
                  "ko" !== n.locale &&
                  (Hn || "onCompositionStart" !== _
                    ? "onCompositionEnd" === _ && Hn && (b = en())
                    : ((Jt = "value" in (Yt = o) ? Yt.value : Yt.textContent),
                      (Hn = !0))),
                0 < (v = $r(r, _)).length &&
                  ((_ = new yn(_, e, null, n, o)),
                  i.push({ event: _, listeners: v }),
                  (b || null !== (b = Zn(n))) && (_.data = b))),
                (b = Rn
                  ? (function (e, t) {
                      switch (e) {
                        case "compositionend":
                          return Zn(t);
                        case "keypress":
                          return 32 !== t.which ? null : ((zn = !0), Bn);
                        case "textInput":
                          return (e = t.data) === Bn && zn ? null : e;
                        default:
                          return null;
                      }
                    })(e, n)
                  : (function (e, t) {
                      if (Hn)
                        return "compositionend" === e || (!An && Fn(e, t))
                          ? ((e = en()), (Xt = Jt = Yt = null), (Hn = !1), e)
                          : null;
                      switch (e) {
                        case "paste":
                        default:
                          return null;
                        case "keypress":
                          if (
                            !(t.ctrlKey || t.altKey || t.metaKey) ||
                            (t.ctrlKey && t.altKey)
                          ) {
                            if (t.char && 1 < t.char.length) return t.char;
                            if (t.which) return String.fromCharCode(t.which);
                          }
                          return null;
                        case "compositionend":
                          return Ln && "ko" !== t.locale ? null : t.data;
                      }
                    })(e, n)) &&
                  0 < (r = $r(r, "onBeforeInput")).length &&
                  ((o = new yn("onBeforeInput", "beforeinput", null, n, o)),
                  i.push({ event: o, listeners: r }),
                  (o.data = b));
            }
            Br(i, t);
          });
        }
        function Ur(e, t, n) {
          return { instance: e, listener: t, currentTarget: n };
        }
        function $r(e, t) {
          for (var n = t + "Capture", r = []; null !== e; ) {
            var o = e,
              a = o.stateNode;
            5 === o.tag &&
              null !== a &&
              ((o = a),
              null != (a = Ne(e, n)) && r.unshift(Ur(e, a, o)),
              null != (a = Ne(e, t)) && r.push(Ur(e, a, o))),
              (e = e.return);
          }
          return r;
        }
        function Kr(e) {
          if (null === e) return null;
          do {
            e = e.return;
          } while (e && 5 !== e.tag);
          return e || null;
        }
        function Gr(e, t, n, r, o) {
          for (var a = t._reactName, i = []; null !== n && n !== r; ) {
            var s = n,
              l = s.alternate,
              d = s.stateNode;
            if (null !== l && l === r) break;
            5 === s.tag &&
              null !== d &&
              ((s = d),
              o
                ? null != (l = Ne(n, a)) && i.unshift(Ur(n, l, s))
                : o || (null != (l = Ne(n, a)) && i.push(Ur(n, l, s)))),
              (n = n.return);
          }
          0 !== i.length && e.push({ event: t, listeners: i });
        }
        var qr = /\r\n?/g,
          Qr = /\u0000|\uFFFD/g;
        function Yr(e) {
          return ("string" == typeof e ? e : "" + e)
            .replace(qr, "\n")
            .replace(Qr, "");
        }
        function Jr(e, t, n) {
          if (((t = Yr(t)), Yr(e) !== t && n)) throw Error(a(425));
        }
        function Xr() {}
        var eo = null,
          to = null;
        function no(e, t) {
          return (
            "textarea" === e ||
            "noscript" === e ||
            "string" == typeof t.children ||
            "number" == typeof t.children ||
            ("object" == typeof t.dangerouslySetInnerHTML &&
              null !== t.dangerouslySetInnerHTML &&
              null != t.dangerouslySetInnerHTML.__html)
          );
        }
        var ro = "function" == typeof setTimeout ? setTimeout : void 0,
          oo = "function" == typeof clearTimeout ? clearTimeout : void 0,
          ao = "function" == typeof Promise ? Promise : void 0,
          io =
            "function" == typeof queueMicrotask
              ? queueMicrotask
              : void 0 !== ao
              ? function (e) {
                  return ao.resolve(null).then(e).catch(so);
                }
              : ro;
        function so(e) {
          setTimeout(function () {
            throw e;
          });
        }
        function lo(e, t) {
          var n = t,
            r = 0;
          do {
            var o = n.nextSibling;
            if ((e.removeChild(n), o && 8 === o.nodeType))
              if ("/$" === (n = o.data)) {
                if (0 === r) return e.removeChild(o), void Ht(t);
                r--;
              } else ("$" !== n && "$?" !== n && "$!" !== n) || r++;
            n = o;
          } while (n);
          Ht(t);
        }
        function co(e) {
          for (; null != e; e = e.nextSibling) {
            var t = e.nodeType;
            if (1 === t || 3 === t) break;
            if (8 === t) {
              if ("$" === (t = e.data) || "$!" === t || "$?" === t) break;
              if ("/$" === t) return null;
            }
          }
          return e;
        }
        function uo(e) {
          e = e.previousSibling;
          for (var t = 0; e; ) {
            if (8 === e.nodeType) {
              var n = e.data;
              if ("$" === n || "$!" === n || "$?" === n) {
                if (0 === t) return e;
                t--;
              } else "/$" === n && t++;
            }
            e = e.previousSibling;
          }
          return null;
        }
        var po = Math.random().toString(36).slice(2),
          mo = "__reactFiber$" + po,
          ho = "__reactProps$" + po,
          fo = "__reactContainer$" + po,
          go = "__reactEvents$" + po,
          vo = "__reactListeners$" + po,
          bo = "__reactHandles$" + po;
        function _o(e) {
          var t = e[mo];
          if (t) return t;
          for (var n = e.parentNode; n; ) {
            if ((t = n[fo] || n[mo])) {
              if (
                ((n = t.alternate),
                null !== t.child || (null !== n && null !== n.child))
              )
                for (e = uo(e); null !== e; ) {
                  if ((n = e[mo])) return n;
                  e = uo(e);
                }
              return t;
            }
            n = (e = n).parentNode;
          }
          return null;
        }
        function yo(e) {
          return !(e = e[mo] || e[fo]) ||
            (5 !== e.tag && 6 !== e.tag && 13 !== e.tag && 3 !== e.tag)
            ? null
            : e;
        }
        function Co(e) {
          if (5 === e.tag || 6 === e.tag) return e.stateNode;
          throw Error(a(33));
        }
        function xo(e) {
          return e[ho] || null;
        }
        var So = [],
          ko = -1;
        function Po(e) {
          return { current: e };
        }
        function wo(e) {
          0 > ko || ((e.current = So[ko]), (So[ko] = null), ko--);
        }
        function Oo(e, t) {
          ko++, (So[ko] = e.current), (e.current = t);
        }
        var To = {},
          Io = Po(To),
          Mo = Po(!1),
          jo = To;
        function No(e, t) {
          var n = e.type.contextTypes;
          if (!n) return To;
          var r = e.stateNode;
          if (r && r.__reactInternalMemoizedUnmaskedChildContext === t)
            return r.__reactInternalMemoizedMaskedChildContext;
          var o,
            a = {};
          for (o in n) a[o] = t[o];
          return (
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                t),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            a
          );
        }
        function Do(e) {
          return null != e.childContextTypes;
        }
        function Ao() {
          wo(Mo), wo(Io);
        }
        function Eo(e, t, n) {
          if (Io.current !== To) throw Error(a(168));
          Oo(Io, t), Oo(Mo, n);
        }
        function Ro(e, t, n) {
          var r = e.stateNode;
          if (
            ((t = t.childContextTypes), "function" != typeof r.getChildContext)
          )
            return n;
          for (var o in (r = r.getChildContext()))
            if (!(o in t)) throw Error(a(108, V(e) || "Unknown", o));
          return L({}, n, r);
        }
        function Lo(e) {
          return (
            (e =
              ((e = e.stateNode) &&
                e.__reactInternalMemoizedMergedChildContext) ||
              To),
            (jo = Io.current),
            Oo(Io, e),
            Oo(Mo, Mo.current),
            !0
          );
        }
        function Bo(e, t, n) {
          var r = e.stateNode;
          if (!r) throw Error(a(169));
          n
            ? ((e = Ro(e, t, jo)),
              (r.__reactInternalMemoizedMergedChildContext = e),
              wo(Mo),
              wo(Io),
              Oo(Io, e))
            : wo(Mo),
            Oo(Mo, n);
        }
        var zo = null,
          Fo = !1,
          Zo = !1;
        function Ho(e) {
          null === zo ? (zo = [e]) : zo.push(e);
        }
        function Vo() {
          if (!Zo && null !== zo) {
            Zo = !0;
            var e = 0,
              t = _t;
            try {
              var n = zo;
              for (_t = 1; e < n.length; e++) {
                var r = n[e];
                do {
                  r = r(!0);
                } while (null !== r);
              }
              (zo = null), (Fo = !1);
            } catch (t) {
              throw (null !== zo && (zo = zo.slice(e + 1)), Ke(Xe, Vo), t);
            } finally {
              (_t = t), (Zo = !1);
            }
          }
          return null;
        }
        var Wo = [],
          Uo = 0,
          $o = null,
          Ko = 0,
          Go = [],
          qo = 0,
          Qo = null,
          Yo = 1,
          Jo = "";
        function Xo(e, t) {
          (Wo[Uo++] = Ko), (Wo[Uo++] = $o), ($o = e), (Ko = t);
        }
        function ea(e, t, n) {
          (Go[qo++] = Yo), (Go[qo++] = Jo), (Go[qo++] = Qo), (Qo = e);
          var r = Yo;
          e = Jo;
          var o = 32 - it(r) - 1;
          (r &= ~(1 << o)), (n += 1);
          var a = 32 - it(t) + o;
          if (30 < a) {
            var i = o - (o % 5);
            (a = (r & ((1 << i) - 1)).toString(32)),
              (r >>= i),
              (o -= i),
              (Yo = (1 << (32 - it(t) + o)) | (n << o) | r),
              (Jo = a + e);
          } else (Yo = (1 << a) | (n << o) | r), (Jo = e);
        }
        function ta(e) {
          null !== e.return && (Xo(e, 1), ea(e, 1, 0));
        }
        function na(e) {
          for (; e === $o; )
            ($o = Wo[--Uo]), (Wo[Uo] = null), (Ko = Wo[--Uo]), (Wo[Uo] = null);
          for (; e === Qo; )
            (Qo = Go[--qo]),
              (Go[qo] = null),
              (Jo = Go[--qo]),
              (Go[qo] = null),
              (Yo = Go[--qo]),
              (Go[qo] = null);
        }
        var ra = null,
          oa = null,
          aa = !1,
          ia = null;
        function sa(e, t) {
          var n = jd(5, null, null, 0);
          (n.elementType = "DELETED"),
            (n.stateNode = t),
            (n.return = e),
            null === (t = e.deletions)
              ? ((e.deletions = [n]), (e.flags |= 16))
              : t.push(n);
        }
        function la(e, t) {
          switch (e.tag) {
            case 5:
              var n = e.type;
              return (
                null !==
                  (t =
                    1 !== t.nodeType ||
                    n.toLowerCase() !== t.nodeName.toLowerCase()
                      ? null
                      : t) &&
                ((e.stateNode = t), (ra = e), (oa = co(t.firstChild)), !0)
              );
            case 6:
              return (
                null !==
                  (t = "" === e.pendingProps || 3 !== t.nodeType ? null : t) &&
                ((e.stateNode = t), (ra = e), (oa = null), !0)
              );
            case 13:
              return (
                null !== (t = 8 !== t.nodeType ? null : t) &&
                ((n = null !== Qo ? { id: Yo, overflow: Jo } : null),
                (e.memoizedState = {
                  dehydrated: t,
                  treeContext: n,
                  retryLane: 1073741824,
                }),
                ((n = jd(18, null, null, 0)).stateNode = t),
                (n.return = e),
                (e.child = n),
                (ra = e),
                (oa = null),
                !0)
              );
            default:
              return !1;
          }
        }
        function da(e) {
          return 0 != (1 & e.mode) && 0 == (128 & e.flags);
        }
        function ca(e) {
          if (aa) {
            var t = oa;
            if (t) {
              var n = t;
              if (!la(e, t)) {
                if (da(e)) throw Error(a(418));
                t = co(n.nextSibling);
                var r = ra;
                t && la(e, t)
                  ? sa(r, n)
                  : ((e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e));
              }
            } else {
              if (da(e)) throw Error(a(418));
              (e.flags = (-4097 & e.flags) | 2), (aa = !1), (ra = e);
            }
          }
        }
        function ua(e) {
          for (
            e = e.return;
            null !== e && 5 !== e.tag && 3 !== e.tag && 13 !== e.tag;

          )
            e = e.return;
          ra = e;
        }
        function pa(e) {
          if (e !== ra) return !1;
          if (!aa) return ua(e), (aa = !0), !1;
          var t;
          if (
            ((t = 3 !== e.tag) &&
              !(t = 5 !== e.tag) &&
              (t =
                "head" !== (t = e.type) &&
                "body" !== t &&
                !no(e.type, e.memoizedProps)),
            t && (t = oa))
          ) {
            if (da(e)) throw (ma(), Error(a(418)));
            for (; t; ) sa(e, t), (t = co(t.nextSibling));
          }
          if ((ua(e), 13 === e.tag)) {
            if (!(e = null !== (e = e.memoizedState) ? e.dehydrated : null))
              throw Error(a(317));
            e: {
              for (e = e.nextSibling, t = 0; e; ) {
                if (8 === e.nodeType) {
                  var n = e.data;
                  if ("/$" === n) {
                    if (0 === t) {
                      oa = co(e.nextSibling);
                      break e;
                    }
                    t--;
                  } else ("$" !== n && "$!" !== n && "$?" !== n) || t++;
                }
                e = e.nextSibling;
              }
              oa = null;
            }
          } else oa = ra ? co(e.stateNode.nextSibling) : null;
          return !0;
        }
        function ma() {
          for (var e = oa; e; ) e = co(e.nextSibling);
        }
        function ha() {
          (oa = ra = null), (aa = !1);
        }
        function fa(e) {
          null === ia ? (ia = [e]) : ia.push(e);
        }
        var ga = y.ReactCurrentBatchConfig;
        function va(e, t, n) {
          if (
            null !== (e = n.ref) &&
            "function" != typeof e &&
            "object" != typeof e
          ) {
            if (n._owner) {
              if ((n = n._owner)) {
                if (1 !== n.tag) throw Error(a(309));
                var r = n.stateNode;
              }
              if (!r) throw Error(a(147, e));
              var o = r,
                i = "" + e;
              return null !== t &&
                null !== t.ref &&
                "function" == typeof t.ref &&
                t.ref._stringRef === i
                ? t.ref
                : ((t = function (e) {
                    var t = o.refs;
                    null === e ? delete t[i] : (t[i] = e);
                  }),
                  (t._stringRef = i),
                  t);
            }
            if ("string" != typeof e) throw Error(a(284));
            if (!n._owner) throw Error(a(290, e));
          }
          return e;
        }
        function ba(e, t) {
          throw (
            ((e = Object.prototype.toString.call(t)),
            Error(
              a(
                31,
                "[object Object]" === e
                  ? "object with keys {" + Object.keys(t).join(", ") + "}"
                  : e
              )
            ))
          );
        }
        function _a(e) {
          return (0, e._init)(e._payload);
        }
        function ya(e) {
          function t(t, n) {
            if (e) {
              var r = t.deletions;
              null === r ? ((t.deletions = [n]), (t.flags |= 16)) : r.push(n);
            }
          }
          function n(n, r) {
            if (!e) return null;
            for (; null !== r; ) t(n, r), (r = r.sibling);
            return null;
          }
          function r(e, t) {
            for (e = new Map(); null !== t; )
              null !== t.key ? e.set(t.key, t) : e.set(t.index, t),
                (t = t.sibling);
            return e;
          }
          function o(e, t) {
            return ((e = Dd(e, t)).index = 0), (e.sibling = null), e;
          }
          function i(t, n, r) {
            return (
              (t.index = r),
              e
                ? null !== (r = t.alternate)
                  ? (r = r.index) < n
                    ? ((t.flags |= 2), n)
                    : r
                  : ((t.flags |= 2), n)
                : ((t.flags |= 1048576), n)
            );
          }
          function s(t) {
            return e && null === t.alternate && (t.flags |= 2), t;
          }
          function l(e, t, n, r) {
            return null === t || 6 !== t.tag
              ? (((t = Ld(n, e.mode, r)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function d(e, t, n, r) {
            var a = n.type;
            return a === S
              ? u(e, t, n.props.children, r, n.key)
              : null !== t &&
                (t.elementType === a ||
                  ("object" == typeof a &&
                    null !== a &&
                    a.$$typeof === N &&
                    _a(a) === t.type))
              ? (((r = o(t, n.props)).ref = va(e, t, n)), (r.return = e), r)
              : (((r = Ad(n.type, n.key, n.props, null, e.mode, r)).ref = va(
                  e,
                  t,
                  n
                )),
                (r.return = e),
                r);
          }
          function c(e, t, n, r) {
            return null === t ||
              4 !== t.tag ||
              t.stateNode.containerInfo !== n.containerInfo ||
              t.stateNode.implementation !== n.implementation
              ? (((t = Bd(n, e.mode, r)).return = e), t)
              : (((t = o(t, n.children || [])).return = e), t);
          }
          function u(e, t, n, r, a) {
            return null === t || 7 !== t.tag
              ? (((t = Ed(n, e.mode, r, a)).return = e), t)
              : (((t = o(t, n)).return = e), t);
          }
          function p(e, t, n) {
            if (("string" == typeof t && "" !== t) || "number" == typeof t)
              return ((t = Ld("" + t, e.mode, n)).return = e), t;
            if ("object" == typeof t && null !== t) {
              switch (t.$$typeof) {
                case C:
                  return (
                    ((n = Ad(t.type, t.key, t.props, null, e.mode, n)).ref = va(
                      e,
                      null,
                      t
                    )),
                    (n.return = e),
                    n
                  );
                case x:
                  return ((t = Bd(t, e.mode, n)).return = e), t;
                case N:
                  return p(e, (0, t._init)(t._payload), n);
              }
              if (te(t) || E(t))
                return ((t = Ed(t, e.mode, n, null)).return = e), t;
              ba(e, t);
            }
            return null;
          }
          function m(e, t, n, r) {
            var o = null !== t ? t.key : null;
            if (("string" == typeof n && "" !== n) || "number" == typeof n)
              return null !== o ? null : l(e, t, "" + n, r);
            if ("object" == typeof n && null !== n) {
              switch (n.$$typeof) {
                case C:
                  return n.key === o ? d(e, t, n, r) : null;
                case x:
                  return n.key === o ? c(e, t, n, r) : null;
                case N:
                  return m(e, t, (o = n._init)(n._payload), r);
              }
              if (te(n) || E(n)) return null !== o ? null : u(e, t, n, r, null);
              ba(e, n);
            }
            return null;
          }
          function h(e, t, n, r, o) {
            if (("string" == typeof r && "" !== r) || "number" == typeof r)
              return l(t, (e = e.get(n) || null), "" + r, o);
            if ("object" == typeof r && null !== r) {
              switch (r.$$typeof) {
                case C:
                  return d(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case x:
                  return c(
                    t,
                    (e = e.get(null === r.key ? n : r.key) || null),
                    r,
                    o
                  );
                case N:
                  return h(e, t, n, (0, r._init)(r._payload), o);
              }
              if (te(r) || E(r))
                return u(t, (e = e.get(n) || null), r, o, null);
              ba(t, r);
            }
            return null;
          }
          function f(o, a, s, l) {
            for (
              var d = null, c = null, u = a, f = (a = 0), g = null;
              null !== u && f < s.length;
              f++
            ) {
              u.index > f ? ((g = u), (u = null)) : (g = u.sibling);
              var v = m(o, u, s[f], l);
              if (null === v) {
                null === u && (u = g);
                break;
              }
              e && u && null === v.alternate && t(o, u),
                (a = i(v, a, f)),
                null === c ? (d = v) : (c.sibling = v),
                (c = v),
                (u = g);
            }
            if (f === s.length) return n(o, u), aa && Xo(o, f), d;
            if (null === u) {
              for (; f < s.length; f++)
                null !== (u = p(o, s[f], l)) &&
                  ((a = i(u, a, f)),
                  null === c ? (d = u) : (c.sibling = u),
                  (c = u));
              return aa && Xo(o, f), d;
            }
            for (u = r(o, u); f < s.length; f++)
              null !== (g = h(u, o, f, s[f], l)) &&
                (e &&
                  null !== g.alternate &&
                  u.delete(null === g.key ? f : g.key),
                (a = i(g, a, f)),
                null === c ? (d = g) : (c.sibling = g),
                (c = g));
            return (
              e &&
                u.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Xo(o, f),
              d
            );
          }
          function g(o, s, l, d) {
            var c = E(l);
            if ("function" != typeof c) throw Error(a(150));
            if (null == (l = c.call(l))) throw Error(a(151));
            for (
              var u = (c = null), f = s, g = (s = 0), v = null, b = l.next();
              null !== f && !b.done;
              g++, b = l.next()
            ) {
              f.index > g ? ((v = f), (f = null)) : (v = f.sibling);
              var _ = m(o, f, b.value, d);
              if (null === _) {
                null === f && (f = v);
                break;
              }
              e && f && null === _.alternate && t(o, f),
                (s = i(_, s, g)),
                null === u ? (c = _) : (u.sibling = _),
                (u = _),
                (f = v);
            }
            if (b.done) return n(o, f), aa && Xo(o, g), c;
            if (null === f) {
              for (; !b.done; g++, b = l.next())
                null !== (b = p(o, b.value, d)) &&
                  ((s = i(b, s, g)),
                  null === u ? (c = b) : (u.sibling = b),
                  (u = b));
              return aa && Xo(o, g), c;
            }
            for (f = r(o, f); !b.done; g++, b = l.next())
              null !== (b = h(f, o, g, b.value, d)) &&
                (e &&
                  null !== b.alternate &&
                  f.delete(null === b.key ? g : b.key),
                (s = i(b, s, g)),
                null === u ? (c = b) : (u.sibling = b),
                (u = b));
            return (
              e &&
                f.forEach(function (e) {
                  return t(o, e);
                }),
              aa && Xo(o, g),
              c
            );
          }
          return function e(r, a, i, l) {
            if (
              ("object" == typeof i &&
                null !== i &&
                i.type === S &&
                null === i.key &&
                (i = i.props.children),
              "object" == typeof i && null !== i)
            ) {
              switch (i.$$typeof) {
                case C:
                  e: {
                    for (var d = i.key, c = a; null !== c; ) {
                      if (c.key === d) {
                        if ((d = i.type) === S) {
                          if (7 === c.tag) {
                            n(r, c.sibling),
                              ((a = o(c, i.props.children)).return = r),
                              (r = a);
                            break e;
                          }
                        } else if (
                          c.elementType === d ||
                          ("object" == typeof d &&
                            null !== d &&
                            d.$$typeof === N &&
                            _a(d) === c.type)
                        ) {
                          n(r, c.sibling),
                            ((a = o(c, i.props)).ref = va(r, c, i)),
                            (a.return = r),
                            (r = a);
                          break e;
                        }
                        n(r, c);
                        break;
                      }
                      t(r, c), (c = c.sibling);
                    }
                    i.type === S
                      ? (((a = Ed(i.props.children, r.mode, l, i.key)).return =
                          r),
                        (r = a))
                      : (((l = Ad(
                          i.type,
                          i.key,
                          i.props,
                          null,
                          r.mode,
                          l
                        )).ref = va(r, a, i)),
                        (l.return = r),
                        (r = l));
                  }
                  return s(r);
                case x:
                  e: {
                    for (c = i.key; null !== a; ) {
                      if (a.key === c) {
                        if (
                          4 === a.tag &&
                          a.stateNode.containerInfo === i.containerInfo &&
                          a.stateNode.implementation === i.implementation
                        ) {
                          n(r, a.sibling),
                            ((a = o(a, i.children || [])).return = r),
                            (r = a);
                          break e;
                        }
                        n(r, a);
                        break;
                      }
                      t(r, a), (a = a.sibling);
                    }
                    ((a = Bd(i, r.mode, l)).return = r), (r = a);
                  }
                  return s(r);
                case N:
                  return e(r, a, (c = i._init)(i._payload), l);
              }
              if (te(i)) return f(r, a, i, l);
              if (E(i)) return g(r, a, i, l);
              ba(r, i);
            }
            return ("string" == typeof i && "" !== i) || "number" == typeof i
              ? ((i = "" + i),
                null !== a && 6 === a.tag
                  ? (n(r, a.sibling), ((a = o(a, i)).return = r), (r = a))
                  : (n(r, a), ((a = Ld(i, r.mode, l)).return = r), (r = a)),
                s(r))
              : n(r, a);
          };
        }
        var Ca = ya(!0),
          xa = ya(!1),
          Sa = Po(null),
          ka = null,
          Pa = null,
          wa = null;
        function Oa() {
          wa = Pa = ka = null;
        }
        function Ta(e) {
          var t = Sa.current;
          wo(Sa), (e._currentValue = t);
        }
        function Ia(e, t, n) {
          for (; null !== e; ) {
            var r = e.alternate;
            if (
              ((e.childLanes & t) !== t
                ? ((e.childLanes |= t), null !== r && (r.childLanes |= t))
                : null !== r && (r.childLanes & t) !== t && (r.childLanes |= t),
              e === n)
            )
              break;
            e = e.return;
          }
        }
        function Ma(e, t) {
          (ka = e),
            (wa = Pa = null),
            null !== (e = e.dependencies) &&
              null !== e.firstContext &&
              (0 != (e.lanes & t) && (_s = !0), (e.firstContext = null));
        }
        function ja(e) {
          var t = e._currentValue;
          if (wa !== e)
            if (
              ((e = { context: e, memoizedValue: t, next: null }), null === Pa)
            ) {
              if (null === ka) throw Error(a(308));
              (Pa = e), (ka.dependencies = { lanes: 0, firstContext: e });
            } else Pa = Pa.next = e;
          return t;
        }
        var Na = null;
        function Da(e) {
          null === Na ? (Na = [e]) : Na.push(e);
        }
        function Aa(e, t, n, r) {
          var o = t.interleaved;
          return (
            null === o
              ? ((n.next = n), Da(t))
              : ((n.next = o.next), (o.next = n)),
            (t.interleaved = n),
            Ea(e, r)
          );
        }
        function Ea(e, t) {
          e.lanes |= t;
          var n = e.alternate;
          for (null !== n && (n.lanes |= t), n = e, e = e.return; null !== e; )
            (e.childLanes |= t),
              null !== (n = e.alternate) && (n.childLanes |= t),
              (n = e),
              (e = e.return);
          return 3 === n.tag ? n.stateNode : null;
        }
        var Ra = !1;
        function La(e) {
          e.updateQueue = {
            baseState: e.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: { pending: null, interleaved: null, lanes: 0 },
            effects: null,
          };
        }
        function Ba(e, t) {
          (e = e.updateQueue),
            t.updateQueue === e &&
              (t.updateQueue = {
                baseState: e.baseState,
                firstBaseUpdate: e.firstBaseUpdate,
                lastBaseUpdate: e.lastBaseUpdate,
                shared: e.shared,
                effects: e.effects,
              });
        }
        function za(e, t) {
          return {
            eventTime: e,
            lane: t,
            tag: 0,
            payload: null,
            callback: null,
            next: null,
          };
        }
        function Fa(e, t, n) {
          var r = e.updateQueue;
          if (null === r) return null;
          if (((r = r.shared), 0 != (2 & Tl))) {
            var o = r.pending;
            return (
              null === o ? (t.next = t) : ((t.next = o.next), (o.next = t)),
              (r.pending = t),
              Ea(e, n)
            );
          }
          return (
            null === (o = r.interleaved)
              ? ((t.next = t), Da(r))
              : ((t.next = o.next), (o.next = t)),
            (r.interleaved = t),
            Ea(e, n)
          );
        }
        function Za(e, t, n) {
          if (
            null !== (t = t.updateQueue) &&
            ((t = t.shared), 0 != (4194240 & n))
          ) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        function Ha(e, t) {
          var n = e.updateQueue,
            r = e.alternate;
          if (null !== r && n === (r = r.updateQueue)) {
            var o = null,
              a = null;
            if (null !== (n = n.firstBaseUpdate)) {
              do {
                var i = {
                  eventTime: n.eventTime,
                  lane: n.lane,
                  tag: n.tag,
                  payload: n.payload,
                  callback: n.callback,
                  next: null,
                };
                null === a ? (o = a = i) : (a = a.next = i), (n = n.next);
              } while (null !== n);
              null === a ? (o = a = t) : (a = a.next = t);
            } else o = a = t;
            return (
              (n = {
                baseState: r.baseState,
                firstBaseUpdate: o,
                lastBaseUpdate: a,
                shared: r.shared,
                effects: r.effects,
              }),
              void (e.updateQueue = n)
            );
          }
          null === (e = n.lastBaseUpdate)
            ? (n.firstBaseUpdate = t)
            : (e.next = t),
            (n.lastBaseUpdate = t);
        }
        function Va(e, t, n, r) {
          var o = e.updateQueue;
          Ra = !1;
          var a = o.firstBaseUpdate,
            i = o.lastBaseUpdate,
            s = o.shared.pending;
          if (null !== s) {
            o.shared.pending = null;
            var l = s,
              d = l.next;
            (l.next = null), null === i ? (a = d) : (i.next = d), (i = l);
            var c = e.alternate;
            null !== c &&
              (s = (c = c.updateQueue).lastBaseUpdate) !== i &&
              (null === s ? (c.firstBaseUpdate = d) : (s.next = d),
              (c.lastBaseUpdate = l));
          }
          if (null !== a) {
            var u = o.baseState;
            for (i = 0, c = d = l = null, s = a; ; ) {
              var p = s.lane,
                m = s.eventTime;
              if ((r & p) === p) {
                null !== c &&
                  (c = c.next =
                    {
                      eventTime: m,
                      lane: 0,
                      tag: s.tag,
                      payload: s.payload,
                      callback: s.callback,
                      next: null,
                    });
                e: {
                  var h = e,
                    f = s;
                  switch (((p = t), (m = n), f.tag)) {
                    case 1:
                      if ("function" == typeof (h = f.payload)) {
                        u = h.call(m, u, p);
                        break e;
                      }
                      u = h;
                      break e;
                    case 3:
                      h.flags = (-65537 & h.flags) | 128;
                    case 0:
                      if (
                        null ==
                        (p =
                          "function" == typeof (h = f.payload)
                            ? h.call(m, u, p)
                            : h)
                      )
                        break e;
                      u = L({}, u, p);
                      break e;
                    case 2:
                      Ra = !0;
                  }
                }
                null !== s.callback &&
                  0 !== s.lane &&
                  ((e.flags |= 64),
                  null === (p = o.effects) ? (o.effects = [s]) : p.push(s));
              } else
                (m = {
                  eventTime: m,
                  lane: p,
                  tag: s.tag,
                  payload: s.payload,
                  callback: s.callback,
                  next: null,
                }),
                  null === c ? ((d = c = m), (l = u)) : (c = c.next = m),
                  (i |= p);
              if (null === (s = s.next)) {
                if (null === (s = o.shared.pending)) break;
                (s = (p = s).next),
                  (p.next = null),
                  (o.lastBaseUpdate = p),
                  (o.shared.pending = null);
              }
            }
            if (
              (null === c && (l = u),
              (o.baseState = l),
              (o.firstBaseUpdate = d),
              (o.lastBaseUpdate = c),
              null !== (t = o.shared.interleaved))
            ) {
              o = t;
              do {
                (i |= o.lane), (o = o.next);
              } while (o !== t);
            } else null === a && (o.shared.lanes = 0);
            (Rl |= i), (e.lanes = i), (e.memoizedState = u);
          }
        }
        function Wa(e, t, n) {
          if (((e = t.effects), (t.effects = null), null !== e))
            for (t = 0; t < e.length; t++) {
              var r = e[t],
                o = r.callback;
              if (null !== o) {
                if (((r.callback = null), (r = n), "function" != typeof o))
                  throw Error(a(191, o));
                o.call(r);
              }
            }
        }
        var Ua = {},
          $a = Po(Ua),
          Ka = Po(Ua),
          Ga = Po(Ua);
        function qa(e) {
          if (e === Ua) throw Error(a(174));
          return e;
        }
        function Qa(e, t) {
          switch ((Oo(Ga, t), Oo(Ka, e), Oo($a, Ua), (e = t.nodeType))) {
            case 9:
            case 11:
              t = (t = t.documentElement) ? t.namespaceURI : le(null, "");
              break;
            default:
              t = le(
                (t = (e = 8 === e ? t.parentNode : t).namespaceURI || null),
                (e = e.tagName)
              );
          }
          wo($a), Oo($a, t);
        }
        function Ya() {
          wo($a), wo(Ka), wo(Ga);
        }
        function Ja(e) {
          qa(Ga.current);
          var t = qa($a.current),
            n = le(t, e.type);
          t !== n && (Oo(Ka, e), Oo($a, n));
        }
        function Xa(e) {
          Ka.current === e && (wo($a), wo(Ka));
        }
        var ei = Po(0);
        function ti(e) {
          for (var t = e; null !== t; ) {
            if (13 === t.tag) {
              var n = t.memoizedState;
              if (
                null !== n &&
                (null === (n = n.dehydrated) ||
                  "$?" === n.data ||
                  "$!" === n.data)
              )
                return t;
            } else if (19 === t.tag && void 0 !== t.memoizedProps.revealOrder) {
              if (0 != (128 & t.flags)) return t;
            } else if (null !== t.child) {
              (t.child.return = t), (t = t.child);
              continue;
            }
            if (t === e) break;
            for (; null === t.sibling; ) {
              if (null === t.return || t.return === e) return null;
              t = t.return;
            }
            (t.sibling.return = t.return), (t = t.sibling);
          }
          return null;
        }
        var ni = [];
        function ri() {
          for (var e = 0; e < ni.length; e++)
            ni[e]._workInProgressVersionPrimary = null;
          ni.length = 0;
        }
        var oi = y.ReactCurrentDispatcher,
          ai = y.ReactCurrentBatchConfig,
          ii = 0,
          si = null,
          li = null,
          di = null,
          ci = !1,
          ui = !1,
          pi = 0,
          mi = 0;
        function hi() {
          throw Error(a(321));
        }
        function fi(e, t) {
          if (null === t) return !1;
          for (var n = 0; n < t.length && n < e.length; n++)
            if (!sr(e[n], t[n])) return !1;
          return !0;
        }
        function gi(e, t, n, r, o, i) {
          if (
            ((ii = i),
            (si = t),
            (t.memoizedState = null),
            (t.updateQueue = null),
            (t.lanes = 0),
            (oi.current = null === e || null === e.memoizedState ? Xi : es),
            (e = n(r, o)),
            ui)
          ) {
            i = 0;
            do {
              if (((ui = !1), (pi = 0), 25 <= i)) throw Error(a(301));
              (i += 1),
                (di = li = null),
                (t.updateQueue = null),
                (oi.current = ts),
                (e = n(r, o));
            } while (ui);
          }
          if (
            ((oi.current = Ji),
            (t = null !== li && null !== li.next),
            (ii = 0),
            (di = li = si = null),
            (ci = !1),
            t)
          )
            throw Error(a(300));
          return e;
        }
        function vi() {
          var e = 0 !== pi;
          return (pi = 0), e;
        }
        function bi() {
          var e = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null,
          };
          return (
            null === di ? (si.memoizedState = di = e) : (di = di.next = e), di
          );
        }
        function _i() {
          if (null === li) {
            var e = si.alternate;
            e = null !== e ? e.memoizedState : null;
          } else e = li.next;
          var t = null === di ? si.memoizedState : di.next;
          if (null !== t) (di = t), (li = e);
          else {
            if (null === e) throw Error(a(310));
            (e = {
              memoizedState: (li = e).memoizedState,
              baseState: li.baseState,
              baseQueue: li.baseQueue,
              queue: li.queue,
              next: null,
            }),
              null === di ? (si.memoizedState = di = e) : (di = di.next = e);
          }
          return di;
        }
        function yi(e, t) {
          return "function" == typeof t ? t(e) : t;
        }
        function Ci(e) {
          var t = _i(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = li,
            o = r.baseQueue,
            i = n.pending;
          if (null !== i) {
            if (null !== o) {
              var s = o.next;
              (o.next = i.next), (i.next = s);
            }
            (r.baseQueue = o = i), (n.pending = null);
          }
          if (null !== o) {
            (i = o.next), (r = r.baseState);
            var l = (s = null),
              d = null,
              c = i;
            do {
              var u = c.lane;
              if ((ii & u) === u)
                null !== d &&
                  (d = d.next =
                    {
                      lane: 0,
                      action: c.action,
                      hasEagerState: c.hasEagerState,
                      eagerState: c.eagerState,
                      next: null,
                    }),
                  (r = c.hasEagerState ? c.eagerState : e(r, c.action));
              else {
                var p = {
                  lane: u,
                  action: c.action,
                  hasEagerState: c.hasEagerState,
                  eagerState: c.eagerState,
                  next: null,
                };
                null === d ? ((l = d = p), (s = r)) : (d = d.next = p),
                  (si.lanes |= u),
                  (Rl |= u);
              }
              c = c.next;
            } while (null !== c && c !== i);
            null === d ? (s = r) : (d.next = l),
              sr(r, t.memoizedState) || (_s = !0),
              (t.memoizedState = r),
              (t.baseState = s),
              (t.baseQueue = d),
              (n.lastRenderedState = r);
          }
          if (null !== (e = n.interleaved)) {
            o = e;
            do {
              (i = o.lane), (si.lanes |= i), (Rl |= i), (o = o.next);
            } while (o !== e);
          } else null === o && (n.lanes = 0);
          return [t.memoizedState, n.dispatch];
        }
        function xi(e) {
          var t = _i(),
            n = t.queue;
          if (null === n) throw Error(a(311));
          n.lastRenderedReducer = e;
          var r = n.dispatch,
            o = n.pending,
            i = t.memoizedState;
          if (null !== o) {
            n.pending = null;
            var s = (o = o.next);
            do {
              (i = e(i, s.action)), (s = s.next);
            } while (s !== o);
            sr(i, t.memoizedState) || (_s = !0),
              (t.memoizedState = i),
              null === t.baseQueue && (t.baseState = i),
              (n.lastRenderedState = i);
          }
          return [i, r];
        }
        function Si() {}
        function ki(e, t) {
          var n = si,
            r = _i(),
            o = t(),
            i = !sr(r.memoizedState, o);
          if (
            (i && ((r.memoizedState = o), (_s = !0)),
            (r = r.queue),
            Ri(Oi.bind(null, n, r, e), [e]),
            r.getSnapshot !== t ||
              i ||
              (null !== di && 1 & di.memoizedState.tag))
          ) {
            if (
              ((n.flags |= 2048),
              ji(9, wi.bind(null, n, r, o, t), void 0, null),
              null === Il)
            )
              throw Error(a(349));
            0 != (30 & ii) || Pi(n, t, o);
          }
          return o;
        }
        function Pi(e, t, n) {
          (e.flags |= 16384),
            (e = { getSnapshot: t, value: n }),
            null === (t = si.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (si.updateQueue = t),
                (t.stores = [e]))
              : null === (n = t.stores)
              ? (t.stores = [e])
              : n.push(e);
        }
        function wi(e, t, n, r) {
          (t.value = n), (t.getSnapshot = r), Ti(t) && Ii(e);
        }
        function Oi(e, t, n) {
          return n(function () {
            Ti(t) && Ii(e);
          });
        }
        function Ti(e) {
          var t = e.getSnapshot;
          e = e.value;
          try {
            var n = t();
            return !sr(e, n);
          } catch (e) {
            return !0;
          }
        }
        function Ii(e) {
          var t = Ea(e, 1);
          null !== t && nd(t, e, 1, -1);
        }
        function Mi(e) {
          var t = bi();
          return (
            "function" == typeof e && (e = e()),
            (t.memoizedState = t.baseState = e),
            (e = {
              pending: null,
              interleaved: null,
              lanes: 0,
              dispatch: null,
              lastRenderedReducer: yi,
              lastRenderedState: e,
            }),
            (t.queue = e),
            (e = e.dispatch = Gi.bind(null, si, e)),
            [t.memoizedState, e]
          );
        }
        function ji(e, t, n, r) {
          return (
            (e = { tag: e, create: t, destroy: n, deps: r, next: null }),
            null === (t = si.updateQueue)
              ? ((t = { lastEffect: null, stores: null }),
                (si.updateQueue = t),
                (t.lastEffect = e.next = e))
              : null === (n = t.lastEffect)
              ? (t.lastEffect = e.next = e)
              : ((r = n.next), (n.next = e), (e.next = r), (t.lastEffect = e)),
            e
          );
        }
        function Ni() {
          return _i().memoizedState;
        }
        function Di(e, t, n, r) {
          var o = bi();
          (si.flags |= e),
            (o.memoizedState = ji(1 | t, n, void 0, void 0 === r ? null : r));
        }
        function Ai(e, t, n, r) {
          var o = _i();
          r = void 0 === r ? null : r;
          var a = void 0;
          if (null !== li) {
            var i = li.memoizedState;
            if (((a = i.destroy), null !== r && fi(r, i.deps)))
              return void (o.memoizedState = ji(t, n, a, r));
          }
          (si.flags |= e), (o.memoizedState = ji(1 | t, n, a, r));
        }
        function Ei(e, t) {
          return Di(8390656, 8, e, t);
        }
        function Ri(e, t) {
          return Ai(2048, 8, e, t);
        }
        function Li(e, t) {
          return Ai(4, 2, e, t);
        }
        function Bi(e, t) {
          return Ai(4, 4, e, t);
        }
        function zi(e, t) {
          return "function" == typeof t
            ? ((e = e()),
              t(e),
              function () {
                t(null);
              })
            : null != t
            ? ((e = e()),
              (t.current = e),
              function () {
                t.current = null;
              })
            : void 0;
        }
        function Fi(e, t, n) {
          return (
            (n = null != n ? n.concat([e]) : null),
            Ai(4, 4, zi.bind(null, t, e), n)
          );
        }
        function Zi() {}
        function Hi(e, t) {
          var n = _i();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && fi(t, r[1])
            ? r[0]
            : ((n.memoizedState = [e, t]), e);
        }
        function Vi(e, t) {
          var n = _i();
          t = void 0 === t ? null : t;
          var r = n.memoizedState;
          return null !== r && null !== t && fi(t, r[1])
            ? r[0]
            : ((e = e()), (n.memoizedState = [e, t]), e);
        }
        function Wi(e, t, n) {
          return 0 == (21 & ii)
            ? (e.baseState && ((e.baseState = !1), (_s = !0)),
              (e.memoizedState = n))
            : (sr(n, t) ||
                ((n = ft()), (si.lanes |= n), (Rl |= n), (e.baseState = !0)),
              t);
        }
        function Ui(e, t) {
          var n = _t;
          (_t = 0 !== n && 4 > n ? n : 4), e(!0);
          var r = ai.transition;
          ai.transition = {};
          try {
            e(!1), t();
          } finally {
            (_t = n), (ai.transition = r);
          }
        }
        function $i() {
          return _i().memoizedState;
        }
        function Ki(e, t, n) {
          var r = td(e);
          (n = {
            lane: r,
            action: n,
            hasEagerState: !1,
            eagerState: null,
            next: null,
          }),
            qi(e)
              ? Qi(t, n)
              : null !== (n = Aa(e, t, n, r)) &&
                (nd(n, e, r, ed()), Yi(n, t, r));
        }
        function Gi(e, t, n) {
          var r = td(e),
            o = {
              lane: r,
              action: n,
              hasEagerState: !1,
              eagerState: null,
              next: null,
            };
          if (qi(e)) Qi(t, o);
          else {
            var a = e.alternate;
            if (
              0 === e.lanes &&
              (null === a || 0 === a.lanes) &&
              null !== (a = t.lastRenderedReducer)
            )
              try {
                var i = t.lastRenderedState,
                  s = a(i, n);
                if (((o.hasEagerState = !0), (o.eagerState = s), sr(s, i))) {
                  var l = t.interleaved;
                  return (
                    null === l
                      ? ((o.next = o), Da(t))
                      : ((o.next = l.next), (l.next = o)),
                    void (t.interleaved = o)
                  );
                }
              } catch (e) {}
            null !== (n = Aa(e, t, o, r)) &&
              (nd(n, e, r, (o = ed())), Yi(n, t, r));
          }
        }
        function qi(e) {
          var t = e.alternate;
          return e === si || (null !== t && t === si);
        }
        function Qi(e, t) {
          ui = ci = !0;
          var n = e.pending;
          null === n ? (t.next = t) : ((t.next = n.next), (n.next = t)),
            (e.pending = t);
        }
        function Yi(e, t, n) {
          if (0 != (4194240 & n)) {
            var r = t.lanes;
            (n |= r &= e.pendingLanes), (t.lanes = n), bt(e, n);
          }
        }
        var Ji = {
            readContext: ja,
            useCallback: hi,
            useContext: hi,
            useEffect: hi,
            useImperativeHandle: hi,
            useInsertionEffect: hi,
            useLayoutEffect: hi,
            useMemo: hi,
            useReducer: hi,
            useRef: hi,
            useState: hi,
            useDebugValue: hi,
            useDeferredValue: hi,
            useTransition: hi,
            useMutableSource: hi,
            useSyncExternalStore: hi,
            useId: hi,
            unstable_isNewReconciler: !1,
          },
          Xi = {
            readContext: ja,
            useCallback: function (e, t) {
              return (bi().memoizedState = [e, void 0 === t ? null : t]), e;
            },
            useContext: ja,
            useEffect: Ei,
            useImperativeHandle: function (e, t, n) {
              return (
                (n = null != n ? n.concat([e]) : null),
                Di(4194308, 4, zi.bind(null, t, e), n)
              );
            },
            useLayoutEffect: function (e, t) {
              return Di(4194308, 4, e, t);
            },
            useInsertionEffect: function (e, t) {
              return Di(4, 2, e, t);
            },
            useMemo: function (e, t) {
              var n = bi();
              return (
                (t = void 0 === t ? null : t),
                (e = e()),
                (n.memoizedState = [e, t]),
                e
              );
            },
            useReducer: function (e, t, n) {
              var r = bi();
              return (
                (t = void 0 !== n ? n(t) : t),
                (r.memoizedState = r.baseState = t),
                (e = {
                  pending: null,
                  interleaved: null,
                  lanes: 0,
                  dispatch: null,
                  lastRenderedReducer: e,
                  lastRenderedState: t,
                }),
                (r.queue = e),
                (e = e.dispatch = Ki.bind(null, si, e)),
                [r.memoizedState, e]
              );
            },
            useRef: function (e) {
              return (e = { current: e }), (bi().memoizedState = e);
            },
            useState: Mi,
            useDebugValue: Zi,
            useDeferredValue: function (e) {
              return (bi().memoizedState = e);
            },
            useTransition: function () {
              var e = Mi(!1),
                t = e[0];
              return (
                (e = Ui.bind(null, e[1])), (bi().memoizedState = e), [t, e]
              );
            },
            useMutableSource: function () {},
            useSyncExternalStore: function (e, t, n) {
              var r = si,
                o = bi();
              if (aa) {
                if (void 0 === n) throw Error(a(407));
                n = n();
              } else {
                if (((n = t()), null === Il)) throw Error(a(349));
                0 != (30 & ii) || Pi(r, t, n);
              }
              o.memoizedState = n;
              var i = { value: n, getSnapshot: t };
              return (
                (o.queue = i),
                Ei(Oi.bind(null, r, i, e), [e]),
                (r.flags |= 2048),
                ji(9, wi.bind(null, r, i, n, t), void 0, null),
                n
              );
            },
            useId: function () {
              var e = bi(),
                t = Il.identifierPrefix;
              if (aa) {
                var n = Jo;
                (t =
                  ":" +
                  t +
                  "R" +
                  (n = (Yo & ~(1 << (32 - it(Yo) - 1))).toString(32) + n)),
                  0 < (n = pi++) && (t += "H" + n.toString(32)),
                  (t += ":");
              } else t = ":" + t + "r" + (n = mi++).toString(32) + ":";
              return (e.memoizedState = t);
            },
            unstable_isNewReconciler: !1,
          },
          es = {
            readContext: ja,
            useCallback: Hi,
            useContext: ja,
            useEffect: Ri,
            useImperativeHandle: Fi,
            useInsertionEffect: Li,
            useLayoutEffect: Bi,
            useMemo: Vi,
            useReducer: Ci,
            useRef: Ni,
            useState: function () {
              return Ci(yi);
            },
            useDebugValue: Zi,
            useDeferredValue: function (e) {
              return Wi(_i(), li.memoizedState, e);
            },
            useTransition: function () {
              return [Ci(yi)[0], _i().memoizedState];
            },
            useMutableSource: Si,
            useSyncExternalStore: ki,
            useId: $i,
            unstable_isNewReconciler: !1,
          },
          ts = {
            readContext: ja,
            useCallback: Hi,
            useContext: ja,
            useEffect: Ri,
            useImperativeHandle: Fi,
            useInsertionEffect: Li,
            useLayoutEffect: Bi,
            useMemo: Vi,
            useReducer: xi,
            useRef: Ni,
            useState: function () {
              return xi(yi);
            },
            useDebugValue: Zi,
            useDeferredValue: function (e) {
              var t = _i();
              return null === li
                ? (t.memoizedState = e)
                : Wi(t, li.memoizedState, e);
            },
            useTransition: function () {
              return [xi(yi)[0], _i().memoizedState];
            },
            useMutableSource: Si,
            useSyncExternalStore: ki,
            useId: $i,
            unstable_isNewReconciler: !1,
          };
        function ns(e, t) {
          if (e && e.defaultProps) {
            for (var n in ((t = L({}, t)), (e = e.defaultProps)))
              void 0 === t[n] && (t[n] = e[n]);
            return t;
          }
          return t;
        }
        function rs(e, t, n, r) {
          (n = null == (n = n(r, (t = e.memoizedState))) ? t : L({}, t, n)),
            (e.memoizedState = n),
            0 === e.lanes && (e.updateQueue.baseState = n);
        }
        var os = {
          isMounted: function (e) {
            return !!(e = e._reactInternals) && He(e) === e;
          },
          enqueueSetState: function (e, t, n) {
            e = e._reactInternals;
            var r = ed(),
              o = td(e),
              a = za(r, o);
            (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = Fa(e, a, o)) && (nd(t, e, o, r), Za(t, e, o));
          },
          enqueueReplaceState: function (e, t, n) {
            e = e._reactInternals;
            var r = ed(),
              o = td(e),
              a = za(r, o);
            (a.tag = 1),
              (a.payload = t),
              null != n && (a.callback = n),
              null !== (t = Fa(e, a, o)) && (nd(t, e, o, r), Za(t, e, o));
          },
          enqueueForceUpdate: function (e, t) {
            e = e._reactInternals;
            var n = ed(),
              r = td(e),
              o = za(n, r);
            (o.tag = 2),
              null != t && (o.callback = t),
              null !== (t = Fa(e, o, r)) && (nd(t, e, r, n), Za(t, e, r));
          },
        };
        function as(e, t, n, r, o, a, i) {
          return "function" == typeof (e = e.stateNode).shouldComponentUpdate
            ? e.shouldComponentUpdate(r, a, i)
            : !(
                t.prototype &&
                t.prototype.isPureReactComponent &&
                lr(n, r) &&
                lr(o, a)
              );
        }
        function is(e, t, n) {
          var r = !1,
            o = To,
            a = t.contextType;
          return (
            "object" == typeof a && null !== a
              ? (a = ja(a))
              : ((o = Do(t) ? jo : Io.current),
                (a = (r = null != (r = t.contextTypes)) ? No(e, o) : To)),
            (t = new t(n, a)),
            (e.memoizedState =
              null !== t.state && void 0 !== t.state ? t.state : null),
            (t.updater = os),
            (e.stateNode = t),
            (t._reactInternals = e),
            r &&
              (((e = e.stateNode).__reactInternalMemoizedUnmaskedChildContext =
                o),
              (e.__reactInternalMemoizedMaskedChildContext = a)),
            t
          );
        }
        function ss(e, t, n, r) {
          (e = t.state),
            "function" == typeof t.componentWillReceiveProps &&
              t.componentWillReceiveProps(n, r),
            "function" == typeof t.UNSAFE_componentWillReceiveProps &&
              t.UNSAFE_componentWillReceiveProps(n, r),
            t.state !== e && os.enqueueReplaceState(t, t.state, null);
        }
        function ls(e, t, n, r) {
          var o = e.stateNode;
          (o.props = n), (o.state = e.memoizedState), (o.refs = {}), La(e);
          var a = t.contextType;
          "object" == typeof a && null !== a
            ? (o.context = ja(a))
            : ((a = Do(t) ? jo : Io.current), (o.context = No(e, a))),
            (o.state = e.memoizedState),
            "function" == typeof (a = t.getDerivedStateFromProps) &&
              (rs(e, t, a, n), (o.state = e.memoizedState)),
            "function" == typeof t.getDerivedStateFromProps ||
              "function" == typeof o.getSnapshotBeforeUpdate ||
              ("function" != typeof o.UNSAFE_componentWillMount &&
                "function" != typeof o.componentWillMount) ||
              ((t = o.state),
              "function" == typeof o.componentWillMount &&
                o.componentWillMount(),
              "function" == typeof o.UNSAFE_componentWillMount &&
                o.UNSAFE_componentWillMount(),
              t !== o.state && os.enqueueReplaceState(o, o.state, null),
              Va(e, n, o, r),
              (o.state = e.memoizedState)),
            "function" == typeof o.componentDidMount && (e.flags |= 4194308);
        }
        function ds(e, t) {
          try {
            var n = "",
              r = t;
            do {
              (n += Z(r)), (r = r.return);
            } while (r);
            var o = n;
          } catch (e) {
            o = "\nError generating stack: " + e.message + "\n" + e.stack;
          }
          return { value: e, source: t, stack: o, digest: null };
        }
        function cs(e, t, n) {
          return {
            value: e,
            source: null,
            stack: null != n ? n : null,
            digest: null != t ? t : null,
          };
        }
        function us(e, t) {
          try {
            console.error(t.value);
          } catch (e) {
            setTimeout(function () {
              throw e;
            });
          }
        }
        var ps = "function" == typeof WeakMap ? WeakMap : Map;
        function ms(e, t, n) {
          ((n = za(-1, n)).tag = 3), (n.payload = { element: null });
          var r = t.value;
          return (
            (n.callback = function () {
              Wl || ((Wl = !0), (Ul = r)), us(0, t);
            }),
            n
          );
        }
        function hs(e, t, n) {
          (n = za(-1, n)).tag = 3;
          var r = e.type.getDerivedStateFromError;
          if ("function" == typeof r) {
            var o = t.value;
            (n.payload = function () {
              return r(o);
            }),
              (n.callback = function () {
                us(0, t);
              });
          }
          var a = e.stateNode;
          return (
            null !== a &&
              "function" == typeof a.componentDidCatch &&
              (n.callback = function () {
                us(0, t),
                  "function" != typeof r &&
                    (null === $l ? ($l = new Set([this])) : $l.add(this));
                var e = t.stack;
                this.componentDidCatch(t.value, {
                  componentStack: null !== e ? e : "",
                });
              }),
            n
          );
        }
        function fs(e, t, n) {
          var r = e.pingCache;
          if (null === r) {
            r = e.pingCache = new ps();
            var o = new Set();
            r.set(t, o);
          } else void 0 === (o = r.get(t)) && ((o = new Set()), r.set(t, o));
          o.has(n) || (o.add(n), (e = Pd.bind(null, e, t, n)), t.then(e, e));
        }
        function gs(e) {
          do {
            var t;
            if (
              ((t = 13 === e.tag) &&
                (t = null === (t = e.memoizedState) || null !== t.dehydrated),
              t)
            )
              return e;
            e = e.return;
          } while (null !== e);
          return null;
        }
        function vs(e, t, n, r, o) {
          return 0 == (1 & e.mode)
            ? (e === t
                ? (e.flags |= 65536)
                : ((e.flags |= 128),
                  (n.flags |= 131072),
                  (n.flags &= -52805),
                  1 === n.tag &&
                    (null === n.alternate
                      ? (n.tag = 17)
                      : (((t = za(-1, 1)).tag = 2), Fa(n, t, 1))),
                  (n.lanes |= 1)),
              e)
            : ((e.flags |= 65536), (e.lanes = o), e);
        }
        var bs = y.ReactCurrentOwner,
          _s = !1;
        function ys(e, t, n, r) {
          t.child = null === e ? xa(t, null, n, r) : Ca(t, e.child, n, r);
        }
        function Cs(e, t, n, r, o) {
          n = n.render;
          var a = t.ref;
          return (
            Ma(t, o),
            (r = gi(e, t, n, r, a, o)),
            (n = vi()),
            null === e || _s
              ? (aa && n && ta(t), (t.flags |= 1), ys(e, t, r, o), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~o),
                Ws(e, t, o))
          );
        }
        function xs(e, t, n, r, o) {
          if (null === e) {
            var a = n.type;
            return "function" != typeof a ||
              Nd(a) ||
              void 0 !== a.defaultProps ||
              null !== n.compare ||
              void 0 !== n.defaultProps
              ? (((e = Ad(n.type, null, r, t, t.mode, o)).ref = t.ref),
                (e.return = t),
                (t.child = e))
              : ((t.tag = 15), (t.type = a), Ss(e, t, a, r, o));
          }
          if (((a = e.child), 0 == (e.lanes & o))) {
            var i = a.memoizedProps;
            if (
              (n = null !== (n = n.compare) ? n : lr)(i, r) &&
              e.ref === t.ref
            )
              return Ws(e, t, o);
          }
          return (
            (t.flags |= 1),
            ((e = Dd(a, r)).ref = t.ref),
            (e.return = t),
            (t.child = e)
          );
        }
        function Ss(e, t, n, r, o) {
          if (null !== e) {
            var a = e.memoizedProps;
            if (lr(a, r) && e.ref === t.ref) {
              if (((_s = !1), (t.pendingProps = r = a), 0 == (e.lanes & o)))
                return (t.lanes = e.lanes), Ws(e, t, o);
              0 != (131072 & e.flags) && (_s = !0);
            }
          }
          return ws(e, t, n, r, o);
        }
        function ks(e, t, n) {
          var r = t.pendingProps,
            o = r.children,
            a = null !== e ? e.memoizedState : null;
          if ("hidden" === r.mode)
            if (0 == (1 & t.mode))
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                Oo(Dl, Nl),
                (Nl |= n);
            else {
              if (0 == (1073741824 & n))
                return (
                  (e = null !== a ? a.baseLanes | n : n),
                  (t.lanes = t.childLanes = 1073741824),
                  (t.memoizedState = {
                    baseLanes: e,
                    cachePool: null,
                    transitions: null,
                  }),
                  (t.updateQueue = null),
                  Oo(Dl, Nl),
                  (Nl |= e),
                  null
                );
              (t.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null,
              }),
                (r = null !== a ? a.baseLanes : n),
                Oo(Dl, Nl),
                (Nl |= r);
            }
          else
            null !== a
              ? ((r = a.baseLanes | n), (t.memoizedState = null))
              : (r = n),
              Oo(Dl, Nl),
              (Nl |= r);
          return ys(e, t, o, n), t.child;
        }
        function Ps(e, t) {
          var n = t.ref;
          ((null === e && null !== n) || (null !== e && e.ref !== n)) &&
            ((t.flags |= 512), (t.flags |= 2097152));
        }
        function ws(e, t, n, r, o) {
          var a = Do(n) ? jo : Io.current;
          return (
            (a = No(t, a)),
            Ma(t, o),
            (n = gi(e, t, n, r, a, o)),
            (r = vi()),
            null === e || _s
              ? (aa && r && ta(t), (t.flags |= 1), ys(e, t, n, o), t.child)
              : ((t.updateQueue = e.updateQueue),
                (t.flags &= -2053),
                (e.lanes &= ~o),
                Ws(e, t, o))
          );
        }
        function Os(e, t, n, r, o) {
          if (Do(n)) {
            var a = !0;
            Lo(t);
          } else a = !1;
          if ((Ma(t, o), null === t.stateNode))
            Vs(e, t), is(t, n, r), ls(t, n, r, o), (r = !0);
          else if (null === e) {
            var i = t.stateNode,
              s = t.memoizedProps;
            i.props = s;
            var l = i.context,
              d = n.contextType;
            d =
              "object" == typeof d && null !== d
                ? ja(d)
                : No(t, (d = Do(n) ? jo : Io.current));
            var c = n.getDerivedStateFromProps,
              u =
                "function" == typeof c ||
                "function" == typeof i.getSnapshotBeforeUpdate;
            u ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((s !== r || l !== d) && ss(t, i, r, d)),
              (Ra = !1);
            var p = t.memoizedState;
            (i.state = p),
              Va(t, r, i, o),
              (l = t.memoizedState),
              s !== r || p !== l || Mo.current || Ra
                ? ("function" == typeof c &&
                    (rs(t, n, c, r), (l = t.memoizedState)),
                  (s = Ra || as(t, n, s, r, p, l, d))
                    ? (u ||
                        ("function" != typeof i.UNSAFE_componentWillMount &&
                          "function" != typeof i.componentWillMount) ||
                        ("function" == typeof i.componentWillMount &&
                          i.componentWillMount(),
                        "function" == typeof i.UNSAFE_componentWillMount &&
                          i.UNSAFE_componentWillMount()),
                      "function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308))
                    : ("function" == typeof i.componentDidMount &&
                        (t.flags |= 4194308),
                      (t.memoizedProps = r),
                      (t.memoizedState = l)),
                  (i.props = r),
                  (i.state = l),
                  (i.context = d),
                  (r = s))
                : ("function" == typeof i.componentDidMount &&
                    (t.flags |= 4194308),
                  (r = !1));
          } else {
            (i = t.stateNode),
              Ba(e, t),
              (s = t.memoizedProps),
              (d = t.type === t.elementType ? s : ns(t.type, s)),
              (i.props = d),
              (u = t.pendingProps),
              (p = i.context),
              (l =
                "object" == typeof (l = n.contextType) && null !== l
                  ? ja(l)
                  : No(t, (l = Do(n) ? jo : Io.current)));
            var m = n.getDerivedStateFromProps;
            (c =
              "function" == typeof m ||
              "function" == typeof i.getSnapshotBeforeUpdate) ||
              ("function" != typeof i.UNSAFE_componentWillReceiveProps &&
                "function" != typeof i.componentWillReceiveProps) ||
              ((s !== u || p !== l) && ss(t, i, r, l)),
              (Ra = !1),
              (p = t.memoizedState),
              (i.state = p),
              Va(t, r, i, o);
            var h = t.memoizedState;
            s !== u || p !== h || Mo.current || Ra
              ? ("function" == typeof m &&
                  (rs(t, n, m, r), (h = t.memoizedState)),
                (d = Ra || as(t, n, d, r, p, h, l) || !1)
                  ? (c ||
                      ("function" != typeof i.UNSAFE_componentWillUpdate &&
                        "function" != typeof i.componentWillUpdate) ||
                      ("function" == typeof i.componentWillUpdate &&
                        i.componentWillUpdate(r, h, l),
                      "function" == typeof i.UNSAFE_componentWillUpdate &&
                        i.UNSAFE_componentWillUpdate(r, h, l)),
                    "function" == typeof i.componentDidUpdate && (t.flags |= 4),
                    "function" == typeof i.getSnapshotBeforeUpdate &&
                      (t.flags |= 1024))
                  : ("function" != typeof i.componentDidUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 4),
                    "function" != typeof i.getSnapshotBeforeUpdate ||
                      (s === e.memoizedProps && p === e.memoizedState) ||
                      (t.flags |= 1024),
                    (t.memoizedProps = r),
                    (t.memoizedState = h)),
                (i.props = r),
                (i.state = h),
                (i.context = l),
                (r = d))
              : ("function" != typeof i.componentDidUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 4),
                "function" != typeof i.getSnapshotBeforeUpdate ||
                  (s === e.memoizedProps && p === e.memoizedState) ||
                  (t.flags |= 1024),
                (r = !1));
          }
          return Ts(e, t, n, r, a, o);
        }
        function Ts(e, t, n, r, o, a) {
          Ps(e, t);
          var i = 0 != (128 & t.flags);
          if (!r && !i) return o && Bo(t, n, !1), Ws(e, t, a);
          (r = t.stateNode), (bs.current = t);
          var s =
            i && "function" != typeof n.getDerivedStateFromError
              ? null
              : r.render();
          return (
            (t.flags |= 1),
            null !== e && i
              ? ((t.child = Ca(t, e.child, null, a)),
                (t.child = Ca(t, null, s, a)))
              : ys(e, t, s, a),
            (t.memoizedState = r.state),
            o && Bo(t, n, !0),
            t.child
          );
        }
        function Is(e) {
          var t = e.stateNode;
          t.pendingContext
            ? Eo(0, t.pendingContext, t.pendingContext !== t.context)
            : t.context && Eo(0, t.context, !1),
            Qa(e, t.containerInfo);
        }
        function Ms(e, t, n, r, o) {
          return ha(), fa(o), (t.flags |= 256), ys(e, t, n, r), t.child;
        }
        var js,
          Ns,
          Ds,
          As,
          Es = { dehydrated: null, treeContext: null, retryLane: 0 };
        function Rs(e) {
          return { baseLanes: e, cachePool: null, transitions: null };
        }
        function Ls(e, t, n) {
          var r,
            o = t.pendingProps,
            i = ei.current,
            s = !1,
            l = 0 != (128 & t.flags);
          if (
            ((r = l) ||
              (r = (null === e || null !== e.memoizedState) && 0 != (2 & i)),
            r
              ? ((s = !0), (t.flags &= -129))
              : (null !== e && null === e.memoizedState) || (i |= 1),
            Oo(ei, 1 & i),
            null === e)
          )
            return (
              ca(t),
              null !== (e = t.memoizedState) && null !== (e = e.dehydrated)
                ? (0 == (1 & t.mode)
                    ? (t.lanes = 1)
                    : "$!" === e.data
                    ? (t.lanes = 8)
                    : (t.lanes = 1073741824),
                  null)
                : ((l = o.children),
                  (e = o.fallback),
                  s
                    ? ((o = t.mode),
                      (s = t.child),
                      (l = { mode: "hidden", children: l }),
                      0 == (1 & o) && null !== s
                        ? ((s.childLanes = 0), (s.pendingProps = l))
                        : (s = Rd(l, o, 0, null)),
                      (e = Ed(e, o, n, null)),
                      (s.return = t),
                      (e.return = t),
                      (s.sibling = e),
                      (t.child = s),
                      (t.child.memoizedState = Rs(n)),
                      (t.memoizedState = Es),
                      e)
                    : Bs(t, l))
            );
          if (null !== (i = e.memoizedState) && null !== (r = i.dehydrated))
            return (function (e, t, n, r, o, i, s) {
              if (n)
                return 256 & t.flags
                  ? ((t.flags &= -257), zs(e, t, s, (r = cs(Error(a(422))))))
                  : null !== t.memoizedState
                  ? ((t.child = e.child), (t.flags |= 128), null)
                  : ((i = r.fallback),
                    (o = t.mode),
                    (r = Rd(
                      { mode: "visible", children: r.children },
                      o,
                      0,
                      null
                    )),
                    ((i = Ed(i, o, s, null)).flags |= 2),
                    (r.return = t),
                    (i.return = t),
                    (r.sibling = i),
                    (t.child = r),
                    0 != (1 & t.mode) && Ca(t, e.child, null, s),
                    (t.child.memoizedState = Rs(s)),
                    (t.memoizedState = Es),
                    i);
              if (0 == (1 & t.mode)) return zs(e, t, s, null);
              if ("$!" === o.data) {
                if ((r = o.nextSibling && o.nextSibling.dataset))
                  var l = r.dgst;
                return (
                  (r = l), zs(e, t, s, (r = cs((i = Error(a(419))), r, void 0)))
                );
              }
              if (((l = 0 != (s & e.childLanes)), _s || l)) {
                if (null !== (r = Il)) {
                  switch (s & -s) {
                    case 4:
                      o = 2;
                      break;
                    case 16:
                      o = 8;
                      break;
                    case 64:
                    case 128:
                    case 256:
                    case 512:
                    case 1024:
                    case 2048:
                    case 4096:
                    case 8192:
                    case 16384:
                    case 32768:
                    case 65536:
                    case 131072:
                    case 262144:
                    case 524288:
                    case 1048576:
                    case 2097152:
                    case 4194304:
                    case 8388608:
                    case 16777216:
                    case 33554432:
                    case 67108864:
                      o = 32;
                      break;
                    case 536870912:
                      o = 268435456;
                      break;
                    default:
                      o = 0;
                  }
                  0 !== (o = 0 != (o & (r.suspendedLanes | s)) ? 0 : o) &&
                    o !== i.retryLane &&
                    ((i.retryLane = o), Ea(e, o), nd(r, e, o, -1));
                }
                return fd(), zs(e, t, s, (r = cs(Error(a(421)))));
              }
              return "$?" === o.data
                ? ((t.flags |= 128),
                  (t.child = e.child),
                  (t = Od.bind(null, e)),
                  (o._reactRetry = t),
                  null)
                : ((e = i.treeContext),
                  (oa = co(o.nextSibling)),
                  (ra = t),
                  (aa = !0),
                  (ia = null),
                  null !== e &&
                    ((Go[qo++] = Yo),
                    (Go[qo++] = Jo),
                    (Go[qo++] = Qo),
                    (Yo = e.id),
                    (Jo = e.overflow),
                    (Qo = t)),
                  ((t = Bs(t, r.children)).flags |= 4096),
                  t);
            })(e, t, l, o, r, i, n);
          if (s) {
            (s = o.fallback), (l = t.mode), (r = (i = e.child).sibling);
            var d = { mode: "hidden", children: o.children };
            return (
              0 == (1 & l) && t.child !== i
                ? (((o = t.child).childLanes = 0),
                  (o.pendingProps = d),
                  (t.deletions = null))
                : ((o = Dd(i, d)).subtreeFlags = 14680064 & i.subtreeFlags),
              null !== r
                ? (s = Dd(r, s))
                : ((s = Ed(s, l, n, null)).flags |= 2),
              (s.return = t),
              (o.return = t),
              (o.sibling = s),
              (t.child = o),
              (o = s),
              (s = t.child),
              (l =
                null === (l = e.child.memoizedState)
                  ? Rs(n)
                  : {
                      baseLanes: l.baseLanes | n,
                      cachePool: null,
                      transitions: l.transitions,
                    }),
              (s.memoizedState = l),
              (s.childLanes = e.childLanes & ~n),
              (t.memoizedState = Es),
              o
            );
          }
          return (
            (e = (s = e.child).sibling),
            (o = Dd(s, { mode: "visible", children: o.children })),
            0 == (1 & t.mode) && (o.lanes = n),
            (o.return = t),
            (o.sibling = null),
            null !== e &&
              (null === (n = t.deletions)
                ? ((t.deletions = [e]), (t.flags |= 16))
                : n.push(e)),
            (t.child = o),
            (t.memoizedState = null),
            o
          );
        }
        function Bs(e, t) {
          return (
            ((t = Rd(
              { mode: "visible", children: t },
              e.mode,
              0,
              null
            )).return = e),
            (e.child = t)
          );
        }
        function zs(e, t, n, r) {
          return (
            null !== r && fa(r),
            Ca(t, e.child, null, n),
            ((e = Bs(t, t.pendingProps.children)).flags |= 2),
            (t.memoizedState = null),
            e
          );
        }
        function Fs(e, t, n) {
          e.lanes |= t;
          var r = e.alternate;
          null !== r && (r.lanes |= t), Ia(e.return, t, n);
        }
        function Zs(e, t, n, r, o) {
          var a = e.memoizedState;
          null === a
            ? (e.memoizedState = {
                isBackwards: t,
                rendering: null,
                renderingStartTime: 0,
                last: r,
                tail: n,
                tailMode: o,
              })
            : ((a.isBackwards = t),
              (a.rendering = null),
              (a.renderingStartTime = 0),
              (a.last = r),
              (a.tail = n),
              (a.tailMode = o));
        }
        function Hs(e, t, n) {
          var r = t.pendingProps,
            o = r.revealOrder,
            a = r.tail;
          if ((ys(e, t, r.children, n), 0 != (2 & (r = ei.current))))
            (r = (1 & r) | 2), (t.flags |= 128);
          else {
            if (null !== e && 0 != (128 & e.flags))
              e: for (e = t.child; null !== e; ) {
                if (13 === e.tag) null !== e.memoizedState && Fs(e, n, t);
                else if (19 === e.tag) Fs(e, n, t);
                else if (null !== e.child) {
                  (e.child.return = e), (e = e.child);
                  continue;
                }
                if (e === t) break e;
                for (; null === e.sibling; ) {
                  if (null === e.return || e.return === t) break e;
                  e = e.return;
                }
                (e.sibling.return = e.return), (e = e.sibling);
              }
            r &= 1;
          }
          if ((Oo(ei, r), 0 == (1 & t.mode))) t.memoizedState = null;
          else
            switch (o) {
              case "forwards":
                for (n = t.child, o = null; null !== n; )
                  null !== (e = n.alternate) && null === ti(e) && (o = n),
                    (n = n.sibling);
                null === (n = o)
                  ? ((o = t.child), (t.child = null))
                  : ((o = n.sibling), (n.sibling = null)),
                  Zs(t, !1, o, n, a);
                break;
              case "backwards":
                for (n = null, o = t.child, t.child = null; null !== o; ) {
                  if (null !== (e = o.alternate) && null === ti(e)) {
                    t.child = o;
                    break;
                  }
                  (e = o.sibling), (o.sibling = n), (n = o), (o = e);
                }
                Zs(t, !0, n, null, a);
                break;
              case "together":
                Zs(t, !1, null, null, void 0);
                break;
              default:
                t.memoizedState = null;
            }
          return t.child;
        }
        function Vs(e, t) {
          0 == (1 & t.mode) &&
            null !== e &&
            ((e.alternate = null), (t.alternate = null), (t.flags |= 2));
        }
        function Ws(e, t, n) {
          if (
            (null !== e && (t.dependencies = e.dependencies),
            (Rl |= t.lanes),
            0 == (n & t.childLanes))
          )
            return null;
          if (null !== e && t.child !== e.child) throw Error(a(153));
          if (null !== t.child) {
            for (
              n = Dd((e = t.child), e.pendingProps), t.child = n, n.return = t;
              null !== e.sibling;

            )
              (e = e.sibling),
                ((n = n.sibling = Dd(e, e.pendingProps)).return = t);
            n.sibling = null;
          }
          return t.child;
        }
        function Us(e, t) {
          if (!aa)
            switch (e.tailMode) {
              case "hidden":
                t = e.tail;
                for (var n = null; null !== t; )
                  null !== t.alternate && (n = t), (t = t.sibling);
                null === n ? (e.tail = null) : (n.sibling = null);
                break;
              case "collapsed":
                n = e.tail;
                for (var r = null; null !== n; )
                  null !== n.alternate && (r = n), (n = n.sibling);
                null === r
                  ? t || null === e.tail
                    ? (e.tail = null)
                    : (e.tail.sibling = null)
                  : (r.sibling = null);
            }
        }
        function $s(e) {
          var t = null !== e.alternate && e.alternate.child === e.child,
            n = 0,
            r = 0;
          if (t)
            for (var o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= 14680064 & o.subtreeFlags),
                (r |= 14680064 & o.flags),
                (o.return = e),
                (o = o.sibling);
          else
            for (o = e.child; null !== o; )
              (n |= o.lanes | o.childLanes),
                (r |= o.subtreeFlags),
                (r |= o.flags),
                (o.return = e),
                (o = o.sibling);
          return (e.subtreeFlags |= r), (e.childLanes = n), t;
        }
        function Ks(e, t, n) {
          var r = t.pendingProps;
          switch ((na(t), t.tag)) {
            case 2:
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
              return $s(t), null;
            case 1:
            case 17:
              return Do(t.type) && Ao(), $s(t), null;
            case 3:
              return (
                (r = t.stateNode),
                Ya(),
                wo(Mo),
                wo(Io),
                ri(),
                r.pendingContext &&
                  ((r.context = r.pendingContext), (r.pendingContext = null)),
                (null !== e && null !== e.child) ||
                  (pa(t)
                    ? (t.flags |= 4)
                    : null === e ||
                      (e.memoizedState.isDehydrated && 0 == (256 & t.flags)) ||
                      ((t.flags |= 1024),
                      null !== ia && (id(ia), (ia = null)))),
                Ns(e, t),
                $s(t),
                null
              );
            case 5:
              Xa(t);
              var o = qa(Ga.current);
              if (((n = t.type), null !== e && null != t.stateNode))
                Ds(e, t, n, r, o),
                  e.ref !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              else {
                if (!r) {
                  if (null === t.stateNode) throw Error(a(166));
                  return $s(t), null;
                }
                if (((e = qa($a.current)), pa(t))) {
                  (r = t.stateNode), (n = t.type);
                  var i = t.memoizedProps;
                  switch (
                    ((r[mo] = t), (r[ho] = i), (e = 0 != (1 & t.mode)), n)
                  ) {
                    case "dialog":
                      zr("cancel", r), zr("close", r);
                      break;
                    case "iframe":
                    case "object":
                    case "embed":
                      zr("load", r);
                      break;
                    case "video":
                    case "audio":
                      for (o = 0; o < Er.length; o++) zr(Er[o], r);
                      break;
                    case "source":
                      zr("error", r);
                      break;
                    case "img":
                    case "image":
                    case "link":
                      zr("error", r), zr("load", r);
                      break;
                    case "details":
                      zr("toggle", r);
                      break;
                    case "input":
                      Q(r, i), zr("invalid", r);
                      break;
                    case "select":
                      (r._wrapperState = { wasMultiple: !!i.multiple }),
                        zr("invalid", r);
                      break;
                    case "textarea":
                      oe(r, i), zr("invalid", r);
                  }
                  for (var l in (be(n, i), (o = null), i))
                    if (i.hasOwnProperty(l)) {
                      var d = i[l];
                      "children" === l
                        ? "string" == typeof d
                          ? r.textContent !== d &&
                            (!0 !== i.suppressHydrationWarning &&
                              Jr(r.textContent, d, e),
                            (o = ["children", d]))
                          : "number" == typeof d &&
                            r.textContent !== "" + d &&
                            (!0 !== i.suppressHydrationWarning &&
                              Jr(r.textContent, d, e),
                            (o = ["children", "" + d]))
                        : s.hasOwnProperty(l) &&
                          null != d &&
                          "onScroll" === l &&
                          zr("scroll", r);
                    }
                  switch (n) {
                    case "input":
                      $(r), X(r, i, !0);
                      break;
                    case "textarea":
                      $(r), ie(r);
                      break;
                    case "select":
                    case "option":
                      break;
                    default:
                      "function" == typeof i.onClick && (r.onclick = Xr);
                  }
                  (r = o), (t.updateQueue = r), null !== r && (t.flags |= 4);
                } else {
                  (l = 9 === o.nodeType ? o : o.ownerDocument),
                    "http://www.w3.org/1999/xhtml" === e && (e = se(n)),
                    "http://www.w3.org/1999/xhtml" === e
                      ? "script" === n
                        ? (((e = l.createElement("div")).innerHTML =
                            "<script></script>"),
                          (e = e.removeChild(e.firstChild)))
                        : "string" == typeof r.is
                        ? (e = l.createElement(n, { is: r.is }))
                        : ((e = l.createElement(n)),
                          "select" === n &&
                            ((l = e),
                            r.multiple
                              ? (l.multiple = !0)
                              : r.size && (l.size = r.size)))
                      : (e = l.createElementNS(e, n)),
                    (e[mo] = t),
                    (e[ho] = r),
                    js(e, t, !1, !1),
                    (t.stateNode = e);
                  e: {
                    switch (((l = _e(n, r)), n)) {
                      case "dialog":
                        zr("cancel", e), zr("close", e), (o = r);
                        break;
                      case "iframe":
                      case "object":
                      case "embed":
                        zr("load", e), (o = r);
                        break;
                      case "video":
                      case "audio":
                        for (o = 0; o < Er.length; o++) zr(Er[o], e);
                        o = r;
                        break;
                      case "source":
                        zr("error", e), (o = r);
                        break;
                      case "img":
                      case "image":
                      case "link":
                        zr("error", e), zr("load", e), (o = r);
                        break;
                      case "details":
                        zr("toggle", e), (o = r);
                        break;
                      case "input":
                        Q(e, r), (o = q(e, r)), zr("invalid", e);
                        break;
                      case "option":
                      default:
                        o = r;
                        break;
                      case "select":
                        (e._wrapperState = { wasMultiple: !!r.multiple }),
                          (o = L({}, r, { value: void 0 })),
                          zr("invalid", e);
                        break;
                      case "textarea":
                        oe(e, r), (o = re(e, r)), zr("invalid", e);
                    }
                    for (i in (be(n, o), (d = o)))
                      if (d.hasOwnProperty(i)) {
                        var c = d[i];
                        "style" === i
                          ? ge(e, c)
                          : "dangerouslySetInnerHTML" === i
                          ? null != (c = c ? c.__html : void 0) && ue(e, c)
                          : "children" === i
                          ? "string" == typeof c
                            ? ("textarea" !== n || "" !== c) && pe(e, c)
                            : "number" == typeof c && pe(e, "" + c)
                          : "suppressContentEditableWarning" !== i &&
                            "suppressHydrationWarning" !== i &&
                            "autoFocus" !== i &&
                            (s.hasOwnProperty(i)
                              ? null != c && "onScroll" === i && zr("scroll", e)
                              : null != c && _(e, i, c, l));
                      }
                    switch (n) {
                      case "input":
                        $(e), X(e, r, !1);
                        break;
                      case "textarea":
                        $(e), ie(e);
                        break;
                      case "option":
                        null != r.value &&
                          e.setAttribute("value", "" + W(r.value));
                        break;
                      case "select":
                        (e.multiple = !!r.multiple),
                          null != (i = r.value)
                            ? ne(e, !!r.multiple, i, !1)
                            : null != r.defaultValue &&
                              ne(e, !!r.multiple, r.defaultValue, !0);
                        break;
                      default:
                        "function" == typeof o.onClick && (e.onclick = Xr);
                    }
                    switch (n) {
                      case "button":
                      case "input":
                      case "select":
                      case "textarea":
                        r = !!r.autoFocus;
                        break e;
                      case "img":
                        r = !0;
                        break e;
                      default:
                        r = !1;
                    }
                  }
                  r && (t.flags |= 4);
                }
                null !== t.ref && ((t.flags |= 512), (t.flags |= 2097152));
              }
              return $s(t), null;
            case 6:
              if (e && null != t.stateNode) As(e, t, e.memoizedProps, r);
              else {
                if ("string" != typeof r && null === t.stateNode)
                  throw Error(a(166));
                if (((n = qa(Ga.current)), qa($a.current), pa(t))) {
                  if (
                    ((r = t.stateNode),
                    (n = t.memoizedProps),
                    (r[mo] = t),
                    (i = r.nodeValue !== n) && null !== (e = ra))
                  )
                    switch (e.tag) {
                      case 3:
                        Jr(r.nodeValue, n, 0 != (1 & e.mode));
                        break;
                      case 5:
                        !0 !== e.memoizedProps.suppressHydrationWarning &&
                          Jr(r.nodeValue, n, 0 != (1 & e.mode));
                    }
                  i && (t.flags |= 4);
                } else
                  ((r = (9 === n.nodeType ? n : n.ownerDocument).createTextNode(
                    r
                  ))[mo] = t),
                    (t.stateNode = r);
              }
              return $s(t), null;
            case 13:
              if (
                (wo(ei),
                (r = t.memoizedState),
                null === e ||
                  (null !== e.memoizedState &&
                    null !== e.memoizedState.dehydrated))
              ) {
                if (
                  aa &&
                  null !== oa &&
                  0 != (1 & t.mode) &&
                  0 == (128 & t.flags)
                )
                  ma(), ha(), (t.flags |= 98560), (i = !1);
                else if (((i = pa(t)), null !== r && null !== r.dehydrated)) {
                  if (null === e) {
                    if (!i) throw Error(a(318));
                    if (
                      !(i =
                        null !== (i = t.memoizedState) ? i.dehydrated : null)
                    )
                      throw Error(a(317));
                    i[mo] = t;
                  } else
                    ha(),
                      0 == (128 & t.flags) && (t.memoizedState = null),
                      (t.flags |= 4);
                  $s(t), (i = !1);
                } else null !== ia && (id(ia), (ia = null)), (i = !0);
                if (!i) return 65536 & t.flags ? t : null;
              }
              return 0 != (128 & t.flags)
                ? ((t.lanes = n), t)
                : ((r = null !== r) !=
                    (null !== e && null !== e.memoizedState) &&
                    r &&
                    ((t.child.flags |= 8192),
                    0 != (1 & t.mode) &&
                      (null === e || 0 != (1 & ei.current)
                        ? 0 === Al && (Al = 3)
                        : fd())),
                  null !== t.updateQueue && (t.flags |= 4),
                  $s(t),
                  null);
            case 4:
              return (
                Ya(),
                Ns(e, t),
                null === e && Hr(t.stateNode.containerInfo),
                $s(t),
                null
              );
            case 10:
              return Ta(t.type._context), $s(t), null;
            case 19:
              if ((wo(ei), null === (i = t.memoizedState))) return $s(t), null;
              if (((r = 0 != (128 & t.flags)), null === (l = i.rendering)))
                if (r) Us(i, !1);
                else {
                  if (0 !== Al || (null !== e && 0 != (128 & e.flags)))
                    for (e = t.child; null !== e; ) {
                      if (null !== (l = ti(e))) {
                        for (
                          t.flags |= 128,
                            Us(i, !1),
                            null !== (r = l.updateQueue) &&
                              ((t.updateQueue = r), (t.flags |= 4)),
                            t.subtreeFlags = 0,
                            r = n,
                            n = t.child;
                          null !== n;

                        )
                          (e = r),
                            ((i = n).flags &= 14680066),
                            null === (l = i.alternate)
                              ? ((i.childLanes = 0),
                                (i.lanes = e),
                                (i.child = null),
                                (i.subtreeFlags = 0),
                                (i.memoizedProps = null),
                                (i.memoizedState = null),
                                (i.updateQueue = null),
                                (i.dependencies = null),
                                (i.stateNode = null))
                              : ((i.childLanes = l.childLanes),
                                (i.lanes = l.lanes),
                                (i.child = l.child),
                                (i.subtreeFlags = 0),
                                (i.deletions = null),
                                (i.memoizedProps = l.memoizedProps),
                                (i.memoizedState = l.memoizedState),
                                (i.updateQueue = l.updateQueue),
                                (i.type = l.type),
                                (e = l.dependencies),
                                (i.dependencies =
                                  null === e
                                    ? null
                                    : {
                                        lanes: e.lanes,
                                        firstContext: e.firstContext,
                                      })),
                            (n = n.sibling);
                        return Oo(ei, (1 & ei.current) | 2), t.child;
                      }
                      e = e.sibling;
                    }
                  null !== i.tail &&
                    Ye() > Hl &&
                    ((t.flags |= 128),
                    (r = !0),
                    Us(i, !1),
                    (t.lanes = 4194304));
                }
              else {
                if (!r)
                  if (null !== (e = ti(l))) {
                    if (
                      ((t.flags |= 128),
                      (r = !0),
                      null !== (n = e.updateQueue) &&
                        ((t.updateQueue = n), (t.flags |= 4)),
                      Us(i, !0),
                      null === i.tail &&
                        "hidden" === i.tailMode &&
                        !l.alternate &&
                        !aa)
                    )
                      return $s(t), null;
                  } else
                    2 * Ye() - i.renderingStartTime > Hl &&
                      1073741824 !== n &&
                      ((t.flags |= 128),
                      (r = !0),
                      Us(i, !1),
                      (t.lanes = 4194304));
                i.isBackwards
                  ? ((l.sibling = t.child), (t.child = l))
                  : (null !== (n = i.last) ? (n.sibling = l) : (t.child = l),
                    (i.last = l));
              }
              return null !== i.tail
                ? ((t = i.tail),
                  (i.rendering = t),
                  (i.tail = t.sibling),
                  (i.renderingStartTime = Ye()),
                  (t.sibling = null),
                  (n = ei.current),
                  Oo(ei, r ? (1 & n) | 2 : 1 & n),
                  t)
                : ($s(t), null);
            case 22:
            case 23:
              return (
                ud(),
                (r = null !== t.memoizedState),
                null !== e &&
                  (null !== e.memoizedState) !== r &&
                  (t.flags |= 8192),
                r && 0 != (1 & t.mode)
                  ? 0 != (1073741824 & Nl) &&
                    ($s(t), 6 & t.subtreeFlags && (t.flags |= 8192))
                  : $s(t),
                null
              );
            case 24:
            case 25:
              return null;
          }
          throw Error(a(156, t.tag));
        }
        function Gs(e, t) {
          switch ((na(t), t.tag)) {
            case 1:
              return (
                Do(t.type) && Ao(),
                65536 & (e = t.flags)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 3:
              return (
                Ya(),
                wo(Mo),
                wo(Io),
                ri(),
                0 != (65536 & (e = t.flags)) && 0 == (128 & e)
                  ? ((t.flags = (-65537 & e) | 128), t)
                  : null
              );
            case 5:
              return Xa(t), null;
            case 13:
              if (
                (wo(ei),
                null !== (e = t.memoizedState) && null !== e.dehydrated)
              ) {
                if (null === t.alternate) throw Error(a(340));
                ha();
              }
              return 65536 & (e = t.flags)
                ? ((t.flags = (-65537 & e) | 128), t)
                : null;
            case 19:
              return wo(ei), null;
            case 4:
              return Ya(), null;
            case 10:
              return Ta(t.type._context), null;
            case 22:
            case 23:
              return ud(), null;
            default:
              return null;
          }
        }
        (js = function (e, t) {
          for (var n = t.child; null !== n; ) {
            if (5 === n.tag || 6 === n.tag) e.appendChild(n.stateNode);
            else if (4 !== n.tag && null !== n.child) {
              (n.child.return = n), (n = n.child);
              continue;
            }
            if (n === t) break;
            for (; null === n.sibling; ) {
              if (null === n.return || n.return === t) return;
              n = n.return;
            }
            (n.sibling.return = n.return), (n = n.sibling);
          }
        }),
          (Ns = function () {}),
          (Ds = function (e, t, n, r) {
            var o = e.memoizedProps;
            if (o !== r) {
              (e = t.stateNode), qa($a.current);
              var a,
                i = null;
              switch (n) {
                case "input":
                  (o = q(e, o)), (r = q(e, r)), (i = []);
                  break;
                case "select":
                  (o = L({}, o, { value: void 0 })),
                    (r = L({}, r, { value: void 0 })),
                    (i = []);
                  break;
                case "textarea":
                  (o = re(e, o)), (r = re(e, r)), (i = []);
                  break;
                default:
                  "function" != typeof o.onClick &&
                    "function" == typeof r.onClick &&
                    (e.onclick = Xr);
              }
              for (c in (be(n, r), (n = null), o))
                if (!r.hasOwnProperty(c) && o.hasOwnProperty(c) && null != o[c])
                  if ("style" === c) {
                    var l = o[c];
                    for (a in l)
                      l.hasOwnProperty(a) && (n || (n = {}), (n[a] = ""));
                  } else
                    "dangerouslySetInnerHTML" !== c &&
                      "children" !== c &&
                      "suppressContentEditableWarning" !== c &&
                      "suppressHydrationWarning" !== c &&
                      "autoFocus" !== c &&
                      (s.hasOwnProperty(c)
                        ? i || (i = [])
                        : (i = i || []).push(c, null));
              for (c in r) {
                var d = r[c];
                if (
                  ((l = null != o ? o[c] : void 0),
                  r.hasOwnProperty(c) && d !== l && (null != d || null != l))
                )
                  if ("style" === c)
                    if (l) {
                      for (a in l)
                        !l.hasOwnProperty(a) ||
                          (d && d.hasOwnProperty(a)) ||
                          (n || (n = {}), (n[a] = ""));
                      for (a in d)
                        d.hasOwnProperty(a) &&
                          l[a] !== d[a] &&
                          (n || (n = {}), (n[a] = d[a]));
                    } else n || (i || (i = []), i.push(c, n)), (n = d);
                  else
                    "dangerouslySetInnerHTML" === c
                      ? ((d = d ? d.__html : void 0),
                        (l = l ? l.__html : void 0),
                        null != d && l !== d && (i = i || []).push(c, d))
                      : "children" === c
                      ? ("string" != typeof d && "number" != typeof d) ||
                        (i = i || []).push(c, "" + d)
                      : "suppressContentEditableWarning" !== c &&
                        "suppressHydrationWarning" !== c &&
                        (s.hasOwnProperty(c)
                          ? (null != d && "onScroll" === c && zr("scroll", e),
                            i || l === d || (i = []))
                          : (i = i || []).push(c, d));
              }
              n && (i = i || []).push("style", n);
              var c = i;
              (t.updateQueue = c) && (t.flags |= 4);
            }
          }),
          (As = function (e, t, n, r) {
            n !== r && (t.flags |= 4);
          });
        var qs = !1,
          Qs = !1,
          Ys = "function" == typeof WeakSet ? WeakSet : Set,
          Js = null;
        function Xs(e, t) {
          var n = e.ref;
          if (null !== n)
            if ("function" == typeof n)
              try {
                n(null);
              } catch (n) {
                kd(e, t, n);
              }
            else n.current = null;
        }
        function el(e, t, n) {
          try {
            n();
          } catch (n) {
            kd(e, t, n);
          }
        }
        var tl = !1;
        function nl(e, t, n) {
          var r = t.updateQueue;
          if (null !== (r = null !== r ? r.lastEffect : null)) {
            var o = (r = r.next);
            do {
              if ((o.tag & e) === e) {
                var a = o.destroy;
                (o.destroy = void 0), void 0 !== a && el(t, n, a);
              }
              o = o.next;
            } while (o !== r);
          }
        }
        function rl(e, t) {
          if (
            null !== (t = null !== (t = t.updateQueue) ? t.lastEffect : null)
          ) {
            var n = (t = t.next);
            do {
              if ((n.tag & e) === e) {
                var r = n.create;
                n.destroy = r();
              }
              n = n.next;
            } while (n !== t);
          }
        }
        function ol(e) {
          var t = e.ref;
          if (null !== t) {
            var n = e.stateNode;
            e.tag, (e = n), "function" == typeof t ? t(e) : (t.current = e);
          }
        }
        function al(e) {
          var t = e.alternate;
          null !== t && ((e.alternate = null), al(t)),
            (e.child = null),
            (e.deletions = null),
            (e.sibling = null),
            5 === e.tag &&
              null !== (t = e.stateNode) &&
              (delete t[mo],
              delete t[ho],
              delete t[go],
              delete t[vo],
              delete t[bo]),
            (e.stateNode = null),
            (e.return = null),
            (e.dependencies = null),
            (e.memoizedProps = null),
            (e.memoizedState = null),
            (e.pendingProps = null),
            (e.stateNode = null),
            (e.updateQueue = null);
        }
        function il(e) {
          return 5 === e.tag || 3 === e.tag || 4 === e.tag;
        }
        function sl(e) {
          e: for (;;) {
            for (; null === e.sibling; ) {
              if (null === e.return || il(e.return)) return null;
              e = e.return;
            }
            for (
              e.sibling.return = e.return, e = e.sibling;
              5 !== e.tag && 6 !== e.tag && 18 !== e.tag;

            ) {
              if (2 & e.flags) continue e;
              if (null === e.child || 4 === e.tag) continue e;
              (e.child.return = e), (e = e.child);
            }
            if (!(2 & e.flags)) return e.stateNode;
          }
        }
        function ll(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode),
              t
                ? 8 === n.nodeType
                  ? n.parentNode.insertBefore(e, t)
                  : n.insertBefore(e, t)
                : (8 === n.nodeType
                    ? (t = n.parentNode).insertBefore(e, n)
                    : (t = n).appendChild(e),
                  null != (n = n._reactRootContainer) ||
                    null !== t.onclick ||
                    (t.onclick = Xr));
          else if (4 !== r && null !== (e = e.child))
            for (ll(e, t, n), e = e.sibling; null !== e; )
              ll(e, t, n), (e = e.sibling);
        }
        function dl(e, t, n) {
          var r = e.tag;
          if (5 === r || 6 === r)
            (e = e.stateNode), t ? n.insertBefore(e, t) : n.appendChild(e);
          else if (4 !== r && null !== (e = e.child))
            for (dl(e, t, n), e = e.sibling; null !== e; )
              dl(e, t, n), (e = e.sibling);
        }
        var cl = null,
          ul = !1;
        function pl(e, t, n) {
          for (n = n.child; null !== n; ) ml(e, t, n), (n = n.sibling);
        }
        function ml(e, t, n) {
          if (at && "function" == typeof at.onCommitFiberUnmount)
            try {
              at.onCommitFiberUnmount(ot, n);
            } catch (e) {}
          switch (n.tag) {
            case 5:
              Qs || Xs(n, t);
            case 6:
              var r = cl,
                o = ul;
              (cl = null),
                pl(e, t, n),
                (ul = o),
                null !== (cl = r) &&
                  (ul
                    ? ((e = cl),
                      (n = n.stateNode),
                      8 === e.nodeType
                        ? e.parentNode.removeChild(n)
                        : e.removeChild(n))
                    : cl.removeChild(n.stateNode));
              break;
            case 18:
              null !== cl &&
                (ul
                  ? ((e = cl),
                    (n = n.stateNode),
                    8 === e.nodeType
                      ? lo(e.parentNode, n)
                      : 1 === e.nodeType && lo(e, n),
                    Ht(e))
                  : lo(cl, n.stateNode));
              break;
            case 4:
              (r = cl),
                (o = ul),
                (cl = n.stateNode.containerInfo),
                (ul = !0),
                pl(e, t, n),
                (cl = r),
                (ul = o);
              break;
            case 0:
            case 11:
            case 14:
            case 15:
              if (
                !Qs &&
                null !== (r = n.updateQueue) &&
                null !== (r = r.lastEffect)
              ) {
                o = r = r.next;
                do {
                  var a = o,
                    i = a.destroy;
                  (a = a.tag),
                    void 0 !== i &&
                      (0 != (2 & a) || 0 != (4 & a)) &&
                      el(n, t, i),
                    (o = o.next);
                } while (o !== r);
              }
              pl(e, t, n);
              break;
            case 1:
              if (
                !Qs &&
                (Xs(n, t),
                "function" == typeof (r = n.stateNode).componentWillUnmount)
              )
                try {
                  (r.props = n.memoizedProps),
                    (r.state = n.memoizedState),
                    r.componentWillUnmount();
                } catch (e) {
                  kd(n, t, e);
                }
              pl(e, t, n);
              break;
            case 21:
              pl(e, t, n);
              break;
            case 22:
              1 & n.mode
                ? ((Qs = (r = Qs) || null !== n.memoizedState),
                  pl(e, t, n),
                  (Qs = r))
                : pl(e, t, n);
              break;
            default:
              pl(e, t, n);
          }
        }
        function hl(e) {
          var t = e.updateQueue;
          if (null !== t) {
            e.updateQueue = null;
            var n = e.stateNode;
            null === n && (n = e.stateNode = new Ys()),
              t.forEach(function (t) {
                var r = Td.bind(null, e, t);
                n.has(t) || (n.add(t), t.then(r, r));
              });
          }
        }
        function fl(e, t) {
          var n = t.deletions;
          if (null !== n)
            for (var r = 0; r < n.length; r++) {
              var o = n[r];
              try {
                var i = e,
                  s = t,
                  l = s;
                e: for (; null !== l; ) {
                  switch (l.tag) {
                    case 5:
                      (cl = l.stateNode), (ul = !1);
                      break e;
                    case 3:
                    case 4:
                      (cl = l.stateNode.containerInfo), (ul = !0);
                      break e;
                  }
                  l = l.return;
                }
                if (null === cl) throw Error(a(160));
                ml(i, s, o), (cl = null), (ul = !1);
                var d = o.alternate;
                null !== d && (d.return = null), (o.return = null);
              } catch (e) {
                kd(o, t, e);
              }
            }
          if (12854 & t.subtreeFlags)
            for (t = t.child; null !== t; ) gl(t, e), (t = t.sibling);
        }
        function gl(e, t) {
          var n = e.alternate,
            r = e.flags;
          switch (e.tag) {
            case 0:
            case 11:
            case 14:
            case 15:
              if ((fl(t, e), vl(e), 4 & r)) {
                try {
                  nl(3, e, e.return), rl(3, e);
                } catch (t) {
                  kd(e, e.return, t);
                }
                try {
                  nl(5, e, e.return);
                } catch (t) {
                  kd(e, e.return, t);
                }
              }
              break;
            case 1:
              fl(t, e), vl(e), 512 & r && null !== n && Xs(n, n.return);
              break;
            case 5:
              if (
                (fl(t, e),
                vl(e),
                512 & r && null !== n && Xs(n, n.return),
                32 & e.flags)
              ) {
                var o = e.stateNode;
                try {
                  pe(o, "");
                } catch (t) {
                  kd(e, e.return, t);
                }
              }
              if (4 & r && null != (o = e.stateNode)) {
                var i = e.memoizedProps,
                  s = null !== n ? n.memoizedProps : i,
                  l = e.type,
                  d = e.updateQueue;
                if (((e.updateQueue = null), null !== d))
                  try {
                    "input" === l &&
                      "radio" === i.type &&
                      null != i.name &&
                      Y(o, i),
                      _e(l, s);
                    var c = _e(l, i);
                    for (s = 0; s < d.length; s += 2) {
                      var u = d[s],
                        p = d[s + 1];
                      "style" === u
                        ? ge(o, p)
                        : "dangerouslySetInnerHTML" === u
                        ? ue(o, p)
                        : "children" === u
                        ? pe(o, p)
                        : _(o, u, p, c);
                    }
                    switch (l) {
                      case "input":
                        J(o, i);
                        break;
                      case "textarea":
                        ae(o, i);
                        break;
                      case "select":
                        var m = o._wrapperState.wasMultiple;
                        o._wrapperState.wasMultiple = !!i.multiple;
                        var h = i.value;
                        null != h
                          ? ne(o, !!i.multiple, h, !1)
                          : m !== !!i.multiple &&
                            (null != i.defaultValue
                              ? ne(o, !!i.multiple, i.defaultValue, !0)
                              : ne(o, !!i.multiple, i.multiple ? [] : "", !1));
                    }
                    o[ho] = i;
                  } catch (t) {
                    kd(e, e.return, t);
                  }
              }
              break;
            case 6:
              if ((fl(t, e), vl(e), 4 & r)) {
                if (null === e.stateNode) throw Error(a(162));
                (o = e.stateNode), (i = e.memoizedProps);
                try {
                  o.nodeValue = i;
                } catch (t) {
                  kd(e, e.return, t);
                }
              }
              break;
            case 3:
              if (
                (fl(t, e),
                vl(e),
                4 & r && null !== n && n.memoizedState.isDehydrated)
              )
                try {
                  Ht(t.containerInfo);
                } catch (t) {
                  kd(e, e.return, t);
                }
              break;
            case 4:
            default:
              fl(t, e), vl(e);
              break;
            case 13:
              fl(t, e),
                vl(e),
                8192 & (o = e.child).flags &&
                  ((i = null !== o.memoizedState),
                  (o.stateNode.isHidden = i),
                  !i ||
                    (null !== o.alternate &&
                      null !== o.alternate.memoizedState) ||
                    (Zl = Ye())),
                4 & r && hl(e);
              break;
            case 22:
              if (
                ((u = null !== n && null !== n.memoizedState),
                1 & e.mode
                  ? ((Qs = (c = Qs) || u), fl(t, e), (Qs = c))
                  : fl(t, e),
                vl(e),
                8192 & r)
              ) {
                if (
                  ((c = null !== e.memoizedState),
                  (e.stateNode.isHidden = c) && !u && 0 != (1 & e.mode))
                )
                  for (Js = e, u = e.child; null !== u; ) {
                    for (p = Js = u; null !== Js; ) {
                      switch (((h = (m = Js).child), m.tag)) {
                        case 0:
                        case 11:
                        case 14:
                        case 15:
                          nl(4, m, m.return);
                          break;
                        case 1:
                          Xs(m, m.return);
                          var f = m.stateNode;
                          if ("function" == typeof f.componentWillUnmount) {
                            (r = m), (n = m.return);
                            try {
                              (t = r),
                                (f.props = t.memoizedProps),
                                (f.state = t.memoizedState),
                                f.componentWillUnmount();
                            } catch (e) {
                              kd(r, n, e);
                            }
                          }
                          break;
                        case 5:
                          Xs(m, m.return);
                          break;
                        case 22:
                          if (null !== m.memoizedState) {
                            Cl(p);
                            continue;
                          }
                      }
                      null !== h ? ((h.return = m), (Js = h)) : Cl(p);
                    }
                    u = u.sibling;
                  }
                e: for (u = null, p = e; ; ) {
                  if (5 === p.tag) {
                    if (null === u) {
                      u = p;
                      try {
                        (o = p.stateNode),
                          c
                            ? "function" == typeof (i = o.style).setProperty
                              ? i.setProperty("display", "none", "important")
                              : (i.display = "none")
                            : ((l = p.stateNode),
                              (s =
                                null != (d = p.memoizedProps.style) &&
                                d.hasOwnProperty("display")
                                  ? d.display
                                  : null),
                              (l.style.display = fe("display", s)));
                      } catch (t) {
                        kd(e, e.return, t);
                      }
                    }
                  } else if (6 === p.tag) {
                    if (null === u)
                      try {
                        p.stateNode.nodeValue = c ? "" : p.memoizedProps;
                      } catch (t) {
                        kd(e, e.return, t);
                      }
                  } else if (
                    ((22 !== p.tag && 23 !== p.tag) ||
                      null === p.memoizedState ||
                      p === e) &&
                    null !== p.child
                  ) {
                    (p.child.return = p), (p = p.child);
                    continue;
                  }
                  if (p === e) break e;
                  for (; null === p.sibling; ) {
                    if (null === p.return || p.return === e) break e;
                    u === p && (u = null), (p = p.return);
                  }
                  u === p && (u = null),
                    (p.sibling.return = p.return),
                    (p = p.sibling);
                }
              }
              break;
            case 19:
              fl(t, e), vl(e), 4 & r && hl(e);
            case 21:
          }
        }
        function vl(e) {
          var t = e.flags;
          if (2 & t) {
            try {
              e: {
                for (var n = e.return; null !== n; ) {
                  if (il(n)) {
                    var r = n;
                    break e;
                  }
                  n = n.return;
                }
                throw Error(a(160));
              }
              switch (r.tag) {
                case 5:
                  var o = r.stateNode;
                  32 & r.flags && (pe(o, ""), (r.flags &= -33)),
                    dl(e, sl(e), o);
                  break;
                case 3:
                case 4:
                  var i = r.stateNode.containerInfo;
                  ll(e, sl(e), i);
                  break;
                default:
                  throw Error(a(161));
              }
            } catch (t) {
              kd(e, e.return, t);
            }
            e.flags &= -3;
          }
          4096 & t && (e.flags &= -4097);
        }
        function bl(e, t, n) {
          (Js = e), _l(e, t, n);
        }
        function _l(e, t, n) {
          for (var r = 0 != (1 & e.mode); null !== Js; ) {
            var o = Js,
              a = o.child;
            if (22 === o.tag && r) {
              var i = null !== o.memoizedState || qs;
              if (!i) {
                var s = o.alternate,
                  l = (null !== s && null !== s.memoizedState) || Qs;
                s = qs;
                var d = Qs;
                if (((qs = i), (Qs = l) && !d))
                  for (Js = o; null !== Js; )
                    (l = (i = Js).child),
                      22 === i.tag && null !== i.memoizedState
                        ? xl(o)
                        : null !== l
                        ? ((l.return = i), (Js = l))
                        : xl(o);
                for (; null !== a; ) (Js = a), _l(a, t, n), (a = a.sibling);
                (Js = o), (qs = s), (Qs = d);
              }
              yl(e);
            } else
              0 != (8772 & o.subtreeFlags) && null !== a
                ? ((a.return = o), (Js = a))
                : yl(e);
          }
        }
        function yl(e) {
          for (; null !== Js; ) {
            var t = Js;
            if (0 != (8772 & t.flags)) {
              var n = t.alternate;
              try {
                if (0 != (8772 & t.flags))
                  switch (t.tag) {
                    case 0:
                    case 11:
                    case 15:
                      Qs || rl(5, t);
                      break;
                    case 1:
                      var r = t.stateNode;
                      if (4 & t.flags && !Qs)
                        if (null === n) r.componentDidMount();
                        else {
                          var o =
                            t.elementType === t.type
                              ? n.memoizedProps
                              : ns(t.type, n.memoizedProps);
                          r.componentDidUpdate(
                            o,
                            n.memoizedState,
                            r.__reactInternalSnapshotBeforeUpdate
                          );
                        }
                      var i = t.updateQueue;
                      null !== i && Wa(t, i, r);
                      break;
                    case 3:
                      var s = t.updateQueue;
                      if (null !== s) {
                        if (((n = null), null !== t.child))
                          switch (t.child.tag) {
                            case 5:
                            case 1:
                              n = t.child.stateNode;
                          }
                        Wa(t, s, n);
                      }
                      break;
                    case 5:
                      var l = t.stateNode;
                      if (null === n && 4 & t.flags) {
                        n = l;
                        var d = t.memoizedProps;
                        switch (t.type) {
                          case "button":
                          case "input":
                          case "select":
                          case "textarea":
                            d.autoFocus && n.focus();
                            break;
                          case "img":
                            d.src && (n.src = d.src);
                        }
                      }
                      break;
                    case 6:
                    case 4:
                    case 12:
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                      break;
                    case 13:
                      if (null === t.memoizedState) {
                        var c = t.alternate;
                        if (null !== c) {
                          var u = c.memoizedState;
                          if (null !== u) {
                            var p = u.dehydrated;
                            null !== p && Ht(p);
                          }
                        }
                      }
                      break;
                    default:
                      throw Error(a(163));
                  }
                Qs || (512 & t.flags && ol(t));
              } catch (e) {
                kd(t, t.return, e);
              }
            }
            if (t === e) {
              Js = null;
              break;
            }
            if (null !== (n = t.sibling)) {
              (n.return = t.return), (Js = n);
              break;
            }
            Js = t.return;
          }
        }
        function Cl(e) {
          for (; null !== Js; ) {
            var t = Js;
            if (t === e) {
              Js = null;
              break;
            }
            var n = t.sibling;
            if (null !== n) {
              (n.return = t.return), (Js = n);
              break;
            }
            Js = t.return;
          }
        }
        function xl(e) {
          for (; null !== Js; ) {
            var t = Js;
            try {
              switch (t.tag) {
                case 0:
                case 11:
                case 15:
                  var n = t.return;
                  try {
                    rl(4, t);
                  } catch (e) {
                    kd(t, n, e);
                  }
                  break;
                case 1:
                  var r = t.stateNode;
                  if ("function" == typeof r.componentDidMount) {
                    var o = t.return;
                    try {
                      r.componentDidMount();
                    } catch (e) {
                      kd(t, o, e);
                    }
                  }
                  var a = t.return;
                  try {
                    ol(t);
                  } catch (e) {
                    kd(t, a, e);
                  }
                  break;
                case 5:
                  var i = t.return;
                  try {
                    ol(t);
                  } catch (e) {
                    kd(t, i, e);
                  }
              }
            } catch (e) {
              kd(t, t.return, e);
            }
            if (t === e) {
              Js = null;
              break;
            }
            var s = t.sibling;
            if (null !== s) {
              (s.return = t.return), (Js = s);
              break;
            }
            Js = t.return;
          }
        }
        var Sl,
          kl = Math.ceil,
          Pl = y.ReactCurrentDispatcher,
          wl = y.ReactCurrentOwner,
          Ol = y.ReactCurrentBatchConfig,
          Tl = 0,
          Il = null,
          Ml = null,
          jl = 0,
          Nl = 0,
          Dl = Po(0),
          Al = 0,
          El = null,
          Rl = 0,
          Ll = 0,
          Bl = 0,
          zl = null,
          Fl = null,
          Zl = 0,
          Hl = 1 / 0,
          Vl = null,
          Wl = !1,
          Ul = null,
          $l = null,
          Kl = !1,
          Gl = null,
          ql = 0,
          Ql = 0,
          Yl = null,
          Jl = -1,
          Xl = 0;
        function ed() {
          return 0 != (6 & Tl) ? Ye() : -1 !== Jl ? Jl : (Jl = Ye());
        }
        function td(e) {
          return 0 == (1 & e.mode)
            ? 1
            : 0 != (2 & Tl) && 0 !== jl
            ? jl & -jl
            : null !== ga.transition
            ? (0 === Xl && (Xl = ft()), Xl)
            : 0 !== (e = _t)
            ? e
            : (e = void 0 === (e = window.event) ? 16 : Qt(e.type));
        }
        function nd(e, t, n, r) {
          if (50 < Ql) throw ((Ql = 0), (Yl = null), Error(a(185)));
          vt(e, n, r),
            (0 != (2 & Tl) && e === Il) ||
              (e === Il && (0 == (2 & Tl) && (Ll |= n), 4 === Al && sd(e, jl)),
              rd(e, r),
              1 === n &&
                0 === Tl &&
                0 == (1 & t.mode) &&
                ((Hl = Ye() + 500), Fo && Vo()));
        }
        function rd(e, t) {
          var n = e.callbackNode;
          !(function (e, t) {
            for (
              var n = e.suspendedLanes,
                r = e.pingedLanes,
                o = e.expirationTimes,
                a = e.pendingLanes;
              0 < a;

            ) {
              var i = 31 - it(a),
                s = 1 << i,
                l = o[i];
              -1 === l
                ? (0 != (s & n) && 0 == (s & r)) || (o[i] = mt(s, t))
                : l <= t && (e.expiredLanes |= s),
                (a &= ~s);
            }
          })(e, t);
          var r = pt(e, e === Il ? jl : 0);
          if (0 === r)
            null !== n && Ge(n),
              (e.callbackNode = null),
              (e.callbackPriority = 0);
          else if (((t = r & -r), e.callbackPriority !== t)) {
            if ((null != n && Ge(n), 1 === t))
              0 === e.tag
                ? (function (e) {
                    (Fo = !0), Ho(e);
                  })(ld.bind(null, e))
                : Ho(ld.bind(null, e)),
                io(function () {
                  0 == (6 & Tl) && Vo();
                }),
                (n = null);
            else {
              switch (yt(r)) {
                case 1:
                  n = Xe;
                  break;
                case 4:
                  n = et;
                  break;
                case 16:
                default:
                  n = tt;
                  break;
                case 536870912:
                  n = rt;
              }
              n = Id(n, od.bind(null, e));
            }
            (e.callbackPriority = t), (e.callbackNode = n);
          }
        }
        function od(e, t) {
          if (((Jl = -1), (Xl = 0), 0 != (6 & Tl))) throw Error(a(327));
          var n = e.callbackNode;
          if (xd() && e.callbackNode !== n) return null;
          var r = pt(e, e === Il ? jl : 0);
          if (0 === r) return null;
          if (0 != (30 & r) || 0 != (r & e.expiredLanes) || t) t = gd(e, r);
          else {
            t = r;
            var o = Tl;
            Tl |= 2;
            var i = hd();
            for (
              (Il === e && jl === t) ||
              ((Vl = null), (Hl = Ye() + 500), pd(e, t));
              ;

            )
              try {
                bd();
                break;
              } catch (t) {
                md(e, t);
              }
            Oa(),
              (Pl.current = i),
              (Tl = o),
              null !== Ml ? (t = 0) : ((Il = null), (jl = 0), (t = Al));
          }
          if (0 !== t) {
            if (
              (2 === t && 0 !== (o = ht(e)) && ((r = o), (t = ad(e, o))),
              1 === t)
            )
              throw ((n = El), pd(e, 0), sd(e, r), rd(e, Ye()), n);
            if (6 === t) sd(e, r);
            else {
              if (
                ((o = e.current.alternate),
                0 == (30 & r) &&
                  !(function (e) {
                    for (var t = e; ; ) {
                      if (16384 & t.flags) {
                        var n = t.updateQueue;
                        if (null !== n && null !== (n = n.stores))
                          for (var r = 0; r < n.length; r++) {
                            var o = n[r],
                              a = o.getSnapshot;
                            o = o.value;
                            try {
                              if (!sr(a(), o)) return !1;
                            } catch (e) {
                              return !1;
                            }
                          }
                      }
                      if (((n = t.child), 16384 & t.subtreeFlags && null !== n))
                        (n.return = t), (t = n);
                      else {
                        if (t === e) break;
                        for (; null === t.sibling; ) {
                          if (null === t.return || t.return === e) return !0;
                          t = t.return;
                        }
                        (t.sibling.return = t.return), (t = t.sibling);
                      }
                    }
                    return !0;
                  })(o) &&
                  (2 === (t = gd(e, r)) &&
                    0 !== (i = ht(e)) &&
                    ((r = i), (t = ad(e, i))),
                  1 === t))
              )
                throw ((n = El), pd(e, 0), sd(e, r), rd(e, Ye()), n);
              switch (((e.finishedWork = o), (e.finishedLanes = r), t)) {
                case 0:
                case 1:
                  throw Error(a(345));
                case 2:
                case 5:
                  Cd(e, Fl, Vl);
                  break;
                case 3:
                  if (
                    (sd(e, r),
                    (130023424 & r) === r && 10 < (t = Zl + 500 - Ye()))
                  ) {
                    if (0 !== pt(e, 0)) break;
                    if (((o = e.suspendedLanes) & r) !== r) {
                      ed(), (e.pingedLanes |= e.suspendedLanes & o);
                      break;
                    }
                    e.timeoutHandle = ro(Cd.bind(null, e, Fl, Vl), t);
                    break;
                  }
                  Cd(e, Fl, Vl);
                  break;
                case 4:
                  if ((sd(e, r), (4194240 & r) === r)) break;
                  for (t = e.eventTimes, o = -1; 0 < r; ) {
                    var s = 31 - it(r);
                    (i = 1 << s), (s = t[s]) > o && (o = s), (r &= ~i);
                  }
                  if (
                    ((r = o),
                    10 <
                      (r =
                        (120 > (r = Ye() - r)
                          ? 120
                          : 480 > r
                          ? 480
                          : 1080 > r
                          ? 1080
                          : 1920 > r
                          ? 1920
                          : 3e3 > r
                          ? 3e3
                          : 4320 > r
                          ? 4320
                          : 1960 * kl(r / 1960)) - r))
                  ) {
                    e.timeoutHandle = ro(Cd.bind(null, e, Fl, Vl), r);
                    break;
                  }
                  Cd(e, Fl, Vl);
                  break;
                default:
                  throw Error(a(329));
              }
            }
          }
          return rd(e, Ye()), e.callbackNode === n ? od.bind(null, e) : null;
        }
        function ad(e, t) {
          var n = zl;
          return (
            e.current.memoizedState.isDehydrated && (pd(e, t).flags |= 256),
            2 !== (e = gd(e, t)) && ((t = Fl), (Fl = n), null !== t && id(t)),
            e
          );
        }
        function id(e) {
          null === Fl ? (Fl = e) : Fl.push.apply(Fl, e);
        }
        function sd(e, t) {
          for (
            t &= ~Bl,
              t &= ~Ll,
              e.suspendedLanes |= t,
              e.pingedLanes &= ~t,
              e = e.expirationTimes;
            0 < t;

          ) {
            var n = 31 - it(t),
              r = 1 << n;
            (e[n] = -1), (t &= ~r);
          }
        }
        function ld(e) {
          if (0 != (6 & Tl)) throw Error(a(327));
          xd();
          var t = pt(e, 0);
          if (0 == (1 & t)) return rd(e, Ye()), null;
          var n = gd(e, t);
          if (0 !== e.tag && 2 === n) {
            var r = ht(e);
            0 !== r && ((t = r), (n = ad(e, r)));
          }
          if (1 === n) throw ((n = El), pd(e, 0), sd(e, t), rd(e, Ye()), n);
          if (6 === n) throw Error(a(345));
          return (
            (e.finishedWork = e.current.alternate),
            (e.finishedLanes = t),
            Cd(e, Fl, Vl),
            rd(e, Ye()),
            null
          );
        }
        function dd(e, t) {
          var n = Tl;
          Tl |= 1;
          try {
            return e(t);
          } finally {
            0 === (Tl = n) && ((Hl = Ye() + 500), Fo && Vo());
          }
        }
        function cd(e) {
          null !== Gl && 0 === Gl.tag && 0 == (6 & Tl) && xd();
          var t = Tl;
          Tl |= 1;
          var n = Ol.transition,
            r = _t;
          try {
            if (((Ol.transition = null), (_t = 1), e)) return e();
          } finally {
            (_t = r), (Ol.transition = n), 0 == (6 & (Tl = t)) && Vo();
          }
        }
        function ud() {
          (Nl = Dl.current), wo(Dl);
        }
        function pd(e, t) {
          (e.finishedWork = null), (e.finishedLanes = 0);
          var n = e.timeoutHandle;
          if ((-1 !== n && ((e.timeoutHandle = -1), oo(n)), null !== Ml))
            for (n = Ml.return; null !== n; ) {
              var r = n;
              switch ((na(r), r.tag)) {
                case 1:
                  null != (r = r.type.childContextTypes) && Ao();
                  break;
                case 3:
                  Ya(), wo(Mo), wo(Io), ri();
                  break;
                case 5:
                  Xa(r);
                  break;
                case 4:
                  Ya();
                  break;
                case 13:
                case 19:
                  wo(ei);
                  break;
                case 10:
                  Ta(r.type._context);
                  break;
                case 22:
                case 23:
                  ud();
              }
              n = n.return;
            }
          if (
            ((Il = e),
            (Ml = e = Dd(e.current, null)),
            (jl = Nl = t),
            (Al = 0),
            (El = null),
            (Bl = Ll = Rl = 0),
            (Fl = zl = null),
            null !== Na)
          ) {
            for (t = 0; t < Na.length; t++)
              if (null !== (r = (n = Na[t]).interleaved)) {
                n.interleaved = null;
                var o = r.next,
                  a = n.pending;
                if (null !== a) {
                  var i = a.next;
                  (a.next = o), (r.next = i);
                }
                n.pending = r;
              }
            Na = null;
          }
          return e;
        }
        function md(e, t) {
          for (;;) {
            var n = Ml;
            try {
              if ((Oa(), (oi.current = Ji), ci)) {
                for (var r = si.memoizedState; null !== r; ) {
                  var o = r.queue;
                  null !== o && (o.pending = null), (r = r.next);
                }
                ci = !1;
              }
              if (
                ((ii = 0),
                (di = li = si = null),
                (ui = !1),
                (pi = 0),
                (wl.current = null),
                null === n || null === n.return)
              ) {
                (Al = 1), (El = t), (Ml = null);
                break;
              }
              e: {
                var i = e,
                  s = n.return,
                  l = n,
                  d = t;
                if (
                  ((t = jl),
                  (l.flags |= 32768),
                  null !== d &&
                    "object" == typeof d &&
                    "function" == typeof d.then)
                ) {
                  var c = d,
                    u = l,
                    p = u.tag;
                  if (0 == (1 & u.mode) && (0 === p || 11 === p || 15 === p)) {
                    var m = u.alternate;
                    m
                      ? ((u.updateQueue = m.updateQueue),
                        (u.memoizedState = m.memoizedState),
                        (u.lanes = m.lanes))
                      : ((u.updateQueue = null), (u.memoizedState = null));
                  }
                  var h = gs(s);
                  if (null !== h) {
                    (h.flags &= -257),
                      vs(h, s, l, 0, t),
                      1 & h.mode && fs(i, c, t),
                      (d = c);
                    var f = (t = h).updateQueue;
                    if (null === f) {
                      var g = new Set();
                      g.add(d), (t.updateQueue = g);
                    } else f.add(d);
                    break e;
                  }
                  if (0 == (1 & t)) {
                    fs(i, c, t), fd();
                    break e;
                  }
                  d = Error(a(426));
                } else if (aa && 1 & l.mode) {
                  var v = gs(s);
                  if (null !== v) {
                    0 == (65536 & v.flags) && (v.flags |= 256),
                      vs(v, s, l, 0, t),
                      fa(ds(d, l));
                    break e;
                  }
                }
                (i = d = ds(d, l)),
                  4 !== Al && (Al = 2),
                  null === zl ? (zl = [i]) : zl.push(i),
                  (i = s);
                do {
                  switch (i.tag) {
                    case 3:
                      (i.flags |= 65536),
                        (t &= -t),
                        (i.lanes |= t),
                        Ha(i, ms(0, d, t));
                      break e;
                    case 1:
                      l = d;
                      var b = i.type,
                        _ = i.stateNode;
                      if (
                        0 == (128 & i.flags) &&
                        ("function" == typeof b.getDerivedStateFromError ||
                          (null !== _ &&
                            "function" == typeof _.componentDidCatch &&
                            (null === $l || !$l.has(_))))
                      ) {
                        (i.flags |= 65536),
                          (t &= -t),
                          (i.lanes |= t),
                          Ha(i, hs(i, l, t));
                        break e;
                      }
                  }
                  i = i.return;
                } while (null !== i);
              }
              yd(n);
            } catch (e) {
              (t = e), Ml === n && null !== n && (Ml = n = n.return);
              continue;
            }
            break;
          }
        }
        function hd() {
          var e = Pl.current;
          return (Pl.current = Ji), null === e ? Ji : e;
        }
        function fd() {
          (0 !== Al && 3 !== Al && 2 !== Al) || (Al = 4),
            null === Il ||
              (0 == (268435455 & Rl) && 0 == (268435455 & Ll)) ||
              sd(Il, jl);
        }
        function gd(e, t) {
          var n = Tl;
          Tl |= 2;
          var r = hd();
          for ((Il === e && jl === t) || ((Vl = null), pd(e, t)); ; )
            try {
              vd();
              break;
            } catch (t) {
              md(e, t);
            }
          if ((Oa(), (Tl = n), (Pl.current = r), null !== Ml))
            throw Error(a(261));
          return (Il = null), (jl = 0), Al;
        }
        function vd() {
          for (; null !== Ml; ) _d(Ml);
        }
        function bd() {
          for (; null !== Ml && !qe(); ) _d(Ml);
        }
        function _d(e) {
          var t = Sl(e.alternate, e, Nl);
          (e.memoizedProps = e.pendingProps),
            null === t ? yd(e) : (Ml = t),
            (wl.current = null);
        }
        function yd(e) {
          var t = e;
          do {
            var n = t.alternate;
            if (((e = t.return), 0 == (32768 & t.flags))) {
              if (null !== (n = Ks(n, t, Nl))) return void (Ml = n);
            } else {
              if (null !== (n = Gs(n, t)))
                return (n.flags &= 32767), void (Ml = n);
              if (null === e) return (Al = 6), void (Ml = null);
              (e.flags |= 32768), (e.subtreeFlags = 0), (e.deletions = null);
            }
            if (null !== (t = t.sibling)) return void (Ml = t);
            Ml = t = e;
          } while (null !== t);
          0 === Al && (Al = 5);
        }
        function Cd(e, t, n) {
          var r = _t,
            o = Ol.transition;
          try {
            (Ol.transition = null),
              (_t = 1),
              (function (e, t, n, r) {
                do {
                  xd();
                } while (null !== Gl);
                if (0 != (6 & Tl)) throw Error(a(327));
                n = e.finishedWork;
                var o = e.finishedLanes;
                if (null === n) return null;
                if (
                  ((e.finishedWork = null),
                  (e.finishedLanes = 0),
                  n === e.current)
                )
                  throw Error(a(177));
                (e.callbackNode = null), (e.callbackPriority = 0);
                var i = n.lanes | n.childLanes;
                if (
                  ((function (e, t) {
                    var n = e.pendingLanes & ~t;
                    (e.pendingLanes = t),
                      (e.suspendedLanes = 0),
                      (e.pingedLanes = 0),
                      (e.expiredLanes &= t),
                      (e.mutableReadLanes &= t),
                      (e.entangledLanes &= t),
                      (t = e.entanglements);
                    var r = e.eventTimes;
                    for (e = e.expirationTimes; 0 < n; ) {
                      var o = 31 - it(n),
                        a = 1 << o;
                      (t[o] = 0), (r[o] = -1), (e[o] = -1), (n &= ~a);
                    }
                  })(e, i),
                  e === Il && ((Ml = Il = null), (jl = 0)),
                  (0 == (2064 & n.subtreeFlags) && 0 == (2064 & n.flags)) ||
                    Kl ||
                    ((Kl = !0),
                    Id(tt, function () {
                      return xd(), null;
                    })),
                  (i = 0 != (15990 & n.flags)),
                  0 != (15990 & n.subtreeFlags) || i)
                ) {
                  (i = Ol.transition), (Ol.transition = null);
                  var s = _t;
                  _t = 1;
                  var l = Tl;
                  (Tl |= 4),
                    (wl.current = null),
                    (function (e, t) {
                      if (((eo = Wt), mr((e = pr())))) {
                        if ("selectionStart" in e)
                          var n = {
                            start: e.selectionStart,
                            end: e.selectionEnd,
                          };
                        else
                          e: {
                            var r =
                              (n =
                                ((n = e.ownerDocument) && n.defaultView) ||
                                window).getSelection && n.getSelection();
                            if (r && 0 !== r.rangeCount) {
                              n = r.anchorNode;
                              var o = r.anchorOffset,
                                i = r.focusNode;
                              r = r.focusOffset;
                              try {
                                n.nodeType, i.nodeType;
                              } catch (e) {
                                n = null;
                                break e;
                              }
                              var s = 0,
                                l = -1,
                                d = -1,
                                c = 0,
                                u = 0,
                                p = e,
                                m = null;
                              t: for (;;) {
                                for (
                                  var h;
                                  p !== n ||
                                    (0 !== o && 3 !== p.nodeType) ||
                                    (l = s + o),
                                    p !== i ||
                                      (0 !== r && 3 !== p.nodeType) ||
                                      (d = s + r),
                                    3 === p.nodeType &&
                                      (s += p.nodeValue.length),
                                    null !== (h = p.firstChild);

                                )
                                  (m = p), (p = h);
                                for (;;) {
                                  if (p === e) break t;
                                  if (
                                    (m === n && ++c === o && (l = s),
                                    m === i && ++u === r && (d = s),
                                    null !== (h = p.nextSibling))
                                  )
                                    break;
                                  m = (p = m).parentNode;
                                }
                                p = h;
                              }
                              n =
                                -1 === l || -1 === d
                                  ? null
                                  : { start: l, end: d };
                            } else n = null;
                          }
                        n = n || { start: 0, end: 0 };
                      } else n = null;
                      for (
                        to = { focusedElem: e, selectionRange: n },
                          Wt = !1,
                          Js = t;
                        null !== Js;

                      )
                        if (
                          ((e = (t = Js).child),
                          0 != (1028 & t.subtreeFlags) && null !== e)
                        )
                          (e.return = t), (Js = e);
                        else
                          for (; null !== Js; ) {
                            t = Js;
                            try {
                              var f = t.alternate;
                              if (0 != (1024 & t.flags))
                                switch (t.tag) {
                                  case 0:
                                  case 11:
                                  case 15:
                                  case 5:
                                  case 6:
                                  case 4:
                                  case 17:
                                    break;
                                  case 1:
                                    if (null !== f) {
                                      var g = f.memoizedProps,
                                        v = f.memoizedState,
                                        b = t.stateNode,
                                        _ = b.getSnapshotBeforeUpdate(
                                          t.elementType === t.type
                                            ? g
                                            : ns(t.type, g),
                                          v
                                        );
                                      b.__reactInternalSnapshotBeforeUpdate = _;
                                    }
                                    break;
                                  case 3:
                                    var y = t.stateNode.containerInfo;
                                    1 === y.nodeType
                                      ? (y.textContent = "")
                                      : 9 === y.nodeType &&
                                        y.documentElement &&
                                        y.removeChild(y.documentElement);
                                    break;
                                  default:
                                    throw Error(a(163));
                                }
                            } catch (e) {
                              kd(t, t.return, e);
                            }
                            if (null !== (e = t.sibling)) {
                              (e.return = t.return), (Js = e);
                              break;
                            }
                            Js = t.return;
                          }
                      (f = tl), (tl = !1);
                    })(e, n),
                    gl(n, e),
                    hr(to),
                    (Wt = !!eo),
                    (to = eo = null),
                    (e.current = n),
                    bl(n, e, o),
                    Qe(),
                    (Tl = l),
                    (_t = s),
                    (Ol.transition = i);
                } else e.current = n;
                if (
                  (Kl && ((Kl = !1), (Gl = e), (ql = o)),
                  0 === (i = e.pendingLanes) && ($l = null),
                  (function (e) {
                    if (at && "function" == typeof at.onCommitFiberRoot)
                      try {
                        at.onCommitFiberRoot(
                          ot,
                          e,
                          void 0,
                          128 == (128 & e.current.flags)
                        );
                      } catch (e) {}
                  })(n.stateNode),
                  rd(e, Ye()),
                  null !== t)
                )
                  for (r = e.onRecoverableError, n = 0; n < t.length; n++)
                    r((o = t[n]).value, {
                      componentStack: o.stack,
                      digest: o.digest,
                    });
                if (Wl) throw ((Wl = !1), (e = Ul), (Ul = null), e);
                0 != (1 & ql) && 0 !== e.tag && xd(),
                  0 != (1 & (i = e.pendingLanes))
                    ? e === Yl
                      ? Ql++
                      : ((Ql = 0), (Yl = e))
                    : (Ql = 0),
                  Vo();
              })(e, t, n, r);
          } finally {
            (Ol.transition = o), (_t = r);
          }
          return null;
        }
        function xd() {
          if (null !== Gl) {
            var e = yt(ql),
              t = Ol.transition,
              n = _t;
            try {
              if (((Ol.transition = null), (_t = 16 > e ? 16 : e), null === Gl))
                var r = !1;
              else {
                if (((e = Gl), (Gl = null), (ql = 0), 0 != (6 & Tl)))
                  throw Error(a(331));
                var o = Tl;
                for (Tl |= 4, Js = e.current; null !== Js; ) {
                  var i = Js,
                    s = i.child;
                  if (0 != (16 & Js.flags)) {
                    var l = i.deletions;
                    if (null !== l) {
                      for (var d = 0; d < l.length; d++) {
                        var c = l[d];
                        for (Js = c; null !== Js; ) {
                          var u = Js;
                          switch (u.tag) {
                            case 0:
                            case 11:
                            case 15:
                              nl(8, u, i);
                          }
                          var p = u.child;
                          if (null !== p) (p.return = u), (Js = p);
                          else
                            for (; null !== Js; ) {
                              var m = (u = Js).sibling,
                                h = u.return;
                              if ((al(u), u === c)) {
                                Js = null;
                                break;
                              }
                              if (null !== m) {
                                (m.return = h), (Js = m);
                                break;
                              }
                              Js = h;
                            }
                        }
                      }
                      var f = i.alternate;
                      if (null !== f) {
                        var g = f.child;
                        if (null !== g) {
                          f.child = null;
                          do {
                            var v = g.sibling;
                            (g.sibling = null), (g = v);
                          } while (null !== g);
                        }
                      }
                      Js = i;
                    }
                  }
                  if (0 != (2064 & i.subtreeFlags) && null !== s)
                    (s.return = i), (Js = s);
                  else
                    e: for (; null !== Js; ) {
                      if (0 != (2048 & (i = Js).flags))
                        switch (i.tag) {
                          case 0:
                          case 11:
                          case 15:
                            nl(9, i, i.return);
                        }
                      var b = i.sibling;
                      if (null !== b) {
                        (b.return = i.return), (Js = b);
                        break e;
                      }
                      Js = i.return;
                    }
                }
                var _ = e.current;
                for (Js = _; null !== Js; ) {
                  var y = (s = Js).child;
                  if (0 != (2064 & s.subtreeFlags) && null !== y)
                    (y.return = s), (Js = y);
                  else
                    e: for (s = _; null !== Js; ) {
                      if (0 != (2048 & (l = Js).flags))
                        try {
                          switch (l.tag) {
                            case 0:
                            case 11:
                            case 15:
                              rl(9, l);
                          }
                        } catch (e) {
                          kd(l, l.return, e);
                        }
                      if (l === s) {
                        Js = null;
                        break e;
                      }
                      var C = l.sibling;
                      if (null !== C) {
                        (C.return = l.return), (Js = C);
                        break e;
                      }
                      Js = l.return;
                    }
                }
                if (
                  ((Tl = o),
                  Vo(),
                  at && "function" == typeof at.onPostCommitFiberRoot)
                )
                  try {
                    at.onPostCommitFiberRoot(ot, e);
                  } catch (e) {}
                r = !0;
              }
              return r;
            } finally {
              (_t = n), (Ol.transition = t);
            }
          }
          return !1;
        }
        function Sd(e, t, n) {
          (e = Fa(e, (t = ms(0, (t = ds(n, t)), 1)), 1)),
            (t = ed()),
            null !== e && (vt(e, 1, t), rd(e, t));
        }
        function kd(e, t, n) {
          if (3 === e.tag) Sd(e, e, n);
          else
            for (; null !== t; ) {
              if (3 === t.tag) {
                Sd(t, e, n);
                break;
              }
              if (1 === t.tag) {
                var r = t.stateNode;
                if (
                  "function" == typeof t.type.getDerivedStateFromError ||
                  ("function" == typeof r.componentDidCatch &&
                    (null === $l || !$l.has(r)))
                ) {
                  (t = Fa(t, (e = hs(t, (e = ds(n, e)), 1)), 1)),
                    (e = ed()),
                    null !== t && (vt(t, 1, e), rd(t, e));
                  break;
                }
              }
              t = t.return;
            }
        }
        function Pd(e, t, n) {
          var r = e.pingCache;
          null !== r && r.delete(t),
            (t = ed()),
            (e.pingedLanes |= e.suspendedLanes & n),
            Il === e &&
              (jl & n) === n &&
              (4 === Al ||
              (3 === Al && (130023424 & jl) === jl && 500 > Ye() - Zl)
                ? pd(e, 0)
                : (Bl |= n)),
            rd(e, t);
        }
        function wd(e, t) {
          0 === t &&
            (0 == (1 & e.mode)
              ? (t = 1)
              : ((t = ct), 0 == (130023424 & (ct <<= 1)) && (ct = 4194304)));
          var n = ed();
          null !== (e = Ea(e, t)) && (vt(e, t, n), rd(e, n));
        }
        function Od(e) {
          var t = e.memoizedState,
            n = 0;
          null !== t && (n = t.retryLane), wd(e, n);
        }
        function Td(e, t) {
          var n = 0;
          switch (e.tag) {
            case 13:
              var r = e.stateNode,
                o = e.memoizedState;
              null !== o && (n = o.retryLane);
              break;
            case 19:
              r = e.stateNode;
              break;
            default:
              throw Error(a(314));
          }
          null !== r && r.delete(t), wd(e, n);
        }
        function Id(e, t) {
          return Ke(e, t);
        }
        function Md(e, t, n, r) {
          (this.tag = e),
            (this.key = n),
            (this.sibling =
              this.child =
              this.return =
              this.stateNode =
              this.type =
              this.elementType =
                null),
            (this.index = 0),
            (this.ref = null),
            (this.pendingProps = t),
            (this.dependencies =
              this.memoizedState =
              this.updateQueue =
              this.memoizedProps =
                null),
            (this.mode = r),
            (this.subtreeFlags = this.flags = 0),
            (this.deletions = null),
            (this.childLanes = this.lanes = 0),
            (this.alternate = null);
        }
        function jd(e, t, n, r) {
          return new Md(e, t, n, r);
        }
        function Nd(e) {
          return !(!(e = e.prototype) || !e.isReactComponent);
        }
        function Dd(e, t) {
          var n = e.alternate;
          return (
            null === n
              ? (((n = jd(e.tag, t, e.key, e.mode)).elementType =
                  e.elementType),
                (n.type = e.type),
                (n.stateNode = e.stateNode),
                (n.alternate = e),
                (e.alternate = n))
              : ((n.pendingProps = t),
                (n.type = e.type),
                (n.flags = 0),
                (n.subtreeFlags = 0),
                (n.deletions = null)),
            (n.flags = 14680064 & e.flags),
            (n.childLanes = e.childLanes),
            (n.lanes = e.lanes),
            (n.child = e.child),
            (n.memoizedProps = e.memoizedProps),
            (n.memoizedState = e.memoizedState),
            (n.updateQueue = e.updateQueue),
            (t = e.dependencies),
            (n.dependencies =
              null === t
                ? null
                : { lanes: t.lanes, firstContext: t.firstContext }),
            (n.sibling = e.sibling),
            (n.index = e.index),
            (n.ref = e.ref),
            n
          );
        }
        function Ad(e, t, n, r, o, i) {
          var s = 2;
          if (((r = e), "function" == typeof e)) Nd(e) && (s = 1);
          else if ("string" == typeof e) s = 5;
          else
            e: switch (e) {
              case S:
                return Ed(n.children, o, i, t);
              case k:
                (s = 8), (o |= 8);
                break;
              case P:
                return (
                  ((e = jd(12, n, t, 2 | o)).elementType = P), (e.lanes = i), e
                );
              case I:
                return (
                  ((e = jd(13, n, t, o)).elementType = I), (e.lanes = i), e
                );
              case M:
                return (
                  ((e = jd(19, n, t, o)).elementType = M), (e.lanes = i), e
                );
              case D:
                return Rd(n, o, i, t);
              default:
                if ("object" == typeof e && null !== e)
                  switch (e.$$typeof) {
                    case w:
                      s = 10;
                      break e;
                    case O:
                      s = 9;
                      break e;
                    case T:
                      s = 11;
                      break e;
                    case j:
                      s = 14;
                      break e;
                    case N:
                      (s = 16), (r = null);
                      break e;
                  }
                throw Error(a(130, null == e ? e : typeof e, ""));
            }
          return (
            ((t = jd(s, n, t, o)).elementType = e),
            (t.type = r),
            (t.lanes = i),
            t
          );
        }
        function Ed(e, t, n, r) {
          return ((e = jd(7, e, r, t)).lanes = n), e;
        }
        function Rd(e, t, n, r) {
          return (
            ((e = jd(22, e, r, t)).elementType = D),
            (e.lanes = n),
            (e.stateNode = { isHidden: !1 }),
            e
          );
        }
        function Ld(e, t, n) {
          return ((e = jd(6, e, null, t)).lanes = n), e;
        }
        function Bd(e, t, n) {
          return (
            ((t = jd(
              4,
              null !== e.children ? e.children : [],
              e.key,
              t
            )).lanes = n),
            (t.stateNode = {
              containerInfo: e.containerInfo,
              pendingChildren: null,
              implementation: e.implementation,
            }),
            t
          );
        }
        function zd(e, t, n, r, o) {
          (this.tag = t),
            (this.containerInfo = e),
            (this.finishedWork =
              this.pingCache =
              this.current =
              this.pendingChildren =
                null),
            (this.timeoutHandle = -1),
            (this.callbackNode = this.pendingContext = this.context = null),
            (this.callbackPriority = 0),
            (this.eventTimes = gt(0)),
            (this.expirationTimes = gt(-1)),
            (this.entangledLanes =
              this.finishedLanes =
              this.mutableReadLanes =
              this.expiredLanes =
              this.pingedLanes =
              this.suspendedLanes =
              this.pendingLanes =
                0),
            (this.entanglements = gt(0)),
            (this.identifierPrefix = r),
            (this.onRecoverableError = o),
            (this.mutableSourceEagerHydrationData = null);
        }
        function Fd(e, t, n, r, o, a, i, s, l) {
          return (
            (e = new zd(e, t, n, s, l)),
            1 === t ? ((t = 1), !0 === a && (t |= 8)) : (t = 0),
            (a = jd(3, null, null, t)),
            (e.current = a),
            (a.stateNode = e),
            (a.memoizedState = {
              element: r,
              isDehydrated: n,
              cache: null,
              transitions: null,
              pendingSuspenseBoundaries: null,
            }),
            La(a),
            e
          );
        }
        function Zd(e) {
          if (!e) return To;
          e: {
            if (He((e = e._reactInternals)) !== e || 1 !== e.tag)
              throw Error(a(170));
            var t = e;
            do {
              switch (t.tag) {
                case 3:
                  t = t.stateNode.context;
                  break e;
                case 1:
                  if (Do(t.type)) {
                    t = t.stateNode.__reactInternalMemoizedMergedChildContext;
                    break e;
                  }
              }
              t = t.return;
            } while (null !== t);
            throw Error(a(171));
          }
          if (1 === e.tag) {
            var n = e.type;
            if (Do(n)) return Ro(e, n, t);
          }
          return t;
        }
        function Hd(e, t, n, r, o, a, i, s, l) {
          return (
            ((e = Fd(n, r, !0, e, 0, a, 0, s, l)).context = Zd(null)),
            (n = e.current),
            ((a = za((r = ed()), (o = td(n)))).callback = null != t ? t : null),
            Fa(n, a, o),
            (e.current.lanes = o),
            vt(e, o, r),
            rd(e, r),
            e
          );
        }
        function Vd(e, t, n, r) {
          var o = t.current,
            a = ed(),
            i = td(o);
          return (
            (n = Zd(n)),
            null === t.context ? (t.context = n) : (t.pendingContext = n),
            ((t = za(a, i)).payload = { element: e }),
            null !== (r = void 0 === r ? null : r) && (t.callback = r),
            null !== (e = Fa(o, t, i)) && (nd(e, o, i, a), Za(e, o, i)),
            i
          );
        }
        function Wd(e) {
          return (e = e.current).child
            ? (e.child.tag, e.child.stateNode)
            : null;
        }
        function Ud(e, t) {
          if (null !== (e = e.memoizedState) && null !== e.dehydrated) {
            var n = e.retryLane;
            e.retryLane = 0 !== n && n < t ? n : t;
          }
        }
        function $d(e, t) {
          Ud(e, t), (e = e.alternate) && Ud(e, t);
        }
        Sl = function (e, t, n) {
          if (null !== e)
            if (e.memoizedProps !== t.pendingProps || Mo.current) _s = !0;
            else {
              if (0 == (e.lanes & n) && 0 == (128 & t.flags))
                return (
                  (_s = !1),
                  (function (e, t, n) {
                    switch (t.tag) {
                      case 3:
                        Is(t), ha();
                        break;
                      case 5:
                        Ja(t);
                        break;
                      case 1:
                        Do(t.type) && Lo(t);
                        break;
                      case 4:
                        Qa(t, t.stateNode.containerInfo);
                        break;
                      case 10:
                        var r = t.type._context,
                          o = t.memoizedProps.value;
                        Oo(Sa, r._currentValue), (r._currentValue = o);
                        break;
                      case 13:
                        if (null !== (r = t.memoizedState))
                          return null !== r.dehydrated
                            ? (Oo(ei, 1 & ei.current), (t.flags |= 128), null)
                            : 0 != (n & t.child.childLanes)
                            ? Ls(e, t, n)
                            : (Oo(ei, 1 & ei.current),
                              null !== (e = Ws(e, t, n)) ? e.sibling : null);
                        Oo(ei, 1 & ei.current);
                        break;
                      case 19:
                        if (
                          ((r = 0 != (n & t.childLanes)), 0 != (128 & e.flags))
                        ) {
                          if (r) return Hs(e, t, n);
                          t.flags |= 128;
                        }
                        if (
                          (null !== (o = t.memoizedState) &&
                            ((o.rendering = null),
                            (o.tail = null),
                            (o.lastEffect = null)),
                          Oo(ei, ei.current),
                          r)
                        )
                          break;
                        return null;
                      case 22:
                      case 23:
                        return (t.lanes = 0), ks(e, t, n);
                    }
                    return Ws(e, t, n);
                  })(e, t, n)
                );
              _s = 0 != (131072 & e.flags);
            }
          else (_s = !1), aa && 0 != (1048576 & t.flags) && ea(t, Ko, t.index);
          switch (((t.lanes = 0), t.tag)) {
            case 2:
              var r = t.type;
              Vs(e, t), (e = t.pendingProps);
              var o = No(t, Io.current);
              Ma(t, n), (o = gi(null, t, r, e, o, n));
              var i = vi();
              return (
                (t.flags |= 1),
                "object" == typeof o &&
                null !== o &&
                "function" == typeof o.render &&
                void 0 === o.$$typeof
                  ? ((t.tag = 1),
                    (t.memoizedState = null),
                    (t.updateQueue = null),
                    Do(r) ? ((i = !0), Lo(t)) : (i = !1),
                    (t.memoizedState =
                      null !== o.state && void 0 !== o.state ? o.state : null),
                    La(t),
                    (o.updater = os),
                    (t.stateNode = o),
                    (o._reactInternals = t),
                    ls(t, r, e, n),
                    (t = Ts(null, t, r, !0, i, n)))
                  : ((t.tag = 0),
                    aa && i && ta(t),
                    ys(null, t, o, n),
                    (t = t.child)),
                t
              );
            case 16:
              r = t.elementType;
              e: {
                switch (
                  (Vs(e, t),
                  (e = t.pendingProps),
                  (r = (o = r._init)(r._payload)),
                  (t.type = r),
                  (o = t.tag =
                    (function (e) {
                      if ("function" == typeof e) return Nd(e) ? 1 : 0;
                      if (null != e) {
                        if ((e = e.$$typeof) === T) return 11;
                        if (e === j) return 14;
                      }
                      return 2;
                    })(r)),
                  (e = ns(r, e)),
                  o)
                ) {
                  case 0:
                    t = ws(null, t, r, e, n);
                    break e;
                  case 1:
                    t = Os(null, t, r, e, n);
                    break e;
                  case 11:
                    t = Cs(null, t, r, e, n);
                    break e;
                  case 14:
                    t = xs(null, t, r, ns(r.type, e), n);
                    break e;
                }
                throw Error(a(306, r, ""));
              }
              return t;
            case 0:
              return (
                (r = t.type),
                (o = t.pendingProps),
                ws(e, t, r, (o = t.elementType === r ? o : ns(r, o)), n)
              );
            case 1:
              return (
                (r = t.type),
                (o = t.pendingProps),
                Os(e, t, r, (o = t.elementType === r ? o : ns(r, o)), n)
              );
            case 3:
              e: {
                if ((Is(t), null === e)) throw Error(a(387));
                (r = t.pendingProps),
                  (o = (i = t.memoizedState).element),
                  Ba(e, t),
                  Va(t, r, null, n);
                var s = t.memoizedState;
                if (((r = s.element), i.isDehydrated)) {
                  if (
                    ((i = {
                      element: r,
                      isDehydrated: !1,
                      cache: s.cache,
                      pendingSuspenseBoundaries: s.pendingSuspenseBoundaries,
                      transitions: s.transitions,
                    }),
                    (t.updateQueue.baseState = i),
                    (t.memoizedState = i),
                    256 & t.flags)
                  ) {
                    t = Ms(e, t, r, n, (o = ds(Error(a(423)), t)));
                    break e;
                  }
                  if (r !== o) {
                    t = Ms(e, t, r, n, (o = ds(Error(a(424)), t)));
                    break e;
                  }
                  for (
                    oa = co(t.stateNode.containerInfo.firstChild),
                      ra = t,
                      aa = !0,
                      ia = null,
                      n = xa(t, null, r, n),
                      t.child = n;
                    n;

                  )
                    (n.flags = (-3 & n.flags) | 4096), (n = n.sibling);
                } else {
                  if ((ha(), r === o)) {
                    t = Ws(e, t, n);
                    break e;
                  }
                  ys(e, t, r, n);
                }
                t = t.child;
              }
              return t;
            case 5:
              return (
                Ja(t),
                null === e && ca(t),
                (r = t.type),
                (o = t.pendingProps),
                (i = null !== e ? e.memoizedProps : null),
                (s = o.children),
                no(r, o)
                  ? (s = null)
                  : null !== i && no(r, i) && (t.flags |= 32),
                Ps(e, t),
                ys(e, t, s, n),
                t.child
              );
            case 6:
              return null === e && ca(t), null;
            case 13:
              return Ls(e, t, n);
            case 4:
              return (
                Qa(t, t.stateNode.containerInfo),
                (r = t.pendingProps),
                null === e ? (t.child = Ca(t, null, r, n)) : ys(e, t, r, n),
                t.child
              );
            case 11:
              return (
                (r = t.type),
                (o = t.pendingProps),
                Cs(e, t, r, (o = t.elementType === r ? o : ns(r, o)), n)
              );
            case 7:
              return ys(e, t, t.pendingProps, n), t.child;
            case 8:
            case 12:
              return ys(e, t, t.pendingProps.children, n), t.child;
            case 10:
              e: {
                if (
                  ((r = t.type._context),
                  (o = t.pendingProps),
                  (i = t.memoizedProps),
                  (s = o.value),
                  Oo(Sa, r._currentValue),
                  (r._currentValue = s),
                  null !== i)
                )
                  if (sr(i.value, s)) {
                    if (i.children === o.children && !Mo.current) {
                      t = Ws(e, t, n);
                      break e;
                    }
                  } else
                    for (
                      null !== (i = t.child) && (i.return = t);
                      null !== i;

                    ) {
                      var l = i.dependencies;
                      if (null !== l) {
                        s = i.child;
                        for (var d = l.firstContext; null !== d; ) {
                          if (d.context === r) {
                            if (1 === i.tag) {
                              (d = za(-1, n & -n)).tag = 2;
                              var c = i.updateQueue;
                              if (null !== c) {
                                var u = (c = c.shared).pending;
                                null === u
                                  ? (d.next = d)
                                  : ((d.next = u.next), (u.next = d)),
                                  (c.pending = d);
                              }
                            }
                            (i.lanes |= n),
                              null !== (d = i.alternate) && (d.lanes |= n),
                              Ia(i.return, n, t),
                              (l.lanes |= n);
                            break;
                          }
                          d = d.next;
                        }
                      } else if (10 === i.tag)
                        s = i.type === t.type ? null : i.child;
                      else if (18 === i.tag) {
                        if (null === (s = i.return)) throw Error(a(341));
                        (s.lanes |= n),
                          null !== (l = s.alternate) && (l.lanes |= n),
                          Ia(s, n, t),
                          (s = i.sibling);
                      } else s = i.child;
                      if (null !== s) s.return = i;
                      else
                        for (s = i; null !== s; ) {
                          if (s === t) {
                            s = null;
                            break;
                          }
                          if (null !== (i = s.sibling)) {
                            (i.return = s.return), (s = i);
                            break;
                          }
                          s = s.return;
                        }
                      i = s;
                    }
                ys(e, t, o.children, n), (t = t.child);
              }
              return t;
            case 9:
              return (
                (o = t.type),
                (r = t.pendingProps.children),
                Ma(t, n),
                (r = r((o = ja(o)))),
                (t.flags |= 1),
                ys(e, t, r, n),
                t.child
              );
            case 14:
              return (
                (o = ns((r = t.type), t.pendingProps)),
                xs(e, t, r, (o = ns(r.type, o)), n)
              );
            case 15:
              return Ss(e, t, t.type, t.pendingProps, n);
            case 17:
              return (
                (r = t.type),
                (o = t.pendingProps),
                (o = t.elementType === r ? o : ns(r, o)),
                Vs(e, t),
                (t.tag = 1),
                Do(r) ? ((e = !0), Lo(t)) : (e = !1),
                Ma(t, n),
                is(t, r, o),
                ls(t, r, o, n),
                Ts(null, t, r, !0, e, n)
              );
            case 19:
              return Hs(e, t, n);
            case 22:
              return ks(e, t, n);
          }
          throw Error(a(156, t.tag));
        };
        var Kd =
          "function" == typeof reportError
            ? reportError
            : function (e) {
                console.error(e);
              };
        function Gd(e) {
          this._internalRoot = e;
        }
        function qd(e) {
          this._internalRoot = e;
        }
        function Qd(e) {
          return !(
            !e ||
            (1 !== e.nodeType && 9 !== e.nodeType && 11 !== e.nodeType)
          );
        }
        function Yd(e) {
          return !(
            !e ||
            (1 !== e.nodeType &&
              9 !== e.nodeType &&
              11 !== e.nodeType &&
              (8 !== e.nodeType ||
                " react-mount-point-unstable " !== e.nodeValue))
          );
        }
        function Jd() {}
        function Xd(e, t, n, r, o) {
          var a = n._reactRootContainer;
          if (a) {
            var i = a;
            if ("function" == typeof o) {
              var s = o;
              o = function () {
                var e = Wd(i);
                s.call(e);
              };
            }
            Vd(t, i, e, o);
          } else
            i = (function (e, t, n, r, o) {
              if (o) {
                if ("function" == typeof r) {
                  var a = r;
                  r = function () {
                    var e = Wd(i);
                    a.call(e);
                  };
                }
                var i = Hd(t, r, e, 0, null, !1, 0, "", Jd);
                return (
                  (e._reactRootContainer = i),
                  (e[fo] = i.current),
                  Hr(8 === e.nodeType ? e.parentNode : e),
                  cd(),
                  i
                );
              }
              for (; (o = e.lastChild); ) e.removeChild(o);
              if ("function" == typeof r) {
                var s = r;
                r = function () {
                  var e = Wd(l);
                  s.call(e);
                };
              }
              var l = Fd(e, 0, !1, null, 0, !1, 0, "", Jd);
              return (
                (e._reactRootContainer = l),
                (e[fo] = l.current),
                Hr(8 === e.nodeType ? e.parentNode : e),
                cd(function () {
                  Vd(t, l, n, r);
                }),
                l
              );
            })(n, t, e, o, r);
          return Wd(i);
        }
        (qd.prototype.render = Gd.prototype.render =
          function (e) {
            var t = this._internalRoot;
            if (null === t) throw Error(a(409));
            Vd(e, t, null, null);
          }),
          (qd.prototype.unmount = Gd.prototype.unmount =
            function () {
              var e = this._internalRoot;
              if (null !== e) {
                this._internalRoot = null;
                var t = e.containerInfo;
                cd(function () {
                  Vd(null, e, null, null);
                }),
                  (t[fo] = null);
              }
            }),
          (qd.prototype.unstable_scheduleHydration = function (e) {
            if (e) {
              var t = kt();
              e = { blockedOn: null, target: e, priority: t };
              for (
                var n = 0;
                n < Dt.length && 0 !== t && t < Dt[n].priority;
                n++
              );
              Dt.splice(n, 0, e), 0 === n && Lt(e);
            }
          }),
          (Ct = function (e) {
            switch (e.tag) {
              case 3:
                var t = e.stateNode;
                if (t.current.memoizedState.isDehydrated) {
                  var n = ut(t.pendingLanes);
                  0 !== n &&
                    (bt(t, 1 | n),
                    rd(t, Ye()),
                    0 == (6 & Tl) && ((Hl = Ye() + 500), Vo()));
                }
                break;
              case 13:
                cd(function () {
                  var t = Ea(e, 1);
                  if (null !== t) {
                    var n = ed();
                    nd(t, e, 1, n);
                  }
                }),
                  $d(e, 1);
            }
          }),
          (xt = function (e) {
            if (13 === e.tag) {
              var t = Ea(e, 134217728);
              null !== t && nd(t, e, 134217728, ed()), $d(e, 134217728);
            }
          }),
          (St = function (e) {
            if (13 === e.tag) {
              var t = td(e),
                n = Ea(e, t);
              null !== n && nd(n, e, t, ed()), $d(e, t);
            }
          }),
          (kt = function () {
            return _t;
          }),
          (Pt = function (e, t) {
            var n = _t;
            try {
              return (_t = e), t();
            } finally {
              _t = n;
            }
          }),
          (xe = function (e, t, n) {
            switch (t) {
              case "input":
                if ((J(e, n), (t = n.name), "radio" === n.type && null != t)) {
                  for (n = e; n.parentNode; ) n = n.parentNode;
                  for (
                    n = n.querySelectorAll(
                      "input[name=" + JSON.stringify("" + t) + '][type="radio"]'
                    ),
                      t = 0;
                    t < n.length;
                    t++
                  ) {
                    var r = n[t];
                    if (r !== e && r.form === e.form) {
                      var o = xo(r);
                      if (!o) throw Error(a(90));
                      K(r), J(r, o);
                    }
                  }
                }
                break;
              case "textarea":
                ae(e, n);
                break;
              case "select":
                null != (t = n.value) && ne(e, !!n.multiple, t, !1);
            }
          }),
          (Te = dd),
          (Ie = cd);
        var ec = {
            usingClientEntryPoint: !1,
            Events: [yo, Co, xo, we, Oe, dd],
          },
          tc = {
            findFiberByHostInstance: _o,
            bundleType: 0,
            version: "18.3.1",
            rendererPackageName: "react-dom",
          },
          nc = {
            bundleType: tc.bundleType,
            version: tc.version,
            rendererPackageName: tc.rendererPackageName,
            rendererConfig: tc.rendererConfig,
            overrideHookState: null,
            overrideHookStateDeletePath: null,
            overrideHookStateRenamePath: null,
            overrideProps: null,
            overridePropsDeletePath: null,
            overridePropsRenamePath: null,
            setErrorHandler: null,
            setSuspenseHandler: null,
            scheduleUpdate: null,
            currentDispatcherRef: y.ReactCurrentDispatcher,
            findHostInstanceByFiber: function (e) {
              return null === (e = Ue(e)) ? null : e.stateNode;
            },
            findFiberByHostInstance:
              tc.findFiberByHostInstance ||
              function () {
                return null;
              },
            findHostInstancesForRefresh: null,
            scheduleRefresh: null,
            scheduleRoot: null,
            setRefreshHandler: null,
            getCurrentFiber: null,
            reconcilerVersion: "18.3.1-next-f1338f8080-20240426",
          };
        if ("undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
          var rc = __REACT_DEVTOOLS_GLOBAL_HOOK__;
          if (!rc.isDisabled && rc.supportsFiber)
            try {
              (ot = rc.inject(nc)), (at = rc);
            } catch (ce) {}
        }
        (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = ec),
          (t.createPortal = function (e, t) {
            var n =
              2 < arguments.length && void 0 !== arguments[2]
                ? arguments[2]
                : null;
            if (!Qd(t)) throw Error(a(200));
            return (function (e, t, n) {
              var r =
                3 < arguments.length && void 0 !== arguments[3]
                  ? arguments[3]
                  : null;
              return {
                $$typeof: x,
                key: null == r ? null : "" + r,
                children: e,
                containerInfo: t,
                implementation: n,
              };
            })(e, t, null, n);
          }),
          (t.createRoot = function (e, t) {
            if (!Qd(e)) throw Error(a(299));
            var n = !1,
              r = "",
              o = Kd;
            return (
              null != t &&
                (!0 === t.unstable_strictMode && (n = !0),
                void 0 !== t.identifierPrefix && (r = t.identifierPrefix),
                void 0 !== t.onRecoverableError && (o = t.onRecoverableError)),
              (t = Fd(e, 1, !1, null, 0, n, 0, r, o)),
              (e[fo] = t.current),
              Hr(8 === e.nodeType ? e.parentNode : e),
              new Gd(t)
            );
          }),
          (t.findDOMNode = function (e) {
            if (null == e) return null;
            if (1 === e.nodeType) return e;
            var t = e._reactInternals;
            if (void 0 === t) {
              if ("function" == typeof e.render) throw Error(a(188));
              throw ((e = Object.keys(e).join(",")), Error(a(268, e)));
            }
            return null === (e = Ue(t)) ? null : e.stateNode;
          }),
          (t.flushSync = function (e) {
            return cd(e);
          }),
          (t.hydrate = function (e, t, n) {
            if (!Yd(t)) throw Error(a(200));
            return Xd(null, e, t, !0, n);
          }),
          (t.hydrateRoot = function (e, t, n) {
            if (!Qd(e)) throw Error(a(405));
            var r = (null != n && n.hydratedSources) || null,
              o = !1,
              i = "",
              s = Kd;
            if (
              (null != n &&
                (!0 === n.unstable_strictMode && (o = !0),
                void 0 !== n.identifierPrefix && (i = n.identifierPrefix),
                void 0 !== n.onRecoverableError && (s = n.onRecoverableError)),
              (t = Hd(t, null, e, 1, null != n ? n : null, o, 0, i, s)),
              (e[fo] = t.current),
              Hr(e),
              r)
            )
              for (e = 0; e < r.length; e++)
                (o = (o = (n = r[e])._getVersion)(n._source)),
                  null == t.mutableSourceEagerHydrationData
                    ? (t.mutableSourceEagerHydrationData = [n, o])
                    : t.mutableSourceEagerHydrationData.push(n, o);
            return new qd(t);
          }),
          (t.render = function (e, t, n) {
            if (!Yd(t)) throw Error(a(200));
            return Xd(null, e, t, !1, n);
          }),
          (t.unmountComponentAtNode = function (e) {
            if (!Yd(e)) throw Error(a(40));
            return (
              !!e._reactRootContainer &&
              (cd(function () {
                Xd(null, null, e, !1, function () {
                  (e._reactRootContainer = null), (e[fo] = null);
                });
              }),
              !0)
            );
          }),
          (t.unstable_batchedUpdates = dd),
          (t.unstable_renderSubtreeIntoContainer = function (e, t, n, r) {
            if (!Yd(n)) throw Error(a(200));
            if (null == e || void 0 === e._reactInternals) throw Error(a(38));
            return Xd(e, t, n, !1, r);
          }),
          (t.version = "18.3.1-next-f1338f8080-20240426");
      },
      745: function (e, t, n) {
        "use strict";
        var r = n(3935);
        (t.s = r.createRoot), r.hydrateRoot;
      },
      3935: function (e, t, n) {
        "use strict";
        !(function e() {
          if (
            "undefined" != typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ &&
            "function" == typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE
          )
            try {
              __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
            } catch (e) {
              console.error(e);
            }
        })(),
          (e.exports = n(4448));
      },
      8359: function (e, t) {
        "use strict";
        if ("function" == typeof Symbol && Symbol.for) {
          var n = Symbol.for;
          n("react.element"),
            n("react.portal"),
            n("react.fragment"),
            n("react.strict_mode"),
            n("react.profiler"),
            n("react.provider"),
            n("react.context"),
            n("react.forward_ref"),
            n("react.suspense"),
            n("react.suspense_list"),
            n("react.memo"),
            n("react.lazy"),
            n("react.block"),
            n("react.server.block"),
            n("react.fundamental"),
            n("react.debug_trace_mode"),
            n("react.legacy_hidden");
        }
      },
      2973: function (e, t, n) {
        "use strict";
        n(8359);
      },
      5251: function (e, t, n) {
        "use strict";
        var r = n(7294),
          o = Symbol.for("react.element"),
          a = Symbol.for("react.fragment"),
          i = Object.prototype.hasOwnProperty,
          s =
            r.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED
              .ReactCurrentOwner,
          l = { key: !0, ref: !0, __self: !0, __source: !0 };
        function d(e, t, n) {
          var r,
            a = {},
            d = null,
            c = null;
          for (r in (void 0 !== n && (d = "" + n),
          void 0 !== t.key && (d = "" + t.key),
          void 0 !== t.ref && (c = t.ref),
          t))
            i.call(t, r) && !l.hasOwnProperty(r) && (a[r] = t[r]);
          if (e && e.defaultProps)
            for (r in (t = e.defaultProps)) void 0 === a[r] && (a[r] = t[r]);
          return {
            $$typeof: o,
            type: e,
            key: d,
            ref: c,
            props: a,
            _owner: s.current,
          };
        }
        (t.Fragment = a), (t.jsx = d), (t.jsxs = d);
      },
      2408: function (e, t) {
        "use strict";
        var n = Symbol.for("react.element"),
          r = Symbol.for("react.portal"),
          o = Symbol.for("react.fragment"),
          a = Symbol.for("react.strict_mode"),
          i = Symbol.for("react.profiler"),
          s = Symbol.for("react.provider"),
          l = Symbol.for("react.context"),
          d = Symbol.for("react.forward_ref"),
          c = Symbol.for("react.suspense"),
          u = Symbol.for("react.memo"),
          p = Symbol.for("react.lazy"),
          m = Symbol.iterator,
          h = {
            isMounted: function () {
              return !1;
            },
            enqueueForceUpdate: function () {},
            enqueueReplaceState: function () {},
            enqueueSetState: function () {},
          },
          f = Object.assign,
          g = {};
        function v(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || h);
        }
        function b() {}
        function _(e, t, n) {
          (this.props = e),
            (this.context = t),
            (this.refs = g),
            (this.updater = n || h);
        }
        (v.prototype.isReactComponent = {}),
          (v.prototype.setState = function (e, t) {
            if ("object" != typeof e && "function" != typeof e && null != e)
              throw Error(
                "setState(...): takes an object of state variables to update or a function which returns an object of state variables."
              );
            this.updater.enqueueSetState(this, e, t, "setState");
          }),
          (v.prototype.forceUpdate = function (e) {
            this.updater.enqueueForceUpdate(this, e, "forceUpdate");
          }),
          (b.prototype = v.prototype);
        var y = (_.prototype = new b());
        (y.constructor = _), f(y, v.prototype), (y.isPureReactComponent = !0);
        var C = Array.isArray,
          x = Object.prototype.hasOwnProperty,
          S = { current: null },
          k = { key: !0, ref: !0, __self: !0, __source: !0 };
        function P(e, t, r) {
          var o,
            a = {},
            i = null,
            s = null;
          if (null != t)
            for (o in (void 0 !== t.ref && (s = t.ref),
            void 0 !== t.key && (i = "" + t.key),
            t))
              x.call(t, o) && !k.hasOwnProperty(o) && (a[o] = t[o]);
          var l = arguments.length - 2;
          if (1 === l) a.children = r;
          else if (1 < l) {
            for (var d = Array(l), c = 0; c < l; c++) d[c] = arguments[c + 2];
            a.children = d;
          }
          if (e && e.defaultProps)
            for (o in (l = e.defaultProps)) void 0 === a[o] && (a[o] = l[o]);
          return {
            $$typeof: n,
            type: e,
            key: i,
            ref: s,
            props: a,
            _owner: S.current,
          };
        }
        function w(e) {
          return "object" == typeof e && null !== e && e.$$typeof === n;
        }
        var O = /\/+/g;
        function T(e, t) {
          return "object" == typeof e && null !== e && null != e.key
            ? (function (e) {
                var t = { "=": "=0", ":": "=2" };
                return (
                  "$" +
                  e.replace(/[=:]/g, function (e) {
                    return t[e];
                  })
                );
              })("" + e.key)
            : t.toString(36);
        }
        function I(e, t, o, a, i) {
          var s = typeof e;
          ("undefined" !== s && "boolean" !== s) || (e = null);
          var l = !1;
          if (null === e) l = !0;
          else
            switch (s) {
              case "string":
              case "number":
                l = !0;
                break;
              case "object":
                switch (e.$$typeof) {
                  case n:
                  case r:
                    l = !0;
                }
            }
          if (l)
            return (
              (i = i((l = e))),
              (e = "" === a ? "." + T(l, 0) : a),
              C(i)
                ? ((o = ""),
                  null != e && (o = e.replace(O, "$&/") + "/"),
                  I(i, t, o, "", function (e) {
                    return e;
                  }))
                : null != i &&
                  (w(i) &&
                    (i = (function (e, t) {
                      return {
                        $$typeof: n,
                        type: e.type,
                        key: t,
                        ref: e.ref,
                        props: e.props,
                        _owner: e._owner,
                      };
                    })(
                      i,
                      o +
                        (!i.key || (l && l.key === i.key)
                          ? ""
                          : ("" + i.key).replace(O, "$&/") + "/") +
                        e
                    )),
                  t.push(i)),
              1
            );
          if (((l = 0), (a = "" === a ? "." : a + ":"), C(e)))
            for (var d = 0; d < e.length; d++) {
              var c = a + T((s = e[d]), d);
              l += I(s, t, o, c, i);
            }
          else if (
            ((c = (function (e) {
              return null === e || "object" != typeof e
                ? null
                : "function" == typeof (e = (m && e[m]) || e["@@iterator"])
                ? e
                : null;
            })(e)),
            "function" == typeof c)
          )
            for (e = c.call(e), d = 0; !(s = e.next()).done; )
              l += I((s = s.value), t, o, (c = a + T(s, d++)), i);
          else if ("object" === s)
            throw (
              ((t = String(e)),
              Error(
                "Objects are not valid as a React child (found: " +
                  ("[object Object]" === t
                    ? "object with keys {" + Object.keys(e).join(", ") + "}"
                    : t) +
                  "). If you meant to render a collection of children, use an array instead."
              ))
            );
          return l;
        }
        function M(e, t, n) {
          if (null == e) return e;
          var r = [],
            o = 0;
          return (
            I(e, r, "", "", function (e) {
              return t.call(n, e, o++);
            }),
            r
          );
        }
        function j(e) {
          if (-1 === e._status) {
            var t = e._result;
            (t = t()).then(
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 1), (e._result = t));
              },
              function (t) {
                (0 !== e._status && -1 !== e._status) ||
                  ((e._status = 2), (e._result = t));
              }
            ),
              -1 === e._status && ((e._status = 0), (e._result = t));
          }
          if (1 === e._status) return e._result.default;
          throw e._result;
        }
        var N = { current: null },
          D = { transition: null },
          A = {
            ReactCurrentDispatcher: N,
            ReactCurrentBatchConfig: D,
            ReactCurrentOwner: S,
          };
        function E() {
          throw Error(
            "act(...) is not supported in production builds of React."
          );
        }
        (t.Children = {
          map: M,
          forEach: function (e, t, n) {
            M(
              e,
              function () {
                t.apply(this, arguments);
              },
              n
            );
          },
          count: function (e) {
            var t = 0;
            return (
              M(e, function () {
                t++;
              }),
              t
            );
          },
          toArray: function (e) {
            return (
              M(e, function (e) {
                return e;
              }) || []
            );
          },
          only: function (e) {
            if (!w(e))
              throw Error(
                "React.Children.only expected to receive a single React element child."
              );
            return e;
          },
        }),
          (t.Component = v),
          (t.Fragment = o),
          (t.Profiler = i),
          (t.PureComponent = _),
          (t.StrictMode = a),
          (t.Suspense = c),
          (t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = A),
          (t.act = E),
          (t.cloneElement = function (e, t, r) {
            if (null == e)
              throw Error(
                "React.cloneElement(...): The argument must be a React element, but you passed " +
                  e +
                  "."
              );
            var o = f({}, e.props),
              a = e.key,
              i = e.ref,
              s = e._owner;
            if (null != t) {
              if (
                (void 0 !== t.ref && ((i = t.ref), (s = S.current)),
                void 0 !== t.key && (a = "" + t.key),
                e.type && e.type.defaultProps)
              )
                var l = e.type.defaultProps;
              for (d in t)
                x.call(t, d) &&
                  !k.hasOwnProperty(d) &&
                  (o[d] = void 0 === t[d] && void 0 !== l ? l[d] : t[d]);
            }
            var d = arguments.length - 2;
            if (1 === d) o.children = r;
            else if (1 < d) {
              l = Array(d);
              for (var c = 0; c < d; c++) l[c] = arguments[c + 2];
              o.children = l;
            }
            return {
              $$typeof: n,
              type: e.type,
              key: a,
              ref: i,
              props: o,
              _owner: s,
            };
          }),
          (t.createContext = function (e) {
            return (
              ((e = {
                $$typeof: l,
                _currentValue: e,
                _currentValue2: e,
                _threadCount: 0,
                Provider: null,
                Consumer: null,
                _defaultValue: null,
                _globalName: null,
              }).Provider = { $$typeof: s, _context: e }),
              (e.Consumer = e)
            );
          }),
          (t.createElement = P),
          (t.createFactory = function (e) {
            var t = P.bind(null, e);
            return (t.type = e), t;
          }),
          (t.createRef = function () {
            return { current: null };
          }),
          (t.forwardRef = function (e) {
            return { $$typeof: d, render: e };
          }),
          (t.isValidElement = w),
          (t.lazy = function (e) {
            return {
              $$typeof: p,
              _payload: { _status: -1, _result: e },
              _init: j,
            };
          }),
          (t.memo = function (e, t) {
            return { $$typeof: u, type: e, compare: void 0 === t ? null : t };
          }),
          (t.startTransition = function (e) {
            var t = D.transition;
            D.transition = {};
            try {
              e();
            } finally {
              D.transition = t;
            }
          }),
          (t.unstable_act = E),
          (t.useCallback = function (e, t) {
            return N.current.useCallback(e, t);
          }),
          (t.useContext = function (e) {
            return N.current.useContext(e);
          }),
          (t.useDebugValue = function () {}),
          (t.useDeferredValue = function (e) {
            return N.current.useDeferredValue(e);
          }),
          (t.useEffect = function (e, t) {
            return N.current.useEffect(e, t);
          }),
          (t.useId = function () {
            return N.current.useId();
          }),
          (t.useImperativeHandle = function (e, t, n) {
            return N.current.useImperativeHandle(e, t, n);
          }),
          (t.useInsertionEffect = function (e, t) {
            return N.current.useInsertionEffect(e, t);
          }),
          (t.useLayoutEffect = function (e, t) {
            return N.current.useLayoutEffect(e, t);
          }),
          (t.useMemo = function (e, t) {
            return N.current.useMemo(e, t);
          }),
          (t.useReducer = function (e, t, n) {
            return N.current.useReducer(e, t, n);
          }),
          (t.useRef = function (e) {
            return N.current.useRef(e);
          }),
          (t.useState = function (e) {
            return N.current.useState(e);
          }),
          (t.useSyncExternalStore = function (e, t, n) {
            return N.current.useSyncExternalStore(e, t, n);
          }),
          (t.useTransition = function () {
            return N.current.useTransition();
          }),
          (t.version = "18.3.1");
      },
      7294: function (e, t, n) {
        "use strict";
        e.exports = n(2408);
      },
      5893: function (e, t, n) {
        "use strict";
        e.exports = n(5251);
      },
      53: function (e, t) {
        "use strict";
        function n(e, t) {
          var n = e.length;
          e.push(t);
          e: for (; 0 < n; ) {
            var r = (n - 1) >>> 1,
              o = e[r];
            if (!(0 < a(o, t))) break e;
            (e[r] = t), (e[n] = o), (n = r);
          }
        }
        function r(e) {
          return 0 === e.length ? null : e[0];
        }
        function o(e) {
          if (0 === e.length) return null;
          var t = e[0],
            n = e.pop();
          if (n !== t) {
            e[0] = n;
            e: for (var r = 0, o = e.length, i = o >>> 1; r < i; ) {
              var s = 2 * (r + 1) - 1,
                l = e[s],
                d = s + 1,
                c = e[d];
              if (0 > a(l, n))
                d < o && 0 > a(c, l)
                  ? ((e[r] = c), (e[d] = n), (r = d))
                  : ((e[r] = l), (e[s] = n), (r = s));
              else {
                if (!(d < o && 0 > a(c, n))) break e;
                (e[r] = c), (e[d] = n), (r = d);
              }
            }
          }
          return t;
        }
        function a(e, t) {
          var n = e.sortIndex - t.sortIndex;
          return 0 !== n ? n : e.id - t.id;
        }
        if (
          "object" == typeof performance &&
          "function" == typeof performance.now
        ) {
          var i = performance;
          t.unstable_now = function () {
            return i.now();
          };
        } else {
          var s = Date,
            l = s.now();
          t.unstable_now = function () {
            return s.now() - l;
          };
        }
        var d = [],
          c = [],
          u = 1,
          p = null,
          m = 3,
          h = !1,
          f = !1,
          g = !1,
          v = "function" == typeof setTimeout ? setTimeout : null,
          b = "function" == typeof clearTimeout ? clearTimeout : null,
          _ = "undefined" != typeof setImmediate ? setImmediate : null;
        function y(e) {
          for (var t = r(c); null !== t; ) {
            if (null === t.callback) o(c);
            else {
              if (!(t.startTime <= e)) break;
              o(c), (t.sortIndex = t.expirationTime), n(d, t);
            }
            t = r(c);
          }
        }
        function C(e) {
          if (((g = !1), y(e), !f))
            if (null !== r(d)) (f = !0), D(x);
            else {
              var t = r(c);
              null !== t && A(C, t.startTime - e);
            }
        }
        function x(e, n) {
          (f = !1), g && ((g = !1), b(w), (w = -1)), (h = !0);
          var a = m;
          try {
            for (
              y(n), p = r(d);
              null !== p && (!(p.expirationTime > n) || (e && !I()));

            ) {
              var i = p.callback;
              if ("function" == typeof i) {
                (p.callback = null), (m = p.priorityLevel);
                var s = i(p.expirationTime <= n);
                (n = t.unstable_now()),
                  "function" == typeof s
                    ? (p.callback = s)
                    : p === r(d) && o(d),
                  y(n);
              } else o(d);
              p = r(d);
            }
            if (null !== p) var l = !0;
            else {
              var u = r(c);
              null !== u && A(C, u.startTime - n), (l = !1);
            }
            return l;
          } finally {
            (p = null), (m = a), (h = !1);
          }
        }
        "undefined" != typeof navigator &&
          void 0 !== navigator.scheduling &&
          void 0 !== navigator.scheduling.isInputPending &&
          navigator.scheduling.isInputPending.bind(navigator.scheduling);
        var S,
          k = !1,
          P = null,
          w = -1,
          O = 5,
          T = -1;
        function I() {
          return !(t.unstable_now() - T < O);
        }
        function M() {
          if (null !== P) {
            var e = t.unstable_now();
            T = e;
            var n = !0;
            try {
              n = P(!0, e);
            } finally {
              n ? S() : ((k = !1), (P = null));
            }
          } else k = !1;
        }
        if ("function" == typeof _)
          S = function () {
            _(M);
          };
        else if ("undefined" != typeof MessageChannel) {
          var j = new MessageChannel(),
            N = j.port2;
          (j.port1.onmessage = M),
            (S = function () {
              N.postMessage(null);
            });
        } else
          S = function () {
            v(M, 0);
          };
        function D(e) {
          (P = e), k || ((k = !0), S());
        }
        function A(e, n) {
          w = v(function () {
            e(t.unstable_now());
          }, n);
        }
        (t.unstable_IdlePriority = 5),
          (t.unstable_ImmediatePriority = 1),
          (t.unstable_LowPriority = 4),
          (t.unstable_NormalPriority = 3),
          (t.unstable_Profiling = null),
          (t.unstable_UserBlockingPriority = 2),
          (t.unstable_cancelCallback = function (e) {
            e.callback = null;
          }),
          (t.unstable_continueExecution = function () {
            f || h || ((f = !0), D(x));
          }),
          (t.unstable_forceFrameRate = function (e) {
            0 > e || 125 < e
              ? console.error(
                  "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
                )
              : (O = 0 < e ? Math.floor(1e3 / e) : 5);
          }),
          (t.unstable_getCurrentPriorityLevel = function () {
            return m;
          }),
          (t.unstable_getFirstCallbackNode = function () {
            return r(d);
          }),
          (t.unstable_next = function (e) {
            switch (m) {
              case 1:
              case 2:
              case 3:
                var t = 3;
                break;
              default:
                t = m;
            }
            var n = m;
            m = t;
            try {
              return e();
            } finally {
              m = n;
            }
          }),
          (t.unstable_pauseExecution = function () {}),
          (t.unstable_requestPaint = function () {}),
          (t.unstable_runWithPriority = function (e, t) {
            switch (e) {
              case 1:
              case 2:
              case 3:
              case 4:
              case 5:
                break;
              default:
                e = 3;
            }
            var n = m;
            m = e;
            try {
              return t();
            } finally {
              m = n;
            }
          }),
          (t.unstable_scheduleCallback = function (e, o, a) {
            var i = t.unstable_now();
            switch (
              ((a =
                "object" == typeof a &&
                null !== a &&
                "number" == typeof (a = a.delay) &&
                0 < a
                  ? i + a
                  : i),
              e)
            ) {
              case 1:
                var s = -1;
                break;
              case 2:
                s = 250;
                break;
              case 5:
                s = 1073741823;
                break;
              case 4:
                s = 1e4;
                break;
              default:
                s = 5e3;
            }
            return (
              (e = {
                id: u++,
                callback: o,
                priorityLevel: e,
                startTime: a,
                expirationTime: (s = a + s),
                sortIndex: -1,
              }),
              a > i
                ? ((e.sortIndex = a),
                  n(c, e),
                  null === r(d) &&
                    e === r(c) &&
                    (g ? (b(w), (w = -1)) : (g = !0), A(C, a - i)))
                : ((e.sortIndex = s), n(d, e), f || h || ((f = !0), D(x))),
              e
            );
          }),
          (t.unstable_shouldYield = I),
          (t.unstable_wrapCallback = function (e) {
            var t = m;
            return function () {
              var n = m;
              m = t;
              try {
                return e.apply(this, arguments);
              } finally {
                m = n;
              }
            };
          });
      },
      3840: function (e, t, n) {
        "use strict";
        e.exports = n(53);
      },
      1739: function (e) {
        e.exports = {
          area: !0,
          base: !0,
          br: !0,
          col: !0,
          embed: !0,
          hr: !0,
          img: !0,
          input: !0,
          link: !0,
          meta: !0,
          param: !0,
          source: !0,
          track: !0,
          wbr: !0,
        };
      },
      434: function (e) {
        function t() {
          return (
            (e.exports = t =
              Object.assign
                ? Object.assign.bind()
                : function (e) {
                    for (var t = 1; t < arguments.length; t++) {
                      var n = arguments[t];
                      for (var r in n)
                        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
                    }
                    return e;
                  }),
            (e.exports.__esModule = !0),
            (e.exports.default = e.exports),
            t.apply(null, arguments)
          );
        }
        (e.exports = t),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      4836: function (e) {
        (e.exports = function (e) {
          return e && e.__esModule ? e : { default: e };
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      7071: function (e) {
        (e.exports = function (e, t) {
          if (null == e) return {};
          var n = {};
          for (var r in e)
            if ({}.hasOwnProperty.call(e, r)) {
              if (t.includes(r)) continue;
              n[r] = e[r];
            }
          return n;
        }),
          (e.exports.__esModule = !0),
          (e.exports.default = e.exports);
      },
      7462: function (e, t, n) {
        "use strict";
        function r() {
          return (
            (r = Object.assign
              ? Object.assign.bind()
              : function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = arguments[t];
                    for (var r in n)
                      ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
                  }
                  return e;
                }),
            r.apply(null, arguments)
          );
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      3366: function (e, t, n) {
        "use strict";
        function r(e, t) {
          if (null == e) return {};
          var n = {};
          for (var r in e)
            if ({}.hasOwnProperty.call(e, r)) {
              if (t.includes(r)) continue;
              n[r] = e[r];
            }
          return n;
        }
        n.d(t, {
          Z: function () {
            return r;
          },
        });
      },
      3961: function (e, t, n) {
        "use strict";
        function r(e) {
          var t,
            n,
            o = "";
          if ("string" == typeof e || "number" == typeof e) o += e;
          else if ("object" == typeof e)
            if (Array.isArray(e)) {
              var a = e.length;
              for (t = 0; t < a; t++)
                e[t] && (n = r(e[t])) && (o && (o += " "), (o += n));
            } else for (n in e) e[n] && (o && (o += " "), (o += n));
          return o;
        }
        t.Z = function () {
          for (var e, t, n = 0, o = "", a = arguments.length; n < a; n++)
            (e = arguments[n]) && (t = r(e)) && (o && (o += " "), (o += t));
          return o;
        };
      },
    },
    r = {};
  function o(e) {
    var t = r[e];
    if (void 0 !== t) return t.exports;
    var a = (r[e] = { exports: {} });
    return n[e].call(a.exports, a, a.exports, o), a.exports;
  }
  (o.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return o.d(t, { a: t }), t;
  }),
    (t = Object.getPrototypeOf
      ? function (e) {
          return Object.getPrototypeOf(e);
        }
      : function (e) {
          return e.__proto__;
        }),
    (o.t = function (n, r) {
      if ((1 & r && (n = this(n)), 8 & r)) return n;
      if ("object" == typeof n && n) {
        if (4 & r && n.__esModule) return n;
        if (16 & r && "function" == typeof n.then) return n;
      }
      var a = Object.create(null);
      o.r(a);
      var i = {};
      e = e || [null, t({}), t([]), t(t)];
      for (var s = 2 & r && n; "object" == typeof s && !~e.indexOf(s); s = t(s))
        Object.getOwnPropertyNames(s).forEach(function (e) {
          i[e] = function () {
            return n[e];
          };
        });
      return (
        (i.default = function () {
          return n;
        }),
        o.d(a, i),
        a
      );
    }),
    (o.d = function (e, t) {
      for (var n in t)
        o.o(t, n) &&
          !o.o(e, n) &&
          Object.defineProperty(e, n, { enumerable: !0, get: t[n] });
    }),
    (o.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (o.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (o.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (function () {
      "use strict";
      var e = o(5893),
        t = o(7294),
        n = o.t(t, 2),
        r = o(745),
        a = t.createContext(null),
        i = function (e) {
          e();
        },
        s = function () {
          return i;
        },
        l = {
          notify: function () {},
          get: function () {
            return [];
          },
        };
      function d(e, t) {
        var n,
          r = l;
        function o() {
          i.onStateChange && i.onStateChange();
        }
        function a() {
          n ||
            ((n = t ? t.addNestedSub(o) : e.subscribe(o)),
            (r = (function () {
              var e = s(),
                t = null,
                n = null;
              return {
                clear: function () {
                  (t = null), (n = null);
                },
                notify: function () {
                  e(function () {
                    for (var e = t; e; ) e.callback(), (e = e.next);
                  });
                },
                get: function () {
                  for (var e = [], n = t; n; ) e.push(n), (n = n.next);
                  return e;
                },
                subscribe: function (e) {
                  var r = !0,
                    o = (n = { callback: e, next: null, prev: n });
                  return (
                    o.prev ? (o.prev.next = o) : (t = o),
                    function () {
                      r &&
                        null !== t &&
                        ((r = !1),
                        o.next ? (o.next.prev = o.prev) : (n = o.prev),
                        o.prev ? (o.prev.next = o.next) : (t = o.next));
                    }
                  );
                },
              };
            })()));
        }
        var i = {
          addNestedSub: function (e) {
            return a(), r.subscribe(e);
          },
          notifyNestedSubs: function () {
            r.notify();
          },
          handleChangeWrapper: o,
          isSubscribed: function () {
            return Boolean(n);
          },
          trySubscribe: a,
          tryUnsubscribe: function () {
            n && (n(), (n = void 0), r.clear(), (r = l));
          },
          getListeners: function () {
            return r;
          },
        };
        return i;
      }
      var c =
        "undefined" != typeof window &&
        void 0 !== window.document &&
        void 0 !== window.document.createElement
          ? t.useLayoutEffect
          : t.useEffect;
      o(8679), o(2973);
      var u = o(7462);
      function p() {
        return (0, t.useContext)(a);
      }
      function m(e) {
        void 0 === e && (e = a);
        var n =
          e === a
            ? p
            : function () {
                return (0, t.useContext)(e);
              };
        return function () {
          return n().store;
        };
      }
      var h = m();
      function f(e) {
        void 0 === e && (e = a);
        var t = e === a ? h : m(e);
        return function () {
          return t().dispatch;
        };
      }
      var g = f(),
        v = function (e, t) {
          return e === t;
        };
      function b(e) {
        void 0 === e && (e = a);
        var n =
          e === a
            ? p
            : function () {
                return (0, t.useContext)(e);
              };
        return function (e, r) {
          void 0 === r && (r = v);
          var o = n(),
            a = (function (e, n, r, o) {
              var a,
                i = (0, t.useReducer)(function (e) {
                  return e + 1;
                }, 0)[1],
                s = (0, t.useMemo)(
                  function () {
                    return d(r, o);
                  },
                  [r, o]
                ),
                l = (0, t.useRef)(),
                u = (0, t.useRef)(),
                p = (0, t.useRef)(),
                m = (0, t.useRef)(),
                h = r.getState();
              try {
                if (e !== u.current || h !== p.current || l.current) {
                  var f = e(h);
                  a = void 0 !== m.current && n(f, m.current) ? m.current : f;
                } else a = m.current;
              } catch (e) {
                throw (
                  (l.current &&
                    (e.message +=
                      "\nThe error may be correlated with this previous error:\n" +
                      l.current.stack +
                      "\n\n"),
                  e)
                );
              }
              return (
                c(function () {
                  (u.current = e),
                    (p.current = h),
                    (m.current = a),
                    (l.current = void 0);
                }),
                c(
                  function () {
                    function e() {
                      try {
                        var e = r.getState();
                        if (e === p.current) return;
                        var t = u.current(e);
                        if (n(t, m.current)) return;
                        (m.current = t), (p.current = e);
                      } catch (e) {
                        l.current = e;
                      }
                      i();
                    }
                    return (
                      (s.onStateChange = e),
                      s.trySubscribe(),
                      e(),
                      function () {
                        return s.tryUnsubscribe();
                      }
                    );
                  },
                  [r, s]
                ),
                a
              );
            })(e, r, o.store, o.subscription);
          return (0, t.useDebugValue)(a), a;
        };
      }
      var _,
        y = b(),
        C = o(3935);
      function x(e) {
        return (
          (x =
            "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
              ? function (e) {
                  return typeof e;
                }
              : function (e) {
                  return e &&
                    "function" == typeof Symbol &&
                    e.constructor === Symbol &&
                    e !== Symbol.prototype
                    ? "symbol"
                    : typeof e;
                }),
          x(e)
        );
      }
      function S(e) {
        var t = (function (e, t) {
          if ("object" != x(e) || !e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, "string");
            if ("object" != x(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        })(e);
        return "symbol" == x(t) ? t : t + "";
      }
      function k(e, t, n) {
        return (
          (t = S(t)) in e
            ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0,
              })
            : (e[t] = n),
          e
        );
      }
      function P(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function w(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? P(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : P(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function O(e) {
        return (
          "Minified Redux error #" +
          e +
          "; visit https://redux.js.org/Errors?code=" +
          e +
          " for the full message or use the non-minified dev environment for full errors. "
        );
      }
      (_ = C.unstable_batchedUpdates), (i = _);
      var T =
          ("function" == typeof Symbol && Symbol.observable) || "@@observable",
        I = function () {
          return Math.random().toString(36).substring(7).split("").join(".");
        },
        M = {
          INIT: "@@redux/INIT" + I(),
          REPLACE: "@@redux/REPLACE" + I(),
          PROBE_UNKNOWN_ACTION: function () {
            return "@@redux/PROBE_UNKNOWN_ACTION" + I();
          },
        };
      function j() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return 0 === t.length
          ? function (e) {
              return e;
            }
          : 1 === t.length
          ? t[0]
          : t.reduce(function (e, t) {
              return function () {
                return e(t.apply(void 0, arguments));
              };
            });
      }
      function N(e) {
        return function (t) {
          var n = t.dispatch,
            r = t.getState;
          return function (t) {
            return function (o) {
              return "function" == typeof o ? o(n, r, e) : t(o);
            };
          };
        };
      }
      var D = N();
      D.withExtraArgument = N;
      var A,
        E,
        R = D;
      ((E = A || (A = {})).BASE_DATA = "BASE_DATA"),
        (E.ORDERS_DATA = "ORDERS_DATA"),
        (E.VIEW_COUPON_DATA = "VIEW_COUPON_DATA"),
        (E.UPDATE_SINGLE_SALES_REP = "UPDATE_SINGLE_SALES_REP"),
        (E.UPDATE_REP_PROFILE = "UPDATE_REP_PROFILE"),
        (E.CUSTOMER_ADDRESS_DATA = "ADDRESS"),
        (E.PRODUCTS_DATA = "PRODUCTS_DATA"),
        (E.DRAFT_ORDER_DATA = "DRAFT_ORDER_DATA"),
        (E.WHOLESALE_PRICE_DATA = "WHOLESALE_PRICE_DATA"),
        (E.RESET_INITIAL_STATE = "RESET_INITIAL_STATE"),
        (E.EDIT_DRAFT_ORDER = "EDIT_DRAFT_ORDER"),
        (E.ACTIVE_TAB = "ACTIVE_TAB"),
        (E.CREATE_ORDER_TAB = "CREATE_ORDER_TAB"),
        (E.CHECKOUT_CONFIRMATION_POPUP = "CHECKOUT_CONFIRMATION_POPUP"),
        (E.CUSTOMER_DETAILS_CREATE_INVOICE = "CUSTOMER_DETAILS_CREATE_INVOICE"),
        (E.LOCATION_PRICELIST_DATA = "LOCATION_PRICELIST_DATA"),
        (E.PRODUCT_TABLE_DATA = "PRODUCT_TABLE_DATA"),
        (E.CART_SHARE_PRODUCT_DATA = "CART_SHARE_PRODUCT_DATA"),
        (E.COLLECTION_PRODUCTS_DATA = "COLLECTION_PRODUCTS_DATA");
      var L = function () {
          return (
            (L =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            L.apply(this, arguments)
          );
        },
        B = {
          baseData: {},
          ordersData: {},
          viewCouponData: [],
          customerNewUpdatedData: {},
          productsData: [],
          loggedInRepDetails: window.salesteam_bo_props,
          draftOrderData: [],
          wholesalePriceData: {},
          editDraftOrder: {},
          activeTab: {},
          createOrderTab: {},
          checkoutConfirmationPopUp: {},
          customerDetailsCreateInvoice: {},
          locationPricelistData: {},
          productTableData: {
            selectedProductData: [],
            isQuantityError: {},
            isDiscountError: {},
            discountKeyValueObject: {},
            selectedDiscountType: "",
            isDiscoutAppliedInEditDraft: !1,
          },
          cartShareProductData: [],
          collectionProductsData: [],
        },
        z = (function e(t, n, r) {
          var o;
          if (
            ("function" == typeof n && "function" == typeof r) ||
            ("function" == typeof r && "function" == typeof arguments[3])
          )
            throw new Error(O(0));
          if (
            ("function" == typeof n && void 0 === r && ((r = n), (n = void 0)),
            void 0 !== r)
          ) {
            if ("function" != typeof r) throw new Error(O(1));
            return r(e)(t, n);
          }
          if ("function" != typeof t) throw new Error(O(2));
          var a = t,
            i = n,
            s = [],
            l = s,
            d = !1;
          function c() {
            l === s && (l = s.slice());
          }
          function u() {
            if (d) throw new Error(O(3));
            return i;
          }
          function p(e) {
            if ("function" != typeof e) throw new Error(O(4));
            if (d) throw new Error(O(5));
            var t = !0;
            return (
              c(),
              l.push(e),
              function () {
                if (t) {
                  if (d) throw new Error(O(6));
                  (t = !1), c();
                  var n = l.indexOf(e);
                  l.splice(n, 1), (s = null);
                }
              }
            );
          }
          function m(e) {
            if (
              !(function (e) {
                if ("object" != typeof e || null === e) return !1;
                for (var t = e; null !== Object.getPrototypeOf(t); )
                  t = Object.getPrototypeOf(t);
                return Object.getPrototypeOf(e) === t;
              })(e)
            )
              throw new Error(O(7));
            if (void 0 === e.type) throw new Error(O(8));
            if (d) throw new Error(O(9));
            try {
              (d = !0), (i = a(i, e));
            } finally {
              d = !1;
            }
            for (var t = (s = l), n = 0; n < t.length; n++) (0, t[n])();
            return e;
          }
          return (
            m({ type: M.INIT }),
            ((o = {
              dispatch: m,
              subscribe: p,
              getState: u,
              replaceReducer: function (e) {
                if ("function" != typeof e) throw new Error(O(10));
                (a = e), m({ type: M.REPLACE });
              },
            })[T] = function () {
              var e,
                t = p;
              return (
                ((e = {
                  subscribe: function (e) {
                    if ("object" != typeof e || null === e)
                      throw new Error(O(11));
                    function n() {
                      e.next && e.next(u());
                    }
                    return n(), { unsubscribe: t(n) };
                  },
                })[T] = function () {
                  return this;
                }),
                e
              );
            }),
            o
          );
        })(
          (function (e) {
            for (var t = Object.keys(e), n = {}, r = 0; r < t.length; r++) {
              var o = t[r];
              "function" == typeof e[o] && (n[o] = e[o]);
            }
            var a,
              i = Object.keys(n);
            try {
              !(function (e) {
                Object.keys(e).forEach(function (t) {
                  var n = e[t];
                  if (void 0 === n(void 0, { type: M.INIT }))
                    throw new Error(O(12));
                  if (void 0 === n(void 0, { type: M.PROBE_UNKNOWN_ACTION() }))
                    throw new Error(O(13));
                });
              })(n);
            } catch (e) {
              a = e;
            }
            return function (e, t) {
              if ((void 0 === e && (e = {}), a)) throw a;
              for (var r = !1, o = {}, s = 0; s < i.length; s++) {
                var l = i[s],
                  d = n[l],
                  c = e[l],
                  u = d(c, t);
                if (void 0 === u) throw (t && t.type, new Error(O(14)));
                (o[l] = u), (r = r || u !== c);
              }
              return (r = r || i.length !== Object.keys(e).length) ? o : e;
            };
          })({
            salesRepData: function (e, t) {
              switch ((void 0 === e && (e = B), t.type)) {
                case A.BASE_DATA:
                  return L(L({}, e), { baseData: t.payload });
                case A.ORDERS_DATA:
                  return L(L({}, e), { ordersData: t.payload });
                case A.CUSTOMER_ADDRESS_DATA:
                  return L(L({}, e), { customerNewUpdatedData: t.payload });
                case A.PRODUCTS_DATA:
                  return L(L({}, e), { productsData: t.payload });
                case A.VIEW_COUPON_DATA:
                  return L(L({}, e), { viewCouponData: t.payload });
                case A.DRAFT_ORDER_DATA:
                  return L(L({}, e), { draftOrderData: t.payload });
                case A.UPDATE_SINGLE_SALES_REP:
                  return L(L({}, e), {
                    baseData: L(L({}, e.baseData), {
                      SingleSalesRep: t.payload,
                    }),
                  });
                case A.UPDATE_REP_PROFILE:
                  return L(L({}, e), {
                    baseData: L(L({}, e.baseData), {
                      SingleSalesRep: L(L({}, e.baseData.SingleSalesRep), {
                        ProfileImagePath: t.payload,
                      }),
                    }),
                  });
                case A.WHOLESALE_PRICE_DATA:
                  return L(L({}, e), { wholesalePriceData: t.payload });
                case A.RESET_INITIAL_STATE:
                  return L({}, B);
                case A.EDIT_DRAFT_ORDER:
                  return L(L({}, e), { editDraftOrder: t.payload });
                case A.ACTIVE_TAB:
                  return L(L({}, e), { activeTab: t.payload });
                case A.CREATE_ORDER_TAB:
                  return L(L({}, e), { createOrderTab: t.payload });
                case A.CHECKOUT_CONFIRMATION_POPUP:
                  return L(L({}, e), { checkoutConfirmationPopUp: t.payload });
                case A.CUSTOMER_DETAILS_CREATE_INVOICE:
                  return L(L({}, e), {
                    customerDetailsCreateInvoice: t.payload,
                  });
                case A.LOCATION_PRICELIST_DATA:
                  return L(L({}, e), { locationPricelistData: t.payload });
                case A.PRODUCT_TABLE_DATA:
                  return L(L({}, e), { productTableData: t.payload });
                case A.CART_SHARE_PRODUCT_DATA:
                  return L(L({}, e), { cartShareProductData: t.payload });
                case A.COLLECTION_PRODUCTS_DATA:
                  return L(L({}, e), { collectionProductsData: t.payload });
              }
              return e;
            },
          }),
          (window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || j)(
            (function () {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              return function (e) {
                return function () {
                  var n = e.apply(void 0, arguments),
                    r = function () {
                      throw new Error(O(15));
                    },
                    o = {
                      getState: n.getState,
                      dispatch: function () {
                        return r.apply(void 0, arguments);
                      },
                    },
                    a = t.map(function (e) {
                      return e(o);
                    });
                  return (
                    (r = j.apply(void 0, a)(n.dispatch)),
                    w(w({}, n), {}, { dispatch: r })
                  );
                };
              };
            })(R)
          )
        ),
        F = z;
      o(1739), Object.create(null);
      const Z = {};
      function H() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        ($(t[0]) && Z[t[0]]) ||
          ($(t[0]) && (Z[t[0]] = new Date()),
          (function () {
            if (console && console.warn) {
              for (
                var e = arguments.length, t = new Array(e), n = 0;
                n < e;
                n++
              )
                t[n] = arguments[n];
              $(t[0]) && (t[0] = `react-i18next:: ${t[0]}`), console.warn(...t);
            }
          })(...t));
      }
      const V = (e, t) => () => {
          if (e.isInitialized) t();
          else {
            const n = () => {
              setTimeout(() => {
                e.off("initialized", n);
              }, 0),
                t();
            };
            e.on("initialized", n);
          }
        },
        W = (e, t, n) => {
          e.loadNamespaces(t, V(e, n));
        },
        U = (e, t, n, r) => {
          $(n) && (n = [n]),
            n.forEach((t) => {
              e.options.ns.indexOf(t) < 0 && e.options.ns.push(t);
            }),
            e.loadLanguages(t, V(e, r));
        },
        $ = (e) => "string" == typeof e,
        K =
          /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g,
        G = {
          "&amp;": "&",
          "&#38;": "&",
          "&lt;": "<",
          "&#60;": "<",
          "&gt;": ">",
          "&#62;": ">",
          "&apos;": "'",
          "&#39;": "'",
          "&quot;": '"',
          "&#34;": '"',
          "&nbsp;": " ",
          "&#160;": " ",
          "&copy;": "©",
          "&#169;": "©",
          "&reg;": "®",
          "&#174;": "®",
          "&hellip;": "…",
          "&#8230;": "…",
          "&#x2F;": "/",
          "&#47;": "/",
        },
        q = (e) => G[e];
      let Q = {
        bindI18n: "languageChanged",
        bindI18nStore: "",
        transEmptyNodeValue: "",
        transSupportBasicHtmlNodes: !0,
        transWrapTextNodes: "",
        transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
        useSuspense: !0,
        unescape: (e) => e.replace(K, q),
      };
      const Y = (0, t.createContext)();
      class J {
        constructor() {
          this.usedNamespaces = {};
        }
        addUsedNamespaces(e) {
          e.forEach((e) => {
            this.usedNamespaces[e] || (this.usedNamespaces[e] = !0);
          });
        }
        getUsedNamespaces = () => Object.keys(this.usedNamespaces);
      }
      const X = (e, t, n, r) => e.getFixedT(t, n, r),
        ee = function (e) {
          let n =
            arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          const { i18n: r } = n,
            { i18n: o, defaultNS: a } = (0, t.useContext)(Y) || {},
            i = r || o || undefined;
          if (
            (i && !i.reportNamespaces && (i.reportNamespaces = new J()), !i)
          ) {
            H(
              "You will need to pass in an i18next instance by using initReactI18next"
            );
            const e = (e, t) => {
                return $(t)
                  ? t
                  : "object" == typeof (n = t) &&
                    null !== n &&
                    $(t.defaultValue)
                  ? t.defaultValue
                  : Array.isArray(e)
                  ? e[e.length - 1]
                  : e;
                var n;
              },
              t = [e, {}, !1];
            return (t.t = e), (t.i18n = {}), (t.ready = !1), t;
          }
          i.options.react &&
            void 0 !== i.options.react.wait &&
            H(
              "It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour."
            );
          const s = { ...Q, ...i.options.react, ...n },
            { useSuspense: l, keyPrefix: d } = s;
          let c = e || a || (i.options && i.options.defaultNS);
          (c = $(c) ? [c] : c || ["translation"]),
            i.reportNamespaces.addUsedNamespaces &&
              i.reportNamespaces.addUsedNamespaces(c);
          const u =
              (i.isInitialized || i.initializedStoreOnce) &&
              c.every((e) =>
                (function (e, t) {
                  let n =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {};
                  return t.languages && t.languages.length
                    ? void 0 !== t.options.ignoreJSONStructure
                      ? t.hasLoadedNamespace(e, {
                          lng: n.lng,
                          precheck: (t, r) => {
                            if (
                              n.bindI18n &&
                              n.bindI18n.indexOf("languageChanging") > -1 &&
                              t.services.backendConnector.backend &&
                              t.isLanguageChangingTo &&
                              !r(t.isLanguageChangingTo, e)
                            )
                              return !1;
                          },
                        })
                      : (function (e, t) {
                          let n =
                            arguments.length > 2 && void 0 !== arguments[2]
                              ? arguments[2]
                              : {};
                          const r = t.languages[0],
                            o = !!t.options && t.options.fallbackLng,
                            a = t.languages[t.languages.length - 1];
                          if ("cimode" === r.toLowerCase()) return !0;
                          const i = (e, n) => {
                            const r =
                              t.services.backendConnector.state[`${e}|${n}`];
                            return -1 === r || 2 === r;
                          };
                          return !(
                            (n.bindI18n &&
                              n.bindI18n.indexOf("languageChanging") > -1 &&
                              t.services.backendConnector.backend &&
                              t.isLanguageChangingTo &&
                              !i(t.isLanguageChangingTo, e)) ||
                            (!t.hasResourceBundle(r, e) &&
                              t.services.backendConnector.backend &&
                              (!t.options.resources ||
                                t.options.partialBundledLanguages) &&
                              (!i(r, e) || (o && !i(a, e))))
                          );
                        })(e, t, n)
                    : (H("i18n.languages were undefined or empty", t.languages),
                      !0);
                })(e, i, s)
              ),
            p = ((e, n, r, o) =>
              (0, t.useCallback)(X(e, n, r, o), [e, n, r, o]))(
              i,
              n.lng || null,
              "fallback" === s.nsMode ? c : c[0],
              d
            ),
            m = () => p,
            h = () =>
              X(i, n.lng || null, "fallback" === s.nsMode ? c : c[0], d),
            [f, g] = (0, t.useState)(m);
          let v = c.join();
          n.lng && (v = `${n.lng}${v}`);
          const b = ((e, n) => {
              const r = (0, t.useRef)();
              return (
                (0, t.useEffect)(() => {
                  r.current = e;
                }, [e, n]),
                r.current
              );
            })(v),
            _ = (0, t.useRef)(!0);
          (0, t.useEffect)(() => {
            const { bindI18n: e, bindI18nStore: t } = s;
            (_.current = !0),
              u ||
                l ||
                (n.lng
                  ? U(i, n.lng, c, () => {
                      _.current && g(h);
                    })
                  : W(i, c, () => {
                      _.current && g(h);
                    })),
              u && b && b !== v && _.current && g(h);
            const r = () => {
              _.current && g(h);
            };
            return (
              e && i && i.on(e, r),
              t && i && i.store.on(t, r),
              () => {
                (_.current = !1),
                  e && i && e.split(" ").forEach((e) => i.off(e, r)),
                  t && i && t.split(" ").forEach((e) => i.store.off(e, r));
              }
            );
          }, [i, v]),
            (0, t.useEffect)(() => {
              _.current && u && g(m);
            }, [i, d, u]);
          const y = [f, i, u];
          if (((y.t = f), (y.i18n = i), (y.ready = u), u)) return y;
          if (!u && !l) return y;
          throw new Promise((e) => {
            n.lng ? U(i, n.lng, c, () => e()) : W(i, c, () => e());
          });
        };
      function te(e) {
        let { i18n: n, defaultNS: r, children: o } = e;
        const a = (0, t.useMemo)(() => ({ i18n: n, defaultNS: r }), [n, r]);
        return (0, t.createElement)(Y.Provider, { value: a }, o);
      }
      function ne(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      function re(e, t) {
        for (var n = 0; n < t.length; n++) {
          var r = t[n];
          (r.enumerable = r.enumerable || !1),
            (r.configurable = !0),
            "value" in r && (r.writable = !0),
            Object.defineProperty(e, S(r.key), r);
        }
      }
      function oe(e, t, n) {
        return (
          t && re(e.prototype, t),
          n && re(e, n),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          e
        );
      }
      function ae(e) {
        if (void 0 === e)
          throw new ReferenceError(
            "this hasn't been initialised - super() hasn't been called"
          );
        return e;
      }
      function ie(e, t) {
        return (
          (ie = Object.setPrototypeOf
            ? Object.setPrototypeOf.bind()
            : function (e, t) {
                return (e.__proto__ = t), e;
              }),
          ie(e, t)
        );
      }
      function se(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Super expression must either be null or a function"
          );
        (e.prototype = Object.create(t && t.prototype, {
          constructor: { value: e, writable: !0, configurable: !0 },
        })),
          Object.defineProperty(e, "prototype", { writable: !1 }),
          t && ie(e, t);
      }
      function le(e, t) {
        if (t && ("object" == x(t) || "function" == typeof t)) return t;
        if (void 0 !== t)
          throw new TypeError(
            "Derived constructors may only return object or undefined"
          );
        return ae(e);
      }
      function de(e) {
        return (
          (de = Object.setPrototypeOf
            ? Object.getPrototypeOf.bind()
            : function (e) {
                return e.__proto__ || Object.getPrototypeOf(e);
              }),
          de(e)
        );
      }
      function ce(e, t) {
        (null == t || t > e.length) && (t = e.length);
        for (var n = 0, r = Array(t); n < t; n++) r[n] = e[n];
        return r;
      }
      function ue(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function pe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? ue(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : ue(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var me = {
          type: "logger",
          log: function (e) {
            this.output("log", e);
          },
          warn: function (e) {
            this.output("warn", e);
          },
          error: function (e) {
            this.output("error", e);
          },
          output: function (e, t) {
            console && console[e] && console[e].apply(console, t);
          },
        },
        he = (function () {
          function e(t) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            ne(this, e), this.init(t, n);
          }
          return (
            oe(e, [
              {
                key: "init",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  (this.prefix = t.prefix || "i18next:"),
                    (this.logger = e || me),
                    (this.options = t),
                    (this.debug = t.debug);
                },
              },
              {
                key: "setDebug",
                value: function (e) {
                  this.debug = e;
                },
              },
              {
                key: "log",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "log", "", !0);
                },
              },
              {
                key: "warn",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "warn", "", !0);
                },
              },
              {
                key: "error",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "error", "");
                },
              },
              {
                key: "deprecate",
                value: function () {
                  for (
                    var e = arguments.length, t = new Array(e), n = 0;
                    n < e;
                    n++
                  )
                    t[n] = arguments[n];
                  return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
                },
              },
              {
                key: "forward",
                value: function (e, t, n, r) {
                  return r && !this.debug
                    ? null
                    : ("string" == typeof e[0] &&
                        (e[0] = ""
                          .concat(n)
                          .concat(this.prefix, " ")
                          .concat(e[0])),
                      this.logger[t](e));
                },
              },
              {
                key: "create",
                value: function (t) {
                  return new e(
                    this.logger,
                    pe(
                      pe(
                        {},
                        { prefix: "".concat(this.prefix, ":").concat(t, ":") }
                      ),
                      this.options
                    )
                  );
                },
              },
              {
                key: "clone",
                value: function (t) {
                  return (
                    ((t = t || this.options).prefix = t.prefix || this.prefix),
                    new e(this.logger, t)
                  );
                },
              },
            ]),
            e
          );
        })(),
        fe = new he(),
        ge = (function () {
          function e() {
            ne(this, e), (this.observers = {});
          }
          return (
            oe(e, [
              {
                key: "on",
                value: function (e, t) {
                  var n = this;
                  return (
                    e.split(" ").forEach(function (e) {
                      (n.observers[e] = n.observers[e] || []),
                        n.observers[e].push(t);
                    }),
                    this
                  );
                },
              },
              {
                key: "off",
                value: function (e, t) {
                  this.observers[e] &&
                    (t
                      ? (this.observers[e] = this.observers[e].filter(function (
                          e
                        ) {
                          return e !== t;
                        }))
                      : delete this.observers[e]);
                },
              },
              {
                key: "emit",
                value: function (e) {
                  for (
                    var t = arguments.length,
                      n = new Array(t > 1 ? t - 1 : 0),
                      r = 1;
                    r < t;
                    r++
                  )
                    n[r - 1] = arguments[r];
                  this.observers[e] &&
                    [].concat(this.observers[e]).forEach(function (e) {
                      e.apply(void 0, n);
                    }),
                    this.observers["*"] &&
                      [].concat(this.observers["*"]).forEach(function (t) {
                        t.apply(t, [e].concat(n));
                      });
                },
              },
            ]),
            e
          );
        })();
      function ve() {
        var e,
          t,
          n = new Promise(function (n, r) {
            (e = n), (t = r);
          });
        return (n.resolve = e), (n.reject = t), n;
      }
      function be(e) {
        return null == e ? "" : "" + e;
      }
      function _e(e, t, n) {
        function r(e) {
          return e && e.indexOf("###") > -1 ? e.replace(/###/g, ".") : e;
        }
        function o() {
          return !e || "string" == typeof e;
        }
        for (
          var a = "string" != typeof t ? [].concat(t) : t.split(".");
          a.length > 1;

        ) {
          if (o()) return {};
          var i = r(a.shift());
          !e[i] && n && (e[i] = new n()),
            (e = Object.prototype.hasOwnProperty.call(e, i) ? e[i] : {});
        }
        return o() ? {} : { obj: e, k: r(a.shift()) };
      }
      function ye(e, t, n) {
        var r = _e(e, t, Object);
        r.obj[r.k] = n;
      }
      function Ce(e, t) {
        var n = _e(e, t),
          r = n.obj,
          o = n.k;
        if (r) return r[o];
      }
      function xe(e, t, n) {
        var r = Ce(e, n);
        return void 0 !== r ? r : Ce(t, n);
      }
      function Se(e, t, n) {
        for (var r in t)
          "__proto__" !== r &&
            "constructor" !== r &&
            (r in e
              ? "string" == typeof e[r] ||
                e[r] instanceof String ||
                "string" == typeof t[r] ||
                t[r] instanceof String
                ? n && (e[r] = t[r])
                : Se(e[r], t[r], n)
              : (e[r] = t[r]));
        return e;
      }
      function ke(e) {
        return e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
      }
      var Pe = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;",
        "/": "&#x2F;",
      };
      function we(e) {
        return "string" == typeof e
          ? e.replace(/[&<>"'\/]/g, function (e) {
              return Pe[e];
            })
          : e;
      }
      var Oe =
          "undefined" != typeof window &&
          window.navigator &&
          void 0 === window.navigator.userAgentData &&
          window.navigator.userAgent &&
          window.navigator.userAgent.indexOf("MSIE") > -1,
        Te = [" ", ",", "?", "!", ";"];
      function Ie(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Me(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ie(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ie(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function je(e, t) {
        var n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : ".";
        if (e) {
          if (e[t]) return e[t];
          for (var r = t.split(n), o = e, a = 0; a < r.length; ++a) {
            if (!o) return;
            if ("string" == typeof o[r[a]] && a + 1 < r.length) return;
            if (void 0 === o[r[a]]) {
              for (
                var i = 2, s = r.slice(a, a + i).join(n), l = o[s];
                void 0 === l && r.length > a + i;

              )
                i++, (l = o[(s = r.slice(a, a + i).join(n))]);
              if (void 0 === l) return;
              if (null === l) return null;
              if (t.endsWith(s)) {
                if ("string" == typeof l) return l;
                if (s && "string" == typeof l[s]) return l[s];
              }
              var d = r.slice(a + i).join(n);
              return d ? je(l, d, n) : void 0;
            }
            o = o[r[a]];
          }
          return o;
        }
      }
      var Ne = (function (e) {
          se(o, e);
          var t,
            n,
            r =
              ((t = o),
              (n = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                  return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return (
                    Boolean.prototype.valueOf.call(
                      Reflect.construct(Boolean, [], function () {})
                    ),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              })()),
              function () {
                var e,
                  r = de(t);
                if (n) {
                  var o = de(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return le(this, e);
              });
          function o(e) {
            var t,
              n =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : { ns: ["translation"], defaultNS: "translation" };
            return (
              ne(this, o),
              (t = r.call(this)),
              Oe && ge.call(ae(t)),
              (t.data = e || {}),
              (t.options = n),
              void 0 === t.options.keySeparator &&
                (t.options.keySeparator = "."),
              void 0 === t.options.ignoreJSONStructure &&
                (t.options.ignoreJSONStructure = !0),
              t
            );
          }
          return (
            oe(o, [
              {
                key: "addNamespaces",
                value: function (e) {
                  this.options.ns.indexOf(e) < 0 && this.options.ns.push(e);
                },
              },
              {
                key: "removeNamespaces",
                value: function (e) {
                  var t = this.options.ns.indexOf(e);
                  t > -1 && this.options.ns.splice(t, 1);
                },
              },
              {
                key: "getResource",
                value: function (e, t, n) {
                  var r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : {},
                    o =
                      void 0 !== r.keySeparator
                        ? r.keySeparator
                        : this.options.keySeparator,
                    a =
                      void 0 !== r.ignoreJSONStructure
                        ? r.ignoreJSONStructure
                        : this.options.ignoreJSONStructure,
                    i = [e, t];
                  n && "string" != typeof n && (i = i.concat(n)),
                    n &&
                      "string" == typeof n &&
                      (i = i.concat(o ? n.split(o) : n)),
                    e.indexOf(".") > -1 && (i = e.split("."));
                  var s = Ce(this.data, i);
                  return s || !a || "string" != typeof n
                    ? s
                    : je(this.data && this.data[e] && this.data[e][t], n, o);
                },
              },
              {
                key: "addResource",
                value: function (e, t, n, r) {
                  var o =
                      arguments.length > 4 && void 0 !== arguments[4]
                        ? arguments[4]
                        : { silent: !1 },
                    a = this.options.keySeparator;
                  void 0 === a && (a = ".");
                  var i = [e, t];
                  n && (i = i.concat(a ? n.split(a) : n)),
                    e.indexOf(".") > -1 &&
                      ((r = t), (t = (i = e.split("."))[1])),
                    this.addNamespaces(t),
                    ye(this.data, i, r),
                    o.silent || this.emit("added", e, t, n, r);
                },
              },
              {
                key: "addResources",
                value: function (e, t, n) {
                  var r =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : { silent: !1 };
                  for (var o in n)
                    ("string" != typeof n[o] &&
                      "[object Array]" !==
                        Object.prototype.toString.apply(n[o])) ||
                      this.addResource(e, t, o, n[o], { silent: !0 });
                  r.silent || this.emit("added", e, t, n);
                },
              },
              {
                key: "addResourceBundle",
                value: function (e, t, n, r, o) {
                  var a =
                      arguments.length > 5 && void 0 !== arguments[5]
                        ? arguments[5]
                        : { silent: !1 },
                    i = [e, t];
                  e.indexOf(".") > -1 &&
                    ((r = n), (n = t), (t = (i = e.split("."))[1])),
                    this.addNamespaces(t);
                  var s = Ce(this.data, i) || {};
                  r ? Se(s, n, o) : (s = Me(Me({}, s), n)),
                    ye(this.data, i, s),
                    a.silent || this.emit("added", e, t, n);
                },
              },
              {
                key: "removeResourceBundle",
                value: function (e, t) {
                  this.hasResourceBundle(e, t) && delete this.data[e][t],
                    this.removeNamespaces(t),
                    this.emit("removed", e, t);
                },
              },
              {
                key: "hasResourceBundle",
                value: function (e, t) {
                  return void 0 !== this.getResource(e, t);
                },
              },
              {
                key: "getResourceBundle",
                value: function (e, t) {
                  return (
                    t || (t = this.options.defaultNS),
                    "v1" === this.options.compatibilityAPI
                      ? Me(Me({}, {}), this.getResource(e, t))
                      : this.getResource(e, t)
                  );
                },
              },
              {
                key: "getDataByLanguage",
                value: function (e) {
                  return this.data[e];
                },
              },
              {
                key: "hasLanguageSomeTranslations",
                value: function (e) {
                  var t = this.getDataByLanguage(e);
                  return !!((t && Object.keys(t)) || []).find(function (e) {
                    return t[e] && Object.keys(t[e]).length > 0;
                  });
                },
              },
              {
                key: "toJSON",
                value: function () {
                  return this.data;
                },
              },
            ]),
            o
          );
        })(ge),
        De = {
          processors: {},
          addPostProcessor: function (e) {
            this.processors[e.name] = e;
          },
          handle: function (e, t, n, r, o) {
            var a = this;
            return (
              e.forEach(function (e) {
                a.processors[e] && (t = a.processors[e].process(t, n, r, o));
              }),
              t
            );
          },
        };
      function Ae(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Ee(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ae(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ae(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var Re = {},
        Le = (function (e) {
          se(o, e);
          var t,
            n,
            r =
              ((t = o),
              (n = (function () {
                if ("undefined" == typeof Reflect || !Reflect.construct)
                  return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return (
                    Boolean.prototype.valueOf.call(
                      Reflect.construct(Boolean, [], function () {})
                    ),
                    !0
                  );
                } catch (e) {
                  return !1;
                }
              })()),
              function () {
                var e,
                  r = de(t);
                if (n) {
                  var o = de(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return le(this, e);
              });
          function o(e) {
            var t,
              n,
              a,
              i =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            return (
              ne(this, o),
              (t = r.call(this)),
              Oe && ge.call(ae(t)),
              (n = e),
              (a = ae(t)),
              [
                "resourceStore",
                "languageUtils",
                "pluralResolver",
                "interpolator",
                "backendConnector",
                "i18nFormat",
                "utils",
              ].forEach(function (e) {
                n[e] && (a[e] = n[e]);
              }),
              (t.options = i),
              void 0 === t.options.keySeparator &&
                (t.options.keySeparator = "."),
              (t.logger = fe.create("translator")),
              t
            );
          }
          return (
            oe(
              o,
              [
                {
                  key: "changeLanguage",
                  value: function (e) {
                    e && (this.language = e);
                  },
                },
                {
                  key: "exists",
                  value: function (e) {
                    var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : { interpolation: {} };
                    if (null == e) return !1;
                    var n = this.resolve(e, t);
                    return n && void 0 !== n.res;
                  },
                },
                {
                  key: "extractFromKey",
                  value: function (e, t) {
                    var n =
                      void 0 !== t.nsSeparator
                        ? t.nsSeparator
                        : this.options.nsSeparator;
                    void 0 === n && (n = ":");
                    var r =
                        void 0 !== t.keySeparator
                          ? t.keySeparator
                          : this.options.keySeparator,
                      o = t.ns || this.options.defaultNS || [],
                      a = n && e.indexOf(n) > -1,
                      i = !(
                        this.options.userDefinedKeySeparator ||
                        t.keySeparator ||
                        this.options.userDefinedNsSeparator ||
                        t.nsSeparator ||
                        (function (e, t, n) {
                          (t = t || ""), (n = n || "");
                          var r = Te.filter(function (e) {
                            return t.indexOf(e) < 0 && n.indexOf(e) < 0;
                          });
                          if (0 === r.length) return !0;
                          var o = new RegExp(
                              "(".concat(
                                r
                                  .map(function (e) {
                                    return "?" === e ? "\\?" : e;
                                  })
                                  .join("|"),
                                ")"
                              )
                            ),
                            a = !o.test(e);
                          if (!a) {
                            var i = e.indexOf(n);
                            i > 0 && !o.test(e.substring(0, i)) && (a = !0);
                          }
                          return a;
                        })(e, n, r)
                      );
                    if (a && !i) {
                      var s = e.match(this.interpolator.nestingRegexp);
                      if (s && s.length > 0) return { key: e, namespaces: o };
                      var l = e.split(n);
                      (n !== r ||
                        (n === r && this.options.ns.indexOf(l[0]) > -1)) &&
                        (o = l.shift()),
                        (e = l.join(r));
                    }
                    return (
                      "string" == typeof o && (o = [o]),
                      { key: e, namespaces: o }
                    );
                  },
                },
                {
                  key: "translate",
                  value: function (e, t, n) {
                    var r = this;
                    if (
                      ("object" !== x(t) &&
                        this.options.overloadTranslationOptionHandler &&
                        (t =
                          this.options.overloadTranslationOptionHandler(
                            arguments
                          )),
                      t || (t = {}),
                      null == e)
                    )
                      return "";
                    Array.isArray(e) || (e = [String(e)]);
                    var a =
                        void 0 !== t.returnDetails
                          ? t.returnDetails
                          : this.options.returnDetails,
                      i =
                        void 0 !== t.keySeparator
                          ? t.keySeparator
                          : this.options.keySeparator,
                      s = this.extractFromKey(e[e.length - 1], t),
                      l = s.key,
                      d = s.namespaces,
                      c = d[d.length - 1],
                      u = t.lng || this.language,
                      p =
                        t.appendNamespaceToCIMode ||
                        this.options.appendNamespaceToCIMode;
                    if (u && "cimode" === u.toLowerCase()) {
                      if (p) {
                        var m = t.nsSeparator || this.options.nsSeparator;
                        return a
                          ? ((h.res = "".concat(c).concat(m).concat(l)), h)
                          : "".concat(c).concat(m).concat(l);
                      }
                      return a ? ((h.res = l), h) : l;
                    }
                    var h = this.resolve(e, t),
                      f = h && h.res,
                      g = (h && h.usedKey) || l,
                      v = (h && h.exactUsedKey) || l,
                      b = Object.prototype.toString.apply(f),
                      _ =
                        void 0 !== t.joinArrays
                          ? t.joinArrays
                          : this.options.joinArrays,
                      y = !this.i18nFormat || this.i18nFormat.handleAsObject;
                    if (
                      y &&
                      f &&
                      "string" != typeof f &&
                      "boolean" != typeof f &&
                      "number" != typeof f &&
                      [
                        "[object Number]",
                        "[object Function]",
                        "[object RegExp]",
                      ].indexOf(b) < 0 &&
                      ("string" != typeof _ || "[object Array]" !== b)
                    ) {
                      if (!t.returnObjects && !this.options.returnObjects) {
                        this.options.returnedObjectHandler ||
                          this.logger.warn(
                            "accessing an object - but returnObjects options is not enabled!"
                          );
                        var C = this.options.returnedObjectHandler
                          ? this.options.returnedObjectHandler(
                              g,
                              f,
                              Ee(Ee({}, t), {}, { ns: d })
                            )
                          : "key '"
                              .concat(l, " (")
                              .concat(
                                this.language,
                                ")' returned an object instead of string."
                              );
                        return a ? ((h.res = C), h) : C;
                      }
                      if (i) {
                        var S = "[object Array]" === b,
                          k = S ? [] : {},
                          P = S ? v : g;
                        for (var w in f)
                          if (Object.prototype.hasOwnProperty.call(f, w)) {
                            var O = "".concat(P).concat(i).concat(w);
                            (k[w] = this.translate(
                              O,
                              Ee(Ee({}, t), { joinArrays: !1, ns: d })
                            )),
                              k[w] === O && (k[w] = f[w]);
                          }
                        f = k;
                      }
                    } else if (
                      y &&
                      "string" == typeof _ &&
                      "[object Array]" === b
                    )
                      (f = f.join(_)) &&
                        (f = this.extendTranslation(f, e, t, n));
                    else {
                      var T = !1,
                        I = !1,
                        M = void 0 !== t.count && "string" != typeof t.count,
                        j = o.hasDefaultValue(t),
                        N = M
                          ? this.pluralResolver.getSuffix(u, t.count, t)
                          : "",
                        D = t["defaultValue".concat(N)] || t.defaultValue;
                      !this.isValidLookup(f) && j && ((T = !0), (f = D)),
                        this.isValidLookup(f) || ((I = !0), (f = l));
                      var A =
                          (t.missingKeyNoValueFallbackToKey ||
                            this.options.missingKeyNoValueFallbackToKey) &&
                          I
                            ? void 0
                            : f,
                        E = j && D !== f && this.options.updateMissing;
                      if (I || T || E) {
                        if (
                          (this.logger.log(
                            E ? "updateKey" : "missingKey",
                            u,
                            c,
                            l,
                            E ? D : f
                          ),
                          i)
                        ) {
                          var R = this.resolve(
                            l,
                            Ee(Ee({}, t), {}, { keySeparator: !1 })
                          );
                          R &&
                            R.res &&
                            this.logger.warn(
                              "Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format."
                            );
                        }
                        var L = [],
                          B = this.languageUtils.getFallbackCodes(
                            this.options.fallbackLng,
                            t.lng || this.language
                          );
                        if (
                          "fallback" === this.options.saveMissingTo &&
                          B &&
                          B[0]
                        )
                          for (var z = 0; z < B.length; z++) L.push(B[z]);
                        else
                          "all" === this.options.saveMissingTo
                            ? (L = this.languageUtils.toResolveHierarchy(
                                t.lng || this.language
                              ))
                            : L.push(t.lng || this.language);
                        var F = function (e, n, o) {
                          var a = j && o !== f ? o : A;
                          r.options.missingKeyHandler
                            ? r.options.missingKeyHandler(e, c, n, a, E, t)
                            : r.backendConnector &&
                              r.backendConnector.saveMissing &&
                              r.backendConnector.saveMissing(e, c, n, a, E, t),
                            r.emit("missingKey", e, c, n, f);
                        };
                        this.options.saveMissing &&
                          (this.options.saveMissingPlurals && M
                            ? L.forEach(function (e) {
                                r.pluralResolver
                                  .getSuffixes(e, t)
                                  .forEach(function (n) {
                                    F(
                                      [e],
                                      l + n,
                                      t["defaultValue".concat(n)] || D
                                    );
                                  });
                              })
                            : F(L, l, D));
                      }
                      (f = this.extendTranslation(f, e, t, h, n)),
                        I &&
                          f === l &&
                          this.options.appendNamespaceToMissingKey &&
                          (f = "".concat(c, ":").concat(l)),
                        (I || T) &&
                          this.options.parseMissingKeyHandler &&
                          (f =
                            "v1" !== this.options.compatibilityAPI
                              ? this.options.parseMissingKeyHandler(
                                  this.options.appendNamespaceToMissingKey
                                    ? "".concat(c, ":").concat(l)
                                    : l,
                                  T ? f : void 0
                                )
                              : this.options.parseMissingKeyHandler(f));
                    }
                    return a ? ((h.res = f), h) : f;
                  },
                },
                {
                  key: "extendTranslation",
                  value: function (e, t, n, r, o) {
                    var a = this;
                    if (this.i18nFormat && this.i18nFormat.parse)
                      e = this.i18nFormat.parse(
                        e,
                        Ee(
                          Ee({}, this.options.interpolation.defaultVariables),
                          n
                        ),
                        r.usedLng,
                        r.usedNS,
                        r.usedKey,
                        { resolved: r }
                      );
                    else if (!n.skipInterpolation) {
                      n.interpolation &&
                        this.interpolator.init(
                          Ee(Ee({}, n), {
                            interpolation: Ee(
                              Ee({}, this.options.interpolation),
                              n.interpolation
                            ),
                          })
                        );
                      var i,
                        s =
                          "string" == typeof e &&
                          (n &&
                          n.interpolation &&
                          void 0 !== n.interpolation.skipOnVariables
                            ? n.interpolation.skipOnVariables
                            : this.options.interpolation.skipOnVariables);
                      if (s) {
                        var l = e.match(this.interpolator.nestingRegexp);
                        i = l && l.length;
                      }
                      var d =
                        n.replace && "string" != typeof n.replace
                          ? n.replace
                          : n;
                      if (
                        (this.options.interpolation.defaultVariables &&
                          (d = Ee(
                            Ee({}, this.options.interpolation.defaultVariables),
                            d
                          )),
                        (e = this.interpolator.interpolate(
                          e,
                          d,
                          n.lng || this.language,
                          n
                        )),
                        s)
                      ) {
                        var c = e.match(this.interpolator.nestingRegexp);
                        i < (c && c.length) && (n.nest = !1);
                      }
                      !1 !== n.nest &&
                        (e = this.interpolator.nest(
                          e,
                          function () {
                            for (
                              var e = arguments.length, r = new Array(e), i = 0;
                              i < e;
                              i++
                            )
                              r[i] = arguments[i];
                            return o && o[0] === r[0] && !n.context
                              ? (a.logger.warn(
                                  "It seems you are nesting recursively key: "
                                    .concat(r[0], " in key: ")
                                    .concat(t[0])
                                ),
                                null)
                              : a.translate.apply(a, r.concat([t]));
                          },
                          n
                        )),
                        n.interpolation && this.interpolator.reset();
                    }
                    var u = n.postProcess || this.options.postProcess,
                      p = "string" == typeof u ? [u] : u;
                    return (
                      null != e &&
                        p &&
                        p.length &&
                        !1 !== n.applyPostProcessor &&
                        (e = De.handle(
                          p,
                          e,
                          t,
                          this.options && this.options.postProcessPassResolved
                            ? Ee({ i18nResolved: r }, n)
                            : n,
                          this
                        )),
                      e
                    );
                  },
                },
                {
                  key: "resolve",
                  value: function (e) {
                    var t,
                      n,
                      r,
                      o,
                      a,
                      i = this,
                      s =
                        arguments.length > 1 && void 0 !== arguments[1]
                          ? arguments[1]
                          : {};
                    return (
                      "string" == typeof e && (e = [e]),
                      e.forEach(function (e) {
                        if (!i.isValidLookup(t)) {
                          var l = i.extractFromKey(e, s),
                            d = l.key;
                          n = d;
                          var c = l.namespaces;
                          i.options.fallbackNS &&
                            (c = c.concat(i.options.fallbackNS));
                          var u =
                              void 0 !== s.count && "string" != typeof s.count,
                            p =
                              u &&
                              !s.ordinal &&
                              0 === s.count &&
                              i.pluralResolver.shouldUseIntlApi(),
                            m =
                              void 0 !== s.context &&
                              ("string" == typeof s.context ||
                                "number" == typeof s.context) &&
                              "" !== s.context,
                            h = s.lngs
                              ? s.lngs
                              : i.languageUtils.toResolveHierarchy(
                                  s.lng || i.language,
                                  s.fallbackLng
                                );
                          c.forEach(function (e) {
                            i.isValidLookup(t) ||
                              ((a = e),
                              !Re["".concat(h[0], "-").concat(e)] &&
                                i.utils &&
                                i.utils.hasLoadedNamespace &&
                                !i.utils.hasLoadedNamespace(a) &&
                                ((Re["".concat(h[0], "-").concat(e)] = !0),
                                i.logger.warn(
                                  'key "'
                                    .concat(n, '" for languages "')
                                    .concat(
                                      h.join(", "),
                                      '" won\'t get resolved as namespace "'
                                    )
                                    .concat(a, '" was not yet loaded'),
                                  "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!"
                                )),
                              h.forEach(function (n) {
                                if (!i.isValidLookup(t)) {
                                  o = n;
                                  var a,
                                    l = [d];
                                  if (
                                    i.i18nFormat &&
                                    i.i18nFormat.addLookupKeys
                                  )
                                    i.i18nFormat.addLookupKeys(l, d, n, e, s);
                                  else {
                                    var c;
                                    u &&
                                      (c = i.pluralResolver.getSuffix(
                                        n,
                                        s.count,
                                        s
                                      ));
                                    var h = "".concat(
                                      i.options.pluralSeparator,
                                      "zero"
                                    );
                                    if (
                                      (u && (l.push(d + c), p && l.push(d + h)),
                                      m)
                                    ) {
                                      var f = ""
                                        .concat(d)
                                        .concat(i.options.contextSeparator)
                                        .concat(s.context);
                                      l.push(f),
                                        u &&
                                          (l.push(f + c), p && l.push(f + h));
                                    }
                                  }
                                  for (; (a = l.pop()); )
                                    i.isValidLookup(t) ||
                                      ((r = a),
                                      (t = i.getResource(n, e, a, s)));
                                }
                              }));
                          });
                        }
                      }),
                      {
                        res: t,
                        usedKey: n,
                        exactUsedKey: r,
                        usedLng: o,
                        usedNS: a,
                      }
                    );
                  },
                },
                {
                  key: "isValidLookup",
                  value: function (e) {
                    return !(
                      void 0 === e ||
                      (!this.options.returnNull && null === e) ||
                      (!this.options.returnEmptyString && "" === e)
                    );
                  },
                },
                {
                  key: "getResource",
                  value: function (e, t, n) {
                    var r =
                      arguments.length > 3 && void 0 !== arguments[3]
                        ? arguments[3]
                        : {};
                    return this.i18nFormat && this.i18nFormat.getResource
                      ? this.i18nFormat.getResource(e, t, n, r)
                      : this.resourceStore.getResource(e, t, n, r);
                  },
                },
              ],
              [
                {
                  key: "hasDefaultValue",
                  value: function (e) {
                    for (var t in e)
                      if (
                        Object.prototype.hasOwnProperty.call(e, t) &&
                        "defaultValue" === t.substring(0, 12) &&
                        void 0 !== e[t]
                      )
                        return !0;
                    return !1;
                  },
                },
              ]
            ),
            o
          );
        })(ge);
      function Be(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
      var ze = (function () {
          function e(t) {
            ne(this, e),
              (this.options = t),
              (this.supportedLngs = this.options.supportedLngs || !1),
              (this.logger = fe.create("languageUtils"));
          }
          return (
            oe(e, [
              {
                key: "getScriptPartFromCode",
                value: function (e) {
                  if (!e || e.indexOf("-") < 0) return null;
                  var t = e.split("-");
                  return 2 === t.length
                    ? null
                    : (t.pop(),
                      "x" === t[t.length - 1].toLowerCase()
                        ? null
                        : this.formatLanguageCode(t.join("-")));
                },
              },
              {
                key: "getLanguagePartFromCode",
                value: function (e) {
                  if (!e || e.indexOf("-") < 0) return e;
                  var t = e.split("-");
                  return this.formatLanguageCode(t[0]);
                },
              },
              {
                key: "formatLanguageCode",
                value: function (e) {
                  if ("string" == typeof e && e.indexOf("-") > -1) {
                    var t = [
                        "hans",
                        "hant",
                        "latn",
                        "cyrl",
                        "cans",
                        "mong",
                        "arab",
                      ],
                      n = e.split("-");
                    return (
                      this.options.lowerCaseLng
                        ? (n = n.map(function (e) {
                            return e.toLowerCase();
                          }))
                        : 2 === n.length
                        ? ((n[0] = n[0].toLowerCase()),
                          (n[1] = n[1].toUpperCase()),
                          t.indexOf(n[1].toLowerCase()) > -1 &&
                            (n[1] = Be(n[1].toLowerCase())))
                        : 3 === n.length &&
                          ((n[0] = n[0].toLowerCase()),
                          2 === n[1].length && (n[1] = n[1].toUpperCase()),
                          "sgn" !== n[0] &&
                            2 === n[2].length &&
                            (n[2] = n[2].toUpperCase()),
                          t.indexOf(n[1].toLowerCase()) > -1 &&
                            (n[1] = Be(n[1].toLowerCase())),
                          t.indexOf(n[2].toLowerCase()) > -1 &&
                            (n[2] = Be(n[2].toLowerCase()))),
                      n.join("-")
                    );
                  }
                  return this.options.cleanCode || this.options.lowerCaseLng
                    ? e.toLowerCase()
                    : e;
                },
              },
              {
                key: "isSupportedCode",
                value: function (e) {
                  return (
                    ("languageOnly" === this.options.load ||
                      this.options.nonExplicitSupportedLngs) &&
                      (e = this.getLanguagePartFromCode(e)),
                    !this.supportedLngs ||
                      !this.supportedLngs.length ||
                      this.supportedLngs.indexOf(e) > -1
                  );
                },
              },
              {
                key: "getBestMatchFromCodes",
                value: function (e) {
                  var t,
                    n = this;
                  return e
                    ? (e.forEach(function (e) {
                        if (!t) {
                          var r = n.formatLanguageCode(e);
                          (n.options.supportedLngs && !n.isSupportedCode(r)) ||
                            (t = r);
                        }
                      }),
                      !t &&
                        this.options.supportedLngs &&
                        e.forEach(function (e) {
                          if (!t) {
                            var r = n.getLanguagePartFromCode(e);
                            if (n.isSupportedCode(r)) return (t = r);
                            t = n.options.supportedLngs.find(function (e) {
                              if (0 === e.indexOf(r)) return e;
                            });
                          }
                        }),
                      t ||
                        (t = this.getFallbackCodes(
                          this.options.fallbackLng
                        )[0]),
                      t)
                    : null;
                },
              },
              {
                key: "getFallbackCodes",
                value: function (e, t) {
                  if (!e) return [];
                  if (
                    ("function" == typeof e && (e = e(t)),
                    "string" == typeof e && (e = [e]),
                    "[object Array]" === Object.prototype.toString.apply(e))
                  )
                    return e;
                  if (!t) return e.default || [];
                  var n = e[t];
                  return (
                    n || (n = e[this.getScriptPartFromCode(t)]),
                    n || (n = e[this.formatLanguageCode(t)]),
                    n || (n = e[this.getLanguagePartFromCode(t)]),
                    n || (n = e.default),
                    n || []
                  );
                },
              },
              {
                key: "toResolveHierarchy",
                value: function (e, t) {
                  var n = this,
                    r = this.getFallbackCodes(
                      t || this.options.fallbackLng || [],
                      e
                    ),
                    o = [],
                    a = function (e) {
                      e &&
                        (n.isSupportedCode(e)
                          ? o.push(e)
                          : n.logger.warn(
                              "rejecting language code not found in supportedLngs: ".concat(
                                e
                              )
                            ));
                    };
                  return (
                    "string" == typeof e && e.indexOf("-") > -1
                      ? ("languageOnly" !== this.options.load &&
                          a(this.formatLanguageCode(e)),
                        "languageOnly" !== this.options.load &&
                          "currentOnly" !== this.options.load &&
                          a(this.getScriptPartFromCode(e)),
                        "currentOnly" !== this.options.load &&
                          a(this.getLanguagePartFromCode(e)))
                      : "string" == typeof e && a(this.formatLanguageCode(e)),
                    r.forEach(function (e) {
                      o.indexOf(e) < 0 && a(n.formatLanguageCode(e));
                    }),
                    o
                  );
                },
              },
            ]),
            e
          );
        })(),
        Fe = [
          {
            lngs: [
              "ach",
              "ak",
              "am",
              "arn",
              "br",
              "fil",
              "gun",
              "ln",
              "mfe",
              "mg",
              "mi",
              "oc",
              "pt",
              "pt-BR",
              "tg",
              "tl",
              "ti",
              "tr",
              "uz",
              "wa",
            ],
            nr: [1, 2],
            fc: 1,
          },
          {
            lngs: [
              "af",
              "an",
              "ast",
              "az",
              "bg",
              "bn",
              "ca",
              "da",
              "de",
              "dev",
              "el",
              "en",
              "eo",
              "es",
              "et",
              "eu",
              "fi",
              "fo",
              "fur",
              "fy",
              "gl",
              "gu",
              "ha",
              "hi",
              "hu",
              "hy",
              "ia",
              "it",
              "kk",
              "kn",
              "ku",
              "lb",
              "mai",
              "ml",
              "mn",
              "mr",
              "nah",
              "nap",
              "nb",
              "ne",
              "nl",
              "nn",
              "no",
              "nso",
              "pa",
              "pap",
              "pms",
              "ps",
              "pt-PT",
              "rm",
              "sco",
              "se",
              "si",
              "so",
              "son",
              "sq",
              "sv",
              "sw",
              "ta",
              "te",
              "tk",
              "ur",
              "yo",
            ],
            nr: [1, 2],
            fc: 2,
          },
          {
            lngs: [
              "ay",
              "bo",
              "cgg",
              "fa",
              "ht",
              "id",
              "ja",
              "jbo",
              "ka",
              "km",
              "ko",
              "ky",
              "lo",
              "ms",
              "sah",
              "su",
              "th",
              "tt",
              "ug",
              "vi",
              "wo",
              "zh",
            ],
            nr: [1],
            fc: 3,
          },
          {
            lngs: ["be", "bs", "cnr", "dz", "hr", "ru", "sr", "uk"],
            nr: [1, 2, 5],
            fc: 4,
          },
          { lngs: ["ar"], nr: [0, 1, 2, 3, 11, 100], fc: 5 },
          { lngs: ["cs", "sk"], nr: [1, 2, 5], fc: 6 },
          { lngs: ["csb", "pl"], nr: [1, 2, 5], fc: 7 },
          { lngs: ["cy"], nr: [1, 2, 3, 8], fc: 8 },
          { lngs: ["fr"], nr: [1, 2], fc: 9 },
          { lngs: ["ga"], nr: [1, 2, 3, 7, 11], fc: 10 },
          { lngs: ["gd"], nr: [1, 2, 3, 20], fc: 11 },
          { lngs: ["is"], nr: [1, 2], fc: 12 },
          { lngs: ["jv"], nr: [0, 1], fc: 13 },
          { lngs: ["kw"], nr: [1, 2, 3, 4], fc: 14 },
          { lngs: ["lt"], nr: [1, 2, 10], fc: 15 },
          { lngs: ["lv"], nr: [1, 2, 0], fc: 16 },
          { lngs: ["mk"], nr: [1, 2], fc: 17 },
          { lngs: ["mnk"], nr: [0, 1, 2], fc: 18 },
          { lngs: ["mt"], nr: [1, 2, 11, 20], fc: 19 },
          { lngs: ["or"], nr: [2, 1], fc: 2 },
          { lngs: ["ro"], nr: [1, 2, 20], fc: 20 },
          { lngs: ["sl"], nr: [5, 1, 2, 3], fc: 21 },
          { lngs: ["he", "iw"], nr: [1, 2, 20, 21], fc: 22 },
        ],
        Ze = {
          1: function (e) {
            return Number(e > 1);
          },
          2: function (e) {
            return Number(1 != e);
          },
          3: function (e) {
            return 0;
          },
          4: function (e) {
            return Number(
              e % 10 == 1 && e % 100 != 11
                ? 0
                : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          5: function (e) {
            return Number(
              0 == e
                ? 0
                : 1 == e
                ? 1
                : 2 == e
                ? 2
                : e % 100 >= 3 && e % 100 <= 10
                ? 3
                : e % 100 >= 11
                ? 4
                : 5
            );
          },
          6: function (e) {
            return Number(1 == e ? 0 : e >= 2 && e <= 4 ? 1 : 2);
          },
          7: function (e) {
            return Number(
              1 == e
                ? 0
                : e % 10 >= 2 && e % 10 <= 4 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          8: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : 8 != e && 11 != e ? 2 : 3);
          },
          9: function (e) {
            return Number(e >= 2);
          },
          10: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : e < 7 ? 2 : e < 11 ? 3 : 4);
          },
          11: function (e) {
            return Number(
              1 == e || 11 == e
                ? 0
                : 2 == e || 12 == e
                ? 1
                : e > 2 && e < 20
                ? 2
                : 3
            );
          },
          12: function (e) {
            return Number(e % 10 != 1 || e % 100 == 11);
          },
          13: function (e) {
            return Number(0 !== e);
          },
          14: function (e) {
            return Number(1 == e ? 0 : 2 == e ? 1 : 3 == e ? 2 : 3);
          },
          15: function (e) {
            return Number(
              e % 10 == 1 && e % 100 != 11
                ? 0
                : e % 10 >= 2 && (e % 100 < 10 || e % 100 >= 20)
                ? 1
                : 2
            );
          },
          16: function (e) {
            return Number(e % 10 == 1 && e % 100 != 11 ? 0 : 0 !== e ? 1 : 2);
          },
          17: function (e) {
            return Number(1 == e || (e % 10 == 1 && e % 100 != 11) ? 0 : 1);
          },
          18: function (e) {
            return Number(0 == e ? 0 : 1 == e ? 1 : 2);
          },
          19: function (e) {
            return Number(
              1 == e
                ? 0
                : 0 == e || (e % 100 > 1 && e % 100 < 11)
                ? 1
                : e % 100 > 10 && e % 100 < 20
                ? 2
                : 3
            );
          },
          20: function (e) {
            return Number(
              1 == e ? 0 : 0 == e || (e % 100 > 0 && e % 100 < 20) ? 1 : 2
            );
          },
          21: function (e) {
            return Number(
              e % 100 == 1
                ? 1
                : e % 100 == 2
                ? 2
                : e % 100 == 3 || e % 100 == 4
                ? 3
                : 0
            );
          },
          22: function (e) {
            return Number(
              1 == e ? 0 : 2 == e ? 1 : (e < 0 || e > 10) && e % 10 == 0 ? 2 : 3
            );
          },
        },
        He = ["v1", "v2", "v3"],
        Ve = { zero: 0, one: 1, two: 2, few: 3, many: 4, other: 5 },
        We = (function () {
          function e(t) {
            var n,
              r =
                arguments.length > 1 && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
            ne(this, e),
              (this.languageUtils = t),
              (this.options = r),
              (this.logger = fe.create("pluralResolver")),
              (this.options.compatibilityJSON &&
                "v4" !== this.options.compatibilityJSON) ||
                ("undefined" != typeof Intl && Intl.PluralRules) ||
                ((this.options.compatibilityJSON = "v3"),
                this.logger.error(
                  "Your environment seems not to be Intl API compatible, use an Intl.PluralRules polyfill. Will fallback to the compatibilityJSON v3 format handling."
                )),
              (this.rules =
                ((n = {}),
                Fe.forEach(function (e) {
                  e.lngs.forEach(function (t) {
                    n[t] = { numbers: e.nr, plurals: Ze[e.fc] };
                  });
                }),
                n));
          }
          return (
            oe(e, [
              {
                key: "addRule",
                value: function (e, t) {
                  this.rules[e] = t;
                },
              },
              {
                key: "getRule",
                value: function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  if (this.shouldUseIntlApi())
                    try {
                      return new Intl.PluralRules(e, {
                        type: t.ordinal ? "ordinal" : "cardinal",
                      });
                    } catch (e) {
                      return;
                    }
                  return (
                    this.rules[e] ||
                    this.rules[this.languageUtils.getLanguagePartFromCode(e)]
                  );
                },
              },
              {
                key: "needsPlural",
                value: function (e) {
                  var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n = this.getRule(e, t);
                  return this.shouldUseIntlApi()
                    ? n && n.resolvedOptions().pluralCategories.length > 1
                    : n && n.numbers.length > 1;
                },
              },
              {
                key: "getPluralFormsOfKey",
                value: function (e, t) {
                  var n =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {};
                  return this.getSuffixes(e, n).map(function (e) {
                    return "".concat(t).concat(e);
                  });
                },
              },
              {
                key: "getSuffixes",
                value: function (e) {
                  var t = this,
                    n =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    r = this.getRule(e, n);
                  return r
                    ? this.shouldUseIntlApi()
                      ? r
                          .resolvedOptions()
                          .pluralCategories.sort(function (e, t) {
                            return Ve[e] - Ve[t];
                          })
                          .map(function (e) {
                            return "".concat(t.options.prepend).concat(e);
                          })
                      : r.numbers.map(function (r) {
                          return t.getSuffix(e, r, n);
                        })
                    : [];
                },
              },
              {
                key: "getSuffix",
                value: function (e, t) {
                  var n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {},
                    r = this.getRule(e, n);
                  return r
                    ? this.shouldUseIntlApi()
                      ? "".concat(this.options.prepend).concat(r.select(t))
                      : this.getSuffixRetroCompatible(r, t)
                    : (this.logger.warn("no plural rule found for: ".concat(e)),
                      "");
                },
              },
              {
                key: "getSuffixRetroCompatible",
                value: function (e, t) {
                  var n = this,
                    r = e.noAbs ? e.plurals(t) : e.plurals(Math.abs(t)),
                    o = e.numbers[r];
                  this.options.simplifyPluralSuffix &&
                    2 === e.numbers.length &&
                    1 === e.numbers[0] &&
                    (2 === o ? (o = "plural") : 1 === o && (o = ""));
                  var a = function () {
                    return n.options.prepend && o.toString()
                      ? n.options.prepend + o.toString()
                      : o.toString();
                  };
                  return "v1" === this.options.compatibilityJSON
                    ? 1 === o
                      ? ""
                      : "number" == typeof o
                      ? "_plural_".concat(o.toString())
                      : a()
                    : "v2" === this.options.compatibilityJSON ||
                      (this.options.simplifyPluralSuffix &&
                        2 === e.numbers.length &&
                        1 === e.numbers[0])
                    ? a()
                    : this.options.prepend && r.toString()
                    ? this.options.prepend + r.toString()
                    : r.toString();
                },
              },
              {
                key: "shouldUseIntlApi",
                value: function () {
                  return !He.includes(this.options.compatibilityJSON);
                },
              },
            ]),
            e
          );
        })();
      function Ue(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function $e(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ue(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ue(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var Ke = (function () {
        function e() {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          ne(this, e),
            (this.logger = fe.create("interpolator")),
            (this.options = t),
            (this.format =
              (t.interpolation && t.interpolation.format) ||
              function (e) {
                return e;
              }),
            this.init(t);
        }
        return (
          oe(e, [
            {
              key: "init",
              value: function () {
                var e =
                  arguments.length > 0 && void 0 !== arguments[0]
                    ? arguments[0]
                    : {};
                e.interpolation || (e.interpolation = { escapeValue: !0 });
                var t = e.interpolation;
                (this.escape = void 0 !== t.escape ? t.escape : we),
                  (this.escapeValue =
                    void 0 === t.escapeValue || t.escapeValue),
                  (this.useRawValueToEscape =
                    void 0 !== t.useRawValueToEscape && t.useRawValueToEscape),
                  (this.prefix = t.prefix
                    ? ke(t.prefix)
                    : t.prefixEscaped || "{{"),
                  (this.suffix = t.suffix
                    ? ke(t.suffix)
                    : t.suffixEscaped || "}}"),
                  (this.formatSeparator = t.formatSeparator
                    ? t.formatSeparator
                    : t.formatSeparator || ","),
                  (this.unescapePrefix = t.unescapeSuffix
                    ? ""
                    : t.unescapePrefix || "-"),
                  (this.unescapeSuffix = this.unescapePrefix
                    ? ""
                    : t.unescapeSuffix || ""),
                  (this.nestingPrefix = t.nestingPrefix
                    ? ke(t.nestingPrefix)
                    : t.nestingPrefixEscaped || ke("$t(")),
                  (this.nestingSuffix = t.nestingSuffix
                    ? ke(t.nestingSuffix)
                    : t.nestingSuffixEscaped || ke(")")),
                  (this.nestingOptionsSeparator = t.nestingOptionsSeparator
                    ? t.nestingOptionsSeparator
                    : t.nestingOptionsSeparator || ","),
                  (this.maxReplaces = t.maxReplaces ? t.maxReplaces : 1e3),
                  (this.alwaysFormat =
                    void 0 !== t.alwaysFormat && t.alwaysFormat),
                  this.resetRegExp();
              },
            },
            {
              key: "reset",
              value: function () {
                this.options && this.init(this.options);
              },
            },
            {
              key: "resetRegExp",
              value: function () {
                var e = "".concat(this.prefix, "(.+?)").concat(this.suffix);
                this.regexp = new RegExp(e, "g");
                var t = ""
                  .concat(this.prefix)
                  .concat(this.unescapePrefix, "(.+?)")
                  .concat(this.unescapeSuffix)
                  .concat(this.suffix);
                this.regexpUnescape = new RegExp(t, "g");
                var n = ""
                  .concat(this.nestingPrefix, "(.+?)")
                  .concat(this.nestingSuffix);
                this.nestingRegexp = new RegExp(n, "g");
              },
            },
            {
              key: "interpolate",
              value: function (e, t, n, r) {
                var o,
                  a,
                  i,
                  s = this,
                  l =
                    (this.options &&
                      this.options.interpolation &&
                      this.options.interpolation.defaultVariables) ||
                    {};
                function d(e) {
                  return e.replace(/\$/g, "$$$$");
                }
                var c = function (e) {
                  if (e.indexOf(s.formatSeparator) < 0) {
                    var o = xe(t, l, e);
                    return s.alwaysFormat
                      ? s.format(
                          o,
                          void 0,
                          n,
                          $e($e($e({}, r), t), {}, { interpolationkey: e })
                        )
                      : o;
                  }
                  var a = e.split(s.formatSeparator),
                    i = a.shift().trim(),
                    d = a.join(s.formatSeparator).trim();
                  return s.format(
                    xe(t, l, i),
                    d,
                    n,
                    $e($e($e({}, r), t), {}, { interpolationkey: i })
                  );
                };
                this.resetRegExp();
                var u =
                    (r && r.missingInterpolationHandler) ||
                    this.options.missingInterpolationHandler,
                  p =
                    r &&
                    r.interpolation &&
                    void 0 !== r.interpolation.skipOnVariables
                      ? r.interpolation.skipOnVariables
                      : this.options.interpolation.skipOnVariables;
                return (
                  [
                    {
                      regex: this.regexpUnescape,
                      safeValue: function (e) {
                        return d(e);
                      },
                    },
                    {
                      regex: this.regexp,
                      safeValue: function (e) {
                        return s.escapeValue ? d(s.escape(e)) : d(e);
                      },
                    },
                  ].forEach(function (t) {
                    for (i = 0; (o = t.regex.exec(e)); ) {
                      var n = o[1].trim();
                      if (void 0 === (a = c(n)))
                        if ("function" == typeof u) {
                          var l = u(e, o, r);
                          a = "string" == typeof l ? l : "";
                        } else if (r && r.hasOwnProperty(n)) a = "";
                        else {
                          if (p) {
                            a = o[0];
                            continue;
                          }
                          s.logger.warn(
                            "missed to pass in variable "
                              .concat(n, " for interpolating ")
                              .concat(e)
                          ),
                            (a = "");
                        }
                      else
                        "string" == typeof a ||
                          s.useRawValueToEscape ||
                          (a = be(a));
                      var d = t.safeValue(a);
                      if (
                        ((e = e.replace(o[0], d)),
                        p
                          ? ((t.regex.lastIndex += a.length),
                            (t.regex.lastIndex -= o[0].length))
                          : (t.regex.lastIndex = 0),
                        ++i >= s.maxReplaces)
                      )
                        break;
                    }
                  }),
                  e
                );
              },
            },
            {
              key: "nest",
              value: function (e, t) {
                var n,
                  r,
                  o = this,
                  a =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {},
                  i = $e({}, a);
                function s(e, t) {
                  var n = this.nestingOptionsSeparator;
                  if (e.indexOf(n) < 0) return e;
                  var r = e.split(new RegExp("".concat(n, "[ ]*{"))),
                    o = "{".concat(r[1]);
                  e = r[0];
                  var a = (o = this.interpolate(o, i)).match(/'/g),
                    s = o.match(/"/g);
                  ((a && a.length % 2 == 0 && !s) || s.length % 2 != 0) &&
                    (o = o.replace(/'/g, '"'));
                  try {
                    (i = JSON.parse(o)), t && (i = $e($e({}, t), i));
                  } catch (t) {
                    return (
                      this.logger.warn(
                        "failed parsing options string in nesting for key ".concat(
                          e
                        ),
                        t
                      ),
                      "".concat(e).concat(n).concat(o)
                    );
                  }
                  return delete i.defaultValue, e;
                }
                for (
                  i.applyPostProcessor = !1, delete i.defaultValue;
                  (n = this.nestingRegexp.exec(e));

                ) {
                  var l = [],
                    d = !1;
                  if (
                    -1 !== n[0].indexOf(this.formatSeparator) &&
                    !/{.*}/.test(n[1])
                  ) {
                    var c = n[1].split(this.formatSeparator).map(function (e) {
                      return e.trim();
                    });
                    (n[1] = c.shift()), (l = c), (d = !0);
                  }
                  if (
                    (r = t(s.call(this, n[1].trim(), i), i)) &&
                    n[0] === e &&
                    "string" != typeof r
                  )
                    return r;
                  "string" != typeof r && (r = be(r)),
                    r ||
                      (this.logger.warn(
                        "missed to resolve "
                          .concat(n[1], " for nesting ")
                          .concat(e)
                      ),
                      (r = "")),
                    d &&
                      (r = l.reduce(function (e, t) {
                        return o.format(
                          e,
                          t,
                          a.lng,
                          $e($e({}, a), {}, { interpolationkey: n[1].trim() })
                        );
                      }, r.trim())),
                    (e = e.replace(n[0], r)),
                    (this.regexp.lastIndex = 0);
                }
                return e;
              },
            },
          ]),
          e
        );
      })();
      function Ge(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function qe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Ge(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Ge(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function Qe(e) {
        var t = {};
        return function (n, r, o) {
          var a = r + JSON.stringify(o),
            i = t[a];
          return i || ((i = e(r, o)), (t[a] = i)), i(n);
        };
      }
      var Ye = (function () {
        function e() {
          var t =
            arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
          ne(this, e),
            (this.logger = fe.create("formatter")),
            (this.options = t),
            (this.formats = {
              number: Qe(function (e, t) {
                var n = new Intl.NumberFormat(e, t);
                return function (e) {
                  return n.format(e);
                };
              }),
              currency: Qe(function (e, t) {
                var n = new Intl.NumberFormat(
                  e,
                  qe(qe({}, t), {}, { style: "currency" })
                );
                return function (e) {
                  return n.format(e);
                };
              }),
              datetime: Qe(function (e, t) {
                var n = new Intl.DateTimeFormat(e, qe({}, t));
                return function (e) {
                  return n.format(e);
                };
              }),
              relativetime: Qe(function (e, t) {
                var n = new Intl.RelativeTimeFormat(e, qe({}, t));
                return function (e) {
                  return n.format(e, t.range || "day");
                };
              }),
              list: Qe(function (e, t) {
                var n = new Intl.ListFormat(e, qe({}, t));
                return function (e) {
                  return n.format(e);
                };
              }),
            }),
            this.init(t);
        }
        return (
          oe(e, [
            {
              key: "init",
              value: function (e) {
                var t = (
                  arguments.length > 1 && void 0 !== arguments[1]
                    ? arguments[1]
                    : { interpolation: {} }
                ).interpolation;
                this.formatSeparator = t.formatSeparator
                  ? t.formatSeparator
                  : t.formatSeparator || ",";
              },
            },
            {
              key: "add",
              value: function (e, t) {
                this.formats[e.toLowerCase().trim()] = t;
              },
            },
            {
              key: "addCached",
              value: function (e, t) {
                this.formats[e.toLowerCase().trim()] = Qe(t);
              },
            },
            {
              key: "format",
              value: function (e, t, n, r) {
                var o = this;
                return t.split(this.formatSeparator).reduce(function (e, t) {
                  var a = (function (e) {
                      var t = e.toLowerCase().trim(),
                        n = {};
                      if (e.indexOf("(") > -1) {
                        var r = e.split("(");
                        t = r[0].toLowerCase().trim();
                        var o = r[1].substring(0, r[1].length - 1);
                        "currency" === t && o.indexOf(":") < 0
                          ? n.currency || (n.currency = o.trim())
                          : "relativetime" === t && o.indexOf(":") < 0
                          ? n.range || (n.range = o.trim())
                          : o.split(";").forEach(function (e) {
                              if (e) {
                                var t =
                                    (function (e) {
                                      if (Array.isArray(e)) return e;
                                    })((a = e.split(":"))) ||
                                    (function (e) {
                                      if (
                                        ("undefined" != typeof Symbol &&
                                          null != e[Symbol.iterator]) ||
                                        null != e["@@iterator"]
                                      )
                                        return Array.from(e);
                                    })(a) ||
                                    (function (e, t) {
                                      if (e) {
                                        if ("string" == typeof e)
                                          return ce(e, t);
                                        var n = {}.toString
                                          .call(e)
                                          .slice(8, -1);
                                        return (
                                          "Object" === n &&
                                            e.constructor &&
                                            (n = e.constructor.name),
                                          "Map" === n || "Set" === n
                                            ? Array.from(e)
                                            : "Arguments" === n ||
                                              /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(
                                                n
                                              )
                                            ? ce(e, t)
                                            : void 0
                                        );
                                      }
                                    })(a) ||
                                    (function () {
                                      throw new TypeError(
                                        "Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
                                      );
                                    })(),
                                  r = t[0],
                                  o = t
                                    .slice(1)
                                    .join(":")
                                    .trim()
                                    .replace(/^'+|'+$/g, "");
                                n[r.trim()] || (n[r.trim()] = o),
                                  "false" === o && (n[r.trim()] = !1),
                                  "true" === o && (n[r.trim()] = !0),
                                  isNaN(o) || (n[r.trim()] = parseInt(o, 10));
                              }
                              var a;
                            });
                      }
                      return { formatName: t, formatOptions: n };
                    })(t),
                    i = a.formatName,
                    s = a.formatOptions;
                  if (o.formats[i]) {
                    var l = e;
                    try {
                      var d =
                          (r &&
                            r.formatParams &&
                            r.formatParams[r.interpolationkey]) ||
                          {},
                        c = d.locale || d.lng || r.locale || r.lng || n;
                      l = o.formats[i](e, c, qe(qe(qe({}, s), r), d));
                    } catch (e) {
                      o.logger.warn(e);
                    }
                    return l;
                  }
                  return (
                    o.logger.warn(
                      "there was no format function for ".concat(i)
                    ),
                    e
                  );
                }, e);
              },
            },
          ]),
          e
        );
      })();
      function Je(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function Xe(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? Je(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : Je(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      var et = (function (e) {
        se(o, e);
        var t,
          n,
          r =
            ((t = o),
            (n = (function () {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Boolean.prototype.valueOf.call(
                    Reflect.construct(Boolean, [], function () {})
                  ),
                  !0
                );
              } catch (e) {
                return !1;
              }
            })()),
            function () {
              var e,
                r = de(t);
              if (n) {
                var o = de(this).constructor;
                e = Reflect.construct(r, arguments, o);
              } else e = r.apply(this, arguments);
              return le(this, e);
            });
        function o(e, t, n) {
          var a,
            i =
              arguments.length > 3 && void 0 !== arguments[3]
                ? arguments[3]
                : {};
          return (
            ne(this, o),
            (a = r.call(this)),
            Oe && ge.call(ae(a)),
            (a.backend = e),
            (a.store = t),
            (a.services = n),
            (a.languageUtils = n.languageUtils),
            (a.options = i),
            (a.logger = fe.create("backendConnector")),
            (a.waitingReads = []),
            (a.maxParallelReads = i.maxParallelReads || 10),
            (a.readingCalls = 0),
            (a.maxRetries = i.maxRetries >= 0 ? i.maxRetries : 5),
            (a.retryTimeout = i.retryTimeout >= 1 ? i.retryTimeout : 350),
            (a.state = {}),
            (a.queue = []),
            a.backend && a.backend.init && a.backend.init(n, i.backend, i),
            a
          );
        }
        return (
          oe(o, [
            {
              key: "queueLoad",
              value: function (e, t, n, r) {
                var o = this,
                  a = {},
                  i = {},
                  s = {},
                  l = {};
                return (
                  e.forEach(function (e) {
                    var r = !0;
                    t.forEach(function (t) {
                      var s = "".concat(e, "|").concat(t);
                      !n.reload && o.store.hasResourceBundle(e, t)
                        ? (o.state[s] = 2)
                        : o.state[s] < 0 ||
                          (1 === o.state[s]
                            ? void 0 === i[s] && (i[s] = !0)
                            : ((o.state[s] = 1),
                              (r = !1),
                              void 0 === i[s] && (i[s] = !0),
                              void 0 === a[s] && (a[s] = !0),
                              void 0 === l[t] && (l[t] = !0)));
                    }),
                      r || (s[e] = !0);
                  }),
                  (Object.keys(a).length || Object.keys(i).length) &&
                    this.queue.push({
                      pending: i,
                      pendingCount: Object.keys(i).length,
                      loaded: {},
                      errors: [],
                      callback: r,
                    }),
                  {
                    toLoad: Object.keys(a),
                    pending: Object.keys(i),
                    toLoadLanguages: Object.keys(s),
                    toLoadNamespaces: Object.keys(l),
                  }
                );
              },
            },
            {
              key: "loaded",
              value: function (e, t, n) {
                var r = e.split("|"),
                  o = r[0],
                  a = r[1];
                t && this.emit("failedLoading", o, a, t),
                  n && this.store.addResourceBundle(o, a, n),
                  (this.state[e] = t ? -1 : 2);
                var i = {};
                this.queue.forEach(function (n) {
                  !(function (e, t, n, r) {
                    var o = _e(e, t, Object),
                      a = o.obj,
                      i = o.k;
                    (a[i] = a[i] || []), a[i].push(n);
                  })(n.loaded, [o], a),
                    (function (e, t) {
                      void 0 !== e.pending[t] &&
                        (delete e.pending[t], e.pendingCount--);
                    })(n, e),
                    t && n.errors.push(t),
                    0 !== n.pendingCount ||
                      n.done ||
                      (Object.keys(n.loaded).forEach(function (e) {
                        i[e] || (i[e] = {});
                        var t = n.loaded[e];
                        t.length &&
                          t.forEach(function (t) {
                            void 0 === i[e][t] && (i[e][t] = !0);
                          });
                      }),
                      (n.done = !0),
                      n.errors.length ? n.callback(n.errors) : n.callback());
                }),
                  this.emit("loaded", i),
                  (this.queue = this.queue.filter(function (e) {
                    return !e.done;
                  }));
              },
            },
            {
              key: "read",
              value: function (e, t, n) {
                var r = this,
                  o =
                    arguments.length > 3 && void 0 !== arguments[3]
                      ? arguments[3]
                      : 0,
                  a =
                    arguments.length > 4 && void 0 !== arguments[4]
                      ? arguments[4]
                      : this.retryTimeout,
                  i = arguments.length > 5 ? arguments[5] : void 0;
                return e.length
                  ? this.readingCalls >= this.maxParallelReads
                    ? void this.waitingReads.push({
                        lng: e,
                        ns: t,
                        fcName: n,
                        tried: o,
                        wait: a,
                        callback: i,
                      })
                    : (this.readingCalls++,
                      this.backend[n](e, t, function (s, l) {
                        if ((r.readingCalls--, r.waitingReads.length > 0)) {
                          var d = r.waitingReads.shift();
                          r.read(
                            d.lng,
                            d.ns,
                            d.fcName,
                            d.tried,
                            d.wait,
                            d.callback
                          );
                        }
                        s && l && o < r.maxRetries
                          ? setTimeout(function () {
                              r.read.call(r, e, t, n, o + 1, 2 * a, i);
                            }, a)
                          : i(s, l);
                      }))
                  : i(null, {});
              },
            },
            {
              key: "prepareLoading",
              value: function (e, t) {
                var n = this,
                  r =
                    arguments.length > 2 && void 0 !== arguments[2]
                      ? arguments[2]
                      : {},
                  o = arguments.length > 3 ? arguments[3] : void 0;
                if (!this.backend)
                  return (
                    this.logger.warn(
                      "No backend was added via i18next.use. Will not load resources."
                    ),
                    o && o()
                  );
                "string" == typeof e &&
                  (e = this.languageUtils.toResolveHierarchy(e)),
                  "string" == typeof t && (t = [t]);
                var a = this.queueLoad(e, t, r, o);
                if (!a.toLoad.length) return a.pending.length || o(), null;
                a.toLoad.forEach(function (e) {
                  n.loadOne(e);
                });
              },
            },
            {
              key: "load",
              value: function (e, t, n) {
                this.prepareLoading(e, t, {}, n);
              },
            },
            {
              key: "reload",
              value: function (e, t, n) {
                this.prepareLoading(e, t, { reload: !0 }, n);
              },
            },
            {
              key: "loadOne",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : "",
                  r = e.split("|"),
                  o = r[0],
                  a = r[1];
                this.read(o, a, "read", void 0, void 0, function (r, i) {
                  r &&
                    t.logger.warn(
                      ""
                        .concat(n, "loading namespace ")
                        .concat(a, " for language ")
                        .concat(o, " failed"),
                      r
                    ),
                    !r &&
                      i &&
                      t.logger.log(
                        ""
                          .concat(n, "loaded namespace ")
                          .concat(a, " for language ")
                          .concat(o),
                        i
                      ),
                    t.loaded(e, r, i);
                });
              },
            },
            {
              key: "saveMissing",
              value: function (e, t, n, r, o) {
                var a =
                  arguments.length > 5 && void 0 !== arguments[5]
                    ? arguments[5]
                    : {};
                this.services.utils &&
                this.services.utils.hasLoadedNamespace &&
                !this.services.utils.hasLoadedNamespace(t)
                  ? this.logger.warn(
                      'did not save key "'
                        .concat(n, '" as the namespace "')
                        .concat(t, '" was not yet loaded'),
                      "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!"
                    )
                  : null != n &&
                    "" !== n &&
                    (this.backend &&
                      this.backend.create &&
                      this.backend.create(
                        e,
                        t,
                        n,
                        r,
                        null,
                        Xe(Xe({}, a), {}, { isUpdate: o })
                      ),
                    e && e[0] && this.store.addResource(e[0], t, n, r));
              },
            },
          ]),
          o
        );
      })(ge);
      function tt(e) {
        return (
          "string" == typeof e.ns && (e.ns = [e.ns]),
          "string" == typeof e.fallbackLng && (e.fallbackLng = [e.fallbackLng]),
          "string" == typeof e.fallbackNS && (e.fallbackNS = [e.fallbackNS]),
          e.supportedLngs &&
            e.supportedLngs.indexOf("cimode") < 0 &&
            (e.supportedLngs = e.supportedLngs.concat(["cimode"])),
          e
        );
      }
      function nt(e, t) {
        var n = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
          var r = Object.getOwnPropertySymbols(e);
          t &&
            (r = r.filter(function (t) {
              return Object.getOwnPropertyDescriptor(e, t).enumerable;
            })),
            n.push.apply(n, r);
        }
        return n;
      }
      function rt(e) {
        for (var t = 1; t < arguments.length; t++) {
          var n = null != arguments[t] ? arguments[t] : {};
          t % 2
            ? nt(Object(n), !0).forEach(function (t) {
                k(e, t, n[t]);
              })
            : Object.getOwnPropertyDescriptors
            ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n))
            : nt(Object(n)).forEach(function (t) {
                Object.defineProperty(
                  e,
                  t,
                  Object.getOwnPropertyDescriptor(n, t)
                );
              });
        }
        return e;
      }
      function ot() {}
      var at = (function (e) {
        se(o, e);
        var t,
          n,
          r =
            ((t = o),
            (n = (function () {
              if ("undefined" == typeof Reflect || !Reflect.construct)
                return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return (
                  Boolean.prototype.valueOf.call(
                    Reflect.construct(Boolean, [], function () {})
                  ),
                  !0
                );
              } catch (e) {
                return !1;
              }
            })()),
            function () {
              var e,
                r = de(t);
              if (n) {
                var o = de(this).constructor;
                e = Reflect.construct(r, arguments, o);
              } else e = r.apply(this, arguments);
              return le(this, e);
            });
        function o() {
          var e,
            t,
            n =
              arguments.length > 0 && void 0 !== arguments[0]
                ? arguments[0]
                : {},
            a = arguments.length > 1 ? arguments[1] : void 0;
          if (
            (ne(this, o),
            (e = r.call(this)),
            Oe && ge.call(ae(e)),
            (e.options = tt(n)),
            (e.services = {}),
            (e.logger = fe),
            (e.modules = { external: [] }),
            (t = ae(e)),
            Object.getOwnPropertyNames(Object.getPrototypeOf(t)).forEach(
              function (e) {
                "function" == typeof t[e] && (t[e] = t[e].bind(t));
              }
            ),
            a && !e.isInitialized && !n.isClone)
          ) {
            if (!e.options.initImmediate) return e.init(n, a), le(e, ae(e));
            setTimeout(function () {
              e.init(n, a);
            }, 0);
          }
          return e;
        }
        return (
          oe(o, [
            {
              key: "init",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : {},
                  n = arguments.length > 1 ? arguments[1] : void 0;
                "function" == typeof t && ((n = t), (t = {})),
                  !t.defaultNS &&
                    !1 !== t.defaultNS &&
                    t.ns &&
                    ("string" == typeof t.ns
                      ? (t.defaultNS = t.ns)
                      : t.ns.indexOf("translation") < 0 &&
                        (t.defaultNS = t.ns[0]));
                var r = {
                  debug: !1,
                  initImmediate: !0,
                  ns: ["translation"],
                  defaultNS: ["translation"],
                  fallbackLng: ["dev"],
                  fallbackNS: !1,
                  supportedLngs: !1,
                  nonExplicitSupportedLngs: !1,
                  load: "all",
                  preload: !1,
                  simplifyPluralSuffix: !0,
                  keySeparator: ".",
                  nsSeparator: ":",
                  pluralSeparator: "_",
                  contextSeparator: "_",
                  partialBundledLanguages: !1,
                  saveMissing: !1,
                  updateMissing: !1,
                  saveMissingTo: "fallback",
                  saveMissingPlurals: !0,
                  missingKeyHandler: !1,
                  missingInterpolationHandler: !1,
                  postProcess: !1,
                  postProcessPassResolved: !1,
                  returnNull: !0,
                  returnEmptyString: !0,
                  returnObjects: !1,
                  joinArrays: !1,
                  returnedObjectHandler: !1,
                  parseMissingKeyHandler: !1,
                  appendNamespaceToMissingKey: !1,
                  appendNamespaceToCIMode: !1,
                  overloadTranslationOptionHandler: function (e) {
                    var t = {};
                    if (
                      ("object" === x(e[1]) && (t = e[1]),
                      "string" == typeof e[1] && (t.defaultValue = e[1]),
                      "string" == typeof e[2] && (t.tDescription = e[2]),
                      "object" === x(e[2]) || "object" === x(e[3]))
                    ) {
                      var n = e[3] || e[2];
                      Object.keys(n).forEach(function (e) {
                        t[e] = n[e];
                      });
                    }
                    return t;
                  },
                  interpolation: {
                    escapeValue: !0,
                    format: function (e, t, n, r) {
                      return e;
                    },
                    prefix: "{{",
                    suffix: "}}",
                    formatSeparator: ",",
                    unescapePrefix: "-",
                    nestingPrefix: "$t(",
                    nestingSuffix: ")",
                    nestingOptionsSeparator: ",",
                    maxReplaces: 1e3,
                    skipOnVariables: !0,
                  },
                };
                function o(e) {
                  return e ? ("function" == typeof e ? new e() : e) : null;
                }
                if (
                  ((this.options = rt(rt(rt({}, r), this.options), tt(t))),
                  "v1" !== this.options.compatibilityAPI &&
                    (this.options.interpolation = rt(
                      rt({}, r.interpolation),
                      this.options.interpolation
                    )),
                  void 0 !== t.keySeparator &&
                    (this.options.userDefinedKeySeparator = t.keySeparator),
                  void 0 !== t.nsSeparator &&
                    (this.options.userDefinedNsSeparator = t.nsSeparator),
                  !this.options.isClone)
                ) {
                  var a;
                  this.modules.logger
                    ? fe.init(o(this.modules.logger), this.options)
                    : fe.init(null, this.options),
                    this.modules.formatter
                      ? (a = this.modules.formatter)
                      : "undefined" != typeof Intl && (a = Ye);
                  var i = new ze(this.options);
                  this.store = new Ne(this.options.resources, this.options);
                  var s = this.services;
                  (s.logger = fe),
                    (s.resourceStore = this.store),
                    (s.languageUtils = i),
                    (s.pluralResolver = new We(i, {
                      prepend: this.options.pluralSeparator,
                      compatibilityJSON: this.options.compatibilityJSON,
                      simplifyPluralSuffix: this.options.simplifyPluralSuffix,
                    })),
                    !a ||
                      (this.options.interpolation.format &&
                        this.options.interpolation.format !==
                          r.interpolation.format) ||
                      ((s.formatter = o(a)),
                      s.formatter.init(s, this.options),
                      (this.options.interpolation.format =
                        s.formatter.format.bind(s.formatter))),
                    (s.interpolator = new Ke(this.options)),
                    (s.utils = {
                      hasLoadedNamespace: this.hasLoadedNamespace.bind(this),
                    }),
                    (s.backendConnector = new et(
                      o(this.modules.backend),
                      s.resourceStore,
                      s,
                      this.options
                    )),
                    s.backendConnector.on("*", function (t) {
                      for (
                        var n = arguments.length,
                          r = new Array(n > 1 ? n - 1 : 0),
                          o = 1;
                        o < n;
                        o++
                      )
                        r[o - 1] = arguments[o];
                      e.emit.apply(e, [t].concat(r));
                    }),
                    this.modules.languageDetector &&
                      ((s.languageDetector = o(this.modules.languageDetector)),
                      s.languageDetector.init(
                        s,
                        this.options.detection,
                        this.options
                      )),
                    this.modules.i18nFormat &&
                      ((s.i18nFormat = o(this.modules.i18nFormat)),
                      s.i18nFormat.init && s.i18nFormat.init(this)),
                    (this.translator = new Le(this.services, this.options)),
                    this.translator.on("*", function (t) {
                      for (
                        var n = arguments.length,
                          r = new Array(n > 1 ? n - 1 : 0),
                          o = 1;
                        o < n;
                        o++
                      )
                        r[o - 1] = arguments[o];
                      e.emit.apply(e, [t].concat(r));
                    }),
                    this.modules.external.forEach(function (t) {
                      t.init && t.init(e);
                    });
                }
                if (
                  ((this.format = this.options.interpolation.format),
                  n || (n = ot),
                  this.options.fallbackLng &&
                    !this.services.languageDetector &&
                    !this.options.lng)
                ) {
                  var l = this.services.languageUtils.getFallbackCodes(
                    this.options.fallbackLng
                  );
                  l.length > 0 && "dev" !== l[0] && (this.options.lng = l[0]);
                }
                this.services.languageDetector ||
                  this.options.lng ||
                  this.logger.warn(
                    "init: no languageDetector is used and no lng is defined"
                  ),
                  [
                    "getResource",
                    "hasResourceBundle",
                    "getResourceBundle",
                    "getDataByLanguage",
                  ].forEach(function (t) {
                    e[t] = function () {
                      var n;
                      return (n = e.store)[t].apply(n, arguments);
                    };
                  }),
                  [
                    "addResource",
                    "addResources",
                    "addResourceBundle",
                    "removeResourceBundle",
                  ].forEach(function (t) {
                    e[t] = function () {
                      var n;
                      return (n = e.store)[t].apply(n, arguments), e;
                    };
                  });
                var d = ve(),
                  c = function () {
                    var t = function (t, r) {
                      e.isInitialized &&
                        !e.initializedStoreOnce &&
                        e.logger.warn(
                          "init: i18next is already initialized. You should call init just once!"
                        ),
                        (e.isInitialized = !0),
                        e.options.isClone ||
                          e.logger.log("initialized", e.options),
                        e.emit("initialized", e.options),
                        d.resolve(r),
                        n(t, r);
                    };
                    if (
                      e.languages &&
                      "v1" !== e.options.compatibilityAPI &&
                      !e.isInitialized
                    )
                      return t(null, e.t.bind(e));
                    e.changeLanguage(e.options.lng, t);
                  };
                return (
                  this.options.resources || !this.options.initImmediate
                    ? c()
                    : setTimeout(c, 0),
                  d
                );
              },
            },
            {
              key: "loadResources",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : ot,
                  r = "string" == typeof e ? e : this.language;
                if (
                  ("function" == typeof e && (n = e),
                  !this.options.resources ||
                    this.options.partialBundledLanguages)
                ) {
                  if (r && "cimode" === r.toLowerCase()) return n();
                  var o = [],
                    a = function (e) {
                      e &&
                        t.services.languageUtils
                          .toResolveHierarchy(e)
                          .forEach(function (e) {
                            o.indexOf(e) < 0 && o.push(e);
                          });
                    };
                  r
                    ? a(r)
                    : this.services.languageUtils
                        .getFallbackCodes(this.options.fallbackLng)
                        .forEach(function (e) {
                          return a(e);
                        }),
                    this.options.preload &&
                      this.options.preload.forEach(function (e) {
                        return a(e);
                      }),
                    this.services.backendConnector.load(
                      o,
                      this.options.ns,
                      function (e) {
                        e ||
                          t.resolvedLanguage ||
                          !t.language ||
                          t.setResolvedLanguage(t.language),
                          n(e);
                      }
                    );
                } else n(null);
              },
            },
            {
              key: "reloadResources",
              value: function (e, t, n) {
                var r = ve();
                return (
                  e || (e = this.languages),
                  t || (t = this.options.ns),
                  n || (n = ot),
                  this.services.backendConnector.reload(e, t, function (e) {
                    r.resolve(), n(e);
                  }),
                  r
                );
              },
            },
            {
              key: "use",
              value: function (e) {
                if (!e)
                  throw new Error(
                    "You are passing an undefined module! Please check the object you are passing to i18next.use()"
                  );
                if (!e.type)
                  throw new Error(
                    "You are passing a wrong module! Please check the object you are passing to i18next.use()"
                  );
                return (
                  "backend" === e.type && (this.modules.backend = e),
                  ("logger" === e.type || (e.log && e.warn && e.error)) &&
                    (this.modules.logger = e),
                  "languageDetector" === e.type &&
                    (this.modules.languageDetector = e),
                  "i18nFormat" === e.type && (this.modules.i18nFormat = e),
                  "postProcessor" === e.type && De.addPostProcessor(e),
                  "formatter" === e.type && (this.modules.formatter = e),
                  "3rdParty" === e.type && this.modules.external.push(e),
                  this
                );
              },
            },
            {
              key: "setResolvedLanguage",
              value: function (e) {
                if (e && this.languages && !(["cimode", "dev"].indexOf(e) > -1))
                  for (var t = 0; t < this.languages.length; t++) {
                    var n = this.languages[t];
                    if (
                      !(["cimode", "dev"].indexOf(n) > -1) &&
                      this.store.hasLanguageSomeTranslations(n)
                    ) {
                      this.resolvedLanguage = n;
                      break;
                    }
                  }
              },
            },
            {
              key: "changeLanguage",
              value: function (e, t) {
                var n = this;
                this.isLanguageChangingTo = e;
                var r = ve();
                this.emit("languageChanging", e);
                var o = function (e) {
                    (n.language = e),
                      (n.languages =
                        n.services.languageUtils.toResolveHierarchy(e)),
                      (n.resolvedLanguage = void 0),
                      n.setResolvedLanguage(e);
                  },
                  a = function (a) {
                    e || a || !n.services.languageDetector || (a = []);
                    var i =
                      "string" == typeof a
                        ? a
                        : n.services.languageUtils.getBestMatchFromCodes(a);
                    i &&
                      (n.language || o(i),
                      n.translator.language || n.translator.changeLanguage(i),
                      n.services.languageDetector &&
                        n.services.languageDetector.cacheUserLanguage(i)),
                      n.loadResources(i, function (e) {
                        !(function (e, a) {
                          a
                            ? (o(a),
                              n.translator.changeLanguage(a),
                              (n.isLanguageChangingTo = void 0),
                              n.emit("languageChanged", a),
                              n.logger.log("languageChanged", a))
                            : (n.isLanguageChangingTo = void 0),
                            r.resolve(function () {
                              return n.t.apply(n, arguments);
                            }),
                            t &&
                              t(e, function () {
                                return n.t.apply(n, arguments);
                              });
                        })(e, i);
                      });
                  };
                return (
                  e ||
                  !this.services.languageDetector ||
                  this.services.languageDetector.async
                    ? !e &&
                      this.services.languageDetector &&
                      this.services.languageDetector.async
                      ? this.services.languageDetector.detect(a)
                      : a(e)
                    : a(this.services.languageDetector.detect()),
                  r
                );
              },
            },
            {
              key: "getFixedT",
              value: function (e, t, n) {
                var r = this,
                  o = function e(t, o) {
                    var a;
                    if ("object" !== x(o)) {
                      for (
                        var i = arguments.length,
                          s = new Array(i > 2 ? i - 2 : 0),
                          l = 2;
                        l < i;
                        l++
                      )
                        s[l - 2] = arguments[l];
                      a = r.options.overloadTranslationOptionHandler(
                        [t, o].concat(s)
                      );
                    } else a = rt({}, o);
                    (a.lng = a.lng || e.lng),
                      (a.lngs = a.lngs || e.lngs),
                      (a.ns = a.ns || e.ns),
                      (a.keyPrefix = a.keyPrefix || n || e.keyPrefix);
                    var d = r.options.keySeparator || ".",
                      c = a.keyPrefix
                        ? "".concat(a.keyPrefix).concat(d).concat(t)
                        : t;
                    return r.t(c, a);
                  };
                return (
                  "string" == typeof e ? (o.lng = e) : (o.lngs = e),
                  (o.ns = t),
                  (o.keyPrefix = n),
                  o
                );
              },
            },
            {
              key: "t",
              value: function () {
                var e;
                return (
                  this.translator &&
                  (e = this.translator).translate.apply(e, arguments)
                );
              },
            },
            {
              key: "exists",
              value: function () {
                var e;
                return (
                  this.translator &&
                  (e = this.translator).exists.apply(e, arguments)
                );
              },
            },
            {
              key: "setDefaultNamespace",
              value: function (e) {
                this.options.defaultNS = e;
              },
            },
            {
              key: "hasLoadedNamespace",
              value: function (e) {
                var t = this,
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                if (!this.isInitialized)
                  return (
                    this.logger.warn(
                      "hasLoadedNamespace: i18next was not initialized",
                      this.languages
                    ),
                    !1
                  );
                if (!this.languages || !this.languages.length)
                  return (
                    this.logger.warn(
                      "hasLoadedNamespace: i18n.languages were undefined or empty",
                      this.languages
                    ),
                    !1
                  );
                var r = this.resolvedLanguage || this.languages[0],
                  o = !!this.options && this.options.fallbackLng,
                  a = this.languages[this.languages.length - 1];
                if ("cimode" === r.toLowerCase()) return !0;
                var i = function (e, n) {
                  var r =
                    t.services.backendConnector.state[
                      "".concat(e, "|").concat(n)
                    ];
                  return -1 === r || 2 === r;
                };
                if (n.precheck) {
                  var s = n.precheck(this, i);
                  if (void 0 !== s) return s;
                }
                return !(
                  !this.hasResourceBundle(r, e) &&
                  this.services.backendConnector.backend &&
                  (!this.options.resources ||
                    this.options.partialBundledLanguages) &&
                  (!i(r, e) || (o && !i(a, e)))
                );
              },
            },
            {
              key: "loadNamespaces",
              value: function (e, t) {
                var n = this,
                  r = ve();
                return this.options.ns
                  ? ("string" == typeof e && (e = [e]),
                    e.forEach(function (e) {
                      n.options.ns.indexOf(e) < 0 && n.options.ns.push(e);
                    }),
                    this.loadResources(function (e) {
                      r.resolve(), t && t(e);
                    }),
                    r)
                  : (t && t(), Promise.resolve());
              },
            },
            {
              key: "loadLanguages",
              value: function (e, t) {
                var n = ve();
                "string" == typeof e && (e = [e]);
                var r = this.options.preload || [],
                  o = e.filter(function (e) {
                    return r.indexOf(e) < 0;
                  });
                return o.length
                  ? ((this.options.preload = r.concat(o)),
                    this.loadResources(function (e) {
                      n.resolve(), t && t(e);
                    }),
                    n)
                  : (t && t(), Promise.resolve());
              },
            },
            {
              key: "dir",
              value: function (e) {
                return (
                  e ||
                    (e =
                      this.resolvedLanguage ||
                      (this.languages && this.languages.length > 0
                        ? this.languages[0]
                        : this.language)),
                  e
                    ? [
                        "ar",
                        "shu",
                        "sqr",
                        "ssh",
                        "xaa",
                        "yhd",
                        "yud",
                        "aao",
                        "abh",
                        "abv",
                        "acm",
                        "acq",
                        "acw",
                        "acx",
                        "acy",
                        "adf",
                        "ads",
                        "aeb",
                        "aec",
                        "afb",
                        "ajp",
                        "apc",
                        "apd",
                        "arb",
                        "arq",
                        "ars",
                        "ary",
                        "arz",
                        "auz",
                        "avl",
                        "ayh",
                        "ayl",
                        "ayn",
                        "ayp",
                        "bbz",
                        "pga",
                        "he",
                        "iw",
                        "ps",
                        "pbt",
                        "pbu",
                        "pst",
                        "prp",
                        "prd",
                        "ug",
                        "ur",
                        "ydd",
                        "yds",
                        "yih",
                        "ji",
                        "yi",
                        "hbo",
                        "men",
                        "xmn",
                        "fa",
                        "jpr",
                        "peo",
                        "pes",
                        "prs",
                        "dv",
                        "sam",
                        "ckb",
                      ].indexOf(
                        this.services.languageUtils.getLanguagePartFromCode(e)
                      ) > -1 || e.toLowerCase().indexOf("-arab") > 1
                      ? "rtl"
                      : "ltr"
                    : "rtl"
                );
              },
            },
            {
              key: "cloneInstance",
              value: function () {
                var e = this,
                  t =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : {},
                  n =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : ot,
                  r = rt(rt(rt({}, this.options), t), { isClone: !0 }),
                  a = new o(r);
                return (
                  (void 0 === t.debug && void 0 === t.prefix) ||
                    (a.logger = a.logger.clone(t)),
                  ["store", "services", "language"].forEach(function (t) {
                    a[t] = e[t];
                  }),
                  (a.services = rt({}, this.services)),
                  (a.services.utils = {
                    hasLoadedNamespace: a.hasLoadedNamespace.bind(a),
                  }),
                  (a.translator = new Le(a.services, a.options)),
                  a.translator.on("*", function (e) {
                    for (
                      var t = arguments.length,
                        n = new Array(t > 1 ? t - 1 : 0),
                        r = 1;
                      r < t;
                      r++
                    )
                      n[r - 1] = arguments[r];
                    a.emit.apply(a, [e].concat(n));
                  }),
                  a.init(r, n),
                  (a.translator.options = a.options),
                  (a.translator.backendConnector.services.utils = {
                    hasLoadedNamespace: a.hasLoadedNamespace.bind(a),
                  }),
                  a
                );
              },
            },
            {
              key: "toJSON",
              value: function () {
                return {
                  options: this.options,
                  store: this.store,
                  language: this.language,
                  languages: this.languages,
                  resolvedLanguage: this.resolvedLanguage,
                };
              },
            },
          ]),
          o
        );
      })(ge);
      k(at, "createInstance", function () {
        return new at(
          arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
          arguments.length > 1 ? arguments[1] : void 0
        );
      });
      var it = at.createInstance();
      (it.createInstance = at.createInstance),
        it.createInstance,
        it.init,
        it.loadResources,
        it.reloadResources,
        it.use,
        it.changeLanguage,
        it.getFixedT,
        it.t,
        it.exists,
        it.setDefaultNamespace,
        it.hasLoadedNamespace,
        it.loadNamespaces,
        it.loadLanguages;
      var st = it,
        lt = [],
        dt = lt.forEach,
        ct = lt.slice,
        ut = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/,
        pt = {
          name: "cookie",
          lookup: function (e) {
            var t;
            if (e.lookupCookie && "undefined" != typeof document) {
              var n = (function (e) {
                for (
                  var t = "".concat(e, "="),
                    n = document.cookie.split(";"),
                    r = 0;
                  r < n.length;
                  r++
                ) {
                  for (var o = n[r]; " " === o.charAt(0); )
                    o = o.substring(1, o.length);
                  if (0 === o.indexOf(t))
                    return o.substring(t.length, o.length);
                }
                return null;
              })(e.lookupCookie);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupCookie &&
              "undefined" != typeof document &&
              (function (e, t, n, r) {
                var o =
                  arguments.length > 4 && void 0 !== arguments[4]
                    ? arguments[4]
                    : { path: "/", sameSite: "strict" };
                n &&
                  ((o.expires = new Date()),
                  o.expires.setTime(o.expires.getTime() + 60 * n * 1e3)),
                  r && (o.domain = r),
                  (document.cookie = (function (e, t, n) {
                    var r = n || {};
                    r.path = r.path || "/";
                    var o = encodeURIComponent(t),
                      a = "".concat(e, "=").concat(o);
                    if (r.maxAge > 0) {
                      var i = r.maxAge - 0;
                      if (Number.isNaN(i))
                        throw new Error("maxAge should be a Number");
                      a += "; Max-Age=".concat(Math.floor(i));
                    }
                    if (r.domain) {
                      if (!ut.test(r.domain))
                        throw new TypeError("option domain is invalid");
                      a += "; Domain=".concat(r.domain);
                    }
                    if (r.path) {
                      if (!ut.test(r.path))
                        throw new TypeError("option path is invalid");
                      a += "; Path=".concat(r.path);
                    }
                    if (r.expires) {
                      if ("function" != typeof r.expires.toUTCString)
                        throw new TypeError("option expires is invalid");
                      a += "; Expires=".concat(r.expires.toUTCString());
                    }
                    if (
                      (r.httpOnly && (a += "; HttpOnly"),
                      r.secure && (a += "; Secure"),
                      r.sameSite)
                    )
                      switch (
                        "string" == typeof r.sameSite
                          ? r.sameSite.toLowerCase()
                          : r.sameSite
                      ) {
                        case !0:
                          a += "; SameSite=Strict";
                          break;
                        case "lax":
                          a += "; SameSite=Lax";
                          break;
                        case "strict":
                          a += "; SameSite=Strict";
                          break;
                        case "none":
                          a += "; SameSite=None";
                          break;
                        default:
                          throw new TypeError("option sameSite is invalid");
                      }
                    return a;
                  })(e, encodeURIComponent(t), o));
              })(
                t.lookupCookie,
                e,
                t.cookieMinutes,
                t.cookieDomain,
                t.cookieOptions
              );
          },
        },
        mt = {
          name: "querystring",
          lookup: function (e) {
            var t;
            if ("undefined" != typeof window) {
              var n = window.location.search;
              !window.location.search &&
                window.location.hash &&
                window.location.hash.indexOf("?") > -1 &&
                (n = window.location.hash.substring(
                  window.location.hash.indexOf("?")
                ));
              for (
                var r = n.substring(1).split("&"), o = 0;
                o < r.length;
                o++
              ) {
                var a = r[o].indexOf("=");
                a > 0 &&
                  r[o].substring(0, a) === e.lookupQuerystring &&
                  (t = r[o].substring(a + 1));
              }
            }
            return t;
          },
        },
        ht = null,
        ft = function () {
          if (null !== ht) return ht;
          try {
            ht = "undefined" !== window && null !== window.localStorage;
            var e = "i18next.translate.boo";
            window.localStorage.setItem(e, "foo"),
              window.localStorage.removeItem(e);
          } catch (e) {
            ht = !1;
          }
          return ht;
        },
        gt = {
          name: "localStorage",
          lookup: function (e) {
            var t;
            if (e.lookupLocalStorage && ft()) {
              var n = window.localStorage.getItem(e.lookupLocalStorage);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupLocalStorage &&
              ft() &&
              window.localStorage.setItem(t.lookupLocalStorage, e);
          },
        },
        vt = null,
        bt = function () {
          if (null !== vt) return vt;
          try {
            vt = "undefined" !== window && null !== window.sessionStorage;
            var e = "i18next.translate.boo";
            window.sessionStorage.setItem(e, "foo"),
              window.sessionStorage.removeItem(e);
          } catch (e) {
            vt = !1;
          }
          return vt;
        },
        _t = {
          name: "sessionStorage",
          lookup: function (e) {
            var t;
            if (e.lookupSessionStorage && bt()) {
              var n = window.sessionStorage.getItem(e.lookupSessionStorage);
              n && (t = n);
            }
            return t;
          },
          cacheUserLanguage: function (e, t) {
            t.lookupSessionStorage &&
              bt() &&
              window.sessionStorage.setItem(t.lookupSessionStorage, e);
          },
        },
        yt = {
          name: "navigator",
          lookup: function (e) {
            var t = [];
            if ("undefined" != typeof navigator) {
              if (navigator.languages)
                for (var n = 0; n < navigator.languages.length; n++)
                  t.push(navigator.languages[n]);
              navigator.userLanguage && t.push(navigator.userLanguage),
                navigator.language && t.push(navigator.language);
            }
            return t.length > 0 ? t : void 0;
          },
        },
        Ct = {
          name: "htmlTag",
          lookup: function (e) {
            var t,
              n =
                e.htmlTag ||
                ("undefined" != typeof document
                  ? document.documentElement
                  : null);
            return (
              n &&
                "function" == typeof n.getAttribute &&
                (t = n.getAttribute("lang")),
              t
            );
          },
        },
        xt = {
          name: "path",
          lookup: function (e) {
            var t;
            if ("undefined" != typeof window) {
              var n = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
              if (n instanceof Array)
                if ("number" == typeof e.lookupFromPathIndex) {
                  if ("string" != typeof n[e.lookupFromPathIndex]) return;
                  t = n[e.lookupFromPathIndex].replace("/", "");
                } else t = n[0].replace("/", "");
            }
            return t;
          },
        },
        St = {
          name: "subdomain",
          lookup: function (e) {
            var t =
                "number" == typeof e.lookupFromSubdomainIndex
                  ? e.lookupFromSubdomainIndex + 1
                  : 1,
              n =
                "undefined" != typeof window &&
                window.location &&
                window.location.hostname &&
                window.location.hostname.match(
                  /^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i
                );
            if (n) return n[t];
          },
        },
        kt = (function () {
          function e(t) {
            var n =
              arguments.length > 1 && void 0 !== arguments[1]
                ? arguments[1]
                : {};
            ne(this, e),
              (this.type = "languageDetector"),
              (this.detectors = {}),
              this.init(t, n);
          }
          return (
            oe(e, [
              {
                key: "init",
                value: function (e) {
                  var t =
                      arguments.length > 1 && void 0 !== arguments[1]
                        ? arguments[1]
                        : {},
                    n =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : {};
                  (this.services = e),
                    (this.options = (function (e) {
                      return (
                        dt.call(ct.call(arguments, 1), function (t) {
                          if (t)
                            for (var n in t) void 0 === e[n] && (e[n] = t[n]);
                        }),
                        e
                      );
                    })(t, this.options || {}, {
                      order: [
                        "querystring",
                        "cookie",
                        "localStorage",
                        "sessionStorage",
                        "navigator",
                        "htmlTag",
                      ],
                      lookupQuerystring: "lng",
                      lookupCookie: "i18next",
                      lookupLocalStorage: "i18nextLng",
                      lookupSessionStorage: "i18nextLng",
                      caches: ["localStorage"],
                      excludeCacheFor: ["cimode"],
                    })),
                    this.options.lookupFromUrlIndex &&
                      (this.options.lookupFromPathIndex =
                        this.options.lookupFromUrlIndex),
                    (this.i18nOptions = n),
                    this.addDetector(pt),
                    this.addDetector(mt),
                    this.addDetector(gt),
                    this.addDetector(_t),
                    this.addDetector(yt),
                    this.addDetector(Ct),
                    this.addDetector(xt),
                    this.addDetector(St);
                },
              },
              {
                key: "addDetector",
                value: function (e) {
                  this.detectors[e.name] = e;
                },
              },
              {
                key: "detect",
                value: function (e) {
                  var t = this;
                  e || (e = this.options.order);
                  var n = [];
                  return (
                    e.forEach(function (e) {
                      if (t.detectors[e]) {
                        var r = t.detectors[e].lookup(t.options);
                        r && "string" == typeof r && (r = [r]),
                          r && (n = n.concat(r));
                      }
                    }),
                    this.services.languageUtils.getBestMatchFromCodes
                      ? n
                      : n.length > 0
                      ? n[0]
                      : null
                  );
                },
              },
              {
                key: "cacheUserLanguage",
                value: function (e, t) {
                  var n = this;
                  t || (t = this.options.caches),
                    t &&
                      ((this.options.excludeCacheFor &&
                        this.options.excludeCacheFor.indexOf(e) > -1) ||
                        t.forEach(function (t) {
                          n.detectors[t] &&
                            n.detectors[t].cacheUserLanguage(e, n.options);
                        }));
                },
              },
            ]),
            e
          );
        })();
      kt.type = "languageDetector";
      var Pt = JSON.parse(
          '{"dashboard_title":"DASHBOARD","dashboard_welcomeMsg":"Welcome to","dashboard_morningMsg":"Good Morning","dashboard_afternoonMsg":"Good Afternoon","dashboard_eveningMsg":"Good Evening","dashboard_subTitle1":"Current Month","dashboard_block1Heading":"CLIENT INVOICE","dashboard_block1Header1":"EARNINGS","dashboard_block1Header2":"INVOICE SENT","dashboard_block1Header3":"INVOICE PAID","dashboard_block2Heading":"WHOLESALE ORDERS","dashboard_block2Header1":"EARNINGS","dashboard_block2Header2":"INVOICE SENT","dashboard_block2Header3":"INVOICE PAID","dashboard_block3Heading":"AFFILIATE ORDERS","dashboard_block3Header1":"EARNINGS","dashboard_block3Header2":"ORDERS PAID","dashboard_block4Heading":"DISCOUNT COUPON","dashboard_block4Header1":"EARNINGS","dashboard_block4Header2":"ORDERS PAID","dashboard_block5Heading":"CUSTOMER COMMISSION","dashboard_block5Header1":"COMMISSION","dashboard_block5Header2":"ORDERS","dashboard_block6Heading":"TEAM LEAD COMMISSION","dashboard_block6Header1":"COMMISSION","dashboard_block7Heading":"POS COMMISSION","dashboard_block7Header1":"COMMISSION","dashboard_block7Header2":"ORDERS","dashboard_tbl1column1":"Month","dashboard_tbl1column2":"Client Invoice Orders","dashboard_tbl1column3":"Client Invoice Commission","dashboard_tbl1column4":"Wholesale Orders","dashboard_tbl1column5":"Total Wholesale Purchase","dashboard_tbl1column6":"Affiliate Orders","dashboard_tbl1column7":"Affilate Commission","dashboard_tbl1column8":"CouponCode Orders","dashboard_tbl1column9":"CouponCode Commission","dashboard_tbl1column10":"Customer Orders","dashboard_tbl1column11":"Customer Commission","dashboard_tbl1column12":"POS Orders","dashboard_tbl1column13":"POS Commission","dashboar_cardHeading1":"Total Order","dashboar_cardHeading2":"Commission","dashboar_cardHeading3":"Sales","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Sales Performance of Last Six Months","dashboard_graphHeading2":"Analyze Feature Wise Order and Commission For Current Month","Graph_Sales_noorderstitle":"No Order to Show","Graph_SalesRepCommission_nocommissiontitle":"No Commission Data to Show","Graph_SalesRepOrders_title":"ORDERS","Graph_SalesRep_XAxisTitle_ForMonth":"6 Month","Graph_SalesRepOrders_YAxisTitle":"Orders","Graph_SalesRepSales_title":"SALES","Graph_SalesRepCommission_title":"COMMISSION","Graph_SalesRepCommissions_YAxisTitle":"Commission","Graph_FeatureWiseOrder_title":"Orders Vs Feature","Graph_featureWiseCommission_title":"Commission Vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Feature","Graph_FeatureWiseOrder_YAxisTitle":"Orders","Graph_FeatureWiseCommission_title":"COMMISSION","Graph_FeatureWiseCommission_YAxisTitle":"Commission","customerInvoice_title":"Create Order","customerInvoice_button":"Back","customerInvoice_noclientorderMsg":"No Client Invoice Orders","customerInvoice_button1":"View Previous Orders","customerInvoice_contentHeading1":"Discount and Commission On","customerInvoice_table1column1":"Product Type","customerInvoice_table1column2":"Commission","customerInvoice_table1column3":"Discount Name","customerInvoice_table1column4":"Discount","customerInvoice_contentHeading2":"Add customer details and select products to send invoice.","customerInvoice_contentHeading2Title1":"Enter/Search Customer","customerInvoice_title1Placeholder":"Enter/Search Customer","customerInvoice_contentHeading2Title2":"Enter Customer Email Id","customerInvoice_title2Placeholder":"Email Address","customerInvoice_contentHeading2Title3":"Enter Order Notes","customerInvoice_contentHeading2Title4":"Customer Address","customerInvoice_contentHeading2Title5":"Customer Mobile Number","customerInvoice_contentHeading2Title6":"Customer Note","customerInvoice_contentHeading2Title7":"Customer Company Name","customerInvoice_title7Placeholder":"Company Name","customerInvoice_Placeholder_contentHeading2Title6":"Note","customerInvoice_Placeholder_contentHeading2Title5":"Mobile Number","customerInvoice_Placeholder_contentHeading2Title4":"Shipping Address","customerInvoice_title3Placeholder":"Order Notes","customerInvoice_table2Column1":"Image","customerInvoice_table2Column2":"Add Quantity","customerInvoice_table2Column3":"Title","customerInvoice_table2Column4":"Variant Title","customerInvoice_ProductTableColumnPrice":"Price","customerInvoice_ProductTableColumnWholeSalePrice":"Wholesale Price","customerInvoice_button2":"Create Invoice","customerInvoice_ProductTableColumnProduct":"Product","customerInvoice_table3Column2":"Product Name","customerInvoice_table3Column3":"Size","customerInvoice_ProductTableColumnQuantity":"Quantity","customerInvoice_table3Column5":"Item Price","customerInvoice_table3Column6":"Total Price","customerInvoice_table3Column7":"Discounted Price for Customer","customerInvoice_table3Column8":"SalesRep Commission","customerInvoice_table3Column9":"DiscountType","customerInvoice_repproInvite":"Select checkbox to send pro invite","customerInvoice_customerOrder_error1":"all customer fields are mandatory. Please enter the customer\'s  email and first name","customerInvoice_productAddedMsg":"Product Added","customerInvoice_AlertErrorMsg":"Error..Please contact support !","wholesaleOrder_title":"Wholesale Order","wholesaleOrder_contentHeading1":"You can purchase products at special wholesale prices","wholesaleOrder_contentHeading2":"Discount On","wholesaleOrder_column1":"SalesRep Name","wholesaleOrder_column2":"Discount","wholesaleOrder_searchtxtPlaceholder":"Search Product","wholesaleOrder_table1Column1":"Image","wholesaleOrder_table1Column2":"Add Quantity","wholesaleOrder_table1Column3":"Title","wholesaleOrder_table1Column4":"Variant Title","wholesaleOrder_table1Column5":"Price","wholesaleOrder_button":"Check Out","wholesaleOrder_Order_btn":"Show/Hide Volume Pricing","wholesaleOrder_contentHeading3":"Total Price","wholesaleOrder_contentHeading4":"Your Discounted Price","wholesaleOrder_table2Column1":"Product","wholesaleOrder_table2Column2":"Product Name","wholesaleOrder_table2Column3":"Size","wholesaleOrder_table2Column4":"Quantity","wholesaleOrder_table2Column5":"Item Price","wholesaleOrder_table2Column6":"Total Price","wholesaleOrder_table2Column7":"Your Discounted Price","affiliateLink_title":"Affiliate Link","affiliate_product_link":"Product Link","affiliateLink_input_error_msg":"Link text field is required and should not contain spaces or special characters.","affiliateLink_contentHeading1":"Share your affiliate link on social media and email. You will get an affiliate commission for every order from your affiliate link","affiliateLink_contentHeading2":"Your Affiliate Link","affiliateLink_contentHeading3":"Commission On","affiliateLink_content_Message1":"Search products and share the link of individual products with you customers.","affiliateLink_noaffiliateorderMsg":"No Affiliate Orders","affiliateLink_column1":"SalesRep Name","affiliateLink_column2":"Commission","affiliateLink_searchtxtPlaceholder":"Search Product","affiliateLink_searchColumn1":"Product","affiliateLink_searchColumn2":"Product Title","affiliateLink_searchColumn3":"Price","affiliateLink_searchColumn4":"Commission","affiliateLink_searchColumn5":"Affiliate Link","affiliateLink_searchColumn7":"Copy Link","affiliateLink_searchColumn8":"Copied","affiliateLink_backbtn":"Back","affiliateLink_card_Title":"Contact Card & Affiliate Link","cartSharing_title":"Cart Sharing","cartSharing_CreateCartInformation_Text":"To create a personalized sharable cart, add products to cart from storefront.Those products will be displayed on this page","cartSharing_content2Placeholder":"Cart name","cartSharing_table2Column2":"Product Name","cartSharing_table2Column3":"Size","cartSharing_table2Column6":"Total Price","cartSharing_SharedCartLinkTableColumnCartName":"Cart Name","cartSharing_SharedCartLinkTableColumnLink":"Link","cartSharing_SharedCartLinkTableColumnCartLink":"Shareable Cart Link","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copy Cart Link","cartSharing_SharedCartLink_Other":"Other","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Delete Cart Link","cartSharing_EnterCartName_Label":"Enter Cart Name","cartSharing_ProductTableColumnProduct":"Product","cartSharing_ProductTableColumnQuantity":"Quantity","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Item Price","cartSharing_Copied_Msg":"Copied!!","cartSharing_CartCreating_Msg":"Creating...","cartSharing_SharedCartLinkTableEmpty_Msg":"No Link to show","cartSharing_CartCreatedSuccessfully_Msg":"Your new Cart has been created successfully","cartSharing_CartCreateError_Msg":"Error..please Try Again","cartSharing_AlertError_Msg":"Error..Please contact support !","cartSharing_CopyCartLink_Msg":"Copy Cart Link","cartSharing_DeleteCartLink_Msg":"Delete Cart Link","cartSharing_DeleteConfirmation_Msg":"Are you sure ?","cartSharing_ProductTableEmpty_Msg":"Product Not Available","cartSharing_CreateCart_Btn":"Create Cart","cartSharing_ProductTableQuantityUpdate_Btn":"Please Select Product","cartSharing_Select_product_Title":"Select Product","discountCoupon_titleOne":"Discount Coupon","discountCoupon_contentHeading1":"Share Discount Coupon Code with your customers and whenever your coupon is used you get a commission.","discountCoupon_contentHeading2":"Your Coupon Code is","discountCoupon_contentHeading3":"Discount Amount","discountCoupon_contentHeading4":"Commision ","discountCoupon_contentHeading4PlaceHolder1":"Hey use my discount coupon code","discountCoupon_contentHeading4PlaceHolder2":"and get discounted products","discountCoupon_button1":"Copy text","cartSharing_copiedButtonText":"Copied","discountCoupon_titleTwo":"Create one time use discount coupons for clients","discountCoupon_button2":"View Coupons","discountCoupon_contentHeading5":"Maximum allowed Discount","discountCoupon_contentHeading6":"Commision","discountCoupon_contentHeading7":"Enter Coupon Code","discountCoupon_contentHeading7PlaceHolder":"Please Enter Coupon Code","discountCoupon_contentHeading8":"Enter Discount","discountCoupon_contentHeading8PlaceHolder":"Discount should not be greater than Maximum discount.","discountCoupon_button3":"Create Coupon","discountCoupon_coupon_error1":"Please enter the coupon code and discount","yourBio_title":"Your contact card","yourBio_content1":"Upload Profile","yourBio_button1":"Choose File","yourBio_button1PlaceHolder":"No File chosen","yourBio_error_image_size":"Image size is too large, please upload a image of size less than 5MB. Please Try again.","yourBio_button2":"Upload","yourBio_content2":"Enter custom word to create your unique Affiliate Link","yourBio_content2PlaceHolder":"create your unique Affiliate Link","yourBio_content4":"When your link will be used your contact card will appear on website","yourBio_content3":"Enter Your contact card","yourBio_content3PlaceHolder":"Enter in 100 words","yourBio_button3":"Save","yourBio_button4":"Saved","yourBio_error_link":"This unique link may be taken. Try with different unique link.","yourBio_Linksuccessmsg":"Unique link saved sucessfully.","team_title1":"Add SalesRep","team_content1":"Enter Email","team_content1PlaceHolder":"Email Address","team_emailerrorMsg":"Please enter email","team_content2":"Enter First Name","team_content2PlaceHolder":"First Name","team_fnameerrorMsg":"Please enter first name","team_content3":"Enter Last Name","team_content3PlaceHolder":"Last Name","team_button1":"Add","team_successmsg":"Rep is added successfully. Rep will receive login credentials on the submitted email id.","team_errorsmsg":"Error while adding. This user email may already have an account on the store.","team_title2":"Team Details","team_content4":"Sign Up Page","team_NoTeamDetailsMsg":"No Team Details","team_content5":"Select SalesRep","team_tableTitle":"LAST TWO MONTHS ORDER DETAILS","team_column1":"Order Number","team_column2":"Order Date","team_column3":"Customer Name","team_column4":"Sales Rep","team_column5":"SubTotal","team_column6":"Sales Rep Commission","team_column7":"Team Manager Commission","team_column8":"Sales Method","addCustomer_title":"Add Customer","addCustomer_content1":"Customer First name ","addCustomer_txt1Placeholder":"First Name","addCustomer_content2":"Customer Last name","addCustomer_content2Placeholder":"Last Name","addCustomer_content3":"Customer Email Id","addCustomer_content3Placeholder":"Email Address","addCustomer_content4":"Note","addCustomer_content4Placeholder":"Note","addCustomer_customerAddress":"Personal Address","addCustomer_customerCity":"City","addCustomer_customerCityPlaceholder":"City","addCustomer_customerCountry":"Country","addCustomer_customerState":"State","addCustomer_customerZipCode":"Zip Code","addCustomer_companyName":"Company Name","addCustomer_companyAddress":"Company Address","addCustomer_companyCity":"City","addCustomer_companyCountry":"Country","addCustomer_companyState":"State","addCustomer_companyZipCode":"Zip Code","addCustomer_button":"Save","addCustomer_leadsuccessmsg":"Customer is added successfully.","addCustomer_leadErrrorMsg":"Error while saving the details.","addCustomer_leadEmptyErrrorMsg":"Please fill the required field.","addCustomer_leadsuccessmsg2":"Customer created & tagged to a sales rep successfully.","addCustomer_leadErrrorMsg2":"This customer is already tagged to a rep.","myCustomers_title":"Your Customers","myCustomers_table1Column1":"Name","myCustomers_table1Column2":"Company Name","myCustomers_table1Column3":"Email Id","myCustomers_table1Column4":"Order","myCustomers_table1Column5":"Total Spent","myCustomers_table2Title":"Customer Details","myCustomers_table3Title":"DRAFT ORDER DETAILS","myCustomers_table3Column1":"Product Name","myCustomers_table3Column2":"Size","myCustomers_table3Column3":"Quantity","myCustomers_table3Column4":"Price","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotal","myCustomers_table2Row1":"Name","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Address","myCustomers_table2Row4":"Company Name","myCustomers_table2Row5":"Customers Notes ","myCustomers_table2Row6":"Total Spent(Subtotal+Tax)","myCustomers_table2Row7":"Number of Orders","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Show all customer","myCustomers_radioButton1":"Search By Name","myCustomers_radioButton2":"Search By Company","myCustomers_radioButtonError1":"Please select search type and enter value to search","myCustomers_radioButtonError2":"Please enter value to search","myCustomers_radioButtonError3":"Please select search type","myCustomers_searchButton":"Search","myCustomers_Placeholder1":"Type Customer Name or Company Name to Search","myCustomers_NoOrdersError":"No Orders","myCustomer_no_salesRep_details":"No Sales Rep Details Available.","myCustomer_select_customer_country":"Please select customer country","myCustomer_company_country":"Company Country","myCustomer_company_state":"Company State","myCustomer_select_company_country":"Please select company country","yourSales_SalesOrderDetailsTitle":"Sales-Order Details","yourSales_title":"Last 2 months order details","yourSales_table1Column1":"Order No.","yourSales_table1Column2":"Order Date","yourSales_table1Column3":"Customer Name","yourSales_table1Column4":"SubTotal","yourSales_table1Column5":"Commission","yourSales_table1Column6":"Commission Type","yourSales_table1Column7":"Print Invoice","printOrderInvoice_btn":"Print","yourSales_tableTitle":"Product Details","yourSalesDraft_tableTitle":"Draft Order Details","yourSales_column1":"Product","yourSales_column2":"Title","yourSales_column3":"Quantity","yourSales_column4":"Item Price","yourSales_column5":"Tracking Number","yourSales_column6":"Ship Date","yourSales_column7":"Total Price","yourSales_content1":"SubTotal","yourSales_content2":"Tax","yourSales_content3":"Shipping Cost","yourSales_content4":"Total","yourSales_content5":"Note","yourSales_tabHeading1":"Paid Orders","yourSales_tabHeading4":"Pending Orders","yourSales_tabHeading2":"Draft orders","myOrders_title":"My Orders Details","myOrdersDetails_Message":"Orders placed for yourself","myOrders_table1Column1":"Order Number","myOrders_table1Column2":"Order Date","myOrders_table1Column3":"Customer Name","myOrders_table1Column4":"Payment","myOrders_table1Column5":"Fulfillment","myOrders_table1Column6":"Total","myOrders_tableTitle":"PRODUCT DETAILS","myOrders_table2Column1":"Product","myOrders_table2Column2":"Title","myOrders_table2Column3":"Quantity","myOrders_table2Column4":"Item Price","myOrders_table2Column5":"Tracking Number","myOrders_table2Column6":"Ship Date","myOrders_table2Column7":"Total Price","myOrders_content1":"SubTotal","myOrders_content2":"Tax","myOrders_content3":"Shipping Cost","myOrders_content4":"Total","myOrders_content5":"Note","myOrders_content6":"Draft Id","tab_Dashboard":"Dashboard","dashbord_Tab":"Home","tab_CustomerInvoice":"Create Order","tab3_WholesaleOrder":"Wholesale Order","tab_AffiliateLink":"Affiliate Link","tab_CartSharing":"Cart Sharing","tab_DiscountCoupon":"Discount Coupon","tab7_YourBio":"Your Contact Card","tab8_Team":"Team","tab9_AddCustomer":"Add Customer","tab_MyCustomers":"My Customers","tab_YourSalesOrderDetails":"Sales-Order Details","tab12_MyOrders":"My Orders Details","tab13_Logout":"Logout","signUp_title":"Sales Representative Sign Up","signUp_subTitle":"Please fill in this form to sign up as a sales rep and get access to all Sales Team features.","signUp_content1":"Email","signUp_content2":"First Name","signUp_content3":"Last Name","signUp_content4":"Phone Number","signUp_content5":"Facebook Handle","signUp_content6":"Twitter Handle","signUp_content7":"Instagram Handle","signUp_content8":"Upload Profile Picture","signUp_socialmedialable1":"Social Media Links","signUp_socialmedialable2":"optional","signUp_uploadBtn":"Choose File","signUp_uploadBtnPlaceHolder":"No file chosen","signUp_button3":"Saving Details...","signUp_welcomemsg1":"Hello","signUp_welcomemsg2":"sign up sales rep and get a commission on sales made by reps under you","signUp_emailerror":"Please enter Email","signUp_Fnameerror":"Please enter First Name","signUp_lnameerror":"Please enter Last Name","signUp_phnumbererror":"Please enter Phone Number","signUp_successmsg":"Your sign-up request has been submitted successfully. You will receive the account login details via email once the admin approves your request. For more information, please contact the store admin.","signUp_errorsmsg":"Error while saving the details. This user email may already have an account on the store.","signUp_RepExistErrorMsg":"This email is already registered as a rep.","addingRep_selectRepsLabel1":"Who helped you?","addingRep_NoSalesRep":"No Sales Rep","addingRep_successMsg":"Added repId to cart note","addingRep_selectRepsLabel2":"Please select an item in the list.","wholesaleOrder_WholesaleDiscountTableColumn1":"Product Title","wholesaleOrder_WholesaleDiscountTableColumn2":"Discount","customerInvoice_ViewClientOrdersColumn1":"Customer Name","customerInvoice_ViewClientOrdersColumn2":"Product Title","customerInvoice_ViewClientOrdersColumn3":"Subtotal Price","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Invoice","salesRep_order_errorMsg":"Error during creating your order.Please contact support","salesRep_order_successMsg":"Order Invoice created successfully!  Invoice has been emailed to Customer!","salesRep_order_errorMsg2":"Error during creating your order.Please contact support","customedraft_btn1":"Create New Invoice","customedraft_btn2":"No Products Selected. Please select products and try again.","customedraft_btn3":"Creating Order...","customedraft_btn4":"Create New Invoice","salesRep_order_NoProductSelected":"No Products Selected. Please select products and try again.","productnotselectforcartsharingtxt1":"No Products Selected. Please select products and try again.","discountCoupons_tblColumn1":"Coupon Code","discountCoupons_tblColumn2":"Coupon Discount","discountCoupons_tblColumn3":"Delete Coupon Code","discountedPriceLabel":"Your Discounted Price:","couponCodeNotSet":"Coupon Code Not Set","dashboard_subTitle2":"Current Month cycle: 5th - 4th","affiliatelink_commissiononlbl":"Product","displaycommission_lbl1":"Product Type","displaycommission_lbl2":"Sales Rep","displaycommission_lbl3":"Quantity Based Discount","discountcommissiononlbl1":"Client Discount Tiers","clientInvoiceCommissionTablecolumn1":"Product Type","clientInvoiceCommissionTablecolumn2":"Commission","clientInvoiceCommissionTablecolumn3":"Product Title","clientInvoiceCommissionTablecolumn4":"SalesRep Name","clientInvoiceQuantityBaseDiscountTablecolumn1":"Product Name","clientInvoiceQuantityBaseDiscountTablecolumn2":"Discount","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantity","affiliateCartProdtableColumn1":"Product","affiliateCartProdtableColumn2":"Product Title","affiliateCartProdtableColumn3":"Price","affiliateCartProdtableColumn4":"Commission","affiliateCartProdtableColumn5":"Affiliate Link","affiliateCartProdtableColumn6":"Share Link","productnotselectforcartsharinglbl1":"Please Enter Cart Name","productnotselectforcartsharinglbl2":"No Products Selected. Please select products and try again.","productnotselectforcartsharinglbl3":"Wait While Processing...","showSharedCartProductcolumn1":"Cart Link","showSharedCartProductcolumn3":"Remove Cart","onSuccessInvoiceSuccessMsg":"Invoice Sent Successfully","onSuccessInvoiceFailedMsg":"Invoice Sending Failed","sendInvoice_successMsg":"Invoice Sent Successfully","deleteInvoice_successMsg":"Invoice deleted Successfully","deleteInvoice_FailedMsg":"Delete Invoice Failed","deleteInvoice_btnlbl":"Deleting Invoice","deleteSharedCartLink_successMsg":"Link Deleted Successfully","deleteSharedCartLink_FailedMsg":"Error in deleting link. Please try again..","deleteSharedCartLink_btnlbl":"Deleting Link","viewInvoiceOrders_btntxt1":"Getting...","viewInvoiceOrders_btntxt2":"View Previous Orders","createCoupon_btnlbl1":"Creating Coupon..","createCoupon_btnlbl2":"Coupon Created","deleteCoupon_successMsg":"Coupon Deleted","deleteCoupon_FailedMsg":"Coupon deleting Failed","deleteCoupon_btnlbl":"Deleting...","viewProductModelColumn1":"Product","viewProductModelColumn2":"Title","viewProductModelColumn3":"Quantity","viewProductModelColumn4":"Refunded Amount","viewProductModelColumn5":"Item Price","viewProductModelColumn6":"Disc. Price","viewProductModelColumn7":"Tracking Number","viewProductModelColumn8":"Ship Date","viewProductModelColumn9":"Total Price","showSharedCartProducts_column2":"Image","showSharedCartProducts_column3":"Add Quantity","showSharedCartProducts_column4":"Title","showSharedCartProducts_column5":"Variant Title","showSharedCartProducts_column6":"Price","viewClientOrders_btn1":"View","viewClientOrders_btn2":"Send","viewClientOrders_btn3":"Delete","showCouponTable_txt1":"Getting...","showCoupon_btn2":"View Coupons","showCoupon_btn1":"Copied","affliateOrder_column1":"Customer Name","affliateOrder_column2":"Customer Email","affliateOrder_column3":"Product Title","affliateOrder_column4":"Order Date","affliateOrder_column5":"Subtotal","affliateOrder_column6":"Commission","affliateOrder_btn1":"Getting...","affliateOrder_btn2":"View Affiliate Orders","affliateOrder_btn3":"View Affiliate Orders","yourBio_btn1":"Save","yourBio_btn2":"Save","yourBio_Uploadbtn1":"Uploading...","yourBio_Uploadbtn2":"Uploaded","yourBio_UploadbtnError":"Sorry, Try Again","yourBio_Savebtn":"Saving..","team_txt1":"Saving..","team_txt2":"Save","viewRepClientOrdersDetails_column1":"Order Number","viewRepClientOrdersDetails_column2":"Order Date","viewRepClientOrdersDetails_column3":"Subtotal","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Product Details","addSalesRep_txt1":"Add SalesRep","addSalesRep_txt2":"Adding SalesRep...","discountCoupons_header":"One Time Discount Coupon","discountCoupons_nodiscountcoupon":"You have not created any Discount Coupon","discountCoupons_deleteBtn":"Delete","discountCoupons_BackBtn":"Back","customerInvoice_selectcustomererror":"Please Select Customer and then add product","createOrderFromCartPage_selectCustomersLabel":"SELECT CUSTOMER","createOrderFromCartPage_selectCustomerAddressLabel":"SHIPPING ADDRESS","createOrderFromCartPage_selectCustomersLabelForDropDown":" Select Customer","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Select Address","createOrderFromCartPage_successMsg":"Order Invoice created successfully! Invoice has been emailed to Customer!","createOrderFromCartPage_AddNewAddressTitle":"ADD NEW ADDRESS","createOrderFromCartPage_draftOrderButton":"CREATE DRAFT ORDER","createOrderFromCartPage_OrderButton":"CREATE ORDER","createOrderFromCartPage_draftOrderButtonText2":"CREATING ORDER...","createOrderFromCartPage_selectShippingCostTitle":"SHIPPING COST","createOrderFromCartPage_Address_errorMsg4":"There was a problem calculating your shipping rates.","createOrderFromCartPage_Address_errorMsg5":"Something went wrong please try again.","yourSales_tabHeading3":"Refund Orders","refundOrders_column1":"Refund Id","refundOrders_column2":"Order Date","refundOrders_column3":"Order No.","refundOrders_column4":"Order Name","refundOrders_column5":"Commission","refundOrders_column6":"Team Manager Commission","refundOrders_column7":"Team Manager Id","refundOrders_column8":"Refund SubTotal","refundOrders_column9":"Order Status","refundOrders_column10":"Sales Method","refundOrderNumber_title":"Refund Order Details","refundOrderNumber_column1":"Name","refundOrderNumber_column2":"Date","refundOrderNumber_column3":"Quantity","refundOrderNumber_column4":"Discount Price","refundOrderNumber_column5":"SubTotal","tableDataError":"No refund order","dashboard_subTitle3":"Commission Details","dashboard_cardHeading5_1":"Commission on","dashboard_cardHeading5_2":"You will get a ","dashboard_cardHeading5_3":"commission on all orders.","Profit_Margin":"Profit Margin","Product_Type":"Product Type","Sales_Rep":"Sales Rep","show_commission_list":"Show Commission List","commission_list":"Commission List","no_customers_to_show":"No Customers to show","no_sales_to_show":"No Sales to show","no_draft_to_show":"No Draft to show","no_refund_to_show":"No Refund to show","no_orders_to_show":"No Orders to show","customerInvoice_ViewClientOrdersColumn6":"Order Number","customerInvoice_ViewClientOrdersColumn7":"Order Date","Error_commissions_NotUpdated":"Commissions are not updated","sales_chart_msg1":"We need data...","sales_chart_msg2":"Looks like we do not have any data to show yet.","page_refresh_msg":"click to refresh","variant_title":"Variant Title","line_items_properties":"Properties","customer_country":"Customer Country","customer_state":"Customer State","company_country":"Company Country","company_state":"Company State","client_orders":"Client Orders","no_product_details":"No products details to show","submit_btn_text":"Submit","submitting_btn_text":"Submitting","submitted_btn_text":"Submitted","email_id_validation_errmsg":"Please enter valid Email Id","customerInvoice_add_more_details":"Add More Details","customerInvoice_add_shipping_address":"Add New Shipping Address","customerInvoice_HideDetails":"Hide Details","customerInvoice_HideAddress":"Hide Shipping Address","customerInvoice_enterFirstName":"Enter First Name","customerInvoice_enterFirstNamePlaceholder":"First Name","customerInvoice_enterLastName":"Enter Last Name","customerInvoice_enterLastNamePlaceholder":"Last Name","customerInvoice_enterAddress1":"Enter Address Line 1","customerInvoice_enterAddress1Placeholder":"Address Line 1","customerInvoice_enterAddress2":"Enter Address Line 2","customerInvoice_enterAddress2Placeholder":"Address Line 2","customerInvoice_enterCity":"Enter City","customerInvoice_enterCityPlaceholder":"City","customerInvoice_selectCountry":"Select Country","customerInvoice_selectState":"Select State","customerInvoice_enterZipNumber":"Enter Zip Code","customerInvoice_enterZipNumberPlaceholder":"Zip Code","customerInvoice_ProductTableColumnSku":"SKU","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Product Not Available","customerInvoice_SendInvoiceBtn":"Send Invoice","customerInvoice_CreateBtn":"Create","customerInvoice_CreatingBtn":"Creating","customerInvoice_ProductTableColumnSubTotal":"Sub Total","customerInvoice_SelectShippingAddress":"Select Shipping Address","customerInvoice_ProductsSearchBy_Placeholder":"Search Products by Name, SKU, Price","customerInvoice_AddMoreProducts_Btn":"Add More Products","customerInvoice_RequiredErrorMsg":"This field is required.","customerInvoice_EmailSuggestionErrorMsg":"Please add valid email id","customerInvoice_MobileSuggestionErrorMsg":"Please add valid phone no","customerInvoice_ErrorMsgAddShippingAddress":"Please fill Shipping Address","customerInvoice_Creating_Msg":"Creating...","customerInvoice_Sending_Msg":"Sending...","customerInvoice_OrderCreatedSuccessfullyMsg":"Order Created Successfully","customerInvoice_InvoiceSentSuccessfullyMsg":"Invoice Sent Successfully to Customer","customerInvoice_ErrorMsgTryAgain":"Error..please Try Again","customerInvoice_Selected_Btn":"Selected","customerInvoice_ProductTableQuantityUpdate_Btn":"Please Select Product","customerInvoice_OrderSubTotal":"Order SubTotal","delete_confirmation_text":"Are you sure ?","draftOrder_OrderNumber":"Order Number","draftOrder_CustName":"Customer Name","draftOrder_OrderDate":"Order Date","draftOrder_SubTotal":"Sub Total","draftOrder_Status":"Status","draftOrder_Invoice":"Invoice","draftOrder_DraftId":" Draft Id","draftOrder_ShippingCost":"Shipping Cost","draftOrder_Tax":"Tax","draftOrder_TotalPrice":"Total Price","draftOrder_Note":"Note","draftOrder_Product":"Product","draftOrder_ProductName":"Product Name","draftOrder_Size":"Size","draftOrder_Quantity":"Quantity","draftOrder_Price":"Price","noDraftOrderProducts":"No Draft Order Product Details Available.","noRefundOrderProduct":"No Refund Order Product Details Available.","loading":"Loading...","dashboard_commissionOn_profitMargin":"Commission on Profit Margin","dashboard_clientInvoice":"Client Invoice","dashboard_affiliateLink":"Affiliate Order","dashboard_returnCustomer":"Return Customer","dashboard_discountCoupon":"Discount Coupon","dashboard_SharedCart":"Shared Cart","dashboard_AdminTaggedOrders":"Admin Tagged Order","dashboard_no_data":"No Data Available","dashboard_sales_of_last_six_months":"Sales of Last 6 Months","dashboard_sales_of_current_month":"Sales of Current Month","addCustomer_ErrorMsgOnSubmitBtn":"Please enter a valid phone number","login_welcome_Msg":"Welcome to Sales Team","login_title":"Login","login_email":"Email Id","login_password":"Password","emailValidation_ErrorMsg":"Please enter valid Email Id","login_newUser":"New User?","login_SignUp":"Sign Up","login_forgotPassword_link":"Forgot Password?","login_LogInBtn":"Log In","login_sliderContent_1":"Reps Placing order behalf of clients","login_sliderContent_2":"Rep\'s driving traffic to store","login_sliderContent_3":"Rep’s marketing products using social media platforms","login_sliderContent_4":"Rep can buy in bulk and make profit","login_sliderContent_5":"Reps Placing order behalf of clients","login_sliderContent_6":"Reps can visit customers in person and create orders","required_ErrorMsg":"Please fill required field","signup_title":"Sign Up","signup_BackTo_login":"Back to Login","signup_firstName":"First Name","signup_lastName":"Last Name","signup_BackBtn":"Back","signup_NextBtn":"Next","signup_phone_number":"Phone Number","signup_phone_number_Error":"Please enter atleast 10 digits","signup_uploadPicture":"Upload Profile Picture","signup_fileSizeError":"File size is larger than 5MB","signup_filePath_lable":"Selected File","signup_MediaTitle2":"Social Media Links","signup_facebookHandle":"Facebook Handle","signup_InstaHandle":"Instagram Handle","signup_SaveBtn":"Save Details","forgotPwd_title":"Forgot Password","forgotPwd_ResetBtn":"Reset Password","forgotPwd_SuccessMsg":"Your request for Reset Password is successful, We have sent the new password to your registered Email id.","customerInvoice_selectShippingCost":"Select Shipping Cost","customerInvoice_CalculatingShippingRates_Msg":"Calculating...","customerInvoice_AddShippingAddress_Msg":"Select Address or Add Shipping Address ","customerInvoice_PleaseSetAnyShippingAddressMsg":"Please select any one shipping address","customerInvoice_ShippingCostErrorMsg":"Please Add New Shipping Address,because the address has insufficient information.","customerInvoice_CalculateShippingCost_Btn":"Calculate Shipping Cost","customerInvoice_ShippingCostAddOrNot_Msg":"Would you like to add Shipping cost?","customerInvoice_ShippingCostAddOrNot_Yes":"Yes","customerInvoice_ShippingCostAddOrNot_No":"No","shop_utterly_conkers_ShippingCostCompulsory_ErrorMsg":"Not placed your order unless and until add Shipping Cost","shop_utterly_conkers_AddMoreProducts__ErrorMsg":"Please add more products to calculate Shipping Cost","customerInvoice_ShippingCostErrorMsg_TryAgain":"Please try again","dashboard_BannerMsg":"Graphs are updated every 8 hours","yourSales__BannerMsg":"Order details are updated every 5 mins","customerInvoice_FirstNameErrorMsg":"Please enter first name","customerInvoice_lastNameErrorMsg":"Please enter last name","customerInvoice_Add1ErrorMsg":"Please enter address line 1","customerInvoice_CountryErrorMsg":"Please select country","customerInvoice_StateErrorMsg":"Please select state","customerInvoice_CityErrorMsg":"Please enter city name","customerInvoice_ZipErrorMsg":"Please enter zip code","uploadImage":"Upload Image","dashboard_CardTitle1":"Commission on all orders","dashboard_CardTitle3":"Total Commission","dashboard_CardTitle4":"Total Sales","dashboard_TotalAvg_Ticket_Size":"Avg ticket size","dashboard_TotalRevenue":"Total Revenue","profile_Change_Password":"Change Password","dashboard_Information_Message":"Commission is tracked only for paid orders","resetPassword_validation_Msg":"This field is required","resetPassword_validation_Msg2":"Password should contain minimum 8 characters,1 uppercase,1 lowercase,1 digit etc.","resetPassword_validation_Msg3":"Confirm password should match with New password","dashbord_Msg_New":"How It Works","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximum Discount is not configured. Please contact site Admin.","discount_couponErrorMsg2":"Commission is not configured. Please contact site Admin.","dashbord_profile_pic":"Change Profile Pic","Performance_Details":"Performance Details","Show_Performance_Details":"Show Performance Details","Dashboard_Month":"Month","Dashboard_Orders_Total":"Total Orders","Dashboard_Total_Sale":"Total Sale","Dashboard_Commission":"Commission","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Please add customer address.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Please select shipping cost.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Cart not updated, please refresh and retry.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Please select product.","customerInvoice_CreatingDraft_Msg":"Draft Creating..","customerInvoice_DraftOrderBtn":"Draft Order","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Draft Order Created Successfully","productTable_error_AlertMsg":"Quantity cannot be 0 or less. Please enter a valid value.","productTable_error_AlertMsg2":"Please Enter Quantity","click_to_copy":"Click  to copy","discount_code_copy_coupon":"Copy Coupon","createOrder_productSearchGuide":"Not able to find products?","soldOut":"Sold Out","InventoryNotTracked":"Inventory not tracked","productStatus":"Product Status","makeSureInShopify":"Make sure in Shopify","products":"Products","sectionTheProductStatusIs":"section, the product status is","active":"Active","productsMayBeSoldOutPleaseCheck":"Products may be sold out,please check and select","yourSales_PaidOrders_PaidDate":"Order Paid Date","ordersLoading":"Orders loading...","productsLoading":"Products loading...","leaveOnPageBtn":"Continue","stayOnPageBtn":"Stay on this page","alertBoxTitle":"Create order page","alertMessage":"Unsaved changes will be lost. You can save this order as a draft.","salesDetailsHeader_Location":"Location","tab_CreateB2BOrder":"B2B Order","b2b_no_company_data_available":"No Company Data Available","b2b_select_location":"Select Location","b2b_select_customer":"Select Customer","b2b_select_location_customer":"Select Customer/Location","b2b_SelectedCompanyDetails":"Selected Company Details","b2b_no_location_data":"No Locations Available","b2b_no_customer_data":"No Customer Data Available","b2b_removeSelectedCustomer":"Remove","b2b_emailId":"Email Id","b2b_customerName":"Customer Name","b2b_companyName":"Company Name","b2b_BillingAddress":"Billing Address","b2b_ShippingAddress":"Shipping Address","ST_CO_no_result_found_msg":"No results found for","ST_CO_SearchProducts_Label":"Search Products","ST_CO_search":"Search","ST_Producttable_netQuantity":"Net Quantity","ST_Producttable_subtotal":"Subtotal","ST_Producttable_wholesalePrice":"Wholesale Price","ST_Producttable_retailPrice":"Retail Price","ST_Producttable_SKU":"SKU","ST_Producttable_product":"Product","createOrder_select_product":"Select Product","createOrder_AddProduct":"Add Product","createOrder_AddBtn":"Add","CreateOrder_doneBtn":"Done","createOrder_productTable_NoProductsAdded":"No products added","productTable_clearCartBtn":"Clear Cart","b2b_companyTable_noMainContact":"No Main Contact Available","ST_none":"None","CreateOrder_EnterPoNumber":"Enter PO Number","CreateOrder_chooseDateMsg":"Choose a Date","CreateOrder_paymnetTerms":"Payment Terms","CreateOrder_TaxExemption":"Tax Exemption","b2b_select_company":"Select Company","draftOrder_CompanyName":"Company Name","CreateOrder_Company":"Company","Create_Order_TotalLocations":"Total Locations","Create_Order_MainContact":"Main Contact","Create_Order_PaymentDueLater":"Payment Due Later","yourSales_headerLocation":"Location","salesDetailsHeader_Company":"Company","customerInvoice_PaymentPending":"Payment Pending","customerInvoice_Checkout":"Checkout","customerInvoice_ProceedToCheckout":"Proceed to Checkout","customerInvoice_CheckoutMsg":"This will generate a draft order, redirecting you to the checkout page. In case the checkout process is unsuccessful, you can find this order in the Sales Order Details tab under Draft Orders.","customerInvoice_sendInvoiceToCustomer":"Send Invoice to Customer","customerInvoice_cancel":"Cancel","Checkout_DoNotAskAgainMsg":"Do not ask again","RepCheckout_RedirectionMsg":"Redirecting to Checkout","customerInvoice_CreatingDraftCheckout":"Draft Creating with Checkout...","customerInvoice_OrderType":"Sales Method","DoNotShowAgain":"Do not show again","copyLinkSuccess":"Link Copied Successfully","affiliateLink_Confirmation_Msg1":"The affiliate link order tracking works only if customer clicks the","affiliateLink_Confirmation_Msg3":"button, it won\'t be effective if customer clicks the","affiliateLink_Confirmation_Msg4":"Buy Now","affiliateLinkConfirmationMsg2":"Add to cart","affiliateLink_Confirmation_Msg5":"Button.","productsPerPage":"Products per page","productTableCartClearButton":"Clear","affiliateLink_Confirmation_Note":"NOTE","myCustomers_searchByCustomerOrCompanyName":"Search by Customer or Company Name","ST_Producttable_VolumePricing":"Volume Pricing","dashboard_B2BCompanyLocation":"Company Location","customer":"Customer","PaidDate":"Paid Date","producttable_discounttypeHeader":"Discount type","customerInvoice_DiscountOnSubtotal":"Discount","ST_Producttable_CartResponse":"Customer is not eligible to purchase some of the products in the cart","ST_B2BPriceBreack_CloseBtn":"Close","B2B_QtyRule_Error_Msg":"Invalid quantity added. Please check quantity rules.","Customer_Info_Title":"Please select country first","Customer_Invalid_pinCode_Msg":"Invalid pin code","Edit_DraftOrderAlert_Msg":"Important: Admin has applied wholesale prices for this customer.","Create_Order_DiscountDropdown_value1":"Percentage","Create_Order_DiscountDropdown_value2":"Fixed Dollar Amount","Create_Order_DiscountType_Popup_Value1":"Change discount type","Create_Order_DiscountType_PopUp_Value2":"Already applied discounts will be removed.","B2B_PriceList_Increment_Msg":"Increment of ","B2B_PriceList_Minimum_Msg":"Minimum of ","B2B_PriceList_Maximum_Msg":"Maximum of ","SpecialChar_Error_Msg":"Special characters like @,#,!,$,& are not allowed in the password","createOrder_ErrorMsgForQuantityLimit":"You can\'t add quantity more than the available stock.","ClientInvoice":"Rep Created","AffiliateOrder":"Affiliate Link","CouponOrder":"Discount Coupon","ReturnCustomerOrder":"Customer Order","Tagcustomer":"Customer Order","POSOrder":"POS","SharedCart":"Share Cart","RepOnCartPage":"Rep Choice","AdminTaggedOrder":"Manual Tagging","TaggedCompanyLocationOrder":"B2B Order","WholesaleOrder":"Wholesale Invoice","TeamManager":"Team Manager","charsLeft":"char left","showing":"Showing","customers":"customers","exportCsv":"Export CSV","all":"All","paid":"Paid","unpaid":"Unpaid","draft":"Draft","refunded":"Refunded","customerInvoice_DraftOrderDescription":"An order draft will be generated. You can also choose to send an invoice to customer for the review. If there are any changes, you can access draft orders from \'Sales Order Details\' section.","customerInvoice_PaymentPendingDescription":"An order will be generated with payment status as \'Pending\'","customerInvoice_CheckoutDescription":"Complete the checkout process on customer\'s behalf.","orderType":"Order Type","ShippingCost_AddressError":"Shipping cost for selected address is not configured. Please contact admin.","ShippingCost_CustomerAddressAndCartProductError":"Customer address and products in the cart are mandatory to calculate shipping cost.","ContactCard_Info_Msg":"Contact card makes your affiliate links more appealing. When a customer uses an affiliate link, they can see your contact card on the website, providing a more personalized shopping experience. This card can be personalized with a profile photo and a message for your customers.","contact_Cart_Heading":"Contact Card","Affiliate_Link_Info_Msg":"Share your affiliate link with customers. Any order placed by using your affiliate link will be attributed to you","Contact_Card_Bio_Save_Success_Msg":"Bio saved sucessfully","Affiliate_Add_ProductInfo_Msg":"Add products for which you would like to share affiliate link","ShareCart_UserGuide_Msg1":"Create a shareable link of cart, pre-loaded with selected products tailored to your customer\'s preferences. Customer can use the link, review cart items and directly proceed","ShareCart_UserGuide_Msg2":"to checkout. Orders placed by using your cart link will be attributed to you.","ShareCart_ToltipTitle":"Remove products from the cart","Delete_Cart_Confirmation":"Are you sure you want to delete the cart?","No_Share_Cart_Added1":"No cart link created till now.","No_Share_Cart_Added2":"Create a cart and share its direct link with your customers","ClearCart_Conformation_Msg":"Are you sure you want to remove all products from the cart?","Edit_Billing_Address":"Edit billing address","Edit_Shipping_Address":"Edit shipping address","New_Customer_Select_Msg":"Create a new customer","CreateOrder_Manage_Heading":"Manage","RemoveCustomer_Msg":"Remove customer","Customer_Address_Apartment":"Apartment, suite, etc","Address_Enter_Msg":"Enter Address","Address_Not_Found_Error_Msg":"Customer address and products in the cart are mandatory to create an order","Load_More_Btn":"Load More","Beta_Version_msg1":"This feature is currently in Beta version. If you face any issue","Beta_Version_msg2":"please contact support.","Heading_Product_Select":"Select Products","Customer_FirstName":"First name","Customer_lastName":"Last name","Customer_Resion":"Country/region","Customer_pinCode":"PIN code","Customer_phone":"Phone","applyDisconutCode_atCheckout":"Allow customers to apply discounts coupon at checkout"}'
        ),
        wt = JSON.parse(
          '{"dashboard_title":"TABLERO","dashboard_welcomeMsg":"Bienvenido a","dashboard_morningMsg":"Buenos días","dashboard_afternoonMsg":"Buenas tardes","dashboard_eveningMsg":"Buena noches","dashboard_subTitle1":"MES ACTUAL","dashboard_block1Heading":"FACTURA DEL CLIENTE","dashboard_block1Header1":"GANANCIAS","dashboard_block1Header2":"FACTURA ENVIADA","dashboard_block1Header3":"FACTURA PAGADA","dashboard_block2Heading":"PEDIDOS AL POR MAYOR","dashboard_block2Header1":"GANANCIAS","dashboard_block2Header2":"FACTURA ENVIADA","dashboard_block2Header3":"FACTURA PAGADA","dashboard_block3Heading":"ÓRDENES DE AFILIADOS","dashboard_block3Header1":"GANANCIAS","dashboard_block3Header2":"PEDIDOS PAGADOS","dashboard_block4Heading":"CUPÓN DE DESCUENTO","dashboard_block4Header1":"GANANCIAS","dashboard_block4Header2":"PEDIDOS PAGADOS","dashboard_block5Heading":"COMISION CLIENTE","dashboard_block5Header1":"COMISIÓN","dashboard_block5Header2":"PEDIDOS","dashboard_block6Heading":"TEAM LEAD COMMISSION","dashboard_block6Header1":"COMISIÓN","dashboard_block7Heading":"POS COMMISSION","dashboard_block7Header1":"COMISIÓN","dashboard_block7Header2":"PEDIDOS","dashboard_tbl1column1":"Mes","dashboard_tbl1column2":"Órdenes de factura de cliente","dashboard_tbl1column3":"Comisión de factura del cliente","dashboard_tbl1column4":"Pedidos al por mayor","dashboard_tbl1column5":"Compra total al por mayor","dashboard_tbl1column6":"Órdenes de afiliados","dashboard_tbl1column7":"Comisión de afiliados","dashboard_tbl1column8":"Órdenes de código de cupón","dashboard_tbl1column9":"Comisión de código de cupón","dashboard_tbl1column10":"Pedidos de los clientes","dashboard_tbl1column11":"Comisión de cliente","dashboard_tbl1column12":"Órdenes POS","dashboard_tbl1column13":"Comisión POS","dashboar_cardHeading1":"Orden total","dashboar_cardHeading2":"Comisión","dashboar_cardHeading3":"Ventas","dashboar_cardHeading4":"Bonificación","dashboard_graphHeading1":"Rendimiento de ventas de los últimos seis meses","dashboard_graphHeading2":"Analice el orden y la comisión de las funciones para el mes actual","Graph_Sales_noorderstitle":"sin orden","Graph_SalesRepCommission_nocommissiontitle":"No hay datos de comisión para mostrar","Graph_SalesRepOrders_title":"Pedidos","Graph_SalesRep_XAxisTitle_ForMonth":"6 meses","Graph_SalesRepOrders_YAxisTitle":"Pedidos","Graph_SalesRepSales_title":"VENTAS","Graph_SalesRepCommission_title":"COMISIÓN","Graph_SalesRepCommissions_YAxisTitle":"Comisión","Graph_FeatureWiseOrder_title":"Órdenes vs característica","Graph_featureWiseCommission_title":"Comisión vs característica","Graph_FeatureWiseOrder_XAxisTitle":"Característica","Graph_FeatureWiseOrder_YAxisTitle":"Pedidos","Graph_FeatureWiseCommission_title":"COMISIÓN","Graph_FeatureWiseCommission_YAxisTitle":"Comisión","customerInvoice_title":"Crear orden","customerInvoice_button":"atrás","customerInvoice_noclientorderMsg":"Sin pedidos de factura de cliente","customerInvoice_button1":"Ver pedidos anteriores","customerInvoice_contentHeading1":"Descuento y comisión en","customerInvoice_table1column1":"tipo de producto","customerInvoice_table1column2":"Comisión","customerInvoice_table1column3":"Nombre de descuento","customerInvoice_table1column4":"Descuento","customerInvoice_contentHeading2":"Agregue los detalles del cliente y seleccione los productos para enviar la factura","customerInvoice_contentHeading2Title1":"Entrar/Buscar Cliente","customerInvoice_title1Placeholder":"Entrar/Buscar Cliente","customerInvoice_contentHeading2Title2":"Ingrese el ID de correo electrónico del cliente","customerInvoice_title2Placeholder":"Dirección de correo electrónico","customerInvoice_contentHeading2Title3":"Ingresar notas de pedido","customerInvoice_contentHeading2Title4":"Dirección del cliente","customerInvoice_contentHeading2Title5":"Número de móvil del cliente","customerInvoice_contentHeading2Title6":"Nota del cliente","customerInvoice_contentHeading2Title7":"Nombre de la empresa del cliente","customerInvoice_title7Placeholder":"nombre de empresa","customerInvoice_Placeholder_contentHeading2Title6":"Nota","customerInvoice_Placeholder_contentHeading2Title5":"Número de teléfono móvil","customerInvoice_Placeholder_contentHeading2Title4":"Dirección de Envío","customerInvoice_title3Placeholder":"pedidos","customerInvoice_table2Column1":"Imagen","customerInvoice_table2Column2":"Agregar cantidad","customerInvoice_table2Column3":"Título","customerInvoice_table2Column4":"Título de la variante","customerInvoice_ProductTableColumnPrice":"Precio","customerInvoice_ProductTableColumnWholeSalePrice":"Precio al por mayor","customerInvoice_button2":"Crear factura","customerInvoice_ProductTableColumnProduct":"Producto","customerInvoice_table3Column2":"nombre del producto","customerInvoice_table3Column3":"Talla","customerInvoice_ProductTableColumnQuantity":"Cantidad","customerInvoice_table3Column5":"Precio del articulo","customerInvoice_table3Column6":"Precio total","customerInvoice_table3Column7":"Precio con descuento para el cliente","customerInvoice_table3Column8":"Comisión SalesRep","customerInvoice_table3Column9":"Tipo de descuento","customerInvoice_repproInvite":"Seleccione la casilla de verificación para enviar una invitación profesional","customerInvoice_customerOrder_error1":"todos los campos del cliente son obligatorios. Ingrese el correo electrónico y el nombre del cliente","customerInvoice_productAddedMsg":"Producto añadido","customerInvoice_AlertErrorMsg":"Error... ¡Por favor, póngase en contacto con el soporte!","wholesaleOrder_title":"Orden al por mayor","wholesaleOrder_contentHeading1":"Puede comprar productos a precios especiales al por mayor","wholesaleOrder_contentHeading2":"Descuento en","wholesaleOrder_column1":"SalesRep Name","wholesaleOrder_column2":"Descuento","wholesaleOrder_searchtxtPlaceholder":"Buscar producto","wholesaleOrder_table1Column1":"Imagen","wholesaleOrder_table1Column2":"Agregar cantidad","wholesaleOrder_table1Column3":"Título","wholesaleOrder_table1Column4":"Título de la variante","wholesaleOrder_table1Column5":"Precio","wholesaleOrder_button":"Echa un vistazo","wholesaleOrder_Order_btn":"Mostrar / Ocultar precios por volumen","wholesaleOrder_contentHeading3":"Precio total","wholesaleOrder_contentHeading4":"Su precio con descuento","wholesaleOrder_table2Column1":"Producto","wholesaleOrder_table2Column2":"nombre del producto","wholesaleOrder_table2Column3":"Talla","wholesaleOrder_table2Column4":"Cantidad","wholesaleOrder_table2Column5":"Precio del articulo","wholesaleOrder_table2Column6":"Precio total","wholesaleOrder_table2Column7":"Su precio con descuento","affiliateLink_title":"Enlace de afiliado","affiliate_product_link":"Enlace de productos","affiliateLink_input_error_msg":"El campo de texto del enlace es obligatorio y no debe contener espacios.","affiliateLink_contentHeading1":"Comparta su enlace de afiliado en las redes sociales y el correo electrónico. Obtendrá una comisión de afiliado por cada pedido de su enlace de afiliado","affiliateLink_contentHeading2":"Tu enlace de afiliado","affiliateLink_contentHeading3":"Comisión en","affiliateLink_content_Message1":"Busque productos y comparta el enlace de productos individuales con sus clientes.","affiliateLink_noaffiliateorderMsg":"Sin pedidos de afiliados","affiliateLink_column1":"SalesRep Name","affiliateLink_column2":"Comisión","affiliateLink_searchtxtPlaceholder":"Buscar producto","affiliateLink_searchColumn1":"Producto","affiliateLink_searchColumn2":"Titulo del producto","affiliateLink_searchColumn3":"Precio","affiliateLink_searchColumn4":"Comisión","affiliateLink_searchColumn5":"Enlace de afiliado","affiliateLink_searchColumn7":"Copiar link","affiliateLink_searchColumn8":"copiada","affiliateLink_backbtn":"atrás","affiliateLink_card_Title":"Tarjeta de contacto y enlace de afiliado","cartSharing_title":"Compartir carro","cartSharing_CreateCartInformation_Text":"Para crear un carrito personalizado para compartir, agregue productos al carrito desde la tienda.Estos productos se mostrarán en esta página","cartSharing_content2Placeholder":"Nombre del carrito","cartSharing_table2Column2":"nombre del producto","cartSharing_table2Column3":"Talla","cartSharing_table2Column6":"Precio total","cartSharing_SharedCartLinkTableColumnCartName":"Nombre del carrito","cartSharing_SharedCartLinkTableColumnLink":"Enlace","cartSharing_SharedCartLinkTableColumnCartLink":"Enlace de carrito compartible","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copiar enlace del carrito","cartSharing_SharedCartLink_Other":"Otra","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Eliminar enlace del carrito","cartSharing_EnterCartName_Label":"Ingrese el nombre del carrito","cartSharing_ProductTableColumnProduct":"Producto","cartSharing_ProductTableColumnQuantity":"Cantidad","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Precio del articulo","cartSharing_CartCreating_Msg":"Creando...","cartSharing_Copied_Msg":"Copiada!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Sin enlace para mostrar","cartSharing_CartCreatedSuccessfully_Msg":"Su nuevo carrito ha sido creado exitosamente","cartSharing_CartCreateError_Msg":"Error... Inténtalo de nuevo","cartSharing_AlertError_Msg":"Error... ¡Por favor, póngase en contacto con el soporte!","cartSharing_CopyCartLink_Msg":"Copiar enlace del carrito","cartSharing_DeleteCartLink_Msg":"Eliminar enlace del carrito","cartSharing_DeleteConfirmation_Msg":"Estas segura","cartSharing_ProductTableEmpty_Msg":"Producto no disponible","cartSharing_CreateCart_Btn":"Crear carrito","cartSharing_ProductTableQuantityUpdate_Btn":"Seleccione el producto","discountCoupon_titleOne":"Cupón de descuento","discountCoupon_contentHeading1":"Comparta el código de cupón de descuento con sus clientes y cada vez que se use su cupón, obtendrá una comisión.","discountCoupon_contentHeading2":"Su código de cupón es","discountCoupon_contentHeading3":"Importe de descuento","discountCoupon_contentHeading4":"Comisión","discountCoupon_contentHeading4PlaceHolder1":"Oye, usa mi código de cupón de descuento","discountCoupon_contentHeading4PlaceHolder2":"y obtén productos con descuento","discountCoupon_button1":"Copiar texto","cartSharing_copiedButtonText":"Copiado","discountCoupon_titleTwo":"Cree cupones de descuento de un solo uso para los clientes","discountCoupon_button2":"Ver cupones","discountCoupon_contentHeading5":"Descuento máximo permitido","discountCoupon_contentHeading6":"Comisión","discountCoupon_contentHeading7":"Introduce el código de cupón","discountCoupon_contentHeading7PlaceHolder":"Ingrese el código del cupón","discountCoupon_contentHeading8":"Ingrese descuento","discountCoupon_contentHeading8PlaceHolder":"El descuento no debe ser mayor que el descuento máximo.","discountCoupon_button3":"Crear cupón","discountCoupon_coupon_error1":"Ingrese el código del cupón y el descuento","yourBio_title":"Tu tarjeta de contacto","yourBio_content1":"Subir perfil","yourBio_button1":"Elija el archivo","yourBio_button1PlaceHolder":"Ningún archivo elegido","yourBio_error_image_size":"El tamaño de la imagen es demasiado grande, cargue una imagen de menos de 5 MB. Inténtalo de nuevo.","yourBio_button2":"Subir","yourBio_content2":"Ingrese una palabra personalizada para crear su enlace de afiliado único","yourBio_content2PlaceHolder":"crea tu enlace de afiliado único","yourBio_content4":"Cuando se utilice su enlace, su tarjeta de contacto aparecerá en el sitio web","yourBio_content3":"Ingrese su tarjeta de contacto","yourBio_content3PlaceHolder":"Ingrese 100 palabras","yourBio_button3":"Salvar","yourBio_button4":"Salvado","yourBio_error_link":"Este enlace único se puede tomar. Pruebe con un enlace único diferente.","yourBio_Linksuccessmsg":"Enlace único guardado con éxito.","team_title1":"Agregar SalesRep","team_content1":"Ingrese correo electrónico","team_content1PlaceHolder":"Dirección de correo electrónico","team_emailerrorMsg":"Por favor ingrese correo electrónico","team_content2":"Ingrese el nombre","team_content2PlaceHolder":"Primer nombre","team_fnameerrorMsg":"Por favor ingrese su nombre","team_content3":"Introduzca el apellido","team_content3PlaceHolder":"Apellido","team_button1":"Añadir","team_successmsg":"El representante ha sido añadido con éxito. Recibirá las credenciales de acceso en el correo electrónico enviado.","team_errorsmsg":"Error al agregar. Es posible que este correo electrónico de usuario ya tenga una cuenta en la tienda","team_title2":"Detalles del equipo","team_content4":"Página de registro","team_NoTeamDetailsMsg":"Sin detalles del equipo","team_content5":"Seleccione SalesRep","team_tableTitle":"DETALLES DEL PEDIDO DE LOS ÚLTIMOS DOS MESES","team_column1":"Número de orden","team_column2":"Fecha de orden","team_column3":"Nombre del cliente","team_column4":"Representante de ventas","team_column5":"Total parcial","team_column6":"Comisión de representante de ventas","team_column7":"Comisión de Team Manager","team_column8":"Método de venta","addCustomer_title":"Agregar cliente","addCustomer_content1":"Ingrese el nombre del cliente","addCustomer_txt1Placeholder":"Primer nombre","addCustomer_content2":"Ingrese el apellido del cliente","addCustomer_content2Placeholder":"Apellido","addCustomer_content3":"Ingrese el ID de correo electrónico del cliente","addCustomer_content3Placeholder":"Dirección de correo electrónico","addCustomer_content4":"Nota","addCustomer_content4Placeholder":"Nota","addCustomer_customerAddress":"Dirección personal","addCustomer_customerCity":"Ciudad","addCustomer_customerCityPlaceholder":"Ciudad","addCustomer_customerCountry":"País","addCustomer_customerState":"Estado","addCustomer_customerZipCode":"Código postal","addCustomer_companyName":"nombre de empresa","addCustomer_companyAddress":"Dirección de la empresa","addCustomer_companyCity":"Ciudad","addCustomer_companyCountry":"País","addCustomer_companyState":"Estado","addCustomer_companyZipCode":"Código postal","addCustomer_button":"Salvar","addCustomer_leadsuccessmsg":"El cliente se agrega con éxito.","addCustomer_leadErrrorMsg":"Error al guardar los detalles.","addCustomer_leadEmptyErrrorMsg":"Por favor complete el campo requerido.","addCustomer_leadsuccessmsg2":"Cliente creado y etiquetado con éxito a un representante de ventas.","addCustomer_leadErrrorMsg2":"Este cliente ya está etiquetado con un representante.","myCustomers_title":"Tus clientes","myCustomers_table1Column1":"Nombre","myCustomers_table1Column2":"nombre de empresa","myCustomers_table1Column3":"Email","myCustomers_table1Column4":"Pedidos","myCustomers_table1Column5":"Total gastado","myCustomers_table2Title":"DETALLES DEL CLIENTE","myCustomers_table3Title":"DETALLES DEL PROYECTO DE PEDIDO","myCustomers_table3Column1":"Nombre del producto","myCustomers_table3Column2":"Tamaño","myCustomers_table3Column3":"Cantidad","myCustomers_table3Column4":"Precio","myCustomers_table3Column5":"Estado","myCustomers_table3Column6":"Total parcial","myCustomers_table2Row1":"Nombre","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Habla a","myCustomers_table2Row4":"nombre de empresa","myCustomers_table2Row5":"Notas de clientes","myCustomers_table2Row6":"Total gastado (subtotal + impuestos)","myCustomers_table2Row7":"Numero de ordenes","myCustomers_table2Row8":"Etiquetas","myCustomers_radioButton0":"Mostrar todos los clientes","myCustomers_radioButton1":"Buscar por nombre","myCustomers_radioButton2":"Buscar por empresa","myCustomers_radioButtonError1":"Seleccione el tipo de búsqueda e ingrese el valor para buscar","myCustomers_radioButtonError2":"Ingrese un valor para buscar","myCustomers_radioButtonError3":"Seleccione el tipo de búsqueda","myCustomers_searchButton":"Buscar","myCustomers_Placeholder1":"Escriba el nombre del cliente o el nombre de la empresa para buscar","myCustomers_NoOrdersError":"Sin pedidos","myCustomer_no_salesRep_details":"No hay detalles de representantes de ventas disponibles.","myCustomer_select_customer_country":"Seleccione el país del cliente","myCustomer_company_country":"País de la empresa","myCustomer_company_state":"Estado de la empresa","myCustomer_select_company_country":"Seleccione el país de la empresa","yourSales_SalesOrderDetailsTitle":"Detalles de órdenes de venta","yourSales_title":"Detalles del pedido de los últimos 2 meses","yourSales_table1Column1":"Número de orden","yourSales_table1Column2":"Fecha de orden","yourSales_table1Column3":"Nombre del cliente","yourSales_table1Column4":"Total parcial","yourSales_table1Column5":"Comisión","yourSales_table1Column6":"Tipo de comisión","yourSales_table1Column7":"Imprimir factura","printOrderInvoice_btn":"Imprimir","yourSales_tableTitle":"DETALLES DE PRODUCTO","yourSalesDraft_tableTitle":"DETALLES DEL PROYECTO DE PEDIDO","yourSales_column1":"Producto","yourSales_column2":"Título","yourSales_column3":"Cantidad","yourSales_column4":"Precio del articulo","yourSales_column5":"El número de rastreo","yourSales_column6":"Fecha de envío","yourSales_column7":"Precio total","yourSales_content1":"Total parcial","yourSales_content2":"Impuesto","yourSales_content3":"Costo de envío","yourSales_content4":"Total","yourSales_content5":"Nota","yourSales_tabHeading1":"Pedidos pagados","yourSales_tabHeading4":"Órdenes pendientes","yourSales_tabHeading2":"Borradores de pedidos","myOrders_title":"Detalles de mis pedidos","myOrdersDetails_Message":"Pedidos realizados para usted","myOrders_table1Column1":"Número de orden","myOrders_table1Column2":"Fecha de orden","myOrders_table1Column3":"Nombre del cliente","myOrders_table1Column4":"Pago","myOrders_table1Column5":"Cumplimiento","myOrders_table1Column6":"Total","myOrders_tableTitle":"DETALLES DE PRODUCTO","myOrders_table2Column1":"Producto","myOrders_table2Column2":"Título","myOrders_table2Column3":"Cantidad","myOrders_table2Column4":"Precio del articulo","myOrders_table2Column5":"El número de rastreo","myOrders_table2Column6":"Fecha de envío","myOrders_table2Column7":"Precio total","myOrders_content1":"Total parcial","myOrders_content2":"Impuesto","myOrders_content3":"Costo de envío","myOrders_content4":"Total","myOrders_content5":"Nota","myOrders_content6":"ID de borrador","tab_Dashboard":"Tablero","dashbord_Tab":"Hogar","tab_CustomerInvoice":"Crear orden","tab3_WholesaleOrder":"Orden al por mayor","tab_AffiliateLink":"Enlace de afiliado","tab_CartSharing":"Compartir carro","tab_DiscountCoupon":"Cupón de descuento","tab7_YourBio":"Tu tarjeta de contacto","tab8_Team":"Equipo","tab9_AddCustomer":"Agregar cliente","tab_MyCustomers":"Mis clientes","tab_YourSalesOrderDetails":"Detalles de su orden de venta","tab12_MyOrders":"Detalles de mis pedidos","tab13_Logout":"Cerrar sesión","signUp_title":"Registro de representante de ventas","signUp_subTitle":"Complete este formulario para registrarse como representante de ventas y obtener acceso a todas las funciones del equipo de ventas.","signUp_content1":"Email","signUp_content2":"Nombre de pila","signUp_content3":"Apellido","signUp_content4":"Número de teléfono","signUp_content5":"Mango de Facebook","signUp_content6":"Usuario de Twitter","signUp_content7":"Mango de Instagram","signUp_content8":"subir foto de perfil","signUp_socialmedialable1":"Enlaces de redes sociales","signUp_socialmedialable2":"Opcional","signUp_uploadBtn":"Elija el archivo","signUp_uploadBtnPlaceHolder":"Ningún archivo elegido","signUp_button3":"Guardando detalles ...","signUp_welcomemsg1":"Hola","signUp_welcomemsg2":"Regístrese como representante de ventas y obtenga una comisión sobre las ventas realizadas por sus representantes","signUp_emailerror":"Por favor ingrese correo electrónico","signUp_Fnameerror":"Por favor ingrese su nombre","signUp_lnameerror":"por favor, introduzca el apellido","signUp_phnumbererror":"Por favor, introduzca el número de teléfono","signUp_successmsg":"Su solicitud de registro ha sido enviada con éxito. Recibirá los detalles de inicio de sesión de la cuenta por correo electrónico una vez que el administrador apruebe su solicitud. Para más información, por favor contacte al administrador de la tienda.","signUp_errorsmsg":"Error al guardar los detalles. Es posible que este correo electrónico de usuario ya tenga una cuenta en la tienda.","signUp_RepExistErrorMsg":"Este correo electrónico ya está registrado como representante.","addingRep_selectRepsLabel1":"¿Quien te ayudo?","addingRep_NoSalesRep":"Sin representante de ventas","addingRep_selectRepsLabel2":"Seleccione un elemento de la lista.","addingRep_successMsg":"RepId agregado a la nota del carrito","wholesaleOrder_WholesaleDiscountTableColumn1":"Titulo del producto","wholesaleOrder_WholesaleDiscountTableColumn2":"Descuento","customerInvoice_ViewClientOrdersColumn1":"Nombre del cliente","customerInvoice_ViewClientOrdersColumn2":"Titulo del producto","customerInvoice_ViewClientOrdersColumn3":"Precio subtotal","customerInvoice_ViewClientOrdersColumn4":"Estado","customerInvoice_ViewClientOrdersColumn5":"Factura","salesRep_order_errorMsg":"Error durante la creación de su pedido, póngase en contacto con el soporte","salesRep_order_successMsg":"¡Factura de pedido creada correctamente! La factura se ha enviado por correo electrónico al cliente.","salesRep_order_errorMsg2":"Error durante la creación de su pedido, póngase en contacto con el soporte","customedraft_btn1":"Crear nueva factura","customedraft_btn2":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","customedraft_btn3":"Creando orden ...","customedraft_btn4":"Crear nueva factura","salesRep_order_NoProductSelected":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","productnotselectforcartsharingtxt1":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","discountCoupons_tblColumn1":"Código promocional","discountCoupons_tblColumn2":"Descuento","discountCoupons_tblColumn3":"Eliminar cupón","discountedPriceLabel":"Su precio con descuento","couponCodeNotSet":"Código de cupón no establecido","dashboard_subTitle2":"Ciclo del mes actual: 5 ° - 4 °","affiliatelink_commissiononlbl":"Producto","displaycommission_lbl1":"tipo de producto","displaycommission_lbl2":"Representante de ventas","displaycommission_lbl3":"Descuento basado en cantidad","discountcommissiononlbl1":"Niveles de descuento para clientes","clientInvoiceCommissionTablecolumn1":"tipo de producto","clientInvoiceCommissionTablecolumn2":"Comisión","clientInvoiceCommissionTablecolumn3":"Titulo del producto","clientInvoiceCommissionTablecolumn4":"SalesRep Name","clientInvoiceQuantityBaseDiscountTablecolumn1":"nombre del producto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Descuento","clientInvoiceQuantityBaseDiscountTablecolumn3":"Cantidad","affiliateCartProdtableColumn1":"Producto","affiliateCartProdtableColumn2":"Titulo del producto","affiliateCartProdtableColumn3":"Precio","affiliateCartProdtableColumn4":"Comisión","affiliateCartProdtableColumn5":"Enlace de afiliado","affiliateCartProdtableColumn6":"Compartir enlace","productnotselectforcartsharinglbl1":"Ingrese el nombre del carrito","productnotselectforcartsharinglbl2":"No hay productos seleccionados. Seleccione productos y vuelva a intentarlo.","productnotselectforcartsharinglbl3":"Espere mientras se procesa ...","showSharedCartProductcolumn1":"Enlace del carrito","showSharedCartProductcolumn3":"Quitar carrito","onSuccessInvoiceSuccessMsg":"Factura enviada correctamente","onSuccessInvoiceFailedMsg":"Error al enviar la factura","sendInvoice_successMsg":"Factura enviada con éxito","deleteInvoice_successMsg":"Factura eliminada correctamente","deleteInvoice_FailedMsg":"Error al eliminar factura","deleteInvoice_btnlbl":"Eliminar factura","deleteSharedCartLink_successMsg":"Enlace eliminado correctamente","deleteSharedCartLink_FailedMsg":"Error al eliminar el enlace. Inténtalo de nuevo..","deleteSharedCartLink_btnlbl":"Eliminando enlace","viewInvoiceOrders_btntxt1":"Consiguiendo...","viewInvoiceOrders_btntxt2":"Ver pedidos anteriores","createCoupon_btnlbl1":"Creando cupón ...","createCoupon_btnlbl2":"Cupón creado","deleteCoupon_successMsg":"Cupón eliminado","deleteCoupon_FailedMsg":"Error al eliminar el cupón","deleteCoupon_btnlbl":"Eliminando...","viewProductModelColumn1":"Producto","viewProductModelColumn2":"Título","viewProductModelColumn3":"Cantidad","viewProductModelColumn4":"Cantidad reembolsada","viewProductModelColumn5":"Precio del articulo","viewProductModelColumn6":"Precio descontado","viewProductModelColumn7":"El número de rastreo","viewProductModelColumn8":"Fecha de envío","viewProductModelColumn9":"Precio total","showSharedCartProducts_column2":"Imagen","showSharedCartProducts_column3":"Agregar cantidad","showSharedCartProducts_column4":"Título","showSharedCartProducts_column5":"Título de la variante","showSharedCartProducts_column6":"Precio","viewClientOrders_btn1":"Mirar","viewClientOrders_btn2":"Enviar","viewClientOrders_btn3":"Eliminar","showCouponTable_txt1":"Consiguiendo...","showCoupon_btn2":"Ver cupones","showCoupon_btn1":"Copiado","affliateOrder_column1":"Nombre del cliente","affliateOrder_column2":"Correo electrónico del cliente","affliateOrder_column3":"Titulo del producto","affliateOrder_column4":"Fecha de orden","affliateOrder_column5":"Total parcial","affliateOrder_column6":"Comisión","affliateOrder_btn1":"Consiguiendo...","affliateOrder_btn2":"Ver pedidos de afiliados","affliateOrder_btn3":"Ver pedidos de afiliados","yourBio_btn1":"Salvar","yourBio_btn2":"Salvar","yourBio_Uploadbtn1":"Subiendo ...","yourBio_Uploadbtn2":"Subido","yourBio_UploadbtnError":"Perdón intente de nuevo","yourBio_Savebtn":"Ahorro..","team_txt1":"Ahorro..","team_txt2":"Salvar","viewRepClientOrdersDetails_column1":"Número de orden","viewRepClientOrdersDetails_column2":"Fecha de orden","viewRepClientOrdersDetails_column3":"Total parcial","viewRepClientOrdersDetails_column4":"Estado","viewRepClientOrdersDetails_column5":"Detalles de producto","addSalesRep_txt1":"Agregar SalesRep","addSalesRep_txt2":"Añadiendo SalesRep ...","discountCoupons_header":"Cupón de descuento único","discountCoupons_nodiscountcoupon":"No ha creado ningún Cupón de descuento","discountCoupons_deleteBtn":"Borrar","discountCoupons_BackBtn":"atrás","customerInvoice_selectcustomererror":"Seleccione Cliente y luego agregue el producto","createOrderFromCartPage_selectCustomersLabel":"SELECCIONAR CLIENTE","createOrderFromCartPage_selectCustomerAddressLabel":"DIRECCIÓN DE ENVÍO","createOrderFromCartPage_selectCustomersLabelForDropDown":" Seleccionar cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Seleccionar dirección","createOrderFromCartPage_successMsg":"¡Factura de pedido creada con éxito! La factura ha sido enviada por correo electrónico al cliente.","createOrderFromCartPage_AddNewAddressTitle":"AGREGAR NUEVA DIRECCIÓN","createOrderFromCartPage_draftOrderButton":"CREAR BORRADOR DE PEDIDO","createOrderFromCartPage_OrderButton":"CREAR ORDEN","createOrderFromCartPage_draftOrderButtonText2":"CREANDO PEDIDO ...","createOrderFromCartPage_selectShippingCostTitle":"COSTO DE ENVÍO","createOrderFromCartPage_Address_errorMsg4":"Hubo un problema al calcular las tarifas de envío.","createOrderFromCartPage_Address_errorMsg5":"Algo salió mal. Por favor, vuelva a intentarlo.","yourSales_tabHeading3":"Órdenes de reembolso","refundOrders_column1":"Id de reembolso","refundOrders_column2":"Fecha de orden","refundOrders_column3":"Número de orden","refundOrders_column4":"Nombre de la orden","refundOrders_column5":"Comisión","refundOrders_column6":"Comisión de Team Manager","refundOrders_column7":"ID de jefe de equipo","refundOrders_column8":"Subtotal de reembolso","refundOrders_column9":"Estado de la orden","refundOrders_column10":"Método de venta","refundOrderNumber_title":"Detalles del pedido de reembolso","refundOrderNumber_column1":"Nombre","refundOrderNumber_column2":"Fecha","refundOrderNumber_column3":"Cantidad","refundOrderNumber_column4":"Precio de descuento","refundOrderNumber_column5":"Total parcial","tableDataError":"Sin orden de reembolso","dashboard_subTitle3":"Detalles de la comisión","dashboard_cardHeading5_1":"Comisión sobre","dashboard_cardHeading5_2":"obtendrás un","dashboard_cardHeading5_3":"comisión en todos los pedidos.","Profit_Margin":"Margen de beneficio","Product_Type":"tipo de producto","Sales_Rep":"Representante de ventas","show_commission_list":"Mostrar lista de comisiones","commission_list":"Lista de comisiones","no_customers_to_show":"No hay clientes para mostrar","no_sales_to_show":"No hay ventas para mostrar","no_draft_to_show":"No hay borrador para mostrar","no_refund_to_show":"Sin reembolso para mostrar","no_orders_to_show":"No hay pedidos para mostrar","customerInvoice_ViewClientOrdersColumn6":"Número de orden","customerInvoice_ViewClientOrdersColumn7":"Fecha de orden","Error_commissions_NotUpdated":"Las comisiones no se actualizan","sales_chart_msg1":"Necesitamos datos...","sales_chart_msg2":"Parece que todavía no tenemos ningún dato para mostrar.","page_refresh_msg":"haga clic para actualizar","variant_title":"título variante","line_items_properties":"Propiedades","customer_country":"País del cliente","customer_state":"Estado del cliente","company_country":"País de la empresa","company_state":"Estado de la empresa","client_orders":"Pedidos de clientes","no_product_details":"No hay detalles de productos para mostrar","submit_btn_text":"Entregar","submitting_btn_text":"Sumisión","submitted_btn_text":"Presentado","email_id_validation_errmsg":"Ingrese una identificación de correo electrónico válida","customerInvoice_add_more_details":"Agregar más detalles","customerInvoice_add_shipping_address":"Añadir nueva Dirección de Envío","customerInvoice_HideDetails":"Ocultar detalles","customerInvoice_HideAddress":"Ocultar dirección de envío","customerInvoice_enterFirstName":"Ingrese el nombre","customerInvoice_enterFirstNamePlaceholder":"Primer nombre","customerInvoice_enterLastName":"Introduzca el apellido","customerInvoice_enterLastNamePlaceholder":"Apellido","customerInvoice_enterAddress1":"Ingrese la línea de dirección 1","customerInvoice_enterAddress1Placeholder":"Dirección Línea 1","customerInvoice_enterAddress2":"Ingrese la línea de dirección 2","customerInvoice_enterAddress2Placeholder":"Línea de dirección 2","customerInvoice_enterCity":"Ingresar ciudad","customerInvoice_enterCityPlaceholder":"Ciudad","customerInvoice_selectCountry":"Seleccionar país","customerInvoice_selectState":"Seleccione estado","customerInvoice_enterZipNumber":"Ingresa tu código postal","customerInvoice_enterZipNumberPlaceholder":"Código postal","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Producto no disponible","customerInvoice_SendInvoiceBtn":"Enviará la factura","customerInvoice_CreateBtn":"Crear","customerInvoice_CreatingBtn":"Creación","customerInvoice_ProductTableColumnSubTotal":"Subtotal","customerInvoice_SelectShippingAddress":"Seleccionar dirección de envío","customerInvoice_ProductsSearchBy_Placeholder":"Buscar productos por nombre, SKU, precio","customerInvoice_AddMoreProducts_Btn":"Agregar más productos","customerInvoice_RequiredErrorMsg":"Este campo es obligatorio","customerInvoice_EmailSuggestionErrorMsg":"Por favor agregue una identificación de correo electrónico válida","customerInvoice_MobileSuggestionErrorMsg":"Agregue un número de teléfono válido","customerInvoice_ErrorMsgAddShippingAddress":"Por favor complete la dirección de envío","customerInvoice_Creating_Msg":"Creando...","customerInvoice_Sending_Msg":"Enviando...","customerInvoice_OrderCreatedSuccessfullyMsg":"Pedido creado con éxito","customerInvoice_InvoiceSentSuccessfullyMsg":"Factura enviada con éxito al cliente","customerInvoice_ErrorMsgTryAgain":"Error... Inténtalo de nuevo","customerInvoice_Selected_Btn":"Seleccionado","customerInvoice_ProductTableQuantityUpdate_Btn":"Seleccione el producto","customerInvoice_OrderSubTotal":"Subtotal de Orden","cartSharing_Select_product_Title":"Seleccionar producto","delete_confirmation_text":"Está seguro ?","draftOrder_OrderNumber":"Número de orden","draftOrder_CustName":"Nombre del cliente","draftOrder_OrderDate":"Fecha de orden","draftOrder_SubTotal":"Subcontrol","draftOrder_Status":"Estado","draftOrder_Invoice":"Factura","draftOrder_DraftId":"Borrador de identificación","draftOrder_ShippingCost":"Costo de envío","draftOrder_Tax":"Impuesto","draftOrder_TotalPrice":"Precio total","draftOrder_Note":"Nota","draftOrder_Product":"Producto","draftOrder_ProductName":"nombre del producto","draftOrder_Size":"Tamaño","draftOrder_Quantity":"Cantidad","draftOrder_Price":"Precio","noDraftOrderProducts":"No hay detalles del producto de pedido de borrador disponibles.","noRefundOrderProduct":"No hay detalles del producto de pedido de reembolso disponibles.","loading":"Cargando...","dashboard_commissionOn_profitMargin":"Comisión sobre el margen de beneficio","dashboard_clientInvoice":"Factura de cliente","dashboard_affiliateLink":"Orden de afiliado","dashboard_returnCustomer":"Devolver cliente","dashboard_discountCoupon":"Cupón de descuento","dashboard_SharedCart":"Carrito compartido","dashboard_AdminTaggedOrders":"Pedido etiquetado por el administrador","dashboard_no_data":"Datos no disponibles","dashboard_sales_of_last_six_months":"Ventas de los últimos 6 meses","dashboard_sales_of_current_month":"Ventas del mes actual","addCustomer_ErrorMsgOnSubmitBtn":"Por favor ingrese un número de teléfono válido","login_welcome_Msg":"Bienvenido al equipo de ventas","login_title":"Acceso","login_email":"Identificación de correo","login_password":"Clave","emailValidation_ErrorMsg":"Ingrese la identificación de correo electrónico válida","login_newUser":"¿Nuevo Usuario?","login_SignUp":"Inscribirse","login_forgotPassword_link":"¿Has olvidado tu contraseña?","login_LogInBtn":"Iniciar sesión","login_sliderContent_1":"Representantes que colocan pedidos en nombre de los clientes","login_sliderContent_2":"Representante de conducción del tráfico para almacenar","login_sliderContent_3":"Productos de marketing de representantes utilizando plataformas de redes sociales","login_sliderContent_4":"El representante puede comprar a granel y obtener ganancias","login_sliderContent_5":"Representantes que colocan pedidos en nombre de los clientes","login_sliderContent_6":"Los representantes pueden visitar a los clientes en persona y crear pedidos","required_ErrorMsg":"Llene el campo requerido","signup_title":"Inscribirse","signup_BackTo_login":"Atrás para iniciar sesión","signup_firstName":"Primer nombre","signup_lastName":"Apellido","signup_BackBtn":"atrás","signup_NextBtn":"próximo","signup_phone_number":"Número de teléfono","signup_phone_number_Error":"Ingrese al menos 10 dígitos","signup_uploadPicture":"Imagen de perfil de carga","signup_fileSizeError":"El tamaño del archivo es mayor que 5MB","signup_filePath_lable":"Archivo seleccionado","signup_MediaTitle2":"Enlaces de redes sociales","signup_facebookHandle":"Mango de Facebook","signup_InstaHandle":"Mango de Instagram","signup_SaveBtn":"Guardar detalles","forgotPwd_title":"Has olvidado tu contraseña","forgotPwd_ResetBtn":"Restablecer la contraseña","forgotPwd_SuccessMsg":"Su solicitud de contraseña de reinicio es exitosa, hemos enviado la nueva contraseña a su ID de correo electrónico registrada.","customerInvoice_selectShippingCost":"Seleccionar costo de envío","customerInvoice_CalculatingShippingRates_Msg":"Calculador...","customerInvoice_AddShippingAddress_Msg":"Seleccione la dirección o agregue la dirección de envío","customerInvoice_PleaseSetAnyShippingAddressMsg":"Seleccione cualquier dirección de envío","customerInvoice_ShippingCostErrorMsg":"Agregue una nueva dirección de envío, porque la dirección no tiene información suficiente.","customerInvoice_CalculateShippingCost_Btn":"Calcular costo de envío","customerInvoice_ShippingCostAddOrNot_Msg":"¿Le gustaría agregar el costo de envío?","customerInvoice_ShippingCostAddOrNot_Yes":"Sí","customerInvoice_ShippingCostAddOrNot_No":"No","customerInvoice_ShippingCostErrorMsg_TryAgain":"Inténtalo de nuevo","dashboard_BannerMsg":"Los gráficos se actualizan cada 8 horas","yourSales__BannerMsg":"Los detalles del pedido se actualizan cada 5 minutos","customerInvoice_FirstNameErrorMsg":"Por favor, introduzca el nombre","customerInvoice_lastNameErrorMsg":"Por favor ingrese apellido","customerInvoice_Add1ErrorMsg":"Ingrese la línea de dirección 1","customerInvoice_CountryErrorMsg":"Por favor seleccione país","customerInvoice_StateErrorMsg":"Por favor seleccione estado","customerInvoice_CityErrorMsg":"Por favor ingrese la ciudad","customerInvoice_ZipErrorMsg":"Por favor ingrese el código postal","uploadImage":"Cargar imagen","dashboard_CardTitle1":"Comisión sobre todas las órdenes","dashboard_CardTitle3":"Comisión total","dashboard_TotalRevenue":"Los ingresos totales","dashboard_TotalAvg_Ticket_Size":"Tamaño del boleto AVG","dashboard_CardTitle4":"Ventas totales","profile_Change_Password":"Cambiar la contraseña","dashboard_Information_Message":"La comisión se rastrea solo para pedidos pagados","resetPassword_validation_Msg":"Este campo es obligatorio","resetPassword_validation_Msg2":"La contraseña debe contener un mínimo de 8 caracteres, 1 mayúscula, 1 minúscula, 1 dígito, etc.","resetPassword_validation_Msg3":"Confirmar que la contraseña debe coincidir con la nueva contraseña","dashbord_Msg_New":"Cómo funciona","dashbord_informationMsg":"Información","discount_couponErrorMsg":"El descuento máximo no está configurado. Póngase en contacto con el Sitio Admin.","discount_couponErrorMsg2":"La comisión no está configurada. Póngase en contacto con el Sitio Admin.","dashbord_profile_pic":"Cambiar foto de perfil","Performance_Details":"Detalles de rendimiento","Show_Performance_Details":"Mostrar detalles de rendimiento","Dashboard_Month":"Mes","Dashboard_Orders_Total":"Total de pedidos","Dashboard_Total_Sale":"Venta total","Dashboard_Commission":"Comisión","Dashboard_Bonus":"Prima","customerInvoice_EditOrder_NoAutoSelectedAddress":"Por favor seleccione producto.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Por favor, seleccione un costo de envío.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrito no actualizado, actualice y vuelva a intentarlo.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Por favor seleccione producto.","customerInvoice_CreatingDraft_Msg":"Borrador creando..","customerInvoice_DraftOrderBtn":"Proyecto de orden","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Borrador de orden creado exitosamente","productTable_error_AlertMsg":"La cantidad no puede ser 0 o menos, ingrese algún valor válido","productTable_error_AlertMsg2":"Por favor ingrese la cantidad","click_to_copy":"Haga clic para copiar","discount_code_copy_coupon":"Copiar cupón","createOrder_productSearchGuide":"¿No puede encontrar productos?","soldOut":"Agotado","InventoryNotTracked":"Inventario no rastreado","productStatus":"Estado del producto","makeSureInShopify":"Asegúrate en Shopify","products":"Productos","sectionTheProductStatusIs":"ssección, el estado del producto es","active":"Activo","productsMayBeSoldOutPleaseCheck":"Los productos pueden estar agotados, verifique y seleccione","yourSales_PaidOrders_PaidDate":"Fecha de pago del pedido","ordersLoading":"Cargando pedidos...","productsLoading":"Productos cargando...","leaveOnPageBtn":"Continuar","stayOnPageBtn":"Quédate en esta página","alertBoxTitle":"Crear página de pedido","alertMessage":"Los cambios no guardados se perderán. Puede guardar este pedido como borrador.","salesDetailsHeader_Location":"Ubicación","tab_CreateB2BOrder":"Pedido B2B","b2b_no_company_data_available":"No hay datos de la compañía disponibles","b2b_select_location":"Seleccionar ubicación","b2b_select_customer":"Seleccionar cliente","b2b_select_location_customer":"Seleccione el cliente/ubicación","b2b_SelectedCompanyDetails":"Detalles seleccionados de la empresa","b2b_no_location_data":"No hay ubicaciones disponibles","b2b_no_customer_data":"No hay datos de clientes disponibles","b2b_removeSelectedCustomer":"Eliminar","b2b_emailId":"Identificación de correo","b2b_customerName":"Nombre del cliente","b2b_companyName":"nombre de empresa","b2b_BillingAddress":"Dirección de Envio","b2b_ShippingAddress":"Dirección de envío","ST_CO_no_result_found_msg":"No se encontraron resultados para","ST_CO_SearchProducts_Label":"Buscar Productos","ST_CO_search":"Buscar","ST_Producttable_netQuantity":"Cantidad neta","ST_Producttable_subtotal":"Total parcial","ST_Producttable_wholesalePrice":"Precio al por mayor","ST_Producttable_retailPrice":"Precio minorista","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Producto","createOrder_select_product":"Seleccionar producto","createOrder_AddProduct":"Agregar producto","createOrder_AddBtn":"Agregar","CreateOrder_doneBtn":"Hecho","createOrder_productTable_NoProductsAdded":"No se agregan productos","productTable_clearCartBtn":"Vaciar carrito","b2b_companyTable_noMainContact":"No hay contacto principal disponible","ST_none":"Ninguno","CreateOrder_EnterPoNumber":"Ingrese el número PO","CreateOrder_chooseDateMsg":"Elija una fecha","CreateOrder_paymnetTerms":"Términos de pago","CreateOrder_TaxExemption":"Exención de impuestos","draftOrder_CompanyName":"nombre de empresa","CreateOrder_Company":"Compañía","Create_Order_TotalLocations":"Total de ubicaciones","Create_Order_MainContact":"Contacto principal","Create_Order_PaymentDueLater":"Pago adeudado más tarde","b2b_select_company":"Compañía seleccionada","yourSales_headerLocation":"Ubicación","salesDetailsHeader_Company":"Compañía","customerInvoice_PaymentPending":"Pago pendiente","customerInvoice_Checkout":"Verificar","customerInvoice_ProceedToCheckout":"Pasar por la caja","customerInvoice_CheckoutMsg":"Esto generará un borrador de orden, redirigiéndolo a la página de pago. En caso de que el proceso de pago no tenga éxito, puede encontrar este pedido en la pestaña Detalles del pedido de ventas bajo el borrador de pedidos.","customerInvoice_sendInvoiceToCustomer":"Enviar factura al cliente","customerInvoice_cancel":"Cancelar","Checkout_DoNotAskAgainMsg":"No preguntes de nuevo","RepCheckout_RedirectionMsg":"Redirigir para pagar","customerInvoice_CreatingDraftCheckout":"Draft Creación con el pago ...","customerInvoice_OrderType":"Método de venta","DoNotShowAgain":"No mostrar de nuevo","copyLinkSuccess":"Enlace copiado con éxito","affiliateLink_Confirmation_Msg1":"El seguimiento del pedido de enlaces de los afiliado funciona solo si el cliente hace clic en el","affiliateLinkConfirmationMsg2":"Añadir a la cesta","affiliateLink_Confirmation_Msg3":"knappen, det kommer inte att vara effektivt om kunden klickar på","affiliateLink_Confirmation_Msg4":"Comprar ahora","affiliateLink_Confirmation_Msg5":"Botón.","productsPerPage":"Productos por pagina","productTableCartClearButton":"Limpiar","affiliateLink_Confirmation_Note":"NOTA","myCustomers_searchByCustomerOrCompanyName":"Buscar por nombre de cliente o empresa","ST_Producttable_VolumePricing":"Precios por volumen","dashboard_B2BCompanyLocation":"Ubicación de la compañía","customer":"Cliente","PaidDate":"Fecha de pago","producttable_discounttypeHeader":"Tipo de Descuento","customerInvoice_DiscountOnSubtotal":"Descuento en el Subtotal","ST_Producttable_CartResponse":"El cliente no es elegible para comprar algunos de los productos en el carrito","ST_B2BPriceBreack_CloseBtn":"Cerca","B2B_QtyRule_Error_Msg":"Cantidad no válida agregada. Por favor verifique las reglas de cantidad.","Customer_Info_Title":"Por favor seleccione el país primero","Customer_Invalid_pinCode_Msg":"Código pin no válido","Edit_DraftOrderAlert_Msg":"Importante: El administrador ha aplicado precios mayoristas para este cliente.","Create_Order_DiscountDropdown_value1":"Porcentaje","Create_Order_DiscountDropdown_value2":"Monto fijo en dólares","Create_Order_DiscountType_Popup_Value1":"Cambiar tipo de descuento","Create_Order_DiscountType_PopUp_Value2":"Se eliminarán los descuentos ya aplicados.","B2B_PriceList_Increment_Msg":"Incrementos de ","B2B_PriceList_Minimum_Msg":"Mínimos de ","B2B_PriceList_Maximum_Msg":"Máximo de ","SpecialChar_Error_Msg":"Caracteres especiales como @,#,!,$,& no están permitidos en la contraseña","createOrder_ErrorMsgForQuantityLimit":"No puedes añadir una cantidad mayor que el stock disponible.","ClientInvoice":"Representante creado","AffiliateOrder":"Enlace de afiliado","CouponOrder":"Cupón de descuento","ReturnCustomerOrder":"Pedido del cliente","Tagcustomer":"Pedido del cliente","POSOrder":"POS","SharedCart":"Compartir carrito","RepOnCartPage":"Elección de representantes","AdminTaggedOrder":"Etiquetado manual","TaggedCompanyLocationOrder":"Pedido B2B","WholesaleOrder":"Factura mayorista","TeamManager":"Director del equipo","charsLeft":"char a la izquierda","showing":"Mostrando","customers":"clientes","exportCsv":"Exportar CSV","all":"Todos","paid":"Pagado","unpaid":"No pagado","draft":"Borrador","refunded":"Reembolsado","orderType":"Tipo de pedido","ShippingCost_AddressError":"El costo de envío para la dirección seleccionada no está configurado. Por favor, contacte al administrador.","ShippingCost_CustomerAddressAndCartProductError":"La dirección del cliente y los productos en el carrito son obligatorios para calcular el costo de envío.","ContactCard_Info_Msg":"La tarjeta de contacto hace que sus enlaces de afiliado sean más atractivos. Cuando un cliente utiliza un enlace de afiliado, puede ver su tarjeta de contacto en el sitio web, lo que proporciona una información más detallada. experiencia de compra personalizada. Esta tarjeta se puede personalizar con una foto de perfil y un mensaje para tus clientes.","contact_Cart_Heading":"Tarjeta de contacto","Affiliate_Link_Info_Msg":"Comparta su enlace de afiliado con los clientes. Cualquier pedido realizado utilizando su enlace de afiliado se le atribuirá","Contact_Card_Bio_Save_Success_Msg":"Bio guardada exitosamente","Affiliate_Add_ProductInfo_Msg":"Agregue productos para los cuales le gustaría compartir un enlace de afiliado","ShareCart_UserGuide_Msg1":"Cree un enlace de carrito para compartir, precargado con productos seleccionados adaptados a las preferencias de su cliente. El cliente puede utilizar el enlace, revisar los artículos del carrito y continuar directamente","ShareCart_UserGuide_Msg2":"para pagar. Los pedidos realizados mediante el enlace de su carrito se le atribuirán.","ShareCart_ToltipTitle":"Quitar productos del carrito","Delete_Cart_Confirmation":"¿Estás seguro de que quieres eliminar el carrito?","No_Share_Cart_Added1":"No se ha creado ningún enlace de carrito hasta ahora.","No_Share_Cart_Added2":"Crea un carrito y comparte su enlace directo con tus clientes","ClearCart_Conformation_Msg":"¿Estás seguro de que deseas eliminar todos los productos del carrito?","Edit_Billing_Address":"Editar dirección de facturación","Edit_Shipping_Address":"Editar dirección de envío","New_Customer_Select_Msg":"Crear un nuevo cliente","CreateOrder_Manage_Heading":"Administrar","RemoveCustomer_Msg":"Eliminar cliente","Customer_Address_Apartment":"Apartamento, suite, etc.","Address_Enter_Msg":"Introduzca la dirección","Address_Not_Found_Error_Msg":"La dirección del cliente y los productos en el carrito son obligatorios para crear un pedido.","Load_More_Btn":"Cargar más","Beta_Version_msg1":"Esta característica se encuentra actualmente en la versión Beta. Si tienes algún problema","Beta_Version_msg2":"por favor, póngase en contacto con el servicio de asistencia.","Heading_Product_Select":"Seleccionar productos","Customer_FirstName":"Nombre de pila","Customer_lastName":"Apellido","Customer_Resion":"País/región","Customer_pinCode":"código PIN","Customer_phone":"Teléfono","applyDisconutCode_atCheckout":"Permitir a los clientes aplicar cupones de descuento en el pago"}'
        ),
        Ot = JSON.parse(
          '{"dashboard_title":"TABLEAU DE BORD","dashboard_welcomeMsg":"Bienvenue à","dashboard_morningMsg":"Bonjour","dashboard_afternoonMsg":"Bonne après-midi","dashboard_eveningMsg":"Bonsoir","dashboard_subTitle1":"MOIS EN COURS","dashboard_block1Heading":"FACTURE CLIENT","dashboard_block1Header1":"GAINS","dashboard_block1Header2":"FACTURE ENVOYÉE","dashboard_block1Header3":"FACTURE PAYEE","dashboard_block2Heading":"COMMANDES EN GROS","dashboard_block2Header1":"GAINS","dashboard_block2Header2":"FACTURE ENVOYÉE","dashboard_block2Header3":"FACTURE PAYEE","dashboard_block3Heading":"COMMANDES AFFILIÉES","dashboard_block3Header1":"GAINS","dashboard_block3Header2":"COMMANDES PAYÉES","dashboard_block4Heading":"COUPON DE RÉDUCTION","dashboard_block4Header1":"GAINS","dashboard_block4Header2":"COMMANDES PAYÉES","dashboard_block5Heading":"COMMISSION CLIENTÈLE","dashboard_block5Header1":"COMMISSION","dashboard_block5Header2":"ORDERS","dashboard_block6Heading":"COMMISSION DE CHEF D\'ÉQUIPE","dashboard_block6Header1":"COMMISSION","dashboard_block7Heading":"COMMISSION POS","dashboard_block7Header1":"COMMISSION","dashboard_block7Header2":"ORDERS","dashboard_tbl1column1":"Mois","dashboard_tbl1column2":"Commandes sur facture client","dashboard_tbl1column3":"Commission de facturation client","dashboard_tbl1column4":"Commandes en gros","dashboard_tbl1column5":"Achat en gros total","dashboard_tbl1column6":"Commandes d\'affiliation","dashboard_tbl1column7":"Commission d\'affiliation","dashboard_tbl1column8":"Commandes avec code coupon","dashboard_tbl1column9":"Commission du code de coupon","dashboard_tbl1column10":"Commandes clients","dashboard_tbl1column11":"Commission client","dashboard_tbl1column12":"Commandes POS","dashboard_tbl1column13":"Commission POS","dashboar_cardHeading1":"Commande totale","dashboar_cardHeading2":"Commission","dashboar_cardHeading3":"Ventes","dashboar_cardHeading4":"Prime","dashboard_graphHeading1":"Performance des ventes des six derniers mois","dashboard_graphHeading2":"Analyser l\'ordre et la commission de Feature Wise pour le mois en cours","Graph_Sales_noorderstitle":"pas d\'ordre à montrer","Graph_SalesRepCommission_nocommissiontitle":"Aucune donnée de commission à afficher","Graph_SalesRepOrders_title":"ORDERS","Graph_SalesRep_XAxisTitle_ForMonth":"6 mois","Graph_SalesRepOrders_YAxisTitle":"Orders","Graph_SalesRepSales_title":"VENTES","Graph_SalesRepCommission_title":"COMMISSION","Graph_SalesRepCommissions_YAxisTitle":"Commission","Graph_FeatureWiseOrder_title":"Commandes vs fonctionnalités","Graph_featureWiseCommission_title":"Commission vs fonctionnalité","Graph_FeatureWiseOrder_XAxisTitle":"Fonctionnalité","Graph_FeatureWiseOrder_YAxisTitle":"Ordres","Graph_FeatureWiseCommission_title":"COMMISSION","Graph_FeatureWiseCommission_YAxisTitle":"Commission","customerInvoice_title":"Créer une commande","customerInvoice_button":"Arrière","customerInvoice_noclientorderMsg":"Aucune commande de facture client","customerInvoice_button1":"Voir les commandes précédentes","customerInvoice_contentHeading1":"Remise et commission sur","customerInvoice_table1column1":"type de produit","customerInvoice_table1column2":"Commission","customerInvoice_table1column3":"Nom de la remise","customerInvoice_table1column4":"Remise","customerInvoice_contentHeading2":"Ajoutez les détails du client et sélectionnez les produits pour envoyer la facture","customerInvoice_contentHeading2Title1":"Saisir/rechercher un client","customerInvoice_title1Placeholder":"Saisir/rechercher un client","customerInvoice_contentHeading2Title2":"Entrez l\'ID de courriel du client","customerInvoice_title2Placeholder":"Adresse e-mail","customerInvoice_contentHeading2Title3":"Saisir les notes de commande","customerInvoice_contentHeading2Title4":"Adresse du client","customerInvoice_contentHeading2Title5":"Numéro de mobile du client","customerInvoice_contentHeading2Title6":"Remarque client","customerInvoice_contentHeading2Title7":"Nom de l\'entreprise cliente","customerInvoice_title7Placeholder":"Nom de la compagnie","customerInvoice_Placeholder_contentHeading2Title6":"Noter","customerInvoice_Placeholder_contentHeading2Title5":"Numéro de portable","customerInvoice_Placeholder_contentHeading2Title4":"Adresse de livraison","customerInvoice_title3Placeholder":"Notes d\'ordre","customerInvoice_table2Column1":"Image","customerInvoice_table2Column2":"Ajouter la quantité","customerInvoice_table2Column3":"Titre","customerInvoice_table2Column4":"Titre de la variante","customerInvoice_ProductTableColumnPrice":"Prix","customerInvoice_ProductTableColumnWholeSalePrice":"Prix ​​de gros","customerInvoice_button2":"Créer une facture","customerInvoice_ProductTableColumnProduct":"Produit","customerInvoice_table3Column2":"Nom du produit","customerInvoice_table3Column3":"Taille","customerInvoice_ProductTableColumnQuantity":"Quantité","customerInvoice_table3Column5":"Prix ​​de l\'article","customerInvoice_table3Column6":"Prix ​​total","customerInvoice_table3Column7":"Prix ​​réduit pour le client","customerInvoice_table3Column8":"Commission SalesRep","customerInvoice_table3Column9":"DiscountType","customerInvoice_repproInvite":"Cochez la case pour envoyer une invitation professionnelle","customerInvoice_customerOrder_error1":"tous les champs client sont obligatoires. Veuillez saisir l\'adresse e-mail et le prénom du client","customerInvoice_productAddedMsg":"Produit ajouté","customerInvoice_AlertErrorMsg":"Erreur..Veuillez contacter le support !","cartSharing_Select_product_Title":"Sélectionner un produit","wholesaleOrder_title":"Commande en gros","wholesaleOrder_contentHeading1":"Vous pouvez acheter des produits à des prix de gros spéciaux","wholesaleOrder_contentHeading2":"Remise sur","wholesaleOrder_column1":"Nom SalesRep","wholesaleOrder_column2":"Rabais","wholesaleOrder_searchtxtPlaceholder":"Rechercher un produit","wholesaleOrder_table1Column1":"Image","wholesaleOrder_table1Column2":"Ajouter la quantité","wholesaleOrder_table1Column3":"Titre","wholesaleOrder_table1Column4":"Titre de la variante","wholesaleOrder_table1Column5":"prix","wholesaleOrder_button":"départ","wholesaleOrder_Order_btn":"Afficher/masquer les prix en volume","wholesaleOrder_contentHeading3":"Prix ​​total","wholesaleOrder_contentHeading4":"Votre prix réduit","wholesaleOrder_table2Column1":"Produit","wholesaleOrder_table2Column2":"Nom du produit","wholesaleOrder_table2Column3":"Taille","wholesaleOrder_table2Column4":"Quantité","wholesaleOrder_table2Column5":"Prix ​​de l\'article","wholesaleOrder_table2Column6":"Prix ​​total","wholesaleOrder_table2Column7":"Votre prix réduit","affiliateLink_title":"Votre prix réduit","affiliate_product_link":"Lien de produit","affiliateLink_input_error_msg":"Le champ de texte du lien est obligatoire et ne doit pas contenir d\'espaces.","affiliateLink_contentHeading1":"Partagez votre lien d\'affiliation sur les réseaux sociaux et par e-mail. Vous recevrez une commission d\'affiliation pour chaque commande de votre lien d\'affiliation","affiliateLink_contentHeading2":"Votre lien d\'affiliation","affiliateLink_contentHeading3":"Commission sur","affiliateLink_content_Message1":"Recherchez des produits et partagez le lien des produits individuels avec vos clients.","affiliateLink_noaffiliateorderMsg":"Aucune commande d\'affiliation","affiliateLink_column1":"Nom SalesRep","affiliateLink_column2":"Commission","affiliateLink_searchtxtPlaceholder":"Rechercher un produit","affiliateLink_searchColumn1":"Produit","affiliateLink_searchColumn2":"Titre du produit","affiliateLink_searchColumn3":"Prix","affiliateLink_searchColumn4":"Commission","affiliateLink_searchColumn5":"Lien d\'affiliation","affiliateLink_searchColumn7":"Copier le lien","affiliateLink_searchColumn8":"Copié","affiliateLink_backbtn":"Arrière","affiliateLink_card_Title":"Carte de contact et lien d\'affiliation","cartSharing_title":"Partage de panier","cartSharing_CreateCartInformation_Text":"Pour créer un panier partageable personnalisé, ajoutez des produits au panier à partir de la vitrine. Ces produits seront affichés sur cette page","cartSharing_content2Placeholder":"Nom du panier","cartSharing_table2Column2":"Nom du produit","cartSharing_table2Column3":"Taille","cartSharing_table2Column6":"Prix ​​total","cartSharing_SharedCartLinkTableColumnCartName":"Nom du panier","cartSharing_SharedCartLinkTableColumnLink":"Lien","cartSharing_SharedCartLinkTableColumnCartLink":"Lien de panier partageable","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copier le lien du panier","cartSharing_SharedCartLink_Other":"Autre","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Supprimer le lien du panier","cartSharing_EnterCartName_Label":"Entrez le nom du panier","cartSharing_ProductTableColumnProduct":"Produit","cartSharing_ProductTableColumnQuantity":"Quantité","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Prix ​​de l\'article","cartSharing_CartCreating_Msg":"Créer...","cartSharing_Copied_Msg":"Copie!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Aucun lien à afficher","cartSharing_CartCreatedSuccessfully_Msg":"Votre nouveau panier a été créé avec succès","cartSharing_CartCreateError_Msg":"Erreur..veuillez réessayer","cartSharing_AlertError_Msg":"Erreur..Veuillez contacter le support !","cartSharing_CopyCartLink_Msg":"Copier le lien du panier","cartSharing_DeleteCartLink_Msg":"Supprimer le lien du panier","cartSharing_DeleteConfirmation_Msg":"Êtes-vous sûr ?","cartSharing_ProductTableEmpty_Msg":"Produit non disponible","cartSharing_CreateCart_Btn":"Créer un panier","cartSharing_ProductTableQuantityUpdate_Btn":"Veuillez sélectionner le produit","discountCoupon_titleOne":"Coupon de réduction","discountCoupon_contentHeading1":"Partagez le code de coupon de réduction avec vos clients et chaque fois que votre coupon est utilisé, vous obtenez une commission.","discountCoupon_contentHeading2":"Votre code de coupon est","discountCoupon_contentHeading3":"Montant de la remise","discountCoupon_contentHeading4":"Commission","discountCoupon_contentHeading4PlaceHolder1":"Hé, utilisez mon code de réduction","discountCoupon_contentHeading4PlaceHolder2":"et obtenez des produits à prix réduit","discountCoupon_button1":"Copier le texte","cartSharing_copiedButtonText":"Copié","discountCoupon_titleTwo":"Créez des coupons de réduction à usage unique pour les clients","discountCoupon_button2":"Voir les coupons","discountCoupon_contentHeading5":"Remise maximale autorisée","discountCoupon_contentHeading6":"Commision","discountCoupon_contentHeading7":"Entrer le code promotionnel","discountCoupon_contentHeading7PlaceHolder":"Veuillez entrer le code de coupon","discountCoupon_contentHeading8":"Entrez la remise","discountCoupon_contentHeading8PlaceHolder":"La remise ne doit pas être supérieure à la remise maximale.","discountCoupon_button3":"Créer un coupon","discountCoupon_coupon_error1":"Veuillez saisir le code de réduction et la réduction","yourBio_title":"Votre carte de contact","yourBio_content1":"Télécharger le profil","yourBio_button1":"Choisir le fichier","yourBio_button1PlaceHolder":"Aucun fichier choisi","yourBio_error_image_size":"La taille de l\'image est trop grande, veuillez télécharger une image d\'une taille inférieure à 5 Mo. Veuillez réessayer.","yourBio_button2":"Télécharger","yourBio_content2":"Entrez un mot personnalisé pour créer votre lien d\'affiliation unique","yourBio_content2PlaceHolder":"créez votre lien d\'affiliation unique","yourBio_content4":"Lorsque votre lien sera utilisé, votre carte de contact apparaîtra sur le site Web","yourBio_content3":"Entrez votre carte de contact","yourBio_content3PlaceHolder":"Saisissez 100 mots","yourBio_button3":"Sauvegarder","yourBio_button4":"enregistré","yourBio_error_link":"Ce lien unique peut être pris. Essayez avec un lien unique différent.","yourBio_Linksuccessmsg":"Lien unique enregistré avec succès.","team_title1":"Ajouter SalesRep","team_content1":"Entrez votre e-mail","team_content1PlaceHolder":"Adresse e-mail","team_emailerrorMsg":"Veuillez saisir votre email","team_content2":"Entrez votre prénom","team_content2PlaceHolder":"Prénom","team_fnameerrorMsg":"Veuillez entrer le prénom","team_content3":"Entrer le nom de famille","team_content3PlaceHolder":"Nom de famille","team_button1":"Ajouter","team_successmsg":"Le représentant a été ajouté avec succès. Il recevra ses identifiants de connexion à l\'adresse e-mail soumise.","team_errorsmsg":"Erreur lors de l\'ajout. Cet e-mail d\'utilisateur peut déjà avoir un compte sur la boutique","team_title2":"Détails de l\'équipe","team_content4":"Page d\'inscription","team_NoTeamDetailsMsg":"Pas de détails sur l\'équipe","team_content5":"Sélectionnez SalesRep:","team_tableTitle":"DÉTAILS DE LA COMMANDE DE DEUX DERNIERS MOIS","team_column1":"Numéro de commande","team_column2":"Date de commande","team_column3":"Nom du client","team_column4":"Représentant commercial","team_column5":"Total","team_column6":"Commission du représentant des ventes","team_column7":"Commission des chefs d\'équipe","team_column8":"Méthode de vente","addCustomer_title":"Ajouter un client","addCustomer_content1":"Entrez le prénom du client","addCustomer_txt1Placeholder":"Prénom","addCustomer_content2":"Entrez le nom du client","addCustomer_content2Placeholder":"Nom de famille","addCustomer_content3":"Entrez l\'ID de courriel du client","addCustomer_content3Placeholder":"Adresse e-mail","addCustomer_content4":"Remarque","addCustomer_content4Placeholder":"Remarque","addCustomer_customerAddress":"Adresse personnelle","addCustomer_customerCity":"Ville","addCustomer_customerCityPlaceholder":"Prénom","addCustomer_customerCountry":"Pays","addCustomer_customerState":"Etat","addCustomer_customerZipCode":"Code postal","addCustomer_companyName":"Nom de l\'entreprise","addCustomer_companyAddress":"Adresse de la société","addCustomer_companyCity":"Ville","addCustomer_companyCountry":"Pays","addCustomer_companyState":"Etat","addCustomer_companyZipCode":"Code postal","addCustomer_button":"sauver","addCustomer_leadsuccessmsg":"Le client a été ajouté avec succès","addCustomer_leadErrrorMsg":"Erreur lors de l\'enregistrement des détails","addCustomer_leadEmptyErrrorMsg":"Veuillez remplir les champs requis","addCustomer_leadsuccessmsg2":"Le client a été créé et associé avec succès à un commercial","addCustomer_leadErrrorMsg2":"Ce client est déjà associé à un représentant","myCustomers_title":"Vos clients","myCustomers_table1Column1":"Nom","myCustomers_table1Column2":"Nom de l\'entreprise","myCustomers_table1Column3":"Email","myCustomers_table1Column4":"Commandes","myCustomers_table1Column5":"Total dépensé","myCustomers_table2Title":"DÉTAILS DU CLIENT","myCustomers_table3Title":"PROJET DE DÉTAILS DE LA COMMANDE","myCustomers_table3Column1":"Nom du produit","myCustomers_table3Column2":"Taille","myCustomers_table3Column3":"Quantité","myCustomers_table3Column4":"Prix","myCustomers_table3Column5":"Statut","myCustomers_table3Column6":"Total","myCustomers_table2Row1":"Nom","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Adresse","myCustomers_table2Row4":"Nom de l\'entreprise","myCustomers_table2Row5":"Notes des clients","myCustomers_table2Row6":"Total dépensé (sous-total + taxes)","myCustomers_table2Row7":"Nombre de commandes","myCustomers_table2Row8":"Mots clés","myCustomers_radioButton0":"Afficher tous les clients","myCustomers_radioButton1":"Recherche par nom","myCustomers_radioButton2":"Recherche par entreprise","myCustomers_radioButtonError1":"Veuillez sélectionner le type de recherche et saisir la valeur à rechercher","myCustomers_radioButtonError2":"Veuillez saisir une valeur à rechercher","myCustomers_radioButtonError3":"Veuillez sélectionner le type de recherche","myCustomers_searchButton":"Rechercher","myCustomers_Placeholder1":"Tapez le nom du client ou le nom de l\'entreprise à rechercher","myCustomers_NoOrdersError":"Aucune commande","myCustomer_no_salesRep_details":"Aucun détail des ventes disponibles.","myCustomer_select_customer_country":"Veuillez sélectionner le pays client","myCustomer_company_country":"Pays de compagnie","myCustomer_company_state":"État de l\'entreprise","myCustomer_select_company_country":"Veuillez sélectionner le pays de l\'entreprise","yourSales_SalesOrderDetailsTitle":"Détails de la commande client","yourSales_title":"Détails de la commande des 2 derniers mois","yourSales_table1Column1":"Numéro de commande","yourSales_table1Column2":"Date de commande","yourSales_table1Column3":"Nom du client","yourSales_table1Column4":"Total","yourSales_table1Column5":"Commission","yourSales_table1Column6":"Type de commission","yourSales_table1Column7":"La facture d impressione","printOrderInvoice_btn":"Impression","yourSales_tableTitle":"DÉTAILS DU PRODUIT","yourSalesDraft_tableTitle":"PROJET DE DÉTAILS DE LA COMMANDE","yourSales_column1":"Produit","yourSales_column2":"Titre","yourSales_column3":"Quantité","yourSales_column4":"Prix ​​de l\'article","yourSales_column5":"Numéro de suivi","yourSales_column6":"Date d\'expédition","yourSales_column7":"Prix ​​total","yourSales_content1":"Total","yourSales_content2":"Impôt","yourSales_content3":"Frais de port","yourSales_content4":"Total","yourSales_content5":"Remarque","yourSales_tabHeading1":"Commandes payées","yourSales_tabHeading4":"Commandes en attente","yourSales_tabHeading2":"Projets d\'ordres","myOrders_title":"Détails de mes commandes","myOrdersDetails_Message":"Commandes passées pour vous-même","myOrders_table1Column1":"Numéro de commande","myOrders_table1Column2":"Date de commande","myOrders_table1Column3":"Nom du client","myOrders_table1Column4":"Paiement","myOrders_table1Column5":"Accomplissement","myOrders_table1Column6":"Total","myOrders_tableTitle":"DÉTAILS DU PRODUIT","myOrders_table2Column1":"Produit","myOrders_table2Column2":"Titre","myOrders_table2Column3":"Quantité","myOrders_table2Column4":"Prix ​​de l\'article","myOrders_table2Column5":"Numéro de suivi","myOrders_table2Column6":"Date d\'expédition","myOrders_table2Column7":"Prix ​​total","myOrders_content1":"Total","myOrders_content2":"Impôt","myOrders_content3":"Frais de port","myOrders_content4":"Total","myOrders_content5":"Remarque","myOrders_content6":"ID de brouillon","tab_Dashboard":"Tableau de bord","dashbord_Tab":"Maison","tab_CustomerInvoice":"Créer une commande","tab3_WholesaleOrder":"Commande en gros","tab_AffiliateLink":"Lien d\'affiliation","tab_CartSharing":"Partage de panier","tab_DiscountCoupon":"Coupon de réduction","tab7_YourBio":"Votre carte de contact","tab8_Team":"Équipe","tab9_AddCustomer":"Ajouter un client","tab_MyCustomers":"Mes clients","tab_YourSalesOrderDetails":"Détails de votre commande client","tab12_MyOrders":"Détails de mes commandes","tab13_Logout":"Se déconnecter","signUp_title":"Inscription représentant des ventes","signUp_subTitle":"Veuillez remplir ce formulaire pour vous inscrire en tant que représentant commercial et accéder à toutes les fonctionnalités de l\'équipe commerciale","signUp_content1":"Email","signUp_content2":"Prénom","signUp_content3":"Nom de famille","signUp_content4":"Numéro de téléphone","signUp_content5":"Poignée Facebook","signUp_content6":"Poignée Twitter","signUp_content7":"Poignée Instagram","signUp_content8":"Télécharger une photo de profil","signUp_socialmedialable1":"Liens de médias sociaux ","signUp_socialmedialable2":"optionnel","signUp_uploadBtn":"Choisir le fichier","signUp_uploadBtnPlaceHolder":"Aucun fichier choisi","signUp_button3":"Enregistrement des détails...","signUp_welcomemsg1":"Bonjour","signUp_welcomemsg2":"inscrivez un représentant des ventes et obtenez une commission sur les ventes effectuées par les représentants sous vous","signUp_emailerror":"Veuillez saisir votre email","signUp_Fnameerror":"Veuillez entrer le prénom","signUp_lnameerror":"Veuillez saisir le nom de famille ","signUp_phnumbererror":"Veuillez entrer le numéro de téléphone ","signUp_successmsg":"Votre demande d\'inscription a été soumise avec succès. Vous recevrez les détails de connexion du compte par email une fois que l\'administrateur aura approuvé votre demande. Pour plus d\'informations, veuillez contacter l\'administrateur du magasin.","signUp_errorsmsg":"Erreur lors de l\'enregistrement des détails. Cet e-mail d\'utilisateur peut déjà avoir un compte sur la boutique.","signUp_RepExistErrorMsg":"Cet e-mail est déjà enregistré en tant que représentant.","addingRep_selectRepsLabel1":"Qui t\'a aidé?","addingRep_NoSalesRep":"Aucun représentant commercial","addingRep_selectRepsLabel2":"Veuillez sélectionner un élément dans la liste.","addingRep_successMsg":"Ajout de repId à la note du panier","wholesaleOrder_WholesaleDiscountTableColumn1":"Titre du produit","wholesaleOrder_WholesaleDiscountTableColumn2":"Réduction","customerInvoice_ViewClientOrdersColumn1":"Nom du client","customerInvoice_ViewClientOrdersColumn2":"Titre du produit","customerInvoice_ViewClientOrdersColumn3":"Prix subtotal","customerInvoice_ViewClientOrdersColumn4":"Statut","customerInvoice_ViewClientOrdersColumn5":"Facture","salesRep_order_errorMsg":"Erreur lors de la création de votre commande. S’il vous plaît contacter le soutien","salesRep_order_successMsg":"Commandez la facture créée avec succès!  La facture a été envoyée par courriel au client!","salesRep_order_errorMsg2":"Erreur lors de la création de votre commande. S’il vous plaît contacter le soutien","customedraft_btn1":"Créer une nouvelle facture","customedraft_btn2":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","customedraft_btn3":"Création de l’ordre...","customedraft_btn4":"Créer une nouvelle facture","salesRep_order_NoProductSelected":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","productnotselectforcartsharingtxt1":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","discountCoupons_tblColumn1":"Coupon Code","discountCoupons_tblColumn2":"Réduction sur coupon","discountCoupons_tblColumn3":"Supprimer le code coupon","discountedPriceLabel":"Votre prix réduit:","couponCodeNotSet":"Code coupon non défini","dashboard_subTitle2":"Cycle du mois en cours: 5ème - 4ème","affiliatelink_commissiononlbl":"Produit","displaycommission_lbl1":"Type de produit","displaycommission_lbl2":"Représentant","displaycommission_lbl3":"Remise basée sur la quantité","discountcommissiononlbl1":"Niveaux de réduction des clients","clientInvoiceCommissionTablecolumn1":"Type de produit","clientInvoiceCommissionTablecolumn2":"Commission","clientInvoiceCommissionTablecolumn3":"Titre du produit","clientInvoiceCommissionTablecolumn4":"Nom SalesRep","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nom du produit","clientInvoiceQuantityBaseDiscountTablecolumn2":"Réduction","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantité","affiliateCartProdtableColumn1":"Produit","affiliateCartProdtableColumn2":"Titre du produit","affiliateCartProdtableColumn3":"Prix","affiliateCartProdtableColumn4":"Commission","affiliateCartProdtableColumn5":"Lien d’affiliation","affiliateCartProdtableColumn6":"Partager le lien","productnotselectforcartsharinglbl1":"S’il vous plaît entrer le nom du chariot","productnotselectforcartsharinglbl2":"Aucun produit sélectionné. S’il vous plaît sélectionner des produits et essayer à nouveau.","productnotselectforcartsharinglbl3":"Attendez pendant le traitement ...","showSharedCartProductcolumn1":"Lien chariot","showSharedCartProductcolumn3":"Retirer le chariot","onSuccessInvoiceSuccessMsg":"Facture envoyée avec succès","onSuccessInvoiceFailedMsg":"L’envoi de factures a échoué","sendInvoice_successMsg":"Facture envoyée avec succès","deleteInvoice_successMsg":"Facture supprimée avec succès","deleteInvoice_FailedMsg":"Supprimer la facture a échoué","deleteInvoice_btnlbl":"Suppression de la facture","deleteSharedCartLink_successMsg":"Lien supprimé avec succès","deleteSharedCartLink_FailedMsg":"Erreur dans la suppression du lien. S’ll vous plaît, réessaiez.","deleteSharedCartLink_btnlbl":"Suppression du lien","viewInvoiceOrders_btntxt1":"Obtenir...","viewInvoiceOrders_btntxt2":"Afficher les commandes précédentes","createCoupon_btnlbl1":"Création de Coupon..","createCoupon_btnlbl2":"Coupon créé","deleteCoupon_successMsg":"Coupon supprimé","deleteCoupon_FailedMsg":"Suppression de coupons échoués","deleteCoupon_btnlbl":"Suppression...","viewProductModelColumn1":"Produit","viewProductModelColumn2":"Titre","viewProductModelColumn3":"Quantité","viewProductModelColumn4":"Montant remboursé","viewProductModelColumn5":"Prix de l’article","viewProductModelColumn6":"discounted Price","viewProductModelColumn7":"Numéro de suivi","viewProductModelColumn8":"Date du navire","viewProductModelColumn9":"Prix total","showSharedCartProducts_column2":"Image","showSharedCartProducts_column3":"Ajouter la quantité","showSharedCartProducts_column4":"Titre","showSharedCartProducts_column5":"Titre de variante","showSharedCartProducts_column6":"Prix","viewClientOrders_btn1":"Afficher","viewClientOrders_btn2":"Envoyer","viewClientOrders_btn3":"Supprimer","showCouponTable_txt1":"Obtenir ...","showCoupon_btn2":"Voir les coupons","showCoupon_btn1":"Copié","affliateOrder_column1":"Nom du client","affliateOrder_column2":"Email client","affliateOrder_column3":"Titre du produit","affliateOrder_column4":"Date de commande","affliateOrder_column5":"Total","affliateOrder_column6":"Commission","affliateOrder_btn1":"Obtenir ...","affliateOrder_btn2":"Afficher les commandes des affiliés","affliateOrder_btn3":"Afficher les commandes des affiliés","yourBio_btn1":"sauver","yourBio_btn2":"sauver","yourBio_Uploadbtn1":"Téléchargement...","yourBio_Uploadbtn2":"Téléchargé","yourBio_UploadbtnError":"Désolé réessayez","yourBio_Savebtn":"Économie..","team_txt1":"Économie..","team_txt2":"sauver","viewRepClientOrdersDetails_column1":"Numéro de commande","viewRepClientOrdersDetails_column2":"Date de commande","viewRepClientOrdersDetails_column3":"Total","viewRepClientOrdersDetails_column4":"Statut","viewRepClientOrdersDetails_column5":"détails du produit","addSalesRep_txt1":"Ajouter SalesRep","addSalesRep_txt2":"Ajout de SalesRep ...","discountCoupons_header":"Coupon de réduction une fois","discountCoupons_nodiscountcoupon":"Vous n’avez pas créé de coupon de réduction","discountCoupons_deleteBtn":"Supprimer","discountCoupons_BackBtn":"Précédent","customerInvoice_selectcustomererror":"Veuillez sélectionner le client, puis ajouter le produit","createOrderFromCartPage_selectCustomersLabel":"SÉLECTIONNER LE CLIENT","createOrderFromCartPage_selectCustomerAddressLabel":"ADRESSE DE LIVRAISON","createOrderFromCartPage_selectCustomersLabelForDropDown":" Sélectionnez le client","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Sélectionnez l\'adresse","createOrderFromCartPage_successMsg":"Facture de commande créée avec succès ! La facture a été envoyée par e-mail au client !","createOrderFromCartPage_AddNewAddressTitle":"AJOUTER UNE NOUVELLE ADRESSE","createOrderFromCartPage_draftOrderButton":"CRÉER UN BROUILLON DE COMMANDE","createOrderFromCartPage_OrderButton":"CRÉER UNE COMMANDE","createOrderFromCartPage_draftOrderButtonText2":"CRÉATION DE COMMANDE...","createOrderFromCartPage_selectShippingCostTitle":"FRAIS DE PORT","createOrderFromCartPage_Address_errorMsg4":"Un problème est survenu lors du calcul de vos tarifs d\'expédition.","createOrderFromCartPage_Address_errorMsg5":"Une erreur s\'est produite. Veuillez réessayer.","yourSales_tabHeading3":"Rembourser les commandes","refundOrders_column1":"Identifiant de remboursement","refundOrders_column2":"Date de commande","refundOrders_column3":"Numéro de commande","refundOrders_column4":"Nom de la commande","refundOrders_column5":"Commission","refundOrders_column6":"Commission de chef d\'équipe","refundOrders_column7":"Identifiant du responsable d\'équipe","refundOrders_column8":"Sous-total des remboursements","refundOrders_column9":"Statut de la commande","refundOrders_column10":"Méthode de vente","refundOrderNumber_title":"Détails de la commande de remboursement","refundOrderNumber_column1":"Nom","refundOrderNumber_column2":"Date","refundOrderNumber_column3":"Quantité","refundOrderNumber_column4":"Prix ​​bas","refundOrderNumber_column5":"Total","tableDataError":"Aucune commande de remboursement","dashboard_subTitle3":"Détails des commissions","dashboard_cardHeading5_1":"Commission sur","dashboard_cardHeading5_2":"Vous obtiendrez un","dashboard_cardHeading5_3":"commission sur toutes les commandes.","Profit_Margin":"Marge bénéficiaire","Product_Type":"type de produit","Sales_Rep":"Représentant commercial","show_commission_list":"Afficher la liste des commissions","commission_list":"Liste des commissions","no_customers_to_show":"Aucun client à afficher","no_sales_to_show":"Aucune vente à afficher","no_draft_to_show":"Aucun brouillon à afficher","no_refund_to_show":"Aucun remboursement à afficher","no_orders_to_show":"Aucune commande à afficher","customerInvoice_ViewClientOrdersColumn6":"Numéro de commande","customerInvoice_ViewClientOrdersColumn7":"Date de commande","Error_commissions_NotUpdated":"Les commissions ne sont pas mises à jour","sales_chart_msg1":"Nous avons besoin de données...","sales_chart_msg2":"Il semble que nous n\'ayons pas encore de données à afficher.","page_refresh_msg":"cliquez pour rafraichir","variant_title":"Titre de la variante","line_items_properties":"Propriétés","customer_country":"Pays du client","customer_state":"État du client","company_country":"Pays de la société","company_state":"État de la société","client_orders":"Commandes clients","no_product_details":"Aucun détail de produit à afficher","submit_btn_text":"Soumettre","submitting_btn_text":"Soumission","submitted_btn_text":"Soumis","email_id_validation_errmsg":"Veuillez saisir un identifiant de messagerie valide","customerInvoice_add_more_details":"Ajouter plus de détails","customerInvoice_add_shipping_address":"Ajouter une nouvelle adresse d\'expédition","customerInvoice_HideDetails":"Cacher les détails","customerInvoice_HideAddress":"Masquer l\'adresse de livraison","customerInvoice_enterFirstName":"Entrez votre prénom","customerInvoice_enterFirstNamePlaceholder":"Prénom","customerInvoice_enterLastName":"Entrer le nom de famille","customerInvoice_enterLastNamePlaceholder":"Nom de famille","customerInvoice_enterAddress1":"Entrer la ligne d\'adresse 1","customerInvoice_enterAddress1Placeholder":"Adresse Ligne 1","customerInvoice_enterAddress2":"Entrez l\'adresse ligne 2","customerInvoice_enterAddress2Placeholder":"Adresse Ligne 2","customerInvoice_enterCity":"Entrez la ville","customerInvoice_enterCityPlaceholder":"Ville","customerInvoice_selectCountry":"Choisissez le pays","customerInvoice_selectState":"Sélectionnez l\'état","customerInvoice_enterZipNumber":"Entrer le code postal","customerInvoice_enterZipNumberPlaceholder":"Code postal","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produit non disponible","customerInvoice_SendInvoiceBtn":"Envoyer une facture","customerInvoice_CreateBtn":"Créer","customerInvoice_CreatingBtn":"Création","customerInvoice_ProductTableColumnSubTotal":"Sous-total","customerInvoice_SelectShippingAddress":"Sélectionnez l\'adresse de livraison","customerInvoice_ProductsSearchBy_Placeholder":"Rechercher des produits par nom, SKU, prix","customerInvoice_AddMoreProducts_Btn":"Ajouter plus de produits","customerInvoice_RequiredErrorMsg":"Ce champ est obligatoire","customerInvoice_EmailSuggestionErrorMsg":"Veuillez ajouter un identifiant de messagerie valide","customerInvoice_MobileSuggestionErrorMsg":"Veuillez ajouter un numéro de téléphone valide","customerInvoice_ErrorMsgAddShippingAddress":"Veuillez remplir l\'adresse de livraison","customerInvoice_Creating_Msg":"Créer...","customerInvoice_Sending_Msg":"Envoi en cours...","customerInvoice_OrderCreatedSuccessfullyMsg":"Commande créée avec succès","customerInvoice_InvoiceSentSuccessfullyMsg":"Facture envoyée avec succès au client","customerInvoice_ErrorMsgTryAgain":"Erreur..veuillez réessayer","customerInvoice_Selected_Btn":"Choisi","customerInvoice_ProductTableQuantityUpdate_Btn":"Veuillez sélectionner le produit","customerInvoice_OrderSubTotal":"Sous-total de la commande","delete_confirmation_text":"Es-tu sûr ?","draftOrder_OrderNumber":"Numéro de commande","draftOrder_CustName":"Nom du client","draftOrder_OrderDate":"Date de commande","draftOrder_SubTotal":"Sous-total","draftOrder_Status":"Statut","draftOrder_Invoice":"Facturer","draftOrder_DraftId":"ID brouillon","draftOrder_ShippingCost":"Frais de port","draftOrder_Tax":"Impôt","draftOrder_TotalPrice":"Prix ​​total","draftOrder_Note":"Noter","draftOrder_Product":"Produit","draftOrder_ProductName":"Nom de produit","draftOrder_Size":"Taille","draftOrder_Quantity":"Quantité","draftOrder_Price":"Prix","noDraftOrderProducts":"Aucun projet de détails sur le produit disponible.","noRefundOrderProduct":"Aucune commande de remboursement des détails du produit disponibles.","loading":"Chargement...","dashboard_commissionOn_profitMargin":"Commission sur la marge bénéficiaire","dashboard_clientInvoice":"Facture client","dashboard_affiliateLink":"Ordre d\'affiliation","dashboard_returnCustomer":"Client de retour","dashboard_discountCoupon":"Coupon de réduction","dashboard_SharedCart":"Panier partagé","dashboard_AdminTaggedOrders":"Commande taguée par l\'administrateur","dashboard_no_data":"Pas de données disponibles","dashboard_sales_of_last_six_months":"Ventes des 6 derniers mois","dashboard_sales_of_current_month":"Ventes du mois en cours","addCustomer_ErrorMsgOnSubmitBtn":"s\'il vous plaît entrer un numéro de téléphone valide","login_welcome_Msg":"Bienvenue dans l\'équipe de vente","login_title":"Connexion","login_email":"ID de messagerie","login_password":"Mot de passe","emailValidation_ErrorMsg":"Veuillez saisir l\'ID de messagerie valide","login_newUser":"Nouvel utilisateur?","login_SignUp":"S\'inscrire","login_forgotPassword_link":"Mot de passe oublié?","login_LogInBtn":"Connexion","login_sliderContent_1":"Repins passant le nom des clients","login_sliderContent_2":"Le trafic de conduite du représentant pour stocker","login_sliderContent_3":"Produits de commercialisation du représentant utilisant des plateformes de médias sociaux","login_sliderContent_4":"Le représentant peut acheter en vrac et réaliser des bénéfices","login_sliderContent_5":"Repins passant le nom des clients","login_sliderContent_6":"Les représentants peuvent visiter les clients en personne et créer des commandes","required_ErrorMsg":"Veuillez remplir le champ requis","signup_title":"S\'inscrire","signup_BackTo_login":"Retour connexion","signup_firstName":"Prénom","signup_lastName":"Nom de famille","signup_BackBtn":"Retour","signup_NextBtn":"Prochain","signup_phone_number":"Numéro de téléphone","signup_phone_number_Error":"Veuillez entrer au moins 10 chiffres","signup_uploadPicture":"Télécharger la photo du profil","signup_fileSizeError":"La taille du fichier est supérieure à 5 Mo","signup_filePath_lable":"Fichier sélectionné","signup_MediaTitle2":"Liens de médias sociaux","signup_facebookHandle":"Manche Facebook","signup_InstaHandle":"Poignée Instagram","signup_SaveBtn":"Enregistrer les détails","forgotPwd_title":"Mot de passe oublié","forgotPwd_ResetBtn":"réinitialiser le mot de passe","forgotPwd_SuccessMsg":"Votre demande de mot de passe de réinitialisation est réussie, nous avons envoyé le nouveau mot de passe à votre identifiant de messagerie enregistré.","customerInvoice_selectShippingCost":"Sélectionnez les frais d\'expédition","customerInvoice_CalculatingShippingRates_Msg":"Calculateur...","customerInvoice_AddShippingAddress_Msg":"Sélectionnez une adresse ou ajoutez une adresse de livraison","customerInvoice_PleaseSetAnyShippingAddressMsg":"Veuillez sélectionner une adresse de livraison","customerInvoice_ShippingCostErrorMsg":"Veuillez ajouter une nouvelle adresse de livraison, car l\'adresse contient des informations insuffisantes.","customerInvoice_CalculateShippingCost_Btn":"Calculer les frais d\'expédition","customerInvoice_ShippingCostAddOrNot_Msg":"Souhaitez-vous ajouter des frais de port?","customerInvoice_ShippingCostAddOrNot_Yes":"Oui","customerInvoice_ShippingCostAddOrNot_No":"Non","customerInvoice_ShippingCostErrorMsg_TryAgain":"Veuillez réessayer","dashboard_BannerMsg":"Les graphiques sont mis à jour toutes les 8 heures","yourSales__BannerMsg":"Les détails de la commande sont mis à jour toutes les 5 minutes","customerInvoice_FirstNameErrorMsg":"Veuillez entrer le prénom","customerInvoice_lastNameErrorMsg":"Veuillez entrer le nom de famille","customerInvoice_Add1ErrorMsg":"Veuillez entrer la ligne d\'adresse 1","customerInvoice_CountryErrorMsg":"Veuillez sélectionner le pays","customerInvoice_StateErrorMsg":"Veuillez sélectionner l\'état","customerInvoice_CityErrorMsg":"Veuillez entrer le nom de la ville","customerInvoice_ZipErrorMsg":"Veuillez entrer le code postal","uploadImage":"Télécharger une image","dashboard_CardTitle1":"Commission sur toutes les commandes","dashboard_CardTitle3":"Commission totale","dashboard_TotalRevenue":"Revenu total","dashboard_TotalAvg_Ticket_Size":"Taille du billet AVG","dashboard_CardTitle4":"Ventes totales","profile_Change_Password":"Changer le mot de passe","dashboard_Information_Message":"La commission est suivie uniquement pour les commandes payantes","resetPassword_validation_Msg":"Ce champ est obligatoire","resetPassword_validation_Msg2":"Le mot de passe doit contenir un minimum de 8 caractères, 1 majuscule, 1 minuscules, 1 chiffre, etc.","resetPassword_validation_Msg3":"Confirmer le mot de passe devrait correspondre avec un nouveau mot de passe","dashbord_Msg_New":"Comment ça fonctionne","dashbord_informationMsg":"Information","discount_couponErrorMsg":"La remise maximale n\'est pas configurée. Veuillez contacter le site Admin.","discount_couponErrorMsg2":"La commission n\'est pas configurée. Veuillez contacter le site Admin.","dashbord_profile_pic":"Changer pic profil","Performance_Details":"Détails de performance","Show_Performance_Details":"Afficher les détails des performances","Dashboard_Month":"Mois","Dashboard_Orders_Total":"Commandes totales","Dashboard_Total_Sale":"Vente totale","Dashboard_Commission":"Commission","Dashboard_Bonus":"Prime","customerInvoice_EditOrder_NoAutoSelectedAddress":"Veuillez ajouter l\'adresse du client.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Veuillez sélectionner un coût d\'expédition.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Panier non mis à jour, veuillez actualiser et réessayer.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Veuillez sélectionner un produit.","customerInvoice_CreatingDraft_Msg":"Création de brouillon..","customerInvoice_DraftOrderBtn":"Projet d\'ordonnance","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Projet de commande créé avec succès","productTable_error_AlertMsg":"La quantité ne peut pas être 0 ou moins, veuillez saisir une valeur valide","productTable_error_AlertMsg2":"Veuillez saisir la quantité","click_to_copy":"Cliquez pour copier","discount_code_copy_coupon":"Coupon de copie","createOrder_productSearchGuide":"Impossible de trouver des produits?","soldOut":"Épuisé","InventoryNotTracked":"Inventaire non suivi","productStatus":"État du produit","makeSureInShopify":"Assurez-vous dans Shopify","products":"Des produits","sectionTheProductStatusIs":"section, l\'état du produit est","active":"Active","productsMayBeSoldOutPleaseCheck":"Les produits peuvent être épuisés, veuillez vérifier et sélectionner","yourSales_PaidOrders_PaidDate":"Date de paiement de la commande","ordersLoading":"Chargement des commandes...","productsLoading":"Chargement des produits...","leaveOnPageBtn":"continuer","stayOnPageBtn":"Restez sur cette page","alertBoxTitle":"Créer une page de commande","alertMessage":"Les modifications non enregistrées seront perdues. Vous pouvez enregistrer cette commande en tant que brouillon.","salesDetailsHeader_Location":"Emplacement","customerInvoice_PaymentPending":"Paiement en attente","customerInvoice_Checkout":"Vérifier","customerInvoice_ProceedToCheckout":"Passer à la caisse","customerInvoice_CheckoutMsg":"Cela générera un projet de commande, vous redirigeant vers la page de paiement. Dans le cas où le processus de paiement échoue, vous pouvez trouver cette commande dans l\'onglet Détails de la commande client dans le projet de commandes.","customerInvoice_sendInvoiceToCustomer":"Envoyer une facture au client","customerInvoice_cancel":"Annuler","Checkout_DoNotAskAgainMsg":"Ne demande plus","RepCheckout_RedirectionMsg":"Redirection vers le paiement","customerInvoice_CreatingDraftCheckout":"Draft Création avec Checkout ...","DoNotShowAgain":"Ne pas montrer de nouveau","copyLinkSuccess":"Lien copié avec succès","affiliateLink_Confirmation_Msg1":"Le suivi des commandes des liens affilié ne fonctionne que si le client clique sur le","affiliateLinkConfirmationMsg2":"Ajouter au panier","affiliateLink_Confirmation_Msg3":"bouton, il ne sera pas efficace si le client clique sur le","affiliateLink_Confirmation_Msg4":"Acheter maintenant","affiliateLink_Confirmation_Msg5":"Bouton.","affiliateLink_Confirmation_Note":"NOTE","salesDetailsHeader_Company":"Entreprise","tab_CreateB2BOrder":"Commande B2B","b2b_no_company_data_available":"Aucune donnée des entreprises disponibles","b2b_select_location":"Sélectionnez l\'emplacement","b2b_select_customer":"Sélectionnez le client","b2b_select_location_customer":"Sélectionnez le client / l\'emplacement","b2b_SelectedCompanyDetails":"Détails sélectionnés de l\'entreprise","b2b_no_location_data":"Aucun emplacement disponible","b2b_no_customer_data":"Aucune donnée client disponible","b2b_removeSelectedCustomer":"Retirer","b2b_emailId":"ID de messagerie","b2b_customerName":"Nom du client","b2b_companyName":"Nom de l\'entreprise","b2b_BillingAddress":"adresse de facturation","b2b_ShippingAddress":"adresse de livraison","ST_CO_no_result_found_msg":"Aucun résultat trouvé pour","ST_CO_SearchProducts_Label":"Recherche de produits","ST_CO_search":"Recherche","ST_Producttable_netQuantity":"Quantité nette","ST_Producttable_subtotal":"Total","ST_Producttable_wholesalePrice":"Prix ​​de gros","ST_Producttable_retailPrice":"Prix ​​au détail","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Produit","createOrder_select_product":"Sélectionner un produit","createOrder_AddProduct":"Ajouter le produit","createOrder_AddBtn":"Ajouter","CreateOrder_doneBtn":"Fait","createOrder_productTable_NoProductsAdded":"Aucun produit ajouté","productTable_clearCartBtn":"Vider le panier","b2b_companyTable_noMainContact":"Aucun contact principal disponible","ST_none":"Aucun","CreateOrder_EnterPoNumber":"Entrez le numéro PO","CreateOrder_chooseDateMsg":"Choisissez une date","CreateOrder_paymnetTerms":"Modalités de paiement","CreateOrder_TaxExemption":"Exonération fiscale","draftOrder_CompanyName":"Nom de l\'entreprise","CreateOrder_Company":"Entreprise","Create_Order_TotalLocations":"Total des emplacements","Create_Order_MainContact":"Contact principal","Create_Order_PaymentDueLater":"Paiement dû plus tard","b2b_select_company":"Sélectionner l\'entreprise","yourSales_headerLocation":"Emplacement","customerInvoice_OrderType":"Méthode de vente","productsPerPage":"Produits par page","productTableCartClearButton":"Effacer","myCustomers_searchByCustomerOrCompanyName":"Recherche par nom de client ou d\'entreprise","ST_Producttable_VolumePricing":"Prix ​​​​de volume","dashboard_B2BCompanyLocation":"Emplacement de la société","customer":"Client","PaidDate":"La date de paiement","producttable_discounttypeHeader":"Type de remise","customerInvoice_DiscountOnSubtotal":"Remise sur le sous-total","ST_Producttable_CartResponse":"Le client n\'est pas éligible pour acheter certains des produits dans le panier","ST_B2BPriceBreack_CloseBtn":"Fermer","B2B_QtyRule_Error_Msg":"Quantité ajoutée non valide. Veuillez vérifier les règles de quantité.","B2B_Qty_PriceBreack":"Mengenpreise","Customer_Info_Title":"Veuillez d\'abord sélectionner le pays","Customer_Invalid_pinCode_Msg":"Code PIN invalide","Edit_DraftOrderAlert_Msg":"Important : L\'administrateur a appliqué des prix de gros pour ce client.","Create_Order_DiscountDropdown_value1":"Pourcentage","Create_Order_DiscountDropdown_value2":"Montant fixe","Create_Order_DiscountType_Popup_Value1":"Changer le type de remise","Create_Order_DiscountType_PopUp_Value2":"Les réductions déjà appliquées seront supprimées.","B2B_PriceList_Increment_Msg":"Incrément de ","B2B_PriceList_Minimum_Msg":"Minimum de ","B2B_PriceList_Maximum_Msg":"Maximum de ","SpecialChar_Error_Msg":"Les caractères spéciaux comme @,#,!,$,& ne sont pas autorisés dans le mot de passe","createOrder_ErrorMsgForQuantityLimit":"Vous ne pouvez pas ajouter une quantité supérieure au stock disponible.","ClientInvoice":"Représentant créé","AffiliateOrder":"Lien d\'affiliation","CouponOrder":"Coupon de réduction","ReturnCustomerOrder":"Commande client","Tagcustomer":"Commande client","POSOrder":"POS","SharedCart":"Partager le panier","RepOnCartPage":"Choix du représentant","AdminTaggedOrder":"Marquage manuel","TaggedCompanyLocationOrder":"Commande B2B","WholesaleOrder":"Facture de gros","TeamManager":"Chef d\'équipe","charsLeft":"caractères restants","showing":"Affichage","customers":"clients","exportCsv":"Exporter CSV","all":"Tous","paid":"Payé","unpaid":"Impayé","draft":"Brouillon","refunded":"Remboursé","orderType":"Type de commande","ShippingCost_AddressError":"Le coût d\'expédition pour l\'adresse sélectionnée n\'est pas configuré. Veuillez contacter l\'administrateur.","ShippingCost_CustomerAddressAndCartProductError":"L\'adresse du client et les produits dans le panier sont obligatoires pour calculer les frais de livraison.","ContactCard_Info_Msg":"La carte de contact rend vos liens d’affiliation plus attrayants. Lorsqu\'un client utilise un lien d\'affiliation, il peut voir votre carte de contact sur le site Web, offrant ainsi une expérience d\'achat plus personnalisée. Cette carte peut être personnalisée avec une photo de profil et un message pour vos clients.","contact_Cart_Heading":"Carte de contact","Affiliate_Link_Info_Msg":"Partagez votre lien d\'affiliation avec les clients. Toute commande passée en utilisant votre lien d\'affiliation vous sera attribuée","Contact_Card_Bio_Save_Success_Msg":"Bio enregistrée avec succès","Affiliate_Add_ProductInfo_Msg":"Ajoutez des produits pour lesquels vous souhaitez partager un lien d\'affiliation","ShareCart_UserGuide_Msg1":"Créez un lien de panier partageable, préchargé avec des produits sélectionnés adaptés aux préférences de votre client. Le client peut utiliser le lien, consulter les articles du panier et procéder directement","ShareCart_UserGuide_Msg2":"à la caisse. Les commandes passées en utilisant le lien de votre panier vous seront attribuées.","ShareCart_ToltipTitle":"Supprimer les produits du panier","Delete_Cart_Confirmation":"¿Estás seguro de que quieres eliminar el carrito?","No_Share_Cart_Added1":"Aucun lien de panier créé jusqu\'à présent.","No_Share_Cart_Added2":"Créez un panier et partagez son lien direct avec vos clients","ClearCart_Conformation_Msg":"Etes-vous sûr de vouloir supprimer tous les produits du panier ?","Edit_Billing_Address":"Modifier l\'adresse de facturation","Edit_Shipping_Address":"Modifier l\'adresse de livraison","New_Customer_Select_Msg":"Créer un nouveau client","CreateOrder_Manage_Heading":"Gérer","RemoveCustomer_Msg":"Supprimer le client","Customer_Address_Apartment":"Appartement, suite, etc.","Address_Enter_Msg":"Entrez l\'adresse","Address_Not_Found_Error_Msg":"L\'adresse du client et les produits dans le panier sont obligatoires pour créer une commande","Load_More_Btn":"Charger plus","Beta_Version_msg1":"Cette fonctionnalité est actuellement en version bêta. Si vous rencontrez un problème","Beta_Version_msg2":"veuillez contacter l\'assistance.","Heading_Product_Select":"Sélectionnez des produits","Customer_FirstName":"Prénom","Customer_lastName":"Nom de famille","Customer_Resion":"Country/region","Customer_pinCode":"Code PIN","Customer_phone":"Téléphone","applyDisconutCode_atCheckout":"Autoriser les clients à appliquer des coupons de réduction lors du paiement"}'
        ),
        Tt = JSON.parse(
          '{"dashboard_title":"CRUSCOTTO","dashboard_morningMsg":"Buon giorno","dashboard_afternoonMsg":"Buon pomeriggio","dashboard_welcomeMsg":"Benvenuto/a in","dashboard_eveningMsg":"Buona sera","dashboard_subTitle1":"Mese corrente","dashboard_block1Heading":"ORDINI RETAIL","dashboard_block1Header1":"PROFITTI","dashboard_block1Header2":"FATTURA INVIATA","dashboard_block1Header3":"FATTURA PAGATA","dashboard_block2Heading":"ORDINI ALL\'INGROSSO","dashboard_block2Header1":"PROFITTI","dashboard_block2Header2":"FATTURA INVIATA","dashboard_block2Header3":"FATTURA PAGATA","dashboard_block3Heading":"ORDINI AFFILIATI","dashboard_block3Header1":"PROFITTI","dashboard_block3Header2":"ORDINI PAGATI","dashboard_block4Heading":"COUPON SCONTO","dashboard_block4Header1":"PROFITTI","dashboard_block4Header2":"ORDINI PAGATI","dashboard_block5Heading":"PROVVIGIONE CLIENTE","dashboard_block5Header1":"PROVVIGIONE","dashboard_block5Header2":"ORDINI","dashboard_block6Heading":"PROVVIGIONE CAPO VENDITA","dashboard_block6Header1":"PROVVIGIONE","dashboard_block7Heading":"PROVVIGIONE POS","dashboard_block7Header1":"PROVVIGIONE","dashboard_block7Header2":"ORDINI","dashboard_tbl1column1":"Mese","dashboard_tbl1column2":"Ordini retail","dashboard_tbl1column3":"Provvigione retail","dashboard_tbl1column4":"Ordini ingrosso","dashboard_tbl1column5":"Totale acquisti all ingrosso","dashboard_tbl1column6":"Ordini affiliati","dashboard_tbl1column7":"Provvigione affiliati","dashboard_tbl1column8":"Ordini con codice coupon","dashboard_tbl1column9":"Provvigione codice coupon","dashboard_tbl1column10":"Ordini clienti","dashboard_tbl1column11":"Provvigione clienti","dashboard_tbl1column12":"Ordini POS","dashboard_tbl1column13":"Provvigione POS","dashboar_cardHeading1":"Totale ordine","dashboar_cardHeading2":"Provvigione","dashboar_cardHeading3":"Vendite","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Riepilogo vendite degli ultimi sei mesi","dashboard_graphHeading2":"Analizza ordini e provvigioni per tipologia - mese corrente","Graph_Sales_noorderstitle":"Nessun ordine da mostrare","Graph_SalesRepCommission_nocommissiontitle":"Nessun dato provvigione da mostrare","Graph_SalesRepOrders_title":"ORDINI","Graph_SalesRep_XAxisTitle_ForMonth":"6 mesi","Graph_SalesRepOrders_YAxisTitle":"Ordini","Graph_SalesRepSales_title":"VENDITE","Graph_SalesRepCommission_title":"PROVVIGIONE","Graph_SalesRepCommissions_YAxisTitle":"Provvigione","Graph_FeatureWiseOrder_title":"Ordini vs funzione","Graph_featureWiseCommission_title":"Funzione Commissione vs","Graph_FeatureWiseOrder_XAxisTitle":"Tipologia","Graph_FeatureWiseOrder_YAxisTitle":"Ordini","Graph_FeatureWiseCommission_title":"PROVVIGIONI","Graph_FeatureWiseCommission_YAxisTitle":"Provvigione","customerInvoice_title":"Crea ordine","customerInvoice_button":"Indietro","customerInvoice_noclientorderMsg":"Nessun ordine retail","customerInvoice_button1":"Vedi ordini precedenti","customerInvoice_contentHeading1":"Sconto e provvigione su","customerInvoice_table1column1":"Tipo prodotto","customerInvoice_table1column2":"Provvigione","customerInvoice_table1column3":"Nome sconto","customerInvoice_table1column4":"Sconto","customerInvoice_contentHeading2":"Inserisci dati cliente e seleziona i prodotti per inviare fattura","customerInvoice_contentHeading2Title1":"Entra/Cerca cliente","customerInvoice_title1Placeholder":"Entra/Cerca cliente","customerInvoice_contentHeading2Title2":"email_ID del cliente","customerInvoice_title2Placeholder":"Indirizzo email","customerInvoice_contentHeading2Title3":"Inserisci note dell\'ordine","customerInvoice_contentHeading2Title4":"Indirizzo cliente","customerInvoice_contentHeading2Title5":"Cellulare cliente","customerInvoice_contentHeading2Title6":"Note cliente","customerInvoice_Placeholder_contentHeading2Title6":"Note","customerInvoice_Placeholder_contentHeading2Title5":"Cellulare","customerInvoice_Placeholder_contentHeading2Title4":"Indirizzo di spedizione","customerInvoice_title3Placeholder":"Note dell\'ordine","customerInvoice_table2Column1":"Immagine","customerInvoice_table2Column2":"Aggiungi quantità","customerInvoice_table2Column3":"Titolo","customerInvoice_table2Column4":"Variante Titolo","customerInvoice_ProductTableColumnPrice":"Prezzo","customerInvoice_ProductTableColumnWholeSalePrice":"Prezzo Ingrosso","customerInvoice_button2":"Crea fattura","customerInvoice_ProductTableColumnProduct":"Prodotto","customerInvoice_table3Column2":"Nome prodotto","customerInvoice_table3Column3":"Provenienza","customerInvoice_ProductTableColumnQuantity":"Quantità","customerInvoice_table3Column5":"Prezzo unitario","customerInvoice_table3Column6":"Prezzo totale","customerInvoice_table3Column7":"Prezzo scontato per cliente","customerInvoice_table3Column8":"Provvigione venditore","customerInvoice_table3Column9":"Tipo sconto","customerInvoice_repproInvite":"Seleziona casella per inviare ","customerInvoice_customerOrder_error1":"tutti i campi cliente sono obbligatori. Inserisci email e nome del cliente","customerInvoice_productAddedMsg":"Prodotto aggiunto","customerInvoice_AlertErrorMsg":"Errore..Si prega di contattare l\'assistenza!","cartSharing_Select_product_Title":"Seleziona il prodotto","wholesaleOrder_title":"Ordine ingrosso","wholesaleOrder_contentHeading1":"Puoi acquistare prodotti a prezzi speciali all\'ingrosso","wholesaleOrder_contentHeading2":"Sconto su","wholesaleOrder_column1":"Nome venditore","wholesaleOrder_column2":"Sconto","wholesaleOrder_searchtxtPlaceholder":"Cerca prodotto","wholesaleOrder_table1Column1":"Immagine","wholesaleOrder_table1Column2":"Aggiungi quantità","wholesaleOrder_table1Column3":"Titolo","wholesaleOrder_table1Column4":"Variante Titolo","wholesaleOrder_table1Column5":"Prezzo","wholesaleOrder_button":"Check Out","wholesaleOrder_Order_btn":"Mostra/Nascondi listino volumi","wholesaleOrder_contentHeading3":"Prezzo totale","wholesaleOrder_contentHeading4":"Il tuo prezzo scontato","wholesaleOrder_table2Column1":"Prodotto","wholesaleOrder_table2Column2":"Nome prodotto","wholesaleOrder_table2Column3":"Provenienza","wholesaleOrder_table2Column4":"Quantità","wholesaleOrder_table2Column5":"Prezzo unitario","wholesaleOrder_table2Column6":"Prezzo totale","wholesaleOrder_table2Column7":"Il tuo prezzo scontato","affiliateLink_title":"Collegamento affiliato","affiliate_product_link":"Link del prodotto","affiliateLink_input_error_msg":"Il campo di testo del collegamento è obbligatorio e non deve contenere spazi.","affiliateLink_contentHeading1":"Condividi il tuo collegamento affiliato sui social media e via email. Riceverai una provvigione affiliato per ogni ordine ricevuto dal tuo collegamento","affiliateLink_contentHeading2":"Il tuo collegamento affiliato","affiliateLink_contentHeading3":"Provvigione su","affiliateLink_noaffiliateorderMsg":"Nessun ordine affiliato","affiliateLink_column1":"Nome venditore","affiliateLink_column2":"Provvigione","affiliateLink_searchtxtPlaceholder":"Cerca prodotto","affiliateLink_searchColumn1":"Prodotto","affiliateLink_searchColumn2":"Titolo prodotto","affiliateLink_searchColumn3":"Prezzo","affiliateLink_searchColumn4":"Provvigione","affiliateLink_searchColumn5":"Collegamento affiliato","affiliateLink_backbtn":"Indietro","affiliateLink_card_Title":"Contatto Card & Affiliate Link","cartSharing_title":"Condivisione del carrello","cartSharing_CreateCartInformation_Text":"Per creare un carrello condivisibile personalizzato, aggiungi i prodotti dalla vetrina. I prodotti verranno mostrati in questa pagina","cartSharing_content2Placeholder":"Nome carrello","cartSharing_table2Column2":"Prodotto","cartSharing_table2Column3":"Provenienza","cartSharing_table2Column6":"Prezzo totale","cartSharing_SharedCartLinkTableColumnCartName":"Nome cartello","cartSharing_SharedCartLinkTableColumnLink":"Collegamento","cartSharing_SharedCartLinkTableColumnCartLink":"Link al carrello condivisibile","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copia collegamento carrello","cartSharing_SharedCartLink_Other":"Altra","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Cancella collegamento carrello","cartSharing_EnterCartName_Label":"Nome carrello","cartSharing_ProductTableColumnProduct":"Prodotto","cartSharing_ProductTableColumnQuantity":"Quantità","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Prezzo unitario","cartSharing_CartCreating_Msg":"Creazione...","cartSharing_Copied_Msg":"Copiato!!","cartSharing_SharedCartLinkTableEmpty_Msg":"Nessun collegamento da mostrare","cartSharing_CartCreatedSuccessfully_Msg":"Il tuo nuovo carrello è stato creato con successo","cartSharing_CartCreateError_Msg":"Errore... per favore riprova","cartSharing_AlertError_Msg":"Errore..Si prega di contattare l\'assistenza!","cartSharing_CopyCartLink_Msg":"Copia collegamento carrello","cartSharing_DeleteCartLink_Msg":"Cancella collegamento carrello","cartSharing_DeleteConfirmation_Msg":"Sei sicuro ?","cartSharing_ProductTableEmpty_Msg":"Prodotto non disponibile","cartSharing_CreateCart_Btn":"Crea carrello","cartSharing_ProductTableQuantityUpdate_Btn":"Si prega di selezionare il prodotto","discountCoupon_titleOne":"Coupon sconto","discountCoupon_contentHeading1":"Condividi il codice del buono sconto con i tuoi clienti e ogni volta che il tuo coupon viene utilizzato ricevi una commissione.","discountCoupon_contentHeading2":"Il tuo codice coupon è","discountCoupon_contentHeading3":"Valore sconto","discountCoupon_contentHeading4":"Provvigione","discountCoupon_contentHeading4PlaceHolder1":"Ehi, usa il mio codice coupon sconto","discountCoupon_contentHeading4PlaceHolder2":"e ottieni prodotti scontati","discountCoupon_button1":"Copia testo","discountCoupon_titleTwo":"Crea coupon sconto univoci per i clienti","discountCoupon_button2":"Visualizza coupon","discountCoupon_contentHeading5":"Sconto massimo consentito","discountCoupon_contentHeading6":"Provvigione","discountCoupon_contentHeading7":"Inserisci codice coupon","cartSharing_copiedButtonText":"Copiato","discountCoupon_contentHeading7PlaceHolder":"Inserisci codice coupon","discountCoupon_contentHeading8":"Inserisci sconto","discountCoupon_contentHeading8PlaceHolder":"Lo sconto non deve essere maggiore dello sconto massimo.","discountCoupon_button3":"Crea coupon","discountCoupon_coupon_error1":"Inserisci codice coupon e sconto","yourBio_title":"Il tuo biglietto da visita","yourBio_content1":"Carica profilo","yourBio_button1":"Seleziona file","yourBio_button1PlaceHolder":"Nessun file selezionato","yourBio_button2":"Carica","yourBio_content2":"Inserisci il tuo testo per creare il tuo collegamento univoco di affiliato","yourBio_content2PlaceHolder":"crea il tuo collegamento affiliato univoco","yourBio_content4":"Quando il tuo collegamento verrà usato il tuo biglietto da visita apparirà","yourBio_content3":"Inserisci il tuo biglietto da visita","yourBio_error_image_size":"La dimensione dell\'immagine è troppo grande, carica un\'immagine inferiore a 5 MB. Per favore riprova.","yourBio_content3PlaceHolder":"Inserisci in 100 parole","yourBio_button3":"Salva","yourBio_button4":"Salvato","yourBio_error_link":"Questo collegamento univoco è già stato utilizzato. Prova con un nuovo collegamento univoco","yourBio_Linksuccessmsg":"Collegamento univoco salvato con successo","team_title1":"Aggiungi venditore","team_content1":"Inserisci email","team_content1PlaceHolder":"Indirizzo email","team_emailerrorMsg":"Inserisci indirizzo email","team_content2":"Nome","team_content2PlaceHolder":"Nome","team_fnameerrorMsg":"Inserisci nome","team_content3":"Cognome","team_content3PlaceHolder":"Cognome","team_button1":"Carica","team_successmsg":"Il rappresentante è stato aggiunto con successo. Riceverà le credenziali di accesso all\'indirizzo e-mail fornito.","team_errorsmsg":"Errore nell\'inserimento. Questa email è già stata registrata nello store","team_title2":"Dettagli del team","team_content4":"Pagina di iscrizione","team_NoTeamDetailsMsg":"Nessun dettaglio di team","team_content5":"Seleziona venditore","team_tableTitle":"DETTAGLI ORDINI DEGLI ULTIMI DUE MESI","team_column1":"Numero ordine","team_column2":"Data ordine","team_column3":"Nome cliente","team_column4":"Venditore","team_column5":"Subtotale","team_column6":"Provvigione Venditore","team_column7":"Provvigione Capo Vendita","team_column8":"Metodo di vendita","addCustomer_title":"Carica cliente","addCustomer_content1":"Cliente nome","addCustomer_txt1Placeholder":"Nome","addCustomer_content2":"Cliente cognome","addCustomer_content2Placeholder":"Cognome","addCustomer_content3":"Cliente email_ID","addCustomer_content3Placeholder":"Indirizzo email","addCustomer_content4":"Note","addCustomer_content4Placeholder":"Note","addCustomer_customerAddress":"Indirizzo privato","addCustomer_customerCity":"Città","addCustomer_customerCityPlaceholder":"Città","addCustomer_customerCountry":"Stato","addCustomer_customerState":"Provincia","addCustomer_customerZipCode":"CAP","addCustomer_companyName":"Nome azienda","addCustomer_companyAddress":"Indirizzo azienda","addCustomer_companyCity":"Città","addCustomer_companyCountry":"Stato","addCustomer_companyState":"Provincia","addCustomer_companyZipCode":"CAP","addCustomer_button":"Salva","addCustomer_leadsuccessmsg":"Il cliente è stato caricato con successo","addCustomer_leadErrrorMsg":"Errore nel salvataggio dati","addCustomer_leadEmptyErrrorMsg":"Compila i campi indicati","addCustomer_leadsuccessmsg2":"Cliente creato e associato a venditore","addCustomer_leadErrrorMsg2":"Questo cliente è già associato a un venditore","myCustomers_title":"I tuoi clienti","myCustomers_table1Column1":"Nome","myCustomers_table1Column2":"Nome azienda","myCustomers_table1Column3":"email","myCustomers_table1Column4":"Oordini","myCustomers_table1Column5":"Totale speso","myCustomers_table2Title":"DETTAGLI CLIENTI","myCustomers_table3Title":"DETTAGLI COPIA COMMISSIONE","myCustomers_table3Column1":"Prodotto","myCustomers_table3Column2":"Provenienza","myCustomers_table3Column3":"Quantità","myCustomers_table3Column4":"Prezzo","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotale","myCustomers_table2Row1":"Nome","myCustomers_table2Row2":"Email","myCustomers_table2Row3":"Indirizzo","myCustomers_table2Row4":"Nome azienda","myCustomers_table2Row5":"Note cliente","myCustomers_table2Row6":"Totale spesa (Subtotale + IVA)","myCustomers_table2Row7":"Numero degli ordini","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Mostra tutti i clienti","myCustomers_radioButton1":"Cerca per Nome Cliente","myCustomers_radioButton2":"Cerca per Azienda","myCustomers_radioButtonError1":"Seleziona tipo di ricerca e valore da cercare","myCustomers_radioButtonError2":"Inserisci valore da cercare","myCustomers_radioButtonError3":"Seleziona tipo ricerca","myCustomers_searchButton":"Cerca","myCustomers_Placeholder1":"Inserisci nome cliente o nome azienda da cercare","myCustomers_NoOrdersError":"Nessun ordine","myCustomer_no_salesRep_details":"Nessun dettaglio del rappresentante di vendita disponibile.","myCustomer_select_customer_country":"Seleziona il paese del cliente","myCustomer_company_country":"Paese aziendale","myCustomer_company_state":"Stato aziendale","myCustomer_select_company_country":"Seleziona il paese dell\'azienda","yourSales_SalesOrderDetailsTitle":"Dettagli dell\'ordine di vendita","yourSales_title":"Dettagli dell\'ordine degli ultimi 2 mesi","yourSales_table1Column1":"Numero ordine","yourSales_table1Column2":"Data ordine","yourSales_table1Column3":"Nome cliente","yourSales_table1Column4":"Subtotale","yourSales_table1Column5":"Provvigione","yourSales_table1Column6":"Tipo provvigione","yourSales_table1Column7":"Stampa fattura","printOrderInvoice_btn":"Stampa fattura","yourSales_tableTitle":"DETTAGLI PRODOTTO","yourSalesDraft_tableTitle":"DETTAGLI COPIA COMMISSIONE","yourSales_column1":"Prodotto","yourSales_column2":"Titolo","yourSales_column3":"Quantità","yourSales_column4":"Prezzo unitario","yourSales_column5":"Tracking Number","yourSales_column6":"Data spedizione","yourSales_column7":"Prezzo totale","yourSales_content1":"Subtotale","yourSales_content2":"IVA","yourSales_content3":"Contributo trasporto","yourSales_content4":"Totale","yourSales_content5":"Note","yourSales_tabHeading1":"Ordini pagati","yourSales_tabHeading4":"Ordini in sospeso","yourSales_tabHeading2":"Copie commissioni","myOrders_title":"Dettaglio dei miei ordini personali","myOrdersDetails_Message":"Ordini fatti per te stesso","myOrders_table1Column1":"Numero ordine","myOrders_table1Column2":"Data ordine","myOrders_table1Column3":"Nome cliente","myOrders_table1Column4":"Pagamento","myOrders_table1Column5":"Stato di evasione","myOrders_table1Column6":"Totale","myOrders_tableTitle":"DETTAGLI PRODOTTO","myOrders_table2Column1":"Prodotto","myOrders_table2Column2":"Titolo","myOrders_table2Column3":"Quantità","myOrders_table2Column4":"Prezzo unitario","myOrders_table2Column5":"Tracking Number","myOrders_table2Column6":"Data spedizione","myOrders_table2Column7":"Prezzo totale","myOrders_content1":"Subtotale","myOrders_content2":"IVA","myOrders_content3":"Contributo trasporto","myOrders_content4":"Totale","myOrders_content5":"Note","myOrders_content6":"ID copia commiss.","tab_Dashboard":"Cruscotto","dashbord_Tab":"Casa","tab_CustomerInvoice":"Crea ordine","tab3_WholesaleOrder":"Ordine ingrosso","tab_AffiliateLink":"Collegamento affiliato","tab_CartSharing":"Condivisione del carrello","tab_DiscountCoupon":"Coupon sconto","tab7_YourBio":"Il tuo biglietto da visita","tab8_Team":"Team","tab9_AddCustomer":"Aggiungi cliente","tab_MyCustomers":"I miei clienti","tab_YourSalesOrderDetails":"Dettagli dei tuoi ordini di vendita","tab12_MyOrders":"Dettagli dei miei ordini","tab13_Logout":"Logout","signUp_title":"Iscrizione venditore","signUp_subTitle":"Compila questo modulo per iscriverti come venditore e oyyieni accesso a tutte le funzionalità team di vendita","signUp_content1":"Email","signUp_content2":"Nome","signUp_content3":"Cognome","signUp_content4":"Telefono","signUp_content5":"Profilo facebook","signUp_content6":"Profilo twitter","signUp_content7":"Profilo instagram","signUp_content8":"Carica immagine profilo","signUp_socialmedialable1":"Collegamenti social media","signUp_socialmedialable2":"opzionale","signUp_uploadBtn":"Scegli file","signUp_uploadBtnPlaceHolder":"Nessun file scelto","signUp_button3":"sto salvando…","signUp_welcomemsg1":"Salve","signUp_welcomemsg2":"Registra venditori sotto di te e ottieni una provvigione sulle vendite da questi generate","signUp_emailerror":"Inserisci email","signUp_Fnameerror":"Inserisci nome","signUp_lnameerror":"Inserisci cognome","signUp_phnumbererror":"Inserisci numero telefono","signUp_successmsg":"La tua richiesta di iscrizione è stata inviata con successo. Riceverai i dettagli di accesso all\'account via email una volta che l\'amministratore avrà approvato la tua richiesta. Per ulteriori informazioni, contatta l\'amministratore del negozio.","signUp_errorsmsg":"Errore nel salvataggio dei dettagli. Questa email ha già un account associato nello store","signUp_RepExistErrorMsg":"Questa email è già registrata come venditore","addingRep_selectRepsLabel1":"Chi ti ha aiutato?","addingRep_NoSalesRep":"Nessun venditore","addingRep_successMsg":"Risposta aggiunta alle note carrello","addingRep_selectRepsLabel2":"Seleziona un oggetto dalla lista","wholesaleOrder_WholesaleDiscountTableColumn1":"Titolo prodotto","wholesaleOrder_WholesaleDiscountTableColumn2":"Sconto","customerInvoice_ViewClientOrdersColumn1":"Nome cliente","customerInvoice_ViewClientOrdersColumn2":"Titolo prodotto","customerInvoice_ViewClientOrdersColumn3":"Subtotale","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Fattura","salesRep_order_errorMsg":"Errore nella creazione del tuo ordine. Contatta il supporto","salesRep_order_successMsg":"Ordine creato con successo! Il documento è stato inviato al cliente","salesRep_order_errorMsg2":"Errore nella creazione del tuo ordine. Contatta il supporto","customedraft_btn1":"Crea nuova fattura","customedraft_btn2":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","customedraft_btn3":"Creazione ordine…","customedraft_btn4":"Crea nuova fattura","salesRep_order_NoProductSelected":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","productnotselectforcartsharingtxt1":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","discountCoupons_tblColumn1":"Codice coupon","discountCoupons_tblColumn2":"Sconto coupon","discountCoupons_tblColumn3":"Cancella codice coupon","discountedPriceLabel":"Il tuo prezzo scontato:","couponCodeNotSet":"Codice coupon non inizializzato","dashboard_subTitle2":"Ciclo mese corrente: dal gg. 5 al gg. 4","affiliatelink_commissiononlbl":"Prodotto","displaycommission_lbl1":"Tipo prodotto","displaycommission_lbl2":"Venditore","displaycommission_lbl3":"Sconto quantità","discountcommissiononlbl1":"Livelli di sconto cliente","clientInvoiceCommissionTablecolumn1":"Tipo prodotto","clientInvoiceCommissionTablecolumn2":"Provvigione","clientInvoiceCommissionTablecolumn3":"Titolo prodotto","clientInvoiceCommissionTablecolumn4":"Nome venditore","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nome prodotto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Sconto","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantità","affiliateCartProdtableColumn1":"Prodotto","affiliateCartProdtableColumn2":"Titolo prodotto","affiliateCartProdtableColumn3":"Prezzo","affiliateCartProdtableColumn4":"Provvigione","affiliateCartProdtableColumn5":"Collegamento affiliato","affiliateCartProdtableColumn6":"Condividi collegamento","productnotselectforcartsharinglbl1":"Inserisci nome carrello","productnotselectforcartsharinglbl2":"Nessun prodotto selezionato. Seleziona i prodotti e riprova","productnotselectforcartsharinglbl3":"Attendi elaborazione in corso…","showSharedCartProductcolumn1":"Collegamento carrello","showSharedCartProductcolumn3":"Rimuovi carrello","onSuccessInvoiceSuccessMsg":"Fattura inviata correttamente","onSuccessInvoiceFailedMsg":"Invio fattura non riuscito","sendInvoice_successMsg":"Fattura inviata correttamente","deleteInvoice_successMsg":"Fattura cancellata correttamente","deleteInvoice_FailedMsg":"Cancellazione fattura non riuscita","deleteInvoice_btnlbl":"Cancellazione fattura","deleteSharedCartLink_successMsg":"Collegamento cancellato correttamente","deleteSharedCartLink_FailedMsg":"Errore nella cancellazione collegamento. Riprova..","deleteSharedCartLink_btnlbl":"Cancello collegamento","viewInvoiceOrders_btntxt1":"Attesa…","viewInvoiceOrders_btntxt2":"Vedi ordini precedenti","createCoupon_btnlbl1":"Creazione coupon..","createCoupon_btnlbl2":"Coupon creato","deleteCoupon_successMsg":"Coupon cancellato","deleteCoupon_FailedMsg":"Cancellazione coupon non riuscita","deleteCoupon_btnlbl":"Cancellazione...","viewProductModelColumn1":"Prodotto","viewProductModelColumn2":"Titolo","viewProductModelColumn3":"Quantità","viewProductModelColumn4":"Importo rimborsato","viewProductModelColumn5":"Prezzo unitario","viewProductModelColumn6":"Prezzo scontato","viewProductModelColumn7":"Tracking Number","viewProductModelColumn8":"Data di spedizione","viewProductModelColumn9":"Prezzo totale","showSharedCartProducts_column2":"Immagine","showSharedCartProducts_column3":"Aggiungi quantità","showSharedCartProducts_column4":"Titolo","showSharedCartProducts_column5":"Titolo variante","showSharedCartProducts_column6":"Prezzo","viewClientOrders_btn1":"Vista","viewClientOrders_btn2":"Invia","viewClientOrders_btn3":"Cancella","showCouponTable_txt1":"Attesa..","showCoupon_btn2":"Vedi coupon","showCoupon_btn1":"Copiato","affliateOrder_column1":"Nome cliente","affliateOrder_column2":"Email cliente","affliateOrder_column3":"Titolo prodotto","affliateOrder_column4":"Data ordine","affliateOrder_column5":"Subtotale","affliateOrder_column6":"Provvigione","affliateOrder_btn1":"Attesa…","affliateOrder_btn2":"Vedi ordini affiliati","affliateOrder_btn3":"Vedi ordini affiliati","yourBio_btn1":"Salva","yourBio_btn2":"Salva","yourBio_Uploadbtn1":"Caricamento…","yourBio_Uploadbtn2":"Caricato","yourBio_UploadbtnError":"Errore, riprova","yourBio_Savebtn":"Salvataggio in corso..","team_txt1":"Salvataggio in corso..","team_txt2":"Salva","viewRepClientOrdersDetails_column1":"Numero ordine","viewRepClientOrdersDetails_column2":"Data ordine","viewRepClientOrdersDetails_column3":"Subtotale","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Dettagli prodotto","addSalesRep_txt1":"Aggiungi venditore","addSalesRep_txt2":"Sto aggiungendo venditore…","discountCoupons_header":"Coupon sconto una tantum","discountCoupons_nodiscountcoupon":"Non hai creato nessun coupon sconto","discountCoupons_deleteBtn":"Cancella","discountCoupons_BackBtn":"Indietro","customerInvoice_selectcustomererror":"Seleziona il cliente e poi aggiungi il prodotto","createOrderFromCartPage_selectCustomersLabel":"SELEZIONA CLIENTE","createOrderFromCartPage_selectCustomerAddressLabel":"INDIRIZZO DI SPEDIZIONE","createOrderFromCartPage_selectCustomersLabelForDropDown":"Seleziona cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Selezione indirizzo","createOrderFromCartPage_successMsg":"Ordine creato correttamente. Il documento è stato inviato via email al cliente","createOrderFromCartPage_AddNewAddressTitle":"AGGIUNGI NUOVO INDIRIZZO","createOrderFromCartPage_draftOrderButton":"CREA COPIA COMMISSIONE","createOrderFromCartPage_OrderButton":"CREA ORDINE","createOrderFromCartPage_draftOrderButtonText2":"STO CREANDO L\'ORDINE...","createOrderFromCartPage_selectShippingCostTitle":"CONTRIBUTO TRASPORTO","createOrderFromCartPage_Address_errorMsg4":"C\'è un problema nel conteggio delle tariffe di trasporto","createOrderFromCartPage_Address_errorMsg5":"Qualcosa non ha funzionato, riprova più tardi","customerInvoice_contentHeading2Title7":"Nome azienda cliente","customerInvoice_title7Placeholder":"Nome della ditta","affiliateLink_content_Message1":"Cerca prodotti e condividi il link dei singoli prodotti con i tuoi clienti.","dashboard_subTitle3":"Dettagli della Commissione","dashboard_cardHeading5_1":"Commissione su","dashboard_cardHeading5_2":"Otterrai un","dashboard_cardHeading5_3":"commissione su tutti gli ordini.","show_commission_list":"Mostra l\'elenco delle commissioni","no_customers_to_show":"Nessun cliente da mostrare","no_sales_to_show":"Nessuna vendita da mostrare","no_draft_to_show":"Nessuna bozza da mostrare","no_refund_to_show":"Nessun rimborso da mostrare","no_orders_to_show":"Nessun ordine da mostrare","yourSales_tabHeading3":"Ordini di rimborso","affiliateLink_searchColumn7":"Copia link","affiliateLink_searchColumn8":"copiato","customerInvoice_ViewClientOrdersColumn6":"Numero d\'ordine","customerInvoice_ViewClientOrdersColumn7":"Data dell\'ordine","Error_commissions_NotUpdated":"Le commissioni non sono aggiornate","Profit_Margin":"Margine di profitto","Product_Type":"Tipologia di prodotto","Sales_Rep":"Rappresentante delle vendite","commission_list":"Elenco delle commissioni","refundOrderNumber_title":"Dettagli dell\'ordine di rimborso","refundOrders_column1":"Rimborso Id","refundOrders_column2":"Data dell\'ordine","refundOrders_column3":"Numero d\'ordine","refundOrders_column4":"Nome ordine","refundOrders_column5":"Commissione","refundOrders_column6":"Commissione Team Manager","refundOrders_column7":"ID del team manager","refundOrders_column8":"Rimborso totale parziale","refundOrders_column9":"Stato dell\'ordine","refundOrders_column10":"Metodo di vendita","refundOrderNumber_column1":"Nome","refundOrderNumber_column2":"Data","refundOrderNumber_column3":"Quantità","refundOrderNumber_column4":"Prezzo scontato","refundOrderNumber_column5":"Totale parziale","sales_chart_msg1":"Abbiamo bisogno di dati...","sales_chart_msg2":"Sembra che non abbiamo ancora dati da mostrare.","page_refresh_msg":"fare clic per aggiornare","variant_title":"Titolo variante","line_items_properties":"proprietà","customer_country":"Paese cliente","customer_state":"Stato cliente","company_country":"Paese dell\'azienda","company_state":"Stato della Società","client_orders":"Ordini dei clienti","no_product_details":"Nessun dettaglio dei prodotti da mostrare","submit_btn_text":"Invia","submitting_btn_text":"Invio","submitted_btn_text":"Presentato","email_id_validation_errmsg":"Si prega di inserire un ID e-mail valido","customerInvoice_add_more_details":"Aggiungi più dettagli","customerInvoice_add_shipping_address":"Aggiungi nuovo indirizzo di spedizione","customerInvoice_HideDetails":"Nascondere dettagli","customerInvoice_HideAddress":"Nascondi indirizzo di spedizione","customerInvoice_enterFirstName":"Inserisci il nome","customerInvoice_enterFirstNamePlaceholder":"Nome di battesimo","customerInvoice_enterLastName":"Inserisci il cognome","customerInvoice_enterLastNamePlaceholder":"Cognome","customerInvoice_enterAddress1":"Immettere l\'indirizzo riga 1","customerInvoice_enterAddress1Placeholder":"indirizzo 1","customerInvoice_enterAddress2":"Immettere l\'indirizzo riga 2","customerInvoice_enterAddress2Placeholder":"indirizzo 2","customerInvoice_enterCity":"Entra in Città","customerInvoice_enterCityPlaceholder":"Città","customerInvoice_selectCountry":"Seleziona il paese","customerInvoice_selectState":"Seleziona stato","customerInvoice_enterZipNumber":"Inserisci il codice postale","customerInvoice_enterZipNumberPlaceholder":"Cap","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Prodotto non disponibile","customerInvoice_SendInvoiceBtn":"Inviare la fattura","customerInvoice_CreateBtn":"Creare","customerInvoice_CreatingBtn":"Creazione","customerInvoice_ProductTableColumnSubTotal":"totale parziale","customerInvoice_SelectShippingAddress":"Seleziona Indirizzo di spedizione","customerInvoice_ProductsSearchBy_Placeholder":"Cerca prodotti per nome, SKU, prezzo","customerInvoice_AddMoreProducts_Btn":"Aggiungi più prodotti","customerInvoice_RequiredErrorMsg":"Questo campo è obbligatorio","customerInvoice_EmailSuggestionErrorMsg":"Si prega di aggiungere un ID e-mail valido","customerInvoice_MobileSuggestionErrorMsg":"Si prega di aggiungere un numero di telefono valido","customerInvoice_ErrorMsgAddShippingAddress":"Si prega di compilare l\'indirizzo di spedizione","customerInvoice_Creating_Msg":"Creazione...","customerInvoice_Sending_Msg":"Invio...","customerInvoice_OrderCreatedSuccessfullyMsg":"Ordine creato con successo","customerInvoice_InvoiceSentSuccessfullyMsg":"Fattura inviata con successo al cliente","customerInvoice_ErrorMsgTryAgain":"Errore... per favore riprova","customerInvoice_Selected_Btn":"Selezionato","customerInvoice_ProductTableQuantityUpdate_Btn":"Si prega di selezionare il prodotto","customerInvoice_OrderSubTotal":"Totale parziale dell\'ordine","delete_confirmation_text":"Sei sicuro ?","draftOrder_OrderNumber":"Numero d\'ordine","draftOrder_CustName":"Nome del cliente","draftOrder_OrderDate":"Data dell\'ordine","draftOrder_SubTotal":"Totale parziale","draftOrder_Status":"Stato","draftOrder_Invoice":"Fattura","draftOrder_DraftId":"ID brouillon","draftOrder_ShippingCost":"Spese di spedizione","draftOrder_Tax":"Imposta","draftOrder_TotalPrice":"Prezzo totale","draftOrder_Note":"Nota","draftOrder_Product":"Prodotto","draftOrder_ProductName":"nome del prodotto","draftOrder_Size":"Misurare","draftOrder_Quantity":"Quantità","draftOrder_Price":"Prezzo","noDraftOrderProducts":"Nessun dettaglio dei dettagli del prodotto dell\'ordine disponibili.","noRefundOrderProduct":"Nessun dettaglio del prodotto dell\'ordine di rimborso disponibile.","loading":"Caricamento in corso...","dashboard_commissionOn_profitMargin":"Commissione sul margine di profitto","dashboard_clientInvoice":"Fattura del cliente","dashboard_affiliateLink":"Ordine di affiliazione","dashboard_returnCustomer":"Restituisci il cliente","dashboard_discountCoupon":"Buono sconto","dashboard_SharedCart":"Carrello condiviso","dashboard_AdminTaggedOrders":"Ordine con tag amministratore","dashboard_no_data":"Nessun dato disponibile","dashboard_sales_of_last_six_months":"Vendite degli ultimi 6 mesi","dashboard_sales_of_current_month":"Vendite del mese corrente","addCustomer_ErrorMsgOnSubmitBtn":"Si prega di inserire un numero di telefono valido","login_welcome_Msg":"Benvenuti nel team di vendita","login_title":"Login","login_email":"E-mail identificativo utente","login_password":"Parola d\'ordine","emailValidation_ErrorMsg":"Inserisci l\'ID email valido","login_newUser":"Nuovo utente?","login_SignUp":"Iscrizione","login_forgotPassword_link":"Ha dimenticato la password?","login_LogInBtn":"Accesso","login_sliderContent_1":"Rappresentanti che effettuano l\'ordine per conto dei clienti","login_sliderContent_2":"Il rappresentante del rappresentante al negozio","login_sliderContent_3":"Prodotti di marketing di Rep che utilizzano piattaforme di social media","login_sliderContent_4":"Il rappresentante può acquistare in blocco e trarre profitto","login_sliderContent_5":"Rappresentanti che effettuano l\'ordine per conto dei clienti","login_sliderContent_6":"I rappresentanti possono visitare i clienti di persona e creare ordini","required_ErrorMsg":"Si prega di riempire il campo richiesto","signup_title":"Iscrizione","signup_BackTo_login":"Torna al login","signup_firstName":"Nome di battesimo","signup_lastName":"Cognome","signup_BackBtn":"Di ritorno","signup_NextBtn":"Prossimo","signup_phone_number":"Numero di telefono","signup_phone_number_Error":"Inserisci almeno 10 cifre","signup_uploadPicture":"Carica immagine del profilo","signup_fileSizeError":"La dimensione del file è maggiore di 5 MB","signup_filePath_lable":"File selezionato","signup_MediaTitle2":"Collegamenti sui social media","signup_facebookHandle":"Hand di Facebook","signup_InstaHandle":"Hand di Instagram","signup_SaveBtn":"Salva i dettagli","forgotPwd_title":"Ha dimenticato la password","forgotPwd_ResetBtn":"Resetta la password","forgotPwd_SuccessMsg":"La tua richiesta di reimpostare la password ha esito positivo, abbiamo inviato la nuova password al tuo ID e -mail registrato.","customerInvoice_selectShippingCost":"Seleziona Costo di spedizione","customerInvoice_CalculatingShippingRates_Msg":"Calcolo...","customerInvoice_AddShippingAddress_Msg":"Seleziona Indirizzo o Aggiungi indirizzo di spedizione","customerInvoice_PleaseSetAnyShippingAddressMsg":"Seleziona un qualsiasi indirizzo di spedizione","customerInvoice_ShippingCostErrorMsg":"Si prega di aggiungere un nuovo indirizzo di spedizione, perché l\'indirizzo non ha informazioni sufficienti.","customerInvoice_CalculateShippingCost_Btn":"Calcola il costo di spedizione","customerInvoice_ShippingCostAddOrNot_Msg":"Vuoi aggiungere il costo di spedizione?","customerInvoice_ShippingCostAddOrNot_Yes":"sì","customerInvoice_ShippingCostAddOrNot_No":"No","customerInvoice_ShippingCostErrorMsg_TryAgain":"Per favore riprova","dashboard_BannerMsg":"I grafici vengono aggiornati ogni 8 ore","yourSales__BannerMsg":"I dettagli dell\'ordine vengono aggiornati ogni 5 minuti","customerInvoice_FirstNameErrorMsg":"Inserisci il nome","customerInvoice_lastNameErrorMsg":"Inserisci il cognome","customerInvoice_Add1ErrorMsg":"Inserisci la riga dell\'indirizzo 1","customerInvoice_CountryErrorMsg":"Si prega di selezionare il paese","customerInvoice_StateErrorMsg":"Seleziona lo stato","customerInvoice_CityErrorMsg":"Inserisci il nome della città","customerInvoice_ZipErrorMsg":"Inserisci il codice postale","uploadImage":"Carica immagine","dashboard_CardTitle1":"Commissione su tutti gli ordini","dashboard_CardTitle3":"Commissione totale","dashboard_TotalRevenue":"Entrate totali","dashboard_TotalAvg_Ticket_Size":"Dimensione del biglietto AVG","dashboard_CardTitle4":"Vendite totali","profile_Change_Password":"Cambiare la password","dashboard_Information_Message":"La commissione è monitorata solo per ordini retribuiti","resetPassword_validation_Msg":"Questo campo è obbligatorio","resetPassword_validation_Msg2":"La password deve contenere minimo 8 caratteri, 1 maiuscolo, 1 minuscolo, 1 cifra ecc.","resetPassword_validation_Msg3":"Confermare che la password dovrebbe corrispondere con una nuova password","dashbord_Msg_New":"Come funziona","dashbord_informationMsg":"Informazione","discount_couponErrorMsg":"Lo sconto massimo non è configurato. Si prega di contattare l\'amministratore del sito.","discount_couponErrorMsg2":"La commissione non è configurata. Si prega di contattare l\'amministratore del sito.","dashbord_profile_pic":"Cambia la foto del profilo","Performance_Details":"Dettagli delle prestazioni","Show_Performance_Details":"Mostra i dettagli delle prestazioni","Dashboard_Month":"Mese","Dashboard_Orders_Total":"Ordini totali","Dashboard_Total_Sale":"Vendita totale","Dashboard_Commission":"Commissione","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Aggiungi l\'indirizzo del cliente.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Si prega di selezionare un costo di spedizione.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrello non aggiornato, aggiorna e riprova.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Seleziona il prodotto.","customerInvoice_CreatingDraft_Msg":"Bozza in creazione...","customerInvoice_DraftOrderBtn":"Progetto di ordinanza","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Bozza di ordine creata con successo","productTable_error_AlertMsg":"La quantità non può essere 0 o meno, inserisci un valore valido","productTable_error_AlertMsg2":"Inserisci la quantità","click_to_copy":"Fare clic per copiare","discount_code_copy_coupon":"Copia coupon","createOrder_productSearchGuide":"Non sei in grado di trovare prodotti?","soldOut":"Esaurito","InventoryNotTracked":"Inventario non tracciato","productStatus":"Stato del prodotto","makeSureInShopify":"Assicurati su Shopify","products":"Prodotti","sectionTheProductStatusIs":"sezione, lo stato del prodotto è","active":"Attivo","productsMayBeSoldOutPleaseCheck":"I prodotti potrebbero essere esauriti, controlla e seleziona","yourSales_PaidOrders_PaidDate":"Data di pagamento dell\'ordine","ordersLoading":"Caricamento ordini...","productsLoading":"Caricamento prodotti...","leaveOnPageBtn":"Continua","stayOnPageBtn":"Rimanere su questa pagina","alertBoxTitle":"Crea la pagina dell\'ordine","alertMessage":"Le modifiche non salvate andranno perse. Puoi salvare questo ordine come bozza.","salesDetailsHeader_Location":"Posizione","tab_CreateB2BOrder":"Ordine B2B","b2b_no_company_data_available":"Nessun dati dell\'azienda disponibile","b2b_select_location":"Seleziona posizione","b2b_select_customer":"Seleziona il cliente","b2b_select_location_customer":"Seleziona cliente/posizione","b2b_SelectedCompanyDetails":"Dettagli dell\'azienda selezionati","b2b_no_location_data":"Nessuna posizione disponibile","b2b_no_customer_data":"Nessun dati sui clienti disponibile","b2b_removeSelectedCustomer":"Rimuovere","b2b_emailId":"E-mail identificativo utente","b2b_customerName":"Nome del cliente","b2b_companyName":"Nome della ditta","b2b_BillingAddress":"Indirizzo di fatturazione","b2b_ShippingAddress":"Indirizzo di spedizione","ST_CO_no_result_found_msg":"Nessun risultato trovato per","ST_CO_SearchProducts_Label":"Cerca prodotti","ST_CO_search":"Ricerca","ST_Producttable_netQuantity":"Quantità netta","ST_Producttable_subtotal":"totale parziale","ST_Producttable_wholesalePrice":"Prezzo all\'ingrosso","ST_Producttable_retailPrice":"Al dettaglio il prezzo","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Prodotto","createOrder_select_product":"Seleziona il prodotto","createOrder_AddProduct":"Aggiungi prodotto","createOrder_AddBtn":"Aggiungere","CreateOrder_doneBtn":"Fatto","createOrder_productTable_NoProductsAdded":"Nessun prodotto aggiunto","productTable_clearCartBtn":"Cancella il carrello","b2b_companyTable_noMainContact":"Nessun contatto principale disponibile","ST_none":"Nessuno","CreateOrder_EnterPoNumber":"Immettere il numero PO","CreateOrder_chooseDateMsg":"Scegli una data","CreateOrder_paymnetTerms":"Termini di pagamento","CreateOrder_TaxExemption":"Esenzione fiscale","draftOrder_CompanyName":"Nome della ditta","CreateOrder_Company":"Azienda","Create_Order_TotalLocations":"Posizioni totali","Create_Order_MainContact":"Contatto principale","Create_Order_PaymentDueLater":"Pagamento dovuto più tardi","b2b_select_company":"Seleziona l\'azienda","yourSales_headerLocation":"Posizione","salesDetailsHeader_Company":"Azienda","customerInvoice_PaymentPending":"Pagamento in sospeso","customerInvoice_Checkout":"Guardare","customerInvoice_ProceedToCheckout":"Procedere al checkout","customerInvoice_CheckoutMsg":"Questo genererà un ordine di bozza, reindirizzandoti alla pagina di pagamento. Nel caso in cui il processo di pagamento non abbia successo, è possibile trovare questo ordine nella scheda Dettagli dell\'ordine di vendita in base agli ordini di bozza.","customerInvoice_sendInvoiceToCustomer":"Invia fattura al cliente","customerInvoice_cancel":"Annulla","Checkout_DoNotAskAgainMsg":"Non chiedere di nuovo","RepCheckout_RedirectionMsg":"Reindirizzamento al checkout","customerInvoice_CreatingDraftCheckout":"Draft Creazione con checkout ...","customerInvoice_OrderType":"Metodo di vendita","DoNotShowAgain":"Non mostrare più","copyLinkSuccess":"Link copiato con successo","affiliateLink_Confirmation_Msg1":"Il monitoraggio dell\'ordine di collegamento affiliato funziona solo se il cliente fa clic sul","affiliateLinkConfirmationMsg2":"Aggiungi al carrello","affiliateLink_Confirmation_Msg3":"pulsante, non sarà efficace se il cliente fa clic sul","affiliateLink_Confirmation_Msg4":"Acquista ora","affiliateLink_Confirmation_Msg5":"Pulsante.","affiliateLink_Confirmation_Note":"NOTA","productsPerPage":"Prodotti per pagina","productTableCartClearButton":"Cancella","myCustomers_searchByCustomerOrCompanyName":"Cerca per nome del cliente o dell\'azienda","producttable_discounttypeHeader":"Tipo di sconto","customerInvoice_DiscountOnSubtotal":"Sconto sul subtotale","ST_Producttable_VolumePricing":"Prezzi a volume","dashboard_B2BCompanyLocation":"Posizione dell\'azienda","customer":"Cliente","PaidDate":"Data di pagamento","ST_Producttable_CartResponse":"Il cliente non è idoneo ad acquistare alcuni dei prodotti nel carrello","ST_B2BPriceBreack_CloseBtn":"Vicino","B2B_QtyRule_Error_Msg":"Quantità non valida aggiunta. Si prega di verificare le regole sulla quantità.","Customer_Info_Title":"Seleziona prima il paese","Customer_Invalid_pinCode_Msg":"Codice PIN non valido","Edit_DraftOrderAlert_Msg":"Importante: l\'amministratore ha applicato i prezzi all\'ingrosso per questo cliente.","Create_Order_DiscountDropdown_value1":"Percentuale","Create_Order_DiscountDropdown_value2":"Importo fisso in dollari","Create_Order_DiscountType_Popup_Value1":"Cambia tipo di sconto","Create_Order_DiscountType_PopUp_Value2":"Gli sconti già applicati verranno rimossi.","B2B_PriceList_Increment_Msg":"Incremento di ","B2B_PriceList_Minimum_Msg":"Minimo di ","B2B_PriceList_Maximum_Msg":"Massimo di ","SpecialChar_Error_Msg":"Caratteri speciali come @,#,!,$,& non sono consentiti nella password","createOrder_ErrorMsgForQuantityLimit":"Non puoi aggiungere una quantità superiore a quella disponibile in magazzino.","ClientInvoice":"Rappresentante creata","AffiliateOrder":"Link di affiliazione","CouponOrder":"Buono sconto","ReturnCustomerOrder":"Ordine del cliente","Tagcustomer":"Ordine del cliente","POSOrder":"POS","SharedCart":"Condividi carrello","RepOnCartPage":"Scelta del rappresentante","AdminTaggedOrder":"Tagging manuale","TaggedCompanyLocationOrder":"Ordine B2B","WholesaleOrder":"Fattura all\'ingrosso","TeamManager":"Direttore della squadra","charsLeft":"carattere a sinistra","showing":"Visualizzazione","customers":"clienti","exportCsv":"Esporta CSV","all":"Tutto","paid":"Pagato","unpaid":"Non pagato","draft":"Bozza","refunded":"Rimborsato","orderType":"Tipo di ordine","ShippingCost_AddressError":"Il costo di spedizione per l\'indirizzo selezionato non è configurato. Si prega di contattare l\'amministratore.","ShippingCost_CustomerAddressAndCartProductError":"L\'indirizzo del cliente e i prodotti nel carrello sono obbligatori per calcolare il costo di spedizione.","ContactCard_Info_Msg":"La scheda di contatto rende i tuoi link di affiliazione più attraenti. Quando un cliente utilizza un link di affiliazione, può vedere la tua scheda di contatto sul sito Web, fornendo ulteriori informazioni esperienza di acquisto personalizzata. Questa carta può essere personalizzata con una foto del profilo e un messaggio per i tuoi clienti.","contact_Cart_Heading":"Scheda di contatto","Affiliate_Link_Info_Msg":"Condividi il tuo link di affiliazione con i clienti. Qualsiasi ordine effettuato utilizzando il tuo link di affiliazione ti verrà attribuito","Contact_Card_Bio_Save_Success_Msg":"Biografia salvata con successo","Affiliate_Add_ProductInfo_Msg":"Aggiungi i prodotti per i quali desideri condividere il link di affiliazione","ShareCart_UserGuide_Msg1":"Crea un collegamento condivisibile del carrello, precaricato con prodotti selezionati su misura per le preferenze del tuo cliente. Il cliente può utilizzare il collegamento, rivedere gli articoli del carrello e procedere direttamente","ShareCart_UserGuide_Msg2":"alla cassa. Gli ordini effettuati utilizzando il link del carrello ti verranno attribuiti.","ShareCart_ToltipTitle":"Rimuovere i prodotti dal carrello","Delete_Cart_Confirmation":"Sei sicuro di voler eliminare il carrello?","No_Share_Cart_Added1":"Nessun collegamento al carrello creato fino ad ora.","No_Share_Cart_Added2":"Crea un carrello e condividi il suo collegamento diretto con i tuoi clienti","ClearCart_Conformation_Msg":"Sei sicuro di voler rimuovere tutti i prodotti dal carrello?","Edit_Billing_Address":"Modifica indirizzo di fatturazione","Edit_Shipping_Address":"Modifica l\'indirizzo di spedizione","New_Customer_Select_Msg":"Crea un nuovo cliente","CreateOrder_Manage_Heading":"Maneggio","RemoveCustomer_Msg":"Rimuovi cliente","Customer_Address_Apartment":"Appartamento, suite, ecc","Address_Enter_Msg":"Inserisci l\'indirizzo","Address_Not_Found_Error_Msg":"L\'indirizzo del cliente e i prodotti nel carrello sono obbligatori per creare un ordine","Load_More_Btn":"Carica altro","Beta_Version_msg1":"Questa funzionalità è attualmente disponibile nella versione Beta. Se riscontri qualsiasi problema","Beta_Version_msg2":"contatta l\'assistenza.","Heading_Product_Select":"Seleziona Prodotti","Customer_FirstName":"Nome di battesimo","Customer_lastName":"Cognome","Customer_Resion":"Paese/regione","Customer_pinCode":"Codice PIN","Customer_phone":"Telefono","applyDisconutCode_atCheckout":"Consenti ai clienti di applicare coupon di sconto al checkout"}'
        ),
        It = JSON.parse(
          '{"dashboard_title":"PAPAN PEMUKA","dashboard_welcomeMsg":"Selamat datang ke","dashboard_morningMsg":"Selamat Pagi","dashboard_afternoonMsg":"Selamat Petang","dashboard_eveningMsg":"Selamat Petang","dashboard_subTitle1":"Bulan semasa","dashboard_block1Heading":"INVOIS PELANGGAN","dashboard_block1Header1":"PENDAPATAN","dashboard_block1Header2":"INVOIS DIHANTAR","dashboard_block1Header3":"INVOIS DIBAYAR","dashboard_block2Heading":"PESANAN BORONG","dashboard_block2Header1":"PENDAPATAN","dashboard_block2Header2":"INVOIS DIHANTAR","dashboard_block2Header3":"INVOIS DIBAYAR","dashboard_block3Heading":"PESANAN AFILIASI","dashboard_block3Header1":"PENDAPATAN","dashboard_block3Header2":"PESANAN DIBAYAR","dashboard_block4Heading":"KUPON DISKAUN","dashboard_block4Header1":"PENDAPATAN","dashboard_block4Header2":"PESANAN DIBAYAR","dashboard_block5Heading":"KOMISYEN PELANGGAN","dashboard_block5Header1":"KOMISYEN","dashboard_block5Header2":"PESANAN","dashboard_block6Heading":"KOMISYEN KETUA PASUKAN","dashboard_block6Header1":"KOMISYEN","dashboard_block7Heading":"KOMISYEN POS","dashboard_block7Header1":"KOMISYEN","dashboard_block7Header2":"PESANAN","dashboard_tbl1column1":"Bulan","dashboard_tbl1column2":"Pesanan Invois Pelanggan","dashboard_tbl1column3":"Komisyen Invois Pelanggan","dashboard_tbl1column4":"Pesanan Borong","dashboard_tbl1column5":"Jumlah Pembelian Borong","dashboard_tbl1column6":"Pesanan Afiliasi","dashboard_tbl1column7":"Komisyen Affilate","dashboard_tbl1column8":"Pesanan Kod Kupon","dashboard_tbl1column9":"Komisyen Kod Kupon","dashboard_tbl1column10":"Pesanan Pelanggan","dashboard_tbl1column11":"Komisyen Pelanggan","dashboard_tbl1column12":"Pesanan POS","dashboard_tbl1column13":"Komisyen POS","dashboar_cardHeading1":"Jumlah Pesanan","dashboar_cardHeading2":"Komisyen","dashboar_cardHeading3":"Jualan","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Prestasi jualan enam bulan lepas","dashboard_graphHeading2":"Menganalisis ciri pesanan bijak dan komisen untuk bulan semasa","Graph_Sales_noorderstitle":"Tiada pesanan untuk dipaparkan","Graph_SalesRepCommission_nocommissiontitle":"Tiada data komisen untuk ditunjukkan","Graph_SalesRepOrders_title":"PESANAN","Graph_SalesRep_XAxisTitle_ForMonth":"6 bulan","Graph_SalesRepOrders_YAxisTitle":"Pesanan","Graph_SalesRepSales_title":"JUALAN","Graph_SalesRepCommission_title":"KOMISYEN","Graph_SalesRepCommissions_YAxisTitle":"Komisyen","Graph_FeatureWiseOrder_title":"Perintah vs ciri","Graph_featureWiseCommission_title":"Suruhanjaya vs Ciri","Graph_FeatureWiseOrder_XAxisTitle":"Ciri","Graph_FeatureWiseOrder_YAxisTitle":"Pesanan","Graph_FeatureWiseCommission_title":"KOMISYEN","Graph_FeatureWiseCommission_YAxisTitle":"Komisyen","customerInvoice_title":"Buat Pesanan","customerInvoice_button":"Kembali","customerInvoice_noclientorderMsg":"Tiada pesanan invois pelanggan","customerInvoice_button1":"Lihat pesanan sebelumnya","customerInvoice_contentHeading1":"Diskaun dan Komisyen","customerInvoice_table1column1":"Jenis Produk","customerInvoice_table1column2":"Komisyen","customerInvoice_table1column3":"Nama Diskaun","customerInvoice_table1column4":"Diskaun","customerInvoice_contentHeading2":"Tambah butiran pelanggan dan pilih produk untuk menghantar invois.","customerInvoice_contentHeading2Title1":"Masukkan/Cari Pelanggan","customerInvoice_title1Placeholder":"Masukkan/Cari Pelanggan","customerInvoice_contentHeading2Title2":"Masukkan ID E-mel Pelanggan","customerInvoice_title2Placeholder":"Alamat Emel","customerInvoice_contentHeading2Title3":"Masukkan mesej","customerInvoice_contentHeading2Title4":"Alamat Pelanggan","customerInvoice_contentHeading2Title5":"Nombor Telefon Pelanggan","customerInvoice_contentHeading2Title6":"Nota Pelanggan","customerInvoice_contentHeading2Title7":"Nama Syarikat Pelanggan","customerInvoice_title7Placeholder":"nama syarikat","customerInvoice_Placeholder_contentHeading2Title6":"Catatan","customerInvoice_Placeholder_contentHeading2Title5":"Nombor Telefon","customerInvoice_Placeholder_contentHeading2Title4":"Alamat Penghantaran","customerInvoice_title3Placeholder":"Mesej","customerInvoice_table2Column1":"Imej","customerInvoice_table2Column2":"Tambah Kuantiti","customerInvoice_table2Column3":"Tajuk","customerInvoice_table2Column4":"Tajuk Variant","customerInvoice_ProductTableColumnPrice":"Harga","customerInvoice_ProductTableColumnWholeSalePrice":"Harga Borong","customerInvoice_button2":"Cipta invois baru","customerInvoice_ProductTableColumnProduct":"Produk","customerInvoice_table3Column2":"Nama Produk","customerInvoice_table3Column3":"Saiz","customerInvoice_ProductTableColumnQuantity":"Kuantiti","customerInvoice_table3Column5":"Harga Item","customerInvoice_table3Column6":"Harga Keseluruhan","customerInvoice_table3Column7":"Harga Diskaun untuk Pelanggan","customerInvoice_table3Column8":"Komisyen SalesRep","customerInvoice_table3Column9":"Diskaun","customerInvoice_repproInvite":"Pilih kotak semak untuk menghantar pro jemputan","customerInvoice_customerOrder_error1":"Semua maklumat pelanggan adalah wajib. Sila masukkan e-mel pelanggan dan nama pertama","customerInvoice_productAddedMsg":"Produk ditambah","customerInvoice_AlertErrorMsg":"Ralat..Sila hubungi sokongan !","cartSharing_Select_product_Title":"","wholesaleOrder_title":"Pesanan borong","wholesaleOrder_contentHeading1":"Anda boleh membeli produk dengan harga borong","wholesaleOrder_contentHeading2":"Diskaun pada","wholesaleOrder_column1":"Nama SalesRep","wholesaleOrder_column2":"Diskaun","wholesaleOrder_searchtxtPlaceholder":"Carian produk","wholesaleOrder_table1Column1":"Imej","wholesaleOrder_table1Column2":"Tambah Kuantiti","wholesaleOrder_table1Column3":"Tajuk","wholesaleOrder_table1Column4":"Tajuk Variant","wholesaleOrder_table1Column5":"Harga","wholesaleOrder_button":"Semak","wholesaleOrder_Order_btn":"Tunjukkan/sembunyikan harga volum","wholesaleOrder_contentHeading3":"Harga Keseluruhan","wholesaleOrder_contentHeading4":"Harga Diskaun Anda","wholesaleOrder_table2Column1":"Produk","wholesaleOrder_table2Column2":"Nama Produk","wholesaleOrder_table2Column3":"Saiz","wholesaleOrder_table2Column4":"Kuantiti","wholesaleOrder_table2Column5":"Harga Item","wholesaleOrder_table2Column6":"Harga Keseluruhan","wholesaleOrder_table2Column7":"Harga Diskaun Anda","affiliateLink_title":"Pautan Afiliasi","affiliate_product_link":"Pautan produk","affiliateLink_input_error_msg":"Medan teks pautan diperlukan dan tidak boleh mengandungi ruang.","affiliateLink_contentHeading1":"Kongsi pautan afiliasi anda di media sosial dan e-mel anda. Anda akan mendapat komisen affiliate untuk setiap pesanan dari pautan afiliasi anda.","affiliateLink_contentHeading2":"Pautan Afiliasi Anda","affiliateLink_contentHeading3":"Komisyen pada","affiliateLink_content_Message1":"Cari produk dan kongsi pautan produk individu dengan pelanggan anda.","affiliateLink_noaffiliateorderMsg":"Tiada pesanan affiliate","affiliateLink_column1":"Nama SalesRep","affiliateLink_column2":"Komisyen","affiliateLink_searchtxtPlaceholder":"Carian produk","affiliateLink_searchColumn1":"Produk","affiliateLink_searchColumn2":"Tajuk Produk","affiliateLink_searchColumn3":"Harga","affiliateLink_searchColumn4":"Komisyen","affiliateLink_searchColumn5":"Pautan Afiliasi","affiliateLink_searchColumn7":"Salin pautan","affiliateLink_searchColumn8":"disalin","affiliateLink_backbtn":"Kembali","affiliateLink_card_Title":"Kad Kenalan & Pautan Ahli Gabungan","cartSharing_title":"Perkongsian Troli","cartSharing_CreateCartInformation_Text":"Untuk mencipta troli yang diperuntukkan, tambahkan produk ke troli dari web yang akan dipaparkan di halaman ini.","cartSharing_content2Placeholder":"Nama troli","cartSharing_table2Column2":"Nama Produk","cartSharing_table2Column3":"Saiz","cartSharing_table2Column6":"Harga Keseluruhan","cartSharing_SharedCartLinkTableColumnCartName":"Nama Troli","cartSharing_SharedCartLinkTableColumnLink":"Pautan","cartSharing_SharedCartLinkTableColumnCartLink":"Pautan Troli Boleh Kongsi","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Salin pautan troli","cartSharing_SharedCartLink_Other":"Lain-lain","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Padamkan pautan troli","cartSharing_EnterCartName_Label":"Masukkan nama troli","cartSharing_ProductTableColumnProduct":"Produk","cartSharing_ProductTableColumnQuantity":"Kuantiti","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Harga Item","cartSharing_CartCreating_Msg":"Mencipta...","cartSharing_Copied_Msg":"Disalin!","cartSharing_SharedCartLinkTableEmpty_Msg":"Tiada Pautan untuk ditunjukkan","cartSharing_CartCreatedSuccessfully_Msg":"Troli baharu anda telah berjaya dibuat","cartSharing_CartCreateError_Msg":"Ralat..sila Cuba Lagi","cartSharing_AlertError_Msg":"Ralat..Sila hubungi sokongan !","cartSharing_CopyCartLink_Msg":"Salin pautan troli","cartSharing_DeleteCartLink_Msg":"Padamkan pautan troli","cartSharing_DeleteConfirmation_Msg":"Adakah anda pasti ?","cartSharing_ProductTableEmpty_Msg":"Produk Tidak Tersedia","cartSharing_CreateCart_Btn":"Cipta troli","cartSharing_ProductTableQuantityUpdate_Btn":"Sila Pilih Produk","discountCoupon_titleOne":"Kupon Diskaun","discountCoupon_contentHeading1":"Kongsi Kod Kupon Diskaun dengan pelanggan anda dan setiap kali kupon anda digunakan, anda mendapat komisen.","discountCoupon_contentHeading2":"Kod kupon anda adalah","discountCoupon_contentHeading3":"Jumlah Diskaun","discountCoupon_contentHeading4":"Komisyen","discountCoupon_contentHeading4PlaceHolder1":"Hey gunakan kod kupon diskaun saya","discountCoupon_contentHeading4PlaceHolder2":"dan dapatkan produk diskaun","discountCoupon_button1":"Salin teks","cartSharing_copiedButtonText":"Disalin","discountCoupon_titleTwo":"Buat kupon diskaun penggunaan satu kali untuk pelanggan","discountCoupon_button2":"Lihat Kupon","discountCoupon_contentHeading5":"Maksimum diskaun yang dibenarkan","discountCoupon_contentHeading6":"Komisyen","discountCoupon_contentHeading7":"Masukkan kod kupon","discountCoupon_contentHeading7PlaceHolder":"Sila masukkan kod kupon","discountCoupon_contentHeading8":"Masukkan diskaun","discountCoupon_contentHeading8PlaceHolder":"Diskaun tidak boleh melebihi diskaun Maksimum.","discountCoupon_button3":"Buat kupon","discountCoupon_coupon_error1":"Sila masukkan kod kupon dan diskaun","yourBio_title":"Bio Anda","yourBio_content1":"Muat naik profil","yourBio_button1":"Pilih fail","yourBio_button1PlaceHolder":"Tiada fail dipilih","yourBio_error_image_size":"Saiz imej terlalu besar, sila muat naik imej bersaiz kurang daripada 5MB. Sila cuba lagi.","yourBio_button2":"Muat naik","yourBio_content2":"Masukkan pautan unik","yourBio_content3":"Masukkan bio anda","yourBio_content2PlaceHolder":"Buat pautan gabungan unik anda","yourBio_content3PlaceHolder":"Masukkan dalam 100 perkataan","yourBio_content4":"Apabila pautan anda akan digunakan kad kenalan anda akan muncul di tapak web","yourBio_button3":"Simpan","yourBio_button4":"Disimpan","yourBio_error_link":"Pautan unik ini telah diambil. Cuba dengan pautan unik yang lain.","yourBio_Linksuccessmsg":"Pautan unik yang disimpan berjaya.","team_title1":"Tambah SalesRep","team_content1":"Masukkan email","team_content1PlaceHolder":"Alamat Emel","team_emailerrorMsg":"Sila masukkan e-mel","team_content2":"Masukkan nama pertama","team_content2PlaceHolder":"Nama Pertama","team_fnameerrorMsg":"Sila masukkan nama pertama","team_content3":"Masukkan nama terakhir","team_content3PlaceHolder":"Nama Terakhir","team_button1":"Tambah","team_successmsg":"Wakil telah berjaya ditambah. Wakil akan menerima kelayakan log masuk di e-mel yang dikemukakan.","team_errorsmsg":"Ralat semasa menambah. E-mel pengguna ini mungkin sudah digunakan","team_title2":"Butiran Pasukan","team_content4":"Halaman Mendaftar","team_NoTeamDetailsMsg":"Tiada butiran pasukan","team_content5":"Pilih SalesRep","team_tableTitle":"BUTIRAN PESANAN DUA BULAN LEPAS","team_column1":"Nombor Pesanan","team_column2":"Tarikh Pesanan","team_column3":"Nama Pelanggan","team_column4":"Sales Rep","team_column5":"Jumlah kecil","team_column6":"Komisyen Rep Sales","team_column7":"Komisyen Pengurus Pasukan","team_column8":"Kaedah Jualan","addCustomer_title":"Tambah pelanggan","addCustomer_content1":"Masukkan Nama Pertama Pelanggan","addCustomer_txt1Placeholder":"Nama Pertama","addCustomer_content2":"Masukkan Nama Akhir Pelanggan","addCustomer_content2Placeholder":"Nama Terakhir","addCustomer_content3":"Masukkan ID E-mel Pelanggan","addCustomer_content3Placeholder":"Alamat Emel","addCustomer_content4":"Catatan","addCustomer_content4Placeholder":"Catatan","addCustomer_customerAddress":"Alamat Peribadi","addCustomer_customerCity":"Bandar","addCustomer_customerCityPlaceholder":"Bandar","addCustomer_customerCountry":"Negara","addCustomer_customerState":"Nyatakan","addCustomer_customerZipCode":"Kod Zip","addCustomer_companyName":"Nama Syarikat","addCustomer_companyAddress":"Alamat Syarikat","addCustomer_companyCity":"Bandar","addCustomer_companyCountry":"Negara","addCustomer_companyState":"Nyatakan","addCustomer_companyZipCode":"Kod Zip","addCustomer_button":"Simpan","addCustomer_leadsuccessmsg":"Pelanggan ditambah dengan jayanya.","addCustomer_leadErrrorMsg":"Ralat semasa menyimpan butiran.","addCustomer_leadEmptyErrrorMsg":"Sila isi ruang yang diwajibkan.","addCustomer_leadsuccessmsg2":"Pelanggan berjaya ditambah dan telah ditandakan kepada wakil rep.","addCustomer_leadErrrorMsg2":"Pelanggan ini sudah ditandakan kepada wakil rep.","myCustomers_title":"Pelanggan Anda","myCustomers_table1Column1":"Nama","myCustomers_table1Column2":"Nama Syarikat","myCustomers_table1Column3":"E-mel","myCustomers_table1Column4":"Pesanan","myCustomers_table1Column5":"Jumlah yang Dibelanjakan","myCustomers_table2Title":"BUTIRAN PELANGGAN","myCustomers_table3Title":"DRAF BUTIRAN PESANAN","myCustomers_table3Column1":"Nama Produk","myCustomers_table3Column2":"Saiz","myCustomers_table3Column3":"Kuantiti","myCustomers_table3Column4":"Harga","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Jumlah kecil","myCustomers_table2Row1":"Nama","myCustomers_table2Row2":"E-mel","myCustomers_table2Row3":"Alamat","myCustomers_table2Row4":"Nama Syarikat","myCustomers_table2Row5":"Nota Pelanggan","myCustomers_table2Row6":"Jumlah yang dibelanjakan (subtotal + cukai)","myCustomers_table2Row7":"Bilangan Pesanan","myCustomers_table2Row8":"Tags","myCustomers_radioButton0":"Tunjukkan semua pelanggan","myCustomers_radioButton1":"Cari mengikut nama","myCustomers_radioButton2":"Cari mengikut syarikat","myCustomers_radioButtonError1":"Sila pilih jenis Carian dan masukkan nilai untuk cari","myCustomers_radioButtonError2":"Sila masukkan nilai untuk mencari","myCustomers_radioButtonError3":"Sila pilih jenis carian","myCustomers_searchButton":"Cari","myCustomers_Placeholder1":"Taip nama pelanggan atau nama syarikat untuk mencari","myCustomers_NoOrdersError":"Tiada pesanan","myCustomer_no_salesRep_details":"Tiada butiran wakil jualan tersedia.","myCustomer_select_customer_country":"Sila pilih Negara Pelanggan","myCustomer_company_country":"Negara syarikat","myCustomer_company_state":"Negeri Syarikat","myCustomer_select_company_country":"Sila pilih Negara Syarikat","yourSales_SalesOrderDetailsTitle":"Butiran Pesanan Jualan","yourSales_title":"Butiran pesanan 2 bulan lepas","yourSales_table1Column1":"Nombor Pesanan","yourSales_table1Column2":"Tarikh Pesanan","yourSales_table1Column3":"Nama Pelanggan","yourSales_table1Column4":"Jumlah kecil","yourSales_table1Column5":"Komisyen","yourSales_table1Column6":"Jenis Komisyen","yourSales_table1Column7":"Cetak Invois","printOrderInvoice_btn":"Cetak","yourSales_tableTitle":"MAKLUMAT PRODUK","yourSalesDraft_tableTitle":"DRAF BUTIRAN PESANAN","yourSales_column1":"Produk","yourSales_column2":"Tajuk","yourSales_column3":"Kuantiti","yourSales_column4":"Harga Item","yourSales_column5":"Nombor Pengesanan","yourSales_column6":"Tarikh Hantar","yourSales_column7":"Harga Keseluruhan","yourSales_content1":"Jumlah kecil","yourSales_content2":"Cukai","yourSales_content3":"Kos Penghantaran","yourSales_content4":"Jumlah","yourSales_content5":"Catatan","yourSales_tabHeading1":"Pesanan Berbayar","yourSales_tabHeading4":"Pending order","yourSales_tabHeading2":"Draf pesanan","myOrders_title":"Maklumat-maklumat Pesanan","myOrdersDetails_Message":"Pesanan dibuat untuk diri sendiri","myOrders_table1Column1":"Nombor Pesanan","myOrders_table1Column2":"Tarikh Pesanan","myOrders_table1Column3":"Nama Pelanggan","myOrders_table1Column4":"Pembayaran","myOrders_table1Column5":"Pemenuhan","myOrders_table1Column6":"Jumlah","myOrders_tableTitle":"MAKLUMAT PRODUK","myOrders_table2Column1":"Produk","myOrders_table2Column2":"Tajuk","myOrders_table2Column3":"Kuantiti","myOrders_table2Column4":"Harga Item","myOrders_table2Column5":"Nombor Pengesanan","myOrders_table2Column6":"Tarikh Hantar","myOrders_table2Column7":"Harga Keseluruhan","myOrders_content1":"Jumlah kecil","myOrders_content2":"Cukai","myOrders_content3":"Kos Penghantaran","myOrders_content4":"Jumlah","myOrders_content5":"Catatan","myOrders_content6":"Draf ID","tab_Dashboard":"Papan pemuka","dashbord_Tab":"Rumah","tab_CustomerInvoice":"Buat Pesanan","tab3_WholesaleOrder":"Pesanan Borong","tab_AffiliateLink":"Pautan Afiliasi","tab_CartSharing":"Perkongsian Troli","tab_DiscountCoupon":"Kupon Diskaun","tab7_YourBio":"Bio Anda","tab8_Team":"Pasukan","tab9_AddCustomer":"Tambah pelanggan","tab_MyCustomers":"Pelanggan Saya","tab_YourSalesOrderDetails":"Butiran pesanan jualan anda","tab12_MyOrders":"Pesanan Saya","tab13_Logout":"Log keluar","signUp_title":"Wakil jualan mendaftar","signUp_subTitle":"Sila isi borang ini untuk mendaftar sebagai wakil jualan dan mendapatkan akses kepada semua ciri pasukan jualan.","signUp_content1":"E-mel","signUp_content2":"Nama Pertama","signUp_content3":"Nama Terakhir","signUp_content4":"Nombor Telefon","signUp_content5":"Nama Facebook","signUp_content6":"Nama Twitter","signUp_content7":"Nama Instagram","signUp_content8":"Muat naik gambar profil","signUp_socialmedialable1":"Pautan Media Sosial","signUp_socialmedialable2":"Pilihannya","signUp_uploadBtn":"Pilih fail","signUp_uploadBtnPlaceHolder":"Tiada fail dipilih","signUp_button3":"Menyimpan butiran ...","signUp_welcomemsg1":"Hello","signUp_welcomemsg2":"Daftar Jualan Rep dan dapatkan komisen mengenai jualan yang dibuat oleh Reps di bawah anda","signUp_emailerror":"Sila masukkan e-mel","signUp_Fnameerror":"Sila masukkan nama pertama","signUp_lnameerror":"Sila masukkan nama terakhir","signUp_phnumbererror":"Sila masukkan nombor telefon","signUp_successmsg":"Permohonan pendaftaran anda telah berjaya dihantar. Anda akan menerima butiran log masuk akaun melalui e-mel sebaik sahaja permintaan anda diluluskan oleh pentadbir. Untuk maklumat lanjut, sila hubungi pentadbir kedai.","signUp_errorsmsg":"Ralat semasa menyimpan butiran. E-mel pengguna ini mungkin sudah mempunyai akaun","signUp_RepExistErrorMsg":"E-mel ini sudah didaftarkan sebagai wakil.","addingRep_selectRepsLabel1":"Siapa yang membantu anda?","addingRep_NoSalesRep":"Tiada sales rep","addingRep_successMsg":"Menambah repId ke nota troli","addingRep_selectRepsLabel2":"Sila pilih item dalam senarai.","wholesaleOrder_WholesaleDiscountTableColumn1":"Tajuk Produk","wholesaleOrder_WholesaleDiscountTableColumn2":"Diskaun","customerInvoice_ViewClientOrdersColumn1":"Nama Pelanggan","customerInvoice_ViewClientOrdersColumn2":"Tajuk Produk","customerInvoice_ViewClientOrdersColumn3":"Harga Subtotal","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Invois","salesRep_order_errorMsg":"Ralat semasa membuat pesanan anda. Sila hubungi khidmat pelanggan.","salesRep_order_successMsg":"Invois pesanan berjaya dicipta! Invois telah dihantar melalui e-mel kepada pelanggan!","salesRep_order_errorMsg2":"Ralat semasa membuat pesanan anda. Sila hubungi khidmat pelanggan.","customedraft_btn1":"Buat invois baru","customedraft_btn2":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","customedraft_btn3":"Pesanan sedang dibuat...","customedraft_btn4":"Buat invois baru","salesRep_order_NoProductSelected":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","productnotselectforcartsharingtxt1":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","discountCoupons_tblColumn1":"Kod Kupon","discountCoupons_tblColumn2":"Diskaun Kupon","discountCoupons_tblColumn3":"Padam kod kupon","discountedPriceLabel":"Harga Diskaun Anda:","couponCodeNotSet":"Kod kupon tidak ditetapkan","dashboard_subTitle2":"Kitaran bulan semasa: 5th - 4th","affiliatelink_commissiononlbl":"Produk","displaycommission_lbl1":"Jenis Produk","displaycommission_lbl2":"Sales Rep","displaycommission_lbl3":"Diskaun Berasaskan Kuantiti","discountcommissiononlbl1":"Tiers Diskaun Pelanggan","clientInvoiceCommissionTablecolumn1":"Jenis Produk","clientInvoiceCommissionTablecolumn2":"Komisyen","clientInvoiceCommissionTablecolumn3":"Tajuk Produk","clientInvoiceCommissionTablecolumn4":"Nama SalesRep","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nama Produk","clientInvoiceQuantityBaseDiscountTablecolumn2":"Diskaun","clientInvoiceQuantityBaseDiscountTablecolumn3":"Kuantiti","affiliateCartProdtableColumn1":"Produk","affiliateCartProdtableColumn2":"Tajuk Produk","affiliateCartProdtableColumn3":"Harga","affiliateCartProdtableColumn4":"Komisyen","affiliateCartProdtableColumn5":"Pautan Afiliasi","affiliateCartProdtableColumn6":"Kongsi Pautan","productnotselectforcartsharinglbl1":"Sila masukkan nama troli","productnotselectforcartsharinglbl2":"Tiada produk yang dipilih. Sila pilih produk dan cuba lagi.","productnotselectforcartsharinglbl3":"Tunggu semasa memproses ...","showSharedCartProductcolumn1":"Pautan troli","showSharedCartProductcolumn3":"Keluarkan troli","onSuccessInvoiceSuccessMsg":"Invois berjaya dihantar","onSuccessInvoiceFailedMsg":"Penghantaran invois gagal","sendInvoice_successMsg":"Invois berjaya dihantar","deleteInvoice_successMsg":"Invois berjaya dihapuskan","deleteInvoice_FailedMsg":"Padam invois gagal","deleteInvoice_btnlbl":"Memadam invois","deleteSharedCartLink_successMsg":"Pautan berjaya dihapuskan","deleteSharedCartLink_FailedMsg":"Ralat dalam memadam pautan. Sila cuba lagi.","deleteSharedCartLink_btnlbl":"Memadamkan pautan","viewInvoiceOrders_btntxt1":"Mendapatkan ...","viewInvoiceOrders_btntxt2":"Lihat pesanan sebelumnya","createCoupon_btnlbl1":"Mencipta kupon ...","createCoupon_btnlbl2":"Kupon dibuat","deleteCoupon_successMsg":"Kupon dipadam","deleteCoupon_FailedMsg":"Kupon gagal dipadam","deleteCoupon_btnlbl":"Memadamkan...","viewProductModelColumn1":"Produk","viewProductModelColumn2":"Tajuk","viewProductModelColumn3":"Kuantiti","viewProductModelColumn4":"Jumlah yang Dikembalikan","viewProductModelColumn5":"Harga Item","viewProductModelColumn6":"Harga Diskaun","viewProductModelColumn7":"Nombor Tracking","viewProductModelColumn8":"Tarikh Hantar","viewProductModelColumn9":"Harga Keseluruhan","showSharedCartProducts_column2":"Imej","showSharedCartProducts_column3":"Tambah Kuantiti","showSharedCartProducts_column4":"Tajuk","showSharedCartProducts_column5":"Tajuk Variant","showSharedCartProducts_column6":"Harga","viewClientOrders_btn1":"Lihat","viewClientOrders_btn2":"Hantar","viewClientOrders_btn3":"Memadam","showCouponTable_txt1":"Mendapatkan ...","showCoupon_btn2":"Lihat Kupon","showCoupon_btn1":"Disalin","affliateOrder_column1":"Nama Pelanggan","affliateOrder_column2":"E-mel Pelanggan","affliateOrder_column3":"Tajuk Produk","affliateOrder_column4":"Tarikh Pesanan","affliateOrder_column5":"Jumlah kecil","affliateOrder_column6":"Komisyen","affliateOrder_btn1":"Mendapatkan ...","affliateOrder_btn2":"Lihat pesanan affiliate","affliateOrder_btn3":"Lihat pesanan affiliate","yourBio_btn1":"Simpan","yourBio_btn2":"Simpan","yourBio_Uploadbtn1":"Memuat naik ...","yourBio_Uploadbtn2":"Dimuat naik","yourBio_UploadbtnError":"Maaf, cuba lagi","yourBio_Savebtn":"Menjimatkan ...","team_txt1":"Menjimatkan ...","team_txt2":"Jimat","viewRepClientOrdersDetails_column1":"Nombor Pesanan","viewRepClientOrdersDetails_column2":"Tarikh Pesanan","viewRepClientOrdersDetails_column3":"Jumlah kecil","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Maklumat Produk","addSalesRep_txt1":"Tambah SalesRep","addSalesRep_txt2":"Menambah SalesRep ...","discountCoupons_header":"Satu Kupon Diskaun Satu Masa","discountCoupons_nodiscountcoupon":"Anda belum membuat sebarang kupon diskaun","discountCoupons_deleteBtn":"Memadam","discountCoupons_BackBtn":"Kembali","customerInvoice_selectcustomererror":"Sila pilih Pelanggan dan kemudian Tambah Produk","createOrderFromCartPage_selectCustomersLabel":"PILIH PELANGGAN","createOrderFromCartPage_selectCustomerAddressLabel":"ALAMAT PENGHANTARAN","createOrderFromCartPage_selectCustomersLabelForDropDown":"Pilih pelanggan","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Pilih alamat","createOrderFromCartPage_successMsg":"Invois pesanan berjaya dibuat! Invois telah dihantar melalui e-mel kepada pelanggan!","createOrderFromCartPage_AddNewAddressTitle":"TAMBAH ALAMAT BARU","createOrderFromCartPage_draftOrderButton":"BUAT PESANAN DRAF","createOrderFromCartPage_OrderButton":"BUAT PESANAN","createOrderFromCartPage_draftOrderButtonText2":"MENCIPTA PESANAN ...","createOrderFromCartPage_selectShippingCostTitle":"KOS PENGHANTARAN","createOrderFromCartPage_Address_errorMsg4":"Terdapat masalah semasa mengira kadar harga penghantaran anda.","createOrderFromCartPage_Address_errorMsg5":"Terdapat kesalahan sila cuba lagi.","yourSales_tabHeading3":"Bayaran Balik Pesanan","refundOrders_column1":"Id Bayaran Balik","refundOrders_column2":"Tarikh pesanan","refundOrders_column3":"Nombor Pesanan","refundOrders_column4":"Nama Pesanan","refundOrders_column5":"Suruhanjaya","refundOrders_column6":"Komisen Pengurus Pasukan","refundOrders_column7":"Id Pengurus Pasukan","refundOrders_column8":"Bayar SubTotal","refundOrders_column9":"Status pesanan","refundOrders_column10":"Kaedah Jualan","refundOrderNumber_title":"Butiran Pesanan Bayaran Balik","refundOrderNumber_column1":"nama","refundOrderNumber_column2":"Tarikh","refundOrderNumber_column3":"Kuantiti","refundOrderNumber_column4":"Harga diskaun","refundOrderNumber_column5":"Jumlah kecil","tableDataError":"Tiada pesanan bayaran balik","dashboard_subTitle3":"Butiran Komisen","dashboard_cardHeading5_1":"Suruhanjaya pada","dashboard_cardHeading5_2":"Anda akan mendapat a","dashboard_cardHeading5_3":"komisen ke atas semua pesanan.","Profit_Margin":"Margin keuntungan","Product_Type":"jenis produk","Sales_Rep":"Wakil Jualan","show_commission_list":"Tunjukkan Senarai Komisen","commission_list":"Senarai Komisen","no_customers_to_show":"Tiada Pelanggan untuk ditunjukkan","no_sales_to_show":"Tiada Jualan untuk ditunjukkan","no_draft_to_show":"Tiada Draf untuk ditunjukkan","no_refund_to_show":"Tiada Bayaran Balik untuk ditunjukkan","no_orders_to_show":"Tiada Pesanan untuk ditunjukkan","customerInvoice_ViewClientOrdersColumn6":"Nombor Pesanan","customerInvoice_ViewClientOrdersColumn7":"Tarikh pesanan","Error_commissions_NotUpdated":"Komisen tidak dikemas kini","sales_chart_msg1":"Kami memerlukan data...","sales_chart_msg2":"Nampaknya kami belum mempunyai sebarang data untuk ditunjukkan.","page_refresh_msg":"klik untuk muat semula","variant_title":"Tajuk Varian","line_items_properties":"harta benda","customer_country":"Negara Pelanggan","customer_state":"Negeri Pelanggan","company_country":"Negara Syarikat","company_state":"Negeri Syarikat","client_orders":"Pesanan Pelanggan","no_product_details":"Tiada butiran produk untuk ditunjukkan","submit_btn_text":"Hantar","submitting_btn_text":"Menyerahkan","submitted_btn_text":"diserahkan","email_id_validation_errmsg":"Sila masukkan Id E-mel yang sah","customerInvoice_add_more_details":"Tambah Lagi Butiran","customerInvoice_add_shipping_address":"Tambah Alamat Penghantaran Baharu","customerInvoice_HideDetails":"Sembunyikan butiran","customerInvoice_HideAddress":"Sembunyikan Alamat Penghantaran","customerInvoice_enterFirstName":"Masukkan Nama Pertama","customerInvoice_enterFirstNamePlaceholder":"Nama pertama","customerInvoice_enterLastName":"Masukkan Nama Akhir","customerInvoice_enterLastNamePlaceholder":"Nama terakhir","customerInvoice_enterAddress1":"Masukkan Alamat Baris 1","customerInvoice_enterAddress1Placeholder":"Alamat Baris 1","customerInvoice_enterAddress2":"Masukkan Baris Alamat 2","customerInvoice_enterAddress2Placeholder":"Alamat 2","customerInvoice_enterCity":"Masuk Bandar","customerInvoice_enterCityPlaceholder":"Bandar","customerInvoice_selectCountry":"Pilih negara","customerInvoice_selectState":"Pilih Negeri","customerInvoice_enterZipNumber":"Masukkan Kod Pos","customerInvoice_enterZipNumberPlaceholder":"Poskod","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produk Tidak Tersedia","customerInvoice_SendInvoiceBtn":"Hantar Invois","customerInvoice_CreateBtn":"Buat","customerInvoice_CreatingBtn":"Mencipta","customerInvoice_ProductTableColumnSubTotal":"jumlah kecil","customerInvoice_SelectShippingAddress":"Pilih Alamat Penghantaran","customerInvoice_ProductsSearchBy_Placeholder":"Cari Produk mengikut Nama, SKU, Harga","customerInvoice_AddMoreProducts_Btn":"Tambah Lebih Banyak Produk","customerInvoice_RequiredErrorMsg":"Medan ini diperlukan","customerInvoice_EmailSuggestionErrorMsg":"Sila tambah id e-mel yang sah","customerInvoice_MobileSuggestionErrorMsg":"Sila tambah no telefon yang sah","customerInvoice_ErrorMsgAddShippingAddress":"Sila isi Alamat Penghantaran","customerInvoice_Creating_Msg":"Mencipta...","customerInvoice_Sending_Msg":"Menghantar...","customerInvoice_OrderCreatedSuccessfullyMsg":"Pesanan Berjaya Dibuat","customerInvoice_InvoiceSentSuccessfullyMsg":"Invois Dihantar Berjaya kepada Pelanggan","customerInvoice_ErrorMsgTryAgain":"Ralat..sila Cuba Lagi","customerInvoice_Selected_Btn":"Dipilih","customerInvoice_ProductTableQuantityUpdate_Btn":"Sila Pilih Produk","customerInvoice_OrderSubTotal":"Pesanan SubTotal","delete_confirmation_text":"Adakah anda pasti ?","draftOrder_OrderNumber":"Nombor pesanan","draftOrder_CustName":"Nama Pelanggan","draftOrder_OrderDate":"Tarikh pesanan","draftOrder_SubTotal":"Jumlah kecil","draftOrder_Status":"Status","draftOrder_Invoice":"Invois","draftOrder_DraftId":"Draf ID","draftOrder_ShippingCost":"Kos penghantaran","draftOrder_Tax":"Cukai","draftOrder_TotalPrice":"Harga keseluruhan","draftOrder_Note":"Catatan","draftOrder_Product":"Produk","draftOrder_ProductName":"Nama Produk","draftOrder_Size":"Saiz","draftOrder_Quantity":"Kuantiti","draftOrder_Price":"Harga","noDraftOrderProducts":"Tiada butiran produk draf pesanan tersedia.","noRefundOrderProduct":"Tiada butiran produk pesanan bayaran balik tersedia.","loading":"Memuatkan ...","dashboard_commissionOn_profitMargin":"Komisen margin keuntungan","dashboard_clientInvoice":"Invois pelanggan","dashboard_affiliateLink":"Perintah afiliasi","dashboard_returnCustomer":"Kembali pelanggan","dashboard_discountCoupon":"Kupon diskaun","dashboard_SharedCart":"Troli Kongsi","dashboard_AdminTaggedOrders":"Pesanan Teg Admin","dashboard_no_data":"Tiada data yang tersedia","dashboard_sales_of_last_six_months":"Jualan 6 bulan terakhir","dashboard_sales_of_current_month":"Jualan bulan semasa","addCustomer_ErrorMsgOnSubmitBtn":"Sila masukkan nombor telefon yang sah","login_welcome_Msg":"Selamat Datang ke Pasukan Jualan","login_title":"Log masuk","login_email":"ID emel","login_password":"Kata laluan","emailValidation_ErrorMsg":"Sila masukkan ID E -mel yang sah","login_newUser":"Pengguna baru?","login_SignUp":"Daftar","login_forgotPassword_link":"Lupa kata laluan?","login_LogInBtn":"Log masuk","login_sliderContent_1":"Wakil membuat pesanan pelanggan","login_sliderContent_2":"Lalu lintas memandu wakil untuk menyimpan","login_sliderContent_3":"Produk pemasaran rep menggunakan platform media sosial","login_sliderContent_4":"Wakil boleh membeli secara pukal dan membuat keuntungan","login_sliderContent_5":"Wakil membuat pesanan pelanggan","login_sliderContent_6":"Wakil boleh melawat pelanggan secara peribadi dan membuat pesanan","required_ErrorMsg":"Sila isi medan yang diperlukan","signup_title":"Daftar","signup_BackTo_login":"Kembali ke log masuk","signup_firstName":"Nama pertama","signup_lastName":"Nama terakhir","signup_BackBtn":"Kembali","signup_NextBtn":"Seterusnya","signup_phone_number":"Nombor telefon","signup_phone_number_Error":"Sila masukkan 10 digit atleast","signup_uploadPicture":"Muat naik gambar profil","signup_fileSizeError":"Saiz fail lebih besar daripada 5MB","signup_filePath_lable":"Fail terpilih","signup_MediaTitle2":"Pautan media sosial","signup_facebookHandle":"Pemegang facebook","signup_InstaHandle":"Pemegang Instagram","signup_SaveBtn":"Simpan perincian","forgotPwd_title":"Lupa kata laluan","forgotPwd_ResetBtn":"Menetapkan semula kata laluan","forgotPwd_SuccessMsg":"Permintaan anda untuk menetapkan semula kata laluan berjaya, kami telah menghantar kata laluan baru ke ID e -mel berdaftar anda.","customerInvoice_selectShippingCost":"Pilih Kos Penghantaran","customerInvoice_CalculatingShippingRates_Msg":"Mengira...","customerInvoice_AddShippingAddress_Msg":"Pilih Alamat atau Tambah Alamat Penghantaran","customerInvoice_PleaseSetAnyShippingAddressMsg":"Sila pilih mana-mana satu alamat penghantaran","customerInvoice_ShippingCostErrorMsg":"Sila Tambah Alamat Penghantaran Baharu, kerana alamat mempunyai maklumat yang tidak mencukupi.","customerInvoice_CalculateShippingCost_Btn":"Kira Kos Penghantaran","customerInvoice_ShippingCostAddOrNot_Msg":"Adakah anda ingin menambah kos penghantaran?","customerInvoice_ShippingCostAddOrNot_Yes":"ya","customerInvoice_ShippingCostAddOrNot_No":"Tidak","customerInvoice_ShippingCostErrorMsg_TryAgain":"Sila cuba lagi","dashboard_BannerMsg":"Grafik dikemas kini setiap 8 jam","yourSales__BannerMsg":"Butiran pesanan dikemas kini setiap 5 minit","customerInvoice_FirstNameErrorMsg":"Sila masukkan nama pertama","customerInvoice_lastNameErrorMsg":"Sila masukkan nama keluarga","customerInvoice_Add1ErrorMsg":"Sila masukkan alamat baris 1","customerInvoice_CountryErrorMsg":"Sila pilih negara","customerInvoice_StateErrorMsg":"Sila pilih negeri","customerInvoice_CityErrorMsg":"Sila masukkan nama bandar","customerInvoice_ZipErrorMsg":"Sila masukkan poskod","uploadImage":"Muat Naik Imej","dashboard_CardTitle1":"Komisen atas semua pesanan","dashboard_CardTitle3":"Jumlah komisen","dashboard_TotalRevenue":"Jumlah hasil","dashboard_TotalAvg_Ticket_Size":"Saiz tiket AVG","dashboard_CardTitle4":"Jumlah jualan","profile_Change_Password":"Tukar kata laluan","dashboard_Information_Message":"Komisen dikesan hanya untuk pesanan berbayar","resetPassword_validation_Msg":"Bidang ini diperlukan","resetPassword_validation_Msg2":"Kata laluan harus mengandungi minimum 8 aksara, 1 huruf besar, 1 huruf kecil, 1 digit dll.","resetPassword_validation_Msg3":"Sahkan kata laluan harus dipadankan dengan kata laluan baru","dashbord_Msg_New":"Bagaimana ia berfungsi","dashbord_informationMsg":"Maklumat","discount_couponErrorMsg":"Diskaun maksimum tidak dikonfigurasikan. Sila hubungi admin laman web.","discount_couponErrorMsg2":"Suruhanjaya tidak dikonfigurasi. Sila hubungi admin laman web.","dashbord_profile_pic":"Tukar gambar profil","Performance_Details":"Butiran Prestasi","Show_Performance_Details":"Tunjukkan butiran prestasi","Dashboard_Month":"Bulan","Dashboard_Orders_Total":"Jumlah pesanan","Dashboard_Total_Sale":"Jumlah Jualan","Dashboard_Commission":"Suruhanjaya","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Sila tambah alamat pelanggan.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Sila pilih kos penghantaran.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Troli tidak dikemas kini, sila muat semula dan cuba semula.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Sila pilih produk.","customerInvoice_CreatingDraft_Msg":"Mencipta Draf..","customerInvoice_DraftOrderBtn":"Draf Perintah","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Draf Pesanan Berjaya Dibuat","productTable_error_AlertMsg":"Kuantiti tidak boleh 0 atau kurang, sila masukkan nilai yang sah","productTable_error_AlertMsg2":"Sila masukkan kuantiti","click_to_copy":"Klik untuk menyalin","discount_code_copy_coupon":"Salin kupon","createOrder_productSearchGuide":"Tidak dapat mencari produk?","soldOut":"Habis dijual","InventoryNotTracked":"Inventori tidak dijejaki","productStatus":"Status Produk","makeSureInShopify":"Pastikan dalam Shopify","products":"Produk","sectionTheProductStatusIs":"bahagian, status produk ialah","active":"Aktif","productsMayBeSoldOutPleaseCheck":"Produk mungkin habis dijual, sila semak dan pilih","yourSales_PaidOrders_PaidDate":"Tarikh Dibayar Pesanan","ordersLoading":"Pesanan dimuatkan...","productsLoading":"Produk dimuatkan...","leaveOnPageBtn":"teruskan","stayOnPageBtn":"Kekal di halaman ini","alertBoxTitle":"Buat halaman pesanan","alertMessage":"Perubahan yang tidak disimpan akan hilang. Anda boleh menyimpan pesanan ini sebagai draf.","salesDetailsHeader_Location":"Lokasi","customerInvoice_PaymentPending":"Pembayaran belum selesai","customerInvoice_Checkout":"Checkout","customerInvoice_ProceedToCheckout":"Teruskan ke checkout","customerInvoice_CheckoutMsg":"Ini akan menghasilkan pesanan draf, mengalihkan anda ke halaman checkout. Sekiranya proses checkout tidak berjaya, anda boleh mencari pesanan ini dalam tab Butiran Pesanan Jualan di bawah draf pesanan.","customerInvoice_sendInvoiceToCustomer":"Hantar Invois kepada Pelanggan","customerInvoice_cancel":"Batalkan","Checkout_DoNotAskAgainMsg":"Jangan tanya lagi","RepCheckout_RedirectionMsg":"Mengalihkan semula ke checkout","customerInvoice_CreatingDraftCheckout":"Draf membuat dengan checkout ...","customerInvoice_OrderType":"Kaedah Jualan","DoNotShowAgain":"Jangan tunjukkan lagi","copyLinkSuccess":"Pautan disalin dengan jayanya","affiliateLink_Confirmation_Msg1":"Penjejakan pesanan pautan afiliasi hanya berfungsi jika pelanggan mengklik","affiliateLinkConfirmationMsg2":"Tambah ke kereta","affiliateLink_Confirmation_Msg3":"butang, tidak akan berkesan jika pelanggan mengklik","affiliateLink_Confirmation_Msg4":"Beli sekarang","affiliateLink_Confirmation_Msg5":"Butang.","affiliateLink_Confirmation_Note":"CATATAN","salesDetailsHeader_Company":"Syarikat","tab_CreateB2BOrder":"Perintah B2B","b2b_no_company_data_available":"Tiada data syarikat tersedia","b2b_select_location":"Pilih Lokasi","b2b_select_customer":"Pilih Pelanggan","b2b_select_location_customer":"Pilih Pelanggan/Lokasi","b2b_SelectedCompanyDetails":"Butiran syarikat terpilih","b2b_no_location_data":"Tiada lokasi yang tersedia","b2b_no_customer_data":"Tiada data pelanggan tersedia","b2b_removeSelectedCustomer":"Keluarkan","b2b_emailId":"ID emel","b2b_customerName":"Nama Pelanggan","b2b_companyName":"nama syarikat","b2b_BillingAddress":"Alamat pengebilan","b2b_ShippingAddress":"Alamat penghantaran","ST_CO_no_result_found_msg":"Tiada hasil yang dijumpai untuk","ST_CO_SearchProducts_Label":"Produk cari","ST_CO_search":"Cari","ST_Producttable_netQuantity":"Kuantiti bersih","ST_Producttable_subtotal":"jumlah kecil","ST_Producttable_wholesalePrice":"Harga borong","ST_Producttable_retailPrice":"Harga runcit","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Produk","createOrder_select_product":"Pilih produk","createOrder_AddProduct":"Tambah produk","createOrder_AddBtn":"Tambah","CreateOrder_doneBtn":"Selesai","createOrder_productTable_NoProductsAdded":"Tiada produk ditambah","productTable_clearCartBtn":"Keranjang yang jelas","b2b_companyTable_noMainContact":"Tiada kenalan utama yang ada","ST_none":"Tiada","CreateOrder_EnterPoNumber":"Masukkan nombor PO","CreateOrder_chooseDateMsg":"Pilih tarikh","CreateOrder_paymnetTerms":"Terma pembayaran","CreateOrder_TaxExemption":"Pengecualian cukai","draftOrder_CompanyName":"nama syarikat","CreateOrder_Company":"Syarikat","Create_Order_TotalLocations":"Jumlah lokasi","Create_Order_MainContact":"Kenalan utama","Create_Order_PaymentDueLater":"Pembayaran jatuh tempo kemudian","b2b_select_company":"Pilih Syarikat","yourSales_headerLocation":"Lokasi","productsPerPage":"Produk setiap halaman","productTableCartClearButton":"Kosongkan","myCustomers_searchByCustomerOrCompanyName":"Cari mengikut nama pelanggan atau syarikat","ST_Producttable_VolumePricing":"Harga Volume","dashboard_B2BCompanyLocation":"Lokasi Syarikat","customer":"Pelanggan","PaidDate":"Tarikh Dibayar","producttable_discounttypeHeader":"Jenis Diskaun","customerInvoice_DiscountOnSubtotal":"Diskaun pada Subjumlah","ST_Producttable_CartResponse":"Pelanggan tidak layak untuk membeli beberapa produk dalam troli","ST_B2BPriceBreack_CloseBtn":"tutup","B2B_QtyRule_Error_Msg":"Kuantiti tidak sah ditambah. Sila semak peraturan kuantiti.","Customer_Info_Title":"Sila pilih negara dahulu","Customer_Invalid_pinCode_Msg":"Kod pin tidak sah","Edit_DraftOrderAlert_Msg":"Penting: Admin telah menggunakan harga borong untuk pelanggan ini.","Create_Order_DiscountDropdown_value1":"Peratusan","Create_Order_DiscountDropdown_value2":"Jumlah Dolar Tetap","Create_Order_DiscountType_Popup_Value1":"Tukar jenis diskaun","Create_Order_DiscountType_PopUp_Value2":"Diskaun yang telah digunakan akan dialih keluar.","B2B_PriceList_Increment_Msg":"Kenaikan daripada ","B2B_PriceList_Minimum_Msg":"Minimum sebanyak ","B2B_PriceList_Maximum_Msg":"Maksimum sebanyak ","SpecialChar_Error_Msg":"Aksara khas seperti @,#,!,$,& tidak dibenarkan dalam kata laluan","createOrder_ErrorMsgForQuantityLimit":"Anda tidak boleh menambah kuantiti melebihi stok yang ada.","ClientInvoice":"Rep Dibuat","AffiliateOrder":"Pautan Gabungan","CouponOrder":"Kupon Diskaun","ReturnCustomerOrder":"Pesanan Pelanggan","Tagcustomer":"Pesanan Pelanggan","POSOrder":"POS","SharedCart":"Troli Kongsi","RepOnCartPage":"Pilihan Rep","AdminTaggedOrder":"Tag Manual","TaggedCompanyLocationOrder":"Pesanan B2B","WholesaleOrder":"Invois Borong","TeamManager":"Pengurus Pasukan","charsLeft":"char kiri","showing":"Menunjukkan","customers":"pelanggan","exportCsv":"Eksport CSV","all":"Semua","paid":"Dibayar","unpaid":"Tidak dibayar","draft":"Draf","refunded":"Dipulangkan","orderType":"Jenis Pesanan","ShippingCost_AddressError":"Kos penghantaran untuk alamat yang dipilih tidak dikonfigurasi. Sila hubungi pentadbir.","ShippingCost_CustomerAddressAndCartProductError":"Alamat pelanggan dan produk dalam troli adalah wajib untuk mengira kos penghantaran.","ContactCard_Info_Msg":"Kad kenalan menjadikan pautan ahli gabungan anda lebih menarik. Apabila pelanggan menggunakan pautan ahli gabungan, mereka boleh melihat kad kenalan anda di tapak web, memberikan lebih banyak lagi pengalaman membeli-belah yang diperibadikan. Kad ini boleh diperibadikan dengan foto profil dan mesej untuk pelanggan anda.","contact_Cart_Heading":"Kad Kenalan","Affiliate_Link_Info_Msg":"Kongsi pautan ahli gabungan anda dengan pelanggan. Sebarang pesanan yang dibuat dengan menggunakan pautan ahli gabungan anda akan dikaitkan dengan anda","Contact_Card_Bio_Save_Success_Msg":"Bio disimpan dengan jayanya","Affiliate_Add_ProductInfo_Msg":"Tambah produk yang anda ingin kongsikan pautan ahli gabungan","ShareCart_UserGuide_Msg1":"Cipta pautan troli yang boleh dikongsi, pramuat dengan produk terpilih yang disesuaikan dengan pilihan pelanggan anda. Pelanggan boleh menggunakan pautan, menyemak item troli dan teruskan","ShareCart_UserGuide_Msg2":"untuk checkout. Pesanan yang dibuat dengan menggunakan pautan troli anda akan dikaitkan dengan anda.","ShareCart_ToltipTitle":"Keluarkan produk dari troli","Delete_Cart_Confirmation":"Adakah anda pasti mahu memadamkan troli?","No_Share_Cart_Added1":"Tiada pautan troli dibuat sehingga sekarang.","No_Share_Cart_Added2":"Buat troli dan kongsi pautan langsungnya dengan pelanggan anda","ClearCart_Conformation_Msg":"Adakah anda pasti mahu mengalih keluar semua produk daripada troli?","Edit_Billing_Address":"Edit alamat pengebilan","Edit_Shipping_Address":"Edit alamat penghantaran","New_Customer_Select_Msg":"Buat pelanggan baharu","CreateOrder_Manage_Heading":"Uruskan","RemoveCustomer_Msg":"Alih keluar pelanggan","Customer_Address_Apartment":"Pangsapuri, suite, dsb","Address_Enter_Msg":"Masukkan Alamat","Address_Not_Found_Error_Msg":"Alamat pelanggan dan produk dalam troli adalah wajib untuk membuat pesanan","Load_More_Btn":"Muatkan Lagi","Beta_Version_msg1":"Ciri ini pada masa ini dalam versi Beta. Jika anda menghadapi sebarang isu","Beta_Version_msg2":"sila hubungi sokongan.","Heading_Product_Select":"Pilih Produk","Customer_FirstName":"nama pertama","Customer_lastName":"nama keluarga","Customer_Resion":"Negara/wilayah","Customer_pinCode":"Kod PIN","Customer_phone":"telefon","applyDisconutCode_atCheckout":"Benarkan pelanggan menggunakan kupon diskaun semasa pembayaran"}'
        ),
        Mt = JSON.parse(
          '{"dashboard_title":"ÖVERSIKT","dashboard_welcomeMsg":"Välkommen Till","dashboard_morningMsg":"God Morgon","dashboard_afternoonMsg":"God Eftermiddag","dashboard_eveningMsg":"God kväll","dashboard_subTitle1":"NUVARANDE MÅNAD","dashboard_block1Heading":"KUNDFÖRTJÄNST","dashboard_block1Header1":"FÖRTJÄNST","dashboard_block1Header2":"SKICKADE FAKTUROR","dashboard_block1Header3":"BETALDA FAKTUROR","dashboard_block2Heading":"ÅTERFÖRSÄJARE ORDRAR","dashboard_block2Header1":"FÖRTJÄNST","dashboard_block2Header2":"SKICKADE FAKTUROR","dashboard_block2Header3":"BETALADA FAKTUROR","dashboard_block3Heading":"AFFILIATE ORDRAR","dashboard_block3Header1":"FÖRTJÄNST","dashboard_block3Header2":"BETALADA ORDRAR","dashboard_block4Heading":"RABATTKUPONG","dashboard_block4Header1":"FÖRTJÄNST","dashboard_block4Header2":"BETALDA ORDRAR","dashboard_block5Heading":"KUNDFÖRTJÄNST","dashboard_block5Header1":"FÖRTJÄNST","dashboard_block5Header2":"ORDRAR","dashboard_block6Heading":"TEAM LEDNINGSFÖRTJÄNST","dashboard_block6Header1":"FÖRTJÄNST","dashboard_block7Heading":"POS FÖRTJÄNST","dashboard_block7Header1":"FÖRTJÄNST","dashboard_block7Header2":"ORDRAR","dashboard_tbl1column1":"Månad","dashboard_tbl1column2":"Klientfaktura Ordrar","dashboard_tbl1column3":"Klientfaktura Förtjänst","dashboard_tbl1column4":"Återförsäljare Ordrar","dashboard_tbl1column5":"Totalt återförsäljare sålt","dashboard_tbl1column6":"Affiliate Ordrar","dashboard_tbl1column7":"Affilate Förtjänst","dashboard_tbl1column8":"Rabattkupong Ordrar","dashboard_tbl1column9":"Rabattkupong Förtjänst","dashboard_tbl1column10":"Kund ordrar","dashboard_tbl1column11":"Kund Förtjänst","dashboard_tbl1column12":"POS Ordrar","dashboard_tbl1column13":"POS Förtjänst","dashboar_cardHeading1":"Total order","dashboar_cardHeading2":"Provision","dashboar_cardHeading3":"Försäljning","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Försäljningsresultat de senaste sex månaderna","dashboard_graphHeading2":"Analysera funktionens kloka ordning och provision för den aktuella månaden","Graph_Sales_noorderstitle":"ingen order att visa","Graph_SalesRepCommission_nocommissiontitle":"Inga kommissionsdata att visa","Graph_SalesRepOrders_title":"ORDER","Graph_SalesRep_XAxisTitle_ForMonth":"6 månader","Graph_SalesRepOrders_YAxisTitle":"Order","Graph_SalesRepSales_title":"SALES","Graph_SalesRepCommission_title":"PROVISION","Graph_SalesRepCommissions_YAxisTitle":"Provision","Graph_FeatureWiseOrder_title":"Beställningar vs -funktionen","Graph_featureWiseCommission_title":"Commission vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Funktion","Graph_FeatureWiseOrder_YAxisTitle":"Order","Graph_FeatureWiseCommission_title":"PROVISION","Graph_FeatureWiseCommission_YAxisTitle":"Provision","customerInvoice_title":"Skapa order","customerInvoice_button":"Tillbaka","customerInvoice_noclientorderMsg":"Ingen kund faktura ordrar","customerInvoice_button1":"Visa tidigare ordrar","customerInvoice_contentHeading1":"Rabatter och förtjänst på","customerInvoice_table1column1":"Produktyp","customerInvoice_table1column2":"Förtjänst","customerInvoice_table1column3":"Rabattnamn","customerInvoice_table1column4":"Rabatt","customerInvoice_contentHeading2":"Lägg till kunduppgifter och välj produkter att skicka faktura till.","customerInvoice_contentHeading2Title1":"Ange/sök kund","customerInvoice_title1Placeholder":"Ange/sök kund","customerInvoice_contentHeading2Title2":"Skriv in kundens mailadress","customerInvoice_title2Placeholder":"Mailadress","customerInvoice_contentHeading2Title3":"Ange ordernoteringar","customerInvoice_contentHeading2Title4":"Kundadress","customerInvoice_contentHeading2Title5":"Kundens mobilnummer","customerInvoice_contentHeading2Title6":"Kundanmärkning","customerInvoice_contentHeading2Title7":"Kundens företagsnamn","customerInvoice_title7Placeholder":"Företagsnamn","customerInvoice_Placeholder_contentHeading2Title6":"Notera","customerInvoice_Placeholder_contentHeading2Title5":"Mobilnummer","customerInvoice_Placeholder_contentHeading2Title4":"leveransadress","customerInvoice_title3Placeholder":"Beställningsanteckningar","customerInvoice_table2Column1":"Bild","customerInvoice_table2Column2":"Lägg till kvantiet","customerInvoice_table2Column3":"Titel","customerInvoice_table2Column4":"Varierande titel","customerInvoice_ProductTableColumnPrice":"Pris","customerInvoice_table2Column6":"Grossistpris","customerInvoice_button2":"Skapa Faktura","customerInvoice_ProductTableColumnProduct":"Produkt","customerInvoice_table3Column2":"Produktnamn","customerInvoice_table3Column3":"Storlek","customerInvoice_ProductTableColumnQuantity":"Kvantitet","customerInvoice_table3Column5":"Artikelpris","customerInvoice_table3Column6":"Totalt Pris","customerInvoice_table3Column7":"Rabatterat Pris för Kund","customerInvoice_table3Column8":"SäljRep Förtjänst","customerInvoice_table3Column9":"Rabattyp","customerInvoice_repproInvite":"Välj kryssruta att skicka en Pro-Inbjudan","customerInvoice_customerOrder_error1":"All fält är obligatoriska. Skriv in kundens Mail och Förnamn Please enter the customer\'s  email and Förnamn","customerInvoice_productAddedMsg":"Produkten tillagd","customerInvoice_AlertErrorMsg":"Fel.. Vänligen kontakta support!","wholesaleOrder_title":"Återförsäljare Ordrar","wholesaleOrder_contentHeading1":"Du kan köpa produkterna för återförsälj priser","wholesaleOrder_contentHeading2":"Rabatt på","wholesaleOrder_column1":"FörjäntRep Namn","wholesaleOrder_column2":"Rabatt","wholesaleOrder_searchtxtPlaceholder":"Sök Produkter","wholesaleOrder_table1Column1":"Bild","wholesaleOrder_table1Column2":"Lägg till Kvantitet","wholesaleOrder_table1Column3":"Titel","wholesaleOrder_table1Column4":"Varierad Titel","wholesaleOrder_table1Column5":"Pris","wholesaleOrder_button":"Utcheckning","wholesaleOrder_Order_btn":"Visa/Göm Volympriser","wholesaleOrder_contentHeading3":"Totalt Pris","wholesaleOrder_contentHeading4":"Dina Rabatterade Priser","wholesaleOrder_table2Column1":"Produkt","wholesaleOrder_table2Column2":"Produktnamn","wholesaleOrder_table2Column3":"Storlek","wholesaleOrder_table2Column4":"Kvantitet","wholesaleOrder_table2Column5":"Artikelpris","wholesaleOrder_table2Column6":"Totalt pris","wholesaleOrder_table2Column7":"Ditt Rabatterade Pris","affiliateLink_title":"Affiliatelänk","affiliate_product_link":"Produktlänk","affiliateLink_input_error_msg":"Länktextfält är obligatoriskt och får inte innehålla mellanslag.","affiliateLink_contentHeading1":"Dela din affiliate -länk på sociala medier och e -post. Du kommer att få en affiliate -provision för varje beställning från din affiliate -länk","affiliateLink_contentHeading2":"Din affiliate länk","affiliateLink_contentHeading3":"Förtjänst på","affiliateLink_content_Message1":"Sök efter produkter och dela länken till enskilda produkter med er kunder.","affiliateLink_noaffiliateorderMsg":"Inga Affiliate Ordrar","affiliateLink_column1":"SäljRep Namn","affiliateLink_column2":"Förtjänst","affiliateLink_searchtxtPlaceholder":"Sök Produkter","affiliateLink_searchColumn1":"Produkt","affiliateLink_searchColumn2":"Produkt Titel","affiliateLink_searchColumn3":"Pris","affiliateLink_searchColumn4":"Förtjänst","affiliateLink_searchColumn5":"Affiliate Länk","affiliateLink_searchColumn7":"Kopiera länk","affiliateLink_searchColumn8":"Kopierade","affiliateLink_card_Title":"Kontaktkort och anslutet länk","affiliateLink_backbtn":"Tillbaka","cartSharing_title":"Kundvagnsdelning","cartSharing_CreateCartInformation_Text":"För att skapa en personlig varukorg lägger du till produkter från webbshoppen. Dom produkter kommer visas på denna sidan.","cartSharing_content2Placeholder":"Varukorgens Namn","cartSharing_table2Column2":"Produkt Namn","cartSharing_table2Column3":"Storlek","cartSharing_SharedCartLinkTableColumnCartName":"Varukorgens Namn","cartSharing_SharedCartLinkTableColumnLink":"Länk","cartSharing_SharedCartLinkTableColumnCartLink":"Delbar varukorgslänk","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Kopiera Varukorgens Länk","cartSharing_SharedCartLink_Other":"Övrig","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Tag bort Varukorgens Länk","cartSharing_EnterCartName_Label":"Skriv in varukorgens namn","cartSharing_ProductTableColumnProduct":"Produkt","cartSharing_ProductTableColumnQuantity":"Kvantitet","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventory","cartSharing_ProductTableColumnItemPrice":"Artikelpris","cartSharing_table2Column6":"Totalt pris","cartSharing_CartCreating_Msg":"Skapande...","cartSharing_Copied_Msg":"Kopierade !!","cartSharing_SharedCartLinkTableEmpty_Msg":"Ingen länk att visa","cartSharing_CartCreatedSuccessfully_Msg":"Din nya kundvagn har skapats framgångsrikt","cartSharing_CartCreateError_Msg":"Fel.. försök igen","cartSharing_AlertError_Msg":"Fel.. Vänligen kontakta support!","cartSharing_CopyCartLink_Msg":"Kopiera Varukorgens Länk","cartSharing_DeleteCartLink_Msg":"Tag bort Varukorgens Länk","cartSharing_DeleteConfirmation_Msg":"Är du säker ?","cartSharing_ProductTableEmpty_Msg":"Produkten är inte tillgänglig","cartSharing_CreateCart_Btn":"Skapa Varukorg","cartSharing_ProductTableQuantityUpdate_Btn":"Välj produkt","cartSharing_Select_product_Title":"Välj produkt","discountCoupon_titleOne":"Rabattkupong","discountCoupon_contentHeading1":"Dela rabattkupongkoden med dina kunder och närhelst din kupong används får du en provision.","discountCoupon_contentHeading2":"Din Rabattkupong kod är","discountCoupon_contentHeading3":"RabattsummaDiscount Amount","discountCoupon_contentHeading4":"Förtjänst ","discountCoupon_contentHeading4PlaceHolder1":"Hej! Använd min Rabattkupongs kod","discountCoupon_contentHeading4PlaceHolder2":"och få rabatt på produkter","discountCoupon_button1":"Kopiera Text","cartSharing_copiedButtonText":"Kopierad","discountCoupon_titleTwo":"Skapa en engångsrabattkupong för dina kunder","discountCoupon_button2":"Visa Kuponger","discountCoupon_contentHeading5":"Maxtillåten Rabatt","discountCoupon_contentHeading6":"Rabatt","discountCoupon_contentHeading7":"Skriv in Rabattskupongens Kod","discountCoupon_contentHeading7PlaceHolder":"Skriv rabattkupongens Kod","discountCoupon_contentHeading8":"Skriv in Rabatten","discountCoupon_contentHeading8PlaceHolder":"Rabatten bör inte vara större än den maximala rabatten.","discountCoupon_button3":"Skapa Rabattkupong","discountCoupon_coupon_error1":"Skriv in Rabbatkupongens kod och Rabatt","yourBio_title":"Ditt kontaktkort","yourBio_content1":"Ladda up Profil","yourBio_button1":"Välj Fil","yourBio_button1PlaceHolder":"Ingen fil Vald","yourBio_error_image_size":"Bildstorleken är för stor, ladda upp en bild som är mindre än 5 MB. Var god försök igen.","yourBio_button2":"Ladda Upp","yourBio_content2":"Ange anpassat ord för att skapa din unika partnerlänk","yourBio_content2PlaceHolder":"skapa din unika affiliate-länk","yourBio_content4":"När din länk kommer att användas kommer ditt kontaktkort att visas på hemsidan","yourBio_content3":"Ange ditt kontaktkort","yourBio_content3PlaceHolder":"Skriv in 100 ord","yourBio_button3":"Spara","yourBio_button4":"Sparad","yourBio_error_link":"Denna unika länken är upptagen. Försök med en annan unik länk.","yourBio_Linksuccessmsg":"Unik länk sparad.","team_title1":"Lägg till SäljareRep","team_content1":"Skriv in din mailadress","team_content1PlaceHolder":"Mailadress","team_emailerrorMsg":"Skriv in mailadress","team_content2":"Skriv Förnamn","team_content2PlaceHolder":"Förnamn","team_fnameerrorMsg":"Skriv in ditt Förnamn","team_content3":"Skriv in ditt Efternamn","team_content3PlaceHolder":"Efternamn","team_button1":"Lägg Till","team_successmsg":"Representanten har lagts till framgångsrikt. Hen kommer att få inloggningsuppgifter till den angivna e-postadressen.","team_errorsmsg":"Fel vid tilläggning. Det finns redan ett konto med denna mailadressen.","team_title2":"Team Detaljer","team_content4":"Inskrivningsida","team_NoTeamDetailsMsg":"Inga Team Detaljer","team_content5":"Välj SäljRep","team_tableTitle":"SENASTE TVÅ MÅNADERNA ORDERDETALJER","team_column1":"Ordernummer","team_column2":"Orderdatum","team_column3":"Kundens Namn","team_column4":"Försäjningar Rep","team_column5":"Delsumma Totalt","team_column6":"Försäljningskommission","team_column7":"teamchefkommission","team_column8":"Försäljningsmetod","addCustomer_title":"lägg Till Kund","addCustomer_content1":"Skriv in Kundens Förnamn","addCustomer_txt1Placeholder":"Förnamn","addCustomer_content2":"Skriv in Kundens Efternamn","addCustomer_content2Placeholder":"Efternamn","addCustomer_content3":"Skriv in Kundens Mailadress","addCustomer_content3Placeholder":"Mailadress","addCustomer_content4":"Anteckningar","addCustomer_content4Placeholder":"Anteckningar","addCustomer_customerAddress":"Personlig Adress","addCustomer_customerCity":"Stad","addCustomer_customerCityPlaceholder":"Stad","addCustomer_customerCountry":"Land","addCustomer_customerState":"Kommun","addCustomer_customerZipCode":"Postadress","addCustomer_companyName":"Företagsnamn","addCustomer_companyAddress":"Företagets adress","addCustomer_companyCity":"Stad","addCustomer_companyCountry":"Land","addCustomer_companyState":"Kommun","addCustomer_companyZipCode":"Postadress","addCustomer_button":"Spara","addCustomer_leadsuccessmsg":"Kunden är Tillagd.","addCustomer_leadErrrorMsg":"Fel vid sparande utav Uppgifter.","addCustomer_leadEmptyErrrorMsg":"Var god fyll i dom obligatoriska fälten.","addCustomer_leadsuccessmsg2":"Kunden är låst till Represantören.","addCustomer_leadErrrorMsg2":"Den här kunden är redan taggad till en Reprensantör.","myCustomers_title":"Dina Kunder","myCustomers_table1Column1":"Namn","myCustomers_table1Column2":"Företagsnamn","myCustomers_table1Column3":"Mailadress","myCustomers_table1Column4":"Ordrar","myCustomers_table1Column5":"Totalt Spenderat","myCustomers_table2Title":"KUNDENS UPPGIFTER","myCustomers_table3Title":"FÖRSLAG TILL BESTÄLLNINGSDETALJER","myCustomers_table3Column1":"Produktnamn","myCustomers_table3Column2":"Storlek","myCustomers_table3Column3":"Kvantitet","myCustomers_table3Column4":"Pris","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Delsumma","myCustomers_table2Row1":"Namn","myCustomers_table2Row2":"Mailadress","myCustomers_table2Row3":"Adress","myCustomers_table2Row4":"Företagsnamn","myCustomers_table2Row5":"Kundens anteckningar","myCustomers_table2Row6":"Totalt Spenderat(Delsumma+Skatt)","myCustomers_table2Row7":"Antal Ordrar","myCustomers_table2Row8":"Taggar","myCustomers_radioButton0":"Visa alla kunder","myCustomers_radioButton1":"Sök efter namn","myCustomers_radioButton2":"Sök efter företag","myCustomers_radioButtonError1":"Välj söktyp och ange värde för sökning","myCustomers_radioButtonError2":"Ange värde för att söka","myCustomers_radioButtonError3":"Välj söktyp","myCustomers_searchButton":"Sök","myCustomers_Placeholder1":"Skriv kundnamn eller företagsnamn för sökning","myCustomers_NoOrdersError":"Inga beställningar","myCustomer_no_salesRep_details":"Inga försäljningsrepresentanter finns tillgängliga.","myCustomer_select_customer_country":"Välj kundland","myCustomer_company_country":"Företagsland","myCustomer_company_state":"Företagsstat","myCustomer_select_company_country":"Välj företagsland","yourSales_SalesOrderDetailsTitle":"Försäljningsorderdetaljer","yourSales_title":"Senaste 2 månaders beställningsinformation","yourSales_table1Column1":"Ordernummer","yourSales_table1Column2":"Orderdatum","yourSales_table1Column3":"Kundens Namn","yourSales_table1Column4":"Delsumma","yourSales_table1Column5":"Förtjänst","yourSales_table1Column6":"Förtjänst Typ","yourSales_table1Column7":"Skriv ut Faktura","printOrderInvoice_btn":"Skriv ut","yourSales_tableTitle":"Produktdetaljer","yourSalesDraft_tableTitle":"FÖRSLAG TILL BESTÄLLNINGSDETALJER","yourSales_column1":"Produkt","yourSales_column2":"Titel","yourSales_column3":"Kvantitet","yourSales_column4":"Artikelpris","yourSales_column5":"Spårningsnummer","yourSales_column6":"Leveransdatum","yourSales_column7":"Totalt Pris","yourSales_content1":"Delsumma","yourSales_content2":"Skatt","yourSales_content3":"Fraktkostnad","yourSales_content4":"Totalt","yourSales_content5":"Anteckning","yourSales_tabHeading1":"Betalda beställningar","yourSales_tabHeading4":"Väntande beställningar","yourSales_tabHeading2":"Utkast till beställningar","myOrders_title":"Mina beställningsdetaljer","myOrdersDetails_Message":"Beställningar för dig själv","myOrders_table1Column1":"Ordernummer","myOrders_table1Column2":"Orderdatum","myOrders_table1Column3":"Kundens Namn","myOrders_table1Column4":"Betalning","myOrders_table1Column5":"Uppfyllt","myOrders_table1Column6":"Totalt","myOrders_tableTitle":"PRODUKTDETALJER","myOrders_table2Column1":"Produkt","myOrders_table2Column2":"Titel","myOrders_table2Column3":"Kvantitet","myOrders_table2Column4":"Artikelpris","myOrders_table2Column5":"Spårningsnummer","myOrders_table2Column6":"Leveransdatum","myOrders_table2Column7":"Totalt Pris","myOrders_content1":"Delsumma","myOrders_content2":"Skatt","myOrders_content3":"Fraktkostnad","myOrders_content4":"Totalt","myOrders_content5":"Anteckning","myOrders_content6":"Utkast till id","tab_Dashboard":"Översikt","dashbord_Tab":"Hem","tab_CustomerInvoice":"Skapa order","tab3_WholesaleOrder":"Återförsäljare Ordrar","tab_AffiliateLink":"Affiliate Länk","tab_CartSharing":"Kundvagnsdelning","tab_DiscountCoupon":"Rabattkupong","tab7_YourBio":"Ditt kontaktkort","tab8_Team":"Team","tab9_AddCustomer":"Lägg till Kund","tab_MyCustomers":"Mina Kunder","tab_YourSalesOrderDetails":"Dina säljorder Detaljer","tab12_MyOrders":"Mina beställningsdetaljer","tab13_Logout":"Logga ut","signUp_title":"Säljrepresentant inskrivning","signUp_subTitle":"Fyll i detta formuläret för att skriva in dig som Säljrepresentant och få tillgång till alla säljteams funktioner.","signUp_content1":"Mailadress","signUp_content2":"Förnamn","signUp_content3":"Efternamn","signUp_content4":"Telefonnummer","signUp_content5":"Facebookprofil","signUp_content6":"Twitter-handtag ","signUp_content7":"Instagramprofil","signUp_content8":"Ladda upp profilbild ","signUp_socialmedialable1":"Sociala medier","signUp_socialmedialable2":"frivillig ","signUp_uploadBtn":"Välj Fil","signUp_uploadBtnPlaceHolder":"Ingen fil Vald","signUp_button3":"Sparar information ...","signUp_welcomemsg1":"Hej","signUp_welcomemsg2":"skriv in dig som Säljrepresentant och få en Förtjänst från säljare dina säljare","signUp_emailerror":"Ange Mailadress","signUp_Fnameerror":"Ange Förnamn","signUp_lnameerror":"Ange efternamn ","signUp_phnumbererror":"Ange telefonnummer","signUp_successmsg":"Din registreringsförfrågan har skickats in framgångsrikt. Du kommer att få kontots inloggningsuppgifter via e-post när administratören godkänner din förfrågan. För mer information, kontakta butikens administratör.","signUp_errorsmsg":"Fel vid Sparande utav Uppgifter. Den här användarens mailadress har redan konto.","signUp_RepExistErrorMsg":"Den här mailadressen är registrerad som Säljrep.","addingRep_selectRepsLabel1":"Vem hjälpte dig?","addingRep_NoSalesRep":"Ingen SäljRep","addingRep_successMsg":"La till SälRep ID till Varukorgens anteckingar","addingRep_selectRepsLabel2":"Var god välj en artikel i listan.","wholesaleOrder_WholesaleDiscountTableColumn1":"Produkt Titel","wholesaleOrder_WholesaleDiscountTableColumn2":"Rabatt","customerInvoice_ViewClientOrdersColumn1":"Kundens Namn","customerInvoice_ViewClientOrdersColumn2":"Produkt Titel","customerInvoice_ViewClientOrdersColumn3":"Delsumma Pris","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Faktura","salesRep_order_errorMsg":"Fel vid skapande utav din order. Kontakta kundtjänst.","salesRep_order_successMsg":"Orderfaktura skapad! Fakturan har blivit skickad till kunden!","salesRep_order_errorMsg2":"Fel vid skapande utav din order. Kontakta kundtjänst","customedraft_btn1":"Skapa ny Faktura","customedraft_btn2":"Inga produkter valda. Välj produkter och försök igen.","customedraft_btn3":"Skapa Order...","customedraft_btn4":"Skapa ny Faktura","salesRep_order_NoProductSelected":"Ingen produkt vald. Välj produkt och försök igen.","productnotselectforcartsharingtxt1":"Ingen produkt vald. Välj produkt och försök igen.","discountCoupons_tblColumn1":"Rabattkupongs kod","discountCoupons_tblColumn2":"Rabattkupongens rabatt","discountCoupons_tblColumn3":"Tag bort Rabattkupongens Kod","discountedPriceLabel":"Ditt rabatterade Pris:","couponCodeNotSet":"Rabattkupongens kod är inte aktiverad","dashboard_subTitle2":"Nuvarande månadscykel 5:e-4:e","affiliatelink_commissiononlbl":"Produkt","displaycommission_lbl1":"Produkt typ","displaycommission_lbl2":"SäljRep","displaycommission_lbl3":"Kvantitets baserad Rabatt","discountcommissiononlbl1":"Klientens Rabattnivåer","clientInvoiceCommissionTablecolumn1":"Produkt Typ","clientInvoiceCommissionTablecolumn2":"Förtjänst","clientInvoiceCommissionTablecolumn3":"Produkt Titel","clientInvoiceCommissionTablecolumn4":"SäljareRep Namn","clientInvoiceQuantityBaseDiscountTablecolumn1":"Produkt Namn","clientInvoiceQuantityBaseDiscountTablecolumn2":"Rabatt","clientInvoiceQuantityBaseDiscountTablecolumn3":"Kvantitet","affiliateCartProdtableColumn1":"Produkt","affiliateCartProdtableColumn2":"Produkt Titel","affiliateCartProdtableColumn3":"pris","affiliateCartProdtableColumn4":"Förtjänst","affiliateCartProdtableColumn5":"Affiliate Länk","affiliateCartProdtableColumn6":"Delningslänk","productnotselectforcartsharinglbl1":"Skriv in Varukorgens Namn","productnotselectforcartsharinglbl2":"Inga produkter Valda. Välj produkter och försök igen.","productnotselectforcartsharinglbl3":"Vänta, bearbetar...","showSharedCartProductcolumn1":"Varukorgens länk","showSharedCartProductcolumn3":"Tag bort Varukorg","onSuccessInvoiceSuccessMsg":"Faktura Skickad","onSuccessInvoiceFailedMsg":"Fakutrasändning misslyckades","sendInvoice_successMsg":"Faktura skickad","deleteInvoice_successMsg":"Faktura borttage","deleteInvoice_FailedMsg":"Bortagning utav Faktura Misslyckades","deleteInvoice_btnlbl":"Tar bort Faktura","deleteSharedCartLink_successMsg":"Länk Borttagen","deleteSharedCartLink_FailedMsg":"Fel vid borttagning utav länk. Var god försök igen..","deleteSharedCartLink_btnlbl":"Tar bort länk","viewInvoiceOrders_btntxt1":"Mottar...","viewInvoiceOrders_btntxt2":"Visa Tidigare Ordrar","createCoupon_btnlbl1":"Skapar Rabattkupong..","createCoupon_btnlbl2":"Rabattkupong Skapad","deleteCoupon_successMsg":"Rabattkupong Borttagen","deleteCoupon_FailedMsg":"Borttagning utav Rabattkupong Misslyckades","deleteCoupon_btnlbl":"Tar bort...","viewProductModelColumn1":"Produkt","viewProductModelColumn2":"Titel","viewProductModelColumn3":"Kvantitet","viewProductModelColumn4":"Återbetalt belopp","viewProductModelColumn5":"Artikelpris","viewProductModelColumn6":"Rabatterat Pris","viewProductModelColumn7":"Spårningsnummer","viewProductModelColumn8":"Leveransdatum","viewProductModelColumn9":"Totalt Pris","showSharedCartProducts_column2":"Bild","showSharedCartProducts_column3":"Lägg till kvantitet","showSharedCartProducts_column4":"Titel","showSharedCartProducts_column5":"Varierad Titel","showSharedCartProducts_column6":"Pris","viewClientOrders_btn1":"Visa","viewClientOrders_btn2":"Skicka","viewClientOrders_btn3":"Radera","showCouponTable_txt1":"Mottar...","showCoupon_btn2":"Visa Rabattkuponger","showCoupon_btn1":"Kopierad","affliateOrder_column1":"Kundens Namn","affliateOrder_column2":"Kundens Mailadress","affliateOrder_column3":"Produkt Titel","affliateOrder_column4":"Order Datum","affliateOrder_column5":"Delsumma","affliateOrder_column6":"Förtjänst","affliateOrder_btn1":"Mottar...","affliateOrder_btn2":"Visa Affiliate Ordrar","affliateOrder_btn3":"Visa Affiliate Ordrar","yourBio_btn1":"Spara","yourBio_btn2":"Spara","yourBio_Uploadbtn1":"Uppladdning...","yourBio_Uploadbtn2":"Uppladdat","yourBio_UploadbtnError":"Ursäkta, försök igen","yourBio_Savebtn":"Sparar..","team_txt1":"Sparar..","team_txt2":"Spara","viewRepClientOrdersDetails_column1":"Ordernummer","viewRepClientOrdersDetails_column2":"Order Date","viewRepClientOrdersDetails_column3":"Delsumma","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Produktdetaljer","addSalesRep_txt1":"Lägg till SäljareRep","addSalesRep_txt2":"Lägger Till SäljarRep...","discountCoupons_header":"Engångs Rabattkuponger","discountCoupons_nodiscountcoupon":"Du har inte skapat några Rabattkuponger","discountCoupons_deleteBtn":"Tag Bort","discountCoupons_BackBtn":"Tillbaka","customerInvoice_selectcustomererror":"Välj kund och lägg sedan till produkt","createOrderFromCartPage_selectCustomersLabel":"VÄLJ KUND","createOrderFromCartPage_selectCustomerAddressLabel":"LEVERANSADRESS","createOrderFromCartPage_selectCustomersLabelForDropDown":"Välj kund","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Välj Adress","createOrderFromCartPage_successMsg":"Beställningsfaktura skapad! Faktura har skickats till kund!","createOrderFromCartPage_AddNewAddressTitle":"LÄGG TILL NY ADRESS","createOrderFromCartPage_draftOrderButton":"SKAPA KRAFTBESTÄLLNING","createOrderFromCartPage_OrderButton":"SKAPA BESTÄLLNING","createOrderFromCartPage_draftOrderButtonText2":"SKAPA BESTÄLLNING ...","createOrderFromCartPage_selectShippingCostTitle":"FRAKTKOSTNAD","createOrderFromCartPage_Address_errorMsg4":"Det gick inte att beräkna dina fraktpriser.","createOrderFromCartPage_Address_errorMsg5":"Något gick fel, försök igen.","yourSales_tabHeading3":"Återbetalningsbeställningar","refundOrders_column1":"Återbetalnings-ID","refundOrders_column2":"Orderdatum","refundOrders_column3":"Ordernummer","refundOrders_column4":"Beställningsnamn","refundOrders_column5":"Provision","refundOrders_column6":"Team Manager Commission","refundOrders_column7":"Team Manager ID","refundOrders_column8":"Återbetalning delsumma","refundOrders_column9":"Orderstatus","refundOrders_column10":"Försäljningsmetod","refundOrderNumber_title":"Återbetalningsbeställningsdetaljer","refundOrderNumber_column1":"namn","refundOrderNumber_column2":"Datum","refundOrderNumber_column3":"Kvantitet","refundOrderNumber_column4":"Rea-pris","refundOrderNumber_column5":"delsumma","tableDataError":"Ingen återbetalningsorder","dashboard_subTitle3":"Uppgifter om kommissionen","dashboard_cardHeading5_1":"kommissionen på","dashboard_cardHeading5_2":"Du kommer att få en","dashboard_cardHeading5_3":"provision på alla beställningar.","Profit_Margin":"Vinstmarginal","Product_Type":"Produkttyp","Sales_Rep":"Säljare","show_commission_list":"Visa provisionslista","commission_list":"Kommissionsförteckning","no_customers_to_show":"Inga kunder att visa","no_sales_to_show":"Ingen försäljning att visa","no_draft_to_show":"Inget utkast att visa","no_refund_to_show":"Ingen återbetalning att visa","no_orders_to_show":"Inga beställningar att visa","customerInvoice_ViewClientOrdersColumn6":"Ordernummer","customerInvoice_ViewClientOrdersColumn7":"Orderdatum","Error_commissions_NotUpdated":"Provisioner uppdateras inte","sales_chart_msg1":"Vi behöver data...","sales_chart_msg2":"Det verkar som att vi inte har några uppgifter att visa ännu.","page_refresh_msg":"klicka för att uppdatera","variant_title":"Varianttitel","line_items_properties":"Egenskaper","customer_country":"Kundland","customer_state":"Kundstat","company_country":"Företagsland","company_state":"Företagsstat","client_orders":"Kundordrar","no_product_details":"Inga produktdetaljer att visa","submit_btn_text":"Skicka in","submitting_btn_text":"Skickar in","submitted_btn_text":"Lämnats","email_id_validation_errmsg":"Vänligen ange ett giltigt e-post-ID","customerInvoice_add_more_details":"Lägg till fler detaljer","customerInvoice_add_shipping_address":"Lägg till ny leveransadress","customerInvoice_HideDetails":"Gömma detaljer","customerInvoice_HideAddress":"Dölj leveransadress","customerInvoice_enterFirstName":"Ange förnamn","customerInvoice_enterFirstNamePlaceholder":"Förnamn","customerInvoice_enterLastName":"Ange efternamn","customerInvoice_enterLastNamePlaceholder":"Efternamn","customerInvoice_enterAddress1":"Ange adressrad 1","customerInvoice_enterAddress1Placeholder":"Adressrad 1","customerInvoice_enterAddress2":"Ange adressrad 2","customerInvoice_enterAddress2Placeholder":"Adress Linje 2","customerInvoice_enterCity":"Gå in i staden","customerInvoice_enterCityPlaceholder":"Stad","customerInvoice_selectCountry":"Välj land","customerInvoice_selectState":"Välj stat","customerInvoice_enterZipNumber":"Ange postnummer","customerInvoice_enterZipNumberPlaceholder":"Postnummer","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventory","customerInvoice_ProductTableEmpty_Msg":"Produkten är inte tillgänglig","customerInvoice_SendInvoiceBtn":"Skicka faktura","customerInvoice_CreateBtn":"Skapa","customerInvoice_CreatingBtn":"Skapande","customerInvoice_ProductTableColumnSubTotal":"Subsumma","customerInvoice_SelectShippingAddress":"Välj leveransadress","customerInvoice_ProductsSearchBy_Placeholder":"Sök efter produkter efter namn, SKU, pris","customerInvoice_AddMoreProducts_Btn":"Lägg till fler produkter","customerInvoice_RequiredErrorMsg":"Detta fält är obligatoriskt","customerInvoice_EmailSuggestionErrorMsg":"Vänligen lägg till ett giltigt e-post-ID","customerInvoice_MobileSuggestionErrorMsg":"Vänligen lägg till giltigt telefonnummer","customerInvoice_ErrorMsgAddShippingAddress":"Vänligen fyll i leveransadress","customerInvoice_Creating_Msg":"Skapande...","customerInvoice_Sending_Msg":"Sändning...","customerInvoice_OrderCreatedSuccessfullyMsg":"Beställning skapad framgångsrikt","customerInvoice_InvoiceSentSuccessfullyMsg":"Faktura har skickats till kunden","customerInvoice_ErrorMsgTryAgain":"Fel.. försök igen","customerInvoice_Selected_Btn":"Vald","customerInvoice_ProductTableQuantityUpdate_Btn":"Välj produkt","customerInvoice_OrderSubTotal":"Beställningens totala kostnad","delete_confirmation_text":"Är du säker ?","draftOrder_OrderNumber":"Ordernummer","draftOrder_CustName":"Köparens namn","draftOrder_OrderDate":"Orderdatum","draftOrder_SubTotal":"Summan","draftOrder_Status":"Status","draftOrder_Invoice":"Faktura","draftOrder_DraftId":"Utkast till ID","draftOrder_ShippingCost":"Fraktkostnad","draftOrder_Tax":"Beskatta","draftOrder_TotalPrice":"Totalbelopp","draftOrder_Note":"Notera","draftOrder_Product":"Produkt","draftOrder_ProductName":"produktnamn","draftOrder_Size":"Storlek","draftOrder_Quantity":"Kvantitet","draftOrder_Price":"Pris","noDraftOrderProducts":"Inga utkast till beställningsproduktdetaljer tillgängligt.","noRefundOrderProduct":"Inga produktinformation för återbetalningsorder.","loading":"Läser in...","dashboard_commissionOn_profitMargin":"Provision på vinstmarginal","dashboard_clientInvoice":"Klientfaktura","dashboard_affiliateLink":"Affiliate order","dashboard_returnCustomer":"Returnera kunden","dashboard_discountCoupon":"Rabattkupong","dashboard_SharedCart":"Delad kundvagn","dashboard_AdminTaggedOrders":"Admin Tagged Order","dashboard_no_data":"Ingen data tillgänglig","dashboard_sales_of_last_six_months":"Försäljning av de senaste 6 månaderna","dashboard_sales_of_current_month":"Försäljning av den aktuella månaden","addCustomer_ErrorMsgOnSubmitBtn":"var vänlig och slå in ett giltigt telefonnummer","login_welcome_Msg":"Välkommen till säljteamet","login_title":"Logga in","login_email":"E-post ID","login_password":"Lösenord","emailValidation_ErrorMsg":"Ange giltigt e -post -ID","login_newUser":"Ny användare?","login_SignUp":"Bli Medlem","login_forgotPassword_link":"Glömt ditt lösenord?","login_LogInBtn":"Logga in","login_sliderContent_1":"Reps -beställning av klienter","login_sliderContent_2":"Rep driver trafik till butik","login_sliderContent_3":"Reps marknadsföringsprodukter med sociala medieplattformar","login_sliderContent_4":"Rep kan köpa i bulk och tjäna vinst","login_sliderContent_5":"Reps -beställning av klienter","login_sliderContent_6":"Reps kan besöka kunder personligen och skapa beställningar","required_ErrorMsg":"Vänligen fyll obligatorisk fält","signup_title":"Bli Medlem","signup_BackTo_login":"Tillbaka till login","signup_firstName":"Förnamn","signup_lastName":"Efternamn","signup_BackBtn":"Tillbaka","signup_NextBtn":"Nästa","signup_phone_number":"Telefonnummer","signup_phone_number_Error":"Ange minst 10 siffror","signup_uploadPicture":"Ladda upp profilbild","signup_fileSizeError":"Filstorleken är större än 5 MB","signup_filePath_lable":"Vald fil","signup_MediaTitle2":"Länkar på sociala medier","signup_facebookHandle":"Facebookhandtag","signup_InstaHandle":"Instagram -handtag","signup_SaveBtn":"Spara information","forgotPwd_title":"Glömt ditt lösenord","forgotPwd_ResetBtn":"Återställ lösenord","forgotPwd_SuccessMsg":"Din begäran om återställningslösenord är framgångsrik, vi har skickat det nya lösenordet till ditt registrerade e -post -ID.","customerInvoice_selectShippingCost":"Välj Fraktkostnad","customerInvoice_CalculatingShippingRates_Msg":"Beräknande...","customerInvoice_AddShippingAddress_Msg":"Välj Adress eller Lägg till leveransadress","customerInvoice_PleaseSetAnyShippingAddressMsg":"Vänligen välj en leveransadress","customerInvoice_ShippingCostErrorMsg":"Vänligen lägg till ny leveransadress, eftersom adressen har otillräcklig information.","customerInvoice_CalculateShippingCost_Btn":"Beräkna fraktkostnad","customerInvoice_ShippingCostAddOrNot_Msg":"Vill du lägga till fraktkostnad?","customerInvoice_ShippingCostAddOrNot_Yes":"Ja","customerInvoice_ShippingCostAddOrNot_No":"Nej","customerInvoice_ShippingCostErrorMsg_TryAgain":"Var god försök igen","dashboard_BannerMsg":"Grafer uppdateras var 8: e timme","yourSales__BannerMsg":"Beställningsinformation uppdateras var 5:e minut","customerInvoice_FirstNameErrorMsg":"Vänligen ange förnamn","customerInvoice_lastNameErrorMsg":"Vänligen ange efternamn","customerInvoice_Add1ErrorMsg":"Ange adressrad 1","customerInvoice_CountryErrorMsg":"Välj land","customerInvoice_StateErrorMsg":"Vänligen välj stat","customerInvoice_CityErrorMsg":"Ange stadens namn","customerInvoice_ZipErrorMsg":"Vänligen ange postnummer","uploadImage":"Ladda upp bild","dashboard_CardTitle1":"Kommission för alla beställningar","dashboard_CardTitle3":"Total provision","dashboard_TotalRevenue":"Totala intäkter","dashboard_TotalAvg_Ticket_Size":"Genomsnittlig biljettstorlek","dashboard_CardTitle4":"Total rea","profile_Change_Password":"Ändra lösenord","dashboard_Information_Message":"Kommissionen spåras endast för betalda beställningar","resetPassword_validation_Msg":"Detta fält krävs","resetPassword_validation_Msg2":"Lösenordet ska innehålla minst 8 tecken, 1 versaler, 1 små bokstäver, 1 siffra etc.","resetPassword_validation_Msg3":"Bekräfta lösenordet ska matcha med nytt lösenord","dashbord_Msg_New":"Hur det fungerar","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximal rabatt är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","discount_couponErrorMsg2":"Kommissionen är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","dashbord_profile_pic":"Ändra profilbild","Performance_Details":"Prestationsdetaljer","Show_Performance_Details":"Visa prestandainformation","Dashboard_Month":"Månad","Dashboard_Orders_Total":"Totala beställningar","Dashboard_Total_Sale":"Total försäljning","Dashboard_Commission":"Provision","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Vänligen lägg till kundadress.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Vänligen välj en fraktkostnad.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Varukorgen har inte uppdaterats, uppdatera och försök igen.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Vänligen välj produkt.","customerInvoice_CreatingDraft_Msg":"Utkast skapas..","customerInvoice_DraftOrderBtn":"Utkast till order","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Utkast till order har skapats framgångsrikt","productTable_error_AlertMsg":"Kvantitet kan inte vara 0 eller mindre, ange något giltigt värde","productTable_error_AlertMsg2":"Ange kvantitet","click_to_copy":"Klicka för att kopiera","discount_code_copy_coupon":"Kopieringskupong","createOrder_productSearchGuide":"Kan du inte hitta produkter?","soldOut":"Utsåld","InventoryNotTracked":"Inventering spåras inte","productStatus":"Produktstatus","makeSureInShopify":"Se till i Shopify","products":"Produkter","sectionTheProductStatusIs":"avsnittet är produktens status","active":"Aktiva","productsMayBeSoldOutPleaseCheck":"Produkter kan vara slutsålda, kontrollera och välj","yourSales_PaidOrders_PaidDate":"Betalningsdatum","ordersLoading":"Beställningar laddas...","productsLoading":"Produkter laddas...","leaveOnPageBtn":"Fortsätta","stayOnPageBtn":"Stanna på denna sida","alertBoxTitle":"Skapa beställningssida","alertMessage":"Osparade ändringar kommer att gå förlorade. Du kan spara den här beställningen som ett utkast.","salesDetailsHeader_Location":"Plats","tab_CreateB2BOrder":"B2B -beställning","b2b_no_company_data_available":"Inga företagsdata tillgängliga","b2b_select_location":"Välj plats","b2b_select_customer":"Välj kund","b2b_select_location_customer":"Välj kund/plats","b2b_SelectedCompanyDetails":"Valda företagsinformation","b2b_no_location_data":"Inga platser tillgängliga","b2b_no_customer_data":"Ingen kunddata tillgänglig","b2b_removeSelectedCustomer":"Avlägsna","b2b_emailId":"E-post ID","b2b_customerName":"Köparens namn","b2b_companyName":"Företagsnamn","b2b_BillingAddress":"Fakturaadress","b2b_ShippingAddress":"leveransadress","ST_CO_no_result_found_msg":"Inga resultat hittades för","ST_CO_SearchProducts_Label":"Sökprodukter","ST_CO_search":"Sök","ST_Producttable_netQuantity":"Nettokvantitet","ST_Producttable_subtotal":"Delsumma","ST_Producttable_wholesalePrice":"Grossistpris","ST_Producttable_retailPrice":"Retails pris","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Produkt","createOrder_select_product":"Välj produkt","createOrder_AddProduct":"Lägg till produkt","createOrder_AddBtn":"Lägg till","CreateOrder_doneBtn":"Gjort","createOrder_productTable_NoProductsAdded":"Inga produkter tillagda","productTable_clearCartBtn":"Rensad vagn","b2b_companyTable_noMainContact":"Ingen huvudkontakt tillgänglig","ST_none":"Ingen","CreateOrder_EnterPoNumber":"Ange PO -nummer","CreateOrder_chooseDateMsg":"Välj ett datum","CreateOrder_paymnetTerms":"Betalningsvillkor","CreateOrder_TaxExemption":"Skattebefrielse","draftOrder_CompanyName":"Företagsnamn","CreateOrder_Company":"Företag","Create_Order_TotalLocations":"Totala platser","Create_Order_MainContact":"Huvudkontakt","Create_Order_PaymentDueLater":"Betalning förfaller senare","b2b_select_company":"Välj företag","yourSales_headerLocation":"Plats","salesDetailsHeader_Company":"Företag","customerInvoice_PaymentPending":"Betalning behandlas","customerInvoice_Checkout":"Kolla upp","customerInvoice_ProceedToCheckout":"Fortsätt till utcheckningen","customerInvoice_CheckoutMsg":"Detta kommer att generera ett utkast till beställning som omdirigerar dig till kassasidan. Om kassningsprocessen inte lyckas kan du hitta den här beställningen i fliken Försäljningsorderinformation under utkast till beställningar.","customerInvoice_sendInvoiceToCustomer":"Skicka faktura till kunden","customerInvoice_cancel":"Annullera","Checkout_DoNotAskAgainMsg":"Fråga inte igen","RepCheckout_RedirectionMsg":"Omdirigering till kassan","customerInvoice_CreatingDraftCheckout":"Utkast till att skapa med kassan ...","customerInvoice_OrderType":"Försäljningsmetod","DoNotShowAgain":"Visa inte igen","copyLinkSuccess":"Länk kopieras framgångsrikt","affiliateLink_Confirmation_Msg1":"Affiliate länkorder spårning fungerar endast om kunden klickar på","affiliateLinkConfirmationMsg2":"Lägg till i kundvagn","affiliateLink_Confirmation_Msg3":"knappen och inte kommer att vara effektiv om kunden klickar på","affiliateLink_Confirmation_Msg4":"Köp nu","affiliateLink_Confirmation_Msg5":"Knapp.","affiliateLink_Confirmation_Note":"NOTERA","productsPerPage":"Produkter per sida","productTableCartClearButton":"Rensa","myCustomers_searchByCustomerOrCompanyName":"Sök efter kund- eller företagsnamn","ST_Producttable_VolumePricing":"Volymprissättning","dashboard_B2BCompanyLocation":"Företagets plats","customer":"Kund","PaidDate":"Betalt datum","producttable_discounttypeHeader":"Rabatttyp","customerInvoice_DiscountOnSubtotal":"Rabatt på Delsumma","ST_Producttable_CartResponse":"Kunden är inte berättigad att köpa vissa av produkterna i kundvagnen","ST_B2BPriceBreack_CloseBtn":"Stänga","B2B_QtyRule_Error_Msg":"Ogiltig kvantitet har lagts till. Kontrollera kvantitetsreglerna.","Customer_Info_Title":"Välj land först","Customer_Invalid_pinCode_Msg":"Ogiltig pinkod","Edit_DraftOrderAlert_Msg":"Viktigt: Admin har tillämpat grossistpriser för denna kund.","Create_Order_DiscountDropdown_value1":"Procentsats","Create_Order_DiscountDropdown_value2":"Fast dollarbelopp","Create_Order_DiscountType_Popup_Value1":"Ändra rabatttyp","Create_Order_DiscountType_PopUp_Value2":"Redan tillämpade rabatter tas bort.","B2B_PriceList_Increment_Msg":"Ökning av ","B2B_PriceList_Minimum_Msg":"Minst ","B2B_PriceList_Maximum_Msg":"Max ","SpecialChar_Error_Msg":"Specialtecken som @,#,!,$,& är inte tillåtna i lösenordet","createOrder_ErrorMsgForQuantityLimit":"Du kan inte lägga till mer kvantitet än vad som finns i lager.","ClientInvoice":"Rep Skapad","AffiliateOrder":"Affiliate Link","CouponOrder":"Rabattkupong","ReturnCustomerOrder":"Kundorder","Tagcustomer":"Kundorder","POSOrder":"POS","SharedCart":"Dela kundvagn","RepOnCartPage":"Rep Val","AdminTaggedOrder":"Manuell taggning","TaggedCompanyLocationOrder":"B2B Order","WholesaleOrder":"Grossistfaktura","TeamManager":"Teamchef","charsLeft":"char kvar","showing":"Visar","customers":"kunder","exportCsv":"Exportera CSV","all":"Alla","paid":"Betalt","unpaid":"Obetalt","draft":"Utkast","refunded":"Återbetald","orderType":"Beställningstyp","ShippingCost_AddressError":"Fraktkostnaden för den valda adressen är inte konfigurerad. Vänligen kontakta administratören.","ShippingCost_CustomerAddressAndCartProductError":"Kundens adress och produkter i kundvagnen är obligatoriska för att beräkna fraktkostnaden.","ContactCard_Info_Msg":"Kontaktkort gör dina affiliate-länkar mer tilltalande. När en kund använder en affiliate-länk kan de se ditt kontaktkort på webbplatsen, vilket ger en mer personlig shoppingupplevelse. Detta kort kan anpassas med ett profilfoto och ett meddelande till dina kunder.","contact_Cart_Heading":"Kontaktkort","Affiliate_Link_Info_Msg":"Dela din affiliate-länk med kunder. Alla beställningar som görs genom att använda din affiliate-länk kommer att tillskrivas dig","Contact_Card_Bio_Save_Success_Msg":"Bio sparas framgångsrikt","Affiliate_Add_ProductInfo_Msg":"Lägg till produkter som du vill dela affiliate länk för","ShareCart_UserGuide_Msg1":"Skapa en delbar länk i kundvagnen, förladdad med utvalda produkter skräddarsydda efter din kunds preferenser. Kunden kan använda länken, granska varukorgsartiklar och gå direkt vidare","ShareCart_UserGuide_Msg2":"till kassan. Beställningar som görs genom att använda din kundvagnslänk kommer att tillskrivas dig.","ShareCart_ToltipTitle":"Ta bort produkter från varukorgen","Delete_Cart_Confirmation":"Är du säker på att du vill ta bort kundvagnen?","No_Share_Cart_Added1":"Ingen varukorgslänk har skapats förrän nu.","No_Share_Cart_Added2":"Skapa en kundvagn och dela dess direktlänk med dina kunder","ClearCart_Conformation_Msg":"Är du säker på att du vill ta bort alla produkter från kundvagnen?","Edit_Billing_Address":"Redigera faktureringsadress","Edit_Shipping_Address":"Redigera leveransadress","New_Customer_Select_Msg":"Skapa en ny kund","CreateOrder_Manage_Heading":"Hantera","RemoveCustomer_Msg":"Ta bort kund","Customer_Address_Apartment":"Lägenhet, svit osv","Address_Enter_Msg":"Ange adress","Address_Not_Found_Error_Msg":"Kundadress och produkter i varukorgen är obligatoriska för att skapa en beställning","Load_More_Btn":"Ladda mer","Beta_Version_msg1":"Den här funktionen är för närvarande i betaversion. Om du ställs inför något problem","Beta_Version_msg2":"Kontakta supporten.","Heading_Product_Select":"Välj produkter","Customer_FirstName":"Förnamn","Customer_lastName":"Efternamn","Customer_Resion":"Land/region","Customer_pinCode":"PIN-kod","Customer_phone":"Telefon","applyDisconutCode_atCheckout":"Tillåt kunder att använda rabattkuponger i kassan"}'
        ),
        jt = JSON.parse(
          '{"dashboard_title":"PAINEL","dashboard_welcomeMsg":"Bem-vindo ao","dashboard_morningMsg":"Bom dia","dashboard_afternoonMsg":"Boa tarde","dashboard_eveningMsg":"Boa noite","dashboard_subTitle1":"Mês atual","dashboard_block1Heading":"Fatura do cliente","dashboard_block1Header1":"GANHOS","dashboard_block1Header2":"Fatura enviada","dashboard_block1Header3":"FATURA PAGA","dashboard_block2Heading":"Ordens de atacado","dashboard_block2Header1":"GANHOS","dashboard_block2Header2":"Fatura enviada","dashboard_block2Header3":"FATURA PAGA","dashboard_block3Heading":"Ordens de afiliados","dashboard_block3Header1":"GANHOS","dashboard_block3Header2":"Pedidos pagos","dashboard_block4Heading":"CUPOM DE DESCONTO","dashboard_block4Header1":"GANHOS","dashboard_block4Header2":"Pedidos pagos","dashboard_block5Heading":"Comissão de clientes","dashboard_block5Header1":"COMISSÃO","dashboard_block5Header2":"Ordens","dashboard_block6Heading":"Comissão líder da equipe","dashboard_block6Header1":"COMISSÃO","dashboard_block7Heading":"Comissão de POS","dashboard_block7Header1":"COMISSÃO","dashboard_block7Header2":"Pedidos","dashboard_tbl1column1":"Mês","dashboard_tbl1column2":"Pedidos de fatura do cliente","dashboard_tbl1column3":"Comissão de Fatura do Cliente","dashboard_tbl1column4":"Pedido de atacado","dashboard_tbl1column5":"Compra total no atacado","dashboard_tbl1column6":"Pedidos de afiliados","dashboard_tbl1column7":"Comissão de Affilate","dashboard_tbl1column8":"Pedidos de cuponCode","dashboard_tbl1column9":"Comissão de código de cupom","dashboard_tbl1column10":"Pedidos de clientes","dashboard_tbl1column11":"Comissão de clientes","dashboard_tbl1column12":"Pedidos de PDV","dashboard_tbl1column13":"Comissão de POS","dashboar_cardHeading1":"Pedido total","dashboar_cardHeading2":"Comissão","dashboar_cardHeading3":"Vendas","dashboar_cardHeading4":"Bônus","dashboard_graphHeading1":"Desempenho de vendas dos últimos seis meses","dashboard_graphHeading2":"Analise de pedidos e a comissão de recursos para o mês atual","Graph_Sales_noorderstitle":"Sem pedidos para mostrar","Graph_SalesRepCommission_nocommissiontitle":"Nenhum dado de comissão para mostrar","Graph_SalesRepOrders_title":"Pedidos","Graph_SalesRep_XAxisTitle_ForMonth":"6 mesas","Graph_SalesRepOrders_YAxisTitle":"Pedidos","Graph_SalesRepSales_title":"VENDAS","Graph_SalesRepCommission_title":"COMISSÃO","Graph_SalesRepCommissions_YAxisTitle":"Comissão","Graph_FeatureWiseOrder_title":"Beställningar vs -funktionen","Graph_featureWiseCommission_title":"Commission vs Feature","Graph_FeatureWiseOrder_XAxisTitle":"Recurso","Graph_FeatureWiseOrder_YAxisTitle":"Pedidos","Graph_FeatureWiseCommission_title":"COMISSÃO","Graph_FeatureWiseCommission_YAxisTitle":"Comissão","customerInvoice_title":"Criar pedido","customerInvoice_button":"Voltar","customerInvoice_noclientorderMsg":"Sem pedidos de fatura de clientes","customerInvoice_button1":"Ver pedidos anteriores","customerInvoice_contentHeading1":"Desconto e comissão","customerInvoice_table1column1":"Tipo de Produto","customerInvoice_table1column2":"Comissão","customerInvoice_table1column3":"Nome de desconto","customerInvoice_table1column4":"Desconto","customerInvoice_contentHeading2":"Adicione detalhes do cliente e selecione produtos para enviar fatura.","customerInvoice_contentHeading2Title1":"Digite/Pesquisar Cliente","customerInvoice_title1Placeholder":"Digite/Pesquisar Cliente","customerInvoice_contentHeading2Title2":"Digite ID de e -mail do cliente","customerInvoice_title2Placeholder":"Endereço de email","customerInvoice_contentHeading2Title3":"Digite Notas do pedido","customerInvoice_contentHeading2Title4":"Endereço do cliente","customerInvoice_contentHeading2Title5":"Número do celular do cliente","customerInvoice_contentHeading2Title6":"Nota do cliente","customerInvoice_contentHeading2Title7":"Nome da empresa do cliente","customerInvoice_title7Placeholder":"nome da empresa","customerInvoice_Placeholder_contentHeading2Title6":"Observação","customerInvoice_Placeholder_contentHeading2Title5":"Número de celular","customerInvoice_Placeholder_contentHeading2Title4":"Endereço para envio","customerInvoice_title3Placeholder":"Notas de pedidos","customerInvoice_SearchProducts_Label":"procurar produtos","customerInvoice_table2Column1":"Imagem","customerInvoice_table2Column2":"Adicione quantidade","customerInvoice_table2Column3":"Título","customerInvoice_table2Column4":"Título variante","customerInvoice_ProductTableColumnPrice":"Preço","customerInvoice_ProductTableColumnWholeSalePrice":"Preço por atacado","customerInvoice_button2":"Criar recibo","customerInvoice_ProductTableColumnProduct":"produtos","customerInvoice_table3Column2":"Nome do Produto","customerInvoice_table3Column3":"Tamanho","customerInvoice_ProductTableColumnQuantity":"Quantidade","customerInvoice_table3Column5":"Preço do item","customerInvoice_table3Column6":"Preço total","customerInvoice_table3Column7":"Preço com desconto para o cliente","customerInvoice_table3Column8":"Comissão de Representante de Vendas","customerInvoice_table3Column9":"Desconto","customerInvoice_repproInvite":"Selecione a caixa de seleção para enviar um convite profissional","customerInvoice_customerOrder_error1":"Todos os campos de clientes são obrigatórios. Insira o e -mail e o primeiro nome do cliente","customerInvoice_productAddedMsg":"Produto adicionado","customerInvoice_AlertErrorMsg":"Erro...Contate o Suporte!","wholesaleOrder_title":"Pedido por atacado","wholesaleOrder_contentHeading1":"Você pode comprar produtos a preços especiais de atacado","wholesaleOrder_contentHeading2":"Desconto em","wholesaleOrder_column1":"Nome do Representante de Vendas","wholesaleOrder_column2":"Desconto","wholesaleOrder_searchtxtPlaceholder":"Produto de pesquisa","wholesaleOrder_table1Column1":"Imagem","wholesaleOrder_table1Column2":"Adicione quantidade","wholesaleOrder_table1Column3":"Título","wholesaleOrder_table1Column4":"Título variante","wholesaleOrder_table1Column5":"Preço","wholesaleOrder_button":"Confira","wholesaleOrder_Order_btn":"Mostrar/ocultar preços de volume","wholesaleOrder_contentHeading3":"Preço total","wholesaleOrder_contentHeading4":"Seu preço com desconto","wholesaleOrder_table2Column1":"produtos","wholesaleOrder_table2Column2":"Nome do Produto","wholesaleOrder_table2Column3":"Tamanho","wholesaleOrder_table2Column4":"Quantidade","wholesaleOrder_table2Column5":"Preço do item","wholesaleOrder_table2Column6":"Preço total","wholesaleOrder_table2Column7":"Seu preço com desconto","affiliateLink_title":"Link de afiliado","affiliate_product_link":"Link do produto","affiliateLink_input_error_msg":"O campo de texto de link é necessário e não deve conter espaços.","affiliateLink_contentHeading1":"Compartilhe seu link de afiliado nas mídias sociais e email. Você receberá uma comissão de afiliados para cada pedido do seu link de afiliado","affiliateLink_contentHeading2":"Seu link de afiliado","affiliateLink_contentHeading3":"Comissão em","affiliateLink_content_Message1":"Pesquise produtos e compartilhe o link de produtos individuais com seus clientes.","affiliateLink_noaffiliateorderMsg":"Sem pedidos de afiliados","affiliateLink_column1":"Nome do Representante de Vendas","affiliateLink_column2":"Comissão","affiliateLink_searchtxtPlaceholder":"Produto de pesquisa","affiliateLink_searchColumn1":"produtos","affiliateLink_searchColumn2":"Título do produto","affiliateLink_searchColumn3":"Preço","affiliateLink_searchColumn4":"Comissão","affiliateLink_searchColumn5":"Link de afiliado","affiliateLink_searchColumn7":"Link de cópia","affiliateLink_searchColumn8":"Copiado","affiliateLink_backbtn":"Voltar","affiliateLink_card_Title":"Kontaktkort och anslutet länk","cartSharing_title":"Compartilhamento de carrinho","cartSharing_CreateCartInformation_Text":"Para criar um carrinho compartilhável personalizado, adicione produtos ao carrinho da loja. Esses produtos serão exibidos nesta página","cartSharing_content2Placeholder":"Nome do carrinho","cartSharing_table2Column2":"Nome do Produto","cartSharing_table2Column3":"Tamanho","cartSharing_table2Column6":"Preço total","cartSharing_SharedCartLinkTableColumnCartName":"Nome do carrinho","cartSharing_SharedCartLinkTableColumnLink":"Link","cartSharing_SharedCartLinkTableColumnCartLink":"Link de carrinho compartilhável","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Copie o link do carrinho","cartSharing_SharedCartLink_Other":"Outra","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Exclua o link do carrinho","cartSharing_EnterCartName_Label":"Digite o nome do carrinho","cartSharing_ProductTableColumnProduct":"produtos","cartSharing_ProductTableColumnQuantity":"Quantidade","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventário","cartSharing_ProductTableColumnItemPrice":"Preço do item","cartSharing_Copied_Msg":"Copiado!","cartSharing_CartCreating_Msg":"Criando...","cartSharing_SharedCartLinkTableEmpty_Msg":"Nenhum link para mostrar","cartSharing_CartCreatedSuccessfully_Msg":"Seu novo carro foi criado com sucesso","cartSharing_CartCreateError_Msg":"Erro... por favor tente novamente","cartSharing_AlertError_Msg":"Erro... Contate o suporte!","cartSharing_CopyCartLink_Msg":"Copie o link do carrinho","cartSharing_DeleteCartLink_Msg":"Exclua o link do carrinho","cartSharing_DeleteConfirmation_Msg":"Tem certeza?","cartSharing_ProductTableEmpty_Msg":"Produto não disponível","cartSharing_CreateCart_Btn":"Criar carrinho","cartSharing_ProductTableQuantityUpdate_Btn":"Selecione o produto","cartSharing_Select_product_Title":"Välj produkt","discountCoupon_titleOne":"Cupom de desconto","discountCoupon_contentHeading1":"Compartilhe o código do cupom de desconto com seus clientes e sempre que o seu cupom for usado, você recebe uma comissão.","discountCoupon_contentHeading2":"Seu código de cupom é","discountCoupon_contentHeading3":"Valor do desconto","discountCoupon_contentHeading4":"Comissão","discountCoupon_contentHeading4PlaceHolder1":"Ei, use meu código de cupom de desconto","discountCoupon_contentHeading4PlaceHolder2":"e obter produtos com desconto","discountCoupon_button1":"Copiar texto","cartSharing_copiedButtonText":"Copiado","discountCoupon_titleTwo":"Crie cupons de desconto para clientes para clientes","discountCoupon_button2":"Veja cupons","discountCoupon_contentHeading5":"Desconto máximo permitido","discountCoupon_contentHeading6":"Comissão","discountCoupon_contentHeading7":"Digite o código do cupom","discountCoupon_contentHeading7PlaceHolder":"Por favor, insira o código do cupom","discountCoupon_contentHeading8":"Insira desconto","discountCoupon_contentHeading8PlaceHolder":"O desconto não deve ser maior que o desconto máximo.","discountCoupon_button3":"Crie cupom","discountCoupon_coupon_error1":"Por favor, insira o código do cupom e o desconto","yourBio_title":"Seu cartão de contato","yourBio_content1":"Carregar perfil","yourBio_button1":"Escolher arquivo","yourBio_button1PlaceHolder":"Nenhum arquivo selecionado","yourBio_error_image_size":"O tamanho da imagem é muito grande, envie uma imagem de tamanho menor que 5 MB. Por favor, tente novamente.","yourBio_button2":"Carregar","yourBio_content2":"Digite uma palavra personalizada para criar seu link de afiliado exclusivo","yourBio_content2PlaceHolder":"Crie seu link de afiliado exclusivo","yourBio_content4":"Quando seu link será usado, seu cartão de contato aparecerá no site","yourBio_content3":"Digite seu cartão de contato","yourBio_content3PlaceHolder":"Digite até 100 palavras","yourBio_button3":"Salvar","yourBio_button4":"Salvou","yourBio_error_link":"Este link único pode ser tomado. Tente com um link exclusivo diferente.","yourBio_Linksuccessmsg":"Link exclusivo salvo com sucesso.","team_title1":"Adicione Representante de Vendas","team_content1":"Digite email","team_content1PlaceHolder":"Endereço de email","team_emailerrorMsg":"Por favor, insira o email","team_content2":"Introduza o primeiro nome","team_content2PlaceHolder":"Primeiro nome","team_fnameerrorMsg":"Por favor, insira o primeiro nome","team_content3":"Insira o último nome","team_content3PlaceHolder":"Sobrenome","team_button1":"Adicionar","team_successmsg":"O representante foi adicionado com sucesso. Ele receberá as credenciais de login no e-mail enviado.","team_errorsmsg":"Erro ao adicionar. Este e -mail de usuário já pode ter uma conta na loja.","team_title2":"Detalhes da equipe","team_content4":"Página de inscrição","team_NoTeamDetailsMsg":"Sem detalhes da equipe","team_content5":"Selecione o Representante de Vendas","team_tableTitle":"Detalhes dos últimos dois meses do pedido","team_column1":"Número do pedido","team_column2":"Data do pedido","team_column3":"nome do cliente","team_column4":"Representante de vendas","team_column5":"Subtotal","team_column6":"Comissão de Representante","team_column7":"Comissão de Gerente de Equipe","team_column8":"Método de Vendas","addCustomer_title":"Adicionar cliente","addCustomer_content1":"Primeiro nome do cliente","addCustomer_txt1Placeholder":"Primeiro nome","addCustomer_content2":"Sobrenome do cliente","addCustomer_content2Placeholder":"Sobrenome","addCustomer_content3":"ID de e -mail do cliente","addCustomer_content3Placeholder":"Endereço de email","addCustomer_content4":"Observação","addCustomer_content4Placeholder":"Observação","addCustomer_customerAddress":"Endereço pessoal","addCustomer_customerCity":"Cidade","addCustomer_customerCityPlaceholder":"Cidade","addCustomer_customerCountry":"País","addCustomer_customerState":"Estado","addCustomer_customerZipCode":"CEP","addCustomer_companyName":"nome da empresa","addCustomer_companyAddress":"Endereço da companhia","addCustomer_companyCity":"Cidade","addCustomer_companyCountry":"País","addCustomer_companyState":"Estado","addCustomer_companyZipCode":"CEP","addCustomer_button":"Salvar","addCustomer_leadsuccessmsg":"O cliente é adicionado com sucesso.","addCustomer_leadErrrorMsg":"Erro ao salvar os detalhes.","addCustomer_leadEmptyErrrorMsg":"Por favor, preencha o campo requerido.","addCustomer_leadsuccessmsg2":"Cliente criado e marcado para uma representação de vendas com sucesso.","addCustomer_leadErrrorMsg2":"Este cliente já está marcado para um representante.","myCustomers_title":"Seus clientes","myCustomers_table1Column1":"Nome","myCustomers_table1Column2":"nome da empresa","myCustomers_table1Column3":"Identificação do email","myCustomers_table1Column4":"Ordem","myCustomers_table1Column5":"Total gasto","myCustomers_table2Title":"Detalhes do cliente","myCustomers_table3Title":"Detalhes do pedido de rascunho","myCustomers_table3Column1":"Nome do Produto","myCustomers_table3Column2":"Tamanho","myCustomers_table3Column3":"Quantidade","myCustomers_table3Column4":"Preço","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Subtotal","myCustomers_table2Row1":"Nome","myCustomers_table2Row2":"E-mail","myCustomers_table2Row3":"Endereço","myCustomers_table2Row4":"Nome da Empresa","myCustomers_table2Row5":"Notas dos clientes","myCustomers_table2Row6":"Total gasto (subtotal+imposto)","myCustomers_table2Row7":"Número de encomendas","myCustomers_table2Row8":"Tag","myCustomers_radioButton0":"Mostre todo cliente","myCustomers_radioButton1":"Procura por nome","myCustomers_radioButton2":"Pesquisa por empresa","myCustomers_radioButtonError1":"Selecione o tipo de pesquisa e insira o valor para pesquisar","myCustomers_radioButtonError2":"Por favor, insira o valor para pesquisar","myCustomers_radioButtonError3":"Selecione o tipo de pesquisa","myCustomers_searchButton":"Procurar","myCustomers_Placeholder1":"Digite o nome do cliente ou o nome da empresa para pesquisar","myCustomers_NoOrdersError":"Sem ordens","myCustomer_no_salesRep_details":"Nenhum detalhe do representante de vendas disponível.","myCustomer_select_customer_country":"Selecione o país do cliente","myCustomer_company_country":"País da empresa","myCustomer_company_state":"Estado da empresa","myCustomer_select_company_country":"Selecione o país da empresa","yourSales_SalesOrderDetailsTitle":"Detalhes da ordem de vendas","yourSales_title":"Últimos 2 meses de pedido detalhes","yourSales_table1Column1":"Número do pedido","yourSales_table1Column2":"Data do pedido","yourSales_table1Column3":"nome do cliente","yourSales_table1Column4":"Subtotal","yourSales_table1Column5":"Comissão","yourSales_table1Column6":"Tipo de comissão","yourSales_table1Column7":"Imprimir fatura","printOrderInvoice_btn":"Imprimir","yourSales_tableTitle":"Detalhes do produto","yourSalesDraft_tableTitle":"Detalhes do pedido de rascunho","yourSales_column1":"produtos","yourSales_column2":"Título","yourSales_column3":"Quantidade","yourSales_column4":"Preço do item","yourSales_column5":"Numero de rastreio","yourSales_column6":"Data de envio","yourSales_column7":"Preço total","yourSales_content1":"Subtotal","yourSales_content2":"Imposto","yourSales_content3":"Frete","yourSales_content4":"Total","yourSales_content5":"Observação","yourSales_tabHeading1":"Ordens pagas","yourSales_tabHeading4":"Ordens pendentes","yourSales_tabHeading2":"Rascunho de pedidos","myOrders_title":"Meus detalhes dos meus pedidos","myOrdersDetails_Message":"Ordens feitas para você","myOrders_table1Column1":"Número do pedido","myOrders_table1Column2":"Data do pedido","myOrders_table1Column3":"nome do cliente","myOrders_table1Column4":"Pagamento","myOrders_table1Column5":"Cumprimento","myOrders_table1Column6":"Total","myOrders_tableTitle":"DETALHES DO PRODUTO","myOrders_table2Column1":"produtos","myOrders_table2Column2":"Título","myOrders_table2Column3":"Quantidade","myOrders_table2Column4":"Preço do item","myOrders_table2Column5":"Numero de rastreio","myOrders_table2Column6":"Data de envio","myOrders_table2Column7":"Preço total","myOrders_content1":"Subtotal","myOrders_content2":"Imposto","myOrders_content3":"Frete","myOrders_content4":"Total","myOrders_content5":"Observação","myOrders_content6":"ID do rascunho","tab_Dashboard":"Painel","dashbord_Tab":"Hem","tab_CustomerInvoice":"Criar ordem","tab3_WholesaleOrder":"Ordem por atacado","tab_AffiliateLink":"Link de afiliado","tab_CartSharing":"Compartilhamento de carrinho","tab_DiscountCoupon":"Cupom de desconto","tab7_YourBio":"Seu cartão de contato","tab8_Team":"Equipe","tab9_AddCustomer":"Adicionar cliente","tab_MyCustomers":"Meus clientes","tab_YourSalesOrderDetails":"Detalhes da ordem de vendas","tab12_MyOrders":"Meus detalhes dos meus pedidos","tab13_Logout":"Sair","signUp_title":"Representante de vendas Inscreva -se","signUp_subTitle":"Por favor, preencha este formulário para se inscrever como um representante de vendas e obter acesso a todos os recursos da equipe de vendas.","signUp_content1":"E-mail","signUp_content2":"Primeiro nome","signUp_content3":"Sobrenome","signUp_content4":"Número de telefone","signUp_content5":"Identificador do Facebook","signUp_content6":"Identificador do Twitter","signUp_content7":"Identificador do Instagram","signUp_content8":"Faça upload da imagem do perfil","signUp_socialmedialable1":"Links de mídia social","signUp_socialmedialable2":"opcional","signUp_uploadBtn":"Escolher arquivo","signUp_uploadBtnPlaceHolder":"Nenhum arquivo selecionado","signUp_button3":"Economizando detalhes ...","signUp_welcomemsg1":"Olá","signUp_welcomemsg2":"Inscreva o representante de vendas e obtenha uma comissão de vendas feitas por representantes sob você","signUp_emailerror":"Por favor, insira o email","signUp_Fnameerror":"Por favor, insira o primeiro nome","signUp_lnameerror":"Por favor, insira o sobrenome","signUp_phnumbererror":"Por favor, insira o número de telefone","signUp_successmsg":"Seu pedido de inscrição foi enviado com sucesso. Você receberá os detalhes de login da conta por e-mail assim que o administrador aprovar seu pedido. Para mais informações, entre em contato com o administrador da loja.","signUp_errorsmsg":"Erro ao salvar os detalhes. Este e -mail de usuário já pode ter uma conta na loja.","signUp_RepExistErrorMsg":"Este email já está registrado como representante.","addingRep_selectRepsLabel1":"Quem te ajudou?","addingRep_NoSalesRep":"Nenhum representante de vendas","addingRep_successMsg":"Adicionado repid à nota de carrinho","addingRep_selectRepsLabel2":"Selecione um item na lista.","wholesaleOrder_WholesaleDiscountTableColumn1":"Título do produto","wholesaleOrder_WholesaleDiscountTableColumn2":"Desconto","customerInvoice_ViewClientOrdersColumn1":"nome do cliente","customerInvoice_ViewClientOrdersColumn2":"Título do produto","customerInvoice_ViewClientOrdersColumn3":"Preço subtotal","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Fatura","salesRep_order_errorMsg":"Erro durante a criação de seu pedido. Por favor, suporte de contato","salesRep_order_successMsg":"Fatura do pedido criado com sucesso! A fatura foi enviada por e -mail ao cliente!","salesRep_order_errorMsg2":"Erro durante a criação de seu pedido. Por favor, suporte de contato","customedraft_btn1":"Crie uma nova fatura","customedraft_btn2":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","customedraft_btn3":"Criando ordem ...","customedraft_btn4":"Crie uma nova fatura","salesRep_order_NoProductSelected":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","productnotselectforcartsharingtxt1":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","discountCoupons_tblColumn1":"Código do cupom","discountCoupons_tblColumn2":"Desconto do cupom","discountCoupons_tblColumn3":"Excluir código de cupom","discountedPriceLabel":"Seu preço com desconto:","couponCodeNotSet":"Código de cupom não definido","dashboard_subTitle2":"Ciclo atual do mês: 5 - 4º","affiliatelink_commissiononlbl":"produtos","displaycommission_lbl1":"Tipo de Produto","displaycommission_lbl2":"Representante de vendas","displaycommission_lbl3":"Desconto baseado em quantidade","discountcommissiononlbl1":"Níveis de desconto do cliente","clientInvoiceCommissionTablecolumn1":"Tipo de Produto","clientInvoiceCommissionTablecolumn2":"Comissão","clientInvoiceCommissionTablecolumn3":"Título do produto","clientInvoiceCommissionTablecolumn4":"Nome do Representante de Vendas","clientInvoiceQuantityBaseDiscountTablecolumn1":"Nome do Produto","clientInvoiceQuantityBaseDiscountTablecolumn2":"Desconto","clientInvoiceQuantityBaseDiscountTablecolumn3":"Quantidade","affiliateCartProdtableColumn1":"produtos","affiliateCartProdtableColumn2":"Título do produto","affiliateCartProdtableColumn3":"Preço","affiliateCartProdtableColumn4":"Comissão","affiliateCartProdtableColumn5":"Link de afiliado","affiliateCartProdtableColumn6":"Compartilhar link","productnotselectforcartsharinglbl1":"Por favor, insira o nome do carrinho","productnotselectforcartsharinglbl2":"Nenhum produto selecionado. Selecione os produtos e tente novamente.","productnotselectforcartsharinglbl3":"Espere durante o processamento ...","showSharedCartProductcolumn1":"Link do carrinho","showSharedCartProductcolumn3":"Remova o carrinho","onSuccessInvoiceSuccessMsg":"Fatura enviada com sucesso","onSuccessInvoiceFailedMsg":"O envio da fatura falhou","sendInvoice_successMsg":"Fatura enviada com sucesso","deleteInvoice_successMsg":"Fatura excluída com sucesso","deleteInvoice_FailedMsg":"Excluir a fatura falhou","deleteInvoice_btnlbl":"Excluindo a fatura","deleteSharedCartLink_successMsg":"Link excluído com sucesso","deleteSharedCartLink_FailedMsg":"Erro na exclusão de link. Por favor, tente novamente..","deleteSharedCartLink_btnlbl":"Excluindo link","viewInvoiceOrders_btntxt1":"Recebendo...","viewInvoiceOrders_btntxt2":"Ver ordens anteriores","createCoupon_btnlbl1":"Criando cupom...","createCoupon_btnlbl2":"Cupom criado","deleteCoupon_successMsg":"Cupom Excluído","deleteCoupon_FailedMsg":"A exclusão de cupom falhou","deleteCoupon_btnlbl":"Excluindo...","viewProductModelColumn1":"produtos","viewProductModelColumn2":"Título","viewProductModelColumn3":"Quantidade","viewProductModelColumn4":"Quantidade reembolsada","viewProductModelColumn5":"Preço do item","viewProductModelColumn6":"Valor do desconto","viewProductModelColumn7":"Numero de rastreio","viewProductModelColumn8":"Data de envio","viewProductModelColumn9":"Preço total","showSharedCartProducts_column2":"Imagem","showSharedCartProducts_column3":"Adicione quantidade","showSharedCartProducts_column4":"Título","showSharedCartProducts_column5":"Título variante","showSharedCartProducts_column6":"Preço","viewClientOrders_btn1":"Visualizar","viewClientOrders_btn2":"Enviar","viewClientOrders_btn3":"Excluir","showCouponTable_txt1":"Recebendo...","showCoupon_btn2":"Veja cupons","showCoupon_btn1":"Copiado","affliateOrder_column1":"nome do cliente","affliateOrder_column2":"Email do cliente","affliateOrder_column3":"Título do produto","affliateOrder_column4":"Data do pedido","affliateOrder_column5":"Subtotal","affliateOrder_column6":"Comissão","affliateOrder_btn1":"Recebendo...","affliateOrder_btn2":"Ver ordens de afiliados","affliateOrder_btn3":"Ver ordens de afiliados","yourBio_btn1":"Salvar","yourBio_btn2":"Salvar","yourBio_Uploadbtn1":"Enviando...","yourBio_Uploadbtn2":"Carregado","yourBio_UploadbtnError":"Desculpe, tente novamente","yourBio_Savebtn":"Salvando...","team_txt1":"Salvando...","team_txt2":"Salvar","viewRepClientOrdersDetails_column1":"Número do pedido","viewRepClientOrdersDetails_column2":"Data do pedido","viewRepClientOrdersDetails_column3":"Subtotal","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Detalhes do produto","addSalesRep_txt1":"Adicione o Representante de Vendas","addSalesRep_txt2":"Adicionando o Representante de Vendas...","discountCoupons_header":"Cupom de desconto único","discountCoupons_nodiscountcoupon":"Você não criou nenhum cupom de desconto","discountCoupons_deleteBtn":"Excluir","discountCoupons_BackBtn":"Voltar","customerInvoice_selectcustomererror":"Selecione o cliente e adicione o produto","createOrderFromCartPage_selectCustomersLabel":"Selecione Cliente","createOrderFromCartPage_selectCustomerAddressLabel":"ENDEREÇO ​​PARA ENVIO","createOrderFromCartPage_selectCustomersLabelForDropDown":"Selecione Cliente","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Selecione o endereço","createOrderFromCartPage_successMsg":"Fatura do pedido criado com sucesso! A fatura foi enviada por e -mail ao cliente!","createOrderFromCartPage_AddNewAddressTitle":"ADICIONAR NOVO ENDEREÇO","createOrderFromCartPage_draftOrderButton":"Crie pedidos de rascunho","createOrderFromCartPage_OrderButton":"Criar ordem","createOrderFromCartPage_draftOrderButtonText2":"Criando ordem ...","createOrderFromCartPage_selectShippingCostTitle":"FRETE","createOrderFromCartPage_Address_errorMsg4":"Houve um problema em calcular suas taxas de envio.","createOrderFromCartPage_Address_errorMsg5":"Alguma coisa deu errado. Por favor tente outra vez.","yourSales_tabHeading3":"Ordens de reembolso","refundOrders_column1":"ID do reembolso","refundOrders_column2":"Data do pedido","refundOrders_column3":"Número do pedido","refundOrders_column4":"Nome do pedido","refundOrders_column5":"Comissão","refundOrders_column6":"Comissão de Gerente de Equipe","refundOrders_column7":"ID do gerente da equipe","refundOrders_column8":"Reembolso subtotal","refundOrders_column9":"Status do pedido","refundOrders_column10":"Método de Vendas","refundOrderNumber_title":"Detalhes do pedido de reembolso","refundOrderNumber_column1":"Nome","refundOrderNumber_column2":"Data","refundOrderNumber_column3":"Quantidade","refundOrderNumber_column4":"Preço com desconto","refundOrderNumber_column5":"Subtotal","tableDataError":"Sem ordem de reembolso","dashboard_subTitle3":"Detalhes da comissão","dashboard_cardHeading5_1":"Comissão em","dashboard_cardHeading5_2":"Você vai conseguir um","dashboard_cardHeading5_3":"Comissão de todas as ordens.","Profit_Margin":"Margem de lucro","Product_Type":"Tipo de Produto","Sales_Rep":"Representante de vendas","show_commission_list":"Lista de comissões do show","commission_list":"Lista de comissão","no_customers_to_show":"Nenhum cliente para mostrar","no_sales_to_show":"Sem vendas para mostrar","no_draft_to_show":"Sem rascunho para mostrar","no_refund_to_show":"Sem reembolso para mostrar","no_orders_to_show":"Sem ordens para mostrar","customerInvoice_ViewClientOrdersColumn6":"Número do pedido","customerInvoice_ViewClientOrdersColumn7":"Data do pedido","Error_commissions_NotUpdated":"As comissões não são atualizadas","sales_chart_msg1":"Precisamos de dados...","sales_chart_msg2":"Parece que ainda não temos dados a serem mostrados.","page_refresh_msg":"Clique para atualizar","variant_title":"Título variante","line_items_properties":"Propriedades","customer_country":"País do cliente","customer_state":"Estado do cliente","company_country":"País da empresa","company_state":"Estado da empresa","client_orders":"Pedidos de cliente","no_product_details":"Não há detalhes de produtos para mostrar","submit_btn_text":"Enviar","submitting_btn_text":"Envio","submitted_btn_text":"Submetido","email_id_validation_errmsg":"Por favor, insira ID de e -mail válido","customerInvoice_add_more_details":"Adicione mais detalhes","customerInvoice_add_shipping_address":"Adicionar novo endereço de entrega","customerInvoice_HideDetails":"Detalhes ocultos","customerInvoice_HideAddress":"Ocultar endereço de entrega","customerInvoice_enterFirstName":"Introduza o primeiro nome","customerInvoice_enterFirstNamePlaceholder":"Primeiro nome","customerInvoice_enterLastName":"Insira o último nome","customerInvoice_enterLastNamePlaceholder":"Sobrenome","customerInvoice_enterAddress1":"Digite a linha de endereço 1","customerInvoice_enterAddress1Placeholder":"Endereço Linha 1","customerInvoice_enterAddress2":"Insira a linha de endereço 2","customerInvoice_enterAddress2Placeholder":"endereço linha 2","customerInvoice_enterCity":"Entre na cidade","customerInvoice_enterCityPlaceholder":"Cidade","customerInvoice_selectCountry":"Selecione o pais","customerInvoice_selectState":"Selecione estado","customerInvoice_enterZipNumber":"Digite o código postal","customerInvoice_enterZipNumberPlaceholder":"CEP","customerInvoice_ProductTableColumnSku":"Sku","customerInvoice_ProductTableColumnInventory":"Inventário","customerInvoice_ProductTableEmpty_Msg":"Produto não disponível","customerInvoice_SendInvoiceBtn":"Enviar fatura","customerInvoice_CreateBtn":"Crear","customerInvoice_CreatingBtn":"Creación","customerInvoice_ProductTableColumnSubTotal":"Subtono","customerInvoice_SelectShippingAddress":"Selecione o endereço de envio","customerInvoice_ProductsSearchBy_Placeholder":"Pesquisar produtos por nome, SKU, preço","customerInvoice_AddMoreProducts_Btn":"Adicione mais produtos","customerInvoice_RequiredErrorMsg":"Este campo é obrigatório.","customerInvoice_EmailSuggestionErrorMsg":"Adicione ID de e -mail válido","customerInvoice_MobileSuggestionErrorMsg":"Por favor, adicione o telefone válido não","customerInvoice_ErrorMsgAddShippingAddress":"Por favor, preencha o endereço de entrega","customerInvoice_Creating_Msg":"Criando...","customerInvoice_Sending_Msg":"Enviando...","customerInvoice_OrderCreatedSuccessfullyMsg":"Ordem criada com sucesso","customerInvoice_InvoiceSentSuccessfullyMsg":"Fatura enviada com sucesso para o cliente","customerInvoice_ErrorMsgTryAgain":"Erro... por favor tente novamente","customerInvoice_Selected_Btn":"Selecionado","customerInvoice_ProductTableQuantityUpdate_Btn":"Selecione o produto","customerInvoice_OrderSubTotal":"Subtotal do pedido","delete_confirmation_text":"Tem certeza?","draftOrder_OrderNumber":"Número do pedido","draftOrder_CustName":"nome do cliente","draftOrder_OrderDate":"Data do pedido","draftOrder_SubTotal":"Subtono","draftOrder_Status":"Status","draftOrder_Invoice":"Fatura","draftOrder_DraftId":"ID do rascunho","draftOrder_ShippingCost":"Frete","draftOrder_Tax":"Imposto","draftOrder_TotalPrice":"Preço total","draftOrder_Note":"Observação","draftOrder_Product":"produtos","draftOrder_ProductName":"Nome do Produto","draftOrder_Size":"Tamanho","draftOrder_Quantity":"Quantidade","draftOrder_Price":"Preço","noDraftOrderProducts":"Não há detalhes sobre detalhes do produto para pedidos disponíveis.","noRefundOrderProduct":"Não há detalhes do produto de pedido de reembolso disponíveis.","loading":"Carregando...","dashboard_commissionOn_profitMargin":"Comissão sobre Margem de Lucro","dashboard_clientInvoice":"Fatura do cliente","dashboard_affiliateLink":"Ordem de afiliados","dashboard_returnCustomer":"Retorno cliente","dashboard_discountCoupon":"Cupom de desconto","dashboard_no_data":"Nenhum dado disponível","dashboard_sales_of_last_six_months":"Vendas dos últimos 6 meses","dashboard_sales_of_current_month":"Vendas do mês atual","addCustomer_ErrorMsgOnSubmitBtn":"Por favor insira um número de telefone válido","login_welcome_Msg":"Bem -vindo à equipe de vendas","login_title":"Conecte-se","login_email":"Identificação do email","login_password":"Senha","emailValidation_ErrorMsg":"Por favor, insira ID de e -mail válido","login_newUser":"Novo usuário?","login_SignUp":"Inscrever-se","login_forgotPassword_link":"Esqueceu sua senha?","login_LogInBtn":"Conecte-se","login_sliderContent_1":"Representantes que estão colocando a ordem dos clientes","login_sliderContent_2":"O tráfego de condução de representantes para a loja","login_sliderContent_3":"Representante produtos de marketing usando plataformas de mídia social","login_sliderContent_4":"O representante pode comprar a granel e obter lucro","login_sliderContent_5":"Representantes que estão colocando a ordem dos clientes","login_sliderContent_6":"Os representantes podem visitar os clientes pessoalmente e criar pedidos","required_ErrorMsg":"Por favor, preencha o campo necessário","signup_title":"Inscrever-se","signup_BackTo_login":"Volte ao login","signup_firstName":"Primeiro nome","signup_lastName":"Sobrenome","signup_BackBtn":"Voltar","signup_NextBtn":"Próximo","signup_phone_number":"Número de telefone","signup_phone_number_Error":"Por favor, insira pelo menos 10 dígitos","signup_uploadPicture":"Faça upload da imagem do perfil","signup_fileSizeError":"O tamanho do arquivo é maior que 5 MB","signup_filePath_lable":"Arquivo selecionado","signup_MediaTitle2":"Links de mídia social","signup_facebookHandle":"Indentificador do Facebook","signup_InstaHandle":"Identificador do Instagram","signup_SaveBtn":"Salve detalhes","forgotPwd_title":"Esqueceu sua senha","forgotPwd_ResetBtn":"Redefinir senha","forgotPwd_SuccessMsg":"Sua solicitação de senha de redefinição é bem -sucedida, enviamos a nova senha para o seu ID de email registrado.","customerInvoice_selectShippingCost":"Selecione o custo de envio","customerInvoice_CalculatingShippingRates_Msg":"Calculando...","customerInvoice_AddShippingAddress_Msg":"Selecione Endereço ou Adicionar endereço de entrega","customerInvoice_PleaseSetAnyShippingAddressMsg":"Selecione qualquer endereço de entrega","customerInvoice_ShippingCostErrorMsg":"Adicione um novo endereço de entrega, porque o endereço tem informações insuficientes.","customerInvoice_CalculateShippingCost_Btn":"Calcule o custo de envio","customerInvoice_ShippingCostAddOrNot_Msg":"Você gostaria de adicionar custo de envio?","customerInvoice_ShippingCostAddOrNot_Yes":"Sim","customerInvoice_ShippingCostAddOrNot_No":"Não","shop_utterly_conkers_ShippingCostCompulsory_ErrorMsg":"Não fez seu pedido, a menos e até adicionar o custo de envio","shop_utterly_conkers_AddMoreProducts__ErrorMsg":"Adicione mais produtos para calcular o custo de envio","customerInvoice_ShippingCostErrorMsg_TryAgain":"Por favor, tente novamente","dashboard_BannerMsg":"Os gráficos são atualizados a cada 8 horas","yourSales__BannerMsg":"Os detalhes do pedido são atualizados a cada 5 minutos","customerInvoice_FirstNameErrorMsg":"Por favor, insira o primeiro nome","customerInvoice_lastNameErrorMsg":"Por favor, insira o sobrenome","customerInvoice_Add1ErrorMsg":"Por favor, insira a linha de endereço 1","customerInvoice_CountryErrorMsg":"Selecione o país","customerInvoice_StateErrorMsg":"Selecione o estado","customerInvoice_CityErrorMsg":"Por favor, insira o nome da cidade","customerInvoice_ZipErrorMsg":"Por favor, insira o CEP","uploadImage":"Enviar Imagem","dashboard_CardTitle1":"Kommission för alla beställningar","dashboard_CardTitle3":"Total provision","dashboard_TotalRevenue":"Totala intäkter","dashboard_TotalAvg_Ticket_Size":"Genomsnittlig biljettstorlek","dashboard_CardTitle4":"Total rea","profile_Change_Password":"Ändra lösenord","dashboard_Information_Message":"Kommissionen spåras endast för betalda beställningar","resetPassword_validation_Msg":"Detta fält krävs","resetPassword_validation_Msg2":"Lösenordet ska innehålla minst 8 tecken, 1 versaler, 1 små bokstäver, 1 siffra etc.","resetPassword_validation_Msg3":"Bekräfta lösenordet ska matcha med nytt lösenord","dashbord_Msg_New":"Hur det fungerar","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Maximal rabatt är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","discount_couponErrorMsg2":"Kommissionen är inte konfigurerad. Vänligen kontakta webbplatsadministratör.","dashbord_profile_pic":"Ändra profilbild","Dashboard_Month":"Månad","Performance_Details":"Prestationsdetaljer","Show_Performance_Details":"Visa prestandainformation","Dashboard_Orders_Total":"Totala beställningar","Dashboard_Total_Sale":"Total försäljning","Dashboard_Commission":"Provision","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Por favor, adicione o endereço do cliente.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Por favor, selecione um custo de envio.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Carrinho não atualizado, atualize e tente novamente.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Selecione o produto.","customerInvoice_CreatingDraft_Msg":"Rascunho Criando..","customerInvoice_DraftOrderBtn":"Projeto de pedido","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Rascunho de pedido criado com sucesso","productTable_error_AlertMsg":"Kvantitet kan inte vara 0 eller mindre, ange något giltigt värde","productTable_error_AlertMsg2":"Ange kvantitet","click_to_copy":"Klicka för att kopiera","discount_code_copy_coupon":"Kopieringskupong","createOrder_productSearchGuide":"Kan du inte hitta produkter?","soldOut":"Vendido","InventoryNotTracked":"Estoque não rastreado","productStatus":"Status do produto","makeSureInShopify":"Certifique-se no Shopify","products":"Produtos","sectionTheProductStatusIs":"seção, o status do produto é","active":"Ativo","productsMayBeSoldOutPleaseCheck":"Os produtos podem estar esgotados, verifique e selecione","yourSales_PaidOrders_PaidDate":"Data de pagamento do pedido","ordersLoading":"Pedidos carregando...","productsLoading":"Carregando produtos...","leaveOnPageBtn":"Continuar","stayOnPageBtn":"Fique nesta página","alertBoxTitle":"Criar página de pedido","alertMessage":"As alterações não salvas serão perdidas. Você pode salvar este pedido como rascunho.","salesDetailsHeader_Location":"Ubicación","tab_CreateB2BOrder":"Pedido B2B","b2b_no_company_data_available":"Sem datos de feno de la comañía descartáveis","b2b_select_location":"Selectionar Ubicación","b2b_select_customer":"SeleCcionar Cliente","b2b_select_location_customer":"Seleccione el cliente/ubicación","b2b_SelectedCompanyDetails":"Detalha seleccionados de la empresa","b2b_no_location_data":"Sem feno ubicaciones descartáveis","b2b_no_customer_data":"Sem dados de feno de clientes descartáveis","b2b_removeSelectedCustomer":"Eliminar","b2b_emailId":"Identificatación de Correo","b2b_customerName":"Nombre del Cliente","b2b_companyName":"Nombre de Empresa","b2b_BillingAddress":"Diretor de envio","b2b_ShippingAddress":"Diretamente de Envío","ST_CO_no_result_found_msg":"Sem Encontraron Resultados para","ST_CO_SearchProducts_Label":"Buscar Products","ST_CO_search":"Buscar","ST_Producttable_netQuantity":"Cantidad Neta","ST_Producttable_subtotal":"Parcial total","ST_Producttable_wholesalePrice":"Prefeito de Precio Al","ST_Producttable_retailPrice":"Precio Minorista","ST_Producttable_SKU":"Sku","ST_Producttable_product":"Producto","createOrder_select_product":"Produto Selectionar","createOrder_AddProduct":"AGREGAR PRODUCTO","createOrder_AddBtn":"AGREGAR","CreateOrder_doneBtn":"HECHO","createOrder_productTable_NoProductsAdded":"Sem produtos de concordância","productTable_clearCartBtn":"Vaciar Carito","b2b_companyTable_noMainContact":"Sem Hay Contato Principal Disponível","ST_none":"Ninguno","CreateOrder_EnterPoNumber":"Ingrese el número po","CreateOrder_chooseDateMsg":"Elija Una Fecha","CreateOrder_paymnetTerms":"Términos de Pago","CreateOrder_TaxExemption":"EXENCION DE IMPUESTOS","draftOrder_CompanyName":"Nombre de Empresa","CreateOrder_Company":"Compañía","Create_Order_TotalLocations":"Total de ubicaciones","Create_Order_MainContact":"Principal de Contato","Create_Order_PaymentDueLater":"Pago Adeudado Más Tarde","b2b_select_company":"Compañía seleccionada","yourSales_headerLocation":"Ubicación","salesDetailsHeader_Company":"Compañía","customerInvoice_PaymentPending":"Pago Pendiente","customerInvoice_Checkout":"Verificar","customerInvoice_ProceedToCheckout":"Pasar por la caja","customerInvoice_CheckoutMsg":"Esto Generará Un Borrador de Orden, Redirigiéndolo a la Página de Pago. En Caso de Que El Proceso de Pago No Tenga Éxito, Puede Encontrar Este pedido en la","customerInvoice_sendInvoiceToCustomer":"Enviar factura al cliente","customerInvoice_cancel":"Cancelamento","Checkout_DoNotAskAgainMsg":"Sem Pre -Gunta de Nuevo","RepCheckout_RedirectionMsg":"Redirigir Para Pagar","customerInvoice_CreatingDraftCheckout":"Rascunho Creación con el pago ...","customerInvoice_OrderType":"Método de Vendas","DoNotShowAgain":"Sem Mostar de Nuevo","copyLinkSuccess":"Enlecle copiada con éxito","affiliateLink_Confirmation_Msg1":"El Seguimiento del Pedido de Allos de Los Afilia Funciona Solo Si El Cliente Hace Clic en el","affiliateLinkConfirmationMsg2":"Añadir a la cesta","affiliateLink_Confirmation_Msg3":"Botón, sem será efetivo si sótora hace clic en el","affiliateLink_Confirmation_Msg4":"Comprar Ahora","affiliateLink_Confirmation_Msg5":"Botón.","productsPerPage":"Produtos por página","productTableCartClearButton":"Limpar","affiliateLink_Confirmation_Note":"NOTA","myCustomers_searchByCustomerOrCompanyName":"Pesquisar por nome de cliente ou empresa","ST_Producttable_VolumePricing":"Preços por volume","dashboard_B2BCompanyLocation":"Localização da empresa","customer":"Cliente","PaidDate":"Data de pagamento","producttable_discounttypeHeader":"Tipo de Desconto","customerInvoice_DiscountOnSubtotal":"Desconto no Subtotal","ST_Producttable_CartResponse":"O cliente não é elegível para comprar alguns dos produtos no carrinho","ST_B2BPriceBreack_CloseBtn":"Cerca","B2B_QtyRule_Error_Msg":"Cantidad não válida agregada. Por favor, verifique as regras de cantidad.","SpecialChar_Error_Msg":"Caracteres especiais como @,#,!,$,& não são permitidos na senha","Customer_Info_Title":"Por favor, selecione o país primeiro","ClientInvoice":"Representante criado","AffiliateOrder":"Link de afiliado","CouponOrder":"Cupom de desconto","ReturnCustomerOrder":"Pedido do cliente","Tagcustomer":"Pedido do cliente","POSOrder":"POS","SharedCart":"Compartilhar carrinho","RepOnCartPage":"Escolha do representante","AdminTaggedOrder":"Marcação manual","TaggedCompanyLocationOrder":"Pedido B2B","WholesaleOrder":"Fatura de atacado","TeamManager":"Gerente de equipe","charsLeft":"char à esquerda","showing":"Mostrando","customers":"clientes","exportCsv":"Exportar CSV","all":"Todos","paid":"Pago","unpaid":"Não pago","draft":"Rascunho","refunded":"Reembolsado","orderType":"Tipo de pedido","ShippingCost_AddressError":"O custo de envio para o endereço selecionado não está configurado. Por favor, contate o administrador.","ShippingCost_CustomerAddressAndCartProductError":"O endereço do cliente e os produtos no carrinho são obrigatórios para calcular o custo de envio.","ContactCard_Info_Msg":"O cartão de contato torna seus links de afiliados mais atraentes. Quando um cliente utiliza um link de afiliado, ele pode ver seu cartão de contato no site, proporcionando uma experiência de compra mais personalizada. Este cartão pode ser personalizado com uma foto de perfil e uma mensagem para seus clientes.","contact_Cart_Heading":"Cartão de contato","Affiliate_Link_Info_Msg":"Compartilhe seu link de afiliado com os clientes. Qualquer pedido feito usando seu link de afiliado será atribuído a você","Contact_Card_Bio_Save_Success_Msg":"Biografia salva com sucesso","Affiliate_Add_ProductInfo_Msg":"Adicione produtos para os quais você gostaria de compartilhar o link de afiliado","ShareCart_UserGuide_Msg1":"Crie um pacote de transporte para compartilhar, pré-carregado com produtos selecionados e adaptados às preferências do seu cliente. O cliente pode usar o link, verificar os artigos do carrinho e prosseguir diretamente","ShareCart_UserGuide_Msg2":"para pagar. Os pedidos realizados mediante o enlace do seu transporte serão atendidos.","ShareCart_ToltipTitle":"Sair dos produtos do carrito","Delete_Cart_Confirmation":"Você tem certeza de que deseja remover o carro?","No_Share_Cart_Added1":"Não se criou nada até agora.","No_Share_Cart_Added2":"Crie um carrinho e compare seu link diretamente com seus clientes","ClearCart_Conformation_Msg":"Tem certeza de que deseja remover todos os produtos do carrinho?","Edit_Billing_Address":"Editar endereço de cobrança","Edit_Shipping_Address":"Editar endereço de entrega","New_Customer_Select_Msg":"Crie um novo cliente","CreateOrder_Manage_Heading":"Gerenciar","RemoveCustomer_Msg":"Remover cliente","Customer_Address_Apartment":"Apartamento, suíte, etc","Address_Enter_Msg":"Insira o endereço","Address_Not_Found_Error_Msg":"O endereço do cliente e os produtos no carrinho são obrigatórios para criar um pedido","Load_More_Btn":"Carregar mais","Beta_Version_msg1":"Este recurso está atualmente na versão Beta. Se você enfrentar qualquer problema","Beta_Version_msg2":"please contact support.","Heading_Product_Select":"Selecione Produtos","Customer_FirstName":"Primeiro nome","Customer_lastName":"Sobrenome","Customer_Resion":"Country/region","Customer_pinCode":"Código PIN","Customer_phone":"Telefone","applyDisconutCode_atCheckout":"Permitir que os clientes apliquem cupons de desconto no checkout"}'
        ),
        Nt = JSON.parse(
          '{"dashboard_title":"Verwaltungsbereich","dashboard_welcomeMsg":"Willkommen bei","dashboard_morningMsg":"Guten Morgen","dashboard_afternoonMsg":"Guten Tag","dashboard_eveningMsg":"Guten Abend","dashboard_subTitle1":"Aktueller Monat","dashboard_block1Heading":"KUNDENRECHNUNG","dashboard_block1Header1":"ERGEBNIS","dashboard_block1Header2":"RECHNUNG GESENDET","dashboard_block1Header3":"RECHNUNG BEZAHLT","dashboard_block2Heading":"GROSSHANDELSBESTELLUNGEN","dashboard_block2Header1":"ERGEBNIS","dashboard_block2Header2":"RECHNUNG GESENDET","dashboard_block2Header3":"RECHNUNG BEZAHLT","dashboard_block3Heading":"Affiliate-Bestellungen","dashboard_block3Header1":"ERGEBNIS","dashboard_block3Header2":"BESTELLUNGEN BEZAHLT","dashboard_block4Heading":"RABATTGUTSCHEIN","dashboard_block4Header1":"ERGEBNIS","dashboard_block4Header2":"BESTELLUNGEN BEZAHLT","dashboard_block5Heading":"KUNDENPROVISION","dashboard_block5Header1":"KOMMISSION","dashboard_block5Header2":"BESTELLUNGEN","dashboard_block6Heading":"TEAMLEITUNGSKOMMISSION","dashboard_block6Header1":"KOMMISSION","dashboard_block7Heading":"POS-KOMMISSION","dashboard_block7Header1":"KOMMISSION","dashboard_block7Header2":"BESTELLUNGEN","dashboard_tbl1column1":"Monat","dashboard_tbl1column2":"Kundenrechnungsbestellungen","dashboard_tbl1column3":"Provision für Kundenrechnungen","dashboard_tbl1column4":"Großhandelsbestellungen","dashboard_tbl1column5":"Gesamter Großhandelseinkauf","dashboard_tbl1column6":"Affiliate-Bestellungen","dashboard_tbl1column7":"Affiliate-Provision","dashboard_tbl1column8":"Gutscheincode-Bestellungen","dashboard_tbl1column9":"CouponCode-Provision","dashboard_tbl1column10":"Kundenbestellungen","dashboard_tbl1column11":"Kundenprovision","dashboard_tbl1column12":"POS-Bestellungen","dashboard_tbl1column13":"POS-Kommission","dashboar_cardHeading1":"Gesamtbestellung","dashboar_cardHeading2":"Kommission","dashboar_cardHeading3":"Verkäufe","dashboar_cardHeading4":"Bonus","dashboard_graphHeading1":"Umsatzentwicklung der letzten sechs Monate","dashboard_graphHeading2":"Analysieren Sie die funktionsbezogene Bestellung und Provision für den aktuellen Monat","Graph_Sales_noorderstitle":"Kein Auftrag zum Vorzeigen","Graph_SalesRepCommission_nocommissiontitle":"Es können keine Provisionsdaten angezeigt werden","Graph_SalesRepOrders_title":"BESTELLUNGEN","Graph_SalesRep_XAxisTitle_ForMonth":"6 Monate","Graph_SalesRepOrders_YAxisTitle":"Bestellungen","Graph_SalesRepSales_title":"VERKÄUFE","Graph_SalesRepCommission_title":"KOMMISSION","Graph_SalesRepCommissions_YAxisTitle":"Kommission","Graph_FeatureWiseOrder_title":"Bestellungen vs. Funktion","Graph_featureWiseCommission_title":"Provision vs. Feature","Graph_FeatureWiseOrder_XAxisTitle":"Besonderheit","Graph_FeatureWiseOrder_YAxisTitle":"Bestellungen","Graph_FeatureWiseCommission_title":"KOMMISSION","Graph_FeatureWiseCommission_YAxisTitle":"Kommission","customerInvoice_title":"Bestellung anlegen","customerInvoice_button":"Zurück","customerInvoice_noclientorderMsg":"Keine Kundenrechnungsbestellungen","customerInvoice_button1":"Frühere Bestellungen anzeigen","customerInvoice_contentHeading1":"Rabatt und Provision auf","customerInvoice_table1column1":"Produkttyp","customerInvoice_table1column2":"Kommission","customerInvoice_table1column3":"Rabattname","customerInvoice_table1column4":"Rabatt","customerInvoice_contentHeading2":"Fügen Sie Kundendaten hinzu und wählen Sie Produkte aus, um die Rechnung zu senden.","customerInvoice_contentHeading2Title1":"Kunden eingeben/suchen","customerInvoice_title1Placeholder":"Kunden eingeben/suchen","customerInvoice_contentHeading2Title2":"Geben Sie die E-Mail-ID des Kunden ein","customerInvoice_title2Placeholder":"E-Mail-Adresse","customerInvoice_contentHeading2Title3":"Geben Sie Bestellnotizen ein","customerInvoice_contentHeading2Title4":"Kundenadresse","customerInvoice_contentHeading2Title5":"Mobiltelefonnummer des Kunden","customerInvoice_contentHeading2Title6":"Kundenhinweis","customerInvoice_contentHeading2Title7":"Name des Kundenunternehmens","customerInvoice_title7Placeholder":"Name der Firma","customerInvoice_Placeholder_contentHeading2Title6":"Notiz","customerInvoice_Placeholder_contentHeading2Title5":"Handynummer","customerInvoice_Placeholder_contentHeading2Title4":"Lieferadresse","customerInvoice_title3Placeholder":"Bestellhinweise","customerInvoice_table2Column1":"Bild","customerInvoice_table2Column2":"Menge hinzufügen","customerInvoice_table2Column3":"Titel","customerInvoice_table2Column4":"Variantentitel","customerInvoice_ProductTableColumnPrice":"Preis","customerInvoice_ProductTableColumnWholeSalePrice":"Großhandelspreis","customerInvoice_button2":"Rechnung erstellen","customerInvoice_ProductTableColumnProduct":"Produkt","customerInvoice_table3Column2":"Produktname","customerInvoice_table3Column3":"Größe","customerInvoice_ProductTableColumnQuantity":"Menge","customerInvoice_table3Column5":"Artikelpreis","customerInvoice_table3Column6":"Gesamtpreis","customerInvoice_table3Column7":"Ermäßigter Preis für Kunden","customerInvoice_table3Column8":"SalesRep-Provision","customerInvoice_table3Column9":"Rabatttyp","customerInvoice_repproInvite":"Aktivieren Sie das Kontrollkästchen, um eine professionelle Einladung zu senden","customerInvoice_customerOrder_error1":"Alle Kundenfelder sind Pflichtfelder. Bitte geben Sie die E-Mail-Adresse und den Vornamen des Kunden ein","customerInvoice_productAddedMsg":"Produkt hinzugefügt","customerInvoice_AlertErrorMsg":"Fehler. Bitte wenden Sie sich an den Support!","wholesaleOrder_title":"Großhandelsbestellung","wholesaleOrder_contentHeading1":"Sie können Produkte zu speziellen Großhandelspreisen erwerben","wholesaleOrder_contentHeading2":"Rabatt auf","wholesaleOrder_column1":"Name des Vertriebsmitarbeiters","wholesaleOrder_column2":"Rabatt","wholesaleOrder_searchtxtPlaceholder":"Produkt suchen","wholesaleOrder_table1Column1":"Bild","wholesaleOrder_table1Column2":"Menge hinzufügen","wholesaleOrder_table1Column3":"Titel","wholesaleOrder_table1Column4":"Variantentitel","wholesaleOrder_table1Column5":"Preis","wholesaleOrder_button":"Kasse","wholesaleOrder_Order_btn":"Mengenpreise anzeigen/ausblenden","wholesaleOrder_contentHeading3":"Gesamtpreis","wholesaleOrder_contentHeading4":"Ihr ermäßigter Preis","wholesaleOrder_table2Column1":"Produkt","wholesaleOrder_table2Column2":"Produktname","wholesaleOrder_table2Column3":"Größe","wholesaleOrder_table2Column4":"Menge","wholesaleOrder_table2Column5":"Artikelpreis","wholesaleOrder_table2Column6":"Gesamtpreis","wholesaleOrder_table2Column7":"Ihr ermäßigter Preis","affiliateLink_title":"Affiliate-Link","affiliate_product_link":"Produktlink","affiliateLink_input_error_msg":"Das Linktextfeld ist erforderlich und sollte keine Leerzeichen oder Sonderzeichen enthalten.","affiliateLink_contentHeading1":"Teilen Sie Ihren Affiliate-Link in sozialen Medien und per E-Mail. Für jede Bestellung über Ihren Affiliate-Link erhalten Sie eine Affiliate-Provision","affiliateLink_contentHeading2":"Ihr Affiliate-Link","affiliateLink_contentHeading3":"Kommission am","affiliateLink_content_Message1":"Suchen Sie nach Produkten und teilen Sie den Link einzelner Produkte mit Ihren Kunden.","affiliateLink_noaffiliateorderMsg":"Keine Affiliate-Bestellungen","affiliateLink_column1":"Name des Vertriebsmitarbeiters","affiliateLink_column2":"Kommission","affiliateLink_searchtxtPlaceholder":"Produkt suchen","affiliateLink_searchColumn1":"Produkt","affiliateLink_searchColumn2":"Produkttitel","affiliateLink_searchColumn3":"Preis","affiliateLink_searchColumn4":"Kommission","affiliateLink_searchColumn5":"Affiliate-Link","affiliateLink_searchColumn7":"Link kopieren","affiliateLink_searchColumn8":"Kopiert","affiliateLink_backbtn":"Zurück","affiliateLink_card_Title":"Kontaktkarte und Affiliate-Link","cartSharing_title":"Warenkorb teilen","cartSharing_CreateCartInformation_Text":"Um einen personalisierten, gemeinsam nutzbaren Warenkorb zu erstellen, fügen Sie Produkte aus der Storefront zum Warenkorb hinzu. Diese Produkte werden auf dieser Seite angezeigt","cartSharing_content2Placeholder":"Warenkorbname","cartSharing_table2Column2":"Produktname","cartSharing_table2Column3":"Größe","cartSharing_table2Column6":"Gesamtpreis","cartSharing_SharedCartLinkTableColumnCartName":"Warenkorbname","cartSharing_SharedCartLinkTableColumnLink":"Link","cartSharing_SharedCartLinkTableColumnCartLink":"Gemeinsam nutzbarer Warenkorb-Link","cartSharing_SharedCartLinkTableColumnCopyCartLink":"Warenkorb-Link kopieren","cartSharing_SharedCartLink_Other":"Andere","cartSharing_SharedCartLinkTableColumnDeleteCartLink":"Warenkorb-Link löschen","cartSharing_EnterCartName_Label":"Geben Sie den Warenkorbnamen ein","cartSharing_ProductTableColumnProduct":"Produkt","cartSharing_ProductTableColumnQuantity":"Menge","cartSharing_ProductTableColumnSku":"Sku","cartSharing_ProductTableColumnInventory":"Inventar","cartSharing_ProductTableColumnItemPrice":"Artikelpreis","cartSharing_Copied_Msg":"Kopiert!!","cartSharing_CartCreating_Msg":"Erstellen...","cartSharing_SharedCartLinkTableEmpty_Msg":"Kein Link zum Anzeigen","cartSharing_CartCreatedSuccessfully_Msg":"Ihr neuer Warenkorb wurde erfolgreich erstellt","cartSharing_CartCreateError_Msg":"Fehler. Bitte versuchen Sie es erneut","cartSharing_AlertError_Msg":"Fehler. Bitte wenden Sie sich an den Support!","cartSharing_CopyCartLink_Msg":"Warenkorb-Link kopieren","cartSharing_DeleteCartLink_Msg":"Warenkorb-Link löschen","cartSharing_DeleteConfirmation_Msg":"Bist du sicher ?","cartSharing_ProductTableEmpty_Msg":"Produkt nicht verfügbar","cartSharing_CreateCart_Btn":"Warenkorb erstellen","cartSharing_ProductTableQuantityUpdate_Btn":"Bitte Produkt auswählen","cartSharing_Select_product_Title":"Wählen Sie Produkt aus","discountCoupon_titleOne":"Rabattgutschein","discountCoupon_contentHeading1":"Teilen Sie Ihren Kunden den Discount-Gutscheincode mit und Sie erhalten bei jeder Verwendung Ihres Gutscheins eine Provision.","discountCoupon_contentHeading2":"Ihr Gutscheincode ist","discountCoupon_contentHeading3":"Rabattbetrag","discountCoupon_contentHeading4":"Kommission","discountCoupon_contentHeading4PlaceHolder1":"Hey, benutze meinen Rabatt-Gutscheincode","discountCoupon_contentHeading4PlaceHolder2":"und erhalten Sie vergünstigte Produkte","discountCoupon_button1":"Text kopieren","cartSharing_copiedButtonText":"Kopiert","discountCoupon_titleTwo":"Erstellen Sie einmalige Rabattgutscheine für Kunden","discountCoupon_button2":"Gutscheine ansehen","discountCoupon_contentHeading5":"Maximal zulässiger Rabatt","discountCoupon_contentHeading6":"Kommission","discountCoupon_contentHeading7":"Geben Sie den Gutscheincode ein","discountCoupon_contentHeading7PlaceHolder":"Bitte geben Sie den Gutscheincode ein","discountCoupon_contentHeading8":"Geben Sie den Rabatt ein","discountCoupon_contentHeading8PlaceHolder":"Der Rabatt sollte nicht größer sein als der maximale Rabatt.","discountCoupon_button3":"Gutschein erstellen","discountCoupon_coupon_error1":"Bitte geben Sie den Gutscheincode und den Rabatt ein","yourBio_title":"Ihre Kontaktkarte","yourBio_content1":"Profil hochladen","yourBio_button1":"Wählen Sie Datei","yourBio_button1PlaceHolder":"Keine Datei ausgewählt","yourBio_error_image_size":"Das Bild ist zu groß. Bitte laden Sie ein Bild mit einer Größe von weniger als 5 MB hoch. Bitte versuchen Sie es erneut.","yourBio_button2":"Hochladen","yourBio_content2":"Geben Sie ein benutzerdefiniertes Wort ein, um Ihren einzigartigen Affiliate-Link zu erstellen","yourBio_content2PlaceHolder":"Erstellen Sie Ihren einzigartigen Affiliate-Link","yourBio_content4":"Wenn Ihr Link verwendet wird, erscheint Ihre Kontaktkarte auf der Website","yourBio_content3":"Geben Sie Ihre Kontaktkarte ein","yourBio_content3PlaceHolder":"Geben Sie 100 Wörter ein","yourBio_button3":"Speichern","yourBio_button4":"Gespeichert","yourBio_error_link":"Dieser einzigartige Link darf verwendet werden. Versuchen Sie es mit einem anderen eindeutigen Link.","yourBio_Linksuccessmsg":"Eindeutiger Link erfolgreich gespeichert.","team_title1":"Vertriebsmitarbeiter hinzufügen","team_content1":"Geben Sie die E-Mail-Adresse ein","team_content1PlaceHolder":"E-Mail-Adresse","team_emailerrorMsg":"Bitte geben Sie Ihre E-Mail-Adresse ein","team_content2":"Geben Sie den Vornamen ein","team_content2PlaceHolder":"Vorname","team_fnameerrorMsg":"Bitte geben Sie den Vornamen ein","team_content3":"Geben Sie den Nachnamen ein","team_content3PlaceHolder":"Nachname","team_button1":"Hinzufügen","team_successmsg":"Der Vertreter wurde erfolgreich hinzugefügt. Er erhält seine Anmeldedaten an die angegebene E-Mail-Adresse.","team_errorsmsg":"Fehler beim Hinzufügen. Diese Benutzer-E-Mail-Adresse verfügt möglicherweise bereits über ein Konto im Shop.","team_title2":"Teamdetails","team_content4":"Anmeldeseite","team_NoTeamDetailsMsg":"Keine Teamdetails","team_content5":"Wählen Sie Vertriebsmitarbeiter aus","team_tableTitle":"BESTELLDETAILS DER LETZTEN ZWEI MONATE","team_column1":"Bestellnummer","team_column2":"Bestelldatum","team_column3":"Kundenname","team_column4":"Vertriebsmitarbeiter","team_column5":"Zwischensumme","team_column6":"Provision für Vertriebsmitarbeiter","team_column7":"Teammanager-Provision","team_column8":"Provisionstyp","addCustomer_title":"Kunde hinzufügen","addCustomer_content1":"Vorname des Kunden","addCustomer_txt1Placeholder":"Vorname","addCustomer_content2":"Nachname des Kunden","addCustomer_content2Placeholder":"Nachname","addCustomer_content3":"Kunden-E-Mail-ID","addCustomer_content3Placeholder":"E-Mail-Adresse","addCustomer_content4":"Notiz","addCustomer_content4Placeholder":"Notiz","addCustomer_customerAddress":"Persönliche Adresse","addCustomer_customerCity":"Stadt","addCustomer_customerCityPlaceholder":"Stadt","addCustomer_customerCountry":"Land","addCustomer_customerState":"Zustand","addCustomer_customerZipCode":"PLZ","addCustomer_companyName":"Name der Firma","addCustomer_companyAddress":"Firmenadresse","addCustomer_companyCity":"Stadt","addCustomer_companyCountry":"Land","addCustomer_companyState":"Zustand","addCustomer_companyZipCode":"PLZ","addCustomer_button":"Speichern","addCustomer_leadsuccessmsg":"Der Kunde wurde erfolgreich hinzugefügt.","addCustomer_leadErrrorMsg":"Fehler beim Speichern der Details.","addCustomer_leadEmptyErrrorMsg":"Bitte füllen Sie das erforderliche Feld aus.","addCustomer_leadsuccessmsg2":"Der Kunde wurde erfolgreich erstellt und einem Vertriebsmitarbeiter zugeordnet.","addCustomer_leadErrrorMsg2":"Dieser Kunde ist bereits einem Vertreter zugeordnet.","myCustomers_title":"Ihre Kunden","myCustomers_table1Column1":"Name","myCustomers_table1Column2":"Name der Firma","myCustomers_table1Column3":"E-Mail-ID","myCustomers_table1Column4":"Befehl","myCustomers_table1Column5":"Gesamtausgaben","myCustomers_table2Title":"Kundendaten","myCustomers_table3Title":"DETAILS DES BESTELLENTWURFS","myCustomers_table3Column1":"Produktname","myCustomers_table3Column2":"Größe","myCustomers_table3Column3":"Menge","myCustomers_table3Column4":"Preis","myCustomers_table3Column5":"Status","myCustomers_table3Column6":"Zwischensumme","myCustomers_table2Row1":"Name","myCustomers_table2Row2":"E-Mail","myCustomers_table2Row3":"Adresse","myCustomers_table2Row4":"Name der Firma","myCustomers_table2Row5":"Kundennotizen","myCustomers_table2Row6":"Gesamtausgaben (Zwischensumme + Steuern)","myCustomers_table2Row7":"Anzahl der Bestellungen","myCustomers_table2Row8":"Schlagworte","myCustomers_radioButton0":"Alle Kunden anzeigen","myCustomers_radioButton1":"Nach Namen suchen","myCustomers_radioButton2":"Suche nach Unternehmen","myCustomers_radioButtonError1":"Bitte wählen Sie den Suchtyp aus und geben Sie den Suchwert ein","myCustomers_radioButtonError2":"Bitte geben Sie einen Wert ein, um zu suchen","myCustomers_radioButtonError3":"Bitte wählen Sie den Suchtyp aus","myCustomers_searchButton":"Suchen","myCustomers_Placeholder1":"Geben Sie den Namen des Kunden oder des Unternehmens ein, um zu suchen","myCustomers_NoOrdersError":"Keine Bestellungen","myCustomer_no_salesRep_details":"Keine Details zum Vertriebsmitarbeiter verfügbar.","myCustomer_select_customer_country":"Bitte wählen Sie das Kundenland aus","myCustomer_company_country":"Firmenland","myCustomer_company_state":"Unternehmensstatus","myCustomer_select_company_country":"Bitte wählen Sie das Land des Unternehmens aus","yourSales_SalesOrderDetailsTitle":"Details zum Kundenauftrag","yourSales_title":"Bestelldetails der letzten 2 Monate","yourSales_table1Column1":"Bestell-Nr.","yourSales_table1Column2":"Bestelldatum","yourSales_table1Column3":"Kundenname","yourSales_table1Column4":"Zwischensumme","yourSales_table1Column5":"Kommission","yourSales_table1Column6":"Provisionstyp","yourSales_table1Column7":"Rechnung drucken","printOrderInvoice_btn":"Drucken","yourSales_tableTitle":"Produktdetails","yourSalesDraft_tableTitle":"Details zum Bestellentwurf","yourSales_column1":"Produkt","yourSales_column2":"Titel","yourSales_column3":"Menge","yourSales_column4":"Artikelpreis","yourSales_column5":"Tracking-Nummer","yourSales_column6":"Versanddatum","yourSales_column7":"Gesamtpreis","yourSales_content1":"Zwischensumme","yourSales_content2":"Steuer","yourSales_content3":"Versandkosten","yourSales_content4":"Gesamt","yourSales_content5":"Notiz","yourSales_tabHeading1":"Bezahlte Bestellungen","yourSales_tabHeading4":"Ausstehende Bestellungen","yourSales_tabHeading2":"Auftragsentwürfe","myOrders_title":"Details zu meinen Bestellungen","myOrdersDetails_Message":"Bestellungen für Sie selbst aufgegeben","myOrders_table1Column1":"Bestellnummer","myOrders_table1Column2":"Bestelldatum","myOrders_table1Column3":"Kundenname","myOrders_table1Column4":"Zahlung","myOrders_table1Column5":"Erfüllung","myOrders_table1Column6":"Gesamt","myOrders_tableTitle":"PRODUKTDETAILS","myOrders_table2Column1":"Produkt","myOrders_table2Column2":"Titel","myOrders_table2Column3":"Menge","myOrders_table2Column4":"Artikelpreis","myOrders_table2Column5":"Tracking-Nummer","myOrders_table2Column6":"Versanddatum","myOrders_table2Column7":"Gesamtpreis","myOrders_content1":"Zwischensumme","myOrders_content2":"Steuer","myOrders_content3":"Versandkosten","myOrders_content4":"Gesamt","myOrders_content5":"Notiz","myOrders_content6":"Entwurfs-ID","tab_Dashboard":"Verwaltungsbereich","dashbord_Tab":"Startseite","tab_CustomerInvoice":"Bestellung anlegen","tab3_WholesaleOrder":"Großhandelsbestellung","tab_AffiliateLink":"Affiliate-Link","tab_CartSharing":"Warenkorb teilen","tab_DiscountCoupon":"Rabattgutschein","tab7_YourBio":"Ihre Kontaktkarte","tab8_Team":"Team","tab9_AddCustomer":"Kunde hinzufügen","tab_MyCustomers":"Meine Kunden","tab_YourSalesOrderDetails":"Details zum Kundenauftrag","tab12_MyOrders":"Details zu meinen Bestellungen","tab13_Logout":"Abmelden","signUp_title":"Anmeldung für Vertriebsmitarbeiter","signUp_subTitle":"Bitte füllen Sie dieses Formular aus, um sich als Vertriebsmitarbeiter zu registrieren und Zugriff auf alle Funktionen des Vertriebsteams zu erhalten.","signUp_content1":"E-Mail","signUp_content2":"Vorname","signUp_content3":"Nachname","signUp_content4":"Telefonnummer","signUp_content5":"Facebook-Handle","signUp_content6":"Twitter-Handle","signUp_content7":"Instagram-Handle","signUp_content8":"Profilbild hochladen","signUp_socialmedialable1":"Social-Media-Links","signUp_socialmedialable2":"optional","signUp_uploadBtn":"Wählen Sie Datei","signUp_uploadBtnPlaceHolder":"Keine Datei ausgewählt","signUp_button3":"Details werden gespeichert...","signUp_welcomemsg1":"Hallo","signUp_welcomemsg2":"Melden Sie sich als Vertriebsmitarbeiter an und erhalten Sie eine Provision für die Verkäufe der Vertriebsmitarbeiter unter Ihnen","signUp_emailerror":"Bitte geben Sie Ihre E-Mail-Adresse ein","signUp_Fnameerror":"Bitte geben Sie den Vornamen ein","signUp_lnameerror":"Bitte geben Sie den Nachnamen ein","signUp_phnumbererror":"Bitte geben Sie die Telefonnummer ein","signUp_successmsg":"Ihre Anfrage wurde erfolgreich registriert. Sie erhalten in Kürze eine E-Mail zur Kontoaktivierung, sobald unser Administrator Ihre Anfrage genehmigt.","signUp_errorsmsg":"Fehler beim Speichern der Details. Diese Benutzer-E-Mail-Adresse verfügt möglicherweise bereits über ein Konto im Shop.","signUp_RepExistErrorMsg":"Diese E-Mail-Adresse ist bereits als Vertreter registriert.","addingRep_selectRepsLabel1":"Wer hat dir geholfen?","addingRep_NoSalesRep":"Kein Vertriebsmitarbeiter","addingRep_successMsg":"RepId zur Warenkorbnotiz hinzugefügt","addingRep_selectRepsLabel2":"Bitte wählen Sie einen Eintrag in der Liste aus.","wholesaleOrder_WholesaleDiscountTableColumn1":"Produkttitel","wholesaleOrder_WholesaleDiscountTableColumn2":"Rabatt","customerInvoice_ViewClientOrdersColumn1":"Kundenname","customerInvoice_ViewClientOrdersColumn2":"Produkttitel","customerInvoice_ViewClientOrdersColumn3":"Zwischensummenpreis","customerInvoice_ViewClientOrdersColumn4":"Status","customerInvoice_ViewClientOrdersColumn5":"Rechnung","salesRep_order_errorMsg":"Fehler beim Erstellen Ihrer Bestellung. Bitte kontaktieren Sie den Support","salesRep_order_successMsg":"Bestellrechnung erfolgreich erstellt! Die Rechnung wurde per E-Mail an den Kunden gesendet!","salesRep_order_errorMsg2":"Fehler beim Erstellen Ihrer Bestellung. Bitte kontaktieren Sie den Support","customedraft_btn1":"Neue Rechnung erstellen","customedraft_btn2":"Keine Produkte ausgewählt. Bitte wählen Sie Produkte aus und versuchen Sie es erneut.","customedraft_btn3":"Ordnung schaffen...","customedraft_btn4":"Neue Rechnung erstellen","salesRep_order_NoProductSelected":"Keine Produkte ausgewählt. Bitte wählen Sie Produkte aus und versuchen Sie es erneut.","productnotselectforcartsharingtxt1":"Keine Produkte ausgewählt. Bitte wählen Sie Produkte aus und versuchen Sie es erneut.","discountCoupons_tblColumn1":"Gutscheincode","discountCoupons_tblColumn2":"Coupon-Rabatt","discountCoupons_tblColumn3":"Gutscheincode löschen","discountedPriceLabel":"Ihr ermäßigter Preis","couponCodeNotSet":"Gutscheincode nicht festgelegt","dashboard_subTitle2":"Aktueller Monatszyklus","affiliatelink_commissiononlbl":"Produkt","displaycommission_lbl1":"Produkttyp","displaycommission_lbl2":"Vertriebsmitarbeiter","displaycommission_lbl3":"Mengenrabatt","discountcommissiononlbl1":"Kundenrabattstufen","clientInvoiceCommissionTablecolumn1":"Produkttyp","clientInvoiceCommissionTablecolumn2":"Kommission","clientInvoiceCommissionTablecolumn3":"Produkttitel","clientInvoiceCommissionTablecolumn4":"Name des Vertriebsmitarbeiters","clientInvoiceQuantityBaseDiscountTablecolumn1":"Produktname","clientInvoiceQuantityBaseDiscountTablecolumn2":"Rabatt","clientInvoiceQuantityBaseDiscountTablecolumn3":"Menge","affiliateCartProdtableColumn1":"Produkt","affiliateCartProdtableColumn2":"Produkttitel","affiliateCartProdtableColumn3":"Preis","affiliateCartProdtableColumn4":"Kommission","affiliateCartProdtableColumn5":"Affiliate-Link","affiliateCartProdtableColumn6":"Link teilen","productnotselectforcartsharinglbl1":"Bitte geben Sie den Warenkorbnamen ein","productnotselectforcartsharinglbl2":"Keine Produkte ausgewählt. Bitte wählen Sie Produkte aus und versuchen Sie es erneut.","productnotselectforcartsharinglbl3":"Während der Verarbeitung warten...","showSharedCartProductcolumn1":"Warenkorb-Link","showSharedCartProductcolumn3":"Warenkorb entfernen","onSuccessInvoiceSuccessMsg":"Rechnung erfolgreich gesendet","onSuccessInvoiceFailedMsg":"Das Versenden der Rechnung ist fehlgeschlagen","sendInvoice_successMsg":"Rechnung erfolgreich gesendet","deleteInvoice_successMsg":"Rechnung erfolgreich gelöscht","deleteInvoice_FailedMsg":"Rechnung löschen fehlgeschlagen","deleteInvoice_btnlbl":"Rechnung löschen","deleteSharedCartLink_successMsg":"Link erfolgreich gelöscht","deleteSharedCartLink_FailedMsg":"Fehler beim Löschen des Links. Bitte versuchen Sie es erneut.","deleteSharedCartLink_btnlbl":"Link wird gelöscht","viewInvoiceOrders_btntxt1":"Erhalten...","viewInvoiceOrders_btntxt2":"Frühere Bestellungen anzeigen","createCoupon_btnlbl1":"Gutschein erstellen..","createCoupon_btnlbl2":"Gutschein erstellt","deleteCoupon_successMsg":"Gutschein gelöscht","deleteCoupon_FailedMsg":"Das Löschen des Gutscheins ist fehlgeschlagen","deleteCoupon_btnlbl":"Löschen...","viewProductModelColumn1":"Produkt","viewProductModelColumn2":"Titel","viewProductModelColumn3":"Menge","viewProductModelColumn4":"Erstatteter Betrag","viewProductModelColumn5":"Artikelpreis","viewProductModelColumn6":"Scheibe. Preis","viewProductModelColumn7":"Tracking-Nummer","viewProductModelColumn8":"Versanddatum","viewProductModelColumn9":"Gesamtpreis","showSharedCartProducts_column2":"Bild","showSharedCartProducts_column3":"Menge hinzufügen","showSharedCartProducts_column4":"Titel","showSharedCartProducts_column5":"Variantentitel","showSharedCartProducts_column6":"Preis","viewClientOrders_btn1":"Sicht","viewClientOrders_btn2":"Schicken","viewClientOrders_btn3":"Löschen","showCouponTable_txt1":"Erhalten...","showCoupon_btn2":"Gutscheine ansehen","showCoupon_btn1":"Kopiert","affliateOrder_column1":"Kundenname","affliateOrder_column2":"Kunden-E-Mail","affliateOrder_column3":"Produkttitel","affliateOrder_column4":"Bestelldatum","affliateOrder_column5":"Zwischensumme","affliateOrder_column6":"Kommission","affliateOrder_btn1":"Erhalten...","affliateOrder_btn2":"Affiliate-Bestellungen anzeigen","affliateOrder_btn3":"Affiliate-Bestellungen anzeigen","yourBio_btn1":"Speichern","yourBio_btn2":"Speichern","yourBio_Uploadbtn1":"Hochladen...","yourBio_Uploadbtn2":"Hochgeladen","yourBio_UploadbtnError":"Tut mir leid, versuchen Sie es noch einmal","yourBio_Savebtn":"Sparen..","team_txt1":"Sparen..","team_txt2":"Speichern","viewRepClientOrdersDetails_column1":"Bestellnummer","viewRepClientOrdersDetails_column2":"Bestelldatum","viewRepClientOrdersDetails_column3":"Zwischensumme","viewRepClientOrdersDetails_column4":"Status","viewRepClientOrdersDetails_column5":"Produktdetails","addSalesRep_txt1":"Vertriebsmitarbeiter hinzufügen","addSalesRep_txt2":"Vertriebsmitarbeiter wird hinzugefügt...","discountCoupons_header":"Einmaliger Rabattgutschein","discountCoupons_nodiscountcoupon":"Sie haben keinen Rabattgutschein erstellt","discountCoupons_deleteBtn":"Löschen","discountCoupons_BackBtn":"Zurück","customerInvoice_selectcustomererror":"Bitte wählen Sie „Kunde“ aus und fügen Sie dann das Produkt hinzu","createOrderFromCartPage_selectCustomersLabel":"KUNDE AUSWÄHLEN","createOrderFromCartPage_selectCustomerAddressLabel":"LIEFERADRESSE","createOrderFromCartPage_selectCustomersLabelForDropDown":"Wählen Sie Kunde aus","createOrderFromCartPage_selectCustomerAddressLabelForDropDown":"Wählen Sie Adresse","createOrderFromCartPage_successMsg":"Bestellrechnung erfolgreich erstellt! Die Rechnung wurde per E-Mail an den Kunden gesendet!","createOrderFromCartPage_AddNewAddressTitle":"NEUE ADRESSE HINZUFÜGEN","createOrderFromCartPage_draftOrderButton":"AUFTRAGSENTWURF ERSTELLEN","createOrderFromCartPage_OrderButton":"Bestellung anlegen","createOrderFromCartPage_draftOrderButtonText2":"AUFTRAG ERSTELLEN...","createOrderFromCartPage_selectShippingCostTitle":"VERSANDKOSTEN","createOrderFromCartPage_Address_errorMsg4":"Bei der Berechnung Ihrer Versandkosten ist ein Problem aufgetreten.","createOrderFromCartPage_Address_errorMsg5":"Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.","yourSales_tabHeading3":"Rückerstattungsaufträge","refundOrders_column1":"Rückerstattungs-ID","refundOrders_column2":"Bestelldatum","refundOrders_column3":"Bestell-Nr.","refundOrders_column4":"Bestellname","refundOrders_column5":"Kommission","refundOrders_column6":"Teammanager-Provision","refundOrders_column7":"Teammanager-ID","refundOrders_column8":"Zwischensumme erstatten","refundOrders_column9":"Bestellstatus","refundOrders_column10":"Auftragsart","refundOrderNumber_title":"Details zur Rückerstattungsbestellung","refundOrderNumber_column1":"Name","refundOrderNumber_column2":"Datum","refundOrderNumber_column3":"Menge","refundOrderNumber_column4":"Rabattpreis","refundOrderNumber_column5":"Zwischensumme","tableDataError":"Kein Rückerstattungsauftrag","dashboard_subTitle3":"Einzelheiten zur Kommission","dashboard_cardHeading5_1":"Kommission am","dashboard_cardHeading5_2":"Du bekommst ein","dashboard_cardHeading5_3":"Provision auf alle Bestellungen.","Profit_Margin":"Gewinnspanne","Product_Type":"Produkttyp","Sales_Rep":"Vertriebsmitarbeiter","show_commission_list":"Provisionsliste anzeigen","commission_list":"Kommissionsliste","no_customers_to_show":"Keine Kunden zum Anzeigen","no_sales_to_show":"Keine Verkäufe vorhanden","no_draft_to_show":"Kein Entwurf zum Anzeigen","no_refund_to_show":"Keine Rückerstattung möglich","no_orders_to_show":"Keine Befehle vorhanden","customerInvoice_ViewClientOrdersColumn6":"Bestellnummer","customerInvoice_ViewClientOrdersColumn7":"Bestelldatum","Error_commissions_NotUpdated":"Provisionen werden nicht aktualisiert","sales_chart_msg1":"Wir brauchen Daten...","sales_chart_msg2":"Es sieht so aus, als hätten wir noch keine Daten zum Anzeigen.","page_refresh_msg":"Klicken Sie zum Aktualisieren","variant_title":"Variantentitel","line_items_properties":"Eigenschaften","customer_country":"Kundenland","customer_state":"Kundenstatus","company_country":"Firmenland","company_state":"Unternehmensstatus","client_orders":"Kundenaufträge","no_product_details":"Es können keine Produktdetails angezeigt werden","submit_btn_text":"Einreichen","submitting_btn_text":"Einreichen","submitted_btn_text":"Eingereicht","email_id_validation_errmsg":"Bitte geben Sie eine gültige E-Mail-ID ein","customerInvoice_add_more_details":"Fügen Sie weitere Details hinzu","customerInvoice_add_shipping_address":"Neue Lieferadresse hinzufügen","customerInvoice_HideDetails":"Details ausblenden","customerInvoice_HideAddress":"Lieferadresse ausblenden","customerInvoice_enterFirstName":"Geben Sie den Vornamen ein","customerInvoice_enterFirstNamePlaceholder":"Vorname","customerInvoice_enterLastName":"Geben Sie den Nachnamen ein","customerInvoice_enterLastNamePlaceholder":"Nachname","customerInvoice_enterAddress1":"Geben Sie Adresszeile 1 ein","customerInvoice_enterAddress1Placeholder":"Adresszeile 1","customerInvoice_enterAddress2":"Geben Sie Adresszeile 2 ein","customerInvoice_enterAddress2Placeholder":"Adresszeile 2","customerInvoice_enterCity":"Stadt eingeben","customerInvoice_enterCityPlaceholder":"Stadt","customerInvoice_selectCountry":"Wählen Sie Land aus","customerInvoice_selectState":"Wählen Sie Staat aus","customerInvoice_enterZipNumber":"Geben Sie die Postleitzahl ein","customerInvoice_enterZipNumberPlaceholder":"PLZ","customerInvoice_ProductTableColumnSku":"Artikelnummer","customerInvoice_ProductTableColumnInventory":"Inventar","customerInvoice_ProductTableEmpty_Msg":"Produkt nicht verfügbar","customerInvoice_SendInvoiceBtn":"Rechnung senden","customerInvoice_CreateBtn":"Erstellen","customerInvoice_CreatingBtn":"Erstellen","customerInvoice_ProductTableColumnSubTotal":"Zwischensumme","customerInvoice_SelectShippingAddress":"Wählen Sie die Lieferadresse aus","customerInvoice_ProductsSearchBy_Placeholder":"Suchen Sie Produkte nach Name, SKU-Preis","customerInvoice_AddMoreProducts_Btn":"Weitere Produkte hinzufügen","customerInvoice_RequiredErrorMsg":"Dieses Feld ist erforderlich.","customerInvoice_EmailSuggestionErrorMsg":"Bitte fügen Sie eine gültige E-Mail-ID hinzu","customerInvoice_MobileSuggestionErrorMsg":"Bitte fügen Sie eine gültige Telefonnummer hinzu","customerInvoice_ErrorMsgAddShippingAddress":"Bitte geben Sie die Lieferadresse ein","customerInvoice_Creating_Msg":"Erstellen...","customerInvoice_Sending_Msg":"Senden...","customerInvoice_OrderCreatedSuccessfullyMsg":"Bestellung erfolgreich erstellt","customerInvoice_InvoiceSentSuccessfullyMsg":"Rechnung erfolgreich an den Kunden gesendet","customerInvoice_ErrorMsgTryAgain":"Fehler. Bitte versuchen Sie es erneut","customerInvoice_Selected_Btn":"Ausgewählt","customerInvoice_ProductTableQuantityUpdate_Btn":"Bitte Produkt auswählen","customerInvoice_OrderSubTotal":"Zwischensumme bestellen","delete_confirmation_text":"Bist du sicher ?","draftOrder_OrderNumber":"Bestellnummer","draftOrder_CustName":"Kundenname","draftOrder_OrderDate":"Bestelldatum","draftOrder_SubTotal":"Zwischensumme","draftOrder_Status":"Status","draftOrder_Invoice":"Rechnung","draftOrder_DraftId":"Entwurfs-ID","draftOrder_ShippingCost":"Versandkosten","draftOrder_Tax":"Steuer","draftOrder_TotalPrice":"Gesamtpreis","draftOrder_Note":"Notiz","draftOrder_Product":"Produkt","draftOrder_ProductName":"Produktname","draftOrder_Size":"Größe","draftOrder_Quantity":"Menge","draftOrder_Price":"Preis","noDraftOrderProducts":"Keine Produktdetails zum Entwurf einer Bestellung verfügbar.","noRefundOrderProduct":"Keine Produktdetails zur Rückerstattungsbestellung verfügbar.","loading":"Laden...","dashboard_commissionOn_profitMargin":"Provision auf die Gewinnspanne","dashboard_clientInvoice":"Kundenrechnung","dashboard_affiliateLink":"Affiliate-Bestellung","dashboard_returnCustomer":"Rücksendekunde","dashboard_discountCoupon":"Rabattgutschein","dashboard_SharedCart":"Geteilter Warenkorb","dashboard_AdminTaggedOrders":"Vom Administrator markierte Bestellung","dashboard_no_data":"Keine Daten verfügbar","dashboard_sales_of_last_six_months":"Verkäufe der letzten 6 Monate","dashboard_sales_of_current_month":"Verkäufe des aktuellen Monats","addCustomer_ErrorMsgOnSubmitBtn":"Bitte geben Sie eine gültige Telefonnummer ein","login_welcome_Msg":"Willkommen im Vertriebsteam","login_title":"Login","login_email":"E-Mail-ID","login_password":"Passwort","emailValidation_ErrorMsg":"Bitte geben Sie eine gültige E-Mail-ID ein","login_newUser":"Neuer Benutzer?","login_SignUp":"Melden Sie sich an","login_forgotPassword_link":"Passwort vergessen?","login_LogInBtn":"Einloggen","login_sliderContent_1":"Vertreter, die im Namen von Kunden Bestellungen aufgeben","login_sliderContent_2":"Der Vertreter leitet den Verkehr zum Laden","login_sliderContent_3":"Rep vermarktet Produkte über Social-Media-Plattformen","login_sliderContent_4":"Rep kann in großen Mengen einkaufen und Gewinn machen","login_sliderContent_5":"Vertreter, die im Namen von Kunden Bestellungen aufgeben","login_sliderContent_6":"Vertreter können Kunden persönlich besuchen und Bestellungen aufgeben","required_ErrorMsg":"Bitte füllen Sie das Pflichtfeld aus","signup_title":"Melden Sie sich an","signup_BackTo_login":"Zurück zum Anmelden","signup_firstName":"Vorname","signup_lastName":"Nachname","signup_BackBtn":"Zurück","signup_NextBtn":"Nächste","signup_phone_number":"Telefonnummer","signup_phone_number_Error":"Bitte geben Sie mindestens 10 Ziffern ein","signup_uploadPicture":"Profilbild hochladen","signup_fileSizeError":"Die Dateigröße ist größer als 5 MB","signup_filePath_lable":"Ausgewählte Datei","signup_MediaTitle2":"Social-Media-Links","signup_facebookHandle":"Facebook-Handle","signup_InstaHandle":"Instagram-Handle","signup_SaveBtn":"Details speichern","forgotPwd_title":"Passwort vergessen","forgotPwd_ResetBtn":"Passwort zurücksetzen","forgotPwd_SuccessMsg":"Ihre Anfrage zum Zurücksetzen des Passworts war erfolgreich. Wir haben das neue Passwort an Ihre registrierte E-Mail-ID gesendet.","customerInvoice_selectShippingCost":"Wählen Sie Versandkosten aus","customerInvoice_CalculatingShippingRates_Msg":"Berechnen...","customerInvoice_AddShippingAddress_Msg":"Wählen Sie Adresse oder Lieferadresse hinzufügen","customerInvoice_PleaseSetAnyShippingAddressMsg":"Bitte wählen Sie eine beliebige Lieferadresse aus","customerInvoice_ShippingCostErrorMsg":"Bitte fügen Sie eine neue Lieferadresse hinzu, da die Adresse nicht genügend Informationen enthält.","customerInvoice_CalculateShippingCost_Btn":"Berechnen Sie die Versandkosten","customerInvoice_ShippingCostAddOrNot_Msg":"Möchten Sie Versandkosten hinzufügen?","customerInvoice_ShippingCostAddOrNot_Yes":"Ja","customerInvoice_ShippingCostAddOrNot_No":"NEIN","shop_utterly_conkers_ShippingCostCompulsory_ErrorMsg":"Ihre Bestellung wird erst dann aufgegeben, wenn die Versandkosten hinzukommen","shop_utterly_conkers_AddMoreProducts__ErrorMsg":"Bitte fügen Sie weitere Produkte hinzu, um die Versandkosten zu berechnen","customerInvoice_ShippingCostErrorMsg_TryAgain":"Bitte versuchen Sie es erneut","dashboard_BannerMsg":"Die Grafiken werden alle 8 Stunden aktualisiert","yourSales__BannerMsg":"Die Bestelldetails werden alle 5 Minuten aktualisiert","customerInvoice_FirstNameErrorMsg":"Bitte geben Sie den Vornamen ein","customerInvoice_lastNameErrorMsg":"Bitte geben Sie den Nachnamen ein","customerInvoice_Add1ErrorMsg":"Bitte geben Sie die Adresszeile 1 ein","customerInvoice_CountryErrorMsg":"Bitte Land auswählen","customerInvoice_StateErrorMsg":"Bitte Bundesland auswählen","customerInvoice_CityErrorMsg":"Bitte geben Sie den Namen der Stadt ein","customerInvoice_ZipErrorMsg":"Bitte Postleitzahl eingeben","uploadImage":"Bild hochladen","dashboard_CardTitle1":"Provision auf alle Bestellungen","dashboard_CardTitle3":"Gesamtprovision","dashboard_CardTitle4":"Gesamtumsatz","dashboard_TotalAvg_Ticket_Size":"Durchschnittlicher Bestellwert","dashboard_TotalRevenue":"Gesamtumsatz","profile_Change_Password":"Kennwort ändern","dashboard_Information_Message":"Die Provision wird nur für bezahlte Bestellungen erfasst","resetPassword_validation_Msg":"Dieses Feld ist erforderlich","resetPassword_validation_Msg2":"Das Passwort sollte mindestens 8 Zeichen1 Großbuchstaben1 Kleinbuchstaben1 Ziffer usw. enthalten.","resetPassword_validation_Msg3":"Das Bestätigungspasswort sollte mit dem neuen Passwort übereinstimmen","dashbord_Msg_New":"Wie es funktioniert","dashbord_informationMsg":"Information","discount_couponErrorMsg":"Der maximale Rabatt ist nicht konfiguriert. Bitte wenden Sie sich an den Site-Administrator.","discount_couponErrorMsg2":"Provision ist nicht konfiguriert. Bitte wenden Sie sich an den Site-Administrator.","dashbord_profile_pic":"Profilbild ändern","Performance_Details":"Leistungsdetails","Show_Performance_Details":"Leistungsdetails anzeigen","Dashboard_Month":"Monat","Dashboard_Orders_Total":"Gesamtbestellungen","Dashboard_Total_Sale":"Gesamtverkauf","Dashboard_Commission":"Kommission","Dashboard_Bonus":"Bonus","customerInvoice_EditOrder_NoAutoSelectedAddress":"Bitte Kundenadresse hinzufügen.","customerInvoice_EditOrder_NoAutoSelectedShippingCost":"Bitte wählen Sie die Versandkosten aus.","customerInvoice_EditOrder_ErrorMsgForCartUpdate":"Der Warenkorb wurde nicht aktualisiert. Bitte aktualisieren Sie ihn und versuchen Sie es erneut.","customerInvoice_EditOrder_ErrorMsgForProductSelected":"Bitte Produkt auswählen.","customerInvoice_CreatingDraft_Msg":"Entwurf erstellen..","customerInvoice_DraftOrderBtn":"Bestellentwurf","customerInvoice_DraftOrderCreatedSuccessfullyMsg":"Bestellentwurf erfolgreich erstellt","productTable_error_AlertMsg":"Die Menge darf nicht 0 oder weniger sein. Bitte geben Sie einen gültigen Wert ein.","productTable_error_AlertMsg2":"Bitte Menge eingeben","click_to_copy":"Klicken Sie zum Kopieren","discount_code_copy_coupon":"Gutschein kopieren","createOrder_productSearchGuide":"Sie können keine Produkte finden?","soldOut":"Ausverkauft","InventoryNotTracked":"Lagerbestand nicht nachverfolgt","productStatus":"Produktstatus","makeSureInShopify":"Stellen Sie sicher, dass Sie dies in Shopify tun","products":"Produkte","sectionTheProductStatusIs":"Abschnitt, in dem sich der Produktstatus befindet","active":"Aktiv","productsMayBeSoldOutPleaseCheck":"Produkte können ausverkauft sein. Bitte überprüfen und auswählen","yourSales_PaidOrders_PaidDate":"Zahlungsdatum der Bestellung","ordersLoading":"Bestellungen werden geladen...","productsLoading":"Produkte werden geladen...","leaveOnPageBtn":"Weitermachen","stayOnPageBtn":"Bleiben Sie auf dieser Seite","alertBoxTitle":"Bestellseite erstellen","alertMessage":"Nicht gespeicherte Änderungen gehen verloren. Sie können diese Bestellung als Entwurf speichern.","salesDetailsHeader_Location":"Standort","tab_CreateB2BOrder":"B2B-Bestellung","b2b_no_company_data_available":"Keine Unternehmensdaten verfügbar","b2b_select_location":"Wählen Sie Standort aus","b2b_select_customer":"Wählen Sie Kunde aus","b2b_select_location_customer":"Wählen Sie Kunde/Standort aus","b2b_SelectedCompanyDetails":"Ausgewählte Firmendetails","b2b_no_location_data":"Keine Standorte verfügbar","b2b_no_customer_data":"Keine Kundendaten verfügbar","b2b_removeSelectedCustomer":"Entfernen","b2b_emailId":"E-Mail-ID","b2b_customerName":"Kundenname","b2b_companyName":"Name der Firma","b2b_BillingAddress":"Rechnungsadresse","b2b_ShippingAddress":"Lieferadresse","ST_CO_no_result_found_msg":"Keine Ergebnisse gefunden für","ST_CO_SearchProducts_Label":"Produkte suchen","ST_CO_search":"Suchen","ST_Producttable_netQuantity":"Nettomenge","ST_Producttable_subtotal":"Zwischensumme","ST_Producttable_wholesalePrice":"Großhandelspreis","ST_Producttable_retailPrice":"Verkaufspreis","ST_Producttable_SKU":"Artikelnummer","ST_Producttable_product":"Produkt","createOrder_select_product":"Wählen Sie Produkt aus","createOrder_AddProduct":"Produkt hinzufügen","createOrder_AddBtn":"Hinzufügen","CreateOrder_doneBtn":"Erledigt","createOrder_productTable_NoProductsAdded":"Keine Produkte hinzugefügt","productTable_clearCartBtn":"Leeren Sie den Warenkorb","b2b_companyTable_noMainContact":"Kein Hauptkontakt verfügbar","ST_none":"Keiner","CreateOrder_EnterPoNumber":"Geben Sie die Bestellnummer ein","CreateOrder_chooseDateMsg":"Wählen Sie ein Datum","CreateOrder_paymnetTerms":"Zahlungsbedingungen","CreateOrder_TaxExemption":"Steuerbefreiung","b2b_select_company":"Wählen Sie Unternehmen aus","draftOrder_CompanyName":"Name der Firma","CreateOrder_Company":"Unternehmen","Create_Order_TotalLocations":"Gesamtzahl der Standorte","Create_Order_MainContact":"Hauptkontakt","Create_Order_PaymentDueLater":"Zahlung später fällig","yourSales_headerLocation":"Standort","salesDetailsHeader_Company":"Unternehmen","customerInvoice_PaymentPending":"Zahlung ausstehend","customerInvoice_Checkout":"Kasse","customerInvoice_ProceedToCheckout":"Gehen Sie zur Kasse","customerInvoice_CheckoutMsg":"Dadurch wird ein Bestellentwurf erstellt, der Sie zur Checkout-Seite weiterleitet. Falls der Bestellvorgang fehlschlägt, finden Sie diese Bestellung auf der Registerkarte „Kundenauftragsdetails“ unter „Bestellentwürfe“.","customerInvoice_sendInvoiceToCustomer":"Rechnung an den Kunden senden","customerInvoice_cancel":"Stornieren","Checkout_DoNotAskAgainMsg":"Fragen Sie nicht noch einmal","RepCheckout_RedirectionMsg":"Weiterleitung zur Kasse","customerInvoice_CreatingDraftCheckout":"Entwurf mit Checkout erstellen...","customerInvoice_OrderType":"Auftragsart","DoNotShowAgain":"Nicht mehr anzeigen","copyLinkSuccess":"Link erfolgreich kopiert","affiliateLink_Confirmation_Msg1":"Die Auftragsverfolgung über den Affiliate-Link funktioniert nur, wenn der Kunde darauf klickt","affiliateLink_Confirmation_Msg3":"Die Schaltfläche wird nicht wirksam, wenn der Kunde auf die Schaltfläche klickt","affiliateLink_Confirmation_Msg4":"Jetzt kaufen","affiliateLinkConfirmationMsg2":"In den Warenkorb legen","affiliateLink_Confirmation_Msg5":"Taste.","productsPerPage":"Produkte pro Seite","productTableCartClearButton":"Klar","affiliateLink_Confirmation_Note":"NOTIZ","myCustomers_searchByCustomerOrCompanyName":"Suchen Sie nach Kunden- oder Firmennamen","ST_Producttable_VolumePricing":"Mengenpreise","dashboard_B2BCompanyLocation":"Firmenstandort","customer":"Kunde","PaidDate":"Bezahltes Datum","producttable_discounttypeHeader":"Rabattart","customerInvoice_DiscountOnSubtotal":"Rabatt","ST_Producttable_CartResponse":"Der Kunde ist nicht berechtigt, einige der Produkte im Warenkorb zu kaufen","ST_B2BPriceBreack_CloseBtn":"Schließen","B2B_QtyRule_Error_Msg":"Ungültige Menge hinzugefügt. Bitte überprüfen Sie die Mengenregeln.","Customer_Info_Title":"Bitte wählen Sie zuerst das Land aus","Customer_Invalid_pinCode_Msg":"Ungültiger PIN-Code","Edit_DraftOrderAlert_Msg":"Wichtig","Create_Order_DiscountDropdown_value1":"Prozentsatz","Create_Order_DiscountDropdown_value2":"Fester Dollarbetrag","Create_Order_DiscountType_Popup_Value1":"Rabattart ändern","Create_Order_DiscountType_PopUp_Value2":"Bereits gewährte Rabatte werden entfernt.","B2B_PriceList_Increment_Msg":"Erhöhung von","B2B_PriceList_Minimum_Msg":"Mindestens","B2B_PriceList_Maximum_Msg":"Maximal","SpecialChar_Error_Msg":"Sonderzeichen wie @#!$& sind im Passwort nicht erlaubt","createOrder_ErrorMsgForQuantityLimit":"Sie können keine größere Menge als den verfügbaren Bestand hinzufügen.","ClientInvoice":"Sie können keine größere Menge als den verfügbaren Bestand hinzufügen.","AffiliateOrder":"Repräsentant erstellt","CouponOrder":"Affiliate-Link","ReturnCustomerOrder":"Rabattgutschein","Tagcustomer":"Kundenauftrag","POSOrder":"Kundenauftrag","SharedCart":"POS","RepOnCartPage":"Warenkorb teilen","AdminTaggedOrder":"Repräsentantenwahl","TaggedCompanyLocationOrder":"Manuelles Tagging","WholesaleOrder":"B2B-Bestellung","TeamManager":"Großhandelsrechnung","charsLeft":"char übrig","showing":"Anzeigen","customers":"Kunden","exportCsv":"CSV exportieren","all":"Alle","paid":"Bezahlt","unpaid":"Unbezahlt","draft":"Entwurf","refunded":"Erstattet","orderType":"Bestellart","ShippingCost_AddressError":"Versandkosten für die ausgewählte Adresse sind nicht konfiguriert. Bitte wenden Sie sich an den Administrator.","ShippingCost_CustomerAddressAndCartProductError":"Die Kundenadresse und die Produkte im Warenkorb sind erforderlich, um die Versandkosten zu berechnen.","ContactCard_Info_Msg":"Die Kontaktkarte macht Ihre Affiliate-Links attraktiver. Wenn ein Kunde einen Affiliate-Link verwendet, kann er Ihre Kontaktkarte auf der Website sehen und so ein persönlicheres Einkaufserlebnis bieten. Diese Karte kann mit einem Profilfoto und einer Nachricht für Ihre Kunden personalisiert werden.","contact_Cart_Heading":"Kontaktkarte","Affiliate_Link_Info_Msg":"Teilen Sie Ihren Affiliate-Link mit Kunden. Jede über Ihren Affiliate-Link aufgegebene Bestellung wird Ihnen zugeordnet","Contact_Card_Bio_Save_Success_Msg":"Bio erfolgreich gespeichert","Affiliate_Add_ProductInfo_Msg":"Fügen Sie Produkte hinzu, für die Sie einen Affiliate-Link teilen möchten","ShareCart_UserGuide_Msg1":"Erstellen Sie einen gemeinsam nutzbaren Link zum Warenkorb, der mit ausgewählten Produkten vorinstalliert ist, die auf die Vorlieben Ihrer Kunden zugeschnitten sind. Der Kunde kann den Link verwenden, die Artikel im Warenkorb überprüfen und direkt fortfahren","ShareCart_UserGuide_Msg2":"zur Kasse. Bestellungen, die über Ihren Warenkorb-Link aufgegeben werden, werden Ihnen zugeordnet.","ShareCart_ToltipTitle":"Produkte aus dem Warenkorb entfernen","Delete_Cart_Confirmation":"Sind Sie sicher, dass Sie den Warenkorb löschen möchten?","No_Share_Cart_Added1":"Bisher wurde kein Warenkorb-Link erstellt.","No_Share_Cart_Added2":"Erstellen Sie einen Warenkorb und teilen Sie den direkten Link mit Ihren Kunden","ClearCart_Conformation_Msg":"Möchten Sie wirklich alle Produkte aus dem Warenkorb entfernen?","Edit_Billing_Address":"Rechnungsadresse bearbeiten","Edit_Shipping_Address":"Lieferadresse bearbeiten","New_Customer_Select_Msg":"Erstellen Sie einen neuen Kunden","CreateOrder_Manage_Heading":"Verwalten","RemoveCustomer_Msg":"Kunde entfernen","Customer_Address_Apartment":"Apartment, Suite usw","Address_Enter_Msg":"Geben Sie die Adresse ein","Address_Not_Found_Error_Msg":"Für die Erstellung einer Bestellung sind die Kundenadresse und die Produkte im Warenkorb zwingend erforderlich","Load_More_Btn":"Mehr laden","Beta_Version_msg1":"Diese Funktion befindet sich derzeit in der Beta-Version. Wenn Sie auf ein Problem stoßen","Beta_Version_msg2":"bitte wenden Sie sich an den Support.","Heading_Product_Select":"Wählen Sie „Produkte“ aus","Customer_FirstName":"Vorname","Customer_lastName":"Nachname","Customer_Resion":"Land/Region","Customer_pinCode":"PIN-Code","Customer_phone":"Telefon","applyDisconutCode_atCheckout":"Erlauben Sie Kunden, Rabattgutscheine an der Kasse einzulösen"}'
        );
      st.use(kt).init({
        debug: !0,
        lng: st.language,
        fallbackLng: st.language,
        keySeparator: !1,
        interpolation: { escapeValue: !1 },
        resources: {
          en: { translations: Pt },
          es: { translations: wt },
          fr: { translations: Ot },
          it: { translations: Tt },
          ms: { translations: It },
          sv: { translations: Mt },
          pt: { translations: jt },
          de: { translations: Nt },
        },
        ns: ["translations"],
        defaultNS: "translations",
      });
      var Dt = st,
        At = o(3366),
        Et = o(3961),
        Rt = o(4780),
        Lt = o(2101),
        Bt = o(948),
        zt = o(8628),
        Ft = o(1588),
        Zt = o(5677);
      function Ht(e) {
        return (0, Zt.ZP)("MuiDivider", e);
      }
      var Vt = (0, Ft.Z)("MuiDivider", [
        "root",
        "absolute",
        "fullWidth",
        "inset",
        "middle",
        "flexItem",
        "light",
        "vertical",
        "withChildren",
        "withChildrenVertical",
        "textAlignRight",
        "textAlignLeft",
        "wrapper",
        "wrapperVertical",
      ]);
      const Wt = [
          "absolute",
          "children",
          "className",
          "component",
          "flexItem",
          "light",
          "orientation",
          "role",
          "textAlign",
          "variant",
        ],
        Ut = (0, Bt.ZP)("div", {
          name: "MuiDivider",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.absolute && t.absolute,
              t[n.variant],
              n.light && t.light,
              "vertical" === n.orientation && t.vertical,
              n.flexItem && t.flexItem,
              n.children && t.withChildren,
              n.children &&
                "vertical" === n.orientation &&
                t.withChildrenVertical,
              "right" === n.textAlign &&
                "vertical" !== n.orientation &&
                t.textAlignRight,
              "left" === n.textAlign &&
                "vertical" !== n.orientation &&
                t.textAlignLeft,
            ];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {
                margin: 0,
                flexShrink: 0,
                borderWidth: 0,
                borderStyle: "solid",
                borderColor: (e.vars || e).palette.divider,
                borderBottomWidth: "thin",
              },
              t.absolute && {
                position: "absolute",
                bottom: 0,
                left: 0,
                width: "100%",
              },
              t.light && {
                borderColor: e.vars
                  ? `rgba(${e.vars.palette.dividerChannel} / 0.08)`
                  : (0, Lt.Fq)(e.palette.divider, 0.08),
              },
              "inset" === t.variant && { marginLeft: 72 },
              "middle" === t.variant &&
                "horizontal" === t.orientation && {
                  marginLeft: e.spacing(2),
                  marginRight: e.spacing(2),
                },
              "middle" === t.variant &&
                "vertical" === t.orientation && {
                  marginTop: e.spacing(1),
                  marginBottom: e.spacing(1),
                },
              "vertical" === t.orientation && {
                height: "100%",
                borderBottomWidth: 0,
                borderRightWidth: "thin",
              },
              t.flexItem && { alignSelf: "stretch", height: "auto" }
            ),
          ({ ownerState: e }) =>
            (0, u.Z)(
              {},
              e.children && {
                display: "flex",
                whiteSpace: "nowrap",
                textAlign: "center",
                border: 0,
                borderTopStyle: "solid",
                borderLeftStyle: "solid",
                "&::before, &::after": { content: '""', alignSelf: "center" },
              }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {},
              t.children &&
                "vertical" !== t.orientation && {
                  "&::before, &::after": {
                    width: "100%",
                    borderTop: `thin solid ${(e.vars || e).palette.divider}`,
                    borderTopStyle: "inherit",
                  },
                }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {},
              t.children &&
                "vertical" === t.orientation && {
                  flexDirection: "column",
                  "&::before, &::after": {
                    height: "100%",
                    borderLeft: `thin solid ${(e.vars || e).palette.divider}`,
                    borderLeftStyle: "inherit",
                  },
                }
            ),
          ({ ownerState: e }) =>
            (0, u.Z)(
              {},
              "right" === e.textAlign &&
                "vertical" !== e.orientation && {
                  "&::before": { width: "90%" },
                  "&::after": { width: "10%" },
                },
              "left" === e.textAlign &&
                "vertical" !== e.orientation && {
                  "&::before": { width: "10%" },
                  "&::after": { width: "90%" },
                }
            )
        ),
        $t = (0, Bt.ZP)("span", {
          name: "MuiDivider",
          slot: "Wrapper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.wrapper,
              "vertical" === n.orientation && t.wrapperVertical,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              display: "inline-block",
              paddingLeft: `calc(${e.spacing(1)} * 1.2)`,
              paddingRight: `calc(${e.spacing(1)} * 1.2)`,
            },
            "vertical" === t.orientation && {
              paddingTop: `calc(${e.spacing(1)} * 1.2)`,
              paddingBottom: `calc(${e.spacing(1)} * 1.2)`,
            }
          )
        ),
        Kt = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiDivider" }),
            {
              absolute: o = !1,
              children: a,
              className: i,
              component: s = a ? "div" : "hr",
              flexItem: l = !1,
              light: d = !1,
              orientation: c = "horizontal",
              role: p = "hr" !== s ? "separator" : void 0,
              textAlign: m = "center",
              variant: h = "fullWidth",
            } = r,
            f = (0, At.Z)(r, Wt),
            g = (0, u.Z)({}, r, {
              absolute: o,
              component: s,
              flexItem: l,
              light: d,
              orientation: c,
              role: p,
              textAlign: m,
              variant: h,
            }),
            v = ((e) => {
              const {
                  absolute: t,
                  children: n,
                  classes: r,
                  flexItem: o,
                  light: a,
                  orientation: i,
                  textAlign: s,
                  variant: l,
                } = e,
                d = {
                  root: [
                    "root",
                    t && "absolute",
                    l,
                    a && "light",
                    "vertical" === i && "vertical",
                    o && "flexItem",
                    n && "withChildren",
                    n && "vertical" === i && "withChildrenVertical",
                    "right" === s && "vertical" !== i && "textAlignRight",
                    "left" === s && "vertical" !== i && "textAlignLeft",
                  ],
                  wrapper: ["wrapper", "vertical" === i && "wrapperVertical"],
                };
              return (0, Rt.Z)(d, Ht, r);
            })(g);
          return (0,
          e.jsx)(Ut, (0, u.Z)({ as: s, className: (0, Et.Z)(v.root, i), role: p, ref: n, ownerState: g }, f, { children: a ? (0, e.jsx)($t, { className: v.wrapper, ownerState: g, children: a }) : null }));
        });
      Kt.muiSkipListHighlight = !0;
      var Gt = Kt;
      function qt(e) {
        var t,
          n,
          r = "";
        if ("string" == typeof e || "number" == typeof e) r += e;
        else if ("object" == typeof e)
          if (Array.isArray(e)) {
            var o = e.length;
            for (t = 0; t < o; t++)
              e[t] && (n = qt(e[t])) && (r && (r += " "), (r += n));
          } else for (n in e) e[n] && (r && (r += " "), (r += n));
        return r;
      }
      var Qt = function () {
          for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
            (e = arguments[n]) && (t = qt(e)) && (r && (r += " "), (r += t));
          return r;
        },
        Yt = o(4742),
        Jt = o(6523),
        Xt = o(9707),
        en = o(7408),
        tn = o(5260),
        nn = function (e = null) {
          const n = t.useContext(tn.T);
          return n && ((r = n), 0 !== Object.keys(r).length) ? n : e;
          var r;
        };
      const rn = (0, en.Z)();
      var on = function (e = rn) {
        return nn(e);
      };
      const an = ["className", "component"];
      function sn(n = {}) {
        const {
            themeId: r,
            defaultTheme: o,
            defaultClassName: a = "MuiBox-root",
            generateClassName: i,
          } = n,
          s = (0, Yt.default)("div", {
            shouldForwardProp: (e) => "theme" !== e && "sx" !== e && "as" !== e,
          })(Jt.Z);
        return t.forwardRef(function (t, n) {
          const l = on(o),
            d = (0, Xt.Z)(t),
            { className: c, component: p = "div" } = d,
            m = (0, At.Z)(d, an);
          return (0,
          e.jsx)(s, (0, u.Z)({ as: p, ref: n, className: Qt(c, i ? i(a) : a), theme: (r && l[r]) || l }, m));
        });
      }
      var ln = o(7078),
        dn = o(5932),
        cn = o(606),
        un = (0, Ft.Z)("MuiBox", ["root"]);
      const pn = (0, dn.Z)();
      var mn = sn({
          themeId: cn.Z,
          defaultTheme: pn,
          defaultClassName: un.root,
          generateClassName: ln.Z.generate,
        }),
        hn = o(1705),
        fn = o(2068),
        gn = o(6601);
      function vn(e, t) {
        (e.prototype = Object.create(t.prototype)),
          (e.prototype.constructor = e),
          ie(e, t);
      }
      var bn = t.createContext(null);
      function _n(e, n) {
        var r = Object.create(null);
        return (
          e &&
            t.Children.map(e, function (e) {
              return e;
            }).forEach(function (e) {
              r[e.key] = (function (e) {
                return n && (0, t.isValidElement)(e) ? n(e) : e;
              })(e);
            }),
          r
        );
      }
      function yn(e, t, n) {
        return null != n[t] ? n[t] : e.props[t];
      }
      function Cn(e, n, r) {
        var o = _n(e.children),
          a = (function (e, t) {
            function n(n) {
              return n in t ? t[n] : e[n];
            }
            (e = e || {}), (t = t || {});
            var r,
              o = Object.create(null),
              a = [];
            for (var i in e)
              i in t ? a.length && ((o[i] = a), (a = [])) : a.push(i);
            var s = {};
            for (var l in t) {
              if (o[l])
                for (r = 0; r < o[l].length; r++) {
                  var d = o[l][r];
                  s[o[l][r]] = n(d);
                }
              s[l] = n(l);
            }
            for (r = 0; r < a.length; r++) s[a[r]] = n(a[r]);
            return s;
          })(n, o);
        return (
          Object.keys(a).forEach(function (i) {
            var s = a[i];
            if ((0, t.isValidElement)(s)) {
              var l = i in n,
                d = i in o,
                c = n[i],
                u = (0, t.isValidElement)(c) && !c.props.in;
              !d || (l && !u)
                ? d || !l || u
                  ? d &&
                    l &&
                    (0, t.isValidElement)(c) &&
                    (a[i] = (0, t.cloneElement)(s, {
                      onExited: r.bind(null, s),
                      in: c.props.in,
                      exit: yn(s, "exit", e),
                      enter: yn(s, "enter", e),
                    }))
                  : (a[i] = (0, t.cloneElement)(s, { in: !1 }))
                : (a[i] = (0, t.cloneElement)(s, {
                    onExited: r.bind(null, s),
                    in: !0,
                    exit: yn(s, "exit", e),
                    enter: yn(s, "enter", e),
                  }));
            }
          }),
          a
        );
      }
      var xn =
          Object.values ||
          function (e) {
            return Object.keys(e).map(function (t) {
              return e[t];
            });
          },
        Sn = (function (e) {
          function n(t, n) {
            var r,
              o = (r = e.call(this, t, n) || this).handleExited.bind(ae(r));
            return (
              (r.state = {
                contextValue: { isMounting: !0 },
                handleExited: o,
                firstRender: !0,
              }),
              r
            );
          }
          vn(n, e);
          var r = n.prototype;
          return (
            (r.componentDidMount = function () {
              (this.mounted = !0),
                this.setState({ contextValue: { isMounting: !1 } });
            }),
            (r.componentWillUnmount = function () {
              this.mounted = !1;
            }),
            (n.getDerivedStateFromProps = function (e, n) {
              var r,
                o,
                a = n.children,
                i = n.handleExited;
              return {
                children: n.firstRender
                  ? ((r = e),
                    (o = i),
                    _n(r.children, function (e) {
                      return (0,
                      t.cloneElement)(e, { onExited: o.bind(null, e), in: !0, appear: yn(e, "appear", r), enter: yn(e, "enter", r), exit: yn(e, "exit", r) });
                    }))
                  : Cn(e, a, i),
                firstRender: !1,
              };
            }),
            (r.handleExited = function (e, t) {
              var n = _n(this.props.children);
              e.key in n ||
                (e.props.onExited && e.props.onExited(t),
                this.mounted &&
                  this.setState(function (t) {
                    var n = (0, u.Z)({}, t.children);
                    return delete n[e.key], { children: n };
                  }));
            }),
            (r.render = function () {
              var e = this.props,
                n = e.component,
                r = e.childFactory,
                o = (0, At.Z)(e, ["component", "childFactory"]),
                a = this.state.contextValue,
                i = xn(this.state.children).map(r);
              return (
                delete o.appear,
                delete o.enter,
                delete o.exit,
                null === n
                  ? t.createElement(bn.Provider, { value: a }, i)
                  : t.createElement(
                      bn.Provider,
                      { value: a },
                      t.createElement(n, o, i)
                    )
              );
            }),
            n
          );
        })(t.Component);
      (Sn.propTypes = {}),
        (Sn.defaultProps = {
          component: "div",
          childFactory: function (e) {
            return e;
          },
        });
      var kn = Sn,
        Pn = o(917),
        wn = o(1818),
        On = (0, Ft.Z)("MuiTouchRipple", [
          "root",
          "ripple",
          "rippleVisible",
          "ripplePulsate",
          "child",
          "childLeaving",
          "childPulsate",
        ]);
      const Tn = ["center", "classes", "className"];
      let In,
        Mn,
        jn,
        Nn,
        Dn = (e) => e;
      const An = (0, Pn.F4)(
          In ||
            (In = Dn`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`)
        ),
        En = (0, Pn.F4)(
          Mn ||
            (Mn = Dn`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`)
        ),
        Rn = (0, Pn.F4)(
          jn ||
            (jn = Dn`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`)
        ),
        Ln = (0, Bt.ZP)("span", { name: "MuiTouchRipple", slot: "Root" })({
          overflow: "hidden",
          pointerEvents: "none",
          position: "absolute",
          zIndex: 0,
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          borderRadius: "inherit",
        }),
        Bn = (0, Bt.ZP)(
          function (n) {
            const {
                className: r,
                classes: o,
                pulsate: a = !1,
                rippleX: i,
                rippleY: s,
                rippleSize: l,
                in: d,
                onExited: c,
                timeout: u,
              } = n,
              [p, m] = t.useState(!1),
              h = (0, Et.Z)(r, o.ripple, o.rippleVisible, a && o.ripplePulsate),
              f = { width: l, height: l, top: -l / 2 + s, left: -l / 2 + i },
              g = (0, Et.Z)(o.child, p && o.childLeaving, a && o.childPulsate);
            return (
              d || p || m(!0),
              t.useEffect(() => {
                if (!d && null != c) {
                  const e = setTimeout(c, u);
                  return () => {
                    clearTimeout(e);
                  };
                }
              }, [c, d, u]),
              (0, e.jsx)("span", {
                className: h,
                style: f,
                children: (0, e.jsx)("span", { className: g }),
              })
            );
          },
          { name: "MuiTouchRipple", slot: "Ripple" }
        )(
          Nn ||
            (Nn = Dn`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`),
          On.rippleVisible,
          An,
          550,
          ({ theme: e }) => e.transitions.easing.easeInOut,
          On.ripplePulsate,
          ({ theme: e }) => e.transitions.duration.shorter,
          On.child,
          On.childLeaving,
          En,
          550,
          ({ theme: e }) => e.transitions.easing.easeInOut,
          On.childPulsate,
          Rn,
          ({ theme: e }) => e.transitions.easing.easeInOut
        ),
        zn = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTouchRipple" }),
            { center: a = !1, classes: i = {}, className: s } = o,
            l = (0, At.Z)(o, Tn),
            [d, c] = t.useState([]),
            p = t.useRef(0),
            m = t.useRef(null);
          t.useEffect(() => {
            m.current && (m.current(), (m.current = null));
          }, [d]);
          const h = t.useRef(!1),
            f = (0, wn.Z)(),
            g = t.useRef(null),
            v = t.useRef(null),
            b = t.useCallback(
              (t) => {
                const {
                  pulsate: n,
                  rippleX: r,
                  rippleY: o,
                  rippleSize: a,
                  cb: s,
                } = t;
                c((t) => [
                  ...t,
                  (0, e.jsx)(
                    Bn,
                    {
                      classes: {
                        ripple: (0, Et.Z)(i.ripple, On.ripple),
                        rippleVisible: (0, Et.Z)(
                          i.rippleVisible,
                          On.rippleVisible
                        ),
                        ripplePulsate: (0, Et.Z)(
                          i.ripplePulsate,
                          On.ripplePulsate
                        ),
                        child: (0, Et.Z)(i.child, On.child),
                        childLeaving: (0, Et.Z)(
                          i.childLeaving,
                          On.childLeaving
                        ),
                        childPulsate: (0, Et.Z)(
                          i.childPulsate,
                          On.childPulsate
                        ),
                      },
                      timeout: 550,
                      pulsate: n,
                      rippleX: r,
                      rippleY: o,
                      rippleSize: a,
                    },
                    p.current
                  ),
                ]),
                  (p.current += 1),
                  (m.current = s);
              },
              [i]
            ),
            _ = t.useCallback(
              (e = {}, t = {}, n = () => {}) => {
                const {
                  pulsate: r = !1,
                  center: o = a || t.pulsate,
                  fakeElement: i = !1,
                } = t;
                if ("mousedown" === (null == e ? void 0 : e.type) && h.current)
                  return void (h.current = !1);
                "touchstart" === (null == e ? void 0 : e.type) &&
                  (h.current = !0);
                const s = i ? null : v.current,
                  l = s
                    ? s.getBoundingClientRect()
                    : { width: 0, height: 0, left: 0, top: 0 };
                let d, c, u;
                if (
                  o ||
                  void 0 === e ||
                  (0 === e.clientX && 0 === e.clientY) ||
                  (!e.clientX && !e.touches)
                )
                  (d = Math.round(l.width / 2)), (c = Math.round(l.height / 2));
                else {
                  const { clientX: t, clientY: n } =
                    e.touches && e.touches.length > 0 ? e.touches[0] : e;
                  (d = Math.round(t - l.left)), (c = Math.round(n - l.top));
                }
                if (o)
                  (u = Math.sqrt((2 * l.width ** 2 + l.height ** 2) / 3)),
                    u % 2 == 0 && (u += 1);
                else {
                  const e =
                      2 * Math.max(Math.abs((s ? s.clientWidth : 0) - d), d) +
                      2,
                    t =
                      2 * Math.max(Math.abs((s ? s.clientHeight : 0) - c), c) +
                      2;
                  u = Math.sqrt(e ** 2 + t ** 2);
                }
                null != e && e.touches
                  ? null === g.current &&
                    ((g.current = () => {
                      b({
                        pulsate: r,
                        rippleX: d,
                        rippleY: c,
                        rippleSize: u,
                        cb: n,
                      });
                    }),
                    f.start(80, () => {
                      g.current && (g.current(), (g.current = null));
                    }))
                  : b({
                      pulsate: r,
                      rippleX: d,
                      rippleY: c,
                      rippleSize: u,
                      cb: n,
                    });
              },
              [a, b, f]
            ),
            y = t.useCallback(() => {
              _({}, { pulsate: !0 });
            }, [_]),
            C = t.useCallback(
              (e, t) => {
                if (
                  (f.clear(),
                  "touchend" === (null == e ? void 0 : e.type) && g.current)
                )
                  return (
                    g.current(),
                    (g.current = null),
                    void f.start(0, () => {
                      C(e, t);
                    })
                  );
                (g.current = null),
                  c((e) => (e.length > 0 ? e.slice(1) : e)),
                  (m.current = t);
              },
              [f]
            );
          return (
            t.useImperativeHandle(
              r,
              () => ({ pulsate: y, start: _, stop: C }),
              [y, _, C]
            ),
            (0, e.jsx)(
              Ln,
              (0, u.Z)(
                { className: (0, Et.Z)(On.root, i.root, s), ref: v },
                l,
                {
                  children: (0, e.jsx)(kn, {
                    component: null,
                    exit: !0,
                    children: d,
                  }),
                }
              )
            )
          );
        });
      var Fn = zn;
      function Zn(e) {
        return (0, Zt.ZP)("MuiButtonBase", e);
      }
      var Hn = (0, Ft.Z)("MuiButtonBase", ["root", "disabled", "focusVisible"]);
      const Vn = [
          "action",
          "centerRipple",
          "children",
          "className",
          "component",
          "disabled",
          "disableRipple",
          "disableTouchRipple",
          "focusRipple",
          "focusVisibleClassName",
          "LinkComponent",
          "onBlur",
          "onClick",
          "onContextMenu",
          "onDragLeave",
          "onFocus",
          "onFocusVisible",
          "onKeyDown",
          "onKeyUp",
          "onMouseDown",
          "onMouseLeave",
          "onMouseUp",
          "onTouchEnd",
          "onTouchMove",
          "onTouchStart",
          "tabIndex",
          "TouchRippleProps",
          "touchRippleRef",
          "type",
        ],
        Wn = (0, Bt.ZP)("button", {
          name: "MuiButtonBase",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          boxSizing: "border-box",
          WebkitTapHighlightColor: "transparent",
          backgroundColor: "transparent",
          outline: 0,
          border: 0,
          margin: 0,
          borderRadius: 0,
          padding: 0,
          cursor: "pointer",
          userSelect: "none",
          verticalAlign: "middle",
          MozAppearance: "none",
          WebkitAppearance: "none",
          textDecoration: "none",
          color: "inherit",
          "&::-moz-focus-inner": { borderStyle: "none" },
          [`&.${Hn.disabled}`]: { pointerEvents: "none", cursor: "default" },
          "@media print": { colorAdjust: "exact" },
        });
      var Un = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiButtonBase" }),
            {
              action: a,
              centerRipple: i = !1,
              children: s,
              className: l,
              component: d = "button",
              disabled: c = !1,
              disableRipple: p = !1,
              disableTouchRipple: m = !1,
              focusRipple: h = !1,
              LinkComponent: f = "a",
              onBlur: g,
              onClick: v,
              onContextMenu: b,
              onDragLeave: _,
              onFocus: y,
              onFocusVisible: C,
              onKeyDown: x,
              onKeyUp: S,
              onMouseDown: k,
              onMouseLeave: P,
              onMouseUp: w,
              onTouchEnd: O,
              onTouchMove: T,
              onTouchStart: I,
              tabIndex: M = 0,
              TouchRippleProps: j,
              touchRippleRef: N,
              type: D,
            } = o,
            A = (0, At.Z)(o, Vn),
            E = t.useRef(null),
            R = t.useRef(null),
            L = (0, hn.Z)(R, N),
            {
              isFocusVisibleRef: B,
              onFocus: z,
              onBlur: F,
              ref: Z,
            } = (0, gn.Z)(),
            [H, V] = t.useState(!1);
          c && H && V(!1),
            t.useImperativeHandle(
              a,
              () => ({
                focusVisible: () => {
                  V(!0), E.current.focus();
                },
              }),
              []
            );
          const [W, U] = t.useState(!1);
          t.useEffect(() => {
            U(!0);
          }, []);
          const $ = W && !p && !c;
          function K(e, t, n = m) {
            return (0,
            fn.Z)((r) => (t && t(r), !n && R.current && R.current[e](r), !0));
          }
          t.useEffect(() => {
            H && h && !p && W && R.current.pulsate();
          }, [p, h, H, W]);
          const G = K("start", k),
            q = K("stop", b),
            Q = K("stop", _),
            Y = K("stop", w),
            J = K("stop", (e) => {
              H && e.preventDefault(), P && P(e);
            }),
            X = K("start", I),
            ee = K("stop", O),
            te = K("stop", T),
            ne = K(
              "stop",
              (e) => {
                F(e), !1 === B.current && V(!1), g && g(e);
              },
              !1
            ),
            re = (0, fn.Z)((e) => {
              E.current || (E.current = e.currentTarget),
                z(e),
                !0 === B.current && (V(!0), C && C(e)),
                y && y(e);
            }),
            oe = () => {
              const e = E.current;
              return d && "button" !== d && !("A" === e.tagName && e.href);
            },
            ae = t.useRef(!1),
            ie = (0, fn.Z)((e) => {
              h &&
                !ae.current &&
                H &&
                R.current &&
                " " === e.key &&
                ((ae.current = !0),
                R.current.stop(e, () => {
                  R.current.start(e);
                })),
                e.target === e.currentTarget &&
                  oe() &&
                  " " === e.key &&
                  e.preventDefault(),
                x && x(e),
                e.target === e.currentTarget &&
                  oe() &&
                  "Enter" === e.key &&
                  !c &&
                  (e.preventDefault(), v && v(e));
            }),
            se = (0, fn.Z)((e) => {
              h &&
                " " === e.key &&
                R.current &&
                H &&
                !e.defaultPrevented &&
                ((ae.current = !1),
                R.current.stop(e, () => {
                  R.current.pulsate(e);
                })),
                S && S(e),
                v &&
                  e.target === e.currentTarget &&
                  oe() &&
                  " " === e.key &&
                  !e.defaultPrevented &&
                  v(e);
            });
          let le = d;
          "button" === le && (A.href || A.to) && (le = f);
          const de = {};
          "button" === le
            ? ((de.type = void 0 === D ? "button" : D), (de.disabled = c))
            : (A.href || A.to || (de.role = "button"),
              c && (de["aria-disabled"] = c));
          const ce = (0, hn.Z)(r, Z, E),
            ue = (0, u.Z)({}, o, {
              centerRipple: i,
              component: d,
              disabled: c,
              disableRipple: p,
              disableTouchRipple: m,
              focusRipple: h,
              tabIndex: M,
              focusVisible: H,
            }),
            pe = ((e) => {
              const {
                  disabled: t,
                  focusVisible: n,
                  focusVisibleClassName: r,
                  classes: o,
                } = e,
                a = { root: ["root", t && "disabled", n && "focusVisible"] },
                i = (0, Rt.Z)(a, Zn, o);
              return n && r && (i.root += ` ${r}`), i;
            })(ue);
          return (0,
          e.jsxs)(Wn, (0, u.Z)({ as: le, className: (0, Et.Z)(pe.root, l), ownerState: ue, onBlur: ne, onClick: v, onContextMenu: q, onFocus: re, onKeyDown: ie, onKeyUp: se, onMouseDown: G, onMouseLeave: J, onMouseUp: Y, onDragLeave: Q, onTouchEnd: ee, onTouchMove: te, onTouchStart: X, ref: ce, tabIndex: c ? -1 : M, type: D }, de, A, { children: [s, $ ? (0, e.jsx)(Fn, (0, u.Z)({ ref: L, center: i }, j)) : null] }));
        }),
        $n = o(8216);
      function Kn(e) {
        return (0, Zt.ZP)("MuiIconButton", e);
      }
      var Gn = (0, Ft.Z)("MuiIconButton", [
        "root",
        "disabled",
        "colorInherit",
        "colorPrimary",
        "colorSecondary",
        "colorError",
        "colorInfo",
        "colorSuccess",
        "colorWarning",
        "edgeStart",
        "edgeEnd",
        "sizeSmall",
        "sizeMedium",
        "sizeLarge",
      ]);
      const qn = [
          "edge",
          "children",
          "className",
          "color",
          "disabled",
          "disableFocusRipple",
          "size",
        ],
        Qn = (0, Bt.ZP)(Un, {
          name: "MuiIconButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "default" !== n.color && t[`color${(0, $n.Z)(n.color)}`],
              n.edge && t[`edge${(0, $n.Z)(n.edge)}`],
              t[`size${(0, $n.Z)(n.size)}`],
            ];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {
                textAlign: "center",
                flex: "0 0 auto",
                fontSize: e.typography.pxToRem(24),
                padding: 8,
                borderRadius: "50%",
                overflow: "visible",
                color: (e.vars || e).palette.action.active,
                transition: e.transitions.create("background-color", {
                  duration: e.transitions.duration.shortest,
                }),
              },
              !t.disableRipple && {
                "&:hover": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.activeChannel} / ${e.vars.palette.action.hoverOpacity})`
                    : (0, Lt.Fq)(
                        e.palette.action.active,
                        e.palette.action.hoverOpacity
                      ),
                  "@media (hover: none)": { backgroundColor: "transparent" },
                },
              },
              "start" === t.edge && {
                marginLeft: "small" === t.size ? -3 : -12,
              },
              "end" === t.edge && { marginRight: "small" === t.size ? -3 : -12 }
            ),
          ({ theme: e, ownerState: t }) => {
            var n;
            const r = null == (n = (e.vars || e).palette) ? void 0 : n[t.color];
            return (0, u.Z)(
              {},
              "inherit" === t.color && { color: "inherit" },
              "inherit" !== t.color &&
                "default" !== t.color &&
                (0, u.Z)(
                  { color: null == r ? void 0 : r.main },
                  !t.disableRipple && {
                    "&:hover": (0, u.Z)(
                      {},
                      r && {
                        backgroundColor: e.vars
                          ? `rgba(${r.mainChannel} / ${e.vars.palette.action.hoverOpacity})`
                          : (0, Lt.Fq)(r.main, e.palette.action.hoverOpacity),
                      },
                      {
                        "@media (hover: none)": {
                          backgroundColor: "transparent",
                        },
                      }
                    ),
                  }
                ),
              "small" === t.size && {
                padding: 5,
                fontSize: e.typography.pxToRem(18),
              },
              "large" === t.size && {
                padding: 12,
                fontSize: e.typography.pxToRem(28),
              },
              {
                [`&.${Gn.disabled}`]: {
                  backgroundColor: "transparent",
                  color: (e.vars || e).palette.action.disabled,
                },
              }
            );
          }
        ),
        Yn = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiIconButton" }),
            {
              edge: o = !1,
              children: a,
              className: i,
              color: s = "default",
              disabled: l = !1,
              disableFocusRipple: d = !1,
              size: c = "medium",
            } = r,
            p = (0, At.Z)(r, qn),
            m = (0, u.Z)({}, r, {
              edge: o,
              color: s,
              disabled: l,
              disableFocusRipple: d,
              size: c,
            }),
            h = ((e) => {
              const { classes: t, disabled: n, color: r, edge: o, size: a } = e,
                i = {
                  root: [
                    "root",
                    n && "disabled",
                    "default" !== r && `color${(0, $n.Z)(r)}`,
                    o && `edge${(0, $n.Z)(o)}`,
                    `size${(0, $n.Z)(a)}`,
                  ],
                };
              return (0, Rt.Z)(i, Kn, t);
            })(m);
          return (0,
          e.jsx)(Qn, (0, u.Z)({ className: (0, Et.Z)(h.root, i), centerRipple: !0, focusRipple: !d, disabled: l, ref: n }, p, { ownerState: m, children: a }));
        });
      var Jn = Yn;
      const Xn = ["value"],
        er = t.createContext(),
        tr = () => {
          const e = t.useContext(er);
          return null != e && e;
        };
      var nr = function (t) {
          let { value: n } = t,
            r = (0, At.Z)(t, Xn);
          return (0, e.jsx)(
            er.Provider,
            (0, u.Z)({ value: null == n || n }, r)
          );
        },
        rr = o(3703),
        or = function (e) {
          return "string" == typeof e;
        },
        ar = function (e, t, n) {
          return void 0 === e || or(e)
            ? t
            : (0, u.Z)({}, t, { ownerState: (0, u.Z)({}, t.ownerState, n) });
        };
      function ir(e) {
        var t,
          n,
          r = "";
        if ("string" == typeof e || "number" == typeof e) r += e;
        else if ("object" == typeof e)
          if (Array.isArray(e)) {
            var o = e.length;
            for (t = 0; t < o; t++)
              e[t] && (n = ir(e[t])) && (r && (r += " "), (r += n));
          } else for (n in e) e[n] && (r && (r += " "), (r += n));
        return r;
      }
      var sr = function () {
          for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++)
            (e = arguments[n]) && (t = ir(e)) && (r && (r += " "), (r += t));
          return r;
        },
        lr = function (e, t = []) {
          if (void 0 === e) return {};
          const n = {};
          return (
            Object.keys(e)
              .filter(
                (n) =>
                  n.match(/^on[A-Z]/) &&
                  "function" == typeof e[n] &&
                  !t.includes(n)
              )
              .forEach((t) => {
                n[t] = e[t];
              }),
            n
          );
        },
        dr = function (e) {
          if (void 0 === e) return {};
          const t = {};
          return (
            Object.keys(e)
              .filter(
                (t) => !(t.match(/^on[A-Z]/) && "function" == typeof e[t])
              )
              .forEach((n) => {
                t[n] = e[n];
              }),
            t
          );
        },
        cr = function (e) {
          const {
            getSlotProps: t,
            additionalProps: n,
            externalSlotProps: r,
            externalForwardedProps: o,
            className: a,
          } = e;
          if (!t) {
            const e = sr(
                null == n ? void 0 : n.className,
                a,
                null == o ? void 0 : o.className,
                null == r ? void 0 : r.className
              ),
              t = (0, u.Z)(
                {},
                null == n ? void 0 : n.style,
                null == o ? void 0 : o.style,
                null == r ? void 0 : r.style
              ),
              i = (0, u.Z)({}, n, o, r);
            return (
              e.length > 0 && (i.className = e),
              Object.keys(t).length > 0 && (i.style = t),
              { props: i, internalRef: void 0 }
            );
          }
          const i = lr((0, u.Z)({}, o, r)),
            s = dr(r),
            l = dr(o),
            d = t(i),
            c = sr(
              null == d ? void 0 : d.className,
              null == n ? void 0 : n.className,
              a,
              null == o ? void 0 : o.className,
              null == r ? void 0 : r.className
            ),
            p = (0, u.Z)(
              {},
              null == d ? void 0 : d.style,
              null == n ? void 0 : n.style,
              null == o ? void 0 : o.style,
              null == r ? void 0 : r.style
            ),
            m = (0, u.Z)({}, d, n, l, s);
          return (
            c.length > 0 && (m.className = c),
            Object.keys(p).length > 0 && (m.style = p),
            { props: m, internalRef: d.ref }
          );
        },
        ur = function (e, t, n) {
          return "function" == typeof e ? e(t, n) : e;
        };
      const pr = [
        "elementType",
        "externalSlotProps",
        "ownerState",
        "skipResolvingSlotProps",
      ];
      var mr = function (e) {
        var t;
        const {
            elementType: n,
            externalSlotProps: r,
            ownerState: o,
            skipResolvingSlotProps: a = !1,
          } = e,
          i = (0, At.Z)(e, pr),
          s = a ? {} : ur(r, o),
          { props: l, internalRef: d } = cr(
            (0, u.Z)({}, i, { externalSlotProps: s })
          ),
          c = (0, rr.Z)(
            d,
            null == s ? void 0 : s.ref,
            null == (t = e.additionalProps) ? void 0 : t.ref
          );
        return ar(n, (0, u.Z)({}, l, { ref: c }), o);
      };
      function hr(e) {
        var n;
        return parseInt(t.version, 10) >= 19
          ? (null == e || null == (n = e.props) ? void 0 : n.ref) || null
          : (null == e ? void 0 : e.ref) || null;
      }
      var fr = o(2690);
      const gr = [
        "input",
        "select",
        "textarea",
        "a[href]",
        "button",
        "[tabindex]",
        "audio[controls]",
        "video[controls]",
        '[contenteditable]:not([contenteditable="false"])',
      ].join(",");
      function vr(e) {
        const t = [],
          n = [];
        return (
          Array.from(e.querySelectorAll(gr)).forEach((e, r) => {
            const o = (function (e) {
              const t = parseInt(e.getAttribute("tabindex") || "", 10);
              return Number.isNaN(t)
                ? "true" === e.contentEditable ||
                  (("AUDIO" === e.nodeName ||
                    "VIDEO" === e.nodeName ||
                    "DETAILS" === e.nodeName) &&
                    null === e.getAttribute("tabindex"))
                  ? 0
                  : e.tabIndex
                : t;
            })(e);
            -1 !== o &&
              (function (e) {
                return !(
                  e.disabled ||
                  ("INPUT" === e.tagName && "hidden" === e.type) ||
                  (function (e) {
                    if ("INPUT" !== e.tagName || "radio" !== e.type) return !1;
                    if (!e.name) return !1;
                    const t = (t) =>
                      e.ownerDocument.querySelector(`input[type="radio"]${t}`);
                    let n = t(`[name="${e.name}"]:checked`);
                    return n || (n = t(`[name="${e.name}"]`)), n !== e;
                  })(e)
                );
              })(e) &&
              (0 === o
                ? t.push(e)
                : n.push({ documentOrder: r, tabIndex: o, node: e }));
          }),
          n
            .sort((e, t) =>
              e.tabIndex === t.tabIndex
                ? e.documentOrder - t.documentOrder
                : e.tabIndex - t.tabIndex
            )
            .map((e) => e.node)
            .concat(t)
        );
      }
      function br() {
        return !0;
      }
      var _r = function (n) {
          const {
              children: r,
              disableAutoFocus: o = !1,
              disableEnforceFocus: a = !1,
              disableRestoreFocus: i = !1,
              getTabbable: s = vr,
              isEnabled: l = br,
              open: d,
            } = n,
            c = t.useRef(!1),
            u = t.useRef(null),
            p = t.useRef(null),
            m = t.useRef(null),
            h = t.useRef(null),
            f = t.useRef(!1),
            g = t.useRef(null),
            v = (0, rr.Z)(hr(r), g),
            b = t.useRef(null);
          t.useEffect(() => {
            d && g.current && (f.current = !o);
          }, [o, d]),
            t.useEffect(() => {
              if (!d || !g.current) return;
              const e = (0, fr.Z)(g.current);
              return (
                g.current.contains(e.activeElement) ||
                  (g.current.hasAttribute("tabIndex") ||
                    g.current.setAttribute("tabIndex", "-1"),
                  f.current && g.current.focus()),
                () => {
                  i ||
                    (m.current &&
                      m.current.focus &&
                      ((c.current = !0), m.current.focus()),
                    (m.current = null));
                }
              );
            }, [d]),
            t.useEffect(() => {
              if (!d || !g.current) return;
              const e = (0, fr.Z)(g.current),
                t = (t) => {
                  (b.current = t),
                    !a &&
                      l() &&
                      "Tab" === t.key &&
                      e.activeElement === g.current &&
                      t.shiftKey &&
                      ((c.current = !0), p.current && p.current.focus());
                },
                n = () => {
                  const t = g.current;
                  if (null === t) return;
                  if (!e.hasFocus() || !l() || c.current)
                    return void (c.current = !1);
                  if (t.contains(e.activeElement)) return;
                  if (
                    a &&
                    e.activeElement !== u.current &&
                    e.activeElement !== p.current
                  )
                    return;
                  if (e.activeElement !== h.current) h.current = null;
                  else if (null !== h.current) return;
                  if (!f.current) return;
                  let n = [];
                  if (
                    ((e.activeElement !== u.current &&
                      e.activeElement !== p.current) ||
                      (n = s(g.current)),
                    n.length > 0)
                  ) {
                    var r, o;
                    const e = Boolean(
                        (null == (r = b.current) ? void 0 : r.shiftKey) &&
                          "Tab" === (null == (o = b.current) ? void 0 : o.key)
                      ),
                      t = n[0],
                      a = n[n.length - 1];
                    "string" != typeof t &&
                      "string" != typeof a &&
                      (e ? a.focus() : t.focus());
                  } else t.focus();
                };
              e.addEventListener("focusin", n),
                e.addEventListener("keydown", t, !0);
              const r = setInterval(() => {
                e.activeElement && "BODY" === e.activeElement.tagName && n();
              }, 50);
              return () => {
                clearInterval(r),
                  e.removeEventListener("focusin", n),
                  e.removeEventListener("keydown", t, !0);
              };
            }, [o, a, i, l, d, s]);
          const _ = (e) => {
            null === m.current && (m.current = e.relatedTarget),
              (f.current = !0);
          };
          return (0, e.jsxs)(t.Fragment, {
            children: [
              (0, e.jsx)("div", {
                tabIndex: d ? 0 : -1,
                onFocus: _,
                ref: u,
                "data-testid": "sentinelStart",
              }),
              t.cloneElement(r, {
                ref: v,
                onFocus: (e) => {
                  null === m.current && (m.current = e.relatedTarget),
                    (f.current = !0),
                    (h.current = e.target);
                  const t = r.props.onFocus;
                  t && t(e);
                },
              }),
              (0, e.jsx)("div", {
                tabIndex: d ? 0 : -1,
                onFocus: _,
                ref: p,
                "data-testid": "sentinelEnd",
              }),
            ],
          });
        },
        yr = o(3546),
        Cr = o(7364);
      const xr = t.forwardRef(function (n, r) {
        const { children: o, container: a, disablePortal: i = !1 } = n,
          [s, l] = t.useState(null),
          d = (0, rr.Z)(t.isValidElement(o) ? hr(o) : null, r);
        if (
          ((0, yr.Z)(() => {
            i ||
              l(
                (function (e) {
                  return "function" == typeof e ? e() : e;
                })(a) || document.body
              );
          }, [a, i]),
          (0, yr.Z)(() => {
            if (s && !i)
              return (
                (0, Cr.Z)(r, s),
                () => {
                  (0, Cr.Z)(r, null);
                }
              );
          }, [r, s, i]),
          i)
        ) {
          if (t.isValidElement(o)) {
            const e = { ref: d };
            return t.cloneElement(o, e);
          }
          return (0, e.jsx)(t.Fragment, { children: o });
        }
        return (0,
        e.jsx)(t.Fragment, { children: s ? C.createPortal(o, s) : s });
      });
      var Sr = xr,
        kr = "unmounted",
        Pr = "exited",
        wr = "entering",
        Or = "entered",
        Tr = "exiting",
        Ir = (function (e) {
          function n(t, n) {
            var r;
            r = e.call(this, t, n) || this;
            var o,
              a = n && !n.isMounting ? t.enter : t.appear;
            return (
              (r.appearStatus = null),
              t.in
                ? a
                  ? ((o = Pr), (r.appearStatus = wr))
                  : (o = Or)
                : (o = t.unmountOnExit || t.mountOnEnter ? kr : Pr),
              (r.state = { status: o }),
              (r.nextCallback = null),
              r
            );
          }
          vn(n, e),
            (n.getDerivedStateFromProps = function (e, t) {
              return e.in && t.status === kr ? { status: Pr } : null;
            });
          var r = n.prototype;
          return (
            (r.componentDidMount = function () {
              this.updateStatus(!0, this.appearStatus);
            }),
            (r.componentDidUpdate = function (e) {
              var t = null;
              if (e !== this.props) {
                var n = this.state.status;
                this.props.in
                  ? n !== wr && n !== Or && (t = wr)
                  : (n !== wr && n !== Or) || (t = Tr);
              }
              this.updateStatus(!1, t);
            }),
            (r.componentWillUnmount = function () {
              this.cancelNextCallback();
            }),
            (r.getTimeouts = function () {
              var e,
                t,
                n,
                r = this.props.timeout;
              return (
                (e = t = n = r),
                null != r &&
                  "number" != typeof r &&
                  ((e = r.exit),
                  (t = r.enter),
                  (n = void 0 !== r.appear ? r.appear : t)),
                { exit: e, enter: t, appear: n }
              );
            }),
            (r.updateStatus = function (e, t) {
              if ((void 0 === e && (e = !1), null !== t))
                if ((this.cancelNextCallback(), t === wr)) {
                  if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var n = this.props.nodeRef
                      ? this.props.nodeRef.current
                      : C.findDOMNode(this);
                    n &&
                      (function (e) {
                        e.scrollTop;
                      })(n);
                  }
                  this.performEnter(e);
                } else this.performExit();
              else
                this.props.unmountOnExit &&
                  this.state.status === Pr &&
                  this.setState({ status: kr });
            }),
            (r.performEnter = function (e) {
              var t = this,
                n = this.props.enter,
                r = this.context ? this.context.isMounting : e,
                o = this.props.nodeRef ? [r] : [C.findDOMNode(this), r],
                a = o[0],
                i = o[1],
                s = this.getTimeouts(),
                l = r ? s.appear : s.enter;
              e || n
                ? (this.props.onEnter(a, i),
                  this.safeSetState({ status: wr }, function () {
                    t.props.onEntering(a, i),
                      t.onTransitionEnd(l, function () {
                        t.safeSetState({ status: Or }, function () {
                          t.props.onEntered(a, i);
                        });
                      });
                  }))
                : this.safeSetState({ status: Or }, function () {
                    t.props.onEntered(a);
                  });
            }),
            (r.performExit = function () {
              var e = this,
                t = this.props.exit,
                n = this.getTimeouts(),
                r = this.props.nodeRef ? void 0 : C.findDOMNode(this);
              t
                ? (this.props.onExit(r),
                  this.safeSetState({ status: Tr }, function () {
                    e.props.onExiting(r),
                      e.onTransitionEnd(n.exit, function () {
                        e.safeSetState({ status: Pr }, function () {
                          e.props.onExited(r);
                        });
                      });
                  }))
                : this.safeSetState({ status: Pr }, function () {
                    e.props.onExited(r);
                  });
            }),
            (r.cancelNextCallback = function () {
              null !== this.nextCallback &&
                (this.nextCallback.cancel(), (this.nextCallback = null));
            }),
            (r.safeSetState = function (e, t) {
              (t = this.setNextCallback(t)), this.setState(e, t);
            }),
            (r.setNextCallback = function (e) {
              var t = this,
                n = !0;
              return (
                (this.nextCallback = function (r) {
                  n && ((n = !1), (t.nextCallback = null), e(r));
                }),
                (this.nextCallback.cancel = function () {
                  n = !1;
                }),
                this.nextCallback
              );
            }),
            (r.onTransitionEnd = function (e, t) {
              this.setNextCallback(t);
              var n = this.props.nodeRef
                  ? this.props.nodeRef.current
                  : C.findDOMNode(this),
                r = null == e && !this.props.addEndListener;
              if (n && !r) {
                if (this.props.addEndListener) {
                  var o = this.props.nodeRef
                      ? [this.nextCallback]
                      : [n, this.nextCallback],
                    a = o[0],
                    i = o[1];
                  this.props.addEndListener(a, i);
                }
                null != e && setTimeout(this.nextCallback, e);
              } else setTimeout(this.nextCallback, 0);
            }),
            (r.render = function () {
              var e = this.state.status;
              if (e === kr) return null;
              var n = this.props,
                r = n.children,
                o =
                  (n.in,
                  n.mountOnEnter,
                  n.unmountOnExit,
                  n.appear,
                  n.enter,
                  n.exit,
                  n.timeout,
                  n.addEndListener,
                  n.onEnter,
                  n.onEntering,
                  n.onEntered,
                  n.onExit,
                  n.onExiting,
                  n.onExited,
                  n.nodeRef,
                  (0, At.Z)(n, [
                    "children",
                    "in",
                    "mountOnEnter",
                    "unmountOnExit",
                    "appear",
                    "enter",
                    "exit",
                    "timeout",
                    "addEndListener",
                    "onEnter",
                    "onEntering",
                    "onEntered",
                    "onExit",
                    "onExiting",
                    "onExited",
                    "nodeRef",
                  ]));
              return t.createElement(
                bn.Provider,
                { value: null },
                "function" == typeof r
                  ? r(e, o)
                  : t.cloneElement(t.Children.only(r), o)
              );
            }),
            n
          );
        })(t.Component);
      function Mr() {}
      (Ir.contextType = bn),
        (Ir.propTypes = {}),
        (Ir.defaultProps = {
          in: !1,
          mountOnEnter: !1,
          unmountOnExit: !1,
          appear: !1,
          enter: !0,
          exit: !0,
          onEnter: Mr,
          onEntering: Mr,
          onEntered: Mr,
          onExit: Mr,
          onExiting: Mr,
          onExited: Mr,
        }),
        (Ir.UNMOUNTED = kr),
        (Ir.EXITED = Pr),
        (Ir.ENTERING = wr),
        (Ir.ENTERED = Or),
        (Ir.EXITING = Tr);
      var jr = Ir,
        Nr = o(247);
      function Dr() {
        const e = on(Nr.Z);
        return e[cn.Z] || e;
      }
      const Ar = (e) => e.scrollTop;
      function Er(e, t) {
        var n, r;
        const { timeout: o, easing: a, style: i = {} } = e;
        return {
          duration:
            null != (n = i.transitionDuration)
              ? n
              : "number" == typeof o
              ? o
              : o[t.mode] || 0,
          easing:
            null != (r = i.transitionTimingFunction)
              ? r
              : "object" == typeof a
              ? a[t.mode]
              : a,
          delay: i.transitionDelay,
        };
      }
      const Rr = [
          "addEndListener",
          "appear",
          "children",
          "easing",
          "in",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "style",
          "timeout",
          "TransitionComponent",
        ],
        Lr = { entering: { opacity: 1 }, entered: { opacity: 1 } },
        Br = t.forwardRef(function (n, r) {
          const o = Dr(),
            a = {
              enter: o.transitions.duration.enteringScreen,
              exit: o.transitions.duration.leavingScreen,
            },
            {
              addEndListener: i,
              appear: s = !0,
              children: l,
              easing: d,
              in: c,
              onEnter: p,
              onEntered: m,
              onEntering: h,
              onExit: f,
              onExited: g,
              onExiting: v,
              style: b,
              timeout: _ = a,
              TransitionComponent: y = jr,
            } = n,
            C = (0, At.Z)(n, Rr),
            x = t.useRef(null),
            S = (0, hn.Z)(x, hr(l), r),
            k = (e) => (t) => {
              if (e) {
                const n = x.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            P = k(h),
            w = k((e, t) => {
              Ar(e);
              const n = Er(
                { style: b, timeout: _, easing: d },
                { mode: "enter" }
              );
              (e.style.webkitTransition = o.transitions.create("opacity", n)),
                (e.style.transition = o.transitions.create("opacity", n)),
                p && p(e, t);
            }),
            O = k(m),
            T = k(v),
            I = k((e) => {
              const t = Er(
                { style: b, timeout: _, easing: d },
                { mode: "exit" }
              );
              (e.style.webkitTransition = o.transitions.create("opacity", t)),
                (e.style.transition = o.transitions.create("opacity", t)),
                f && f(e);
            }),
            M = k(g);
          return (0, e.jsx)(
            y,
            (0, u.Z)(
              {
                appear: s,
                in: c,
                nodeRef: x,
                onEnter: w,
                onEntered: O,
                onEntering: P,
                onExit: I,
                onExited: M,
                onExiting: T,
                addEndListener: (e) => {
                  i && i(x.current, e);
                },
                timeout: _,
              },
              C,
              {
                children: (e, n) =>
                  t.cloneElement(
                    l,
                    (0, u.Z)(
                      {
                        style: (0, u.Z)(
                          {
                            opacity: 0,
                            visibility: "exited" !== e || c ? void 0 : "hidden",
                          },
                          Lr[e],
                          b,
                          l.props.style
                        ),
                        ref: S,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      var zr = Br;
      function Fr(e) {
        return (0, Zt.ZP)("MuiBackdrop", e);
      }
      (0, Ft.Z)("MuiBackdrop", ["root", "invisible"]);
      const Zr = [
          "children",
          "className",
          "component",
          "components",
          "componentsProps",
          "invisible",
          "open",
          "slotProps",
          "slots",
          "TransitionComponent",
          "transitionDuration",
        ],
        Hr = (0, Bt.ZP)("div", {
          name: "MuiBackdrop",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.invisible && t.invisible];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              position: "fixed",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              WebkitTapHighlightColor: "transparent",
            },
            e.invisible && { backgroundColor: "transparent" }
          )
        );
      var Vr = t.forwardRef(function (t, n) {
          var r, o, a;
          const i = (0, zt.i)({ props: t, name: "MuiBackdrop" }),
            {
              children: s,
              className: l,
              component: d = "div",
              components: c = {},
              componentsProps: p = {},
              invisible: m = !1,
              open: h,
              slotProps: f = {},
              slots: g = {},
              TransitionComponent: v = zr,
              transitionDuration: b,
            } = i,
            _ = (0, At.Z)(i, Zr),
            y = (0, u.Z)({}, i, { component: d, invisible: m }),
            C = ((e) => {
              const { classes: t, invisible: n } = e,
                r = { root: ["root", n && "invisible"] };
              return (0, Rt.Z)(r, Fr, t);
            })(y),
            x = null != (r = f.root) ? r : p.root;
          return (0,
          e.jsx)(v, (0, u.Z)({ in: h, timeout: b }, _, { children: (0, e.jsx)(Hr, (0, u.Z)({ "aria-hidden": !0 }, x, { as: null != (o = null != (a = g.root) ? a : c.Root) ? o : d, className: (0, Et.Z)(C.root, l, null == x ? void 0 : x.className), ownerState: (0, u.Z)({}, y, null == x ? void 0 : x.ownerState), classes: C, ref: n, children: s })) }));
        }),
        Wr = o(9948),
        Ur = o(1476),
        $r = o(4161);
      function Kr(e) {
        const t = e.documentElement.clientWidth;
        return Math.abs(window.innerWidth - t);
      }
      function Gr(e, t) {
        t
          ? e.setAttribute("aria-hidden", "true")
          : e.removeAttribute("aria-hidden");
      }
      function qr(e) {
        return parseInt((0, $r.Z)(e).getComputedStyle(e).paddingRight, 10) || 0;
      }
      function Qr(e, t, n, r, o) {
        const a = [t, n, ...r];
        [].forEach.call(e.children, (e) => {
          const t = -1 === a.indexOf(e),
            n = !(function (e) {
              const t =
                  -1 !==
                  [
                    "TEMPLATE",
                    "SCRIPT",
                    "STYLE",
                    "LINK",
                    "MAP",
                    "META",
                    "NOSCRIPT",
                    "PICTURE",
                    "COL",
                    "COLGROUP",
                    "PARAM",
                    "SLOT",
                    "SOURCE",
                    "TRACK",
                  ].indexOf(e.tagName),
                n =
                  "INPUT" === e.tagName && "hidden" === e.getAttribute("type");
              return t || n;
            })(e);
          t && n && Gr(e, o);
        });
      }
      function Yr(e, t) {
        let n = -1;
        return e.some((e, r) => !!t(e) && ((n = r), !0)), n;
      }
      const Jr = new (class {
        constructor() {
          (this.containers = void 0),
            (this.modals = void 0),
            (this.modals = []),
            (this.containers = []);
        }
        add(e, t) {
          let n = this.modals.indexOf(e);
          if (-1 !== n) return n;
          (n = this.modals.length),
            this.modals.push(e),
            e.modalRef && Gr(e.modalRef, !1);
          const r = (function (e) {
            const t = [];
            return (
              [].forEach.call(e.children, (e) => {
                "true" === e.getAttribute("aria-hidden") && t.push(e);
              }),
              t
            );
          })(t);
          Qr(t, e.mount, e.modalRef, r, !0);
          const o = Yr(this.containers, (e) => e.container === t);
          return -1 !== o
            ? (this.containers[o].modals.push(e), n)
            : (this.containers.push({
                modals: [e],
                container: t,
                restore: null,
                hiddenSiblings: r,
              }),
              n);
        }
        mount(e, t) {
          const n = Yr(this.containers, (t) => -1 !== t.modals.indexOf(e)),
            r = this.containers[n];
          r.restore ||
            (r.restore = (function (e, t) {
              const n = [],
                r = e.container;
              if (!t.disableScrollLock) {
                if (
                  (function (e) {
                    const t = (0, fr.Z)(e);
                    return t.body === e
                      ? (0, $r.Z)(e).innerWidth > t.documentElement.clientWidth
                      : e.scrollHeight > e.clientHeight;
                  })(r)
                ) {
                  const e = Kr((0, fr.Z)(r));
                  n.push({
                    value: r.style.paddingRight,
                    property: "padding-right",
                    el: r,
                  }),
                    (r.style.paddingRight = `${qr(r) + e}px`);
                  const t = (0, fr.Z)(r).querySelectorAll(".mui-fixed");
                  [].forEach.call(t, (t) => {
                    n.push({
                      value: t.style.paddingRight,
                      property: "padding-right",
                      el: t,
                    }),
                      (t.style.paddingRight = `${qr(t) + e}px`);
                  });
                }
                let e;
                if (r.parentNode instanceof DocumentFragment)
                  e = (0, fr.Z)(r).body;
                else {
                  const t = r.parentElement,
                    n = (0, $r.Z)(r);
                  e =
                    "HTML" === (null == t ? void 0 : t.nodeName) &&
                    "scroll" === n.getComputedStyle(t).overflowY
                      ? t
                      : r;
                }
                n.push(
                  { value: e.style.overflow, property: "overflow", el: e },
                  { value: e.style.overflowX, property: "overflow-x", el: e },
                  { value: e.style.overflowY, property: "overflow-y", el: e }
                ),
                  (e.style.overflow = "hidden");
              }
              return () => {
                n.forEach(({ value: e, el: t, property: n }) => {
                  e ? t.style.setProperty(n, e) : t.style.removeProperty(n);
                });
              };
            })(r, t));
        }
        remove(e, t = !0) {
          const n = this.modals.indexOf(e);
          if (-1 === n) return n;
          const r = Yr(this.containers, (t) => -1 !== t.modals.indexOf(e)),
            o = this.containers[r];
          if (
            (o.modals.splice(o.modals.indexOf(e), 1),
            this.modals.splice(n, 1),
            0 === o.modals.length)
          )
            o.restore && o.restore(),
              e.modalRef && Gr(e.modalRef, t),
              Qr(o.container, e.mount, e.modalRef, o.hiddenSiblings, !1),
              this.containers.splice(r, 1);
          else {
            const e = o.modals[o.modals.length - 1];
            e.modalRef && Gr(e.modalRef, !1);
          }
          return n;
        }
        isTopModal(e) {
          return (
            this.modals.length > 0 && this.modals[this.modals.length - 1] === e
          );
        }
      })();
      function Xr(e) {
        return (0, Zt.ZP)("MuiModal", e);
      }
      (0, Ft.Z)("MuiModal", ["root", "hidden", "backdrop"]);
      const eo = [
          "BackdropComponent",
          "BackdropProps",
          "classes",
          "className",
          "closeAfterTransition",
          "children",
          "container",
          "component",
          "components",
          "componentsProps",
          "disableAutoFocus",
          "disableEnforceFocus",
          "disableEscapeKeyDown",
          "disablePortal",
          "disableRestoreFocus",
          "disableScrollLock",
          "hideBackdrop",
          "keepMounted",
          "onBackdropClick",
          "onClose",
          "onTransitionEnter",
          "onTransitionExited",
          "open",
          "slotProps",
          "slots",
          "theme",
        ],
        to = (0, Bt.ZP)("div", {
          name: "MuiModal",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.open && n.exited && t.hidden];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              position: "fixed",
              zIndex: (e.vars || e).zIndex.modal,
              right: 0,
              bottom: 0,
              top: 0,
              left: 0,
            },
            !t.open && t.exited && { visibility: "hidden" }
          )
        ),
        no = (0, Bt.ZP)(Vr, {
          name: "MuiModal",
          slot: "Backdrop",
          overridesResolver: (e, t) => t.backdrop,
        })({ zIndex: -1 }),
        ro = t.forwardRef(function (n, r) {
          var o, a, i, s, l, d;
          const c = (0, zt.i)({ name: "MuiModal", props: n }),
            {
              BackdropComponent: p = no,
              BackdropProps: m,
              className: h,
              closeAfterTransition: f = !1,
              children: g,
              container: v,
              component: b,
              components: _ = {},
              componentsProps: y = {},
              disableAutoFocus: C = !1,
              disableEnforceFocus: x = !1,
              disableEscapeKeyDown: S = !1,
              disablePortal: k = !1,
              disableRestoreFocus: P = !1,
              disableScrollLock: w = !1,
              hideBackdrop: O = !1,
              keepMounted: T = !1,
              onBackdropClick: I,
              open: M,
              slotProps: j,
              slots: N,
            } = c,
            D = (0, At.Z)(c, eo),
            A = (0, u.Z)({}, c, {
              closeAfterTransition: f,
              disableAutoFocus: C,
              disableEnforceFocus: x,
              disableEscapeKeyDown: S,
              disablePortal: k,
              disableRestoreFocus: P,
              disableScrollLock: w,
              hideBackdrop: O,
              keepMounted: T,
            }),
            {
              getRootProps: E,
              getBackdropProps: R,
              getTransitionProps: L,
              portalRef: B,
              isTopModal: z,
              exited: F,
              hasTransition: Z,
            } = (function (e) {
              const {
                  container: n,
                  disableEscapeKeyDown: r = !1,
                  disableScrollLock: o = !1,
                  manager: a = Jr,
                  closeAfterTransition: i = !1,
                  onTransitionEnter: s,
                  onTransitionExited: l,
                  children: d,
                  onClose: c,
                  open: p,
                  rootRef: m,
                } = e,
                h = t.useRef({}),
                f = t.useRef(null),
                g = t.useRef(null),
                v = (0, rr.Z)(g, m),
                [b, _] = t.useState(!p),
                y = (function (e) {
                  return !!e && e.props.hasOwnProperty("in");
                })(d);
              let C = !0;
              ("false" !== e["aria-hidden"] && !1 !== e["aria-hidden"]) ||
                (C = !1);
              const x = () => (
                  (h.current.modalRef = g.current),
                  (h.current.mount = f.current),
                  h.current
                ),
                S = () => {
                  a.mount(x(), { disableScrollLock: o }),
                    g.current && (g.current.scrollTop = 0);
                },
                k = (0, Wr.Z)(() => {
                  const e =
                    (function (e) {
                      return "function" == typeof e ? e() : e;
                    })(n) || (0, fr.Z)(f.current).body;
                  a.add(x(), e), g.current && S();
                }),
                P = t.useCallback(() => a.isTopModal(x()), [a]),
                w = (0, Wr.Z)((e) => {
                  (f.current = e),
                    e && (p && P() ? S() : g.current && Gr(g.current, C));
                }),
                O = t.useCallback(() => {
                  a.remove(x(), C);
                }, [C, a]);
              t.useEffect(
                () => () => {
                  O();
                },
                [O]
              ),
                t.useEffect(() => {
                  p ? k() : (y && i) || O();
                }, [p, O, y, i, k]);
              const T = (e) => (t) => {
                  var n;
                  null == (n = e.onKeyDown) || n.call(e, t),
                    "Escape" === t.key &&
                      229 !== t.which &&
                      P() &&
                      (r || (t.stopPropagation(), c && c(t, "escapeKeyDown")));
                },
                I = (e) => (t) => {
                  var n;
                  null == (n = e.onClick) || n.call(e, t),
                    t.target === t.currentTarget && c && c(t, "backdropClick");
                };
              return {
                getRootProps: (t = {}) => {
                  const n = lr(e);
                  delete n.onTransitionEnter, delete n.onTransitionExited;
                  const r = (0, u.Z)({}, n, t);
                  return (0, u.Z)({ role: "presentation" }, r, {
                    onKeyDown: T(r),
                    ref: v,
                  });
                },
                getBackdropProps: (e = {}) => {
                  const t = e;
                  return (0, u.Z)({ "aria-hidden": !0 }, t, {
                    onClick: I(t),
                    open: p,
                  });
                },
                getTransitionProps: () => ({
                  onEnter: (0, Ur.Z)(
                    () => {
                      _(!1), s && s();
                    },
                    null == d ? void 0 : d.props.onEnter
                  ),
                  onExited: (0, Ur.Z)(
                    () => {
                      _(!0), l && l(), i && O();
                    },
                    null == d ? void 0 : d.props.onExited
                  ),
                }),
                rootRef: v,
                portalRef: w,
                isTopModal: P,
                exited: b,
                hasTransition: y,
              };
            })((0, u.Z)({}, A, { rootRef: r })),
            H = (0, u.Z)({}, A, { exited: F }),
            V = ((e) => {
              const { open: t, exited: n, classes: r } = e,
                o = {
                  root: ["root", !t && n && "hidden"],
                  backdrop: ["backdrop"],
                };
              return (0, Rt.Z)(o, Xr, r);
            })(H),
            W = {};
          if ((void 0 === g.props.tabIndex && (W.tabIndex = "-1"), Z)) {
            const { onEnter: e, onExited: t } = L();
            (W.onEnter = e), (W.onExited = t);
          }
          const U =
              null !=
              (o = null != (a = null == N ? void 0 : N.root) ? a : _.Root)
                ? o
                : to,
            $ =
              null !=
              (i =
                null != (s = null == N ? void 0 : N.backdrop) ? s : _.Backdrop)
                ? i
                : p,
            K = null != (l = null == j ? void 0 : j.root) ? l : y.root,
            G = null != (d = null == j ? void 0 : j.backdrop) ? d : y.backdrop,
            q = mr({
              elementType: U,
              externalSlotProps: K,
              externalForwardedProps: D,
              getSlotProps: E,
              additionalProps: { ref: r, as: b },
              ownerState: H,
              className: (0, Et.Z)(
                h,
                null == K ? void 0 : K.className,
                null == V ? void 0 : V.root,
                !H.open && H.exited && (null == V ? void 0 : V.hidden)
              ),
            }),
            Q = mr({
              elementType: $,
              externalSlotProps: G,
              additionalProps: m,
              getSlotProps: (e) =>
                R(
                  (0, u.Z)({}, e, {
                    onClick: (t) => {
                      I && I(t), null != e && e.onClick && e.onClick(t);
                    },
                  })
                ),
              className: (0, Et.Z)(
                null == G ? void 0 : G.className,
                null == m ? void 0 : m.className,
                null == V ? void 0 : V.backdrop
              ),
              ownerState: H,
            });
          return T || M || (Z && !F)
            ? (0, e.jsx)(Sr, {
                ref: B,
                container: v,
                disablePortal: k,
                children: (0, e.jsxs)(
                  U,
                  (0, u.Z)({}, q, {
                    children: [
                      !O && p ? (0, e.jsx)($, (0, u.Z)({}, Q)) : null,
                      (0, e.jsx)(_r, {
                        disableEnforceFocus: x,
                        disableAutoFocus: C,
                        disableRestoreFocus: P,
                        isEnabled: z,
                        open: M,
                        children: t.cloneElement(g, W),
                      }),
                    ],
                  })
                ),
              })
            : null;
        });
      var oo = ro,
        ao = o(7144),
        io = o(5340);
      const so = [
        "addEndListener",
        "appear",
        "children",
        "container",
        "direction",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent",
      ];
      function lo(e, t, n) {
        var r;
        const o = (function (e, t, n) {
          const r = t.getBoundingClientRect(),
            o = n && n.getBoundingClientRect(),
            a = (0, io.Z)(t);
          let i;
          if (t.fakeTransform) i = t.fakeTransform;
          else {
            const e = a.getComputedStyle(t);
            i =
              e.getPropertyValue("-webkit-transform") ||
              e.getPropertyValue("transform");
          }
          let s = 0,
            l = 0;
          if (i && "none" !== i && "string" == typeof i) {
            const e = i.split("(")[1].split(")")[0].split(",");
            (s = parseInt(e[4], 10)), (l = parseInt(e[5], 10));
          }
          return "left" === e
            ? o
              ? `translateX(${o.right + s - r.left}px)`
              : `translateX(${a.innerWidth + s - r.left}px)`
            : "right" === e
            ? o
              ? `translateX(-${r.right - o.left - s}px)`
              : `translateX(-${r.left + r.width - s}px)`
            : "up" === e
            ? o
              ? `translateY(${o.bottom + l - r.top}px)`
              : `translateY(${a.innerHeight + l - r.top}px)`
            : o
            ? `translateY(-${r.top - o.top + r.height - l}px)`
            : `translateY(-${r.top + r.height - l}px)`;
        })(e, t, "function" == typeof (r = n) ? r() : r);
        o && ((t.style.webkitTransform = o), (t.style.transform = o));
      }
      const co = t.forwardRef(function (n, r) {
        const o = Dr(),
          a = {
            enter: o.transitions.easing.easeOut,
            exit: o.transitions.easing.sharp,
          },
          i = {
            enter: o.transitions.duration.enteringScreen,
            exit: o.transitions.duration.leavingScreen,
          },
          {
            addEndListener: s,
            appear: l = !0,
            children: d,
            container: c,
            direction: p = "down",
            easing: m = a,
            in: h,
            onEnter: f,
            onEntered: g,
            onEntering: v,
            onExit: b,
            onExited: _,
            onExiting: y,
            style: C,
            timeout: x = i,
            TransitionComponent: S = jr,
          } = n,
          k = (0, At.Z)(n, so),
          P = t.useRef(null),
          w = (0, hn.Z)(hr(d), P, r),
          O = (e) => (t) => {
            e && (void 0 === t ? e(P.current) : e(P.current, t));
          },
          T = O((e, t) => {
            lo(p, e, c), Ar(e), f && f(e, t);
          }),
          I = O((e, t) => {
            const n = Er(
              { timeout: x, style: C, easing: m },
              { mode: "enter" }
            );
            (e.style.webkitTransition = o.transitions.create(
              "-webkit-transform",
              (0, u.Z)({}, n)
            )),
              (e.style.transition = o.transitions.create(
                "transform",
                (0, u.Z)({}, n)
              )),
              (e.style.webkitTransform = "none"),
              (e.style.transform = "none"),
              v && v(e, t);
          }),
          M = O(g),
          j = O(y),
          N = O((e) => {
            const t = Er({ timeout: x, style: C, easing: m }, { mode: "exit" });
            (e.style.webkitTransition = o.transitions.create(
              "-webkit-transform",
              t
            )),
              (e.style.transition = o.transitions.create("transform", t)),
              lo(p, e, c),
              b && b(e);
          }),
          D = O((e) => {
            (e.style.webkitTransition = ""),
              (e.style.transition = ""),
              _ && _(e);
          }),
          A = t.useCallback(() => {
            P.current && lo(p, P.current, c);
          }, [p, c]);
        return (
          t.useEffect(() => {
            if (h || "down" === p || "right" === p) return;
            const e = (0, ao.Z)(() => {
                P.current && lo(p, P.current, c);
              }),
              t = (0, io.Z)(P.current);
            return (
              t.addEventListener("resize", e),
              () => {
                e.clear(), t.removeEventListener("resize", e);
              }
            );
          }, [p, h, c]),
          t.useEffect(() => {
            h || A();
          }, [h, A]),
          (0, e.jsx)(
            S,
            (0, u.Z)(
              {
                nodeRef: P,
                onEnter: T,
                onEntered: M,
                onEntering: I,
                onExit: N,
                onExited: D,
                onExiting: j,
                addEndListener: (e) => {
                  s && s(P.current, e);
                },
                appear: l,
                in: h,
                timeout: x,
              },
              k,
              {
                children: (e, n) =>
                  t.cloneElement(
                    d,
                    (0, u.Z)(
                      {
                        ref: w,
                        style: (0, u.Z)(
                          {
                            visibility: "exited" !== e || h ? void 0 : "hidden",
                          },
                          C,
                          d.props.style
                        ),
                      },
                      n
                    )
                  ),
              }
            )
          )
        );
      });
      var uo = co,
        po = (e) => {
          let t;
          return (
            (t = e < 1 ? 5.11916 * e ** 2 : 4.5 * Math.log(e + 1) + 2),
            (t / 100).toFixed(2)
          );
        };
      function mo(e) {
        return (0, Zt.ZP)("MuiPaper", e);
      }
      (0, Ft.Z)("MuiPaper", [
        "root",
        "rounded",
        "outlined",
        "elevation",
        "elevation0",
        "elevation1",
        "elevation2",
        "elevation3",
        "elevation4",
        "elevation5",
        "elevation6",
        "elevation7",
        "elevation8",
        "elevation9",
        "elevation10",
        "elevation11",
        "elevation12",
        "elevation13",
        "elevation14",
        "elevation15",
        "elevation16",
        "elevation17",
        "elevation18",
        "elevation19",
        "elevation20",
        "elevation21",
        "elevation22",
        "elevation23",
        "elevation24",
      ]);
      const ho = ["className", "component", "elevation", "square", "variant"],
        fo = (0, Bt.ZP)("div", {
          name: "MuiPaper",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              !n.square && t.rounded,
              "elevation" === n.variant && t[`elevation${n.elevation}`],
            ];
          },
        })(({ theme: e, ownerState: t }) => {
          var n;
          return (0, u.Z)(
            {
              backgroundColor: (e.vars || e).palette.background.paper,
              color: (e.vars || e).palette.text.primary,
              transition: e.transitions.create("box-shadow"),
            },
            !t.square && { borderRadius: e.shape.borderRadius },
            "outlined" === t.variant && {
              border: `1px solid ${(e.vars || e).palette.divider}`,
            },
            "elevation" === t.variant &&
              (0, u.Z)(
                { boxShadow: (e.vars || e).shadows[t.elevation] },
                !e.vars &&
                  "dark" === e.palette.mode && {
                    backgroundImage: `linear-gradient(${(0, Lt.Fq)(
                      "#fff",
                      po(t.elevation)
                    )}, ${(0, Lt.Fq)("#fff", po(t.elevation))})`,
                  },
                e.vars && {
                  backgroundImage:
                    null == (n = e.vars.overlays) ? void 0 : n[t.elevation],
                }
              )
          );
        });
      var go = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiPaper" }),
            {
              className: o,
              component: a = "div",
              elevation: i = 1,
              square: s = !1,
              variant: l = "elevation",
            } = r,
            d = (0, At.Z)(r, ho),
            c = (0, u.Z)({}, r, {
              component: a,
              elevation: i,
              square: s,
              variant: l,
            }),
            p = ((e) => {
              const { square: t, elevation: n, variant: r, classes: o } = e,
                a = {
                  root: [
                    "root",
                    r,
                    !t && "rounded",
                    "elevation" === r && `elevation${n}`,
                  ],
                };
              return (0, Rt.Z)(a, mo, o);
            })(c);
          return (0,
          e.jsx)(fo, (0, u.Z)({ as: a, ownerState: c, className: (0, Et.Z)(p.root, o), ref: n }, d));
        }),
        vo = o(4136);
      function bo(e) {
        return (0, Zt.ZP)("MuiDrawer", e);
      }
      (0, Ft.Z)("MuiDrawer", [
        "root",
        "docked",
        "paper",
        "paperAnchorLeft",
        "paperAnchorRight",
        "paperAnchorTop",
        "paperAnchorBottom",
        "paperAnchorDockedLeft",
        "paperAnchorDockedRight",
        "paperAnchorDockedTop",
        "paperAnchorDockedBottom",
        "modal",
      ]);
      const _o = ["BackdropProps"],
        yo = [
          "anchor",
          "BackdropProps",
          "children",
          "className",
          "elevation",
          "hideBackdrop",
          "ModalProps",
          "onClose",
          "open",
          "PaperProps",
          "SlideProps",
          "TransitionComponent",
          "transitionDuration",
          "variant",
        ],
        Co = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.root,
            ("permanent" === n.variant || "persistent" === n.variant) &&
              t.docked,
            t.modal,
          ];
        },
        xo = (0, Bt.ZP)(oo, {
          name: "MuiDrawer",
          slot: "Root",
          overridesResolver: Co,
        })(({ theme: e }) => ({ zIndex: (e.vars || e).zIndex.drawer })),
        So = (0, Bt.ZP)("div", {
          shouldForwardProp: vo.Z,
          name: "MuiDrawer",
          slot: "Docked",
          skipVariantsResolver: !1,
          overridesResolver: Co,
        })({ flex: "0 0 auto" }),
        ko = (0, Bt.ZP)(go, {
          name: "MuiDrawer",
          slot: "Paper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.paper,
              t[`paperAnchor${(0, $n.Z)(n.anchor)}`],
              "temporary" !== n.variant &&
                t[`paperAnchorDocked${(0, $n.Z)(n.anchor)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              height: "100%",
              flex: "1 0 auto",
              zIndex: (e.vars || e).zIndex.drawer,
              WebkitOverflowScrolling: "touch",
              position: "fixed",
              top: 0,
              outline: 0,
            },
            "left" === t.anchor && { left: 0 },
            "top" === t.anchor && {
              top: 0,
              left: 0,
              right: 0,
              height: "auto",
              maxHeight: "100%",
            },
            "right" === t.anchor && { right: 0 },
            "bottom" === t.anchor && {
              top: "auto",
              left: 0,
              bottom: 0,
              right: 0,
              height: "auto",
              maxHeight: "100%",
            },
            "left" === t.anchor &&
              "temporary" !== t.variant && {
                borderRight: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "top" === t.anchor &&
              "temporary" !== t.variant && {
                borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "right" === t.anchor &&
              "temporary" !== t.variant && {
                borderLeft: `1px solid ${(e.vars || e).palette.divider}`,
              },
            "bottom" === t.anchor &&
              "temporary" !== t.variant && {
                borderTop: `1px solid ${(e.vars || e).palette.divider}`,
              }
          )
        ),
        Po = { left: "right", right: "left", top: "down", bottom: "up" };
      var wo = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiDrawer" }),
            a = Dr(),
            i = tr(),
            s = {
              enter: a.transitions.duration.enteringScreen,
              exit: a.transitions.duration.leavingScreen,
            },
            {
              anchor: l = "left",
              BackdropProps: d,
              children: c,
              className: p,
              elevation: m = 16,
              hideBackdrop: h = !1,
              ModalProps: { BackdropProps: f } = {},
              onClose: g,
              open: v = !1,
              PaperProps: b = {},
              SlideProps: _,
              TransitionComponent: y = uo,
              transitionDuration: C = s,
              variant: x = "temporary",
            } = o,
            S = (0, At.Z)(o.ModalProps, _o),
            k = (0, At.Z)(o, yo),
            P = t.useRef(!1);
          t.useEffect(() => {
            P.current = !0;
          }, []);
          const w = (function ({ direction: e }, t) {
              return "rtl" === e &&
                (function (e) {
                  return -1 !== ["left", "right"].indexOf(e);
                })(t)
                ? Po[t]
                : t;
            })({ direction: i ? "rtl" : "ltr" }, l),
            O = l,
            T = (0, u.Z)(
              {},
              o,
              { anchor: O, elevation: m, open: v, variant: x },
              k
            ),
            I = ((e) => {
              const { classes: t, anchor: n, variant: r } = e,
                o = {
                  root: ["root"],
                  docked: [
                    ("permanent" === r || "persistent" === r) && "docked",
                  ],
                  modal: ["modal"],
                  paper: [
                    "paper",
                    `paperAnchor${(0, $n.Z)(n)}`,
                    "temporary" !== r && `paperAnchorDocked${(0, $n.Z)(n)}`,
                  ],
                };
              return (0, Rt.Z)(o, bo, t);
            })(T),
            M = (0, e.jsx)(
              ko,
              (0, u.Z)(
                { elevation: "temporary" === x ? m : 0, square: !0 },
                b,
                {
                  className: (0, Et.Z)(I.paper, b.className),
                  ownerState: T,
                  children: c,
                }
              )
            );
          if ("permanent" === x)
            return (0, e.jsx)(
              So,
              (0, u.Z)(
                {
                  className: (0, Et.Z)(I.root, I.docked, p),
                  ownerState: T,
                  ref: r,
                },
                k,
                { children: M }
              )
            );
          const j = (0, e.jsx)(
            y,
            (0, u.Z)(
              { in: v, direction: Po[w], timeout: C, appear: P.current },
              _,
              { children: M }
            )
          );
          return "persistent" === x
            ? (0, e.jsx)(
                So,
                (0, u.Z)(
                  {
                    className: (0, Et.Z)(I.root, I.docked, p),
                    ownerState: T,
                    ref: r,
                  },
                  k,
                  { children: j }
                )
              )
            : (0, e.jsx)(
                xo,
                (0, u.Z)(
                  {
                    BackdropProps: (0, u.Z)({}, d, f, {
                      transitionDuration: C,
                    }),
                    className: (0, Et.Z)(I.root, I.modal, p),
                    open: v,
                    ownerState: T,
                    onClose: g,
                    hideBackdrop: h,
                    ref: r,
                  },
                  k,
                  S,
                  { children: j }
                )
              );
        }),
        Oo = o(2066),
        To = (0, Oo.Z)(
          (0, e.jsx)("path", { d: "M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z" }),
          "Menu"
        ),
        Io = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
          }),
          "Close"
        ),
        Mo = { display: "flex" },
        jo = { mr: 2, display: { sm: "none" } },
        No = { position: "sticky" },
        Do = {
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: 260 },
          left: "unset !important",
        },
        Ao = { "& .MuiDrawer-paper": { boxSizing: "border-box", width: 260 } },
        Eo = {
          flexGrow: 1,
          width: "calc(100% - ".concat(260, "px)"),
          mt: "-2%",
          background: "#f6f6f7",
        },
        Ro = {
          left: "50%",
          top: "20%",
          position: "absolute",
          zIndex: 99999999,
          animation: "none !important",
        },
        Lo = {
          cursor: "pointer",
          textTransform: "capitalize",
          color: "#1976d2 !important",
          textDecoration: "underline",
        },
        Bo = { textTransform: "capitalize", pointerEvents: "none" },
        zo = { padding: "10px", fontSize: "12px", whiteSpace: "nowrap" },
        Fo = { display: "none" },
        Zo = { cursor: "pointer", color: "#1976d2" },
        Ho = {
          width: "auto !important",
          maxHeight: 500,
          tableLayout: "fixed",
          border: "1px solid #bfbfbf",
        },
        Vo = { height: 40, width: 40, borderRadius: "4px" },
        Wo = {
          display: { xs: "none", md: "flex" },
          fontSize: "16px",
          color: "#1565C4",
          fontFamily: "Segoe UI",
        },
        Uo = {
          boxShadow: "none",
          ".MuiOutlinedInput-notchedOutline": { border: 0 },
        },
        $o = { display: "flex", alignItems: "center" },
        Ko = {
          fontWeight: "bold",
          fontFamily: "Segoe UI",
          fontSize: "1.3rem",
          whiteSpace: "nowrap",
        },
        Go = {
          width: 45,
          height: 45,
          borderRadius: "50%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        qo = {
          width: 30,
          height: 30,
          borderRadius: "50%",
          backgroundColor: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
        Qo = { fontSize: "13px" },
        Yo = { borderRadius: "10px" },
        Jo = {
          marginTop: "20px",
          padding: "20px",
          backgroundColor: "#fff",
          borderRadius: "8px",
          border: "1px solid #d4d4d4",
        };
      let Xo;
      function ea() {
        if (Xo) return Xo;
        const e = document.createElement("div"),
          t = document.createElement("div");
        return (
          (t.style.width = "10px"),
          (t.style.height = "1px"),
          e.appendChild(t),
          (e.dir = "rtl"),
          (e.style.fontSize = "14px"),
          (e.style.width = "4px"),
          (e.style.height = "1px"),
          (e.style.position = "absolute"),
          (e.style.top = "-1000px"),
          (e.style.overflow = "scroll"),
          document.body.appendChild(e),
          (Xo = "reverse"),
          e.scrollLeft > 0
            ? (Xo = "default")
            : ((e.scrollLeft = 1), 0 === e.scrollLeft && (Xo = "negative")),
          document.body.removeChild(e),
          Xo
        );
      }
      function ta(e, t) {
        const n = e.scrollLeft;
        if ("rtl" !== t) return n;
        switch (ea()) {
          case "negative":
            return e.scrollWidth - e.clientWidth + n;
          case "reverse":
            return e.scrollWidth - e.clientWidth - n;
          default:
            return n;
        }
      }
      function na(e) {
        return (1 + Math.sin(Math.PI * e - Math.PI / 2)) / 2;
      }
      var ra = o(8974);
      const oa = ["onChange"],
        aa = {
          width: 99,
          height: 99,
          position: "absolute",
          top: -9999,
          overflow: "scroll",
        };
      var ia = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z",
          }),
          "KeyboardArrowLeft"
        ),
        sa = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z",
          }),
          "KeyboardArrowRight"
        );
      function la(e) {
        return (0, Zt.ZP)("MuiTabScrollButton", e);
      }
      var da = (0, Ft.Z)("MuiTabScrollButton", [
        "root",
        "vertical",
        "horizontal",
        "disabled",
      ]);
      const ca = [
          "className",
          "slots",
          "slotProps",
          "direction",
          "orientation",
          "disabled",
        ],
        ua = (0, Bt.ZP)(Un, {
          name: "MuiTabScrollButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.orientation && t[n.orientation]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              width: 40,
              flexShrink: 0,
              opacity: 0.8,
              [`&.${da.disabled}`]: { opacity: 0 },
            },
            "vertical" === e.orientation && {
              width: "100%",
              height: 40,
              "& svg": { transform: `rotate(${e.isRtl ? -90 : 90}deg)` },
            }
          )
        );
      var pa = t.forwardRef(function (t, n) {
        var r, o;
        const a = (0, zt.i)({ props: t, name: "MuiTabScrollButton" }),
          { className: i, slots: s = {}, slotProps: l = {}, direction: d } = a,
          c = (0, At.Z)(a, ca),
          p = tr(),
          m = (0, u.Z)({ isRtl: p }, a),
          h = ((e) => {
            const { classes: t, orientation: n, disabled: r } = e,
              o = { root: ["root", n, r && "disabled"] };
            return (0, Rt.Z)(o, la, t);
          })(m),
          f = null != (r = s.StartScrollButtonIcon) ? r : ia,
          g = null != (o = s.EndScrollButtonIcon) ? o : sa,
          v = mr({
            elementType: f,
            externalSlotProps: l.startScrollButtonIcon,
            additionalProps: { fontSize: "small" },
            ownerState: m,
          }),
          b = mr({
            elementType: g,
            externalSlotProps: l.endScrollButtonIcon,
            additionalProps: { fontSize: "small" },
            ownerState: m,
          });
        return (0,
        e.jsx)(ua, (0, u.Z)({ component: "div", className: (0, Et.Z)(h.root, i), ref: n, role: null, ownerState: m, tabIndex: null }, c, { children: "left" === d ? (0, e.jsx)(f, (0, u.Z)({}, v)) : (0, e.jsx)(g, (0, u.Z)({}, b)) }));
      });
      function ma(e) {
        return (0, Zt.ZP)("MuiTabs", e);
      }
      var ha = (0, Ft.Z)("MuiTabs", [
          "root",
          "vertical",
          "flexContainer",
          "flexContainerVertical",
          "centered",
          "scroller",
          "fixed",
          "scrollableX",
          "scrollableY",
          "hideScrollbar",
          "scrollButtons",
          "scrollButtonsHideMobile",
          "indicator",
        ]),
        fa = o(8038);
      const ga = [
          "aria-label",
          "aria-labelledby",
          "action",
          "centered",
          "children",
          "className",
          "component",
          "allowScrollButtonsMobile",
          "indicatorColor",
          "onChange",
          "orientation",
          "ScrollButtonComponent",
          "scrollButtons",
          "selectionFollowsFocus",
          "slots",
          "slotProps",
          "TabIndicatorProps",
          "TabScrollButtonProps",
          "textColor",
          "value",
          "variant",
          "visibleScrollbar",
        ],
        va = (e, t) =>
          e === t
            ? e.firstChild
            : t && t.nextElementSibling
            ? t.nextElementSibling
            : e.firstChild,
        ba = (e, t) =>
          e === t
            ? e.lastChild
            : t && t.previousElementSibling
            ? t.previousElementSibling
            : e.lastChild,
        _a = (e, t, n) => {
          let r = !1,
            o = n(e, t);
          for (; o; ) {
            if (o === e.firstChild) {
              if (r) return;
              r = !0;
            }
            const t = o.disabled || "true" === o.getAttribute("aria-disabled");
            if (o.hasAttribute("tabindex") && !t) return void o.focus();
            o = n(e, o);
          }
        },
        ya = (0, Bt.ZP)("div", {
          name: "MuiTabs",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${ha.scrollButtons}`]: t.scrollButtons },
              {
                [`& .${ha.scrollButtons}`]:
                  n.scrollButtonsHideMobile && t.scrollButtonsHideMobile,
              },
              t.root,
              n.vertical && t.vertical,
            ];
          },
        })(({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              overflow: "hidden",
              minHeight: 48,
              WebkitOverflowScrolling: "touch",
              display: "flex",
            },
            e.vertical && { flexDirection: "column" },
            e.scrollButtonsHideMobile && {
              [`& .${ha.scrollButtons}`]: {
                [t.breakpoints.down("sm")]: { display: "none" },
              },
            }
          )
        ),
        Ca = (0, Bt.ZP)("div", {
          name: "MuiTabs",
          slot: "Scroller",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.scroller,
              n.fixed && t.fixed,
              n.hideScrollbar && t.hideScrollbar,
              n.scrollableX && t.scrollableX,
              n.scrollableY && t.scrollableY,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              position: "relative",
              display: "inline-block",
              flex: "1 1 auto",
              whiteSpace: "nowrap",
            },
            e.fixed && { overflowX: "hidden", width: "100%" },
            e.hideScrollbar && {
              scrollbarWidth: "none",
              "&::-webkit-scrollbar": { display: "none" },
            },
            e.scrollableX && { overflowX: "auto", overflowY: "hidden" },
            e.scrollableY && { overflowY: "auto", overflowX: "hidden" }
          )
        ),
        xa = (0, Bt.ZP)("div", {
          name: "MuiTabs",
          slot: "FlexContainer",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.flexContainer,
              n.vertical && t.flexContainerVertical,
              n.centered && t.centered,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { display: "flex" },
            e.vertical && { flexDirection: "column" },
            e.centered && { justifyContent: "center" }
          )
        ),
        Sa = (0, Bt.ZP)("span", {
          name: "MuiTabs",
          slot: "Indicator",
          overridesResolver: (e, t) => t.indicator,
        })(({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              position: "absolute",
              height: 2,
              bottom: 0,
              width: "100%",
              transition: t.transitions.create(),
            },
            "primary" === e.indicatorColor && {
              backgroundColor: (t.vars || t).palette.primary.main,
            },
            "secondary" === e.indicatorColor && {
              backgroundColor: (t.vars || t).palette.secondary.main,
            },
            e.vertical && { height: "100%", width: 2, right: 0 }
          )
        ),
        ka = (0, Bt.ZP)(function (n) {
          const { onChange: r } = n,
            o = (0, At.Z)(n, oa),
            a = t.useRef(),
            i = t.useRef(null),
            s = () => {
              a.current = i.current.offsetHeight - i.current.clientHeight;
            };
          return (
            (0, ra.Z)(() => {
              const e = (0, ao.Z)(() => {
                  const e = a.current;
                  s(), e !== a.current && r(a.current);
                }),
                t = (0, io.Z)(i.current);
              return (
                t.addEventListener("resize", e),
                () => {
                  e.clear(), t.removeEventListener("resize", e);
                }
              );
            }, [r]),
            t.useEffect(() => {
              s(), r(a.current);
            }, [r]),
            (0, e.jsx)("div", (0, u.Z)({ style: aa }, o, { ref: i }))
          );
        })({
          overflowX: "auto",
          overflowY: "hidden",
          scrollbarWidth: "none",
          "&::-webkit-scrollbar": { display: "none" },
        }),
        Pa = {},
        wa = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTabs" }),
            a = Dr(),
            i = tr(),
            {
              "aria-label": s,
              "aria-labelledby": l,
              action: d,
              centered: c = !1,
              children: p,
              className: m,
              component: h = "div",
              allowScrollButtonsMobile: f = !1,
              indicatorColor: g = "primary",
              onChange: v,
              orientation: b = "horizontal",
              ScrollButtonComponent: _ = pa,
              scrollButtons: y = "auto",
              selectionFollowsFocus: C,
              slots: x = {},
              slotProps: S = {},
              TabIndicatorProps: k = {},
              TabScrollButtonProps: P = {},
              textColor: w = "primary",
              value: O,
              variant: T = "standard",
              visibleScrollbar: I = !1,
            } = o,
            M = (0, At.Z)(o, ga),
            j = "scrollable" === T,
            N = "vertical" === b,
            D = N ? "scrollTop" : "scrollLeft",
            A = N ? "top" : "left",
            E = N ? "bottom" : "right",
            R = N ? "clientHeight" : "clientWidth",
            L = N ? "height" : "width",
            B = (0, u.Z)({}, o, {
              component: h,
              allowScrollButtonsMobile: f,
              indicatorColor: g,
              orientation: b,
              vertical: N,
              scrollButtons: y,
              textColor: w,
              variant: T,
              visibleScrollbar: I,
              fixed: !j,
              hideScrollbar: j && !I,
              scrollableX: j && !N,
              scrollableY: j && N,
              centered: c && !j,
              scrollButtonsHideMobile: !f,
            }),
            z = ((e) => {
              const {
                  vertical: t,
                  fixed: n,
                  hideScrollbar: r,
                  scrollableX: o,
                  scrollableY: a,
                  centered: i,
                  scrollButtonsHideMobile: s,
                  classes: l,
                } = e,
                d = {
                  root: ["root", t && "vertical"],
                  scroller: [
                    "scroller",
                    n && "fixed",
                    r && "hideScrollbar",
                    o && "scrollableX",
                    a && "scrollableY",
                  ],
                  flexContainer: [
                    "flexContainer",
                    t && "flexContainerVertical",
                    i && "centered",
                  ],
                  indicator: ["indicator"],
                  scrollButtons: [
                    "scrollButtons",
                    s && "scrollButtonsHideMobile",
                  ],
                  scrollableX: [o && "scrollableX"],
                  hideScrollbar: [r && "hideScrollbar"],
                };
              return (0, Rt.Z)(d, ma, l);
            })(B),
            F = mr({
              elementType: x.StartScrollButtonIcon,
              externalSlotProps: S.startScrollButtonIcon,
              ownerState: B,
            }),
            Z = mr({
              elementType: x.EndScrollButtonIcon,
              externalSlotProps: S.endScrollButtonIcon,
              ownerState: B,
            }),
            [H, V] = t.useState(!1),
            [W, U] = t.useState(Pa),
            [$, K] = t.useState(!1),
            [G, q] = t.useState(!1),
            [Q, Y] = t.useState(!1),
            [J, X] = t.useState({ overflow: "hidden", scrollbarWidth: 0 }),
            ee = new Map(),
            te = t.useRef(null),
            ne = t.useRef(null),
            re = () => {
              const e = te.current;
              let t, n;
              if (e) {
                const n = e.getBoundingClientRect();
                t = {
                  clientWidth: e.clientWidth,
                  scrollLeft: e.scrollLeft,
                  scrollTop: e.scrollTop,
                  scrollLeftNormalized: ta(e, i ? "rtl" : "ltr"),
                  scrollWidth: e.scrollWidth,
                  top: n.top,
                  bottom: n.bottom,
                  left: n.left,
                  right: n.right,
                };
              }
              if (e && !1 !== O) {
                const e = ne.current.children;
                if (e.length > 0) {
                  const t = e[ee.get(O)];
                  n = t ? t.getBoundingClientRect() : null;
                }
              }
              return { tabsMeta: t, tabMeta: n };
            },
            oe = (0, fn.Z)(() => {
              const { tabsMeta: e, tabMeta: t } = re();
              let n,
                r = 0;
              if (N) (n = "top"), t && e && (r = t.top - e.top + e.scrollTop);
              else if (((n = i ? "right" : "left"), t && e)) {
                const o = i
                  ? e.scrollLeftNormalized + e.clientWidth - e.scrollWidth
                  : e.scrollLeft;
                r = (i ? -1 : 1) * (t[n] - e[n] + o);
              }
              const o = { [n]: r, [L]: t ? t[L] : 0 };
              if (isNaN(W[n]) || isNaN(W[L])) U(o);
              else {
                const e = Math.abs(W[n] - o[n]),
                  t = Math.abs(W[L] - o[L]);
                (e >= 1 || t >= 1) && U(o);
              }
            }),
            ae = (e, { animation: t = !0 } = {}) => {
              t
                ? (function (e, t, n, r = {}, o = () => {}) {
                    const { ease: a = na, duration: i = 300 } = r;
                    let s = null;
                    const l = t[e];
                    let d = !1;
                    const c = (r) => {
                      if (d) return void o(new Error("Animation cancelled"));
                      null === s && (s = r);
                      const u = Math.min(1, (r - s) / i);
                      (t[e] = a(u) * (n - l) + l),
                        u >= 1
                          ? requestAnimationFrame(() => {
                              o(null);
                            })
                          : requestAnimationFrame(c);
                    };
                    l === n
                      ? o(new Error("Element already at target position"))
                      : requestAnimationFrame(c);
                  })(D, te.current, e, {
                    duration: a.transitions.duration.standard,
                  })
                : (te.current[D] = e);
            },
            ie = (e) => {
              let t = te.current[D];
              N
                ? (t += e)
                : ((t += e * (i ? -1 : 1)),
                  (t *= i && "reverse" === ea() ? -1 : 1)),
                ae(t);
            },
            se = () => {
              const e = te.current[R];
              let t = 0;
              const n = Array.from(ne.current.children);
              for (let r = 0; r < n.length; r += 1) {
                const o = n[r];
                if (t + o[R] > e) {
                  0 === r && (t = e);
                  break;
                }
                t += o[R];
              }
              return t;
            },
            le = () => {
              ie(-1 * se());
            },
            de = () => {
              ie(se());
            },
            ce = t.useCallback((e) => {
              X({ overflow: null, scrollbarWidth: e });
            }, []),
            ue = (0, fn.Z)((e) => {
              const { tabsMeta: t, tabMeta: n } = re();
              if (n && t)
                if (n[A] < t[A]) {
                  const r = t[D] + (n[A] - t[A]);
                  ae(r, { animation: e });
                } else if (n[E] > t[E]) {
                  const r = t[D] + (n[E] - t[E]);
                  ae(r, { animation: e });
                }
            }),
            pe = (0, fn.Z)(() => {
              j && !1 !== y && Y(!Q);
            });
          t.useEffect(() => {
            const e = (0, ao.Z)(() => {
              te.current && oe();
            });
            let t;
            const n = (0, io.Z)(te.current);
            let r;
            return (
              n.addEventListener("resize", e),
              "undefined" != typeof ResizeObserver &&
                ((t = new ResizeObserver(e)),
                Array.from(ne.current.children).forEach((e) => {
                  t.observe(e);
                })),
              "undefined" != typeof MutationObserver &&
                ((r = new MutationObserver((n) => {
                  n.forEach((e) => {
                    e.removedNodes.forEach((e) => {
                      var n;
                      null == (n = t) || n.unobserve(e);
                    }),
                      e.addedNodes.forEach((e) => {
                        var n;
                        null == (n = t) || n.observe(e);
                      });
                  }),
                    e(),
                    pe();
                })),
                r.observe(ne.current, { childList: !0 })),
              () => {
                var o, a;
                e.clear(),
                  n.removeEventListener("resize", e),
                  null == (o = r) || o.disconnect(),
                  null == (a = t) || a.disconnect();
              }
            );
          }, [oe, pe]),
            t.useEffect(() => {
              const e = Array.from(ne.current.children),
                t = e.length;
              if (
                "undefined" != typeof IntersectionObserver &&
                t > 0 &&
                j &&
                !1 !== y
              ) {
                const n = e[0],
                  r = e[t - 1],
                  o = { root: te.current, threshold: 0.99 },
                  a = new IntersectionObserver((e) => {
                    K(!e[0].isIntersecting);
                  }, o);
                a.observe(n);
                const i = new IntersectionObserver((e) => {
                  q(!e[0].isIntersecting);
                }, o);
                return (
                  i.observe(r),
                  () => {
                    a.disconnect(), i.disconnect();
                  }
                );
              }
            }, [j, y, Q, null == p ? void 0 : p.length]),
            t.useEffect(() => {
              V(!0);
            }, []),
            t.useEffect(() => {
              oe();
            }),
            t.useEffect(() => {
              ue(Pa !== W);
            }, [ue, W]),
            t.useImperativeHandle(
              d,
              () => ({ updateIndicator: oe, updateScrollButtons: pe }),
              [oe, pe]
            );
          const me = (0, e.jsx)(
            Sa,
            (0, u.Z)({}, k, {
              className: (0, Et.Z)(z.indicator, k.className),
              ownerState: B,
              style: (0, u.Z)({}, W, k.style),
            })
          );
          let he = 0;
          const fe = t.Children.map(p, (e) => {
              if (!t.isValidElement(e)) return null;
              const n = void 0 === e.props.value ? he : e.props.value;
              ee.set(n, he);
              const r = n === O;
              return (
                (he += 1),
                t.cloneElement(
                  e,
                  (0, u.Z)(
                    {
                      fullWidth: "fullWidth" === T,
                      indicator: r && !H && me,
                      selected: r,
                      selectionFollowsFocus: C,
                      onChange: v,
                      textColor: w,
                      value: n,
                    },
                    1 !== he || !1 !== O || e.props.tabIndex
                      ? {}
                      : { tabIndex: 0 }
                  )
                )
              );
            }),
            ge = (() => {
              const t = {};
              t.scrollbarSizeListener = j
                ? (0, e.jsx)(ka, {
                    onChange: ce,
                    className: (0, Et.Z)(z.scrollableX, z.hideScrollbar),
                  })
                : null;
              const n = j && (("auto" === y && ($ || G)) || !0 === y);
              return (
                (t.scrollButtonStart = n
                  ? (0, e.jsx)(
                      _,
                      (0, u.Z)(
                        {
                          slots: {
                            StartScrollButtonIcon: x.StartScrollButtonIcon,
                          },
                          slotProps: { startScrollButtonIcon: F },
                          orientation: b,
                          direction: i ? "right" : "left",
                          onClick: le,
                          disabled: !$,
                        },
                        P,
                        { className: (0, Et.Z)(z.scrollButtons, P.className) }
                      )
                    )
                  : null),
                (t.scrollButtonEnd = n
                  ? (0, e.jsx)(
                      _,
                      (0, u.Z)(
                        {
                          slots: { EndScrollButtonIcon: x.EndScrollButtonIcon },
                          slotProps: { endScrollButtonIcon: Z },
                          orientation: b,
                          direction: i ? "left" : "right",
                          onClick: de,
                          disabled: !G,
                        },
                        P,
                        { className: (0, Et.Z)(z.scrollButtons, P.className) }
                      )
                    )
                  : null),
                t
              );
            })();
          return (0, e.jsxs)(
            ya,
            (0, u.Z)(
              { className: (0, Et.Z)(z.root, m), ownerState: B, ref: r, as: h },
              M,
              {
                children: [
                  ge.scrollButtonStart,
                  ge.scrollbarSizeListener,
                  (0, e.jsxs)(Ca, {
                    className: z.scroller,
                    ownerState: B,
                    style: {
                      overflow: J.overflow,
                      [N ? "margin" + (i ? "Left" : "Right") : "marginBottom"]:
                        I ? void 0 : -J.scrollbarWidth,
                    },
                    ref: te,
                    children: [
                      (0, e.jsx)(xa, {
                        "aria-label": s,
                        "aria-labelledby": l,
                        "aria-orientation":
                          "vertical" === b ? "vertical" : null,
                        className: z.flexContainer,
                        ownerState: B,
                        onKeyDown: (e) => {
                          const t = ne.current,
                            n = (0, fa.Z)(t).activeElement;
                          if ("tab" !== n.getAttribute("role")) return;
                          let r = "horizontal" === b ? "ArrowLeft" : "ArrowUp",
                            o = "horizontal" === b ? "ArrowRight" : "ArrowDown";
                          switch (
                            ("horizontal" === b &&
                              i &&
                              ((r = "ArrowRight"), (o = "ArrowLeft")),
                            e.key)
                          ) {
                            case r:
                              e.preventDefault(), _a(t, n, ba);
                              break;
                            case o:
                              e.preventDefault(), _a(t, n, va);
                              break;
                            case "Home":
                              e.preventDefault(), _a(t, null, va);
                              break;
                            case "End":
                              e.preventDefault(), _a(t, null, ba);
                          }
                        },
                        ref: ne,
                        role: "tablist",
                        children: fe,
                      }),
                      H && me,
                    ],
                  }),
                  ge.scrollButtonEnd,
                ],
              }
            )
          );
        });
      var Oa = wa;
      function Ta(e) {
        return (0, Zt.ZP)("MuiTab", e);
      }
      var Ia = (0, Ft.Z)("MuiTab", [
        "root",
        "labelIcon",
        "textColorInherit",
        "textColorPrimary",
        "textColorSecondary",
        "selected",
        "disabled",
        "fullWidth",
        "wrapped",
        "iconWrapper",
      ]);
      const Ma = [
          "className",
          "disabled",
          "disableFocusRipple",
          "fullWidth",
          "icon",
          "iconPosition",
          "indicator",
          "label",
          "onChange",
          "onClick",
          "onFocus",
          "selected",
          "selectionFollowsFocus",
          "textColor",
          "value",
          "wrapped",
        ],
        ja = (0, Bt.ZP)(Un, {
          name: "MuiTab",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.label && n.icon && t.labelIcon,
              t[`textColor${(0, $n.Z)(n.textColor)}`],
              n.fullWidth && t.fullWidth,
              n.wrapped && t.wrapped,
              { [`& .${Ia.iconWrapper}`]: t.iconWrapper },
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {},
            e.typography.button,
            {
              maxWidth: 360,
              minWidth: 90,
              position: "relative",
              minHeight: 48,
              flexShrink: 0,
              padding: "12px 16px",
              overflow: "hidden",
              whiteSpace: "normal",
              textAlign: "center",
            },
            t.label && {
              flexDirection:
                "top" === t.iconPosition || "bottom" === t.iconPosition
                  ? "column"
                  : "row",
            },
            { lineHeight: 1.25 },
            t.icon &&
              t.label && {
                minHeight: 72,
                paddingTop: 9,
                paddingBottom: 9,
                [`& > .${Ia.iconWrapper}`]: (0, u.Z)(
                  {},
                  "top" === t.iconPosition && { marginBottom: 6 },
                  "bottom" === t.iconPosition && { marginTop: 6 },
                  "start" === t.iconPosition && { marginRight: e.spacing(1) },
                  "end" === t.iconPosition && { marginLeft: e.spacing(1) }
                ),
              },
            "inherit" === t.textColor && {
              color: "inherit",
              opacity: 0.6,
              [`&.${Ia.selected}`]: { opacity: 1 },
              [`&.${Ia.disabled}`]: {
                opacity: (e.vars || e).palette.action.disabledOpacity,
              },
            },
            "primary" === t.textColor && {
              color: (e.vars || e).palette.text.secondary,
              [`&.${Ia.selected}`]: {
                color: (e.vars || e).palette.primary.main,
              },
              [`&.${Ia.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
            },
            "secondary" === t.textColor && {
              color: (e.vars || e).palette.text.secondary,
              [`&.${Ia.selected}`]: {
                color: (e.vars || e).palette.secondary.main,
              },
              [`&.${Ia.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
            },
            t.fullWidth && {
              flexShrink: 1,
              flexGrow: 1,
              flexBasis: 0,
              maxWidth: "none",
            },
            t.wrapped && { fontSize: e.typography.pxToRem(12) }
          )
        );
      var Na = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTab" }),
            {
              className: a,
              disabled: i = !1,
              disableFocusRipple: s = !1,
              fullWidth: l,
              icon: d,
              iconPosition: c = "top",
              indicator: p,
              label: m,
              onChange: h,
              onClick: f,
              onFocus: g,
              selected: v,
              selectionFollowsFocus: b,
              textColor: _ = "inherit",
              value: y,
              wrapped: C = !1,
            } = o,
            x = (0, At.Z)(o, Ma),
            S = (0, u.Z)({}, o, {
              disabled: i,
              disableFocusRipple: s,
              selected: v,
              icon: !!d,
              iconPosition: c,
              label: !!m,
              fullWidth: l,
              textColor: _,
              wrapped: C,
            }),
            k = ((e) => {
              const {
                  classes: t,
                  textColor: n,
                  fullWidth: r,
                  wrapped: o,
                  icon: a,
                  label: i,
                  selected: s,
                  disabled: l,
                } = e,
                d = {
                  root: [
                    "root",
                    a && i && "labelIcon",
                    `textColor${(0, $n.Z)(n)}`,
                    r && "fullWidth",
                    o && "wrapped",
                    s && "selected",
                    l && "disabled",
                  ],
                  iconWrapper: ["iconWrapper"],
                };
              return (0, Rt.Z)(d, Ta, t);
            })(S),
            P =
              d && m && t.isValidElement(d)
                ? t.cloneElement(d, {
                    className: (0, Et.Z)(k.iconWrapper, d.props.className),
                  })
                : d;
          return (0, e.jsxs)(
            ja,
            (0, u.Z)(
              {
                focusRipple: !s,
                className: (0, Et.Z)(k.root, a),
                ref: r,
                role: "tab",
                "aria-selected": v,
                disabled: i,
                onClick: (e) => {
                  !v && h && h(e, y), f && f(e);
                },
                onFocus: (e) => {
                  b && !v && h && h(e, y), g && g(e);
                },
                ownerState: S,
                tabIndex: v ? 0 : -1,
              },
              x,
              {
                children: [
                  "top" === c || "start" === c
                    ? (0, e.jsxs)(t.Fragment, { children: [P, m] })
                    : (0, e.jsxs)(t.Fragment, { children: [m, P] }),
                  p,
                ],
              }
            )
          );
        }),
        Da = (0, Oo.Z)(
          (0, e.jsx)("path", { d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" }),
          "Home"
        ),
        Aa = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2M1 3c0 .55.45 1 1 1h1l3.6 7.59-1.35 2.44C4.52 15.37 5.48 17 7 17h11c.55 0 1-.45 1-1s-.45-1-1-1H7l1.1-2h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.37-.66-.11-1.48-.87-1.48H5.21l-.67-1.43c-.16-.35-.52-.57-.9-.57H2c-.55 0-1 .45-1 1m16 15c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2",
          }),
          "ShoppingCartRounded"
        ),
        Ea = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12.75c1.63 0 3.07.39 4.24.9 1.08.48 1.76 1.56 1.76 2.73V17c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-.61c0-1.18.68-2.26 1.76-2.73 1.17-.52 2.61-.91 4.24-.91M4 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m1.13 1.1c-.37-.06-.74-.1-1.13-.1-.99 0-1.93.21-2.78.58C.48 14.9 0 15.62 0 16.43V17c0 .55.45 1 1 1h3.5v-1.61c0-.83.23-1.61.63-2.29M20 13c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2m4 3.43c0-.81-.48-1.53-1.22-1.85-.85-.37-1.79-.58-2.78-.58-.39 0-.76.04-1.13.1.4.68.63 1.46.63 2.29V18H23c.55 0 1-.45 1-1zM12 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3",
          }),
          "GroupsRounded"
        ),
        Ra = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4",
          }),
          "Person"
        ),
        La = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M21 2.21c-.13 0-.26.05-.35.15l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.79-.79c-.2-.2-.51-.2-.71 0l-.79.79c-.2.2-.51.2-.71 0l-.8-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.2-.2-.51-.2-.71 0l-.79.8c-.2.2-.51.2-.71 0l-.79-.8c-.09-.09-.22-.14-.35-.14V21.8c.13 0 .26-.05.35-.15l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.2.2.51.2.71 0l.79-.79c.2-.2.51-.2.71 0l.79.79c.1.1.23.15.35.15V2.21zM17 17H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1m0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1m0-4H7c-.55 0-1-.45-1-1s.45-1 1-1h10c.55 0 1 .45 1 1s-.45 1-1 1",
          }),
          "ReceiptRounded"
        ),
        Ba = o(5408),
        za = t.createContext();
      function Fa(e) {
        return (0, Zt.ZP)("MuiGrid", e);
      }
      const Za = ["auto", !0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
        Ha = (0, Ft.Z)("MuiGrid", [
          "root",
          "container",
          "item",
          "zeroMinWidth",
          ...[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((e) => `spacing-xs-${e}`),
          ...["column-reverse", "column", "row-reverse", "row"].map(
            (e) => `direction-xs-${e}`
          ),
          ...["nowrap", "wrap-reverse", "wrap"].map((e) => `wrap-xs-${e}`),
          ...Za.map((e) => `grid-xs-${e}`),
          ...Za.map((e) => `grid-sm-${e}`),
          ...Za.map((e) => `grid-md-${e}`),
          ...Za.map((e) => `grid-lg-${e}`),
          ...Za.map((e) => `grid-xl-${e}`),
        ]);
      var Va = Ha;
      const Wa = [
        "className",
        "columns",
        "columnSpacing",
        "component",
        "container",
        "direction",
        "item",
        "rowSpacing",
        "spacing",
        "wrap",
        "zeroMinWidth",
      ];
      function Ua(e) {
        const t = parseFloat(e);
        return `${t}${String(e).replace(String(t), "") || "px"}`;
      }
      function $a({ breakpoints: e, values: t }) {
        let n = "";
        Object.keys(t).forEach((e) => {
          "" === n && 0 !== t[e] && (n = e);
        });
        const r = Object.keys(e).sort((t, n) => e[t] - e[n]);
        return r.slice(0, r.indexOf(n));
      }
      const Ka = (0, Bt.ZP)("div", {
          name: "MuiGrid",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                container: r,
                direction: o,
                item: a,
                spacing: i,
                wrap: s,
                zeroMinWidth: l,
                breakpoints: d,
              } = n;
            let c = [];
            r &&
              (c = (function (e, t, n = {}) {
                if (!e || e <= 0) return [];
                if (
                  ("string" == typeof e && !Number.isNaN(Number(e))) ||
                  "number" == typeof e
                )
                  return [n[`spacing-xs-${String(e)}`]];
                const r = [];
                return (
                  t.forEach((t) => {
                    const o = e[t];
                    Number(o) > 0 && r.push(n[`spacing-${t}-${String(o)}`]);
                  }),
                  r
                );
              })(i, d, t));
            const u = [];
            return (
              d.forEach((e) => {
                const r = n[e];
                r && u.push(t[`grid-${e}-${String(r)}`]);
              }),
              [
                t.root,
                r && t.container,
                a && t.item,
                l && t.zeroMinWidth,
                ...c,
                "row" !== o && t[`direction-xs-${String(o)}`],
                "wrap" !== s && t[`wrap-xs-${String(s)}`],
                ...u,
              ]
            );
          },
        })(
          ({ ownerState: e }) =>
            (0, u.Z)(
              { boxSizing: "border-box" },
              e.container && {
                display: "flex",
                flexWrap: "wrap",
                width: "100%",
              },
              e.item && { margin: 0 },
              e.zeroMinWidth && { minWidth: 0 },
              "wrap" !== e.wrap && { flexWrap: e.wrap }
            ),
          function ({ theme: e, ownerState: t }) {
            const n = (0, Ba.P$)({
              values: t.direction,
              breakpoints: e.breakpoints.values,
            });
            return (0, Ba.k9)({ theme: e }, n, (e) => {
              const t = { flexDirection: e };
              return (
                0 === e.indexOf("column") &&
                  (t[`& > .${Va.item}`] = { maxWidth: "none" }),
                t
              );
            });
          },
          function ({ theme: e, ownerState: t }) {
            const { container: n, rowSpacing: r } = t;
            let o = {};
            if (n && 0 !== r) {
              const t = (0, Ba.P$)({
                values: r,
                breakpoints: e.breakpoints.values,
              });
              let n;
              "object" == typeof t &&
                (n = $a({ breakpoints: e.breakpoints.values, values: t })),
                (o = (0, Ba.k9)({ theme: e }, t, (t, r) => {
                  var o;
                  const a = e.spacing(t);
                  return "0px" !== a
                    ? {
                        marginTop: `-${Ua(a)}`,
                        [`& > .${Va.item}`]: { paddingTop: Ua(a) },
                      }
                    : null != (o = n) && o.includes(r)
                    ? {}
                    : { marginTop: 0, [`& > .${Va.item}`]: { paddingTop: 0 } };
                }));
            }
            return o;
          },
          function ({ theme: e, ownerState: t }) {
            const { container: n, columnSpacing: r } = t;
            let o = {};
            if (n && 0 !== r) {
              const t = (0, Ba.P$)({
                values: r,
                breakpoints: e.breakpoints.values,
              });
              let n;
              "object" == typeof t &&
                (n = $a({ breakpoints: e.breakpoints.values, values: t })),
                (o = (0, Ba.k9)({ theme: e }, t, (t, r) => {
                  var o;
                  const a = e.spacing(t);
                  return "0px" !== a
                    ? {
                        width: `calc(100% + ${Ua(a)})`,
                        marginLeft: `-${Ua(a)}`,
                        [`& > .${Va.item}`]: { paddingLeft: Ua(a) },
                      }
                    : null != (o = n) && o.includes(r)
                    ? {}
                    : {
                        width: "100%",
                        marginLeft: 0,
                        [`& > .${Va.item}`]: { paddingLeft: 0 },
                      };
                }));
            }
            return o;
          },
          function ({ theme: e, ownerState: t }) {
            let n;
            return e.breakpoints.keys.reduce((r, o) => {
              let a = {};
              if ((t[o] && (n = t[o]), !n)) return r;
              if (!0 === n) a = { flexBasis: 0, flexGrow: 1, maxWidth: "100%" };
              else if ("auto" === n)
                a = {
                  flexBasis: "auto",
                  flexGrow: 0,
                  flexShrink: 0,
                  maxWidth: "none",
                  width: "auto",
                };
              else {
                const i = (0, Ba.P$)({
                    values: t.columns,
                    breakpoints: e.breakpoints.values,
                  }),
                  s = "object" == typeof i ? i[o] : i;
                if (null == s) return r;
                const l = Math.round((n / s) * 1e8) / 1e6 + "%";
                let d = {};
                if (t.container && t.item && 0 !== t.columnSpacing) {
                  const n = e.spacing(t.columnSpacing);
                  if ("0px" !== n) {
                    const e = `calc(${l} + ${Ua(n)})`;
                    d = { flexBasis: e, maxWidth: e };
                  }
                }
                a = (0, u.Z)({ flexBasis: l, flexGrow: 0, maxWidth: l }, d);
              }
              return (
                0 === e.breakpoints.values[o]
                  ? Object.assign(r, a)
                  : (r[e.breakpoints.up(o)] = a),
                r
              );
            }, {});
          }
        ),
        Ga = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiGrid" }),
            { breakpoints: a } = Dr(),
            i = (0, Xt.Z)(o),
            {
              className: s,
              columns: l,
              columnSpacing: d,
              component: c = "div",
              container: p = !1,
              direction: m = "row",
              item: h = !1,
              rowSpacing: f,
              spacing: g = 0,
              wrap: v = "wrap",
              zeroMinWidth: b = !1,
            } = i,
            _ = (0, At.Z)(i, Wa),
            y = f || g,
            C = d || g,
            x = t.useContext(za),
            S = p ? l || 12 : x,
            k = {},
            P = (0, u.Z)({}, _);
          a.keys.forEach((e) => {
            null != _[e] && ((k[e] = _[e]), delete P[e]);
          });
          const w = (0, u.Z)(
              {},
              i,
              {
                columns: S,
                container: p,
                direction: m,
                item: h,
                rowSpacing: y,
                columnSpacing: C,
                wrap: v,
                zeroMinWidth: b,
                spacing: g,
              },
              k,
              { breakpoints: a.keys }
            ),
            O = ((e) => {
              const {
                classes: t,
                container: n,
                direction: r,
                item: o,
                spacing: a,
                wrap: i,
                zeroMinWidth: s,
                breakpoints: l,
              } = e;
              let d = [];
              n &&
                (d = (function (e, t) {
                  if (!e || e <= 0) return [];
                  if (
                    ("string" == typeof e && !Number.isNaN(Number(e))) ||
                    "number" == typeof e
                  )
                    return [`spacing-xs-${String(e)}`];
                  const n = [];
                  return (
                    t.forEach((t) => {
                      const r = e[t];
                      if (Number(r) > 0) {
                        const e = `spacing-${t}-${String(r)}`;
                        n.push(e);
                      }
                    }),
                    n
                  );
                })(a, l));
              const c = [];
              l.forEach((t) => {
                const n = e[t];
                n && c.push(`grid-${t}-${String(n)}`);
              });
              const u = {
                root: [
                  "root",
                  n && "container",
                  o && "item",
                  s && "zeroMinWidth",
                  ...d,
                  "row" !== r && `direction-xs-${String(r)}`,
                  "wrap" !== i && `wrap-xs-${String(i)}`,
                  ...c,
                ],
              };
              return (0, Rt.Z)(u, Fa, t);
            })(w);
          return (0,
          e.jsx)(za.Provider, { value: S, children: (0, e.jsx)(Ka, (0, u.Z)({ ownerState: w, className: (0, Et.Z)(O.root, s), as: c, ref: r }, P)) });
        });
      var qa = Ga;
      function Qa(e) {
        return (0, Zt.ZP)("MuiTypography", e);
      }
      (0, Ft.Z)("MuiTypography", [
        "root",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "subtitle1",
        "subtitle2",
        "body1",
        "body2",
        "inherit",
        "button",
        "caption",
        "overline",
        "alignLeft",
        "alignRight",
        "alignCenter",
        "alignJustify",
        "noWrap",
        "gutterBottom",
        "paragraph",
      ]);
      const Ya = [
          "align",
          "className",
          "component",
          "gutterBottom",
          "noWrap",
          "paragraph",
          "variant",
          "variantMapping",
        ],
        Ja = (0, Bt.ZP)("span", {
          name: "MuiTypography",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.variant && t[n.variant],
              "inherit" !== n.align && t[`align${(0, $n.Z)(n.align)}`],
              n.noWrap && t.noWrap,
              n.gutterBottom && t.gutterBottom,
              n.paragraph && t.paragraph,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { margin: 0 },
            "inherit" === t.variant && { font: "inherit" },
            "inherit" !== t.variant && e.typography[t.variant],
            "inherit" !== t.align && { textAlign: t.align },
            t.noWrap && {
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
            },
            t.gutterBottom && { marginBottom: "0.35em" },
            t.paragraph && { marginBottom: 16 }
          )
        ),
        Xa = {
          h1: "h1",
          h2: "h2",
          h3: "h3",
          h4: "h4",
          h5: "h5",
          h6: "h6",
          subtitle1: "h6",
          subtitle2: "h6",
          body1: "p",
          body2: "p",
          inherit: "p",
        },
        ei = {
          primary: "primary.main",
          textPrimary: "text.primary",
          secondary: "secondary.main",
          textSecondary: "text.secondary",
          error: "error.main",
        },
        ti = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiTypography" }),
            o = ((e) => ei[e] || e)(r.color),
            a = (0, Xt.Z)((0, u.Z)({}, r, { color: o })),
            {
              align: i = "inherit",
              className: s,
              component: l,
              gutterBottom: d = !1,
              noWrap: c = !1,
              paragraph: p = !1,
              variant: m = "body1",
              variantMapping: h = Xa,
            } = a,
            f = (0, At.Z)(a, Ya),
            g = (0, u.Z)({}, a, {
              align: i,
              color: o,
              className: s,
              component: l,
              gutterBottom: d,
              noWrap: c,
              paragraph: p,
              variant: m,
              variantMapping: h,
            }),
            v = l || (p ? "p" : h[m] || Xa[m]) || "span",
            b = ((e) => {
              const {
                  align: t,
                  gutterBottom: n,
                  noWrap: r,
                  paragraph: o,
                  variant: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    a,
                    "inherit" !== e.align && `align${(0, $n.Z)(t)}`,
                    n && "gutterBottom",
                    r && "noWrap",
                    o && "paragraph",
                  ],
                };
              return (0, Rt.Z)(s, Qa, i);
            })(g);
          return (0,
          e.jsx)(Ja, (0, u.Z)({ as: v, ref: n, ownerState: g, className: (0, Et.Z)(b.root, s) }, f));
        });
      var ni = ti;
      function ri(e) {
        return (0, Zt.ZP)("MuiCard", e);
      }
      (0, Ft.Z)("MuiCard", ["root"]);
      const oi = ["className", "raised"],
        ai = (0, Bt.ZP)(go, {
          name: "MuiCard",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(() => ({ overflow: "hidden" }));
      var ii = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiCard" }),
          { className: o, raised: a = !1 } = r,
          i = (0, At.Z)(r, oi),
          s = (0, u.Z)({}, r, { raised: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)({ root: ["root"] }, ri, t);
          })(s);
        return (0,
        e.jsx)(ai, (0, u.Z)({ className: (0, Et.Z)(l.root, o), elevation: a ? 8 : void 0, ref: n, ownerState: s }, i));
      });
      const si = [
        "addEndListener",
        "appear",
        "children",
        "easing",
        "in",
        "onEnter",
        "onEntered",
        "onEntering",
        "onExit",
        "onExited",
        "onExiting",
        "style",
        "timeout",
        "TransitionComponent",
      ];
      function li(e) {
        return `scale(${e}, ${e ** 2})`;
      }
      const di = {
          entering: { opacity: 1, transform: li(1) },
          entered: { opacity: 1, transform: "none" },
        },
        ci =
          "undefined" != typeof navigator &&
          /^((?!chrome|android).)*(safari|mobile)/i.test(navigator.userAgent) &&
          /(os |version\/)15(.|_)4/i.test(navigator.userAgent),
        ui = t.forwardRef(function (n, r) {
          const {
              addEndListener: o,
              appear: a = !0,
              children: i,
              easing: s,
              in: l,
              onEnter: d,
              onEntered: c,
              onEntering: p,
              onExit: m,
              onExited: h,
              onExiting: f,
              style: g,
              timeout: v = "auto",
              TransitionComponent: b = jr,
            } = n,
            _ = (0, At.Z)(n, si),
            y = (0, wn.Z)(),
            C = t.useRef(),
            x = Dr(),
            S = t.useRef(null),
            k = (0, hn.Z)(S, hr(i), r),
            P = (e) => (t) => {
              if (e) {
                const n = S.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            w = P(p),
            O = P((e, t) => {
              Ar(e);
              const {
                duration: n,
                delay: r,
                easing: o,
              } = Er({ style: g, timeout: v, easing: s }, { mode: "enter" });
              let a;
              "auto" === v
                ? ((a = x.transitions.getAutoHeightDuration(e.clientHeight)),
                  (C.current = a))
                : (a = n),
                (e.style.transition = [
                  x.transitions.create("opacity", { duration: a, delay: r }),
                  x.transitions.create("transform", {
                    duration: ci ? a : 0.666 * a,
                    delay: r,
                    easing: o,
                  }),
                ].join(",")),
                d && d(e, t);
            }),
            T = P(c),
            I = P(f),
            M = P((e) => {
              const {
                duration: t,
                delay: n,
                easing: r,
              } = Er({ style: g, timeout: v, easing: s }, { mode: "exit" });
              let o;
              "auto" === v
                ? ((o = x.transitions.getAutoHeightDuration(e.clientHeight)),
                  (C.current = o))
                : (o = t),
                (e.style.transition = [
                  x.transitions.create("opacity", { duration: o, delay: n }),
                  x.transitions.create("transform", {
                    duration: ci ? o : 0.666 * o,
                    delay: ci ? n : n || 0.333 * o,
                    easing: r,
                  }),
                ].join(",")),
                (e.style.opacity = 0),
                (e.style.transform = li(0.75)),
                m && m(e);
            }),
            j = P(h);
          return (0, e.jsx)(
            b,
            (0, u.Z)(
              {
                appear: a,
                in: l,
                nodeRef: S,
                onEnter: O,
                onEntered: T,
                onEntering: w,
                onExit: M,
                onExited: j,
                onExiting: I,
                addEndListener: (e) => {
                  "auto" === v && y.start(C.current || 0, e),
                    o && o(S.current, e);
                },
                timeout: "auto" === v ? null : v,
              },
              _,
              {
                children: (e, n) =>
                  t.cloneElement(
                    i,
                    (0, u.Z)(
                      {
                        style: (0, u.Z)(
                          {
                            opacity: 0,
                            transform: li(0.75),
                            visibility: "exited" !== e || l ? void 0 : "hidden",
                          },
                          di[e],
                          g,
                          i.props.style
                        ),
                        ref: k,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      ui.muiSupportAuto = !0;
      var pi = ui,
        mi = o(1070);
      function hi(e) {
        if (null == e) return window;
        if ("[object Window]" !== e.toString()) {
          var t = e.ownerDocument;
          return (t && t.defaultView) || window;
        }
        return e;
      }
      function fi(e) {
        return e instanceof hi(e).Element || e instanceof Element;
      }
      function gi(e) {
        return e instanceof hi(e).HTMLElement || e instanceof HTMLElement;
      }
      function vi(e) {
        return (
          "undefined" != typeof ShadowRoot &&
          (e instanceof hi(e).ShadowRoot || e instanceof ShadowRoot)
        );
      }
      var bi = Math.max,
        _i = Math.min,
        yi = Math.round;
      function Ci() {
        var e = navigator.userAgentData;
        return null != e && e.brands && Array.isArray(e.brands)
          ? e.brands
              .map(function (e) {
                return e.brand + "/" + e.version;
              })
              .join(" ")
          : navigator.userAgent;
      }
      function xi() {
        return !/^((?!chrome|android).)*safari/i.test(Ci());
      }
      function Si(e, t, n) {
        void 0 === t && (t = !1), void 0 === n && (n = !1);
        var r = e.getBoundingClientRect(),
          o = 1,
          a = 1;
        t &&
          gi(e) &&
          ((o = (e.offsetWidth > 0 && yi(r.width) / e.offsetWidth) || 1),
          (a = (e.offsetHeight > 0 && yi(r.height) / e.offsetHeight) || 1));
        var i = (fi(e) ? hi(e) : window).visualViewport,
          s = !xi() && n,
          l = (r.left + (s && i ? i.offsetLeft : 0)) / o,
          d = (r.top + (s && i ? i.offsetTop : 0)) / a,
          c = r.width / o,
          u = r.height / a;
        return {
          width: c,
          height: u,
          top: d,
          right: l + c,
          bottom: d + u,
          left: l,
          x: l,
          y: d,
        };
      }
      function ki(e) {
        var t = hi(e);
        return { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
      }
      function Pi(e) {
        return e ? (e.nodeName || "").toLowerCase() : null;
      }
      function wi(e) {
        return ((fi(e) ? e.ownerDocument : e.document) || window.document)
          .documentElement;
      }
      function Oi(e) {
        return Si(wi(e)).left + ki(e).scrollLeft;
      }
      function Ti(e) {
        return hi(e).getComputedStyle(e);
      }
      function Ii(e) {
        var t = Ti(e),
          n = t.overflow,
          r = t.overflowX,
          o = t.overflowY;
        return /auto|scroll|overlay|hidden/.test(n + o + r);
      }
      function Mi(e, t, n) {
        void 0 === n && (n = !1);
        var r,
          o,
          a = gi(t),
          i =
            gi(t) &&
            (function (e) {
              var t = e.getBoundingClientRect(),
                n = yi(t.width) / e.offsetWidth || 1,
                r = yi(t.height) / e.offsetHeight || 1;
              return 1 !== n || 1 !== r;
            })(t),
          s = wi(t),
          l = Si(e, i, n),
          d = { scrollLeft: 0, scrollTop: 0 },
          c = { x: 0, y: 0 };
        return (
          (a || (!a && !n)) &&
            (("body" !== Pi(t) || Ii(s)) &&
              (d =
                (r = t) !== hi(r) && gi(r)
                  ? { scrollLeft: (o = r).scrollLeft, scrollTop: o.scrollTop }
                  : ki(r)),
            gi(t)
              ? (((c = Si(t, !0)).x += t.clientLeft), (c.y += t.clientTop))
              : s && (c.x = Oi(s))),
          {
            x: l.left + d.scrollLeft - c.x,
            y: l.top + d.scrollTop - c.y,
            width: l.width,
            height: l.height,
          }
        );
      }
      function ji(e) {
        var t = Si(e),
          n = e.offsetWidth,
          r = e.offsetHeight;
        return (
          Math.abs(t.width - n) <= 1 && (n = t.width),
          Math.abs(t.height - r) <= 1 && (r = t.height),
          { x: e.offsetLeft, y: e.offsetTop, width: n, height: r }
        );
      }
      function Ni(e) {
        return "html" === Pi(e)
          ? e
          : e.assignedSlot || e.parentNode || (vi(e) ? e.host : null) || wi(e);
      }
      function Di(e) {
        return ["html", "body", "#document"].indexOf(Pi(e)) >= 0
          ? e.ownerDocument.body
          : gi(e) && Ii(e)
          ? e
          : Di(Ni(e));
      }
      function Ai(e, t) {
        var n;
        void 0 === t && (t = []);
        var r = Di(e),
          o = r === (null == (n = e.ownerDocument) ? void 0 : n.body),
          a = hi(r),
          i = o ? [a].concat(a.visualViewport || [], Ii(r) ? r : []) : r,
          s = t.concat(i);
        return o ? s : s.concat(Ai(Ni(i)));
      }
      function Ei(e) {
        return ["table", "td", "th"].indexOf(Pi(e)) >= 0;
      }
      function Ri(e) {
        return gi(e) && "fixed" !== Ti(e).position ? e.offsetParent : null;
      }
      function Li(e) {
        for (
          var t = hi(e), n = Ri(e);
          n && Ei(n) && "static" === Ti(n).position;

        )
          n = Ri(n);
        return n &&
          ("html" === Pi(n) ||
            ("body" === Pi(n) && "static" === Ti(n).position))
          ? t
          : n ||
              (function (e) {
                var t = /firefox/i.test(Ci());
                if (
                  /Trident/i.test(Ci()) &&
                  gi(e) &&
                  "fixed" === Ti(e).position
                )
                  return null;
                var n = Ni(e);
                for (
                  vi(n) && (n = n.host);
                  gi(n) && ["html", "body"].indexOf(Pi(n)) < 0;

                ) {
                  var r = Ti(n);
                  if (
                    "none" !== r.transform ||
                    "none" !== r.perspective ||
                    "paint" === r.contain ||
                    -1 !== ["transform", "perspective"].indexOf(r.willChange) ||
                    (t && "filter" === r.willChange) ||
                    (t && r.filter && "none" !== r.filter)
                  )
                    return n;
                  n = n.parentNode;
                }
                return null;
              })(e) ||
              t;
      }
      var Bi = "top",
        zi = "bottom",
        Fi = "right",
        Zi = "left",
        Hi = "auto",
        Vi = [Bi, zi, Fi, Zi],
        Wi = "start",
        Ui = "end",
        $i = "viewport",
        Ki = "popper",
        Gi = Vi.reduce(function (e, t) {
          return e.concat([t + "-" + Wi, t + "-" + Ui]);
        }, []),
        qi = [].concat(Vi, [Hi]).reduce(function (e, t) {
          return e.concat([t, t + "-" + Wi, t + "-" + Ui]);
        }, []),
        Qi = [
          "beforeRead",
          "read",
          "afterRead",
          "beforeMain",
          "main",
          "afterMain",
          "beforeWrite",
          "write",
          "afterWrite",
        ];
      function Yi(e) {
        var t = new Map(),
          n = new Set(),
          r = [];
        function o(e) {
          n.add(e.name),
            []
              .concat(e.requires || [], e.requiresIfExists || [])
              .forEach(function (e) {
                if (!n.has(e)) {
                  var r = t.get(e);
                  r && o(r);
                }
              }),
            r.push(e);
        }
        return (
          e.forEach(function (e) {
            t.set(e.name, e);
          }),
          e.forEach(function (e) {
            n.has(e.name) || o(e);
          }),
          r
        );
      }
      var Ji = { placement: "bottom", modifiers: [], strategy: "absolute" };
      function Xi() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return !t.some(function (e) {
          return !(e && "function" == typeof e.getBoundingClientRect);
        });
      }
      function es(e) {
        void 0 === e && (e = {});
        var t = e,
          n = t.defaultModifiers,
          r = void 0 === n ? [] : n,
          o = t.defaultOptions,
          a = void 0 === o ? Ji : o;
        return function (e, t, n) {
          void 0 === n && (n = a);
          var o,
            i,
            s = {
              placement: "bottom",
              orderedModifiers: [],
              options: Object.assign({}, Ji, a),
              modifiersData: {},
              elements: { reference: e, popper: t },
              attributes: {},
              styles: {},
            },
            l = [],
            d = !1,
            c = {
              state: s,
              setOptions: function (n) {
                var o = "function" == typeof n ? n(s.options) : n;
                u(),
                  (s.options = Object.assign({}, a, s.options, o)),
                  (s.scrollParents = {
                    reference: fi(e)
                      ? Ai(e)
                      : e.contextElement
                      ? Ai(e.contextElement)
                      : [],
                    popper: Ai(t),
                  });
                var i,
                  d,
                  p = (function (e) {
                    var t = Yi(e);
                    return Qi.reduce(function (e, n) {
                      return e.concat(
                        t.filter(function (e) {
                          return e.phase === n;
                        })
                      );
                    }, []);
                  })(
                    ((i = [].concat(r, s.options.modifiers)),
                    (d = i.reduce(function (e, t) {
                      var n = e[t.name];
                      return (
                        (e[t.name] = n
                          ? Object.assign({}, n, t, {
                              options: Object.assign({}, n.options, t.options),
                              data: Object.assign({}, n.data, t.data),
                            })
                          : t),
                        e
                      );
                    }, {})),
                    Object.keys(d).map(function (e) {
                      return d[e];
                    }))
                  );
                return (
                  (s.orderedModifiers = p.filter(function (e) {
                    return e.enabled;
                  })),
                  s.orderedModifiers.forEach(function (e) {
                    var t = e.name,
                      n = e.options,
                      r = void 0 === n ? {} : n,
                      o = e.effect;
                    if ("function" == typeof o) {
                      var a = o({ state: s, name: t, instance: c, options: r });
                      l.push(a || function () {});
                    }
                  }),
                  c.update()
                );
              },
              forceUpdate: function () {
                if (!d) {
                  var e = s.elements,
                    t = e.reference,
                    n = e.popper;
                  if (Xi(t, n)) {
                    (s.rects = {
                      reference: Mi(t, Li(n), "fixed" === s.options.strategy),
                      popper: ji(n),
                    }),
                      (s.reset = !1),
                      (s.placement = s.options.placement),
                      s.orderedModifiers.forEach(function (e) {
                        return (s.modifiersData[e.name] = Object.assign(
                          {},
                          e.data
                        ));
                      });
                    for (var r = 0; r < s.orderedModifiers.length; r++)
                      if (!0 !== s.reset) {
                        var o = s.orderedModifiers[r],
                          a = o.fn,
                          i = o.options,
                          l = void 0 === i ? {} : i,
                          u = o.name;
                        "function" == typeof a &&
                          (s =
                            a({ state: s, options: l, name: u, instance: c }) ||
                            s);
                      } else (s.reset = !1), (r = -1);
                  }
                }
              },
              update:
                ((o = function () {
                  return new Promise(function (e) {
                    c.forceUpdate(), e(s);
                  });
                }),
                function () {
                  return (
                    i ||
                      (i = new Promise(function (e) {
                        Promise.resolve().then(function () {
                          (i = void 0), e(o());
                        });
                      })),
                    i
                  );
                }),
              destroy: function () {
                u(), (d = !0);
              },
            };
          if (!Xi(e, t)) return c;
          function u() {
            l.forEach(function (e) {
              return e();
            }),
              (l = []);
          }
          return (
            c.setOptions(n).then(function (e) {
              !d && n.onFirstUpdate && n.onFirstUpdate(e);
            }),
            c
          );
        };
      }
      var ts = { passive: !0 },
        ns = {
          name: "eventListeners",
          enabled: !0,
          phase: "write",
          fn: function () {},
          effect: function (e) {
            var t = e.state,
              n = e.instance,
              r = e.options,
              o = r.scroll,
              a = void 0 === o || o,
              i = r.resize,
              s = void 0 === i || i,
              l = hi(t.elements.popper),
              d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
            return (
              a &&
                d.forEach(function (e) {
                  e.addEventListener("scroll", n.update, ts);
                }),
              s && l.addEventListener("resize", n.update, ts),
              function () {
                a &&
                  d.forEach(function (e) {
                    e.removeEventListener("scroll", n.update, ts);
                  }),
                  s && l.removeEventListener("resize", n.update, ts);
              }
            );
          },
          data: {},
        };
      function rs(e) {
        return e.split("-")[0];
      }
      function os(e) {
        return e.split("-")[1];
      }
      function as(e) {
        return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
      }
      function is(e) {
        var t,
          n = e.reference,
          r = e.element,
          o = e.placement,
          a = o ? rs(o) : null,
          i = o ? os(o) : null,
          s = n.x + n.width / 2 - r.width / 2,
          l = n.y + n.height / 2 - r.height / 2;
        switch (a) {
          case Bi:
            t = { x: s, y: n.y - r.height };
            break;
          case zi:
            t = { x: s, y: n.y + n.height };
            break;
          case Fi:
            t = { x: n.x + n.width, y: l };
            break;
          case Zi:
            t = { x: n.x - r.width, y: l };
            break;
          default:
            t = { x: n.x, y: n.y };
        }
        var d = a ? as(a) : null;
        if (null != d) {
          var c = "y" === d ? "height" : "width";
          switch (i) {
            case Wi:
              t[d] = t[d] - (n[c] / 2 - r[c] / 2);
              break;
            case Ui:
              t[d] = t[d] + (n[c] / 2 - r[c] / 2);
          }
        }
        return t;
      }
      var ss = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
      function ls(e) {
        var t,
          n = e.popper,
          r = e.popperRect,
          o = e.placement,
          a = e.variation,
          i = e.offsets,
          s = e.position,
          l = e.gpuAcceleration,
          d = e.adaptive,
          c = e.roundOffsets,
          u = e.isFixed,
          p = i.x,
          m = void 0 === p ? 0 : p,
          h = i.y,
          f = void 0 === h ? 0 : h,
          g = "function" == typeof c ? c({ x: m, y: f }) : { x: m, y: f };
        (m = g.x), (f = g.y);
        var v = i.hasOwnProperty("x"),
          b = i.hasOwnProperty("y"),
          _ = Zi,
          y = Bi,
          C = window;
        if (d) {
          var x = Li(n),
            S = "clientHeight",
            k = "clientWidth";
          x === hi(n) &&
            "static" !== Ti((x = wi(n))).position &&
            "absolute" === s &&
            ((S = "scrollHeight"), (k = "scrollWidth")),
            (o === Bi || ((o === Zi || o === Fi) && a === Ui)) &&
              ((y = zi),
              (f -=
                (u && x === C && C.visualViewport
                  ? C.visualViewport.height
                  : x[S]) - r.height),
              (f *= l ? 1 : -1)),
            (o !== Zi && ((o !== Bi && o !== zi) || a !== Ui)) ||
              ((_ = Fi),
              (m -=
                (u && x === C && C.visualViewport
                  ? C.visualViewport.width
                  : x[k]) - r.width),
              (m *= l ? 1 : -1));
        }
        var P,
          w = Object.assign({ position: s }, d && ss),
          O =
            !0 === c
              ? (function (e, t) {
                  var n = e.x,
                    r = e.y,
                    o = t.devicePixelRatio || 1;
                  return { x: yi(n * o) / o || 0, y: yi(r * o) / o || 0 };
                })({ x: m, y: f }, hi(n))
              : { x: m, y: f };
        return (
          (m = O.x),
          (f = O.y),
          l
            ? Object.assign(
                {},
                w,
                (((P = {})[y] = b ? "0" : ""),
                (P[_] = v ? "0" : ""),
                (P.transform =
                  (C.devicePixelRatio || 1) <= 1
                    ? "translate(" + m + "px, " + f + "px)"
                    : "translate3d(" + m + "px, " + f + "px, 0)"),
                P)
              )
            : Object.assign(
                {},
                w,
                (((t = {})[y] = b ? f + "px" : ""),
                (t[_] = v ? m + "px" : ""),
                (t.transform = ""),
                t)
              )
        );
      }
      var ds = {
          name: "applyStyles",
          enabled: !0,
          phase: "write",
          fn: function (e) {
            var t = e.state;
            Object.keys(t.elements).forEach(function (e) {
              var n = t.styles[e] || {},
                r = t.attributes[e] || {},
                o = t.elements[e];
              gi(o) &&
                Pi(o) &&
                (Object.assign(o.style, n),
                Object.keys(r).forEach(function (e) {
                  var t = r[e];
                  !1 === t
                    ? o.removeAttribute(e)
                    : o.setAttribute(e, !0 === t ? "" : t);
                }));
            });
          },
          effect: function (e) {
            var t = e.state,
              n = {
                popper: {
                  position: t.options.strategy,
                  left: "0",
                  top: "0",
                  margin: "0",
                },
                arrow: { position: "absolute" },
                reference: {},
              };
            return (
              Object.assign(t.elements.popper.style, n.popper),
              (t.styles = n),
              t.elements.arrow &&
                Object.assign(t.elements.arrow.style, n.arrow),
              function () {
                Object.keys(t.elements).forEach(function (e) {
                  var r = t.elements[e],
                    o = t.attributes[e] || {},
                    a = Object.keys(
                      t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]
                    ).reduce(function (e, t) {
                      return (e[t] = ""), e;
                    }, {});
                  gi(r) &&
                    Pi(r) &&
                    (Object.assign(r.style, a),
                    Object.keys(o).forEach(function (e) {
                      r.removeAttribute(e);
                    }));
                });
              }
            );
          },
          requires: ["computeStyles"],
        },
        cs = { left: "right", right: "left", bottom: "top", top: "bottom" };
      function us(e) {
        return e.replace(/left|right|bottom|top/g, function (e) {
          return cs[e];
        });
      }
      var ps = { start: "end", end: "start" };
      function ms(e) {
        return e.replace(/start|end/g, function (e) {
          return ps[e];
        });
      }
      function hs(e, t) {
        var n = t.getRootNode && t.getRootNode();
        if (e.contains(t)) return !0;
        if (n && vi(n)) {
          var r = t;
          do {
            if (r && e.isSameNode(r)) return !0;
            r = r.parentNode || r.host;
          } while (r);
        }
        return !1;
      }
      function fs(e) {
        return Object.assign({}, e, {
          left: e.x,
          top: e.y,
          right: e.x + e.width,
          bottom: e.y + e.height,
        });
      }
      function gs(e, t, n) {
        return t === $i
          ? fs(
              (function (e, t) {
                var n = hi(e),
                  r = wi(e),
                  o = n.visualViewport,
                  a = r.clientWidth,
                  i = r.clientHeight,
                  s = 0,
                  l = 0;
                if (o) {
                  (a = o.width), (i = o.height);
                  var d = xi();
                  (d || (!d && "fixed" === t)) &&
                    ((s = o.offsetLeft), (l = o.offsetTop));
                }
                return { width: a, height: i, x: s + Oi(e), y: l };
              })(e, n)
            )
          : fi(t)
          ? (function (e, t) {
              var n = Si(e, !1, "fixed" === t);
              return (
                (n.top = n.top + e.clientTop),
                (n.left = n.left + e.clientLeft),
                (n.bottom = n.top + e.clientHeight),
                (n.right = n.left + e.clientWidth),
                (n.width = e.clientWidth),
                (n.height = e.clientHeight),
                (n.x = n.left),
                (n.y = n.top),
                n
              );
            })(t, n)
          : fs(
              (function (e) {
                var t,
                  n = wi(e),
                  r = ki(e),
                  o = null == (t = e.ownerDocument) ? void 0 : t.body,
                  a = bi(
                    n.scrollWidth,
                    n.clientWidth,
                    o ? o.scrollWidth : 0,
                    o ? o.clientWidth : 0
                  ),
                  i = bi(
                    n.scrollHeight,
                    n.clientHeight,
                    o ? o.scrollHeight : 0,
                    o ? o.clientHeight : 0
                  ),
                  s = -r.scrollLeft + Oi(e),
                  l = -r.scrollTop;
                return (
                  "rtl" === Ti(o || n).direction &&
                    (s += bi(n.clientWidth, o ? o.clientWidth : 0) - a),
                  { width: a, height: i, x: s, y: l }
                );
              })(wi(e))
            );
      }
      function vs(e) {
        return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, e);
      }
      function bs(e, t) {
        return t.reduce(function (t, n) {
          return (t[n] = e), t;
        }, {});
      }
      function _s(e, t) {
        void 0 === t && (t = {});
        var n = t,
          r = n.placement,
          o = void 0 === r ? e.placement : r,
          a = n.strategy,
          i = void 0 === a ? e.strategy : a,
          s = n.boundary,
          l = void 0 === s ? "clippingParents" : s,
          d = n.rootBoundary,
          c = void 0 === d ? $i : d,
          u = n.elementContext,
          p = void 0 === u ? Ki : u,
          m = n.altBoundary,
          h = void 0 !== m && m,
          f = n.padding,
          g = void 0 === f ? 0 : f,
          v = vs("number" != typeof g ? g : bs(g, Vi)),
          b = p === Ki ? "reference" : Ki,
          _ = e.rects.popper,
          y = e.elements[h ? b : p],
          C = (function (e, t, n, r) {
            var o =
                "clippingParents" === t
                  ? (function (e) {
                      var t = Ai(Ni(e)),
                        n =
                          ["absolute", "fixed"].indexOf(Ti(e).position) >= 0 &&
                          gi(e)
                            ? Li(e)
                            : e;
                      return fi(n)
                        ? t.filter(function (e) {
                            return fi(e) && hs(e, n) && "body" !== Pi(e);
                          })
                        : [];
                    })(e)
                  : [].concat(t),
              a = [].concat(o, [n]),
              i = a[0],
              s = a.reduce(function (t, n) {
                var o = gs(e, n, r);
                return (
                  (t.top = bi(o.top, t.top)),
                  (t.right = _i(o.right, t.right)),
                  (t.bottom = _i(o.bottom, t.bottom)),
                  (t.left = bi(o.left, t.left)),
                  t
                );
              }, gs(e, i, r));
            return (
              (s.width = s.right - s.left),
              (s.height = s.bottom - s.top),
              (s.x = s.left),
              (s.y = s.top),
              s
            );
          })(fi(y) ? y : y.contextElement || wi(e.elements.popper), l, c, i),
          x = Si(e.elements.reference),
          S = is({
            reference: x,
            element: _,
            strategy: "absolute",
            placement: o,
          }),
          k = fs(Object.assign({}, _, S)),
          P = p === Ki ? k : x,
          w = {
            top: C.top - P.top + v.top,
            bottom: P.bottom - C.bottom + v.bottom,
            left: C.left - P.left + v.left,
            right: P.right - C.right + v.right,
          },
          O = e.modifiersData.offset;
        if (p === Ki && O) {
          var T = O[o];
          Object.keys(w).forEach(function (e) {
            var t = [Fi, zi].indexOf(e) >= 0 ? 1 : -1,
              n = [Bi, zi].indexOf(e) >= 0 ? "y" : "x";
            w[e] += T[n] * t;
          });
        }
        return w;
      }
      function ys(e, t, n) {
        return bi(e, _i(t, n));
      }
      function Cs(e, t, n) {
        return (
          void 0 === n && (n = { x: 0, y: 0 }),
          {
            top: e.top - t.height - n.y,
            right: e.right - t.width + n.x,
            bottom: e.bottom - t.height + n.y,
            left: e.left - t.width - n.x,
          }
        );
      }
      function xs(e) {
        return [Bi, Fi, zi, Zi].some(function (t) {
          return e[t] >= 0;
        });
      }
      var Ss = es({
        defaultModifiers: [
          ns,
          {
            name: "popperOffsets",
            enabled: !0,
            phase: "read",
            fn: function (e) {
              var t = e.state,
                n = e.name;
              t.modifiersData[n] = is({
                reference: t.rects.reference,
                element: t.rects.popper,
                strategy: "absolute",
                placement: t.placement,
              });
            },
            data: {},
          },
          {
            name: "computeStyles",
            enabled: !0,
            phase: "beforeWrite",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = n.gpuAcceleration,
                o = void 0 === r || r,
                a = n.adaptive,
                i = void 0 === a || a,
                s = n.roundOffsets,
                l = void 0 === s || s,
                d = {
                  placement: rs(t.placement),
                  variation: os(t.placement),
                  popper: t.elements.popper,
                  popperRect: t.rects.popper,
                  gpuAcceleration: o,
                  isFixed: "fixed" === t.options.strategy,
                };
              null != t.modifiersData.popperOffsets &&
                (t.styles.popper = Object.assign(
                  {},
                  t.styles.popper,
                  ls(
                    Object.assign({}, d, {
                      offsets: t.modifiersData.popperOffsets,
                      position: t.options.strategy,
                      adaptive: i,
                      roundOffsets: l,
                    })
                  )
                )),
                null != t.modifiersData.arrow &&
                  (t.styles.arrow = Object.assign(
                    {},
                    t.styles.arrow,
                    ls(
                      Object.assign({}, d, {
                        offsets: t.modifiersData.arrow,
                        position: "absolute",
                        adaptive: !1,
                        roundOffsets: l,
                      })
                    )
                  )),
                (t.attributes.popper = Object.assign({}, t.attributes.popper, {
                  "data-popper-placement": t.placement,
                }));
            },
            data: {},
          },
          ds,
          {
            name: "offset",
            enabled: !0,
            phase: "main",
            requires: ["popperOffsets"],
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name,
                o = n.offset,
                a = void 0 === o ? [0, 0] : o,
                i = qi.reduce(function (e, n) {
                  return (
                    (e[n] = (function (e, t, n) {
                      var r = rs(e),
                        o = [Zi, Bi].indexOf(r) >= 0 ? -1 : 1,
                        a =
                          "function" == typeof n
                            ? n(Object.assign({}, t, { placement: e }))
                            : n,
                        i = a[0],
                        s = a[1];
                      return (
                        (i = i || 0),
                        (s = (s || 0) * o),
                        [Zi, Fi].indexOf(r) >= 0
                          ? { x: s, y: i }
                          : { x: i, y: s }
                      );
                    })(n, t.rects, a)),
                    e
                  );
                }, {}),
                s = i[t.placement],
                l = s.x,
                d = s.y;
              null != t.modifiersData.popperOffsets &&
                ((t.modifiersData.popperOffsets.x += l),
                (t.modifiersData.popperOffsets.y += d)),
                (t.modifiersData[r] = i);
            },
          },
          {
            name: "flip",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name;
              if (!t.modifiersData[r]._skip) {
                for (
                  var o = n.mainAxis,
                    a = void 0 === o || o,
                    i = n.altAxis,
                    s = void 0 === i || i,
                    l = n.fallbackPlacements,
                    d = n.padding,
                    c = n.boundary,
                    u = n.rootBoundary,
                    p = n.altBoundary,
                    m = n.flipVariations,
                    h = void 0 === m || m,
                    f = n.allowedAutoPlacements,
                    g = t.options.placement,
                    v = rs(g),
                    b =
                      l ||
                      (v !== g && h
                        ? (function (e) {
                            if (rs(e) === Hi) return [];
                            var t = us(e);
                            return [ms(e), t, ms(t)];
                          })(g)
                        : [us(g)]),
                    _ = [g].concat(b).reduce(function (e, n) {
                      return e.concat(
                        rs(n) === Hi
                          ? (function (e, t) {
                              void 0 === t && (t = {});
                              var n = t,
                                r = n.placement,
                                o = n.boundary,
                                a = n.rootBoundary,
                                i = n.padding,
                                s = n.flipVariations,
                                l = n.allowedAutoPlacements,
                                d = void 0 === l ? qi : l,
                                c = os(r),
                                u = c
                                  ? s
                                    ? Gi
                                    : Gi.filter(function (e) {
                                        return os(e) === c;
                                      })
                                  : Vi,
                                p = u.filter(function (e) {
                                  return d.indexOf(e) >= 0;
                                });
                              0 === p.length && (p = u);
                              var m = p.reduce(function (t, n) {
                                return (
                                  (t[n] = _s(e, {
                                    placement: n,
                                    boundary: o,
                                    rootBoundary: a,
                                    padding: i,
                                  })[rs(n)]),
                                  t
                                );
                              }, {});
                              return Object.keys(m).sort(function (e, t) {
                                return m[e] - m[t];
                              });
                            })(t, {
                              placement: n,
                              boundary: c,
                              rootBoundary: u,
                              padding: d,
                              flipVariations: h,
                              allowedAutoPlacements: f,
                            })
                          : n
                      );
                    }, []),
                    y = t.rects.reference,
                    C = t.rects.popper,
                    x = new Map(),
                    S = !0,
                    k = _[0],
                    P = 0;
                  P < _.length;
                  P++
                ) {
                  var w = _[P],
                    O = rs(w),
                    T = os(w) === Wi,
                    I = [Bi, zi].indexOf(O) >= 0,
                    M = I ? "width" : "height",
                    j = _s(t, {
                      placement: w,
                      boundary: c,
                      rootBoundary: u,
                      altBoundary: p,
                      padding: d,
                    }),
                    N = I ? (T ? Fi : Zi) : T ? zi : Bi;
                  y[M] > C[M] && (N = us(N));
                  var D = us(N),
                    A = [];
                  if (
                    (a && A.push(j[O] <= 0),
                    s && A.push(j[N] <= 0, j[D] <= 0),
                    A.every(function (e) {
                      return e;
                    }))
                  ) {
                    (k = w), (S = !1);
                    break;
                  }
                  x.set(w, A);
                }
                if (S)
                  for (
                    var E = function (e) {
                        var t = _.find(function (t) {
                          var n = x.get(t);
                          if (n)
                            return n.slice(0, e).every(function (e) {
                              return e;
                            });
                        });
                        if (t) return (k = t), "break";
                      },
                      R = h ? 3 : 1;
                    R > 0 && "break" !== E(R);
                    R--
                  );
                t.placement !== k &&
                  ((t.modifiersData[r]._skip = !0),
                  (t.placement = k),
                  (t.reset = !0));
              }
            },
            requiresIfExists: ["offset"],
            data: { _skip: !1 },
          },
          {
            name: "preventOverflow",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t = e.state,
                n = e.options,
                r = e.name,
                o = n.mainAxis,
                a = void 0 === o || o,
                i = n.altAxis,
                s = void 0 !== i && i,
                l = n.boundary,
                d = n.rootBoundary,
                c = n.altBoundary,
                u = n.padding,
                p = n.tether,
                m = void 0 === p || p,
                h = n.tetherOffset,
                f = void 0 === h ? 0 : h,
                g = _s(t, {
                  boundary: l,
                  rootBoundary: d,
                  padding: u,
                  altBoundary: c,
                }),
                v = rs(t.placement),
                b = os(t.placement),
                _ = !b,
                y = as(v),
                C = "x" === y ? "y" : "x",
                x = t.modifiersData.popperOffsets,
                S = t.rects.reference,
                k = t.rects.popper,
                P =
                  "function" == typeof f
                    ? f(Object.assign({}, t.rects, { placement: t.placement }))
                    : f,
                w =
                  "number" == typeof P
                    ? { mainAxis: P, altAxis: P }
                    : Object.assign({ mainAxis: 0, altAxis: 0 }, P),
                O = t.modifiersData.offset
                  ? t.modifiersData.offset[t.placement]
                  : null,
                T = { x: 0, y: 0 };
              if (x) {
                if (a) {
                  var I,
                    M = "y" === y ? Bi : Zi,
                    j = "y" === y ? zi : Fi,
                    N = "y" === y ? "height" : "width",
                    D = x[y],
                    A = D + g[M],
                    E = D - g[j],
                    R = m ? -k[N] / 2 : 0,
                    L = b === Wi ? S[N] : k[N],
                    B = b === Wi ? -k[N] : -S[N],
                    z = t.elements.arrow,
                    F = m && z ? ji(z) : { width: 0, height: 0 },
                    Z = t.modifiersData["arrow#persistent"]
                      ? t.modifiersData["arrow#persistent"].padding
                      : { top: 0, right: 0, bottom: 0, left: 0 },
                    H = Z[M],
                    V = Z[j],
                    W = ys(0, S[N], F[N]),
                    U = _
                      ? S[N] / 2 - R - W - H - w.mainAxis
                      : L - W - H - w.mainAxis,
                    $ = _
                      ? -S[N] / 2 + R + W + V + w.mainAxis
                      : B + W + V + w.mainAxis,
                    K = t.elements.arrow && Li(t.elements.arrow),
                    G = K
                      ? "y" === y
                        ? K.clientTop || 0
                        : K.clientLeft || 0
                      : 0,
                    q = null != (I = null == O ? void 0 : O[y]) ? I : 0,
                    Q = D + $ - q,
                    Y = ys(m ? _i(A, D + U - q - G) : A, D, m ? bi(E, Q) : E);
                  (x[y] = Y), (T[y] = Y - D);
                }
                if (s) {
                  var J,
                    X = "x" === y ? Bi : Zi,
                    ee = "x" === y ? zi : Fi,
                    te = x[C],
                    ne = "y" === C ? "height" : "width",
                    re = te + g[X],
                    oe = te - g[ee],
                    ae = -1 !== [Bi, Zi].indexOf(v),
                    ie = null != (J = null == O ? void 0 : O[C]) ? J : 0,
                    se = ae ? re : te - S[ne] - k[ne] - ie + w.altAxis,
                    le = ae ? te + S[ne] + k[ne] - ie - w.altAxis : oe,
                    de =
                      m && ae
                        ? (function (e, t, n) {
                            var r = ys(e, t, n);
                            return r > n ? n : r;
                          })(se, te, le)
                        : ys(m ? se : re, te, m ? le : oe);
                  (x[C] = de), (T[C] = de - te);
                }
                t.modifiersData[r] = T;
              }
            },
            requiresIfExists: ["offset"],
          },
          {
            name: "arrow",
            enabled: !0,
            phase: "main",
            fn: function (e) {
              var t,
                n = e.state,
                r = e.name,
                o = e.options,
                a = n.elements.arrow,
                i = n.modifiersData.popperOffsets,
                s = rs(n.placement),
                l = as(s),
                d = [Zi, Fi].indexOf(s) >= 0 ? "height" : "width";
              if (a && i) {
                var c = (function (e, t) {
                    return vs(
                      "number" !=
                        typeof (e =
                          "function" == typeof e
                            ? e(
                                Object.assign({}, t.rects, {
                                  placement: t.placement,
                                })
                              )
                            : e)
                        ? e
                        : bs(e, Vi)
                    );
                  })(o.padding, n),
                  u = ji(a),
                  p = "y" === l ? Bi : Zi,
                  m = "y" === l ? zi : Fi,
                  h =
                    n.rects.reference[d] +
                    n.rects.reference[l] -
                    i[l] -
                    n.rects.popper[d],
                  f = i[l] - n.rects.reference[l],
                  g = Li(a),
                  v = g
                    ? "y" === l
                      ? g.clientHeight || 0
                      : g.clientWidth || 0
                    : 0,
                  b = h / 2 - f / 2,
                  _ = c[p],
                  y = v - u[d] - c[m],
                  C = v / 2 - u[d] / 2 + b,
                  x = ys(_, C, y),
                  S = l;
                n.modifiersData[r] =
                  (((t = {})[S] = x), (t.centerOffset = x - C), t);
              }
            },
            effect: function (e) {
              var t = e.state,
                n = e.options.element,
                r = void 0 === n ? "[data-popper-arrow]" : n;
              null != r &&
                ("string" != typeof r ||
                  (r = t.elements.popper.querySelector(r))) &&
                hs(t.elements.popper, r) &&
                (t.elements.arrow = r);
            },
            requires: ["popperOffsets"],
            requiresIfExists: ["preventOverflow"],
          },
          {
            name: "hide",
            enabled: !0,
            phase: "main",
            requiresIfExists: ["preventOverflow"],
            fn: function (e) {
              var t = e.state,
                n = e.name,
                r = t.rects.reference,
                o = t.rects.popper,
                a = t.modifiersData.preventOverflow,
                i = _s(t, { elementContext: "reference" }),
                s = _s(t, { altBoundary: !0 }),
                l = Cs(i, r),
                d = Cs(s, o, a),
                c = xs(l),
                u = xs(d);
              (t.modifiersData[n] = {
                referenceClippingOffsets: l,
                popperEscapeOffsets: d,
                isReferenceHidden: c,
                hasPopperEscaped: u,
              }),
                (t.attributes.popper = Object.assign({}, t.attributes.popper, {
                  "data-popper-reference-hidden": c,
                  "data-popper-escaped": u,
                }));
            },
          },
        ],
      });
      function ks(e) {
        return (0, Zt.ZP)("MuiPopper", e);
      }
      (0, Ft.Z)("MuiPopper", ["root"]);
      const Ps = [
          "anchorEl",
          "children",
          "direction",
          "disablePortal",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "slotProps",
          "slots",
          "TransitionProps",
          "ownerState",
        ],
        ws = [
          "anchorEl",
          "children",
          "container",
          "direction",
          "disablePortal",
          "keepMounted",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "style",
          "transition",
          "slotProps",
          "slots",
        ];
      function Os(e) {
        return "function" == typeof e ? e() : e;
      }
      const Ts = {},
        Is = t.forwardRef(function (n, r) {
          var o;
          const {
              anchorEl: a,
              children: i,
              direction: s,
              disablePortal: l,
              modifiers: d,
              open: c,
              placement: p,
              popperOptions: m,
              popperRef: h,
              slotProps: f = {},
              slots: g = {},
              TransitionProps: v,
            } = n,
            b = (0, At.Z)(n, Ps),
            _ = t.useRef(null),
            y = (0, rr.Z)(_, r),
            C = t.useRef(null),
            x = (0, rr.Z)(C, h),
            S = t.useRef(x);
          (0, yr.Z)(() => {
            S.current = x;
          }, [x]),
            t.useImperativeHandle(h, () => C.current, []);
          const k = (function (e, t) {
              if ("ltr" === t) return e;
              switch (e) {
                case "bottom-end":
                  return "bottom-start";
                case "bottom-start":
                  return "bottom-end";
                case "top-end":
                  return "top-start";
                case "top-start":
                  return "top-end";
                default:
                  return e;
              }
            })(p, s),
            [P, w] = t.useState(k),
            [O, T] = t.useState(Os(a));
          t.useEffect(() => {
            C.current && C.current.forceUpdate();
          }),
            t.useEffect(() => {
              a && T(Os(a));
            }, [a]),
            (0, yr.Z)(() => {
              if (!O || !c) return;
              let e = [
                { name: "preventOverflow", options: { altBoundary: l } },
                { name: "flip", options: { altBoundary: l } },
                {
                  name: "onUpdate",
                  enabled: !0,
                  phase: "afterWrite",
                  fn: ({ state: e }) => {
                    w(e.placement);
                  },
                },
              ];
              null != d && (e = e.concat(d)),
                m && null != m.modifiers && (e = e.concat(m.modifiers));
              const t = Ss(
                O,
                _.current,
                (0, u.Z)({ placement: k }, m, { modifiers: e })
              );
              return (
                S.current(t),
                () => {
                  t.destroy(), S.current(null);
                }
              );
            }, [O, l, d, c, m, k]);
          const I = { placement: P };
          null !== v && (I.TransitionProps = v);
          const M = ((e) => {
              const { classes: t } = e;
              return (0, Rt.Z)({ root: ["root"] }, ks, t);
            })(n),
            j = null != (o = g.root) ? o : "div",
            N = mr({
              elementType: j,
              externalSlotProps: f.root,
              externalForwardedProps: b,
              additionalProps: { role: "tooltip", ref: y },
              ownerState: n,
              className: M.root,
            });
          return (0,
          e.jsx)(j, (0, u.Z)({}, N, { children: "function" == typeof i ? i(I) : i }));
        }),
        Ms = t.forwardRef(function (n, r) {
          const {
              anchorEl: o,
              children: a,
              container: i,
              direction: s = "ltr",
              disablePortal: l = !1,
              keepMounted: d = !1,
              modifiers: c,
              open: p,
              placement: m = "bottom",
              popperOptions: h = Ts,
              popperRef: f,
              style: g,
              transition: v = !1,
              slotProps: b = {},
              slots: _ = {},
            } = n,
            y = (0, At.Z)(n, ws),
            [C, x] = t.useState(!0);
          if (!d && !p && (!v || C)) return null;
          let S;
          if (i) S = i;
          else if (o) {
            const e = Os(o);
            S =
              e && void 0 !== e.nodeType
                ? (0, fr.Z)(e).body
                : (0, fr.Z)(null).body;
          }
          const k = p || !d || (v && !C) ? void 0 : "none",
            P = v
              ? {
                  in: p,
                  onEnter: () => {
                    x(!1);
                  },
                  onExited: () => {
                    x(!0);
                  },
                }
              : void 0;
          return (0,
          e.jsx)(Sr, { disablePortal: l, container: S, children: (0, e.jsx)(Is, (0, u.Z)({ anchorEl: o, direction: s, disablePortal: l, modifiers: c, ref: r, open: v ? !C : p, placement: m, popperOptions: h, popperRef: f, slotProps: b, slots: _ }, y, { style: (0, u.Z)({ position: "fixed", top: 0, left: 0, display: k }, g), TransitionProps: P, children: a })) });
        });
      var js = Ms;
      const Ns = [
          "anchorEl",
          "component",
          "components",
          "componentsProps",
          "container",
          "disablePortal",
          "keepMounted",
          "modifiers",
          "open",
          "placement",
          "popperOptions",
          "popperRef",
          "transition",
          "slots",
          "slotProps",
        ],
        Ds = (0, Bt.ZP)(js, {
          name: "MuiPopper",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        As = t.forwardRef(function (t, n) {
          var r;
          const o = (0, mi.Z)(),
            a = (0, zt.i)({ props: t, name: "MuiPopper" }),
            {
              anchorEl: i,
              component: s,
              components: l,
              componentsProps: d,
              container: c,
              disablePortal: p,
              keepMounted: m,
              modifiers: h,
              open: f,
              placement: g,
              popperOptions: v,
              popperRef: b,
              transition: _,
              slots: y,
              slotProps: C,
            } = a,
            x = (0, At.Z)(a, Ns),
            S =
              null != (r = null == y ? void 0 : y.root)
                ? r
                : null == l
                ? void 0
                : l.Root,
            k = (0, u.Z)(
              {
                anchorEl: i,
                container: c,
                disablePortal: p,
                keepMounted: m,
                modifiers: h,
                open: f,
                placement: g,
                popperOptions: v,
                popperRef: b,
                transition: _,
              },
              x
            );
          return (0,
          e.jsx)(Ds, (0, u.Z)({ as: s, direction: null == o ? void 0 : o.direction, slots: { root: S }, slotProps: null != C ? C : d }, k, { ref: n }));
        });
      var Es = As,
        Rs = o(7909),
        Ls = o(9299);
      function Bs(e) {
        return (0, Zt.ZP)("MuiTooltip", e);
      }
      var zs = (0, Ft.Z)("MuiTooltip", [
        "popper",
        "popperInteractive",
        "popperArrow",
        "popperClose",
        "tooltip",
        "tooltipArrow",
        "touch",
        "tooltipPlacementLeft",
        "tooltipPlacementRight",
        "tooltipPlacementTop",
        "tooltipPlacementBottom",
        "arrow",
      ]);
      const Fs = [
          "arrow",
          "children",
          "classes",
          "components",
          "componentsProps",
          "describeChild",
          "disableFocusListener",
          "disableHoverListener",
          "disableInteractive",
          "disableTouchListener",
          "enterDelay",
          "enterNextDelay",
          "enterTouchDelay",
          "followCursor",
          "id",
          "leaveDelay",
          "leaveTouchDelay",
          "onClose",
          "onOpen",
          "open",
          "placement",
          "PopperComponent",
          "PopperProps",
          "slotProps",
          "slots",
          "title",
          "TransitionComponent",
          "TransitionProps",
        ],
        Zs = (0, Bt.ZP)(Es, {
          name: "MuiTooltip",
          slot: "Popper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.popper,
              !n.disableInteractive && t.popperInteractive,
              n.arrow && t.popperArrow,
              !n.open && t.popperClose,
            ];
          },
        })(({ theme: e, ownerState: t, open: n }) =>
          (0, u.Z)(
            { zIndex: (e.vars || e).zIndex.tooltip, pointerEvents: "none" },
            !t.disableInteractive && { pointerEvents: "auto" },
            !n && { pointerEvents: "none" },
            t.arrow && {
              [`&[data-popper-placement*="bottom"] .${zs.arrow}`]: {
                top: 0,
                marginTop: "-0.71em",
                "&::before": { transformOrigin: "0 100%" },
              },
              [`&[data-popper-placement*="top"] .${zs.arrow}`]: {
                bottom: 0,
                marginBottom: "-0.71em",
                "&::before": { transformOrigin: "100% 0" },
              },
              [`&[data-popper-placement*="right"] .${zs.arrow}`]: (0, u.Z)(
                {},
                t.isRtl
                  ? { right: 0, marginRight: "-0.71em" }
                  : { left: 0, marginLeft: "-0.71em" },
                {
                  height: "1em",
                  width: "0.71em",
                  "&::before": { transformOrigin: "100% 100%" },
                }
              ),
              [`&[data-popper-placement*="left"] .${zs.arrow}`]: (0, u.Z)(
                {},
                t.isRtl
                  ? { left: 0, marginLeft: "-0.71em" }
                  : { right: 0, marginRight: "-0.71em" },
                {
                  height: "1em",
                  width: "0.71em",
                  "&::before": { transformOrigin: "0 0" },
                }
              ),
            }
          )
        ),
        Hs = (0, Bt.ZP)("div", {
          name: "MuiTooltip",
          slot: "Tooltip",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.tooltip,
              n.touch && t.touch,
              n.arrow && t.tooltipArrow,
              t[`tooltipPlacement${(0, $n.Z)(n.placement.split("-")[0])}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              backgroundColor: e.vars
                ? e.vars.palette.Tooltip.bg
                : (0, Lt.Fq)(e.palette.grey[700], 0.92),
              borderRadius: (e.vars || e).shape.borderRadius,
              color: (e.vars || e).palette.common.white,
              fontFamily: e.typography.fontFamily,
              padding: "4px 8px",
              fontSize: e.typography.pxToRem(11),
              maxWidth: 300,
              margin: 2,
              wordWrap: "break-word",
              fontWeight: e.typography.fontWeightMedium,
            },
            t.arrow && { position: "relative", margin: 0 },
            t.touch && {
              padding: "8px 16px",
              fontSize: e.typography.pxToRem(14),
              lineHeight:
                (16 / 14, Math.round(114285.71428571428) / 1e5 + "em"),
              fontWeight: e.typography.fontWeightRegular,
            },
            {
              [`.${zs.popper}[data-popper-placement*="left"] &`]: (0, u.Z)(
                { transformOrigin: "right center" },
                t.isRtl
                  ? (0, u.Z)(
                      { marginLeft: "14px" },
                      t.touch && { marginLeft: "24px" }
                    )
                  : (0, u.Z)(
                      { marginRight: "14px" },
                      t.touch && { marginRight: "24px" }
                    )
              ),
              [`.${zs.popper}[data-popper-placement*="right"] &`]: (0, u.Z)(
                { transformOrigin: "left center" },
                t.isRtl
                  ? (0, u.Z)(
                      { marginRight: "14px" },
                      t.touch && { marginRight: "24px" }
                    )
                  : (0, u.Z)(
                      { marginLeft: "14px" },
                      t.touch && { marginLeft: "24px" }
                    )
              ),
              [`.${zs.popper}[data-popper-placement*="top"] &`]: (0, u.Z)(
                { transformOrigin: "center bottom", marginBottom: "14px" },
                t.touch && { marginBottom: "24px" }
              ),
              [`.${zs.popper}[data-popper-placement*="bottom"] &`]: (0, u.Z)(
                { transformOrigin: "center top", marginTop: "14px" },
                t.touch && { marginTop: "24px" }
              ),
            }
          )
        ),
        Vs = (0, Bt.ZP)("span", {
          name: "MuiTooltip",
          slot: "Arrow",
          overridesResolver: (e, t) => t.arrow,
        })(({ theme: e }) => ({
          overflow: "hidden",
          position: "absolute",
          width: "1em",
          height: "0.71em",
          boxSizing: "border-box",
          color: e.vars
            ? e.vars.palette.Tooltip.bg
            : (0, Lt.Fq)(e.palette.grey[700], 0.9),
          "&::before": {
            content: '""',
            margin: "auto",
            display: "block",
            width: "100%",
            height: "100%",
            backgroundColor: "currentColor",
            transform: "rotate(45deg)",
          },
        }));
      let Ws = !1;
      const Us = new wn.V();
      let $s = { x: 0, y: 0 };
      function Ks(e, t) {
        return (n, ...r) => {
          t && t(n, ...r), e(n, ...r);
        };
      }
      var Gs = t.forwardRef(function (n, r) {
        var o, a, i, s, l, d, c, p, m, h, f, g, v, b, _, y, C, x, S;
        const k = (0, zt.i)({ props: n, name: "MuiTooltip" }),
          {
            arrow: P = !1,
            children: w,
            components: O = {},
            componentsProps: T = {},
            describeChild: I = !1,
            disableFocusListener: M = !1,
            disableHoverListener: j = !1,
            disableInteractive: N = !1,
            disableTouchListener: D = !1,
            enterDelay: A = 100,
            enterNextDelay: E = 0,
            enterTouchDelay: R = 700,
            followCursor: L = !1,
            id: B,
            leaveDelay: z = 0,
            leaveTouchDelay: F = 1500,
            onClose: Z,
            onOpen: H,
            open: V,
            placement: W = "bottom",
            PopperComponent: U,
            PopperProps: $ = {},
            slotProps: K = {},
            slots: G = {},
            title: q,
            TransitionComponent: Q = pi,
            TransitionProps: Y,
          } = k,
          J = (0, At.Z)(k, Fs),
          X = t.isValidElement(w) ? w : (0, e.jsx)("span", { children: w }),
          ee = Dr(),
          te = tr(),
          [ne, re] = t.useState(),
          [oe, ae] = t.useState(null),
          ie = t.useRef(!1),
          se = N || L,
          le = (0, wn.Z)(),
          de = (0, wn.Z)(),
          ce = (0, wn.Z)(),
          ue = (0, wn.Z)(),
          [pe, me] = (0, Ls.Z)({
            controlled: V,
            default: !1,
            name: "Tooltip",
            state: "open",
          });
        let he = pe;
        const fe = (0, Rs.Z)(B),
          ge = t.useRef(),
          ve = (0, fn.Z)(() => {
            void 0 !== ge.current &&
              ((document.body.style.WebkitUserSelect = ge.current),
              (ge.current = void 0)),
              ue.clear();
          });
        t.useEffect(() => ve, [ve]);
        const be = (e) => {
            Us.clear(), (Ws = !0), me(!0), H && !he && H(e);
          },
          _e = (0, fn.Z)((e) => {
            Us.start(800 + z, () => {
              Ws = !1;
            }),
              me(!1),
              Z && he && Z(e),
              le.start(ee.transitions.duration.shortest, () => {
                ie.current = !1;
              });
          }),
          ye = (e) => {
            (ie.current && "touchstart" !== e.type) ||
              (ne && ne.removeAttribute("title"),
              de.clear(),
              ce.clear(),
              A || (Ws && E)
                ? de.start(Ws ? E : A, () => {
                    be(e);
                  })
                : be(e));
          },
          Ce = (e) => {
            de.clear(),
              ce.start(z, () => {
                _e(e);
              });
          },
          {
            isFocusVisibleRef: xe,
            onBlur: Se,
            onFocus: ke,
            ref: Pe,
          } = (0, gn.Z)(),
          [, we] = t.useState(!1),
          Oe = (e) => {
            Se(e), !1 === xe.current && (we(!1), Ce(e));
          },
          Te = (e) => {
            ne || re(e.currentTarget),
              ke(e),
              !0 === xe.current && (we(!0), ye(e));
          },
          Ie = (e) => {
            ie.current = !0;
            const t = X.props;
            t.onTouchStart && t.onTouchStart(e);
          };
        t.useEffect(() => {
          if (he)
            return (
              document.addEventListener("keydown", e),
              () => {
                document.removeEventListener("keydown", e);
              }
            );
          function e(e) {
            ("Escape" !== e.key && "Esc" !== e.key) || _e(e);
          }
        }, [_e, he]);
        const Me = (0, hn.Z)(hr(X), Pe, re, r);
        q || 0 === q || (he = !1);
        const je = t.useRef(),
          Ne = {},
          De = "string" == typeof q;
        I
          ? ((Ne.title = he || !De || j ? null : q),
            (Ne["aria-describedby"] = he ? fe : null))
          : ((Ne["aria-label"] = De ? q : null),
            (Ne["aria-labelledby"] = he && !De ? fe : null));
        const Ae = (0, u.Z)(
            {},
            Ne,
            J,
            X.props,
            {
              className: (0, Et.Z)(J.className, X.props.className),
              onTouchStart: Ie,
              ref: Me,
            },
            L
              ? {
                  onMouseMove: (e) => {
                    const t = X.props;
                    t.onMouseMove && t.onMouseMove(e),
                      ($s = { x: e.clientX, y: e.clientY }),
                      je.current && je.current.update();
                  },
                }
              : {}
          ),
          Ee = {};
        D ||
          ((Ae.onTouchStart = (e) => {
            Ie(e),
              ce.clear(),
              le.clear(),
              ve(),
              (ge.current = document.body.style.WebkitUserSelect),
              (document.body.style.WebkitUserSelect = "none"),
              ue.start(R, () => {
                (document.body.style.WebkitUserSelect = ge.current), ye(e);
              });
          }),
          (Ae.onTouchEnd = (e) => {
            X.props.onTouchEnd && X.props.onTouchEnd(e),
              ve(),
              ce.start(F, () => {
                _e(e);
              });
          })),
          j ||
            ((Ae.onMouseOver = Ks(ye, Ae.onMouseOver)),
            (Ae.onMouseLeave = Ks(Ce, Ae.onMouseLeave)),
            se || ((Ee.onMouseOver = ye), (Ee.onMouseLeave = Ce))),
          M ||
            ((Ae.onFocus = Ks(Te, Ae.onFocus)),
            (Ae.onBlur = Ks(Oe, Ae.onBlur)),
            se || ((Ee.onFocus = Te), (Ee.onBlur = Oe)));
        const Re = t.useMemo(() => {
            var e;
            let t = [
              {
                name: "arrow",
                enabled: Boolean(oe),
                options: { element: oe, padding: 4 },
              },
            ];
            return (
              null != (e = $.popperOptions) &&
                e.modifiers &&
                (t = t.concat($.popperOptions.modifiers)),
              (0, u.Z)({}, $.popperOptions, { modifiers: t })
            );
          }, [oe, $]),
          Le = (0, u.Z)({}, k, {
            isRtl: te,
            arrow: P,
            disableInteractive: se,
            placement: W,
            PopperComponentProp: U,
            touch: ie.current,
          }),
          Be = ((e) => {
            const {
                classes: t,
                disableInteractive: n,
                arrow: r,
                touch: o,
                placement: a,
              } = e,
              i = {
                popper: [
                  "popper",
                  !n && "popperInteractive",
                  r && "popperArrow",
                ],
                tooltip: [
                  "tooltip",
                  r && "tooltipArrow",
                  o && "touch",
                  `tooltipPlacement${(0, $n.Z)(a.split("-")[0])}`,
                ],
                arrow: ["arrow"],
              };
            return (0, Rt.Z)(i, Bs, t);
          })(Le),
          ze = null != (o = null != (a = G.popper) ? a : O.Popper) ? o : Zs,
          Fe =
            null !=
            (i =
              null != (s = null != (l = G.transition) ? l : O.Transition)
                ? s
                : Q)
              ? i
              : pi,
          Ze = null != (d = null != (c = G.tooltip) ? c : O.Tooltip) ? d : Hs,
          He = null != (p = null != (m = G.arrow) ? m : O.Arrow) ? p : Vs,
          Ve = ar(
            ze,
            (0, u.Z)({}, $, null != (h = K.popper) ? h : T.popper, {
              className: (0, Et.Z)(
                Be.popper,
                null == $ ? void 0 : $.className,
                null == (f = null != (g = K.popper) ? g : T.popper)
                  ? void 0
                  : f.className
              ),
            }),
            Le
          ),
          We = ar(
            Fe,
            (0, u.Z)({}, Y, null != (v = K.transition) ? v : T.transition),
            Le
          ),
          Ue = ar(
            Ze,
            (0, u.Z)({}, null != (b = K.tooltip) ? b : T.tooltip, {
              className: (0, Et.Z)(
                Be.tooltip,
                null == (_ = null != (y = K.tooltip) ? y : T.tooltip)
                  ? void 0
                  : _.className
              ),
            }),
            Le
          ),
          $e = ar(
            He,
            (0, u.Z)({}, null != (C = K.arrow) ? C : T.arrow, {
              className: (0, Et.Z)(
                Be.arrow,
                null == (x = null != (S = K.arrow) ? S : T.arrow)
                  ? void 0
                  : x.className
              ),
            }),
            Le
          );
        return (0,
        e.jsxs)(t.Fragment, { children: [t.cloneElement(X, Ae), (0, e.jsx)(ze, (0, u.Z)({ as: null != U ? U : Es, placement: W, anchorEl: L ? { getBoundingClientRect: () => ({ top: $s.y, left: $s.x, right: $s.x, bottom: $s.y, width: 0, height: 0 }) } : ne, popperRef: je, open: !!ne && he, id: fe, transition: !0 }, Ee, Ve, { popperOptions: Re, children: ({ TransitionProps: t }) => (0, e.jsx)(Fe, (0, u.Z)({ timeout: ee.transitions.duration.shorter }, t, We, { children: (0, e.jsxs)(Ze, (0, u.Z)({}, Ue, { children: [q, P ? (0, e.jsx)(He, (0, u.Z)({}, $e, { ref: ae })) : null] })) })) }))] });
      });
      function qs(e) {
        return (0, Zt.ZP)("MuiLink", e);
      }
      var Qs = (0, Ft.Z)("MuiLink", [
          "root",
          "underlineNone",
          "underlineHover",
          "underlineAlways",
          "button",
          "focusVisible",
        ]),
        Ys = o(4844);
      const Js = {
        primary: "primary.main",
        textPrimary: "text.primary",
        secondary: "secondary.main",
        textSecondary: "text.secondary",
        error: "error.main",
      };
      var Xs = ({ theme: e, ownerState: t }) => {
        const n = ((e) => Js[e] || e)(t.color),
          r = (0, Ys.DW)(e, `palette.${n}`, !1) || t.color,
          o = (0, Ys.DW)(e, `palette.${n}Channel`);
        return "vars" in e && o ? `rgba(${o} / 0.4)` : (0, Lt.Fq)(r, 0.4);
      };
      const el = [
          "className",
          "color",
          "component",
          "onBlur",
          "onFocus",
          "TypographyClasses",
          "underline",
          "variant",
          "sx",
        ],
        tl = (0, Bt.ZP)(ni, {
          name: "MuiLink",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`underline${(0, $n.Z)(n.underline)}`],
              "button" === n.component && t.button,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {},
            "none" === t.underline && { textDecoration: "none" },
            "hover" === t.underline && {
              textDecoration: "none",
              "&:hover": { textDecoration: "underline" },
            },
            "always" === t.underline &&
              (0, u.Z)(
                { textDecoration: "underline" },
                "inherit" !== t.color && {
                  textDecorationColor: Xs({ theme: e, ownerState: t }),
                },
                { "&:hover": { textDecorationColor: "inherit" } }
              ),
            "button" === t.component && {
              position: "relative",
              WebkitTapHighlightColor: "transparent",
              backgroundColor: "transparent",
              outline: 0,
              border: 0,
              margin: 0,
              borderRadius: 0,
              padding: 0,
              cursor: "pointer",
              userSelect: "none",
              verticalAlign: "middle",
              MozAppearance: "none",
              WebkitAppearance: "none",
              "&::-moz-focus-inner": { borderStyle: "none" },
              [`&.${Qs.focusVisible}`]: { outline: "auto" },
            }
          )
        ),
        nl = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiLink" }),
            {
              className: a,
              color: i = "primary",
              component: s = "a",
              onBlur: l,
              onFocus: d,
              TypographyClasses: c,
              underline: p = "always",
              variant: m = "inherit",
              sx: h,
            } = o,
            f = (0, At.Z)(o, el),
            {
              isFocusVisibleRef: g,
              onBlur: v,
              onFocus: b,
              ref: _,
            } = (0, gn.Z)(),
            [y, C] = t.useState(!1),
            x = (0, hn.Z)(r, _),
            S = (0, u.Z)({}, o, {
              color: i,
              component: s,
              focusVisible: y,
              underline: p,
              variant: m,
            }),
            k = ((e) => {
              const {
                  classes: t,
                  component: n,
                  focusVisible: r,
                  underline: o,
                } = e,
                a = {
                  root: [
                    "root",
                    `underline${(0, $n.Z)(o)}`,
                    "button" === n && "button",
                    r && "focusVisible",
                  ],
                };
              return (0, Rt.Z)(a, qs, t);
            })(S);
          return (0, e.jsx)(
            tl,
            (0, u.Z)(
              {
                color: i,
                className: (0, Et.Z)(k.root, a),
                classes: c,
                component: s,
                onBlur: (e) => {
                  v(e), !1 === g.current && C(!1), l && l(e);
                },
                onFocus: (e) => {
                  b(e), !0 === g.current && C(!0), d && d(e);
                },
                ref: x,
                ownerState: S,
                variant: m,
                sx: [
                  ...(Object.keys(Js).includes(i) ? [] : [{ color: i }]),
                  ...(Array.isArray(h) ? h : [h]),
                ],
              },
              f
            )
          );
        });
      var rl = nl,
        ol = o(2996),
        al = o(4953),
        il = o(6535),
        sl = o(9336);
      const ll = ["onChange", "maxRows", "minRows", "style", "value"];
      function dl(e) {
        return parseInt(e, 10) || 0;
      }
      const cl = {
          visibility: "hidden",
          position: "absolute",
          overflow: "hidden",
          height: 0,
          top: 0,
          left: 0,
          transform: "translateZ(0)",
        },
        ul = t.forwardRef(function (n, r) {
          const {
              onChange: o,
              maxRows: a,
              minRows: i = 1,
              style: s,
              value: l,
            } = n,
            d = (0, At.Z)(n, ll),
            { current: c } = t.useRef(null != l),
            p = t.useRef(null),
            m = (0, rr.Z)(r, p),
            h = t.useRef(null),
            f = t.useRef(null),
            g = t.useCallback(() => {
              const e = p.current,
                t = (0, $r.Z)(e).getComputedStyle(e);
              if ("0px" === t.width)
                return { outerHeightStyle: 0, overflowing: !1 };
              const r = f.current;
              (r.style.width = t.width),
                (r.value = e.value || n.placeholder || "x"),
                "\n" === r.value.slice(-1) && (r.value += " ");
              const o = t.boxSizing,
                s = dl(t.paddingBottom) + dl(t.paddingTop),
                l = dl(t.borderBottomWidth) + dl(t.borderTopWidth),
                d = r.scrollHeight;
              r.value = "x";
              const c = r.scrollHeight;
              let u = d;
              return (
                i && (u = Math.max(Number(i) * c, u)),
                a && (u = Math.min(Number(a) * c, u)),
                (u = Math.max(u, c)),
                {
                  outerHeightStyle: u + ("border-box" === o ? s + l : 0),
                  overflowing: Math.abs(u - d) <= 1,
                }
              );
            }, [a, i, n.placeholder]),
            v = t.useCallback(() => {
              const e = g();
              if (
                null == (t = e) ||
                0 === Object.keys(t).length ||
                (0 === t.outerHeightStyle && !t.overflowing)
              )
                return;
              var t;
              const n = e.outerHeightStyle,
                r = p.current;
              h.current !== n && ((h.current = n), (r.style.height = `${n}px`)),
                (r.style.overflow = e.overflowing ? "hidden" : "");
            }, [g]);
          return (
            (0, yr.Z)(() => {
              const e = () => {
                v();
              };
              const t = (0, sl.Z)(e),
                n = p.current,
                r = (0, $r.Z)(n);
              let o;
              return (
                r.addEventListener("resize", t),
                "undefined" != typeof ResizeObserver &&
                  ((o = new ResizeObserver(e)), o.observe(n)),
                () => {
                  t.clear(),
                    cancelAnimationFrame(undefined),
                    r.removeEventListener("resize", t),
                    o && o.disconnect();
                }
              );
            }, [g, v]),
            (0, yr.Z)(() => {
              v();
            }),
            (0, e.jsxs)(t.Fragment, {
              children: [
                (0, e.jsx)(
                  "textarea",
                  (0, u.Z)(
                    {
                      value: l,
                      onChange: (e) => {
                        c || v(), o && o(e);
                      },
                      ref: m,
                      rows: i,
                      style: s,
                    },
                    d
                  )
                ),
                (0, e.jsx)("textarea", {
                  "aria-hidden": !0,
                  className: n.className,
                  readOnly: !0,
                  ref: f,
                  tabIndex: -1,
                  style: (0, u.Z)({}, cl, s, {
                    paddingTop: 0,
                    paddingBottom: 0,
                  }),
                }),
              ],
            })
          );
        });
      var pl = ul;
      function ml({ props: e, states: t, muiFormControl: n }) {
        return t.reduce(
          (t, r) => ((t[r] = e[r]), n && void 0 === e[r] && (t[r] = n[r]), t),
          {}
        );
      }
      var hl = t.createContext(void 0);
      function fl() {
        return t.useContext(hl);
      }
      var gl = o(1234),
        vl = function ({ styles: t, themeId: n, defaultTheme: r = {} }) {
          const o = on(r),
            a = "function" == typeof t ? t((n && o[n]) || o) : t;
          return (0, e.jsx)(gl.Z, { styles: a });
        },
        bl = function (t) {
          return (0, e.jsx)(
            vl,
            (0, u.Z)({}, t, { defaultTheme: Nr.Z, themeId: cn.Z })
          );
        };
      function _l(e) {
        return null != e && !(Array.isArray(e) && 0 === e.length);
      }
      function yl(e, t = !1) {
        return (
          e &&
          ((_l(e.value) && "" !== e.value) ||
            (t && _l(e.defaultValue) && "" !== e.defaultValue))
        );
      }
      function Cl(e) {
        return (0, Zt.ZP)("MuiInputBase", e);
      }
      var xl = (0, Ft.Z)("MuiInputBase", [
        "root",
        "formControl",
        "focused",
        "disabled",
        "adornedStart",
        "adornedEnd",
        "error",
        "sizeSmall",
        "multiline",
        "colorSecondary",
        "fullWidth",
        "hiddenLabel",
        "readOnly",
        "input",
        "inputSizeSmall",
        "inputMultiline",
        "inputTypeSearch",
        "inputAdornedStart",
        "inputAdornedEnd",
        "inputHiddenLabel",
      ]);
      const Sl = [
          "aria-describedby",
          "autoComplete",
          "autoFocus",
          "className",
          "color",
          "components",
          "componentsProps",
          "defaultValue",
          "disabled",
          "disableInjectingGlobalStyles",
          "endAdornment",
          "error",
          "fullWidth",
          "id",
          "inputComponent",
          "inputProps",
          "inputRef",
          "margin",
          "maxRows",
          "minRows",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onClick",
          "onFocus",
          "onKeyDown",
          "onKeyUp",
          "placeholder",
          "readOnly",
          "renderSuffix",
          "rows",
          "size",
          "slotProps",
          "slots",
          "startAdornment",
          "type",
          "value",
        ],
        kl = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.root,
            n.formControl && t.formControl,
            n.startAdornment && t.adornedStart,
            n.endAdornment && t.adornedEnd,
            n.error && t.error,
            "small" === n.size && t.sizeSmall,
            n.multiline && t.multiline,
            n.color && t[`color${(0, $n.Z)(n.color)}`],
            n.fullWidth && t.fullWidth,
            n.hiddenLabel && t.hiddenLabel,
          ];
        },
        Pl = (e, t) => {
          const { ownerState: n } = e;
          return [
            t.input,
            "small" === n.size && t.inputSizeSmall,
            n.multiline && t.inputMultiline,
            "search" === n.type && t.inputTypeSearch,
            n.startAdornment && t.inputAdornedStart,
            n.endAdornment && t.inputAdornedEnd,
            n.hiddenLabel && t.inputHiddenLabel,
          ];
        },
        wl = (0, Bt.ZP)("div", {
          name: "MuiInputBase",
          slot: "Root",
          overridesResolver: kl,
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {},
            e.typography.body1,
            {
              color: (e.vars || e).palette.text.primary,
              lineHeight: "1.4375em",
              boxSizing: "border-box",
              position: "relative",
              cursor: "text",
              display: "inline-flex",
              alignItems: "center",
              [`&.${xl.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
                cursor: "default",
              },
            },
            t.multiline &&
              (0, u.Z)(
                { padding: "4px 0 5px" },
                "small" === t.size && { paddingTop: 1 }
              ),
            t.fullWidth && { width: "100%" }
          )
        ),
        Ol = (0, Bt.ZP)("input", {
          name: "MuiInputBase",
          slot: "Input",
          overridesResolver: Pl,
        })(({ theme: e, ownerState: t }) => {
          const n = "light" === e.palette.mode,
            r = (0, u.Z)(
              { color: "currentColor" },
              e.vars
                ? { opacity: e.vars.opacity.inputPlaceholder }
                : { opacity: n ? 0.42 : 0.5 },
              {
                transition: e.transitions.create("opacity", {
                  duration: e.transitions.duration.shorter,
                }),
              }
            ),
            o = { opacity: "0 !important" },
            a = e.vars
              ? { opacity: e.vars.opacity.inputPlaceholder }
              : { opacity: n ? 0.42 : 0.5 };
          return (0, u.Z)(
            {
              font: "inherit",
              letterSpacing: "inherit",
              color: "currentColor",
              padding: "4px 0 5px",
              border: 0,
              boxSizing: "content-box",
              background: "none",
              height: "1.4375em",
              margin: 0,
              WebkitTapHighlightColor: "transparent",
              display: "block",
              minWidth: 0,
              width: "100%",
              animationName: "mui-auto-fill-cancel",
              animationDuration: "10ms",
              "&::-webkit-input-placeholder": r,
              "&::-moz-placeholder": r,
              "&:-ms-input-placeholder": r,
              "&::-ms-input-placeholder": r,
              "&:focus": { outline: 0 },
              "&:invalid": { boxShadow: "none" },
              "&::-webkit-search-decoration": { WebkitAppearance: "none" },
              [`label[data-shrink=false] + .${xl.formControl} &`]: {
                "&::-webkit-input-placeholder": o,
                "&::-moz-placeholder": o,
                "&:-ms-input-placeholder": o,
                "&::-ms-input-placeholder": o,
                "&:focus::-webkit-input-placeholder": a,
                "&:focus::-moz-placeholder": a,
                "&:focus:-ms-input-placeholder": a,
                "&:focus::-ms-input-placeholder": a,
              },
              [`&.${xl.disabled}`]: {
                opacity: 1,
                WebkitTextFillColor: (e.vars || e).palette.text.disabled,
              },
              "&:-webkit-autofill": {
                animationDuration: "5000s",
                animationName: "mui-auto-fill",
              },
            },
            "small" === t.size && { paddingTop: 1 },
            t.multiline && {
              height: "auto",
              resize: "none",
              padding: 0,
              paddingTop: 0,
            },
            "search" === t.type && { MozAppearance: "textfield" }
          );
        }),
        Tl = (0, e.jsx)(bl, {
          styles: {
            "@keyframes mui-auto-fill": { from: { display: "block" } },
            "@keyframes mui-auto-fill-cancel": { from: { display: "block" } },
          },
        }),
        Il = t.forwardRef(function (n, r) {
          var o;
          const a = (0, zt.i)({ props: n, name: "MuiInputBase" }),
            {
              "aria-describedby": i,
              autoComplete: s,
              autoFocus: l,
              className: d,
              components: c = {},
              componentsProps: p = {},
              defaultValue: m,
              disabled: h,
              disableInjectingGlobalStyles: f,
              endAdornment: g,
              fullWidth: v = !1,
              id: b,
              inputComponent: _ = "input",
              inputProps: y = {},
              inputRef: C,
              maxRows: x,
              minRows: S,
              multiline: k = !1,
              name: P,
              onBlur: w,
              onChange: O,
              onClick: T,
              onFocus: I,
              onKeyDown: M,
              onKeyUp: j,
              placeholder: N,
              readOnly: D,
              renderSuffix: A,
              rows: E,
              slotProps: R = {},
              slots: L = {},
              startAdornment: B,
              type: z = "text",
              value: F,
            } = a,
            Z = (0, At.Z)(a, Sl),
            H = null != y.value ? y.value : F,
            { current: V } = t.useRef(null != H),
            W = t.useRef(),
            U = t.useCallback((e) => {}, []),
            $ = (0, hn.Z)(W, C, y.ref, U),
            [K, G] = t.useState(!1),
            q = fl(),
            Q = ml({
              props: a,
              muiFormControl: q,
              states: [
                "color",
                "disabled",
                "error",
                "hiddenLabel",
                "size",
                "required",
                "filled",
              ],
            });
          (Q.focused = q ? q.focused : K),
            t.useEffect(() => {
              !q && h && K && (G(!1), w && w());
            }, [q, h, K, w]);
          const Y = q && q.onFilled,
            J = q && q.onEmpty,
            X = t.useCallback(
              (e) => {
                yl(e) ? Y && Y() : J && J();
              },
              [Y, J]
            );
          (0, ra.Z)(() => {
            V && X({ value: H });
          }, [H, X, V]),
            t.useEffect(() => {
              X(W.current);
            }, []);
          let ee = _,
            te = y;
          k &&
            "input" === ee &&
            ((te = E
              ? (0, u.Z)({ type: void 0, minRows: E, maxRows: E }, te)
              : (0, u.Z)({ type: void 0, maxRows: x, minRows: S }, te)),
            (ee = pl)),
            t.useEffect(() => {
              q && q.setAdornedStart(Boolean(B));
            }, [q, B]);
          const ne = (0, u.Z)({}, a, {
              color: Q.color || "primary",
              disabled: Q.disabled,
              endAdornment: g,
              error: Q.error,
              focused: Q.focused,
              formControl: q,
              fullWidth: v,
              hiddenLabel: Q.hiddenLabel,
              multiline: k,
              size: Q.size,
              startAdornment: B,
              type: z,
            }),
            re = ((e) => {
              const {
                  classes: t,
                  color: n,
                  disabled: r,
                  error: o,
                  endAdornment: a,
                  focused: i,
                  formControl: s,
                  fullWidth: l,
                  hiddenLabel: d,
                  multiline: c,
                  readOnly: u,
                  size: p,
                  startAdornment: m,
                  type: h,
                } = e,
                f = {
                  root: [
                    "root",
                    `color${(0, $n.Z)(n)}`,
                    r && "disabled",
                    o && "error",
                    l && "fullWidth",
                    i && "focused",
                    s && "formControl",
                    p && "medium" !== p && `size${(0, $n.Z)(p)}`,
                    c && "multiline",
                    m && "adornedStart",
                    a && "adornedEnd",
                    d && "hiddenLabel",
                    u && "readOnly",
                  ],
                  input: [
                    "input",
                    r && "disabled",
                    "search" === h && "inputTypeSearch",
                    c && "inputMultiline",
                    "small" === p && "inputSizeSmall",
                    d && "inputHiddenLabel",
                    m && "inputAdornedStart",
                    a && "inputAdornedEnd",
                    u && "readOnly",
                  ],
                };
              return (0, Rt.Z)(f, Cl, t);
            })(ne),
            oe = L.root || c.Root || wl,
            ae = R.root || p.root || {},
            ie = L.input || c.Input || Ol;
          return (
            (te = (0, u.Z)({}, te, null != (o = R.input) ? o : p.input)),
            (0, e.jsxs)(t.Fragment, {
              children: [
                !f && Tl,
                (0, e.jsxs)(
                  oe,
                  (0, u.Z)(
                    {},
                    ae,
                    !or(oe) && { ownerState: (0, u.Z)({}, ne, ae.ownerState) },
                    {
                      ref: r,
                      onClick: (e) => {
                        W.current &&
                          e.currentTarget === e.target &&
                          W.current.focus(),
                          T && T(e);
                      },
                    },
                    Z,
                    {
                      className: (0, Et.Z)(
                        re.root,
                        ae.className,
                        d,
                        D && "MuiInputBase-readOnly"
                      ),
                      children: [
                        B,
                        (0, e.jsx)(hl.Provider, {
                          value: null,
                          children: (0, e.jsx)(
                            ie,
                            (0, u.Z)(
                              {
                                ownerState: ne,
                                "aria-invalid": Q.error,
                                "aria-describedby": i,
                                autoComplete: s,
                                autoFocus: l,
                                defaultValue: m,
                                disabled: Q.disabled,
                                id: b,
                                onAnimationStart: (e) => {
                                  X(
                                    "mui-auto-fill-cancel" === e.animationName
                                      ? W.current
                                      : { value: "x" }
                                  );
                                },
                                name: P,
                                placeholder: N,
                                readOnly: D,
                                required: Q.required,
                                rows: E,
                                value: H,
                                onKeyDown: M,
                                onKeyUp: j,
                                type: z,
                              },
                              te,
                              !or(ie) && {
                                as: ee,
                                ownerState: (0, u.Z)({}, ne, te.ownerState),
                              },
                              {
                                ref: $,
                                className: (0, Et.Z)(
                                  re.input,
                                  te.className,
                                  D && "MuiInputBase-readOnly"
                                ),
                                onBlur: (e) => {
                                  w && w(e),
                                    y.onBlur && y.onBlur(e),
                                    q && q.onBlur ? q.onBlur(e) : G(!1);
                                },
                                onChange: (e, ...t) => {
                                  if (!V) {
                                    const t = e.target || W.current;
                                    if (null == t)
                                      throw new Error((0, il.Z)(1));
                                    X({ value: t.value });
                                  }
                                  y.onChange && y.onChange(e, ...t),
                                    O && O(e, ...t);
                                },
                                onFocus: (e) => {
                                  Q.disabled
                                    ? e.stopPropagation()
                                    : (I && I(e),
                                      y.onFocus && y.onFocus(e),
                                      q && q.onFocus ? q.onFocus(e) : G(!0));
                                },
                              }
                            )
                          ),
                        }),
                        g,
                        A ? A((0, u.Z)({}, Q, { startAdornment: B })) : null,
                      ],
                    }
                  )
                ),
              ],
            })
          );
        });
      var Ml = Il;
      function jl(e) {
        return (0, Zt.ZP)("MuiInput", e);
      }
      var Nl = (0, u.Z)(
        {},
        xl,
        (0, Ft.Z)("MuiInput", ["root", "underline", "input"])
      );
      const Dl = [
          "disableUnderline",
          "components",
          "componentsProps",
          "fullWidth",
          "inputComponent",
          "multiline",
          "slotProps",
          "slots",
          "type",
        ],
        Al = (0, Bt.ZP)(wl, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiInput",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [...kl(e, t), !n.disableUnderline && t.underline];
          },
        })(({ theme: e, ownerState: t }) => {
          let n =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.42)"
              : "rgba(255, 255, 255, 0.7)";
          return (
            e.vars &&
              (n = `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`),
            (0, u.Z)(
              { position: "relative" },
              t.formControl && { "label + &": { marginTop: 16 } },
              !t.disableUnderline && {
                "&::after": {
                  borderBottom: `2px solid ${
                    (e.vars || e).palette[t.color].main
                  }`,
                  left: 0,
                  bottom: 0,
                  content: '""',
                  position: "absolute",
                  right: 0,
                  transform: "scaleX(0)",
                  transition: e.transitions.create("transform", {
                    duration: e.transitions.duration.shorter,
                    easing: e.transitions.easing.easeOut,
                  }),
                  pointerEvents: "none",
                },
                [`&.${Nl.focused}:after`]: {
                  transform: "scaleX(1) translateX(0)",
                },
                [`&.${Nl.error}`]: {
                  "&::before, &::after": {
                    borderBottomColor: (e.vars || e).palette.error.main,
                  },
                },
                "&::before": {
                  borderBottom: `1px solid ${n}`,
                  left: 0,
                  bottom: 0,
                  content: '"\\00a0"',
                  position: "absolute",
                  right: 0,
                  transition: e.transitions.create("border-bottom-color", {
                    duration: e.transitions.duration.shorter,
                  }),
                  pointerEvents: "none",
                },
                [`&:hover:not(.${Nl.disabled}, .${Nl.error}):before`]: {
                  borderBottom: `2px solid ${
                    (e.vars || e).palette.text.primary
                  }`,
                  "@media (hover: none)": { borderBottom: `1px solid ${n}` },
                },
                [`&.${Nl.disabled}:before`]: { borderBottomStyle: "dotted" },
              }
            )
          );
        }),
        El = (0, Bt.ZP)(Ol, {
          name: "MuiInput",
          slot: "Input",
          overridesResolver: Pl,
        })({}),
        Rl = t.forwardRef(function (t, n) {
          var r, o, a, i;
          const s = (0, zt.i)({ props: t, name: "MuiInput" }),
            {
              disableUnderline: l,
              components: d = {},
              componentsProps: c,
              fullWidth: p = !1,
              inputComponent: m = "input",
              multiline: h = !1,
              slotProps: f,
              slots: g = {},
              type: v = "text",
            } = s,
            b = (0, At.Z)(s, Dl),
            _ = ((e) => {
              const { classes: t, disableUnderline: n } = e,
                r = { root: ["root", !n && "underline"], input: ["input"] },
                o = (0, Rt.Z)(r, jl, t);
              return (0, u.Z)({}, t, o);
            })(s),
            y = { root: { ownerState: { disableUnderline: l } } },
            C = (null != f ? f : c) ? (0, al.Z)(null != f ? f : c, y) : y,
            x = null != (r = null != (o = g.root) ? o : d.Root) ? r : Al,
            S = null != (a = null != (i = g.input) ? i : d.Input) ? a : El;
          return (0,
          e.jsx)(Ml, (0, u.Z)({ slots: { root: x, input: S }, slotProps: C, fullWidth: p, inputComponent: m, multiline: h, ref: n, type: v }, b, { classes: _ }));
        });
      Rl.muiName = "Input";
      var Ll = Rl;
      function Bl(e) {
        return (0, Zt.ZP)("MuiFilledInput", e);
      }
      var zl = (0, u.Z)(
        {},
        xl,
        (0, Ft.Z)("MuiFilledInput", ["root", "underline", "input"])
      );
      const Fl = [
          "disableUnderline",
          "components",
          "componentsProps",
          "fullWidth",
          "hiddenLabel",
          "inputComponent",
          "multiline",
          "slotProps",
          "slots",
          "type",
        ],
        Zl = (0, Bt.ZP)(wl, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiFilledInput",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [...kl(e, t), !n.disableUnderline && t.underline];
          },
        })(({ theme: e, ownerState: t }) => {
          var n;
          const r = "light" === e.palette.mode,
            o = r ? "rgba(0, 0, 0, 0.42)" : "rgba(255, 255, 255, 0.7)",
            a = r ? "rgba(0, 0, 0, 0.06)" : "rgba(255, 255, 255, 0.09)",
            i = r ? "rgba(0, 0, 0, 0.09)" : "rgba(255, 255, 255, 0.13)",
            s = r ? "rgba(0, 0, 0, 0.12)" : "rgba(255, 255, 255, 0.12)";
          return (0, u.Z)(
            {
              position: "relative",
              backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
              borderTopLeftRadius: (e.vars || e).shape.borderRadius,
              borderTopRightRadius: (e.vars || e).shape.borderRadius,
              transition: e.transitions.create("background-color", {
                duration: e.transitions.duration.shorter,
                easing: e.transitions.easing.easeOut,
              }),
              "&:hover": {
                backgroundColor: e.vars
                  ? e.vars.palette.FilledInput.hoverBg
                  : i,
                "@media (hover: none)": {
                  backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
                },
              },
              [`&.${zl.focused}`]: {
                backgroundColor: e.vars ? e.vars.palette.FilledInput.bg : a,
              },
              [`&.${zl.disabled}`]: {
                backgroundColor: e.vars
                  ? e.vars.palette.FilledInput.disabledBg
                  : s,
              },
            },
            !t.disableUnderline && {
              "&::after": {
                borderBottom: `2px solid ${
                  null == (n = (e.vars || e).palette[t.color || "primary"])
                    ? void 0
                    : n.main
                }`,
                left: 0,
                bottom: 0,
                content: '""',
                position: "absolute",
                right: 0,
                transform: "scaleX(0)",
                transition: e.transitions.create("transform", {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut,
                }),
                pointerEvents: "none",
              },
              [`&.${zl.focused}:after`]: {
                transform: "scaleX(1) translateX(0)",
              },
              [`&.${zl.error}`]: {
                "&::before, &::after": {
                  borderBottomColor: (e.vars || e).palette.error.main,
                },
              },
              "&::before": {
                borderBottom: `1px solid ${
                  e.vars
                    ? `rgba(${e.vars.palette.common.onBackgroundChannel} / ${e.vars.opacity.inputUnderline})`
                    : o
                }`,
                left: 0,
                bottom: 0,
                content: '"\\00a0"',
                position: "absolute",
                right: 0,
                transition: e.transitions.create("border-bottom-color", {
                  duration: e.transitions.duration.shorter,
                }),
                pointerEvents: "none",
              },
              [`&:hover:not(.${zl.disabled}, .${zl.error}):before`]: {
                borderBottom: `1px solid ${(e.vars || e).palette.text.primary}`,
              },
              [`&.${zl.disabled}:before`]: { borderBottomStyle: "dotted" },
            },
            t.startAdornment && { paddingLeft: 12 },
            t.endAdornment && { paddingRight: 12 },
            t.multiline &&
              (0, u.Z)(
                { padding: "25px 12px 8px" },
                "small" === t.size && { paddingTop: 21, paddingBottom: 4 },
                t.hiddenLabel && { paddingTop: 16, paddingBottom: 17 },
                t.hiddenLabel &&
                  "small" === t.size && { paddingTop: 8, paddingBottom: 9 }
              )
          );
        }),
        Hl = (0, Bt.ZP)(Ol, {
          name: "MuiFilledInput",
          slot: "Input",
          overridesResolver: Pl,
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              paddingTop: 25,
              paddingRight: 12,
              paddingBottom: 8,
              paddingLeft: 12,
            },
            !e.vars && {
              "&:-webkit-autofill": {
                WebkitBoxShadow:
                  "light" === e.palette.mode
                    ? null
                    : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "light" === e.palette.mode ? null : "#fff",
                caretColor: "light" === e.palette.mode ? null : "#fff",
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
              },
            },
            e.vars && {
              "&:-webkit-autofill": {
                borderTopLeftRadius: "inherit",
                borderTopRightRadius: "inherit",
              },
              [e.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "#fff",
                  caretColor: "#fff",
                },
              },
            },
            "small" === t.size && { paddingTop: 21, paddingBottom: 4 },
            t.hiddenLabel && { paddingTop: 16, paddingBottom: 17 },
            t.startAdornment && { paddingLeft: 0 },
            t.endAdornment && { paddingRight: 0 },
            t.hiddenLabel &&
              "small" === t.size && { paddingTop: 8, paddingBottom: 9 },
            t.multiline && {
              paddingTop: 0,
              paddingBottom: 0,
              paddingLeft: 0,
              paddingRight: 0,
            }
          )
        ),
        Vl = t.forwardRef(function (t, n) {
          var r, o, a, i;
          const s = (0, zt.i)({ props: t, name: "MuiFilledInput" }),
            {
              components: l = {},
              componentsProps: d,
              fullWidth: c = !1,
              inputComponent: p = "input",
              multiline: m = !1,
              slotProps: h,
              slots: f = {},
              type: g = "text",
            } = s,
            v = (0, At.Z)(s, Fl),
            b = (0, u.Z)({}, s, {
              fullWidth: c,
              inputComponent: p,
              multiline: m,
              type: g,
            }),
            _ = ((e) => {
              const { classes: t, disableUnderline: n } = e,
                r = { root: ["root", !n && "underline"], input: ["input"] },
                o = (0, Rt.Z)(r, Bl, t);
              return (0, u.Z)({}, t, o);
            })(s),
            y = { root: { ownerState: b }, input: { ownerState: b } },
            C = (null != h ? h : d) ? (0, al.Z)(y, null != h ? h : d) : y,
            x = null != (r = null != (o = f.root) ? o : l.Root) ? r : Zl,
            S = null != (a = null != (i = f.input) ? i : l.Input) ? a : Hl;
          return (0,
          e.jsx)(Ml, (0, u.Z)({ slots: { root: x, input: S }, componentsProps: C, fullWidth: c, inputComponent: p, multiline: m, ref: n, type: g }, v, { classes: _ }));
        });
      Vl.muiName = "Input";
      var Wl,
        Ul = Vl;
      const $l = ["children", "classes", "className", "label", "notched"],
        Kl = (0, Bt.ZP)("fieldset", { shouldForwardProp: vo.Z })({
          textAlign: "left",
          position: "absolute",
          bottom: 0,
          right: 0,
          top: -5,
          left: 0,
          margin: 0,
          padding: "0 8px",
          pointerEvents: "none",
          borderRadius: "inherit",
          borderStyle: "solid",
          borderWidth: 1,
          overflow: "hidden",
          minWidth: "0%",
        }),
        Gl = (0, Bt.ZP)("legend", { shouldForwardProp: vo.Z })(
          ({ ownerState: e, theme: t }) =>
            (0, u.Z)(
              { float: "unset", width: "auto", overflow: "hidden" },
              !e.withLabel && {
                padding: 0,
                lineHeight: "11px",
                transition: t.transitions.create("width", {
                  duration: 150,
                  easing: t.transitions.easing.easeOut,
                }),
              },
              e.withLabel &&
                (0, u.Z)(
                  {
                    display: "block",
                    padding: 0,
                    height: 11,
                    fontSize: "0.75em",
                    visibility: "hidden",
                    maxWidth: 0.01,
                    transition: t.transitions.create("max-width", {
                      duration: 50,
                      easing: t.transitions.easing.easeOut,
                    }),
                    whiteSpace: "nowrap",
                    "& > span": {
                      paddingLeft: 5,
                      paddingRight: 5,
                      display: "inline-block",
                      opacity: 0,
                      visibility: "visible",
                    },
                  },
                  e.notched && {
                    maxWidth: "100%",
                    transition: t.transitions.create("max-width", {
                      duration: 100,
                      easing: t.transitions.easing.easeOut,
                      delay: 50,
                    }),
                  }
                )
            )
        );
      function ql(e) {
        return (0, Zt.ZP)("MuiOutlinedInput", e);
      }
      var Ql = (0, u.Z)(
        {},
        xl,
        (0, Ft.Z)("MuiOutlinedInput", ["root", "notchedOutline", "input"])
      );
      const Yl = [
          "components",
          "fullWidth",
          "inputComponent",
          "label",
          "multiline",
          "notched",
          "slots",
          "type",
        ],
        Jl = (0, Bt.ZP)(wl, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiOutlinedInput",
          slot: "Root",
          overridesResolver: kl,
        })(({ theme: e, ownerState: t }) => {
          const n =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)";
          return (0, u.Z)(
            {
              position: "relative",
              borderRadius: (e.vars || e).shape.borderRadius,
              [`&:hover .${Ql.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.text.primary,
              },
              "@media (hover: none)": {
                [`&:hover .${Ql.notchedOutline}`]: {
                  borderColor: e.vars
                    ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
                    : n,
                },
              },
              [`&.${Ql.focused} .${Ql.notchedOutline}`]: {
                borderColor: (e.vars || e).palette[t.color].main,
                borderWidth: 2,
              },
              [`&.${Ql.error} .${Ql.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.error.main,
              },
              [`&.${Ql.disabled} .${Ql.notchedOutline}`]: {
                borderColor: (e.vars || e).palette.action.disabled,
              },
            },
            t.startAdornment && { paddingLeft: 14 },
            t.endAdornment && { paddingRight: 14 },
            t.multiline &&
              (0, u.Z)(
                { padding: "16.5px 14px" },
                "small" === t.size && { padding: "8.5px 14px" }
              )
          );
        }),
        Xl = (0, Bt.ZP)(
          function (t) {
            const { className: n, label: r, notched: o } = t,
              a = (0, At.Z)(t, $l),
              i = null != r && "" !== r,
              s = (0, u.Z)({}, t, { notched: o, withLabel: i });
            return (0, e.jsx)(
              Kl,
              (0, u.Z)({ "aria-hidden": !0, className: n, ownerState: s }, a, {
                children: (0, e.jsx)(Gl, {
                  ownerState: s,
                  children: i
                    ? (0, e.jsx)("span", { children: r })
                    : Wl ||
                      (Wl = (0, e.jsx)("span", {
                        className: "notranslate",
                        children: "​",
                      })),
                }),
              })
            );
          },
          {
            name: "MuiOutlinedInput",
            slot: "NotchedOutline",
            overridesResolver: (e, t) => t.notchedOutline,
          }
        )(({ theme: e }) => {
          const t =
            "light" === e.palette.mode
              ? "rgba(0, 0, 0, 0.23)"
              : "rgba(255, 255, 255, 0.23)";
          return {
            borderColor: e.vars
              ? `rgba(${e.vars.palette.common.onBackgroundChannel} / 0.23)`
              : t,
          };
        }),
        ed = (0, Bt.ZP)(Ol, {
          name: "MuiOutlinedInput",
          slot: "Input",
          overridesResolver: Pl,
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { padding: "16.5px 14px" },
            !e.vars && {
              "&:-webkit-autofill": {
                WebkitBoxShadow:
                  "light" === e.palette.mode
                    ? null
                    : "0 0 0 100px #266798 inset",
                WebkitTextFillColor: "light" === e.palette.mode ? null : "#fff",
                caretColor: "light" === e.palette.mode ? null : "#fff",
                borderRadius: "inherit",
              },
            },
            e.vars && {
              "&:-webkit-autofill": { borderRadius: "inherit" },
              [e.getColorSchemeSelector("dark")]: {
                "&:-webkit-autofill": {
                  WebkitBoxShadow: "0 0 0 100px #266798 inset",
                  WebkitTextFillColor: "#fff",
                  caretColor: "#fff",
                },
              },
            },
            "small" === t.size && { padding: "8.5px 14px" },
            t.multiline && { padding: 0 },
            t.startAdornment && { paddingLeft: 0 },
            t.endAdornment && { paddingRight: 0 }
          )
        ),
        td = t.forwardRef(function (n, r) {
          var o, a, i, s, l;
          const d = (0, zt.i)({ props: n, name: "MuiOutlinedInput" }),
            {
              components: c = {},
              fullWidth: p = !1,
              inputComponent: m = "input",
              label: h,
              multiline: f = !1,
              notched: g,
              slots: v = {},
              type: b = "text",
            } = d,
            _ = (0, At.Z)(d, Yl),
            y = ((e) => {
              const { classes: t } = e,
                n = (0, Rt.Z)(
                  {
                    root: ["root"],
                    notchedOutline: ["notchedOutline"],
                    input: ["input"],
                  },
                  ql,
                  t
                );
              return (0, u.Z)({}, t, n);
            })(d),
            C = fl(),
            x = ml({
              props: d,
              muiFormControl: C,
              states: [
                "color",
                "disabled",
                "error",
                "focused",
                "hiddenLabel",
                "size",
                "required",
              ],
            }),
            S = (0, u.Z)({}, d, {
              color: x.color || "primary",
              disabled: x.disabled,
              error: x.error,
              focused: x.focused,
              formControl: C,
              fullWidth: p,
              hiddenLabel: x.hiddenLabel,
              multiline: f,
              size: x.size,
              type: b,
            }),
            k = null != (o = null != (a = v.root) ? a : c.Root) ? o : Jl,
            P = null != (i = null != (s = v.input) ? s : c.Input) ? i : ed;
          return (0,
          e.jsx)(Ml, (0, u.Z)({ slots: { root: k, input: P }, renderSuffix: (n) => (0, e.jsx)(Xl, { ownerState: S, className: y.notchedOutline, label: null != h && "" !== h && x.required ? l || (l = (0, e.jsxs)(t.Fragment, { children: [h, " ", "*"] })) : h, notched: void 0 !== g ? g : Boolean(n.startAdornment || n.filled || n.focused) }), fullWidth: p, inputComponent: m, multiline: f, ref: r, type: b }, _, { classes: (0, u.Z)({}, y, { notchedOutline: null }) }));
        });
      td.muiName = "Input";
      var nd = td;
      function rd(e) {
        return (0, Zt.ZP)("MuiFormLabel", e);
      }
      var od = (0, Ft.Z)("MuiFormLabel", [
        "root",
        "colorSecondary",
        "focused",
        "disabled",
        "error",
        "filled",
        "required",
        "asterisk",
      ]);
      const ad = [
          "children",
          "className",
          "color",
          "component",
          "disabled",
          "error",
          "filled",
          "focused",
          "required",
        ],
        id = (0, Bt.ZP)("label", {
          name: "MuiFormLabel",
          slot: "Root",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, u.Z)(
              {},
              t.root,
              "secondary" === e.color && t.colorSecondary,
              e.filled && t.filled
            ),
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { color: (e.vars || e).palette.text.secondary },
            e.typography.body1,
            {
              lineHeight: "1.4375em",
              padding: 0,
              position: "relative",
              [`&.${od.focused}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
              [`&.${od.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
              [`&.${od.error}`]: { color: (e.vars || e).palette.error.main },
            }
          )
        ),
        sd = (0, Bt.ZP)("span", {
          name: "MuiFormLabel",
          slot: "Asterisk",
          overridesResolver: (e, t) => t.asterisk,
        })(({ theme: e }) => ({
          [`&.${od.error}`]: { color: (e.vars || e).palette.error.main },
        })),
        ld = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiFormLabel" }),
            { children: o, className: a, component: i = "label" } = r,
            s = (0, At.Z)(r, ad),
            l = ml({
              props: r,
              muiFormControl: fl(),
              states: [
                "color",
                "required",
                "focused",
                "disabled",
                "error",
                "filled",
              ],
            }),
            d = (0, u.Z)({}, r, {
              color: l.color || "primary",
              component: i,
              disabled: l.disabled,
              error: l.error,
              filled: l.filled,
              focused: l.focused,
              required: l.required,
            }),
            c = ((e) => {
              const {
                  classes: t,
                  color: n,
                  focused: r,
                  disabled: o,
                  error: a,
                  filled: i,
                  required: s,
                } = e,
                l = {
                  root: [
                    "root",
                    `color${(0, $n.Z)(n)}`,
                    o && "disabled",
                    a && "error",
                    i && "filled",
                    r && "focused",
                    s && "required",
                  ],
                  asterisk: ["asterisk", a && "error"],
                };
              return (0, Rt.Z)(l, rd, t);
            })(d);
          return (0,
          e.jsxs)(id, (0, u.Z)({ as: i, ownerState: d, className: (0, Et.Z)(c.root, a), ref: n }, s, { children: [o, l.required && (0, e.jsxs)(sd, { ownerState: d, "aria-hidden": !0, className: c.asterisk, children: [" ", "*"] })] }));
        });
      var dd = ld;
      function cd(e) {
        return (0, Zt.ZP)("MuiInputLabel", e);
      }
      (0, Ft.Z)("MuiInputLabel", [
        "root",
        "focused",
        "disabled",
        "error",
        "required",
        "asterisk",
        "formControl",
        "sizeSmall",
        "shrink",
        "animated",
        "standard",
        "filled",
        "outlined",
      ]);
      const ud = [
          "disableAnimation",
          "margin",
          "shrink",
          "variant",
          "className",
        ],
        pd = (0, Bt.ZP)(dd, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiInputLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${od.asterisk}`]: t.asterisk },
              t.root,
              n.formControl && t.formControl,
              "small" === n.size && t.sizeSmall,
              n.shrink && t.shrink,
              !n.disableAnimation && t.animated,
              n.focused && t.focused,
              t[n.variant],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              display: "block",
              transformOrigin: "top left",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            },
            t.formControl && {
              position: "absolute",
              left: 0,
              top: 0,
              transform: "translate(0, 20px) scale(1)",
            },
            "small" === t.size && { transform: "translate(0, 17px) scale(1)" },
            t.shrink && {
              transform: "translate(0, -1.5px) scale(0.75)",
              transformOrigin: "top left",
              maxWidth: "133%",
            },
            !t.disableAnimation && {
              transition: e.transitions.create(
                ["color", "transform", "max-width"],
                {
                  duration: e.transitions.duration.shorter,
                  easing: e.transitions.easing.easeOut,
                }
              ),
            },
            "filled" === t.variant &&
              (0, u.Z)(
                {
                  zIndex: 1,
                  pointerEvents: "none",
                  transform: "translate(12px, 16px) scale(1)",
                  maxWidth: "calc(100% - 24px)",
                },
                "small" === t.size && {
                  transform: "translate(12px, 13px) scale(1)",
                },
                t.shrink &&
                  (0, u.Z)(
                    {
                      userSelect: "none",
                      pointerEvents: "auto",
                      transform: "translate(12px, 7px) scale(0.75)",
                      maxWidth: "calc(133% - 24px)",
                    },
                    "small" === t.size && {
                      transform: "translate(12px, 4px) scale(0.75)",
                    }
                  )
              ),
            "outlined" === t.variant &&
              (0, u.Z)(
                {
                  zIndex: 1,
                  pointerEvents: "none",
                  transform: "translate(14px, 16px) scale(1)",
                  maxWidth: "calc(100% - 24px)",
                },
                "small" === t.size && {
                  transform: "translate(14px, 9px) scale(1)",
                },
                t.shrink && {
                  userSelect: "none",
                  pointerEvents: "auto",
                  maxWidth: "calc(133% - 32px)",
                  transform: "translate(14px, -9px) scale(0.75)",
                }
              )
          )
        ),
        md = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ name: "MuiInputLabel", props: t }),
            { disableAnimation: o = !1, shrink: a, className: i } = r,
            s = (0, At.Z)(r, ud),
            l = fl();
          let d = a;
          void 0 === d && l && (d = l.filled || l.focused || l.adornedStart);
          const c = ml({
              props: r,
              muiFormControl: l,
              states: ["size", "variant", "required", "focused"],
            }),
            p = (0, u.Z)({}, r, {
              disableAnimation: o,
              formControl: l,
              shrink: d,
              size: c.size,
              variant: c.variant,
              required: c.required,
              focused: c.focused,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  formControl: n,
                  size: r,
                  shrink: o,
                  disableAnimation: a,
                  variant: i,
                  required: s,
                } = e,
                l = {
                  root: [
                    "root",
                    n && "formControl",
                    !a && "animated",
                    o && "shrink",
                    r && "normal" !== r && `size${(0, $n.Z)(r)}`,
                    i,
                  ],
                  asterisk: [s && "asterisk"],
                },
                d = (0, Rt.Z)(l, cd, t);
              return (0, u.Z)({}, t, d);
            })(p);
          return (0,
          e.jsx)(pd, (0, u.Z)({ "data-shrink": d, ownerState: p, ref: n, className: (0, Et.Z)(m.root, i) }, s, { classes: m }));
        });
      var hd = md,
        fd = o(1829);
      function gd(e) {
        return (0, Zt.ZP)("MuiFormControl", e);
      }
      (0, Ft.Z)("MuiFormControl", [
        "root",
        "marginNone",
        "marginNormal",
        "marginDense",
        "fullWidth",
        "disabled",
      ]);
      const vd = [
          "children",
          "className",
          "color",
          "component",
          "disabled",
          "error",
          "focused",
          "fullWidth",
          "hiddenLabel",
          "margin",
          "required",
          "size",
          "variant",
        ],
        bd = (0, Bt.ZP)("div", {
          name: "MuiFormControl",
          slot: "Root",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, u.Z)(
              {},
              t.root,
              t[`margin${(0, $n.Z)(e.margin)}`],
              e.fullWidth && t.fullWidth
            ),
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              display: "inline-flex",
              flexDirection: "column",
              position: "relative",
              minWidth: 0,
              padding: 0,
              margin: 0,
              border: 0,
              verticalAlign: "top",
            },
            "normal" === e.margin && { marginTop: 16, marginBottom: 8 },
            "dense" === e.margin && { marginTop: 8, marginBottom: 4 },
            e.fullWidth && { width: "100%" }
          )
        ),
        _d = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiFormControl" }),
            {
              children: a,
              className: i,
              color: s = "primary",
              component: l = "div",
              disabled: d = !1,
              error: c = !1,
              focused: p,
              fullWidth: m = !1,
              hiddenLabel: h = !1,
              margin: f = "none",
              required: g = !1,
              size: v = "medium",
              variant: b = "outlined",
            } = o,
            _ = (0, At.Z)(o, vd),
            y = (0, u.Z)({}, o, {
              color: s,
              component: l,
              disabled: d,
              error: c,
              fullWidth: m,
              hiddenLabel: h,
              margin: f,
              required: g,
              size: v,
              variant: b,
            }),
            C = ((e) => {
              const { classes: t, margin: n, fullWidth: r } = e,
                o = {
                  root: [
                    "root",
                    "none" !== n && `margin${(0, $n.Z)(n)}`,
                    r && "fullWidth",
                  ],
                };
              return (0, Rt.Z)(o, gd, t);
            })(y),
            [x, S] = t.useState(() => {
              let e = !1;
              return (
                a &&
                  t.Children.forEach(a, (t) => {
                    if (!(0, fd.Z)(t, ["Input", "Select"])) return;
                    const n = (0, fd.Z)(t, ["Select"]) ? t.props.input : t;
                    n && n.props.startAdornment && (e = !0);
                  }),
                e
              );
            }),
            [k, P] = t.useState(() => {
              let e = !1;
              return (
                a &&
                  t.Children.forEach(a, (t) => {
                    (0, fd.Z)(t, ["Input", "Select"]) &&
                      (yl(t.props, !0) || yl(t.props.inputProps, !0)) &&
                      (e = !0);
                  }),
                e
              );
            }),
            [w, O] = t.useState(!1);
          d && w && O(!1);
          const T = void 0 === p || d ? w : p;
          let I;
          const M = t.useMemo(
            () => ({
              adornedStart: x,
              setAdornedStart: S,
              color: s,
              disabled: d,
              error: c,
              filled: k,
              focused: T,
              fullWidth: m,
              hiddenLabel: h,
              size: v,
              onBlur: () => {
                O(!1);
              },
              onEmpty: () => {
                P(!1);
              },
              onFilled: () => {
                P(!0);
              },
              onFocus: () => {
                O(!0);
              },
              registerEffect: I,
              required: g,
              variant: b,
            }),
            [x, s, d, c, k, T, m, h, I, g, v, b]
          );
          return (0,
          e.jsx)(hl.Provider, { value: M, children: (0, e.jsx)(bd, (0, u.Z)({ as: l, ownerState: y, className: (0, Et.Z)(C.root, i), ref: r }, _, { children: a })) });
        });
      var yd = _d;
      function Cd(e) {
        return (0, Zt.ZP)("MuiFormHelperText", e);
      }
      var xd,
        Sd = (0, Ft.Z)("MuiFormHelperText", [
          "root",
          "error",
          "disabled",
          "sizeSmall",
          "sizeMedium",
          "contained",
          "focused",
          "filled",
          "required",
        ]);
      const kd = [
          "children",
          "className",
          "component",
          "disabled",
          "error",
          "filled",
          "focused",
          "margin",
          "required",
          "variant",
        ],
        Pd = (0, Bt.ZP)("p", {
          name: "MuiFormHelperText",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.size && t[`size${(0, $n.Z)(n.size)}`],
              n.contained && t.contained,
              n.filled && t.filled,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { color: (e.vars || e).palette.text.secondary },
            e.typography.caption,
            {
              textAlign: "left",
              marginTop: 3,
              marginRight: 0,
              marginBottom: 0,
              marginLeft: 0,
              [`&.${Sd.disabled}`]: {
                color: (e.vars || e).palette.text.disabled,
              },
              [`&.${Sd.error}`]: { color: (e.vars || e).palette.error.main },
            },
            "small" === t.size && { marginTop: 4 },
            t.contained && { marginLeft: 14, marginRight: 14 }
          )
        ),
        wd = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiFormHelperText" }),
            { children: o, className: a, component: i = "p" } = r,
            s = (0, At.Z)(r, kd),
            l = ml({
              props: r,
              muiFormControl: fl(),
              states: [
                "variant",
                "size",
                "disabled",
                "error",
                "filled",
                "focused",
                "required",
              ],
            }),
            d = (0, u.Z)({}, r, {
              component: i,
              contained: "filled" === l.variant || "outlined" === l.variant,
              variant: l.variant,
              size: l.size,
              disabled: l.disabled,
              error: l.error,
              filled: l.filled,
              focused: l.focused,
              required: l.required,
            }),
            c = ((e) => {
              const {
                  classes: t,
                  contained: n,
                  size: r,
                  disabled: o,
                  error: a,
                  filled: i,
                  focused: s,
                  required: l,
                } = e,
                d = {
                  root: [
                    "root",
                    o && "disabled",
                    a && "error",
                    r && `size${(0, $n.Z)(r)}`,
                    n && "contained",
                    s && "focused",
                    i && "filled",
                    l && "required",
                  ],
                };
              return (0, Rt.Z)(d, Cd, t);
            })(d);
          return (0,
          e.jsx)(Pd, (0, u.Z)({ as: i, ownerState: d, className: (0, Et.Z)(c.root, a), ref: n }, s, { children: " " === o ? xd || (xd = (0, e.jsx)("span", { className: "notranslate", children: "​" })) : o }));
        });
      var Od = wd,
        Td = t.createContext({});
      function Id(e) {
        return (0, Zt.ZP)("MuiList", e);
      }
      (0, Ft.Z)("MuiList", ["root", "padding", "dense", "subheader"]);
      const Md = [
          "children",
          "className",
          "component",
          "dense",
          "disablePadding",
          "subheader",
        ],
        jd = (0, Bt.ZP)("ul", {
          name: "MuiList",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              !n.disablePadding && t.padding,
              n.dense && t.dense,
              n.subheader && t.subheader,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { listStyle: "none", margin: 0, padding: 0, position: "relative" },
            !e.disablePadding && { paddingTop: 8, paddingBottom: 8 },
            e.subheader && { paddingTop: 0 }
          )
        ),
        Nd = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiList" }),
            {
              children: a,
              className: i,
              component: s = "ul",
              dense: l = !1,
              disablePadding: d = !1,
              subheader: c,
            } = o,
            p = (0, At.Z)(o, Md),
            m = t.useMemo(() => ({ dense: l }), [l]),
            h = (0, u.Z)({}, o, { component: s, dense: l, disablePadding: d }),
            f = ((e) => {
              const {
                  classes: t,
                  disablePadding: n,
                  dense: r,
                  subheader: o,
                } = e,
                a = {
                  root: [
                    "root",
                    !n && "padding",
                    r && "dense",
                    o && "subheader",
                  ],
                };
              return (0, Rt.Z)(a, Id, t);
            })(h);
          return (0,
          e.jsx)(Td.Provider, { value: m, children: (0, e.jsxs)(jd, (0, u.Z)({ as: s, className: (0, Et.Z)(f.root, i), ref: r, ownerState: h }, p, { children: [c, a] })) });
        });
      var Dd = Nd,
        Ad = Kr;
      const Ed = [
        "actions",
        "autoFocus",
        "autoFocusItem",
        "children",
        "className",
        "disabledItemsFocusable",
        "disableListWrap",
        "onKeyDown",
        "variant",
      ];
      function Rd(e, t, n) {
        return e === t
          ? e.firstChild
          : t && t.nextElementSibling
          ? t.nextElementSibling
          : n
          ? null
          : e.firstChild;
      }
      function Ld(e, t, n) {
        return e === t
          ? n
            ? e.firstChild
            : e.lastChild
          : t && t.previousElementSibling
          ? t.previousElementSibling
          : n
          ? null
          : e.lastChild;
      }
      function Bd(e, t) {
        if (void 0 === t) return !0;
        let n = e.innerText;
        return (
          void 0 === n && (n = e.textContent),
          (n = n.trim().toLowerCase()),
          0 !== n.length &&
            (t.repeating
              ? n[0] === t.keys[0]
              : 0 === n.indexOf(t.keys.join("")))
        );
      }
      function zd(e, t, n, r, o, a) {
        let i = !1,
          s = o(e, t, !!t && n);
        for (; s; ) {
          if (s === e.firstChild) {
            if (i) return !1;
            i = !0;
          }
          const t =
            !r && (s.disabled || "true" === s.getAttribute("aria-disabled"));
          if (s.hasAttribute("tabindex") && Bd(s, a) && !t)
            return s.focus(), !0;
          s = o(e, s, n);
        }
        return !1;
      }
      var Fd = t.forwardRef(function (n, r) {
        const {
            actions: o,
            autoFocus: a = !1,
            autoFocusItem: i = !1,
            children: s,
            className: l,
            disabledItemsFocusable: d = !1,
            disableListWrap: c = !1,
            onKeyDown: p,
            variant: m = "selectedMenu",
          } = n,
          h = (0, At.Z)(n, Ed),
          f = t.useRef(null),
          g = t.useRef({
            keys: [],
            repeating: !0,
            previousKeyMatched: !0,
            lastTime: null,
          });
        (0, ra.Z)(() => {
          a && f.current.focus();
        }, [a]),
          t.useImperativeHandle(
            o,
            () => ({
              adjustStyleForScrollbar: (e, { direction: t }) => {
                const n = !f.current.style.width;
                if (e.clientHeight < f.current.clientHeight && n) {
                  const n = `${Ad((0, fa.Z)(e))}px`;
                  (f.current.style[
                    "rtl" === t ? "paddingLeft" : "paddingRight"
                  ] = n),
                    (f.current.style.width = `calc(100% + ${n})`);
                }
                return f.current;
              },
            }),
            []
          );
        const v = (0, hn.Z)(f, r);
        let b = -1;
        t.Children.forEach(s, (e, n) => {
          t.isValidElement(e)
            ? (e.props.disabled ||
                ((("selectedMenu" === m && e.props.selected) || -1 === b) &&
                  (b = n)),
              b === n &&
                (e.props.disabled ||
                  e.props.muiSkipListHighlight ||
                  e.type.muiSkipListHighlight) &&
                ((b += 1), b >= s.length && (b = -1)))
            : b === n && ((b += 1), b >= s.length && (b = -1));
        });
        const _ = t.Children.map(s, (e, n) => {
          if (n === b) {
            const n = {};
            return (
              i && (n.autoFocus = !0),
              void 0 === e.props.tabIndex &&
                "selectedMenu" === m &&
                (n.tabIndex = 0),
              t.cloneElement(e, n)
            );
          }
          return e;
        });
        return (0, e.jsx)(
          Dd,
          (0, u.Z)(
            {
              role: "menu",
              ref: v,
              className: l,
              onKeyDown: (e) => {
                const t = f.current,
                  n = e.key,
                  r = (0, fa.Z)(t).activeElement;
                if ("ArrowDown" === n) e.preventDefault(), zd(t, r, c, d, Rd);
                else if ("ArrowUp" === n)
                  e.preventDefault(), zd(t, r, c, d, Ld);
                else if ("Home" === n)
                  e.preventDefault(), zd(t, null, c, d, Rd);
                else if ("End" === n) e.preventDefault(), zd(t, null, c, d, Ld);
                else if (1 === n.length) {
                  const o = g.current,
                    a = n.toLowerCase(),
                    i = performance.now();
                  o.keys.length > 0 &&
                    (i - o.lastTime > 500
                      ? ((o.keys = []),
                        (o.repeating = !0),
                        (o.previousKeyMatched = !0))
                      : o.repeating && a !== o.keys[0] && (o.repeating = !1)),
                    (o.lastTime = i),
                    o.keys.push(a);
                  const s = r && !o.repeating && Bd(r, o);
                  o.previousKeyMatched && (s || zd(t, r, !1, d, Rd, o))
                    ? e.preventDefault()
                    : (o.previousKeyMatched = !1);
                }
                p && p(e);
              },
              tabIndex: a ? 0 : -1,
            },
            h,
            { children: _ }
          )
        );
      });
      function Zd(e) {
        return (0, Zt.ZP)("MuiPopover", e);
      }
      (0, Ft.Z)("MuiPopover", ["root", "paper"]);
      const Hd = ["onEntering"],
        Vd = [
          "action",
          "anchorEl",
          "anchorOrigin",
          "anchorPosition",
          "anchorReference",
          "children",
          "className",
          "container",
          "elevation",
          "marginThreshold",
          "open",
          "PaperProps",
          "slots",
          "slotProps",
          "transformOrigin",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
          "disableScrollLock",
        ],
        Wd = ["slotProps"];
      function Ud(e, t) {
        let n = 0;
        return (
          "number" == typeof t
            ? (n = t)
            : "center" === t
            ? (n = e.height / 2)
            : "bottom" === t && (n = e.height),
          n
        );
      }
      function $d(e, t) {
        let n = 0;
        return (
          "number" == typeof t
            ? (n = t)
            : "center" === t
            ? (n = e.width / 2)
            : "right" === t && (n = e.width),
          n
        );
      }
      function Kd(e) {
        return [e.horizontal, e.vertical]
          .map((e) => ("number" == typeof e ? `${e}px` : e))
          .join(" ");
      }
      function Gd(e) {
        return "function" == typeof e ? e() : e;
      }
      const qd = (0, Bt.ZP)(oo, {
          name: "MuiPopover",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        Qd = (0, Bt.ZP)(go, {
          name: "MuiPopover",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })({
          position: "absolute",
          overflowY: "auto",
          overflowX: "hidden",
          minWidth: 16,
          minHeight: 16,
          maxWidth: "calc(100% - 32px)",
          maxHeight: "calc(100% - 32px)",
          outline: 0,
        }),
        Yd = t.forwardRef(function (n, r) {
          var o, a, i;
          const s = (0, zt.i)({ props: n, name: "MuiPopover" }),
            {
              action: l,
              anchorEl: d,
              anchorOrigin: c = { vertical: "top", horizontal: "left" },
              anchorPosition: p,
              anchorReference: m = "anchorEl",
              children: h,
              className: f,
              container: g,
              elevation: v = 8,
              marginThreshold: b = 16,
              open: _,
              PaperProps: y = {},
              slots: C,
              slotProps: x,
              transformOrigin: S = { vertical: "top", horizontal: "left" },
              TransitionComponent: k = pi,
              transitionDuration: P = "auto",
              TransitionProps: { onEntering: w } = {},
              disableScrollLock: O = !1,
            } = s,
            T = (0, At.Z)(s.TransitionProps, Hd),
            I = (0, At.Z)(s, Vd),
            M = null != (o = null == x ? void 0 : x.paper) ? o : y,
            j = t.useRef(),
            N = (0, hn.Z)(j, M.ref),
            D = (0, u.Z)({}, s, {
              anchorOrigin: c,
              anchorReference: m,
              elevation: v,
              marginThreshold: b,
              externalPaperSlotProps: M,
              transformOrigin: S,
              TransitionComponent: k,
              transitionDuration: P,
              TransitionProps: T,
            }),
            A = ((e) => {
              const { classes: t } = e;
              return (0, Rt.Z)({ root: ["root"], paper: ["paper"] }, Zd, t);
            })(D),
            E = t.useCallback(() => {
              if ("anchorPosition" === m) return p;
              const e = Gd(d),
                t = (
                  e && 1 === e.nodeType ? e : (0, fa.Z)(j.current).body
                ).getBoundingClientRect();
              return {
                top: t.top + Ud(t, c.vertical),
                left: t.left + $d(t, c.horizontal),
              };
            }, [d, c.horizontal, c.vertical, p, m]),
            R = t.useCallback(
              (e) => ({
                vertical: Ud(e, S.vertical),
                horizontal: $d(e, S.horizontal),
              }),
              [S.horizontal, S.vertical]
            ),
            L = t.useCallback(
              (e) => {
                const t = { width: e.offsetWidth, height: e.offsetHeight },
                  n = R(t);
                if ("none" === m)
                  return { top: null, left: null, transformOrigin: Kd(n) };
                const r = E();
                let o = r.top - n.vertical,
                  a = r.left - n.horizontal;
                const i = o + t.height,
                  s = a + t.width,
                  l = (0, io.Z)(Gd(d)),
                  c = l.innerHeight - b,
                  u = l.innerWidth - b;
                if (null !== b && o < b) {
                  const e = o - b;
                  (o -= e), (n.vertical += e);
                } else if (null !== b && i > c) {
                  const e = i - c;
                  (o -= e), (n.vertical += e);
                }
                if (null !== b && a < b) {
                  const e = a - b;
                  (a -= e), (n.horizontal += e);
                } else if (s > u) {
                  const e = s - u;
                  (a -= e), (n.horizontal += e);
                }
                return {
                  top: `${Math.round(o)}px`,
                  left: `${Math.round(a)}px`,
                  transformOrigin: Kd(n),
                };
              },
              [d, m, E, R, b]
            ),
            [B, z] = t.useState(_),
            F = t.useCallback(() => {
              const e = j.current;
              if (!e) return;
              const t = L(e);
              null !== t.top && (e.style.top = t.top),
                null !== t.left && (e.style.left = t.left),
                (e.style.transformOrigin = t.transformOrigin),
                z(!0);
            }, [L]);
          t.useEffect(
            () => (
              O && window.addEventListener("scroll", F),
              () => window.removeEventListener("scroll", F)
            ),
            [d, O, F]
          ),
            t.useEffect(() => {
              _ && F();
            }),
            t.useImperativeHandle(
              l,
              () =>
                _
                  ? {
                      updatePosition: () => {
                        F();
                      },
                    }
                  : null,
              [_, F]
            ),
            t.useEffect(() => {
              if (!_) return;
              const e = (0, ao.Z)(() => {
                  F();
                }),
                t = (0, io.Z)(d);
              return (
                t.addEventListener("resize", e),
                () => {
                  e.clear(), t.removeEventListener("resize", e);
                }
              );
            }, [d, _, F]);
          let Z = P;
          "auto" !== P || k.muiSupportAuto || (Z = void 0);
          const H = g || (d ? (0, fa.Z)(Gd(d)).body : void 0),
            V = null != (a = null == C ? void 0 : C.root) ? a : qd,
            W = null != (i = null == C ? void 0 : C.paper) ? i : Qd,
            U = mr({
              elementType: W,
              externalSlotProps: (0, u.Z)({}, M, {
                style: B ? M.style : (0, u.Z)({}, M.style, { opacity: 0 }),
              }),
              additionalProps: { elevation: v, ref: N },
              ownerState: D,
              className: (0, Et.Z)(A.paper, null == M ? void 0 : M.className),
            }),
            $ = mr({
              elementType: V,
              externalSlotProps: (null == x ? void 0 : x.root) || {},
              externalForwardedProps: I,
              additionalProps: {
                ref: r,
                slotProps: { backdrop: { invisible: !0 } },
                container: H,
                open: _,
              },
              ownerState: D,
              className: (0, Et.Z)(A.root, f),
            }),
            { slotProps: K } = $,
            G = (0, At.Z)($, Wd);
          return (0, e.jsx)(
            V,
            (0, u.Z)({}, G, !or(V) && { slotProps: K, disableScrollLock: O }, {
              children: (0, e.jsx)(
                k,
                (0, u.Z)(
                  {
                    appear: !0,
                    in: _,
                    onEntering: (e, t) => {
                      w && w(e, t), F();
                    },
                    onExited: () => {
                      z(!1);
                    },
                    timeout: Z,
                  },
                  T,
                  { children: (0, e.jsx)(W, (0, u.Z)({}, U, { children: h })) }
                )
              ),
            })
          );
        });
      var Jd = Yd;
      function Xd(e) {
        return (0, Zt.ZP)("MuiMenu", e);
      }
      (0, Ft.Z)("MuiMenu", ["root", "paper", "list"]);
      const ec = ["onEntering"],
        tc = [
          "autoFocus",
          "children",
          "className",
          "disableAutoFocusItem",
          "MenuListProps",
          "onClose",
          "open",
          "PaperProps",
          "PopoverClasses",
          "transitionDuration",
          "TransitionProps",
          "variant",
          "slots",
          "slotProps",
        ],
        nc = { vertical: "top", horizontal: "right" },
        rc = { vertical: "top", horizontal: "left" },
        oc = (0, Bt.ZP)(Jd, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiMenu",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        ac = (0, Bt.ZP)(Qd, {
          name: "MuiMenu",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })({
          maxHeight: "calc(100% - 96px)",
          WebkitOverflowScrolling: "touch",
        }),
        ic = (0, Bt.ZP)(Fd, {
          name: "MuiMenu",
          slot: "List",
          overridesResolver: (e, t) => t.list,
        })({ outline: 0 });
      var sc = t.forwardRef(function (n, r) {
        var o, a;
        const i = (0, zt.i)({ props: n, name: "MuiMenu" }),
          {
            autoFocus: s = !0,
            children: l,
            className: d,
            disableAutoFocusItem: c = !1,
            MenuListProps: p = {},
            onClose: m,
            open: h,
            PaperProps: f = {},
            PopoverClasses: g,
            transitionDuration: v = "auto",
            TransitionProps: { onEntering: b } = {},
            variant: _ = "selectedMenu",
            slots: y = {},
            slotProps: C = {},
          } = i,
          x = (0, At.Z)(i.TransitionProps, ec),
          S = (0, At.Z)(i, tc),
          k = tr(),
          P = (0, u.Z)({}, i, {
            autoFocus: s,
            disableAutoFocusItem: c,
            MenuListProps: p,
            onEntering: b,
            PaperProps: f,
            transitionDuration: v,
            TransitionProps: x,
            variant: _,
          }),
          w = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)(
              { root: ["root"], paper: ["paper"], list: ["list"] },
              Xd,
              t
            );
          })(P),
          O = s && !c && h,
          T = t.useRef(null);
        let I = -1;
        t.Children.map(l, (e, n) => {
          t.isValidElement(e) &&
            (e.props.disabled ||
              ((("selectedMenu" === _ && e.props.selected) || -1 === I) &&
                (I = n)));
        });
        const M = null != (o = y.paper) ? o : ac,
          j = null != (a = C.paper) ? a : f,
          N = mr({
            elementType: y.root,
            externalSlotProps: C.root,
            ownerState: P,
            className: [w.root, d],
          }),
          D = mr({
            elementType: M,
            externalSlotProps: j,
            ownerState: P,
            className: w.paper,
          });
        return (0, e.jsx)(
          oc,
          (0, u.Z)(
            {
              onClose: m,
              anchorOrigin: {
                vertical: "bottom",
                horizontal: k ? "right" : "left",
              },
              transformOrigin: k ? nc : rc,
              slots: { paper: M, root: y.root },
              slotProps: { root: N, paper: D },
              open: h,
              ref: r,
              transitionDuration: v,
              TransitionProps: (0, u.Z)(
                {
                  onEntering: (e, t) => {
                    T.current &&
                      T.current.adjustStyleForScrollbar(e, {
                        direction: k ? "rtl" : "ltr",
                      }),
                      b && b(e, t);
                  },
                },
                x
              ),
              ownerState: P,
            },
            S,
            {
              classes: g,
              children: (0, e.jsx)(
                ic,
                (0, u.Z)(
                  {
                    onKeyDown: (e) => {
                      "Tab" === e.key &&
                        (e.preventDefault(), m && m(e, "tabKeyDown"));
                    },
                    actions: T,
                    autoFocus: s && (-1 === I || c),
                    autoFocusItem: O,
                    variant: _,
                  },
                  p,
                  { className: (0, Et.Z)(w.list, p.className), children: l }
                )
              ),
            }
          )
        );
      });
      function lc(e) {
        return (0, Zt.ZP)("MuiNativeSelect", e);
      }
      var dc = (0, Ft.Z)("MuiNativeSelect", [
        "root",
        "select",
        "multiple",
        "filled",
        "outlined",
        "standard",
        "disabled",
        "icon",
        "iconOpen",
        "iconFilled",
        "iconOutlined",
        "iconStandard",
        "nativeInput",
        "error",
      ]);
      const cc = [
          "className",
          "disabled",
          "error",
          "IconComponent",
          "inputRef",
          "variant",
        ],
        uc = ({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              MozAppearance: "none",
              WebkitAppearance: "none",
              userSelect: "none",
              borderRadius: 0,
              cursor: "pointer",
              "&:focus": (0, u.Z)(
                {},
                t.vars
                  ? {
                      backgroundColor: `rgba(${t.vars.palette.common.onBackgroundChannel} / 0.05)`,
                    }
                  : {
                      backgroundColor:
                        "light" === t.palette.mode
                          ? "rgba(0, 0, 0, 0.05)"
                          : "rgba(255, 255, 255, 0.05)",
                    },
                { borderRadius: 0 }
              ),
              "&::-ms-expand": { display: "none" },
              [`&.${dc.disabled}`]: { cursor: "default" },
              "&[multiple]": { height: "auto" },
              "&:not([multiple]) option, &:not([multiple]) optgroup": {
                backgroundColor: (t.vars || t).palette.background.paper,
              },
              "&&&": { paddingRight: 24, minWidth: 16 },
            },
            "filled" === e.variant && { "&&&": { paddingRight: 32 } },
            "outlined" === e.variant && {
              borderRadius: (t.vars || t).shape.borderRadius,
              "&:focus": { borderRadius: (t.vars || t).shape.borderRadius },
              "&&&": { paddingRight: 32 },
            }
          ),
        pc = (0, Bt.ZP)("select", {
          name: "MuiNativeSelect",
          slot: "Select",
          shouldForwardProp: vo.Z,
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.select,
              t[n.variant],
              n.error && t.error,
              { [`&.${dc.multiple}`]: t.multiple },
            ];
          },
        })(uc),
        mc = ({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              position: "absolute",
              right: 0,
              top: "calc(50% - .5em)",
              pointerEvents: "none",
              color: (t.vars || t).palette.action.active,
              [`&.${dc.disabled}`]: {
                color: (t.vars || t).palette.action.disabled,
              },
            },
            e.open && { transform: "rotate(180deg)" },
            "filled" === e.variant && { right: 7 },
            "outlined" === e.variant && { right: 7 }
          ),
        hc = (0, Bt.ZP)("svg", {
          name: "MuiNativeSelect",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.icon,
              n.variant && t[`icon${(0, $n.Z)(n.variant)}`],
              n.open && t.iconOpen,
            ];
          },
        })(mc);
      var fc = t.forwardRef(function (n, r) {
          const {
              className: o,
              disabled: a,
              error: i,
              IconComponent: s,
              inputRef: l,
              variant: d = "standard",
            } = n,
            c = (0, At.Z)(n, cc),
            p = (0, u.Z)({}, n, { disabled: a, variant: d, error: i }),
            m = ((e) => {
              const {
                  classes: t,
                  variant: n,
                  disabled: r,
                  multiple: o,
                  open: a,
                  error: i,
                } = e,
                s = {
                  select: [
                    "select",
                    n,
                    r && "disabled",
                    o && "multiple",
                    i && "error",
                  ],
                  icon: [
                    "icon",
                    `icon${(0, $n.Z)(n)}`,
                    a && "iconOpen",
                    r && "disabled",
                  ],
                };
              return (0, Rt.Z)(s, lc, t);
            })(p);
          return (0,
          e.jsxs)(t.Fragment, { children: [(0, e.jsx)(pc, (0, u.Z)({ ownerState: p, className: (0, Et.Z)(m.select, o), disabled: a, ref: l || r }, c)), n.multiple ? null : (0, e.jsx)(hc, { as: s, ownerState: p, className: m.icon })] });
        }),
        gc = o(5536);
      function vc(e) {
        return (0, Zt.ZP)("MuiSelect", e);
      }
      var bc,
        _c = (0, Ft.Z)("MuiSelect", [
          "root",
          "select",
          "multiple",
          "filled",
          "outlined",
          "standard",
          "disabled",
          "focused",
          "icon",
          "iconOpen",
          "iconFilled",
          "iconOutlined",
          "iconStandard",
          "nativeInput",
          "error",
        ]);
      const yc = [
          "aria-describedby",
          "aria-label",
          "autoFocus",
          "autoWidth",
          "children",
          "className",
          "defaultOpen",
          "defaultValue",
          "disabled",
          "displayEmpty",
          "error",
          "IconComponent",
          "inputRef",
          "labelId",
          "MenuProps",
          "multiple",
          "name",
          "onBlur",
          "onChange",
          "onClose",
          "onFocus",
          "onOpen",
          "open",
          "readOnly",
          "renderValue",
          "SelectDisplayProps",
          "tabIndex",
          "type",
          "value",
          "variant",
        ],
        Cc = (0, Bt.ZP)("div", {
          name: "MuiSelect",
          slot: "Select",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`&.${_c.select}`]: t.select },
              { [`&.${_c.select}`]: t[n.variant] },
              { [`&.${_c.error}`]: t.error },
              { [`&.${_c.multiple}`]: t.multiple },
            ];
          },
        })(uc, {
          [`&.${_c.select}`]: {
            height: "auto",
            minHeight: "1.4375em",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            overflow: "hidden",
          },
        }),
        xc = (0, Bt.ZP)("svg", {
          name: "MuiSelect",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.icon,
              n.variant && t[`icon${(0, $n.Z)(n.variant)}`],
              n.open && t.iconOpen,
            ];
          },
        })(mc),
        Sc = (0, Bt.ZP)("input", {
          shouldForwardProp: (e) => (0, gc.Z)(e) && "classes" !== e,
          name: "MuiSelect",
          slot: "NativeInput",
          overridesResolver: (e, t) => t.nativeInput,
        })({
          bottom: 0,
          left: 0,
          position: "absolute",
          opacity: 0,
          pointerEvents: "none",
          width: "100%",
          boxSizing: "border-box",
        });
      function kc(e, t) {
        return "object" == typeof t && null !== t
          ? e === t
          : String(e) === String(t);
      }
      function Pc(e) {
        return null == e || ("string" == typeof e && !e.trim());
      }
      const wc = t.forwardRef(function (n, r) {
        var o;
        const {
            "aria-describedby": a,
            "aria-label": i,
            autoFocus: s,
            autoWidth: l,
            children: d,
            className: c,
            defaultOpen: p,
            defaultValue: m,
            disabled: h,
            displayEmpty: f,
            error: g = !1,
            IconComponent: v,
            inputRef: b,
            labelId: _,
            MenuProps: y = {},
            multiple: C,
            name: x,
            onBlur: S,
            onChange: k,
            onClose: P,
            onFocus: w,
            onOpen: O,
            open: T,
            readOnly: I,
            renderValue: M,
            SelectDisplayProps: j = {},
            tabIndex: N,
            value: D,
            variant: A = "standard",
          } = n,
          E = (0, At.Z)(n, yc),
          [R, L] = (0, Ls.Z)({ controlled: D, default: m, name: "Select" }),
          [B, z] = (0, Ls.Z)({ controlled: T, default: p, name: "Select" }),
          F = t.useRef(null),
          Z = t.useRef(null),
          [H, V] = t.useState(null),
          { current: W } = t.useRef(null != T),
          [U, $] = t.useState(),
          K = (0, hn.Z)(r, b),
          G = t.useCallback((e) => {
            (Z.current = e), e && V(e);
          }, []),
          q = null == H ? void 0 : H.parentNode;
        t.useImperativeHandle(
          K,
          () => ({
            focus: () => {
              Z.current.focus();
            },
            node: F.current,
            value: R,
          }),
          [R]
        ),
          t.useEffect(() => {
            p &&
              B &&
              H &&
              !W &&
              ($(l ? null : q.clientWidth), Z.current.focus());
          }, [H, l]),
          t.useEffect(() => {
            s && Z.current.focus();
          }, [s]),
          t.useEffect(() => {
            if (!_) return;
            const e = (0, fa.Z)(Z.current).getElementById(_);
            if (e) {
              const t = () => {
                getSelection().isCollapsed && Z.current.focus();
              };
              return (
                e.addEventListener("click", t),
                () => {
                  e.removeEventListener("click", t);
                }
              );
            }
          }, [_]);
        const Q = (e, t) => {
            e ? O && O(t) : P && P(t), W || ($(l ? null : q.clientWidth), z(e));
          },
          Y = t.Children.toArray(d),
          J = (e) => (t) => {
            let n;
            if (t.currentTarget.hasAttribute("tabindex")) {
              if (C) {
                n = Array.isArray(R) ? R.slice() : [];
                const t = R.indexOf(e.props.value);
                -1 === t ? n.push(e.props.value) : n.splice(t, 1);
              } else n = e.props.value;
              if (
                (e.props.onClick && e.props.onClick(t), R !== n && (L(n), k))
              ) {
                const r = t.nativeEvent || t,
                  o = new r.constructor(r.type, r);
                Object.defineProperty(o, "target", {
                  writable: !0,
                  value: { value: n, name: x },
                }),
                  k(o, e);
              }
              C || Q(!1, t);
            }
          },
          X = null !== H && B;
        let ee, te;
        delete E["aria-invalid"];
        const ne = [];
        let re = !1,
          oe = !1;
        (yl({ value: R }) || f) && (M ? (ee = M(R)) : (re = !0));
        const ae = Y.map((e) => {
          if (!t.isValidElement(e)) return null;
          let n;
          if (C) {
            if (!Array.isArray(R)) throw new Error((0, il.Z)(2));
            (n = R.some((t) => kc(t, e.props.value))),
              n && re && ne.push(e.props.children);
          } else (n = kc(R, e.props.value)), n && re && (te = e.props.children);
          return (
            n && (oe = !0),
            t.cloneElement(e, {
              "aria-selected": n ? "true" : "false",
              onClick: J(e),
              onKeyUp: (t) => {
                " " === t.key && t.preventDefault(),
                  e.props.onKeyUp && e.props.onKeyUp(t);
              },
              role: "option",
              selected: n,
              value: void 0,
              "data-value": e.props.value,
            })
          );
        });
        re &&
          (ee = C
            ? 0 === ne.length
              ? null
              : ne.reduce(
                  (e, t, n) => (
                    e.push(t), n < ne.length - 1 && e.push(", "), e
                  ),
                  []
                )
            : te);
        let ie,
          se = U;
        !l && W && H && (se = q.clientWidth),
          (ie = void 0 !== N ? N : h ? null : 0);
        const le = j.id || (x ? `mui-component-select-${x}` : void 0),
          de = (0, u.Z)({}, n, { variant: A, value: R, open: X, error: g }),
          ce = ((e) => {
            const {
                classes: t,
                variant: n,
                disabled: r,
                multiple: o,
                open: a,
                error: i,
              } = e,
              s = {
                select: [
                  "select",
                  n,
                  r && "disabled",
                  o && "multiple",
                  i && "error",
                ],
                icon: [
                  "icon",
                  `icon${(0, $n.Z)(n)}`,
                  a && "iconOpen",
                  r && "disabled",
                ],
                nativeInput: ["nativeInput"],
              };
            return (0, Rt.Z)(s, vc, t);
          })(de),
          ue = (0, u.Z)(
            {},
            y.PaperProps,
            null == (o = y.slotProps) ? void 0 : o.paper
          ),
          pe = (0, ol.Z)();
        return (0, e.jsxs)(t.Fragment, {
          children: [
            (0, e.jsx)(
              Cc,
              (0, u.Z)(
                {
                  ref: G,
                  tabIndex: ie,
                  role: "combobox",
                  "aria-controls": pe,
                  "aria-disabled": h ? "true" : void 0,
                  "aria-expanded": X ? "true" : "false",
                  "aria-haspopup": "listbox",
                  "aria-label": i,
                  "aria-labelledby":
                    [_, le].filter(Boolean).join(" ") || void 0,
                  "aria-describedby": a,
                  onKeyDown: (e) => {
                    I ||
                      (-1 !==
                        [" ", "ArrowUp", "ArrowDown", "Enter"].indexOf(e.key) &&
                        (e.preventDefault(), Q(!0, e)));
                  },
                  onMouseDown:
                    h || I
                      ? null
                      : (e) => {
                          0 === e.button &&
                            (e.preventDefault(), Z.current.focus(), Q(!0, e));
                        },
                  onBlur: (e) => {
                    !X &&
                      S &&
                      (Object.defineProperty(e, "target", {
                        writable: !0,
                        value: { value: R, name: x },
                      }),
                      S(e));
                  },
                  onFocus: w,
                },
                j,
                {
                  ownerState: de,
                  className: (0, Et.Z)(j.className, ce.select, c),
                  id: le,
                  children: Pc(ee)
                    ? bc ||
                      (bc = (0, e.jsx)("span", {
                        className: "notranslate",
                        children: "​",
                      }))
                    : ee,
                }
              )
            ),
            (0, e.jsx)(
              Sc,
              (0, u.Z)(
                {
                  "aria-invalid": g,
                  value: Array.isArray(R) ? R.join(",") : R,
                  name: x,
                  ref: F,
                  "aria-hidden": !0,
                  onChange: (e) => {
                    const t = Y.find((t) => t.props.value === e.target.value);
                    void 0 !== t && (L(t.props.value), k && k(e, t));
                  },
                  tabIndex: -1,
                  disabled: h,
                  className: ce.nativeInput,
                  autoFocus: s,
                  ownerState: de,
                },
                E
              )
            ),
            (0, e.jsx)(xc, { as: v, className: ce.icon, ownerState: de }),
            (0, e.jsx)(
              sc,
              (0, u.Z)(
                {
                  id: `menu-${x || ""}`,
                  anchorEl: q,
                  open: X,
                  onClose: (e) => {
                    Q(!1, e);
                  },
                  anchorOrigin: { vertical: "bottom", horizontal: "center" },
                  transformOrigin: { vertical: "top", horizontal: "center" },
                },
                y,
                {
                  MenuListProps: (0, u.Z)(
                    {
                      "aria-labelledby": _,
                      role: "listbox",
                      "aria-multiselectable": C ? "true" : void 0,
                      disableListWrap: !0,
                      id: pe,
                    },
                    y.MenuListProps
                  ),
                  slotProps: (0, u.Z)({}, y.slotProps, {
                    paper: (0, u.Z)({}, ue, {
                      style: (0, u.Z)(
                        { minWidth: se },
                        null != ue ? ue.style : null
                      ),
                    }),
                  }),
                  children: ae,
                }
              )
            ),
          ],
        });
      });
      var Oc = wc,
        Tc = (0, Oo.Z)(
          (0, e.jsx)("path", { d: "M7 10l5 5 5-5z" }),
          "ArrowDropDown"
        );
      const Ic = [
          "autoWidth",
          "children",
          "classes",
          "className",
          "defaultOpen",
          "displayEmpty",
          "IconComponent",
          "id",
          "input",
          "inputProps",
          "label",
          "labelId",
          "MenuProps",
          "multiple",
          "native",
          "onClose",
          "onOpen",
          "open",
          "renderValue",
          "SelectDisplayProps",
          "variant",
        ],
        Mc = ["root"],
        jc = {
          name: "MuiSelect",
          overridesResolver: (e, t) => t.root,
          shouldForwardProp: (e) => (0, vo.Z)(e) && "variant" !== e,
          slot: "Root",
        },
        Nc = (0, Bt.ZP)(Ll, jc)(""),
        Dc = (0, Bt.ZP)(nd, jc)(""),
        Ac = (0, Bt.ZP)(Ul, jc)(""),
        Ec = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ name: "MuiSelect", props: n }),
            {
              autoWidth: a = !1,
              children: i,
              classes: s = {},
              className: l,
              defaultOpen: d = !1,
              displayEmpty: c = !1,
              IconComponent: p = Tc,
              id: m,
              input: h,
              inputProps: f,
              label: g,
              labelId: v,
              MenuProps: b,
              multiple: _ = !1,
              native: y = !1,
              onClose: C,
              onOpen: x,
              open: S,
              renderValue: k,
              SelectDisplayProps: P,
              variant: w = "outlined",
            } = o,
            O = (0, At.Z)(o, Ic),
            T = y ? fc : Oc,
            I = ml({
              props: o,
              muiFormControl: fl(),
              states: ["variant", "error"],
            }),
            M = I.variant || w,
            j = (0, u.Z)({}, o, { variant: M, classes: s }),
            N = ((e) => {
              const { classes: t } = e;
              return t;
            })(j),
            D = (0, At.Z)(N, Mc),
            A =
              h ||
              {
                standard: (0, e.jsx)(Nc, { ownerState: j }),
                outlined: (0, e.jsx)(Dc, { label: g, ownerState: j }),
                filled: (0, e.jsx)(Ac, { ownerState: j }),
              }[M],
            E = (0, hn.Z)(r, hr(A));
          return (0,
          e.jsx)(t.Fragment, { children: t.cloneElement(A, (0, u.Z)({ inputComponent: T, inputProps: (0, u.Z)({ children: i, error: I.error, IconComponent: p, variant: M, type: void 0, multiple: _ }, y ? { id: m } : { autoWidth: a, defaultOpen: d, displayEmpty: c, labelId: v, MenuProps: b, onClose: C, onOpen: x, open: S, renderValue: k, SelectDisplayProps: (0, u.Z)({ id: m }, P) }, f, { classes: f ? (0, al.Z)(D, f.classes) : D }, h ? h.props.inputProps : {}) }, ((_ && y) || c) && "outlined" === M ? { notched: !0 } : {}, { ref: E, className: (0, Et.Z)(A.props.className, l, N.root) }, !h && { variant: M }, O)) });
        });
      Ec.muiName = "Select";
      var Rc = Ec;
      function Lc(e) {
        return (0, Zt.ZP)("MuiTextField", e);
      }
      (0, Ft.Z)("MuiTextField", ["root"]);
      const Bc = [
          "autoComplete",
          "autoFocus",
          "children",
          "className",
          "color",
          "defaultValue",
          "disabled",
          "error",
          "FormHelperTextProps",
          "fullWidth",
          "helperText",
          "id",
          "InputLabelProps",
          "inputProps",
          "InputProps",
          "inputRef",
          "label",
          "maxRows",
          "minRows",
          "multiline",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "placeholder",
          "required",
          "rows",
          "select",
          "SelectProps",
          "type",
          "value",
          "variant",
        ],
        zc = { standard: Ll, filled: Ul, outlined: nd },
        Fc = (0, Bt.ZP)(yd, {
          name: "MuiTextField",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({}),
        Zc = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiTextField" }),
            {
              autoComplete: o,
              autoFocus: a = !1,
              children: i,
              className: s,
              color: l = "primary",
              defaultValue: d,
              disabled: c = !1,
              error: p = !1,
              FormHelperTextProps: m,
              fullWidth: h = !1,
              helperText: f,
              id: g,
              InputLabelProps: v,
              inputProps: b,
              InputProps: _,
              inputRef: y,
              label: C,
              maxRows: x,
              minRows: S,
              multiline: k = !1,
              name: P,
              onBlur: w,
              onChange: O,
              onFocus: T,
              placeholder: I,
              required: M = !1,
              rows: j,
              select: N = !1,
              SelectProps: D,
              type: A,
              value: E,
              variant: R = "outlined",
            } = r,
            L = (0, At.Z)(r, Bc),
            B = (0, u.Z)({}, r, {
              autoFocus: a,
              color: l,
              disabled: c,
              error: p,
              fullWidth: h,
              multiline: k,
              required: M,
              select: N,
              variant: R,
            }),
            z = ((e) => {
              const { classes: t } = e;
              return (0, Rt.Z)({ root: ["root"] }, Lc, t);
            })(B),
            F = {};
          "outlined" === R &&
            (v && void 0 !== v.shrink && (F.notched = v.shrink), (F.label = C)),
            N &&
              ((D && D.native) || (F.id = void 0),
              (F["aria-describedby"] = void 0));
          const Z = (0, ol.Z)(g),
            H = f && Z ? `${Z}-helper-text` : void 0,
            V = C && Z ? `${Z}-label` : void 0,
            W = zc[R],
            U = (0, e.jsx)(
              W,
              (0, u.Z)(
                {
                  "aria-describedby": H,
                  autoComplete: o,
                  autoFocus: a,
                  defaultValue: d,
                  fullWidth: h,
                  multiline: k,
                  name: P,
                  rows: j,
                  maxRows: x,
                  minRows: S,
                  type: A,
                  value: E,
                  id: Z,
                  inputRef: y,
                  onBlur: w,
                  onChange: O,
                  onFocus: T,
                  placeholder: I,
                  inputProps: b,
                },
                F,
                _
              )
            );
          return (0,
          e.jsxs)(Fc, (0, u.Z)({ className: (0, Et.Z)(z.root, s), disabled: c, error: p, fullWidth: h, ref: n, required: M, color: l, variant: R, ownerState: B }, L, { children: [null != C && "" !== C && (0, e.jsx)(hd, (0, u.Z)({ htmlFor: Z, id: V }, v, { children: C })), N ? (0, e.jsx)(Rc, (0, u.Z)({ "aria-describedby": H, id: Z, labelId: V, value: E, input: U }, D, { children: i })) : U, f && (0, e.jsx)(Od, (0, u.Z)({ id: H }, m, { children: f }))] }));
        });
      var Hc = Zc,
        Vc = o(9032),
        Wc = (e) => {
          const n = t.useRef({});
          return (
            t.useEffect(() => {
              n.current = e;
            }),
            n.current
          );
        };
      function Uc(e) {
        return void 0 !== e.normalize
          ? e.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
          : e;
      }
      function $c(e, t) {
        for (let n = 0; n < e.length; n += 1) if (t(e[n])) return n;
        return -1;
      }
      const Kc = (function (e = {}) {
          const {
            ignoreAccents: t = !0,
            ignoreCase: n = !0,
            limit: r,
            matchFrom: o = "any",
            stringify: a,
            trim: i = !1,
          } = e;
          return (e, { inputValue: s, getOptionLabel: l }) => {
            let d = i ? s.trim() : s;
            n && (d = d.toLowerCase()), t && (d = Uc(d));
            const c = d
              ? e.filter((e) => {
                  let r = (a || l)(e);
                  return (
                    n && (r = r.toLowerCase()),
                    t && (r = Uc(r)),
                    "start" === o ? 0 === r.indexOf(d) : r.indexOf(d) > -1
                  );
                })
              : e;
            return "number" == typeof r ? c.slice(0, r) : c;
          };
        })(),
        Gc = (e) => {
          var t;
          return (
            null !== e.current &&
            (null == (t = e.current.parentElement)
              ? void 0
              : t.contains(document.activeElement))
          );
        },
        qc = [];
      function Qc(e) {
        return (0, Zt.ZP)("MuiListSubheader", e);
      }
      (0, Ft.Z)("MuiListSubheader", [
        "root",
        "colorPrimary",
        "colorInherit",
        "gutters",
        "inset",
        "sticky",
      ]);
      const Yc = [
          "className",
          "color",
          "component",
          "disableGutters",
          "disableSticky",
          "inset",
        ],
        Jc = (0, Bt.ZP)("li", {
          name: "MuiListSubheader",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "default" !== n.color && t[`color${(0, $n.Z)(n.color)}`],
              !n.disableGutters && t.gutters,
              n.inset && t.inset,
              !n.disableSticky && t.sticky,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              boxSizing: "border-box",
              lineHeight: "48px",
              listStyle: "none",
              color: (e.vars || e).palette.text.secondary,
              fontFamily: e.typography.fontFamily,
              fontWeight: e.typography.fontWeightMedium,
              fontSize: e.typography.pxToRem(14),
            },
            "primary" === t.color && {
              color: (e.vars || e).palette.primary.main,
            },
            "inherit" === t.color && { color: "inherit" },
            !t.disableGutters && { paddingLeft: 16, paddingRight: 16 },
            t.inset && { paddingLeft: 72 },
            !t.disableSticky && {
              position: "sticky",
              top: 0,
              zIndex: 1,
              backgroundColor: (e.vars || e).palette.background.paper,
            }
          )
        ),
        Xc = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiListSubheader" }),
            {
              className: o,
              color: a = "default",
              component: i = "li",
              disableGutters: s = !1,
              disableSticky: l = !1,
              inset: d = !1,
            } = r,
            c = (0, At.Z)(r, Yc),
            p = (0, u.Z)({}, r, {
              color: a,
              component: i,
              disableGutters: s,
              disableSticky: l,
              inset: d,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  color: n,
                  disableGutters: r,
                  inset: o,
                  disableSticky: a,
                } = e,
                i = {
                  root: [
                    "root",
                    "default" !== n && `color${(0, $n.Z)(n)}`,
                    !r && "gutters",
                    o && "inset",
                    !a && "sticky",
                  ],
                };
              return (0, Rt.Z)(i, Qc, t);
            })(p);
          return (0,
          e.jsx)(Jc, (0, u.Z)({ as: i, className: (0, Et.Z)(m.root, o), ref: n, ownerState: p }, c));
        });
      Xc.muiSkipListHighlight = !0;
      var eu = Xc,
        tu = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z",
          }),
          "Cancel"
        );
      function nu(e) {
        return (0, Zt.ZP)("MuiChip", e);
      }
      var ru = (0, Ft.Z)("MuiChip", [
        "root",
        "sizeSmall",
        "sizeMedium",
        "colorError",
        "colorInfo",
        "colorPrimary",
        "colorSecondary",
        "colorSuccess",
        "colorWarning",
        "disabled",
        "clickable",
        "clickableColorPrimary",
        "clickableColorSecondary",
        "deletable",
        "deletableColorPrimary",
        "deletableColorSecondary",
        "outlined",
        "filled",
        "outlinedPrimary",
        "outlinedSecondary",
        "filledPrimary",
        "filledSecondary",
        "avatar",
        "avatarSmall",
        "avatarMedium",
        "avatarColorPrimary",
        "avatarColorSecondary",
        "icon",
        "iconSmall",
        "iconMedium",
        "iconColorPrimary",
        "iconColorSecondary",
        "label",
        "labelSmall",
        "labelMedium",
        "deleteIcon",
        "deleteIconSmall",
        "deleteIconMedium",
        "deleteIconColorPrimary",
        "deleteIconColorSecondary",
        "deleteIconOutlinedColorPrimary",
        "deleteIconOutlinedColorSecondary",
        "deleteIconFilledColorPrimary",
        "deleteIconFilledColorSecondary",
        "focusVisible",
      ]);
      const ou = [
          "avatar",
          "className",
          "clickable",
          "color",
          "component",
          "deleteIcon",
          "disabled",
          "icon",
          "label",
          "onClick",
          "onDelete",
          "onKeyDown",
          "onKeyUp",
          "size",
          "variant",
          "tabIndex",
          "skipFocusWhenDisabled",
        ],
        au = (0, Bt.ZP)("div", {
          name: "MuiChip",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                color: r,
                iconColor: o,
                clickable: a,
                onDelete: i,
                size: s,
                variant: l,
              } = n;
            return [
              { [`& .${ru.avatar}`]: t.avatar },
              { [`& .${ru.avatar}`]: t[`avatar${(0, $n.Z)(s)}`] },
              { [`& .${ru.avatar}`]: t[`avatarColor${(0, $n.Z)(r)}`] },
              { [`& .${ru.icon}`]: t.icon },
              { [`& .${ru.icon}`]: t[`icon${(0, $n.Z)(s)}`] },
              { [`& .${ru.icon}`]: t[`iconColor${(0, $n.Z)(o)}`] },
              { [`& .${ru.deleteIcon}`]: t.deleteIcon },
              { [`& .${ru.deleteIcon}`]: t[`deleteIcon${(0, $n.Z)(s)}`] },
              { [`& .${ru.deleteIcon}`]: t[`deleteIconColor${(0, $n.Z)(r)}`] },
              {
                [`& .${ru.deleteIcon}`]:
                  t[`deleteIcon${(0, $n.Z)(l)}Color${(0, $n.Z)(r)}`],
              },
              t.root,
              t[`size${(0, $n.Z)(s)}`],
              t[`color${(0, $n.Z)(r)}`],
              a && t.clickable,
              a && "default" !== r && t[`clickableColor${(0, $n.Z)(r)})`],
              i && t.deletable,
              i && "default" !== r && t[`deletableColor${(0, $n.Z)(r)}`],
              t[l],
              t[`${l}${(0, $n.Z)(r)}`],
            ];
          },
        })(
          ({ theme: e, ownerState: t }) => {
            const n =
              "light" === e.palette.mode
                ? e.palette.grey[700]
                : e.palette.grey[300];
            return (0, u.Z)(
              {
                maxWidth: "100%",
                fontFamily: e.typography.fontFamily,
                fontSize: e.typography.pxToRem(13),
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: 32,
                color: (e.vars || e).palette.text.primary,
                backgroundColor: (e.vars || e).palette.action.selected,
                borderRadius: 16,
                whiteSpace: "nowrap",
                transition: e.transitions.create([
                  "background-color",
                  "box-shadow",
                ]),
                cursor: "unset",
                outline: 0,
                textDecoration: "none",
                border: 0,
                padding: 0,
                verticalAlign: "middle",
                boxSizing: "border-box",
                [`&.${ru.disabled}`]: {
                  opacity: (e.vars || e).palette.action.disabledOpacity,
                  pointerEvents: "none",
                },
                [`& .${ru.avatar}`]: {
                  marginLeft: 5,
                  marginRight: -6,
                  width: 24,
                  height: 24,
                  color: e.vars ? e.vars.palette.Chip.defaultAvatarColor : n,
                  fontSize: e.typography.pxToRem(12),
                },
                [`& .${ru.avatarColorPrimary}`]: {
                  color: (e.vars || e).palette.primary.contrastText,
                  backgroundColor: (e.vars || e).palette.primary.dark,
                },
                [`& .${ru.avatarColorSecondary}`]: {
                  color: (e.vars || e).palette.secondary.contrastText,
                  backgroundColor: (e.vars || e).palette.secondary.dark,
                },
                [`& .${ru.avatarSmall}`]: {
                  marginLeft: 4,
                  marginRight: -4,
                  width: 18,
                  height: 18,
                  fontSize: e.typography.pxToRem(10),
                },
                [`& .${ru.icon}`]: (0, u.Z)(
                  { marginLeft: 5, marginRight: -6 },
                  "small" === t.size && {
                    fontSize: 18,
                    marginLeft: 4,
                    marginRight: -4,
                  },
                  t.iconColor === t.color &&
                    (0, u.Z)(
                      {
                        color: e.vars
                          ? e.vars.palette.Chip.defaultIconColor
                          : n,
                      },
                      "default" !== t.color && { color: "inherit" }
                    )
                ),
                [`& .${ru.deleteIcon}`]: (0, u.Z)(
                  {
                    WebkitTapHighlightColor: "transparent",
                    color: e.vars
                      ? `rgba(${e.vars.palette.text.primaryChannel} / 0.26)`
                      : (0, Lt.Fq)(e.palette.text.primary, 0.26),
                    fontSize: 22,
                    cursor: "pointer",
                    margin: "0 5px 0 -6px",
                    "&:hover": {
                      color: e.vars
                        ? `rgba(${e.vars.palette.text.primaryChannel} / 0.4)`
                        : (0, Lt.Fq)(e.palette.text.primary, 0.4),
                    },
                  },
                  "small" === t.size && {
                    fontSize: 16,
                    marginRight: 4,
                    marginLeft: -4,
                  },
                  "default" !== t.color && {
                    color: e.vars
                      ? `rgba(${
                          e.vars.palette[t.color].contrastTextChannel
                        } / 0.7)`
                      : (0, Lt.Fq)(e.palette[t.color].contrastText, 0.7),
                    "&:hover, &:active": {
                      color: (e.vars || e).palette[t.color].contrastText,
                    },
                  }
                ),
              },
              "small" === t.size && { height: 24 },
              "default" !== t.color && {
                backgroundColor: (e.vars || e).palette[t.color].main,
                color: (e.vars || e).palette[t.color].contrastText,
              },
              t.onDelete && {
                [`&.${ru.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, Lt.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
              },
              t.onDelete &&
                "default" !== t.color && {
                  [`&.${ru.focusVisible}`]: {
                    backgroundColor: (e.vars || e).palette[t.color].dark,
                  },
                }
            );
          },
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {},
              t.clickable && {
                userSelect: "none",
                WebkitTapHighlightColor: "transparent",
                cursor: "pointer",
                "&:hover": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                    : (0, Lt.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.hoverOpacity
                      ),
                },
                [`&.${ru.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.action.selectedChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, Lt.Fq)(
                        e.palette.action.selected,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
                "&:active": { boxShadow: (e.vars || e).shadows[1] },
              },
              t.clickable &&
                "default" !== t.color && {
                  [`&:hover, &.${ru.focusVisible}`]: {
                    backgroundColor: (e.vars || e).palette[t.color].dark,
                  },
                }
            ),
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              {},
              "outlined" === t.variant && {
                backgroundColor: "transparent",
                border: e.vars
                  ? `1px solid ${e.vars.palette.Chip.defaultBorder}`
                  : `1px solid ${
                      "light" === e.palette.mode
                        ? e.palette.grey[400]
                        : e.palette.grey[700]
                    }`,
                [`&.${ru.clickable}:hover`]: {
                  backgroundColor: (e.vars || e).palette.action.hover,
                },
                [`&.${ru.focusVisible}`]: {
                  backgroundColor: (e.vars || e).palette.action.focus,
                },
                [`& .${ru.avatar}`]: { marginLeft: 4 },
                [`& .${ru.avatarSmall}`]: { marginLeft: 2 },
                [`& .${ru.icon}`]: { marginLeft: 4 },
                [`& .${ru.iconSmall}`]: { marginLeft: 2 },
                [`& .${ru.deleteIcon}`]: { marginRight: 5 },
                [`& .${ru.deleteIconSmall}`]: { marginRight: 3 },
              },
              "outlined" === t.variant &&
                "default" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                  border: `1px solid ${
                    e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)`
                      : (0, Lt.Fq)(e.palette[t.color].main, 0.7)
                  }`,
                  [`&.${ru.clickable}:hover`]: {
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                          e.vars.palette.action.hoverOpacity
                        })`
                      : (0, Lt.Fq)(
                          e.palette[t.color].main,
                          e.palette.action.hoverOpacity
                        ),
                  },
                  [`&.${ru.focusVisible}`]: {
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                          e.vars.palette.action.focusOpacity
                        })`
                      : (0, Lt.Fq)(
                          e.palette[t.color].main,
                          e.palette.action.focusOpacity
                        ),
                  },
                  [`& .${ru.deleteIcon}`]: {
                    color: e.vars
                      ? `rgba(${e.vars.palette[t.color].mainChannel} / 0.7)`
                      : (0, Lt.Fq)(e.palette[t.color].main, 0.7),
                    "&:hover, &:active": {
                      color: (e.vars || e).palette[t.color].main,
                    },
                  },
                }
            )
        ),
        iu = (0, Bt.ZP)("span", {
          name: "MuiChip",
          slot: "Label",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              { size: r } = n;
            return [t.label, t[`label${(0, $n.Z)(r)}`]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              overflow: "hidden",
              textOverflow: "ellipsis",
              paddingLeft: 12,
              paddingRight: 12,
              whiteSpace: "nowrap",
            },
            "outlined" === e.variant && { paddingLeft: 11, paddingRight: 11 },
            "small" === e.size && { paddingLeft: 8, paddingRight: 8 },
            "small" === e.size &&
              "outlined" === e.variant && { paddingLeft: 7, paddingRight: 7 }
          )
        );
      function su(e) {
        return "Backspace" === e.key || "Delete" === e.key;
      }
      const lu = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiChip" }),
          {
            avatar: a,
            className: i,
            clickable: s,
            color: l = "default",
            component: d,
            deleteIcon: c,
            disabled: p = !1,
            icon: m,
            label: h,
            onClick: f,
            onDelete: g,
            onKeyDown: v,
            onKeyUp: b,
            size: _ = "medium",
            variant: y = "filled",
            tabIndex: C,
            skipFocusWhenDisabled: x = !1,
          } = o,
          S = (0, At.Z)(o, ou),
          k = t.useRef(null),
          P = (0, hn.Z)(k, r),
          w = (e) => {
            e.stopPropagation(), g && g(e);
          },
          O = !(!1 === s || !f) || s,
          T = O || g ? Un : d || "div",
          I = (0, u.Z)({}, o, {
            component: T,
            disabled: p,
            size: _,
            color: l,
            iconColor: (t.isValidElement(m) && m.props.color) || l,
            onDelete: !!g,
            clickable: O,
            variant: y,
          }),
          M = ((e) => {
            const {
                classes: t,
                disabled: n,
                size: r,
                color: o,
                iconColor: a,
                onDelete: i,
                clickable: s,
                variant: l,
              } = e,
              d = {
                root: [
                  "root",
                  l,
                  n && "disabled",
                  `size${(0, $n.Z)(r)}`,
                  `color${(0, $n.Z)(o)}`,
                  s && "clickable",
                  s && `clickableColor${(0, $n.Z)(o)}`,
                  i && "deletable",
                  i && `deletableColor${(0, $n.Z)(o)}`,
                  `${l}${(0, $n.Z)(o)}`,
                ],
                label: ["label", `label${(0, $n.Z)(r)}`],
                avatar: [
                  "avatar",
                  `avatar${(0, $n.Z)(r)}`,
                  `avatarColor${(0, $n.Z)(o)}`,
                ],
                icon: [
                  "icon",
                  `icon${(0, $n.Z)(r)}`,
                  `iconColor${(0, $n.Z)(a)}`,
                ],
                deleteIcon: [
                  "deleteIcon",
                  `deleteIcon${(0, $n.Z)(r)}`,
                  `deleteIconColor${(0, $n.Z)(o)}`,
                  `deleteIcon${(0, $n.Z)(l)}Color${(0, $n.Z)(o)}`,
                ],
              };
            return (0, Rt.Z)(d, nu, t);
          })(I),
          j =
            T === Un
              ? (0, u.Z)(
                  {
                    component: d || "div",
                    focusVisibleClassName: M.focusVisible,
                  },
                  g && { disableRipple: !0 }
                )
              : {};
        let N = null;
        g &&
          (N =
            c && t.isValidElement(c)
              ? t.cloneElement(c, {
                  className: (0, Et.Z)(c.props.className, M.deleteIcon),
                  onClick: w,
                })
              : (0, e.jsx)(tu, {
                  className: (0, Et.Z)(M.deleteIcon),
                  onClick: w,
                }));
        let D = null;
        a &&
          t.isValidElement(a) &&
          (D = t.cloneElement(a, {
            className: (0, Et.Z)(M.avatar, a.props.className),
          }));
        let A = null;
        return (
          m &&
            t.isValidElement(m) &&
            (A = t.cloneElement(m, {
              className: (0, Et.Z)(M.icon, m.props.className),
            })),
          (0, e.jsxs)(
            au,
            (0, u.Z)(
              {
                as: T,
                className: (0, Et.Z)(M.root, i),
                disabled: !(!O || !p) || void 0,
                onClick: f,
                onKeyDown: (e) => {
                  e.currentTarget === e.target && su(e) && e.preventDefault(),
                    v && v(e);
                },
                onKeyUp: (e) => {
                  e.currentTarget === e.target &&
                    (g && su(e)
                      ? g(e)
                      : "Escape" === e.key && k.current && k.current.blur()),
                    b && b(e);
                },
                ref: P,
                tabIndex: x && p ? -1 : C,
                ownerState: I,
              },
              j,
              S,
              {
                children: [
                  D || A,
                  (0, e.jsx)(iu, {
                    className: (0, Et.Z)(M.label),
                    ownerState: I,
                    children: h,
                  }),
                  N,
                ],
              }
            )
          )
        );
      });
      var du = lu,
        cu = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z",
          }),
          "Close"
        );
      function uu(e) {
        return (0, Zt.ZP)("MuiAutocomplete", e);
      }
      var pu,
        mu,
        hu = (0, Ft.Z)("MuiAutocomplete", [
          "root",
          "expanded",
          "fullWidth",
          "focused",
          "focusVisible",
          "tag",
          "tagSizeSmall",
          "tagSizeMedium",
          "hasPopupIcon",
          "hasClearIcon",
          "inputRoot",
          "input",
          "inputFocused",
          "endAdornment",
          "clearIndicator",
          "popupIndicator",
          "popupIndicatorOpen",
          "popper",
          "popperDisablePortal",
          "paper",
          "listbox",
          "loading",
          "noOptions",
          "option",
          "groupLabel",
          "groupUl",
        ]);
      const fu = [
          "autoComplete",
          "autoHighlight",
          "autoSelect",
          "blurOnSelect",
          "ChipProps",
          "className",
          "clearIcon",
          "clearOnBlur",
          "clearOnEscape",
          "clearText",
          "closeText",
          "componentsProps",
          "defaultValue",
          "disableClearable",
          "disableCloseOnSelect",
          "disabled",
          "disabledItemsFocusable",
          "disableListWrap",
          "disablePortal",
          "filterOptions",
          "filterSelectedOptions",
          "forcePopupIcon",
          "freeSolo",
          "fullWidth",
          "getLimitTagsText",
          "getOptionDisabled",
          "getOptionKey",
          "getOptionLabel",
          "isOptionEqualToValue",
          "groupBy",
          "handleHomeEndKeys",
          "id",
          "includeInputInList",
          "inputValue",
          "limitTags",
          "ListboxComponent",
          "ListboxProps",
          "loading",
          "loadingText",
          "multiple",
          "noOptionsText",
          "onChange",
          "onClose",
          "onHighlightChange",
          "onInputChange",
          "onOpen",
          "open",
          "openOnFocus",
          "openText",
          "options",
          "PaperComponent",
          "PopperComponent",
          "popupIcon",
          "readOnly",
          "renderGroup",
          "renderInput",
          "renderOption",
          "renderTags",
          "selectOnFocus",
          "size",
          "slotProps",
          "value",
        ],
        gu = ["ref"],
        vu = ["key"],
        bu = ["key"],
        _u = (0, Bt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e,
              {
                fullWidth: r,
                hasClearIcon: o,
                hasPopupIcon: a,
                inputFocused: i,
                size: s,
              } = n;
            return [
              { [`& .${hu.tag}`]: t.tag },
              { [`& .${hu.tag}`]: t[`tagSize${(0, $n.Z)(s)}`] },
              { [`& .${hu.inputRoot}`]: t.inputRoot },
              { [`& .${hu.input}`]: t.input },
              { [`& .${hu.input}`]: i && t.inputFocused },
              t.root,
              r && t.fullWidth,
              a && t.hasPopupIcon,
              o && t.hasClearIcon,
            ];
          },
        })({
          [`&.${hu.focused} .${hu.clearIndicator}`]: { visibility: "visible" },
          "@media (pointer: fine)": {
            [`&:hover .${hu.clearIndicator}`]: { visibility: "visible" },
          },
          [`& .${hu.tag}`]: { margin: 3, maxWidth: "calc(100% - 6px)" },
          [`& .${hu.inputRoot}`]: {
            [`.${hu.hasPopupIcon}&, .${hu.hasClearIcon}&`]: {
              paddingRight: 30,
            },
            [`.${hu.hasPopupIcon}.${hu.hasClearIcon}&`]: { paddingRight: 56 },
            [`& .${hu.input}`]: { width: 0, minWidth: 30 },
          },
          [`& .${Nl.root}`]: {
            paddingBottom: 1,
            "& .MuiInput-input": { padding: "4px 4px 4px 0px" },
          },
          [`& .${Nl.root}.${xl.sizeSmall}`]: {
            [`& .${Nl.input}`]: { padding: "2px 4px 3px 0" },
          },
          [`& .${Ql.root}`]: {
            padding: 9,
            [`.${hu.hasPopupIcon}&, .${hu.hasClearIcon}&`]: {
              paddingRight: 39,
            },
            [`.${hu.hasPopupIcon}.${hu.hasClearIcon}&`]: { paddingRight: 65 },
            [`& .${hu.input}`]: { padding: "7.5px 4px 7.5px 5px" },
            [`& .${hu.endAdornment}`]: { right: 9 },
          },
          [`& .${Ql.root}.${xl.sizeSmall}`]: {
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 6,
            [`& .${hu.input}`]: { padding: "2.5px 4px 2.5px 8px" },
          },
          [`& .${zl.root}`]: {
            paddingTop: 19,
            paddingLeft: 8,
            [`.${hu.hasPopupIcon}&, .${hu.hasClearIcon}&`]: {
              paddingRight: 39,
            },
            [`.${hu.hasPopupIcon}.${hu.hasClearIcon}&`]: { paddingRight: 65 },
            [`& .${zl.input}`]: { padding: "7px 4px" },
            [`& .${hu.endAdornment}`]: { right: 9 },
          },
          [`& .${zl.root}.${xl.sizeSmall}`]: {
            paddingBottom: 1,
            [`& .${zl.input}`]: { padding: "2.5px 4px" },
          },
          [`& .${xl.hiddenLabel}`]: { paddingTop: 8 },
          [`& .${zl.root}.${xl.hiddenLabel}`]: {
            paddingTop: 0,
            paddingBottom: 0,
            [`& .${hu.input}`]: { paddingTop: 16, paddingBottom: 17 },
          },
          [`& .${zl.root}.${xl.hiddenLabel}.${xl.sizeSmall}`]: {
            [`& .${hu.input}`]: { paddingTop: 8, paddingBottom: 9 },
          },
          [`& .${hu.input}`]: {
            flexGrow: 1,
            textOverflow: "ellipsis",
            opacity: 0,
          },
          variants: [
            { props: { fullWidth: !0 }, style: { width: "100%" } },
            {
              props: { size: "small" },
              style: {
                [`& .${hu.tag}`]: { margin: 2, maxWidth: "calc(100% - 4px)" },
              },
            },
            {
              props: { inputFocused: !0 },
              style: { [`& .${hu.input}`]: { opacity: 1 } },
            },
            {
              props: { multiple: !0 },
              style: { [`& .${hu.inputRoot}`]: { flexWrap: "wrap" } },
            },
          ],
        }),
        yu = (0, Bt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "EndAdornment",
          overridesResolver: (e, t) => t.endAdornment,
        })({
          position: "absolute",
          right: 0,
          top: "50%",
          transform: "translate(0, -50%)",
        }),
        Cu = (0, Bt.ZP)(Jn, {
          name: "MuiAutocomplete",
          slot: "ClearIndicator",
          overridesResolver: (e, t) => t.clearIndicator,
        })({ marginRight: -2, padding: 4, visibility: "hidden" }),
        xu = (0, Bt.ZP)(Jn, {
          name: "MuiAutocomplete",
          slot: "PopupIndicator",
          overridesResolver: ({ ownerState: e }, t) =>
            (0, u.Z)({}, t.popupIndicator, e.popupOpen && t.popupIndicatorOpen),
        })({
          padding: 2,
          marginRight: -2,
          variants: [
            {
              props: { popupOpen: !0 },
              style: { transform: "rotate(180deg)" },
            },
          ],
        }),
        Su = (0, Bt.ZP)(Es, {
          name: "MuiAutocomplete",
          slot: "Popper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${hu.option}`]: t.option },
              t.popper,
              n.disablePortal && t.popperDisablePortal,
            ];
          },
        })(({ theme: e }) => ({
          zIndex: (e.vars || e).zIndex.modal,
          variants: [
            { props: { disablePortal: !0 }, style: { position: "absolute" } },
          ],
        })),
        ku = (0, Bt.ZP)(go, {
          name: "MuiAutocomplete",
          slot: "Paper",
          overridesResolver: (e, t) => t.paper,
        })(({ theme: e }) =>
          (0, u.Z)({}, e.typography.body1, { overflow: "auto" })
        ),
        Pu = (0, Bt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Loading",
          overridesResolver: (e, t) => t.loading,
        })(({ theme: e }) => ({
          color: (e.vars || e).palette.text.secondary,
          padding: "14px 16px",
        })),
        wu = (0, Bt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "NoOptions",
          overridesResolver: (e, t) => t.noOptions,
        })(({ theme: e }) => ({
          color: (e.vars || e).palette.text.secondary,
          padding: "14px 16px",
        })),
        Ou = (0, Bt.ZP)("div", {
          name: "MuiAutocomplete",
          slot: "Listbox",
          overridesResolver: (e, t) => t.listbox,
        })(({ theme: e }) => ({
          listStyle: "none",
          margin: 0,
          padding: "8px 0",
          maxHeight: "40vh",
          overflow: "auto",
          position: "relative",
          [`& .${hu.option}`]: {
            minHeight: 48,
            display: "flex",
            overflow: "hidden",
            justifyContent: "flex-start",
            alignItems: "center",
            cursor: "pointer",
            paddingTop: 6,
            boxSizing: "border-box",
            outline: "0",
            WebkitTapHighlightColor: "transparent",
            paddingBottom: 6,
            paddingLeft: 16,
            paddingRight: 16,
            [e.breakpoints.up("sm")]: { minHeight: "auto" },
            [`&.${hu.focused}`]: {
              backgroundColor: (e.vars || e).palette.action.hover,
              "@media (hover: none)": { backgroundColor: "transparent" },
            },
            '&[aria-disabled="true"]': {
              opacity: (e.vars || e).palette.action.disabledOpacity,
              pointerEvents: "none",
            },
            [`&.${hu.focusVisible}`]: {
              backgroundColor: (e.vars || e).palette.action.focus,
            },
            '&[aria-selected="true"]': {
              backgroundColor: e.vars
                ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                : (0, Lt.Fq)(
                    e.palette.primary.main,
                    e.palette.action.selectedOpacity
                  ),
              [`&.${hu.focused}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                  : (0, Lt.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": {
                  backgroundColor: (e.vars || e).palette.action.selected,
                },
              },
              [`&.${hu.focusVisible}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                  : (0, Lt.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.focusOpacity
                    ),
              },
            },
          },
        })),
        Tu = (0, Bt.ZP)(eu, {
          name: "MuiAutocomplete",
          slot: "GroupLabel",
          overridesResolver: (e, t) => t.groupLabel,
        })(({ theme: e }) => ({
          backgroundColor: (e.vars || e).palette.background.paper,
          top: -8,
        })),
        Iu = (0, Bt.ZP)("ul", {
          name: "MuiAutocomplete",
          slot: "GroupUl",
          overridesResolver: (e, t) => t.groupUl,
        })({ padding: 0, [`& .${hu.option}`]: { paddingLeft: 24 } }),
        Mu = t.forwardRef(function (n, r) {
          var o, a, i, s;
          const l = (0, zt.i)({ props: n, name: "MuiAutocomplete" }),
            {
              autoComplete: d = !1,
              autoHighlight: c = !1,
              autoSelect: p = !1,
              blurOnSelect: m = !1,
              ChipProps: h,
              className: f,
              clearIcon: g = pu || (pu = (0, e.jsx)(cu, { fontSize: "small" })),
              clearOnBlur: v = !l.freeSolo,
              clearOnEscape: b = !1,
              clearText: _ = "Clear",
              closeText: y = "Close",
              componentsProps: C = {},
              defaultValue: x = l.multiple ? [] : null,
              disableClearable: S = !1,
              disableCloseOnSelect: k = !1,
              disabled: P = !1,
              disabledItemsFocusable: w = !1,
              disableListWrap: O = !1,
              disablePortal: T = !1,
              filterSelectedOptions: I = !1,
              forcePopupIcon: M = "auto",
              freeSolo: j = !1,
              fullWidth: N = !1,
              getLimitTagsText: D = (e) => `+${e}`,
              getOptionLabel: A,
              groupBy: E,
              handleHomeEndKeys: R = !l.freeSolo,
              includeInputInList: L = !1,
              limitTags: B = -1,
              ListboxComponent: z = "ul",
              ListboxProps: F,
              loading: Z = !1,
              loadingText: H = "Loading…",
              multiple: V = !1,
              noOptionsText: W = "No options",
              openOnFocus: U = !1,
              openText: $ = "Open",
              PaperComponent: K = go,
              PopperComponent: G = Es,
              popupIcon: q = mu || (mu = (0, e.jsx)(Tc, {})),
              readOnly: Q = !1,
              renderGroup: Y,
              renderInput: J,
              renderOption: X,
              renderTags: ee,
              selectOnFocus: te = !l.freeSolo,
              size: ne = "medium",
              slotProps: re = {},
            } = l,
            oe = (0, At.Z)(l, fu),
            {
              getRootProps: ae,
              getInputProps: ie,
              getInputLabelProps: se,
              getPopupIndicatorProps: le,
              getClearProps: de,
              getTagProps: ce,
              getListboxProps: ue,
              getOptionProps: pe,
              value: me,
              dirty: he,
              expanded: fe,
              id: ge,
              popupOpen: ve,
              focused: be,
              focusedTag: _e,
              anchorEl: ye,
              setAnchorEl: Ce,
              inputValue: xe,
              groupedOptions: Se,
            } = (function (e) {
              const {
                  unstable_isActiveElementInListbox: n = Gc,
                  unstable_classNamePrefix: r = "Mui",
                  autoComplete: o = !1,
                  autoHighlight: a = !1,
                  autoSelect: i = !1,
                  blurOnSelect: s = !1,
                  clearOnBlur: l = !e.freeSolo,
                  clearOnEscape: d = !1,
                  componentName: c = "useAutocomplete",
                  defaultValue: p = e.multiple ? qc : null,
                  disableClearable: m = !1,
                  disableCloseOnSelect: h = !1,
                  disabled: f,
                  disabledItemsFocusable: g = !1,
                  disableListWrap: v = !1,
                  filterOptions: b = Kc,
                  filterSelectedOptions: _ = !1,
                  freeSolo: y = !1,
                  getOptionDisabled: C,
                  getOptionKey: x,
                  getOptionLabel: S = (e) => {
                    var t;
                    return null != (t = e.label) ? t : e;
                  },
                  groupBy: k,
                  handleHomeEndKeys: P = !e.freeSolo,
                  id: w,
                  includeInputInList: O = !1,
                  inputValue: T,
                  isOptionEqualToValue: I = (e, t) => e === t,
                  multiple: M = !1,
                  onChange: j,
                  onClose: N,
                  onHighlightChange: D,
                  onInputChange: A,
                  onOpen: E,
                  open: R,
                  openOnFocus: L = !1,
                  options: B,
                  readOnly: z = !1,
                  selectOnFocus: F = !e.freeSolo,
                  value: Z,
                } = e,
                H = (0, ol.Z)(w);
              let V = S;
              V = (e) => {
                const t = S(e);
                return "string" != typeof t ? String(t) : t;
              };
              const W = t.useRef(!1),
                U = t.useRef(!0),
                $ = t.useRef(null),
                K = t.useRef(null),
                [G, q] = t.useState(null),
                [Q, Y] = t.useState(-1),
                J = a ? 0 : -1,
                X = t.useRef(J),
                [ee, te] = (0, Vc.Z)({ controlled: Z, default: p, name: c }),
                [ne, re] = (0, Vc.Z)({
                  controlled: T,
                  default: "",
                  name: c,
                  state: "inputValue",
                }),
                [oe, ae] = t.useState(!1),
                ie = t.useCallback(
                  (e, t) => {
                    if (!(M ? ee.length < t.length : null !== t) && !l) return;
                    let n;
                    if (M) n = "";
                    else if (null == t) n = "";
                    else {
                      const e = V(t);
                      n = "string" == typeof e ? e : "";
                    }
                    ne !== n && (re(n), A && A(e, n, "reset"));
                  },
                  [V, ne, M, A, re, l, ee]
                ),
                [se, le] = (0, Vc.Z)({
                  controlled: R,
                  default: !1,
                  name: c,
                  state: "open",
                }),
                [de, ce] = t.useState(!0),
                ue = !M && null != ee && ne === V(ee),
                pe = se && !z,
                me = pe
                  ? b(
                      B.filter(
                        (e) =>
                          !_ ||
                          !(M ? ee : [ee]).some((t) => null !== t && I(e, t))
                      ),
                      { inputValue: ue && de ? "" : ne, getOptionLabel: V }
                    )
                  : [],
                he = Wc({ filteredOptions: me, value: ee, inputValue: ne });
              t.useEffect(() => {
                const e = ee !== he.value;
                (oe && !e) || (y && !e) || ie(null, ee);
              }, [ee, ie, oe, he.value, y]);
              const fe = se && me.length > 0 && !z,
                ge = (0, Wr.Z)((e) => {
                  -1 === e
                    ? $.current.focus()
                    : G.querySelector(`[data-tag-index="${e}"]`).focus();
                });
              t.useEffect(() => {
                M && Q > ee.length - 1 && (Y(-1), ge(-1));
              }, [ee, M, Q, ge]);
              const ve = (0, Wr.Z)(
                  ({ event: e, index: t, reason: n = "auto" }) => {
                    if (
                      ((X.current = t),
                      -1 === t
                        ? $.current.removeAttribute("aria-activedescendant")
                        : $.current.setAttribute(
                            "aria-activedescendant",
                            `${H}-option-${t}`
                          ),
                      D && D(e, -1 === t ? null : me[t], n),
                      !K.current)
                    )
                      return;
                    const o = K.current.querySelector(
                      `[role="option"].${r}-focused`
                    );
                    o &&
                      (o.classList.remove(`${r}-focused`),
                      o.classList.remove(`${r}-focusVisible`));
                    let a = K.current;
                    if (
                      ("listbox" !== K.current.getAttribute("role") &&
                        (a =
                          K.current.parentElement.querySelector(
                            '[role="listbox"]'
                          )),
                      !a)
                    )
                      return;
                    if (-1 === t) return void (a.scrollTop = 0);
                    const i = K.current.querySelector(
                      `[data-option-index="${t}"]`
                    );
                    if (
                      i &&
                      (i.classList.add(`${r}-focused`),
                      "keyboard" === n && i.classList.add(`${r}-focusVisible`),
                      a.scrollHeight > a.clientHeight &&
                        "mouse" !== n &&
                        "touch" !== n)
                    ) {
                      const e = i,
                        t = a.clientHeight + a.scrollTop,
                        n = e.offsetTop + e.offsetHeight;
                      n > t
                        ? (a.scrollTop = n - a.clientHeight)
                        : e.offsetTop - e.offsetHeight * (k ? 1.3 : 0) <
                            a.scrollTop &&
                          (a.scrollTop =
                            e.offsetTop - e.offsetHeight * (k ? 1.3 : 0));
                    }
                  }
                ),
                be = (0, Wr.Z)(
                  ({
                    event: e,
                    diff: t,
                    direction: n = "next",
                    reason: r = "auto",
                  }) => {
                    if (!pe) return;
                    const a = (function (e, t) {
                      if (!K.current || e < 0 || e >= me.length) return -1;
                      let n = e;
                      for (;;) {
                        const r = K.current.querySelector(
                            `[data-option-index="${n}"]`
                          ),
                          o =
                            !g &&
                            (!r ||
                              r.disabled ||
                              "true" === r.getAttribute("aria-disabled"));
                        if (r && r.hasAttribute("tabindex") && !o) return n;
                        if (
                          ((n =
                            "next" === t
                              ? (n + 1) % me.length
                              : (n - 1 + me.length) % me.length),
                          n === e)
                        )
                          return -1;
                      }
                    })(
                      (() => {
                        const e = me.length - 1;
                        if ("reset" === t) return J;
                        if ("start" === t) return 0;
                        if ("end" === t) return e;
                        const n = X.current + t;
                        return n < 0
                          ? -1 === n && O
                            ? -1
                            : (v && -1 !== X.current) || Math.abs(t) > 1
                            ? 0
                            : e
                          : n > e
                          ? n === e + 1 && O
                            ? -1
                            : v || Math.abs(t) > 1
                            ? e
                            : 0
                          : n;
                      })(),
                      n
                    );
                    if (
                      (ve({ index: a, reason: r, event: e }),
                      o && "reset" !== t)
                    )
                      if (-1 === a) $.current.value = ne;
                      else {
                        const e = V(me[a]);
                        ($.current.value = e),
                          0 === e.toLowerCase().indexOf(ne.toLowerCase()) &&
                            ne.length > 0 &&
                            $.current.setSelectionRange(ne.length, e.length);
                      }
                  }
                ),
                _e = t.useCallback(() => {
                  if (!pe) return;
                  const e = (() => {
                    if (
                      -1 !== X.current &&
                      he.filteredOptions &&
                      he.filteredOptions.length !== me.length &&
                      he.inputValue === ne &&
                      (M
                        ? ee.length === he.value.length &&
                          he.value.every((e, t) => V(ee[t]) === V(e))
                        : ((e = he.value),
                          (t = ee),
                          (e ? V(e) : "") === (t ? V(t) : "")))
                    ) {
                      const e = he.filteredOptions[X.current];
                      if (e) return $c(me, (t) => V(t) === V(e));
                    }
                    var e, t;
                    return -1;
                  })();
                  if (-1 !== e) return void (X.current = e);
                  const t = M ? ee[0] : ee;
                  if (0 !== me.length && null != t) {
                    if (K.current)
                      if (null == t)
                        X.current >= me.length - 1
                          ? ve({ index: me.length - 1 })
                          : ve({ index: X.current });
                      else {
                        const e = me[X.current];
                        if (M && e && -1 !== $c(ee, (t) => I(e, t))) return;
                        const n = $c(me, (e) => I(e, t));
                        -1 === n ? be({ diff: "reset" }) : ve({ index: n });
                      }
                  } else be({ diff: "reset" });
                }, [me.length, !M && ee, _, be, ve, pe, ne, M]),
                ye = (0, Wr.Z)((e) => {
                  (0, Cr.Z)(K, e), e && _e();
                });
              t.useEffect(() => {
                _e();
              }, [_e]);
              const Ce = (e) => {
                  se || (le(!0), ce(!0), E && E(e));
                },
                xe = (e, t) => {
                  se && (le(!1), N && N(e, t));
                },
                Se = (e, t, n, r) => {
                  if (M) {
                    if (
                      ee.length === t.length &&
                      ee.every((e, n) => e === t[n])
                    )
                      return;
                  } else if (ee === t) return;
                  j && j(e, t, n, r), te(t);
                },
                ke = t.useRef(!1),
                Pe = (e, t, n = "selectOption", r = "options") => {
                  let o = n,
                    a = t;
                  if (M) {
                    a = Array.isArray(ee) ? ee.slice() : [];
                    const e = $c(a, (e) => I(t, e));
                    -1 === e
                      ? a.push(t)
                      : "freeSolo" !== r &&
                        (a.splice(e, 1), (o = "removeOption"));
                  }
                  ie(e, a),
                    Se(e, a, o, { option: t }),
                    h || (e && (e.ctrlKey || e.metaKey)) || xe(e, o),
                    (!0 === s ||
                      ("touch" === s && ke.current) ||
                      ("mouse" === s && !ke.current)) &&
                      $.current.blur();
                },
                we = (e, t) => {
                  if (!M) return;
                  "" === ne && xe(e, "toggleInput");
                  let n = Q;
                  -1 === Q
                    ? "" === ne && "previous" === t && (n = ee.length - 1)
                    : ((n += "next" === t ? 1 : -1),
                      n < 0 && (n = 0),
                      n === ee.length && (n = -1)),
                    (n = (function (e, t) {
                      if (-1 === e) return -1;
                      let n = e;
                      for (;;) {
                        if (
                          ("next" === t && n === ee.length) ||
                          ("previous" === t && -1 === n)
                        )
                          return -1;
                        const e = G.querySelector(`[data-tag-index="${n}"]`);
                        if (
                          e &&
                          e.hasAttribute("tabindex") &&
                          !e.disabled &&
                          "true" !== e.getAttribute("aria-disabled")
                        )
                          return n;
                        n += "next" === t ? 1 : -1;
                      }
                    })(n, t)),
                    Y(n),
                    ge(n);
                },
                Oe = (e) => {
                  (W.current = !0),
                    re(""),
                    A && A(e, "", "clear"),
                    Se(e, M ? [] : null, "clear");
                },
                Te = (e) => (t) => {
                  if (
                    (e.onKeyDown && e.onKeyDown(t),
                    !t.defaultMuiPrevented &&
                      (-1 !== Q &&
                        -1 === ["ArrowLeft", "ArrowRight"].indexOf(t.key) &&
                        (Y(-1), ge(-1)),
                      229 !== t.which))
                  )
                    switch (t.key) {
                      case "Home":
                        pe &&
                          P &&
                          (t.preventDefault(),
                          be({
                            diff: "start",
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }));
                        break;
                      case "End":
                        pe &&
                          P &&
                          (t.preventDefault(),
                          be({
                            diff: "end",
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }));
                        break;
                      case "PageUp":
                        t.preventDefault(),
                          be({
                            diff: -5,
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }),
                          Ce(t);
                        break;
                      case "PageDown":
                        t.preventDefault(),
                          be({
                            diff: 5,
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }),
                          Ce(t);
                        break;
                      case "ArrowDown":
                        t.preventDefault(),
                          be({
                            diff: 1,
                            direction: "next",
                            reason: "keyboard",
                            event: t,
                          }),
                          Ce(t);
                        break;
                      case "ArrowUp":
                        t.preventDefault(),
                          be({
                            diff: -1,
                            direction: "previous",
                            reason: "keyboard",
                            event: t,
                          }),
                          Ce(t);
                        break;
                      case "ArrowLeft":
                        we(t, "previous");
                        break;
                      case "ArrowRight":
                        we(t, "next");
                        break;
                      case "Enter":
                        if (-1 !== X.current && pe) {
                          const e = me[X.current],
                            n = !!C && C(e);
                          if ((t.preventDefault(), n)) return;
                          Pe(t, e, "selectOption"),
                            o &&
                              $.current.setSelectionRange(
                                $.current.value.length,
                                $.current.value.length
                              );
                        } else
                          y &&
                            "" !== ne &&
                            !1 === ue &&
                            (M && t.preventDefault(),
                            Pe(t, ne, "createOption", "freeSolo"));
                        break;
                      case "Escape":
                        pe
                          ? (t.preventDefault(),
                            t.stopPropagation(),
                            xe(t, "escape"))
                          : d &&
                            ("" !== ne || (M && ee.length > 0)) &&
                            (t.preventDefault(), t.stopPropagation(), Oe(t));
                        break;
                      case "Backspace":
                        if (M && !z && "" === ne && ee.length > 0) {
                          const e = -1 === Q ? ee.length - 1 : Q,
                            n = ee.slice();
                          n.splice(e, 1),
                            Se(t, n, "removeOption", { option: ee[e] });
                        }
                        break;
                      case "Delete":
                        if (M && !z && "" === ne && ee.length > 0 && -1 !== Q) {
                          const e = Q,
                            n = ee.slice();
                          n.splice(e, 1),
                            Se(t, n, "removeOption", { option: ee[e] });
                        }
                    }
                },
                Ie = (e) => {
                  ae(!0), L && !W.current && Ce(e);
                },
                Me = (e) => {
                  n(K)
                    ? $.current.focus()
                    : (ae(!1),
                      (U.current = !0),
                      (W.current = !1),
                      i && -1 !== X.current && pe
                        ? Pe(e, me[X.current], "blur")
                        : i && y && "" !== ne
                        ? Pe(e, ne, "blur", "freeSolo")
                        : l && ie(e, ee),
                      xe(e, "blur"));
                },
                je = (e) => {
                  const t = e.target.value;
                  ne !== t && (re(t), ce(!1), A && A(e, t, "input")),
                    "" === t ? m || M || Se(e, null, "clear") : Ce(e);
                },
                Ne = (e) => {
                  const t = Number(
                    e.currentTarget.getAttribute("data-option-index")
                  );
                  X.current !== t &&
                    ve({ event: e, index: t, reason: "mouse" });
                },
                De = (e) => {
                  ve({
                    event: e,
                    index: Number(
                      e.currentTarget.getAttribute("data-option-index")
                    ),
                    reason: "touch",
                  }),
                    (ke.current = !0);
                },
                Ae = (e) => {
                  const t = Number(
                    e.currentTarget.getAttribute("data-option-index")
                  );
                  Pe(e, me[t], "selectOption"), (ke.current = !1);
                },
                Ee = (e) => (t) => {
                  const n = ee.slice();
                  n.splice(e, 1), Se(t, n, "removeOption", { option: ee[e] });
                },
                Re = (e) => {
                  se ? xe(e, "toggleInput") : Ce(e);
                },
                Le = (e) => {
                  e.currentTarget.contains(e.target) &&
                    e.target.getAttribute("id") !== H &&
                    e.preventDefault();
                },
                Be = (e) => {
                  e.currentTarget.contains(e.target) &&
                    ($.current.focus(),
                    F &&
                      U.current &&
                      $.current.selectionEnd - $.current.selectionStart == 0 &&
                      $.current.select(),
                    (U.current = !1));
                },
                ze = (e) => {
                  f || ("" !== ne && se) || Re(e);
                };
              let Fe = y && ne.length > 0;
              Fe = Fe || (M ? ee.length > 0 : null !== ee);
              let Ze = me;
              return (
                k &&
                  (new Map(),
                  (Ze = me.reduce((e, t, n) => {
                    const r = k(t);
                    return (
                      e.length > 0 && e[e.length - 1].group === r
                        ? e[e.length - 1].options.push(t)
                        : e.push({ key: n, index: n, group: r, options: [t] }),
                      e
                    );
                  }, []))),
                f && oe && Me(),
                {
                  getRootProps: (e = {}) =>
                    (0, u.Z)({ "aria-owns": fe ? `${H}-listbox` : null }, e, {
                      onKeyDown: Te(e),
                      onMouseDown: Le,
                      onClick: Be,
                    }),
                  getInputLabelProps: () => ({ id: `${H}-label`, htmlFor: H }),
                  getInputProps: () => ({
                    id: H,
                    value: ne,
                    onBlur: Me,
                    onFocus: Ie,
                    onChange: je,
                    onMouseDown: ze,
                    "aria-activedescendant": pe ? "" : null,
                    "aria-autocomplete": o ? "both" : "list",
                    "aria-controls": fe ? `${H}-listbox` : void 0,
                    "aria-expanded": fe,
                    autoComplete: "off",
                    ref: $,
                    autoCapitalize: "none",
                    spellCheck: "false",
                    role: "combobox",
                    disabled: f,
                  }),
                  getClearProps: () => ({
                    tabIndex: -1,
                    type: "button",
                    onClick: Oe,
                  }),
                  getPopupIndicatorProps: () => ({
                    tabIndex: -1,
                    type: "button",
                    onClick: Re,
                  }),
                  getTagProps: ({ index: e }) =>
                    (0, u.Z)(
                      { key: e, "data-tag-index": e, tabIndex: -1 },
                      !z && { onDelete: Ee(e) }
                    ),
                  getListboxProps: () => ({
                    role: "listbox",
                    id: `${H}-listbox`,
                    "aria-labelledby": `${H}-label`,
                    ref: ye,
                    onMouseDown: (e) => {
                      e.preventDefault();
                    },
                  }),
                  getOptionProps: ({ index: e, option: t }) => {
                    var n;
                    const r = (M ? ee : [ee]).some((e) => null != e && I(t, e)),
                      o = !!C && C(t);
                    return {
                      key: null != (n = null == x ? void 0 : x(t)) ? n : V(t),
                      tabIndex: -1,
                      role: "option",
                      id: `${H}-option-${e}`,
                      onMouseMove: Ne,
                      onClick: Ae,
                      onTouchStart: De,
                      "data-option-index": e,
                      "aria-disabled": o,
                      "aria-selected": r,
                    };
                  },
                  id: H,
                  inputValue: ne,
                  value: ee,
                  dirty: Fe,
                  expanded: pe && G,
                  popupOpen: pe,
                  focused: oe || -1 !== Q,
                  anchorEl: G,
                  setAnchorEl: q,
                  focusedTag: Q,
                  groupedOptions: Ze,
                }
              );
            })((0, u.Z)({}, l, { componentName: "Autocomplete" })),
            ke = !S && !P && he && !Q,
            Pe = (!j || !0 === M) && !1 !== M,
            { onMouseDown: we } = ie(),
            { ref: Oe } = null != F ? F : {},
            Te = ue(),
            { ref: Ie } = Te,
            Me = (0, At.Z)(Te, gu),
            je = (0, hn.Z)(Ie, Oe),
            Ne =
              A ||
              ((e) => {
                var t;
                return null != (t = e.label) ? t : e;
              }),
            De = (0, u.Z)({}, l, {
              disablePortal: T,
              expanded: fe,
              focused: be,
              fullWidth: N,
              getOptionLabel: Ne,
              hasClearIcon: ke,
              hasPopupIcon: Pe,
              inputFocused: -1 === _e,
              popupOpen: ve,
              size: ne,
            }),
            Ae = ((e) => {
              const {
                  classes: t,
                  disablePortal: n,
                  expanded: r,
                  focused: o,
                  fullWidth: a,
                  hasClearIcon: i,
                  hasPopupIcon: s,
                  inputFocused: l,
                  popupOpen: d,
                  size: c,
                } = e,
                u = {
                  root: [
                    "root",
                    r && "expanded",
                    o && "focused",
                    a && "fullWidth",
                    i && "hasClearIcon",
                    s && "hasPopupIcon",
                  ],
                  inputRoot: ["inputRoot"],
                  input: ["input", l && "inputFocused"],
                  tag: ["tag", `tagSize${(0, $n.Z)(c)}`],
                  endAdornment: ["endAdornment"],
                  clearIndicator: ["clearIndicator"],
                  popupIndicator: ["popupIndicator", d && "popupIndicatorOpen"],
                  popper: ["popper", n && "popperDisablePortal"],
                  paper: ["paper"],
                  listbox: ["listbox"],
                  loading: ["loading"],
                  noOptions: ["noOptions"],
                  option: ["option"],
                  groupLabel: ["groupLabel"],
                  groupUl: ["groupUl"],
                };
              return (0, Rt.Z)(u, uu, t);
            })(De);
          let Ee;
          if (V && me.length > 0) {
            const t = (e) =>
              (0, u.Z)({ className: Ae.tag, disabled: P }, ce(e));
            Ee = ee
              ? ee(me, t, De)
              : me.map((n, r) => {
                  const o = t({ index: r }),
                    { key: a } = o,
                    i = (0, At.Z)(o, vu);
                  return (0, e.jsx)(
                    du,
                    (0, u.Z)({ label: Ne(n), size: ne }, i, h),
                    a
                  );
                });
          }
          if (B > -1 && Array.isArray(Ee)) {
            const t = Ee.length - B;
            !be &&
              t > 0 &&
              ((Ee = Ee.splice(0, B)),
              Ee.push(
                (0, e.jsx)(
                  "span",
                  { className: Ae.tag, children: D(t) },
                  Ee.length
                )
              ));
          }
          const Re =
              Y ||
              ((t) =>
                (0, e.jsxs)(
                  "li",
                  {
                    children: [
                      (0, e.jsx)(Tu, {
                        className: Ae.groupLabel,
                        ownerState: De,
                        component: "div",
                        children: t.group,
                      }),
                      (0, e.jsx)(Iu, {
                        className: Ae.groupUl,
                        ownerState: De,
                        children: t.children,
                      }),
                    ],
                  },
                  t.key
                )),
            Le =
              X ||
              ((t, n) => {
                const { key: r } = t,
                  o = (0, At.Z)(t, bu);
                return (0, e.jsx)(
                  "li",
                  (0, u.Z)({}, o, { children: Ne(n) }),
                  r
                );
              }),
            Be = (e, t) => {
              const n = pe({ option: e, index: t });
              return Le(
                (0, u.Z)({}, n, { className: Ae.option }),
                e,
                { selected: n["aria-selected"], index: t, inputValue: xe },
                De
              );
            },
            ze = null != (o = re.clearIndicator) ? o : C.clearIndicator,
            Fe = null != (a = re.paper) ? a : C.paper,
            Ze = null != (i = re.popper) ? i : C.popper,
            He = null != (s = re.popupIndicator) ? s : C.popupIndicator,
            Ve = (t) =>
              (0, e.jsx)(
                Su,
                (0, u.Z)(
                  {
                    as: G,
                    disablePortal: T,
                    style: { width: ye ? ye.clientWidth : null },
                    ownerState: De,
                    role: "presentation",
                    anchorEl: ye,
                    open: ve,
                  },
                  Ze,
                  {
                    className: (0, Et.Z)(
                      Ae.popper,
                      null == Ze ? void 0 : Ze.className
                    ),
                    children: (0, e.jsx)(
                      ku,
                      (0, u.Z)({ ownerState: De, as: K }, Fe, {
                        className: (0, Et.Z)(
                          Ae.paper,
                          null == Fe ? void 0 : Fe.className
                        ),
                        children: t,
                      })
                    ),
                  }
                )
              );
          let We = null;
          return (
            Se.length > 0
              ? (We = Ve(
                  (0, e.jsx)(
                    Ou,
                    (0, u.Z)(
                      { as: z, className: Ae.listbox, ownerState: De },
                      Me,
                      F,
                      {
                        ref: je,
                        children: Se.map((e, t) =>
                          E
                            ? Re({
                                key: e.key,
                                group: e.group,
                                children: e.options.map((t, n) =>
                                  Be(t, e.index + n)
                                ),
                              })
                            : Be(e, t)
                        ),
                      }
                    )
                  )
                ))
              : Z && 0 === Se.length
              ? (We = Ve(
                  (0, e.jsx)(Pu, {
                    className: Ae.loading,
                    ownerState: De,
                    children: H,
                  })
                ))
              : 0 !== Se.length ||
                j ||
                Z ||
                (We = Ve(
                  (0, e.jsx)(wu, {
                    className: Ae.noOptions,
                    ownerState: De,
                    role: "presentation",
                    onMouseDown: (e) => {
                      e.preventDefault();
                    },
                    children: W,
                  })
                )),
            (0, e.jsxs)(t.Fragment, {
              children: [
                (0, e.jsx)(
                  _u,
                  (0, u.Z)(
                    {
                      ref: r,
                      className: (0, Et.Z)(Ae.root, f),
                      ownerState: De,
                    },
                    ae(oe),
                    {
                      children: J({
                        id: ge,
                        disabled: P,
                        fullWidth: !0,
                        size: "small" === ne ? "small" : void 0,
                        InputLabelProps: se(),
                        InputProps: (0, u.Z)(
                          {
                            ref: Ce,
                            className: Ae.inputRoot,
                            startAdornment: Ee,
                            onClick: (e) => {
                              e.target === e.currentTarget && we(e);
                            },
                          },
                          (ke || Pe) && {
                            endAdornment: (0, e.jsxs)(yu, {
                              className: Ae.endAdornment,
                              ownerState: De,
                              children: [
                                ke
                                  ? (0, e.jsx)(
                                      Cu,
                                      (0, u.Z)(
                                        {},
                                        de(),
                                        {
                                          "aria-label": _,
                                          title: _,
                                          ownerState: De,
                                        },
                                        ze,
                                        {
                                          className: (0, Et.Z)(
                                            Ae.clearIndicator,
                                            null == ze ? void 0 : ze.className
                                          ),
                                          children: g,
                                        }
                                      )
                                    )
                                  : null,
                                Pe
                                  ? (0, e.jsx)(
                                      xu,
                                      (0, u.Z)(
                                        {},
                                        le(),
                                        {
                                          disabled: P,
                                          "aria-label": ve ? y : $,
                                          title: ve ? y : $,
                                          ownerState: De,
                                        },
                                        He,
                                        {
                                          className: (0, Et.Z)(
                                            Ae.popupIndicator,
                                            null == He ? void 0 : He.className
                                          ),
                                          children: q,
                                        }
                                      )
                                    )
                                  : null,
                              ],
                            }),
                          }
                        ),
                        inputProps: (0, u.Z)(
                          { className: Ae.input, disabled: P, readOnly: Q },
                          ie()
                        ),
                      }),
                    }
                  )
                ),
                ye ? We : null,
              ],
            })
          );
        });
      var ju = Mu;
      function Nu(e) {
        return (0, Zt.ZP)("MuiInputAdornment", e);
      }
      var Du,
        Au = (0, Ft.Z)("MuiInputAdornment", [
          "root",
          "filled",
          "standard",
          "outlined",
          "positionStart",
          "positionEnd",
          "disablePointerEvents",
          "hiddenLabel",
          "sizeSmall",
        ]);
      const Eu = [
          "children",
          "className",
          "component",
          "disablePointerEvents",
          "disableTypography",
          "position",
          "variant",
        ],
        Ru = (0, Bt.ZP)("div", {
          name: "MuiInputAdornment",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`position${(0, $n.Z)(n.position)}`],
              !0 === n.disablePointerEvents && t.disablePointerEvents,
              t[n.variant],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              display: "flex",
              height: "0.01em",
              maxHeight: "2em",
              alignItems: "center",
              whiteSpace: "nowrap",
              color: (e.vars || e).palette.action.active,
            },
            "filled" === t.variant && {
              [`&.${Au.positionStart}&:not(.${Au.hiddenLabel})`]: {
                marginTop: 16,
              },
            },
            "start" === t.position && { marginRight: 8 },
            "end" === t.position && { marginLeft: 8 },
            !0 === t.disablePointerEvents && { pointerEvents: "none" }
          )
        ),
        Lu = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiInputAdornment" }),
            {
              children: a,
              className: i,
              component: s = "div",
              disablePointerEvents: l = !1,
              disableTypography: d = !1,
              position: c,
              variant: p,
            } = o,
            m = (0, At.Z)(o, Eu),
            h = fl() || {};
          let f = p;
          p && h.variant, h && !f && (f = h.variant);
          const g = (0, u.Z)({}, o, {
              hiddenLabel: h.hiddenLabel,
              size: h.size,
              disablePointerEvents: l,
              position: c,
              variant: f,
            }),
            v = ((e) => {
              const {
                  classes: t,
                  disablePointerEvents: n,
                  hiddenLabel: r,
                  position: o,
                  size: a,
                  variant: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n && "disablePointerEvents",
                    o && `position${(0, $n.Z)(o)}`,
                    i,
                    r && "hiddenLabel",
                    a && `size${(0, $n.Z)(a)}`,
                  ],
                };
              return (0, Rt.Z)(s, Nu, t);
            })(g);
          return (0,
          e.jsx)(hl.Provider, { value: null, children: (0, e.jsx)(Ru, (0, u.Z)({ as: s, ownerState: g, className: (0, Et.Z)(v.root, i), ref: r }, m, { children: "string" != typeof a || d ? (0, e.jsxs)(t.Fragment, { children: ["start" === c ? Du || (Du = (0, e.jsx)("span", { className: "notranslate", children: "​" })) : null, a] }) : (0, e.jsx)(ni, { color: "text.secondary", children: a }) })) });
        });
      var Bu = Lu,
        zu = o(5971);
      function Fu(e) {
        return (0, Zt.ZP)("MuiButton", e);
      }
      var Zu = (0, Ft.Z)("MuiButton", [
          "root",
          "text",
          "textInherit",
          "textPrimary",
          "textSecondary",
          "textSuccess",
          "textError",
          "textInfo",
          "textWarning",
          "outlined",
          "outlinedInherit",
          "outlinedPrimary",
          "outlinedSecondary",
          "outlinedSuccess",
          "outlinedError",
          "outlinedInfo",
          "outlinedWarning",
          "contained",
          "containedInherit",
          "containedPrimary",
          "containedSecondary",
          "containedSuccess",
          "containedError",
          "containedInfo",
          "containedWarning",
          "disableElevation",
          "focusVisible",
          "disabled",
          "colorInherit",
          "colorPrimary",
          "colorSecondary",
          "colorSuccess",
          "colorError",
          "colorInfo",
          "colorWarning",
          "textSizeSmall",
          "textSizeMedium",
          "textSizeLarge",
          "outlinedSizeSmall",
          "outlinedSizeMedium",
          "outlinedSizeLarge",
          "containedSizeSmall",
          "containedSizeMedium",
          "containedSizeLarge",
          "sizeMedium",
          "sizeSmall",
          "sizeLarge",
          "fullWidth",
          "startIcon",
          "endIcon",
          "icon",
          "iconSizeSmall",
          "iconSizeMedium",
          "iconSizeLarge",
        ]),
        Hu = t.createContext({}),
        Vu = t.createContext(void 0);
      const Wu = [
          "children",
          "color",
          "component",
          "className",
          "disabled",
          "disableElevation",
          "disableFocusRipple",
          "endIcon",
          "focusVisibleClassName",
          "fullWidth",
          "size",
          "startIcon",
          "type",
          "variant",
        ],
        Uu = (e) =>
          (0, u.Z)(
            {},
            "small" === e.size && { "& > *:nth-of-type(1)": { fontSize: 18 } },
            "medium" === e.size && { "& > *:nth-of-type(1)": { fontSize: 20 } },
            "large" === e.size && { "& > *:nth-of-type(1)": { fontSize: 22 } }
          ),
        $u = (0, Bt.ZP)(Un, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiButton",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`${n.variant}${(0, $n.Z)(n.color)}`],
              t[`size${(0, $n.Z)(n.size)}`],
              t[`${n.variant}Size${(0, $n.Z)(n.size)}`],
              "inherit" === n.color && t.colorInherit,
              n.disableElevation && t.disableElevation,
              n.fullWidth && t.fullWidth,
            ];
          },
        })(
          ({ theme: e, ownerState: t }) => {
            var n, r;
            const o =
                "light" === e.palette.mode
                  ? e.palette.grey[300]
                  : e.palette.grey[800],
              a =
                "light" === e.palette.mode
                  ? e.palette.grey.A100
                  : e.palette.grey[700];
            return (0, u.Z)(
              {},
              e.typography.button,
              {
                minWidth: 64,
                padding: "6px 16px",
                borderRadius: (e.vars || e).shape.borderRadius,
                transition: e.transitions.create(
                  ["background-color", "box-shadow", "border-color", "color"],
                  { duration: e.transitions.duration.short }
                ),
                "&:hover": (0, u.Z)(
                  {
                    textDecoration: "none",
                    backgroundColor: e.vars
                      ? `rgba(${e.vars.palette.text.primaryChannel} / ${e.vars.palette.action.hoverOpacity})`
                      : (0, Lt.Fq)(
                          e.palette.text.primary,
                          e.palette.action.hoverOpacity
                        ),
                    "@media (hover: none)": { backgroundColor: "transparent" },
                  },
                  "text" === t.variant &&
                    "inherit" !== t.color && {
                      backgroundColor: e.vars
                        ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                            e.vars.palette.action.hoverOpacity
                          })`
                        : (0, Lt.Fq)(
                            e.palette[t.color].main,
                            e.palette.action.hoverOpacity
                          ),
                      "@media (hover: none)": {
                        backgroundColor: "transparent",
                      },
                    },
                  "outlined" === t.variant &&
                    "inherit" !== t.color && {
                      border: `1px solid ${
                        (e.vars || e).palette[t.color].main
                      }`,
                      backgroundColor: e.vars
                        ? `rgba(${e.vars.palette[t.color].mainChannel} / ${
                            e.vars.palette.action.hoverOpacity
                          })`
                        : (0, Lt.Fq)(
                            e.palette[t.color].main,
                            e.palette.action.hoverOpacity
                          ),
                      "@media (hover: none)": {
                        backgroundColor: "transparent",
                      },
                    },
                  "contained" === t.variant && {
                    backgroundColor: e.vars
                      ? e.vars.palette.Button.inheritContainedHoverBg
                      : a,
                    boxShadow: (e.vars || e).shadows[4],
                    "@media (hover: none)": {
                      boxShadow: (e.vars || e).shadows[2],
                      backgroundColor: (e.vars || e).palette.grey[300],
                    },
                  },
                  "contained" === t.variant &&
                    "inherit" !== t.color && {
                      backgroundColor: (e.vars || e).palette[t.color].dark,
                      "@media (hover: none)": {
                        backgroundColor: (e.vars || e).palette[t.color].main,
                      },
                    }
                ),
                "&:active": (0, u.Z)(
                  {},
                  "contained" === t.variant && {
                    boxShadow: (e.vars || e).shadows[8],
                  }
                ),
                [`&.${Zu.focusVisible}`]: (0, u.Z)(
                  {},
                  "contained" === t.variant && {
                    boxShadow: (e.vars || e).shadows[6],
                  }
                ),
                [`&.${Zu.disabled}`]: (0, u.Z)(
                  { color: (e.vars || e).palette.action.disabled },
                  "outlined" === t.variant && {
                    border: `1px solid ${
                      (e.vars || e).palette.action.disabledBackground
                    }`,
                  },
                  "contained" === t.variant && {
                    color: (e.vars || e).palette.action.disabled,
                    boxShadow: (e.vars || e).shadows[0],
                    backgroundColor: (e.vars || e).palette.action
                      .disabledBackground,
                  }
                ),
              },
              "text" === t.variant && { padding: "6px 8px" },
              "text" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                },
              "outlined" === t.variant && {
                padding: "5px 15px",
                border: "1px solid currentColor",
              },
              "outlined" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].main,
                  border: e.vars
                    ? `1px solid rgba(${
                        e.vars.palette[t.color].mainChannel
                      } / 0.5)`
                    : `1px solid ${(0, Lt.Fq)(e.palette[t.color].main, 0.5)}`,
                },
              "contained" === t.variant && {
                color: e.vars
                  ? e.vars.palette.text.primary
                  : null == (n = (r = e.palette).getContrastText)
                  ? void 0
                  : n.call(r, e.palette.grey[300]),
                backgroundColor: e.vars
                  ? e.vars.palette.Button.inheritContainedBg
                  : o,
                boxShadow: (e.vars || e).shadows[2],
              },
              "contained" === t.variant &&
                "inherit" !== t.color && {
                  color: (e.vars || e).palette[t.color].contrastText,
                  backgroundColor: (e.vars || e).palette[t.color].main,
                },
              "inherit" === t.color && {
                color: "inherit",
                borderColor: "currentColor",
              },
              "small" === t.size &&
                "text" === t.variant && {
                  padding: "4px 5px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "text" === t.variant && {
                  padding: "8px 11px",
                  fontSize: e.typography.pxToRem(15),
                },
              "small" === t.size &&
                "outlined" === t.variant && {
                  padding: "3px 9px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "outlined" === t.variant && {
                  padding: "7px 21px",
                  fontSize: e.typography.pxToRem(15),
                },
              "small" === t.size &&
                "contained" === t.variant && {
                  padding: "4px 10px",
                  fontSize: e.typography.pxToRem(13),
                },
              "large" === t.size &&
                "contained" === t.variant && {
                  padding: "8px 22px",
                  fontSize: e.typography.pxToRem(15),
                },
              t.fullWidth && { width: "100%" }
            );
          },
          ({ ownerState: e }) =>
            e.disableElevation && {
              boxShadow: "none",
              "&:hover": { boxShadow: "none" },
              [`&.${Zu.focusVisible}`]: { boxShadow: "none" },
              "&:active": { boxShadow: "none" },
              [`&.${Zu.disabled}`]: { boxShadow: "none" },
            }
        ),
        Ku = (0, Bt.ZP)("span", {
          name: "MuiButton",
          slot: "StartIcon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.startIcon, t[`iconSize${(0, $n.Z)(n.size)}`]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { display: "inherit", marginRight: 8, marginLeft: -4 },
            "small" === e.size && { marginLeft: -2 },
            Uu(e)
          )
        ),
        Gu = (0, Bt.ZP)("span", {
          name: "MuiButton",
          slot: "EndIcon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.endIcon, t[`iconSize${(0, $n.Z)(n.size)}`]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { display: "inherit", marginRight: -4, marginLeft: 8 },
            "small" === e.size && { marginRight: -2 },
            Uu(e)
          )
        ),
        qu = t.forwardRef(function (n, r) {
          const o = t.useContext(Hu),
            a = t.useContext(Vu),
            i = (0, zu.Z)(o, n),
            s = (0, zt.i)({ props: i, name: "MuiButton" }),
            {
              children: l,
              color: d = "primary",
              component: c = "button",
              className: p,
              disabled: m = !1,
              disableElevation: h = !1,
              disableFocusRipple: f = !1,
              endIcon: g,
              focusVisibleClassName: v,
              fullWidth: b = !1,
              size: _ = "medium",
              startIcon: y,
              type: C,
              variant: x = "text",
            } = s,
            S = (0, At.Z)(s, Wu),
            k = (0, u.Z)({}, s, {
              color: d,
              component: c,
              disabled: m,
              disableElevation: h,
              disableFocusRipple: f,
              fullWidth: b,
              size: _,
              type: C,
              variant: x,
            }),
            P = ((e) => {
              const {
                  color: t,
                  disableElevation: n,
                  fullWidth: r,
                  size: o,
                  variant: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    a,
                    `${a}${(0, $n.Z)(t)}`,
                    `size${(0, $n.Z)(o)}`,
                    `${a}Size${(0, $n.Z)(o)}`,
                    `color${(0, $n.Z)(t)}`,
                    n && "disableElevation",
                    r && "fullWidth",
                  ],
                  label: ["label"],
                  startIcon: ["icon", "startIcon", `iconSize${(0, $n.Z)(o)}`],
                  endIcon: ["icon", "endIcon", `iconSize${(0, $n.Z)(o)}`],
                },
                l = (0, Rt.Z)(s, Fu, i);
              return (0, u.Z)({}, i, l);
            })(k),
            w =
              y &&
              (0, e.jsx)(Ku, {
                className: P.startIcon,
                ownerState: k,
                children: y,
              }),
            O =
              g &&
              (0, e.jsx)(Gu, {
                className: P.endIcon,
                ownerState: k,
                children: g,
              }),
            T = a || "";
          return (0,
          e.jsxs)($u, (0, u.Z)({ ownerState: k, className: (0, Et.Z)(o.className, P.root, p, T), component: c, disabled: m, focusRipple: !f, focusVisibleClassName: (0, Et.Z)(P.focusVisible, v), ref: r, type: C }, S, { classes: P, children: [w, l, O] }));
        });
      var Qu = qu;
      function Yu(e) {
        return (0, Zt.ZP)("MuiTableContainer", e);
      }
      (0, Ft.Z)("MuiTableContainer", ["root"]);
      const Ju = ["className", "component"],
        Xu = (0, Bt.ZP)("div", {
          name: "MuiTableContainer",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ width: "100%", overflowX: "auto" });
      var ep = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiTableContainer" }),
            { className: o, component: a = "div" } = r,
            i = (0, At.Z)(r, Ju),
            s = (0, u.Z)({}, r, { component: a }),
            l = ((e) => {
              const { classes: t } = e;
              return (0, Rt.Z)({ root: ["root"] }, Yu, t);
            })(s);
          return (0,
          e.jsx)(Xu, (0, u.Z)({ ref: n, as: a, className: (0, Et.Z)(l.root, o), ownerState: s }, i));
        }),
        tp = t.createContext();
      function np(e) {
        return (0, Zt.ZP)("MuiTable", e);
      }
      (0, Ft.Z)("MuiTable", ["root", "stickyHeader"]);
      const rp = ["className", "component", "padding", "size", "stickyHeader"],
        op = (0, Bt.ZP)("table", {
          name: "MuiTable",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.stickyHeader && t.stickyHeader];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              display: "table",
              width: "100%",
              borderCollapse: "collapse",
              borderSpacing: 0,
              "& caption": (0, u.Z)({}, e.typography.body2, {
                padding: e.spacing(2),
                color: (e.vars || e).palette.text.secondary,
                textAlign: "left",
                captionSide: "bottom",
              }),
            },
            t.stickyHeader && { borderCollapse: "separate" }
          )
        ),
        ap = "table",
        ip = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTable" }),
            {
              className: a,
              component: i = ap,
              padding: s = "normal",
              size: l = "medium",
              stickyHeader: d = !1,
            } = o,
            c = (0, At.Z)(o, rp),
            p = (0, u.Z)({}, o, {
              component: i,
              padding: s,
              size: l,
              stickyHeader: d,
            }),
            m = ((e) => {
              const { classes: t, stickyHeader: n } = e,
                r = { root: ["root", n && "stickyHeader"] };
              return (0, Rt.Z)(r, np, t);
            })(p),
            h = t.useMemo(
              () => ({ padding: s, size: l, stickyHeader: d }),
              [s, l, d]
            );
          return (0,
          e.jsx)(tp.Provider, { value: h, children: (0, e.jsx)(op, (0, u.Z)({ as: i, role: i === ap ? null : "table", ref: r, className: (0, Et.Z)(m.root, a), ownerState: p }, c)) });
        });
      var sp = ip,
        lp = t.createContext();
      function dp(e) {
        return (0, Zt.ZP)("MuiTableHead", e);
      }
      (0, Ft.Z)("MuiTableHead", ["root"]);
      const cp = ["className", "component"],
        up = (0, Bt.ZP)("thead", {
          name: "MuiTableHead",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ display: "table-header-group" }),
        pp = { variant: "head" },
        mp = "thead";
      var hp = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiTableHead" }),
          { className: o, component: a = mp } = r,
          i = (0, At.Z)(r, cp),
          s = (0, u.Z)({}, r, { component: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)({ root: ["root"] }, dp, t);
          })(s);
        return (0,
        e.jsx)(lp.Provider, { value: pp, children: (0, e.jsx)(up, (0, u.Z)({ as: a, className: (0, Et.Z)(l.root, o), ref: n, role: a === mp ? null : "rowgroup", ownerState: s }, i)) });
      });
      function fp(e) {
        return (0, Zt.ZP)("MuiTableRow", e);
      }
      var gp = (0, Ft.Z)("MuiTableRow", [
        "root",
        "selected",
        "hover",
        "head",
        "footer",
      ]);
      const vp = ["className", "component", "hover", "selected"],
        bp = (0, Bt.ZP)("tr", {
          name: "MuiTableRow",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.head && t.head, n.footer && t.footer];
          },
        })(({ theme: e }) => ({
          color: "inherit",
          display: "table-row",
          verticalAlign: "middle",
          outline: 0,
          [`&.${gp.hover}:hover`]: {
            backgroundColor: (e.vars || e).palette.action.hover,
          },
          [`&.${gp.selected}`]: {
            backgroundColor: e.vars
              ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
              : (0, Lt.Fq)(
                  e.palette.primary.main,
                  e.palette.action.selectedOpacity
                ),
            "&:hover": {
              backgroundColor: e.vars
                ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                : (0, Lt.Fq)(
                    e.palette.primary.main,
                    e.palette.action.selectedOpacity +
                      e.palette.action.hoverOpacity
                  ),
            },
          },
        })),
        _p = "tr",
        yp = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTableRow" }),
            {
              className: a,
              component: i = _p,
              hover: s = !1,
              selected: l = !1,
            } = o,
            d = (0, At.Z)(o, vp),
            c = t.useContext(lp),
            p = (0, u.Z)({}, o, {
              component: i,
              hover: s,
              selected: l,
              head: c && "head" === c.variant,
              footer: c && "footer" === c.variant,
            }),
            m = ((e) => {
              const {
                  classes: t,
                  selected: n,
                  hover: r,
                  head: o,
                  footer: a,
                } = e,
                i = {
                  root: [
                    "root",
                    n && "selected",
                    r && "hover",
                    o && "head",
                    a && "footer",
                  ],
                };
              return (0, Rt.Z)(i, fp, t);
            })(p);
          return (0,
          e.jsx)(bp, (0, u.Z)({ as: i, ref: r, className: (0, Et.Z)(m.root, a), role: i === _p ? null : "row", ownerState: p }, d));
        });
      var Cp = yp;
      function xp(e) {
        return (0, Zt.ZP)("MuiTableCell", e);
      }
      var Sp = (0, Ft.Z)("MuiTableCell", [
        "root",
        "head",
        "body",
        "footer",
        "sizeSmall",
        "sizeMedium",
        "paddingCheckbox",
        "paddingNone",
        "alignLeft",
        "alignCenter",
        "alignRight",
        "alignJustify",
        "stickyHeader",
      ]);
      const kp = [
          "align",
          "className",
          "component",
          "padding",
          "scope",
          "size",
          "sortDirection",
          "variant",
        ],
        Pp = (0, Bt.ZP)("td", {
          name: "MuiTableCell",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`size${(0, $n.Z)(n.size)}`],
              "normal" !== n.padding && t[`padding${(0, $n.Z)(n.padding)}`],
              "inherit" !== n.align && t[`align${(0, $n.Z)(n.align)}`],
              n.stickyHeader && t.stickyHeader,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {},
            e.typography.body2,
            {
              display: "table-cell",
              verticalAlign: "inherit",
              borderBottom: e.vars
                ? `1px solid ${e.vars.palette.TableCell.border}`
                : `1px solid\n    ${
                    "light" === e.palette.mode
                      ? (0, Lt.$n)((0, Lt.Fq)(e.palette.divider, 1), 0.88)
                      : (0, Lt._j)((0, Lt.Fq)(e.palette.divider, 1), 0.68)
                  }`,
              textAlign: "left",
              padding: 16,
            },
            "head" === t.variant && {
              color: (e.vars || e).palette.text.primary,
              lineHeight: e.typography.pxToRem(24),
              fontWeight: e.typography.fontWeightMedium,
            },
            "body" === t.variant && {
              color: (e.vars || e).palette.text.primary,
            },
            "footer" === t.variant && {
              color: (e.vars || e).palette.text.secondary,
              lineHeight: e.typography.pxToRem(21),
              fontSize: e.typography.pxToRem(12),
            },
            "small" === t.size && {
              padding: "6px 16px",
              [`&.${Sp.paddingCheckbox}`]: {
                width: 24,
                padding: "0 12px 0 16px",
                "& > *": { padding: 0 },
              },
            },
            "checkbox" === t.padding && { width: 48, padding: "0 0 0 4px" },
            "none" === t.padding && { padding: 0 },
            "left" === t.align && { textAlign: "left" },
            "center" === t.align && { textAlign: "center" },
            "right" === t.align && {
              textAlign: "right",
              flexDirection: "row-reverse",
            },
            "justify" === t.align && { textAlign: "justify" },
            t.stickyHeader && {
              position: "sticky",
              top: 0,
              zIndex: 2,
              backgroundColor: (e.vars || e).palette.background.default,
            }
          )
        ),
        wp = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiTableCell" }),
            {
              align: a = "inherit",
              className: i,
              component: s,
              padding: l,
              scope: d,
              size: c,
              sortDirection: p,
              variant: m,
            } = o,
            h = (0, At.Z)(o, kp),
            f = t.useContext(tp),
            g = t.useContext(lp),
            v = g && "head" === g.variant;
          let b;
          b = s || (v ? "th" : "td");
          let _ = d;
          "td" === b ? (_ = void 0) : !_ && v && (_ = "col");
          const y = m || (g && g.variant),
            C = (0, u.Z)({}, o, {
              align: a,
              component: b,
              padding: l || (f && f.padding ? f.padding : "normal"),
              size: c || (f && f.size ? f.size : "medium"),
              sortDirection: p,
              stickyHeader: "head" === y && f && f.stickyHeader,
              variant: y,
            }),
            x = ((e) => {
              const {
                  classes: t,
                  variant: n,
                  align: r,
                  padding: o,
                  size: a,
                  stickyHeader: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n,
                    i && "stickyHeader",
                    "inherit" !== r && `align${(0, $n.Z)(r)}`,
                    "normal" !== o && `padding${(0, $n.Z)(o)}`,
                    `size${(0, $n.Z)(a)}`,
                  ],
                };
              return (0, Rt.Z)(s, xp, t);
            })(C);
          let S = null;
          return (
            p && (S = "asc" === p ? "ascending" : "descending"),
            (0, e.jsx)(
              Pp,
              (0, u.Z)(
                {
                  as: b,
                  ref: r,
                  className: (0, Et.Z)(x.root, i),
                  "aria-sort": S,
                  scope: _,
                  ownerState: C,
                },
                h
              )
            )
          );
        });
      var Op = wp;
      function Tp(e) {
        return (0, Zt.ZP)("MuiTableBody", e);
      }
      (0, Ft.Z)("MuiTableBody", ["root"]);
      const Ip = ["className", "component"],
        Mp = (0, Bt.ZP)("tbody", {
          name: "MuiTableBody",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ display: "table-row-group" }),
        jp = { variant: "body" },
        Np = "tbody";
      var Dp = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiTableBody" }),
          { className: o, component: a = Np } = r,
          i = (0, At.Z)(r, Ip),
          s = (0, u.Z)({}, r, { component: a }),
          l = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)({ root: ["root"] }, Tp, t);
          })(s);
        return (0,
        e.jsx)(lp.Provider, { value: jp, children: (0, e.jsx)(Mp, (0, u.Z)({ className: (0, Et.Z)(l.root, o), as: a, ref: n, role: a === Np ? null : "rowgroup", ownerState: s }, i)) });
      });
      function Ap(e) {
        return (0, Zt.ZP)("MuiDialog", e);
      }
      var Ep = (0, Ft.Z)("MuiDialog", [
          "root",
          "scrollPaper",
          "scrollBody",
          "container",
          "paper",
          "paperScrollPaper",
          "paperScrollBody",
          "paperWidthFalse",
          "paperWidthXs",
          "paperWidthSm",
          "paperWidthMd",
          "paperWidthLg",
          "paperWidthXl",
          "paperFullWidth",
          "paperFullScreen",
        ]),
        Rp = t.createContext({});
      const Lp = [
          "aria-describedby",
          "aria-labelledby",
          "BackdropComponent",
          "BackdropProps",
          "children",
          "className",
          "disableEscapeKeyDown",
          "fullScreen",
          "fullWidth",
          "maxWidth",
          "onBackdropClick",
          "onClick",
          "onClose",
          "open",
          "PaperComponent",
          "PaperProps",
          "scroll",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ],
        Bp = (0, Bt.ZP)(Vr, {
          name: "MuiDialog",
          slot: "Backdrop",
          overrides: (e, t) => t.backdrop,
        })({ zIndex: -1 }),
        zp = (0, Bt.ZP)(oo, {
          name: "MuiDialog",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ "@media print": { position: "absolute !important" } }),
        Fp = (0, Bt.ZP)("div", {
          name: "MuiDialog",
          slot: "Container",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.container, t[`scroll${(0, $n.Z)(n.scroll)}`]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { height: "100%", "@media print": { height: "auto" }, outline: 0 },
            "paper" === e.scroll && {
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
            "body" === e.scroll && {
              overflowY: "auto",
              overflowX: "hidden",
              textAlign: "center",
              "&::after": {
                content: '""',
                display: "inline-block",
                verticalAlign: "middle",
                height: "100%",
                width: "0",
              },
            }
          )
        ),
        Zp = (0, Bt.ZP)(go, {
          name: "MuiDialog",
          slot: "Paper",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.paper,
              t[`scrollPaper${(0, $n.Z)(n.scroll)}`],
              t[`paperWidth${(0, $n.Z)(String(n.maxWidth))}`],
              n.fullWidth && t.paperFullWidth,
              n.fullScreen && t.paperFullScreen,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              margin: 32,
              position: "relative",
              overflowY: "auto",
              "@media print": { overflowY: "visible", boxShadow: "none" },
            },
            "paper" === t.scroll && {
              display: "flex",
              flexDirection: "column",
              maxHeight: "calc(100% - 64px)",
            },
            "body" === t.scroll && {
              display: "inline-block",
              verticalAlign: "middle",
              textAlign: "left",
            },
            !t.maxWidth && { maxWidth: "calc(100% - 64px)" },
            "xs" === t.maxWidth && {
              maxWidth:
                "px" === e.breakpoints.unit
                  ? Math.max(e.breakpoints.values.xs, 444)
                  : `max(${e.breakpoints.values.xs}${e.breakpoints.unit}, 444px)`,
              [`&.${Ep.paperScrollBody}`]: {
                [e.breakpoints.down(
                  Math.max(e.breakpoints.values.xs, 444) + 64
                )]: { maxWidth: "calc(100% - 64px)" },
              },
            },
            t.maxWidth &&
              "xs" !== t.maxWidth && {
                maxWidth: `${e.breakpoints.values[t.maxWidth]}${
                  e.breakpoints.unit
                }`,
                [`&.${Ep.paperScrollBody}`]: {
                  [e.breakpoints.down(e.breakpoints.values[t.maxWidth] + 64)]: {
                    maxWidth: "calc(100% - 64px)",
                  },
                },
              },
            t.fullWidth && { width: "calc(100% - 64px)" },
            t.fullScreen && {
              margin: 0,
              width: "100%",
              maxWidth: "100%",
              height: "100%",
              maxHeight: "none",
              borderRadius: 0,
              [`&.${Ep.paperScrollBody}`]: { margin: 0, maxWidth: "100%" },
            }
          )
        );
      var Hp = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiDialog" }),
          a = Dr(),
          i = {
            enter: a.transitions.duration.enteringScreen,
            exit: a.transitions.duration.leavingScreen,
          },
          {
            "aria-describedby": s,
            "aria-labelledby": l,
            BackdropComponent: d,
            BackdropProps: c,
            children: p,
            className: m,
            disableEscapeKeyDown: h = !1,
            fullScreen: f = !1,
            fullWidth: g = !1,
            maxWidth: v = "sm",
            onBackdropClick: b,
            onClick: _,
            onClose: y,
            open: C,
            PaperComponent: x = go,
            PaperProps: S = {},
            scroll: k = "paper",
            TransitionComponent: P = zr,
            transitionDuration: w = i,
            TransitionProps: O,
          } = o,
          T = (0, At.Z)(o, Lp),
          I = (0, u.Z)({}, o, {
            disableEscapeKeyDown: h,
            fullScreen: f,
            fullWidth: g,
            maxWidth: v,
            scroll: k,
          }),
          M = ((e) => {
            const {
                classes: t,
                scroll: n,
                maxWidth: r,
                fullWidth: o,
                fullScreen: a,
              } = e,
              i = {
                root: ["root"],
                container: ["container", `scroll${(0, $n.Z)(n)}`],
                paper: [
                  "paper",
                  `paperScroll${(0, $n.Z)(n)}`,
                  `paperWidth${(0, $n.Z)(String(r))}`,
                  o && "paperFullWidth",
                  a && "paperFullScreen",
                ],
              };
            return (0, Rt.Z)(i, Ap, t);
          })(I),
          j = t.useRef(),
          N = (0, ol.Z)(l),
          D = t.useMemo(() => ({ titleId: N }), [N]);
        return (0, e.jsx)(
          zp,
          (0, u.Z)(
            {
              className: (0, Et.Z)(M.root, m),
              closeAfterTransition: !0,
              components: { Backdrop: Bp },
              componentsProps: {
                backdrop: (0, u.Z)({ transitionDuration: w, as: d }, c),
              },
              disableEscapeKeyDown: h,
              onClose: y,
              open: C,
              ref: r,
              onClick: (e) => {
                _ && _(e),
                  j.current &&
                    ((j.current = null), b && b(e), y && y(e, "backdropClick"));
              },
              ownerState: I,
            },
            T,
            {
              children: (0, e.jsx)(
                P,
                (0, u.Z)(
                  { appear: !0, in: C, timeout: w, role: "presentation" },
                  O,
                  {
                    children: (0, e.jsx)(Fp, {
                      className: (0, Et.Z)(M.container),
                      onMouseDown: (e) => {
                        j.current = e.target === e.currentTarget;
                      },
                      ownerState: I,
                      children: (0, e.jsx)(
                        Zp,
                        (0, u.Z)(
                          {
                            as: x,
                            elevation: 24,
                            role: "dialog",
                            "aria-describedby": s,
                            "aria-labelledby": N,
                          },
                          S,
                          {
                            className: (0, Et.Z)(M.paper, S.className),
                            ownerState: I,
                            children: (0, e.jsx)(Rp.Provider, {
                              value: D,
                              children: p,
                            }),
                          }
                        )
                      ),
                    }),
                  }
                )
              ),
            }
          )
        );
      });
      function Vp(e) {
        return (0, Zt.ZP)("MuiDialogContent", e);
      }
      function Wp(e) {
        return (0, Zt.ZP)("MuiDialogTitle", e);
      }
      (0, Ft.Z)("MuiDialogContent", ["root", "dividers"]);
      var Up = (0, Ft.Z)("MuiDialogTitle", ["root"]);
      const $p = ["className", "dividers"],
        Kp = (0, Bt.ZP)("div", {
          name: "MuiDialogContent",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.dividers && t.dividers];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              flex: "1 1 auto",
              WebkitOverflowScrolling: "touch",
              overflowY: "auto",
              padding: "20px 24px",
            },
            t.dividers
              ? {
                  padding: "16px 24px",
                  borderTop: `1px solid ${(e.vars || e).palette.divider}`,
                  borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
                }
              : { [`.${Up.root} + &`]: { paddingTop: 0 } }
          )
        );
      var Gp = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiDialogContent" }),
          { className: o, dividers: a = !1 } = r,
          i = (0, At.Z)(r, $p),
          s = (0, u.Z)({}, r, { dividers: a }),
          l = ((e) => {
            const { classes: t, dividers: n } = e,
              r = { root: ["root", n && "dividers"] };
            return (0, Rt.Z)(r, Vp, t);
          })(s);
        return (0,
        e.jsx)(Kp, (0, u.Z)({ className: (0, Et.Z)(l.root, o), ownerState: s, ref: n }, i));
      });
      function qp(e) {
        return (0, Zt.ZP)("MuiDialogActions", e);
      }
      (0, Ft.Z)("MuiDialogActions", ["root", "spacing"]);
      const Qp = ["className", "disableSpacing"],
        Yp = (0, Bt.ZP)("div", {
          name: "MuiDialogActions",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.disableSpacing && t.spacing];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              display: "flex",
              alignItems: "center",
              padding: 8,
              justifyContent: "flex-end",
              flex: "0 0 auto",
            },
            !e.disableSpacing && {
              "& > :not(style) ~ :not(style)": { marginLeft: 8 },
            }
          )
        );
      var Jp = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiDialogActions" }),
          { className: o, disableSpacing: a = !1 } = r,
          i = (0, At.Z)(r, Qp),
          s = (0, u.Z)({}, r, { disableSpacing: a }),
          l = ((e) => {
            const { classes: t, disableSpacing: n } = e,
              r = { root: ["root", !n && "spacing"] };
            return (0, Rt.Z)(r, qp, t);
          })(s);
        return (0,
        e.jsx)(Yp, (0, u.Z)({ className: (0, Et.Z)(l.root, o), ownerState: s, ref: n }, i));
      });
      function Xp(e) {
        return e.substring(2).toLowerCase();
      }
      function em(n) {
        const {
            children: r,
            disableReactTree: o = !1,
            mouseEvent: a = "onClick",
            onClickAway: i,
            touchEvent: s = "onTouchEnd",
          } = n,
          l = t.useRef(!1),
          d = t.useRef(null),
          c = t.useRef(!1),
          u = t.useRef(!1);
        t.useEffect(
          () => (
            setTimeout(() => {
              c.current = !0;
            }, 0),
            () => {
              c.current = !1;
            }
          ),
          []
        );
        const p = (0, rr.Z)(hr(r), d),
          m = (0, Wr.Z)((e) => {
            const t = u.current;
            u.current = !1;
            const n = (0, fr.Z)(d.current);
            if (
              !c.current ||
              !d.current ||
              ("clientX" in e &&
                (function (e, t) {
                  return (
                    t.documentElement.clientWidth < e.clientX ||
                    t.documentElement.clientHeight < e.clientY
                  );
                })(e, n))
            )
              return;
            if (l.current) return void (l.current = !1);
            let r;
            (r = e.composedPath
              ? e.composedPath().indexOf(d.current) > -1
              : !n.documentElement.contains(e.target) ||
                d.current.contains(e.target)),
              r || (!o && t) || i(e);
          }),
          h = (e) => (t) => {
            u.current = !0;
            const n = r.props[e];
            n && n(t);
          },
          f = { ref: p };
        return (
          !1 !== s && (f[s] = h(s)),
          t.useEffect(() => {
            if (!1 !== s) {
              const e = Xp(s),
                t = (0, fr.Z)(d.current),
                n = () => {
                  l.current = !0;
                };
              return (
                t.addEventListener(e, m),
                t.addEventListener("touchmove", n),
                () => {
                  t.removeEventListener(e, m),
                    t.removeEventListener("touchmove", n);
                }
              );
            }
          }, [m, s]),
          !1 !== a && (f[a] = h(a)),
          t.useEffect(() => {
            if (!1 !== a) {
              const e = Xp(a),
                t = (0, fr.Z)(d.current);
              return (
                t.addEventListener(e, m),
                () => {
                  t.removeEventListener(e, m);
                }
              );
            }
          }, [m, a]),
          (0, e.jsx)(t.Fragment, { children: t.cloneElement(r, f) })
        );
      }
      function tm(e) {
        return (0, Zt.ZP)("MuiSnackbarContent", e);
      }
      (0, Ft.Z)("MuiSnackbarContent", ["root", "message", "action"]);
      const nm = ["action", "className", "message", "role"],
        rm = (0, Bt.ZP)(go, {
          name: "MuiSnackbarContent",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(({ theme: e }) => {
          const t = "light" === e.palette.mode ? 0.8 : 0.98,
            n = (0, Lt._4)(e.palette.background.default, t);
          return (0, u.Z)({}, e.typography.body2, {
            color: e.vars
              ? e.vars.palette.SnackbarContent.color
              : e.palette.getContrastText(n),
            backgroundColor: e.vars ? e.vars.palette.SnackbarContent.bg : n,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            padding: "6px 16px",
            borderRadius: (e.vars || e).shape.borderRadius,
            flexGrow: 1,
            [e.breakpoints.up("sm")]: { flexGrow: "initial", minWidth: 288 },
          });
        }),
        om = (0, Bt.ZP)("div", {
          name: "MuiSnackbarContent",
          slot: "Message",
          overridesResolver: (e, t) => t.message,
        })({ padding: "8px 0" }),
        am = (0, Bt.ZP)("div", {
          name: "MuiSnackbarContent",
          slot: "Action",
          overridesResolver: (e, t) => t.action,
        })({
          display: "flex",
          alignItems: "center",
          marginLeft: "auto",
          paddingLeft: 16,
          marginRight: -8,
        });
      var im = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiSnackbarContent" }),
          { action: o, className: a, message: i, role: s = "alert" } = r,
          l = (0, At.Z)(r, nm),
          d = r,
          c = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)(
              { root: ["root"], action: ["action"], message: ["message"] },
              tm,
              t
            );
          })(d);
        return (0,
        e.jsxs)(rm, (0, u.Z)({ role: s, square: !0, elevation: 6, className: (0, Et.Z)(c.root, a), ownerState: d, ref: n }, l, { children: [(0, e.jsx)(om, { className: c.message, ownerState: d, children: i }), o ? (0, e.jsx)(am, { className: c.action, ownerState: d, children: o }) : null] }));
      });
      function sm(e) {
        return (0, Zt.ZP)("MuiSnackbar", e);
      }
      (0, Ft.Z)("MuiSnackbar", [
        "root",
        "anchorOriginTopCenter",
        "anchorOriginBottomCenter",
        "anchorOriginTopRight",
        "anchorOriginBottomRight",
        "anchorOriginTopLeft",
        "anchorOriginBottomLeft",
      ]);
      const lm = ["onEnter", "onExited"],
        dm = [
          "action",
          "anchorOrigin",
          "autoHideDuration",
          "children",
          "className",
          "ClickAwayListenerProps",
          "ContentProps",
          "disableWindowBlurListener",
          "message",
          "onBlur",
          "onClose",
          "onFocus",
          "onMouseEnter",
          "onMouseLeave",
          "open",
          "resumeHideDuration",
          "TransitionComponent",
          "transitionDuration",
          "TransitionProps",
        ],
        cm = (0, Bt.ZP)("div", {
          name: "MuiSnackbar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[
                `anchorOrigin${(0, $n.Z)(n.anchorOrigin.vertical)}${(0, $n.Z)(
                  n.anchorOrigin.horizontal
                )}`
              ],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              zIndex: (e.vars || e).zIndex.snackbar,
              position: "fixed",
              display: "flex",
              left: 8,
              right: 8,
              justifyContent: "center",
              alignItems: "center",
            },
            "top" === t.anchorOrigin.vertical ? { top: 8 } : { bottom: 8 },
            "left" === t.anchorOrigin.horizontal && {
              justifyContent: "flex-start",
            },
            "right" === t.anchorOrigin.horizontal && {
              justifyContent: "flex-end",
            },
            {
              [e.breakpoints.up("sm")]: (0, u.Z)(
                {},
                "top" === t.anchorOrigin.vertical
                  ? { top: 24 }
                  : { bottom: 24 },
                "center" === t.anchorOrigin.horizontal && {
                  left: "50%",
                  right: "auto",
                  transform: "translateX(-50%)",
                },
                "left" === t.anchorOrigin.horizontal && {
                  left: 24,
                  right: "auto",
                },
                "right" === t.anchorOrigin.horizontal && {
                  right: 24,
                  left: "auto",
                }
              ),
            }
          )
        );
      var um = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiSnackbar" }),
          a = Dr(),
          i = {
            enter: a.transitions.duration.enteringScreen,
            exit: a.transitions.duration.leavingScreen,
          },
          {
            action: s,
            anchorOrigin: { vertical: l, horizontal: d } = {
              vertical: "bottom",
              horizontal: "left",
            },
            autoHideDuration: c = null,
            children: p,
            className: m,
            ClickAwayListenerProps: h,
            ContentProps: f,
            disableWindowBlurListener: g = !1,
            message: v,
            open: b,
            TransitionComponent: _ = pi,
            transitionDuration: y = i,
            TransitionProps: { onEnter: C, onExited: x } = {},
          } = o,
          S = (0, At.Z)(o.TransitionProps, lm),
          k = (0, At.Z)(o, dm),
          P = (0, u.Z)({}, o, {
            anchorOrigin: { vertical: l, horizontal: d },
            autoHideDuration: c,
            disableWindowBlurListener: g,
            TransitionComponent: _,
            transitionDuration: y,
          }),
          w = ((e) => {
            const { classes: t, anchorOrigin: n } = e,
              r = {
                root: [
                  "root",
                  `anchorOrigin${(0, $n.Z)(n.vertical)}${(0, $n.Z)(
                    n.horizontal
                  )}`,
                ],
              };
            return (0, Rt.Z)(r, sm, t);
          })(P),
          { getRootProps: O, onClickAway: T } = (function (e = {}) {
            const {
                autoHideDuration: n = null,
                disableWindowBlurListener: r = !1,
                onClose: o,
                open: a,
                resumeHideDuration: i,
              } = e,
              s = (0, wn.Z)();
            t.useEffect(() => {
              if (a)
                return (
                  document.addEventListener("keydown", e),
                  () => {
                    document.removeEventListener("keydown", e);
                  }
                );
              function e(e) {
                e.defaultPrevented ||
                  ("Escape" !== e.key && "Esc" !== e.key) ||
                  null == o ||
                  o(e, "escapeKeyDown");
              }
            }, [a, o]);
            const l = (0, Wr.Z)((e, t) => {
                null == o || o(e, t);
              }),
              d = (0, Wr.Z)((e) => {
                o &&
                  null != e &&
                  s.start(e, () => {
                    l(null, "timeout");
                  });
              });
            t.useEffect(() => (a && d(n), s.clear), [a, n, d, s]);
            const c = s.clear,
              p = t.useCallback(() => {
                null != n && d(null != i ? i : 0.5 * n);
              }, [n, i, d]),
              m = (e) => (t) => {
                const n = e.onFocus;
                null == n || n(t), c();
              },
              h = (e) => (t) => {
                const n = e.onMouseEnter;
                null == n || n(t), c();
              },
              f = (e) => (t) => {
                const n = e.onMouseLeave;
                null == n || n(t), p();
              };
            return (
              t.useEffect(() => {
                if (!r && a)
                  return (
                    window.addEventListener("focus", p),
                    window.addEventListener("blur", c),
                    () => {
                      window.removeEventListener("focus", p),
                        window.removeEventListener("blur", c);
                    }
                  );
              }, [r, a, p, c]),
              {
                getRootProps: (t = {}) => {
                  const n = (0, u.Z)({}, lr(e), lr(t));
                  return (0, u.Z)({ role: "presentation" }, t, n, {
                    onBlur:
                      ((r = n),
                      (e) => {
                        const t = r.onBlur;
                        null == t || t(e), p();
                      }),
                    onFocus: m(n),
                    onMouseEnter: h(n),
                    onMouseLeave: f(n),
                  });
                  var r;
                },
                onClickAway: (e) => {
                  null == o || o(e, "clickaway");
                },
              }
            );
          })((0, u.Z)({}, P)),
          [I, M] = t.useState(!0),
          j = mr({
            elementType: cm,
            getSlotProps: O,
            externalForwardedProps: k,
            ownerState: P,
            additionalProps: { ref: r },
            className: [w.root, m],
          });
        return !b && I
          ? null
          : (0, e.jsx)(
              em,
              (0, u.Z)({ onClickAway: T }, h, {
                children: (0, e.jsx)(
                  cm,
                  (0, u.Z)({}, j, {
                    children: (0, e.jsx)(
                      _,
                      (0, u.Z)(
                        {
                          appear: !0,
                          in: b,
                          timeout: y,
                          direction: "top" === l ? "down" : "up",
                          onEnter: (e, t) => {
                            M(!1), C && C(e, t);
                          },
                          onExited: (e) => {
                            M(!0), x && x(e);
                          },
                        },
                        S,
                        {
                          children:
                            p ||
                            (0, e.jsx)(
                              im,
                              (0, u.Z)({ message: v, action: s }, f)
                            ),
                        }
                      )
                    ),
                  })
                ),
              })
            );
      });
      const pm = [
          "className",
          "elementType",
          "ownerState",
          "externalForwardedProps",
          "getSlotOwnerState",
          "internalForwardedProps",
        ],
        mm = ["component", "slots", "slotProps"],
        hm = ["component"];
      function fm(e, t) {
        const {
            className: n,
            elementType: r,
            ownerState: o,
            externalForwardedProps: a,
            getSlotOwnerState: i,
            internalForwardedProps: s,
          } = t,
          l = (0, At.Z)(t, pm),
          {
            component: d,
            slots: c = { [e]: void 0 },
            slotProps: p = { [e]: void 0 },
          } = a,
          m = (0, At.Z)(a, mm),
          h = c[e] || r,
          f = ur(p[e], o),
          g = cr(
            (0, u.Z)({ className: n }, l, {
              externalForwardedProps: "root" === e ? m : void 0,
              externalSlotProps: f,
            })
          ),
          {
            props: { component: v },
            internalRef: b,
          } = g,
          _ = (0, At.Z)(g.props, hm),
          y = (0, rr.Z)(b, null == f ? void 0 : f.ref, t.ref),
          C = i ? i(_) : {},
          x = (0, u.Z)({}, o, C),
          S = "root" === e ? v || d : v,
          k = ar(
            h,
            (0, u.Z)(
              {},
              "root" === e && !d && !c[e] && s,
              "root" !== e && !c[e] && s,
              _,
              S && { as: S },
              { ref: y }
            ),
            x
          );
        return (
          Object.keys(C).forEach((e) => {
            delete k[e];
          }),
          [h, k]
        );
      }
      function gm(e) {
        return (0, Zt.ZP)("MuiAlert", e);
      }
      var vm = (0, Ft.Z)("MuiAlert", [
          "root",
          "action",
          "icon",
          "message",
          "filled",
          "colorSuccess",
          "colorInfo",
          "colorWarning",
          "colorError",
          "filledSuccess",
          "filledInfo",
          "filledWarning",
          "filledError",
          "outlined",
          "outlinedSuccess",
          "outlinedInfo",
          "outlinedWarning",
          "outlinedError",
          "standard",
          "standardSuccess",
          "standardInfo",
          "standardWarning",
          "standardError",
        ]),
        bm = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z",
          }),
          "SuccessOutlined"
        ),
        _m = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z",
          }),
          "ReportProblemOutlined"
        ),
        ym = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
          }),
          "ErrorOutline"
        ),
        Cm = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z",
          }),
          "InfoOutlined"
        );
      const xm = [
          "action",
          "children",
          "className",
          "closeText",
          "color",
          "components",
          "componentsProps",
          "icon",
          "iconMapping",
          "onClose",
          "role",
          "severity",
          "slotProps",
          "slots",
          "variant",
        ],
        Sm = (0, Bt.ZP)(go, {
          name: "MuiAlert",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.variant],
              t[`${n.variant}${(0, $n.Z)(n.color || n.severity)}`],
            ];
          },
        })(({ theme: e }) => {
          const t = "light" === e.palette.mode ? Lt._j : Lt.$n,
            n = "light" === e.palette.mode ? Lt.$n : Lt._j;
          return (0, u.Z)({}, e.typography.body2, {
            backgroundColor: "transparent",
            display: "flex",
            padding: "6px 16px",
            variants: [
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.light)
                .map(([r]) => ({
                  props: { colorSeverity: r, variant: "standard" },
                  style: {
                    color: e.vars
                      ? e.vars.palette.Alert[`${r}Color`]
                      : t(e.palette[r].light, 0.6),
                    backgroundColor: e.vars
                      ? e.vars.palette.Alert[`${r}StandardBg`]
                      : n(e.palette[r].light, 0.9),
                    [`& .${vm.icon}`]: e.vars
                      ? { color: e.vars.palette.Alert[`${r}IconColor`] }
                      : { color: e.palette[r].main },
                  },
                })),
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.light)
                .map(([n]) => ({
                  props: { colorSeverity: n, variant: "outlined" },
                  style: {
                    color: e.vars
                      ? e.vars.palette.Alert[`${n}Color`]
                      : t(e.palette[n].light, 0.6),
                    border: `1px solid ${(e.vars || e).palette[n].light}`,
                    [`& .${vm.icon}`]: e.vars
                      ? { color: e.vars.palette.Alert[`${n}IconColor`] }
                      : { color: e.palette[n].main },
                  },
                })),
              ...Object.entries(e.palette)
                .filter(([, e]) => e.main && e.dark)
                .map(([t]) => ({
                  props: { colorSeverity: t, variant: "filled" },
                  style: (0, u.Z)(
                    { fontWeight: e.typography.fontWeightMedium },
                    e.vars
                      ? {
                          color: e.vars.palette.Alert[`${t}FilledColor`],
                          backgroundColor: e.vars.palette.Alert[`${t}FilledBg`],
                        }
                      : {
                          backgroundColor:
                            "dark" === e.palette.mode
                              ? e.palette[t].dark
                              : e.palette[t].main,
                          color: e.palette.getContrastText(e.palette[t].main),
                        }
                  ),
                })),
            ],
          });
        }),
        km = (0, Bt.ZP)("div", {
          name: "MuiAlert",
          slot: "Icon",
          overridesResolver: (e, t) => t.icon,
        })({
          marginRight: 12,
          padding: "7px 0",
          display: "flex",
          fontSize: 22,
          opacity: 0.9,
        }),
        Pm = (0, Bt.ZP)("div", {
          name: "MuiAlert",
          slot: "Message",
          overridesResolver: (e, t) => t.message,
        })({ padding: "8px 0", minWidth: 0, overflow: "auto" }),
        wm = (0, Bt.ZP)("div", {
          name: "MuiAlert",
          slot: "Action",
          overridesResolver: (e, t) => t.action,
        })({
          display: "flex",
          alignItems: "flex-start",
          padding: "4px 0 0 16px",
          marginLeft: "auto",
          marginRight: -8,
        }),
        Om = {
          success: (0, e.jsx)(bm, { fontSize: "inherit" }),
          warning: (0, e.jsx)(_m, { fontSize: "inherit" }),
          error: (0, e.jsx)(ym, { fontSize: "inherit" }),
          info: (0, e.jsx)(Cm, { fontSize: "inherit" }),
        },
        Tm = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiAlert" }),
            {
              action: o,
              children: a,
              className: i,
              closeText: s = "Close",
              color: l,
              components: d = {},
              componentsProps: c = {},
              icon: p,
              iconMapping: m = Om,
              onClose: h,
              role: f = "alert",
              severity: g = "success",
              slotProps: v = {},
              slots: b = {},
              variant: _ = "standard",
            } = r,
            y = (0, At.Z)(r, xm),
            C = (0, u.Z)({}, r, {
              color: l,
              severity: g,
              variant: _,
              colorSeverity: l || g,
            }),
            x = ((e) => {
              const { variant: t, color: n, severity: r, classes: o } = e,
                a = {
                  root: [
                    "root",
                    `color${(0, $n.Z)(n || r)}`,
                    `${t}${(0, $n.Z)(n || r)}`,
                    `${t}`,
                  ],
                  icon: ["icon"],
                  message: ["message"],
                  action: ["action"],
                };
              return (0, Rt.Z)(a, gm, o);
            })(C),
            S = {
              slots: (0, u.Z)(
                { closeButton: d.CloseButton, closeIcon: d.CloseIcon },
                b
              ),
              slotProps: (0, u.Z)({}, c, v),
            },
            [k, P] = fm("closeButton", {
              elementType: Jn,
              externalForwardedProps: S,
              ownerState: C,
            }),
            [w, O] = fm("closeIcon", {
              elementType: cu,
              externalForwardedProps: S,
              ownerState: C,
            });
          return (0,
          e.jsxs)(Sm, (0, u.Z)({ role: f, elevation: 0, ownerState: C, className: (0, Et.Z)(x.root, i), ref: n }, y, { children: [!1 !== p ? (0, e.jsx)(km, { ownerState: C, className: x.icon, children: p || m[g] || Om[g] }) : null, (0, e.jsx)(Pm, { ownerState: C, className: x.message, children: a }), null != o ? (0, e.jsx)(wm, { ownerState: C, className: x.action, children: o }) : null, null == o && h ? (0, e.jsx)(wm, { ownerState: C, className: x.action, children: (0, e.jsx)(k, (0, u.Z)({ size: "small", "aria-label": s, title: s, color: "inherit", onClick: h }, P, { children: (0, e.jsx)(w, (0, u.Z)({ fontSize: "small" }, O)) })) }) : null] }));
        });
      var Im = Tm;
      function Mm(e) {
        const { theme: t, name: n, props: r } = e;
        return t &&
          t.components &&
          t.components[n] &&
          t.components[n].defaultProps
          ? (0, zu.Z)(t.components[n].defaultProps, r)
          : r;
      }
      function jm({ props: e, name: t, defaultTheme: n, themeId: r }) {
        let o = on(n);
        return r && (o = o[r] || o), Mm({ theme: o, name: t, props: e });
      }
      function Nm(e) {
        return (0, Zt.ZP)("MuiCircularProgress", e);
      }
      (0, Ft.Z)("MuiCircularProgress", [
        "root",
        "determinate",
        "indeterminate",
        "colorPrimary",
        "colorSecondary",
        "svg",
        "circle",
        "circleDeterminate",
        "circleIndeterminate",
        "circleDisableShrink",
      ]);
      const Dm = [
        "className",
        "color",
        "disableShrink",
        "size",
        "style",
        "thickness",
        "value",
        "variant",
      ];
      let Am,
        Em,
        Rm,
        Lm,
        Bm = (e) => e;
      const zm = (0, Pn.F4)(
          Am ||
            (Am = Bm`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`)
        ),
        Fm = (0, Pn.F4)(
          Em ||
            (Em = Bm`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`)
        ),
        Zm = (0, Bt.ZP)("span", {
          name: "MuiCircularProgress",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.variant], t[`color${(0, $n.Z)(n.color)}`]];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, u.Z)(
              { display: "inline-block" },
              "determinate" === e.variant && {
                transition: t.transitions.create("transform"),
              },
              "inherit" !== e.color && {
                color: (t.vars || t).palette[e.color].main,
              }
            ),
          ({ ownerState: e }) =>
            "indeterminate" === e.variant &&
            (0, Pn.iv)(
              Rm ||
                (Rm = Bm`
      animation: ${0} 1.4s linear infinite;
    `),
              zm
            )
        ),
        Hm = (0, Bt.ZP)("svg", {
          name: "MuiCircularProgress",
          slot: "Svg",
          overridesResolver: (e, t) => t.svg,
        })({ display: "block" }),
        Vm = (0, Bt.ZP)("circle", {
          name: "MuiCircularProgress",
          slot: "Circle",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.circle,
              t[`circle${(0, $n.Z)(n.variant)}`],
              n.disableShrink && t.circleDisableShrink,
            ];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, u.Z)(
              { stroke: "currentColor" },
              "determinate" === e.variant && {
                transition: t.transitions.create("stroke-dashoffset"),
              },
              "indeterminate" === e.variant && {
                strokeDasharray: "80px, 200px",
                strokeDashoffset: 0,
              }
            ),
          ({ ownerState: e }) =>
            "indeterminate" === e.variant &&
            !e.disableShrink &&
            (0, Pn.iv)(
              Lm ||
                (Lm = Bm`
      animation: ${0} 1.4s ease-in-out infinite;
    `),
              Fm
            )
        ),
        Wm = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiCircularProgress" }),
            {
              className: o,
              color: a = "primary",
              disableShrink: i = !1,
              size: s = 40,
              style: l,
              thickness: d = 3.6,
              value: c = 0,
              variant: p = "indeterminate",
            } = r,
            m = (0, At.Z)(r, Dm),
            h = (0, u.Z)({}, r, {
              color: a,
              disableShrink: i,
              size: s,
              thickness: d,
              value: c,
              variant: p,
            }),
            f = ((e) => {
              const { classes: t, variant: n, color: r, disableShrink: o } = e,
                a = {
                  root: ["root", n, `color${(0, $n.Z)(r)}`],
                  svg: ["svg"],
                  circle: [
                    "circle",
                    `circle${(0, $n.Z)(n)}`,
                    o && "circleDisableShrink",
                  ],
                };
              return (0, Rt.Z)(a, Nm, t);
            })(h),
            g = {},
            v = {},
            b = {};
          if ("determinate" === p) {
            const e = 2 * Math.PI * ((44 - d) / 2);
            (g.strokeDasharray = e.toFixed(3)),
              (b["aria-valuenow"] = Math.round(c)),
              (g.strokeDashoffset = `${(((100 - c) / 100) * e).toFixed(3)}px`),
              (v.transform = "rotate(-90deg)");
          }
          return (0,
          e.jsx)(Zm, (0, u.Z)({ className: (0, Et.Z)(f.root, o), style: (0, u.Z)({ width: s, height: s }, v, l), ownerState: h, ref: n, role: "progressbar" }, b, m, { children: (0, e.jsx)(Hm, { className: f.svg, ownerState: h, viewBox: "22 22 44 44", children: (0, e.jsx)(Vm, { className: f.circle, style: g, ownerState: h, cx: 44, cy: 44, r: (44 - d) / 2, fill: "none", strokeWidth: d }) }) }));
        });
      var Um = Wm;
      function $m(e) {
        return (0, Zt.ZP)("MuiLoadingButton", e);
      }
      var Km = (0, Ft.Z)("MuiLoadingButton", [
        "root",
        "loading",
        "loadingIndicator",
        "loadingIndicatorCenter",
        "loadingIndicatorStart",
        "loadingIndicatorEnd",
        "endIconLoadingEnd",
        "startIconLoadingStart",
      ]);
      const Gm = [
          "children",
          "disabled",
          "id",
          "loading",
          "loadingIndicator",
          "loadingPosition",
          "variant",
        ],
        qm = (0, Bt.ZP)(Qu, {
          shouldForwardProp: (e) =>
            ((e) =>
              "ownerState" !== e &&
              "theme" !== e &&
              "sx" !== e &&
              "as" !== e &&
              "classes" !== e)(e) || "classes" === e,
          name: "MuiLoadingButton",
          slot: "Root",
          overridesResolver: (e, t) => [
            t.root,
            t.startIconLoadingStart && {
              [`& .${Km.startIconLoadingStart}`]: t.startIconLoadingStart,
            },
            t.endIconLoadingEnd && {
              [`& .${Km.endIconLoadingEnd}`]: t.endIconLoadingEnd,
            },
          ],
        })(({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              [`& .${Km.startIconLoadingStart}, & .${Km.endIconLoadingEnd}`]: {
                transition: t.transitions.create(["opacity"], {
                  duration: t.transitions.duration.short,
                }),
                opacity: 0,
              },
            },
            "center" === e.loadingPosition && {
              transition: t.transitions.create(
                ["background-color", "box-shadow", "border-color"],
                { duration: t.transitions.duration.short }
              ),
              [`&.${Km.loading}`]: { color: "transparent" },
            },
            "start" === e.loadingPosition &&
              e.fullWidth && {
                [`& .${Km.startIconLoadingStart}, & .${Km.endIconLoadingEnd}`]:
                  {
                    transition: t.transitions.create(["opacity"], {
                      duration: t.transitions.duration.short,
                    }),
                    opacity: 0,
                    marginRight: -8,
                  },
              },
            "end" === e.loadingPosition &&
              e.fullWidth && {
                [`& .${Km.startIconLoadingStart}, & .${Km.endIconLoadingEnd}`]:
                  {
                    transition: t.transitions.create(["opacity"], {
                      duration: t.transitions.duration.short,
                    }),
                    opacity: 0,
                    marginLeft: -8,
                  },
              }
          )
        ),
        Qm = (0, Bt.ZP)("div", {
          name: "MuiLoadingButton",
          slot: "LoadingIndicator",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.loadingIndicator,
              t[`loadingIndicator${(0, $n.Z)(n.loadingPosition)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { position: "absolute", visibility: "visible", display: "flex" },
            "start" === t.loadingPosition &&
              ("outlined" === t.variant || "contained" === t.variant) && {
                left: "small" === t.size ? 10 : 14,
              },
            "start" === t.loadingPosition &&
              "text" === t.variant && { left: 6 },
            "center" === t.loadingPosition && {
              left: "50%",
              transform: "translate(-50%)",
              color: (e.vars || e).palette.action.disabled,
            },
            "end" === t.loadingPosition &&
              ("outlined" === t.variant || "contained" === t.variant) && {
                right: "small" === t.size ? 10 : 14,
              },
            "end" === t.loadingPosition && "text" === t.variant && { right: 6 },
            "start" === t.loadingPosition &&
              t.fullWidth && { position: "relative", left: -10 },
            "end" === t.loadingPosition &&
              t.fullWidth && { position: "relative", right: -10 }
          )
        );
      var Ym = t.forwardRef(function (t, n) {
          const r = (function ({ props: e, name: t }) {
              return jm({
                props: e,
                name: t,
                defaultTheme: Nr.Z,
                themeId: cn.Z,
              });
            })({ props: t, name: "MuiLoadingButton" }),
            {
              children: o,
              disabled: a = !1,
              id: i,
              loading: s = !1,
              loadingIndicator: l,
              loadingPosition: d = "center",
              variant: c = "text",
            } = r,
            p = (0, At.Z)(r, Gm),
            m = (0, Rs.Z)(i),
            h =
              null != l
                ? l
                : (0, e.jsx)(Um, {
                    "aria-labelledby": m,
                    color: "inherit",
                    size: 16,
                  }),
            f = (0, u.Z)({}, r, {
              disabled: a,
              loading: s,
              loadingIndicator: h,
              loadingPosition: d,
              variant: c,
            }),
            g = ((e) => {
              const { loading: t, loadingPosition: n, classes: r } = e,
                o = {
                  root: ["root", t && "loading"],
                  startIcon: [t && `startIconLoading${(0, $n.Z)(n)}`],
                  endIcon: [t && `endIconLoading${(0, $n.Z)(n)}`],
                  loadingIndicator: [
                    "loadingIndicator",
                    t && `loadingIndicator${(0, $n.Z)(n)}`,
                  ],
                },
                a = (0, Rt.Z)(o, $m, r);
              return (0, u.Z)({}, r, a);
            })(f),
            v = s
              ? (0, e.jsx)(Qm, {
                  className: g.loadingIndicator,
                  ownerState: f,
                  children: h,
                })
              : null;
          return (0,
          e.jsxs)(qm, (0, u.Z)({ disabled: a || s, id: m, ref: n }, p, { variant: c, classes: g, ownerState: f, children: ["end" === f.loadingPosition ? o : v, "end" === f.loadingPosition ? v : o] }));
        }),
        Jm = function (e, t) {
          return (
            (Jm =
              Object.setPrototypeOf ||
              ({ __proto__: [] } instanceof Array &&
                function (e, t) {
                  e.__proto__ = t;
                }) ||
              function (e, t) {
                for (var n in t)
                  Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
              }),
            Jm(e, t)
          );
        };
      function Xm(e, t) {
        if ("function" != typeof t && null !== t)
          throw new TypeError(
            "Class extends value " + String(t) + " is not a constructor or null"
          );
        function n() {
          this.constructor = e;
        }
        Jm(e, t),
          (e.prototype =
            null === t
              ? Object.create(t)
              : ((n.prototype = t.prototype), new n()));
      }
      function eh(e) {
        var t = "function" == typeof Symbol && Symbol.iterator,
          n = t && e[t],
          r = 0;
        if (n) return n.call(e);
        if (e && "number" == typeof e.length)
          return {
            next: function () {
              return (
                e && r >= e.length && (e = void 0),
                { value: e && e[r++], done: !e }
              );
            },
          };
        throw new TypeError(
          t ? "Object is not iterable." : "Symbol.iterator is not defined."
        );
      }
      function th(e, t) {
        var n = "function" == typeof Symbol && e[Symbol.iterator];
        if (!n) return e;
        var r,
          o,
          a = n.call(e),
          i = [];
        try {
          for (; (void 0 === t || t-- > 0) && !(r = a.next()).done; )
            i.push(r.value);
        } catch (e) {
          o = { error: e };
        } finally {
          try {
            r && !r.done && (n = a.return) && n.call(a);
          } finally {
            if (o) throw o.error;
          }
        }
        return i;
      }
      function nh(e, t, n) {
        if (n || 2 === arguments.length)
          for (var r, o = 0, a = t.length; o < a; o++)
            (!r && o in t) ||
              (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
        return e.concat(r || Array.prototype.slice.call(t));
      }
      function rh(e) {
        return "function" == typeof e;
      }
      function oh(e) {
        var t = e(function (e) {
          Error.call(e), (e.stack = new Error().stack);
        });
        return (
          (t.prototype = Object.create(Error.prototype)),
          (t.prototype.constructor = t),
          t
        );
      }
      Object.create,
        Object.create,
        "function" == typeof SuppressedError && SuppressedError;
      var ah = oh(function (e) {
        return function (t) {
          e(this),
            (this.message = t
              ? t.length +
                " errors occurred during unsubscription:\n" +
                t
                  .map(function (e, t) {
                    return t + 1 + ") " + e.toString();
                  })
                  .join("\n  ")
              : ""),
            (this.name = "UnsubscriptionError"),
            (this.errors = t);
        };
      });
      function ih(e, t) {
        if (e) {
          var n = e.indexOf(t);
          0 <= n && e.splice(n, 1);
        }
      }
      var sh = (function () {
          function e(e) {
            (this.initialTeardown = e),
              (this.closed = !1),
              (this._parentage = null),
              (this._finalizers = null);
          }
          var t;
          return (
            (e.prototype.unsubscribe = function () {
              var e, t, n, r, o;
              if (!this.closed) {
                this.closed = !0;
                var a = this._parentage;
                if (a)
                  if (((this._parentage = null), Array.isArray(a)))
                    try {
                      for (var i = eh(a), s = i.next(); !s.done; s = i.next())
                        s.value.remove(this);
                    } catch (t) {
                      e = { error: t };
                    } finally {
                      try {
                        s && !s.done && (t = i.return) && t.call(i);
                      } finally {
                        if (e) throw e.error;
                      }
                    }
                  else a.remove(this);
                var l = this.initialTeardown;
                if (rh(l))
                  try {
                    l();
                  } catch (e) {
                    o = e instanceof ah ? e.errors : [e];
                  }
                var d = this._finalizers;
                if (d) {
                  this._finalizers = null;
                  try {
                    for (var c = eh(d), u = c.next(); !u.done; u = c.next()) {
                      var p = u.value;
                      try {
                        ch(p);
                      } catch (e) {
                        (o = null != o ? o : []),
                          e instanceof ah
                            ? (o = nh(nh([], th(o)), th(e.errors)))
                            : o.push(e);
                      }
                    }
                  } catch (e) {
                    n = { error: e };
                  } finally {
                    try {
                      u && !u.done && (r = c.return) && r.call(c);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
                if (o) throw new ah(o);
              }
            }),
            (e.prototype.add = function (t) {
              var n;
              if (t && t !== this)
                if (this.closed) ch(t);
                else {
                  if (t instanceof e) {
                    if (t.closed || t._hasParent(this)) return;
                    t._addParent(this);
                  }
                  (this._finalizers =
                    null !== (n = this._finalizers) && void 0 !== n
                      ? n
                      : []).push(t);
                }
            }),
            (e.prototype._hasParent = function (e) {
              var t = this._parentage;
              return t === e || (Array.isArray(t) && t.includes(e));
            }),
            (e.prototype._addParent = function (e) {
              var t = this._parentage;
              this._parentage = Array.isArray(t)
                ? (t.push(e), t)
                : t
                ? [t, e]
                : e;
            }),
            (e.prototype._removeParent = function (e) {
              var t = this._parentage;
              t === e ? (this._parentage = null) : Array.isArray(t) && ih(t, e);
            }),
            (e.prototype.remove = function (t) {
              var n = this._finalizers;
              n && ih(n, t), t instanceof e && t._removeParent(this);
            }),
            (e.EMPTY = (((t = new e()).closed = !0), t)),
            e
          );
        })(),
        lh = sh.EMPTY;
      function dh(e) {
        return (
          e instanceof sh ||
          (e && "closed" in e && rh(e.remove) && rh(e.add) && rh(e.unsubscribe))
        );
      }
      function ch(e) {
        rh(e) ? e() : e.unsubscribe();
      }
      var uh = null,
        ph = null,
        mh = void 0,
        hh = !1,
        fh = !1,
        gh = {
          setTimeout: function (e, t) {
            for (var n = [], r = 2; r < arguments.length; r++)
              n[r - 2] = arguments[r];
            var o = gh.delegate;
            return (null == o ? void 0 : o.setTimeout)
              ? o.setTimeout.apply(o, nh([e, t], th(n)))
              : setTimeout.apply(void 0, nh([e, t], th(n)));
          },
          clearTimeout: function (e) {
            var t = gh.delegate;
            return ((null == t ? void 0 : t.clearTimeout) || clearTimeout)(e);
          },
          delegate: void 0,
        };
      function vh() {}
      var bh = _h("C", void 0, void 0);
      function _h(e, t, n) {
        return { kind: e, value: t, error: n };
      }
      var yh = null;
      function Ch(e) {
        if (hh) {
          var t = !yh;
          if ((t && (yh = { errorThrown: !1, error: null }), e(), t)) {
            var n = yh,
              r = n.errorThrown,
              o = n.error;
            if (((yh = null), r)) throw o;
          }
        } else e();
      }
      var xh = (function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return (
              (n.isStopped = !1),
              t
                ? ((n.destination = t), dh(t) && t.add(n))
                : (n.destination = Ih),
              n
            );
          }
          return (
            Xm(t, e),
            (t.create = function (e, t, n) {
              return new wh(e, t, n);
            }),
            (t.prototype.next = function (e) {
              this.isStopped
                ? Th(
                    (function (e) {
                      return _h("N", e, void 0);
                    })(e),
                    this
                  )
                : this._next(e);
            }),
            (t.prototype.error = function (e) {
              this.isStopped
                ? Th(_h("E", void 0, e), this)
                : ((this.isStopped = !0), this._error(e));
            }),
            (t.prototype.complete = function () {
              this.isStopped
                ? Th(bh, this)
                : ((this.isStopped = !0), this._complete());
            }),
            (t.prototype.unsubscribe = function () {
              this.closed ||
                ((this.isStopped = !0),
                e.prototype.unsubscribe.call(this),
                (this.destination = null));
            }),
            (t.prototype._next = function (e) {
              this.destination.next(e);
            }),
            (t.prototype._error = function (e) {
              try {
                this.destination.error(e);
              } finally {
                this.unsubscribe();
              }
            }),
            (t.prototype._complete = function () {
              try {
                this.destination.complete();
              } finally {
                this.unsubscribe();
              }
            }),
            t
          );
        })(sh),
        Sh = Function.prototype.bind;
      function kh(e, t) {
        return Sh.call(e, t);
      }
      var Ph = (function () {
          function e(e) {
            this.partialObserver = e;
          }
          return (
            (e.prototype.next = function (e) {
              var t = this.partialObserver;
              if (t.next)
                try {
                  t.next(e);
                } catch (e) {
                  Oh(e);
                }
            }),
            (e.prototype.error = function (e) {
              var t = this.partialObserver;
              if (t.error)
                try {
                  t.error(e);
                } catch (e) {
                  Oh(e);
                }
              else Oh(e);
            }),
            (e.prototype.complete = function () {
              var e = this.partialObserver;
              if (e.complete)
                try {
                  e.complete();
                } catch (e) {
                  Oh(e);
                }
            }),
            e
          );
        })(),
        wh = (function (e) {
          function t(t, n, r) {
            var o,
              a,
              i = e.call(this) || this;
            return (
              rh(t) || !t
                ? (o = {
                    next: null != t ? t : void 0,
                    error: null != n ? n : void 0,
                    complete: null != r ? r : void 0,
                  })
                : i && fh
                ? (((a = Object.create(t)).unsubscribe = function () {
                    return i.unsubscribe();
                  }),
                  (o = {
                    next: t.next && kh(t.next, a),
                    error: t.error && kh(t.error, a),
                    complete: t.complete && kh(t.complete, a),
                  }))
                : (o = t),
              (i.destination = new Ph(o)),
              i
            );
          }
          return Xm(t, e), t;
        })(xh);
      function Oh(e) {
        var t;
        hh
          ? ((t = e), hh && yh && ((yh.errorThrown = !0), (yh.error = t)))
          : (function (e) {
              gh.setTimeout(function () {
                if (!uh) throw e;
                uh(e);
              });
            })(e);
      }
      function Th(e, t) {
        var n = ph;
        n &&
          gh.setTimeout(function () {
            return n(e, t);
          });
      }
      var Ih = {
          closed: !0,
          next: vh,
          error: function (e) {
            throw e;
          },
          complete: vh,
        },
        Mh =
          ("function" == typeof Symbol && Symbol.observable) || "@@observable";
      function jh(e) {
        return e;
      }
      var Nh = (function () {
        function e(e) {
          e && (this._subscribe = e);
        }
        return (
          (e.prototype.lift = function (t) {
            var n = new e();
            return (n.source = this), (n.operator = t), n;
          }),
          (e.prototype.subscribe = function (e, t, n) {
            var r,
              o = this,
              a =
                ((r = e) && r instanceof xh) ||
                ((function (e) {
                  return e && rh(e.next) && rh(e.error) && rh(e.complete);
                })(r) &&
                  dh(r))
                  ? e
                  : new wh(e, t, n);
            return (
              Ch(function () {
                var e = o,
                  t = e.operator,
                  n = e.source;
                a.add(
                  t ? t.call(a, n) : n ? o._subscribe(a) : o._trySubscribe(a)
                );
              }),
              a
            );
          }),
          (e.prototype._trySubscribe = function (e) {
            try {
              return this._subscribe(e);
            } catch (t) {
              e.error(t);
            }
          }),
          (e.prototype.forEach = function (e, t) {
            var n = this;
            return new (t = Dh(t))(function (t, r) {
              var o = new wh({
                next: function (t) {
                  try {
                    e(t);
                  } catch (e) {
                    r(e), o.unsubscribe();
                  }
                },
                error: r,
                complete: t,
              });
              n.subscribe(o);
            });
          }),
          (e.prototype._subscribe = function (e) {
            var t;
            return null === (t = this.source) || void 0 === t
              ? void 0
              : t.subscribe(e);
          }),
          (e.prototype[Mh] = function () {
            return this;
          }),
          (e.prototype.pipe = function () {
            for (var e = [], t = 0; t < arguments.length; t++)
              e[t] = arguments[t];
            return (
              0 === (n = e).length
                ? jh
                : 1 === n.length
                ? n[0]
                : function (e) {
                    return n.reduce(function (e, t) {
                      return t(e);
                    }, e);
                  }
            )(this);
            var n;
          }),
          (e.prototype.toPromise = function (e) {
            var t = this;
            return new (e = Dh(e))(function (e, n) {
              var r;
              t.subscribe(
                function (e) {
                  return (r = e);
                },
                function (e) {
                  return n(e);
                },
                function () {
                  return e(r);
                }
              );
            });
          }),
          (e.create = function (t) {
            return new e(t);
          }),
          e
        );
      })();
      function Dh(e) {
        var t;
        return null !== (t = null != e ? e : mh) && void 0 !== t ? t : Promise;
      }
      var Ah = oh(function (e) {
          return function () {
            e(this),
              (this.name = "ObjectUnsubscribedError"),
              (this.message = "object unsubscribed");
          };
        }),
        Eh = (function (e) {
          function t() {
            var t = e.call(this) || this;
            return (
              (t.closed = !1),
              (t.currentObservers = null),
              (t.observers = []),
              (t.isStopped = !1),
              (t.hasError = !1),
              (t.thrownError = null),
              t
            );
          }
          return (
            Xm(t, e),
            (t.prototype.lift = function (e) {
              var t = new Rh(this, this);
              return (t.operator = e), t;
            }),
            (t.prototype._throwIfClosed = function () {
              if (this.closed) throw new Ah();
            }),
            (t.prototype.next = function (e) {
              var t = this;
              Ch(function () {
                var n, r;
                if ((t._throwIfClosed(), !t.isStopped)) {
                  t.currentObservers ||
                    (t.currentObservers = Array.from(t.observers));
                  try {
                    for (
                      var o = eh(t.currentObservers), a = o.next();
                      !a.done;
                      a = o.next()
                    )
                      a.value.next(e);
                  } catch (e) {
                    n = { error: e };
                  } finally {
                    try {
                      a && !a.done && (r = o.return) && r.call(o);
                    } finally {
                      if (n) throw n.error;
                    }
                  }
                }
              });
            }),
            (t.prototype.error = function (e) {
              var t = this;
              Ch(function () {
                if ((t._throwIfClosed(), !t.isStopped)) {
                  (t.hasError = t.isStopped = !0), (t.thrownError = e);
                  for (var n = t.observers; n.length; ) n.shift().error(e);
                }
              });
            }),
            (t.prototype.complete = function () {
              var e = this;
              Ch(function () {
                if ((e._throwIfClosed(), !e.isStopped)) {
                  e.isStopped = !0;
                  for (var t = e.observers; t.length; ) t.shift().complete();
                }
              });
            }),
            (t.prototype.unsubscribe = function () {
              (this.isStopped = this.closed = !0),
                (this.observers = this.currentObservers = null);
            }),
            Object.defineProperty(t.prototype, "observed", {
              get: function () {
                var e;
                return (
                  (null === (e = this.observers) || void 0 === e
                    ? void 0
                    : e.length) > 0
                );
              },
              enumerable: !1,
              configurable: !0,
            }),
            (t.prototype._trySubscribe = function (t) {
              return (
                this._throwIfClosed(), e.prototype._trySubscribe.call(this, t)
              );
            }),
            (t.prototype._subscribe = function (e) {
              return (
                this._throwIfClosed(),
                this._checkFinalizedStatuses(e),
                this._innerSubscribe(e)
              );
            }),
            (t.prototype._innerSubscribe = function (e) {
              var t = this,
                n = this,
                r = n.hasError,
                o = n.isStopped,
                a = n.observers;
              return r || o
                ? lh
                : ((this.currentObservers = null),
                  a.push(e),
                  new sh(function () {
                    (t.currentObservers = null), ih(a, e);
                  }));
            }),
            (t.prototype._checkFinalizedStatuses = function (e) {
              var t = this,
                n = t.hasError,
                r = t.thrownError,
                o = t.isStopped;
              n ? e.error(r) : o && e.complete();
            }),
            (t.prototype.asObservable = function () {
              var e = new Nh();
              return (e.source = this), e;
            }),
            (t.create = function (e, t) {
              return new Rh(e, t);
            }),
            t
          );
        })(Nh),
        Rh = (function (e) {
          function t(t, n) {
            var r = e.call(this) || this;
            return (r.destination = t), (r.source = n), r;
          }
          return (
            Xm(t, e),
            (t.prototype.next = function (e) {
              var t, n;
              null ===
                (n =
                  null === (t = this.destination) || void 0 === t
                    ? void 0
                    : t.next) ||
                void 0 === n ||
                n.call(t, e);
            }),
            (t.prototype.error = function (e) {
              var t, n;
              null ===
                (n =
                  null === (t = this.destination) || void 0 === t
                    ? void 0
                    : t.error) ||
                void 0 === n ||
                n.call(t, e);
            }),
            (t.prototype.complete = function () {
              var e, t;
              null ===
                (t =
                  null === (e = this.destination) || void 0 === e
                    ? void 0
                    : e.complete) ||
                void 0 === t ||
                t.call(e);
            }),
            (t.prototype._subscribe = function (e) {
              var t, n;
              return null !==
                (n =
                  null === (t = this.source) || void 0 === t
                    ? void 0
                    : t.subscribe(e)) && void 0 !== n
                ? n
                : lh;
            }),
            t
          );
        })(Eh),
        Lh = (function (e) {
          function t(t) {
            var n = e.call(this) || this;
            return (n._value = t), n;
          }
          return (
            Xm(t, e),
            Object.defineProperty(t.prototype, "value", {
              get: function () {
                return this.getValue();
              },
              enumerable: !1,
              configurable: !0,
            }),
            (t.prototype._subscribe = function (t) {
              var n = e.prototype._subscribe.call(this, t);
              return !n.closed && t.next(this._value), n;
            }),
            (t.prototype.getValue = function () {
              var e = this,
                t = e.hasError,
                n = e.thrownError,
                r = e._value;
              if (t) throw n;
              return this._throwIfClosed(), r;
            }),
            (t.prototype.next = function (t) {
              e.prototype.next.call(this, (this._value = t));
            }),
            t
          );
        })(Eh),
        Bh = new Lh(!1),
        zh = new Lh(!1),
        Fh = new Lh(!1),
        Zh = new Lh(!1),
        Hh = new Lh({ searchText: "", orderTab: "" }),
        Vh = o(9669),
        Wh = o.n(Vh),
        Uh = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        $h = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Kh = rf().shopName;
      function Gh(e, t, n, r) {
        return Uh(this, void 0, void 0, function () {
          var o, a;
          return $h(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  i.trys.push([0, 8, , 9]),
                  (o = void 0),
                  "GET" !== n
                    ? [3, 3]
                    : [
                        4,
                        qh(e).then(function (e) {
                          return e;
                        }),
                      ]
                );
              case 1:
                return [4, Jh((o = i.sent()).data)];
              case 2:
                return [2, i.sent()];
              case 3:
                return [
                  4,
                  Qh(e, t, r).then(function (e) {
                    return e;
                  }),
                ];
              case 4:
                return 0 == (o = i.sent()).data || 200 !== o.status
                  ? [3, 6]
                  : (null == e ? void 0 : e.includes("pageIndex=44")) ||
                    (null == e ? void 0 : e.includes("pageIndex=02")) ||
                    (null == e ? void 0 : e.includes("pageIndex=14")) ||
                    (null == e ? void 0 : e.includes("pageIndex=52"))
                  ? [2, o]
                  : ((a = o), [4, Jh(o.data)]);
              case 5:
                if (
                  ((a.data = i.sent()),
                  (null == e ? void 0 : e.includes("pageIndex=0")) ||
                    (null == e ? void 0 : e.includes("pageIndex=31")) ||
                    (null == e ? void 0 : e.includes("pageIndex=30")))
                )
                  return [2, o];
                i.label = 6;
              case 6:
                return [2, o.data];
              case 7:
                return [3, 9];
              case 8:
                return i.sent(), [2, null];
              case 9:
                return [2];
            }
          });
        });
      }
      function qh(e) {
        return Uh(this, void 0, void 0, function () {
          var t = this;
          return $h(this, function (n) {
            return [
              2,
              Wh()({ method: "GET", url: e, headers: sf() })
                .then(function (e) {
                  return Uh(t, void 0, void 0, function () {
                    return $h(this, function (t) {
                      return [2, e];
                    });
                  });
                })
                .catch(function (e) {
                  return e.response;
                }),
            ];
          });
        });
      }
      function Qh(e, t, n) {
        return Uh(this, void 0, void 0, function () {
          return $h(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  Wh()({
                    method: "POST",
                    url: e,
                    headers: sf(),
                    params: { shop: Kh },
                    data: t ? (n ? t : JSON.stringify(t)) : "",
                  })
                    .then(function (e) {
                      return (function (e) {
                        return (
                          "string" != typeof (null == e ? void 0 : e.data) &&
                            null === (null == e ? void 0 : e.data) &&
                            "" === (null == e ? void 0 : e.data) &&
                            (e.data = !1),
                          e
                        );
                      })(e);
                    })
                    .catch(function (e) {
                      return e.response;
                    }),
                ];
              case 1:
                return [2, r.sent()];
            }
          });
        });
      }
      function Yh(e) {
        return Uh(this, void 0, void 0, function () {
          var t, n, r, o, a, i, s, l, d;
          return $h(this, function (c) {
            switch (c.label) {
              case 0:
                return (
                  c.trys.push([0, 3, , 4]),
                  (t = JSON.stringify(e)),
                  (n = new TextEncoder()),
                  (r = n.encode(t)),
                  [
                    4,
                    crypto.subtle.importKey(
                      "raw",
                      n.encode("nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ"),
                      "AES-CBC",
                      !1,
                      ["encrypt"]
                    ),
                  ]
                );
              case 1:
                return (
                  (o = c.sent()),
                  (a = crypto.getRandomValues(new Uint8Array(16))),
                  [4, crypto.subtle.encrypt({ name: "AES-CBC", iv: a }, o, r)]
                );
              case 2:
                return (
                  (i = c.sent()),
                  (s = new Uint8Array(
                    (null == a ? void 0 : a.length) + i.byteLength
                  )).set(a),
                  s.set(new Uint8Array(i), null == a ? void 0 : a.length),
                  (l = Array.from(s)),
                  [
                    2,
                    null !== (d = btoa(String.fromCharCode.apply(null, l)))
                      ? btoa(d)
                      : null,
                  ]
                );
              case 3:
                return c.sent(), [2, null];
              case 4:
                return [2];
            }
          });
        });
      }
      function Jh(e) {
        var t;
        return Uh(this, void 0, void 0, function () {
          var n, r, o, a, i, s, l, d;
          return $h(this, function (c) {
            switch (c.label) {
              case 0:
                return (
                  c.trys.push([0, 3, , 4]),
                  (n =
                    null === (t = Array.from(atob(e))) || void 0 === t
                      ? void 0
                      : t.map(function (e) {
                          return e.charCodeAt(0);
                        })),
                  (r = new Uint8Array(n)),
                  (o = r.slice(0, 16)),
                  (a = r.slice(16)),
                  [
                    4,
                    crypto.subtle.importKey(
                      "raw",
                      new TextEncoder().encode(
                        "nuH2aoKmHFHl8pNCzAOfbPoEx5JFTZPZ"
                      ),
                      "AES-CBC",
                      !1,
                      ["decrypt"]
                    ),
                  ]
                );
              case 1:
                return (
                  (i = c.sent()),
                  [4, crypto.subtle.decrypt({ name: "AES-CBC", iv: o }, i, a)]
                );
              case 2:
                return (
                  (s = c.sent()),
                  (l = new TextDecoder()),
                  (d = l.decode(s)),
                  [2, JSON.parse(d)]
                );
              case 3:
                return c.sent(), [2, null];
              case 4:
                return [2];
            }
          });
        });
      }
      var Xh = function () {
          return (
            (Xh =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Xh.apply(this, arguments)
          );
        },
        ef = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        tf = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        nf = "";
      function rf() {
        return F.getState().salesRepData.loggedInRepDetails;
      }
      function of() {
        zh.next(!0),
          Bh.next(!1),
          setTimeout(function () {
            zh.next(!1);
          }, 2e3);
      }
      function af() {
        var e = sessionStorage.getItem("Authorization");
        return (nf = e ? JSON.parse(atob(e)) : "");
      }
      function sf() {
        var e = sessionStorage.getItem("Authorization");
        return {
          Authorization: "Bearer " + (nf = e ? JSON.parse(atob(e)) : "").token,
          STApiVersion: "V2",
          XEncryptedPayload: "true",
        };
      }
      var lf = rf(),
        df = (lf.customerId, lf.customerName, lf.shopName),
        cf = (nf.CustomerId, nf.SalesRepName),
        uf = "https://" + rf().baseUrlShopName + "/apps/SalesRep";
      function pf() {
        var e = af(),
          t = e.CustomerId,
          n = e.SalesRepName;
        return uf + "?customerId=" + t + "&customerName=" + n + "&shop=" + df;
      }
      function mf() {
        return ef(this, void 0, void 0, function () {
          var e;
          return tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&data=1", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (of(), [2, !1]);
            }
          });
        });
      }
      function hf() {
        return ef(this, void 0, void 0, function () {
          var e;
          return tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&data=18", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (of(), [2, !1]);
            }
          });
        });
      }
      function ff() {
        return ef(this, void 0, void 0, function () {
          var e;
          return tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&data=8", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (of(), [2, !1]);
            }
          });
        });
      }
      function gf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o;
          return tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  t.SalesRepName,
                  [
                    4,
                    Yh(
                      JSON.stringify({
                        salesrepId: n,
                        couponCode: e.discountCode,
                        Discount: e.discountValue,
                      })
                    ),
                  ]
                );
              case 1:
                return (
                  (r = a.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + r + "&pageIndex=3", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (o = a.sent()) ? [2, o] : (of(), [2, !1]);
            }
          });
        });
      }
      function vf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Yh(JSON.stringify(e))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + t + "&pageIndex=4", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function bf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    Yh(
                      JSON.stringify(
                        Xh(Xh({}, e), { SalesRepId: n, SalesRepName: r })
                      )
                    ),
                  ]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + o + "&pageIndex=13", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (of(), [2, !1]);
            }
          });
        });
      }
      function _f(e) {
        return ef(this, void 0, void 0, function () {
          var t;
          return tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&clientId=" + e + "&data=25", "", "GET").then(
                    function (e) {
                      return e;
                    }
                  ),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (of(), [2, !1]);
            }
          });
        });
      }
      function yf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r;
          return tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (t = af()).CustomerId,
                  (n = t.SalesRepName),
                  [
                    4,
                    Gh(
                      uf +
                        "?customerId=" +
                        e +
                        "&customerName=" +
                        n +
                        "&data=12",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (r = o.sent()) ? [2, r] : (of(), [2, !1]);
            }
          });
        });
      }
      function Cf(e) {
        return ef(this, void 0, void 0, function () {
          var t;
          return tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Gh(
                    pf() +
                      "&clientId=" +
                      e.clientId +
                      "&orderId=" +
                      e.order_id +
                      "&data=19",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (of(), [2, !1]);
            }
          });
        });
      }
      function xf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r;
          return tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (t = af()).CustomerId,
                  (n = t.SalesRepName),
                  [
                    4,
                    Gh(
                      uf +
                        "?customerId=" +
                        e +
                        "&customerName=" +
                        n +
                        "&shop=" +
                        df +
                        "&data=31",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (r = o.sent()) ? [2, r] : (of(), [2, !1]);
            }
          });
        });
      }
      function Sf(e, t) {
        return ef(this, void 0, void 0, function () {
          var n, r;
          return tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (
                  (n = uf + "?pageIndex=".concat(t ? 44 : 0)),
                  [4, Yh(JSON.stringify(e))]
                );
              case 1:
                return (
                  (r = o.sent()),
                  [
                    4,
                    Gh(n, r, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return [2, o.sent()];
            }
          });
        });
      }
      function kf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    Yh(
                      JSON.stringify({
                        salesrepId: n,
                        email: e.email,
                        name: e.firstName,
                        TeamManagerName: r,
                        Lname: e.lastName,
                        IsTeamManager: !0,
                        RequestSignUpV2: !0,
                      })
                    ),
                  ]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Gh(pf() + "&data=" + o + "&pageIndex=21", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (of(), [2, !1]);
            }
          });
        });
      }
      function Pf(e) {
        return ef(this, void 0, void 0, function () {
          var t;
          return tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Gh(
                    uf +
                      "?customerId=" +
                      e.repId +
                      "&customerName=" +
                      e.repName +
                      "&data=18",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (of(), [2, !1]);
            }
          });
        });
      }
      function wf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Yh(JSON.stringify(e))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + t + "&pageIndex=31", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function Of(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Yh(e)];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?pageIndex=30", t, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function Tf() {
        return ef(this, void 0, void 0, function () {
          var e;
          return tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&data=2", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (of(), [2, !1]);
            }
          });
        });
      }
      function If(e) {
        return ef(this, void 0, void 0, function () {
          var t;
          return tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Gh(
                    pf() + "&orderId=" + e.order_id + "&data=20",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (of(), [2, !1]);
            }
          });
        });
      }
      function Mf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  Yh(
                    JSON.stringify({
                      orderid: e.orderid,
                      shopname: df,
                      emailid: e.emailid,
                    })
                  ),
                ];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + t + "&pageIndex=02", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function jf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Yh(JSON.stringify({ orderid: e }))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(
                      uf +
                        "?&customerName=" +
                        cf +
                        "&data=" +
                        t +
                        "&pageIndex=14",
                      "",
                      "POST"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) && (null == n ? void 0 : n.data)
                  ? [2, n]
                  : (of(), [2, !1]);
            }
          });
        });
      }
      function Nf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o;
          return tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [
                    4,
                    Gh(
                      uf +
                        "?shop=" +
                        df +
                        "&customerId=" +
                        n +
                        "&customerName=" +
                        r +
                        "&orderId=" +
                        e.orderId +
                        "&refundId=" +
                        e.refundId +
                        "&data=35",
                      "",
                      "GET"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 1:
                return (o = a.sent()) ? [2, o] : (of(), [2, !1]);
            }
          });
        });
      }
      function Df(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  (r = t.SalesRepName),
                  [4, Yh(JSON.stringify(Xh({ repId: n, repname: r }, e)))]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Gh(uf + "?data=" + o + "&pageIndex=8", "", "POST").then(
                      function (e) {
                        return e;
                      }
                    ),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (of(), [2, !1]);
            }
          });
        });
      }
      function Af(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o, a;
          return tf(this, function (i) {
            switch (i.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  t.SalesRepName,
                  (r = new FormData()).append("postedFile", e),
                  [4, Yh(JSON.stringify({ repId: n }))]
                );
              case 1:
                return (
                  (o = i.sent()),
                  [
                    4,
                    Gh(
                      uf + "?data=" + o + "&pageIndex=28",
                      r,
                      "POST",
                      "multipart/form-data"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (a = i.sent()) ? [2, a] : (of(), [2, !1]);
            }
          });
        });
      }
      function Ef() {
        return ef(this, void 0, void 0, function () {
          var e;
          return tf(this, function (t) {
            switch (t.label) {
              case 0:
                return [
                  4,
                  Gh(pf() + "&data=30", "", "GET").then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (e = t.sent()) ? [2, e] : (of(), [2, !1]);
            }
          });
        });
      }
      function Rf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o, a, i, s;
          return tf(this, function (l) {
            switch (l.label) {
              case 0:
                return (
                  (t = af()).CustomerId,
                  (n = t.SalesRepName),
                  (r = e.fileUpload),
                  (o = new FormData()).append("postedFile", r),
                  (a = {
                    email: e.userDetails.emailId,
                    name: e.userDetails.firstName,
                    TeamManagerName: n,
                    Lname: e.userDetails.lastName,
                    IsTeamManager: !1,
                    PhNumber: e.userDetails.phoneNumber,
                    fbHandle: e.userDetails.fbHandle,
                    InstaHandle: e.userDetails.instHandle,
                    signUpRequestV2: 1,
                  }),
                  [4, Yh(JSON.stringify(a))]
                );
              case 1:
                return (
                  (i = l.sent()),
                  [
                    4,
                    Gh(
                      uf + "?data=" + i + "&pageIndex=21",
                      o,
                      "POST",
                      "multipart/form-data"
                    ).then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (s = l.sent()) ? [2, s] : (of(), [2, !1]);
            }
          });
        });
      }
      function Lf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  Yh(
                    JSON.stringify({
                      email: e.emailField,
                      password: e.passwordField,
                    })
                  ),
                ];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?pageIndex=45", t, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function Bf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [4, Yh(JSON.stringify({ email: e }))];
              case 1:
                return (
                  (t = r.sent()),
                  [
                    4,
                    Gh(uf + "?pageIndex=46", t, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function zf(e, t) {
        return ef(this, void 0, void 0, function () {
          var n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return (
                  (n =
                    "add.js" === t
                      ? { items: e }
                      : "update.js" === t
                      ? { updates: e }
                      : e),
                  [
                    4,
                    Wh()({
                      method: "post",
                      url: "/cart/" + t,
                      data: JSON.stringify(n),
                      headers: { "Content-type": "application/json" },
                    })
                      .then(function (e) {
                        return !0;
                      })
                      .catch(function (e) {
                        return e;
                      }),
                  ]
                );
              case 1:
                return [2, r.sent()];
            }
          });
        });
      }
      function Ff(e) {
        var t, n, r, o, a, i, s, l, d;
        return ef(this, void 0, void 0, function () {
          var c, u, p, m, h, f;
          return tf(this, function (g) {
            switch (g.label) {
              case 0:
                (c = ""), (g.label = 1);
              case 1:
                return (
                  g.trys.push([1, 8, , 9]),
                  [
                    4,
                    Wh()({
                      method: "post",
                      url: "/cart/prepare_shipping_rates.json",
                      params: {
                        "shipping_address[zip]": e.customerZip,
                        "shipping_address[country]": e.customerCountry,
                        "shipping_address[province]": e.customerProvince,
                      },
                    }),
                  ]
                );
              case 2:
                return 202 !== g.sent().status
                  ? [3, 7]
                  : [
                      4,
                      new Promise(function (e) {
                        return setTimeout(e, 5e3);
                      }),
                    ];
              case 3:
                g.sent(), (g.label = 4);
              case 4:
                return (
                  g.trys.push([4, 6, , 7]),
                  [
                    4,
                    Wh()({
                      method: "get",
                      url: "/cart/async_shipping_rates.json",
                      params: {
                        "shipping_address[zip]": e.customerZip,
                        "shipping_address[country]": e.customerCountry,
                        "shipping_address[province]": e.customerProvince,
                      },
                    }),
                  ]
                );
              case 5:
                return (
                  (u = g.sent()),
                  (c = "Success"),
                  [2, Xh(Xh({}, u.data), { message: c })]
                );
              case 6:
                return (
                  (p = g.sent()), (c = p.message), of(), [2, { message: c }]
                );
              case 7:
                return [3, 9];
              case 8:
                return (
                  (m = g.sent()),
                  0 ===
                  (null === (t = null == m ? void 0 : m.request) || void 0 === t
                    ? void 0
                    : t.status)
                    ? (c = "Network Problem")
                    : 404 ===
                      (null === (n = null == m ? void 0 : m.request) ||
                      void 0 === n
                        ? void 0
                        : n.status)
                    ? (c = "Not Found")
                    : 422 ===
                      (null === (r = null == m ? void 0 : m.request) ||
                      void 0 === r
                        ? void 0
                        : r.status)
                    ? ((h = JSON.parse(
                        null !==
                          (a =
                            null === (o = null == m ? void 0 : m.request) ||
                            void 0 === o
                              ? void 0
                              : o.responseText) && void 0 !== a
                          ? a
                          : "{}"
                      )) &&
                        (null == h ? void 0 : h.zip) &&
                        (null === (i = null == h ? void 0 : h.zip) ||
                        void 0 === i
                          ? void 0
                          : i[0]) &&
                        (c = c
                          ? "".concat(c, ", ").concat(h.zip[0])
                          : h.zip[0]),
                      h &&
                        (null == h ? void 0 : h.country) &&
                        (null === (s = null == h ? void 0 : h.country) ||
                        void 0 === s
                          ? void 0
                          : s[0]) &&
                        ("Country/region not supported" ===
                          (f = h.country[0]) &&
                          (f =
                            "Shipping cost for selected address is not configured. Please contact admin."),
                        (c = c ? "".concat(c, ", ").concat(f) : f)),
                      h &&
                        (null == h ? void 0 : h.province) &&
                        (null === (l = null == h ? void 0 : h.province) ||
                        void 0 === l
                          ? void 0
                          : l[0]) &&
                        (c = c
                          ? "".concat(c, ", ").concat(h.province[0])
                          : h.province[0]),
                      (null === (d = null == h ? void 0 : h.error) ||
                      void 0 === d
                        ? void 0
                        : d[0]) &&
                        (c = c
                          ? "".concat(c, ", ").concat(h.error[0])
                          : h.error[0]))
                    : (c = null == m ? void 0 : m.message),
                  [2, { message: c }]
                );
              case 9:
                return [2];
            }
          });
        });
      }
      function Zf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o;
          return tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = nf.CustomerId),
                  (n = nf.email),
                  [4, Yh(JSON.stringify(Xh({ customerId: t, email: n }, e)))]
                );
              case 1:
                return (
                  (r = a.sent()),
                  [
                    4,
                    Gh(uf + "?pageIndex=47", r, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return null !== (o = a.sent()) ? [2, o] : (of(), [2, !1]);
            }
          });
        });
      }
      function Hf() {
        return ef(this, void 0, void 0, function () {
          return tf(this, function (e) {
            switch (e.label) {
              case 0:
                return [
                  4,
                  Wh()({
                    method: "get",
                    url: "/cart.js",
                    headers: { "Content-type": "application/json" },
                  })
                    .then(function (e) {
                      return e;
                    })
                    .catch(function (e) {
                      return e;
                    }),
                ];
              case 1:
                return [2, e.sent()];
            }
          });
        });
      }
      function Vf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r, o;
          return tf(this, function (a) {
            switch (a.label) {
              case 0:
                return (
                  (t = af()),
                  (n = t.CustomerId),
                  t.SalesRepName,
                  [
                    4,
                    Yh(
                      JSON.stringify({
                        shopName: df,
                        customerId: n,
                        affiliatePopUpVisible: e,
                      })
                    ),
                  ]
                );
              case 1:
                return (
                  (r = a.sent()),
                  [
                    4,
                    Gh(uf + "?pageIndex=52", r, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return (o = a.sent()) ? [2, o] : (of(), [2, !1]);
            }
          });
        });
      }
      function Wf(e, t, n, r, o, a) {
        var i, s, l, d, c, u, p, m, h;
        return ef(this, void 0, void 0, function () {
          var f, g, v, b, _, y, C, x, S, k, P, w, O, T;
          return tf(this, function (I) {
            switch (I.label) {
              case 0:
                return (
                  I.trys.push([0, 3, , 4]),
                  (f = rf().shopName),
                  (g = "https://".concat(f, "/api/2023-10/graphql.json")),
                  (v = ""),
                  (b = "first:".concat(250)),
                  (_ = []),
                  n
                    ? ((v = 'after:"' + n + '"'), (b = "first:".concat(250)))
                    : r &&
                      ((v = 'before:"' + r + '"'), (b = "last:".concat(250))),
                  (y = {
                    "X-Shopify-Storefront-Access-Token": t,
                    "Content-Type": "application/json",
                  }),
                  void 0,
                  (C = a
                    ? null == a
                      ? void 0
                      : a
                          .map(function (e) {
                            var t = null == e ? void 0 : e.split("/").pop();
                            return "id:".concat(t);
                          })
                          .join(" OR ")
                    : e && "" !== e
                    ? e
                    : ""),
                  (x = "{\n            products("
                    .concat(b, ', query: "(')
                    .concat(C, ')" ')
                    .concat(
                      v,
                      ") {\n                edges {\n                    node {\n                        id\n                        title\n                        handle\n                        productType\n                        images(first: 1) {\n                            edges {\n                                node {\n                                    url\n                                }\n                            }\n                        }\n                        variants(first: "
                    )
                    .concat(
                      120,
                      ") {\n                            edges {\n                                node {\n                                    id\n                                    price {\n                                        amount\n                                        currencyCode\n                                    }\n                                    image {\n                                        url\n                                    }\n                                    sku\n                                    title\n                                    quantityAvailable\n                                    availableForSale\n                                }\n                            }\n                        }\n                    }\n                }\n                pageInfo {\n                    hasPreviousPage\n                    hasNextPage\n                    startCursor\n                    endCursor\n                }\n            }\n        }"
                    )),
                  o &&
                    ((S = "gid://shopify/Collection/".concat(o)),
                    (x = '{\n                collection(id: "'
                      .concat(S, '") {\n                    products(')
                      .concat(b, ", ")
                      .concat(
                        v,
                        ") {\n                        nodes {\n                            id\n                            handle\n                            title\n                            productType\n                            images(first: 10) {\n                                edges {\n                                    node {\n                                        url\n                                    }\n                                }\n                            }\n                            variants(first: "
                      )
                      .concat(
                        120,
                        ") {\n                                nodes {\n                                    id\n                                    price {\n                                        amount\n                                        currencyCode\n                                    }\n                                    sku\n                                    title\n                                    quantityAvailable\n                                    availableForSale\n                                }\n                            }\n                        }\n                        pageInfo {\n                            hasPreviousPage\n                            hasNextPage\n                            startCursor\n                            endCursor\n                        }\n                    }\n                }\n            }"
                      ))),
                  [
                    4,
                    Wh()({
                      method: "POST",
                      url: g,
                      headers: y,
                      data: { query: x },
                    }),
                  ]
                );
              case 1:
                if (
                  ((k = I.sent()),
                  (P = null == k ? void 0 : k.data),
                  200 !== (null == k ? void 0 : k.status))
                )
                  throw new Error(
                    "Error fetching product data due to a network or server issue."
                  );
                if (o) {
                  if (
                    !(null === (i = P.data.collection) || void 0 === i
                      ? void 0
                      : i.products)
                  )
                    throw new Error(
                      "Error fetching product data: No products found in the collection."
                    );
                } else if (!(null === (s = P.data) || void 0 === s ? void 0 : s.products)) throw new Error("Error fetching product data: No products found.");
                return (
                  (w = o
                    ? null === (l = null == P ? void 0 : P.data) || void 0 === l
                      ? void 0
                      : l.collection
                    : null == P
                    ? void 0
                    : P.data),
                  (_ = null == _ ? void 0 : _.concat(w)),
                  [
                    4,
                    o
                      ? $f(
                          null === (d = _[0].products) || void 0 === d
                            ? void 0
                            : d.nodes
                        )
                      : Uf(_),
                  ]
                );
              case 2:
                return (
                  (O = I.sent()),
                  [
                    2,
                    o
                      ? {
                          products: O,
                          pageInfo:
                            null ===
                              (p =
                                null ===
                                  (u =
                                    null ===
                                      (c = null == P ? void 0 : P.data) ||
                                    void 0 === c
                                      ? void 0
                                      : c.collection) || void 0 === u
                                  ? void 0
                                  : u.products) || void 0 === p
                              ? void 0
                              : p.pageInfo,
                        }
                      : {
                          products: O,
                          pageInfo:
                            null ===
                              (h =
                                null === (m = null == P ? void 0 : P.data) ||
                                void 0 === m
                                  ? void 0
                                  : m.products) || void 0 === h
                              ? void 0
                              : h.pageInfo,
                        },
                  ]
                );
              case 3:
                throw ((T = I.sent()), console.log(T), T);
              case 4:
                return [2];
            }
          });
        });
      }
      function Uf(e) {
        try {
          if (e) {
            var t =
              null == e
                ? void 0
                : e.map(function (e) {
                    var t = e.products.edges,
                      n =
                        null == t
                          ? void 0
                          : t.map(function (e) {
                              var t,
                                n,
                                r,
                                o,
                                a = e.node,
                                i =
                                  null ===
                                    (t =
                                      null == a ? void 0 : a.variants.edges) ||
                                  void 0 === t
                                    ? void 0
                                    : t.map(function (e) {
                                        var t,
                                          n,
                                          r,
                                          o,
                                          i = null == e ? void 0 : e.node;
                                        return {
                                          variantId: null == i ? void 0 : i.id,
                                          variantPrice: Number(
                                            null ===
                                              (t =
                                                null == i ? void 0 : i.price) ||
                                              void 0 === t
                                              ? void 0
                                              : t.amount
                                          ),
                                          imageUrl:
                                            (null ===
                                              (n =
                                                null == i ? void 0 : i.image) ||
                                            void 0 === n
                                              ? void 0
                                              : n.url) || null,
                                          currency:
                                            null ===
                                              (r =
                                                null == i ? void 0 : i.price) ||
                                            void 0 === r
                                              ? void 0
                                              : r.currencyCode,
                                          inventoryQuantity:
                                            null == i
                                              ? void 0
                                              : i.inventoryQuantity,
                                          sku: null == i ? void 0 : i.sku,
                                          title: null == i ? void 0 : i.title,
                                          quantityAvailable:
                                            null == i
                                              ? void 0
                                              : i.quantityAvailable,
                                          availableForSale:
                                            null == i
                                              ? void 0
                                              : i.availableForSale,
                                          product_type:
                                            null !==
                                              (o =
                                                null == a
                                                  ? void 0
                                                  : a.productType) &&
                                            void 0 !== o
                                              ? o
                                              : "",
                                        };
                                      });
                              return {
                                productId: null == a ? void 0 : a.id,
                                handle: null == a ? void 0 : a.handle,
                                title: null == a ? void 0 : a.title,
                                variants: i,
                                imageUrl:
                                  (null ===
                                    (o =
                                      null ===
                                        (r =
                                          null ===
                                            (n =
                                              null == a ? void 0 : a.images) ||
                                          void 0 === n
                                            ? void 0
                                            : n.edges[0]) || void 0 === r
                                        ? void 0
                                        : r.node) || void 0 === o
                                    ? void 0
                                    : o.url) || null,
                              };
                            });
                    return n;
                  });
            return t.flat();
          }
        } catch (e) {
          return console.error("Error parsing GraphQL response:", e), [];
        }
      }
      function $f(e) {
        try {
          var t =
            null == e
              ? void 0
              : e.map(function (e) {
                  var t,
                    n,
                    r,
                    o,
                    a =
                      null === (t = null == e ? void 0 : e.variants.nodes) ||
                      void 0 === t
                        ? void 0
                        : t.map(function (t) {
                            var n, r, o;
                            return {
                              variantId: null == t ? void 0 : t.id,
                              variantPrice: Number(
                                null === (n = null == t ? void 0 : t.price) ||
                                  void 0 === n
                                  ? void 0
                                  : n.amount
                              ),
                              currency:
                                null === (r = null == t ? void 0 : t.price) ||
                                void 0 === r
                                  ? void 0
                                  : r.currencyCode,
                              sku: null == t ? void 0 : t.sku,
                              title: null == t ? void 0 : t.title,
                              quantityAvailable:
                                null == t ? void 0 : t.quantityAvailable,
                              availableForSale:
                                null == t ? void 0 : t.availableForSale,
                              product_type:
                                null !==
                                  (o = null == e ? void 0 : e.productType) &&
                                void 0 !== o
                                  ? o
                                  : "",
                            };
                          });
                  return {
                    productId: e.id,
                    handle: e.handle,
                    title: null == e ? void 0 : e.title,
                    variants: a,
                    imageUrl:
                      (null ===
                        (o =
                          null ===
                            (r =
                              null === (n = null == e ? void 0 : e.images) ||
                              void 0 === n
                                ? void 0
                                : n.edges[0]) || void 0 === r
                            ? void 0
                            : r.node) || void 0 === o
                        ? void 0
                        : o.url) || null,
                    productType: null == e ? void 0 : e.productType,
                  };
                });
          return t;
        } catch (e) {
          return (
            console.error("Error parsing GraphQL collection response:", e), []
          );
        }
      }
      function Kf(e, t) {
        return ef(this, void 0, void 0, function () {
          var n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  Gh(
                    pf() +
                      "&companyLocationId=" +
                      e +
                      "&b2bPricesCatalogDetails=" +
                      t +
                      "&isPaginationAdded=True&data=41",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function Gf(e, t) {
        return ef(this, void 0, void 0, function () {
          var n;
          return tf(this, function (r) {
            switch (r.label) {
              case 0:
                return [
                  4,
                  Gh(
                    pf() +
                      "&companyLocationId=" +
                      e +
                      "&b2bPricesCatalogDetails=" +
                      t +
                      "&data=47",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (n = r.sent()) ? [2, n] : (of(), [2, !1]);
            }
          });
        });
      }
      function qf(e) {
        return ef(this, void 0, void 0, function () {
          var t;
          return tf(this, function (n) {
            switch (n.label) {
              case 0:
                return [
                  4,
                  Gh(
                    pf() + "&catalogVariantData=" + e + "&data=48",
                    "",
                    "GET"
                  ).then(function (e) {
                    return e;
                  }),
                ];
              case 1:
                return (t = n.sent()) ? [2, t] : (of(), [2, !1]);
            }
          });
        });
      }
      function Qf(e) {
        return ef(this, void 0, void 0, function () {
          var t, n, r;
          return tf(this, function (o) {
            switch (o.label) {
              case 0:
                return (t = uf + "?pageIndex=51"), [4, Yh(JSON.stringify(e))];
              case 1:
                return (
                  (n = o.sent()),
                  [
                    4,
                    Gh(t, n, "POST").then(function (e) {
                      return e;
                    }),
                  ]
                );
              case 2:
                return (r = o.sent()) &&
                  "" != (null == r ? void 0 : r.id) &&
                  null != (null == r ? void 0 : r.id)
                  ? [2, !0]
                  : [2, r];
            }
          });
        });
      }
      var Yf = function () {
          return (
            (Yf =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Yf.apply(this, arguments)
          );
        },
        Jf = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Xf = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function eg() {
        var e = this;
        return function (t) {
          return Jf(e, void 0, void 0, function () {
            var e, n;
            return Xf(this, function (r) {
              switch (r.label) {
                case 0:
                  return [
                    4,
                    mf().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = r.sent())
                    ? ((n = { payload: e, type: A.BASE_DATA }), [2, t(n)])
                    : [2];
              }
            });
          });
        };
      }
      function tg() {
        var e = this;
        return function (t) {
          return Jf(e, void 0, void 0, function () {
            var e, n, r, o, a;
            return Xf(this, function (i) {
              switch (i.label) {
                case 0:
                  return [
                    4,
                    hf().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = i.sent())
                    ? ((n = {
                        payload: Yf(
                          Yf(
                            Yf(
                              {},
                              null === (r = F.getState().salesRepData) ||
                                void 0 === r
                                ? void 0
                                : r.ordersData
                            ),
                            e
                          ),
                          {
                            refundOrdersDetails: mg(
                              null !==
                                (o =
                                  null == e
                                    ? void 0
                                    : e.allRefundOrdersDetails) && void 0 !== o
                                ? o
                                : []
                            ),
                            isPaidUnPaidOrdersLoaded: !0,
                          }
                        ),
                        type: A.ORDERS_DATA,
                      }),
                      [2, t(n)])
                    : ((n = {
                        payload: Yf(
                          Yf(
                            {},
                            null === (a = F.getState().salesRepData) ||
                              void 0 === a
                              ? void 0
                              : a.ordersData
                          ),
                          {
                            refundOrdersDetails: [],
                            isPaidUnPaidOrdersLoaded: !1,
                          }
                        ),
                        type: A.ORDERS_DATA,
                      }),
                      [2, t(n)]);
              }
            });
          });
        };
      }
      function ng(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r, o;
            return Xf(this, function (a) {
              switch (a.label) {
                case 0:
                  return [
                    4,
                    xf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    (t = a.sent()),
                    (r = {
                      customerAddressesList: t.customerAddressesList,
                      SingleShopifyCustomers: t.SingleShopifyCustomers,
                    }),
                    t
                      ? ((o = { payload: r, type: A.CUSTOMER_ADDRESS_DATA }),
                        [2, n(o)])
                      : [2]
                  );
              }
            });
          });
        };
      }
      var rg = function (e, t) {
        return Jf(void 0, void 0, void 0, function () {
          var n, r, o, a, i, s, l, d;
          return Xf(this, function (c) {
            switch (c.label) {
              case 0:
                return [4, Sf(e, t)];
              case 1:
                return 200 === (null == (n = c.sent()) ? void 0 : n.status)
                  ? t
                    ? [
                        2,
                        "" !== (null == n ? void 0 : n.data) &&
                          void 0 !== (null == n ? void 0 : n.data) &&
                          null !== (null == n ? void 0 : n.data),
                      ]
                    : [
                        2,
                        "" !==
                          (null === (r = null == n ? void 0 : n.data) ||
                          void 0 === r
                            ? void 0
                            : r.id) &&
                        void 0 !==
                          (null === (o = null == n ? void 0 : n.data) ||
                          void 0 === o
                            ? void 0
                            : o.id) &&
                        null !==
                          (null === (a = null == n ? void 0 : n.data) ||
                          void 0 === a
                            ? void 0
                            : a.id) &&
                        "" !==
                          (null === (i = null == n ? void 0 : n.data) ||
                          void 0 === i
                            ? void 0
                            : i.invoice_url) &&
                        void 0 !==
                          (null === (s = null == n ? void 0 : n.data) ||
                          void 0 === s
                            ? void 0
                            : s.invoice_url) &&
                        null !==
                          (null === (l = null == n ? void 0 : n.data) ||
                          void 0 === l
                            ? void 0
                            : l.invoice_url)
                          ? null === (d = null == n ? void 0 : n.data) ||
                            void 0 === d
                            ? void 0
                            : d.invoice_url
                          : "",
                      ]
                  : [2, ""];
            }
          });
        });
      };
      function og() {
        var e = this;
        return function (t) {
          return Jf(e, void 0, void 0, function () {
            var e, n, r;
            return Xf(this, function (o) {
              switch (o.label) {
                case 0:
                  return (null ===
                    (r = F.getState().salesRepData.viewCouponData) ||
                  void 0 === r
                    ? void 0
                    : r.length) > 0
                    ? [2, F.getState().salesRepData.viewCouponData]
                    : [3, 1];
                case 1:
                  return [
                    4,
                    ff().then(function (e) {
                      return e;
                    }),
                  ];
                case 2:
                  if ((e = o.sent()).Coupons)
                    return (
                      (n = { payload: e.Coupons, type: A.VIEW_COUPON_DATA }),
                      [2, t(n)]
                    );
                  o.label = 3;
                case 3:
                  return [2];
              }
            });
          });
        };
      }
      function ag(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r;
            return Xf(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    gf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    "Coupon Created" === (t = o.sent()) &&
                      ((r = { payload: [], type: A.VIEW_COUPON_DATA }), n(r)),
                    [2, t]
                  );
              }
            });
          });
        };
      }
      function ig(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r;
            return Xf(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    vf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return o.sent() && F.getState().salesRepData.viewCouponData
                    ? (null == (t = F.getState().salesRepData.viewCouponData) ||
                        t.forEach(function (n, r) {
                          e.couponid === n.couponId && t.splice(r, 1);
                        }),
                      (r = { payload: t, type: A.VIEW_COUPON_DATA }),
                      [2, n(r)])
                    : [2];
              }
            });
          });
        };
      }
      function sg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    bf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function lg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    _f(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function dg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    yf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function cg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Cf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function ug() {
        var e = this;
        return function (t) {
          return Jf(e, void 0, void 0, function () {
            var e, n, r, o, a, i, s;
            return Xf(this, function (l) {
              switch (l.label) {
                case 0:
                  return (null ===
                    (a =
                      null === (o = F.getState().salesRepData) || void 0 === o
                        ? void 0
                        : o.draftOrderData) || void 0 === a
                    ? void 0
                    : a.length) > 0
                    ? [2, F.getState().salesRepData.draftOrderData]
                    : [3, 1];
                case 1:
                  return [
                    4,
                    Tf().then(function (e) {
                      return e;
                    }),
                  ];
                case 2:
                  return (
                    null == (e = l.sent()) ? void 0 : e.ClientInvoiceDetails
                  )
                    ? ((r = {
                        payload: e.ClientInvoiceDetails,
                        type: A.DRAFT_ORDER_DATA,
                      }),
                      t(r),
                      (n = {
                        payload: Yf(
                          Yf(
                            {},
                            null === (i = F.getState().salesRepData) ||
                              void 0 === i
                              ? void 0
                              : i.ordersData
                          ),
                          {
                            draftOrdersDetails: pg(
                              null == e ? void 0 : e.ClientInvoiceDetails
                            ),
                            isDraftOrdersLoaded: !0,
                          }
                        ),
                        type: A.ORDERS_DATA,
                      }),
                      t(n),
                      [2, !0])
                    : ((r = {
                        payload: Yf(
                          Yf(
                            {},
                            null === (s = F.getState().salesRepData) ||
                              void 0 === s
                              ? void 0
                              : s.ordersData
                          ),
                          { draftOrdersDetails: [], isDraftOrdersLoaded: !1 }
                        ),
                        type: A.ORDERS_DATA,
                      }),
                      t(r),
                      [2, []]);
                case 3:
                  return [2];
              }
            });
          });
        };
      }
      var pg = function (e) {
          var t = [];
          return (
            null == e ||
              e.filter(function (e, n) {
                var r, o, a;
                if (
                  (null == e ? void 0 : e.status) &&
                  ("open" ===
                    (null === (r = null == e ? void 0 : e.status) ||
                    void 0 === r
                      ? void 0
                      : r.toLowerCase()) ||
                    "voided" ===
                      (null === (o = null == e ? void 0 : e.status) ||
                      void 0 === o
                        ? void 0
                        : o.toLowerCase()))
                ) {
                  var i = {
                    orderNumber: null == e ? void 0 : e.orderNumber,
                    orderName: null == e ? void 0 : e.orderName,
                    orderDate: null == e ? void 0 : e.orderDate,
                    OrderPaidDate: null == e ? void 0 : e.orderPaidDate,
                    CustomerName: null == e ? void 0 : e.customername,
                    CustomerId: null == e ? void 0 : e.CustomerId,
                    SalesRepName: null,
                    SalesRepId: null,
                    CustomerEmail: null == e ? void 0 : e.emailid,
                    subtotal: null == e ? void 0 : e.subtotalprice,
                    commission: 0,
                    TeamManagerCommission: 0,
                    CommissionType: "-",
                    ProductTitle: "",
                    OrderId: Number(
                      null !== (a = null == e ? void 0 : e.orderid) &&
                        void 0 !== a
                        ? a
                        : 0
                    ),
                    total: 0,
                    financial_status: null,
                    fulfillment_status: null,
                    TypeOfCustomer: null,
                    DateOfFirstOrder: null,
                    PartyId: 0,
                    Discount: 0,
                    FulfillmentDate: "",
                    OrderStatus: null == e ? void 0 : e.status,
                    b2BCompanyId: null,
                    b2BCompanyName: null == e ? void 0 : e.b2BCompanyName,
                    b2BLocationId: null,
                    b2BLocationName: null == e ? void 0 : e.b2BLocationName,
                  };
                  t.push(i);
                }
              }),
            t
          );
        },
        mg = function (e) {
          var t = [];
          return (
            null == e ||
              e.filter(function (e, n) {
                var r, o, a, i, s, l;
                if (
                  (null == e ? void 0 : e.OrderStatus) &&
                  ("refunded" ===
                    (null === (r = null == e ? void 0 : e.OrderStatus) ||
                    void 0 === r
                      ? void 0
                      : r.toLowerCase()) ||
                    "partially_refunded" ===
                      (null === (o = null == e ? void 0 : e.OrderStatus) ||
                      void 0 === o
                        ? void 0
                        : o.toLowerCase()))
                ) {
                  var d = (
                      null === (a = null == e ? void 0 : e.OrderDate) ||
                      void 0 === a
                        ? void 0
                        : a.includes("-")
                    )
                      ? null === (i = null == e ? void 0 : e.OrderDate) ||
                        void 0 === i
                        ? void 0
                        : i
                            .split("T")[0]
                            .replace(/(\d{4})-(\d{2})-(\d{2}).*/, "$2/$3/$1")
                      : new Date(
                          parseInt(
                            null === (s = null == e ? void 0 : e.OrderDate) ||
                              void 0 === s
                              ? void 0
                              : s.replace("/Date(", "").replace(")/", "")
                          )
                        ).toLocaleDateString(),
                    c = {
                      orderNumber: null == e ? void 0 : e.ShopifyOrderNumber,
                      orderName: null == e ? void 0 : e.OrderName,
                      orderDate: d,
                      OrderPaidDate: "-",
                      CustomerName: "-",
                      CustomerId: "-",
                      SalesRepName: null,
                      SalesRepId: null == e ? void 0 : e.SalesRepId,
                      CustomerEmail: "-",
                      subtotal: null == e ? void 0 : e.RefundSubTotal,
                      commission: null == e ? void 0 : e.Commission,
                      TeamManagerCommission:
                        null == e ? void 0 : e.TeamManagerCommission,
                      CommissionType: null == e ? void 0 : e.OrderType,
                      ProductTitle: "",
                      OrderId: Number(
                        null !== (l = null == e ? void 0 : e.orderId) &&
                          void 0 !== l
                          ? l
                          : 0
                      ),
                      total: 0,
                      financial_status: null,
                      fulfillment_status: null,
                      TypeOfCustomer: null,
                      DateOfFirstOrder: null,
                      PartyId: 0,
                      Discount: 0,
                      FulfillmentDate: "",
                      OrderStatus: null == e ? void 0 : e.OrderStatus,
                      b2BCompanyId: null,
                      b2BCompanyName: "-",
                      b2BLocationId: null,
                      b2BLocationName: "-",
                      isRefundedOrders: !0,
                    };
                  t.push(c);
                }
              }),
            t
          );
        },
        hg = function (e) {
          return function (t) {
            return Jf(void 0, void 0, void 0, function () {
              var n, r;
              return Xf(this, function (o) {
                switch (o.label) {
                  case 0:
                    return [4, wf(e)];
                  case 1:
                    return o.sent().data &&
                      F.getState().salesRepData.baseData.SharedCartDetails
                      ? (null ==
                          (n =
                            F.getState().salesRepData.baseData
                              .SharedCartDetails) ||
                          n.forEach(function (t, r) {
                            void 0 === r && (r = 0),
                              t.CartUniqueId === e.cartUniqueId &&
                                n.splice(r, 1);
                          }),
                        (r = {
                          payload: Yf(
                            Yf({}, F.getState().salesRepData.baseData),
                            { SharedCartDetails: n }
                          ),
                          type: A.BASE_DATA,
                        }),
                        [2, t(r)])
                      : [2, !1];
                }
              });
            });
          };
        };
      function fg(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r, o, a, i, s, l, d;
            return Xf(this, function (c) {
              switch (c.label) {
                case 0:
                  return [4, Vf(e)];
                case 1:
                  return c.sent() &&
                    (null ===
                      (i =
                        null === (a = F.getState().salesRepData) || void 0 === a
                          ? void 0
                          : a.baseData) || void 0 === i
                      ? void 0
                      : i.ConfirmationPopUpStatus)
                    ? ((t =
                        null ===
                          (l =
                            null === (s = F.getState().salesRepData) ||
                            void 0 === s
                              ? void 0
                              : s.baseData) || void 0 === l
                          ? void 0
                          : l.ConfirmationPopUpStatus),
                      (r = Yf(Yf({}, t), { isAffiliatePopUpVisible: !0 })),
                      (o = {
                        payload: Yf(
                          Yf(
                            {},
                            null === (d = F.getState().salesRepData) ||
                              void 0 === d
                              ? void 0
                              : d.baseData
                          ),
                          { ConfirmationPopUpStatus: r }
                        ),
                        type: A.BASE_DATA,
                      }),
                      n(o),
                      [2, !0])
                    : [2, !1];
              }
            });
          });
        };
      }
      function gg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Of(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function vg(e, t) {
        var n = this;
        return function (r) {
          return Jf(n, void 0, void 0, function () {
            var n, o, a, i;
            return Xf(this, function (s) {
              switch (s.label) {
                case 0:
                  return [
                    4,
                    If(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (
                    (n = s.sent()) &&
                      (null == n ? void 0 : n.draftOrder) &&
                      (null ===
                        (a = Object.keys(null == n ? void 0 : n.draftOrder)) ||
                      void 0 === a
                        ? void 0
                        : a.length) > 0 &&
                      (null === (i = null == n ? void 0 : n.ProductDetails) ||
                      void 0 === i
                        ? void 0
                        : i.length) > 0 &&
                      ((o = {
                        payload: {
                          draftOrderObj: null == n ? void 0 : n.draftOrder,
                          productDetailsArray:
                            null == n ? void 0 : n.ProductDetails,
                          actionEvent: t,
                        },
                        type: A.EDIT_DRAFT_ORDER,
                      }),
                      r(o)),
                    [2, n]
                  );
              }
            });
          });
        };
      }
      function bg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Mf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function _g(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r;
            return Xf(this, function (o) {
              switch (o.label) {
                case 0:
                  return [
                    4,
                    jf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return o.sent() && F.getState().salesRepData.draftOrderData
                    ? (null == (t = F.getState().salesRepData.draftOrderData) ||
                        t.forEach(function (n, r) {
                          e === n.orderid && t.splice(r, 1);
                        }),
                      (r = { payload: t, type: A.DRAFT_ORDER_DATA }),
                      [2, n(r)])
                    : [2];
              }
            });
          });
        };
      }
      function yg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Nf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Cg(e) {
        return Jf(this, void 0, void 0, function () {
          return Xf(this, function (t) {
            switch (t.label) {
              case 0:
                return [4, Df(e)];
              case 1:
                return [2, t.sent()];
            }
          });
        });
      }
      function xg(e) {
        var t = this;
        return function (n) {
          return Jf(t, void 0, void 0, function () {
            var t, r, o, a, i, s;
            return Xf(this, function (l) {
              switch (l.label) {
                case 0:
                  return [
                    4,
                    Af(e)
                      .then(function (e) {
                        return e;
                      })
                      .catch(function (e) {
                        return e;
                      }),
                  ];
                case 1:
                  return l.sent()
                    ? [
                        4,
                        mf().then(function (e) {
                          return e;
                        }),
                      ]
                    : [3, 3];
                case 2:
                  return (
                    (t = l.sent()),
                    (r =
                      null === (a = null == t ? void 0 : t.SingleSalesRep) ||
                      void 0 === a
                        ? void 0
                        : a.ProfileImagePath)
                      ? ((o = { payload: r, type: A.UPDATE_REP_PROFILE }),
                        n(o),
                        [2, !0])
                      : [3, 4]
                  );
                case 3:
                  return (
                    (r =
                      null ===
                        (s =
                          null === (i = F.getState().salesRepData.baseData) ||
                          void 0 === i
                            ? void 0
                            : i.SingleSalesRep) || void 0 === s
                        ? void 0
                        : s.ProfileImagePath),
                    (o = { payload: r, type: A.UPDATE_REP_PROFILE }),
                    n(o),
                    [2, !1]
                  );
                case 4:
                  return [2];
              }
            });
          });
        };
      }
      function Sg() {
        var e = this;
        return function (t) {
          return Jf(e, void 0, void 0, function () {
            var e, n;
            return Xf(this, function (r) {
              switch (r.label) {
                case 0:
                  return [
                    4,
                    Ef().then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return (e = r.sent())
                    ? ((n = { payload: e, type: A.WHOLESALE_PRICE_DATA }),
                      [2, t(n)])
                    : [2];
              }
            });
          });
        };
      }
      function kg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Rf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Pg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Lf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function wg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [
                    4,
                    Bf(e).then(function (e) {
                      return e;
                    }),
                  ];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Og(e, t) {
        var n = this;
        return function () {
          return Jf(n, void 0, void 0, function () {
            var n, r, o, a;
            return Xf(this, function (i) {
              switch (i.label) {
                case 0:
                  return [4, zf(e, t)];
                case 1:
                  return "boolean" == typeof (n = i.sent()) && !0 === n
                    ? [2, n]
                    : [
                        2,
                        null !==
                          (a =
                            null ===
                              (o =
                                null ===
                                  (r = null == n ? void 0 : n.response) ||
                                void 0 === r
                                  ? void 0
                                  : r.data) || void 0 === o
                              ? void 0
                              : o.description) && void 0 !== a
                          ? a
                          : null == n
                          ? void 0
                          : n.message,
                      ];
              }
            });
          });
        };
      }
      function Tg(e) {
        var t = this;
        return function () {
          return Jf(t, void 0, void 0, function () {
            return Xf(this, function (t) {
              switch (t.label) {
                case 0:
                  return [4, Zf(e)];
                case 1:
                  return [2, t.sent()];
              }
            });
          });
        };
      }
      function Ig() {
        var e = this;
        return function () {
          return Jf(e, void 0, void 0, function () {
            return Xf(this, function (e) {
              switch (e.label) {
                case 0:
                  return [4, Hf()];
                case 1:
                  return [2, e.sent()];
              }
            });
          });
        };
      }
      function Mg(e, t, n, r) {
        var o = this;
        return (
          void 0 === n && (n = !1),
          void 0 === r && (r = !1),
          function (a) {
            return Jf(o, void 0, void 0, function () {
              var o, i, s, l, d, c, u, p;
              return Xf(this, function (m) {
                switch (m.label) {
                  case 0:
                    return (
                      m.trys.push([0, 6, , 7]),
                      (o =
                        F.getState().salesRepData.locationPricelistData || {}),
                      !n &&
                      r &&
                      o[e] &&
                      Object.keys(
                        null === (u = o[e]) || void 0 === u
                          ? void 0
                          : u.priceList
                      ).length > 0
                        ? [2]
                        : e
                        ? ((i = void 0), n ? [4, Gf(e, t)] : [3, 2])
                        : [3, 5]
                    );
                  case 1:
                    return (i = m.sent()), [3, 4];
                  case 2:
                    return [4, Kf(e, t)];
                  case 3:
                    (i = m.sent()), (m.label = 4);
                  case 4:
                    if (i)
                      return (
                        (s = Yf(
                          {
                            priceList: Yf(
                              {},
                              null == i ? void 0 : i.b2bPriceList
                            ),
                            companyLocationCatalogCursorDetails: Yf(
                              {},
                              null == i
                                ? void 0
                                : i.companyLocationCatalogCursorDetails
                            ),
                          },
                          null == i ? void 0 : i.selectedB2bLocationDetails
                        )),
                        (l = Yf(
                          Yf({}, o),
                          (((c = {})[e] = Yf(
                            Yf(Yf({}, o[e]), {
                              priceList: Yf(
                                Yf(
                                  {},
                                  null === (p = o[e]) || void 0 === p
                                    ? void 0
                                    : p.priceList
                                ),
                                s.priceList
                              ),
                              companyLocationCatalogCursorDetails:
                                s.companyLocationCatalogCursorDetails,
                            }),
                            s
                          )),
                          c)
                        )),
                        (d = { payload: l, type: A.LOCATION_PRICELIST_DATA }),
                        a(d),
                        [2, l[e]]
                      );
                    m.label = 5;
                  case 5:
                    return [3, 7];
                  case 6:
                    return m.sent(), [2, null];
                  case 7:
                    return [2];
                }
              });
            });
          }
        );
      }
      function jg(e, t) {
        var n = this;
        return function (r) {
          return Jf(n, void 0, void 0, function () {
            var n, o, a, i, s, l, d;
            return Xf(this, function (c) {
              switch (c.label) {
                case 0:
                  return (
                    c.trys.push([0, 2, , 3]),
                    (n = F.getState().salesRepData.locationPricelistData || {}),
                    [4, qf(t)]
                  );
                case 1:
                  return (
                    (o = c.sent()),
                    (a =
                      (null === (d = n[e]) || void 0 === d
                        ? void 0
                        : d.priceList) || []),
                    o
                      ? ((a = Object.keys(a).reduce(function (e, t) {
                          var n,
                            r = a[t];
                          return (
                            t &&
                            (null ===
                              (n =
                                null == o
                                  ? void 0
                                  : o.CatalogQuantityRulesDetails) ||
                            void 0 === n
                              ? void 0
                              : n[t])
                              ? (e[t] = Yf(Yf({}, r), {
                                  QuantityRule:
                                    o.CatalogQuantityRulesDetails[t],
                                }))
                              : (e[t] = r),
                            e
                          );
                        }, {})),
                        (i = Yf(
                          Yf({}, n),
                          (((l = {})[e] = Yf(Yf({}, n[e]), { priceList: a })),
                          l)
                        )),
                        (s = { payload: i, type: A.LOCATION_PRICELIST_DATA }),
                        r(s),
                        [2, i[e]])
                      : [3, 3]
                  );
                case 2:
                  return c.sent(), [2, null];
                case 3:
                  return [2];
              }
            });
          });
        };
      }
      var Ng = function (e) {
        return Jf(void 0, void 0, void 0, function () {
          var t, n, r, o;
          return Xf(this, function (a) {
            switch (a.label) {
              case 0:
                return [4, Qf(e)];
              case 1:
                return 200 === (null == (t = a.sent()) ? void 0 : t.status)
                  ? [
                      2,
                      void 0 !==
                        (null === (n = null == t ? void 0 : t.data) ||
                        void 0 === n
                          ? void 0
                          : n.id) &&
                        null !==
                          (null === (r = null == t ? void 0 : t.data) ||
                          void 0 === r
                            ? void 0
                            : r.id) &&
                        "" !==
                          (null === (o = null == t ? void 0 : t.data) ||
                          void 0 === o
                            ? void 0
                            : o.id),
                    ]
                  : (null == t ? void 0 : t.exceptionMessage)
                  ? [2, t.exceptionMessage]
                  : [2, !1];
            }
          });
        });
      };
      function Dg(e) {
        return (0, Zt.ZP)("MuiBadge", e);
      }
      var Ag = (0, Ft.Z)("MuiBadge", [
        "root",
        "badge",
        "dot",
        "standard",
        "anchorOriginTopRight",
        "anchorOriginBottomRight",
        "anchorOriginTopLeft",
        "anchorOriginBottomLeft",
        "invisible",
        "colorError",
        "colorInfo",
        "colorPrimary",
        "colorSecondary",
        "colorSuccess",
        "colorWarning",
        "overlapRectangular",
        "overlapCircular",
        "anchorOriginTopLeftCircular",
        "anchorOriginTopLeftRectangular",
        "anchorOriginTopRightCircular",
        "anchorOriginTopRightRectangular",
        "anchorOriginBottomLeftCircular",
        "anchorOriginBottomLeftRectangular",
        "anchorOriginBottomRightCircular",
        "anchorOriginBottomRightRectangular",
      ]);
      const Eg = [
          "anchorOrigin",
          "className",
          "classes",
          "component",
          "components",
          "componentsProps",
          "children",
          "overlap",
          "color",
          "invisible",
          "max",
          "badgeContent",
          "slots",
          "slotProps",
          "showZero",
          "variant",
        ],
        Rg = (0, Bt.ZP)("span", {
          name: "MuiBadge",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({
          position: "relative",
          display: "inline-flex",
          verticalAlign: "middle",
          flexShrink: 0,
        }),
        Lg = (0, Bt.ZP)("span", {
          name: "MuiBadge",
          slot: "Badge",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.badge,
              t[n.variant],
              t[
                `anchorOrigin${(0, $n.Z)(n.anchorOrigin.vertical)}${(0, $n.Z)(
                  n.anchorOrigin.horizontal
                )}${(0, $n.Z)(n.overlap)}`
              ],
              "default" !== n.color && t[`color${(0, $n.Z)(n.color)}`],
              n.invisible && t.invisible,
            ];
          },
        })(({ theme: e }) => {
          var t;
          return {
            display: "flex",
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "center",
            alignContent: "center",
            alignItems: "center",
            position: "absolute",
            boxSizing: "border-box",
            fontFamily: e.typography.fontFamily,
            fontWeight: e.typography.fontWeightMedium,
            fontSize: e.typography.pxToRem(12),
            minWidth: 20,
            lineHeight: 1,
            padding: "0 6px",
            height: 20,
            borderRadius: 10,
            zIndex: 1,
            transition: e.transitions.create("transform", {
              easing: e.transitions.easing.easeInOut,
              duration: e.transitions.duration.enteringScreen,
            }),
            variants: [
              ...Object.keys((null != (t = e.vars) ? t : e).palette)
                .filter((t) => {
                  var n, r;
                  return (
                    (null != (n = e.vars) ? n : e).palette[t].main &&
                    (null != (r = e.vars) ? r : e).palette[t].contrastText
                  );
                })
                .map((t) => ({
                  props: { color: t },
                  style: {
                    backgroundColor: (e.vars || e).palette[t].main,
                    color: (e.vars || e).palette[t].contrastText,
                  },
                })),
              {
                props: { variant: "dot" },
                style: { borderRadius: 4, height: 8, minWidth: 8, padding: 0 },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  top: 0,
                  right: 0,
                  transform: "scale(1) translate(50%, -50%)",
                  transformOrigin: "100% 0%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  bottom: 0,
                  right: 0,
                  transform: "scale(1) translate(50%, 50%)",
                  transformOrigin: "100% 100%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  top: 0,
                  left: 0,
                  transform: "scale(1) translate(-50%, -50%)",
                  transformOrigin: "0% 0%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(-50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "rectangular" === e.overlap,
                style: {
                  bottom: 0,
                  left: 0,
                  transform: "scale(1) translate(-50%, 50%)",
                  transformOrigin: "0% 100%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(-50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  top: "14%",
                  right: "14%",
                  transform: "scale(1) translate(50%, -50%)",
                  transformOrigin: "100% 0%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "right" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  bottom: "14%",
                  right: "14%",
                  transform: "scale(1) translate(50%, 50%)",
                  transformOrigin: "100% 100%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(50%, 50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "top" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  top: "14%",
                  left: "14%",
                  transform: "scale(1) translate(-50%, -50%)",
                  transformOrigin: "0% 0%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(-50%, -50%)",
                  },
                },
              },
              {
                props: ({ ownerState: e }) =>
                  "bottom" === e.anchorOrigin.vertical &&
                  "left" === e.anchorOrigin.horizontal &&
                  "circular" === e.overlap,
                style: {
                  bottom: "14%",
                  left: "14%",
                  transform: "scale(1) translate(-50%, 50%)",
                  transformOrigin: "0% 100%",
                  [`&.${Ag.invisible}`]: {
                    transform: "scale(0) translate(-50%, 50%)",
                  },
                },
              },
              {
                props: { invisible: !0 },
                style: {
                  transition: e.transitions.create("transform", {
                    easing: e.transitions.easing.easeInOut,
                    duration: e.transitions.duration.leavingScreen,
                  }),
                },
              },
            ],
          };
        }),
        Bg = t.forwardRef(function (t, n) {
          var r, o, a, i, s, l;
          const d = (0, zt.i)({ props: t, name: "MuiBadge" }),
            {
              anchorOrigin: c = { vertical: "top", horizontal: "right" },
              className: p,
              component: m,
              components: h = {},
              componentsProps: f = {},
              children: g,
              overlap: v = "rectangular",
              color: b = "default",
              invisible: _ = !1,
              max: y = 99,
              badgeContent: C,
              slots: x,
              slotProps: S,
              showZero: k = !1,
              variant: P = "standard",
            } = d,
            w = (0, At.Z)(d, Eg),
            {
              badgeContent: O,
              invisible: T,
              max: I,
              displayValue: M,
            } = (function (e) {
              const {
                  badgeContent: t,
                  invisible: n = !1,
                  max: r = 99,
                  showZero: o = !1,
                } = e,
                a = Wc({ badgeContent: t, max: r });
              let i = n;
              !1 !== n || 0 !== t || o || (i = !0);
              const { badgeContent: s, max: l = r } = i ? a : e;
              return {
                badgeContent: s,
                invisible: i,
                max: l,
                displayValue: s && Number(s) > l ? `${l}+` : s,
              };
            })({ max: y, invisible: _, badgeContent: C, showZero: k }),
            j = Wc({
              anchorOrigin: c,
              color: b,
              overlap: v,
              variant: P,
              badgeContent: C,
            }),
            N = T || (null == O && "dot" !== P),
            {
              color: D = b,
              overlap: A = v,
              anchorOrigin: E = c,
              variant: R = P,
            } = N ? j : d,
            L = "dot" !== R ? M : void 0,
            B = (0, u.Z)({}, d, {
              badgeContent: O,
              invisible: N,
              max: I,
              displayValue: L,
              showZero: k,
              anchorOrigin: E,
              color: D,
              overlap: A,
              variant: R,
            }),
            z = ((e) => {
              const {
                  color: t,
                  anchorOrigin: n,
                  invisible: r,
                  overlap: o,
                  variant: a,
                  classes: i = {},
                } = e,
                s = {
                  root: ["root"],
                  badge: [
                    "badge",
                    a,
                    r && "invisible",
                    `anchorOrigin${(0, $n.Z)(n.vertical)}${(0, $n.Z)(
                      n.horizontal
                    )}`,
                    `anchorOrigin${(0, $n.Z)(n.vertical)}${(0, $n.Z)(
                      n.horizontal
                    )}${(0, $n.Z)(o)}`,
                    `overlap${(0, $n.Z)(o)}`,
                    "default" !== t && `color${(0, $n.Z)(t)}`,
                  ],
                };
              return (0, Rt.Z)(s, Dg, i);
            })(B),
            F =
              null !=
              (r = null != (o = null == x ? void 0 : x.root) ? o : h.Root)
                ? r
                : Rg,
            Z =
              null !=
              (a = null != (i = null == x ? void 0 : x.badge) ? i : h.Badge)
                ? a
                : Lg,
            H = null != (s = null == S ? void 0 : S.root) ? s : f.root,
            V = null != (l = null == S ? void 0 : S.badge) ? l : f.badge,
            W = mr({
              elementType: F,
              externalSlotProps: H,
              externalForwardedProps: w,
              additionalProps: { ref: n, as: m },
              ownerState: B,
              className: (0, Et.Z)(null == H ? void 0 : H.className, z.root, p),
            }),
            U = mr({
              elementType: Z,
              externalSlotProps: V,
              ownerState: B,
              className: (0, Et.Z)(z.badge, null == V ? void 0 : V.className),
            });
          return (0,
          e.jsxs)(F, (0, u.Z)({}, W, { children: [g, (0, e.jsx)(Z, (0, u.Z)({}, U, { children: L }))] }));
        });
      var zg = Bg,
        Fg = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12z",
          }),
          "Cancel"
        ),
        Zg = "editOrder",
        Hg = "shopify",
        Vg = "deny",
        Wg = "redirectTab",
        Ug = "Yes",
        $g = "No",
        Kg = "createOrder",
        Gg = "draftOrder",
        qg = "CREATE_CHECKOUT",
        Qg = "SelectShippingAtCheckout",
        Yg = "isShippingAddress",
        Jg = "isBillingAddress",
        Xg = o(8699);
      function ev(e) {
        return (0, Zt.ZP)("MuiLinearProgress", e);
      }
      (0, Ft.Z)("MuiLinearProgress", [
        "root",
        "colorPrimary",
        "colorSecondary",
        "determinate",
        "indeterminate",
        "buffer",
        "query",
        "dashed",
        "dashedColorPrimary",
        "dashedColorSecondary",
        "bar",
        "barColorPrimary",
        "barColorSecondary",
        "bar1Indeterminate",
        "bar1Determinate",
        "bar1Buffer",
        "bar2Indeterminate",
        "bar2Buffer",
      ]);
      const tv = ["className", "color", "value", "valueBuffer", "variant"];
      let nv,
        rv,
        ov,
        av,
        iv,
        sv,
        lv = (e) => e;
      const dv = (0, Pn.F4)(
          nv ||
            (nv = lv`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`)
        ),
        cv = (0, Pn.F4)(
          rv ||
            (rv = lv`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`)
        ),
        uv = (0, Pn.F4)(
          ov ||
            (ov = lv`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`)
        ),
        pv = (e, t) =>
          "inherit" === t
            ? "currentColor"
            : e.vars
            ? e.vars.palette.LinearProgress[`${t}Bg`]
            : "light" === e.palette.mode
            ? (0, Lt.$n)(e.palette[t].main, 0.62)
            : (0, Lt._j)(e.palette[t].main, 0.5),
        mv = (0, Bt.ZP)("span", {
          name: "MuiLinearProgress",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[`color${(0, $n.Z)(n.color)}`], t[n.variant]];
          },
        })(({ ownerState: e, theme: t }) =>
          (0, u.Z)(
            {
              position: "relative",
              overflow: "hidden",
              display: "block",
              height: 4,
              zIndex: 0,
              "@media print": { colorAdjust: "exact" },
              backgroundColor: pv(t, e.color),
            },
            "inherit" === e.color &&
              "buffer" !== e.variant && {
                backgroundColor: "none",
                "&::before": {
                  content: '""',
                  position: "absolute",
                  left: 0,
                  top: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "currentColor",
                  opacity: 0.3,
                },
              },
            "buffer" === e.variant && { backgroundColor: "transparent" },
            "query" === e.variant && { transform: "rotate(180deg)" }
          )
        ),
        hv = (0, Bt.ZP)("span", {
          name: "MuiLinearProgress",
          slot: "Dashed",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.dashed, t[`dashedColor${(0, $n.Z)(n.color)}`]];
          },
        })(
          ({ ownerState: e, theme: t }) => {
            const n = pv(t, e.color);
            return (0, u.Z)(
              {
                position: "absolute",
                marginTop: 0,
                height: "100%",
                width: "100%",
              },
              "inherit" === e.color && { opacity: 0.3 },
              {
                backgroundImage: `radial-gradient(${n} 0%, ${n} 16%, transparent 42%)`,
                backgroundSize: "10px 10px",
                backgroundPosition: "0 -23px",
              }
            );
          },
          (0, Pn.iv)(
            av ||
              (av = lv`
    animation: ${0} 3s infinite linear;
  `),
            uv
          )
        ),
        fv = (0, Bt.ZP)("span", {
          name: "MuiLinearProgress",
          slot: "Bar1",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.bar,
              t[`barColor${(0, $n.Z)(n.color)}`],
              ("indeterminate" === n.variant || "query" === n.variant) &&
                t.bar1Indeterminate,
              "determinate" === n.variant && t.bar1Determinate,
              "buffer" === n.variant && t.bar1Buffer,
            ];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, u.Z)(
              {
                width: "100%",
                position: "absolute",
                left: 0,
                bottom: 0,
                top: 0,
                transition: "transform 0.2s linear",
                transformOrigin: "left",
                backgroundColor:
                  "inherit" === e.color
                    ? "currentColor"
                    : (t.vars || t).palette[e.color].main,
              },
              "determinate" === e.variant && {
                transition: "transform .4s linear",
              },
              "buffer" === e.variant && {
                zIndex: 1,
                transition: "transform .4s linear",
              }
            ),
          ({ ownerState: e }) =>
            ("indeterminate" === e.variant || "query" === e.variant) &&
            (0, Pn.iv)(
              iv ||
                (iv = lv`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `),
              dv
            )
        ),
        gv = (0, Bt.ZP)("span", {
          name: "MuiLinearProgress",
          slot: "Bar2",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.bar,
              t[`barColor${(0, $n.Z)(n.color)}`],
              ("indeterminate" === n.variant || "query" === n.variant) &&
                t.bar2Indeterminate,
              "buffer" === n.variant && t.bar2Buffer,
            ];
          },
        })(
          ({ ownerState: e, theme: t }) =>
            (0, u.Z)(
              {
                width: "100%",
                position: "absolute",
                left: 0,
                bottom: 0,
                top: 0,
                transition: "transform 0.2s linear",
                transformOrigin: "left",
              },
              "buffer" !== e.variant && {
                backgroundColor:
                  "inherit" === e.color
                    ? "currentColor"
                    : (t.vars || t).palette[e.color].main,
              },
              "inherit" === e.color && { opacity: 0.3 },
              "buffer" === e.variant && {
                backgroundColor: pv(t, e.color),
                transition: "transform .4s linear",
              }
            ),
          ({ ownerState: e }) =>
            ("indeterminate" === e.variant || "query" === e.variant) &&
            (0, Pn.iv)(
              sv ||
                (sv = lv`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `),
              cv
            )
        ),
        vv = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiLinearProgress" }),
            {
              className: o,
              color: a = "primary",
              value: i,
              valueBuffer: s,
              variant: l = "indeterminate",
            } = r,
            d = (0, At.Z)(r, tv),
            c = (0, u.Z)({}, r, { color: a, variant: l }),
            p = ((e) => {
              const { classes: t, variant: n, color: r } = e,
                o = {
                  root: ["root", `color${(0, $n.Z)(r)}`, n],
                  dashed: ["dashed", `dashedColor${(0, $n.Z)(r)}`],
                  bar1: [
                    "bar",
                    `barColor${(0, $n.Z)(r)}`,
                    ("indeterminate" === n || "query" === n) &&
                      "bar1Indeterminate",
                    "determinate" === n && "bar1Determinate",
                    "buffer" === n && "bar1Buffer",
                  ],
                  bar2: [
                    "bar",
                    "buffer" !== n && `barColor${(0, $n.Z)(r)}`,
                    "buffer" === n && `color${(0, $n.Z)(r)}`,
                    ("indeterminate" === n || "query" === n) &&
                      "bar2Indeterminate",
                    "buffer" === n && "bar2Buffer",
                  ],
                };
              return (0, Rt.Z)(o, ev, t);
            })(c),
            m = tr(),
            h = {},
            f = { bar1: {}, bar2: {} };
          if (("determinate" === l || "buffer" === l) && void 0 !== i) {
            (h["aria-valuenow"] = Math.round(i)),
              (h["aria-valuemin"] = 0),
              (h["aria-valuemax"] = 100);
            let e = i - 100;
            m && (e = -e), (f.bar1.transform = `translateX(${e}%)`);
          }
          if ("buffer" === l && void 0 !== s) {
            let e = (s || 0) - 100;
            m && (e = -e), (f.bar2.transform = `translateX(${e}%)`);
          }
          return (0,
          e.jsxs)(mv, (0, u.Z)({ className: (0, Et.Z)(p.root, o), ownerState: c, role: "progressbar" }, h, { ref: n }, d, { children: ["buffer" === l ? (0, e.jsx)(hv, { className: p.dashed, ownerState: c }) : null, (0, e.jsx)(fv, { className: p.bar1, ownerState: c, style: f.bar1 }), "determinate" === l ? null : (0, e.jsx)(gv, { className: p.bar2, ownerState: c, style: f.bar2 })] }));
        });
      var bv = vv,
        _v = function () {
          return (
            (_v =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            _v.apply(this, arguments)
          );
        },
        yv = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Cv = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function xv() {
        var n,
          r,
          o,
          a = this,
          i = (0, t.useState)({}),
          s = i[0],
          l = i[1],
          d = (0, t.useState)(!1),
          c = d[0],
          u = d[1],
          p = (0, t.useState)(!0),
          m = p[0],
          h = p[1],
          f = ee().t,
          g =
            null !==
              (o =
                null ===
                  (r =
                    null === (n = F.getState().salesRepData) || void 0 === n
                      ? void 0
                      : n.loggedInRepDetails) || void 0 === r
                  ? void 0
                  : r.countriesAndStates) && void 0 !== o
              ? o
              : {},
          v = (0, e.jsx)(
            Hp,
            _v(
              {
                open: c,
                onClose: function () {
                  return u(!1);
                },
                maxWidth: "sm",
                fullWidth: !0,
              },
              {
                children: (0, e.jsxs)(
                  mn,
                  _v(
                    { className: "ST_DB_Dialog_Box" },
                    {
                      children: [
                        (0, e.jsxs)(
                          qa,
                          _v(
                            { container: !0, spacing: 2, mb: 2, pl: 2 },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  _v(
                                    { item: !0, xs: 10, md: 10 },
                                    {
                                      children: (0, e.jsx)(
                                        ni,
                                        _v(
                                          { variant: "h6" },
                                          {
                                            children: (0, e.jsx)("b", {
                                              children: f("productStatus"),
                                            }),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  qa,
                                  _v(
                                    {
                                      item: !0,
                                      xs: 2,
                                      md: 2,
                                      sx: { textAlign: "right" },
                                      pr: 1,
                                    },
                                    {
                                      children: (0, e.jsx)(Fg, {
                                        sx: { cursor: "pointer" },
                                        onClick: function () {
                                          u(!1);
                                        },
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                        m &&
                          (0, e.jsx)(
                            "p",
                            _v(
                              { style: { textAlign: "center" } },
                              { children: f("loading") }
                            )
                          ),
                        (0, e.jsx)(
                          Gp,
                          _v(
                            { sx: { padding: "0px" } },
                            {
                              children: (0, e.jsx)("img", {
                                style: { width: "100%", height: "100%" },
                                src: "https://salesrepapp.azurewebsites.net/assets/img/productTableGuide.png",
                                onLoad: function () {
                                  h(!1);
                                },
                                onError: function () {
                                  h(!1);
                                },
                              }),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          "div",
                          _v(
                            {
                              style: { textAlign: "center", marginTop: "1rem" },
                            },
                            {
                              children: (0, e.jsxs)(
                                ni,
                                _v(
                                  { variant: "h6" },
                                  {
                                    children: [
                                      f("makeSureInShopify"),
                                      " ",
                                      (0, e.jsx)("b", {
                                        children: f("products"),
                                      }),
                                      " ",
                                      f("sectionTheProductStatusIs"),
                                      " ",
                                      (0, e.jsx)("b", {
                                        children: f("active"),
                                      }),
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
              }
            )
          ),
          b = function (e) {
            var t,
              n,
              r =
                null !==
                  (n =
                    null !== (t = null == e ? void 0 : e.inventory_quantity) &&
                    void 0 !== t
                      ? t
                      : null == e
                      ? void 0
                      : e.inventoryQuantity) && void 0 !== n
                  ? n
                  : 0;
            return (
              (null == e ? void 0 : e.inventory_management) === Hg &&
              (null == e ? void 0 : e.inventory_policy) === Vg &&
              r <= 0
            );
          };
        function _(t) {
          return (0, e.jsxs)(
            mn,
            _v(
              { sx: { position: "relative", display: "inline-flex" } },
              {
                children: [
                  (0, e.jsx)(
                    Um,
                    _v({ variant: "determinate" }, t, { size: 60 })
                  ),
                  (0, e.jsx)(
                    mn,
                    _v(
                      {
                        sx: {
                          top: 0,
                          left: 0,
                          bottom: 0,
                          right: 0,
                          position: "absolute",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        },
                      },
                      {
                        children: (0, e.jsx)(
                          ni,
                          _v(
                            {
                              variant: "caption",
                              component: "div",
                              sx: { color: "text.secondary" },
                            },
                            { children: "".concat(Math.round(t.value), "%") }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          );
        }
        return {
          copyTextFunction: function (e, t) {
            return yv(a, void 0, void 0, function () {
              var n, r;
              return Cv(this, function (o) {
                switch (o.label) {
                  case 0:
                    if (!(n = e)) return [3, 4];
                    o.label = 1;
                  case 1:
                    return (
                      o.trys.push([1, 3, , 4]),
                      [4, navigator.clipboard.writeText(n)]
                    );
                  case 2:
                    return (
                      o.sent(),
                      l(_v(_v({}, s), (((r = {})[t] = "#05bf05"), r))),
                      setTimeout(function () {
                        var e;
                        l(_v(_v({}, s), (((e = {})[t] = "#757575"), e)));
                      }, 2e3),
                      [3, 4]
                    );
                  case 3:
                    return o.sent(), [2];
                  case 4:
                    return [2];
                }
              });
            });
          },
          copyIconSuccessColor: s,
          getProductTableRenderPopup: v,
          handleProductTableGuidePopup: function () {
            u(!c);
          },
          checkVariantIsSoldOut: b,
          checkAllVariantsSoldOutInProduct: function (e) {
            var t, n;
            return (
              !(
                (null === (t = null == e ? void 0 : e.variants) || void 0 === t
                  ? void 0
                  : t.length) > 0
              ) ||
              (null === (n = null == e ? void 0 : e.variants) || void 0 === n
                ? void 0
                : n.every(function (e) {
                    return b(e);
                  }))
            );
          },
          filterVariantsWithOutSoldOut: function (e) {
            var t,
              n,
              r = _v({}, e);
            return (
              (null === (t = null == e ? void 0 : e.variants) || void 0 === t
                ? void 0
                : t.length) > 0 &&
                (r.variants =
                  null === (n = null == r ? void 0 : r.variants) || void 0 === n
                    ? void 0
                    : n.filter(function (e) {
                        return !b(e);
                      })),
              r
            );
          },
          showInventoryQuantity: function (t, n) {
            return n
              ? (null == t ? void 0 : t.quantityAvailable) || 0
              : b(t)
              ? (0, e.jsx)(zg, {
                  className: "ST_SoldOut",
                  badgeContent: f("soldOut"),
                  color: "warning",
                })
              : (null == t ? void 0 : t.inventory_management) !== Hg
              ? f("InventoryNotTracked")
              : (null == t ? void 0 : t.inventory_quantity) || 0;
          },
          filterprovince: function (e, t) {
            var n = null != e ? e : [];
            return (
              "mx" === (null == t ? void 0 : t.trim()) &&
                (n =
                  null == e
                    ? void 0
                    : e.map(function (e) {
                        return null == e
                          ? void 0
                          : e.replace(
                              /Estado de |Coahuila de|-Llave|de Ocampo/g,
                              ""
                            );
                      })),
              n
            );
          },
          getProvinceOfShopify: function (e) {
            return g[e] || [];
          },
          SnackbarAlertMsg: function (t, n) {
            var r;
            return "" !== (null == t ? void 0 : t.msg)
              ? (0, e.jsx)(
                  um,
                  _v(
                    {
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                      },
                      open: null == t ? void 0 : t.open,
                      autoHideDuration: 4e3,
                      onClose: n,
                    },
                    {
                      children: (0, e.jsx)(
                        Im,
                        _v(
                          {
                            onClose: n,
                            severity:
                              null !== (r = null == t ? void 0 : t.severity) &&
                              void 0 !== r
                                ? r
                                : "error",
                            variant: "filled",
                            sx: { width: "100%" },
                          },
                          { children: null == t ? void 0 : t.msg }
                        )
                      ),
                    }
                  )
                )
              : (0, e.jsx)(e.Fragment, {});
          },
          getCountriesList: function () {
            var e,
              t = [];
            return (
              null === (e = (0, Xg.getCountries)()) ||
                void 0 === e ||
                e.forEach(function (e) {
                  var n, r, o, a;
                  "gb" ===
                  (null ===
                    (r =
                      null === (n = null == e ? void 0 : e.code) || void 0 === n
                        ? void 0
                        : n.trim()) || void 0 === r
                    ? void 0
                    : r.toLowerCase())
                    ? t.push(_v(_v({}, e), { name: "United Kingdom" }))
                    : "us" ===
                      (null ===
                        (a =
                          null === (o = null == e ? void 0 : e.code) ||
                          void 0 === o
                            ? void 0
                            : o.trim()) || void 0 === a
                        ? void 0
                        : a.toLowerCase())
                    ? t.push(_v(_v({}, e), { name: "United States" }))
                    : t.push(e);
                }),
              t.sort(function (e, t) {
                return e.name.localeCompare(t.name);
              })
            );
          },
          useInfiniteScroll: function (e, n, r) {
            var o = (0, t.useRef)(null);
            return (
              (0, t.useEffect)(
                function () {
                  var t = function () {
                      var t = null == o ? void 0 : o.current;
                      if (t) {
                        var a = null == t ? void 0 : t.scrollTop;
                        ((a /
                          ((null == t ? void 0 : t.scrollHeight) -
                            (null == t ? void 0 : t.clientHeight))) *
                          100 >
                          90 ||
                          0 === a) &&
                          e < (null == r ? void 0 : r.length) &&
                          n(e + 5);
                      }
                    },
                    a = o.current;
                  return (
                    a && a.addEventListener("scroll", t),
                    function () {
                      a && a.removeEventListener("scroll", t);
                    }
                  );
                },
                [r, e]
              ),
              o
            );
          },
          getDateFormat: function (e) {
            var t, n, r;
            return (null == e ? void 0 : e.includes("-"))
              ? null === (t = null == e ? void 0 : e.split("T")[0]) ||
                void 0 === t
                ? void 0
                : t.replace(/(\d{4})-(\d{2})-(\d{2}).*/, "$2/$3/$1")
              : null ===
                  (r = new Date(
                    parseInt(
                      null ===
                        (n = null == e ? void 0 : e.replace("/Date(", "")) ||
                        void 0 === n
                        ? void 0
                        : n.replace(")/", "")
                    )
                  )) || void 0 === r
              ? void 0
              : r.toLocaleDateString();
          },
          disableTableRow: function (e) {
            var t, n;
            return (
              (null === (t = null == e ? void 0 : e.variants) || void 0 === t
                ? void 0
                : t.length) > 0 &&
              (null === (n = null == e ? void 0 : e.variants) || void 0 === n
                ? void 0
                : n.every(function (e) {
                    return !(null == e ? void 0 : e.availableForSale);
                  }))
            );
          },
          debounce: function (e, t) {
            var n;
            return function () {
              for (var r = [], o = 0; o < arguments.length; o++)
                r[o] = arguments[o];
              clearTimeout(n),
                (n = setTimeout(function () {
                  return e.apply(void 0, r);
                }, t));
            };
          },
          LinearDeterminate: function () {
            var n = t.useState(0),
              r = n[0],
              o = n[1];
            return (
              t.useEffect(function () {
                var e = setInterval(function () {
                  o(function (e) {
                    if (100 === e) return 0;
                    var t = 10 * Math.random();
                    return Math.min(e + t, 100);
                  });
                }, 500);
                return function () {
                  clearInterval(e);
                };
              }, []),
              (0, e.jsx)(
                mn,
                _v(
                  { sx: { width: "100%" } },
                  {
                    children: (0, e.jsx)(bv, {
                      variant: "determinate",
                      value: r,
                    }),
                  }
                )
              )
            );
          },
          CircularWithValueLabel: function () {
            var n = t.useState(10),
              r = n[0],
              o = n[1];
            return (
              t.useEffect(function () {
                var e = setInterval(function () {
                  o(function (e) {
                    return e >= 100 ? 0 : e + 10;
                  });
                }, 800);
                return function () {
                  clearInterval(e);
                };
              }, []),
              (0, e.jsx)(_, { value: r })
            );
          },
        };
      }
      function Sv(e, n, r, o, a) {
        const [i, s] = t.useState(() =>
          a && r ? r(e).matches : o ? o(e).matches : n
        );
        return (
          (0, yr.Z)(() => {
            let t = !0;
            if (!r) return;
            const n = r(e),
              o = () => {
                t && s(n.matches);
              };
            return (
              o(),
              n.addListener(o),
              () => {
                (t = !1), n.removeListener(o);
              }
            );
          }, [e, r]),
          i
        );
      }
      const kv = n.useSyncExternalStore;
      function Pv(e, n, r, o, a) {
        const i = t.useCallback(() => n, [n]),
          s = t.useMemo(() => {
            if (a && r) return () => r(e).matches;
            if (null !== o) {
              const { matches: t } = o(e);
              return () => t;
            }
            return i;
          }, [i, e, o, a, r]),
          [l, d] = t.useMemo(() => {
            if (null === r) return [i, () => () => {}];
            const t = r(e);
            return [
              () => t.matches,
              (e) => (
                t.addListener(e),
                () => {
                  t.removeListener(e);
                }
              ),
            ];
          }, [i, r, e]);
        return kv(d, l, s);
      }
      function wv(e, t = {}) {
        const n = nn(),
          r = "undefined" != typeof window && void 0 !== window.matchMedia,
          {
            defaultMatches: o = !1,
            matchMedia: a = r ? window.matchMedia : null,
            ssrMatchMedia: i = null,
            noSsr: s = !1,
          } = Mm({ name: "MuiUseMediaQuery", props: t, theme: n });
        let l = "function" == typeof e ? e(n) : e;
        return (
          (l = l.replace(/^@media( ?)/m, "")),
          (void 0 !== kv ? Pv : Sv)(l, o, a, i, s)
        );
      }
      function Ov() {
        for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
        var n = !1;
        try {
          return (
            null == e ||
              e.forEach(function (e) {
                (null != e && "" !== e.toString().trim()) || (n = !0);
              }),
            n
          );
        } catch (e) {
          return !0;
        }
      }
      var Tv = function () {
          var e = wv(
              "(min-device-width: 768px) and (max-device-width: 834px) and (min-device-height: 1024px) and (max-device-height: 1112px) and (-webkit-min-device-pixel-ratio: 2), (min-device-width: 1024px) and (max-device-width: 1112px) and (min-device-height: 768px) and (max-device-height: 834px) and (-webkit-min-device-pixel-ratio: 2)"
            ),
            t = wv(
              "(min-device-width: 834px) and (max-device-width: 834px) and (min-device-height: 1112px) and (max-device-height: 1112px) and (-webkit-min-device-pixel-ratio: 2), (min-device-width: 1112px) and (max-device-width: 1112px) and (min-device-height: 834px) and (max-device-height: 834px) and (-webkit-min-device-pixel-ratio: 2)"
            ),
            n = wv(
              "(min-device-width: 820px) and (max-device-width: 820px) and (min-device-height: 1180px) and (max-device-height: 1180px) and (-webkit-min-device-pixel-ratio: 2), (min-device-width: 1180px) and (max-device-width: 1180px) and (min-device-height: 820px) and (max-device-height: 820px) and (-webkit-min-device-pixel-ratio: 2)"
            ),
            r = wv(
              "(min-device-width: 834px) and (max-device-width: 834px) and (min-device-height: 1194px) and (max-device-height: 1194px) and (-webkit-min-device-pixel-ratio: 2), (min-device-width: 1194px) and (max-device-width: 1194px) and (min-device-height: 834px) and (max-device-height: 834px) and (-webkit-min-device-pixel-ratio: 2)"
            ),
            o = wv(
              "(min-device-width: 1024px) and (max-device-width: 1024px) and (min-device-height: 1366px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2), (min-device-width: 1366px) and (max-device-width: 1366px) and (min-device-height: 1024px) and (max-device-height: 1024px) and (-webkit-min-device-pixel-ratio: 2)"
            ),
            a = wv("(max-width: 767px)"),
            i = wv("(max-height: 500px) and (orientation: landscape)");
          return e || t || n || r || o || a || i;
        },
        Iv = function () {
          return (
            (Iv =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Iv.apply(this, arguments)
          );
        },
        Mv = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        jv = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Nv = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        },
        Dv = { textTransform: "capitalize" },
        Av = "h6",
        Ev = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6zM19 4h-3.5l-1-1h-5l-1 1H5v2h14z",
          }),
          "Delete"
        ),
        Rv = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14",
          }),
          "Search"
        ),
        Lv = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1M8 13h8v-2H8zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5",
          }),
          "InsertLink"
        );
      function Bv(e) {
        return (0, Zt.ZP)("PrivateSwitchBase", e);
      }
      (0, Ft.Z)("PrivateSwitchBase", [
        "root",
        "checked",
        "disabled",
        "input",
        "edgeStart",
        "edgeEnd",
      ]);
      const zv = [
          "autoFocus",
          "checked",
          "checkedIcon",
          "className",
          "defaultChecked",
          "disabled",
          "disableFocusRipple",
          "edge",
          "icon",
          "id",
          "inputProps",
          "inputRef",
          "name",
          "onBlur",
          "onChange",
          "onFocus",
          "readOnly",
          "required",
          "tabIndex",
          "type",
          "value",
        ],
        Fv = (0, Bt.ZP)(Un)(({ ownerState: e }) =>
          (0, u.Z)(
            { padding: 9, borderRadius: "50%" },
            "start" === e.edge && { marginLeft: "small" === e.size ? -3 : -12 },
            "end" === e.edge && { marginRight: "small" === e.size ? -3 : -12 }
          )
        ),
        Zv = (0, Bt.ZP)("input", { shouldForwardProp: vo.Z })({
          cursor: "inherit",
          position: "absolute",
          opacity: 0,
          width: "100%",
          height: "100%",
          top: 0,
          left: 0,
          margin: 0,
          padding: 0,
          zIndex: 1,
        }),
        Hv = t.forwardRef(function (t, n) {
          const {
              autoFocus: r,
              checked: o,
              checkedIcon: a,
              className: i,
              defaultChecked: s,
              disabled: l,
              disableFocusRipple: d = !1,
              edge: c = !1,
              icon: p,
              id: m,
              inputProps: h,
              inputRef: f,
              name: g,
              onBlur: v,
              onChange: b,
              onFocus: _,
              readOnly: y,
              required: C = !1,
              tabIndex: x,
              type: S,
              value: k,
            } = t,
            P = (0, At.Z)(t, zv),
            [w, O] = (0, Ls.Z)({
              controlled: o,
              default: Boolean(s),
              name: "SwitchBase",
              state: "checked",
            }),
            T = fl();
          let I = l;
          T && void 0 === I && (I = T.disabled);
          const M = "checkbox" === S || "radio" === S,
            j = (0, u.Z)({}, t, {
              checked: w,
              disabled: I,
              disableFocusRipple: d,
              edge: c,
            }),
            N = ((e) => {
              const { classes: t, checked: n, disabled: r, edge: o } = e,
                a = {
                  root: [
                    "root",
                    n && "checked",
                    r && "disabled",
                    o && `edge${(0, $n.Z)(o)}`,
                  ],
                  input: ["input"],
                };
              return (0, Rt.Z)(a, Bv, t);
            })(j);
          return (0, e.jsxs)(
            Fv,
            (0, u.Z)(
              {
                component: "span",
                className: (0, Et.Z)(N.root, i),
                centerRipple: !0,
                focusRipple: !d,
                disabled: I,
                tabIndex: null,
                role: void 0,
                onFocus: (e) => {
                  _ && _(e), T && T.onFocus && T.onFocus(e);
                },
                onBlur: (e) => {
                  v && v(e), T && T.onBlur && T.onBlur(e);
                },
                ownerState: j,
                ref: n,
              },
              P,
              {
                children: [
                  (0, e.jsx)(
                    Zv,
                    (0, u.Z)(
                      {
                        autoFocus: r,
                        checked: o,
                        defaultChecked: s,
                        className: N.input,
                        disabled: I,
                        id: M ? m : void 0,
                        name: g,
                        onChange: (e) => {
                          if (e.nativeEvent.defaultPrevented) return;
                          const t = e.target.checked;
                          O(t), b && b(e, t);
                        },
                        readOnly: y,
                        ref: f,
                        required: C,
                        ownerState: j,
                        tabIndex: x,
                        type: S,
                      },
                      "checkbox" === S && void 0 === k ? {} : { value: k },
                      h
                    )
                  ),
                  w ? a : p,
                ],
              }
            )
          );
        });
      var Vv = Hv,
        Wv = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z",
          }),
          "CheckBoxOutlineBlank"
        ),
        Uv = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z",
          }),
          "CheckBox"
        ),
        $v = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z",
          }),
          "IndeterminateCheckBox"
        );
      function Kv(e) {
        return (0, Zt.ZP)("MuiCheckbox", e);
      }
      var Gv = (0, Ft.Z)("MuiCheckbox", [
        "root",
        "checked",
        "disabled",
        "indeterminate",
        "colorPrimary",
        "colorSecondary",
        "sizeSmall",
        "sizeMedium",
      ]);
      const qv = [
          "checkedIcon",
          "color",
          "icon",
          "indeterminate",
          "indeterminateIcon",
          "inputProps",
          "size",
          "className",
        ],
        Qv = (0, Bt.ZP)(Vv, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiCheckbox",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.indeterminate && t.indeterminate,
              t[`size${(0, $n.Z)(n.size)}`],
              "default" !== n.color && t[`color${(0, $n.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { color: (e.vars || e).palette.text.secondary },
            !t.disableRipple && {
              "&:hover": {
                backgroundColor: e.vars
                  ? `rgba(${
                      "default" === t.color
                        ? e.vars.palette.action.activeChannel
                        : e.vars.palette[t.color].mainChannel
                    } / ${e.vars.palette.action.hoverOpacity})`
                  : (0, Lt.Fq)(
                      "default" === t.color
                        ? e.palette.action.active
                        : e.palette[t.color].main,
                      e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "default" !== t.color && {
              [`&.${Gv.checked}, &.${Gv.indeterminate}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
              [`&.${Gv.disabled}`]: {
                color: (e.vars || e).palette.action.disabled,
              },
            }
          )
        ),
        Yv = (0, e.jsx)(Uv, {}),
        Jv = (0, e.jsx)(Wv, {}),
        Xv = (0, e.jsx)($v, {}),
        eb = t.forwardRef(function (n, r) {
          var o, a;
          const i = (0, zt.i)({ props: n, name: "MuiCheckbox" }),
            {
              checkedIcon: s = Yv,
              color: l = "primary",
              icon: d = Jv,
              indeterminate: c = !1,
              indeterminateIcon: p = Xv,
              inputProps: m,
              size: h = "medium",
              className: f,
            } = i,
            g = (0, At.Z)(i, qv),
            v = c ? p : d,
            b = c ? p : s,
            _ = (0, u.Z)({}, i, { color: l, indeterminate: c, size: h }),
            y = ((e) => {
              const { classes: t, indeterminate: n, color: r, size: o } = e,
                a = {
                  root: [
                    "root",
                    n && "indeterminate",
                    `color${(0, $n.Z)(r)}`,
                    `size${(0, $n.Z)(o)}`,
                  ],
                },
                i = (0, Rt.Z)(a, Kv, t);
              return (0, u.Z)({}, t, i);
            })(_);
          return (0,
          e.jsx)(Qv, (0, u.Z)({ type: "checkbox", inputProps: (0, u.Z)({ "data-indeterminate": c }, m), icon: t.cloneElement(v, { fontSize: null != (o = v.props.fontSize) ? o : h }), checkedIcon: t.cloneElement(b, { fontSize: null != (a = b.props.fontSize) ? a : h }), ownerState: _, ref: r, className: (0, Et.Z)(y.root, f) }, g, { classes: y }));
        });
      var tb = eb,
        nb = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z",
          }),
          "Person"
        );
      function rb(e) {
        return (0, Zt.ZP)("MuiAvatar", e);
      }
      (0, Ft.Z)("MuiAvatar", [
        "root",
        "colorDefault",
        "circular",
        "rounded",
        "square",
        "img",
        "fallback",
      ]);
      const ob = [
          "alt",
          "children",
          "className",
          "component",
          "slots",
          "slotProps",
          "imgProps",
          "sizes",
          "src",
          "srcSet",
          "variant",
        ],
        ab = (0, Bt.ZP)("div", {
          name: "MuiAvatar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.variant], n.colorDefault && t.colorDefault];
          },
        })(({ theme: e }) => ({
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          width: 40,
          height: 40,
          fontFamily: e.typography.fontFamily,
          fontSize: e.typography.pxToRem(20),
          lineHeight: 1,
          borderRadius: "50%",
          overflow: "hidden",
          userSelect: "none",
          variants: [
            {
              props: { variant: "rounded" },
              style: { borderRadius: (e.vars || e).shape.borderRadius },
            },
            { props: { variant: "square" }, style: { borderRadius: 0 } },
            {
              props: { colorDefault: !0 },
              style: (0, u.Z)(
                { color: (e.vars || e).palette.background.default },
                e.vars
                  ? { backgroundColor: e.vars.palette.Avatar.defaultBg }
                  : (0, u.Z)(
                      { backgroundColor: e.palette.grey[400] },
                      e.applyStyles("dark", {
                        backgroundColor: e.palette.grey[600],
                      })
                    )
              ),
            },
          ],
        })),
        ib = (0, Bt.ZP)("img", {
          name: "MuiAvatar",
          slot: "Img",
          overridesResolver: (e, t) => t.img,
        })({
          width: "100%",
          height: "100%",
          textAlign: "center",
          objectFit: "cover",
          color: "transparent",
          textIndent: 1e4,
        }),
        sb = (0, Bt.ZP)(nb, {
          name: "MuiAvatar",
          slot: "Fallback",
          overridesResolver: (e, t) => t.fallback,
        })({ width: "75%", height: "75%" });
      var lb = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiAvatar" }),
          {
            alt: a,
            children: i,
            className: s,
            component: l = "div",
            slots: d = {},
            slotProps: c = {},
            imgProps: p,
            sizes: m,
            src: h,
            srcSet: f,
            variant: g = "circular",
          } = o,
          v = (0, At.Z)(o, ob);
        let b = null;
        const _ = (function ({
            crossOrigin: e,
            referrerPolicy: n,
            src: r,
            srcSet: o,
          }) {
            const [a, i] = t.useState(!1);
            return (
              t.useEffect(() => {
                if (!r && !o) return;
                i(!1);
                let t = !0;
                const a = new Image();
                return (
                  (a.onload = () => {
                    t && i("loaded");
                  }),
                  (a.onerror = () => {
                    t && i("error");
                  }),
                  (a.crossOrigin = e),
                  (a.referrerPolicy = n),
                  (a.src = r),
                  o && (a.srcset = o),
                  () => {
                    t = !1;
                  }
                );
              }, [e, n, r, o]),
              a
            );
          })((0, u.Z)({}, p, { src: h, srcSet: f })),
          y = h || f,
          C = y && "error" !== _,
          x = (0, u.Z)({}, o, { colorDefault: !C, component: l, variant: g }),
          S = ((e) => {
            const { classes: t, variant: n, colorDefault: r } = e,
              o = {
                root: ["root", n, r && "colorDefault"],
                img: ["img"],
                fallback: ["fallback"],
              };
            return (0, Rt.Z)(o, rb, t);
          })(x),
          [k, P] = fm("img", {
            className: S.img,
            elementType: ib,
            externalForwardedProps: {
              slots: d,
              slotProps: { img: (0, u.Z)({}, p, c.img) },
            },
            additionalProps: { alt: a, src: h, srcSet: f, sizes: m },
            ownerState: x,
          });
        return (
          (b = C
            ? (0, e.jsx)(k, (0, u.Z)({}, P))
            : i || 0 === i
            ? i
            : y && a
            ? a[0]
            : (0, e.jsx)(sb, { ownerState: x, className: S.fallback })),
          (0, e.jsx)(
            ab,
            (0, u.Z)(
              { as: l, ownerState: x, className: (0, Et.Z)(S.root, s), ref: r },
              v,
              { children: b }
            )
          )
        );
      });
      const db = [
          "addEndListener",
          "appear",
          "children",
          "easing",
          "in",
          "onEnter",
          "onEntered",
          "onEntering",
          "onExit",
          "onExited",
          "onExiting",
          "style",
          "timeout",
          "TransitionComponent",
        ],
        cb = {
          entering: { transform: "none" },
          entered: { transform: "none" },
        },
        ub = t.forwardRef(function (n, r) {
          const o = Dr(),
            a = {
              enter: o.transitions.duration.enteringScreen,
              exit: o.transitions.duration.leavingScreen,
            },
            {
              addEndListener: i,
              appear: s = !0,
              children: l,
              easing: d,
              in: c,
              onEnter: p,
              onEntered: m,
              onEntering: h,
              onExit: f,
              onExited: g,
              onExiting: v,
              style: b,
              timeout: _ = a,
              TransitionComponent: y = jr,
            } = n,
            C = (0, At.Z)(n, db),
            x = t.useRef(null),
            S = (0, hn.Z)(x, hr(l), r),
            k = (e) => (t) => {
              if (e) {
                const n = x.current;
                void 0 === t ? e(n) : e(n, t);
              }
            },
            P = k(h),
            w = k((e, t) => {
              Ar(e);
              const n = Er(
                { style: b, timeout: _, easing: d },
                { mode: "enter" }
              );
              (e.style.webkitTransition = o.transitions.create("transform", n)),
                (e.style.transition = o.transitions.create("transform", n)),
                p && p(e, t);
            }),
            O = k(m),
            T = k(v),
            I = k((e) => {
              const t = Er(
                { style: b, timeout: _, easing: d },
                { mode: "exit" }
              );
              (e.style.webkitTransition = o.transitions.create("transform", t)),
                (e.style.transition = o.transitions.create("transform", t)),
                f && f(e);
            }),
            M = k(g);
          return (0, e.jsx)(
            y,
            (0, u.Z)(
              {
                appear: s,
                in: c,
                nodeRef: x,
                onEnter: w,
                onEntered: O,
                onEntering: P,
                onExit: I,
                onExited: M,
                onExiting: T,
                addEndListener: (e) => {
                  i && i(x.current, e);
                },
                timeout: _,
              },
              C,
              {
                children: (e, n) =>
                  t.cloneElement(
                    l,
                    (0, u.Z)(
                      {
                        style: (0, u.Z)(
                          {
                            transform: "scale(0)",
                            visibility: "exited" !== e || c ? void 0 : "hidden",
                          },
                          cb[e],
                          b,
                          l.props.style
                        ),
                        ref: S,
                      },
                      n
                    )
                  ),
              }
            )
          );
        });
      var pb = ub,
        mb = function () {
          return (
            (mb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            mb.apply(this, arguments)
          );
        },
        hb = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        fb = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        gb = function () {
          var e,
            n,
            r,
            o,
            a,
            i,
            s,
            l,
            d,
            c,
            u,
            p = ee().t,
            m = g(),
            h = y(function (e) {
              return e.salesRepData ? e.salesRepData : {};
            }),
            f = xv(),
            v = f.copyTextFunction,
            b = f.useInfiniteScroll,
            _ = y(function (e) {
              return e.salesRepData;
            }),
            C =
              null === (e = null == _ ? void 0 : _.baseData) || void 0 === e
                ? void 0
                : e.SingleSalesRep,
            x =
              null !==
                (o =
                  null ===
                    (r =
                      null === (n = null == h ? void 0 : h.baseData) ||
                      void 0 === n
                        ? void 0
                        : n.ConfirmationPopUpStatus) || void 0 === r
                    ? void 0
                    : r.isAffiliatePopUpVisible) &&
              void 0 !== o &&
              o,
            S = {
              isLoading: !1,
              imageName: "",
              imagePreview: Ov(null == C ? void 0 : C.ProfileImagePath)
                ? ""
                : null == C
                ? void 0
                : C.ProfileImagePath,
              imageSize: 0,
            },
            k = (0, t.useState)(C ? (null == C ? void 0 : C.Bio) : ""),
            P = k[0],
            w = k[1],
            O = (0, t.useState)(
              P && (null == P ? void 0 : P.length) < 100
                ? 100 - (null == P ? void 0 : P.length)
                : 0
            ),
            T = O[0],
            I = O[1],
            M = _.productsData,
            j = _.baseData,
            N =
              null === (a = null == j ? void 0 : j.CommissionDiscountOn) ||
              void 0 === a
                ? void 0
                : a.CommissionDiscountOn,
            D =
              null !== (i = null == j ? void 0 : j.ShopDomainName) &&
              void 0 !== i
                ? i
                : null == j
                ? void 0
                : j.ShopName,
            E = (0, t.useState)(!1),
            R = E[0],
            L = E[1],
            B = (0, t.useState)(0),
            z = B[0],
            Z = B[1],
            H = (0, t.useState)(""),
            V = H[0],
            W = H[1],
            U = (0, t.useState)({ msg: "", open: !1, severity: "error" }),
            $ = U[0],
            K = U[1],
            G = [];
          (0, t.useEffect)(
            function () {
              (null == M ? void 0 : M.length) > 0 && Bh.next(!1);
            },
            [M]
          );
          var q = [
            {
              id: "product",
              headerName: p("viewProductModelColumn1"),
              hide: !1,
            },
            {
              id: "product_title",
              headerName: p("affiliateLink_searchColumn2"),
              hide: !1,
            },
            {
              id: "price",
              headerName: p("affiliateLink_searchColumn3"),
              hide: !1,
            },
            {
              id: "commission",
              headerName: p("affliateOrder_column6"),
              hide: "Product" !== N,
            },
            {
              id: "affiliate_link",
              headerName: p("affiliate_product_link"),
              hide: !1,
            },
            {
              id: "copy_link",
              headerName: p("affiliateLink_searchColumn7"),
              hide: !1,
            },
            {
              id: "share_link",
              headerName: p("affiliateCartProdtableColumn6"),
              hide: !1,
            },
          ];
          function Q(e, t) {
            for (
              var n,
                r = null === (n = e[0]) || void 0 === n ? void 0 : n.src,
                o = 0,
                a = e;
              o < a.length;
              o++
            ) {
              var i = a[o],
                s = i.imageId,
                l = i.src;
              l = s === t ? l : null;
            }
            return r;
          }
          function Y(e, t) {
            var n,
              r = null == j ? void 0 : j.CommissionandDiscountPerProductType,
              o = null == j ? void 0 : j.AffiliateCommissionPerProduct,
              a = null == j ? void 0 : j.AffiliateCommissionPerRepModel,
              i =
                null === (n = null == _ ? void 0 : _.loggedInRepDetails) ||
                void 0 === n
                  ? void 0
                  : n.customerId.toString();
            switch (N) {
              case "ProductType":
                if (Ov(r)) return 0;
                for (var s = 0, l = r; s < l.length; s++) {
                  var d = l[s],
                    c = d.productType,
                    u = d.AffiliateCommission;
                  if (e.toLowerCase() === c.toLowerCase()) return u;
                }
                break;
              case "Product":
                if (Ov(o)) return 0;
                for (var p = 0, m = o; p < m.length; p++) {
                  var h = m[p],
                    f = h.variantId,
                    g = h.Commission;
                  if (t === f) return 100 * g;
                }
                break;
              case "SalesRep":
                if (Ov(a)) return 0;
                for (var v = 0, b = a; v < b.length; v++) {
                  var y = b[v],
                    C = y.SalesRepId;
                  if (((g = y.Commission), i === C)) return g;
                }
                break;
              default:
                return 0;
            }
          }
          function J(e, t) {
            var n,
              r,
              o,
              a = Ov(
                null === (n = null == j ? void 0 : j.SingleSalesRep) ||
                  void 0 === n
                  ? void 0
                  : n.SalesRepAffiliateUrl
              )
                ? "ambassador="
                : null ===
                    (o =
                      null === (r = j.SingleSalesRep) || void 0 === r
                        ? void 0
                        : r.SalesRepAffiliateUrl) || void 0 === o
                ? void 0
                : o.split("?")[1];
            return (
              "https://" +
                e +
                "/products/" +
                t +
                "/?ambassador=" +
                new URLSearchParams(a).get("ambassador") || "https://" + e
            );
          }
          G = (function (e) {
            for (var t = [], n = 0, r = e; n < r.length; n++) {
              var o = r[n],
                a = o.productTitle,
                i = o.variants,
                s = o.productImages,
                l = o.product_type,
                d = o.handle,
                c = J(D, d);
              if (!((null == i ? void 0 : i.length) > 0)) return t;
              for (var u = 0, p = i; u < p.length; u++) {
                var m = p[u],
                  h = m.variantPrice,
                  f = m.image_id,
                  g = m.variantId,
                  v = m.variantTitle,
                  b = m.sku,
                  _ = Q(s, f),
                  y = Y(l, g) || 0;
                t.push({
                  src: _,
                  productTitle: a,
                  variantPrice: h,
                  commission: y,
                  handle: d,
                  url: c,
                  variantId: g,
                  variantTitle: v,
                  sku: b,
                });
              }
            }
            return t;
          })(M);
          var X = (0, t.useRef)(null),
            te = (0, t.useState)(""),
            ne = te[0],
            re = te[1],
            oe = (0, t.useState)(!1),
            ae = oe[0],
            ie = oe[1],
            se = (0, t.useState)(!1),
            le = se[0],
            de = se[1],
            ce = (0, t.useState)(),
            ue = ce[0],
            pe = ce[1],
            me = (0, t.useState)(!1),
            he = me[0],
            fe = me[1],
            ge = (0, t.useState)(S),
            ve = ge[0],
            be = ge[1],
            _e = (0, t.useState)(p("yourBio_button2")),
            ye = _e[0],
            Ce = _e[1],
            xe = (0, t.useState)(!1),
            Se = xe[0],
            ke = xe[1],
            Pe = (0, t.useState)(""),
            we = Pe[0],
            Oe = Pe[1],
            Te = (0, t.useState)(!1),
            Ie = Te[0],
            Me = Te[1],
            je = (0, t.useState)(p("yourBio_button3")),
            Ne = je[0],
            De = je[1],
            Ae = (0, t.useState)(p("yourBio_button3")),
            Ee = Ae[0],
            Re = Ae[1],
            Le = (0, t.useState)(""),
            Be = Le[0],
            ze = Le[1],
            Fe = (0, t.useState)(!1),
            Ze = Fe[0],
            He = Fe[1],
            Ve = (0, t.useState)(null == C ? void 0 : C.SalesRepUniqueLink),
            We = Ve[0],
            Ue = Ve[1],
            $e = (0, t.useState)(!0),
            Ke = $e[0],
            Ge = $e[1],
            qe = ve.imagePreview;
          (0, t.useEffect)(
            function () {
              De(p("yourBio_button3")), Re(p("yourBio_button3"));
            },
            [p]
          );
          var Qe =
              (void 0 !== (null == C ? void 0 : C.SalesRepUniqueLink) &&
                null !== (null == C ? void 0 : C.SalesRepUniqueLink) &&
                "" !== (null == C ? void 0 : C.SalesRepUniqueLink)) ||
              (null == we ? void 0 : we.length) > 0
                ? "https://" + D + "/" + we
                : "https://" +
                  D +
                  "/?" +
                  (null === (s = null == C ? void 0 : C.SalesRepAffiliateUrl) ||
                  void 0 === s
                    ? void 0
                    : s.split("?")[1]),
            Ye =
              null ===
                (d =
                  null === (l = F.getState().salesRepData) || void 0 === l
                    ? void 0
                    : l.loggedInRepDetails) || void 0 === d
                ? void 0
                : d.shopCurrency,
            Je =
              null ===
                (u =
                  null === (c = null == _ ? void 0 : _.baseData) || void 0 === c
                    ? void 0
                    : c.CommissionDiscountOn) || void 0 === u
                ? void 0
                : u.CommissionDiscountType,
            Xe = (0, t.useState)(G),
            et = Xe[0],
            tt = Xe[1],
            nt = (0, t.useState)(!1),
            rt = nt[0],
            ot = nt[1],
            at = (0, t.useState)(10),
            it = at[0],
            st = at[1],
            lt = b(it, st, et);
          return {
            isImageInput: le,
            repProfile: _,
            saveBtn: Ke,
            searchProductTable: function (e) {
              st(10);
              var t = e.target.value.trim().toLowerCase();
              ot(!!t);
              var n =
                null == G
                  ? void 0
                  : G.filter(function (e) {
                      var n,
                        r,
                        o =
                          null === (n = e.productTitle) || void 0 === n
                            ? void 0
                            : n.toLowerCase(),
                        a =
                          null === (r = e.variantTitle) || void 0 === r
                            ? void 0
                            : r.toLowerCase();
                      return (
                        (null == o ? void 0 : o.includes(t)) ||
                        (null == a ? void 0 : a.includes(t))
                      );
                    });
              tt(n);
            },
            commissionDiscountType: Je,
            commissionOn: N,
            shopCurrency: Ye,
            products: et,
            showTable: rt,
            shopName: D,
            productsContent: G,
            productTableColumns: q,
            showNewImage: he,
            imagePreview: qe,
            saveState: Ne,
            cardSaveState: Ee,
            profile: C,
            setBio: w,
            uploadInputImage: X,
            setLinkText: Oe,
            setImage: be,
            image: ve,
            bio: P,
            uploadImageState: ye,
            linkText: we,
            imageLoading: Se,
            updatedLink: We,
            savingLinkBio: Ze,
            helperTextLink: Be,
            linkError: Ie,
            handleUploadImage: function (e) {
              var t = e.target.files;
              return hb(void 0, void 0, void 0, function () {
                var e;
                return fb(this, function (n) {
                  return (
                    re(""),
                    ie(!1),
                    Ov((e = t[0])) ||
                      (e.size < 5e6
                        ? (be(function (e) {
                            return mb(mb({}, e), { isLoading: !0 });
                          }),
                          pe(e),
                          fe(!0),
                          be(function (t) {
                            return mb(mb({}, t), {
                              imageName: e.name,
                              imagePreview: URL.createObjectURL(e),
                              imageSize: e.size,
                              isLoading: !1,
                            });
                          }))
                        : (setTimeout(function () {
                            ie(!1);
                          }, 3e3),
                          ie(!0),
                          re(p("yourBio_error_image_size")),
                          be(S),
                          (X.current.value = null))),
                    [2]
                  );
                });
              });
            },
            uploadImage: function () {
              return hb(void 0, void 0, void 0, function () {
                var e;
                return fb(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return (
                        Ce(p("yourBio_Uploadbtn1")),
                        ke(!0),
                        re(""),
                        ie(!1),
                        de(!0),
                        !Ov(ue) && ve.imageSize < 5e6 && "" !== ve.imagePreview
                          ? (e = ue)
                            ? [4, m(xg(ue))]
                            : [3, 2]
                          : [3, 3]
                      );
                    case 1:
                      (e = t.sent()), (t.label = 2);
                    case 2:
                      return (
                        e
                          ? (Ce(p("yourBio_Uploadbtn2")),
                            be(function (e) {
                              return mb(mb({}, e), { isLoading: !1 });
                            }),
                            re(""),
                            ie(!1))
                          : (ie(!0),
                            be(S),
                            (X.current.value = null),
                            Ce(p("yourBio_button2")),
                            re(p("addCustomer_leadErrrorMsg"))),
                        [3, 4]
                      );
                    case 3:
                      re(p("yourBio_error_image_size")),
                        ie(!0),
                        fe(!1),
                        be(S),
                        (X.current.value = null),
                        (t.label = 4);
                    case 4:
                      return (
                        setTimeout(function () {
                          ie(!1);
                        }, 3e3),
                        fe(!1),
                        ke(!1),
                        de(!1),
                        [2]
                      );
                  }
                });
              });
            },
            linkTextValidation: function (e) {
              Oe(e.target.value),
                "" === e.target.value.trim() ||
                /^[A-Za-z0-9]+$/.test(e.target.value)
                  ? (Ge(!1), Me(!1), ze(""))
                  : (Ge(!0), Me(!0), ze(p("affiliateLink_input_error_msg")));
            },
            bioTextValidation: function (e) {
              var t;
              I(
                100 -
                  (null === (t = e.target.value) || void 0 === t
                    ? void 0
                    : t.length)
              ),
                w(e.target.value),
                Ge(!1);
            },
            saveAffiliateInfo: function (e) {
              return hb(void 0, void 0, void 0, function () {
                var t, n, r, o, a, i, s;
                return fb(this, function (l) {
                  switch (l.label) {
                    case 0:
                      if (
                        "" === we &&
                        void 0 !==
                          (null == C ? void 0 : C.SalesRepUniqueLink) &&
                        null !== (null == C ? void 0 : C.SalesRepUniqueLink) &&
                        "" !== (null == C ? void 0 : C.SalesRepUniqueLink)
                      )
                        return Me(!0), ze(p("This field is required")), [2];
                      (t = "affiliateUrl" === e),
                        He(!0),
                        t ? De(p("yourBio_Savebtn")) : Re(p("yourBio_Savebtn")),
                        (n = { uniquelink: we, bio: P }),
                        (l.label = 1);
                    case 1:
                      return l.trys.push([1, 3, , 4]), [4, Cg(n)];
                    case 2:
                      return (
                        (r = l.sent()),
                        He(!1),
                        Ge(!0),
                        r
                          ? ((o = mb(
                              mb(
                                {},
                                F.getState().salesRepData.baseData
                                  .SingleSalesRep
                              ),
                              { SalesRepUniqueLink: n.uniquelink, Bio: n.bio }
                            )),
                            t
                              ? De(p("yourBio_button4"))
                              : Re(p("yourBio_button4")),
                            (a = p(
                              "affiliateUrl" === e
                                ? "yourBio_Linksuccessmsg"
                                : "Contact_Card_Bio_Save_Success_Msg"
                            )),
                            K({ msg: a, open: !0, severity: "success" }),
                            we ===
                              (null == o ? void 0 : o.SalesRepUniqueLink) &&
                              P === (null == o ? void 0 : o.Bio) &&
                              (Ue(we),
                              setTimeout(function () {
                                t
                                  ? De(p("yourBio_button3"))
                                  : Re(p("yourBio_button3"));
                              }, 2e3)),
                            (i = {
                              payload: o,
                              type: A.UPDATE_SINGLE_SALES_REP,
                            }),
                            m(i))
                          : (K({
                              msg: p("yourBio_error_link"),
                              open: !0,
                              severity: "error",
                            }),
                            t
                              ? De(p("yourBio_button3"))
                              : Re(p("yourBio_button3")),
                            Ge(!1),
                            m({
                              type: A.UPDATE_SINGLE_SALES_REP,
                              payload:
                                F.getState().salesRepData.baseData
                                  .SingleSalesRep,
                            })),
                        [3, 4]
                      );
                    case 3:
                      return (
                        (s = l.sent()),
                        console.error("Error updating affiliate link:", s),
                        He(!1),
                        Ge(!0),
                        K({
                          msg: p("yourBio_error_link"),
                          open: !0,
                          severity: "error",
                        }),
                        t ? De(p("yourBio_button3")) : Re(p("yourBio_button3")),
                        m({
                          type: A.UPDATE_SINGLE_SALES_REP,
                          payload:
                            F.getState().salesRepData.baseData.SingleSalesRep,
                        }),
                        [3, 4]
                      );
                    case 4:
                      return [2];
                  }
                });
              });
            },
            helperImage: ne,
            imageError: ae,
            contactCardCharLength: T,
            charMaxLength: 100,
            productsData: M,
            salesRepUniqueLink: Qe,
            t: p,
            affiliateIsConfirmOpen: R,
            handleDoNotShowState: function (e, t) {
              return hb(void 0, void 0, void 0, function () {
                var n;
                return fb(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return Bh.next(!0), v(e, t), [4, m(fg(!0))];
                    case 1:
                      return (
                        (n = r.sent()),
                        K(
                          n
                            ? {
                                msg: p("copyLinkSuccess"),
                                open: !0,
                                severity: "success",
                              }
                            : {
                                msg: p(
                                  "createOrderFromCartPage_Address_errorMsg5"
                                ),
                                open: !0,
                                severity: "error",
                              }
                        ),
                        Bh.next(!1),
                        [2]
                      );
                  }
                });
              });
            },
            handleAffiliateOpenConfirm: function () {
              L(!R);
            },
            CheckPopUpInitialValue: x,
            setSelectedProductIndex: Z,
            selectedProductIndex: z,
            setSelectedProductLink: W,
            selectedProductLink: V,
            handleAlertMsgClose: function (e, t) {
              "clickaway" !== t && K({ msg: "", open: !1 });
            },
            affiliateAlertMsg: $,
            affiliateInnerScroll: lt,
            affiliateProductsRowsPerPage: it,
            affiliateUrl: J,
            commissionPerProduct: Y,
            showToasterSuccessMsg: function () {
              K({ msg: p("copyLinkSuccess"), open: !0, severity: "success" });
            },
          };
        };
      function vb() {
        var e = Tv();
        return {
          ST_CI_ContactCart: {
            width: e ? "100% !important" : "95% !important",
            margin: "0 auto",
            display: "inline-flex",
          },
          ST_CI_MediaCart: {
            width: e ? "100% !important" : "95% !important",
            margin: "0 auto",
            display: "inline-flex",
          },
          ST_CI_HorizontalLine: {
            marginBottom: "1rem",
            display: "inline-flex",
            width: "95%",
          },
          isMobile: e,
        };
      }
      var bb = function () {
          return (
            (bb =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            bb.apply(this, arguments)
          );
        },
        _b = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        yb = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Cb = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function xb(e) {
        var n,
          r,
          o,
          a,
          i,
          s,
          l,
          d,
          c = this,
          u = g(),
          p = ee().t,
          m = rf().shopCurrency,
          h = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          f = (null === (n = h.baseData) || void 0 === n ? void 0 : n.select)
            ? null === (r = h.baseData) || void 0 === r
              ? void 0
              : r.select
            : {},
          v = (0, t.useState)(""),
          b = v[0],
          _ = v[1],
          C = (0, t.useState)(!1),
          x = C[0],
          S = C[1],
          k = (0, t.useState)(!1),
          P = k[0],
          w = k[1],
          O = (0, t.useState)([]),
          T = O[0],
          I = O[1],
          M = (0, t.useState)([]),
          j = M[0],
          N = M[1],
          D = (0, t.useState)([]),
          E = D[0],
          R = D[1],
          L = (0, t.useState)([]),
          B = L[0],
          z = L[1],
          Z = (0, t.useState)({}),
          H = Z[0],
          V = Z[1],
          W = (0, t.useState)([]),
          U = W[0],
          $ = W[1],
          K = (0, t.useState)(!1),
          G = K[0],
          q = K[1],
          Q = (0, t.useState)(),
          Y = Q[0],
          J = Q[1],
          X = (0, t.useState)({ msg: "", open: !1 }),
          te = X[0],
          ne = X[1],
          re = (0, t.useState)({}),
          oe = re[0],
          ae = re[1],
          ie =
            null === (o = F.getState().salesRepData.baseData) || void 0 === o
              ? void 0
              : o.storefrontAccessToken,
          se =
            F.getState().salesRepData.cartShareProductData
              .cartCreatedSuccessFully,
          le =
            null !==
              (s =
                null ===
                  (i =
                    null === (a = F.getState().salesRepData) || void 0 === a
                      ? void 0
                      : a.baseData) || void 0 === i
                  ? void 0
                  : i.ShopDomainName) && void 0 !== s
              ? s
              : null ===
                  (d =
                    null === (l = F.getState().salesRepData) || void 0 === l
                      ? void 0
                      : l.baseData) || void 0 === d
              ? void 0
              : d.ShopName,
          de = y(function () {
            var e, t;
            return null !==
              (t =
                null === (e = F.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.collectionProductsData) && void 0 !== t
              ? t
              : [];
          }),
          ce = [],
          ue = [],
          pe = "showSpecific" === f.featuresAdditionalSettings.showProducts,
          me = (0, t.useState)(null),
          he = me[0],
          fe = me[1],
          ge = gb(),
          ve = ge.commissionDiscountType,
          be = ge.commissionOn,
          _e = ge.CheckPopUpInitialValue,
          ye = ge.affiliateUrl,
          Ce = ge.commissionPerProduct,
          xe = [
            { name: "ST_Producttable_product", hide: !1 },
            { name: "ST_Producttable_SKU", hide: !1 },
            { name: "customerInvoice_ProductTableColumnInventory", hide: !1 },
            { name: "ST_Producttable_retailPrice", hide: !1 },
            {
              name: "ST_Producttable_netQuantity",
              hide: 3 === (null == e ? void 0 : e.activeTabIndex),
            },
            {
              name: "affliateOrder_column6",
              hide:
                4 === (null == e ? void 0 : e.activeTabIndex) ||
                "Product" !== be,
            },
            {
              name: "affiliate_product_link",
              hide: 4 === (null == e ? void 0 : e.activeTabIndex),
            },
            { name: "", hide: !1 },
          ],
          Se = (0, t.useRef)(null);
        (0, t.useEffect)(
          function () {
            se && Ie();
          },
          [se]
        ),
          (0, t.useEffect)(
            function () {
              if (4 === (null == e ? void 0 : e.activeTabIndex)) $(j);
              else {
                var t = Me(j);
                $(t);
              }
            },
            [G]
          ),
          (0, t.useEffect)(
            function () {
              Oe();
            },
            [H]
          ),
          (0, t.useEffect)(
            function () {
              if (($([]), 4 === (null == e ? void 0 : e.activeTabIndex)))
                $(function (e) {
                  return Cb(Cb([], e, !0), j, !0);
                });
              else {
                var t = Me(j);
                $(t);
              }
              Oe();
            },
            [j]
          ),
          (0, t.useEffect)(function () {
            4 === (null == e ? void 0 : e.activeTabIndex) && je();
          }, []);
        var ke = function (e, t, n) {
            return _b(c, void 0, void 0, function () {
              function r(e, n) {
                return _b(this, void 0, void 0, function () {
                  var o, a, i, s;
                  return yb(this, function (l) {
                    switch (l.label) {
                      case 0:
                        return [4, Wf(b, ie, n, t, e)];
                      case 1:
                        return (
                          (o = l.sent()),
                          (a = o.products),
                          (i = o.pageInfo),
                          a &&
                            (null == a ? void 0 : a.length) > 0 &&
                            ((s =
                              null == a
                                ? void 0
                                : a.filter(function (e) {
                                    if (
                                      !(null == ue
                                        ? void 0
                                        : ue.includes(e.productId))
                                    )
                                      return ue.push(e.productId), e;
                                  })),
                            (ce = null == ce ? void 0 : ce.concat(s))),
                          i.hasNextPage ? [4, r(e, i.endCursor)] : [3, 3]
                        );
                      case 2:
                        l.sent(), (l.label = 3);
                      case 3:
                        return [2];
                    }
                  });
                });
              }
              var o, a, i, s, l, d, c, p, m, f;
              return yb(this, function (g) {
                switch (g.label) {
                  case 0:
                    return (
                      g.trys.push([0, 10, , 11]),
                      w(!0),
                      (o =
                        null !==
                          (f =
                            null === (m = null == h ? void 0 : h.baseData) ||
                            void 0 === m
                              ? void 0
                              : m.activeCollectionList) && void 0 !== f
                          ? f
                          : []),
                      pe && (null == o ? void 0 : o.length) > 0
                        ? de && (null == de ? void 0 : de.length) > 0
                          ? ("" !== b && pe ? we(de) : I(de), [3, 6])
                          : [3, 1]
                        : [3, 7]
                    );
                  case 1:
                    (a = 0), (i = o), (g.label = 2);
                  case 2:
                    return a < i.length ? [4, r(i[a].CollectionId)] : [3, 5];
                  case 3:
                    g.sent(), (g.label = 4);
                  case 4:
                    return a++, [3, 2];
                  case 5:
                    (s = { payload: ce, type: A.COLLECTION_PRODUCTS_DATA }),
                      u(s),
                      I(ce),
                      (g.label = 6);
                  case 6:
                    return [3, 9];
                  case 7:
                    return [
                      4,
                      Wf("" == n ? "" : b, ie, e, t).then(function (e) {
                        return e;
                      }),
                    ];
                  case 8:
                    (l = g.sent()),
                      (d = l.products),
                      (c = l.pageInfo),
                      "" == n ? I(d) : we(d),
                      J(c),
                      (g.label = 9);
                  case 9:
                    return w(!1), [3, 11];
                  case 10:
                    return (
                      (p = g.sent()),
                      console.error("Error fetching products:", p),
                      w(!1),
                      [3, 11]
                    );
                  case 11:
                    return [2];
                }
              });
            });
          },
          Pe = function () {
            return _b(c, void 0, void 0, function () {
              return yb(this, function (t) {
                switch (t.label) {
                  case 0:
                    return _(""), pe ? (I(de), [3, 3]) : [3, 1];
                  case 1:
                    return I([]), [4, ke("", "", "")];
                  case 2:
                    t.sent(), (t.label = 3);
                  case 3:
                    return (
                      4 === (null == e ? void 0 : e.activeTabIndex) &&
                        (null == e || e.setOpenSearchProducts(!1)),
                      [2]
                    );
                }
              });
            });
          },
          we = function (e) {
            I(e);
          },
          Oe = function () {
            var e = [];
            null == j ||
              j.forEach(function (t) {
                var n;
                null === (n = null == t ? void 0 : t.variants) ||
                  void 0 === n ||
                  n.forEach(function (n) {
                    var r,
                      o,
                      a = Number(
                        null === (r = null == n ? void 0 : n.variantId) ||
                          void 0 === r
                          ? void 0
                          : r.split("gid://shopify/ProductVariant/")[1]
                      );
                    e.push(
                      bb(
                        {
                          id: a,
                          quantity:
                            (null ===
                              (o = H[null == n ? void 0 : n.variantId]) ||
                            void 0 === o
                              ? void 0
                              : o.quantity) || 1,
                          handle: t.handle,
                        },
                        n.selling_plan_id && { selling_plan: n.selling_plan_id }
                      )
                    );
                  });
              });
            var t = { payload: e, type: A.CART_SHARE_PRODUCT_DATA };
            u(t);
          };
        function Te(e, t, n) {
          var r, o;
          if (!("" !== e && "0" !== e && Number(e) > 0))
            return (
              ne({ msg: p("productTable_error_AlertMsg"), open: !0 }),
              ae(bb(bb({}, oe), (((r = {})[t] = !0), r))),
              void V(function (n) {
                var r;
                return bb(
                  bb({}, n),
                  (((r = {})[t] = bb(bb({}, n[t]), { quantity: e })), r)
                );
              })
            );
          ae(function (e) {
            var n;
            return bb(bb({}, e), (((n = {})[t] = !1), n));
          }),
            V(function (r) {
              var a,
                i = r[t];
              return (
                (o =
                  "increaseQty" === n
                    ? Number(i.quantity) + 1
                    : "decreaseQty" === n
                    ? Math.max(Number(i.quantity) - 1, 1)
                    : Number(e)),
                bb(bb({}, r), (((a = {})[t] = { quantity: o }), a))
              );
            });
        }
        var Ie = function () {
          try {
            $([]),
              V({}),
              R([]),
              z([]),
              N([]),
              Pe(),
              4 === (null == e ? void 0 : e.activeTabIndex) &&
                (null == e || e.setIsRemoveSelectedProduct(!1));
          } catch (e) {
            return;
          }
        };
        function Me(e) {
          var t = [];
          return (
            null == e ||
              e.forEach(function (e) {
                var n,
                  r,
                  o = ye(le, e.handle),
                  a = [];
                (null === (n = null == e ? void 0 : e.variants) || void 0 === n
                  ? void 0
                  : n.length) > 0 &&
                  (null === (r = null == e ? void 0 : e.variants) ||
                    void 0 === r ||
                    r.forEach(function (t) {
                      var n,
                        r = Number(
                          null === (n = null == t ? void 0 : t.variantId) ||
                            void 0 === n
                            ? void 0
                            : n.split("gid://shopify/ProductVariant/")[1]
                        ),
                        i = Ce(t.product_type, r) || 0;
                      a.push({
                        variantId: null == t ? void 0 : t.variantId,
                        title: null == t ? void 0 : t.title,
                        variantPrice: null == t ? void 0 : t.variantPrice,
                        commission: i,
                        handle: null == e ? void 0 : e.handle,
                        url: o,
                        sku: t.sku,
                        quantityAvailable:
                          null == t ? void 0 : t.quantityAvailable,
                      });
                    })),
                  t.push({
                    productId: null == e ? void 0 : e.productId,
                    title: null == e ? void 0 : e.title,
                    imageUrl: null == e ? void 0 : e.imageUrl,
                    variants: a,
                  });
              }),
            t
          );
        }
        var je = function () {
            return _b(c, void 0, void 0, function () {
              var e, t, n, r, o, a;
              return yb(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, u(Ig())];
                  case 1:
                    return (
                      200 === (null == (e = i.sent()) ? void 0 : e.status) &&
                        (null ===
                          (o =
                            null === (r = null == e ? void 0 : e.data) ||
                            void 0 === r
                              ? void 0
                              : r.items) || void 0 === o
                          ? void 0
                          : o.length) > 0 &&
                        (w(!0),
                        (t = Ne(
                          null === (a = null == e ? void 0 : e.data) ||
                            void 0 === a
                            ? void 0
                            : a.items
                        )),
                        $(t),
                        N(t),
                        (n =
                          null == t
                            ? void 0
                            : t.map(function (e) {
                                return e.productId;
                              })),
                        R(n),
                        Oe()),
                      w(!1),
                      [2]
                    );
                }
              });
            });
          },
          Ne = function (e) {
            var t = [],
              n = [];
            return (
              null == e ||
                e.forEach(function (e) {
                  var r,
                    o,
                    a,
                    i,
                    s,
                    l = t.findIndex(function (t) {
                      return (
                        t.productId === "gid://shopify/Product/" + e.product_id
                      );
                    }),
                    d = {
                      variantId: "gid://shopify/ProductVariant/" + e.variant_id,
                      variantPrice: e.final_price / 100,
                      imageUrl:
                        (null === (r = e.featured_image) || void 0 === r
                          ? void 0
                          : r.url) || "",
                      currency: m,
                      inventoryQuantity: e.quantity,
                      sku: e.sku,
                      title: e.variant_title || "Default Title",
                      quantityAvailable:
                        null !== (o = e.quantity) && void 0 !== o ? o : "NA",
                      availableForSale: !0,
                      quantity: e.quantity,
                      wholesalePrice: e.final_price / 100,
                      selling_plan_id:
                        null ===
                          (i =
                            null ===
                              (a =
                                null == e
                                  ? void 0
                                  : e.selling_plan_allocation) || void 0 === a
                              ? void 0
                              : a.selling_plan) || void 0 === i
                          ? void 0
                          : i.id,
                    };
                  if (-1 !== l) t[l].variants.push(d);
                  else {
                    var c = {
                      productId: "gid://shopify/Product/" + e.product_id,
                      title: e.title,
                      variants: [d],
                      imageUrl:
                        (null === (s = e.featured_image) || void 0 === s
                          ? void 0
                          : s.url) || null,
                    };
                    t.push(c);
                  }
                  n.push(d);
                }),
              z(function (e) {
                return Cb(Cb([], e, !0), n, !0);
              }),
              N(t),
              null == n ||
                n.forEach(function (e) {
                  Te(
                    (null == e ? void 0 : e.quantity) || 1,
                    e.variantId,
                    "manual"
                  );
                }),
              t
            );
          };
        return {
          handleSearchProductData: ke,
          makeFieldsEmpty: Pe,
          productSearchText: b,
          handleKeyDown: function (e) {
            "Enter" === e.key &&
              13 === e.keyCode &&
              ("" !== b && pe ? we(de) : ke());
          },
          handleProductTableSearchPopup: function () {
            S(!0), ke();
          },
          shopCurrency: m,
          handleSearchTextChange: function (e) {
            return _b(c, void 0, void 0, function () {
              var t;
              return yb(this, function (n) {
                return (
                  (t = e.target.value),
                  _(t),
                  pe && ("" === t ? I(de) : we(de)),
                  [2]
                );
              });
            });
          },
          searchTablePopupOpen: x,
          productsArray: T,
          getProductsLoading: P,
          selectedProductArray: j,
          checkUncheckProductVariant: function (e, t, n, r, o) {
            try {
              var a = e.target.checked;
              if ("isProduct" === t) {
                var i = null == n ? void 0 : n.variants;
                if (a) {
                  var s =
                    null == i
                      ? void 0
                      : i.filter(function (e) {
                          return e.availableForSale;
                        });
                  if (
                    null == j
                      ? void 0
                      : j.some(function (e) {
                          return e.productId === n.productId;
                        })
                  ) {
                    var l = j.findIndex(function (e) {
                      return e.productId === n.productId;
                    });
                    if (-1 !== l) {
                      var d = Cb([], j, !0);
                      (d[l].variants = s), N(d);
                    }
                  } else
                    N(Cb(Cb([], j, !0), [bb(bb({}, n), { variants: s })], !1)),
                      R(Cb(Cb([], E, !0), [n.productId], !1));
                  z(Cb(Cb([], B, !0), s, !0));
                  var c = bb({}, H);
                  null == s ||
                    s.forEach(function (e) {
                      c[e.variantId] = { quantity: 1 };
                    }),
                    V(c);
                } else {
                  q(!G),
                    N(
                      null == j
                        ? void 0
                        : j.filter(function (e) {
                            return e.productId !== n.productId;
                          })
                    ),
                    R(
                      null == E
                        ? void 0
                        : E.filter(function (e) {
                            return e !== n.productId;
                          })
                    );
                  var u =
                    null == B
                      ? void 0
                      : B.filter(function (e) {
                          return !(null == i
                            ? void 0
                            : i.some(function (t) {
                                return (
                                  (null == t ? void 0 : t.variantId) ===
                                  (null == e ? void 0 : e.variantId)
                                );
                              }));
                        });
                  if ((z(u), o)) {
                    var p = bb({}, H);
                    null == i ||
                      i.forEach(function (e) {
                        delete p[null == e ? void 0 : e.variantId];
                      }),
                      V(p);
                  }
                }
              } else if (a)
                (
                  null == j
                    ? void 0
                    : j.some(function (e) {
                        return e.productId === n.productId;
                      })
                )
                  ? N(function (e) {
                      return null == e
                        ? void 0
                        : e.map(function (e) {
                            return e.productId === n.productId
                              ? bb(bb({}, e), {
                                  variants: Cb(Cb([], e.variants, !0), [r], !1),
                                })
                              : e;
                          });
                    })
                  : (N(
                      Cb(Cb([], j, !0), [bb(bb({}, n), { variants: [r] })], !1)
                    ),
                    R(Cb(Cb([], E, !0), [n.productId], !1))),
                  z(Cb(Cb([], B, !0), [r], !1)),
                  V(function (e) {
                    var t;
                    return bb(
                      bb({}, e),
                      (((t = {})[null == r ? void 0 : r.variantId] = {
                        quantity: 1,
                      }),
                      t)
                    );
                  });
              else {
                q(!G),
                  z(function (e) {
                    return null == e
                      ? void 0
                      : e.filter(function (e) {
                          return (
                            (null == e ? void 0 : e.variantId) !==
                            (null == r ? void 0 : r.variantId)
                          );
                        });
                  }),
                  N(function (e) {
                    return null == e
                      ? void 0
                      : e.map(function (e) {
                          var t;
                          return e.productId === n.productId
                            ? bb(bb({}, e), {
                                variants:
                                  null === (t = e.variants) || void 0 === t
                                    ? void 0
                                    : t.filter(function (e) {
                                        return (
                                          (null == e ? void 0 : e.variantId) !==
                                          (null == r ? void 0 : r.variantId)
                                        );
                                      }),
                              })
                            : e;
                        });
                  });
                var m = null == n ? void 0 : n.variants;
                if (
                  (z(function (e) {
                    return (
                      (null == m
                        ? void 0
                        : m.some(function (t) {
                            return null == e
                              ? void 0
                              : e.some(function (e) {
                                  return (
                                    (null == e ? void 0 : e.variantId) ===
                                    (null == t ? void 0 : t.variantId)
                                  );
                                });
                          })) ||
                        (R(function (e) {
                          return null == e
                            ? void 0
                            : e.filter(function (e) {
                                return e !== n.productId;
                              });
                        }),
                        N(function (e) {
                          return null == e
                            ? void 0
                            : e.filter(function (e) {
                                return e.productId !== n.productId;
                              });
                        })),
                      null == e
                        ? void 0
                        : e.filter(function (e) {
                            return (
                              (null == e ? void 0 : e.variantId) !==
                              (null == r ? void 0 : r.variantId)
                            );
                          })
                    );
                  }),
                  o)
                ) {
                  var h = bb({}, H);
                  delete h[null == r ? void 0 : r.variantId], V(h);
                }
              }
            } catch (e) {
              return;
            }
          },
          selectedVariantArray: B,
          selectedProductIdArray: E,
          showSelectedProduct: function () {
            try {
              S(!1), Pe(), Oe();
            } catch (e) {
              return;
            }
          },
          ProductTableHeaders: xe,
          netQuantitySubtotal: H,
          updateNetQuantitySubtotal: Te,
          finalSelectedProducts: U,
          closePopupForSearchProductData: function () {
            S(!1), w(!1), Pe();
          },
          removeAllSelectedProducts: Ie,
          handleNextClick: function () {
            var e;
            Y.hasNextPage &&
              (ke(Y.endCursor, ""),
              null === (e = Se.current) || void 0 === e || e.scrollTo(0, 0));
          },
          handlePrevClick: function () {
            var e;
            Y.hasPreviousPage &&
              (ke("", Y.startCursor),
              null === (e = Se.current) || void 0 === e || e.scrollTo(0, 0));
          },
          pageInfo: Y,
          salesRepData: h,
          searchDialogProductTableHeaders: [
            { name: "ST_Producttable_product", hide: !1 },
            { name: "customerInvoice_ProductTableColumnInventory", hide: !1 },
            { name: "ST_Producttable_retailPrice", hide: !1 },
          ],
          selectFeatures: f,
          handleAlertMsgClose: function (e, t) {
            "clickaway" !== t && ne({ msg: "", open: !1 });
          },
          alertErrorMsg: te,
          isQuantityError: oe,
          commissionDiscountType: ve,
          commissionOn: be,
          CheckPopUpInitialValue: _e,
          t: p,
          tableContainerRef: Se,
          hoveredIconIndex: he,
          setHoveredIconIndex: fe,
        };
      }
      var Sb = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2M8.5 13.5l2.5 3.01L14.5 12l4.5 6H5z",
          }),
          "Image"
        ),
        kb = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M15.41 16.59 10.83 12l4.58-4.59L14 6l-6 6 6 6z",
          }),
          "KeyboardArrowLeft"
        ),
        Pb = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M8.59 16.59 13.17 12 8.59 7.41 10 6l6 6-6 6z",
          }),
          "KeyboardArrowRight"
        ),
        wb = (0, Oo.Z)((0, e.jsx)("path", { d: "M19 13H5v-2h14z" }), "Remove"),
        Ob = (0, Oo.Z)(
          (0, e.jsx)("path", { d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6z" }),
          "Add"
        ),
        Tb = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2m0 16H8V7h11z",
          }),
          "ContentCopy"
        ),
        Ib = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M14.59 8 12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8",
          }),
          "HighlightOff"
        ),
        Mb = "^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)[a-zA-Z\\d]{8,}$",
        jb = function (e) {
          return ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
        },
        Nb = function (e) {
          return (
            ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
          );
        },
        Db =
          "^[\\w!#$%&'*+/=?`{|}~^-]+(?:\\.[\\w!#$%&'*+/=?`{|}~^-]+)*@(?:[a-zA-Z0-9]+[a-zA-Z0-9-]*[a-zA-Z0-9]+\\.)+[a-zA-Z]{2,}$",
        Ab = /[@#!$&]/;
      const Eb = ["className", "id"],
        Rb = (0, Bt.ZP)(ni, {
          name: "MuiDialogTitle",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({ padding: "16px 24px", flex: "0 0 auto" });
      var Lb = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiDialogTitle" }),
          { className: a, id: i } = o,
          s = (0, At.Z)(o, Eb),
          l = o,
          d = ((e) => {
            const { classes: t } = e;
            return (0, Rt.Z)({ root: ["root"] }, Wp, t);
          })(l),
          { titleId: c = i } = t.useContext(Rp);
        return (0,
        e.jsx)(Rb, (0, u.Z)({ component: "h2", className: (0, Et.Z)(d.root, a), ownerState: l, ref: r, variant: "h6", id: null != i ? i : c }, s));
      });
      function Bb(e) {
        return (0, Zt.ZP)("MuiDialogContentText", e);
      }
      (0, Ft.Z)("MuiDialogContentText", ["root"]);
      const zb = ["children", "className"],
        Fb = (0, Bt.ZP)(ni, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiDialogContentText",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })({});
      var Zb = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiDialogContentText" }),
          { className: o } = r,
          a = (0, At.Z)(r, zb),
          i = ((e) => {
            const { classes: t } = e,
              n = (0, Rt.Z)({ root: ["root"] }, Bb, t);
            return (0, u.Z)({}, t, n);
          })(a);
        return (0,
        e.jsx)(Fb, (0, u.Z)({ component: "p", variant: "body1", color: "text.secondary", ref: n, ownerState: a, className: (0, Et.Z)(i.root, o) }, r, { classes: i }));
      });
      const Hb = ["ownerState"],
        Vb = ["variants"],
        Wb = [
          "name",
          "slot",
          "skipVariantsResolver",
          "skipSx",
          "overridesResolver",
        ];
      function Ub(e) {
        return "ownerState" !== e && "theme" !== e && "sx" !== e && "as" !== e;
      }
      const $b = (0, en.Z)(),
        Kb = (e) => (e ? e.charAt(0).toLowerCase() + e.slice(1) : e);
      function Gb({ defaultTheme: e, theme: t, themeId: n }) {
        return (r = t), 0 === Object.keys(r).length ? e : t[n] || t;
        var r;
      }
      function qb(e) {
        return e ? (t, n) => n[e] : null;
      }
      function Qb(e, t) {
        let { ownerState: n } = t,
          r = (0, At.Z)(t, Hb);
        const o =
          "function" == typeof e ? e((0, u.Z)({ ownerState: n }, r)) : e;
        if (Array.isArray(o))
          return o.flatMap((e) => Qb(e, (0, u.Z)({ ownerState: n }, r)));
        if (o && "object" == typeof o && Array.isArray(o.variants)) {
          const { variants: e = [] } = o;
          let t = (0, At.Z)(o, Vb);
          return (
            e.forEach((e) => {
              let o = !0;
              "function" == typeof e.props
                ? (o = e.props((0, u.Z)({ ownerState: n }, r, n)))
                : Object.keys(e.props).forEach((t) => {
                    (null == n ? void 0 : n[t]) !== e.props[t] &&
                      r[t] !== e.props[t] &&
                      (o = !1);
                  }),
                o &&
                  (Array.isArray(t) || (t = [t]),
                  t.push(
                    "function" == typeof e.style
                      ? e.style((0, u.Z)({ ownerState: n }, r, n))
                      : e.style
                  ));
            }),
            t
          );
        }
        return o;
      }
      const Yb = (function (e = {}) {
        const {
            themeId: t,
            defaultTheme: n = $b,
            rootShouldForwardProp: r = Ub,
            slotShouldForwardProp: o = Ub,
          } = e,
          a = (e) =>
            (0, Jt.Z)(
              (0, u.Z)({}, e, {
                theme: Gb((0, u.Z)({}, e, { defaultTheme: n, themeId: t })),
              })
            );
        return (
          (a.__mui_systemSx = !0),
          (e, i = {}) => {
            (0, Yt.internal_processStyles)(e, (e) =>
              e.filter((e) => !(null != e && e.__mui_systemSx))
            );
            const {
                name: s,
                slot: l,
                skipVariantsResolver: d,
                skipSx: c,
                overridesResolver: p = qb(Kb(l)),
              } = i,
              m = (0, At.Z)(i, Wb),
              h = void 0 !== d ? d : (l && "Root" !== l && "root" !== l) || !1,
              f = c || !1;
            let g = Ub;
            "Root" === l || "root" === l
              ? (g = r)
              : l
              ? (g = o)
              : (function (e) {
                  return "string" == typeof e && e.charCodeAt(0) > 96;
                })(e) && (g = void 0);
            const v = (0, Yt.default)(
                e,
                (0, u.Z)({ shouldForwardProp: g, label: void 0 }, m)
              ),
              b = (e) =>
                ("function" == typeof e && e.__emotion_real !== e) ||
                (0, al.P)(e)
                  ? (r) =>
                      Qb(
                        e,
                        (0, u.Z)({}, r, {
                          theme: Gb({
                            theme: r.theme,
                            defaultTheme: n,
                            themeId: t,
                          }),
                        })
                      )
                  : e,
              _ = (r, ...o) => {
                let i = b(r);
                const l = o ? o.map(b) : [];
                s &&
                  p &&
                  l.push((e) => {
                    const r = Gb(
                      (0, u.Z)({}, e, { defaultTheme: n, themeId: t })
                    );
                    if (
                      !r.components ||
                      !r.components[s] ||
                      !r.components[s].styleOverrides
                    )
                      return null;
                    const o = r.components[s].styleOverrides,
                      a = {};
                    return (
                      Object.entries(o).forEach(([t, n]) => {
                        a[t] = Qb(n, (0, u.Z)({}, e, { theme: r }));
                      }),
                      p(e, a)
                    );
                  }),
                  s &&
                    !h &&
                    l.push((e) => {
                      var r;
                      const o = Gb(
                        (0, u.Z)({}, e, { defaultTheme: n, themeId: t })
                      );
                      return Qb(
                        {
                          variants:
                            null == o ||
                            null == (r = o.components) ||
                            null == (r = r[s])
                              ? void 0
                              : r.variants,
                        },
                        (0, u.Z)({}, e, { theme: o })
                      );
                    }),
                  f || l.push(a);
                const d = l.length - o.length;
                if (Array.isArray(r) && d > 0) {
                  const e = new Array(d).fill("");
                  (i = [...r, ...e]), (i.raw = [...r.raw, ...e]);
                }
                const c = v(i, ...l);
                return e.muiName && (c.muiName = e.muiName), c;
              };
            return v.withConfig && (_.withConfig = v.withConfig), _;
          }
        );
      })();
      var Jb = Yb,
        Xb = o(2605);
      const e_ = [
          "component",
          "direction",
          "spacing",
          "divider",
          "children",
          "className",
          "useFlexGap",
        ],
        t_ = (0, en.Z)(),
        n_ = Jb("div", {
          name: "MuiStack",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        });
      function r_(e) {
        return jm({ props: e, name: "MuiStack", defaultTheme: t_ });
      }
      function o_(e, n) {
        const r = t.Children.toArray(e).filter(Boolean);
        return r.reduce(
          (e, o, a) => (
            e.push(o),
            a < r.length - 1 &&
              e.push(t.cloneElement(n, { key: `separator-${a}` })),
            e
          ),
          []
        );
      }
      const a_ = ({ ownerState: e, theme: t }) => {
          let n = (0, u.Z)(
            { display: "flex", flexDirection: "column" },
            (0, Ba.k9)(
              { theme: t },
              (0, Ba.P$)({
                values: e.direction,
                breakpoints: t.breakpoints.values,
              }),
              (e) => ({ flexDirection: e })
            )
          );
          if (e.spacing) {
            const r = (0, Xb.hB)(t),
              o = Object.keys(t.breakpoints.values).reduce(
                (t, n) => (
                  (("object" == typeof e.spacing && null != e.spacing[n]) ||
                    ("object" == typeof e.direction &&
                      null != e.direction[n])) &&
                    (t[n] = !0),
                  t
                ),
                {}
              ),
              a = (0, Ba.P$)({ values: e.direction, base: o }),
              i = (0, Ba.P$)({ values: e.spacing, base: o });
            "object" == typeof a &&
              Object.keys(a).forEach((e, t, n) => {
                if (!a[e]) {
                  const r = t > 0 ? a[n[t - 1]] : "column";
                  a[e] = r;
                }
              });
            const s = (t, n) => {
              return e.useFlexGap
                ? { gap: (0, Xb.NA)(r, t) }
                : {
                    "& > :not(style):not(style)": { margin: 0 },
                    "& > :not(style) ~ :not(style)": {
                      [`margin${
                        ((o = n ? a[n] : e.direction),
                        {
                          row: "Left",
                          "row-reverse": "Right",
                          column: "Top",
                          "column-reverse": "Bottom",
                        }[o])
                      }`]: (0, Xb.NA)(r, t),
                    },
                  };
              var o;
            };
            n = (0, al.Z)(n, (0, Ba.k9)({ theme: t }, i, s));
          }
          return (n = (0, Ba.dt)(t.breakpoints, n)), n;
        },
        i_ = (function (n = {}) {
          const {
              createStyledComponent: r = n_,
              useThemeProps: o = r_,
              componentName: a = "MuiStack",
            } = n,
            i = r(a_),
            s = t.forwardRef(function (t, n) {
              const r = o(t),
                s = (0, Xt.Z)(r),
                {
                  component: l = "div",
                  direction: d = "column",
                  spacing: c = 0,
                  divider: p,
                  children: m,
                  className: h,
                  useFlexGap: f = !1,
                } = s,
                g = (0, At.Z)(s, e_),
                v = { direction: d, spacing: c, useFlexGap: f },
                b = (0, Rt.Z)({ root: ["root"] }, (e) => (0, Zt.ZP)(a, e), {});
              return (0,
              e.jsx)(i, (0, u.Z)({ as: l, ownerState: v, ref: n, className: Qt(b.root, h) }, g, { children: p ? o_(m, p) : m }));
            });
          return s;
        })({
          createStyledComponent: (0, Bt.ZP)("div", {
            name: "MuiStack",
            slot: "Root",
            overridesResolver: (e, t) => t.root,
          }),
          useThemeProps: (e) => (0, zt.i)({ props: e, name: "MuiStack" }),
        });
      var s_ = i_;
      function l_(e) {
        return (0, Zt.ZP)("MuiFormControlLabel", e);
      }
      var d_ = (0, Ft.Z)("MuiFormControlLabel", [
        "root",
        "labelPlacementStart",
        "labelPlacementTop",
        "labelPlacementBottom",
        "disabled",
        "label",
        "error",
        "required",
        "asterisk",
      ]);
      const c_ = [
          "checked",
          "className",
          "componentsProps",
          "control",
          "disabled",
          "disableTypography",
          "inputRef",
          "label",
          "labelPlacement",
          "name",
          "onChange",
          "required",
          "slotProps",
          "value",
        ],
        u_ = (0, Bt.ZP)("label", {
          name: "MuiFormControlLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              { [`& .${d_.label}`]: t.label },
              t.root,
              t[`labelPlacement${(0, $n.Z)(n.labelPlacement)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              display: "inline-flex",
              alignItems: "center",
              cursor: "pointer",
              verticalAlign: "middle",
              WebkitTapHighlightColor: "transparent",
              marginLeft: -11,
              marginRight: 16,
              [`&.${d_.disabled}`]: { cursor: "default" },
            },
            "start" === t.labelPlacement && {
              flexDirection: "row-reverse",
              marginLeft: 16,
              marginRight: -11,
            },
            "top" === t.labelPlacement && {
              flexDirection: "column-reverse",
              marginLeft: 16,
            },
            "bottom" === t.labelPlacement && {
              flexDirection: "column",
              marginLeft: 16,
            },
            {
              [`& .${d_.label}`]: {
                [`&.${d_.disabled}`]: {
                  color: (e.vars || e).palette.text.disabled,
                },
              },
            }
          )
        ),
        p_ = (0, Bt.ZP)("span", {
          name: "MuiFormControlLabel",
          slot: "Asterisk",
          overridesResolver: (e, t) => t.asterisk,
        })(({ theme: e }) => ({
          [`&.${d_.error}`]: { color: (e.vars || e).palette.error.main },
        }));
      var m_ = t.forwardRef(function (n, r) {
          var o, a;
          const i = (0, zt.i)({ props: n, name: "MuiFormControlLabel" }),
            {
              className: s,
              componentsProps: l = {},
              control: d,
              disabled: c,
              disableTypography: p,
              label: m,
              labelPlacement: h = "end",
              required: f,
              slotProps: g = {},
            } = i,
            v = (0, At.Z)(i, c_),
            b = fl(),
            _ =
              null != (o = null != c ? c : d.props.disabled)
                ? o
                : null == b
                ? void 0
                : b.disabled,
            y = null != f ? f : d.props.required,
            C = { disabled: _, required: y };
          ["checked", "name", "onChange", "value", "inputRef"].forEach((e) => {
            void 0 === d.props[e] && void 0 !== i[e] && (C[e] = i[e]);
          });
          const x = ml({ props: i, muiFormControl: b, states: ["error"] }),
            S = (0, u.Z)({}, i, {
              disabled: _,
              labelPlacement: h,
              required: y,
              error: x.error,
            }),
            k = ((e) => {
              const {
                  classes: t,
                  disabled: n,
                  labelPlacement: r,
                  error: o,
                  required: a,
                } = e,
                i = {
                  root: [
                    "root",
                    n && "disabled",
                    `labelPlacement${(0, $n.Z)(r)}`,
                    o && "error",
                    a && "required",
                  ],
                  label: ["label", n && "disabled"],
                  asterisk: ["asterisk", o && "error"],
                };
              return (0, Rt.Z)(i, l_, t);
            })(S),
            P = null != (a = g.typography) ? a : l.typography;
          let w = m;
          return (
            null == w ||
              w.type === ni ||
              p ||
              (w = (0, e.jsx)(
                ni,
                (0, u.Z)({ component: "span" }, P, {
                  className: (0, Et.Z)(
                    k.label,
                    null == P ? void 0 : P.className
                  ),
                  children: w,
                })
              )),
            (0, e.jsxs)(
              u_,
              (0, u.Z)(
                { className: (0, Et.Z)(k.root, s), ownerState: S, ref: r },
                v,
                {
                  children: [
                    t.cloneElement(d, C),
                    y
                      ? (0, e.jsxs)(s_, {
                          display: "block",
                          children: [
                            w,
                            (0, e.jsxs)(p_, {
                              ownerState: S,
                              "aria-hidden": !0,
                              className: k.asterisk,
                              children: [" ", "*"],
                            }),
                          ],
                        })
                      : w,
                  ],
                }
              )
            )
          );
        }),
        h_ = function () {
          return (
            (h_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            h_.apply(this, arguments)
          );
        },
        f_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                h_(
                  {
                    id: "Group_6879",
                    "data-name": "Group 6879",
                    transform: "translate(-337 -282.331)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "17.5",
                        r: "17.5",
                        transform: "translate(337 282.331)",
                        fill: "#e3f4fe",
                      }),
                      (0, e.jsx)("path", {
                        id: "DiscountsMajor_2_",
                        "data-name": "DiscountsMajor (2)",
                        d: "M12.64.721a2.392,2.392,0,0,0-3.423,0L8.166,1.8a2.392,2.392,0,0,1-1.74.721L4.921,2.5A2.392,2.392,0,0,0,2.5,4.921l.017,1.5A2.392,2.392,0,0,1,1.8,8.166L.721,9.217a2.392,2.392,0,0,0,0,3.423L1.8,13.692a2.4,2.4,0,0,1,.721,1.74l-.019,1.5a2.392,2.392,0,0,0,2.421,2.421l1.5-.017a2.392,2.392,0,0,1,1.74.721l1.051,1.075a2.391,2.391,0,0,0,3.423,0l1.051-1.077a2.392,2.392,0,0,1,1.74-.721l1.5.019a2.392,2.392,0,0,0,2.421-2.421l-.017-1.5a2.392,2.392,0,0,1,.721-1.74l1.075-1.051a2.391,2.391,0,0,0,0-3.423L20.06,8.166a2.392,2.392,0,0,1-.721-1.74l.019-1.5A2.392,2.392,0,0,0,16.937,2.5l-1.5.017a2.392,2.392,0,0,1-1.74-.721ZM7.65,9.29A1.639,1.639,0,1,0,6.011,7.65,1.639,1.639,0,0,0,7.65,9.29Zm6.557,6.557a1.639,1.639,0,1,0-1.639-1.639A1.639,1.639,0,0,0,14.208,15.847Zm.85-9.047a1.2,1.2,0,0,1,0,1.7L8.5,15.058a1.2,1.2,0,1,1-1.7-1.7L13.357,6.8a1.2,1.2,0,0,1,1.7,0Z",
                        transform: "translate(343.571 289.429)",
                        fill: "#2371cb",
                        "fill-rule": "evenodd",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        g_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                h_(
                  {
                    id: "Group_6883",
                    "data-name": "Group 6883",
                    transform: "translate(-1201 -257)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "17.5",
                        r: "17.5",
                        transform: "translate(1201 257)",
                        fill: "#eafaeb",
                      }),
                      (0, e.jsx)("path", {
                        id: "ProductsMinor",
                        d: "M11.75,3h6.605a1.181,1.181,0,0,1,1.181,1.181v6.605a2.362,2.362,0,0,1-.673,1.652l-6.1,6.233a2.953,2.953,0,0,1-4.177,0L3.865,13.947a2.953,2.953,0,0,1,0-4.177l.009-.009L10.1,3.673A2.362,2.362,0,0,1,11.749,3ZM15.4,8.906a1.772,1.772,0,1,0-1.772-1.772A1.772,1.772,0,0,0,15.4,8.906Z",
                        transform: "translate(1206.361 264.464)",
                        fill: "#28b433",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        v_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "40",
              height: "40",
              viewBox: "0 0 35 36",
            },
            {
              children: (0, e.jsxs)(
                "g",
                h_(
                  {
                    id: "Group_6880",
                    "data-name": "Group 6880",
                    transform: "translate(-646 -274)",
                  },
                  {
                    children: [
                      (0, e.jsx)("ellipse", {
                        id: "Ellipse_4",
                        "data-name": "Ellipse 4",
                        cx: "17.5",
                        cy: "18",
                        rx: "17.5",
                        ry: "18",
                        transform: "translate(646 274)",
                        fill: "#f1eefe",
                      }),
                      (0, e.jsx)("path", {
                        id: "CheckoutMajor_1_",
                        "data-name": "CheckoutMajor (1)",
                        d: "M1,.986A.989.989,0,0,1,1.99,0H3.474A1.482,1.482,0,0,1,4.958,1.479v.552l12.4.9a1.482,1.482,0,0,1,1.378,1.686l-.854,5.95a1.483,1.483,0,0,1-1.468,1.27H4.958v1.972h9.9a2.955,2.955,0,1,1-2.8,1.972H6.769a2.97,2.97,0,1,1-3.79-1.8v-12H1.99A.988.988,0,0,1,1,.986ZM13.873,16.764a.99.99,0,1,1,.989.986.988.988,0,0,1-.989-.986Zm-10.894,0a.99.99,0,1,1,.99.986.989.989,0,0,1-.99-.986Z",
                        transform: "translate(653.625 282.835)",
                        fill: "#8566fb",
                        "fill-rule": "evenodd",
                      }),
                    ],
                  }
                )
              ),
            }
          )
        ),
        b_ =
          ((0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.338",
                height: "16.338",
                viewBox: "16.338 16.338",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "CircleInformationMajor",
                  d: "M8.169,16.338A8.169,8.169,0,1,0,0,8.169,8.178,8.178,0,0,0,8.169,16.338Zm.817-4.9a.817.817,0,0,1-1.634,0V8.169a.817.817,0,0,1,1.634,0ZM8.169,4.085a.817.817,0,1,0,.817.817A.817.817,0,0,0,8.169,4.085Z",
                  fill: "#00a0ac",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "40",
                height: "40",
                viewBox: "0 0 35 35",
              },
              {
                children: (0, e.jsxs)(
                  "g",
                  h_(
                    {
                      id: "Group_6931",
                      "data-name": "Group 6931",
                      transform: "translate(-912 -271)",
                    },
                    {
                      children: [
                        (0, e.jsx)("circle", {
                          id: "Ellipse_4",
                          "data-name": "Ellipse 4",
                          cx: "17.5",
                          cy: "17.5",
                          r: "17.5",
                          transform: "translate(912 271)",
                          fill: "#e7fcff",
                        }),
                        (0, e.jsx)(
                          "g",
                          h_(
                            {
                              id: "Group_6917",
                              "data-name": "Group 6917",
                              transform: "translate(-0.872 -1)",
                            },
                            {
                              children: (0, e.jsx)(
                                "g",
                                h_(
                                  {
                                    id: "Group_6918",
                                    "data-name": "Group 6918",
                                    transform: "translate(919.891 278.02)",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      "g",
                                      h_(
                                        {
                                          id: "Group_6927",
                                          "data-name": "Group 6927",
                                          transform: "translate(0 0)",
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            "g",
                                            h_(
                                              {
                                                id: "money_2_",
                                                "data-name": "money (2)",
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    "g",
                                                    h_(
                                                      {
                                                        id: "Group_6920",
                                                        "data-name":
                                                          "Group 6920",
                                                        transform:
                                                          "translate(0 9.734)",
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "g",
                                                          h_(
                                                            {
                                                              id: "Group_6919",
                                                              "data-name":
                                                                "Group 6919",
                                                              transform:
                                                                "translate(0)",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("path", {
                                                                id: "Path_4897",
                                                                "data-name":
                                                                  "Path 4897",
                                                                d: "M.286,238.525a.437.437,0,0,0-.259.559l.274.755,2.088-2.088Z",
                                                                transform:
                                                                  "translate(-0.001 -237.75)",
                                                                fill: "#2dacae",
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    "g",
                                                    h_(
                                                      {
                                                        id: "Group_6922",
                                                        "data-name":
                                                          "Group 6922",
                                                        transform:
                                                          "translate(2.262 17.216)",
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "g",
                                                          h_(
                                                            {
                                                              id: "Group_6921",
                                                              "data-name":
                                                                "Group 6921",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("path", {
                                                                id: "Path_4898",
                                                                "data-name":
                                                                  "Path 4898",
                                                                d: "M55.257,420.513l1.258,3.459a.433.433,0,0,0,.226.246.439.439,0,0,0,.184.041.428.428,0,0,0,.151-.027l1.388-.512Z",
                                                                transform:
                                                                  "translate(-55.257 -420.513)",
                                                                fill: "#2dacae",
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    "g",
                                                    h_(
                                                      {
                                                        id: "Group_6924",
                                                        "data-name":
                                                          "Group 6924",
                                                        transform:
                                                          "translate(11.66 10.306)",
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "g",
                                                          h_(
                                                            {
                                                              id: "Group_6923",
                                                              "data-name":
                                                                "Group 6923",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("path", {
                                                                id: "Path_4899",
                                                                "data-name":
                                                                  "Path 4899",
                                                                d: "M294.06,255.682l-1.439-3.958-3.454,3.454,1.712-.631a.437.437,0,1,1,.3.819l-2.175.8a.436.436,0,0,1-.561-.259s0-.005,0-.008l-3.661,3.661,9.017-3.323A.435.435,0,0,0,294.06,255.682Z",
                                                                transform:
                                                                  "translate(-284.783 -251.724)",
                                                                fill: "#2dacae",
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    "g",
                                                    h_(
                                                      {
                                                        id: "Group_6926",
                                                        "data-name":
                                                          "Group 6926",
                                                        transform:
                                                          "translate(0.001 0)",
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "g",
                                                          h_(
                                                            {
                                                              id: "Group_6925",
                                                              "data-name":
                                                                "Group 6925",
                                                              transform:
                                                                "translate(0 0)",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)("path", {
                                                                id: "Path_4900",
                                                                "data-name":
                                                                  "Path 4900",
                                                                d: "M20.853,7.121,13.866.134a.437.437,0,0,0-.618,0l-13.1,13.1a.437.437,0,0,0,0,.618L7.134,20.84a.432.432,0,0,0,.308.128.439.439,0,0,0,.309-.128l13.1-13.1A.438.438,0,0,0,20.853,7.121ZM5.131,12.107,3.385,13.854a.437.437,0,0,1-.618-.618l1.747-1.747a.437.437,0,0,1,.618.618Zm7.542.555a1.649,1.649,0,0,1-1.2.458,3.609,3.609,0,0,1-2.429-1.16A4,4,0,0,1,7.957,10.1a1.825,1.825,0,0,1,.389-1.767,1.819,1.819,0,0,1,1.767-.389,3.994,3.994,0,0,1,1.859,1.091C13.184,10.248,13.494,11.841,12.674,12.661ZM18.233,7.74,16.486,9.486a.437.437,0,1,1-.618-.618l1.747-1.747a.437.437,0,0,1,.618.618Z",
                                                                transform:
                                                                  "translate(-0.019 -0.006)",
                                                                fill: "#2dacae",
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
              }
            )
          )),
        __ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "37",
              height: "37",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsx)(
                "g",
                h_(
                  {
                    id: "Group_6981",
                    "data-name": "Group 6981",
                    transform: "translate(-826 -320)",
                  },
                  {
                    children: (0, e.jsxs)(
                      "g",
                      h_(
                        { id: "Group_6980", "data-name": "Group 6980" },
                        {
                          children: [
                            (0, e.jsx)("circle", {
                              id: "Ellipse_81",
                              "data-name": "Ellipse 81",
                              cx: "17.5",
                              cy: "17.5",
                              r: "17.5",
                              transform: "translate(826 320)",
                              fill: "#e3f4fe",
                            }),
                            (0, e.jsx)(
                              "g",
                              h_(
                                {
                                  id: "Group_6979",
                                  "data-name": "Group 6979",
                                  transform: "translate(-0.877 -0.356)",
                                },
                                {
                                  children: (0, e.jsx)(
                                    "g",
                                    h_(
                                      {
                                        id: "line-chart",
                                        transform: "translate(832.877 328.356)",
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          "g",
                                          h_(
                                            {
                                              id: "Group_6978",
                                              "data-name": "Group 6978",
                                              transform: "translate(0 0)",
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)("path", {
                                                  id: "Path_4901",
                                                  "data-name": "Path 4901",
                                                  d: "M33,305.3v3.728a.416.416,0,0,0,.416.416H36.3a.416.416,0,0,0,.416-.416v-6.558l-2.093,2.093A2.539,2.539,0,0,1,33,305.3Z",
                                                  transform:
                                                    "translate(-31.441 -289.913)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4902",
                                                  "data-name": "Path 4902",
                                                  d: "M142,301.471v6.6a.416.416,0,0,0,.416.416H145.3a.416.416,0,0,0,.416-.416v-3.888a2.512,2.512,0,0,1-1.734-.737Z",
                                                  transform:
                                                    "translate(-135.291 -288.96)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4903",
                                                  "data-name": "Path 4903",
                                                  d: "M251,277v4.3a.416.416,0,0,0,.416.416H254.3a.416.416,0,0,0,.416-.416v-7.932l-3.3,3.3A2.469,2.469,0,0,1,251,277Z",
                                                  transform:
                                                    "translate(-239.141 -262.188)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4904",
                                                  "data-name": "Path 4904",
                                                  d: "M363.435,170.171,360,173.606v9.373a.416.416,0,0,0,.416.416H363.3a.416.416,0,0,0,.416-.416V170.431c-.094-.08-.165-.151-.217-.2Z",
                                                  transform:
                                                    "translate(-342.992 -163.864)",
                                                  fill: "#2371cb",
                                                }),
                                                (0, e.jsx)("path", {
                                                  id: "Path_4905",
                                                  "data-name": "Path 4905",
                                                  d: "M22.8,36.893a.8.8,0,0,0-.609-.222h-.076c-1.342.061-2.679.128-4.021.189a.868.868,0,0,0-.619.213.7.7,0,0,0-.146.217.7.7,0,0,0,.213.841l.335.34c.232.236.468.472.7.7l-8.107,8.112L6.832,43.644a1.158,1.158,0,0,0-1.639,0L.34,48.492a1.158,1.158,0,0,0,0,1.639l.217.217a1.158,1.158,0,0,0,1.639,0L6.01,46.536l3.643,3.643a1.163,1.163,0,0,0,1.644,0l9.147-9.147,1.035,1.03a.784.784,0,0,0,.553.293.684.684,0,0,0,.331-.09.9.9,0,0,0,.2-.146.961.961,0,0,0,.25-.666c.038-.869.08-1.739.123-2.613l.061-1.309A.813.813,0,0,0,22.8,36.893Z",
                                                  transform:
                                                    "translate(0 -36.671)",
                                                  fill: "#2371cb",
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            }
          )
        ),
        y_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "35",
              height: "35",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsxs)(
                "g",
                h_(
                  {
                    id: "Group_6929",
                    "data-name": "Group 6929",
                    transform: "translate(-1066 -792)",
                  },
                  {
                    children: [
                      (0, e.jsx)("circle", {
                        id: "Ellipse_80",
                        "data-name": "Ellipse 80",
                        cx: "15.5",
                        cy: "15.5",
                        r: "15.5",
                        transform: "translate(1066 792)",
                        fill: "#4ed8da",
                      }),
                      (0, e.jsx)(
                        "g",
                        h_(
                          {
                            id: "Group_6930",
                            "data-name": "Group 6930",
                            transform: "translate(150.072 516.494)",
                          },
                          {
                            children: (0, e.jsx)(
                              "g",
                              h_(
                                {
                                  id: "Group_6927",
                                  "data-name": "Group 6927",
                                  transform: "translate(920.412 279.02)",
                                },
                                {
                                  children: (0, e.jsxs)(
                                    "g",
                                    h_(
                                      {
                                        id: "money_2_",
                                        "data-name": "money (2)",
                                        transform: "translate(0 0)",
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            "g",
                                            h_(
                                              {
                                                id: "Group_6920",
                                                "data-name": "Group 6920",
                                                transform:
                                                  "translate(0 10.231)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  h_(
                                                    {
                                                      id: "Group_6919",
                                                      "data-name": "Group 6919",
                                                      transform: "translate(0)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4897",
                                                          "data-name":
                                                            "Path 4897",
                                                          d: "M.3,238.564a.459.459,0,0,0-.273.588l.288.793,2.195-2.195Z",
                                                          transform:
                                                            "translate(-0.001 -237.75)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            h_(
                                              {
                                                id: "Group_6922",
                                                "data-name": "Group 6922",
                                                transform:
                                                  "translate(2.378 18.095)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  h_(
                                                    {
                                                      id: "Group_6921",
                                                      "data-name": "Group 6921",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4898",
                                                          "data-name":
                                                            "Path 4898",
                                                          d: "M55.257,420.513l1.322,3.635a.455.455,0,0,0,.238.259.461.461,0,0,0,.194.043.45.45,0,0,0,.159-.028l1.459-.538Z",
                                                          transform:
                                                            "translate(-55.257 -420.513)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            h_(
                                              {
                                                id: "Group_6924",
                                                "data-name": "Group 6924",
                                                transform:
                                                  "translate(12.255 10.832)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  h_(
                                                    {
                                                      id: "Group_6923",
                                                      "data-name": "Group 6923",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4899",
                                                          "data-name":
                                                            "Path 4899",
                                                          d: "M294.533,255.884l-1.513-4.16-3.631,3.631,1.8-.663a.459.459,0,1,1,.318.861l-2.286.843a.459.459,0,0,1-.589-.272s0-.006,0-.008l-3.847,3.847,9.478-3.492A.458.458,0,0,0,294.533,255.884Z",
                                                          transform:
                                                            "translate(-284.783 -251.724)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            "g",
                                            h_(
                                              {
                                                id: "Group_6926",
                                                "data-name": "Group 6926",
                                                transform: "translate(0.001)",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  "g",
                                                  h_(
                                                    {
                                                      id: "Group_6925",
                                                      "data-name": "Group 6925",
                                                      transform:
                                                        "translate(0 0)",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "path",
                                                        {
                                                          id: "Path_4900",
                                                          "data-name":
                                                            "Path 4900",
                                                          d: "M21.917,7.484,14.573.14a.459.459,0,0,0-.649,0L.153,13.911a.459.459,0,0,0,0,.649L7.5,21.9a.454.454,0,0,0,.324.135.461.461,0,0,0,.325-.134l13.77-13.77A.46.46,0,0,0,21.917,7.484ZM5.392,12.724,3.556,14.56a.459.459,0,0,1-.65-.649l1.836-1.836a.459.459,0,0,1,.65.649Zm7.927.583a1.733,1.733,0,0,1-1.258.481,3.793,3.793,0,0,1-2.553-1.219,4.206,4.206,0,0,1-1.147-1.954,1.918,1.918,0,0,1,.409-1.857,1.912,1.912,0,0,1,1.857-.409A4.2,4.2,0,0,1,12.581,9.5C13.857,10.771,14.181,12.445,13.319,13.307Zm5.843-5.173L17.327,9.97a.459.459,0,0,1-.65-.649l1.836-1.836a.459.459,0,0,1,.65.649Z",
                                                          transform:
                                                            "translate(-0.019 -0.006)",
                                                          fill: "#fafafa",
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
            }
          )
        ),
        C_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "35",
              height: "35",
              viewBox: "0 0 35 35",
            },
            {
              children: (0, e.jsx)(
                "g",
                h_(
                  {
                    id: "Group_6885",
                    "data-name": "Group 6885",
                    transform: "translate(-1067.5 -1310)",
                  },
                  {
                    children: (0, e.jsx)("path", {
                      id: "MarkPaidMinor_1_",
                      "data-name": "MarkPaidMinor (1)",
                      d: "M24.618,10.317a1.929,1.929,0,0,1,0,2.728l-8.68,8.68a1.929,1.929,0,0,1-2.728,0L8.388,16.9a1.929,1.929,0,1,1,2.728-2.728l3.458,3.459,7.317-7.317A1.929,1.929,0,0,1,24.618,10.317ZM5.893,3A2.893,2.893,0,0,0,3,5.893V30.005a1.933,1.933,0,0,0,2.51,1.838,1.921,1.921,0,0,0,.843-.648l2.164-2.55,2.6,2.7a1.932,1.932,0,0,0,1.354.59,1.852,1.852,0,0,0,1.375-.542l2.631-2.54L19,31.369a1.923,1.923,0,0,0,2.728,0l2.739-2.739,2.2,2.573a1.879,1.879,0,0,0,3.347-1.2V5.893A2.893,2.893,0,0,0,27.112,3Z",
                      transform: "translate(1064.5 1307)",
                      fill: "#9c6ade",
                    }),
                  }
                )
              ),
            }
          )
        ),
        x_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "22.515",
              height: "15.386",
              viewBox: "0 0 20.515 15.386",
            },
            {
              children: (0, e.jsx)("path", {
                id: "id-card",
                d: "M18.164,3H2.351A2.353,2.353,0,0,0,0,5.351V16.035a2.353,2.353,0,0,0,2.351,2.351H18.164a2.353,2.353,0,0,0,2.351-2.351V5.351A2.353,2.353,0,0,0,18.164,3ZM6.411,6.419A2.137,2.137,0,1,1,4.274,8.556,2.14,2.14,0,0,1,6.411,6.419Zm3.847,7.907a.641.641,0,0,1-.641.641H3.205a.641.641,0,0,1-.641-.641V13.9a2.353,2.353,0,0,1,2.351-2.351H7.907A2.353,2.353,0,0,1,10.257,13.9Zm7.052.641h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Zm0-3.419h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Zm0-3.419h-4.7a.641.641,0,0,1,0-1.282h4.7a.641.641,0,1,1,0,1.282Z",
                transform: "translate(0 -3)",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              }),
            }
          )
        ),
        S_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "18.321",
              height: "18.321",
              viewBox: "0 0 18.321 18.321",
            },
            {
              children: (0, e.jsx)("path", {
                id: "DiscountsMajor",
                d: "M10.6.6A2.005,2.005,0,0,0,7.726.6l-.881.9a2.005,2.005,0,0,1-1.458.6L4.125,2.1A2.005,2.005,0,0,0,2.1,4.125l.015,1.261a2.005,2.005,0,0,1-.6,1.458l-.9.881A2.005,2.005,0,0,0,.6,10.6l.9.881a2.007,2.007,0,0,1,.6,1.458L2.1,14.2a2.005,2.005,0,0,0,2.029,2.029l1.261-.015a2.005,2.005,0,0,1,1.458.6l.881.9a2,2,0,0,0,2.869,0l.881-.9a2.005,2.005,0,0,1,1.458-.6l1.261.016A2.005,2.005,0,0,0,16.225,14.2l-.015-1.261a2.005,2.005,0,0,1,.6-1.458l.9-.881a2,2,0,0,0,0-2.869l-.9-.881a2.005,2.005,0,0,1-.6-1.458l.016-1.261A2.005,2.005,0,0,0,14.2,2.1l-1.261.015a2.005,2.005,0,0,1-1.458-.6ZM6.412,7.787A1.374,1.374,0,1,0,5.038,6.412,1.374,1.374,0,0,0,6.412,7.787Zm5.5,5.5a1.374,1.374,0,1,0-1.374-1.374A1.374,1.374,0,0,0,11.909,13.283ZM12.621,5.7a1.008,1.008,0,0,1,0,1.425l-5.5,5.5A1.008,1.008,0,0,1,5.7,11.2l5.5-5.5a1.008,1.008,0,0,1,1.425,0Z",
                transform: "translate(0 0)",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              }),
            }
          )
        ),
        k_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "20.515",
              height: "20.515",
              viewBox: "0 0 20.515 15.386",
            },
            {
              children: (0, e.jsx)(
                "g",
                h_(
                  {
                    id: "Group_6934",
                    "data-name": "Group 6934",
                    transform: "translate(-30 -603)",
                  },
                  {
                    children: (0, e.jsx)(
                      "g",
                      h_(
                        {
                          id: "Group_6933",
                          "data-name": "Group 6933",
                          transform: "translate(-30 13.36)",
                        },
                        {
                          children: (0, e.jsxs)(
                            "g",
                            h_(
                              {
                                id: "Layer_2",
                                "data-name": "Layer 2",
                                transform: "translate(60 589.64)",
                              },
                              {
                                children: [
                                  (0, e.jsx)("circle", {
                                    id: "Ellipse_81",
                                    "data-name": "Ellipse 81",
                                    cx: "1.749",
                                    cy: "1.749",
                                    r: "1.749",
                                    transform: "translate(6.704 21.277)",
                                    fill: "#5c5f62",
                                  }),
                                  (0, e.jsx)("circle", {
                                    id: "Ellipse_82",
                                    "data-name": "Ellipse 82",
                                    cx: "1.749",
                                    cy: "1.749",
                                    r: "1.749",
                                    transform: "translate(16.03 21.277)",
                                    fill: "#5c5f62",
                                  }),
                                  (0, e.jsx)("path", {
                                    id: "Path_4901",
                                    "data-name": "Path 4901",
                                    d: "M4.643,1.25H2.124A.874.874,0,0,0,2.124,3H4.643a.3.3,0,0,1,.291.233L7.266,16.406a2.623,2.623,0,0,0,.093,5.235H21.944a.874.874,0,1,0,0-1.749H7.371a.874.874,0,1,1,0-1.749H21.2a3.229,3.229,0,0,0,3.148-2.576l1.679-8.394a2.052,2.052,0,0,0-2.005-2.437H6.986L6.659,2.917A2.064,2.064,0,0,0,4.643,1.25Zm7.974,9.583L14.949,8.5a.909.909,0,0,1,.28-.187.851.851,0,0,1,.676,0,.909.909,0,0,1,.28.187l2.332,2.332a.874.874,0,1,1-1.236,1.236l-.839-.839v2.553a.874.874,0,0,1-1.749,0V11.23l-.839.839a.874.874,0,0,1-1.236-1.236Z",
                                    transform: "translate(-1.25 -1.25)",
                                    fill: "#5c5f62",
                                    "fill-rule": "evenodd",
                                  }),
                                ],
                              }
                            )
                          ),
                        }
                      )
                    ),
                  }
                )
              ),
            }
          )
        ),
        P_ =
          ((0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "HomeMinor",
                  d: "M11.218,3.183a1.088,1.088,0,0,0-1.207,0L3.969,7.21A2.175,2.175,0,0,0,3,9.021v7.032a2.175,2.175,0,0,0,2.175,2.175H7.351A1.088,1.088,0,0,0,8.439,17.14V12.79H12.79V17.14a1.088,1.088,0,0,0,1.088,1.088h2.175a2.175,2.175,0,0,0,2.175-2.175V9.021a2.176,2.176,0,0,0-.968-1.81L11.218,3.183Z",
                  transform: "translate(-3 -3)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.125",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
                className: "icon-hover",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "CheckoutMajor",
                  d: "M1,.84A.842.842,0,0,1,1.844,0H3.108A1.263,1.263,0,0,1,4.373,1.26v.471l10.565.763a1.263,1.263,0,0,1,1.174,1.437L15.384,9a1.264,1.264,0,0,1-1.251,1.082H4.373v1.68h8.439a2.518,2.518,0,1,1-2.385,1.68H5.915a2.531,2.531,0,1,1-3.229-1.538V1.68H1.844A.842.842,0,0,1,1,.84ZM11.969,14.284a.843.843,0,1,1,.843.84.842.842,0,0,1-.843-.84Zm-9.282,0a.843.843,0,1,1,.844.84.842.842,0,0,1-.844-.84Z",
                  transform: "translate(-1)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "CustomersMajor",
                  d: "M14.288,5.195A4.194,4.194,0,1,1,10.094,1a4.194,4.194,0,0,1,4.194,4.195ZM2.666,14.388a12.486,12.486,0,0,1,7.429-2.836,12.5,12.5,0,0,1,7.429,2.836,1.843,1.843,0,0,1,.564,2.044l-.331,1.014a2.1,2.1,0,0,1-1.994,1.446H4.426a2.1,2.1,0,0,1-1.993-1.446L2.1,16.431a1.838,1.838,0,0,1,.564-2.044Z",
                  transform: "translate(-2 -1)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "16.228",
                height: "16.228",
                viewBox: "0 0 16.228 15.228",
              },
              {
                children: (0, e.jsx)("path", {
                  id: "ReceiptMajor",
                  d: "M13.826,0H4.3A1.3,1.3,0,0,0,3,1.31V17.079a.173.173,0,0,0,.289.13L4.73,15.9a.43.43,0,0,1,.58,0l1.441,1.311a.431.431,0,0,0,.58,0L8.773,15.9a.43.43,0,0,1,.58,0l1.44,1.311a.431.431,0,0,0,.58,0L12.815,15.9a.43.43,0,0,1,.58,0l1.441,1.312a.173.173,0,0,0,.289-.13V1.31A1.3,1.3,0,0,0,13.826,0Zm-.433,4.33V3.464H4.732V5.2h8.661Zm0,2.6V8.661H4.732V6.929Zm-3.464,4.33v-.866h-5.2v1.732h5.2Z",
                  transform: "translate(-3)",
                  fill: "#5c5f62",
                  "fill-rule": "evenodd",
                }),
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "550",
                height: "200",
                viewBox: "0 0 721 226",
              },
              {
                children: (0, e.jsx)(
                  "g",
                  h_(
                    {
                      id: "Group_38",
                      "data-name": "Group 38",
                      transform: "translate(-4440 -9635)",
                    },
                    {
                      children: (0, e.jsxs)(
                        "g",
                        h_(
                          { id: "Group_37", "data-name": "Group 37" },
                          {
                            children: [
                              (0, e.jsxs)(
                                "g",
                                h_(
                                  {
                                    id: "Rectangle_49",
                                    "data-name": "Rectangle 49",
                                    transform: "translate(4440 9635)",
                                    fill: "#eff0f5",
                                    stroke: "#d2d3d4",
                                    "stroke-width": "1",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)("rect", {
                                        width: "721",
                                        height: "226",
                                        rx: "12",
                                        stroke: "none",
                                      }),
                                      (0, e.jsx)("rect", {
                                        x: "0.5",
                                        y: "0.5",
                                        width: "720",
                                        height: "225",
                                        rx: "11.5",
                                        fill: "none",
                                      }),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsxs)(
                                "g",
                                h_(
                                  { id: "Group_33", "data-name": "Group 33" },
                                  {
                                    children: [
                                      (0, e.jsxs)(
                                        "g",
                                        h_(
                                          {
                                            id: "Rectangle_50",
                                            "data-name": "Rectangle 50",
                                            transform: "translate(4510 9691)",
                                            fill: "#fff",
                                            stroke: "#4770db",
                                            "stroke-width": "2",
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("rect", {
                                                width: "279",
                                                height: "68",
                                                rx: "34",
                                                stroke: "none",
                                              }),
                                              (0, e.jsx)("rect", {
                                                x: "1",
                                                y: "1",
                                                width: "277",
                                                height: "66",
                                                rx: "33",
                                                fill: "none",
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        "text",
                                        h_(
                                          {
                                            id: "Add_to_cart",
                                            "data-name": "Add to cart",
                                            transform: "translate(4580 9737)",
                                            fill: "#090500",
                                            "font-size": "28",
                                            "font-family": "SegoeUI, Segoe UI",
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              "tspan",
                                              h_(
                                                { x: "0", y: "0" },
                                                { children: "Add to cart" }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsxs)(
                                "g",
                                h_(
                                  {
                                    id: "Group_34",
                                    "data-name": "Group 34",
                                    transform: "translate(314)",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)("rect", {
                                        id: "Rectangle_50-2",
                                        "data-name": "Rectangle 50",
                                        width: "279",
                                        height: "68",
                                        rx: "34",
                                        transform: "translate(4510 9691)",
                                        fill: "#4770db",
                                      }),
                                      (0, e.jsx)(
                                        "text",
                                        h_(
                                          {
                                            id: "Buy_it_now",
                                            "data-name": "Buy it now",
                                            transform: "translate(4580 9737)",
                                            fill: "#fff",
                                            "font-size": "28",
                                            "font-family": "SegoeUI, Segoe UI",
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              "tspan",
                                              h_(
                                                { x: "0", y: "0" },
                                                { children: "Buy it now" }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsxs)(
                                "g",
                                h_(
                                  {
                                    id: "Group_36",
                                    "data-name": "Group 36",
                                    transform: "translate(-6 7)",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)("circle", {
                                        id: "Ellipse_5",
                                        "data-name": "Ellipse 5",
                                        cx: "25.5",
                                        cy: "25.5",
                                        r: "25.5",
                                        transform: "translate(4613 9768)",
                                        fill: "#22a707",
                                      }),
                                      (0, e.jsx)("path", {
                                        id: "check_6_",
                                        "data-name": "check (6)",
                                        d: "M31.318,5.794a1.587,1.587,0,0,1,.134,2.256L14.773,26.564a1.587,1.587,0,0,1-2.266.093L2.854,17.57a1.6,1.6,0,0,1,2.166-2.357l7.489,6.736a1.587,1.587,0,0,0,2.239-.117L29.1,5.925a1.587,1.587,0,0,1,2.223-.131Z",
                                        transform:
                                          "translate(4622.64 9777.256)",
                                        fill: "#fafafa",
                                        "fill-rule": "evenodd",
                                      }),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsxs)(
                                "g",
                                h_(
                                  {
                                    id: "Group_35",
                                    "data-name": "Group 35",
                                    transform: "translate(13 11.309)",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)("circle", {
                                        id: "Ellipse_6",
                                        "data-name": "Ellipse 6",
                                        cx: "23",
                                        cy: "23",
                                        r: "23",
                                        transform: "translate(4930 9767.691)",
                                        fill: "#e71212",
                                      }),
                                      (0, e.jsxs)(
                                        "g",
                                        h_(
                                          {
                                            id: "_02_User",
                                            "data-name": "02 User",
                                            transform:
                                              "translate(4941.423 9779.423)",
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("path", {
                                                id: "Path_1",
                                                "data-name": "Path 1",
                                                d: "M1.11,22.842a1.115,1.115,0,0,1-.789-1.9L20.935.323A1.116,1.116,0,0,1,22.513,1.9L1.9,22.515a1.112,1.112,0,0,1-.789.327Z",
                                                transform:
                                                  "translate(0.006 0.003)",
                                                fill: "#fafafa",
                                              }),
                                              (0, e.jsx)("path", {
                                                id: "Path_2",
                                                "data-name": "Path 2",
                                                d: "M21.726,22.842a1.112,1.112,0,0,1-.789-.327L.323,1.9A1.116,1.116,0,1,1,1.9.323L22.515,20.937a1.115,1.115,0,0,1-.789,1.9Z",
                                                transform:
                                                  "translate(0.003 0.003)",
                                                fill: "#fafafa",
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    }
                  )
                ),
              }
            )
          )),
        w_ =
          ((0, e.jsxs)(
            "svg",
            h_(
              {
                version: "1.1",
                id: "Capa_1",
                xmlns: "http://www.w3.org/2000/svg",
                width: "50.228",
                height: "20.228",
                viewBox: "0 0 50.999 511.999",
                fill: "#5c5f62",
                "fill-rule": "evenodd",
              },
              {
                children: [
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M438.09,273.32h-39.596c4.036,11.05,6.241,22.975,6.241,35.404v149.65c0,5.182-0.902,10.156-2.543,14.782h65.461\r\n\t\t\tc24.453,0,44.346-19.894,44.346-44.346v-81.581C512,306.476,478.844,273.32,438.09,273.32z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M107.265,308.725c0-12.43,2.205-24.354,6.241-35.404H73.91c-40.754,0-73.91,33.156-73.91,73.91v81.581\r\n\t\t\tc0,24.452,19.893,44.346,44.346,44.346h65.462c-1.641-4.628-2.543-9.601-2.543-14.783V308.725z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M301.261,234.815h-90.522c-40.754,0-73.91,33.156-73.91,73.91v149.65c0,8.163,6.618,14.782,14.782,14.782h208.778\r\n\t\t\tc8.164,0,14.782-6.618,14.782-14.782v-149.65C375.171,267.971,342.015,234.815,301.261,234.815z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M256,38.84c-49.012,0-88.886,39.874-88.886,88.887c0,33.245,18.349,62.28,45.447,77.524\r\n\t\t\tc12.853,7.23,27.671,11.362,43.439,11.362c15.768,0,30.586-4.132,43.439-11.362c27.099-15.244,45.447-44.28,45.447-77.524\r\n\t\t\tC344.886,78.715,305.012,38.84,256,38.84z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M99.918,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,36.655,29.82,66.475,66.475,66.475\r\n\t\t\tc9.298,0,18.152-1.926,26.195-5.388c13.906-5.987,25.372-16.585,32.467-29.86c4.98-9.317,7.813-19.946,7.813-31.227\r\n\t\t\tC166.393,151.51,136.573,121.689,99.918,121.689z",
                      }),
                    }),
                  }),
                  (0, e.jsx)("g", {
                    children: (0, e.jsx)("g", {
                      children: (0, e.jsx)("path", {
                        d: "M412.082,121.689c-36.655,0-66.475,29.82-66.475,66.475c0,11.282,2.833,21.911,7.813,31.227\r\n\t\t\tc7.095,13.276,18.561,23.874,32.467,29.86c8.043,3.462,16.897,5.388,26.195,5.388c36.655,0,66.475-29.82,66.475-66.475\r\n\t\t\tC478.557,151.509,448.737,121.689,412.082,121.689z",
                      }),
                    }),
                  }),
                ],
              }
            )
          ),
          (0, e.jsx)(
            "svg",
            h_(
              {
                height: "24px",
                viewBox: "0 0 32 32",
                fill: "#5c5f62",
                width: "30px",
                xmlns: "http://www.w3.org/2000/svg",
                id: "fi_7162310",
              },
              {
                children: (0, e.jsxs)(
                  "g",
                  h_(
                    { id: "_x32_0" },
                    {
                      children: [
                        (0, e.jsx)("path", {
                          d: "m22 8c1.6542969 0 3 1.3457031 3 3v.5859375l-.2929688-.2929688c-.390625-.390625-1.0234375-.390625-1.4140625 0s-.390625 1.0234375 0 1.4140625l2 2c.1953126.1953126.4511719.2929688.7070313.2929688s.5117188-.0976563.7070313-.2929688l2-2c.390625-.390625.390625-1.0234375 0-1.4140625s-1.0234375-.390625-1.4140625 0l-.2929688.2929688v-.5859375c0-2.7568359-2.2431641-5-5-5-.5527344 0-1 .4472656-1 1s.4472656 1 1 1z",
                        }),
                        (0, e.jsx)("path", {
                          d: "m10 25c-1.6542969 0-3-1.3457031-3-3v-.5859375l.2929688.2929688c.1953125.1953125.4511718.2929687.7070312.2929687s.5117188-.0976563.7070313-.2929688c.390625-.390625.390625-1.0234375 0-1.4140625l-2-2c-.390625-.390625-1.0234375-.390625-1.4140625 0l-2 2c-.390625.390625-.390625 1.0234375 0 1.4140625s1.0234375.390625 1.4140625 0l.2929687-.2929687v.5859375c0 2.7568359 2.2431641 5 5 5 .5527344 0 1-.4472656 1-1s-.4472656-1-1-1z",
                        }),
                        (0, e.jsx)("path", {
                          d: "m17 16c.5527344 0 1-.4472656 1-1v-6.4407349l-2.7763672 1.3881836c-.0693359.0341797-.1464844.0527344-.2236328.0527344h-4v.9998169h-2v-.9998169h-4c-.0771484 0-.1542969-.0185547-.2236328-.0527344l-2.7763672-1.3881836v6.4407349c0 .5527344.4472656 1 1 1z",
                        }),
                        (0, e.jsx)("path", {
                          d: "m9 9.0001831v-1.0001831h2v1.0001831h3.8818359l3.1181641-1.559082v-1.4411011c0-.5527344-.4472656-1-1-1h-3v-2c0-.5527344-.4472656-1-1-1h-6c-.5527344 0-1 .4472656-1 1v2h-3c-.5527344 0-1 .4472656-1 1v1.4411011l3.1181641 1.559082zm-1-5.0001831h4v1h-4z",
                        }),
                        (0, e.jsx)("path", {
                          d: "m27 24.0001831h-4v.9998169h-2v-.9998169h-4c-.0771484 0-.1542969-.0185547-.2236328-.0527344l-2.7763672-1.3881836v6.4407349c0 .5527344.4472656 1 1 1h14c.5527344 0 1-.4472656 1-1v-6.4407349l-2.7763672 1.3881836c-.0693359.0341797-.1464844.0527344-.2236328.0527344z",
                        }),
                        (0, e.jsx)("path", {
                          d: "m29 19h-3v-2c0-.5527344-.4472656-1-1-1h-6c-.5527344 0-1 .4472656-1 1v2h-3c-.5527344 0-1 .4472656-1 1v1.4411011l3.1181641 1.559082h3.8818359v-1.0001831h2v1.0001831h3.8818359l3.1181641-1.559082v-1.4411011c0-.5527344-.4472656-1-1-1zm-5 0h-4v-1h4z",
                        }),
                      ],
                    }
                  )
                ),
              }
            )
          )),
        O_ = (0, e.jsx)(
          "svg",
          h_(
            {
              xmlns: "http://www.w3.org/2000/svg",
              width: "22.611",
              height: "16",
              viewBox: "0 0 22.611 16",
            },
            {
              children: (0, e.jsx)("path", {
                id: "youtube_3_",
                "data-name": "youtube (3)",
                d: "M17.915,67.393H4.7a4.7,4.7,0,0,0-4.7,4.7V78.7a4.7,4.7,0,0,0,4.7,4.7H17.915a4.7,4.7,0,0,0,4.7-4.7V72.089A4.7,4.7,0,0,0,17.915,67.393Zm-3.176,8.322L8.556,78.663a.248.248,0,0,1-.355-.224V72.357a.248.248,0,0,1,.36-.221l6.183,3.133A.248.248,0,0,1,14.739,75.715Z",
                transform: "translate(0 -67.393)",
                fill: "#f61c0d",
              }),
            }
          )
        ),
        T_ = function () {
          return (
            (T_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            T_.apply(this, arguments)
          );
        },
        I_ = function (n) {
          var r,
            o,
            a,
            i = n.popUpType,
            s = n.openPopUp,
            l = n.CallMethod,
            d = n.closeModal,
            c = n.uniqueLink,
            u = n.affiliateLinkType,
            p = n.showToasterMsg,
            m = g(),
            h = xv().copyTextFunction,
            f =
              null ===
                (o =
                  null === (r = F.getState()) || void 0 === r
                    ? void 0
                    : r.salesRepData) || void 0 === o
                ? void 0
                : o.checkoutConfirmationPopUp,
            v = i,
            b = (0, t.useState)(null != s && s),
            _ = b[0],
            y = b[1],
            C = { IscheckBoxChecked: !1 },
            x = (0, t.useState)(
              null !== (a = null == C ? void 0 : C.IscheckBoxChecked) &&
                void 0 !== a &&
                a
            ),
            S = x[0],
            k = x[1],
            P = ee().t,
            w = function () {
              y(!_);
            };
          return (0, e.jsxs)(
            Hp,
            T_(
              {
                open: _,
                onClose: function () {
                  return y(!1);
                },
                maxWidth: "sm",
                fullWidth: !0,
              },
              {
                children: [
                  (0, e.jsx)(
                    Lb,
                    T_(
                      { id: "alert-proceed-title" },
                      {
                        children: (0, e.jsxs)(
                          "div",
                          T_(
                            {
                              style: {
                                display: "flex",
                                justifyContent: "space-between",
                              },
                            },
                            {
                              children: [
                                (0, e.jsxs)("b", {
                                  children: [
                                    " ",
                                    P(
                                      "checkOutPopUp" === v
                                        ? "customerInvoice_ProceedToCheckout"
                                        : "affiliateLink_Confirmation_Note"
                                    ),
                                  ],
                                }),
                                (0, e.jsx)(Fg, {
                                  sx: { cursor: "pointer" },
                                  onClick: function () {
                                    w(), d();
                                  },
                                }),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                  (0, e.jsx)(Gp, {
                    children:
                      "checkOutPopUp" === v
                        ? (0, e.jsxs)(
                            Zb,
                            T_(
                              { id: "alert-dialog-description" },
                              {
                                children: [
                                  P("customerInvoice_CheckoutMsg"),
                                  (0, e.jsx)(
                                    ni,
                                    T_(
                                      { sx: { mt: 2 }, variant: "subtitle1" },
                                      {
                                        children: (0, e.jsx)(m_, {
                                          label: P("Checkout_DoNotAskAgainMsg"),
                                          control: (0, e.jsx)(tb, {
                                            checked: S,
                                            onChange: function (e) {
                                              return (function (e) {
                                                var t, n, r;
                                                k(
                                                  null ===
                                                    (t =
                                                      null == e
                                                        ? void 0
                                                        : e.target) ||
                                                    void 0 === t
                                                    ? void 0
                                                    : t.checked
                                                ),
                                                  (n = T_(T_({}, f), {
                                                    IscheckBoxChecked:
                                                      null == e
                                                        ? void 0
                                                        : e.target.checked,
                                                  })),
                                                  (r =
                                                    A.CHECKOUT_CONFIRMATION_POPUP),
                                                  m({ payload: n, type: r });
                                              })(e);
                                            },
                                          }),
                                        }),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          )
                        : (0, e.jsxs)(
                            Zb,
                            T_(
                              { id: "alert-dialog-description" },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    ni,
                                    T_(
                                      { sx: { color: "black" } },
                                      {
                                        children: [
                                          P("affiliateLink_Confirmation_Msg1"),
                                          "  ",
                                          (0, e.jsx)("b", {
                                            children: P(
                                              "affiliateLinkConfirmationMsg2"
                                            ),
                                          }),
                                          "  ",
                                          P("affiliateLink_Confirmation_Msg3"),
                                          "  ",
                                          (0, e.jsxs)("b", {
                                            children: [
                                              P(
                                                "affiliateLink_Confirmation_Msg4"
                                              ),
                                              " ",
                                            ],
                                          }),
                                          " ",
                                          P("affiliateLink_Confirmation_Msg5"),
                                        ],
                                      }
                                    )
                                  ),
                                  P_,
                                ],
                              }
                            )
                          ),
                  }),
                  (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                  (0, e.jsxs)(Jp, {
                    children: [
                      "checkOutPopUp" === v
                        ? (0, e.jsx)(
                            Qu,
                            T_(
                              {
                                variant: "outlined",
                                onClick: function () {
                                  w(), d();
                                },
                                sx: { textTransform: "capitalize", mr: 1 },
                              },
                              { children: P("customerInvoice_cancel") }
                            )
                          )
                        : (0, e.jsx)(
                            Qu,
                            T_(
                              {
                                variant: "outlined",
                                onClick: function () {
                                  w(), d(), l(c, u);
                                },
                                sx: { textTransform: "capitalize", mr: 1 },
                              },
                              { children: P("DoNotShowAgain") }
                            )
                          ),
                      (0, e.jsx)(
                        Ym,
                        T_(
                          {
                            onClick: function () {
                              w(),
                                "checkOutPopUp" === v ? l(qg) : (h(c, u), p()),
                                d();
                            },
                            loadingPosition: "end",
                            variant: "contained",
                            style: {
                              marginLeft: "5px",
                              textTransform: "capitalize",
                            },
                          },
                          {
                            children: P(
                              "checkOutPopUp" === v
                                ? "customerInvoice_Checkout"
                                : "leaveOnPageBtn"
                            ),
                          }
                        )
                      ),
                    ],
                  }),
                ],
              }
            )
          );
        },
        M_ = function () {
          return (
            (M_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            M_.apply(this, arguments)
          );
        };
      function j_(n) {
        var r = xb(n),
          o = r.handleSearchProductData,
          a = r.makeFieldsEmpty,
          i = r.productSearchText,
          s = r.handleKeyDown,
          l = r.handleProductTableSearchPopup,
          d = r.shopCurrency,
          c = r.handleSearchTextChange,
          u = r.searchTablePopupOpen,
          p = r.productsArray,
          m = r.getProductsLoading,
          h = r.selectedProductArray,
          f = r.checkUncheckProductVariant,
          g = r.selectedVariantArray,
          v = r.selectedProductIdArray,
          b = r.showSelectedProduct,
          _ = r.ProductTableHeaders,
          y = r.netQuantitySubtotal,
          C = r.updateNetQuantitySubtotal,
          x = r.finalSelectedProducts,
          S = r.closePopupForSearchProductData,
          k = r.removeAllSelectedProducts,
          P = r.handleNextClick,
          w = r.handlePrevClick,
          O = r.pageInfo,
          T = r.searchDialogProductTableHeaders,
          I = r.selectFeatures,
          M = r.handleAlertMsgClose,
          j = r.isQuantityError,
          N = r.t,
          D = r.tableContainerRef,
          A = r.hoveredIconIndex,
          E = r.setHoveredIconIndex,
          R = gb(),
          L = R.commissionDiscountType,
          B = R.setSelectedProductIndex,
          z = R.setSelectedProductLink,
          F = R.affiliateAlertMsg,
          Z = R.commissionOn,
          H = R.affiliateIsConfirmOpen,
          V = R.handleAffiliateOpenConfirm,
          W = R.handleDoNotShowState,
          U = R.selectedProductLink,
          $ = R.selectedProductIndex,
          K = R.CheckPopUpInitialValue,
          G = xv(),
          q = G.copyTextFunction,
          Q = G.copyIconSuccessColor,
          Y = G.SnackbarAlertMsg,
          J = G.disableTableRow,
          X = {
            background: "#F2F2F2",
            border: "1px solid #E0E0E0",
            color: "gray",
            minWidth: "40px !important",
          },
          ee = { width: "50px", m: "5px", textAlign: "center" };
        return (
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.openSearchProducts) && l();
            },
            [null == n ? void 0 : n.openSearchProducts]
          ),
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.isRemoveSelectedProduct) && k();
            },
            [null == n ? void 0 : n.isRemoveSelectedProduct]
          ),
          (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(
                mn,
                M_(
                  { pt: 1 },
                  {
                    children: [
                      3 === (null == n ? void 0 : n.activeTabIndex) &&
                        (0, e.jsx)(e.Fragment, {
                          children: (0, e.jsxs)(
                            qa,
                            M_(
                              { container: !0, spacing: 2 },
                              {
                                children: [
                                  (0, e.jsx)(
                                    qa,
                                    M_(
                                      { item: !0, xs: 12, md: 7, mb: 1 },
                                      {
                                        children: (0, e.jsx)(
                                          ni,
                                          M_(
                                            { variant: "h6", sx: Ko },
                                            {
                                              children: N(
                                                "createOrder_select_product"
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    qa,
                                    M_(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 5,
                                        mb: 1,
                                        className: "ST_DC_Card_Grid",
                                        sx: { textAlign: "right" },
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          "div",
                                          M_(
                                            {
                                              className:
                                                "ST_ProductTableSearchBar",
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)(ju, {
                                                  fullWidth: !0,
                                                  size: "medium",
                                                  inputValue: "",
                                                  options: [],
                                                  renderInput: function (t) {
                                                    return (0, e.jsx)(
                                                      Hc,
                                                      M_(
                                                        {
                                                          placeholder: N(
                                                            "ST_CO_SearchProducts_Label"
                                                          ),
                                                        },
                                                        t,
                                                        {
                                                          onClick: function () {
                                                            l();
                                                          },
                                                          InputProps: M_(
                                                            M_(
                                                              {},
                                                              t.InputProps
                                                            ),
                                                            {
                                                              style: {
                                                                height: 40,
                                                              },
                                                              endAdornment: (0,
                                                              e.jsx)(
                                                                Bu,
                                                                M_(
                                                                  {
                                                                    position:
                                                                      "end",
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsx)(
                                                                        Rv,
                                                                        {}
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    );
                                                  },
                                                }),
                                                x &&
                                                (null == x
                                                  ? void 0
                                                  : x.length) > 0
                                                  ? (0, e.jsx)(
                                                      Qu,
                                                      M_(
                                                        {
                                                          disabled:
                                                            0 ===
                                                            (null == x
                                                              ? void 0
                                                              : x.length),
                                                          variant: "outlined",
                                                          startIcon: (0, e.jsx)(
                                                            Ev,
                                                            {}
                                                          ),
                                                          className:
                                                            "ST_CI_ClearCart_Btn",
                                                          onClick: function () {
                                                            return k();
                                                          },
                                                        },
                                                        {
                                                          children: N(
                                                            4 ===
                                                              (null == n
                                                                ? void 0
                                                                : n.activeTabIndex)
                                                              ? "productTable_clearCartBtn"
                                                              : "productTableCartClearButton"
                                                          ),
                                                        }
                                                      )
                                                    )
                                                  : null,
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        }),
                      (0, e.jsxs)(
                        Hp,
                        M_(
                          {
                            open: u,
                            onClose: function () {
                              return S();
                            },
                            fullWidth: !0,
                            maxWidth: "md",
                            className: "Dialog_Border_Radius",
                          },
                          {
                            children: [
                              (0, e.jsxs)("div", {
                                children: [
                                  (0, e.jsxs)(
                                    qa,
                                    M_(
                                      {
                                        container: !0,
                                        spacing: 2,
                                        className: "Product_Picker_Heading",
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            M_(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  M_(
                                                    { variant: Av, sx: Ko },
                                                    {
                                                      children: N(
                                                        "ST_CO_SearchProducts_Label"
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            M_(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                                pr: 1,
                                              },
                                              {
                                                children: (0, e.jsx)(Fg, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    S();
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    M_(
                                      { container: !0, spacing: 2, p: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            M_(
                                              {
                                                item: !0,
                                                xs: 10,
                                                md: 10,
                                                lg: 10,
                                                xl: 10,
                                              },
                                              {
                                                children: (0, e.jsxs)(
                                                  go,
                                                  M_(
                                                    {
                                                      className: "PT_SearchBox",
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(Ml, {
                                                          autoFocus: !0,
                                                          value: i,
                                                          onKeyDown: s,
                                                          onChange: function (
                                                            e
                                                          ) {
                                                            return c(e);
                                                          },
                                                          sx: {
                                                            ml: 2,
                                                            flex: 1,
                                                          },
                                                          placeholder: N(
                                                            "ST_CO_SearchProducts_Label"
                                                          ),
                                                          inputProps: {
                                                            "aria-label":
                                                              "searchProducts",
                                                          },
                                                        }),
                                                        (0, e.jsx)(
                                                          Jn,
                                                          M_(
                                                            {
                                                              onClick: a,
                                                              type: "button",
                                                              sx: { p: "10px" },
                                                              "aria-label":
                                                                "search",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Fg, {}),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            M_(
                                              {
                                                sx: {
                                                  display: "flex",
                                                  alignItems: "center",
                                                },
                                                item: !0,
                                                xs: 2,
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  Ym,
                                                  M_(
                                                    {
                                                      disabled: !i,
                                                      loading: m,
                                                      sx: {
                                                        textTransform:
                                                          "capitalize",
                                                      },
                                                      onClick: function () {
                                                        o();
                                                      },
                                                      variant: "contained",
                                                    },
                                                    {
                                                      children:
                                                        N("ST_CO_search"),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Gp,
                                    M_(
                                      { sx: { padding: "0px" } },
                                      {
                                        children: (0, e.jsx)(
                                          ep,
                                          M_(
                                            {
                                              className:
                                                "selectProductsProductTable",
                                              component: go,
                                              ref: D,
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                sp,
                                                M_(
                                                  {
                                                    stickyHeader: !0,
                                                    "aria-label":
                                                      "selectProductsProductTable",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hp, {
                                                        children: (0, e.jsx)(
                                                          Cp,
                                                          M_(
                                                            {
                                                              className:
                                                                "stickyHeaderRow",
                                                            },
                                                            {
                                                              children:
                                                                null == T
                                                                  ? void 0
                                                                  : T.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          M_(
                                                                            {
                                                                              align:
                                                                                "center",
                                                                              sx: (
                                                                                null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.hide
                                                                              )
                                                                                ? {
                                                                                    display:
                                                                                      "none",
                                                                                  }
                                                                                : {
                                                                                    display:
                                                                                      "table-cell",
                                                                                  },
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsxs)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      [
                                                                                        " ",
                                                                                        N(
                                                                                          t.name
                                                                                        ),
                                                                                        " ",
                                                                                      ],
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }
                                                          )
                                                        ),
                                                      }),
                                                      (0, e.jsx)(Dp, {
                                                        children:
                                                          0 !==
                                                          (null == p
                                                            ? void 0
                                                            : p.length)
                                                            ? (0, e.jsx)(
                                                                e.Fragment,
                                                                {
                                                                  children:
                                                                    null == p
                                                                      ? void 0
                                                                      : p.map(
                                                                          function (
                                                                            n,
                                                                            r
                                                                          ) {
                                                                            var o,
                                                                              a,
                                                                              i;
                                                                            return (null ===
                                                                              (o =
                                                                                null ==
                                                                                n
                                                                                  ? void 0
                                                                                  : n.variants) ||
                                                                            void 0 ===
                                                                              o
                                                                              ? void 0
                                                                              : o.length) >
                                                                              0
                                                                              ? (0,
                                                                                e.jsxs)(
                                                                                  t.Fragment,
                                                                                  {
                                                                                    children:
                                                                                      [
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Cp,
                                                                                          M_(
                                                                                            {
                                                                                              className:
                                                                                                "PT_TableRow_Padding",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  Op,
                                                                                                  M_(
                                                                                                    {
                                                                                                      colSpan:
                                                                                                        (
                                                                                                          null ==
                                                                                                          I
                                                                                                            ? void 0
                                                                                                            : I.PriceList
                                                                                                        )
                                                                                                          ? 4
                                                                                                          : 3,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          mn,
                                                                                                          M_(
                                                                                                            {
                                                                                                              display:
                                                                                                                "flex",
                                                                                                              alignItems:
                                                                                                                "center",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    tb,
                                                                                                                    {
                                                                                                                      disabled:
                                                                                                                        J(
                                                                                                                          n
                                                                                                                        ),
                                                                                                                      checked:
                                                                                                                        !!(null ==
                                                                                                                        v
                                                                                                                          ? void 0
                                                                                                                          : v.includes(
                                                                                                                              null ==
                                                                                                                                n
                                                                                                                                ? void 0
                                                                                                                                : n.productId
                                                                                                                            )),
                                                                                                                      onChange:
                                                                                                                        function (
                                                                                                                          e
                                                                                                                        ) {
                                                                                                                          return f(
                                                                                                                            e,
                                                                                                                            "isProduct",
                                                                                                                            n
                                                                                                                          );
                                                                                                                        },
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (null ==
                                                                                                                  n
                                                                                                                    ? void 0
                                                                                                                    : n.imageUrl) &&
                                                                                                                  0 !==
                                                                                                                    (null ===
                                                                                                                      (a =
                                                                                                                        null ==
                                                                                                                        n
                                                                                                                          ? void 0
                                                                                                                          : n.imageUrl) ||
                                                                                                                    void 0 ===
                                                                                                                      a
                                                                                                                      ? void 0
                                                                                                                      : a.length)
                                                                                                                    ? (0,
                                                                                                                      e.jsx)(
                                                                                                                        lb,
                                                                                                                        {
                                                                                                                          alt: "image",
                                                                                                                          src: n.imageUrl,
                                                                                                                          variant:
                                                                                                                            "rounded",
                                                                                                                        }
                                                                                                                      )
                                                                                                                    : (0,
                                                                                                                      e.jsx)(
                                                                                                                        lb,
                                                                                                                        M_(
                                                                                                                          {
                                                                                                                            alt: "image",
                                                                                                                            sx: {
                                                                                                                              bgcolor:
                                                                                                                                "white",
                                                                                                                              color:
                                                                                                                                "black",
                                                                                                                            },
                                                                                                                            variant:
                                                                                                                              "rounded",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Sb,
                                                                                                                                {
                                                                                                                                  sx: {
                                                                                                                                    fontSize:
                                                                                                                                      "3.1rem",
                                                                                                                                  },
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    mn,
                                                                                                                    M_(
                                                                                                                      {
                                                                                                                        sx: {
                                                                                                                          ml: 1,
                                                                                                                        },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          (null ==
                                                                                                                            n ||
                                                                                                                            n.title,
                                                                                                                          null ==
                                                                                                                          n
                                                                                                                            ? void 0
                                                                                                                            : n.title),
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        null ===
                                                                                          (i =
                                                                                            null ==
                                                                                            n
                                                                                              ? void 0
                                                                                              : n.variants) ||
                                                                                        void 0 ===
                                                                                          i
                                                                                          ? void 0
                                                                                          : i.map(
                                                                                              function (
                                                                                                t,
                                                                                                r
                                                                                              ) {
                                                                                                return (0,
                                                                                                e.jsxs)(
                                                                                                  Cp,
                                                                                                  M_(
                                                                                                    {
                                                                                                      sx: {
                                                                                                        whiteSpace:
                                                                                                          "nowrap",
                                                                                                        opacity:
                                                                                                          (
                                                                                                            null ==
                                                                                                            t
                                                                                                              ? void 0
                                                                                                              : t.availableForSale
                                                                                                          )
                                                                                                            ? 1
                                                                                                            : 0.7,
                                                                                                      },
                                                                                                      className:
                                                                                                        "PT_Variaant_TableRow",
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Op,
                                                                                                            M_(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "PT_Variaant_TableRow_Padding",
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    mn,
                                                                                                                    M_(
                                                                                                                      {
                                                                                                                        display:
                                                                                                                          "flex",
                                                                                                                        alignItems:
                                                                                                                          "center",
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            (0,
                                                                                                                            e.jsx)(
                                                                                                                              tb,
                                                                                                                              {
                                                                                                                                disabled:
                                                                                                                                  !(null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.availableForSale),
                                                                                                                                checked:
                                                                                                                                  null ==
                                                                                                                                  g
                                                                                                                                    ? void 0
                                                                                                                                    : g.some(
                                                                                                                                        function (
                                                                                                                                          e
                                                                                                                                        ) {
                                                                                                                                          return (
                                                                                                                                            (null ==
                                                                                                                                            e
                                                                                                                                              ? void 0
                                                                                                                                              : e.variantId) ===
                                                                                                                                            (null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.variantId)
                                                                                                                                          );
                                                                                                                                        }
                                                                                                                                      ),
                                                                                                                                onChange:
                                                                                                                                  function (
                                                                                                                                    e
                                                                                                                                  ) {
                                                                                                                                    return f(
                                                                                                                                      e,
                                                                                                                                      "isVariant",
                                                                                                                                      n,
                                                                                                                                      t
                                                                                                                                    );
                                                                                                                                  },
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            (0,
                                                                                                                            e.jsx)(
                                                                                                                              mn,
                                                                                                                              M_(
                                                                                                                                {
                                                                                                                                  sx: {
                                                                                                                                    ml: 2,
                                                                                                                                    whiteSpace:
                                                                                                                                      "pre-line",
                                                                                                                                  },
                                                                                                                                },
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    "Default Title" !==
                                                                                                                                    (null ==
                                                                                                                                    t
                                                                                                                                      ? void 0
                                                                                                                                      : t.title)
                                                                                                                                      ? null ==
                                                                                                                                        t
                                                                                                                                        ? void 0
                                                                                                                                        : t.title
                                                                                                                                      : null ==
                                                                                                                                        n
                                                                                                                                      ? void 0
                                                                                                                                      : n.title,
                                                                                                                                }
                                                                                                                              )
                                                                                                                            ),
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Op,
                                                                                                            M_(
                                                                                                              {
                                                                                                                align:
                                                                                                                  "center",
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  (
                                                                                                                    null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.availableForSale
                                                                                                                  )
                                                                                                                    ? t.quantityAvailable ||
                                                                                                                      0
                                                                                                                    : (0,
                                                                                                                      e.jsx)(
                                                                                                                        du,
                                                                                                                        {
                                                                                                                          label:
                                                                                                                            N(
                                                                                                                              "soldOut"
                                                                                                                            ),
                                                                                                                          sx: {
                                                                                                                            backgroundColor:
                                                                                                                              "#fff6c2",
                                                                                                                            borderColor:
                                                                                                                              "#f7eba2",
                                                                                                                          },
                                                                                                                        }
                                                                                                                      ),
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            Op,
                                                                                                            M_(
                                                                                                              {
                                                                                                                className:
                                                                                                                  "ST_White_Space",
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    d +
                                                                                                                      " ",
                                                                                                                    t.variantPrice ||
                                                                                                                      (0).toFixed(
                                                                                                                        2
                                                                                                                      ),
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  ),
                                                                                                  r
                                                                                                );
                                                                                              }
                                                                                            ),
                                                                                      ],
                                                                                  },
                                                                                  r
                                                                                )
                                                                              : "";
                                                                          }
                                                                        ),
                                                                }
                                                              )
                                                            : (0, e.jsx)(Cp, {
                                                                children: (0,
                                                                e.jsx)(
                                                                  Op,
                                                                  M_(
                                                                    {
                                                                      colSpan: 3,
                                                                      align:
                                                                        "center",
                                                                    },
                                                                    {
                                                                      children:
                                                                        m
                                                                          ? N(
                                                                              "productsLoading"
                                                                            )
                                                                          : N(
                                                                              "ST_CO_no_result_found_msg"
                                                                            ) +
                                                                            " " +
                                                                            i,
                                                                    }
                                                                  )
                                                                ),
                                                              }),
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }),
                              (0, e.jsxs)(
                                Jp,
                                M_(
                                  { className: "Product_Picker_Heading" },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        Qu,
                                        M_(
                                          {
                                            onClick: w,
                                            disabled: !(null == O
                                              ? void 0
                                              : O.hasPreviousPage),
                                            className: "Product_Picker_Footer",
                                          },
                                          {
                                            children: (0, e.jsx)(kb, {
                                              fontSize: "large",
                                            }),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        Qu,
                                        M_(
                                          {
                                            onClick: P,
                                            disabled: !(null == O
                                              ? void 0
                                              : O.hasNextPage),
                                            className: "Product_Picker_Footer",
                                          },
                                          {
                                            children: (0, e.jsx)(Pb, {
                                              fontSize: "large",
                                            }),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        Qu,
                                        M_(
                                          {
                                            disabled:
                                              0 ===
                                              (null == h ? void 0 : h.length),
                                            sx: { textTransform: "uppercase" },
                                            variant: "contained",
                                            onClick: function () {
                                              return b();
                                            },
                                          },
                                          { children: N("CreateOrder_doneBtn") }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                      (0, e.jsx)(
                        ep,
                        M_(
                          {
                            className: "selectedProductTable",
                            sx: { mt: 1 },
                            component: go,
                          },
                          {
                            children: (0, e.jsxs)(
                              sp,
                              M_(
                                {
                                  stickyHeader: !0,
                                  "aria-label": "selectedProductTable",
                                },
                                {
                                  children: [
                                    (0, e.jsx)(hp, {
                                      children: (0, e.jsx)(
                                        Cp,
                                        M_(
                                          { className: "stickyHeaderRow" },
                                          {
                                            children:
                                              4 ===
                                              (null == n
                                                ? void 0
                                                : n.activeTabIndex)
                                                ? x && x.length > 0
                                                  ? null == _
                                                    ? void 0
                                                    : _.map(function (t, n) {
                                                        return (0,
                                                        e.jsx)(Op, M_({ align: "center", sx: (null == t ? void 0 : t.hide) ? { display: "none" } : { display: "table-cell" } }, { children: (0, e.jsx)("b", { children: t.name ? N(t.name) : t.name }) }), n);
                                                      })
                                                  : ""
                                                : null == _
                                                ? void 0
                                                : _.map(function (t, n) {
                                                    return (0,
                                                    e.jsx)(Op, M_({ align: "center", sx: (null == t ? void 0 : t.hide) ? { display: "none" } : { display: "table-cell" } }, { children: (0, e.jsx)("b", { children: t.name ? N(t.name) : t.name }) }), n);
                                                  }),
                                          }
                                        )
                                      ),
                                    }),
                                    (0, e.jsxs)(Dp, {
                                      children: [
                                        x && (null == x ? void 0 : x.length) > 0
                                          ? (0, e.jsx)(e.Fragment, {
                                              children:
                                                null == x
                                                  ? void 0
                                                  : x.map(function (r, o) {
                                                      var a, i;
                                                      return (null ===
                                                        (a =
                                                          null == r
                                                            ? void 0
                                                            : r.variants) ||
                                                      void 0 === a
                                                        ? void 0
                                                        : a.length) > 0
                                                        ? (0, e.jsx)(
                                                            t.Fragment,
                                                            {
                                                              children:
                                                                null ===
                                                                  (i =
                                                                    null == r
                                                                      ? void 0
                                                                      : r.variants) ||
                                                                void 0 === i
                                                                  ? void 0
                                                                  : i.map(
                                                                      function (
                                                                        t,
                                                                        o
                                                                      ) {
                                                                        var a,
                                                                          i,
                                                                          s,
                                                                          l = ""
                                                                            .concat(
                                                                              null ==
                                                                                t
                                                                                ? void 0
                                                                                : t.variantId,
                                                                              " "
                                                                            )
                                                                            .concat(
                                                                              o
                                                                            );
                                                                        return (0,
                                                                        e.jsxs)(
                                                                          Cp,
                                                                          M_(
                                                                            {
                                                                              sx: {
                                                                                whiteSpace:
                                                                                  "nowrap",
                                                                              },
                                                                              className:
                                                                                "PT_Variaant_TableRow",
                                                                            },
                                                                            {
                                                                              children:
                                                                                [
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    M_(
                                                                                      {
                                                                                        className:
                                                                                          "PT_Variaant_TableRow_Padding",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          (0,
                                                                                          e.jsxs)(
                                                                                            mn,
                                                                                            M_(
                                                                                              {
                                                                                                display:
                                                                                                  "flex",
                                                                                                alignItems:
                                                                                                  "center",
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    (null ==
                                                                                                    r
                                                                                                      ? void 0
                                                                                                      : r.imageUrl) &&
                                                                                                    0 !==
                                                                                                      (null ===
                                                                                                        (a =
                                                                                                          null ==
                                                                                                          r
                                                                                                            ? void 0
                                                                                                            : r.imageUrl) ||
                                                                                                      void 0 ===
                                                                                                        a
                                                                                                        ? void 0
                                                                                                        : a.length)
                                                                                                      ? (0,
                                                                                                        e.jsx)(
                                                                                                          lb,
                                                                                                          {
                                                                                                            alt: "image",
                                                                                                            src: r.imageUrl,
                                                                                                            variant:
                                                                                                              "rounded",
                                                                                                          }
                                                                                                        )
                                                                                                      : (0,
                                                                                                        e.jsx)(
                                                                                                          lb,
                                                                                                          M_(
                                                                                                            {
                                                                                                              alt: "image",
                                                                                                              sx: {
                                                                                                                bgcolor:
                                                                                                                  "white",
                                                                                                                color:
                                                                                                                  "black",
                                                                                                              },
                                                                                                              variant:
                                                                                                                "rounded",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Sb,
                                                                                                                  {
                                                                                                                    sx: {
                                                                                                                      fontSize:
                                                                                                                        "3.1rem",
                                                                                                                    },
                                                                                                                  }
                                                                                                                ),
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      mn,
                                                                                                      M_(
                                                                                                        {
                                                                                                          sx: {
                                                                                                            ml: 2,
                                                                                                            whiteSpace:
                                                                                                              "pre-line",
                                                                                                          },
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            "Default Title" !==
                                                                                                            (null ==
                                                                                                            t
                                                                                                              ? void 0
                                                                                                              : t.title)
                                                                                                              ? null ==
                                                                                                                t
                                                                                                                ? void 0
                                                                                                                : t.title
                                                                                                              : null ==
                                                                                                                r
                                                                                                              ? void 0
                                                                                                              : r.title,
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                  ],
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    M_(
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.sku,
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    M_(
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.quantityAvailable ||
                                                                                          0,
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    M_(
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          ""
                                                                                            .concat(
                                                                                              d,
                                                                                              "  "
                                                                                            )
                                                                                            .concat(
                                                                                              t.variantPrice ||
                                                                                                (0).toFixed(
                                                                                                  2
                                                                                                )
                                                                                            ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  3 ===
                                                                                  (null ==
                                                                                  n
                                                                                    ? void 0
                                                                                    : n.activeTabIndex)
                                                                                    ? (0,
                                                                                      e.jsx)(
                                                                                        e.Fragment,
                                                                                        {}
                                                                                      )
                                                                                    : (0,
                                                                                      e.jsx)(
                                                                                        Op,
                                                                                        M_(
                                                                                          {
                                                                                            align:
                                                                                              "center",
                                                                                            className:
                                                                                              "Display_Alignment_Middle",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Gs,
                                                                                                M_(
                                                                                                  {
                                                                                                    arrow:
                                                                                                      !0,
                                                                                                    title:
                                                                                                      "Quantity",
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        "span",
                                                                                                        M_(
                                                                                                          {
                                                                                                            className:
                                                                                                              "Display_Alignment_Middle",
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Qu,
                                                                                                                  M_(
                                                                                                                    {
                                                                                                                      id: "decreaseQty",
                                                                                                                      onClick:
                                                                                                                        function () {
                                                                                                                          var e;
                                                                                                                          return C(
                                                                                                                            null ===
                                                                                                                              (e =
                                                                                                                                y[
                                                                                                                                  null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId
                                                                                                                                ]) ||
                                                                                                                              void 0 ===
                                                                                                                                e
                                                                                                                              ? void 0
                                                                                                                              : e.quantity,
                                                                                                                            null ==
                                                                                                                              t
                                                                                                                              ? void 0
                                                                                                                              : t.variantId,
                                                                                                                            "decreaseQty"
                                                                                                                          );
                                                                                                                        },
                                                                                                                      sx: X,
                                                                                                                      "aria-label":
                                                                                                                        "reduce",
                                                                                                                    },
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsx)(
                                                                                                                          wb,
                                                                                                                          {
                                                                                                                            fontSize:
                                                                                                                              "small",
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  )
                                                                                                                ),
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Hc,
                                                                                                                  {
                                                                                                                    InputProps:
                                                                                                                      {
                                                                                                                        inputProps:
                                                                                                                          {
                                                                                                                            className:
                                                                                                                              "ST_Custom_Number_Input",
                                                                                                                          },
                                                                                                                      },
                                                                                                                    value:
                                                                                                                      null ===
                                                                                                                        (i =
                                                                                                                          y[
                                                                                                                            null ==
                                                                                                                            t
                                                                                                                              ? void 0
                                                                                                                              : t.variantId
                                                                                                                          ]) ||
                                                                                                                      void 0 ===
                                                                                                                        i
                                                                                                                        ? void 0
                                                                                                                        : i.quantity,
                                                                                                                    sx: ee,
                                                                                                                    onKeyDown:
                                                                                                                      Nb,
                                                                                                                    name: "".concat(
                                                                                                                      null ==
                                                                                                                        t
                                                                                                                        ? void 0
                                                                                                                        : t.variantId
                                                                                                                    ),
                                                                                                                    variant:
                                                                                                                      "outlined",
                                                                                                                    size: "small",
                                                                                                                    type: "number",
                                                                                                                    error:
                                                                                                                      j[
                                                                                                                        null ==
                                                                                                                        t
                                                                                                                          ? void 0
                                                                                                                          : t.variantId
                                                                                                                      ] ||
                                                                                                                      !1,
                                                                                                                    onChange:
                                                                                                                      function (
                                                                                                                        e
                                                                                                                      ) {
                                                                                                                        return C(
                                                                                                                          e
                                                                                                                            .target
                                                                                                                            .value,
                                                                                                                          null ==
                                                                                                                            t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId,
                                                                                                                          "manual"
                                                                                                                        );
                                                                                                                      },
                                                                                                                  }
                                                                                                                ),
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Qu,
                                                                                                                  M_(
                                                                                                                    {
                                                                                                                      id: "increaseQty",
                                                                                                                      sx: X,
                                                                                                                      "aria-label":
                                                                                                                        "increase",
                                                                                                                      onClick:
                                                                                                                        function () {
                                                                                                                          var e;
                                                                                                                          return C(
                                                                                                                            null ===
                                                                                                                              (e =
                                                                                                                                y[
                                                                                                                                  null ==
                                                                                                                                  t
                                                                                                                                    ? void 0
                                                                                                                                    : t.variantId
                                                                                                                                ]) ||
                                                                                                                              void 0 ===
                                                                                                                                e
                                                                                                                              ? void 0
                                                                                                                              : e.quantity,
                                                                                                                            null ==
                                                                                                                              t
                                                                                                                              ? void 0
                                                                                                                              : t.variantId,
                                                                                                                            "increaseQty"
                                                                                                                          );
                                                                                                                        },
                                                                                                                    },
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsx)(
                                                                                                                          Ob,
                                                                                                                          {
                                                                                                                            fontSize:
                                                                                                                              "small",
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  )
                                                                                                                ),
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  3 ===
                                                                                  (null ==
                                                                                  n
                                                                                    ? void 0
                                                                                    : n.activeTabIndex)
                                                                                    ? (0,
                                                                                      e.jsxs)(
                                                                                        e.Fragment,
                                                                                        {
                                                                                          children:
                                                                                            [
                                                                                              "Product" ===
                                                                                              Z
                                                                                                ? (0,
                                                                                                  e.jsx)(
                                                                                                    Op,
                                                                                                    M_(
                                                                                                      {
                                                                                                        align:
                                                                                                          "center",
                                                                                                        className:
                                                                                                          "ST_White_Space",
                                                                                                      },
                                                                                                      {
                                                                                                        children:
                                                                                                          "Percentage" ===
                                                                                                          L
                                                                                                            ? (null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.commission) +
                                                                                                              "%"
                                                                                                            : d +
                                                                                                              " " +
                                                                                                              (null ===
                                                                                                                (s =
                                                                                                                  null ==
                                                                                                                  t
                                                                                                                    ? void 0
                                                                                                                    : t.commission) ||
                                                                                                              void 0 ===
                                                                                                                s
                                                                                                                ? void 0
                                                                                                                : s.toFixed(
                                                                                                                    2
                                                                                                                  )),
                                                                                                      }
                                                                                                    )
                                                                                                  )
                                                                                                : (0,
                                                                                                  e.jsx)(
                                                                                                    e.Fragment,
                                                                                                    {}
                                                                                                  ),
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Op,
                                                                                                M_(
                                                                                                  {
                                                                                                    align:
                                                                                                      "center",
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsxs)(
                                                                                                        e.Fragment,
                                                                                                        {
                                                                                                          children:
                                                                                                            [
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                Gs,
                                                                                                                M_(
                                                                                                                  {
                                                                                                                    TransitionComponent:
                                                                                                                      pb,
                                                                                                                    title:
                                                                                                                      null ==
                                                                                                                      t
                                                                                                                        ? void 0
                                                                                                                        : t.url,
                                                                                                                    arrow:
                                                                                                                      !0,
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        rl,
                                                                                                                        M_(
                                                                                                                          {
                                                                                                                            href:
                                                                                                                              null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.url,
                                                                                                                            target:
                                                                                                                              "_blank",
                                                                                                                            className:
                                                                                                                              "ST_link_FontColor",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              N(
                                                                                                                                "affiliate_product_link"
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                Gs,
                                                                                                                M_(
                                                                                                                  {
                                                                                                                    TransitionComponent:
                                                                                                                      pb,
                                                                                                                    title:
                                                                                                                      "#05bf05" ===
                                                                                                                      Q[
                                                                                                                        ""
                                                                                                                          .concat(
                                                                                                                            "productLink",
                                                                                                                            " "
                                                                                                                          )
                                                                                                                          .concat(
                                                                                                                            ""
                                                                                                                              .concat(
                                                                                                                                null ==
                                                                                                                                  t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantId,
                                                                                                                                " "
                                                                                                                              )
                                                                                                                              .concat(
                                                                                                                                o
                                                                                                                              ),
                                                                                                                            "}"
                                                                                                                          )
                                                                                                                      ]
                                                                                                                        ? N(
                                                                                                                            "affiliateLink_searchColumn8"
                                                                                                                          )
                                                                                                                        : N(
                                                                                                                            "affiliateLink_searchColumn7"
                                                                                                                          ),
                                                                                                                    arrow:
                                                                                                                      !0,
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Jn,
                                                                                                                        M_(
                                                                                                                          {
                                                                                                                            onClick:
                                                                                                                              function () {
                                                                                                                                var e;
                                                                                                                                z(
                                                                                                                                  null !==
                                                                                                                                    (e =
                                                                                                                                      null ==
                                                                                                                                      t
                                                                                                                                        ? void 0
                                                                                                                                        : t.url) &&
                                                                                                                                    void 0 !==
                                                                                                                                      e
                                                                                                                                    ? e
                                                                                                                                    : ""
                                                                                                                                ),
                                                                                                                                  B(
                                                                                                                                    o
                                                                                                                                  ),
                                                                                                                                  K
                                                                                                                                    ? q(
                                                                                                                                        null ==
                                                                                                                                          t
                                                                                                                                          ? void 0
                                                                                                                                          : t.url,
                                                                                                                                        ""
                                                                                                                                          .concat(
                                                                                                                                            "productLink",
                                                                                                                                            " "
                                                                                                                                          )
                                                                                                                                          .concat(
                                                                                                                                            ""
                                                                                                                                              .concat(
                                                                                                                                                null ==
                                                                                                                                                  t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.variantId,
                                                                                                                                                " "
                                                                                                                                              )
                                                                                                                                              .concat(
                                                                                                                                                o
                                                                                                                                              ),
                                                                                                                                            "}"
                                                                                                                                          )
                                                                                                                                      )
                                                                                                                                    : V();
                                                                                                                              },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Tb,
                                                                                                                                {
                                                                                                                                  style:
                                                                                                                                    {
                                                                                                                                      fontSize:
                                                                                                                                        "small",
                                                                                                                                      cursor:
                                                                                                                                        "pointer",
                                                                                                                                      color:
                                                                                                                                        Q[
                                                                                                                                          ""
                                                                                                                                            .concat(
                                                                                                                                              "productLink",
                                                                                                                                              " "
                                                                                                                                            )
                                                                                                                                            .concat(
                                                                                                                                              ""
                                                                                                                                                .concat(
                                                                                                                                                  null ==
                                                                                                                                                    t
                                                                                                                                                    ? void 0
                                                                                                                                                    : t.variantId,
                                                                                                                                                  " "
                                                                                                                                                )
                                                                                                                                                .concat(
                                                                                                                                                  o
                                                                                                                                                ),
                                                                                                                                              "}"
                                                                                                                                            )
                                                                                                                                        ],
                                                                                                                                    },
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                            ],
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                            ],
                                                                                        }
                                                                                      )
                                                                                    : (0,
                                                                                      e.jsx)(
                                                                                        e.Fragment,
                                                                                        {}
                                                                                      ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    M_(
                                                                                      {
                                                                                        align:
                                                                                          "center",
                                                                                        size: "medium",
                                                                                        sx: {
                                                                                          width:
                                                                                            "70px",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          A ===
                                                                                          l
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                Gs,
                                                                                                M_(
                                                                                                  {
                                                                                                    TransitionComponent:
                                                                                                      pb,
                                                                                                    title:
                                                                                                      N(
                                                                                                        "b2b_removeSelectedCustomer"
                                                                                                      ),
                                                                                                    placement:
                                                                                                      "bottom",
                                                                                                    arrow:
                                                                                                      !0,
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        Fg,
                                                                                                        {
                                                                                                          className:
                                                                                                            "ST_SC_Delete_Product_Icon",
                                                                                                          onMouseLeave:
                                                                                                            function () {
                                                                                                              return E(
                                                                                                                null
                                                                                                              );
                                                                                                            },
                                                                                                          onClick:
                                                                                                            function (
                                                                                                              e
                                                                                                            ) {
                                                                                                              f(
                                                                                                                e,
                                                                                                                "isVariant",
                                                                                                                r,
                                                                                                                t,
                                                                                                                !0
                                                                                                              );
                                                                                                            },
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                Ib,
                                                                                                {
                                                                                                  className:
                                                                                                    "ST_SC_Delete_Product_Icon",
                                                                                                  onMouseEnter:
                                                                                                    function () {
                                                                                                      return E(
                                                                                                        l
                                                                                                      );
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                ],
                                                                            }
                                                                          ),
                                                                          ""
                                                                            .concat(
                                                                              null ==
                                                                                t
                                                                                ? void 0
                                                                                : t.variantId,
                                                                              " "
                                                                            )
                                                                            .concat(
                                                                              o
                                                                            )
                                                                        );
                                                                      }
                                                                    ),
                                                            },
                                                            o
                                                          )
                                                        : null;
                                                    }),
                                            })
                                          : (0, e.jsx)(Cp, {
                                              children:
                                                4 !==
                                                  (null == n
                                                    ? void 0
                                                    : n.activeTabIndex) &&
                                                (0, e.jsx)(
                                                  Op,
                                                  M_(
                                                    {
                                                      align: "center",
                                                      colSpan:
                                                        3 ===
                                                        (null == n
                                                          ? void 0
                                                          : n.activeTabIndex)
                                                          ? 8
                                                          : 4,
                                                    },
                                                    {
                                                      children: m
                                                        ? N("productsLoading")
                                                        : (0, e.jsxs)(
                                                            "div",
                                                            M_(
                                                              {
                                                                style: {
                                                                  marginTop:
                                                                    "15px",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    ni,
                                                                    M_(
                                                                      {
                                                                        variant:
                                                                          Av,
                                                                        sx: Ko,
                                                                      },
                                                                      {
                                                                        children:
                                                                          N(
                                                                            "createOrder_productTable_NoProductsAdded"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Qu,
                                                                    M_(
                                                                      {
                                                                        sx: {
                                                                          mt: 1,
                                                                          mb: 2,
                                                                          textTransform:
                                                                            "capitalize",
                                                                        },
                                                                        onClick:
                                                                          function () {
                                                                            return l();
                                                                          },
                                                                        variant:
                                                                          "contained",
                                                                      },
                                                                      {
                                                                        children:
                                                                          N(
                                                                            "createOrder_AddProduct"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                    }
                                                  )
                                                ),
                                            }),
                                        H &&
                                          (0, e.jsx)(I_, {
                                            closeModal: V,
                                            popUpType: "affiliatePopUp",
                                            openPopUp: !0,
                                            CallMethod: W,
                                            uniqueLink: U,
                                            affiliateLinkType: ""
                                              .concat("productLink", " ")
                                              .concat($),
                                          }),
                                      ],
                                    }),
                                  ],
                                }
                              )
                            ),
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
              Y(F, M),
            ],
          })
        );
      }
      var N_ = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M9.04 21.54c.96.29 1.93.46 2.96.46a10 10 0 0 0 10-10A10 10 0 0 0 12 2 10 10 0 0 0 2 12c0 4.25 2.67 7.9 6.44 9.34-.09-.78-.18-2.07 0-2.96l1.15-4.94s-.29-.58-.29-1.5c0-1.38.86-2.41 1.84-2.41.86 0 1.26.63 1.26 1.44 0 .86-.57 2.09-.86 3.27-.17.98.52 1.84 1.52 1.84 1.78 0 3.16-1.9 3.16-4.58 0-2.4-1.72-4.04-4.19-4.04-2.82 0-4.48 2.1-4.48 4.31 0 .86.28 1.73.74 2.3.09.06.09.14.06.29l-.29 1.09c0 .17-.11.23-.28.11-1.28-.56-2.02-2.38-2.02-3.85 0-3.16 2.24-6.03 6.56-6.03 3.44 0 6.12 2.47 6.12 5.75 0 3.44-2.13 6.2-5.18 6.2-.97 0-1.92-.52-2.26-1.13l-.67 2.37c-.23.86-.86 2.01-1.29 2.7v-.03z",
          }),
          "Pinterest"
        ),
        D_ = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M7.8 2h8.4C19.4 2 22 4.6 22 7.8v8.4a5.8 5.8 0 0 1-5.8 5.8H7.8C4.6 22 2 19.4 2 16.2V7.8A5.8 5.8 0 0 1 7.8 2m-.2 2A3.6 3.6 0 0 0 4 7.6v8.8C4 18.39 5.61 20 7.6 20h8.8a3.6 3.6 0 0 0 3.6-3.6V7.6C20 5.61 18.39 4 16.4 4H7.6m9.65 1.5a1.25 1.25 0 0 1 1.25 1.25A1.25 1.25 0 0 1 17.25 8 1.25 1.25 0 0 1 16 6.75a1.25 1.25 0 0 1 1.25-1.25M12 7a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5m0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3z",
          }),
          "Instagram"
        ),
        A_ = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z",
          }),
          "Twitter"
        ),
        E_ = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m13 2h-2.5A3.5 3.5 0 0 0 12 8.5V11h-2v3h2v7h3v-7h3v-3h-3V9a1 1 0 0 1 1-1h2V5z",
          }),
          "Facebook"
        ),
        R_ = function () {
          return (
            (R_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            R_.apply(this, arguments)
          );
        },
        L_ = function (t) {
          return (0, e.jsxs)(
            "div",
            R_(
              { className: "ST-Icons", style: { marginTop: "1rem" } },
              {
                children: [
                  (0, e.jsx)(
                    rl,
                    R_(
                      {
                        target: "_blank",
                        href:
                          "http://pinterest.com/pin/create/bookmarklet/?is_video=false&url=" +
                          t.url,
                      },
                      {
                        children: (0, e.jsx)(N_, {
                          sx: { mr: 2, color: "#d01313" },
                        }),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    rl,
                    R_(
                      {
                        target: "_blank",
                        href: "https://www.instagram.com/###?ref=" + t.url,
                      },
                      {
                        children: (0, e.jsx)(D_, {
                          sx: { mr: 2, color: "#c54e63" },
                        }),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    rl,
                    R_(
                      {
                        target: "_blank",
                        href: "https://twitter.com/share?url=" + t.url,
                      },
                      {
                        children: (0, e.jsx)(A_, {
                          sx: { mr: 2, color: "#00a7eb" },
                        }),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    rl,
                    R_(
                      {
                        target: "_blank",
                        href: "http://www.facebook.com/sharer.php?u=" + t.url,
                      },
                      {
                        children: (0, e.jsx)(E_, {
                          sx: { mr: 2, color: "#00007e" },
                        }),
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        B_ = function () {
          return (
            (B_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            B_.apply(this, arguments)
          );
        };
      function z_(n) {
        var r = xb(n),
          o = r.handleSearchProductData,
          a = r.makeFieldsEmpty,
          i = r.productSearchText,
          s = r.handleKeyDown,
          l = r.handleProductTableSearchPopup,
          d = r.shopCurrency,
          c = r.handleSearchTextChange,
          u = r.searchTablePopupOpen,
          p = r.productsArray,
          m = r.getProductsLoading,
          h = r.selectedProductArray,
          f = r.checkUncheckProductVariant,
          g = r.selectedVariantArray,
          v = r.selectedProductIdArray,
          b = r.showSelectedProduct,
          _ = r.netQuantitySubtotal,
          y = r.updateNetQuantitySubtotal,
          C = r.finalSelectedProducts,
          x = r.closePopupForSearchProductData,
          S = r.removeAllSelectedProducts,
          k = r.handleNextClick,
          P = r.handlePrevClick,
          w = r.pageInfo,
          O = r.selectFeatures,
          T = r.handleAlertMsgClose,
          I = r.isQuantityError,
          M = r.t,
          j = r.tableContainerRef,
          N = gb(),
          D = N.commissionDiscountType,
          A = N.setSelectedProductIndex,
          E = N.setSelectedProductLink,
          R = N.affiliateAlertMsg,
          L = N.commissionOn,
          B = xv(),
          z = B.copyTextFunction,
          F = B.copyIconSuccessColor,
          Z = B.SnackbarAlertMsg,
          H = B.disableTableRow,
          V = {
            background: "#F2F2F2",
            border: "1px solid #E0E0E0",
            color: "gray",
            minWidth: "40px !important",
          },
          W = { width: "50px", m: "5px", textAlign: "center" };
        return (
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.openSearchProducts) && l(),
                (null == n ? void 0 : n.isRemoveSelectedProduct) && S();
            },
            [n]
          ),
          (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(
                mn,
                B_(
                  { pt: 1 },
                  {
                    children: [
                      3 === (null == n ? void 0 : n.activeTabIndex) &&
                        (0, e.jsxs)(e.Fragment, {
                          children: [
                            (0, e.jsx)(
                              "div",
                              B_(
                                { className: "headingDivider" },
                                {
                                  children: (0, e.jsx)(
                                    Gt,
                                    B_(
                                      {
                                        textAlign: "left",
                                        className: "PT_Search_Text_Divider",
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          ni,
                                          B_(
                                            { variant: Av, sx: Ko },
                                            {
                                              children: M(
                                                "createOrder_select_product"
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                            (0, e.jsxs)(
                              "div",
                              B_(
                                { className: "ST_ProductTableSearchBar" },
                                {
                                  children: [
                                    (0, e.jsx)(ju, {
                                      id: "free-solo-demo",
                                      freeSolo: !0,
                                      inputValue: "",
                                      className: "ST_SearchBar",
                                      sx: {
                                        ml: 1,
                                        flex: 1,
                                        "& .MuiOutlinedInput-root": {
                                          border: "none",
                                          background: "white",
                                          "& fieldset": { border: "none" },
                                          "&:hover fieldset": {
                                            border: "none",
                                          },
                                          "&.Mui-focused fieldset": {
                                            border: "none",
                                          },
                                          boxShadow:
                                            "0px 2px 4px rgba(0,0,0,0.1)",
                                        },
                                      },
                                      options: [],
                                      renderInput: function (t) {
                                        return (0, e.jsx)(
                                          Hc,
                                          B_(
                                            {
                                              placeholder: M(
                                                "ST_CO_SearchProducts_Label"
                                              ),
                                            },
                                            t,
                                            {
                                              onClick: function () {
                                                l();
                                              },
                                              className: "ST_SearchBar",
                                              InputProps: B_(
                                                B_({}, t.InputProps),
                                                {
                                                  endAdornment: (0, e.jsx)(
                                                    Bu,
                                                    B_(
                                                      {
                                                        position: "end",
                                                        sx: {
                                                          mr: 0,
                                                          p: "15px",
                                                        },
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          Rv,
                                                          {}
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              ),
                                            }
                                          )
                                        );
                                      },
                                      size: "medium",
                                    }),
                                    C && (null == C ? void 0 : C.length) > 0
                                      ? (0, e.jsx)(
                                          Qu,
                                          B_(
                                            {
                                              disabled:
                                                0 ===
                                                (null == C ? void 0 : C.length),
                                              variant: "outlined",
                                              startIcon: (0, e.jsx)(Ev, {}),
                                              sx: {
                                                mt: 1,
                                                mb: 2,
                                                textTransform: "capitalize",
                                              },
                                              onClick: function () {
                                                return S();
                                              },
                                            },
                                            {
                                              children: M(
                                                4 ===
                                                  (null == n
                                                    ? void 0
                                                    : n.activeTabIndex)
                                                  ? "productTable_clearCartBtn"
                                                  : "productTableCartClearButton"
                                              ),
                                            }
                                          )
                                        )
                                      : null,
                                  ],
                                }
                              )
                            ),
                          ],
                        }),
                      (0, e.jsxs)(
                        Hp,
                        B_(
                          {
                            open: u,
                            onClose: function () {
                              return x();
                            },
                            fullWidth: !0,
                            maxWidth: "md",
                            className: "Dialog_Border_Radius",
                          },
                          {
                            children: [
                              (0, e.jsxs)("div", {
                                children: [
                                  (0, e.jsxs)(
                                    qa,
                                    B_(
                                      {
                                        container: !0,
                                        spacing: 2,
                                        className: "Product_Picker_Heading",
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            B_(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  B_(
                                                    { variant: Av, sx: Ko },
                                                    {
                                                      children: M(
                                                        "ST_CO_SearchProducts_Label"
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            B_(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                                pr: 1,
                                              },
                                              {
                                                children: (0, e.jsx)(Fg, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    x();
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    B_(
                                      { container: !0, p: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            B_(
                                              {
                                                item: !0,
                                                xs: 8,
                                                md: 10,
                                                lg: 10,
                                                xl: 10,
                                              },
                                              {
                                                children: (0, e.jsxs)(
                                                  go,
                                                  B_(
                                                    {
                                                      className: "PT_SearchBox",
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(Ml, {
                                                          autoFocus: !0,
                                                          value: i,
                                                          onKeyDown: s,
                                                          onChange: function (
                                                            e
                                                          ) {
                                                            return c(e);
                                                          },
                                                          sx: {
                                                            ml: 2,
                                                            flex: 1,
                                                          },
                                                          placeholder: M(
                                                            "ST_CO_SearchProducts_Label"
                                                          ),
                                                          inputProps: {
                                                            "aria-label":
                                                              "searchProducts",
                                                          },
                                                        }),
                                                        (0, e.jsx)(
                                                          Jn,
                                                          B_(
                                                            {
                                                              onClick: a,
                                                              type: "button",
                                                              sx: { p: "10px" },
                                                              "aria-label":
                                                                "search",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Fg, {}),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            B_(
                                              {
                                                sx: {
                                                  display: "flex",
                                                  alignItems: "center",
                                                  justifyContent: "end",
                                                },
                                                item: !0,
                                                xs: 4,
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  Ym,
                                                  B_(
                                                    {
                                                      disabled: !i,
                                                      loading: m,
                                                      sx: {
                                                        textTransform:
                                                          "capitalize",
                                                      },
                                                      onClick: function () {
                                                        o();
                                                      },
                                                      variant: "contained",
                                                    },
                                                    {
                                                      children:
                                                        M("ST_CO_search"),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    Gp,
                                    B_(
                                      { sx: { padding: "0px" } },
                                      {
                                        children: (0, e.jsx)(
                                          ep,
                                          B_(
                                            {
                                              className:
                                                "selectProductsProductTable",
                                              component: go,
                                              ref: j,
                                            },
                                            {
                                              children: (0, e.jsx)(
                                                sp,
                                                B_(
                                                  {
                                                    stickyHeader: !0,
                                                    "aria-label":
                                                      "selectProductsProductTable",
                                                  },
                                                  {
                                                    children:
                                                      0 !==
                                                      (null == p
                                                        ? void 0
                                                        : p.length)
                                                        ? (0, e.jsx)(
                                                            e.Fragment,
                                                            {
                                                              children:
                                                                null == p
                                                                  ? void 0
                                                                  : p.map(
                                                                      function (
                                                                        n,
                                                                        r
                                                                      ) {
                                                                        var o,
                                                                          a,
                                                                          i;
                                                                        return (null ===
                                                                          (o =
                                                                            null ==
                                                                            n
                                                                              ? void 0
                                                                              : n.variants) ||
                                                                        void 0 ===
                                                                          o
                                                                          ? void 0
                                                                          : o.length) >
                                                                          0
                                                                          ? (0,
                                                                            e.jsx)(
                                                                              Dp,
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    t.Fragment,
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Cp,
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  Op,
                                                                                                  B_(
                                                                                                    {
                                                                                                      className:
                                                                                                        "New_PT_Header",
                                                                                                      colSpan:
                                                                                                        (
                                                                                                          null ==
                                                                                                          O
                                                                                                            ? void 0
                                                                                                            : O.PriceList
                                                                                                        )
                                                                                                          ? 4
                                                                                                          : 3,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          mn,
                                                                                                          B_(
                                                                                                            {
                                                                                                              display:
                                                                                                                "flex",
                                                                                                              alignItems:
                                                                                                                "center",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    tb,
                                                                                                                    {
                                                                                                                      disabled:
                                                                                                                        H(
                                                                                                                          n
                                                                                                                        ),
                                                                                                                      checked:
                                                                                                                        !!(null ==
                                                                                                                        v
                                                                                                                          ? void 0
                                                                                                                          : v.includes(
                                                                                                                              null ==
                                                                                                                                n
                                                                                                                                ? void 0
                                                                                                                                : n.productId
                                                                                                                            )),
                                                                                                                      onChange:
                                                                                                                        function (
                                                                                                                          e
                                                                                                                        ) {
                                                                                                                          return f(
                                                                                                                            e,
                                                                                                                            "isProduct",
                                                                                                                            n
                                                                                                                          );
                                                                                                                        },
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (null ==
                                                                                                                  n
                                                                                                                    ? void 0
                                                                                                                    : n.imageUrl) &&
                                                                                                                  0 !==
                                                                                                                    (null ===
                                                                                                                      (a =
                                                                                                                        null ==
                                                                                                                        n
                                                                                                                          ? void 0
                                                                                                                          : n.imageUrl) ||
                                                                                                                    void 0 ===
                                                                                                                      a
                                                                                                                      ? void 0
                                                                                                                      : a.length)
                                                                                                                    ? (0,
                                                                                                                      e.jsx)(
                                                                                                                        lb,
                                                                                                                        {
                                                                                                                          alt: "image",
                                                                                                                          src: n.imageUrl,
                                                                                                                          variant:
                                                                                                                            "rounded",
                                                                                                                        }
                                                                                                                      )
                                                                                                                    : (0,
                                                                                                                      e.jsx)(
                                                                                                                        lb,
                                                                                                                        B_(
                                                                                                                          {
                                                                                                                            alt: "image",
                                                                                                                            sx: {
                                                                                                                              bgcolor:
                                                                                                                                "white",
                                                                                                                              color:
                                                                                                                                "black",
                                                                                                                            },
                                                                                                                            variant:
                                                                                                                              "rounded",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Sb,
                                                                                                                                {
                                                                                                                                  sx: {
                                                                                                                                    fontSize:
                                                                                                                                      "3.1rem",
                                                                                                                                  },
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    mn,
                                                                                                                    B_(
                                                                                                                      {
                                                                                                                        sx: {
                                                                                                                          ml: 1,
                                                                                                                        },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          (null ==
                                                                                                                            n ||
                                                                                                                            n.title,
                                                                                                                          null ==
                                                                                                                          n
                                                                                                                            ? void 0
                                                                                                                            : n.title),
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            }
                                                                                          ),
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Cp,
                                                                                            B_(
                                                                                              {
                                                                                                sx: {
                                                                                                  whiteSpace:
                                                                                                    "nowrap",
                                                                                                },
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  null ===
                                                                                                    (i =
                                                                                                      null ==
                                                                                                      n
                                                                                                        ? void 0
                                                                                                        : n.variants) ||
                                                                                                  void 0 ===
                                                                                                    i
                                                                                                    ? void 0
                                                                                                    : i.map(
                                                                                                        function (
                                                                                                          t,
                                                                                                          r
                                                                                                        ) {
                                                                                                          return (0,
                                                                                                          e.jsxs)(
                                                                                                            e.Fragment,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    "div",
                                                                                                                    B_(
                                                                                                                      {
                                                                                                                        className:
                                                                                                                          "Popup_PT_TableCell",
                                                                                                                        style:
                                                                                                                          {
                                                                                                                            margin:
                                                                                                                              "10px 15px",
                                                                                                                            opacity:
                                                                                                                              (
                                                                                                                                null ==
                                                                                                                                t
                                                                                                                                  ? void 0
                                                                                                                                  : t.availableForSale
                                                                                                                              )
                                                                                                                                ? 1
                                                                                                                                : 0.7,
                                                                                                                          },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            (0,
                                                                                                                            e.jsx)(
                                                                                                                              Cp,
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  (0,
                                                                                                                                  e.jsx)(
                                                                                                                                    Op,
                                                                                                                                    B_(
                                                                                                                                      {
                                                                                                                                        colSpan: 2,
                                                                                                                                      },
                                                                                                                                      {
                                                                                                                                        children:
                                                                                                                                          (0,
                                                                                                                                          e.jsxs)(
                                                                                                                                            mn,
                                                                                                                                            B_(
                                                                                                                                              {
                                                                                                                                                display:
                                                                                                                                                  "flex",
                                                                                                                                                alignItems:
                                                                                                                                                  "center",
                                                                                                                                              },
                                                                                                                                              {
                                                                                                                                                children:
                                                                                                                                                  [
                                                                                                                                                    (0,
                                                                                                                                                    e.jsx)(
                                                                                                                                                      tb,
                                                                                                                                                      {
                                                                                                                                                        disabled:
                                                                                                                                                          !(null ==
                                                                                                                                                          t
                                                                                                                                                            ? void 0
                                                                                                                                                            : t.availableForSale),
                                                                                                                                                        checked:
                                                                                                                                                          null ==
                                                                                                                                                          g
                                                                                                                                                            ? void 0
                                                                                                                                                            : g.some(
                                                                                                                                                                function (
                                                                                                                                                                  e
                                                                                                                                                                ) {
                                                                                                                                                                  return (
                                                                                                                                                                    (null ==
                                                                                                                                                                    e
                                                                                                                                                                      ? void 0
                                                                                                                                                                      : e.variantId) ===
                                                                                                                                                                    (null ==
                                                                                                                                                                    t
                                                                                                                                                                      ? void 0
                                                                                                                                                                      : t.variantId)
                                                                                                                                                                  );
                                                                                                                                                                }
                                                                                                                                                              ),
                                                                                                                                                        onChange:
                                                                                                                                                          function (
                                                                                                                                                            e
                                                                                                                                                          ) {
                                                                                                                                                            return f(
                                                                                                                                                              e,
                                                                                                                                                              "isVariant",
                                                                                                                                                              n,
                                                                                                                                                              t
                                                                                                                                                            );
                                                                                                                                                          },
                                                                                                                                                      }
                                                                                                                                                    ),
                                                                                                                                                    (0,
                                                                                                                                                    e.jsx)(
                                                                                                                                                      mn,
                                                                                                                                                      B_(
                                                                                                                                                        {
                                                                                                                                                          sx: {
                                                                                                                                                            ml: 2,
                                                                                                                                                            whiteSpace:
                                                                                                                                                              "pre-line",
                                                                                                                                                          },
                                                                                                                                                        },
                                                                                                                                                        {
                                                                                                                                                          children:
                                                                                                                                                            "Default Title" !==
                                                                                                                                                            (null ==
                                                                                                                                                            t
                                                                                                                                                              ? void 0
                                                                                                                                                              : t.title)
                                                                                                                                                              ? null ==
                                                                                                                                                                t
                                                                                                                                                                ? void 0
                                                                                                                                                                : t.title
                                                                                                                                                              : null ==
                                                                                                                                                                n
                                                                                                                                                              ? void 0
                                                                                                                                                              : n.title,
                                                                                                                                                        }
                                                                                                                                                      )
                                                                                                                                                    ),
                                                                                                                                                  ],
                                                                                                                                              }
                                                                                                                                            )
                                                                                                                                          ),
                                                                                                                                      }
                                                                                                                                    )
                                                                                                                                  ),
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            (0,
                                                                                                                            e.jsxs)(
                                                                                                                              Cp,
                                                                                                                              B_(
                                                                                                                                {
                                                                                                                                  className:
                                                                                                                                    "Popup_PT_Sub_TableCell",
                                                                                                                                },
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    [
                                                                                                                                      (0,
                                                                                                                                      e.jsxs)(
                                                                                                                                        Op,
                                                                                                                                        B_(
                                                                                                                                          {
                                                                                                                                            className:
                                                                                                                                              "ST_White_Space",
                                                                                                                                          },
                                                                                                                                          {
                                                                                                                                            children:
                                                                                                                                              [
                                                                                                                                                (0,
                                                                                                                                                e.jsxs)(
                                                                                                                                                  "b",
                                                                                                                                                  {
                                                                                                                                                    children:
                                                                                                                                                      [
                                                                                                                                                        M(
                                                                                                                                                          "ST_Producttable_retailPrice"
                                                                                                                                                        ),
                                                                                                                                                        " : ",
                                                                                                                                                      ],
                                                                                                                                                  }
                                                                                                                                                ),
                                                                                                                                                d +
                                                                                                                                                  " ",
                                                                                                                                                t.variantPrice ||
                                                                                                                                                  (0).toFixed(
                                                                                                                                                    2
                                                                                                                                                  ),
                                                                                                                                              ],
                                                                                                                                          }
                                                                                                                                        )
                                                                                                                                      ),
                                                                                                                                      (0,
                                                                                                                                      e.jsxs)(
                                                                                                                                        Op,
                                                                                                                                        B_(
                                                                                                                                          {
                                                                                                                                            align:
                                                                                                                                              "center",
                                                                                                                                          },
                                                                                                                                          {
                                                                                                                                            children:
                                                                                                                                              [
                                                                                                                                                (0,
                                                                                                                                                e.jsxs)(
                                                                                                                                                  "b",
                                                                                                                                                  {
                                                                                                                                                    children:
                                                                                                                                                      [
                                                                                                                                                        M(
                                                                                                                                                          "customerInvoice_ProductTableColumnInventory"
                                                                                                                                                        ),
                                                                                                                                                        " : ",
                                                                                                                                                      ],
                                                                                                                                                  }
                                                                                                                                                ),
                                                                                                                                                (
                                                                                                                                                  null ==
                                                                                                                                                  t
                                                                                                                                                    ? void 0
                                                                                                                                                    : t.availableForSale
                                                                                                                                                )
                                                                                                                                                  ? t.quantityAvailable ||
                                                                                                                                                    0
                                                                                                                                                  : (0,
                                                                                                                                                    e.jsx)(
                                                                                                                                                      du,
                                                                                                                                                      {
                                                                                                                                                        label:
                                                                                                                                                          M(
                                                                                                                                                            "soldOut"
                                                                                                                                                          ),
                                                                                                                                                        sx: {
                                                                                                                                                          backgroundColor:
                                                                                                                                                            "#fff6c2",
                                                                                                                                                          borderColor:
                                                                                                                                                            "#f7eba2",
                                                                                                                                                        },
                                                                                                                                                      }
                                                                                                                                                    ),
                                                                                                                                              ],
                                                                                                                                          }
                                                                                                                                        )
                                                                                                                                      ),
                                                                                                                                    ],
                                                                                                                                }
                                                                                                                              )
                                                                                                                            ),
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    "hr",
                                                                                                                    {}
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          );
                                                                                                        }
                                                                                                      ),
                                                                                              }
                                                                                            ),
                                                                                            r
                                                                                          ),
                                                                                        ],
                                                                                    },
                                                                                    r
                                                                                  ),
                                                                              }
                                                                            )
                                                                          : "";
                                                                      }
                                                                    ),
                                                            }
                                                          )
                                                        : (0, e.jsx)(Dp, {
                                                            children: (0,
                                                            e.jsx)(Cp, {
                                                              children: (0,
                                                              e.jsx)(
                                                                Op,
                                                                B_(
                                                                  {
                                                                    colSpan: 3,
                                                                    align:
                                                                      "center",
                                                                  },
                                                                  {
                                                                    children: m
                                                                      ? M(
                                                                          "productsLoading"
                                                                        )
                                                                      : M(
                                                                          "ST_CO_no_result_found_msg"
                                                                        ) +
                                                                        " " +
                                                                        i,
                                                                  }
                                                                )
                                                              ),
                                                            }),
                                                          }),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }),
                              (0, e.jsxs)(
                                Jp,
                                B_(
                                  { className: "Product_Picker_Heading" },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        Qu,
                                        B_(
                                          {
                                            onClick: P,
                                            disabled: !(null == w
                                              ? void 0
                                              : w.hasPreviousPage),
                                            className: "Product_Picker_Footer",
                                          },
                                          {
                                            children: (0, e.jsx)(kb, {
                                              fontSize: "large",
                                            }),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        Qu,
                                        B_(
                                          {
                                            onClick: k,
                                            disabled: !(null == w
                                              ? void 0
                                              : w.hasNextPage),
                                            className: "Product_Picker_Footer",
                                          },
                                          {
                                            children: (0, e.jsx)(Pb, {
                                              fontSize: "large",
                                            }),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        Qu,
                                        B_(
                                          {
                                            disabled:
                                              0 ===
                                              (null == h ? void 0 : h.length),
                                            sx: { textTransform: "uppercase" },
                                            variant: "contained",
                                            onClick: function () {
                                              return b();
                                            },
                                          },
                                          { children: M("CreateOrder_doneBtn") }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                      C &&
                        (null == C ? void 0 : C.length) > 0 &&
                        (0, e.jsx)(e.Fragment, {
                          children: (0, e.jsx)(
                            ep,
                            B_(
                              {
                                className: "selectedProductTable",
                                sx: { mt: 3 },
                                component: go,
                              },
                              {
                                children: (0, e.jsx)(
                                  sp,
                                  B_(
                                    {
                                      stickyHeader: !0,
                                      "aria-label": "selectedProductTable",
                                    },
                                    {
                                      children:
                                        C && (null == C ? void 0 : C.length) > 0
                                          ? (0, e.jsx)(e.Fragment, {
                                              children:
                                                null == C
                                                  ? void 0
                                                  : C.map(function (r, o) {
                                                      var a, i, s;
                                                      return (null ===
                                                        (a =
                                                          null == r
                                                            ? void 0
                                                            : r.variants) ||
                                                      void 0 === a
                                                        ? void 0
                                                        : a.length) > 0
                                                        ? (0, e.jsxs)(
                                                            e.Fragment,
                                                            {
                                                              children: [
                                                                (0, e.jsx)(
                                                                  Dp,
                                                                  B_(
                                                                    {
                                                                      className:
                                                                        "PT_Product_Table_Body",
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsxs)(
                                                                          t.Fragment,
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Cp,
                                                                                  B_(
                                                                                    {
                                                                                      className:
                                                                                        "iPadTableRowDisplay",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          B_(
                                                                                            {
                                                                                              className:
                                                                                                "New_PT_Header iPadTableCellDisplay",
                                                                                              colSpan:
                                                                                                3 ===
                                                                                                (null ==
                                                                                                n
                                                                                                  ? void 0
                                                                                                  : n.activeTabIndex)
                                                                                                  ? 7
                                                                                                  : 6,
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  mn,
                                                                                                  B_(
                                                                                                    {
                                                                                                      display:
                                                                                                        "flex",
                                                                                                      alignItems:
                                                                                                        "center",
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            tb,
                                                                                                            {
                                                                                                              checked:
                                                                                                                null ==
                                                                                                                v
                                                                                                                  ? void 0
                                                                                                                  : v.includes(
                                                                                                                      r.productId
                                                                                                                    ),
                                                                                                              onChange:
                                                                                                                function (
                                                                                                                  e
                                                                                                                ) {
                                                                                                                  return f(
                                                                                                                    e,
                                                                                                                    "isProduct",
                                                                                                                    r,
                                                                                                                    void 0,
                                                                                                                    !0
                                                                                                                  );
                                                                                                                },
                                                                                                            }
                                                                                                          ),
                                                                                                          (null ==
                                                                                                          r
                                                                                                            ? void 0
                                                                                                            : r.imageUrl) &&
                                                                                                          0 !==
                                                                                                            (null ===
                                                                                                              (i =
                                                                                                                null ==
                                                                                                                r
                                                                                                                  ? void 0
                                                                                                                  : r.imageUrl) ||
                                                                                                            void 0 ===
                                                                                                              i
                                                                                                              ? void 0
                                                                                                              : i.length)
                                                                                                            ? (0,
                                                                                                              e.jsx)(
                                                                                                                lb,
                                                                                                                {
                                                                                                                  alt: "image",
                                                                                                                  src:
                                                                                                                    null ==
                                                                                                                    r
                                                                                                                      ? void 0
                                                                                                                      : r.imageUrl,
                                                                                                                  variant:
                                                                                                                    "rounded",
                                                                                                                }
                                                                                                              )
                                                                                                            : (0,
                                                                                                              e.jsx)(
                                                                                                                lb,
                                                                                                                B_(
                                                                                                                  {
                                                                                                                    alt: "image",
                                                                                                                    sx: {
                                                                                                                      bgcolor:
                                                                                                                        "white",
                                                                                                                      color:
                                                                                                                        "black",
                                                                                                                    },
                                                                                                                    variant:
                                                                                                                      "rounded",
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Sb,
                                                                                                                        {
                                                                                                                          sx: {
                                                                                                                            fontSize:
                                                                                                                              "3.1rem",
                                                                                                                          },
                                                                                                                        }
                                                                                                                      ),
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            mn,
                                                                                                            B_(
                                                                                                              {
                                                                                                                sx: {
                                                                                                                  ml: 1,
                                                                                                                },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  (null ==
                                                                                                                    r ||
                                                                                                                    r.title,
                                                                                                                  null ==
                                                                                                                  r
                                                                                                                    ? void 0
                                                                                                                    : r.title),
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Cp,
                                                                                  B_(
                                                                                    {
                                                                                      sx: {
                                                                                        whiteSpace:
                                                                                          "nowrap",
                                                                                        backgroundColor:
                                                                                          "white",
                                                                                      },
                                                                                      className:
                                                                                        "iPadTableRowDisplay",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        null ===
                                                                                          (s =
                                                                                            null ==
                                                                                            r
                                                                                              ? void 0
                                                                                              : r.variants) ||
                                                                                        void 0 ===
                                                                                          s
                                                                                          ? void 0
                                                                                          : s.map(
                                                                                              function (
                                                                                                t,
                                                                                                o
                                                                                              ) {
                                                                                                var a,
                                                                                                  i;
                                                                                                return (0,
                                                                                                e.jsxs)(
                                                                                                  "div",
                                                                                                  B_(
                                                                                                    {
                                                                                                      className:
                                                                                                        "Mobile_Product_Picker_Div ipadTableDiv",
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Cp,
                                                                                                            {
                                                                                                              children:
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Op,
                                                                                                                  B_(
                                                                                                                    {
                                                                                                                      colSpan: 2,
                                                                                                                      className:
                                                                                                                        "New_PT_Sub_Header",
                                                                                                                    },
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsxs)(
                                                                                                                          mn,
                                                                                                                          B_(
                                                                                                                            {
                                                                                                                              display:
                                                                                                                                "flex",
                                                                                                                              alignItems:
                                                                                                                                "center",
                                                                                                                            },
                                                                                                                            {
                                                                                                                              children:
                                                                                                                                [
                                                                                                                                  (0,
                                                                                                                                  e.jsx)(
                                                                                                                                    tb,
                                                                                                                                    {
                                                                                                                                      checked:
                                                                                                                                        null ==
                                                                                                                                        g
                                                                                                                                          ? void 0
                                                                                                                                          : g.some(
                                                                                                                                              function (
                                                                                                                                                e
                                                                                                                                              ) {
                                                                                                                                                return (
                                                                                                                                                  (null ==
                                                                                                                                                  e
                                                                                                                                                    ? void 0
                                                                                                                                                    : e.variantId) ===
                                                                                                                                                  (null ==
                                                                                                                                                  t
                                                                                                                                                    ? void 0
                                                                                                                                                    : t.variantId)
                                                                                                                                                );
                                                                                                                                              }
                                                                                                                                            ),
                                                                                                                                      onChange:
                                                                                                                                        function (
                                                                                                                                          e
                                                                                                                                        ) {
                                                                                                                                          return f(
                                                                                                                                            e,
                                                                                                                                            "isVariant",
                                                                                                                                            r,
                                                                                                                                            t,
                                                                                                                                            !0
                                                                                                                                          );
                                                                                                                                        },
                                                                                                                                    }
                                                                                                                                  ),
                                                                                                                                  (0,
                                                                                                                                  e.jsx)(
                                                                                                                                    mn,
                                                                                                                                    B_(
                                                                                                                                      {
                                                                                                                                        sx: {
                                                                                                                                          ml: 2,
                                                                                                                                          whiteSpace:
                                                                                                                                            "pre-line",
                                                                                                                                        },
                                                                                                                                      },
                                                                                                                                      {
                                                                                                                                        children:
                                                                                                                                          "Default Title" !==
                                                                                                                                          (null ==
                                                                                                                                          t
                                                                                                                                            ? void 0
                                                                                                                                            : t.title)
                                                                                                                                            ? null ==
                                                                                                                                              t
                                                                                                                                              ? void 0
                                                                                                                                              : t.title
                                                                                                                                            : null ==
                                                                                                                                              r
                                                                                                                                            ? void 0
                                                                                                                                            : r.title,
                                                                                                                                      }
                                                                                                                                    )
                                                                                                                                  ),
                                                                                                                                ],
                                                                                                                            }
                                                                                                                          )
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  )
                                                                                                                ),
                                                                                                            }
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            Cp,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsxs)(
                                                                                                                          "b",
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                M(
                                                                                                                                  "ST_Producttable_SKU"
                                                                                                                                ),
                                                                                                                                " : ",
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        [
                                                                                                                          " ",
                                                                                                                          t.sku,
                                                                                                                        ],
                                                                                                                    }
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            Cp,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsxs)(
                                                                                                                          "b",
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                M(
                                                                                                                                  "customerInvoice_ProductTableColumnInventory"
                                                                                                                                ),
                                                                                                                                " : ",
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        t.quantityAvailable ||
                                                                                                                        0,
                                                                                                                    }
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            Cp,
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        (0,
                                                                                                                        e.jsxs)(
                                                                                                                          "b",
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                M(
                                                                                                                                  "ST_Producttable_retailPrice"
                                                                                                                                ),
                                                                                                                                " : ",
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        ),
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsx)(
                                                                                                                    Op,
                                                                                                                    B_(
                                                                                                                      {
                                                                                                                        className:
                                                                                                                          "ST_White_Space",
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          ""
                                                                                                                            .concat(
                                                                                                                              d,
                                                                                                                              "  "
                                                                                                                            )
                                                                                                                            .concat(
                                                                                                                              t.variantPrice ||
                                                                                                                                (0).toFixed(
                                                                                                                                  2
                                                                                                                                )
                                                                                                                            ),
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsxs)(
                                                                                                            Cp,
                                                                                                            B_(
                                                                                                              {
                                                                                                                sx:
                                                                                                                  3 ===
                                                                                                                  (null ==
                                                                                                                  n
                                                                                                                    ? void 0
                                                                                                                    : n.activeTabIndex)
                                                                                                                    ? {
                                                                                                                        display:
                                                                                                                          "none",
                                                                                                                      }
                                                                                                                    : {
                                                                                                                        display:
                                                                                                                          "table-row",
                                                                                                                      },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  [
                                                                                                                    (0,
                                                                                                                    e.jsxs)(
                                                                                                                      Op,
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            M(
                                                                                                                              "customerInvoice_ProductTableColumnQuantity"
                                                                                                                            ),
                                                                                                                            " :",
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    ),
                                                                                                                    (0,
                                                                                                                    e.jsx)(
                                                                                                                      Op,
                                                                                                                      B_(
                                                                                                                        {
                                                                                                                          className:
                                                                                                                            "No_LineHeight",
                                                                                                                          sx: {
                                                                                                                            padding:
                                                                                                                              "0 !important",
                                                                                                                          },
                                                                                                                        },
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            (0,
                                                                                                                            e.jsx)(
                                                                                                                              Gs,
                                                                                                                              B_(
                                                                                                                                {
                                                                                                                                  arrow:
                                                                                                                                    !0,
                                                                                                                                  title:
                                                                                                                                    "Quantity",
                                                                                                                                },
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsxs)(
                                                                                                                                      mn,
                                                                                                                                      B_(
                                                                                                                                        {
                                                                                                                                          className:
                                                                                                                                            "Display_Alignment_Middle",
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            [
                                                                                                                                              (0,
                                                                                                                                              e.jsx)(
                                                                                                                                                Qu,
                                                                                                                                                B_(
                                                                                                                                                  {
                                                                                                                                                    id: "decreaseQty",
                                                                                                                                                    onClick:
                                                                                                                                                      function () {
                                                                                                                                                        var e;
                                                                                                                                                        return y(
                                                                                                                                                          null ===
                                                                                                                                                            (e =
                                                                                                                                                              _[
                                                                                                                                                                null ==
                                                                                                                                                                t
                                                                                                                                                                  ? void 0
                                                                                                                                                                  : t.variantId
                                                                                                                                                              ]) ||
                                                                                                                                                            void 0 ===
                                                                                                                                                              e
                                                                                                                                                            ? void 0
                                                                                                                                                            : e.quantity,
                                                                                                                                                          null ==
                                                                                                                                                            t
                                                                                                                                                            ? void 0
                                                                                                                                                            : t.variantId,
                                                                                                                                                          "decreaseQty"
                                                                                                                                                        );
                                                                                                                                                      },
                                                                                                                                                    sx: V,
                                                                                                                                                    "aria-label":
                                                                                                                                                      "reduce",
                                                                                                                                                  },
                                                                                                                                                  {
                                                                                                                                                    children:
                                                                                                                                                      (0,
                                                                                                                                                      e.jsx)(
                                                                                                                                                        wb,
                                                                                                                                                        {
                                                                                                                                                          fontSize:
                                                                                                                                                            "small",
                                                                                                                                                        }
                                                                                                                                                      ),
                                                                                                                                                  }
                                                                                                                                                )
                                                                                                                                              ),
                                                                                                                                              (0,
                                                                                                                                              e.jsx)(
                                                                                                                                                Hc,
                                                                                                                                                {
                                                                                                                                                  InputProps:
                                                                                                                                                    {
                                                                                                                                                      inputProps:
                                                                                                                                                        {
                                                                                                                                                          className:
                                                                                                                                                            "ST_Custom_Number_Input",
                                                                                                                                                        },
                                                                                                                                                    },
                                                                                                                                                  value:
                                                                                                                                                    null ===
                                                                                                                                                      (a =
                                                                                                                                                        _[
                                                                                                                                                          null ==
                                                                                                                                                          t
                                                                                                                                                            ? void 0
                                                                                                                                                            : t.variantId
                                                                                                                                                        ]) ||
                                                                                                                                                    void 0 ===
                                                                                                                                                      a
                                                                                                                                                      ? void 0
                                                                                                                                                      : a.quantity,
                                                                                                                                                  sx: W,
                                                                                                                                                  onKeyDown:
                                                                                                                                                    Nb,
                                                                                                                                                  name: "".concat(
                                                                                                                                                    null ==
                                                                                                                                                      t
                                                                                                                                                      ? void 0
                                                                                                                                                      : t.variantId
                                                                                                                                                  ),
                                                                                                                                                  variant:
                                                                                                                                                    "outlined",
                                                                                                                                                  size: "small",
                                                                                                                                                  type: "number",
                                                                                                                                                  error:
                                                                                                                                                    I[
                                                                                                                                                      null ==
                                                                                                                                                      t
                                                                                                                                                        ? void 0
                                                                                                                                                        : t.variantId
                                                                                                                                                    ] ||
                                                                                                                                                    !1,
                                                                                                                                                  onChange:
                                                                                                                                                    function (
                                                                                                                                                      e
                                                                                                                                                    ) {
                                                                                                                                                      return y(
                                                                                                                                                        e
                                                                                                                                                          .target
                                                                                                                                                          .value,
                                                                                                                                                        null ==
                                                                                                                                                          t
                                                                                                                                                          ? void 0
                                                                                                                                                          : t.variantId,
                                                                                                                                                        "manual"
                                                                                                                                                      );
                                                                                                                                                    },
                                                                                                                                                }
                                                                                                                                              ),
                                                                                                                                              (0,
                                                                                                                                              e.jsx)(
                                                                                                                                                Qu,
                                                                                                                                                B_(
                                                                                                                                                  {
                                                                                                                                                    id: "increaseQty",
                                                                                                                                                    sx: V,
                                                                                                                                                    "aria-label":
                                                                                                                                                      "increase",
                                                                                                                                                    onClick:
                                                                                                                                                      function () {
                                                                                                                                                        var e;
                                                                                                                                                        return y(
                                                                                                                                                          null ===
                                                                                                                                                            (e =
                                                                                                                                                              _[
                                                                                                                                                                null ==
                                                                                                                                                                t
                                                                                                                                                                  ? void 0
                                                                                                                                                                  : t.variantId
                                                                                                                                                              ]) ||
                                                                                                                                                            void 0 ===
                                                                                                                                                              e
                                                                                                                                                            ? void 0
                                                                                                                                                            : e.quantity,
                                                                                                                                                          null ==
                                                                                                                                                            t
                                                                                                                                                            ? void 0
                                                                                                                                                            : t.variantId,
                                                                                                                                                          "increaseQty"
                                                                                                                                                        );
                                                                                                                                                      },
                                                                                                                                                  },
                                                                                                                                                  {
                                                                                                                                                    children:
                                                                                                                                                      (0,
                                                                                                                                                      e.jsx)(
                                                                                                                                                        Ob,
                                                                                                                                                        {
                                                                                                                                                          fontSize:
                                                                                                                                                            "small",
                                                                                                                                                        }
                                                                                                                                                      ),
                                                                                                                                                  }
                                                                                                                                                )
                                                                                                                                              ),
                                                                                                                                            ],
                                                                                                                                        }
                                                                                                                                      )
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              )
                                                                                                                            ),
                                                                                                                        }
                                                                                                                      )
                                                                                                                    ),
                                                                                                                  ],
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                          3 ===
                                                                                                          (null ==
                                                                                                          n
                                                                                                            ? void 0
                                                                                                            : n.activeTabIndex)
                                                                                                            ? (0,
                                                                                                              e.jsxs)(
                                                                                                                e.Fragment,
                                                                                                                {
                                                                                                                  children:
                                                                                                                    [
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        Cp,
                                                                                                                        B_(
                                                                                                                          {
                                                                                                                            sx:
                                                                                                                              "Product" !==
                                                                                                                              L
                                                                                                                                ? {
                                                                                                                                    display:
                                                                                                                                      "none",
                                                                                                                                  }
                                                                                                                                : {
                                                                                                                                    display:
                                                                                                                                      "table-row",
                                                                                                                                  },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  Op,
                                                                                                                                  {
                                                                                                                                    children:
                                                                                                                                      (0,
                                                                                                                                      e.jsxs)(
                                                                                                                                        "b",
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            [
                                                                                                                                              M(
                                                                                                                                                "affliateOrder_column6"
                                                                                                                                              ),
                                                                                                                                              " : ",
                                                                                                                                            ],
                                                                                                                                        }
                                                                                                                                      ),
                                                                                                                                  }
                                                                                                                                ),
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  Op,
                                                                                                                                  B_(
                                                                                                                                    {
                                                                                                                                      className:
                                                                                                                                        "ST_White_Space",
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                      children:
                                                                                                                                        "Percentage" ===
                                                                                                                                        D
                                                                                                                                          ? (null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.commission) +
                                                                                                                                            "%"
                                                                                                                                          : d +
                                                                                                                                            " " +
                                                                                                                                            (null ===
                                                                                                                                              (i =
                                                                                                                                                null ==
                                                                                                                                                t
                                                                                                                                                  ? void 0
                                                                                                                                                  : t.commission) ||
                                                                                                                                            void 0 ===
                                                                                                                                              i
                                                                                                                                              ? void 0
                                                                                                                                              : i.toFixed(
                                                                                                                                                  2
                                                                                                                                                )),
                                                                                                                                    }
                                                                                                                                  )
                                                                                                                                ),
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        Cp,
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsxs)(
                                                                                                                                      "b",
                                                                                                                                      {
                                                                                                                                        children:
                                                                                                                                          [
                                                                                                                                            M(
                                                                                                                                              "affiliate_product_link"
                                                                                                                                            ),
                                                                                                                                            " : ",
                                                                                                                                          ],
                                                                                                                                      }
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              ),
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsx)(
                                                                                                                                      Gs,
                                                                                                                                      B_(
                                                                                                                                        {
                                                                                                                                          TransitionComponent:
                                                                                                                                            pb,
                                                                                                                                          title:
                                                                                                                                            null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.url,
                                                                                                                                          placement:
                                                                                                                                            "bottom",
                                                                                                                                          arrow:
                                                                                                                                            !0,
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            (0,
                                                                                                                                            e.jsx)(
                                                                                                                                              rl,
                                                                                                                                              B_(
                                                                                                                                                {
                                                                                                                                                  target:
                                                                                                                                                    "_blank",
                                                                                                                                                  href:
                                                                                                                                                    null ==
                                                                                                                                                    t
                                                                                                                                                      ? void 0
                                                                                                                                                      : t.url,
                                                                                                                                                  className:
                                                                                                                                                    "ST_link_FontColor",
                                                                                                                                                },
                                                                                                                                                {
                                                                                                                                                  children:
                                                                                                                                                    M(
                                                                                                                                                      "affiliate_product_link"
                                                                                                                                                    ),
                                                                                                                                                }
                                                                                                                                              )
                                                                                                                                            ),
                                                                                                                                        }
                                                                                                                                      )
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              ),
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        Cp,
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsxs)(
                                                                                                                                      "b",
                                                                                                                                      {
                                                                                                                                        children:
                                                                                                                                          [
                                                                                                                                            M(
                                                                                                                                              "affiliateLink_searchColumn7"
                                                                                                                                            ),
                                                                                                                                            " : ",
                                                                                                                                          ],
                                                                                                                                      }
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              ),
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsx)(
                                                                                                                                      Gs,
                                                                                                                                      B_(
                                                                                                                                        {
                                                                                                                                          TransitionComponent:
                                                                                                                                            pb,
                                                                                                                                          title:
                                                                                                                                            "#05bf05" ===
                                                                                                                                            F[
                                                                                                                                              ""
                                                                                                                                                .concat(
                                                                                                                                                  "productLink",
                                                                                                                                                  " "
                                                                                                                                                )
                                                                                                                                                .concat(
                                                                                                                                                  ""
                                                                                                                                                    .concat(
                                                                                                                                                      null ==
                                                                                                                                                        t
                                                                                                                                                        ? void 0
                                                                                                                                                        : t.variantId,
                                                                                                                                                      " "
                                                                                                                                                    )
                                                                                                                                                    .concat(
                                                                                                                                                      o
                                                                                                                                                    ),
                                                                                                                                                  "}"
                                                                                                                                                )
                                                                                                                                            ]
                                                                                                                                              ? M(
                                                                                                                                                  "affiliateLink_searchColumn8"
                                                                                                                                                )
                                                                                                                                              : null ==
                                                                                                                                                t
                                                                                                                                              ? void 0
                                                                                                                                              : t.url,
                                                                                                                                          placement:
                                                                                                                                            "bottom",
                                                                                                                                          arrow:
                                                                                                                                            !0,
                                                                                                                                        },
                                                                                                                                        {
                                                                                                                                          children:
                                                                                                                                            (0,
                                                                                                                                            e.jsx)(
                                                                                                                                              Tb,
                                                                                                                                              {
                                                                                                                                                onClick:
                                                                                                                                                  function () {
                                                                                                                                                    var e;
                                                                                                                                                    E(
                                                                                                                                                      null !==
                                                                                                                                                        (e =
                                                                                                                                                          null ==
                                                                                                                                                          t
                                                                                                                                                            ? void 0
                                                                                                                                                            : t.url) &&
                                                                                                                                                        void 0 !==
                                                                                                                                                          e
                                                                                                                                                        ? e
                                                                                                                                                        : ""
                                                                                                                                                    ),
                                                                                                                                                      A(
                                                                                                                                                        o
                                                                                                                                                      ),
                                                                                                                                                      z(
                                                                                                                                                        null ==
                                                                                                                                                          t
                                                                                                                                                          ? void 0
                                                                                                                                                          : t.url,
                                                                                                                                                        ""
                                                                                                                                                          .concat(
                                                                                                                                                            "productLink",
                                                                                                                                                            " "
                                                                                                                                                          )
                                                                                                                                                          .concat(
                                                                                                                                                            ""
                                                                                                                                                              .concat(
                                                                                                                                                                null ==
                                                                                                                                                                  t
                                                                                                                                                                  ? void 0
                                                                                                                                                                  : t.variantId,
                                                                                                                                                                " "
                                                                                                                                                              )
                                                                                                                                                              .concat(
                                                                                                                                                                o
                                                                                                                                                              ),
                                                                                                                                                            "}"
                                                                                                                                                          )
                                                                                                                                                      );
                                                                                                                                                  },
                                                                                                                                                style:
                                                                                                                                                  {
                                                                                                                                                    cursor:
                                                                                                                                                      "pointer",
                                                                                                                                                    color:
                                                                                                                                                      F[
                                                                                                                                                        ""
                                                                                                                                                          .concat(
                                                                                                                                                            "productLink",
                                                                                                                                                            " "
                                                                                                                                                          )
                                                                                                                                                          .concat(
                                                                                                                                                            ""
                                                                                                                                                              .concat(
                                                                                                                                                                null ==
                                                                                                                                                                  t
                                                                                                                                                                  ? void 0
                                                                                                                                                                  : t.variantId,
                                                                                                                                                                " "
                                                                                                                                                              )
                                                                                                                                                              .concat(
                                                                                                                                                                o
                                                                                                                                                              ),
                                                                                                                                                            "}"
                                                                                                                                                          )
                                                                                                                                                      ],
                                                                                                                                                  },
                                                                                                                                              }
                                                                                                                                            ),
                                                                                                                                        }
                                                                                                                                      )
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              ),
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        Cp,
                                                                                                                        {
                                                                                                                          children:
                                                                                                                            [
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                {
                                                                                                                                  children:
                                                                                                                                    (0,
                                                                                                                                    e.jsxs)(
                                                                                                                                      "b",
                                                                                                                                      {
                                                                                                                                        children:
                                                                                                                                          [
                                                                                                                                            M(
                                                                                                                                              "affiliateCartProdtableColumn6"
                                                                                                                                            ),
                                                                                                                                            " : ",
                                                                                                                                          ],
                                                                                                                                      }
                                                                                                                                    ),
                                                                                                                                }
                                                                                                                              ),
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Op,
                                                                                                                                B_(
                                                                                                                                  {
                                                                                                                                    size: "medium",
                                                                                                                                  },
                                                                                                                                  {
                                                                                                                                    children:
                                                                                                                                      (0,
                                                                                                                                      e.jsx)(
                                                                                                                                        L_,
                                                                                                                                        {
                                                                                                                                          url:
                                                                                                                                            null ==
                                                                                                                                            t
                                                                                                                                              ? void 0
                                                                                                                                              : t.url,
                                                                                                                                        }
                                                                                                                                      ),
                                                                                                                                  }
                                                                                                                                )
                                                                                                                              ),
                                                                                                                            ],
                                                                                                                        }
                                                                                                                      ),
                                                                                                                    ],
                                                                                                                }
                                                                                                              )
                                                                                                            : null,
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                );
                                                                                              }
                                                                                            ),
                                                                                    }
                                                                                  ),
                                                                                  o
                                                                                ),
                                                                              ],
                                                                          },
                                                                          o
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(Dp, {
                                                                  children: (0,
                                                                  e.jsx)(Op, {
                                                                    colSpan: 2,
                                                                  }),
                                                                }),
                                                              ],
                                                            }
                                                          )
                                                        : null;
                                                    }),
                                            })
                                          : (0, e.jsx)(Dp, {
                                              children: (0, e.jsx)(Cp, {
                                                children: (0, e.jsx)(
                                                  Op,
                                                  B_(
                                                    {
                                                      align: "center",
                                                      colSpan:
                                                        3 ===
                                                        (null == n
                                                          ? void 0
                                                          : n.activeTabIndex)
                                                          ? 8
                                                          : 4,
                                                    },
                                                    {
                                                      children: m
                                                        ? M("productsLoading")
                                                        : (0, e.jsxs)(
                                                            "div",
                                                            B_(
                                                              {
                                                                style: {
                                                                  marginTop:
                                                                    "15px",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    ni,
                                                                    B_(
                                                                      {
                                                                        variant:
                                                                          Av,
                                                                        sx: Ko,
                                                                      },
                                                                      {
                                                                        children:
                                                                          M(
                                                                            "createOrder_productTable_NoProductsAdded"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Qu,
                                                                    B_(
                                                                      {
                                                                        sx: {
                                                                          mt: 1,
                                                                          mb: 2,
                                                                          textTransform:
                                                                            "capitalize",
                                                                        },
                                                                        onClick:
                                                                          function () {
                                                                            return l();
                                                                          },
                                                                        variant:
                                                                          "contained",
                                                                      },
                                                                      {
                                                                        children:
                                                                          M(
                                                                            "createOrder_AddProduct"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                    }
                                                  )
                                                ),
                                              }),
                                            }),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        }),
                    ],
                  }
                )
              ),
              Z(R, T),
            ],
          })
        );
      }
      var F_ = function () {
          return (
            (F_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            F_.apply(this, arguments)
          );
        },
        Z_ = function (t) {
          var n = t.isRemoveCartPopup,
            r = t.setIsRemoveCartPopup,
            o = t.removeProductMethod,
            a = ee().t;
          return (0, e.jsx)(
            Hp,
            F_(
              {
                open: n,
                onClose: function () {
                  return r(!1);
                },
                maxWidth: "xs",
                fullWidth: !0,
                className: "Dialog_Border_Radius",
              },
              {
                children: (0, e.jsxs)("div", {
                  children: [
                    (0, e.jsxs)(
                      qa,
                      F_(
                        {
                          container: !0,
                          spacing: 2,
                          className: "Product_Picker_Heading",
                        },
                        {
                          children: [
                            (0, e.jsx)(
                              qa,
                              F_(
                                { item: !0, xs: 10, md: 10 },
                                {
                                  children: (0, e.jsx)(
                                    ni,
                                    F_(
                                      { variant: Av, fontWeight: "bold" },
                                      {
                                        children: a(
                                          "productTable_clearCartBtn"
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              qa,
                              F_(
                                {
                                  item: !0,
                                  xs: 2,
                                  md: 2,
                                  sx: { textAlign: "right" },
                                  pr: 1,
                                },
                                {
                                  children: (0, e.jsx)(Io, {
                                    sx: { cursor: "pointer" },
                                    onClick: function () {
                                      return r(!1);
                                    },
                                  }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsx)("hr", { className: "ST_CS_HR_Color" }),
                    (0, e.jsx)(
                      Gp,
                      F_(
                        { sx: { padding: "30px" } },
                        {
                          children: (0, e.jsx)(
                            ni,
                            F_(
                              { pb: 2 },
                              { children: a("ClearCart_Conformation_Msg") }
                            )
                          ),
                        }
                      )
                    ),
                    (0, e.jsx)("hr", { className: "ST_CS_HR_Color" }),
                    (0, e.jsx)(Jp, {
                      children: (0, e.jsx)(
                        Ym,
                        F_(
                          {
                            sx: { textTransform: "none" },
                            onClick: function () {
                              o(), r(!1);
                            },
                            variant: "contained",
                            loadingPosition: "center",
                          },
                          { children: a("b2b_removeSelectedCustomer") }
                        )
                      ),
                    }),
                  ],
                }),
              }
            )
          );
        },
        H_ = function () {
          return (
            (H_ =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            H_.apply(this, arguments)
          );
        };
      function V_() {
        var n,
          r = xv(),
          o = r.copyTextFunction,
          a = r.copyIconSuccessColor,
          i = (function () {
            var e,
              n = this,
              r = ee().t,
              o = g(),
              a = y(function (e) {
                return e.salesRepData ? e.salesRepData : {};
              }),
              i = rf().shopCurrency,
              s = (0, t.useState)(
                a.baseData.SharedCartDetails ? a.baseData.SharedCartDetails : []
              ),
              l = s[0],
              d = s[1],
              c = (0, t.useState)({}),
              u = c[0],
              p = c[1],
              m = (0, t.useState)(""),
              h = m[0],
              f = m[1],
              v = (0, t.useState)(a.productsData ? a.productsData : []),
              b = v[0],
              _ = v[1],
              C = (0, t.useState)(""),
              x = C[0],
              S = C[1],
              k = (0, t.useState)({}),
              P = k[0],
              w = k[1],
              O = (0, t.useState)(!1),
              T = O[0],
              I = O[1],
              M = (0, t.useState)({}),
              j = M[0],
              N = M[1],
              D = (0, t.useState)([]),
              E = D[0],
              R = D[1],
              L = (0, t.useState)({ msg: "", color: "blue" }),
              B = L[0],
              z = L[1],
              Z = (0, t.useState)(!1),
              H = Z[0],
              V = Z[1],
              W = (0, t.useState)(null),
              U = W[0],
              $ = W[1],
              K = B.msg === r("cartSharing_CartCreating_Msg"),
              G = (0, t.useState)(!1),
              q = (G[0], G[1]),
              Q = (0, t.useState)([]),
              Y = Q[0],
              J = Q[1],
              X = (0, t.useState)(),
              te = X[0],
              ne = X[1],
              re = (0, t.useState)({}),
              oe = re[0],
              ae =
                (re[1],
                (0, t.useState)({ msg: "", open: !1, severity: "error" })),
              ie = ae[0],
              se = ae[1],
              le = Tv(),
              de = (0, t.useState)(
                !(
                  (null === (e = null == a ? void 0 : a.productsData) ||
                  void 0 === e
                    ? void 0
                    : e.length) > 0
                )
              ),
              ce = de[0],
              ue = de[1],
              pe = xv().useInfiniteScroll,
              me = (0, t.useState)(0),
              he = (me[0], me[1]),
              fe = (0, t.useState)(10),
              ge = fe[0],
              ve = fe[1],
              be = pe(ge, ve, b),
              _e = (0, t.useState)(!1),
              ye = _e[0],
              Ce = _e[1],
              xe = (0, t.useState)(!1),
              Se = xe[0],
              ke = xe[1],
              Pe = (0, t.useState)(!1),
              we = Pe[0],
              Oe = Pe[1];
            (0, t.useEffect)(function () {
              var e;
              (
                null === (e = null == a ? void 0 : a.baseData) || void 0 === e
                  ? void 0
                  : e.completedGetProductApi
              )
                ? ue(!1)
                : ue(!0);
            }, []),
              (0, t.useEffect)(
                function () {
                  var e;
                  (null === (e = null == a ? void 0 : a.productsData) ||
                  void 0 === e
                    ? void 0
                    : e.length) > 0 && _(null == a ? void 0 : a.productsData),
                    he(function (e) {
                      return 1 === e && ue(!1), e + 1;
                    });
                },
                [a.productsData]
              );
            var Te = function (e) {
                return null != e;
              },
              Ie = (function () {
                var e,
                  t =
                    null !== (e = a.cartShareProductData) && void 0 !== e
                      ? e
                      : [];
                return (
                  "" !== h.trim() &&
                    (null == E ? void 0 : E.length) > 0 &&
                    (null == E ||
                      E.forEach(function (e) {
                        var n;
                        null === (n = null == e ? void 0 : e.variants) ||
                          void 0 === n ||
                          n.forEach(function (n) {
                            t = Nv(
                              Nv([], t, !0),
                              [
                                {
                                  id: n.variantId,
                                  quantity: j[n.variantId],
                                  handle: null == e ? void 0 : e.handle,
                                },
                              ],
                              !1
                            );
                          });
                      })),
                  0 === (null == t ? void 0 : t.length)
                );
              })();
            return {
              t: r,
              shopCurrency: i,
              shareCartData: l,
              deleteSharedCartLink: function () {
                return Mv(n, void 0, void 0, function () {
                  var e, t, n, r, a, i, s, l, d;
                  return jv(this, function (c) {
                    switch (c.label) {
                      case 0:
                        return (
                          (e = null == te ? void 0 : te.delete_Cart_Link_Id),
                          (t = null == te ? void 0 : te.delete_Cart_Id),
                          e && t
                            ? ((n = af()),
                              (r = n.CustomerId),
                              (a = n.SalesRepName),
                              (i = a),
                              (s = r),
                              (l = Iv({}, u)),
                              (d = {
                                salesRepName: i,
                                SalesrepId: s,
                                cartUniqueId: e,
                              }),
                              (l[t] = !0),
                              p(Iv({}, l)),
                              [4, o(hg(d))])
                            : [3, 2]
                        );
                      case 1:
                        return (
                          c.sent()
                            ? (delete u[t], $(null))
                            : ((l[t] = !1), p(Iv({}, l))),
                          [3, 3]
                        );
                      case 2:
                        V(!0), (c.label = 3);
                      case 3:
                        return [2];
                    }
                  });
                });
              },
              deleteLink: u,
              cartName: h,
              setCartName: f,
              products: b,
              SearchProduct: function (e) {
                var t, n;
                if (
                  (ve(10),
                  (null === (t = a.productsData) || void 0 === t
                    ? void 0
                    : t.length) > 0)
                ) {
                  var r =
                    null === (n = a.productsData) || void 0 === n
                      ? void 0
                      : n.filter(function (t) {
                          var n,
                            r =
                              !!(null == t ? void 0 : t.productTitle) &&
                              (null === (n = t.productTitle.toLowerCase()) ||
                              void 0 === n
                                ? void 0
                                : n.includes(e.trim().toLowerCase())),
                            o =
                              null == t
                                ? void 0
                                : t.variants.some(function (t) {
                                    var n;
                                    return null ===
                                      (n = t.variantTitle.toLowerCase()) ||
                                      void 0 === n
                                      ? void 0
                                      : n.includes(e.trim().toLowerCase());
                                  }),
                            a =
                              null == t
                                ? void 0
                                : t.variants.some(function (t) {
                                    var n;
                                    return null ===
                                      (n = (t.sku || "").toLowerCase()) ||
                                      void 0 === n
                                      ? void 0
                                      : n.includes(
                                          (e.trim() || "").toLowerCase()
                                        );
                                  }),
                            i =
                              null == t
                                ? void 0
                                : t.variants.some(function (t) {
                                    return (
                                      Number(t.variantPrice) ===
                                      Number(e.trim())
                                    );
                                  });
                          return !!(r || o || a || i);
                        });
                  J(r), q(!!Y), _(r);
                }
              },
              renderImageSrc: function (e, t) {
                var n = t[0].src;
                return (
                  e &&
                    0 !== (null == t ? void 0 : t.length) &&
                    (null == t ||
                      t.forEach(function (t) {
                        if (t.imageId === e)
                          return (n = t.src ? t.src : "image");
                      })),
                  n
                );
              },
              searchProductInput: x,
              setSearchProductInput: S,
              product_idObject: P,
              backToShopBtn: T,
              handleBackToShopBtn: function () {
                return (
                  _(
                    (null == a ? void 0 : a.productsData)
                      ? null == a
                        ? void 0
                        : a.productsData
                      : []
                  ),
                  I(!1),
                  ve(10),
                  "" !== x ? S("") : null
                );
              },
              handleSelectedBtn: function () {
                I(!0), q(!1), _(E), ve(10);
              },
              variant_idObject: j,
              createSharedCart: function () {
                return Mv(n, void 0, void 0, function () {
                  var e, t, n, i, s, l, c, u, p, m, g, v;
                  return jv(this, function (b) {
                    switch (b.label) {
                      case 0:
                        return (
                          (e = af()),
                          (t = e.CustomerId),
                          (n = e.SalesRepName),
                          (i = n),
                          (s = t),
                          (l =
                            null !== (v = a.cartShareProductData) &&
                            void 0 !== v
                              ? v
                              : []),
                          "" !== h.trim() &&
                            (null == E ? void 0 : E.length) > 0 &&
                            (null == E ||
                              E.forEach(function (e) {
                                var t;
                                null ===
                                  (t = null == e ? void 0 : e.variants) ||
                                  void 0 === t ||
                                  t.forEach(function (t) {
                                    l = Nv(
                                      Nv([], l, !0),
                                      [
                                        {
                                          id: t.variantId,
                                          quantity: j[t.variantId],
                                          handle: e.handle,
                                        },
                                      ],
                                      !1
                                    );
                                  });
                              })),
                          "" === h.trim() ||
                          0 === (null == l ? void 0 : l.length)
                            ? ((c =
                                "" === h.trim()
                                  ? r("productnotselectforcartsharinglbl1")
                                  : r("productnotselectforcartsharinglbl2")),
                              se({ msg: c, open: !0 }),
                              [2])
                            : ((u = {
                                salesRepName: i,
                                SalesrepId: s,
                                cartName: h,
                                cartdata: JSON.stringify(l),
                              }),
                              (p = JSON.stringify(u)),
                              z({
                                msg: r("cartSharing_CartCreating_Msg"),
                                color: "blue",
                              }),
                              [4, o(gg(p))])
                        );
                      case 1:
                        return !0 === (m = b.sent()).data && Te(m.data)
                          ? (se({
                              msg: r("cartSharing_CartCreatedSuccessfully_Msg"),
                              open: !0,
                              severity: "success",
                            }),
                            R([]),
                            N({}),
                            w({}),
                            f(""),
                            setTimeout(function () {
                              z({ msg: "", color: "" }),
                                se({ msg: "", open: !1 });
                            }, 2e3),
                            [4, o(eg())])
                          : [3, 3];
                      case 2:
                        return (
                          b.sent(),
                          (g = {
                            payload: { cartCreatedSuccessFully: !0 },
                            type: A.CART_SHARE_PRODUCT_DATA,
                          }),
                          o(g),
                          d(
                            F.getState().salesRepData.baseData.SharedCartDetails
                          ),
                          [3, 4]
                        );
                      case 3:
                        se({
                          msg: r("cartSharing_CartCreateError_Msg"),
                          open: !0,
                          severity: "error",
                        }),
                          setTimeout(function () {
                            se({ msg: "", open: !1 }),
                              z({ msg: "", color: "" });
                          }, 3e3),
                          (b.label = 4);
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              createdCartMsg: B,
              handleQuantity_IncrementDecrement: function (e, t) {
                if (e && t) {
                  var n = Iv({}, j);
                  (n[e] =
                    "add" === t ? parseInt(j[e]) + 1 : Math.max(j[e] - 1, 1)),
                    N(Iv({}, n));
                } else V(!0);
              },
              checkUncheck: function (e, t, n, r) {
                var o, a, i, s;
                if (
                  n &&
                  0 !==
                    (null === (o = Object.keys(n)) || void 0 === o
                      ? void 0
                      : o.length) &&
                  (null === (a = n.variants) || void 0 === a
                    ? void 0
                    : a.length) > 0
                ) {
                  var l = e.target.checked,
                    d = Iv({}, P),
                    c = Iv({}, j),
                    u = n ? JSON.parse(JSON.stringify(n)) : {},
                    p = r ? JSON.parse(JSON.stringify(r)) : {};
                  if ("isProduct" === t)
                    if (l)
                      Te(P[n.productId])
                        ? null == E ||
                          E.forEach(function (e) {
                            var t;
                            e.productId === n.productId &&
                              ((e.variants = u.variants),
                              R(Nv([], E, !0)),
                              null === (t = u.variants) ||
                                void 0 === t ||
                                t.forEach(function (e) {
                                  (c[e.variantId] = 1), N(Iv({}, c));
                                }));
                          })
                        : (R(Nv(Nv([], E, !0), [u], !1)),
                          (d[n.productId] = n.productId),
                          w(Iv({}, d)),
                          null === (i = u.variants) ||
                            void 0 === i ||
                            i.forEach(function (e) {
                              (c[e.variantId] = 1), N(Iv({}, c));
                            }));
                    else {
                      var m =
                        null == E
                          ? void 0
                          : E.filter(function (e) {
                              return e.productId !== n.productId;
                            });
                      R(Nv([], m, !0)),
                        delete P[n.productId],
                        null === (s = u.variants) ||
                          void 0 === s ||
                          s.forEach(function (e) {
                            delete j[e.variantId];
                          });
                    }
                  else if (l)
                    if (Te(P[n.productId]))
                      null == E ||
                        E.forEach(function (e) {
                          if (e.productId === n.productId)
                            return (
                              (e.variants = Nv(
                                Nv([], e.variants, !0),
                                [Iv(Iv({}, p), { quantity: 1 })],
                                !1
                              )),
                              R(Nv([], E, !0)),
                              (c[r.variantId] = 1),
                              N(Iv({}, c)),
                              e
                            );
                        });
                    else {
                      var h = Iv(Iv({}, u), { variants: [p] });
                      R(Nv(Nv([], E, !0), [h], !1)),
                        (d[n.productId] = n.productId),
                        w(Iv({}, d)),
                        (c[r.variantId] = 1),
                        N(Iv({}, c));
                    }
                  else {
                    var f;
                    null == E ||
                      E.forEach(function (e) {
                        var t;
                        return null === (t = e.variants) || void 0 === t
                          ? void 0
                          : t.forEach(function (t, n) {
                              if (t.variantId === r.variantId)
                                return e.variants.splice(n, 1);
                            });
                      }),
                      (f =
                        null == E
                          ? void 0
                          : E.filter(function (e) {
                              var t, n, r;
                              if (
                                (null ===
                                  (t = null == e ? void 0 : e.variants) ||
                                void 0 === t
                                  ? void 0
                                  : t.length) >= 1
                              )
                                return (
                                  (null ===
                                    (n = null == e ? void 0 : e.variants) ||
                                  void 0 === n
                                    ? void 0
                                    : n.length) >= 1
                                );
                              0 ===
                                (null ===
                                  (r = null == e ? void 0 : e.variants) ||
                                void 0 === r
                                  ? void 0
                                  : r.length) &&
                                delete P[null == e ? void 0 : e.productId];
                            })),
                      R(Nv([], f, !0)),
                      delete j[r.variantId];
                  }
                } else V(!0);
              },
              NewselectedArray: E,
              handleAlertMsgClose: function (e, t) {
                "clickaway" !== t && (V(!1), se({ msg: "", open: !1 }));
              },
              alertMsgOpen: H,
              deleteConfirmation: U,
              openDeleteConfirmation: function (e, t, n) {
                $(e.currentTarget),
                  ne({
                    delete_Cart_Link_Id: null == t ? void 0 : t.CartUniqueId,
                    delete_index: n,
                    delete_Cart_Id: null == t ? void 0 : t.Id,
                  });
              },
              setDeleteConfirmation: $,
              CreateCartBtnDisabled: K,
              isNotEmpty: Te,
              deleteShareCartDataObject: te,
              handleProductQuantity: function (e, t) {
                var n;
                if (t) {
                  var o = e.target,
                    a = (o.name, o.value);
                  "" === a &&
                    se({ msg: r("productTable_error_AlertMsg2"), open: !0 }),
                    (function (e, t) {
                      return (
                        parseInt(t) <= 0 &&
                        (se({
                          msg: r("productTable_error_AlertMsg"),
                          open: !0,
                        }),
                        !0)
                      );
                    })(0, a) ||
                      N(Iv(Iv({}, j), (((n = {})[t] = "0" === a ? "" : a), n)));
                } else V(!0);
              },
              isError: oe,
              isMobile: le,
              alertErrorMsg: ie,
              productsLoading: ce,
              cartSharingInnerScroll: be,
              cartSharingProductsRowsPerPage: ge,
              setOpenSearchProducts: Ce,
              openSearchProducts: ye,
              disableCreateCartBtn: Ie,
              setIsRemoveSelectedProduct: ke,
              isRemoveSelectedProduct: Se,
              setIsRemoveCartPopup: Oe,
              isRemoveCartPopup: we,
            };
          })(),
          s = i.t,
          l = i.shareCartData,
          d = i.deleteSharedCartLink,
          c = i.deleteLink,
          u = i.cartName,
          p = i.setCartName,
          m = i.backToShopBtn,
          h = i.handleSelectedBtn,
          f = i.variant_idObject,
          v = i.createSharedCart,
          b = i.createdCartMsg,
          _ = i.NewselectedArray,
          C = i.handleAlertMsgClose,
          x = i.alertMsgOpen,
          S = i.deleteConfirmation,
          k = i.openDeleteConfirmation,
          P = i.setDeleteConfirmation,
          w = i.CreateCartBtnDisabled,
          O = i.deleteShareCartDataObject,
          T = i.isMobile,
          I = i.alertErrorMsg,
          M = i.setOpenSearchProducts,
          j = i.openSearchProducts,
          N = i.disableCreateCartBtn,
          D = i.setIsRemoveSelectedProduct,
          E = i.isRemoveSelectedProduct,
          R = i.setIsRemoveCartPopup,
          L = i.isRemoveCartPopup,
          B = (function () {
            var e = Tv();
            return {
              ST_CS_tableContainer: {
                maxHeight: 340,
                border: "1px solid #bfbfbf",
                borderRadius: "10px",
              },
              ST_CS_tableDataCell: { pt: 0.5, pb: 0.5 },
              ST_CS_OrderNotesGrid: {
                maxWidth: e ? "100% !important" : "300px !important",
                minWidth: e ? "100% !important" : "264px !important",
                mt: 2,
              },
              ST_CS_DisplayFlex: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                mb: e ? 1 : 3,
                mt: e ? 1 : 3,
                alignItems: "center",
              },
              ST_CS_AddMoreProducts_Btn: { mr: 1, mt: 2, whiteSpace: "nowrap" },
              ST_CS_SearchProductGrid: { mt: 2 },
              ST_CS_Display_ShareCart: {
                boxShadow: "none",
                width: e ? "100px" : "120px",
                height: e ? "35px" : "40px",
                fontSize: e ? "12px" : "13.5px",
                whiteSpace: "nowrap",
              },
            };
          })(),
          z = B.ST_CS_tableContainer,
          Z = B.ST_CS_Display_ShareCart;
        return (
          (0, t.useEffect)(
            function () {
              if (!0 === m) return h();
            },
            [f, _]
          ),
          (0, e.jsxs)(
            mn,
            H_(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    qa,
                    H_(
                      { mb: 2 },
                      {
                        children: [
                          (0, e.jsx)(
                            ni,
                            H_(
                              { variant: Av, sx: Ko },
                              { children: s("SharedCart") }
                            )
                          ),
                          (0, e.jsxs)(
                            ni,
                            H_(
                              { sx: { fontSize: "14px" } },
                              {
                                children: [
                                  s("ShareCart_UserGuide_Msg1"),
                                  " ",
                                  (0, e.jsx)("br", {}),
                                  " ",
                                  s("ShareCart_UserGuide_Msg2"),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    ii,
                    H_(
                      { className: "ST_DC_Card2Color" },
                      {
                        children: [
                          (0, e.jsxs)(
                            qa,
                            H_(
                              {
                                container: !0,
                                spacing: 2,
                                alignItems: "center",
                                mb: 2,
                              },
                              {
                                children: [
                                  (0, e.jsx)(
                                    qa,
                                    H_(
                                      { item: !0, xs: 12, md: 6 },
                                      {
                                        children: (0, e.jsx)(
                                          ni,
                                          H_(
                                            { variant: "h4", fontSize: 15 },
                                            {
                                              children: s(
                                                "cartSharing_CreateCart_Btn"
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                  !N &&
                                    (0, e.jsx)(e.Fragment, {
                                      children: (0, e.jsx)(
                                        qa,
                                        H_(
                                          {
                                            item: !0,
                                            xs: 12,
                                            md: 6,
                                            display: "flex",
                                            justifyContent: "flex-end",
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              "div",
                                              H_(
                                                {
                                                  onClick: function () {
                                                    return R(!0);
                                                  },
                                                },
                                                {
                                                  children: (0, e.jsx)(
                                                    Gs,
                                                    H_(
                                                      {
                                                        title: s(
                                                          "ShareCart_ToltipTitle"
                                                        ),
                                                        arrow: !0,
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          mn,
                                                          H_(
                                                            {
                                                              display: "flex",
                                                              alignItems:
                                                                "center",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(Jn, {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Ev,
                                                                    {
                                                                      className:
                                                                        "ST_SC_Icon_Font_Color",
                                                                    }
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    rl,
                                                                    H_(
                                                                      {
                                                                        underline:
                                                                          "always",
                                                                        className:
                                                                          "ST_SC_Icon_Font_Color",
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            H_(
                                                                              {
                                                                                variant:
                                                                                  "body1",
                                                                                className:
                                                                                  "ST_link_FontColor",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  s(
                                                                                    "productTable_clearCartBtn"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            qa,
                            H_(
                              {
                                container: !0,
                                spacing: 2,
                                alignItems: "center",
                              },
                              {
                                children: [
                                  (0, e.jsx)(
                                    qa,
                                    H_(
                                      { item: !0, xs: 12, md: 5 },
                                      {
                                        children: (0, e.jsx)(Hc, {
                                          required: !0,
                                          type: "search",
                                          name: "cartname",
                                          className: "ST_Cart_Name_TextField",
                                          label: s(
                                            "cartSharing_EnterCartName_Label"
                                          ),
                                          value: u,
                                          onChange: function (e) {
                                            return p(e.target.value);
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    qa,
                                    H_(
                                      { item: !0, xs: 12, md: 5 },
                                      {
                                        children: (0, e.jsx)(ju, {
                                          fullWidth: !0,
                                          size: "medium",
                                          inputValue: "",
                                          className: "ST_ShareCartSearchBar",
                                          options: [],
                                          renderInput: function (t) {
                                            return (0, e.jsx)(
                                              Hc,
                                              H_(
                                                {
                                                  placeholder: s(
                                                    "ST_CO_SearchProducts_Label"
                                                  ),
                                                },
                                                t,
                                                {
                                                  onClick: function () {
                                                    M(!0);
                                                  },
                                                  className:
                                                    "ST_ShareCartSearchBar",
                                                  InputProps: H_(
                                                    H_({}, t.InputProps),
                                                    {
                                                      endAdornment: (0, e.jsx)(
                                                        Bu,
                                                        H_(
                                                          { position: "start" },
                                                          {
                                                            children: (0,
                                                            e.jsx)(Rv, {}),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  ),
                                                }
                                              )
                                            );
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    qa,
                                    H_(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 2,
                                        display: "flex",
                                        justifyContent: "center",
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          Qu,
                                          H_(
                                            {
                                              variant: "contained",
                                              size: "medium",
                                              disabled: w,
                                              onClick: function () {
                                                return v();
                                              },
                                              sx: H_(H_({}, Dv), Z),
                                            },
                                            {
                                              children:
                                                b.msg ===
                                                s(
                                                  "cartSharing_CartCreating_Msg"
                                                )
                                                  ? b.msg
                                                  : s(
                                                      "cartSharing_CreateCart_Btn"
                                                    ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                          T
                            ? (0, e.jsx)(z_, {
                                activeTabIndex: 4,
                                openSearchProducts: j,
                                setOpenSearchProducts: M,
                                isRemoveSelectedProduct: E,
                                setIsRemoveSelectedProduct: D,
                              })
                            : (0, e.jsx)(j_, {
                                activeTabIndex: 4,
                                openSearchProducts: j,
                                setOpenSearchProducts: M,
                                isRemoveSelectedProduct: E,
                                setIsRemoveSelectedProduct: D,
                              }),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)("br", {}),
                  (0, e.jsx)(
                    ep,
                    H_(
                      { sx: z, className: "ST_ShareCartTable_Color" },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          H_(
                            { stickyHeader: !0, "aria-label": "simple table" },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsxs)(
                                    Cp,
                                    H_(
                                      { className: "stickyHeaderRow" },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            Op,
                                            H_(
                                              { sx: H_({ width: "20%" }, Qo) },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  H_(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        s(
                                                          "cartSharing_SharedCartLinkTableColumnCartName"
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Op,
                                            H_(
                                              { align: "center", sx: Qo },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  H_(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        s(
                                                          "showSharedCartProductcolumn1"
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Op,
                                            H_(
                                              { align: "center", sx: Qo },
                                              {
                                                children: (0, e.jsxs)(
                                                  "b",
                                                  H_(
                                                    {
                                                      className:
                                                        "ST_CS_TableHeading",
                                                    },
                                                    {
                                                      children: [
                                                        " ",
                                                        s(
                                                          "cartSharing_SharedCartLink_Other"
                                                        ),
                                                        " ",
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                }),
                                (0, e.jsx)(Dp, {
                                  children:
                                    0 !== (null == l ? void 0 : l.length)
                                      ? (0, e.jsx)(e.Fragment, {
                                          children:
                                            null == l
                                              ? void 0
                                              : l.map(function (t, n) {
                                                  return (0, e.jsxs)(
                                                    Cp,
                                                    {
                                                      children: [
                                                        (0, e.jsxs)(
                                                          Op,
                                                          H_(
                                                            {
                                                              sx: {
                                                                width: "20%",
                                                                wordBreak:
                                                                  "break-all",
                                                              },
                                                            },
                                                            {
                                                              children: [
                                                                " ",
                                                                (null == t
                                                                  ? void 0
                                                                  : t.CartName) ||
                                                                  "-",
                                                                " ",
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsxs)(
                                                          Op,
                                                          H_(
                                                            { align: "center" },
                                                            {
                                                              children: [
                                                                (0, e.jsx)(
                                                                  Gs,
                                                                  H_(
                                                                    {
                                                                      title:
                                                                        (null ==
                                                                        t
                                                                          ? void 0
                                                                          : t.CartUrl) ||
                                                                        "-",
                                                                      arrow: !0,
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          rl,
                                                                          H_(
                                                                            {
                                                                              href:
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.CartUrl) ||
                                                                                "-",
                                                                              target:
                                                                                "_blank",
                                                                              className:
                                                                                "ST_link_FontColor",
                                                                            },
                                                                            {
                                                                              children:
                                                                                s(
                                                                                  "showSharedCartProductcolumn1"
                                                                                ),
                                                                            }
                                                                          )
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  Gs,
                                                                  H_(
                                                                    {
                                                                      title:
                                                                        "#05bf05" ===
                                                                        a[
                                                                          ""
                                                                            .concat(
                                                                              "shareCartLink",
                                                                              " "
                                                                            )
                                                                            .concat(
                                                                              n
                                                                            )
                                                                        ]
                                                                          ? s(
                                                                              "cartSharing_CopyCartLink_Msg"
                                                                            )
                                                                          : s(
                                                                              "click_to_copy"
                                                                            ),
                                                                      arrow: !0,
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          Jn,
                                                                          H_(
                                                                            {
                                                                              onClick:
                                                                                function () {
                                                                                  return o(
                                                                                    null ==
                                                                                      t
                                                                                      ? void 0
                                                                                      : t.CartUrl,
                                                                                    ""
                                                                                      .concat(
                                                                                        "shareCartLink",
                                                                                        " "
                                                                                      )
                                                                                      .concat(
                                                                                        n
                                                                                      )
                                                                                  );
                                                                                },
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Lv,
                                                                                  {
                                                                                    style:
                                                                                      {
                                                                                        color:
                                                                                          a[
                                                                                            ""
                                                                                              .concat(
                                                                                                "shareCartLink",
                                                                                                " "
                                                                                              )
                                                                                              .concat(
                                                                                                n
                                                                                              )
                                                                                          ],
                                                                                        cursor:
                                                                                          "pointer",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                            }
                                                                          )
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          Op,
                                                          H_(
                                                            { align: "center" },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                Gs,
                                                                H_(
                                                                  {
                                                                    title:
                                                                      s(
                                                                        "cartSharing_DeleteCartLink_Msg"
                                                                      ) ||
                                                                      "Delete",
                                                                    arrow: !0,
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsx)(
                                                                        Jn,
                                                                        H_(
                                                                          {
                                                                            onClick:
                                                                              function (
                                                                                e
                                                                              ) {
                                                                                return k(
                                                                                  e,
                                                                                  t,
                                                                                  n
                                                                                );
                                                                              },
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsx)(
                                                                                Ev,
                                                                                {
                                                                                  className:
                                                                                    "ST_SC_Icon_Font_Color ST_link_FontColor",
                                                                                }
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    },
                                                    n
                                                  );
                                                }),
                                        })
                                      : (0, e.jsx)(Cp, {
                                          children: (0, e.jsxs)(
                                            Op,
                                            H_(
                                              { colSpan: 4, align: "center" },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    ni,
                                                    H_(
                                                      {
                                                        variant: "body1",
                                                        fontSize: "Bolt",
                                                      },
                                                      {
                                                        children: s(
                                                          "No_Share_Cart_Added1"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ni,
                                                    H_(
                                                      { variant: "body2" },
                                                      {
                                                        children: s(
                                                          "No_Share_Cart_Added2"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }),
                                }),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsxs)(
                    Hp,
                    H_(
                      {
                        open: Boolean(S),
                        onClose: function () {
                          return P(null);
                        },
                        maxWidth: "xs",
                        fullWidth: !0,
                        className: "Dialog_Border_Radius",
                      },
                      {
                        children: [
                          (0, e.jsxs)("div", {
                            children: [
                              (0, e.jsxs)(
                                qa,
                                H_(
                                  {
                                    container: !0,
                                    spacing: 2,
                                    className: "Product_Picker_Heading",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        qa,
                                        H_(
                                          { item: !0, xs: 10, md: 10 },
                                          {
                                            children: (0, e.jsx)(
                                              ni,
                                              H_(
                                                {
                                                  variant: Av,
                                                  fontWeight: "bold",
                                                },
                                                {
                                                  children: s(
                                                    "viewClientOrders_btn3"
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        qa,
                                        H_(
                                          {
                                            item: !0,
                                            xs: 2,
                                            md: 2,
                                            sx: { textAlign: "right" },
                                            pr: 1,
                                          },
                                          {
                                            children: (0, e.jsx)(Io, {
                                              sx: { cursor: "pointer" },
                                              onClick: function () {
                                                P(null);
                                              },
                                            }),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsx)("hr", { className: "ST_CS_HR_Color" }),
                              (0, e.jsx)(
                                Gp,
                                H_(
                                  { sx: { padding: "30px" } },
                                  {
                                    children: (0, e.jsx)(
                                      ni,
                                      H_(
                                        { pb: 2 },
                                        {
                                          children: s(
                                            "Delete_Cart_Confirmation"
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }),
                          (0, e.jsx)("hr", { className: "ST_CS_HR_Color" }),
                          (0, e.jsx)(Jp, {
                            children: (0, e.jsx)(
                              Ym,
                              H_(
                                {
                                  sx: { textTransform: "none" },
                                  onClick: function () {
                                    return d();
                                  },
                                  variant: "contained",
                                  loading:
                                    !!c[
                                      (null == O ? void 0 : O.delete_Cart_Id) ||
                                        0
                                    ] &&
                                    c[
                                      (null == O ? void 0 : O.delete_Cart_Id) ||
                                        0
                                    ],
                                  loadingPosition: "center",
                                },
                                { children: s("viewClientOrders_btn3") }
                              )
                            ),
                          }),
                        ],
                      }
                    )
                  ),
                  L &&
                    (0, e.jsx)(Z_, {
                      isRemoveCartPopup: L,
                      setIsRemoveCartPopup: R,
                      removeProductMethod: function () {
                        D(!0);
                      },
                    }),
                  (0, e.jsx)(
                    um,
                    H_(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: x,
                        autoHideDuration: 4e3,
                        onClose: C,
                      },
                      {
                        children: (0, e.jsx)(
                          Im,
                          H_(
                            {
                              onClose: C,
                              severity: "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: s("cartSharing_AlertError_Msg") }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    um,
                    H_(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: I.open,
                        autoHideDuration: 4e3,
                        onClose: C,
                      },
                      {
                        children: (0, e.jsx)(
                          Im,
                          H_(
                            {
                              onClose: C,
                              severity:
                                null !==
                                  (n = null == I ? void 0 : I.severity) &&
                                void 0 !== n
                                  ? n
                                  : "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: I.msg }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          )
        );
      }
      var W_ = (0, Ft.Z)("MuiListItemIcon", ["root", "alignItemsFlexStart"]),
        U_ = (0, Ft.Z)("MuiListItemText", [
          "root",
          "multiline",
          "dense",
          "inset",
          "primary",
          "secondary",
        ]);
      function $_(e) {
        return (0, Zt.ZP)("MuiMenuItem", e);
      }
      var K_ = (0, Ft.Z)("MuiMenuItem", [
        "root",
        "focusVisible",
        "dense",
        "disabled",
        "divider",
        "gutters",
        "selected",
      ]);
      const G_ = [
          "autoFocus",
          "component",
          "dense",
          "divider",
          "disableGutters",
          "focusVisibleClassName",
          "role",
          "tabIndex",
          "className",
        ],
        q_ = (0, Bt.ZP)(Un, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiMenuItem",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              n.dense && t.dense,
              n.divider && t.divider,
              !n.disableGutters && t.gutters,
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {},
            e.typography.body1,
            {
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              position: "relative",
              textDecoration: "none",
              minHeight: 48,
              paddingTop: 6,
              paddingBottom: 6,
              boxSizing: "border-box",
              whiteSpace: "nowrap",
            },
            !t.disableGutters && { paddingLeft: 16, paddingRight: 16 },
            t.divider && {
              borderBottom: `1px solid ${(e.vars || e).palette.divider}`,
              backgroundClip: "padding-box",
            },
            {
              "&:hover": {
                textDecoration: "none",
                backgroundColor: (e.vars || e).palette.action.hover,
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
              [`&.${K_.selected}`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                  : (0, Lt.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity
                    ),
                [`&.${K_.focusVisible}`]: {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.focusOpacity}))`
                    : (0, Lt.Fq)(
                        e.palette.primary.main,
                        e.palette.action.selectedOpacity +
                          e.palette.action.focusOpacity
                      ),
                },
              },
              [`&.${K_.selected}:hover`]: {
                backgroundColor: e.vars
                  ? `rgba(${e.vars.palette.primary.mainChannel} / calc(${e.vars.palette.action.selectedOpacity} + ${e.vars.palette.action.hoverOpacity}))`
                  : (0, Lt.Fq)(
                      e.palette.primary.main,
                      e.palette.action.selectedOpacity +
                        e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": {
                  backgroundColor: e.vars
                    ? `rgba(${e.vars.palette.primary.mainChannel} / ${e.vars.palette.action.selectedOpacity})`
                    : (0, Lt.Fq)(
                        e.palette.primary.main,
                        e.palette.action.selectedOpacity
                      ),
                },
              },
              [`&.${K_.focusVisible}`]: {
                backgroundColor: (e.vars || e).palette.action.focus,
              },
              [`&.${K_.disabled}`]: {
                opacity: (e.vars || e).palette.action.disabledOpacity,
              },
              [`& + .${Vt.root}`]: {
                marginTop: e.spacing(1),
                marginBottom: e.spacing(1),
              },
              [`& + .${Vt.inset}`]: { marginLeft: 52 },
              [`& .${U_.root}`]: { marginTop: 0, marginBottom: 0 },
              [`& .${U_.inset}`]: { paddingLeft: 36 },
              [`& .${W_.root}`]: { minWidth: 36 },
            },
            !t.dense && { [e.breakpoints.up("sm")]: { minHeight: "auto" } },
            t.dense &&
              (0, u.Z)(
                { minHeight: 32, paddingTop: 4, paddingBottom: 4 },
                e.typography.body2,
                { [`& .${W_.root} svg`]: { fontSize: "1.25rem" } }
              )
          )
        ),
        Q_ = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiMenuItem" }),
            {
              autoFocus: a = !1,
              component: i = "li",
              dense: s = !1,
              divider: l = !1,
              disableGutters: d = !1,
              focusVisibleClassName: c,
              role: p = "menuitem",
              tabIndex: m,
              className: h,
            } = o,
            f = (0, At.Z)(o, G_),
            g = t.useContext(Td),
            v = t.useMemo(
              () => ({ dense: s || g.dense || !1, disableGutters: d }),
              [g.dense, s, d]
            ),
            b = t.useRef(null);
          (0, ra.Z)(() => {
            a && b.current && b.current.focus();
          }, [a]);
          const _ = (0, u.Z)({}, o, {
              dense: v.dense,
              divider: l,
              disableGutters: d,
            }),
            y = ((e) => {
              const {
                  disabled: t,
                  dense: n,
                  divider: r,
                  disableGutters: o,
                  selected: a,
                  classes: i,
                } = e,
                s = {
                  root: [
                    "root",
                    n && "dense",
                    t && "disabled",
                    !o && "gutters",
                    r && "divider",
                    a && "selected",
                  ],
                },
                l = (0, Rt.Z)(s, $_, i);
              return (0, u.Z)({}, i, l);
            })(o),
            C = (0, hn.Z)(b, r);
          let x;
          return (
            o.disabled || (x = void 0 !== m ? m : -1),
            (0, e.jsx)(Td.Provider, {
              value: v,
              children: (0, e.jsx)(
                q_,
                (0, u.Z)(
                  {
                    ref: C,
                    role: p,
                    tabIndex: x,
                    component: i,
                    focusVisibleClassName: (0, Et.Z)(y.focusVisible, c),
                    className: (0, Et.Z)(y.root, h),
                  },
                  f,
                  { ownerState: _, classes: y }
                )
              ),
            })
          );
        });
      var Y_,
        J_ = Q_,
        X_ = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8",
          }),
          "AddCircleOutline"
        );
      !(function (e) {
        (e.UK = "UK"),
          (e.GB = "GB"),
          (e.JE = "JE"),
          (e.GG = "GG"),
          (e.IM = "IM"),
          (e.US = "US"),
          (e.CA = "CA"),
          (e.IE = "IE"),
          (e.DE = "DE"),
          (e.JP = "JP"),
          (e.FR = "FR"),
          (e.AU = "AU"),
          (e.IT = "IT"),
          (e.CH = "CH"),
          (e.AT = "AT"),
          (e.ES = "ES"),
          (e.NL = "NL"),
          (e.BE = "BE"),
          (e.DK = "DK"),
          (e.SE = "SE"),
          (e.NO = "NO"),
          (e.BR = "BR"),
          (e.PT = "PT"),
          (e.FI = "FI"),
          (e.AX = "AX"),
          (e.KR = "KR"),
          (e.CN = "CN"),
          (e.TW = "TW"),
          (e.SG = "SG"),
          (e.DZ = "DZ"),
          (e.AD = "AD"),
          (e.AR = "AR"),
          (e.AM = "AM"),
          (e.AZ = "AZ"),
          (e.BH = "BH"),
          (e.BD = "BD"),
          (e.BB = "BB"),
          (e.BY = "BY"),
          (e.BM = "BM"),
          (e.BA = "BA"),
          (e.IO = "IO"),
          (e.BN = "BN"),
          (e.BG = "BG"),
          (e.KH = "KH"),
          (e.CV = "CV"),
          (e.CL = "CL"),
          (e.CR = "CR"),
          (e.HR = "HR"),
          (e.CY = "CY"),
          (e.CZ = "CZ"),
          (e.DO = "DO"),
          (e.EC = "EC"),
          (e.EG = "EG"),
          (e.EE = "EE"),
          (e.FO = "FO"),
          (e.GE = "GE"),
          (e.GR = "GR"),
          (e.GL = "GL"),
          (e.GT = "GT"),
          (e.HT = "HT"),
          (e.HN = "HN"),
          (e.HU = "HU"),
          (e.IS = "IS"),
          (e.IN = "IN"),
          (e.ID = "ID"),
          (e.IL = "IL"),
          (e.JO = "JO"),
          (e.KZ = "KZ"),
          (e.KE = "KE"),
          (e.KW = "KW"),
          (e.KY = "KY"),
          (e.LA = "LA"),
          (e.LV = "LV"),
          (e.LB = "LB"),
          (e.LI = "LI"),
          (e.LT = "LT"),
          (e.LU = "LU"),
          (e.MK = "MK"),
          (e.MY = "MY"),
          (e.MV = "MV"),
          (e.MT = "MT"),
          (e.MU = "MU"),
          (e.MX = "MX"),
          (e.MD = "MD"),
          (e.MC = "MC"),
          (e.MA = "MA"),
          (e.NP = "NP"),
          (e.NZ = "NZ"),
          (e.NI = "NI"),
          (e.NG = "NG"),
          (e.OM = "OM"),
          (e.PA = "PA"),
          (e.PK = "PK"),
          (e.PY = "PY"),
          (e.PH = "PH"),
          (e.PL = "PL"),
          (e.PR = "PR"),
          (e.RO = "RO"),
          (e.RU = "RU"),
          (e.SM = "SM"),
          (e.SA = "SA"),
          (e.SN = "SN"),
          (e.SK = "SK"),
          (e.SI = "SI"),
          (e.ZA = "ZA"),
          (e.LK = "LK"),
          (e.TJ = "TJ"),
          (e.TH = "TH"),
          (e.TN = "TN"),
          (e.TR = "TR"),
          (e.TM = "TM"),
          (e.UA = "UA"),
          (e.UY = "UY"),
          (e.UZ = "UZ"),
          (e.VA = "VA"),
          (e.VE = "VE"),
          (e.ZM = "ZM"),
          (e.AS = "AS"),
          (e.CC = "CC"),
          (e.CK = "CK"),
          (e.RS = "RS"),
          (e.ME = "ME"),
          (e.CS = "CS"),
          (e.YU = "YU"),
          (e.CX = "CX"),
          (e.ET = "ET"),
          (e.FK = "FK"),
          (e.NF = "NF"),
          (e.FM = "FM"),
          (e.GF = "GF"),
          (e.GN = "GN"),
          (e.GP = "GP"),
          (e.GS = "GS"),
          (e.GU = "GU"),
          (e.GW = "GW"),
          (e.HM = "HM"),
          (e.IQ = "IQ"),
          (e.KG = "KG"),
          (e.LR = "LR"),
          (e.LS = "LS"),
          (e.MG = "MG"),
          (e.MH = "MH"),
          (e.MN = "MN"),
          (e.MP = "MP"),
          (e.MQ = "MQ"),
          (e.NC = "NC"),
          (e.NE = "NE"),
          (e.VI = "VI"),
          (e.VN = "VN"),
          (e.PF = "PF"),
          (e.PG = "PG"),
          (e.PM = "PM"),
          (e.PN = "PN"),
          (e.PW = "PW"),
          (e.RE = "RE"),
          (e.SH = "SH"),
          (e.SJ = "SJ"),
          (e.SO = "SO"),
          (e.SZ = "SZ"),
          (e.TC = "TC"),
          (e.WF = "WF"),
          (e.XK = "XK"),
          (e.YT = "YT"),
          (e.PE = "PE"),
          (e.GI = "GI"),
          (e.BT = "BT"),
          (e.AL = "AL"),
          (e.CU = "CU"),
          (e.UM = "UM"),
          (e.AI = "AI"),
          (e.AF = "AF"),
          (e.SD = "SD"),
          (e.VC = "VC"),
          (e.TA = "TA"),
          (e.NA = "NA"),
          (e.EH = "EH"),
          (e.BL = "BL"),
          (e.TZ = "TZ"),
          (e.AC = "AC"),
          (e.VG = "VG"),
          (e.MZ = "MZ"),
          (e.MF = "MF"),
          (e.MM = "MM"),
          (e.SV = "SV"),
          (e.IR = "IR"),
          (e.INTL = "INTL"),
          (e.CO = "CO");
      })(Y_ || (Y_ = {}));
      const ey = new Map([
          [
            Y_.UK,
            /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
          ],
          [
            Y_.GB,
            /^([A-Z]){1}([0-9][0-9]|[0-9]|[A-Z][0-9][A-Z]|[A-Z][0-9][0-9]|[A-Z][0-9]|[0-9][A-Z]){1}([ ])?([0-9][A-z][A-z]){1}$/i,
          ],
          [Y_.JE, /^JE\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
          [Y_.GG, /^GY\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
          [Y_.IM, /^IM\d[\dA-Z]?[ ]?\d[ABD-HJLN-UW-Z]{2}$/],
          [Y_.US, /^([0-9]{5})(?:-([0-9]{4}))?$/],
          [
            Y_.CA,
            /^([ABCEGHJKLMNPRSTVXY][0-9][ABCEGHJKLMNPRSTVWXYZ])\s*([0-9][ABCEGHJKLMNPRSTVWXYZ][0-9])$/i,
          ],
          [Y_.IE, /^([AC-FHKNPRTV-Y][0-9]{2}|D6W)[ -]?[0-9AC-FHKNPRTV-Y]{4}$/],
          [Y_.DE, /^\d{5}$/],
          [Y_.JP, /^\d{3}-\d{4}$/],
          [Y_.FR, /^\d{2}[ ]?\d{3}$/],
          [Y_.AU, /^\d{4}$/],
          [Y_.IT, /^\d{5}$/],
          [Y_.CH, /^\d{4}$/],
          [Y_.AT, /^(?!0)\d{4}$/],
          [Y_.ES, /^(?:0[1-9]|[1-4]\d|5[0-2])\d{3}$/],
          [Y_.NL, /^\d{4}[ ]?[A-Z]{2}$/],
          [Y_.BE, /^\d{4}$/],
          [Y_.DK, /^\d{4}$/],
          [Y_.SE, /^(SE-)?\d{3}[ ]?\d{2}$/],
          [Y_.NO, /^\d{4}$/],
          [Y_.BR, /^\d{5}[\-]?\d{3}$/],
          [Y_.PT, /^\d{4}([\-]\d{3})?$/],
          [Y_.FI, /^(FI-|AX-)?\d{5}$/],
          [Y_.AX, /^22\d{3}$/],
          [Y_.KR, /^\d{5}$/],
          [Y_.CN, /^\d{6}$/],
          [Y_.TW, /^\d{3}(\d{2,3})?$/],
          [Y_.SG, /^\d{6}$/],
          [Y_.DZ, /^\d{5}$/],
          [Y_.AD, /^AD\d{3}$/],
          [Y_.AR, /^([A-HJ-NP-Z])?\d{4}([A-Z]{3})?$/],
          [Y_.AM, /^(37)?\d{4}$/],
          [Y_.AZ, /^\d{4}$/],
          [Y_.BH, /^((1[0-2]|[2-9])\d{2})?$/],
          [Y_.BD, /^\d{4}$/],
          [Y_.BB, /^(BB\d{5})?$/],
          [Y_.BY, /^\d{6}$/],
          [Y_.BM, /^[A-Z]{2}[ ]?[A-Z0-9]{2}$/],
          [Y_.BA, /^\d{5}$/],
          [Y_.IO, /^BBND 1ZZ$/],
          [Y_.BN, /^[A-Z]{2}[ ]?\d{4}$/],
          [Y_.BG, /^\d{4}$/],
          [Y_.KH, /^\d{5}$/],
          [Y_.CV, /^\d{4}$/],
          [Y_.CL, /^\d{7}$/],
          [Y_.CR, /^(\d{4,5}|\d{3}-\d{4})$/],
          [Y_.HR, /^(HR-)?\d{5}$/],
          [Y_.CY, /^\d{4}$/],
          [Y_.CZ, /^\d{3}[ ]?\d{2}$/],
          [Y_.DO, /^\d{5}$/],
          [Y_.EC, /^([A-Z]\d{4}[A-Z]|(?:[A-Z]{2})?\d{6})?$/],
          [Y_.EG, /^\d{5}$/],
          [Y_.EE, /^\d{5}$/],
          [Y_.FO, /^\d{3}$/],
          [Y_.GE, /^\d{4}$/],
          [Y_.GR, /^\d{3}[ ]?\d{2}$/],
          [Y_.GL, /^39\d{2}$/],
          [Y_.GT, /^\d{5}$/],
          [Y_.HT, /^\d{4}$/],
          [Y_.HN, /^(?:\d{5})?$/],
          [Y_.HU, /^\d{4}$/],
          [Y_.IS, /^\d{3}$/],
          [Y_.IN, /^\d{6}$/],
          [Y_.ID, /^\d{5}$/],
          [Y_.IL, /^\d{5,7}$/],
          [Y_.JO, /^\d{5}$/],
          [Y_.KZ, /^\d{6}$/],
          [Y_.KE, /^\d{5}$/],
          [Y_.KW, /^\d{5}$/],
          [Y_.KY, /^KY[123]-\d{4}$/],
          [Y_.LA, /^\d{5}$/],
          [Y_.LV, /^(LV-)?\d{4}$/],
          [Y_.LB, /^(\d{4}([ ]?\d{4})?)?$/],
          [Y_.LI, /^(948[5-9])|(949[0-7])$/],
          [Y_.LT, /^(LT-)?\d{5}$/],
          [Y_.LU, /^(L-)?\d{4}$/],
          [Y_.MK, /^\d{4}$/],
          [Y_.MY, /^\d{5}$/],
          [Y_.MV, /^\d{5}$/],
          [Y_.MT, /^[A-Z]{3}[ ]?\d{2,4}$/],
          [Y_.MU, /^((\d|[A-Z])\d{4})?$/],
          [Y_.MX, /^\d{5}$/],
          [Y_.MD, /^\d{4}$/],
          [Y_.MC, /^980\d{2}$/],
          [Y_.MA, /^\d{5}$/],
          [Y_.NP, /^\d{5}$/],
          [Y_.NZ, /^\d{4}$/],
          [Y_.NI, /^((\d{4}-)?\d{3}-\d{3}(-\d{1})?)?$/],
          [Y_.NG, /^(\d{6})?$/],
          [Y_.OM, /^(PC )?\d{3}$/],
          [Y_.PA, /^\d{4}$/],
          [Y_.PK, /^\d{5}$/],
          [Y_.PY, /^\d{4}$/],
          [Y_.PH, /^\d{4}$/],
          [Y_.PL, /^\d{2}-\d{3}$/],
          [Y_.PR, /^00[679]\d{2}([ \-]\d{4})?$/],
          [Y_.RO, /^\d{6}$/],
          [Y_.RU, /^\d{6}$/],
          [Y_.SM, /^4789\d$/],
          [Y_.SA, /^\d{5}$/],
          [Y_.SN, /^\d{5}$/],
          [Y_.SK, /^\d{3}[ ]?\d{2}$/],
          [Y_.SI, /^(SI-)?\d{4}$/],
          [Y_.ZA, /^\d{4}$/],
          [Y_.LK, /^\d{5}$/],
          [Y_.TJ, /^\d{6}$/],
          [Y_.TH, /^\d{5}$/],
          [Y_.TN, /^\d{4}$/],
          [Y_.TR, /^\d{5}$/],
          [Y_.TM, /^\d{6}$/],
          [Y_.UA, /^\d{5}$/],
          [Y_.UY, /^\d{5}$/],
          [Y_.UZ, /^\d{6}$/],
          [Y_.VA, /^00120$/],
          [Y_.VE, /^\d{4}$/],
          [Y_.ZM, /^\d{5}$/],
          [Y_.AS, /^96799$/],
          [Y_.CC, /^6799$/],
          [Y_.CK, /^\d{4}$/],
          [Y_.RS, /^\d{5,6}$/],
          [Y_.ME, /^8\d{4}$/],
          [Y_.CS, /^\d{5}$/],
          [Y_.YU, /^\d{5}$/],
          [Y_.CX, /^6798$/],
          [Y_.ET, /^\d{4}$/],
          [Y_.FK, /^FIQQ 1ZZ$/],
          [Y_.NF, /^2899$/],
          [Y_.FM, /^(9694[1-4])([ \-]\d{4})?$/],
          [Y_.GF, /^9[78]3\d{2}$/],
          [Y_.GN, /^\d{3}$/],
          [Y_.GP, /^9[78][01]\d{2}$/],
          [Y_.GS, /^SIQQ 1ZZ$/],
          [Y_.GU, /^969[123]\d([ \-]\d{4})?$/],
          [Y_.GW, /^\d{4}$/],
          [Y_.HM, /^\d{4}$/],
          [Y_.IQ, /^\d{5}$/],
          [Y_.KG, /^\d{6}$/],
          [Y_.LR, /^\d{4}$/],
          [Y_.LS, /^\d{3}$/],
          [Y_.MG, /^\d{3}$/],
          [Y_.MH, /^969[67]\d([ \-]\d{4})?$/],
          [Y_.MN, /^\d{5}$/],
          [Y_.MP, /^9695[012]([ \-]\d{4})?$/],
          [Y_.MQ, /^9[78]2\d{2}$/],
          [Y_.NC, /^988\d{2}$/],
          [Y_.NE, /^\d{4}$/],
          [Y_.VI, /^008(([0-4]\d)|(5[01]))([ \-]\d{4})?$/],
          [Y_.VN, /^\d{6}$/],
          [Y_.PF, /^987\d{2}$/],
          [Y_.PG, /^\d{3}$/],
          [Y_.PM, /^9[78]5\d{2}$/],
          [Y_.PN, /^PCRN 1ZZ$/],
          [Y_.PW, /^96940$/],
          [Y_.RE, /^9[78]4\d{2}$/],
          [Y_.SH, /^(ASCN|STHL) 1ZZ$/],
          [Y_.SJ, /^\d{4}$/],
          [Y_.SO, /^\d{5}$/],
          [Y_.SZ, /^[HLMS]\d{3}$/],
          [Y_.TC, /^TKCA 1ZZ$/],
          [Y_.WF, /^986\d{2}$/],
          [Y_.XK, /^\d{5}$/],
          [Y_.YT, /^976\d{2}$/],
          [Y_.GI, /^GX11 1AA/],
          [Y_.BT, /^\d{5}/],
          [Y_.AL, /^\d{4}/],
          [Y_.CU, /^\d{5}/],
          [Y_.UM, /^96898/],
          [Y_.AI, /^(?:AI-)?2640/],
          [Y_.AF, /^\d{4}/],
          [Y_.SD, /^\d{5}/],
          [Y_.VC, /^VC\d{4}/],
          [Y_.TA, /^TDCU 1ZZ/],
          [Y_.NA, /^\d{5}/],
          [Y_.EH, /^\d{5}/],
          [Y_.BL, /^9[78][01]\d{2}/],
          [Y_.TZ, /^\d{4,5}/],
          [Y_.AC, /^ASCN 1ZZ/],
          [Y_.VG, /^VG\d{4}/],
          [Y_.MZ, /^\d{4}/],
          [Y_.MF, /^9[78][01]\d{2}/],
          [Y_.MM, /^\d{5}/],
          [Y_.SV, /^CP [1-3][1-7][0-2]\d/],
          [Y_.IR, /^\d{5}-?\d{5}/],
          [Y_.PE, /^[0-2]\d{4}$/],
          [Y_.INTL, /^(?:[A-Z0-9]+([- ]?[A-Z0-9]+)*)?$/i],
          [
            Y_.CO,
            /^(0[58]|1[135789]|2[0357]|4[147]|5[024]|6[368]|7[036]|8[1568]|9[4579])\d{4}$/,
          ],
        ]),
        ty = (e, t) => {
          if (!ey.has(t)) throw Error(`Invalid country code: ${t}`);
          return ey.get(t).test(e);
        };
      var ny = new RegExp("^[0-9]+$"),
        ry = new RegExp(""),
        oy = function (e) {
          return !e.match(Db);
        },
        ay = function (e) {
          var t = ny.test(e),
            n = (null == e ? void 0 : e.length) >= 10;
          return !t || !n;
        },
        iy = function (e) {
          return !e.match(ry);
        },
        sy = function (e, t) {
          var n = (0, Xg.getCountries)(),
            r = (function (e, t, n) {
              if (n || 2 === arguments.length)
                for (var r, o = 0, a = t.length; o < a; o++)
                  (!r && o in t) ||
                    (r || (r = Array.prototype.slice.call(t, 0, o)),
                    (r[o] = t[o]));
              return e.concat(r || Array.prototype.slice.call(t));
            })(
              [],
              null == n
                ? void 0
                : n.map(function (e) {
                    return null == e ? void 0 : e.code;
                  }),
              !0
            );
          return (
            !(null == r ? void 0 : r.includes(t)) ||
            !ty(e, null == t ? void 0 : t.toUpperCase())
          );
        },
        ly = function () {
          return (
            (ly =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            ly.apply(this, arguments)
          );
        },
        dy = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        cy = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function uy() {
        var n,
          r = this,
          o = ee().t,
          a = xv(),
          i = a.filterprovince,
          s = a.getProvinceOfShopify,
          l = a.getCountriesList,
          d = g(),
          c = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          u = (0, t.useState)(
            null !== (n = null == c ? void 0 : c.editDraftOrder) && void 0 !== n
              ? n
              : {}
          ),
          p = u[0],
          m = u[1],
          h = (0, t.useState)({
            customerName: "",
            mobileNumber: "",
            emailId: "",
            companyName: "",
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            city: "",
            zipNumber: "",
            shippingAddress: "",
            selectCountry: "",
            selectCountryCode: "",
            selectCountryState: "",
            countriesStateData: [],
            billingAddress: "",
            billing_mobileNumber: "",
            billing_companyName: "",
            billing_firstName: "",
            billing_lastName: "",
            billing_address1: "",
            billing_address2: "",
            billing_city: "",
            billing_zipNumber: "",
            billing_selectCountry: "",
            billing_selectCountryCode: "",
            billing_selectCountryState: "",
            billing_countriesStateData: [],
          }),
          f = h[0],
          v = h[1],
          b = (0, t.useState)({
            firstName: "",
            lastName: "",
            address1: "",
            address2: "",
            selectCountry: "",
            selectCountryState: "",
            city: "",
            zipNumber: "",
            companyName: "",
            mobileNumber: "",
          }),
          _ = b[0],
          C = b[1],
          x = (0, t.useState)("isShippingAddress"),
          S = x[0],
          k = x[1],
          P = (0, t.useState)(!1),
          w = P[0],
          O = P[1],
          T = (0, t.useState)(!1),
          I = T[0],
          M = T[1],
          j = (0, t.useState)(!1),
          N = j[0],
          D = j[1],
          E = (0, t.useState)(!1),
          R = E[0],
          L = E[1],
          B = (0, t.useState)([]),
          z = B[0],
          Z = B[1],
          H = (0, t.useState)(!1),
          V = H[0],
          W = H[1],
          U = (0, t.useState)(!1),
          $ = U[0],
          K = U[1],
          G = (0, t.useState)(!1),
          q = G[0],
          Q = G[1],
          Y = (0, t.useState)([]),
          J = Y[0],
          X = Y[1],
          te = c.baseData.select ? c.baseData.select : {},
          ne = (0, t.useState)(!1),
          re = ne[0],
          oe = ne[1],
          ae = (0, t.useState)({
            customername: !1,
            email: !1,
            mobileNumber: !1,
            zipNumber: !1,
          }),
          ie = ae[0],
          se = ae[1],
          le = [
            {
              label: o("Edit_Shipping_Address"),
              action: "Edit_shipping_address",
            },
            {
              label: o("Edit_Billing_Address"),
              action: "Edit_billing_address",
            },
            {
              label: o("RemoveCustomer_Msg"),
              action: "Remove_customer",
              sx: { color: "#C70A24" },
            },
          ],
          de = function (e, t) {
            d({ payload: e, type: t });
          },
          ce = (0, t.useCallback)(
            function (e, t) {
              v(function (n) {
                var r;
                return ly(ly({}, n), (((r = {})[e] = t), r));
              }),
                D(!0);
            },
            [v]
          ),
          ue = function () {
            v(function (e) {
              return ly(ly({}, e), {
                mobileNumber: "",
                emailId: "",
                companyName: "",
                shippingAddress: "",
                countriesStateData: [],
                billingAddress: "",
                billing_mobileNumber: "",
                billing_companyName: "",
                billing_countriesStateData: [],
              });
            }),
              X([]),
              Z([]),
              K(!1),
              de({}, A.CREATE_ORDER_TAB);
          },
          pe = function () {
            v(
              ly(ly({}, f), {
                customerName: "",
                mobileNumber: "",
                emailId: "",
                companyName: "",
                firstName: "",
                lastName: "",
                address1: "",
                address2: "",
                city: "",
                zipNumber: "",
                shippingAddress: "",
                selectCountry: "",
                selectCountryCode: "",
                selectCountryState: "",
                countriesStateData: [],
                billingAddress: "",
                billing_mobileNumber: "",
                billing_companyName: "",
                billing_firstName: "",
                billing_lastName: "",
                billing_address1: "",
                billing_address2: "",
                billing_city: "",
                billing_zipNumber: "",
                billing_selectCountry: "",
                billing_selectCountryCode: "",
                billing_selectCountryState: "",
                billing_countriesStateData: [],
              })
            ),
              m({});
          },
          me = function (e, t) {
            var n;
            return (
              void 0 === t && (t = ""),
              ((n = {})["".concat(t, "firstName")] =
                (null == e ? void 0 : e.first_name) || ""),
              (n["".concat(t, "lastName")] =
                (null == e ? void 0 : e.last_name) || ""),
              (n["".concat(t, "address1")] =
                (null == e ? void 0 : e.address1) || ""),
              (n["".concat(t, "address2")] =
                (null == e ? void 0 : e.address2) || ""),
              (n["".concat(t, "city")] = (null == e ? void 0 : e.city) || ""),
              (n["".concat(t, "zipNumber")] =
                (null == e ? void 0 : e.zip) || ""),
              (n["".concat(t, "selectCountry")] =
                (null == e ? void 0 : e.country) || ""),
              (n["".concat(t, "selectCountryState")] =
                (null == e ? void 0 : e.province) || ""),
              (n["".concat(t, "mobileNumber")] =
                (null == e ? void 0 : e.phone) || ""),
              (n["".concat(t, "companyName")] =
                (null == e ? void 0 : e.company) || ""),
              n
            );
          },
          he = function (e, t, n) {
            var r = { phoneNumber: "", companyName: "" };
            t
              ? ((r.phoneNumber = null == t ? void 0 : t.phoneNumber),
                (r.companyName = null == t ? void 0 : t.companyName))
              : ((r.phoneNumber = (null == f ? void 0 : f.mobileNumber)
                  ? null == f
                    ? void 0
                    : f.mobileNumber
                  : ""),
                (r.companyName = (null == f ? void 0 : f.companyName)
                  ? null == f
                    ? void 0
                    : f.companyName
                  : ""));
            var o =
              null == e
                ? void 0
                : e.find(function (e) {
                    return e.defaultAddr;
                  });
            o &&
              (o.phone || (o.phone = r.phoneNumber),
              o.company || (o.company = r.companyName),
              v(function (e) {
                return ly(
                  ly(
                    ly(ly({}, e), "isShippingAddress" === n ? me(o) : {}),
                    "isBillingAddress" === n ? me(o, "billing_") : {}
                  ),
                  void 0 === n ? ly(ly({}, me(o)), me(o, "billing_")) : {}
                );
              }),
              ve(
                null == o ? void 0 : o.country,
                null == o ? void 0 : o.province
              ));
          },
          fe = function (e) {
            return dy(r, void 0, void 0, function () {
              var t, n, r, o, a, i, s, l, c;
              return cy(this, function (u) {
                switch (u.label) {
                  case 0:
                    return (
                      Z([]),
                      e
                        ? (Bh.next(!0),
                          [
                            4,
                            d(
                              ng(
                                null !== (i = e.CustomerId) && void 0 !== i
                                  ? i
                                  : ""
                              )
                            ),
                          ])
                        : [3, 2]
                    );
                  case 1:
                    (t = u.sent()),
                      Bh.next(!1),
                      (n = { phoneNumber: "", companyName: "" }),
                      v(function (t) {
                        var n, r;
                        return ly(ly({}, t), {
                          customerName: (null !== (n = e.CustomerName) &&
                          void 0 !== n
                            ? n
                            : ""
                          ).trim()
                            ? e.CustomerName
                            : e.CustomerMailid,
                          emailId:
                            null !==
                              (r = null == e ? void 0 : e.CustomerMailid) &&
                            void 0 !== r
                              ? r
                              : "",
                        });
                      }),
                      oe(!0),
                      (n.companyName =
                        (null == e ? void 0 : e.CompanyName) || ""),
                      "" === e.CustomerPhoneno ||
                      null === e.CustomerPhoneno ||
                      void 0 === e.CustomerPhoneno
                        ? ((r = ge()), (n.phoneNumber = null != r ? r : ""))
                        : (n.phoneNumber =
                            null !== (s = e.CustomerPhoneno) && void 0 !== s
                              ? s
                              : ""),
                      t && F.getState().salesRepData.wholesalePriceData
                        ? be(t)
                        : (X([]),
                          de({ wholePriceArray: [] }, A.CREATE_ORDER_TAB)),
                      t &&
                        (Z(
                          null ===
                            (l =
                              F.getState().salesRepData
                                .customerNewUpdatedData) || void 0 === l
                            ? void 0
                            : l.customerAddressesList
                        ),
                        (o =
                          null === (c = null == t ? void 0 : t.payload) ||
                          void 0 === c
                            ? void 0
                            : c.customerAddressesList),
                        (a = (null == p ? void 0 : p.actionEvent) === Zg),
                        (null == o ? void 0 : o.length) > 0 && !a && he(o, n)),
                      (u.label = 2);
                  case 2:
                    return (
                      ((m = ly({}, ie)).customername = !1),
                      (m.email = !1),
                      (m.mobileNumber = !1),
                      (m.zipNumber = !1),
                      se(ly({}, m)),
                      [2]
                    );
                }
                var m;
              });
            });
          },
          ge = function () {
            var e,
              t,
              n =
                null ===
                  (t =
                    null ===
                      (e = F.getState().salesRepData.customerNewUpdatedData) ||
                    void 0 === e
                      ? void 0
                      : e.SingleShopifyCustomers) || void 0 === t
                  ? void 0
                  : t.phone;
            return null != n
              ? (v(function (e) {
                  return ly(ly({}, e), {
                    mobileNumber: n || "",
                    billing_mobileNumber: n || "",
                  });
                }),
                n)
              : "";
          },
          ve = function (e, t, n) {
            var r,
              o,
              a,
              d =
                null === (r = l()) || void 0 === r
                  ? void 0
                  : r.filter(function (t) {
                      var n;
                      return null ===
                        (n = null == t ? void 0 : t.name.toLowerCase()) ||
                        void 0 === n
                        ? void 0
                        : n.includes(null == e ? void 0 : e.toLowerCase());
                    }),
              c = e
                ? null === (o = d[0]) || void 0 === o
                  ? void 0
                  : o.name
                : "",
              u = s(c || ""),
              p =
                0 != (null == u ? void 0 : u.length)
                  ? u
                  : (0, Xg.getStates)(
                      null === (a = d[0]) || void 0 === a ? void 0 : a.code
                    ),
              m = i(null != p ? p : [], d[0].code),
              h = m.find(function (e) {
                return (
                  e.toLowerCase() === (null == t ? void 0 : t.toLowerCase())
                );
              });
            v(function (e) {
              var t, r, o, a;
              return ly(
                ly(
                  ly(
                    ly({}, e),
                    n === Yg && {
                      selectCountryCode: c
                        ? null === (t = d[0]) || void 0 === t
                          ? void 0
                          : t.code
                        : "",
                      countriesStateData: m || "",
                      selectCountryState: h || "",
                    }
                  ),
                  n === Jg && {
                    billing_selectCountryCode: c
                      ? null === (r = d[0]) || void 0 === r
                        ? void 0
                        : r.code
                      : "",
                    billing_countriesStateData: m || "",
                    billing_selectCountryState: h || "",
                  }
                ),
                void 0 === n && {
                  selectCountryCode: c
                    ? null === (o = d[0]) || void 0 === o
                      ? void 0
                      : o.code
                    : "",
                  countriesStateData: m || "",
                  selectCountryState: h || "",
                  billing_selectCountryCode: c
                    ? null === (a = d[0]) || void 0 === a
                      ? void 0
                      : a.code
                    : "",
                  billing_countriesStateData: m || "",
                  billing_selectCountryState: h || "",
                }
              );
            });
          },
          be = function (e) {
            var t, n, r, o, a, i, s, l;
            X([]);
            var d =
              null !==
                (n =
                  null === (t = F.getState().salesRepData) || void 0 === t
                    ? void 0
                    : t.createOrderTab) && void 0 !== n
                ? n
                : {};
            de(ly(ly({}, d), { wholePriceArray: [] }), A.CREATE_ORDER_TAB);
            var c = {},
              u =
                F.getState().salesRepData.wholesalePriceData.AllWholesalePrices,
              p =
                null ===
                  (a =
                    null ===
                      (o =
                        null === (r = null == e ? void 0 : e.payload) ||
                        void 0 === r
                          ? void 0
                          : r.SingleShopifyCustomers) || void 0 === o
                      ? void 0
                      : o.tags) || void 0 === a
                  ? void 0
                  : a.split(","),
              m =
                null == p
                  ? void 0
                  : p.some(function (e) {
                      var t;
                      return null ===
                        (t = null == e ? void 0 : e.toLowerCase()) ||
                        void 0 === t
                        ? void 0
                        : t.includes("price_");
                    });
            if ((null == te ? void 0 : te.PriceList) && m && null != u)
              try {
                var h = Object.keys(JSON.parse(u[Object.keys(u)[0]])),
                  f =
                    (null ===
                      (i =
                        null == p
                          ? void 0
                          : p.find(function (e) {
                              var t;
                              return null == h
                                ? void 0
                                : h.includes(
                                    null === (t = e.trim()) || void 0 === t
                                      ? void 0
                                      : t.toLowerCase()
                                  );
                            })) || void 0 === i
                      ? void 0
                      : i.toLowerCase().trim()) || "";
                f &&
                  (null ===
                    (l =
                      null === (s = Object.keys(u)) || void 0 === s
                        ? void 0
                        : s.map(function (e) {
                            var t, n;
                            try {
                              var r = JSON.parse(u[e]),
                                o = null !== (n = r[f]) && void 0 !== n ? n : 0,
                                a =
                                  !isNaN(parseFloat(o)) &&
                                  isFinite(parseFloat(o))
                                    ? parseFloat(o)
                                    : 0;
                              return (
                                (c = ly(ly({}, c), (((t = {})[e] = a), t))),
                                { variantId: e, wholesalePrice: r[f] }
                              );
                            } catch (e) {
                              return null;
                            }
                          })) ||
                    void 0 === l ||
                    l.filter(function (e) {
                      return null !== e;
                    }),
                  X(c),
                  de(ly(ly({}, d), { wholePriceObj: c }), A.CREATE_ORDER_TAB));
              } catch (e) {
                return [];
              }
          },
          _e = function (t) {
            return (null == t ? void 0 : t.firstName) ||
              (null == t ? void 0 : t.lastName) ||
              (null == t ? void 0 : t.address1) ||
              (null == t ? void 0 : t.address2) ||
              (null == t ? void 0 : t.city) ||
              (null == t ? void 0 : t.selectCountryState) ||
              (null == t ? void 0 : t.selectCountry) ||
              (null == t ? void 0 : t.zipNumber) ||
              (null == t ? void 0 : t.companyName) ||
              (null == t ? void 0 : t.mobileNumber)
              ? (0, e.jsxs)(
                  ni,
                  ly(
                    { variant: "body1" },
                    {
                      children: [
                        (null == t ? void 0 : t.firstName) || "",
                        " ",
                        (null == t ? void 0 : t.lastName) || "",
                        " ",
                        (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.companyName) || "",
                        " ",
                        (null == t ? void 0 : t.companyName) &&
                          (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.address1) || "",
                        " ",
                        (null == t ? void 0 : t.address1) &&
                          (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.address2) || "",
                        " ",
                        (null == t ? void 0 : t.address2) &&
                          (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.zipNumber) || "",
                        " ",
                        (null == t ? void 0 : t.city) || "",
                        " ",
                        (null == t ? void 0 : t.selectCountryState) || "",
                        " ",
                        ((null == t ? void 0 : t.zipNumber) ||
                          (null == t ? void 0 : t.city) ||
                          (null == t ? void 0 : t.selectCountryState)) &&
                          (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.selectCountry) || "",
                        " ",
                        (null == t ? void 0 : t.selectCountry) &&
                          (0, e.jsx)("br", {}),
                        (null == t ? void 0 : t.mobileNumber) || "",
                      ],
                    }
                  )
                )
              : (0, e.jsx)(
                  ni,
                  ly(
                    { variant: "body1", color: "textSecondary" },
                    { children: "No Address Found" }
                  )
                );
          };
        return {
          customerInfo: f,
          t: o,
          dispatch: d,
          salesRepData: c,
          addDetailsBtn: V,
          setAddDetailsBtn: W,
          addShippingAddressBtn: $,
          setAddShippingAddressBtn: K,
          errors: ie,
          setErrors: se,
          EmptyFields: ue,
          SearchByCustomer: fe,
          SearchByCountry: function (e) {
            var t, n, r;
            v(function (e) {
              return ly(
                ly({}, e),
                S === Yg
                  ? { countriesStateData: [], selectCountryState: "" }
                  : {
                      billing_countriesStateData: [],
                      billing_selectCountryState: "",
                    }
              );
            });
            var o =
                null === (t = l()) || void 0 === t
                  ? void 0
                  : t.filter(function (t) {
                      var n;
                      return null ===
                        (n = null == t ? void 0 : t.name.toLowerCase()) ||
                        void 0 === n
                        ? void 0
                        : n.includes(e.toLowerCase());
                    }),
              a = null === (n = o[0]) || void 0 === n ? void 0 : n.name,
              d = s(a || ""),
              c =
                0 != (null == d ? void 0 : d.length)
                  ? d
                  : (0, Xg.getStates)(
                      null === (r = o[0]) || void 0 === r ? void 0 : r.code
                    );
            v(function (e) {
              var t, n, r, a;
              return ly(
                ly({}, e),
                S === Yg
                  ? {
                      selectCountryCode:
                        null === (t = o[0]) || void 0 === t ? void 0 : t.code,
                      countriesStateData: i(
                        null != c ? c : [],
                        null !== (n = o[0].code) && void 0 !== n ? n : ""
                      ),
                    }
                  : {
                      billing_selectCountryCode:
                        null === (r = o[0]) || void 0 === r ? void 0 : r.code,
                      billing_countriesStateData: i(
                        null != c ? c : [],
                        null !== (a = o[0].code) && void 0 !== a ? a : ""
                      ),
                    }
              );
            });
          },
          checkValidation: function (e, t, n) {
            var r = ly({}, ie),
              a = e.target.name;
            switch (t) {
              case "validateOnemail":
                oy(e.target.value.trim())
                  ? ((r[a] = !0),
                    "email" === a &&
                      (r[a] =
                        "" === e.target.value.trim()
                          ? o("customerInvoice_RequiredErrorMsg")
                          : o("customerInvoice_EmailSuggestionErrorMsg")))
                  : (r[a] = !1);
                break;
              case "validateOnmobileNumber":
                ay(e.target.value.trim())
                  ? ((r[a] = !0),
                    "mobileNumber" === a &&
                      (r[a] =
                        "" !== e.target.value.trim()
                          ? o("customerInvoice_MobileSuggestionErrorMsg")
                          : ""))
                  : (r[a] = !1);
                break;
              case "validateOnstring":
                iy(e.target.value)
                  ? ((r[a] = !0),
                    "customername" === a &&
                      (r[a] =
                        "" === e.target.value
                          ? o("customerInvoice_RequiredErrorMsg")
                          : ""))
                  : (r[a] = !1);
                break;
              case "validateOnzipNumber":
                var i = "";
                n && (i = n),
                  i && sy(e.target.value, i)
                    ? ((r[a] = !0),
                      "zipNumber" === a &&
                        (r[a] = o("Customer_Invalid_pinCode_Msg")))
                    : (r[a] = !1);
            }
            se(ly({}, r));
          },
          setOrderCreateBtn: Q,
          orderCreateBtn: q,
          tagWiseWholeSalePrices: J,
          customerAddressOptionsData: z,
          setCustomerAddressOptionsData: Z,
          editOrderReduxData: p,
          handleCustomerChange: function (e, t) {
            fe(t),
              "string" == typeof t
                ? v(function (e) {
                    return ly(ly({}, e), { customerName: "" });
                  })
                : t && t.inputValue
                ? (v(function (e) {
                    return ly(ly({}, e), { customerName: t.inputValue });
                  }),
                  ("" === t && "" === f.customerName) || ue())
                : null === t && ue();
          },
          handleGetOptionLabel: function (e) {
            return "string" == typeof e
              ? e
              : e.inputValue
              ? e.inputValue
              : e.CustomerName;
          },
          setEditOrderReduxData: m,
          setTagWiseWholeSalePrices: X,
          handleSelectShippingAddress: function (e) {
            var t,
              n,
              r,
              o =
                null !==
                  (n =
                    null === (t = F.getState().salesRepData) || void 0 === t
                      ? void 0
                      : t.createOrderTab) && void 0 !== n
                  ? n
                  : {},
              a =
                null === (r = e.target.value) || void 0 === r
                  ? void 0
                  : r.toString();
            v(function (e) {
              return ly(ly({}, e), { shippingAddress: a });
            }),
              de(
                ly(ly({}, o), { customer_shippingaddressID: a }),
                A.CREATE_ORDER_TAB
              );
          },
          handleUpdateReduxState: de,
          setCustomerInfo: v,
          handleManualAddressChange: ce,
          EmptyAllFieldsOnSuccess: pe,
          orderCreatedSuccesfullyFlag: R,
          setOrderCreatedSuccesfullyFlag: L,
          getCountriesList: l,
          setCustomerDefaultAddress: C,
          customerDefaultAddress: _,
          addressType: S,
          handleNewCustomerModal: function () {
            O(!w);
          },
          handleMenuAction: function (e) {
            var t,
              n = {
                Remove_customer: function () {
                  pe(), oe(!re);
                },
                Edit_shipping_address: function () {
                  k("isShippingAddress"), M(!I);
                },
                Edit_billing_address: function () {
                  k("isBillingAddress"), M(!I);
                },
              };
            null === (t = n[e]) || void 0 === t || t.call(n);
          },
          newCustomerModal: w,
          addressModal: I,
          handleAddressModal: function () {
            M(!I);
          },
          isEditAddress: N,
          cancelAddressModal: function (e) {
            D(!1),
              M(!I),
              (null == p ? void 0 : p.actionEvent) === Zg
                ? (function (e, t) {
                    var n =
                        t === Yg &&
                        ((null == e
                          ? void 0
                          : e.find(function (e) {
                              return 12345 === e.id;
                            })) ||
                          (null == e
                            ? void 0
                            : e.find(function (e) {
                                return (
                                  e.id ===
                                  (null == f ? void 0 : f.shippingAddress)
                                );
                              })) ||
                          (null == e
                            ? void 0
                            : e.find(function (e) {
                                return e.defaultAddr;
                              }))),
                      r =
                        t === Jg &&
                        ((null == e
                          ? void 0
                          : e.find(function (e) {
                              return 678910 === e.id;
                            })) ||
                          (null == e
                            ? void 0
                            : e.find(function (e) {
                                return (
                                  e.id ===
                                  (null == f ? void 0 : f.billingAddress)
                                );
                              })) ||
                          (null == e
                            ? void 0
                            : e.find(function (e) {
                                return e.defaultAddr;
                              })));
                    v(function (e) {
                      return ly(
                        ly(ly({}, e), t === Yg ? me(n) : {}),
                        t === Jg ? me(r, "billing_") : {}
                      );
                    }),
                      t === Yg
                        ? ve(
                            null == n ? void 0 : n.country,
                            null == n ? void 0 : n.province,
                            t
                          )
                        : ve(
                            null == r ? void 0 : r.country,
                            null == r ? void 0 : r.province,
                            t
                          );
                  })(z, e)
                : he(z, {}, e);
          },
          handleSelectAddress: function (e, t) {
            var n,
              r =
                null === (n = e.target.value) || void 0 === n
                  ? void 0
                  : n.toString(),
              o = z.find(function (e) {
                return e.id.toString() === r;
              });
            if (o) {
              var a = t === Yg ? "" : "billing_";
              v(function (e) {
                return ly(ly({}, e), me(o, a));
              }),
                D(!0),
                ve(o.country, o.province, t);
            } else console.error("Address not found");
          },
          handleAutoCountryStateSet: ve,
          setIsEditAddress: D,
          manageMenuItems: le,
          getCustomerAddressData: function (t) {
            return t === Yg
              ? _e(f)
              : t === Jg
              ? _e({
                  firstName: null == f ? void 0 : f.billing_firstName,
                  lastName: null == f ? void 0 : f.billing_lastName,
                  address1: null == f ? void 0 : f.billing_address1,
                  address2: null == f ? void 0 : f.billing_address2,
                  city: null == f ? void 0 : f.billing_city,
                  selectCountryState:
                    null == f ? void 0 : f.billing_selectCountryState,
                  selectCountry: null == f ? void 0 : f.billing_selectCountry,
                  zipNumber: null == f ? void 0 : f.billing_zipNumber,
                  companyName: null == f ? void 0 : f.billing_companyName,
                  mobileNumber: null == f ? void 0 : f.billing_mobileNumber,
                })
              : (0, e.jsx)(
                  ni,
                  ly(
                    { variant: "body1", color: "textSecondary" },
                    { children: "No Address Found" }
                  )
                );
          },
          isCustomerSelected: re,
          setIsCustomerSelected: oe,
        };
      }
      var py = function () {
          return (
            (py =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            py.apply(this, arguments)
          );
        },
        my = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        hy = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        fy = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function gy() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s,
          l,
          d,
          c,
          u,
          p,
          m,
          h,
          f,
          v,
          b,
          _ = this,
          C = g(),
          x = ee().t,
          S = xv().debounce,
          k = rf(),
          P = k.shopCurrency,
          w =
            (k.currency,
            y(function (e) {
              return e.salesRepData ? e.salesRepData : {};
            })),
          O = (null === (e = w.baseData) || void 0 === e ? void 0 : e.select)
            ? null === (n = w.baseData) || void 0 === n
              ? void 0
              : n.select
            : {},
          T = (0, t.useState)(""),
          I = T[0],
          M = T[1],
          j = (0, t.useState)(!1),
          N = j[0],
          D = j[1],
          E = (0, t.useState)(!1),
          R = E[0],
          L = E[1],
          B = (0, t.useState)([]),
          z = B[0],
          Z = B[1],
          H = (0, t.useState)([]),
          V = H[0],
          W = H[1],
          U = (0, t.useState)([]),
          $ = U[0],
          K = U[1],
          G = (0, t.useState)([]),
          q = G[0],
          Q = G[1],
          Y = (0, t.useState)({}),
          J = Y[0],
          X = Y[1],
          te = (0, t.useState)(0),
          ne = te[0],
          re = te[1],
          oe = (0, t.useState)([]),
          ae = oe[0],
          ie = oe[1],
          se = (0, t.useState)(!1),
          le = se[0],
          de = se[1],
          ce = (0, t.useState)(),
          ue = ce[0],
          pe = ce[1],
          me = (0, t.useState)(
            null !== (r = null == w ? void 0 : w.editDraftOrder) && void 0 !== r
              ? r
              : {}
          ),
          he = me[0],
          fe =
            (me[1],
            (null === (o = null == w ? void 0 : w.editDraftOrder) ||
            void 0 === o
              ? void 0
              : o.actionEvent) === Zg),
          ge =
            null === (a = null == w ? void 0 : w.editDraftOrder) || void 0 === a
              ? void 0
              : a.isUpdatedCart,
          ve =
            null !==
              (i = y(function () {
                return F.getState().salesRepData.createOrderTab;
              })) && void 0 !== i
              ? i
              : {},
          be = null !== (s = ve.wholePriceObj) && void 0 !== s ? s : {},
          _e =
            !(null == O ? void 0 : O.PriceList) ||
            "" === (null == ve ? void 0 : ve.customerName) ||
            0 ===
              (null === (l = Object.keys(be)) || void 0 === l
                ? void 0
                : l.length),
          ye = (0, t.useState)({ msg: "", open: !1, severity: "error" }),
          Ce = ye[0],
          xe = ye[1],
          Se = (0, t.useState)({}),
          ke = Se[0],
          Pe = Se[1],
          we =
            null === (d = F.getState().salesRepData.baseData) || void 0 === d
              ? void 0
              : d.storefrontAccessToken,
          Oe = y(function () {
            var e, t;
            return null !==
              (t =
                null === (e = F.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.collectionProductsData) && void 0 !== t
              ? t
              : [];
          }),
          Te = [],
          Ie = [],
          Me = "showSpecific" === O.featuresAdditionalSettings.showProducts,
          je =
            null !==
              (u =
                null === (c = null == w ? void 0 : w.baseData) || void 0 === c
                  ? void 0
                  : c.activeCollectionList) && void 0 !== u
              ? u
              : [],
          Ne = (0, t.useRef)(null),
          De = (0, t.useState)({}),
          Ae = De[0],
          Ee = De[1],
          Re = (0, t.useState)("percentage"),
          Le = Re[0],
          Be = Re[1],
          ze = (0, t.useState)({}),
          Fe = ze[0],
          Ze = ze[1],
          He = (0, t.useState)(!1),
          Ve = He[0],
          We = He[1],
          Ue = (0, t.useState)("percentage"),
          $e = Ue[0],
          Ke = Ue[1],
          Ge = (0, t.useState)(!1),
          qe = Ge[0],
          Qe = Ge[1],
          Ye =
            !!(null ===
              (p = null == O ? void 0 : O.featuresAdditionalSettings) ||
            void 0 === p
              ? void 0
              : p.showApplyDiscount) &&
            (null === (m = null == O ? void 0 : O.featuresAdditionalSettings) ||
            void 0 === m
              ? void 0
              : m.showApplyDiscount),
          Je =
            !!(null ===
              (f =
                null === (h = null == he ? void 0 : he.draftOrderObj) ||
                void 0 === h
                  ? void 0
                  : h.applied_discount) || void 0 === f
              ? void 0
              : f.value) &&
            (null ===
              (b =
                null === (v = null == he ? void 0 : he.draftOrderObj) ||
                void 0 === v
                  ? void 0
                  : v.applied_discount) || void 0 === b
              ? void 0
              : b.value),
          Xe = qe || Je,
          et = (0, t.useState)(0),
          tt = et[0],
          nt = et[1],
          rt = (0, t.useState)(!1),
          ot = rt[0],
          at = rt[1],
          it = function (e, t, n) {
            return my(_, void 0, void 0, function () {
              var r, o, a, i, s, l, d, c, u, p, m, h;
              return hy(this, function (f) {
                switch (f.label) {
                  case 0:
                    switch (t) {
                      case "add.js":
                        return [3, 1];
                      case "update.js":
                        return [3, 3];
                      case "change.js":
                        return [3, 4];
                      case "clear.js":
                        return [3, 5];
                    }
                    return [3, 6];
                  case 1:
                    return [4, C(Ig())];
                  case 2:
                    return (
                      (o = f.sent()),
                      (a =
                        null ===
                          (c =
                            null === (d = null == o ? void 0 : o.data) ||
                            void 0 === d
                              ? void 0
                              : d.items) || void 0 === c
                          ? void 0
                          : c.map(function (e) {
                              return null == e ? void 0 : e.variant_id;
                            })),
                      (i = new Set(a)),
                      (r =
                        null == e
                          ? void 0
                          : e.reduce(function (e, t) {
                              var n,
                                r = Number(
                                  null ===
                                    (n = null == t ? void 0 : t.variantId) ||
                                    void 0 === n
                                    ? void 0
                                    : n.split(
                                        "gid://shopify/ProductVariant/"
                                      )[1]
                                );
                              return (
                                (null == i ? void 0 : i.has(r)) ||
                                  e.push({
                                    id: r,
                                    quantity:
                                      (null == t ? void 0 : t.quantity) || 1,
                                  }),
                                e
                              );
                            }, [])),
                      [3, 7]
                    );
                  case 3:
                    return (r = n), [3, 7];
                  case 4:
                    return (
                      (s = Number(
                        null === (u = null == n ? void 0 : n.variantId) ||
                          void 0 === u
                          ? void 0
                          : u.split("gid://shopify/ProductVariant/")[1]
                      )),
                      (r = {
                        id: null == s ? void 0 : s.toString(),
                        quantity: null == n ? void 0 : n.quantity,
                      }),
                      [3, 7]
                    );
                  case 5:
                    return (r = {}), [3, 7];
                  case 6:
                    (r = {}), (f.label = 7);
                  case 7:
                    if (
                      (Bh.next(!0),
                      !(
                        (r &&
                          (null === (p = Object.keys(r)) || void 0 === p
                            ? void 0
                            : p.length) > 0) ||
                        "clear.js" === t
                      ))
                    )
                      return [3, 11];
                    f.label = 8;
                  case 8:
                    return f.trys.push([8, 10, , 11]), [4, C(Og(r, t))];
                  case 9:
                    return (
                      (l = f.sent()),
                      Bh.next(!1),
                      "boolean" == typeof l && l
                        ? [2, !0]
                        : ((
                            null ===
                              (m = null == l ? void 0 : l.toLowerCase()) ||
                            void 0 === m
                              ? void 0
                              : m.includes("can't add more")
                          )
                            ? xe({
                                msg: x("createOrder_ErrorMsgForQuantityLimit"),
                                open: !0,
                              })
                            : (
                                null ===
                                  (h = null == l ? void 0 : l.toLowerCase()) ||
                                void 0 === h
                                  ? void 0
                                  : h.includes("cannot find")
                              )
                            ? xe({
                                msg: x("ST_Producttable_CartResponse"),
                                open: !0,
                              })
                            : xe({ msg: l, open: !0 }),
                          [2, !1])
                    );
                  case 10:
                    return f.sent(), [2, !1];
                  case 11:
                    return Bh.next(!1), [2];
                }
              });
            });
          },
          st = (0, t.useCallback)(S(it, 600), []);
        (0, t.useEffect)(function () {
          fe || ge || _t();
        }, []),
          (0, t.useEffect)(
            function () {
              ie(V);
            },
            [le]
          ),
          (0, t.useEffect)(
            function () {
              var e = mt(J);
              nt(e), re(e), (Ye || Xe) && ct(e);
            },
            [J, ae, be, Ae]
          ),
          (0, t.useEffect)(
            function () {
              ie([]),
                ie(function (e) {
                  var t = fy(fy([], e, !0), V, !0);
                  return st(q, "add.js", t), t;
                });
            },
            [V, st]
          ),
          (0, t.useEffect)(
            function () {
              var e, t, n;
              J &&
                (null === (e = Object.keys(J)) || void 0 === e
                  ? void 0
                  : e.length) > 0 &&
                (null === (t = Object.keys(J)) ||
                  void 0 === t ||
                  t.forEach(function (e) {
                    var t =
                        null == q
                          ? void 0
                          : q.find(function (t) {
                              return e === (null == t ? void 0 : t.variantId);
                            }),
                      n = bt(t);
                    lt(e, n);
                  }),
                fe &&
                  ((null == O ? void 0 : O.PriceList) &&
                    (null === (n = null == Object ? void 0 : Object.keys(be)) ||
                    void 0 === n
                      ? void 0
                      : n.length) > 0 &&
                    xe({
                      msg: x("Edit_DraftOrderAlert_Msg"),
                      open: !0,
                      severity: "success",
                    }),
                  ht()));
            },
            [ve, ae]
          ),
          (0, t.useEffect)(
            function () {
              gt();
            },
            [J, Fe, ke]
          );
        var lt = function (e, t) {
            X(
              Ye
                ? function (n) {
                    var r,
                      o,
                      a =
                        (null === (o = n[e]) || void 0 === o
                          ? void 0
                          : o.quantity) || 1,
                      i = a * t;
                    if (null == Ae ? void 0 : Ae.hasOwnProperty(e)) {
                      var s = Ae[e];
                      "percentage" === Le && s >= 0 && s <= 100
                        ? (i -= (s * i) / 100)
                        : "percentage" !== Le &&
                          s >= 0 &&
                          s <= t &&
                          (i = a * (t - s));
                    }
                    return py(
                      py({}, n),
                      (((r = {})[e] = py(py({}, n[e]), { subtotal: i })), r)
                    );
                  }
                : function (n) {
                    var r;
                    return py(
                      py({}, n),
                      (((r = {})[e] = py(py({}, n[e]), {
                        subtotal: n[e].quantity * t,
                      })),
                      r)
                    );
                  }
            );
          },
          dt = function (e, t, n) {
            return my(_, void 0, void 0, function () {
              function r(e, n) {
                return my(this, void 0, void 0, function () {
                  var o, a, i, s;
                  return hy(this, function (l) {
                    switch (l.label) {
                      case 0:
                        return [4, Wf(I, we, n, t, e)];
                      case 1:
                        return (
                          (o = l.sent()),
                          (a = o.products),
                          (i = o.pageInfo),
                          a &&
                            (null == a ? void 0 : a.length) > 0 &&
                            ((s =
                              null == a
                                ? void 0
                                : a.filter(function (e) {
                                    if (
                                      !(null == Ie
                                        ? void 0
                                        : Ie.includes(e.productId))
                                    )
                                      return Ie.push(e.productId), e;
                                  })),
                            (Te = null == Te ? void 0 : Te.concat(s))),
                          (null == i ? void 0 : i.hasNextPage)
                            ? [4, r(e, i.endCursor)]
                            : [3, 3]
                        );
                      case 2:
                        l.sent(), (l.label = 3);
                      case 3:
                        return [2];
                    }
                  });
                });
              }
              var o, a, i, s, l, d, c, u;
              return hy(this, function (p) {
                switch (p.label) {
                  case 0:
                    return (
                      p.trys.push([0, 10, , 11]),
                      L(!0),
                      Me && (null == je ? void 0 : je.length) > 0
                        ? Oe && (null == Oe ? void 0 : Oe.length) > 0
                          ? ("" != n && "" !== I && Me ? pt(Oe) : Z(Oe), [3, 6])
                          : [3, 1]
                        : [3, 7]
                    );
                  case 1:
                    (o = 0), (a = je), (p.label = 2);
                  case 2:
                    return o < a.length
                      ? [4, r(null == (i = a[o]) ? void 0 : i.CollectionId)]
                      : [3, 5];
                  case 3:
                    p.sent(), (p.label = 4);
                  case 4:
                    return o++, [3, 2];
                  case 5:
                    (s = { payload: Te, type: A.COLLECTION_PRODUCTS_DATA }),
                      C(s),
                      Z(Te),
                      (p.label = 6);
                  case 6:
                    return [3, 9];
                  case 7:
                    return [
                      4,
                      Wf("" == n ? "" : I, we, e, t).then(function (e) {
                        return e;
                      }),
                    ];
                  case 8:
                    (l = p.sent()),
                      (d = l.products),
                      (c = l.pageInfo),
                      "" == n ? Z(d) : pt(d),
                      pe(c),
                      (p.label = 9);
                  case 9:
                    return L(!1), [3, 11];
                  case 10:
                    return (
                      (u = p.sent()),
                      console.error("Error fetching products:", u),
                      L(!1),
                      [3, 11]
                    );
                  case 11:
                    return [2];
                }
              });
            });
          },
          ct = function (e) {
            if (Ae.discountOnSubTotal) {
              var t = parseFloat(Ae.discountOnSubTotal);
              t &&
                ("percentage" === Le
                  ? void 0 !== t && t >= 0 && t <= 100 && re(e - (e * t) / 100)
                  : void 0 !== t && t >= 0 && t <= e && re(e - t));
            }
          },
          ut = function () {
            return my(_, void 0, void 0, function () {
              return hy(this, function (e) {
                switch (e.label) {
                  case 0:
                    return M(""), Me ? (Z(Oe), [3, 3]) : [3, 1];
                  case 1:
                    return Z([]), [4, dt("", "", "")];
                  case 2:
                    e.sent(), (e.label = 3);
                  case 3:
                    return [2];
                }
              });
            });
          },
          pt = function (e) {
            Z(e);
          },
          mt = function (e) {
            var t =
              null == q
                ? void 0
                : q.reduce(function (t, n) {
                    var r,
                      o =
                        (null === (r = e[null == n ? void 0 : n.variantId]) ||
                        void 0 === r
                          ? void 0
                          : r.quantity) || 1,
                      a = (function (e) {
                        var t,
                          n =
                            null === (t = e.variantId) || void 0 === t
                              ? void 0
                              : t.split("gid://shopify/ProductVariant/");
                        return (
                          ((null == O ? void 0 : O.PriceList) &&
                            "" !== (null == ve ? void 0 : ve.customerName) &&
                            be[Number(n[1])]) ||
                          e.variantPrice
                        );
                      })(n),
                      i = (function (e, t, n) {
                        if (!Ye && !Xe) return e * t;
                        var r = Ae[n];
                        if (Ae.hasOwnProperty(n) && void 0 !== r) {
                          if ("percentage" === Le && r >= 0 && r <= 100)
                            return t * e - (r / 100) * e * t;
                          if (r >= 0 && r <= e) return t * (e - r);
                        }
                        return e * t;
                      })(a, o, null == n ? void 0 : n.variantId);
                    return t + i;
                  }, 0);
            return (Ye || Xe) && re(t), t;
          },
          ht = function () {
            var e,
              t,
              n,
              r,
              o = null == he ? void 0 : he.draftOrderObj;
            if (o) {
              var a = {},
                i = null == o ? void 0 : o.line_items,
                s = void 0;
              (null === (e = null == o ? void 0 : o.applied_discount) ||
              void 0 === e
                ? void 0
                : e.value) &&
                (null ===
                  (t = Object.keys(null == o ? void 0 : o.applied_discount)) ||
                void 0 === t
                  ? void 0
                  : t.length) > 0 &&
                (s =
                  (null === (n = null == o ? void 0 : o.applied_discount) ||
                  void 0 === n
                    ? void 0
                    : n.value) || 0),
                "percentage" !==
                  ((null === (r = null == o ? void 0 : o.applied_discount) ||
                  void 0 === r
                    ? void 0
                    : r.value_type) || "percentage") && Be("dollar"),
                i &&
                  Array.isArray(i) &&
                  (null == i ||
                    i.forEach(function (e) {
                      var t,
                        n,
                        r,
                        o,
                        i,
                        s,
                        l = null == e ? void 0 : e.variant_id,
                        d = (
                          null ===
                            (t = null == e ? void 0 : e.applied_discount) ||
                          void 0 === t
                            ? void 0
                            : t.amount
                        )
                          ? parseFloat(
                              null ===
                                (n = null == e ? void 0 : e.applied_discount) ||
                                void 0 === n
                                ? void 0
                                : n.amount
                            )
                          : 0;
                      if (
                        l &&
                        null !=
                          (null === (r = e.applied_discount) || void 0 === r
                            ? void 0
                            : r.value) &&
                        null !=
                          (null === (o = e.applied_discount) || void 0 === o
                            ? void 0
                            : o.value)
                      ) {
                        Qe(!0);
                        var c = parseInt(
                            (null == e ? void 0 : e.quantity) || "0"
                          ),
                          u = "gid://shopify/ProductVariant/".concat(l);
                        a[u] =
                          null ===
                            (i = null == e ? void 0 : e.applied_discount) ||
                          void 0 === i
                            ? void 0
                            : i.value;
                        var p =
                          ((null == O ? void 0 : O.PriceList) &&
                          be &&
                          (null === (s = Object.keys(be)) || void 0 === s
                            ? void 0
                            : s.length) > 0 &&
                          be[l]
                            ? be[l]
                            : null == e
                            ? void 0
                            : e.price) *
                            c -
                          d;
                        X(function (e) {
                          var t;
                          return py(
                            py({}, e),
                            (((t = {})[u] = {
                              quantity: c,
                              subtotal: Math.max(p, 0),
                            }),
                            t)
                          );
                        });
                      }
                    })),
                Ee(py(py({}, a), { discountOnSubTotal: s }));
            }
          },
          ft = function (e, t) {
            var n, r;
            Ee(py(py({}, Ae), (((n = {}).discountOnSubTotal = e), n))),
              Ze(py(py({}, Fe), (((r = {}).discountOnSubTotal = t), r)));
          },
          gt = function () {
            Q(function (e) {
              var t =
                  null == e
                    ? void 0
                    : e.map(function (e) {
                        var t;
                        return py(py({}, e), {
                          quantity: J[e.variantId]
                            ? null === (t = J[e.variantId]) || void 0 === t
                              ? void 0
                              : t.quantity
                            : 1,
                        });
                      }),
                n = {
                  payload: {
                    selectedProductData: t,
                    isDiscountError: Fe,
                    isQuantityError: ke,
                    discountKeyValueObject: Ae,
                    selectedDiscountType: Le,
                    isDiscoutAppliedInEditDraft: Xe || Ye,
                  },
                  type: A.PRODUCT_TABLE_DATA,
                };
              return C(n), t;
            });
          };
        function vt(e, t, n, r, o) {
          return (
            void 0 === o && (o = ""),
            my(this, void 0, void 0, function () {
              var a, i, s, l, d, c;
              return hy(this, function (u) {
                switch (u.label) {
                  case 0:
                    return "" !== e && "0" !== e && Number(e) > 0
                      ? ((i = {}),
                        Pe(function (e) {
                          var n;
                          return py(py({}, e), (((n = {})[t] = !1), n));
                        }),
                        (s = function () {
                          var o,
                            s,
                            l = J[t];
                          a =
                            "increaseQty" === r
                              ? Number(null == l ? void 0 : l.quantity) + 1
                              : "decreaseQty" === r
                              ? Math.max(
                                  Number(null == l ? void 0 : l.quantity) - 1,
                                  1
                                )
                              : Number(e);
                          var d,
                            c = Number(a) * n;
                          (null == Ae ? void 0 : Ae.hasOwnProperty(t)) &&
                            ("percentage" === Le
                              ? void 0 !== (d = Ae[t]) &&
                                d >= 0 &&
                                d <= 100 &&
                                (c = a * n - (d * c) / 100)
                              : void 0 !== (d = Ae[t]) &&
                                d >= 0 &&
                                d <= n &&
                                (c = (n - d) * a));
                          var u = py(
                            py({}, J),
                            (((o = {})[t] = { quantity: a, subtotal: c }), o)
                          );
                          return (
                            (i = {
                              variantId: t,
                              quantity:
                                null === (s = u[t]) || void 0 === s
                                  ? void 0
                                  : s.quantity,
                            }),
                            u
                          );
                        }),
                        (l = s()),
                        "isReadCartData" === o
                          ? [3, 2]
                          : [4, it({}, "change.js", i)])
                      : [3, 4];
                  case 1:
                    return (d = u.sent()), [3, 3];
                  case 2:
                    (d = !0), (u.label = 3);
                  case 3:
                    return (
                      d &&
                        X(function (e) {
                          return py(py({}, e), l);
                        }),
                      [3, 5]
                    );
                  case 4:
                    return (
                      xe({ msg: x("productTable_error_AlertMsg"), open: !0 }),
                      Pe(py(py({}, ke), (((c = {})[t] = !0), c))),
                      X(function (n) {
                        var r;
                        return py(
                          py({}, n),
                          (((r = {})[t] = py(py({}, n[t]), {
                            quantity: e,
                            subtotal: 0,
                          })),
                          r)
                        );
                      }),
                      [2]
                    );
                  case 5:
                    return [2];
                }
              });
            })
          );
        }
        var bt = function (e) {
            var t, n;
            if (null != e && null != e) {
              var r = Number(
                null === (t = null == e ? void 0 : e.variantId) || void 0 === t
                  ? void 0
                  : t.split("gid://shopify/ProductVariant/")[1]
              );
              return (null == O ? void 0 : O.PriceList) &&
                be &&
                (null === (n = Object.keys(be)) || void 0 === n
                  ? void 0
                  : n.length) > 0 &&
                be[r]
                ? be[r]
                : null == e
                ? void 0
                : e.variantPrice;
            }
          },
          _t = function () {
            return my(_, void 0, void 0, function () {
              var e, t, n, r, o, a;
              return hy(this, function (i) {
                switch (i.label) {
                  case 0:
                    return Bh.next(!0), [4, C(Ig())];
                  case 1:
                    return (
                      200 === (null == (e = i.sent()) ? void 0 : e.status) &&
                        (null ===
                          (o =
                            null === (r = null == e ? void 0 : e.data) ||
                            void 0 === r
                              ? void 0
                              : r.items) || void 0 === o
                          ? void 0
                          : o.length) > 0 &&
                        (L(!0),
                        (t = yt(
                          null === (a = null == e ? void 0 : e.data) ||
                            void 0 === a
                            ? void 0
                            : a.items
                        )),
                        ie(t),
                        W(t),
                        (n =
                          null == t
                            ? void 0
                            : t.map(function (e) {
                                return e.productId;
                              })),
                        K(n),
                        gt()),
                      Bh.next(!1),
                      L(!1),
                      [2]
                    );
                }
              });
            });
          },
          yt = function (e) {
            var t,
              n,
              r,
              o = [],
              a = [],
              i =
                null !==
                  (r =
                    null ===
                      (n =
                        null === (t = F.getState().salesRepData) || void 0 === t
                          ? void 0
                          : t.editDraftOrder) || void 0 === n
                      ? void 0
                      : n.productDetailsArray) && void 0 !== r
                  ? r
                  : [],
              s = Object.fromEntries(
                i
                  .filter(function (e) {
                    return !!e.variantId;
                  })
                  .map(function (e) {
                    return [e.variantId, e];
                  })
              );
            return (
              null == e ||
                e.forEach(function (e) {
                  var t,
                    n,
                    r,
                    i,
                    l = o.findIndex(function (t) {
                      return (
                        t.productId === "gid://shopify/Product/" + e.product_id
                      );
                    }),
                    d =
                      null !==
                        (n =
                          null === (t = s[e.variant_id]) || void 0 === t
                            ? void 0
                            : t.inventoryQuantity.toString()) && void 0 !== n
                        ? n
                        : "NA",
                    c = {
                      variantId: "gid://shopify/ProductVariant/" + e.variant_id,
                      variantPrice: e.final_price / 100,
                      imageUrl:
                        (null === (r = e.featured_image) || void 0 === r
                          ? void 0
                          : r.url) || "",
                      currency: P,
                      inventoryQuantity: e.quantity,
                      sku: e.sku,
                      title: e.variant_title || "Default Title",
                      quantityAvailable: null != d ? d : "NA",
                      availableForSale: !0,
                      quantity: e.quantity,
                      wholesalePrice: e.final_price / 100,
                    };
                  if (-1 !== l) o[l].variants.push(c);
                  else {
                    var u = {
                      productId: "gid://shopify/Product/" + e.product_id,
                      title: e.title,
                      variants: [c],
                      imageUrl:
                        (null === (i = e.featured_image) || void 0 === i
                          ? void 0
                          : i.url) || null,
                    };
                    o.push(u);
                  }
                  a.push(c);
                }),
              Q(function (e) {
                return fy(fy([], e, !0), a, !0);
              }),
              W(o),
              null == a ||
                a.forEach(function (e) {
                  var t;
                  vt(
                    (null == e ? void 0 : e.quantity) || 1,
                    e.variantId,
                    ((null == O ? void 0 : O.PriceList) &&
                      "" !== (null == ve ? void 0 : ve.customerName) &&
                      be[
                        Number(
                          null === (t = e.variantId) || void 0 === t
                            ? void 0
                            : t.split("gid://shopify/ProductVariant/")[1]
                        )
                      ]) ||
                      e.variantPrice,
                    "manual",
                    "isReadCartData"
                  );
                }),
              o
            );
          };
        return {
          totalOrderAmount: ne,
          handleSearchProductData: dt,
          makeFieldsEmpty: ut,
          productSearchText: I,
          handleKeyDown: function (e) {
            "Enter" === e.key &&
              13 === e.keyCode &&
              ("" !== I && Me && (null == je ? void 0 : je.length) > 0
                ? pt(Oe)
                : dt());
          },
          handleProductTableSearchPopup: function () {
            D(!0), dt();
          },
          shopCurrency: P,
          handleSearchTextChange: function (e) {
            return my(_, void 0, void 0, function () {
              var t;
              return hy(this, function (n) {
                return (
                  (t = e.target.value),
                  M(t),
                  Me && ("" === t ? Z(Oe) : pt(Oe)),
                  [2]
                );
              });
            });
          },
          searchTablePopupOpen: N,
          productsArray: z,
          getProductsLoading: R,
          selectedProductArray: V,
          checkUncheckProductVariant: function (e, t, n, r, o) {
            var a;
            return my(this, void 0, void 0, function () {
              var i,
                s,
                l,
                d,
                c,
                u,
                p,
                m,
                h,
                f,
                g,
                v,
                b,
                _,
                y,
                C = this;
              return hy(this, function (x) {
                switch (x.label) {
                  case 0:
                    return (
                      x.trys.push([0, 6, , 7]),
                      (i = e.target.checked),
                      "isProduct" !== t
                        ? [3, 4]
                        : ((s = null == n ? void 0 : n.variants),
                          i
                            ? ((l =
                                null == s
                                  ? void 0
                                  : s.filter(function (e) {
                                      return e.availableForSale;
                                    })),
                              (
                                null == V
                                  ? void 0
                                  : V.some(function (e) {
                                      return e.productId === n.productId;
                                    })
                              )
                                ? -1 !==
                                    (d = V.findIndex(function (e) {
                                      return e.productId === n.productId;
                                    })) &&
                                  (((c = fy([], V, !0))[d].variants = l), W(c))
                                : (W(
                                    fy(
                                      fy([], V, !0),
                                      [py(py({}, n), { variants: l })],
                                      !1
                                    )
                                  ),
                                  K(fy(fy([], $, !0), [n.productId], !1))),
                              Q(fy(fy([], q, !0), l, !0)),
                              (u = py({}, J)),
                              null == l ||
                                l.forEach(function (e) {
                                  u[e.variantId] = {
                                    quantity: 1,
                                    subtotal: e.variantPrice,
                                  };
                                }),
                              X(u),
                              [3, 3])
                            : [3, 1])
                    );
                  case 1:
                    return (
                      de(!le),
                      W(
                        null == V
                          ? void 0
                          : V.filter(function (e) {
                              return e.productId !== n.productId;
                            })
                      ),
                      K(
                        null == $
                          ? void 0
                          : $.filter(function (e) {
                              return e !== n.productId;
                            })
                      ),
                      (p =
                        null == q
                          ? void 0
                          : q.filter(function (e) {
                              return !(null == s
                                ? void 0
                                : s.some(function (t) {
                                    return t.variantId === e.variantId;
                                  }));
                            })),
                      Q(p),
                      o
                        ? ((m = py({}, J)),
                          (h = {}),
                          null == s ||
                            s.forEach(function (e) {
                              var t;
                              delete m[null == e ? void 0 : e.variantId],
                                (Ye || Xe) &&
                                  delete Ae[null == e ? void 0 : e.variantId];
                              var n = Number(
                                null ===
                                  (t = null == e ? void 0 : e.variantId) ||
                                  void 0 === t
                                  ? void 0
                                  : t.split("gid://shopify/ProductVariant/")[1]
                              );
                              h[n] = 0;
                            }),
                          [4, it("", "update.js", h)])
                        : [3, 3]
                    );
                  case 2:
                    x.sent(),
                      Ee(
                        py(py({}, Ae), (((_ = {}).discountOnSubTotal = 0), _))
                      ),
                      X(m),
                      (x.label = 3);
                  case 3:
                    return [3, 5];
                  case 4:
                    i
                      ? ((
                          null == V
                            ? void 0
                            : V.some(function (e) {
                                return e.productId === n.productId;
                              })
                        )
                          ? W(function (e) {
                              return null == e
                                ? void 0
                                : e.map(function (e) {
                                    return e.productId === n.productId
                                      ? py(py({}, e), {
                                          variants: fy(
                                            fy([], e.variants, !0),
                                            [r],
                                            !1
                                          ),
                                        })
                                      : e;
                                  });
                            })
                          : (W(
                              fy(
                                fy([], V, !0),
                                [py(py({}, n), { variants: [r] })],
                                !1
                              )
                            ),
                            K(fy(fy([], $, !0), [n.productId], !1))),
                        Q(fy(fy([], q, !0), [r], !1)),
                        X(function (e) {
                          var t;
                          return py(
                            py({}, e),
                            (((t = {})[r.variantId] = {
                              quantity: 1,
                              subtotal: r.variantPrice,
                            }),
                            t)
                          );
                        }))
                      : (de(!le),
                        Q(function (e) {
                          return null == e
                            ? void 0
                            : e.filter(function (e) {
                                return e.variantId !== r.variantId;
                              });
                        }),
                        W(function (e) {
                          return null == e
                            ? void 0
                            : e.map(function (e) {
                                var t;
                                return e.productId === n.productId
                                  ? py(py({}, e), {
                                      variants:
                                        null === (t = e.variants) ||
                                        void 0 === t
                                          ? void 0
                                          : t.filter(function (e) {
                                              return (
                                                e.variantId !== r.variantId
                                              );
                                            }),
                                    })
                                  : e;
                              });
                        }),
                        (f = null == n ? void 0 : n.variants),
                        Q(function (e) {
                          return (
                            (null == f
                              ? void 0
                              : f.some(function (t) {
                                  return null == e
                                    ? void 0
                                    : e.some(function (e) {
                                        return e.variantId === t.variantId;
                                      });
                                })) ||
                              (K(function (e) {
                                return null == e
                                  ? void 0
                                  : e.filter(function (e) {
                                      return e !== n.productId;
                                    });
                              }),
                              W(function (e) {
                                return null == e
                                  ? void 0
                                  : e.filter(function (e) {
                                      return e.productId !== n.productId;
                                    });
                              })),
                            null == e
                              ? void 0
                              : e.filter(function (e) {
                                  return e.variantId !== r.variantId;
                                })
                          );
                        }),
                        o &&
                          ((g = py({}, J)),
                          (v = {}),
                          delete g[null == r ? void 0 : r.variantId],
                          (Ye || Xe) &&
                            delete Ae[null == r ? void 0 : r.variantId],
                          (b = Number(
                            null === (a = r.variantId) || void 0 === a
                              ? void 0
                              : a.split("gid://shopify/ProductVariant/")[1]
                          )),
                          (v[b] = 0),
                          setTimeout(function () {
                            return my(C, void 0, void 0, function () {
                              return hy(this, function (e) {
                                switch (e.label) {
                                  case 0:
                                    return [4, it("", "update.js", v)];
                                  case 1:
                                    return e.sent(), [2];
                                }
                              });
                            });
                          }, 800),
                          Ee(
                            py(
                              py({}, Ae),
                              (((y = {}).discountOnSubTotal = 0), y)
                            )
                          ),
                          X(g))),
                      (x.label = 5);
                  case 5:
                    return [3, 7];
                  case 6:
                    return x.sent(), [2];
                  case 7:
                    return [2];
                }
              });
            });
          },
          selectedVariantArray: q,
          selectedProductIdArray: $,
          showSelectedProduct: function () {
            try {
              D(!1), ut();
            } catch (e) {
              return;
            }
          },
          netQuantitySubtotal: J,
          updateNetQuantitySubtotal: vt,
          finalSelectedProducts: ae,
          closePopupForSearchProductData: function () {
            D(!1), L(!1), ut();
          },
          removeAllSelectedProducts: function () {
            try {
              ie([]),
                X({}),
                K([]),
                Q([]),
                W([]),
                ut(),
                re(0),
                Ee({}),
                it({}, "clear.js");
            } catch (e) {
              return;
            }
          },
          handleNextClick: function () {
            var e;
            ue.hasNextPage &&
              (dt(ue.endCursor, ""),
              null === (e = Ne.current) || void 0 === e || e.scrollTo(0, 0));
          },
          handlePrevClick: function () {
            var e, t;
            ue.hasPreviousPage &&
              (dt("", ue.startCursor),
              null === (e = Ne.current) || void 0 === e || e.scrollTo(0, 0),
              null === (t = Ne.current) || void 0 === t || t.scrollTo(0, 0));
          },
          pageInfo: ue,
          readCartProducts: _t,
          salesRepData: w,
          selectFeatures: O,
          createOrderTabReduxState: ve,
          handleWholesalePriceMapping: bt,
          hideWholeSalePriceListColumn: _e,
          handleAlertMsgClose: function (e, t) {
            "clickaway" !== t && xe({ msg: "", open: !1 });
          },
          alertErrorMsg: Ce,
          isQuantityError: ke,
          t: x,
          isNotEmpty: function (e) {
            return null != e;
          },
          propsFromCreateOrderParentTab: !1,
          appliedDiscount: function (e, t) {
            var n,
              r,
              o,
              a,
              i,
              s,
              l,
              d,
              c,
              u = e.target.value,
              p = null == t ? void 0 : t.variantId;
            try {
              var m = bt(t);
              if (p)
                if ("" !== u) {
                  var h = Number(u);
                  if (
                    (Ee(py(py({}, Ae), (((n = {})[p] = parseFloat(u)), n))),
                    "percentage" === Le)
                  )
                    if (h > 0 && h <= 100) {
                      var f =
                          ((null === (d = J[p]) || void 0 === d
                            ? void 0
                            : d.quantity) || 1) * m,
                        g = f - Number((h * f) / 100);
                      X(function (e) {
                        var t;
                        return py(
                          py({}, e),
                          (((t = {})[p] = py(py({}, e[p]), { subtotal: g })), t)
                        );
                      }),
                        Ze(py(py({}, Fe), (((r = {})[p] = !1), r)));
                    } else Ze(py(py({}, Fe), (((o = {})[p] = !0), o)));
                  else if (parseFloat(u) >= 0 && parseFloat(u) <= m) {
                    var v = m - parseFloat(u),
                      b =
                        ((null === (c = J[p]) || void 0 === c
                          ? void 0
                          : c.quantity) || 1) * v;
                    X(function (e) {
                      var t;
                      return py(
                        py({}, e),
                        (((t = {})[p] = py(py({}, e[p]), { subtotal: b })), t)
                      );
                    }),
                      Ze(py(py({}, Fe), (((a = {})[p] = !1), a)));
                  } else Ze(py(py({}, Fe), (((i = {})[p] = !0), i)));
                } else
                  X(function (e) {
                    var t, n, r;
                    return py(
                      py({}, e),
                      (((t = {})[p] = py(py({}, e[p]), {
                        quantity: J[p]
                          ? null === (n = J[p]) || void 0 === n
                            ? void 0
                            : n.quantity
                          : 1,
                        subtotal: J[p]
                          ? m *
                            (null === (r = J[p]) || void 0 === r
                              ? void 0
                              : r.quantity)
                          : 1,
                      })),
                      t)
                    );
                  }),
                    Ee(py(py({}, Ae), (((s = {})[p] = ""), s))),
                    Ze(py(py({}, Fe), (((l = {})[p] = !1), l)));
              else xe({ msg: x("customerInvoice_AlertErrorMsg"), open: !0 });
            } catch (e) {
              return;
            }
          },
          isDiscountError: Fe,
          discount_idObject: Ae,
          selectedDiscountType: Le,
          handleSelectChangeForDiscountType: function (e) {
            Ke(e.target.value), We(!0);
          },
          handleDiscountChange: function (e) {
            var t = parseFloat(e.target.value);
            if ("" !== e.target.value) {
              var n =
                "percentage" === Le
                  ? t >= 0 && t <= 100
                  : !isNaN(t) && t <= tt && t >= 0;
              ft(n ? t : "", !n);
            } else ft("", !1);
          },
          ShopApplyDiscount: Ye,
          handleConfirmChangeDiscountType: function () {
            We(!1),
              Be($e),
              null == ae ||
                ae.forEach(function (e) {
                  var t;
                  null === (t = null == e ? void 0 : e.variants) ||
                    void 0 === t ||
                    t.forEach(function (e) {
                      var t = bt(e);
                      X(function (n) {
                        var r, o, a;
                        return py(
                          py({}, n),
                          (((r = {})[null == e ? void 0 : e.variantId] = py(
                            py({}, n[null == e ? void 0 : e.variantId]),
                            {
                              quantity: J[null == e ? void 0 : e.variantId]
                                ? null ===
                                    (o = J[null == e ? void 0 : e.variantId]) ||
                                  void 0 === o
                                  ? void 0
                                  : o.quantity
                                : 1,
                              subtotal: J[null == e ? void 0 : e.variantId]
                                ? t *
                                  (null ===
                                    (a = J[null == e ? void 0 : e.variantId]) ||
                                  void 0 === a
                                    ? void 0
                                    : a.quantity)
                                : 1,
                            }
                          )),
                          r)
                        );
                      });
                    });
                }),
              Ee({});
          },
          handleCancelChangeDiscountType: function () {
            We(!1);
          },
          discountAlertBox: Ve,
          isDiscoutAppliedInEditDraft: Xe,
          tableContainerRef: Ne,
          isDiscountAppliedInInline: qe,
          isRemoveCartPopup: ot,
          setIsRemoveCartPopup: at,
        };
      }
      var vy = function () {
          return (
            (vy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            vy.apply(this, arguments)
          );
        },
        by = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function _y() {
        var n = rf(),
          r = n.shopCurrency,
          o = n.currency,
          a = gy(),
          i = a.selectFeatures,
          s = a.hideWholeSalePriceListColumn,
          l = a.t,
          d = a.handleWholesalePriceMapping,
          c = a.createOrderTabReduxState,
          u = {
            background: "#F2F2F2",
            border: "1px solid #E0E0E0",
            color: "gray",
            minWidth: "40px !important",
          },
          p = { width: "50px", m: "5px", textAlign: "center" },
          m = xv(),
          h = m.disableTableRow,
          f = m.LinearDeterminate,
          g = m.CircularWithValueLabel;
        return {
          productTableSearchBar: function (t) {
            var n = t.handleProductTableSearchPopup,
              r = t.removeAllSelectedProducts,
              o = t.finalSelectedProducts,
              a = t.propsFromCreateOrderParentTab,
              i = t.selectedDiscountType,
              s = t.handleSelectChangeForDiscountType,
              d = t.ShopApplyDiscount,
              c = t.isDiscoutAppliedInEditDraft,
              u = t.isRemoveCartPopup,
              p = t.setIsRemoveCartPopup;
            return (0, e.jsxs)(
              "div",
              vy(
                { className: "ST_ProductTableSearchBar" },
                {
                  children: [
                    (0, e.jsxs)(
                      "div",
                      vy(
                        { style: { display: "flex" } },
                        {
                          children: [
                            (0, e.jsx)(ju, {
                              id: "free-solo-demo",
                              freeSolo: !0,
                              inputValue: "",
                              className: "ST_SearchBar",
                              sx: {
                                ml: 1,
                                flex: 1,
                                "& .MuiOutlinedInput-root": {
                                  border: "none",
                                  background: "white",
                                  "& fieldset": { border: "none" },
                                  "&:hover fieldset": { border: "none" },
                                  "&.Mui-focused fieldset": { border: "none" },
                                  boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                                },
                              },
                              options: [],
                              renderInput: function (t) {
                                return (0, e.jsx)(
                                  Hc,
                                  vy(
                                    {
                                      placeholder: l(
                                        "ST_CO_SearchProducts_Label"
                                      ),
                                    },
                                    t,
                                    {
                                      className: "ST_SearchBar",
                                      onClick: function () {
                                        n();
                                      },
                                      InputProps: vy(vy({}, t.InputProps), {
                                        endAdornment: (0, e.jsx)(
                                          Bu,
                                          vy(
                                            {
                                              position: "end",
                                              sx: { mr: 0, p: "15px" },
                                            },
                                            { children: (0, e.jsx)(Rv, {}) }
                                          )
                                        ),
                                      }),
                                    }
                                  )
                                );
                              },
                              size: "medium",
                            }),
                            !a &&
                              o &&
                              (null == o ? void 0 : o.length) > 0 &&
                              ((!d && c) || d) &&
                              (0, e.jsx)(
                                qa,
                                vy(
                                  {
                                    className: "ST_CI_discountCodeOptionsGrid",
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      yd,
                                      vy(
                                        { fullWidth: !0, size: "small" },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              hd,
                                              vy(
                                                { id: "demo-select-small" },
                                                {
                                                  children: l(
                                                    "producttable_discounttypeHeader"
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsxs)(
                                              Rc,
                                              vy(
                                                {
                                                  sx: {
                                                    backgroundColor: "white",
                                                    height: 47,
                                                  },
                                                  labelId: "demo-select-small",
                                                  value: i,
                                                  label: l(
                                                    "customerInvoice_DiscountOnSubtotal"
                                                  ),
                                                  readOnly: !d && c,
                                                  disabled: !d && c,
                                                  onChange: function (e) {
                                                    s(e);
                                                  },
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      J_,
                                                      vy(
                                                        { value: "percentage" },
                                                        {
                                                          children: l(
                                                            "Create_Order_DiscountDropdown_value1"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      J_,
                                                      vy(
                                                        { value: "dollar" },
                                                        {
                                                          children: l(
                                                            "Create_Order_DiscountDropdown_value2"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                          ],
                        }
                      )
                    ),
                    o && (null == o ? void 0 : o.length) > 0
                      ? (0, e.jsx)(
                          Qu,
                          vy(
                            {
                              disabled:
                                !o || 0 === (null == o ? void 0 : o.length),
                              variant: "outlined",
                              startIcon: (0, e.jsx)(Ev, {}),
                              sx: { mt: 1, mb: 2, textTransform: "capitalize" },
                              onClick: function () {
                                return p(!0);
                              },
                            },
                            { children: l("productTable_clearCartBtn") }
                          )
                        )
                      : null,
                    u &&
                      (0, e.jsx)(Z_, {
                        isRemoveCartPopup: u,
                        setIsRemoveCartPopup: p,
                        removeProductMethod: r,
                      }),
                  ],
                }
              )
            );
          },
          searchProductTablePopUp: function (n) {
            var o,
              a,
              c,
              u,
              p = n.searchTablePopupOpen,
              m = n.closePopupForSearchProductData,
              g = n.handleKeyDown,
              v = n.handleSearchTextChange,
              b = n.makeFieldsEmpty,
              _ = n.handleSearchProductData,
              y = n.checkUncheckProductVariant,
              C = n.handlePrevClick,
              x = n.handleNextClick,
              S = n.showSelectedProduct,
              k = n.productsArray,
              P = n.selectedProductIdArray,
              w = n.selectedVariantArray,
              O = n.pageInfo,
              T = n.getProductsLoading,
              I = n.productSearchText,
              M = n.propsFromCreateOrderParentTab,
              j = n.selectedProductArray,
              N = n.tableContainerRef,
              D = n.loadMoreBtnDisable,
              A = [
                { name: "ST_Producttable_product", hide: !1 },
                {
                  name: "ST_Producttable_SKU",
                  hide: !(null ===
                    (o = null == i ? void 0 : i.featuresAdditionalSettings) ||
                  void 0 === o
                    ? void 0
                    : o.showSkuColumn),
                },
                {
                  name: "customerInvoice_ProductTableColumnInventory",
                  hide: !(null ===
                    (a = null == i ? void 0 : i.featuresAdditionalSettings) ||
                  void 0 === a
                    ? void 0
                    : a.showInventoryColumn),
                },
                { name: "ST_Producttable_retailPrice", hide: M },
                { name: "ST_Producttable_wholesalePrice", hide: s },
              ];
            return (0, e.jsxs)(
              Hp,
              vy(
                {
                  open: p,
                  onClose: function () {
                    return m();
                  },
                  fullWidth: !0,
                  maxWidth: "md",
                  className: "Dialog_Border_Radius",
                },
                {
                  children: [
                    (0, e.jsxs)("div", {
                      children: [
                        (0, e.jsxs)(
                          qa,
                          vy(
                            {
                              container: !0,
                              spacing: 2,
                              className: "Product_Picker_Heading",
                            },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  vy(
                                    { item: !0, xs: 10, md: 10 },
                                    {
                                      children: (0, e.jsx)(
                                        ni,
                                        vy(
                                          { variant: Av, sx: Ko },
                                          {
                                            children: l(
                                              "ST_CO_SearchProducts_Label"
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  qa,
                                  vy(
                                    {
                                      item: !0,
                                      xs: 2,
                                      md: 2,
                                      sx: { textAlign: "right" },
                                      pr: 1,
                                    },
                                    {
                                      children: (0, e.jsx)(Fg, {
                                        sx: { cursor: "pointer" },
                                        onClick: function () {
                                          m();
                                        },
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsxs)(
                          qa,
                          vy(
                            { container: !0, spacing: 2, p: 2 },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  vy(
                                    {
                                      item: !0,
                                      xs: 10,
                                      md: 10,
                                      lg: 10,
                                      xl: 10,
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        go,
                                        vy(
                                          { className: "PT_SearchBox" },
                                          {
                                            children: [
                                              (0, e.jsx)(Ml, {
                                                autoFocus: !0,
                                                value: I,
                                                onKeyDown: g,
                                                onChange: function (e) {
                                                  return v(e);
                                                },
                                                sx: { ml: 2, flex: 1 },
                                                size: "small",
                                                placeholder: l(
                                                  "ST_CO_SearchProducts_Label"
                                                ),
                                                inputProps: {
                                                  "aria-label":
                                                    "searchProducts",
                                                },
                                              }),
                                              (0, e.jsx)(
                                                Jn,
                                                vy(
                                                  {
                                                    onClick: b,
                                                    type: "button",
                                                    sx: { p: "10px" },
                                                    "aria-label": "search",
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Fg,
                                                      {}
                                                    ),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                !M &&
                                  (0, e.jsx)(
                                    qa,
                                    vy(
                                      {
                                        sx: {
                                          display: "flex",
                                          alignItems: "center",
                                        },
                                        item: !0,
                                        xs: 2,
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          Ym,
                                          vy(
                                            {
                                              disabled: !I,
                                              loading: T,
                                              sx: {
                                                textTransform: "capitalize",
                                              },
                                              onClick: function () {
                                                _();
                                              },
                                              variant: "contained",
                                            },
                                            { children: l("ST_CO_search") }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Gp,
                          vy(
                            { sx: { padding: "0px" } },
                            {
                              children: (0, e.jsx)(
                                ep,
                                vy(
                                  {
                                    className: "selectProductsProductTable",
                                    component: go,
                                    ref: N,
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      sp,
                                      vy(
                                        {
                                          stickyHeader: !0,
                                          "aria-label":
                                            "selectProductsProductTable",
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(hp, {
                                              children: (0, e.jsx)(
                                                Cp,
                                                vy(
                                                  {
                                                    className:
                                                      "stickyHeaderRow",
                                                  },
                                                  {
                                                    children:
                                                      null == A
                                                        ? void 0
                                                        : A.map(function (
                                                            t,
                                                            n
                                                          ) {
                                                            return (0, e.jsx)(
                                                              Op,
                                                              vy(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  sx: (
                                                                    null == t
                                                                      ? void 0
                                                                      : t.hide
                                                                  )
                                                                    ? {
                                                                        display:
                                                                          "none",
                                                                      }
                                                                    : {
                                                                        display:
                                                                          "table-cell",
                                                                      },
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)("b", {
                                                                    children: [
                                                                      " ",
                                                                      l(t.name),
                                                                      " ",
                                                                    ],
                                                                  }),
                                                                }
                                                              ),
                                                              n
                                                            );
                                                          }),
                                                  }
                                                )
                                              ),
                                            }),
                                            (0, e.jsx)(Dp, {
                                              children:
                                                0 !==
                                                (null == k ? void 0 : k.length)
                                                  ? (0, e.jsx)(e.Fragment, {
                                                      children:
                                                        M && T
                                                          ? (0, e.jsx)(
                                                              Cp,
                                                              vy(
                                                                {
                                                                  className:
                                                                    "stickyHeaderRow",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(
                                                                    Op,
                                                                    vy(
                                                                      {
                                                                        align:
                                                                          "center",
                                                                        colSpan:
                                                                          null ===
                                                                            (c =
                                                                              null ==
                                                                              A
                                                                                ? void 0
                                                                                : A.filter(
                                                                                    function (
                                                                                      e
                                                                                    ) {
                                                                                      return !e.hide;
                                                                                    }
                                                                                  )) ||
                                                                          void 0 ===
                                                                            c
                                                                            ? void 0
                                                                            : c.length,
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            f,
                                                                            {}
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            )
                                                          : null == k
                                                          ? void 0
                                                          : k.map(function (
                                                              n,
                                                              o
                                                            ) {
                                                              var a, c, u, p;
                                                              return (null ===
                                                                (a =
                                                                  null == n
                                                                    ? void 0
                                                                    : n.variants) ||
                                                              void 0 === a
                                                                ? void 0
                                                                : a.length) > 0
                                                                ? (0, e.jsxs)(
                                                                    t.Fragment,
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            Cp,
                                                                            vy(
                                                                              {
                                                                                className:
                                                                                  "PT_TableRow_Padding",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    vy(
                                                                                      {
                                                                                        colSpan:
                                                                                          null ===
                                                                                            (c =
                                                                                              null ==
                                                                                              A
                                                                                                ? void 0
                                                                                                : A.filter(
                                                                                                    function (
                                                                                                      e
                                                                                                    ) {
                                                                                                      return !e.hide;
                                                                                                    }
                                                                                                  )) ||
                                                                                          void 0 ===
                                                                                            c
                                                                                            ? void 0
                                                                                            : c.length,
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          (0,
                                                                                          e.jsxs)(
                                                                                            mn,
                                                                                            vy(
                                                                                              {
                                                                                                display:
                                                                                                  "flex",
                                                                                                alignItems:
                                                                                                  "center",
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      tb,
                                                                                                      {
                                                                                                        disabled:
                                                                                                          h(
                                                                                                            n
                                                                                                          ),
                                                                                                        checked:
                                                                                                          !!(null ==
                                                                                                          P
                                                                                                            ? void 0
                                                                                                            : P.includes(
                                                                                                                null ==
                                                                                                                  n
                                                                                                                  ? void 0
                                                                                                                  : n.productId
                                                                                                              )),
                                                                                                        onChange:
                                                                                                          function (
                                                                                                            e
                                                                                                          ) {
                                                                                                            return y(
                                                                                                              e,
                                                                                                              "isProduct",
                                                                                                              n,
                                                                                                              void 0,
                                                                                                              !0
                                                                                                            );
                                                                                                          },
                                                                                                      }
                                                                                                    ),
                                                                                                    (null ==
                                                                                                    n
                                                                                                      ? void 0
                                                                                                      : n.imageUrl) &&
                                                                                                    0 !==
                                                                                                      (null ===
                                                                                                        (u =
                                                                                                          null ==
                                                                                                          n
                                                                                                            ? void 0
                                                                                                            : n.imageUrl) ||
                                                                                                      void 0 ===
                                                                                                        u
                                                                                                        ? void 0
                                                                                                        : u.length)
                                                                                                      ? (0,
                                                                                                        e.jsx)(
                                                                                                          lb,
                                                                                                          {
                                                                                                            alt: "image",
                                                                                                            src: n.imageUrl,
                                                                                                            variant:
                                                                                                              "rounded",
                                                                                                          }
                                                                                                        )
                                                                                                      : (0,
                                                                                                        e.jsx)(
                                                                                                          lb,
                                                                                                          vy(
                                                                                                            {
                                                                                                              alt: "image",
                                                                                                              sx: {
                                                                                                                bgcolor:
                                                                                                                  "white",
                                                                                                                color:
                                                                                                                  "black",
                                                                                                              },
                                                                                                              variant:
                                                                                                                "rounded",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                (0,
                                                                                                                e.jsx)(
                                                                                                                  Sb,
                                                                                                                  {
                                                                                                                    sx: {
                                                                                                                      fontSize:
                                                                                                                        "3.1rem",
                                                                                                                    },
                                                                                                                  }
                                                                                                                ),
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      mn,
                                                                                                      vy(
                                                                                                        {
                                                                                                          sx: {
                                                                                                            ml: 1,
                                                                                                          },
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (null ==
                                                                                                              n ||
                                                                                                              n.title,
                                                                                                            null ==
                                                                                                            n
                                                                                                              ? void 0
                                                                                                              : n.title),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                  ],
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          null ===
                                                                            (p =
                                                                              null ==
                                                                              n
                                                                                ? void 0
                                                                                : n.variants) ||
                                                                          void 0 ===
                                                                            p
                                                                            ? void 0
                                                                            : p.map(
                                                                                function (
                                                                                  t,
                                                                                  o
                                                                                ) {
                                                                                  var a,
                                                                                    c,
                                                                                    u;
                                                                                  return (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    vy(
                                                                                      {
                                                                                        sx: {
                                                                                          whiteSpace:
                                                                                            "nowrap",
                                                                                          opacity:
                                                                                            (
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.availableForSale
                                                                                            )
                                                                                              ? 1
                                                                                              : 0.7,
                                                                                        },
                                                                                        className:
                                                                                          "PT_Variaant_TableRow",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              vy(
                                                                                                {
                                                                                                  className:
                                                                                                    "PT_Variaant_TableRow_Padding",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsxs)(
                                                                                                      mn,
                                                                                                      vy(
                                                                                                        {
                                                                                                          display:
                                                                                                            "flex",
                                                                                                          alignItems:
                                                                                                            "center",
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            [
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                tb,
                                                                                                                {
                                                                                                                  disabled:
                                                                                                                    !(null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.availableForSale),
                                                                                                                  checked:
                                                                                                                    null ==
                                                                                                                    w
                                                                                                                      ? void 0
                                                                                                                      : w.some(
                                                                                                                          function (
                                                                                                                            e
                                                                                                                          ) {
                                                                                                                            return (
                                                                                                                              (null ==
                                                                                                                              e
                                                                                                                                ? void 0
                                                                                                                                : e.variantId) ===
                                                                                                                              (null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.variantId)
                                                                                                                            );
                                                                                                                          }
                                                                                                                        ),
                                                                                                                  onChange:
                                                                                                                    function (
                                                                                                                      e
                                                                                                                    ) {
                                                                                                                      return y(
                                                                                                                        e,
                                                                                                                        "isVariant",
                                                                                                                        n,
                                                                                                                        t,
                                                                                                                        !0
                                                                                                                      );
                                                                                                                    },
                                                                                                                }
                                                                                                              ),
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                mn,
                                                                                                                vy(
                                                                                                                  {
                                                                                                                    sx: {
                                                                                                                      ml: 2,
                                                                                                                      whiteSpace:
                                                                                                                        "pre-line",
                                                                                                                    },
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      "Default Title" !==
                                                                                                                      (null ==
                                                                                                                      t
                                                                                                                        ? void 0
                                                                                                                        : t.title)
                                                                                                                        ? null ==
                                                                                                                          t
                                                                                                                          ? void 0
                                                                                                                          : t.title
                                                                                                                        : null ==
                                                                                                                          n
                                                                                                                        ? void 0
                                                                                                                        : n.title,
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                            ],
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              vy(
                                                                                                {
                                                                                                  sx: (
                                                                                                    null ===
                                                                                                      (a =
                                                                                                        null ==
                                                                                                        i
                                                                                                          ? void 0
                                                                                                          : i.featuresAdditionalSettings) ||
                                                                                                    void 0 ===
                                                                                                      a
                                                                                                      ? void 0
                                                                                                      : a.showSkuColumn
                                                                                                  )
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      },
                                                                                                  align:
                                                                                                    "center",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    null !==
                                                                                                      (c =
                                                                                                        null ==
                                                                                                        t
                                                                                                          ? void 0
                                                                                                          : t.sku) &&
                                                                                                    void 0 !==
                                                                                                      c
                                                                                                      ? c
                                                                                                      : "",
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              vy(
                                                                                                {
                                                                                                  align:
                                                                                                    "center",
                                                                                                  sx: (
                                                                                                    null ===
                                                                                                      (u =
                                                                                                        null ==
                                                                                                        i
                                                                                                          ? void 0
                                                                                                          : i.featuresAdditionalSettings) ||
                                                                                                    void 0 ===
                                                                                                      u
                                                                                                      ? void 0
                                                                                                      : u.showInventoryColumn
                                                                                                  )
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      },
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    (
                                                                                                      null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.availableForSale
                                                                                                    )
                                                                                                      ? t.quantityAvailable ||
                                                                                                        0
                                                                                                      : (0,
                                                                                                        e.jsx)(
                                                                                                          du,
                                                                                                          {
                                                                                                            label:
                                                                                                              l(
                                                                                                                "soldOut"
                                                                                                              ),
                                                                                                            sx: {
                                                                                                              backgroundColor:
                                                                                                                "#fff6c2",
                                                                                                              borderColor:
                                                                                                                "#f7eba2",
                                                                                                            },
                                                                                                          }
                                                                                                        ),
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              Op,
                                                                                              vy(
                                                                                                {
                                                                                                  sx: M
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      },
                                                                                                  align:
                                                                                                    "center",
                                                                                                  className:
                                                                                                    "ST_White_Space",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      r +
                                                                                                        " ",
                                                                                                      t.variantPrice ||
                                                                                                        (0).toFixed(
                                                                                                          2
                                                                                                        ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              Op,
                                                                                              vy(
                                                                                                {
                                                                                                  align:
                                                                                                    "center",
                                                                                                  sx: s
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      },
                                                                                                  className:
                                                                                                    "ST_White_Space",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      r +
                                                                                                        " ",
                                                                                                      d(
                                                                                                        t
                                                                                                      ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    ),
                                                                                    o
                                                                                  );
                                                                                }
                                                                              ),
                                                                        ],
                                                                    },
                                                                    o
                                                                  )
                                                                : "";
                                                            }),
                                                    })
                                                  : (0, e.jsx)(Cp, {
                                                      children: (0, e.jsx)(
                                                        Op,
                                                        vy(
                                                          {
                                                            colSpan:
                                                              null ===
                                                                (u =
                                                                  null == A
                                                                    ? void 0
                                                                    : A.filter(
                                                                        function (
                                                                          e
                                                                        ) {
                                                                          return !e.hide;
                                                                        }
                                                                      )) ||
                                                              void 0 === u
                                                                ? void 0
                                                                : u.length,
                                                            align: "center",
                                                          },
                                                          {
                                                            children: M
                                                              ? T
                                                                ? (0, e.jsx)(
                                                                    f,
                                                                    {}
                                                                  )
                                                                : I
                                                                ? l(
                                                                    "ST_CO_no_result_found_msg"
                                                                  ) +
                                                                  " " +
                                                                  I +
                                                                  ", please check catalog products."
                                                                : ""
                                                              : T
                                                              ? l(
                                                                  "productsLoading"
                                                                )
                                                              : l(
                                                                  "ST_CO_no_result_found_msg"
                                                                ) +
                                                                " " +
                                                                I,
                                                          }
                                                        )
                                                      ),
                                                    }),
                                            }),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }),
                    (0, e.jsxs)(
                      Jp,
                      vy(
                        { className: "Product_Picker_Heading" },
                        {
                          children: [
                            M
                              ? (0, e.jsx)(e.Fragment, {})
                              : (0, e.jsx)(
                                  Qu,
                                  vy(
                                    {
                                      onClick: C,
                                      disabled: !(null == O
                                        ? void 0
                                        : O.hasPreviousPage),
                                      className: "Product_Picker_Footer",
                                    },
                                    {
                                      children: (0, e.jsx)(kb, {
                                        fontSize: "large",
                                      }),
                                    }
                                  )
                                ),
                            (0, e.jsx)(
                              Qu,
                              vy(
                                {
                                  onClick: x,
                                  disabled: M
                                    ? ("" != I &&
                                        !(null == O ? void 0 : O.endCursor)) ||
                                      ("" != I &&
                                        !(null == O
                                          ? void 0
                                          : O.SearchPricesEndCursor)) ||
                                      T ||
                                      D
                                    : !(null == O ? void 0 : O.hasNextPage),
                                  className: "Product_Picker_Footer",
                                },
                                {
                                  children: M
                                    ? l("Load_More_Btn")
                                    : (0, e.jsx)(Pb, { fontSize: "large" }),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              Qu,
                              vy(
                                {
                                  disabled:
                                    0 === (null == j ? void 0 : j.length),
                                  sx: { textTransform: "uppercase" },
                                  variant: "contained",
                                  onClick: function () {
                                    return S();
                                  },
                                },
                                { children: l("CreateOrder_doneBtn") }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  ],
                }
              )
            );
          },
          selectedProductTable: function (n) {
            var o,
              a,
              m,
              f,
              v = n.checkUncheckProductVariant,
              b = n.selectedProductIdArray,
              _ = n.selectedVariantArray,
              y = n.getProductsLoading,
              C = n.finalSelectedProducts,
              x = n.updateNetQuantitySubtotal,
              S = n.netQuantitySubtotal,
              k = n.isQuantityError,
              P = n.handleProductTableSearchPopup,
              w = n.showB2BQtyCataloguePrice,
              O = n.handleViewPricingPopup,
              T = n.propsFromCreateOrderParentTab,
              I = n.isNotEmpty,
              M = n.appliedDiscount,
              j = n.isDiscountError,
              N = n.discount_idObject,
              D = n.ShopApplyDiscount,
              A = n.isDiscoutAppliedInEditDraft,
              E = n.loadMoreBtnDisable,
              R = [
                { name: "ST_Producttable_product", hide: !1 },
                {
                  name: "ST_Producttable_SKU",
                  hide: !(null ===
                    (o = null == i ? void 0 : i.featuresAdditionalSettings) ||
                  void 0 === o
                    ? void 0
                    : o.showSkuColumn),
                },
                {
                  name: "customerInvoice_ProductTableColumnInventory",
                  hide: !(null ===
                    (a = null == i ? void 0 : i.featuresAdditionalSettings) ||
                  void 0 === a
                    ? void 0
                    : a.showInventoryColumn),
                },
                {
                  name: T
                    ? "customerInvoice_ProductTableColumnPrice"
                    : "ST_Producttable_retailPrice",
                  hide: !1,
                },
                {
                  name: "customerInvoice_DiscountOnSubtotal",
                  hide: T || (!D && !A),
                },
                { name: "ST_Producttable_wholesalePrice", hide: s || T },
                { name: "ST_Producttable_netQuantity", hide: !1 },
                { name: "ST_Producttable_VolumePricing", hide: !T },
                { name: "ST_Producttable_subtotal", hide: !1 },
              ];
            return (0, e.jsx)(e.Fragment, {
              children: (0, e.jsx)(
                ep,
                vy(
                  {
                    className: "selectedProductTable",
                    sx: { mt: 3 },
                    component: go,
                  },
                  {
                    children: (0, e.jsxs)(
                      sp,
                      vy(
                        {
                          stickyHeader: !0,
                          "aria-label": "selectedProductTable",
                        },
                        {
                          children: [
                            (0, e.jsx)(hp, {
                              children: (0, e.jsx)(
                                Cp,
                                vy(
                                  { className: "stickyHeaderRow" },
                                  {
                                    children: (0, e.jsx)(e.Fragment, {
                                      children:
                                        null == R
                                          ? void 0
                                          : R.map(function (t, n) {
                                              return (0,
                                              e.jsx)(Op, vy({ align: "center", sx: (null == t ? void 0 : t.hide) ? { display: "none" } : { display: "table-cell" } }, { children: (0, e.jsxs)("b", { children: [" ", l(t.name), " "] }) }), n);
                                            }),
                                    }),
                                  }
                                )
                              ),
                            }),
                            (0, e.jsx)(Dp, {
                              children:
                                T && E
                                  ? (0, e.jsx)(e.Fragment, {
                                      children: (0, e.jsx)(
                                        Cp,
                                        vy(
                                          { className: "stickyHeaderRow" },
                                          {
                                            children: (0, e.jsx)(
                                              Op,
                                              vy(
                                                {
                                                  align: "center",
                                                  colSpan:
                                                    null ===
                                                      (m =
                                                        null == R
                                                          ? void 0
                                                          : R.filter(function (
                                                              e
                                                            ) {
                                                              return !e.hide;
                                                            })) || void 0 === m
                                                      ? void 0
                                                      : m.length,
                                                },
                                                { children: (0, e.jsx)(g, {}) }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    })
                                  : C && (null == C ? void 0 : C.length) > 0
                                  ? (0, e.jsx)(e.Fragment, {
                                      children:
                                        null == C
                                          ? void 0
                                          : C.map(function (n, o) {
                                              var a, m, f, g;
                                              return (null ===
                                                (a =
                                                  null == n
                                                    ? void 0
                                                    : n.variants) ||
                                              void 0 === a
                                                ? void 0
                                                : a.length) > 0
                                                ? (0, e.jsxs)(
                                                    t.Fragment,
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          Cp,
                                                          vy(
                                                            {
                                                              className:
                                                                "PT_TableRow_Padding",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                Op,
                                                                vy(
                                                                  {
                                                                    sx: {
                                                                      ml: 2,
                                                                    },
                                                                    colSpan:
                                                                      null ===
                                                                        (m =
                                                                          null ==
                                                                          R
                                                                            ? void 0
                                                                            : R.filter(
                                                                                function (
                                                                                  e
                                                                                ) {
                                                                                  return !e.hide;
                                                                                }
                                                                              )) ||
                                                                      void 0 ===
                                                                        m
                                                                        ? void 0
                                                                        : m.length,
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsxs)(
                                                                        mn,
                                                                        vy(
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  tb,
                                                                                  {
                                                                                    disabled:
                                                                                      h(
                                                                                        n
                                                                                      ),
                                                                                    checked:
                                                                                      null ==
                                                                                      b
                                                                                        ? void 0
                                                                                        : b.includes(
                                                                                            n.productId
                                                                                          ),
                                                                                    onChange:
                                                                                      function (
                                                                                        e
                                                                                      ) {
                                                                                        return v(
                                                                                          e,
                                                                                          "isProduct",
                                                                                          n,
                                                                                          void 0,
                                                                                          !0
                                                                                        );
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                (null ==
                                                                                n
                                                                                  ? void 0
                                                                                  : n.imageUrl) &&
                                                                                0 !==
                                                                                  (null ===
                                                                                    (f =
                                                                                      null ==
                                                                                      n
                                                                                        ? void 0
                                                                                        : n.imageUrl) ||
                                                                                  void 0 ===
                                                                                    f
                                                                                    ? void 0
                                                                                    : f.length)
                                                                                  ? (0,
                                                                                    e.jsx)(
                                                                                      lb,
                                                                                      {
                                                                                        alt: "image",
                                                                                        src: n.imageUrl,
                                                                                        variant:
                                                                                          "rounded",
                                                                                      }
                                                                                    )
                                                                                  : (0,
                                                                                    e.jsx)(
                                                                                      lb,
                                                                                      vy(
                                                                                        {
                                                                                          alt: "image",
                                                                                          sx: {
                                                                                            bgcolor:
                                                                                              "white",
                                                                                            color:
                                                                                              "black",
                                                                                          },
                                                                                          variant:
                                                                                            "rounded",
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Sb,
                                                                                              {
                                                                                                sx: {
                                                                                                  fontSize:
                                                                                                    "3.1rem",
                                                                                                },
                                                                                              }
                                                                                            ),
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                (0,
                                                                                e.jsx)(
                                                                                  mn,
                                                                                  vy(
                                                                                    {
                                                                                      sx: {
                                                                                        ml: 1,
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (null ==
                                                                                          n ||
                                                                                          n.title,
                                                                                        null ==
                                                                                        n
                                                                                          ? void 0
                                                                                          : n.title),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        null ===
                                                          (g =
                                                            null == n
                                                              ? void 0
                                                              : n.variants) ||
                                                        void 0 === g
                                                          ? void 0
                                                          : g.map(function (
                                                              t,
                                                              o
                                                            ) {
                                                              var a,
                                                                m,
                                                                h,
                                                                f,
                                                                g,
                                                                b,
                                                                y,
                                                                C,
                                                                P,
                                                                E,
                                                                R,
                                                                L,
                                                                B,
                                                                z,
                                                                F,
                                                                Z,
                                                                H,
                                                                V,
                                                                W,
                                                                U,
                                                                $,
                                                                K,
                                                                G,
                                                                q,
                                                                Q,
                                                                Y,
                                                                J,
                                                                X,
                                                                ee;
                                                              return (0,
                                                              e.jsxs)(
                                                                Cp,
                                                                vy(
                                                                  {
                                                                    sx: {
                                                                      whiteSpace:
                                                                        "nowrap",
                                                                    },
                                                                    className:
                                                                      "PT_Variaant_TableRow",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            className:
                                                                              "PT_Variaant_TableRow_Padding",
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsxs)(
                                                                                mn,
                                                                                vy(
                                                                                  {
                                                                                    display:
                                                                                      "flex",
                                                                                    alignItems:
                                                                                      "center",
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      [
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          tb,
                                                                                          {
                                                                                            disabled:
                                                                                              !(null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.availableForSale),
                                                                                            checked:
                                                                                              _.some(
                                                                                                function (
                                                                                                  e
                                                                                                ) {
                                                                                                  return (
                                                                                                    (null ==
                                                                                                    e
                                                                                                      ? void 0
                                                                                                      : e.variantId) ===
                                                                                                    (null ==
                                                                                                    t
                                                                                                      ? void 0
                                                                                                      : t.variantId)
                                                                                                  );
                                                                                                }
                                                                                              ),
                                                                                            onChange:
                                                                                              function (
                                                                                                e
                                                                                              ) {
                                                                                                return v(
                                                                                                  e,
                                                                                                  "isVariant",
                                                                                                  n,
                                                                                                  t,
                                                                                                  !0
                                                                                                );
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          mn,
                                                                                          vy(
                                                                                            {
                                                                                              sx: {
                                                                                                ml: 2,
                                                                                                whiteSpace:
                                                                                                  "pre-line",
                                                                                              },
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                "Default Title" !==
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.title)
                                                                                                  ? null ==
                                                                                                    t
                                                                                                    ? void 0
                                                                                                    : t.title
                                                                                                  : null ==
                                                                                                    n
                                                                                                  ? void 0
                                                                                                  : n.title,
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                  }
                                                                                )
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                            sx: (
                                                                              null ===
                                                                                (a =
                                                                                  null ==
                                                                                  i
                                                                                    ? void 0
                                                                                    : i.featuresAdditionalSettings) ||
                                                                              void 0 ===
                                                                                a
                                                                                ? void 0
                                                                                : a.showSkuColumn
                                                                            )
                                                                              ? {
                                                                                  display:
                                                                                    "table-cell",
                                                                                }
                                                                              : {
                                                                                  display:
                                                                                    "none",
                                                                                },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.sku,
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                            sx: (
                                                                              null ===
                                                                                (m =
                                                                                  null ==
                                                                                  i
                                                                                    ? void 0
                                                                                    : i.featuresAdditionalSettings) ||
                                                                              void 0 ===
                                                                                m
                                                                                ? void 0
                                                                                : m.showInventoryColumn
                                                                            )
                                                                              ? {
                                                                                  display:
                                                                                    "table-cell",
                                                                                }
                                                                              : {
                                                                                  display:
                                                                                    "none",
                                                                                },
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.quantityAvailable ||
                                                                              0,
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                            className:
                                                                              "ST_White_Space",
                                                                          },
                                                                          {
                                                                            children:
                                                                              T &&
                                                                              (null ===
                                                                                (h =
                                                                                  S[
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.variantId
                                                                                  ]) ||
                                                                              void 0 ===
                                                                                h
                                                                                ? void 0
                                                                                : h.QuantityPriceBreaks) &&
                                                                              null !=
                                                                                w(
                                                                                  null ==
                                                                                    t
                                                                                    ? void 0
                                                                                    : t.variantId,
                                                                                  null ===
                                                                                    (f =
                                                                                      S[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ]) ||
                                                                                    void 0 ===
                                                                                      f
                                                                                    ? void 0
                                                                                    : f.quantity,
                                                                                  null ===
                                                                                    (g =
                                                                                      S[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ]) ||
                                                                                    void 0 ===
                                                                                      g
                                                                                    ? void 0
                                                                                    : g.price
                                                                                )
                                                                                ? ""
                                                                                    .concat(
                                                                                      r,
                                                                                      " "
                                                                                    )
                                                                                    .concat(
                                                                                      w(
                                                                                        null ==
                                                                                          t
                                                                                          ? void 0
                                                                                          : t.variantId,
                                                                                        null ===
                                                                                          (b =
                                                                                            S[
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.variantId
                                                                                            ]) ||
                                                                                          void 0 ===
                                                                                            b
                                                                                          ? void 0
                                                                                          : b.quantity,
                                                                                        null ===
                                                                                          (y =
                                                                                            S[
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.variantId
                                                                                            ]) ||
                                                                                          void 0 ===
                                                                                            y
                                                                                          ? void 0
                                                                                          : y.price
                                                                                      )
                                                                                    )
                                                                                : ""
                                                                                    .concat(
                                                                                      r,
                                                                                      "  "
                                                                                    )
                                                                                    .concat(
                                                                                      (null ==
                                                                                      t
                                                                                        ? void 0
                                                                                        : t.variantPrice
                                                                                      ).toFixed(
                                                                                        2
                                                                                      ) ||
                                                                                        (0).toFixed(
                                                                                          2
                                                                                        )
                                                                                    ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      !T &&
                                                                        ((!D &&
                                                                          A) ||
                                                                          D) &&
                                                                        (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          vy(
                                                                            {
                                                                              align:
                                                                                "center",
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Hc,
                                                                                  {
                                                                                    InputProps:
                                                                                      {
                                                                                        inputProps:
                                                                                          {
                                                                                            className:
                                                                                              "ST_Custom_Number_Input",
                                                                                          },
                                                                                      },
                                                                                    name: "".concat(
                                                                                      null ==
                                                                                        t
                                                                                        ? void 0
                                                                                        : t.variantId
                                                                                    ),
                                                                                    placeholder:
                                                                                      "0",
                                                                                    variant:
                                                                                      "outlined",
                                                                                    size: "small",
                                                                                    type: "number",
                                                                                    value:
                                                                                      I(
                                                                                        N[
                                                                                          (null ==
                                                                                          t
                                                                                            ? void 0
                                                                                            : t.variantId) ||
                                                                                            0
                                                                                        ]
                                                                                      )
                                                                                        ? N[
                                                                                            (null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.variantId) ||
                                                                                              0
                                                                                          ]
                                                                                        : "",
                                                                                    disabled:
                                                                                      !D &&
                                                                                      A,
                                                                                    onKeyDown:
                                                                                      jb,
                                                                                    onChange:
                                                                                      function (
                                                                                        e
                                                                                      ) {
                                                                                        M(
                                                                                          e,
                                                                                          t
                                                                                        );
                                                                                      },
                                                                                    error:
                                                                                      j[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ] ||
                                                                                      !1,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          )
                                                                        ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            sx: s
                                                                              ? {
                                                                                  display:
                                                                                    "none",
                                                                                }
                                                                              : {
                                                                                  display:
                                                                                    "table-cell",
                                                                                },
                                                                            align:
                                                                              "center",
                                                                            className:
                                                                              "ST_White_Space",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                ""
                                                                                  .concat(
                                                                                    r,
                                                                                    "  "
                                                                                  )
                                                                                  .concat(
                                                                                    d(
                                                                                      t
                                                                                    )
                                                                                  ),
                                                                                " ",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Gs,
                                                                                  vy(
                                                                                    {
                                                                                      arrow:
                                                                                        !0,
                                                                                      title:
                                                                                        "Quantity",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsxs)(
                                                                                          "span",
                                                                                          vy(
                                                                                            {
                                                                                              className:
                                                                                                "Display_Alignment_Middle",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                [
                                                                                                  (0,
                                                                                                  e.jsx)(
                                                                                                    Qu,
                                                                                                    vy(
                                                                                                      {
                                                                                                        id: "decreaseQty",
                                                                                                        onClick:
                                                                                                          function () {
                                                                                                            var e;
                                                                                                            return x(
                                                                                                              null ===
                                                                                                                (e =
                                                                                                                  S[
                                                                                                                    null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId
                                                                                                                  ]) ||
                                                                                                                void 0 ===
                                                                                                                  e
                                                                                                                ? void 0
                                                                                                                : e.quantity,
                                                                                                              null ==
                                                                                                                t
                                                                                                                ? void 0
                                                                                                                : t.variantId,
                                                                                                              (null ==
                                                                                                              i
                                                                                                                ? void 0
                                                                                                                : i.PriceList) &&
                                                                                                                "" !==
                                                                                                                  (null ==
                                                                                                                  c
                                                                                                                    ? void 0
                                                                                                                    : c.customerName)
                                                                                                                ? d(
                                                                                                                    t
                                                                                                                  )
                                                                                                                : t.variantPrice,
                                                                                                              "decreaseQty"
                                                                                                            );
                                                                                                          },
                                                                                                        sx: u,
                                                                                                        "aria-label":
                                                                                                          "reduce",
                                                                                                      },
                                                                                                      {
                                                                                                        children:
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            wb,
                                                                                                            {
                                                                                                              fontSize:
                                                                                                                "small",
                                                                                                            }
                                                                                                          ),
                                                                                                      }
                                                                                                    )
                                                                                                  ),
                                                                                                  (0,
                                                                                                  e.jsx)(
                                                                                                    Hc,
                                                                                                    {
                                                                                                      InputProps:
                                                                                                        {
                                                                                                          inputProps:
                                                                                                            {
                                                                                                              className:
                                                                                                                "ST_Custom_Number_Input",
                                                                                                            },
                                                                                                        },
                                                                                                      value:
                                                                                                        null ===
                                                                                                          (C =
                                                                                                            S[
                                                                                                              null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.variantId
                                                                                                            ]) ||
                                                                                                        void 0 ===
                                                                                                          C
                                                                                                          ? void 0
                                                                                                          : C.quantity,
                                                                                                      sx: p,
                                                                                                      onKeyDown:
                                                                                                        Nb,
                                                                                                      name: "".concat(
                                                                                                        null ==
                                                                                                          t
                                                                                                          ? void 0
                                                                                                          : t.variantId
                                                                                                      ),
                                                                                                      variant:
                                                                                                        "outlined",
                                                                                                      size: "small",
                                                                                                      type: "number",
                                                                                                      error:
                                                                                                        k[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ] ||
                                                                                                        !1,
                                                                                                      onChange:
                                                                                                        function (
                                                                                                          e
                                                                                                        ) {
                                                                                                          return x(
                                                                                                            null ==
                                                                                                              e
                                                                                                              ? void 0
                                                                                                              : e
                                                                                                                  .target
                                                                                                                  .value,
                                                                                                            null ==
                                                                                                              t
                                                                                                              ? void 0
                                                                                                              : t.variantId,
                                                                                                            (null ==
                                                                                                            i
                                                                                                              ? void 0
                                                                                                              : i.PriceList) &&
                                                                                                              "" !==
                                                                                                                (null ==
                                                                                                                c
                                                                                                                  ? void 0
                                                                                                                  : c.customerName)
                                                                                                              ? d(
                                                                                                                  t
                                                                                                                )
                                                                                                              : null ==
                                                                                                                t
                                                                                                              ? void 0
                                                                                                              : t.variantPrice,
                                                                                                            "manual"
                                                                                                          );
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                  (0,
                                                                                                  e.jsx)(
                                                                                                    Qu,
                                                                                                    vy(
                                                                                                      {
                                                                                                        id: "increaseQty",
                                                                                                        sx: u,
                                                                                                        "aria-label":
                                                                                                          "increase",
                                                                                                        onClick:
                                                                                                          function () {
                                                                                                            var e;
                                                                                                            return x(
                                                                                                              null ===
                                                                                                                (e =
                                                                                                                  S[
                                                                                                                    null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId
                                                                                                                  ]) ||
                                                                                                                void 0 ===
                                                                                                                  e
                                                                                                                ? void 0
                                                                                                                : e.quantity,
                                                                                                              null ==
                                                                                                                t
                                                                                                                ? void 0
                                                                                                                : t.variantId,
                                                                                                              (null ==
                                                                                                              i
                                                                                                                ? void 0
                                                                                                                : i.PriceList) &&
                                                                                                                "" !==
                                                                                                                  (null ==
                                                                                                                  c
                                                                                                                    ? void 0
                                                                                                                    : c.customerName)
                                                                                                                ? d(
                                                                                                                    t
                                                                                                                  )
                                                                                                                : t.variantPrice,
                                                                                                              "increaseQty"
                                                                                                            );
                                                                                                          },
                                                                                                      },
                                                                                                      {
                                                                                                        children:
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Ob,
                                                                                                            {
                                                                                                              fontSize:
                                                                                                                "small",
                                                                                                            }
                                                                                                          ),
                                                                                                      }
                                                                                                    )
                                                                                                  ),
                                                                                                ],
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                                T
                                                                                  ? (0,
                                                                                    e.jsxs)(
                                                                                      "div",
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (null ===
                                                                                              (E =
                                                                                                null ===
                                                                                                  (P =
                                                                                                    S[
                                                                                                      null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.variantId
                                                                                                    ]) ||
                                                                                                void 0 ===
                                                                                                  P
                                                                                                  ? void 0
                                                                                                  : P.QuantityRule) ||
                                                                                            void 0 ===
                                                                                              E
                                                                                              ? void 0
                                                                                              : E.Increment) &&
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                e.Fragment,
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      l(
                                                                                                        "B2B_PriceList_Increment_Msg"
                                                                                                      ),
                                                                                                      null ===
                                                                                                        (L =
                                                                                                          null ===
                                                                                                            (R =
                                                                                                              S[
                                                                                                                null ==
                                                                                                                t
                                                                                                                  ? void 0
                                                                                                                  : t.variantId
                                                                                                              ]) ||
                                                                                                          void 0 ===
                                                                                                            R
                                                                                                            ? void 0
                                                                                                            : R.QuantityRule) ||
                                                                                                      void 0 ===
                                                                                                        L
                                                                                                        ? void 0
                                                                                                        : L.Increment,
                                                                                                      " ",
                                                                                                      "",
                                                                                                    ],
                                                                                                }
                                                                                              ),
                                                                                            (null ===
                                                                                              (z =
                                                                                                null ===
                                                                                                  (B =
                                                                                                    S[
                                                                                                      null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.variantId
                                                                                                    ]) ||
                                                                                                void 0 ===
                                                                                                  B
                                                                                                  ? void 0
                                                                                                  : B.QuantityRule) ||
                                                                                            void 0 ===
                                                                                              z
                                                                                              ? void 0
                                                                                              : z.Minimum) &&
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                e.Fragment,
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      l(
                                                                                                        "B2B_PriceList_Minimum_Msg"
                                                                                                      ),
                                                                                                      null ===
                                                                                                        (Z =
                                                                                                          null ===
                                                                                                            (F =
                                                                                                              S[
                                                                                                                null ==
                                                                                                                t
                                                                                                                  ? void 0
                                                                                                                  : t.variantId
                                                                                                              ]) ||
                                                                                                          void 0 ===
                                                                                                            F
                                                                                                            ? void 0
                                                                                                            : F.QuantityRule) ||
                                                                                                      void 0 ===
                                                                                                        Z
                                                                                                        ? void 0
                                                                                                        : Z.Minimum,
                                                                                                      " ",
                                                                                                      "",
                                                                                                    ],
                                                                                                }
                                                                                              ),
                                                                                            (null ===
                                                                                              (V =
                                                                                                null ===
                                                                                                  (H =
                                                                                                    S[
                                                                                                      null ==
                                                                                                      t
                                                                                                        ? void 0
                                                                                                        : t.variantId
                                                                                                    ]) ||
                                                                                                void 0 ===
                                                                                                  H
                                                                                                  ? void 0
                                                                                                  : H.QuantityRule) ||
                                                                                            void 0 ===
                                                                                              V
                                                                                              ? void 0
                                                                                              : V.Maximum) &&
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                e.Fragment,
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      l(
                                                                                                        "B2B_PriceList_Maximum_Msg"
                                                                                                      ),
                                                                                                      " ",
                                                                                                      null ===
                                                                                                        (U =
                                                                                                          null ===
                                                                                                            (W =
                                                                                                              S[
                                                                                                                null ==
                                                                                                                t
                                                                                                                  ? void 0
                                                                                                                  : t.variantId
                                                                                                              ]) ||
                                                                                                          void 0 ===
                                                                                                            W
                                                                                                            ? void 0
                                                                                                            : W.QuantityRule) ||
                                                                                                      void 0 ===
                                                                                                        U
                                                                                                        ? void 0
                                                                                                        : U.Maximum,
                                                                                                    ],
                                                                                                }
                                                                                              ),
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  : "",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                            sx: by(
                                                                              [
                                                                                T
                                                                                  ? {
                                                                                      display:
                                                                                        "table-cell",
                                                                                    }
                                                                                  : {
                                                                                      display:
                                                                                        "none",
                                                                                    },
                                                                              ],
                                                                              (null ===
                                                                                (K =
                                                                                  null ===
                                                                                    ($ =
                                                                                      S[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ]) ||
                                                                                  void 0 ===
                                                                                    $
                                                                                    ? void 0
                                                                                    : $.QuantityPriceBreaks) ||
                                                                              void 0 ===
                                                                                K
                                                                                ? void 0
                                                                                : K.length) >
                                                                                0
                                                                                ? [
                                                                                    Lo,
                                                                                  ]
                                                                                : [],
                                                                              !0
                                                                            ),
                                                                            className:
                                                                              0 ===
                                                                              (null ===
                                                                                (q =
                                                                                  null ===
                                                                                    (G =
                                                                                      S[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ]) ||
                                                                                  void 0 ===
                                                                                    G
                                                                                    ? void 0
                                                                                    : G.QuantityPriceBreaks) ||
                                                                              void 0 ===
                                                                                q
                                                                                ? void 0
                                                                                : q.length)
                                                                                ? "ST_MC_Cursor_CSS"
                                                                                : "",
                                                                            onClick:
                                                                              function () {
                                                                                return O(
                                                                                  null ==
                                                                                    n
                                                                                    ? void 0
                                                                                    : n.title,
                                                                                  null ==
                                                                                    t
                                                                                    ? void 0
                                                                                    : t.variantId
                                                                                );
                                                                              },
                                                                          },
                                                                          {
                                                                            children:
                                                                              (null ===
                                                                                (Y =
                                                                                  null ===
                                                                                    (Q =
                                                                                      S[
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.variantId
                                                                                      ]) ||
                                                                                  void 0 ===
                                                                                    Q
                                                                                    ? void 0
                                                                                    : Q.QuantityPriceBreaks) ||
                                                                              void 0 ===
                                                                                Y
                                                                                ? void 0
                                                                                : Y.length) >
                                                                              0
                                                                                ? "View Pricing"
                                                                                : "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        vy(
                                                                          {
                                                                            align:
                                                                              "center",
                                                                            className:
                                                                              "ST_White_Space",
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsxs)(
                                                                                "b",
                                                                                {
                                                                                  children:
                                                                                    [
                                                                                      r,
                                                                                      (
                                                                                        null ===
                                                                                          (J =
                                                                                            S[
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.variantId
                                                                                            ]) ||
                                                                                        void 0 ===
                                                                                          J
                                                                                          ? void 0
                                                                                          : J.subtotal
                                                                                      )
                                                                                        ? null ===
                                                                                            (ee =
                                                                                              Math.trunc(
                                                                                                100 *
                                                                                                  Number(
                                                                                                    null ===
                                                                                                      (X =
                                                                                                        S[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ]) ||
                                                                                                      void 0 ===
                                                                                                        X
                                                                                                      ? void 0
                                                                                                      : X.subtotal
                                                                                                  )
                                                                                              ) /
                                                                                              100) ||
                                                                                          void 0 ===
                                                                                            ee
                                                                                          ? void 0
                                                                                          : ee.toFixed(
                                                                                              2
                                                                                            )
                                                                                        : (null ==
                                                                                          i
                                                                                            ? void 0
                                                                                            : i.PriceList) &&
                                                                                          "" !==
                                                                                            (null ==
                                                                                            c
                                                                                              ? void 0
                                                                                              : c.customerName)
                                                                                        ? d(
                                                                                            t
                                                                                          )
                                                                                        : 0,
                                                                                    ],
                                                                                }
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  }
                                                                ),
                                                                o
                                                              );
                                                            }),
                                                      ],
                                                    },
                                                    o
                                                  )
                                                : null;
                                            }),
                                    })
                                  : (0, e.jsx)(Cp, {
                                      children: (0, e.jsx)(
                                        Op,
                                        vy(
                                          {
                                            align: "center",
                                            colSpan:
                                              null ===
                                                (f =
                                                  null == R
                                                    ? void 0
                                                    : R.filter(function (e) {
                                                        return !e.hide;
                                                      })) || void 0 === f
                                                ? void 0
                                                : f.length,
                                          },
                                          {
                                            children: y
                                              ? l("productsLoading")
                                              : (0, e.jsxs)(
                                                  "div",
                                                  vy(
                                                    {
                                                      style: {
                                                        marginTop: "15px",
                                                      },
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          ni,
                                                          vy(
                                                            {
                                                              variant: Av,
                                                              sx: Ko,
                                                            },
                                                            {
                                                              children: l(
                                                                "createOrder_productTable_NoProductsAdded"
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          Qu,
                                                          vy(
                                                            {
                                                              sx: {
                                                                mt: 1,
                                                                mb: 2,
                                                                textTransform:
                                                                  "capitalize",
                                                              },
                                                              onClick:
                                                                function () {
                                                                  return P();
                                                                },
                                                              variant:
                                                                "contained",
                                                            },
                                                            {
                                                              children: l(
                                                                "createOrder_AddProduct"
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                          }
                                        )
                                      ),
                                    }),
                            }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            });
          },
          productTable_SubTotal: function (t) {
            return t > 0
              ? (0, e.jsxs)(
                  "div",
                  vy(
                    { className: "ST_ProductTable_subtotal" },
                    {
                      children: [
                        (0, e.jsx)(
                          mn,
                          vy(
                            { className: "ST_ProductTable_subtotal_boxes" },
                            {
                              children: (0, e.jsxs)(
                                "b",
                                vy(
                                  { className: "ST_CS_TableHeading" },
                                  {
                                    children: [
                                      l(
                                        "customerInvoice_ProductTableColumnSubTotal"
                                      ),
                                      " ",
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          mn,
                          vy(
                            { className: "ST_ProductTable_subtotal_boxes" },
                            {
                              children: (0, e.jsxs)("b", {
                                children: [
                                  r,
                                  " ",
                                  "   ",
                                  (Math.trunc(100 * Number(t)) / 100).toFixed(
                                    2
                                  ),
                                  " " + (null != o ? o : ""),
                                ],
                              }),
                            }
                          )
                        ),
                      ],
                    }
                  )
                )
              : (0, e.jsx)("br", {});
          },
        };
      }
      var yy = function () {
          return (
            (yy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            yy.apply(this, arguments)
          );
        },
        Cy = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function xy() {
        var n,
          r,
          o = rf(),
          a = o.shopCurrency,
          i = o.currency,
          s = gy(),
          l = s.selectFeatures,
          d = s.hideWholeSalePriceListColumn,
          c = s.t,
          u = s.handleWholesalePriceMapping,
          p = s.createOrderTabReduxState,
          m = {
            background: "#F2F2F2",
            border: "1px solid #E0E0E0",
            color: "gray",
            minWidth: "40px !important",
          },
          h = { width: "50px", m: "5px", textAlign: "center" },
          f = xv(),
          g = f.disableTableRow,
          v = f.LinearDeterminate,
          b = [
            { name: "ST_Producttable_product", hide: !1 },
            {
              name: "ST_Producttable_SKU",
              hide: !(null ===
                (n = null == l ? void 0 : l.featuresAdditionalSettings) ||
              void 0 === n
                ? void 0
                : n.showSkuColumn),
            },
            {
              name: "customerInvoice_ProductTableColumnInventory",
              hide: !(null ===
                (r = null == l ? void 0 : l.featuresAdditionalSettings) ||
              void 0 === r
                ? void 0
                : r.showInventoryColumn),
            },
            { name: "ST_Producttable_retailPrice", hide: !1 },
            { name: "ST_Producttable_wholesalePrice", hide: d },
          ];
        return {
          productTableSearchBar_mobile: function (t) {
            var n = t.handleProductTableSearchPopup,
              r = t.removeAllSelectedProducts,
              o = t.finalSelectedProducts,
              a = t.propsFromCreateOrderParentTab,
              i = t.selectedDiscountType,
              s = t.handleSelectChangeForDiscountType,
              l = t.ShopApplyDiscount,
              d = t.isDiscoutAppliedInEditDraft,
              u = t.isRemoveCartPopup,
              p = t.setIsRemoveCartPopup;
            return (0, e.jsxs)(
              "div",
              yy(
                { className: "ST_ProductTableSearchBar" },
                {
                  children: [
                    (0, e.jsx)(ju, {
                      id: "free-solo-demo",
                      freeSolo: !0,
                      inputValue: "",
                      className: "ST_SearchBar",
                      sx: {
                        ml: 1,
                        flex: 1,
                        "& .MuiOutlinedInput-root": {
                          border: "none",
                          background: "white",
                          boxShadow: "none",
                          "& fieldset": { border: "none" },
                          "&:hover fieldset": { border: "none" },
                          "&.Mui-focused fieldset": { border: "none" },
                          "&.MuiOutlinedInput-root.Mui-focused": {
                            boxShadow: "0px 2px 4px rgba(0,0,0,0.1)",
                          },
                        },
                      },
                      options: [],
                      renderInput: function (t) {
                        return (0, e.jsx)(
                          Hc,
                          yy(
                            { placeholder: c("ST_CO_SearchProducts_Label") },
                            t,
                            {
                              className: "ST_SearchBar",
                              onClick: function () {
                                n();
                              },
                              InputProps: yy(yy({}, t.InputProps), {
                                endAdornment: (0, e.jsx)(
                                  Bu,
                                  yy(
                                    {
                                      position: "end",
                                      sx: { mr: 0, p: "15px" },
                                    },
                                    { children: (0, e.jsx)(Rv, {}) }
                                  )
                                ),
                              }),
                            }
                          )
                        );
                      },
                      size: "medium",
                    }),
                    !a &&
                      ((!l && d) || l) &&
                      (0, e.jsx)(
                        qa,
                        yy(
                          {
                            className: "ST_SearchBar",
                            sx: { marginTop: "13px !important" },
                          },
                          {
                            children: (0, e.jsxs)(
                              yd,
                              yy(
                                { fullWidth: !0, size: "small" },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      hd,
                                      yy(
                                        { id: "demo-select-small" },
                                        {
                                          children: c(
                                            "producttable_discounttypeHeader"
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsxs)(
                                      Rc,
                                      yy(
                                        {
                                          sx: {
                                            backgroundColor: "white",
                                            height: 47,
                                          },
                                          labelId: "demo-select-small",
                                          value: i,
                                          label: c(
                                            "customerInvoice_DiscountOnSubtotal"
                                          ),
                                          readOnly: !l && d,
                                          disabled: !l && d,
                                          onChange: function (e) {
                                            s(e);
                                          },
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              J_,
                                              yy(
                                                { value: "percentage" },
                                                {
                                                  children: c(
                                                    "Create_Order_DiscountDropdown_value1"
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              J_,
                                              yy(
                                                { value: "dollar" },
                                                {
                                                  children: c(
                                                    "Create_Order_DiscountDropdown_value2"
                                                  ),
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                          }
                        )
                      ),
                    o && (null == o ? void 0 : o.length) > 0
                      ? (0, e.jsx)(
                          Qu,
                          yy(
                            {
                              disabled:
                                !o || 0 === (null == o ? void 0 : o.length),
                              variant: "outlined",
                              startIcon: (0, e.jsx)(Ev, {}),
                              sx: { mt: 1, mb: 2, textTransform: "capitalize" },
                              onClick: function () {
                                return p(!0);
                              },
                            },
                            { children: c("productTable_clearCartBtn") }
                          )
                        )
                      : null,
                    u &&
                      (0, e.jsx)(Z_, {
                        isRemoveCartPopup: u,
                        setIsRemoveCartPopup: p,
                        removeProductMethod: r,
                      }),
                  ],
                }
              )
            );
          },
          searchProductTablePopUp_mobile: function (n) {
            var r,
              o = n.searchTablePopupOpen,
              i = n.closePopupForSearchProductData,
              s = n.handleKeyDown,
              p = n.handleSearchTextChange,
              m = n.makeFieldsEmpty,
              h = n.handleSearchProductData,
              f = n.checkUncheckProductVariant,
              _ = n.handlePrevClick,
              y = n.handleNextClick,
              C = n.showSelectedProduct,
              x = n.productsArray,
              S = n.selectedProductIdArray,
              k = n.selectedVariantArray,
              P = n.pageInfo,
              w = n.getProductsLoading,
              O = n.productSearchText,
              T = n.propsFromCreateOrderParentTab,
              I = n.selectedProductArray,
              M = n.tableContainerRef,
              j = n.loadMoreBtnDisable;
            return (0, e.jsxs)(
              Hp,
              yy(
                {
                  open: o,
                  onClose: function () {
                    return i();
                  },
                  fullWidth: !0,
                  maxWidth: "md",
                  className: "Dialog_Border_Radius",
                },
                {
                  children: [
                    (0, e.jsxs)("div", {
                      children: [
                        (0, e.jsxs)(
                          qa,
                          yy(
                            {
                              container: !0,
                              spacing: 2,
                              className: "Product_Picker_Heading",
                            },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  yy(
                                    { item: !0, xs: 10, md: 10 },
                                    {
                                      children: (0, e.jsx)(
                                        ni,
                                        yy(
                                          { variant: Av, sx: Ko },
                                          {
                                            children: c(
                                              "ST_CO_SearchProducts_Label"
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  qa,
                                  yy(
                                    {
                                      item: !0,
                                      xs: 2,
                                      md: 2,
                                      sx: { textAlign: "right" },
                                      pr: 1,
                                    },
                                    {
                                      children: (0, e.jsx)(Fg, {
                                        sx: { cursor: "pointer" },
                                        onClick: function () {
                                          i();
                                        },
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsxs)(
                          qa,
                          yy(
                            { container: !0, p: 2 },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  yy(
                                    { item: !0, xs: 8, md: 10, lg: 10, xl: 10 },
                                    {
                                      children: (0, e.jsxs)(
                                        go,
                                        yy(
                                          { className: "PT_SearchBox" },
                                          {
                                            children: [
                                              (0, e.jsx)(Ml, {
                                                autoFocus: !0,
                                                value: O,
                                                onKeyDown: s,
                                                onChange: function (e) {
                                                  return p(e);
                                                },
                                                sx: { ml: 2, flex: 1 },
                                                size: "small",
                                                placeholder: c(
                                                  "ST_CO_SearchProducts_Label"
                                                ),
                                                inputProps: {
                                                  "aria-label":
                                                    "searchProducts",
                                                },
                                              }),
                                              (0, e.jsx)(
                                                Jn,
                                                yy(
                                                  {
                                                    onClick: m,
                                                    type: "button",
                                                    sx: { p: "10px" },
                                                    "aria-label": "search",
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Fg,
                                                      {}
                                                    ),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                !T &&
                                  (0, e.jsx)(
                                    qa,
                                    yy(
                                      {
                                        sx: {
                                          display: "flex",
                                          alignItems: "center",
                                          justifyContent: "end",
                                        },
                                        item: !0,
                                        xs: 4,
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          Ym,
                                          yy(
                                            {
                                              disabled: !O,
                                              loading: w,
                                              sx: {
                                                textTransform: "capitalize",
                                              },
                                              onClick: function () {
                                                h();
                                              },
                                              variant: "contained",
                                            },
                                            { children: c("ST_CO_search") }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Gp,
                          yy(
                            { sx: { padding: "0px" } },
                            {
                              children: (0, e.jsx)(
                                ep,
                                yy(
                                  {
                                    className: "selectProductsProductTable",
                                    component: go,
                                    ref: M,
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      sp,
                                      yy(
                                        {
                                          stickyHeader: !0,
                                          "aria-label":
                                            "selectProductsProductTable",
                                        },
                                        {
                                          children:
                                            0 !==
                                            (null == x ? void 0 : x.length)
                                              ? (0, e.jsx)(e.Fragment, {
                                                  children:
                                                    null == x
                                                      ? void 0
                                                      : x.map(function (n, r) {
                                                          var o, i, s, p;
                                                          return (null ===
                                                            (o =
                                                              null == n
                                                                ? void 0
                                                                : n.variants) ||
                                                          void 0 === o
                                                            ? void 0
                                                            : o.length) > 0
                                                            ? (0, e.jsx)(Dp, {
                                                                children: (0,
                                                                e.jsxs)(
                                                                  t.Fragment,
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        Cp,
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Op,
                                                                              yy(
                                                                                {
                                                                                  className:
                                                                                    "New_PT_Header",
                                                                                  colSpan:
                                                                                    null ===
                                                                                      (i =
                                                                                        null ==
                                                                                        b
                                                                                          ? void 0
                                                                                          : b.filter(
                                                                                              function (
                                                                                                e
                                                                                              ) {
                                                                                                return !e.hide;
                                                                                              }
                                                                                            )) ||
                                                                                    void 0 ===
                                                                                      i
                                                                                      ? void 0
                                                                                      : i.length,
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsxs)(
                                                                                      mn,
                                                                                      yy(
                                                                                        {
                                                                                          display:
                                                                                            "flex",
                                                                                          alignItems:
                                                                                            "center",
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            [
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                tb,
                                                                                                {
                                                                                                  disabled:
                                                                                                    g(
                                                                                                      n
                                                                                                    ),
                                                                                                  checked:
                                                                                                    !!(null ==
                                                                                                    S
                                                                                                      ? void 0
                                                                                                      : S.includes(
                                                                                                          null ==
                                                                                                            n
                                                                                                            ? void 0
                                                                                                            : n.productId
                                                                                                        )),
                                                                                                  onChange:
                                                                                                    function (
                                                                                                      e
                                                                                                    ) {
                                                                                                      return f(
                                                                                                        e,
                                                                                                        "isProduct",
                                                                                                        n
                                                                                                      );
                                                                                                    },
                                                                                                }
                                                                                              ),
                                                                                              (null ==
                                                                                              n
                                                                                                ? void 0
                                                                                                : n.imageUrl) &&
                                                                                              0 !==
                                                                                                (null ===
                                                                                                  (s =
                                                                                                    null ==
                                                                                                    n
                                                                                                      ? void 0
                                                                                                      : n.imageUrl) ||
                                                                                                void 0 ===
                                                                                                  s
                                                                                                  ? void 0
                                                                                                  : s.length)
                                                                                                ? (0,
                                                                                                  e.jsx)(
                                                                                                    lb,
                                                                                                    {
                                                                                                      alt: "image",
                                                                                                      src: n.imageUrl,
                                                                                                      variant:
                                                                                                        "rounded",
                                                                                                    }
                                                                                                  )
                                                                                                : (0,
                                                                                                  e.jsx)(
                                                                                                    lb,
                                                                                                    yy(
                                                                                                      {
                                                                                                        alt: "image",
                                                                                                        sx: {
                                                                                                          bgcolor:
                                                                                                            "white",
                                                                                                          color:
                                                                                                            "black",
                                                                                                        },
                                                                                                        variant:
                                                                                                          "rounded",
                                                                                                      },
                                                                                                      {
                                                                                                        children:
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            Sb,
                                                                                                            {
                                                                                                              sx: {
                                                                                                                fontSize:
                                                                                                                  "3.1rem",
                                                                                                              },
                                                                                                            }
                                                                                                          ),
                                                                                                      }
                                                                                                    )
                                                                                                  ),
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                mn,
                                                                                                yy(
                                                                                                  {
                                                                                                    sx: {
                                                                                                      ml: 1,
                                                                                                      whiteSpace:
                                                                                                        "pre-line",
                                                                                                    },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (null ==
                                                                                                        n ||
                                                                                                        n.title,
                                                                                                      null ==
                                                                                                      n
                                                                                                        ? void 0
                                                                                                        : n.title),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                            ],
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Cp,
                                                                        yy(
                                                                          {
                                                                            sx: {
                                                                              whiteSpace:
                                                                                "nowrap",
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              null ===
                                                                                (p =
                                                                                  null ==
                                                                                  n
                                                                                    ? void 0
                                                                                    : n.variants) ||
                                                                              void 0 ===
                                                                                p
                                                                                ? void 0
                                                                                : p.map(
                                                                                    function (
                                                                                      t,
                                                                                      r
                                                                                    ) {
                                                                                      var o,
                                                                                        i,
                                                                                        s;
                                                                                      return (0,
                                                                                      e.jsxs)(
                                                                                        e.Fragment,
                                                                                        {
                                                                                          children:
                                                                                            [
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                "div",
                                                                                                yy(
                                                                                                  {
                                                                                                    className:
                                                                                                      "Popup_PT_TableCell",
                                                                                                    style:
                                                                                                      {
                                                                                                        margin:
                                                                                                          "10px 15px",
                                                                                                        opacity:
                                                                                                          (
                                                                                                            null ==
                                                                                                            t
                                                                                                              ? void 0
                                                                                                              : t.availableForSale
                                                                                                          )
                                                                                                            ? 1
                                                                                                            : 0.7,
                                                                                                      },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      [
                                                                                                        (0,
                                                                                                        e.jsx)(
                                                                                                          Cp,
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                Op,
                                                                                                                yy(
                                                                                                                  {
                                                                                                                    colSpan: 2,
                                                                                                                  },
                                                                                                                  {
                                                                                                                    children:
                                                                                                                      (0,
                                                                                                                      e.jsxs)(
                                                                                                                        mn,
                                                                                                                        yy(
                                                                                                                          {
                                                                                                                            display:
                                                                                                                              "flex",
                                                                                                                            alignItems:
                                                                                                                              "center",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              [
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  tb,
                                                                                                                                  {
                                                                                                                                    disabled:
                                                                                                                                      !(null ==
                                                                                                                                      t
                                                                                                                                        ? void 0
                                                                                                                                        : t.availableForSale),
                                                                                                                                    checked:
                                                                                                                                      null ==
                                                                                                                                      k
                                                                                                                                        ? void 0
                                                                                                                                        : k.some(
                                                                                                                                            function (
                                                                                                                                              e
                                                                                                                                            ) {
                                                                                                                                              return (
                                                                                                                                                e.variantId ===
                                                                                                                                                t.variantId
                                                                                                                                              );
                                                                                                                                            }
                                                                                                                                          ),
                                                                                                                                    onChange:
                                                                                                                                      function (
                                                                                                                                        e
                                                                                                                                      ) {
                                                                                                                                        return f(
                                                                                                                                          e,
                                                                                                                                          "isVariant",
                                                                                                                                          n,
                                                                                                                                          t
                                                                                                                                        );
                                                                                                                                      },
                                                                                                                                  }
                                                                                                                                ),
                                                                                                                                (0,
                                                                                                                                e.jsx)(
                                                                                                                                  mn,
                                                                                                                                  yy(
                                                                                                                                    {
                                                                                                                                      sx: {
                                                                                                                                        ml: 2,
                                                                                                                                        whiteSpace:
                                                                                                                                          "pre-line",
                                                                                                                                      },
                                                                                                                                    },
                                                                                                                                    {
                                                                                                                                      children:
                                                                                                                                        "Default Title" !==
                                                                                                                                        (null ==
                                                                                                                                        t
                                                                                                                                          ? void 0
                                                                                                                                          : t.title)
                                                                                                                                          ? null ==
                                                                                                                                            t
                                                                                                                                            ? void 0
                                                                                                                                            : t.title
                                                                                                                                          : null ==
                                                                                                                                            n
                                                                                                                                          ? void 0
                                                                                                                                          : n.title,
                                                                                                                                    }
                                                                                                                                  )
                                                                                                                                ),
                                                                                                                              ],
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                  }
                                                                                                                )
                                                                                                              ),
                                                                                                          }
                                                                                                        ),
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          Cp,
                                                                                                          yy(
                                                                                                            {
                                                                                                              className:
                                                                                                                "Popup_PT_Sub_TableCell",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    Op,
                                                                                                                    yy(
                                                                                                                      {
                                                                                                                        sx: (
                                                                                                                          null ===
                                                                                                                            (o =
                                                                                                                              null ==
                                                                                                                              l
                                                                                                                                ? void 0
                                                                                                                                : l.featuresAdditionalSettings) ||
                                                                                                                          void 0 ===
                                                                                                                            o
                                                                                                                            ? void 0
                                                                                                                            : o.showSkuColumn
                                                                                                                        )
                                                                                                                          ? {
                                                                                                                              display:
                                                                                                                                "table-cell",
                                                                                                                            }
                                                                                                                          : {
                                                                                                                              display:
                                                                                                                                "none",
                                                                                                                            },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            (0,
                                                                                                                            e.jsxs)(
                                                                                                                              "b",
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  [
                                                                                                                                    c(
                                                                                                                                      "ST_Producttable_SKU"
                                                                                                                                    ),
                                                                                                                                    " :",
                                                                                                                                  ],
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            " ",
                                                                                                                            null !==
                                                                                                                              (i =
                                                                                                                                null ==
                                                                                                                                t
                                                                                                                                  ? void 0
                                                                                                                                  : t.sku) &&
                                                                                                                            void 0 !==
                                                                                                                              i
                                                                                                                              ? i
                                                                                                                              : "-",
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    Op,
                                                                                                                    yy(
                                                                                                                      {
                                                                                                                        sx: (
                                                                                                                          null ===
                                                                                                                            (s =
                                                                                                                              null ==
                                                                                                                              l
                                                                                                                                ? void 0
                                                                                                                                : l.featuresAdditionalSettings) ||
                                                                                                                          void 0 ===
                                                                                                                            s
                                                                                                                            ? void 0
                                                                                                                            : s.showInventoryColumn
                                                                                                                        )
                                                                                                                          ? {
                                                                                                                              display:
                                                                                                                                "table-cell",
                                                                                                                            }
                                                                                                                          : {
                                                                                                                              display:
                                                                                                                                "none",
                                                                                                                            },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            (0,
                                                                                                                            e.jsxs)(
                                                                                                                              "b",
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  [
                                                                                                                                    c(
                                                                                                                                      "customerInvoice_ProductTableColumnInventory"
                                                                                                                                    ),
                                                                                                                                    " : ",
                                                                                                                                  ],
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            (
                                                                                                                              null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.availableForSale
                                                                                                                            )
                                                                                                                              ? t.quantityAvailable ||
                                                                                                                                0
                                                                                                                              : (0,
                                                                                                                                e.jsx)(
                                                                                                                                  du,
                                                                                                                                  {
                                                                                                                                    label:
                                                                                                                                      c(
                                                                                                                                        "soldOut"
                                                                                                                                      ),
                                                                                                                                    sx: {
                                                                                                                                      backgroundColor:
                                                                                                                                        "#fff6c2",
                                                                                                                                      borderColor:
                                                                                                                                        "#f7eba2",
                                                                                                                                    },
                                                                                                                                  }
                                                                                                                                ),
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          Cp,
                                                                                                          yy(
                                                                                                            {
                                                                                                              className:
                                                                                                                "Popup_PT_Sub_TableCell",
                                                                                                            },
                                                                                                            {
                                                                                                              children:
                                                                                                                [
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    Op,
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        [
                                                                                                                          (0,
                                                                                                                          e.jsxs)(
                                                                                                                            "b",
                                                                                                                            {
                                                                                                                              children:
                                                                                                                                [
                                                                                                                                  c(
                                                                                                                                    "ST_Producttable_retailPrice"
                                                                                                                                  ),
                                                                                                                                  " :",
                                                                                                                                ],
                                                                                                                            }
                                                                                                                          ),
                                                                                                                          a +
                                                                                                                            " ",
                                                                                                                          t.variantPrice ||
                                                                                                                            (0).toFixed(
                                                                                                                              2
                                                                                                                            ),
                                                                                                                        ],
                                                                                                                    }
                                                                                                                  ),
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    Op,
                                                                                                                    yy(
                                                                                                                      {
                                                                                                                        sx: d
                                                                                                                          ? {
                                                                                                                              display:
                                                                                                                                "none",
                                                                                                                            }
                                                                                                                          : {
                                                                                                                              display:
                                                                                                                                "table-cell",
                                                                                                                            },
                                                                                                                      },
                                                                                                                      {
                                                                                                                        children:
                                                                                                                          [
                                                                                                                            (0,
                                                                                                                            e.jsxs)(
                                                                                                                              "b",
                                                                                                                              {
                                                                                                                                children:
                                                                                                                                  [
                                                                                                                                    c(
                                                                                                                                      "ST_Producttable_wholesalePrice"
                                                                                                                                    ),
                                                                                                                                    " :",
                                                                                                                                  ],
                                                                                                                              }
                                                                                                                            ),
                                                                                                                            a +
                                                                                                                              " ",
                                                                                                                            u(
                                                                                                                              t
                                                                                                                            ),
                                                                                                                          ],
                                                                                                                      }
                                                                                                                    )
                                                                                                                  ),
                                                                                                                ],
                                                                                                            }
                                                                                                          )
                                                                                                        ),
                                                                                                      ],
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                "hr",
                                                                                                {}
                                                                                              ),
                                                                                            ],
                                                                                        }
                                                                                      );
                                                                                    }
                                                                                  ),
                                                                          }
                                                                        ),
                                                                        r
                                                                      ),
                                                                    ],
                                                                  },
                                                                  r
                                                                ),
                                                              })
                                                            : "";
                                                        }),
                                                })
                                              : (0, e.jsx)(Dp, {
                                                  children: (0, e.jsx)(Cp, {
                                                    children: (0, e.jsx)(
                                                      Op,
                                                      yy(
                                                        {
                                                          colSpan:
                                                            null ===
                                                              (r =
                                                                null == b
                                                                  ? void 0
                                                                  : b.filter(
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return !e.hide;
                                                                      }
                                                                    )) ||
                                                            void 0 === r
                                                              ? void 0
                                                              : r.length,
                                                          align: "center",
                                                        },
                                                        {
                                                          children: T
                                                            ? w
                                                              ? (0, e.jsx)(
                                                                  v,
                                                                  {}
                                                                )
                                                              : O
                                                              ? c(
                                                                  "ST_CO_no_result_found_msg"
                                                                ) +
                                                                " " +
                                                                O
                                                              : ""
                                                            : w
                                                            ? c(
                                                                "productsLoading"
                                                              )
                                                            : c(
                                                                "ST_CO_no_result_found_msg"
                                                              ) +
                                                              " " +
                                                              O,
                                                        }
                                                      )
                                                    ),
                                                  }),
                                                }),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }),
                    (0, e.jsxs)(
                      Jp,
                      yy(
                        { className: "Product_Picker_Heading" },
                        {
                          children: [
                            T
                              ? (0, e.jsx)(e.Fragment, {})
                              : (0, e.jsx)(
                                  Qu,
                                  yy(
                                    {
                                      onClick: _,
                                      disabled: !(null == P
                                        ? void 0
                                        : P.hasPreviousPage),
                                      className: "Product_Picker_Footer",
                                    },
                                    {
                                      children: (0, e.jsx)(kb, {
                                        fontSize: "large",
                                      }),
                                    }
                                  )
                                ),
                            (0, e.jsx)(
                              Qu,
                              yy(
                                {
                                  onClick: y,
                                  disabled: T
                                    ? !(null == P ? void 0 : P.endCursor) ||
                                      w ||
                                      j ||
                                      ("" != O &&
                                        !(null == P
                                          ? void 0
                                          : P.SearchPricesEndCursor))
                                    : !(null == P ? void 0 : P.hasNextPage),
                                  className: "Product_Picker_Footer",
                                },
                                {
                                  children: (0, e.jsx)(Pb, {
                                    fontSize: "large",
                                  }),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              Qu,
                              yy(
                                {
                                  disabled:
                                    0 === (null == I ? void 0 : I.length),
                                  sx: { textTransform: "uppercase" },
                                  variant: "contained",
                                  onClick: function () {
                                    return C();
                                  },
                                },
                                { children: c("CreateOrder_doneBtn") }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  ],
                }
              )
            );
          },
          selectedProductTable_mobile: function (n) {
            var r,
              o,
              s,
              f = n.checkUncheckProductVariant,
              g = n.selectedProductIdArray,
              v = n.selectedVariantArray,
              b = n.getProductsLoading,
              _ = n.finalSelectedProducts,
              y = n.updateNetQuantitySubtotal,
              C = n.netQuantitySubtotal,
              x = n.isQuantityError,
              S = n.handleProductTableSearchPopup,
              k = n.showB2BQtyCataloguePrice,
              P = n.handleViewPricingPopup,
              w = n.propsFromCreateOrderParentTab,
              O = n.isNotEmpty,
              T = n.appliedDiscount,
              I = n.isDiscountError,
              M = n.discount_idObject,
              j = n.ShopApplyDiscount,
              N = n.isDiscoutAppliedInEditDraft,
              D = n.selectedDiscountType,
              A = [
                { name: "ST_Producttable_product", hide: !1 },
                {
                  name: "ST_Producttable_SKU",
                  hide: !(null ===
                    (r = null == l ? void 0 : l.featuresAdditionalSettings) ||
                  void 0 === r
                    ? void 0
                    : r.showSkuColumn),
                },
                {
                  name: "customerInvoice_ProductTableColumnInventory",
                  hide: !(null ===
                    (o = null == l ? void 0 : l.featuresAdditionalSettings) ||
                  void 0 === o
                    ? void 0
                    : o.showInventoryColumn),
                },
                { name: "ST_Producttable_retailPrice", hide: !1 },
                { name: "ST_Producttable_wholesalePrice", hide: d },
                { name: "ST_Producttable_netQuantity", hide: !1 },
                { name: "ST_Producttable_VolumePricing", hide: !w },
                { name: "ST_Producttable_subtotal", hide: !1 },
              ];
            return (0, e.jsx)(e.Fragment, {
              children: (0, e.jsx)(
                ep,
                yy(
                  {
                    className: "selectedProductTable",
                    sx: { mt: 3 },
                    component: go,
                  },
                  {
                    children: (0, e.jsx)(
                      sp,
                      yy(
                        { "aria-label": "selectedProductTable" },
                        {
                          children:
                            _ && (null == _ ? void 0 : _.length) > 0
                              ? null == _
                                ? void 0
                                : _.map(function (n, r) {
                                    var o, s, b;
                                    return (null ===
                                      (o = null == n ? void 0 : n.variants) ||
                                    void 0 === o
                                      ? void 0
                                      : o.length) > 0
                                      ? (0, e.jsxs)(e.Fragment, {
                                          children: [
                                            (0, e.jsx)(
                                              Dp,
                                              yy(
                                                {
                                                  className:
                                                    "PT_Product_Table_Body",
                                                },
                                                {
                                                  children: (0, e.jsxs)(
                                                    t.Fragment,
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          Cp,
                                                          yy(
                                                            {
                                                              className:
                                                                "iPadTableRowDisplay",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                Op,
                                                                yy(
                                                                  {
                                                                    className:
                                                                      "New_PT_Header iPadTableCellDisplay",
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsxs)(
                                                                        mn,
                                                                        yy(
                                                                          {
                                                                            display:
                                                                              "flex",
                                                                            alignItems:
                                                                              "center",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  tb,
                                                                                  {
                                                                                    checked:
                                                                                      !!(null ==
                                                                                      g
                                                                                        ? void 0
                                                                                        : g.includes(
                                                                                            null ==
                                                                                              n
                                                                                              ? void 0
                                                                                              : n.productId
                                                                                          )),
                                                                                    onChange:
                                                                                      function (
                                                                                        e
                                                                                      ) {
                                                                                        return f(
                                                                                          e,
                                                                                          "isProduct",
                                                                                          n
                                                                                        );
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                (null ==
                                                                                n
                                                                                  ? void 0
                                                                                  : n.imageUrl) &&
                                                                                0 !==
                                                                                  (null ===
                                                                                    (s =
                                                                                      null ==
                                                                                      n
                                                                                        ? void 0
                                                                                        : n.imageUrl) ||
                                                                                  void 0 ===
                                                                                    s
                                                                                    ? void 0
                                                                                    : s.length)
                                                                                  ? (0,
                                                                                    e.jsx)(
                                                                                      lb,
                                                                                      {
                                                                                        alt: "image",
                                                                                        src: n.imageUrl,
                                                                                        variant:
                                                                                          "rounded",
                                                                                      }
                                                                                    )
                                                                                  : (0,
                                                                                    e.jsx)(
                                                                                      lb,
                                                                                      yy(
                                                                                        {
                                                                                          alt: "image",
                                                                                          sx: {
                                                                                            bgcolor:
                                                                                              "white",
                                                                                            color:
                                                                                              "black",
                                                                                          },
                                                                                          variant:
                                                                                            "rounded",
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Sb,
                                                                                              {
                                                                                                sx: {
                                                                                                  fontSize:
                                                                                                    "3.1rem",
                                                                                                },
                                                                                              }
                                                                                            ),
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                (0,
                                                                                e.jsx)(
                                                                                  mn,
                                                                                  yy(
                                                                                    {
                                                                                      sx: {
                                                                                        ml: 1,
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (null ==
                                                                                          n ||
                                                                                          n.title,
                                                                                        null ==
                                                                                        n
                                                                                          ? void 0
                                                                                          : n.title),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          Cp,
                                                          yy(
                                                            {
                                                              sx: {
                                                                whiteSpace:
                                                                  "nowrap",
                                                                backgroundColor:
                                                                  "white",
                                                              },
                                                              className:
                                                                "iPadTableRowDisplay",
                                                            },
                                                            {
                                                              children:
                                                                null ===
                                                                  (b =
                                                                    null == n
                                                                      ? void 0
                                                                      : n.variants) ||
                                                                void 0 === b
                                                                  ? void 0
                                                                  : b.map(
                                                                      function (
                                                                        t,
                                                                        r
                                                                      ) {
                                                                        var o,
                                                                          s,
                                                                          g,
                                                                          b,
                                                                          _,
                                                                          S,
                                                                          A,
                                                                          E,
                                                                          R,
                                                                          L,
                                                                          B,
                                                                          z,
                                                                          F,
                                                                          Z,
                                                                          H,
                                                                          V,
                                                                          W,
                                                                          U,
                                                                          $,
                                                                          K,
                                                                          G,
                                                                          q,
                                                                          Q,
                                                                          Y,
                                                                          J,
                                                                          X,
                                                                          ee,
                                                                          te;
                                                                        return (0,
                                                                        e.jsxs)(
                                                                          "div",
                                                                          yy(
                                                                            {
                                                                              className:
                                                                                "Mobile_Product_Picker_Div ipadTableDiv",
                                                                            },
                                                                            {
                                                                              children:
                                                                                [
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Cp,
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          yy(
                                                                                            {
                                                                                              colSpan: 2,
                                                                                              className:
                                                                                                "New_PT_Sub_Header",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  mn,
                                                                                                  yy(
                                                                                                    {
                                                                                                      display:
                                                                                                        "flex",
                                                                                                      alignItems:
                                                                                                        "center",
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            tb,
                                                                                                            {
                                                                                                              checked:
                                                                                                                null ==
                                                                                                                v
                                                                                                                  ? void 0
                                                                                                                  : v.some(
                                                                                                                      function (
                                                                                                                        e
                                                                                                                      ) {
                                                                                                                        return (
                                                                                                                          e.variantId ===
                                                                                                                          t.variantId
                                                                                                                        );
                                                                                                                      }
                                                                                                                    ),
                                                                                                              onChange:
                                                                                                                function (
                                                                                                                  e
                                                                                                                ) {
                                                                                                                  return f(
                                                                                                                    e,
                                                                                                                    "isVariant",
                                                                                                                    n,
                                                                                                                    t
                                                                                                                  );
                                                                                                                },
                                                                                                            }
                                                                                                          ),
                                                                                                          (0,
                                                                                                          e.jsx)(
                                                                                                            mn,
                                                                                                            yy(
                                                                                                              {
                                                                                                                sx: {
                                                                                                                  ml: 2,
                                                                                                                  whiteSpace:
                                                                                                                    "pre-line",
                                                                                                                },
                                                                                                              },
                                                                                                              {
                                                                                                                children:
                                                                                                                  "Default Title" !==
                                                                                                                  (null ==
                                                                                                                  t
                                                                                                                    ? void 0
                                                                                                                    : t.title)
                                                                                                                    ? null ==
                                                                                                                      t
                                                                                                                      ? void 0
                                                                                                                      : t.title
                                                                                                                    : null ==
                                                                                                                      n
                                                                                                                    ? void 0
                                                                                                                    : n.title,
                                                                                                              }
                                                                                                            )
                                                                                                          ),
                                                                                                        ],
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    yy(
                                                                                      {
                                                                                        sx: (
                                                                                          null ===
                                                                                            (o =
                                                                                              null ==
                                                                                              l
                                                                                                ? void 0
                                                                                                : l.featuresAdditionalSettings) ||
                                                                                          void 0 ===
                                                                                            o
                                                                                            ? void 0
                                                                                            : o.showSkuColumn
                                                                                        )
                                                                                          ? {
                                                                                              display:
                                                                                                "table-row",
                                                                                            }
                                                                                          : {
                                                                                              display:
                                                                                                "none",
                                                                                            },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              {
                                                                                                children:
                                                                                                  (0,
                                                                                                  e.jsxs)(
                                                                                                    "b",
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          c(
                                                                                                            "ST_Producttable_SKU"
                                                                                                          ),
                                                                                                          " : ",
                                                                                                        ],
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              Op,
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    " ",
                                                                                                    t.sku,
                                                                                                  ],
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    yy(
                                                                                      {
                                                                                        sx: (
                                                                                          null ===
                                                                                            (s =
                                                                                              null ==
                                                                                              l
                                                                                                ? void 0
                                                                                                : l.featuresAdditionalSettings) ||
                                                                                          void 0 ===
                                                                                            s
                                                                                            ? void 0
                                                                                            : s.showInventoryColumn
                                                                                        )
                                                                                          ? {
                                                                                              display:
                                                                                                "table-row",
                                                                                            }
                                                                                          : {
                                                                                              display:
                                                                                                "none",
                                                                                            },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              {
                                                                                                children:
                                                                                                  (0,
                                                                                                  e.jsxs)(
                                                                                                    "b",
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          c(
                                                                                                            "customerInvoice_ProductTableColumnInventory"
                                                                                                          ),
                                                                                                          " :",
                                                                                                        ],
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              {
                                                                                                children:
                                                                                                  t.quantityAvailable ||
                                                                                                  0,
                                                                                              }
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Op,
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  "b",
                                                                                                  {
                                                                                                    children:
                                                                                                      [
                                                                                                        " ",
                                                                                                        c(
                                                                                                          "ST_Producttable_retailPrice"
                                                                                                        ),
                                                                                                        " :",
                                                                                                      ],
                                                                                                  }
                                                                                                ),
                                                                                            }
                                                                                          ),
                                                                                          (0,
                                                                                          e.jsxs)(
                                                                                            Op,
                                                                                            yy(
                                                                                              {
                                                                                                className:
                                                                                                  "ST_White_Space",
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    " ",
                                                                                                    w &&
                                                                                                    (null ===
                                                                                                      (g =
                                                                                                        C[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ]) ||
                                                                                                    void 0 ===
                                                                                                      g
                                                                                                      ? void 0
                                                                                                      : g.QuantityPriceBreaks) &&
                                                                                                    null !=
                                                                                                      k(
                                                                                                        null ==
                                                                                                          t
                                                                                                          ? void 0
                                                                                                          : t.variantId,
                                                                                                        null ===
                                                                                                          (b =
                                                                                                            C[
                                                                                                              t
                                                                                                                .variantId
                                                                                                            ]) ||
                                                                                                          void 0 ===
                                                                                                            b
                                                                                                          ? void 0
                                                                                                          : b.quantity,
                                                                                                        null ===
                                                                                                          (_ =
                                                                                                            C[
                                                                                                              null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.variantId
                                                                                                            ]) ||
                                                                                                          void 0 ===
                                                                                                            _
                                                                                                          ? void 0
                                                                                                          : _.price
                                                                                                      )
                                                                                                      ? ""
                                                                                                          .concat(
                                                                                                            a,
                                                                                                            " "
                                                                                                          )
                                                                                                          .concat(
                                                                                                            k(
                                                                                                              null ==
                                                                                                                t
                                                                                                                ? void 0
                                                                                                                : t.variantId,
                                                                                                              null ===
                                                                                                                (S =
                                                                                                                  C[
                                                                                                                    null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId
                                                                                                                  ]) ||
                                                                                                                void 0 ===
                                                                                                                  S
                                                                                                                ? void 0
                                                                                                                : S.quantity,
                                                                                                              null ===
                                                                                                                (A =
                                                                                                                  C[
                                                                                                                    null ==
                                                                                                                    t
                                                                                                                      ? void 0
                                                                                                                      : t.variantId
                                                                                                                  ]) ||
                                                                                                                void 0 ===
                                                                                                                  A
                                                                                                                ? void 0
                                                                                                                : A.price
                                                                                                            )
                                                                                                          )
                                                                                                      : ""
                                                                                                          .concat(
                                                                                                            a,
                                                                                                            "  "
                                                                                                          )
                                                                                                          .concat(
                                                                                                            (null ==
                                                                                                            t
                                                                                                              ? void 0
                                                                                                              : t.variantPrice
                                                                                                            ).toFixed(
                                                                                                              2
                                                                                                            ) ||
                                                                                                              (0).toFixed(
                                                                                                                2
                                                                                                              )
                                                                                                          ),
                                                                                                  ],
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                        ],
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    yy(
                                                                                      {
                                                                                        sx: d
                                                                                          ? {
                                                                                              display:
                                                                                                "none",
                                                                                            }
                                                                                          : {
                                                                                              display:
                                                                                                "table-row",
                                                                                            },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            (0,
                                                                                            e.jsx)(
                                                                                              Op,
                                                                                              {
                                                                                                children:
                                                                                                  (0,
                                                                                                  e.jsxs)(
                                                                                                    "b",
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          " ",
                                                                                                          c(
                                                                                                            "ST_Producttable_wholesalePrice"
                                                                                                          ),
                                                                                                          " :",
                                                                                                        ],
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            ),
                                                                                            (0,
                                                                                            e.jsxs)(
                                                                                              Op,
                                                                                              yy(
                                                                                                {
                                                                                                  className:
                                                                                                    "ST_White_Space",
                                                                                                },
                                                                                                {
                                                                                                  children:
                                                                                                    [
                                                                                                      " ",
                                                                                                      ""
                                                                                                        .concat(
                                                                                                          a,
                                                                                                          "  "
                                                                                                        )
                                                                                                        .concat(
                                                                                                          u(
                                                                                                            t
                                                                                                          )
                                                                                                        ),
                                                                                                    ],
                                                                                                }
                                                                                              )
                                                                                            ),
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  !w &&
                                                                                    ((!j &&
                                                                                      N) ||
                                                                                      j) &&
                                                                                    (0,
                                                                                    e.jsxs)(
                                                                                      Cp,
                                                                                      yy(
                                                                                        {
                                                                                          sx: {
                                                                                            display:
                                                                                              "table-row",
                                                                                          },
                                                                                        },
                                                                                        {
                                                                                          children:
                                                                                            [
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Op,
                                                                                                {
                                                                                                  children:
                                                                                                    (0,
                                                                                                    e.jsxs)(
                                                                                                      "b",
                                                                                                      {
                                                                                                        children:
                                                                                                          [
                                                                                                            c(
                                                                                                              "customerInvoice_DiscountOnSubtotal"
                                                                                                            ),
                                                                                                            "(",
                                                                                                            "percentage" ===
                                                                                                            D
                                                                                                              ? "%"
                                                                                                              : a,
                                                                                                            ") :",
                                                                                                          ],
                                                                                                      }
                                                                                                    ),
                                                                                                }
                                                                                              ),
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Op,
                                                                                                yy(
                                                                                                  {
                                                                                                    align:
                                                                                                      "center",
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        Hc,
                                                                                                        {
                                                                                                          InputProps:
                                                                                                            {
                                                                                                              inputProps:
                                                                                                                {
                                                                                                                  className:
                                                                                                                    "ST_Custom_Number_Input",
                                                                                                                },
                                                                                                            },
                                                                                                          name: "".concat(
                                                                                                            null ==
                                                                                                              t
                                                                                                              ? void 0
                                                                                                              : t.variantId
                                                                                                          ),
                                                                                                          placeholder:
                                                                                                            "0",
                                                                                                          variant:
                                                                                                            "outlined",
                                                                                                          size: "small",
                                                                                                          className:
                                                                                                            "ST_CI_DiscountTextBox",
                                                                                                          type: "number",
                                                                                                          value:
                                                                                                            O(
                                                                                                              M[
                                                                                                                (null ==
                                                                                                                t
                                                                                                                  ? void 0
                                                                                                                  : t.variantId) ||
                                                                                                                  0
                                                                                                              ]
                                                                                                            )
                                                                                                              ? M[
                                                                                                                  (null ==
                                                                                                                  t
                                                                                                                    ? void 0
                                                                                                                    : t.variantId) ||
                                                                                                                    0
                                                                                                                ]
                                                                                                              : "",
                                                                                                          disabled:
                                                                                                            !j &&
                                                                                                            N,
                                                                                                          onKeyDown:
                                                                                                            jb,
                                                                                                          onChange:
                                                                                                            function (
                                                                                                              e
                                                                                                            ) {
                                                                                                              T(
                                                                                                                e,
                                                                                                                t
                                                                                                              );
                                                                                                            },
                                                                                                          error:
                                                                                                            I[
                                                                                                              null ==
                                                                                                              t
                                                                                                                ? void 0
                                                                                                                : t.variantId
                                                                                                            ] ||
                                                                                                            !1,
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                            ],
                                                                                        }
                                                                                      )
                                                                                    ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Op,
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsxs)(
                                                                                                  "b",
                                                                                                  {
                                                                                                    children:
                                                                                                      [
                                                                                                        c(
                                                                                                          "customerInvoice_ProductTableColumnQuantity"
                                                                                                        ),
                                                                                                        " :",
                                                                                                      ],
                                                                                                  }
                                                                                                ),
                                                                                            }
                                                                                          ),
                                                                                          (0,
                                                                                          e.jsxs)(
                                                                                            Op,
                                                                                            yy(
                                                                                              {
                                                                                                className:
                                                                                                  "No_LineHeight",
                                                                                                sx: {
                                                                                                  padding:
                                                                                                    "0 !important",
                                                                                                },
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      Gs,
                                                                                                      yy(
                                                                                                        {
                                                                                                          arrow:
                                                                                                            !0,
                                                                                                          title:
                                                                                                            "Quantity",
                                                                                                        },
                                                                                                        {
                                                                                                          children:
                                                                                                            (0,
                                                                                                            e.jsxs)(
                                                                                                              mn,
                                                                                                              yy(
                                                                                                                {
                                                                                                                  className:
                                                                                                                    "Display_Alignment_Middle",
                                                                                                                },
                                                                                                                {
                                                                                                                  children:
                                                                                                                    [
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Qu,
                                                                                                                        yy(
                                                                                                                          {
                                                                                                                            id: "decreaseQty",
                                                                                                                            onClick:
                                                                                                                              function () {
                                                                                                                                var e;
                                                                                                                                return y(
                                                                                                                                  null ===
                                                                                                                                    (e =
                                                                                                                                      C[
                                                                                                                                        t
                                                                                                                                          .variantId
                                                                                                                                      ]) ||
                                                                                                                                    void 0 ===
                                                                                                                                      e
                                                                                                                                    ? void 0
                                                                                                                                    : e.quantity,
                                                                                                                                  t.variantId,
                                                                                                                                  (null ==
                                                                                                                                  l
                                                                                                                                    ? void 0
                                                                                                                                    : l.PriceList) &&
                                                                                                                                    "" !==
                                                                                                                                      (null ==
                                                                                                                                      p
                                                                                                                                        ? void 0
                                                                                                                                        : p.customerName)
                                                                                                                                    ? u(
                                                                                                                                        t
                                                                                                                                      )
                                                                                                                                    : t.variantPrice,
                                                                                                                                  "decreaseQty"
                                                                                                                                );
                                                                                                                              },
                                                                                                                            sx: m,
                                                                                                                            "aria-label":
                                                                                                                              "reduce",
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                wb,
                                                                                                                                {
                                                                                                                                  fontSize:
                                                                                                                                    "small",
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Hc,
                                                                                                                        {
                                                                                                                          InputProps:
                                                                                                                            {
                                                                                                                              inputProps:
                                                                                                                                {
                                                                                                                                  className:
                                                                                                                                    "ST_Custom_Number_Input",
                                                                                                                                },
                                                                                                                            },
                                                                                                                          value:
                                                                                                                            null ===
                                                                                                                              (E =
                                                                                                                                C[
                                                                                                                                  t
                                                                                                                                    .variantId
                                                                                                                                ]) ||
                                                                                                                            void 0 ===
                                                                                                                              E
                                                                                                                              ? void 0
                                                                                                                              : E.quantity,
                                                                                                                          sx: h,
                                                                                                                          onKeyDown:
                                                                                                                            Nb,
                                                                                                                          name: "".concat(
                                                                                                                            null ==
                                                                                                                              t
                                                                                                                              ? void 0
                                                                                                                              : t.variantId
                                                                                                                          ),
                                                                                                                          variant:
                                                                                                                            "outlined",
                                                                                                                          size: "small",
                                                                                                                          type: "number",
                                                                                                                          error:
                                                                                                                            x[
                                                                                                                              null ==
                                                                                                                              t
                                                                                                                                ? void 0
                                                                                                                                : t.variantId
                                                                                                                            ] ||
                                                                                                                            !1,
                                                                                                                          onChange:
                                                                                                                            function (
                                                                                                                              e
                                                                                                                            ) {
                                                                                                                              return y(
                                                                                                                                null ==
                                                                                                                                  e
                                                                                                                                  ? void 0
                                                                                                                                  : e
                                                                                                                                      .target
                                                                                                                                      .value,
                                                                                                                                null ==
                                                                                                                                  t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantId,
                                                                                                                                (null ==
                                                                                                                                l
                                                                                                                                  ? void 0
                                                                                                                                  : l.PriceList) &&
                                                                                                                                  "" !==
                                                                                                                                    (null ==
                                                                                                                                    p
                                                                                                                                      ? void 0
                                                                                                                                      : p.customerName)
                                                                                                                                  ? u(
                                                                                                                                      t
                                                                                                                                    )
                                                                                                                                  : null ==
                                                                                                                                    t
                                                                                                                                  ? void 0
                                                                                                                                  : t.variantPrice,
                                                                                                                                "manual"
                                                                                                                              );
                                                                                                                            },
                                                                                                                        }
                                                                                                                      ),
                                                                                                                      (0,
                                                                                                                      e.jsx)(
                                                                                                                        Qu,
                                                                                                                        yy(
                                                                                                                          {
                                                                                                                            id: "increaseQty",
                                                                                                                            sx: m,
                                                                                                                            "aria-label":
                                                                                                                              "increase",
                                                                                                                            onClick:
                                                                                                                              function () {
                                                                                                                                var e;
                                                                                                                                return y(
                                                                                                                                  null ===
                                                                                                                                    (e =
                                                                                                                                      C[
                                                                                                                                        t
                                                                                                                                          .variantId
                                                                                                                                      ]) ||
                                                                                                                                    void 0 ===
                                                                                                                                      e
                                                                                                                                    ? void 0
                                                                                                                                    : e.quantity,
                                                                                                                                  t.variantId,
                                                                                                                                  (null ==
                                                                                                                                  l
                                                                                                                                    ? void 0
                                                                                                                                    : l.PriceList) &&
                                                                                                                                    "" !==
                                                                                                                                      (null ==
                                                                                                                                      p
                                                                                                                                        ? void 0
                                                                                                                                        : p.customerName)
                                                                                                                                    ? u(
                                                                                                                                        t
                                                                                                                                      )
                                                                                                                                    : t.variantPrice,
                                                                                                                                  "increaseQty"
                                                                                                                                );
                                                                                                                              },
                                                                                                                          },
                                                                                                                          {
                                                                                                                            children:
                                                                                                                              (0,
                                                                                                                              e.jsx)(
                                                                                                                                Ob,
                                                                                                                                {
                                                                                                                                  fontSize:
                                                                                                                                    "small",
                                                                                                                                }
                                                                                                                              ),
                                                                                                                          }
                                                                                                                        )
                                                                                                                      ),
                                                                                                                    ],
                                                                                                                }
                                                                                                              )
                                                                                                            ),
                                                                                                        }
                                                                                                      )
                                                                                                    ),
                                                                                                    (0,
                                                                                                    e.jsx)(
                                                                                                      "br",
                                                                                                      {}
                                                                                                    ),
                                                                                                    w
                                                                                                      ? (0,
                                                                                                        e.jsxs)(
                                                                                                          "div",
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                (null ===
                                                                                                                  (L =
                                                                                                                    null ===
                                                                                                                      (R =
                                                                                                                        C[
                                                                                                                          null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId
                                                                                                                        ]) ||
                                                                                                                    void 0 ===
                                                                                                                      R
                                                                                                                      ? void 0
                                                                                                                      : R.QuantityRule) ||
                                                                                                                void 0 ===
                                                                                                                  L
                                                                                                                  ? void 0
                                                                                                                  : L.Increment) &&
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    "p",
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        [
                                                                                                                          "Increments of ",
                                                                                                                          null ===
                                                                                                                            (z =
                                                                                                                              null ===
                                                                                                                                (B =
                                                                                                                                  C[
                                                                                                                                    null ==
                                                                                                                                    t
                                                                                                                                      ? void 0
                                                                                                                                      : t.variantId
                                                                                                                                  ]) ||
                                                                                                                              void 0 ===
                                                                                                                                B
                                                                                                                                ? void 0
                                                                                                                                : B.QuantityRule) ||
                                                                                                                          void 0 ===
                                                                                                                            z
                                                                                                                            ? void 0
                                                                                                                            : z.Increment,
                                                                                                                          " ",
                                                                                                                          "",
                                                                                                                        ],
                                                                                                                    }
                                                                                                                  ),
                                                                                                                (null ===
                                                                                                                  (Z =
                                                                                                                    null ===
                                                                                                                      (F =
                                                                                                                        C[
                                                                                                                          null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId
                                                                                                                        ]) ||
                                                                                                                    void 0 ===
                                                                                                                      F
                                                                                                                      ? void 0
                                                                                                                      : F.QuantityRule) ||
                                                                                                                void 0 ===
                                                                                                                  Z
                                                                                                                  ? void 0
                                                                                                                  : Z.Minimum) &&
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    "p",
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        [
                                                                                                                          "Minimums of ",
                                                                                                                          null ===
                                                                                                                            (V =
                                                                                                                              null ===
                                                                                                                                (H =
                                                                                                                                  C[
                                                                                                                                    null ==
                                                                                                                                    t
                                                                                                                                      ? void 0
                                                                                                                                      : t.variantId
                                                                                                                                  ]) ||
                                                                                                                              void 0 ===
                                                                                                                                H
                                                                                                                                ? void 0
                                                                                                                                : H.QuantityRule) ||
                                                                                                                          void 0 ===
                                                                                                                            V
                                                                                                                            ? void 0
                                                                                                                            : V.Minimum,
                                                                                                                          " ",
                                                                                                                          "",
                                                                                                                        ],
                                                                                                                    }
                                                                                                                  ),
                                                                                                                (null ===
                                                                                                                  (U =
                                                                                                                    null ===
                                                                                                                      (W =
                                                                                                                        C[
                                                                                                                          null ==
                                                                                                                          t
                                                                                                                            ? void 0
                                                                                                                            : t.variantId
                                                                                                                        ]) ||
                                                                                                                    void 0 ===
                                                                                                                      W
                                                                                                                      ? void 0
                                                                                                                      : W.QuantityRule) ||
                                                                                                                void 0 ===
                                                                                                                  U
                                                                                                                  ? void 0
                                                                                                                  : U.Maximum) &&
                                                                                                                  (0,
                                                                                                                  e.jsxs)(
                                                                                                                    "p",
                                                                                                                    {
                                                                                                                      children:
                                                                                                                        [
                                                                                                                          "Maximum of ",
                                                                                                                          null ===
                                                                                                                            (K =
                                                                                                                              null ===
                                                                                                                                ($ =
                                                                                                                                  C[
                                                                                                                                    null ==
                                                                                                                                    t
                                                                                                                                      ? void 0
                                                                                                                                      : t.variantId
                                                                                                                                  ]) ||
                                                                                                                              void 0 ===
                                                                                                                                $
                                                                                                                                ? void 0
                                                                                                                                : $.QuantityRule) ||
                                                                                                                          void 0 ===
                                                                                                                            K
                                                                                                                            ? void 0
                                                                                                                            : K.Maximum,
                                                                                                                        ],
                                                                                                                    }
                                                                                                                  ),
                                                                                                              ],
                                                                                                          }
                                                                                                        )
                                                                                                      : "",
                                                                                                  ],
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                        ],
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Cp,
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          yy(
                                                                                            {
                                                                                              colSpan: 2,
                                                                                              sx: Cy(
                                                                                                [
                                                                                                  w
                                                                                                    ? {
                                                                                                        display:
                                                                                                          "table-cell",
                                                                                                      }
                                                                                                    : {
                                                                                                        display:
                                                                                                          "none",
                                                                                                      },
                                                                                                ],
                                                                                                (null ===
                                                                                                  (q =
                                                                                                    null ===
                                                                                                      (G =
                                                                                                        C[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ]) ||
                                                                                                    void 0 ===
                                                                                                      G
                                                                                                      ? void 0
                                                                                                      : G.QuantityPriceBreaks) ||
                                                                                                void 0 ===
                                                                                                  q
                                                                                                  ? void 0
                                                                                                  : q.length) >
                                                                                                  0
                                                                                                  ? [
                                                                                                      Lo,
                                                                                                    ]
                                                                                                  : [],
                                                                                                !0
                                                                                              ),
                                                                                              className:
                                                                                                0 ===
                                                                                                (null ===
                                                                                                  (Y =
                                                                                                    null ===
                                                                                                      (Q =
                                                                                                        C[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ]) ||
                                                                                                    void 0 ===
                                                                                                      Q
                                                                                                      ? void 0
                                                                                                      : Q.QuantityPriceBreaks) ||
                                                                                                void 0 ===
                                                                                                  Y
                                                                                                  ? void 0
                                                                                                  : Y.length)
                                                                                                  ? "ST_MC_Cursor_CSS"
                                                                                                  : "",
                                                                                              onClick:
                                                                                                function () {
                                                                                                  return P(
                                                                                                    null ==
                                                                                                      n
                                                                                                      ? void 0
                                                                                                      : n.title,
                                                                                                    null ==
                                                                                                      t
                                                                                                      ? void 0
                                                                                                      : t.variantId
                                                                                                  );
                                                                                                },
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (null ===
                                                                                                  (X =
                                                                                                    null ===
                                                                                                      (J =
                                                                                                        C[
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.variantId
                                                                                                        ]) ||
                                                                                                    void 0 ===
                                                                                                      J
                                                                                                      ? void 0
                                                                                                      : J.QuantityPriceBreaks) ||
                                                                                                void 0 ===
                                                                                                  X
                                                                                                  ? void 0
                                                                                                  : X.length) >
                                                                                                0
                                                                                                  ? "View Pricing"
                                                                                                  : "-",
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Cp,
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          (0,
                                                                                          e.jsxs)(
                                                                                            Op,
                                                                                            yy(
                                                                                              {
                                                                                                className:
                                                                                                  "New_PT_Sub_Footer",
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  [
                                                                                                    " ",
                                                                                                    (0,
                                                                                                    e.jsxs)(
                                                                                                      "b",
                                                                                                      {
                                                                                                        children:
                                                                                                          [
                                                                                                            c(
                                                                                                              "customerInvoice_ProductTableColumnSubTotal"
                                                                                                            ),
                                                                                                            " :",
                                                                                                          ],
                                                                                                      }
                                                                                                    ),
                                                                                                  ],
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                          (0,
                                                                                          e.jsx)(
                                                                                            Op,
                                                                                            yy(
                                                                                              {
                                                                                                className:
                                                                                                  "New_PT_Sub_Footer ST_White_Space",
                                                                                              },
                                                                                              {
                                                                                                children:
                                                                                                  (0,
                                                                                                  e.jsxs)(
                                                                                                    "b",
                                                                                                    {
                                                                                                      children:
                                                                                                        [
                                                                                                          a,
                                                                                                          (
                                                                                                            null ===
                                                                                                              (ee =
                                                                                                                C[
                                                                                                                  t
                                                                                                                    .variantId
                                                                                                                ]) ||
                                                                                                            void 0 ===
                                                                                                              ee
                                                                                                              ? void 0
                                                                                                              : ee.subtotal
                                                                                                          )
                                                                                                            ? Number(
                                                                                                                null ===
                                                                                                                  (te =
                                                                                                                    C[
                                                                                                                      t
                                                                                                                        .variantId
                                                                                                                    ]) ||
                                                                                                                  void 0 ===
                                                                                                                    te
                                                                                                                  ? void 0
                                                                                                                  : te.subtotal
                                                                                                              ).toFixed(
                                                                                                                2
                                                                                                              )
                                                                                                            : (null ==
                                                                                                              l
                                                                                                                ? void 0
                                                                                                                : l.PriceList) &&
                                                                                                              "" !==
                                                                                                                (null ==
                                                                                                                p
                                                                                                                  ? void 0
                                                                                                                  : p.customerName)
                                                                                                            ? u(
                                                                                                                t
                                                                                                              )
                                                                                                            : 0,
                                                                                                          " " +
                                                                                                            (null !=
                                                                                                            i
                                                                                                              ? i
                                                                                                              : ""),
                                                                                                        ],
                                                                                                    }
                                                                                                  ),
                                                                                              }
                                                                                            )
                                                                                          ),
                                                                                        ],
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                            }
                                                                          )
                                                                        );
                                                                      }
                                                                    ),
                                                            }
                                                          ),
                                                          r
                                                        ),
                                                      ],
                                                    },
                                                    r
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(Dp, {
                                              children: (0, e.jsx)(Op, {
                                                colSpan: 2,
                                                sx: {
                                                  backgroundColor:
                                                    "#f6f6f7 !important",
                                                },
                                              }),
                                            }),
                                          ],
                                        })
                                      : null;
                                  })
                              : (0, e.jsx)(Dp, {
                                  children: (0, e.jsx)(Cp, {
                                    children: (0, e.jsx)(
                                      Op,
                                      yy(
                                        {
                                          align: "center",
                                          colSpan:
                                            null ===
                                              (s =
                                                null == A
                                                  ? void 0
                                                  : A.filter(function (e) {
                                                      return !e.hide;
                                                    })) || void 0 === s
                                              ? void 0
                                              : s.length,
                                        },
                                        {
                                          children: b
                                            ? c("productsLoading")
                                            : (0, e.jsxs)(
                                                "div",
                                                yy(
                                                  {
                                                    style: {
                                                      marginTop: "15px",
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        ni,
                                                        yy(
                                                          {
                                                            variant: Av,
                                                            sx: Ko,
                                                          },
                                                          {
                                                            children: c(
                                                              "createOrder_productTable_NoProductsAdded"
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        Qu,
                                                        yy(
                                                          {
                                                            sx: {
                                                              mt: 1,
                                                              mb: 2,
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            onClick:
                                                              function () {
                                                                return S();
                                                              },
                                                            variant:
                                                              "contained",
                                                          },
                                                          {
                                                            children: c(
                                                              "createOrder_AddProduct"
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                        }
                                      )
                                    ),
                                  }),
                                }),
                        }
                      )
                    ),
                  }
                )
              ),
            });
          },
          productTable_SubTotal_mobile: function (t) {
            return t > 0
              ? (0, e.jsxs)(
                  "div",
                  yy(
                    { className: "ST_ProductTable_subtotal" },
                    {
                      children: [
                        (0, e.jsx)(
                          mn,
                          yy(
                            { className: "ST_ProductTable_subtotal_boxes" },
                            {
                              children: (0, e.jsxs)(
                                "b",
                                yy(
                                  { className: "ST_CS_TableHeading" },
                                  {
                                    children: [
                                      c(
                                        "customerInvoice_ProductTableColumnSubTotal"
                                      ),
                                      " ",
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          mn,
                          yy(
                            { className: "ST_ProductTable_subtotal_boxes" },
                            {
                              children: (0, e.jsxs)("b", {
                                children: [
                                  a,
                                  " ",
                                  "   ",
                                  t.toFixed(2),
                                  " " + (null != i ? i : ""),
                                ],
                              }),
                            }
                          )
                        ),
                      ],
                    }
                  )
                )
              : (0, e.jsx)("br", {});
          },
        };
      }
      var Sy = function () {
        return (
          (Sy =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          Sy.apply(this, arguments)
        );
      };
      function ky(n) {
        var r,
          o = gy(),
          a = o.totalOrderAmount,
          i = o.handleSearchProductData,
          s = o.makeFieldsEmpty,
          l = o.productSearchText,
          d = o.handleKeyDown,
          c = o.handleProductTableSearchPopup,
          u = o.handleSearchTextChange,
          p = o.searchTablePopupOpen,
          m = o.productsArray,
          h = o.getProductsLoading,
          f = o.selectedProductArray,
          g = o.checkUncheckProductVariant,
          v = o.selectedVariantArray,
          b = o.selectedProductIdArray,
          _ = o.showSelectedProduct,
          y = o.netQuantitySubtotal,
          C = o.updateNetQuantitySubtotal,
          x = o.finalSelectedProducts,
          S = o.closePopupForSearchProductData,
          k = o.removeAllSelectedProducts,
          P = o.handleNextClick,
          w = o.handlePrevClick,
          O = o.pageInfo,
          T = o.readCartProducts,
          I = o.salesRepData,
          M = o.propsFromCreateOrderParentTab,
          j = o.handleAlertMsgClose,
          N = o.alertErrorMsg,
          D = o.isQuantityError,
          A = o.t,
          E = o.isNotEmpty,
          R = o.appliedDiscount,
          L = o.isDiscountError,
          B = o.discount_idObject,
          z = o.selectedDiscountType,
          F = o.handleSelectChangeForDiscountType,
          Z = o.handleDiscountChange,
          H = o.ShopApplyDiscount,
          V = o.shopCurrency,
          W = o.handleCancelChangeDiscountType,
          U = o.handleConfirmChangeDiscountType,
          $ = o.discountAlertBox,
          K = o.isDiscoutAppliedInEditDraft,
          G = o.tableContainerRef,
          q = o.isRemoveCartPopup,
          Q = o.setIsRemoveCartPopup,
          Y = xv().SnackbarAlertMsg,
          J = _y(),
          X = J.productTableSearchBar,
          ee = J.searchProductTablePopUp,
          te = J.selectedProductTable,
          ne = J.productTable_SubTotal,
          re = xy(),
          oe = re.productTableSearchBar_mobile,
          ae = re.searchProductTablePopUp_mobile,
          ie = re.selectedProductTable_mobile,
          se = re.productTable_SubTotal_mobile,
          le =
            null === (r = null == I ? void 0 : I.editDraftOrder) || void 0 === r
              ? void 0
              : r.isUpdatedCart,
          de = Tv();
        return (
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.orderCreatedSuccesfullyFlag) &&
                (k(), null == n || n.setAddShippingAddressBtn(!1));
            },
            [null == n ? void 0 : n.orderCreatedSuccesfullyFlag]
          ),
          (0, t.useEffect)(
            function () {
              le && T();
            },
            [le]
          ),
          (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(mn, {
                children: [
                  (0, e.jsx)(
                    "div",
                    Sy(
                      { className: "headingDivider" },
                      {
                        children: (0, e.jsx)(
                          Gt,
                          Sy(
                            {
                              textAlign: "left",
                              className: "PT_Search_Text_Divider",
                            },
                            {
                              children: (0, e.jsx)(
                                ni,
                                Sy(
                                  { variant: Av, sx: Ko },
                                  { children: A("createOrder_select_product") }
                                )
                              ),
                            }
                          )
                        ),
                      }
                    )
                  ),
                  de
                    ? (0, e.jsxs)(e.Fragment, {
                        children: [
                          oe({
                            handleProductTableSearchPopup: c,
                            removeAllSelectedProducts: k,
                            finalSelectedProducts: x,
                            propsFromCreateOrderParentTab: M,
                            selectedDiscountType: z,
                            handleSelectChangeForDiscountType: F,
                            ShopApplyDiscount: H,
                            isDiscoutAppliedInEditDraft: K,
                            isRemoveCartPopup: q,
                            setIsRemoveCartPopup: Q,
                          }),
                          ae({
                            searchTablePopupOpen: p,
                            closePopupForSearchProductData: S,
                            handleKeyDown: d,
                            handleSearchTextChange: u,
                            makeFieldsEmpty: s,
                            handleSearchProductData: i,
                            checkUncheckProductVariant: g,
                            handlePrevClick: w,
                            handleNextClick: P,
                            showSelectedProduct: _,
                            productsArray: m,
                            selectedProductIdArray: b,
                            selectedVariantArray: v,
                            pageInfo: O,
                            getProductsLoading: h,
                            productSearchText: l,
                            selectedProductArray: f,
                            tableContainerRef: G,
                          }),
                          ie({
                            checkUncheckProductVariant: g,
                            selectedProductIdArray: b,
                            selectedVariantArray: v,
                            getProductsLoading: h,
                            finalSelectedProducts: x,
                            updateNetQuantitySubtotal: C,
                            netQuantitySubtotal: y,
                            isQuantityError: D,
                            handleProductTableSearchPopup: c,
                            propsFromCreateOrderParentTab: M,
                            isNotEmpty: E,
                            appliedDiscount: R,
                            isDiscountError: L,
                            discount_idObject: B,
                            ShopApplyDiscount: H,
                            isDiscoutAppliedInEditDraft: K,
                            selectedDiscountType: z,
                          }),
                          se(a),
                        ],
                      })
                    : (0, e.jsxs)(e.Fragment, {
                        children: [
                          X({
                            handleProductTableSearchPopup: c,
                            removeAllSelectedProducts: k,
                            finalSelectedProducts: x,
                            propsFromCreateOrderParentTab: M,
                            selectedDiscountType: z,
                            handleSelectChangeForDiscountType: F,
                            ShopApplyDiscount: H,
                            isDiscoutAppliedInEditDraft: K,
                            isRemoveCartPopup: q,
                            setIsRemoveCartPopup: Q,
                          }),
                          ee({
                            searchTablePopupOpen: p,
                            closePopupForSearchProductData: S,
                            handleKeyDown: d,
                            handleSearchTextChange: u,
                            makeFieldsEmpty: s,
                            handleSearchProductData: i,
                            checkUncheckProductVariant: g,
                            handlePrevClick: w,
                            handleNextClick: P,
                            showSelectedProduct: _,
                            productsArray: m,
                            selectedProductIdArray: b,
                            selectedVariantArray: v,
                            pageInfo: O,
                            getProductsLoading: h,
                            productSearchText: l,
                            selectedProductArray: f,
                            tableContainerRef: G,
                          }),
                          te({
                            checkUncheckProductVariant: g,
                            selectedProductIdArray: b,
                            selectedVariantArray: v,
                            getProductsLoading: h,
                            finalSelectedProducts: x,
                            updateNetQuantitySubtotal: C,
                            netQuantitySubtotal: y,
                            isQuantityError: D,
                            handleProductTableSearchPopup: c,
                            propsFromCreateOrderParentTab: M,
                            isNotEmpty: E,
                            appliedDiscount: R,
                            isDiscountError: L,
                            discount_idObject: B,
                            ShopApplyDiscount: H,
                            isDiscoutAppliedInEditDraft: K,
                          }),
                          ne(a),
                        ],
                      }),
                  !M &&
                    x &&
                    (null == x ? void 0 : x.length) > 0 &&
                    ((!H && K) || H
                      ? (0, e.jsxs)(
                          "div",
                          Sy(
                            { className: "ST_ProductTable_subtotal" },
                            {
                              children: [
                                (0, e.jsx)(
                                  mn,
                                  Sy(
                                    {
                                      className:
                                        "ST_ProductTable_subtotal_boxes",
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        "b",
                                        Sy(
                                          { className: "ST_CS_TableHeading" },
                                          {
                                            children: [
                                              A(
                                                "customerInvoice_DiscountOnSubtotal"
                                              ),
                                              " (",
                                              "percentage" === z ? "%" : V,
                                              ")",
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  mn,
                                  Sy(
                                    { sx: { backgroundColor: "white" } },
                                    {
                                      children: (0, e.jsx)(Hc, {
                                        name: "discountOnSubTotal",
                                        InputProps: {
                                          inputProps: {
                                            className: "ST_Custom_Number_Input",
                                          },
                                        },
                                        disabled: !H && K,
                                        placeholder: "0",
                                        variant: "outlined",
                                        size: "small",
                                        type: "number",
                                        value: E(B.discountOnSubTotal)
                                          ? B.discountOnSubTotal
                                          : "",
                                        onKeyDown: jb,
                                        onChange: function (e) {
                                          Z(e);
                                        },
                                        error: L.discountOnSubTotal || !1,
                                        helperText: L.discountOnSubTotal
                                          ? "Invalid"
                                          : "",
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        )
                      : (0, e.jsx)(e.Fragment, {})),
                ],
              }),
              Y(N, j),
              (0, e.jsxs)(
                Hp,
                Sy(
                  {
                    open: $,
                    onClose: W,
                    "aria-labelledby": "alert-dialog-title",
                    "aria-describedby": "alert-dialog-description",
                  },
                  {
                    children: [
                      (0, e.jsx)(
                        Lb,
                        Sy(
                          { id: "alert-dialog-title" },
                          {
                            children: A(
                              "Create_Order_DiscountType_Popup_Value1"
                            ),
                          }
                        )
                      ),
                      (0, e.jsx)(Gp, {
                        children: (0, e.jsx)(
                          Zb,
                          Sy(
                            { id: "alert-dialog-description" },
                            {
                              children: A(
                                "Create_Order_DiscountType_PopUp_Value2"
                              ),
                            }
                          )
                        ),
                      }),
                      (0, e.jsxs)(Jp, {
                        children: [
                          (0, e.jsx)(
                            Qu,
                            Sy(
                              { onClick: W },
                              { children: A("customerInvoice_cancel") }
                            )
                          ),
                          (0, e.jsx)(
                            Qu,
                            Sy(
                              { onClick: U },
                              { children: A("leaveOnPageBtn") }
                            )
                          ),
                        ],
                      }),
                    ],
                  }
                )
              ),
            ],
          })
        );
      }
      var Py = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z",
          }),
          "RadioButtonUnchecked"
        ),
        wy = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z",
          }),
          "RadioButtonChecked"
        );
      const Oy = (0, Bt.ZP)("span", { shouldForwardProp: vo.Z })({
          position: "relative",
          display: "flex",
        }),
        Ty = (0, Bt.ZP)(Py)({ transform: "scale(1)" }),
        Iy = (0, Bt.ZP)(wy)(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              left: 0,
              position: "absolute",
              transform: "scale(0)",
              transition: e.transitions.create("transform", {
                easing: e.transitions.easing.easeIn,
                duration: e.transitions.duration.shortest,
              }),
            },
            t.checked && {
              transform: "scale(1)",
              transition: e.transitions.create("transform", {
                easing: e.transitions.easing.easeOut,
                duration: e.transitions.duration.shortest,
              }),
            }
          )
        );
      var My = function (t) {
          const { checked: n = !1, classes: r = {}, fontSize: o } = t,
            a = (0, u.Z)({}, t, { checked: n });
          return (0, e.jsxs)(Oy, {
            className: r.root,
            ownerState: a,
            children: [
              (0, e.jsx)(Ty, {
                fontSize: o,
                className: r.background,
                ownerState: a,
              }),
              (0, e.jsx)(Iy, { fontSize: o, className: r.dot, ownerState: a }),
            ],
          });
        },
        jy = o(7450),
        Ny = t.createContext(void 0);
      function Dy(e) {
        return (0, Zt.ZP)("MuiRadio", e);
      }
      var Ay = (0, Ft.Z)("MuiRadio", [
        "root",
        "checked",
        "disabled",
        "colorPrimary",
        "colorSecondary",
        "sizeSmall",
      ]);
      const Ey = [
          "checked",
          "checkedIcon",
          "color",
          "icon",
          "name",
          "onChange",
          "size",
          "className",
        ],
        Ry = (0, Bt.ZP)(Vv, {
          shouldForwardProp: (e) => (0, vo.Z)(e) || "classes" === e,
          name: "MuiRadio",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              "medium" !== n.size && t[`size${(0, $n.Z)(n.size)}`],
              t[`color${(0, $n.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            { color: (e.vars || e).palette.text.secondary },
            !t.disableRipple && {
              "&:hover": {
                backgroundColor: e.vars
                  ? `rgba(${
                      "default" === t.color
                        ? e.vars.palette.action.activeChannel
                        : e.vars.palette[t.color].mainChannel
                    } / ${e.vars.palette.action.hoverOpacity})`
                  : (0, Lt.Fq)(
                      "default" === t.color
                        ? e.palette.action.active
                        : e.palette[t.color].main,
                      e.palette.action.hoverOpacity
                    ),
                "@media (hover: none)": { backgroundColor: "transparent" },
              },
            },
            "default" !== t.color && {
              [`&.${Ay.checked}`]: {
                color: (e.vars || e).palette[t.color].main,
              },
            },
            {
              [`&.${Ay.disabled}`]: {
                color: (e.vars || e).palette.action.disabled,
              },
            }
          )
        ),
        Ly = (0, e.jsx)(My, { checked: !0 }),
        By = (0, e.jsx)(My, {}),
        zy = t.forwardRef(function (n, r) {
          var o, a;
          const i = (0, zt.i)({ props: n, name: "MuiRadio" }),
            {
              checked: s,
              checkedIcon: l = Ly,
              color: d = "primary",
              icon: c = By,
              name: p,
              onChange: m,
              size: h = "medium",
              className: f,
            } = i,
            g = (0, At.Z)(i, Ey),
            v = (0, u.Z)({}, i, { color: d, size: h }),
            b = ((e) => {
              const { classes: t, color: n, size: r } = e,
                o = {
                  root: [
                    "root",
                    `color${(0, $n.Z)(n)}`,
                    "medium" !== r && `size${(0, $n.Z)(r)}`,
                  ],
                };
              return (0, u.Z)({}, t, (0, Rt.Z)(o, Dy, t));
            })(v),
            _ = t.useContext(Ny);
          let y = s;
          const C = (0, jy.Z)(m, _ && _.onChange);
          let x = p;
          return (
            _ &&
              (void 0 === y &&
                ((S = _.value),
                (y =
                  "object" == typeof (k = i.value) && null !== k
                    ? S === k
                    : String(S) === String(k))),
              void 0 === x && (x = _.name)),
            (0, e.jsx)(
              Ry,
              (0, u.Z)(
                {
                  type: "radio",
                  icon: t.cloneElement(c, {
                    fontSize: null != (o = By.props.fontSize) ? o : h,
                  }),
                  checkedIcon: t.cloneElement(l, {
                    fontSize: null != (a = Ly.props.fontSize) ? a : h,
                  }),
                  ownerState: v,
                  classes: b,
                  name: x,
                  checked: y,
                  onChange: C,
                  ref: r,
                  className: (0, Et.Z)(b.root, f),
                },
                g
              )
            )
          );
          var S, k;
        });
      var Fy = zy,
        Zy = function () {
          return (
            (Zy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Zy.apply(this, arguments)
          );
        },
        Hy = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Vy = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Wy = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      var Uy = function () {
          return (
            (Uy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Uy.apply(this, arguments)
          );
        },
        $y = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Ky = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        Gy = function () {
          return (
            (Gy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Gy.apply(this, arguments)
          );
        };
      function qy(n) {
        var r,
          o,
          a,
          i = (function (e) {
            var n,
              r,
              o,
              a,
              i,
              s,
              l,
              d,
              c,
              u,
              p,
              m,
              h,
              f,
              v,
              b,
              _,
              C,
              x,
              S,
              k,
              P,
              w = this,
              O = ee().t,
              T = (function () {
                var e,
                  t,
                  n,
                  r,
                  o,
                  a,
                  i = this,
                  s = g(),
                  l = xv().filterVariantsWithOutSoldOut,
                  d = ee().t,
                  c =
                    null !==
                      (t =
                        null === (e = F.getState().salesRepData) || void 0 === e
                          ? void 0
                          : e.editDraftOrder) && void 0 !== t
                      ? t
                      : {},
                  u =
                    null !==
                      (o =
                        null ===
                          (r =
                            null === (n = F.getState().salesRepData) ||
                            void 0 === n
                              ? void 0
                              : n.baseData) || void 0 === r
                          ? void 0
                          : r.select) && void 0 !== o
                      ? o
                      : {},
                  p =
                    null !== (a = null == c ? void 0 : c.draftOrderObj) &&
                    void 0 !== a
                      ? a
                      : {},
                  m = function (e) {
                    return Hy(i, void 0, void 0, function () {
                      var t,
                        n,
                        r,
                        o,
                        a,
                        i,
                        s,
                        l,
                        c,
                        u,
                        m,
                        f,
                        g,
                        v,
                        b,
                        _,
                        y,
                        C,
                        x,
                        S,
                        k,
                        P,
                        w,
                        O,
                        T,
                        I,
                        M;
                      return Vy(this, function (j) {
                        (t =
                          null !==
                            (y = null == p ? void 0 : p.shipping_Address) &&
                          void 0 !== y
                            ? y
                            : {}),
                          (n =
                            null !==
                              (C = null == p ? void 0 : p.billing_address) &&
                            void 0 !== C
                              ? C
                              : {}),
                          (r =
                            null !==
                              (k =
                                null ===
                                  (S =
                                    null === (x = F.getState().salesRepData) ||
                                    void 0 === x
                                      ? void 0
                                      : x.customerNewUpdatedData) ||
                                void 0 === S
                                  ? void 0
                                  : S.customerAddressesList) && void 0 !== k
                              ? k
                              : []),
                          (o =
                            null ===
                              (w =
                                null === (P = F.getState().salesRepData) ||
                                void 0 === P
                                  ? void 0
                                  : P.customerNewUpdatedData) || void 0 === w
                              ? void 0
                              : w.SingleShopifyCustomers),
                          (a =
                            null !==
                              (T =
                                null === (O = F.getState().salesRepData) ||
                                void 0 === O
                                  ? void 0
                                  : O.createOrderTab) && void 0 !== T
                              ? T
                              : {}),
                          (i = !1),
                          (s = !1);
                        try {
                          for (
                            l = function (e, t) {
                              return (
                                (null == e ? void 0 : e.address1) ===
                                  (null == t ? void 0 : t.address1) &&
                                (null == e ? void 0 : e.city) ===
                                  (null == t ? void 0 : t.city) &&
                                (null == e ? void 0 : e.country) ===
                                  (null == t ? void 0 : t.country) &&
                                ((null == e ? void 0 : e.province) || null) ===
                                  ((null == t ? void 0 : t.province) || null) &&
                                (null == e ? void 0 : e.zip) ===
                                  (null == t ? void 0 : t.zip)
                              );
                            },
                              c = 0,
                              u = r || [];
                            c < u.length &&
                            ((m = u[c]),
                            !i &&
                              l(t, m) &&
                              (h(e, m, "isShippingAddress"), (i = !0)),
                            !s &&
                              l(n, m) &&
                              (h(e, m, "isBillingAddress"), (s = !0)),
                            !i && !s);
                            c++
                          );
                          (f = function (e) {
                            var t, n, r, o, a, i, s, l, d, c, u, m, h;
                            return {
                              address1:
                                null !==
                                  (t = null == e ? void 0 : e.address1) &&
                                void 0 !== t
                                  ? t
                                  : "",
                              address2:
                                null !==
                                  (n = null == e ? void 0 : e.address2) &&
                                void 0 !== n
                                  ? n
                                  : "",
                              city:
                                null !== (r = null == e ? void 0 : e.city) &&
                                void 0 !== r
                                  ? r
                                  : "",
                              company:
                                null !== (o = null == e ? void 0 : e.company) &&
                                void 0 !== o
                                  ? o
                                  : "",
                              country:
                                null !== (a = null == e ? void 0 : e.country) &&
                                void 0 !== a
                                  ? a
                                  : "",
                              customer_id: (null !==
                                (s =
                                  null ===
                                    (i = null == p ? void 0 : p.customer) ||
                                  void 0 === i
                                    ? void 0
                                    : i.id) && void 0 !== s
                                ? s
                                : ""
                              ).toString(),
                              defaultAddr: !1,
                              email:
                                null !== (l = null == e ? void 0 : e.email) &&
                                void 0 !== l
                                  ? l
                                  : "",
                              first_name:
                                null !==
                                  (d = null == e ? void 0 : e.first_name) &&
                                void 0 !== d
                                  ? d
                                  : "",
                              id: 678910,
                              last_name:
                                null !==
                                  (c = null == e ? void 0 : e.last_name) &&
                                void 0 !== c
                                  ? c
                                  : "",
                              phone:
                                null !== (u = null == e ? void 0 : e.phone) &&
                                void 0 !== u
                                  ? u
                                  : "",
                              province:
                                null !==
                                  (m = null == e ? void 0 : e.province) &&
                                void 0 !== m
                                  ? m
                                  : "",
                              zip:
                                null !== (h = null == e ? void 0 : e.zip) &&
                                void 0 !== h
                                  ? h
                                  : "",
                            };
                          }),
                            !i &&
                            ((null == t ? void 0 : t.address1) ||
                              (null == t ? void 0 : t.city) ||
                              (null == t ? void 0 : t.province) ||
                              (null == t ? void 0 : t.country))
                              ? ((g = f(t)),
                                h(e, g, "isShippingAddress"),
                                (_ = {
                                  customerAddressesList: Wy(
                                    Wy([], r, !0),
                                    [g],
                                    !1
                                  ),
                                  SingleShopifyCustomers: o,
                                }),
                                null == e ||
                                  e.handleUpdateReduxState(
                                    _,
                                    A.CUSTOMER_ADDRESS_DATA
                                  ),
                                null === (I = null == e ? void 0 : e.props) ||
                                  void 0 === I ||
                                  I.setCustomerAddressOptionsData(
                                    Wy(Wy([], r, !0), [g], !1)
                                  ),
                                null == e ||
                                  e.handleUpdateReduxState(
                                    Zy(Zy({}, a), {
                                      customer_shippingaddressID:
                                        null == g ? void 0 : g.id.toString(),
                                    }),
                                    A.CREATE_ORDER_TAB
                                  ),
                                (i = !0))
                              : i ||
                                null == e ||
                                e.setAlertErrorMsg({
                                  msg: d(
                                    "customerInvoice_EditOrder_NoAutoSelectedAddress"
                                  ),
                                  open: !0,
                                }),
                            s ||
                              ((v =
                                (null == n ? void 0 : n.address1) ||
                                (null == n ? void 0 : n.city) ||
                                (null == n ? void 0 : n.province) ||
                                (null == n ? void 0 : n.country)
                                  ? n
                                  : t),
                              (b = f(v)),
                              h(e, b, "isBillingAddress"),
                              (_ = {
                                customerAddressesList: Wy(
                                  Wy([], r, !0),
                                  [b],
                                  !1
                                ),
                                SingleShopifyCustomers: o,
                              }),
                              null === (M = null == e ? void 0 : e.props) ||
                                void 0 === M ||
                                M.setCustomerAddressOptionsData(
                                  Wy(Wy([], r, !0), [b], !1)
                                ),
                              null == e ||
                                e.handleUpdateReduxState(
                                  _,
                                  A.CUSTOMER_ADDRESS_DATA
                                ));
                        } catch (t) {
                          null == e ||
                            e.setAlertErrorMsg({
                              msg: d(
                                "customerInvoice_EditOrder_NoAutoSelectedAddress"
                              ),
                              open: !0,
                            });
                        }
                        return [2, i];
                      });
                    });
                  },
                  h = function (e, t, n) {
                    e.props.setCustomerInfo(function (e) {
                      return Zy(
                        Zy(
                          Zy({}, e),
                          n === Yg
                            ? Zy(Zy({}, f(t)), {
                                shippingAddress:
                                  (null == t ? void 0 : t.id) || "",
                              })
                            : {}
                        ),
                        n === Jg
                          ? Zy(Zy({}, f(t, "billing_")), {
                              billingAddress: (null == t ? void 0 : t.id) || "",
                            })
                          : {}
                      );
                    }),
                      e.props.handleAutoCountryStateSet(
                        null == t ? void 0 : t.country,
                        null == t ? void 0 : t.province,
                        n
                      );
                  },
                  f = function (e, t) {
                    var n;
                    return (
                      void 0 === t && (t = ""),
                      ((n = {})["".concat(t, "firstName")] =
                        (null == e ? void 0 : e.first_name) || ""),
                      (n["".concat(t, "lastName")] =
                        (null == e ? void 0 : e.last_name) || ""),
                      (n["".concat(t, "address1")] =
                        (null == e ? void 0 : e.address1) || ""),
                      (n["".concat(t, "address2")] =
                        (null == e ? void 0 : e.address2) || ""),
                      (n["".concat(t, "city")] =
                        (null == e ? void 0 : e.city) || ""),
                      (n["".concat(t, "zipNumber")] =
                        (null == e ? void 0 : e.zip) || ""),
                      (n["".concat(t, "selectCountry")] =
                        (null == e ? void 0 : e.country) || ""),
                      (n["".concat(t, "selectCountryState")] =
                        (null == e ? void 0 : e.province) || ""),
                      (n["".concat(t, "mobileNumber")] =
                        (null == e ? void 0 : e.phone) || ""),
                      (n["".concat(t, "companyName")] =
                        (null == e ? void 0 : e.company) || ""),
                      n
                    );
                  },
                  v = function (e, t) {
                    return Hy(i, void 0, void 0, function () {
                      var n, r, o, a, i, s, l, d, c;
                      return Vy(this, function (u) {
                        switch (u.label) {
                          case 0:
                            return (
                              (n = !1),
                              e &&
                              ((null ===
                                (a = null == p ? void 0 : p.shipping_line) ||
                              void 0 === a
                                ? void 0
                                : a.title) ||
                                (null ===
                                  (i = null == p ? void 0 : p.shipping_line) ||
                                void 0 === i
                                  ? void 0
                                  : i.price))
                                ? [
                                    4,
                                    null == t
                                      ? void 0
                                      : t.GetShippingRatesOnSelectedAddress(),
                                  ]
                                : [3, 2]
                            );
                          case 1:
                            u.sent() &&
                              ((r =
                                null !==
                                  (d =
                                    null ===
                                      (l =
                                        null ===
                                          (s =
                                            null == p
                                              ? void 0
                                              : p.shipping_line) || void 0 === s
                                          ? void 0
                                          : s.price) || void 0 === l
                                      ? void 0
                                      : l.toFixed(2)) && void 0 !== d
                                  ? d
                                  : ""),
                              (o = ""
                                .concat(
                                  null ===
                                    (c =
                                      null == p ? void 0 : p.shipping_line) ||
                                    void 0 === c
                                    ? void 0
                                    : c.title,
                                  "/"
                                )
                                .concat(r)),
                              null == t || t.setShippingCost(o),
                              null == t || t.setApplyShippingCost(Ug),
                              (n = !0)),
                              (u.label = 2);
                          case 2:
                            return [2, n];
                        }
                      });
                    });
                  },
                  b = function (e, t) {
                    return Hy(i, void 0, void 0, function () {
                      var n, r, o, a, i, l, u, p, m, h, f, g, v, b, _, y;
                      return Vy(this, function (C) {
                        switch (C.label) {
                          case 0:
                            for (
                              n = [], r = !1, o = [], a = 0;
                              a < (null == t ? void 0 : t.length);
                              a++
                            )
                              (null === (p = t[a]) || void 0 === p
                                ? void 0
                                : p.variantId) &&
                                (null === (m = t[a]) || void 0 === m
                                  ? void 0
                                  : m.quantity) &&
                                o.push({
                                  id:
                                    null !==
                                      (f =
                                        null === (h = t[a]) || void 0 === h
                                          ? void 0
                                          : h.variantId) && void 0 !== f
                                      ? f
                                      : "",
                                  quantity:
                                    null !==
                                      (v =
                                        null === (g = t[a]) || void 0 === g
                                          ? void 0
                                          : g.quantity) && void 0 !== v
                                      ? v
                                      : 0,
                                });
                            return (
                              (i = function (e, t) {
                                "Request failed with status code 404" === e
                                  ? null == t ||
                                    t.setAlertErrorMsg({
                                      msg: d(
                                        "customerInvoice_EditOrder_ErrorMsgForCartUpdate"
                                      ),
                                      open: !0,
                                    })
                                  : null == t ||
                                    t.setAlertErrorMsg({ msg: e, open: !0 });
                              }),
                              [4, s(Og({}, "clear.js"))]
                            );
                          case 1:
                            return "boolean" != typeof (l = C.sent()) ||
                              !0 !== l
                              ? [3, 3]
                              : [4, s(Og(o, "add.js"))];
                          case 2:
                            return (
                              "boolean" == typeof (r = C.sent()) && !0 === r
                                ? ((n = t),
                                  null == e ||
                                    e.handleUpdateReduxState(
                                      Zy(Zy({}, c), { isUpdatedCart: !0 }),
                                      A.EDIT_DRAFT_ORDER
                                    ))
                                : i(r, e),
                              [3, 4]
                            );
                          case 3:
                            i(l, e), (C.label = 4);
                          case 4:
                            return 0 !== (null == n ? void 0 : n.length)
                              ? [3, 6]
                              : [4, s(Ig())];
                          case 5:
                            200 ===
                              (null == (u = C.sent()) ? void 0 : u.status) &&
                            (null ===
                              (_ =
                                null === (b = null == u ? void 0 : u.data) ||
                                void 0 === b
                                  ? void 0
                                  : b.items) || void 0 === _
                              ? void 0
                              : _.length) > 0
                              ? (n = (function (e, t) {
                                  return (
                                    null == t ||
                                      t.map(function (t) {
                                        var n,
                                          r = e.find(function (e) {
                                            var n, r;
                                            return (
                                              (null ===
                                                (n =
                                                  null == e
                                                    ? void 0
                                                    : e.variant_id) ||
                                              void 0 === n
                                                ? void 0
                                                : n.toString()) ===
                                              (null ===
                                                (r =
                                                  null == t
                                                    ? void 0
                                                    : t.variantId) ||
                                              void 0 === r
                                                ? void 0
                                                : r.toString())
                                            );
                                          });
                                        t.quantity =
                                          null !==
                                            (n =
                                              null == r
                                                ? void 0
                                                : r.quantity) && void 0 !== n
                                            ? n
                                            : t.quantity;
                                      }),
                                    t
                                  );
                                })(
                                  null === (y = null == u ? void 0 : u.data) ||
                                    void 0 === y
                                    ? void 0
                                    : y.items,
                                  t
                                ))
                              : i(null == u ? void 0 : u.message, e),
                              (C.label = 6);
                          case 6:
                            return [2, n];
                        }
                      });
                    });
                  },
                  _ = function (e) {
                    return Hy(i, void 0, void 0, function () {
                      var t, n, r, o, a, i, s, l, d, c, u, m, h, f;
                      return Vy(this, function (g) {
                        switch (g.label) {
                          case 0:
                            return (
                              (t = {
                                CustomerId:
                                  null !==
                                    (r =
                                      null ===
                                        (n = null == p ? void 0 : p.customer) ||
                                      void 0 === n
                                        ? void 0
                                        : n.id) && void 0 !== r
                                    ? r
                                    : "",
                                CustomerName: (
                                  (null !==
                                    (a =
                                      null ===
                                        (o = null == p ? void 0 : p.customer) ||
                                      void 0 === o
                                        ? void 0
                                        : o.first_name) && void 0 !== a
                                    ? a
                                    : "") +
                                  " " +
                                  (null !==
                                    (s =
                                      null ===
                                        (i = null == p ? void 0 : p.customer) ||
                                      void 0 === i
                                        ? void 0
                                        : i.last_name) && void 0 !== s
                                    ? s
                                    : "")
                                ).trim(),
                                CustomerMailid:
                                  null !==
                                    (d =
                                      null ===
                                        (l = null == p ? void 0 : p.customer) ||
                                      void 0 === l
                                        ? void 0
                                        : l.email) && void 0 !== d
                                    ? d
                                    : "",
                                CompanyName:
                                  null !==
                                    (u =
                                      null ===
                                        (c =
                                          null == p
                                            ? void 0
                                            : p.shipping_Address) ||
                                      void 0 === c
                                        ? void 0
                                        : c.company) && void 0 !== u
                                    ? u
                                    : "",
                                CustomerPhoneno:
                                  null !==
                                    (h =
                                      null ===
                                        (m =
                                          null == p
                                            ? void 0
                                            : p.shipping_Address) ||
                                      void 0 === m
                                        ? void 0
                                        : m.phone) && void 0 !== h
                                    ? h
                                    : "",
                              }),
                              [
                                4,
                                null === (f = null == e ? void 0 : e.props) ||
                                void 0 === f
                                  ? void 0
                                  : f.SearchByCustomer(t),
                              ]
                            );
                          case 1:
                            return g.sent(), [2];
                        }
                      });
                    });
                  };
                return {
                  updateStateForEditOrder: function (e, t) {
                    return Hy(i, void 0, void 0, function () {
                      var n, r, o, a, s, h, f;
                      return Vy(this, function (g) {
                        switch (g.label) {
                          case 0:
                            return "autoFatchDataForEditOrder" === e
                              ? [3, 1]
                              : [3, 10];
                          case 1:
                            return Bh.next(!0), [4, _(t)];
                          case 2:
                            return g.sent(), [4, m(t)];
                          case 3:
                            return (
                              (n = g.sent()),
                              [
                                4,
                                Hy(i, void 0, void 0, function () {
                                  var e, t;
                                  return Vy(this, function (n) {
                                    switch (n.label) {
                                      case 0:
                                        return [
                                          4,
                                          l({
                                            variants:
                                              null == c
                                                ? void 0
                                                : c.productDetailsArray,
                                          }),
                                        ];
                                      case 1:
                                        return (
                                          (e = n.sent()),
                                          [
                                            2,
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.variants) && void 0 !== t
                                              ? t
                                              : null == c
                                              ? void 0
                                              : c.productDetailsArray,
                                          ]
                                        );
                                    }
                                  });
                                }),
                              ]
                            );
                          case 4:
                            return (null == (r = g.sent())
                              ? void 0
                              : r.length) > 0
                              ? [4, b(t, r)]
                              : [3, 8];
                          case 5:
                            return (
                              (o = g.sent()),
                              (null == t ? void 0 : t.newProductTable) ||
                                (function (e, t) {
                                  var n, r, o, a, i, s, l;
                                  if ((null == e ? void 0 : e.length) > 0)
                                    try {
                                      for (
                                        var c = [],
                                          p = {},
                                          m = {},
                                          h =
                                            null !==
                                              (a =
                                                null ===
                                                  (o =
                                                    null ===
                                                      (r =
                                                        F.getState()
                                                          .salesRepData) ||
                                                    void 0 === r
                                                      ? void 0
                                                      : r.createOrderTab) ||
                                                void 0 === o
                                                  ? void 0
                                                  : o.wholePriceObj) &&
                                            void 0 !== a
                                              ? a
                                              : {},
                                          f = {},
                                          g = 0,
                                          v = e;
                                        g < v.length;
                                        g++
                                      ) {
                                        var b = v[g];
                                        if (
                                          b &&
                                          0 !==
                                            (null === (i = Object.keys(b)) ||
                                            void 0 === i
                                              ? void 0
                                              : i.length)
                                        ) {
                                          var _ = b.productId,
                                            y = void 0 === _ ? "0" : _,
                                            C = b.variantId,
                                            x = void 0 === C ? "0" : C,
                                            S = b.quantity,
                                            k = void 0 === S ? 0 : S,
                                            P = b.ItemPrice,
                                            w = void 0 === P ? 0 : P,
                                            O = b.Image,
                                            T = void 0 === O ? "" : O,
                                            I = b.Title,
                                            M = void 0 === I ? "" : I,
                                            j = b.type,
                                            N = void 0 === j ? "" : j,
                                            D = b.tags,
                                            A = void 0 === D ? "" : D,
                                            E = b.inventoryQuantity,
                                            R = void 0 === E ? 0 : E,
                                            L = b.SKU,
                                            B = void 0 === L ? "" : L,
                                            z = b.variantTitle,
                                            Z = void 0 === z ? "" : z,
                                            H = b.inventory_policy,
                                            V = void 0 === H ? "" : H,
                                            W = b.inventory_management,
                                            U = void 0 === W ? "" : W;
                                          (p[y] = y), (m[x] = k);
                                          var $ =
                                              void 0 !== h[x] &&
                                              null !== h[x] &&
                                              0 !== h[x]
                                                ? parseFloat(h[x])
                                                : w,
                                            K = {
                                              productId: parseInt(y),
                                              productImages: T
                                                ? [
                                                    {
                                                      imageId: parseInt(x),
                                                      src: T,
                                                    },
                                                  ]
                                                : [],
                                              productTitle: M,
                                              product_type: N,
                                              tags: A,
                                              variants: [
                                                {
                                                  image_id: parseInt(x),
                                                  inventory_quantity: R,
                                                  product_id: parseInt(y),
                                                  sku: B,
                                                  variantId: parseInt(x),
                                                  variantPrice: w,
                                                  variantTitle: Z,
                                                  quantity: k,
                                                  wholesalePrice: $,
                                                  inventory_policy: V,
                                                  inventory_management: U,
                                                },
                                              ],
                                            },
                                            G = c.find(function (e) {
                                              return (
                                                e.productId === K.productId
                                              );
                                            });
                                          G
                                            ? (n = G.variants).push.apply(
                                                n,
                                                K.variants
                                              )
                                            : c.push(K),
                                            (null == u ? void 0 : u.PriceList)
                                              ? (f[x] =
                                                  (null !== (s = f[x]) &&
                                                  void 0 !== s
                                                    ? s
                                                    : 0) +
                                                  $ * k)
                                              : (f[x] = w * k);
                                          var q = parseInt(
                                            null ===
                                              (l =
                                                null == b
                                                  ? void 0
                                                  : b.appliedDiscount) ||
                                              void 0 === l
                                              ? void 0
                                              : l.value
                                          );
                                          q &&
                                            null != q &&
                                            null != q &&
                                            q &&
                                            f[x] >= q &&
                                            (f[x] = f[x] - q);
                                        }
                                      }
                                      null == t || t.setProduct_idObject(p),
                                        null == t || t.setVariant_idObject(m),
                                        null == t || t.setSubtotal(f),
                                        null == t ||
                                          t.setProductSelectedArray(c);
                                    } catch (e) {
                                      null == t ||
                                        t.setAlertErrorMsg({
                                          msg: d(
                                            "customerInvoice_EditOrder_ErrorMsgForProductSelected"
                                          ),
                                          open: !0,
                                        });
                                    }
                                })(o, t),
                              null == t ||
                                t.setOrderNotes(
                                  null !== (s = null == p ? void 0 : p.note) &&
                                    void 0 !== s
                                    ? s
                                    : ""
                                ),
                              (a =
                                null !==
                                  (h =
                                    null == p
                                      ? void 0
                                      : p.allow_discount_codes_in_checkout) &&
                                void 0 !== h &&
                                h),
                              null == t || t.setDiscountApplyOnCheckout(a),
                              (
                                null ===
                                  (f =
                                    null == u
                                      ? void 0
                                      : u.featuresAdditionalSettings) ||
                                void 0 === f
                                  ? void 0
                                  : f.showShippingCalculation
                              )
                                ? [4, v(n, t)]
                                : [3, 7]
                            );
                          case 6:
                            g.sent(), (g.label = 7);
                          case 7:
                            return [3, 9];
                          case 8:
                            null == t ||
                              t.setAlertErrorMsg({
                                msg: d("productsMayBeSoldOutPleaseCheck"),
                                open: !0,
                              }),
                              (g.label = 9);
                          case 9:
                            return Bh.next(!1), [3, 11];
                          case 10:
                            return [2, null];
                          case 11:
                            return [2];
                        }
                      });
                    });
                  },
                };
              })().updateStateForEditOrder,
              I = Tv(),
              M = g(),
              j = y(function (e) {
                return e.salesRepData ? e.salesRepData : {};
              }),
              N = (0, t.useState)(""),
              D = N[0],
              E = N[1],
              R = (0, t.useState)({ msg: "", color: "blue" }),
              L = R[0],
              B = R[1],
              z =
                null !==
                  (o =
                    null ===
                      (r =
                        null === (n = j.baseData) || void 0 === n
                          ? void 0
                          : n.ConfirmationPopUpStatus) || void 0 === r
                      ? void 0
                      : r.isCheckOutPopUpVisible) &&
                void 0 !== o &&
                o,
              Z = (0, t.useState)(""),
              H = Z[0],
              V = Z[1],
              W = (0, t.useState)({ msg: "", open: !1 }),
              U = W[0],
              $ = W[1],
              K = (0, t.useState)([]),
              G = K[0],
              q = K[1],
              Q = !1,
              Y = (0, t.useState)(""),
              J = Y[0],
              X = Y[1],
              te = J,
              ne = (0, t.useState)(""),
              re = ne[0],
              oe = ne[1],
              ae = (0, t.useState)(!1),
              ie = ae[0],
              se = ae[1],
              le = (0, t.useState)(!1),
              de = le[0],
              ce = le[1],
              ue = (0, t.useState)(!1),
              pe = ue[0],
              me = ue[1],
              he = (0, t.useState)(!1),
              fe = he[0],
              ge = he[1],
              ve = (
                null === (a = j.baseData) || void 0 === a ? void 0 : a.select
              )
                ? null === (i = j.baseData) || void 0 === i
                  ? void 0
                  : i.select
                : {},
              be = (0, t.useState)(
                null !== (s = null == j ? void 0 : j.editDraftOrder) &&
                  void 0 !== s
                  ? s
                  : {}
              ),
              _e = be[0],
              ye = be[1],
              Ce = (0, t.useState)(!1),
              xe = Ce[0],
              Se = Ce[1],
              ke = (0, t.useState)(""),
              Pe = ke[0],
              we = ke[1],
              Oe = (0, t.useState)(!1),
              Te = Oe[0],
              Ie = Oe[1],
              Me = (0, t.useState)(
                null !==
                  (c =
                    null ===
                      (d =
                        null === (l = j.baseData) || void 0 === l
                          ? void 0
                          : l.ConfirmationPopUpStatus) || void 0 === d
                      ? void 0
                      : d.isCheckOutPopUpVisible) &&
                  void 0 !== c &&
                  c
              ),
              je = Me[0],
              Ne = Me[1],
              De =
                !!(null ===
                  (u = null == j ? void 0 : j.checkoutConfirmationPopUp) ||
                void 0 === u
                  ? void 0
                  : u.IscheckBoxChecked) &&
                (null ===
                  (p = null == j ? void 0 : j.checkoutConfirmationPopUp) ||
                void 0 === p
                  ? void 0
                  : p.IscheckBoxChecked),
              Ae = (0, t.useState)(!1),
              Ee = Ae[0],
              Re = Ae[1],
              Le =
                (null === (m = null == j ? void 0 : j.editDraftOrder) ||
                void 0 === m
                  ? void 0
                  : m.actionEvent) === Zg,
              Be = y(function (e) {
                var t;
                return null === (t = e.salesRepData) || void 0 === t
                  ? void 0
                  : t.productTableData;
              }),
              ze = Be.selectedProductData,
              Fe = Be.isQuantityError,
              Ze = Be.isDiscountError,
              He = Be.discountKeyValueObject,
              Ve = Be.selectedDiscountType,
              We = Be.isDiscoutAppliedInEditDraft;
            (0, t.useEffect)(
              function () {
                var t = function () {
                    oe(""), q([]);
                  },
                  n = F.subscribe(function () {
                    t();
                  });
                return (
                  e.customerInfo && t(),
                  function () {
                    return n();
                  }
                );
              },
              [e.customerInfo]
            );
            var Ue = {
                newAddress: [
                  {
                    0:
                      null === (h = e.customerInfo) || void 0 === h
                        ? void 0
                        : h.firstName,
                    errorMsg: O("customerInvoice_FirstNameErrorMsg"),
                  },
                  {
                    1:
                      null === (f = e.customerInfo) || void 0 === f
                        ? void 0
                        : f.lastName,
                    errorMsg: O("customerInvoice_lastNameErrorMsg"),
                  },
                  {
                    2:
                      null === (v = e.customerInfo) || void 0 === v
                        ? void 0
                        : v.address1,
                    errorMsg: O("customerInvoice_Add1ErrorMsg"),
                  },
                  {
                    3:
                      null === (b = e.customerInfo) || void 0 === b
                        ? void 0
                        : b.selectCountry,
                    errorMsg: O("customerInvoice_CountryErrorMsg"),
                  },
                  {
                    4:
                      null === (_ = e.customerInfo) || void 0 === _
                        ? void 0
                        : _.selectCountryState,
                    errorMsg: O("customerInvoice_StateErrorMsg"),
                  },
                  {
                    5:
                      null === (C = e.customerInfo) || void 0 === C
                        ? void 0
                        : C.city,
                    errorMsg: O("customerInvoice_CityErrorMsg"),
                  },
                  {
                    6:
                      null === (x = e.customerInfo) || void 0 === x
                        ? void 0
                        : x.zipNumber,
                    errorMsg: O("customerInvoice_ZipErrorMsg"),
                  },
                ],
              },
              $e = [
                {
                  value: Gg,
                  label: O("customerInvoice_DraftOrderBtn"),
                  description: O("customerInvoice_DraftOrderDescription"),
                  hide: !ve.CreateInvoice,
                },
                {
                  value: Kg,
                  label: O("customerInvoice_PaymentPending"),
                  description: O("customerInvoice_PaymentPendingDescription"),
                  hide: !ve.CreateOrder,
                },
                {
                  value: qg,
                  label: O("customerInvoice_Checkout"),
                  description: O("customerInvoice_CheckoutDescription"),
                  hide: !(null == ve ? void 0 : ve.CreateCheckout),
                },
              ];
            (0, t.useEffect)(function () {
              Le &&
                T("autoFatchDataForEditOrder", {
                  props: e,
                  setOrderNotes: E,
                  setAlertErrorMsg: $,
                  setApplyShippingCost: oe,
                  setShippingCost: V,
                  GetShippingRatesOnSelectedAddress: Ye,
                  handleUpdateReduxState: Xe,
                  newProductTable: !0,
                  setDiscountApplyOnCheckout: Ie,
                });
            }, []),
              (0, t.useEffect)(
                function () {
                  V(""), q([]), oe(""), se(!1);
                },
                [e.customerInfo.shippingAddress, e.customerInfo.zipNumber]
              ),
              (0, t.useEffect)(
                function () {
                  Ne(!(!z || De) || De);
                },
                [De, z]
              );
            var Ke = {
                createOrder: O("customerInvoice_OrderCreatedSuccessfullyMsg"),
                draftOrder: O(
                  "customerInvoice_DraftOrderCreatedSuccessfullyMsg"
                ),
                CreateCheckout:
                  O("customerInvoice_DraftOrderCreatedSuccessfullyMsg") +
                  ", " +
                  O("RepCheckout_RedirectionMsg"),
              },
              Ge = {
                draftOrder: O("customerInvoice_CreatingDraft_Msg"),
                CreateCheckout: O("customerInvoice_CreatingDraft_Msg"),
                createOrder: O("customerInvoice_Creating_Msg"),
              },
              qe = function (t, n) {
                var r;
                null == e || e.setIsCustomerSelected(!1),
                  Xe({}, A.CREATE_ORDER_TAB),
                  B({ msg: Ke[t], color: "green" }),
                  $({ msg: Ke[t], open: !0, severity: "success" }),
                  me(!0),
                  setTimeout(function () {
                    B({ msg: "", color: "" });
                  }, 5e3),
                  null == e || e.setOrderCreatedSuccesfullyFlag(!0),
                  Xe([], A.DRAFT_ORDER_DATA),
                  Xe({}, A.EDIT_DRAFT_ORDER),
                  we(""),
                  t === qg &&
                    (Re(!1),
                    (window.location.href = Le
                      ? null === (r = null == _e ? void 0 : _e.draftOrderObj) ||
                        void 0 === r
                        ? void 0
                        : r.invoice_url
                      : n)),
                  ye({}),
                  (Le = !1);
              },
              Qe = function (e, t) {
                var n = O(
                  "GetShippingRates" === e
                    ? "ShippingCost_CustomerAddressAndCartProductError"
                    : "Address_Not_Found_Error_Msg"
                );
                if (0 !== (null == ze ? void 0 : ze.length) || Le)
                  if (
                    null == Ue
                      ? void 0
                      : Ue.newAddress.every(function (e, t) {
                          return "" === e[t];
                        })
                  ) {
                    if (((Q = !1), t !== Gg && !Le))
                      return void $({ msg: n, open: !0, severity: "warning" });
                    t === Gg || Le
                      ? (X("formAddress"), (te = "formAddress"))
                      : (X(""), (te = ""));
                  } else
                    (
                      null == Ue
                        ? void 0
                        : Ue.newAddress.every(function (e, t) {
                            return "" !== e[t];
                          })
                    )
                      ? ((Q = !0), X("formAddress"), (te = "formAddress"))
                      : t !== Gg
                      ? Je()
                      : (X("formAddress"), (te = "formAddress"));
                else $({ msg: n, open: !0, severity: "warning" });
              },
              Ye = function () {
                return $y(w, void 0, void 0, function () {
                  var t, n, r, o, a, i;
                  return Ky(this, function (s) {
                    switch (s.label) {
                      case 0:
                        return (
                          V(""),
                          q([]),
                          oe(Ug),
                          se(!1),
                          (null == e ? void 0 : e.customerAddressesList) &&
                          (null ===
                            (r =
                              null == e ? void 0 : e.customerAddressesList) ||
                          void 0 === r
                            ? void 0
                            : r.length) > 0
                            ? e.customerAddressesList
                            : null ===
                                (a =
                                  null === (o = F.getState().salesRepData) ||
                                  void 0 === o
                                    ? void 0
                                    : o.customerNewUpdatedData) ||
                              void 0 === a ||
                              a.customerAddressesList,
                          Qe("GetShippingRates", ""),
                          Q && "" !== te
                            ? ((t = {
                                customerCountry: "",
                                customerProvince: "",
                                customerZip: "",
                              }),
                              "formAddress" === te &&
                                ((t.customerCountry =
                                  e.customerInfo.selectCountry),
                                (t.customerProvince = e.customerInfo
                                  .selectCountryState
                                  ? e.customerInfo.selectCountryState
                                  : e.customerInfo.city),
                                (t.customerZip = e.customerInfo.zipNumber)),
                              "Great Britain (UK)" === t.customerCountry
                                ? (t.customerCountry = "United Kingdom")
                                : "United States of America" ===
                                    t.customerCountry &&
                                  (t.customerCountry = "United States"),
                              V(
                                O(
                                  "customerInvoice_CalculatingShippingRates_Msg"
                                )
                              ),
                              [4, Ff(t)])
                            : [3, 2]
                        );
                      case 1:
                        return (
                          (n = s.sent()),
                          V(""),
                          ce(!0),
                          null != n &&
                          null != n &&
                          n.hasOwnProperty("shipping_rates") &&
                          "Success" === (null == n ? void 0 : n.message)
                            ? (q(null == n ? void 0 : n.shipping_rates),
                              0 ===
                                (null ===
                                  (i = null == n ? void 0 : n.shipping_rates) ||
                                void 0 === i
                                  ? void 0
                                  : i.length) &&
                                ($({
                                  msg: O("ShippingCost_AddressError"),
                                  open: !0,
                                  severity: "warning",
                                }),
                                oe("")),
                              [2, !0])
                            : ("Success" === (null == n ? void 0 : n.message)
                                ? ($({
                                    msg: O(
                                      "customerInvoice_ShippingCostErrorMsg_TryAgain"
                                    ),
                                    open: !0,
                                  }),
                                  oe(""))
                                : ($({
                                    msg: null == n ? void 0 : n.message,
                                    open: !0,
                                  }),
                                  oe("")),
                              [2, !1])
                        );
                      case 2:
                        return [2];
                    }
                  });
                });
              },
              Je = function () {
                for (
                  var e, t = 0;
                  t <
                  (null === (e = null == Ue ? void 0 : Ue.newAddress) ||
                  void 0 === e
                    ? void 0
                    : e.length);
                  t++
                )
                  if ("" === (null == Ue ? void 0 : Ue.newAddress[t][t])) {
                    $({
                      msg: null == Ue ? void 0 : Ue.newAddress[t].errorMsg,
                      open: !0,
                      severity: "warning",
                    });
                    break;
                  }
              },
              Xe = function (e, t) {
                M({ payload: e, type: t });
              },
              et = function () {
                return (
                  L.msg === O("customerInvoice_Sending_Msg") ||
                  L.msg === O("customerInvoice_Creating_Msg") ||
                  L.msg === O("customerInvoice_CreatingDraft_Msg") ||
                  L.msg === O("customerInvoice_CreatingDraftCheckout")
                );
              };
            return {
              orderCreateBtnDisabled:
                "" != Pe &&
                (null == ze ? void 0 : ze.length) > 0 &&
                !et() &&
                "" !== e.customerInfo.customerName.trim() &&
                "" !== e.customerInfo.emailId.trim() &&
                !1 === (null == e ? void 0 : e.email_validation) &&
                (!1 === (null == e ? void 0 : e.zip_validation) ||
                  (null === (S = null == e ? void 0 : e.customerInfo) ||
                  void 0 === S
                    ? void 0
                    : S.shippingAddress)) &&
                (!1 === (null == e ? void 0 : e.mobile_validation) ||
                  "" === (null == e ? void 0 : e.mobile_validation)) &&
                (null === (k = Object.values(Fe)) || void 0 === k
                  ? void 0
                  : k.every(function (e) {
                      return !e;
                    })) &&
                (null === (P = Object.values(Ze)) || void 0 === P
                  ? void 0
                  : P.every(function (e) {
                      return !e;
                    })) &&
                !(H === O("customerInvoice_CalculatingShippingRates_Msg")),
              handleOpenConfirm: function () {
                re !== Ug || "" !== H
                  ? Re(!Ee)
                  : $({
                      msg: O(
                        "customerInvoice_EditOrder_NoAutoSelectedShippingCost"
                      ),
                      open: !0,
                      severity: "warning",
                    });
              },
              isConfirmOpen: Ee,
              selectedOrderType: Pe,
              t: O,
              salesRepData: j,
              orderNotes: D,
              setOrderNotes: E,
              orderPlacedMsg: L,
              CreateOrder: function (t) {
                return $y(w, void 0, void 0, function () {
                  var n,
                    r,
                    o,
                    a,
                    i,
                    s,
                    l,
                    d,
                    c,
                    u,
                    p,
                    m,
                    h,
                    f,
                    g,
                    v,
                    b,
                    _,
                    y,
                    C,
                    x,
                    S,
                    k,
                    P,
                    w,
                    T,
                    I,
                    M,
                    j,
                    N,
                    A,
                    E,
                    R,
                    L,
                    z,
                    F,
                    Z,
                    V,
                    W,
                    U,
                    K;
                  return Ky(this, function (G) {
                    switch (G.label) {
                      case 0:
                        if (
                          (G.trys.push([0, 3, , 4]),
                          (n = af()),
                          (r = n.CustomerId),
                          (o = n.email),
                          (a = o),
                          (i = r),
                          (s = {}),
                          Qe(Kg, t),
                          null ===
                            (y =
                              null == ve
                                ? void 0
                                : ve.featuresAdditionalSettings) || void 0 === y
                            ? void 0
                            : y.showShippingCalculation)
                        ) {
                          if (Q && "" !== te && "" === re)
                            return (
                              $({
                                msg: O(
                                  "customerInvoice_ShippingCostAddOrNot_Msg"
                                ),
                                open: !0,
                                severity: "warning",
                              }),
                              [2]
                            );
                          if (t !== Gg && re === Ug && "" === H)
                            return (
                              $({
                                msg: O(
                                  "customerInvoice_EditOrder_NoAutoSelectedShippingCost"
                                ),
                                open: !0,
                                severity: "warning",
                              }),
                              [2]
                            );
                        }
                        if (
                          t !== Gg &&
                          (!Q ||
                            "" === te ||
                            ((null ===
                              (C =
                                null == ve
                                  ? void 0
                                  : ve.featuresAdditionalSettings) ||
                            void 0 === C
                              ? void 0
                              : C.showShippingCalculation) &&
                              re !== $g &&
                              "" === H))
                        )
                          return [3, 2];
                        if (
                          ((d = []),
                          (c = null),
                          (u = null),
                          (p = null == H ? void 0 : H.split("/")),
                          (m = null == p ? void 0 : p.pop()),
                          "" !== (h = null == p ? void 0 : p.join("/")) &&
                            "" !== m &&
                            ((c = h), (u = m)),
                          re === $g && ((c = "Custom"), (u = null)),
                          H === Qg && ((c = ""), (u = null)),
                          (f =
                            null == ze
                              ? void 0
                              : ze.map(function (e) {
                                  var t = e.variantId.replace(
                                    "gid://shopify/ProductVariant/",
                                    ""
                                  );
                                  return Uy(Uy({}, e), { variantId: t });
                                })),
                          "formAddress" === te &&
                            (d = [
                              {
                                fname:
                                  (null === (x = e.customerInfo) || void 0 === x
                                    ? void 0
                                    : x.firstName) || "",
                                lastname:
                                  (null === (S = e.customerInfo) || void 0 === S
                                    ? void 0
                                    : S.lastName) || "",
                                address1:
                                  (null === (k = e.customerInfo) || void 0 === k
                                    ? void 0
                                    : k.address1) || "",
                                address2:
                                  (null === (P = e.customerInfo) || void 0 === P
                                    ? void 0
                                    : P.address2) || "",
                                province:
                                  (null === (w = e.customerInfo) || void 0 === w
                                    ? void 0
                                    : w.selectCountryState) || "",
                                city:
                                  (null === (T = e.customerInfo) || void 0 === T
                                    ? void 0
                                    : T.city) || "",
                                country:
                                  (null === (I = e.customerInfo) || void 0 === I
                                    ? void 0
                                    : I.selectCountryCode) || "",
                                zip:
                                  (null === (M = e.customerInfo) || void 0 === M
                                    ? void 0
                                    : M.zipNumber) || "",
                              },
                              {
                                fname: e.customerInfo.billing_firstName || "",
                                lastname: e.customerInfo.billing_lastName || "",
                                address1: e.customerInfo.billing_address1 || "",
                                address2: e.customerInfo.billing_address2 || "",
                                province:
                                  e.customerInfo.billing_selectCountryState ||
                                  "",
                                city: e.customerInfo.billing_city || "",
                                country:
                                  e.customerInfo.billing_selectCountryCode ||
                                  "",
                                zip: e.customerInfo.billing_zipNumber || "",
                              },
                            ]),
                          "formAddress" === te &&
                            ((d[0].company = (
                              null === (j = e.customerInfo) || void 0 === j
                                ? void 0
                                : j.companyName
                            )
                              ? e.customerInfo.companyName
                              : null !== (N = null == s ? void 0 : s.company) &&
                                void 0 !== N
                              ? N
                              : ""),
                            (d[0].phone = (
                              null === (A = e.customerInfo) || void 0 === A
                                ? void 0
                                : A.mobileNumber
                            )
                              ? null === (E = e.customerInfo) || void 0 === E
                                ? void 0
                                : E.mobileNumber
                              : null !== (R = null == s ? void 0 : s.phone) &&
                                void 0 !== R
                              ? R
                              : ""),
                            (d[1].company = (
                              null === (L = e.customerInfo) || void 0 === L
                                ? void 0
                                : L.billing_companyName
                            )
                              ? e.customerInfo.billing_companyName
                              : ""),
                            (d[1].phone = (
                              null === (z = e.customerInfo) || void 0 === z
                                ? void 0
                                : z.billing_mobileNumber
                            )
                              ? null === (F = e.customerInfo) || void 0 === F
                                ? void 0
                                : F.billing_mobileNumber
                              : "")),
                          (g = {}),
                          He &&
                            (null === (Z = Object.keys(He)) || void 0 === Z
                              ? void 0
                              : Z.length) > 0)
                        )
                          for (v in He)
                            "discountOnSubTotal" !== v
                              ? ((b =
                                  null == v
                                    ? void 0
                                    : v.split(
                                        "gid://shopify/ProductVariant/"
                                      )[1]),
                                (g[b] = He[v]))
                              : (g[v] = He[v]);
                        return (
                          (l = Uy(
                            Uy(
                              Uy({}, !Le && { email: a }),
                              Le && {
                                repEmail: a,
                                orderId:
                                  null ===
                                    (V =
                                      null == _e ? void 0 : _e.draftOrderObj) ||
                                  void 0 === V
                                    ? void 0
                                    : V.id,
                                orderTags:
                                  null ===
                                    (W =
                                      null == _e ? void 0 : _e.draftOrderObj) ||
                                  void 0 === W
                                    ? void 0
                                    : W.tags,
                                additionalNoteDetails:
                                  null !==
                                    (K =
                                      null ===
                                        (U =
                                          null == _e
                                            ? void 0
                                            : _e.draftOrderObj) || void 0 === U
                                        ? void 0
                                        : U.note_attributesList) && void 0 !== K
                                    ? K
                                    : [],
                              }
                            ),
                            {
                              prods: JSON.stringify(f),
                              customerId: i,
                              Index: -1,
                              fnamecus: e.customerInfo.customerName,
                              cusemail: e.customerInfo.emailId,
                              wholesale: "false",
                              message: D,
                              cusAddress: d,
                              shippingtitle: c,
                              shippingprice: u,
                              IsAdressFromCustmerInvoice: !1,
                              completeDraftOrder: t === Kg,
                              isNewaddress: !0,
                              pro: !1,
                              saveAsDraftOrder: !1,
                              sendInvoice: xe,
                              doNotShowCheckOutInfoPopUp: t === qg && je,
                              lineItemDiscountObject: g,
                              discountApplyOnSubTotal: (
                                null == g ? void 0 : g.discountOnSubTotal
                              )
                                ? Number(
                                    null == g ? void 0 : g.discountOnSubTotal
                                  )
                                : 0,
                              discountType: Ve,
                              backofficeDiscountApplied: null != We && We,
                              isApplyDiscountOnCheckout: null != Te && Te,
                            }
                          )),
                          B({ msg: Ge[t], color: "blue" }),
                          Bh.next(!0),
                          null == e || e.setOrderCreatedSuccesfullyFlag(!1),
                          ge(!0),
                          [4, rg(l, Le)]
                        );
                      case 1:
                        (_ = G.sent()),
                          ge(!1),
                          "string" == typeof _ && "" !== _
                            ? qe(t, _)
                            : _ && Le
                            ? qe(t)
                            : (B({
                                msg: O("customerInvoice_ErrorMsgTryAgain"),
                                color: "red",
                              }),
                              $({
                                msg: O("customerInvoice_ErrorMsgTryAgain"),
                                open: !0,
                                severity: "error",
                              }),
                              setTimeout(function () {
                                B({ msg: "", color: "" });
                              }, 2e3)),
                          Re(!1),
                          Bh.next(!1),
                          (G.label = 2);
                      case 2:
                        return [3, 4];
                      case 3:
                        return (
                          G.sent(),
                          $({
                            msg: O("customerInvoice_ErrorMsgTryAgain"),
                            open: !0,
                            severity: "error",
                          }),
                          [3, 4]
                        );
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              handleAlertMsgClose: function (e, t) {
                "clickaway" !== t && $({ msg: "", open: !1 });
              },
              shippingCost: H,
              setShippingCost: V,
              alertErrorMsg: U,
              handleSelectShippingAddress: function (e) {
                X(e), V(""), q([]), oe(""), se(!1);
              },
              shippingAddresSet: J,
              shippingCostData: G,
              handleShippingCostApply: function (e) {
                oe(Ug), V(e), e === Qg && we(qg);
              },
              applyShippingCost: re,
              setApplyShippingCost: oe,
              isDisabledShippingCostRadioBtn_YesNo: ie,
              selectFeatures: ve,
              isMobile: I,
              checkIsPlacingMessage: et,
              orderCreatedSuccessfully: pe,
              sendInvoiceFeature: xe,
              setSendInvoiceFeature: Se,
              handleOrderTypeChange: function (e) {
                we(e), Se(e === Kg);
              },
              defaultPopupStateFromDb: je,
              handleUpdateReduxState: Xe,
              setOrderCreatedSuccessfully: me,
              selectedProductData: ze,
              handleApplyShippingRadio: function (e) {
                V(""), q([]), oe(e), e && e === Ug && Ye();
              },
              orderOptions: $e,
              openSelectShippingFlag: de,
              setOpenSelectShippingFlag: ce,
              createOrderBtnLoader: fe,
              discountApplyOnCheckout: Te,
              setDiscountApplyOnCheckout: Ie,
            };
          })(n),
          s = i.createOrderBtnLoader,
          l = i.orderOptions,
          d = i.orderCreateBtnDisabled,
          c = i.handleOpenConfirm,
          u = i.isConfirmOpen,
          p = i.selectedOrderType,
          m = i.t,
          h = (i.salesRepData, i.orderNotes),
          f = i.setOrderNotes,
          v = i.orderPlacedMsg,
          b = i.CreateOrder,
          _ = i.handleAlertMsgClose,
          C = i.shippingCost,
          x = i.setShippingCost,
          S = i.alertErrorMsg,
          k =
            (i.handleSelectShippingAddress,
            i.shippingAddresSet,
            i.shippingCostData),
          P = i.applyShippingCost,
          w = i.setApplyShippingCost,
          O = i.isDisabledShippingCostRadioBtn_YesNo,
          T = i.selectFeatures,
          I = i.isMobile,
          M = i.checkIsPlacingMessage,
          j = i.orderCreatedSuccessfully,
          N = i.sendInvoiceFeature,
          D = i.setSendInvoiceFeature,
          E = i.handleOrderTypeChange,
          R = i.defaultPopupStateFromDb,
          L = i.handleUpdateReduxState,
          B = i.setOrderCreatedSuccessfully,
          z = i.handleShippingCostApply,
          Z = i.handleApplyShippingRadio,
          H = i.openSelectShippingFlag,
          V = i.setOpenSelectShippingFlag,
          W = i.setDiscountApplyOnCheckout,
          U = i.discountApplyOnCheckout,
          $ = (function () {
            var e = Tv();
            return {
              ST_CI_table: { minWidth: 650 },
              ST_CI_tableDataCell: { pt: 0.5, pb: 0.5 },
              ST_CI_renderPriceArea: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                mt: 2,
              },
              ST_CI_MinWidth: { minWidth: 228, mt: 1 },
              ST_CI_TotalPriceRenderBox: {
                display: "flex",
                alignItems: "center",
                border: 1,
                borderRadius: 1,
                borderColor: "#d4d4d4",
                backgroundColor: "white",
                mt: 1,
                color: "black",
                "& svg": { m: 1.5 },
                "& hr": {
                  borderColor: "black",
                  borderWidth: 1,
                  background: "black",
                },
                width: e ? 400 : 280,
                height: e ? 50 : 40,
              },
              ST_CI_TotalPriceText: { fontWeight: 600, ml: 2, mr: 2 },
              ST_CI_BtnArea: {
                display: "flex",
                justifyContent: e ? "start" : "flex-end",
                mt: 3,
                mb: 2,
              },
              ST_CI_DisplayFlex: {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                mb: 3,
                mt: 3,
              },
              ST_CI_AddMoreProducts_Btn: { mt: 2, mr: 1, whiteSpace: "nowrap" },
              ST_CI_SearchProductGrid: {
                minWidth: e ? 0 : 232,
                mt: 2,
                backgroundColor: "white",
                width: e ? 400 : 0,
              },
              ST_CI_ShippingCost: { display: "flex", flexWrap: "wrap" },
              ST_CI_DisplayFlexEnd: {
                display: "flex",
                justifyContent: e ? "start" : "flex-end",
                marginTop: e ? 2 : 0,
              },
              ST_CI_ApplyShippingCostRadio_Btn: {
                pl: "0.1rem",
                pt: "0rem",
                pb: "0rem",
                pr: "0rem",
              },
              ST_CI_SippingCostBtn: {
                mt: 1,
                backgroundColor: "white",
                width: e ? "100%" : 190,
                height: 36,
                fontSize: e ? 14 : 11,
              },
              ST_CI_SippingCost_TextField: {
                width: e ? "100%" : 180,
                backgroundColor: "white",
                mt: 1,
                ml: e ? 0 : 1,
              },
              ST_CI_SendInvoice_CreateOrder_Btn: {
                width: e ? "100%" : 135,
                height: e ? 45 : 36,
                fontSize: e ? 14 : 12,
                backgroundColor: "#1f76ce",
              },
            };
          })(),
          K = $.ST_CI_MinWidth,
          G = $.ST_CI_BtnArea,
          q = $.ST_CI_DisplayFlexEnd,
          Q = $.ST_CI_ApplyShippingCostRadio_Btn,
          Y = $.ST_CI_SippingCost_TextField,
          J = $.ST_CI_SendInvoice_CreateOrder_Btn;
        (0, t.useEffect)(
          function () {
            j &&
              (null == n || n.EmptyAllFieldsOnSuccess(),
              f(""),
              w(""),
              x(""),
              L({}, A.PRODUCT_TABLE_DATA),
              B(!1));
          },
          [j]
        );
        var X = xv().SnackbarAlertMsg;
        return (0, e.jsxs)(e.Fragment, {
          children: [
            (0, e.jsxs)(
              qa,
              Gy(
                { container: !0, spacing: 2 },
                {
                  children: [
                    (0, e.jsx)(
                      qa,
                      Gy(
                        { item: !0, xs: 12, md: 6, lg: 4, xl: 4 },
                        {
                          children: (0, e.jsx)(Hc, {
                            InputProps: {
                              style: Gy(Gy({}, K), {
                                height: I ? 70 : 40,
                                backgroundColor: "white",
                              }),
                            },
                            label: m("customerInvoice_contentHeading2Title3"),
                            value: h,
                            onChange: function (e) {
                              return f(e.target.value);
                            },
                            className: "ST_CI_textfield-details ",
                            type: "search",
                            size: "small",
                          }),
                        }
                      )
                    ),
                    (0, e.jsxs)(
                      qa,
                      Gy(
                        { item: !0, xs: 12, md: 6, lg: 8, xl: 8 },
                        {
                          children: [
                            (0, e.jsx)(
                              "div",
                              Gy(
                                { style: q },
                                {
                                  children: (
                                    null ===
                                      (r =
                                        null == T
                                          ? void 0
                                          : T.featuresAdditionalSettings) ||
                                    void 0 === r
                                      ? void 0
                                      : r.showShippingCalculation
                                  )
                                    ? (0, e.jsxs)(
                                        ni,
                                        Gy(
                                          { variant: "subtitle1" },
                                          {
                                            children: [
                                              m(
                                                "customerInvoice_ShippingCostAddOrNot_Msg"
                                              ),
                                              (0, e.jsxs)(
                                                "span",
                                                Gy(
                                                  {
                                                    style: {
                                                      color:
                                                        P === Ug
                                                          ? "green"
                                                          : "blue",
                                                      marginLeft: I
                                                        ? "0.2rem"
                                                        : "0.5rem",
                                                      cursor: "pointer",
                                                    },
                                                    onClick: function () {
                                                      return O ? null : Z(Ug);
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      m(
                                                        "customerInvoice_ShippingCostAddOrNot_Yes"
                                                      ),
                                                      (0, e.jsx)(Fy, {
                                                        sx: Gy(
                                                          { mr: "0.5rem" },
                                                          Q
                                                        ),
                                                        checked: P === Ug,
                                                        value: Ug,
                                                        disabled:
                                                          O ||
                                                          C ===
                                                            m(
                                                              "customerInvoice_CalculatingShippingRates_Msg"
                                                            ),
                                                        inputProps: {
                                                          "aria-label": Ug,
                                                        },
                                                        size: "small",
                                                        color: "success",
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                              "/",
                                              (0, e.jsxs)(
                                                "span",
                                                Gy(
                                                  {
                                                    style: {
                                                      marginLeft: "0.5rem",
                                                      cursor: "pointer",
                                                      color:
                                                        P === $g
                                                          ? "green"
                                                          : "blue",
                                                      pointerEvents: "auto",
                                                    },
                                                    onClick: function () {
                                                      return O ? null : Z($g);
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      m(
                                                        "customerInvoice_ShippingCostAddOrNot_No"
                                                      ),
                                                      (0, e.jsx)(Fy, {
                                                        sx: Q,
                                                        checked: P === $g,
                                                        value: $g,
                                                        disabled:
                                                          O ||
                                                          C ===
                                                            m(
                                                              "customerInvoice_CalculatingShippingRates_Msg"
                                                            ),
                                                        inputProps: {
                                                          "aria-label": $g,
                                                        },
                                                        size: "small",
                                                        color: "success",
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      )
                                    : null,
                                }
                              )
                            ),
                            (null ===
                              (o =
                                null == T
                                  ? void 0
                                  : T.featuresAdditionalSettings) ||
                            void 0 === o
                              ? void 0
                              : o.showShippingCalculation) && P === Ug
                              ? (0, e.jsx)(
                                  "div",
                                  Gy(
                                    { style: q },
                                    {
                                      children: (0, e.jsxs)(
                                        yd,
                                        Gy(
                                          { sx: Gy({}, Y) },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                hd,
                                                Gy(
                                                  {
                                                    sx: { top: "-6px" },
                                                    id: "shipping-cost-label",
                                                  },
                                                  {
                                                    children: m(
                                                      "customerInvoice_selectShippingCost"
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsxs)(
                                                Rc,
                                                Gy(
                                                  {
                                                    labelId:
                                                      "shipping-cost-label",
                                                    id: "outlined-select-shippingCost",
                                                    value: C,
                                                    onChange: function (e) {
                                                      return z(e.target.value);
                                                    },
                                                    open: H,
                                                    onOpen: function () {
                                                      return V(!0);
                                                    },
                                                    onClose: function () {
                                                      return V(!1);
                                                    },
                                                    label: m(
                                                      "customerInvoice_selectShippingCost"
                                                    ),
                                                    size: "small",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        J_,
                                                        Gy(
                                                          {
                                                            disabled: !0,
                                                            value:
                                                              C ===
                                                              m(
                                                                "customerInvoice_CalculatingShippingRates_Msg"
                                                              )
                                                                ? C
                                                                : "",
                                                          },
                                                          {
                                                            children:
                                                              C ===
                                                              m(
                                                                "customerInvoice_CalculatingShippingRates_Msg"
                                                              )
                                                                ? C
                                                                : m(
                                                                    "customerInvoice_selectShippingCost"
                                                                  ),
                                                          }
                                                        )
                                                      ),
                                                      (null == k
                                                        ? void 0
                                                        : k.length) > 0
                                                        ? null == k
                                                          ? void 0
                                                          : k.map(function (
                                                              t,
                                                              n
                                                            ) {
                                                              return (0, e.jsx)(
                                                                J_,
                                                                Gy(
                                                                  {
                                                                    value: ""
                                                                      .concat(
                                                                        t.name,
                                                                        "/"
                                                                      )
                                                                      .concat(
                                                                        t.price
                                                                      ),
                                                                  },
                                                                  {
                                                                    children: ""
                                                                      .concat(
                                                                        t.name,
                                                                        " / "
                                                                      )
                                                                      .concat(
                                                                        t.price
                                                                      ),
                                                                  }
                                                                ),
                                                                n
                                                              );
                                                            })
                                                        : null,
                                                      (0, e.jsx)(
                                                        J_,
                                                        Gy(
                                                          { value: Qg },
                                                          {
                                                            children:
                                                              "Select at Checkout Shipping",
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                )
                              : null,
                          ],
                        }
                      )
                    ),
                    (0, e.jsx)(
                      qa,
                      Gy(
                        { item: !0, xs: 12, md: 12, lg: 12, xl: 12 },
                        {
                          children: (0, e.jsx)(
                            mn,
                            Gy(
                              { sx: G },
                              {
                                children: (0, e.jsx)(e.Fragment, {
                                  children: (0, e.jsxs)(
                                    qa,
                                    Gy(
                                      { item: !0, xs: 12 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            "div",
                                            Gy(
                                              { className: "headingDivider" },
                                              {
                                                children: (0, e.jsx)(
                                                  Gt,
                                                  Gy(
                                                    {
                                                      textAlign: "left",
                                                      className:
                                                        "PT_Search_Text_Divider",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        ni,
                                                        Gy(
                                                          {
                                                            variant: Av,
                                                            sx: Ko,
                                                          },
                                                          {
                                                            children:
                                                              m("orderType"),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)("br", {}),
                                          (0, e.jsx)(
                                            qa,
                                            Gy(
                                              {
                                                container: !0,
                                                spacing: 2,
                                                sx: {
                                                  display: "flex",
                                                  justifyContent: "right",
                                                },
                                              },
                                              {
                                                children:
                                                  null ===
                                                    (a =
                                                      null == l
                                                        ? void 0
                                                        : l.filter(function (
                                                            e
                                                          ) {
                                                            return !e.hide;
                                                          })) || void 0 === a
                                                    ? void 0
                                                    : a.map(function (t) {
                                                        return (0, e.jsx)(
                                                          qa,
                                                          Gy(
                                                            {
                                                              item: !0,
                                                              xs: 12,
                                                              sm: 12,
                                                              md: 4,
                                                              lg: 4,
                                                              xl: 4,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(
                                                                mn,
                                                                Gy(
                                                                  {
                                                                    onClick:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        "INPUT" !==
                                                                          e
                                                                            .target
                                                                            .tagName &&
                                                                          (C !==
                                                                            Qg ||
                                                                            t.value ===
                                                                              qg ||
                                                                            p ===
                                                                              t.value) &&
                                                                          E(
                                                                            t.value
                                                                          );
                                                                      },
                                                                    sx: {
                                                                      background:
                                                                        p ===
                                                                        t.value
                                                                          ? "#FAFDFF"
                                                                          : "white",
                                                                      border:
                                                                        p ===
                                                                        t.value
                                                                          ? "1px solid #1976D2"
                                                                          : "1px solid #e0e0e0",
                                                                      borderRadius:
                                                                        "4px",
                                                                      height:
                                                                        "100%",
                                                                      "&:hover":
                                                                        {
                                                                          backgroundColor:
                                                                            "rgb(246, 250, 253)",
                                                                          cursor:
                                                                            "pointer",
                                                                        },
                                                                    },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsxs)(
                                                                        mn,
                                                                        Gy(
                                                                          {
                                                                            sx: {
                                                                              padding: 2,
                                                                              "&:hover":
                                                                                {
                                                                                  backgroundColor:
                                                                                    "rgb(246, 250, 253)",
                                                                                  cursor:
                                                                                    "pointer",
                                                                                },
                                                                            },
                                                                            onClick:
                                                                              function (
                                                                                e
                                                                              ) {
                                                                                "INPUT" !==
                                                                                  e
                                                                                    .target
                                                                                    .tagName &&
                                                                                  (C !==
                                                                                    Qg ||
                                                                                    t.value ===
                                                                                      qg ||
                                                                                    p ===
                                                                                      t.value) &&
                                                                                  E(
                                                                                    t.value
                                                                                  );
                                                                              },
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  m_,
                                                                                  {
                                                                                    disabled:
                                                                                      C ===
                                                                                        Qg &&
                                                                                      t.value !==
                                                                                        qg,
                                                                                    value:
                                                                                      t.value,
                                                                                    control:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Fy,
                                                                                        {
                                                                                          size: "small",
                                                                                        }
                                                                                      ),
                                                                                    label:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        "b",
                                                                                        {
                                                                                          children:
                                                                                            t.label,
                                                                                        }
                                                                                      ),
                                                                                    checked:
                                                                                      p ===
                                                                                      t.value,
                                                                                    onChange:
                                                                                      function (
                                                                                        e
                                                                                      ) {
                                                                                        e.preventDefault(),
                                                                                          e.stopPropagation(),
                                                                                          E(
                                                                                            t.value
                                                                                          );
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                (0,
                                                                                e.jsx)(
                                                                                  ni,
                                                                                  Gy(
                                                                                    {
                                                                                      className:
                                                                                        "OrderTypeDescription",
                                                                                      variant:
                                                                                        "subtitle1",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        t.description,
                                                                                    }
                                                                                  )
                                                                                ),
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          ),
                                                          t.value
                                                        );
                                                      }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                }),
                              }
                            )
                          ),
                        }
                      )
                    ),
                    (0, e.jsxs)(
                      qa,
                      Gy(
                        {
                          item: !0,
                          xs: 12,
                          md: 12,
                          lg: 12,
                          xl: 12,
                          sx: [q, { display: { xs: "block", md: "flex" } }],
                        },
                        {
                          children: [
                            (0, e.jsx)(
                              ni,
                              Gy(
                                { variant: "subtitle1" },
                                {
                                  children: (0, e.jsx)(m_, {
                                    disabled: p === Kg,
                                    label: m(
                                      "customerInvoice_sendInvoiceToCustomer"
                                    ),
                                    control: (0, e.jsx)(tb, {
                                      checked: N,
                                      onChange: function (e) {
                                        return D(e.target.checked);
                                      },
                                    }),
                                  }),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              ni,
                              Gy(
                                { variant: "subtitle1" },
                                {
                                  children: (0, e.jsx)(m_, {
                                    label: m("applyDisconutCode_atCheckout"),
                                    control: (0, e.jsx)(tb, {
                                      checked: U,
                                      onChange: function (e) {
                                        return W(e.target.checked);
                                      },
                                    }),
                                  }),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              ni,
                              Gy(
                                { variant: "subtitle1" },
                                {
                                  children: (0, e.jsx)(
                                    Ym,
                                    Gy(
                                      {
                                        loading: s,
                                        sx: [Dv, J],
                                        variant: "contained",
                                        disabled: !d,
                                        onClick: function () {
                                          return p !== qg || R ? b(p) : c();
                                        },
                                      },
                                      {
                                        children:
                                          "" === v.msg
                                            ? m("customerInvoice_CreateBtn")
                                            : m("customerInvoice_CreatingBtn"),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsx)(
                      ni,
                      Gy(
                        {
                          variant: "body2",
                          sx: {
                            mt: 2,
                            mr: 1,
                            display: " block",
                            color: v.color,
                          },
                          align: "right",
                        },
                        { children: M() ? "" : v.msg }
                      )
                    ),
                  ],
                }
              )
            ),
            u &&
              (0, e.jsx)(I_, {
                closeModal: c,
                popUpType: "checkOutPopUp",
                openPopUp: !0,
                CallMethod: b,
              }),
            X(S, _),
            (0, e.jsx)("br", {}),
          ],
        });
      }
      var Qy = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M5 18h14v2H5zm4.6-2.7L5 10.7l2-1.9 2.6 2.6L17 4l2 2z",
          }),
          "FileDownloadDone"
        ),
        Yy = function () {
          return (
            (Yy =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Yy.apply(this, arguments)
          );
        },
        Jy = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        Xy = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        eC = function () {
          return (
            (eC =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            eC.apply(this, arguments)
          );
        };
      function tC(n) {
        var r,
          o,
          a,
          i,
          s,
          l,
          d,
          c,
          u = xv(),
          p = u.filterprovince,
          m = u.getCountriesList,
          h = (function (e) {
            var n,
              r,
              o = this,
              a = g(),
              i = ee().t,
              s = xv().getProvinceOfShopify,
              l = (0, t.useState)([]),
              d = l[0],
              c = l[1],
              u =
                (Tv(),
                {
                  customer_fname: "",
                  customer_lname: "",
                  customer_email: "",
                  customer_phoneno: 0,
                  customer_note: "",
                  customer_address: "",
                  customer_address2: "",
                  customer_city: "",
                  customer_country: "",
                  customer_state: "",
                  customer_pincode: "",
                  business_name: "",
                  cust_company_address: "",
                  cust_company_city: "",
                  cust_company_country: "",
                  cust_company_state: "",
                  cust_company_pincode: "",
                  subTotal: 0,
                  noOfOrders: 0,
                  tags: "",
                }),
              p = (0, t.useState)(!1),
              m = p[0],
              h = p[1],
              f = (0, t.useState)(u),
              v = f[0],
              b = f[1],
              _ = (0, t.useState)(!0),
              y = _[0],
              C = _[1],
              x = (0, t.useState)({
                fnameErrMsg: "",
                emailErrMsg: "",
                customerPinCodeErrMsg: "",
                companyPinCodeErrMsg: "",
              }),
              S = x[0],
              k = x[1],
              P = (0, t.useState)({
                customerStates: "in",
                companyStates: "in",
              }),
              w = P[0],
              O = P[1],
              T =
                (null === (n = null == v ? void 0 : v.customer_fname) ||
                void 0 === n
                  ? void 0
                  : n.length) > 0 &&
                (null === (r = null == v ? void 0 : v.customer_email) ||
                void 0 === r
                  ? void 0
                  : r.length) > 0 &&
                "" === S.fnameErrMsg &&
                "" === S.emailErrMsg &&
                "" === S.customerPinCodeErrMsg &&
                "" === S.companyPinCodeErrMsg,
              I = (0, t.useState)(i("submit_btn_text")),
              M = I[0],
              j = (I[1], (0, t.useState)("")),
              N = j[0],
              D = j[1],
              A = (0, t.useState)(""),
              E = A[0],
              R = A[1],
              L = (0, t.useState)(!1),
              B = L[0],
              z = L[1],
              Z = (0, t.useState)(!1),
              H = Z[0],
              V = Z[1],
              W = (0, t.useState)(
                F.getState().salesRepData.baseData
                  .hideCompanyAddressInAddCustomer
              ),
              U = W[0];
            W[1],
              Bh.subscribe(function (e) {
                e !== B && z(e);
              });
            var $ = function (e) {
                var t = e.target,
                  n = t.name,
                  r = t.value;
                b(function (e) {
                  var t,
                    o = Yy(Yy({}, e), (((t = {})[n] = r), t));
                  return (
                    (("customer_country" === n && e.customer_pincode) ||
                      ("cust_company_country" === n &&
                        e.cust_company_pincode)) &&
                      (o[
                        "customer_country" === n
                          ? "customer_pincode"
                          : "cust_company_pincode"
                      ] = ""),
                    o
                  );
                }),
                  (("customer_country" === n &&
                    (null == S ? void 0 : S.customerPinCodeErrMsg)) ||
                    ("cust_company_country" === n &&
                      (null == S ? void 0 : S.companyPinCodeErrMsg))) &&
                    k(function (e) {
                      var t;
                      return Yy(
                        Yy({}, e),
                        (((t = {})[
                          "customer_country" === n
                            ? "customerPinCodeErrMsg"
                            : "companyPinCodeErrMsg"
                        ] = ""),
                        t)
                      );
                    }),
                  K(n, r);
              },
              K = function (e, t) {
                var n,
                  r,
                  o = function (e, t) {
                    k(function (n) {
                      var r;
                      return Yy(Yy({}, n), (((r = {})[e] = t), r));
                    });
                  };
                switch (e) {
                  case "customer_fname":
                    o(
                      "fnameErrMsg",
                      "" === t ? i("addCustomer_leadEmptyErrrorMsg") : ""
                    );
                    break;
                  case "customer_email":
                    o(
                      "emailErrMsg",
                      "" === t
                        ? i("addCustomer_leadEmptyErrrorMsg")
                        : t.match(Db)
                        ? ""
                        : i("email_id_validation_errmsg")
                    );
                    break;
                  case "customer_pincode":
                    "" != t &&
                      (null == v ? void 0 : v.customer_country) &&
                      (null == w ? void 0 : w.customerStates) &&
                      o(
                        "customerPinCodeErrMsg",
                        ty(
                          t,
                          null ===
                            (n = null == w ? void 0 : w.customerStates) ||
                            void 0 === n
                            ? void 0
                            : n.toUpperCase()
                        )
                          ? ""
                          : i("Customer_Invalid_pinCode_Msg")
                      );
                    break;
                  case "cust_company_pincode":
                    "" != t &&
                      (null == v ? void 0 : v.cust_company_country) &&
                      (null == w ? void 0 : w.companyStates) &&
                      o(
                        "companyPinCodeErrMsg",
                        ty(
                          t,
                          null === (r = null == w ? void 0 : w.companyStates) ||
                            void 0 === r
                            ? void 0
                            : r.toUpperCase()
                        )
                          ? ""
                          : i("Customer_Invalid_pinCode_Msg")
                      );
                }
              },
              G = function () {
                D(""), R("");
              },
              q = function () {
                h(!m), null == e || e.closeModal();
              };
            return {
              t: i,
              addCustomerForm: v,
              isAddCustomer: y,
              setAddCustomerForm: b,
              defaultFormValues: u,
              changeValue: $,
              submitCustomerData: function () {
                return Jy(o, void 0, void 0, function () {
                  var t, n, r, o, s, l, d, c;
                  return Xy(this, function (p) {
                    switch (p.label) {
                      case 0:
                        return (
                          V(!0),
                          D(""),
                          (t = {
                            firstname: null == v ? void 0 : v.customer_fname,
                            lastname: null == v ? void 0 : v.customer_lname,
                            phoneno:
                              0 === (null == v ? void 0 : v.customer_phoneno)
                                ? ""
                                : null == v
                                ? void 0
                                : v.customer_phoneno,
                            email: null == v ? void 0 : v.customer_email,
                            note: null == v ? void 0 : v.customer_note,
                            address:
                              (null == v ? void 0 : v.customer_address) +
                              " " +
                              (null == v ? void 0 : v.customer_address2),
                            address2: null == v ? void 0 : v.customer_address2,
                            customercity: null == v ? void 0 : v.customer_city,
                            customerstate:
                              null == v ? void 0 : v.customer_state,
                            customercountry:
                              null ===
                                (r = null == v ? void 0 : v.customer_country) ||
                              void 0 === r
                                ? void 0
                                : r.split("_")[1],
                            customerpincode:
                              "" === (null == v ? void 0 : v.customer_pincode)
                                ? ""
                                : null == v
                                ? void 0
                                : v.customer_pincode,
                            companyaddress:
                              null == v ? void 0 : v.cust_company_address,
                            companycity:
                              null == v ? void 0 : v.cust_company_city,
                            companystate:
                              null == v ? void 0 : v.cust_company_state,
                            companycountry:
                              null ===
                                (o =
                                  null == v
                                    ? void 0
                                    : v.cust_company_country) || void 0 === o
                                ? void 0
                                : o.split("_")[1],
                            companypincode:
                              0 ===
                              (null == v ? void 0 : v.cust_company_pincode)
                                ? ""
                                : null == v
                                ? void 0
                                : v.cust_company_pincode,
                            CustomerCompanyName:
                              null == v ? void 0 : v.business_name,
                          }),
                          [4, a(sg(t))]
                        );
                      case 1:
                        return (
                          (n = p.sent()),
                          V(!1),
                          "Customer sucessfully tagged to a rep." !== n
                            ? [3, 3]
                            : (R(i("addCustomer_leadsuccessmsg")), [4, a(eg())])
                        );
                      case 2:
                        return (
                          p.sent(),
                          2 == (null == e ? void 0 : e.indexFrom) &&
                            (null == e ||
                              e.setCustomerArray(
                                F.getState().salesRepData.baseData.ClientOrders
                              ),
                            null == e ||
                              e.setAllCustomerCounts(
                                null !==
                                  (c =
                                    null ===
                                      (d =
                                        null ===
                                          (l =
                                            null ===
                                              (s = F.getState().salesRepData) ||
                                            void 0 === s
                                              ? void 0
                                              : s.baseData) || void 0 === l
                                          ? void 0
                                          : l.ClientOrders) || void 0 === d
                                      ? void 0
                                      : d.length) && void 0 !== c
                                  ? c
                                  : 0
                              )),
                          setTimeout(function () {
                            1 == (null == e ? void 0 : e.indexFrom) &&
                              (null == e || e.EmptyAllFieldsOnSuccess()),
                              b(u),
                              q();
                          }, 3e3),
                          [3, 4]
                        );
                      case 3:
                        D(
                          "phone Enter a valid phone number to use this delivery method" ===
                            n
                            ? i("addCustomer_ErrorMsgOnSubmitBtn")
                            : n
                        ),
                          (p.label = 4);
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              submitBtnEnabled: T,
              inputState: S,
              stateByCountry: w,
              changeCountry: function (e, t) {
                var n = e.target.value,
                  r = null == n ? void 0 : n.split("_")[0];
                c(s(r || "")),
                  ("customer_country" !== t && "cust_company_country" !== t) ||
                    O(function (e) {
                      var r;
                      return Yy(
                        Yy({}, e),
                        (((r = {})[
                          "customer_country" === t
                            ? "customerStates"
                            : "companyStates"
                        ] = n ? (null == n ? void 0 : n.split("_")[1]) : "in"),
                        r)
                      );
                    }),
                  $(e);
              },
              submitDataText: M,
              addCustomerErr: N,
              hideCompanySection: U,
              customerFullAddress: function () {
                var e;
                return null ===
                  (e = [
                    v.customer_address,
                    v.customer_address2,
                    v.customer_city,
                    v.customer_state,
                    v.customer_country,
                    v.customer_pincode,
                  ]) || void 0 === e
                  ? void 0
                  : e.filter(Boolean).join(", ");
              },
              provinceStates: d,
              addCustomerSuccess: E,
              submitLoader: H,
              setCreateCustomerModalOpen: h,
              createCustomerModalOpen: m,
              getSingleCustomerData: function (e) {
                return Jy(o, void 0, void 0, function () {
                  var t, n, r, o, i, s, l, d;
                  return Xy(this, function (c) {
                    switch (c.label) {
                      case 0:
                        return G(), C(!1), D(""), Bh.next(!0), [4, a(lg(e))];
                      case 1:
                        return (
                          (t = c.sent()),
                          h(!0),
                          (null == t ? void 0 : t.SingleClientOrders) &&
                            (Bh.next(!1),
                            (n = null == t ? void 0 : t.SingleClientOrders),
                            b({
                              customer_fname:
                                (null ===
                                  (r = null == n ? void 0 : n.ClientName) ||
                                void 0 === r
                                  ? void 0
                                  : r.split(" ")[0]) || "NA",
                              customer_lname:
                                (null ===
                                  (o = null == n ? void 0 : n.ClientName) ||
                                void 0 === o
                                  ? void 0
                                  : o.split(" ")[1]) || "NA",
                              customer_email:
                                (null == n ? void 0 : n.CustomerMailid) || "NA",
                              customer_phoneno: (null == n ? void 0 : n.phoneno)
                                ? parseInt(null == n ? void 0 : n.phoneno)
                                : 0,
                              customer_note:
                                (null == n ? void 0 : n.notes) || "NA",
                              customer_address:
                                (null == n ? void 0 : n.address1) || "NA",
                              customer_address2:
                                (null == n ? void 0 : n.address2) || "NA",
                              customer_city:
                                null !== (i = null == n ? void 0 : n.city) &&
                                void 0 !== i
                                  ? i
                                  : "",
                              customer_country:
                                null !== (s = null == n ? void 0 : n.country) &&
                                void 0 !== s
                                  ? s
                                  : "",
                              customer_state:
                                null !==
                                  (l = null == n ? void 0 : n.province) &&
                                void 0 !== l
                                  ? l
                                  : "",
                              customer_pincode:
                                null !== (d = null == n ? void 0 : n.zip) &&
                                void 0 !== d
                                  ? d
                                  : 0,
                              business_name:
                                (null == n ? void 0 : n.companyName) || "NA",
                              cust_company_address: "",
                              cust_company_city: "",
                              cust_company_country: "",
                              cust_company_state: "",
                              cust_company_pincode: 0,
                              subTotal:
                                null == n ? void 0 : n.shopifyTotalSpent,
                              noOfOrders:
                                null == n ? void 0 : n.shopifyOrdersCount,
                              tags: (null == n ? void 0 : n.tags) || "NA",
                            })),
                          [2]
                        );
                    }
                  });
                });
              },
              handleNewCustomerModal: q,
              setIsAddCustomer: C,
              removeMessages: G,
            };
          })(n),
          f = h.addCustomerForm,
          v = h.isAddCustomer,
          b = h.setAddCustomerForm,
          _ = h.defaultFormValues,
          y = h.changeValue,
          C = h.submitCustomerData,
          x = h.submitBtnEnabled,
          S = h.inputState,
          k = h.stateByCountry,
          P = h.changeCountry,
          w = h.submitDataText,
          O = h.addCustomerErr,
          T = h.hideCompanySection,
          I = h.customerFullAddress,
          M = h.provinceStates,
          j = h.addCustomerSuccess,
          N = h.submitLoader,
          D = h.t,
          A = h.setCreateCustomerModalOpen,
          E = h.createCustomerModalOpen,
          R = h.getSingleCustomerData,
          L = h.setIsAddCustomer,
          B = h.removeMessages,
          z = h.handleNewCustomerModal;
        return (
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.openPopUp) &&
                (null == n ? void 0 : n.isAddCustomer) &&
                (A(!0), L(!0), B());
            },
            [null == n ? void 0 : n.openPopUp]
          ),
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.singleCustomerId) &&
                "" !== (null == n ? void 0 : n.singleCustomerId) &&
                !(null == n ? void 0 : n.isAddCustomer) &&
                R(null == n ? void 0 : n.singleCustomerId);
            },
            [null == n ? void 0 : n.singleCustomerId]
          ),
          (0, e.jsx)(
            Hp,
            eC(
              {
                open: E,
                onClose: function () {
                  return z();
                },
                maxWidth: "md",
                fullWidth: !0,
              },
              {
                children: (0, e.jsxs)(mn, {
                  children: [
                    (0, e.jsxs)(
                      qa,
                      eC(
                        {
                          container: !0,
                          spacing: 2,
                          className: "Product_Picker_Heading",
                        },
                        {
                          children: [
                            (0, e.jsx)(
                              qa,
                              eC(
                                { item: !0, xs: 10, md: 10 },
                                {
                                  children: (0, e.jsx)(
                                    ni,
                                    eC(
                                      { variant: "h6", fontWeight: "bold" },
                                      {
                                        children: D(
                                          v
                                            ? "New_Customer_Select_Msg"
                                            : "myCustomers_table2Title"
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              qa,
                              eC(
                                {
                                  item: !0,
                                  xs: 2,
                                  md: 2,
                                  sx: { textAlign: "right" },
                                },
                                {
                                  children: (0, e.jsx)(Io, {
                                    sx: { cursor: "pointer" },
                                    onClick: function () {
                                      null == n || n.closeModal(), b(_);
                                    },
                                  }),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsx)(
                      Gp,
                      eC(
                        { sx: { padding: "20px" } },
                        {
                          children: (0, e.jsx)(
                            "form",
                            eC(
                              { className: v ? "" : "ST_MC_Disable_Form" },
                              {
                                children: (0, e.jsxs)(
                                  qa,
                                  eC(
                                    { container: !0 },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            { item: !0, xs: 12, md: 6, p: 1 },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_fname",
                                                label: D("Customer_FirstName"),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_fname.toString(),
                                                fullWidth: !0,
                                                error:
                                                  "" !==
                                                  (null == S
                                                    ? void 0
                                                    : S.fnameErrMsg),
                                                helperText:
                                                  null == S
                                                    ? void 0
                                                    : S.fnameErrMsg,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                required: !0,
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            { item: !0, xs: 12, md: 6, p: 1 },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_lname",
                                                label: D("Customer_lastName"),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_lname.toString(),
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            { item: !0, xs: 12, md: 6, p: 1 },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "email",
                                                size: "small",
                                                name: "customer_email",
                                                label: D(
                                                  "myCustomers_table2Row2"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_email.toString(),
                                                fullWidth: !0,
                                                error:
                                                  "" !==
                                                  (null == S
                                                    ? void 0
                                                    : S.emailErrMsg),
                                                helperText:
                                                  null == S
                                                    ? void 0
                                                    : S.emailErrMsg,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                required: !0,
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            { item: !0, xs: 12, md: 6, p: 1 },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "number",
                                                size: "small",
                                                onKeyDown: jb,
                                                name: "customer_phoneno",
                                                label: D("Customer_phone"),
                                                value:
                                                  0 ===
                                                  (null == f
                                                    ? void 0
                                                    : f.customer_phoneno)
                                                    ? ""
                                                    : null == f
                                                    ? void 0
                                                    : f.customer_phoneno.toString(),
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_address",
                                                label: D(
                                                  "myCustomers_table2Row3"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_address,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_address2",
                                                label: D(
                                                  "Customer_Address_Apartment"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_address2,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                multiline: !0,
                                                rows: 2,
                                                name: "customer_address",
                                                label: D(
                                                  "addCustomer_customerAddress"
                                                ),
                                                value: I(),
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                yd,
                                                eC(
                                                  {
                                                    fullWidth: !0,
                                                    size: "small",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hd, {
                                                        children:
                                                          D("Customer_Resion"),
                                                      }),
                                                      (0, e.jsx)(
                                                        Rc,
                                                        eC(
                                                          {
                                                            value:
                                                              null == f
                                                                ? void 0
                                                                : f.customer_country,
                                                            name: "customer_country",
                                                            label:
                                                              D(
                                                                "Customer_Resion"
                                                              ),
                                                            onChange: function (
                                                              e
                                                            ) {
                                                              return P(
                                                                e,
                                                                "customer_country"
                                                              );
                                                            },
                                                            MenuProps: {
                                                              PaperProps: {
                                                                sx: {
                                                                  maxHeight: 200,
                                                                },
                                                              },
                                                            },
                                                            sx: Yo,
                                                          },
                                                          {
                                                            children:
                                                              null ===
                                                                (r = m()) ||
                                                              void 0 === r
                                                                ? void 0
                                                                : r.map(
                                                                    function (
                                                                      t,
                                                                      n
                                                                    ) {
                                                                      return (0,
                                                                      e.jsx)(
                                                                        J_,
                                                                        eC(
                                                                          {
                                                                            value:
                                                                              t.name +
                                                                              "_" +
                                                                              t.code,
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.name,
                                                                          }
                                                                        ),
                                                                        n
                                                                      );
                                                                    }
                                                                  ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                yd,
                                                eC(
                                                  {
                                                    fullWidth: !0,
                                                    size: "small",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hd, {
                                                        children: D(
                                                          "addCustomer_customerState"
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Rc,
                                                        eC(
                                                          {
                                                            value:
                                                              null == f
                                                                ? void 0
                                                                : f.customer_state,
                                                            name: "customer_state",
                                                            label: D(
                                                              "addCustomer_customerState"
                                                            ),
                                                            onChange: function (
                                                              e
                                                            ) {
                                                              return y(e);
                                                            },
                                                            MenuProps: {
                                                              PaperProps: {
                                                                sx: {
                                                                  maxHeight: 200,
                                                                },
                                                              },
                                                            },
                                                            sx: Yo,
                                                          },
                                                          {
                                                            children:
                                                              "" ===
                                                              (null == f
                                                                ? void 0
                                                                : f.customer_country)
                                                                ? (0, e.jsx)(
                                                                    J_,
                                                                    {
                                                                      children:
                                                                        D(
                                                                          "myCustomer_select_customer_country"
                                                                        ),
                                                                    }
                                                                  )
                                                                : 0 ===
                                                                  (null == M
                                                                    ? void 0
                                                                    : M.length)
                                                                ? null ===
                                                                    (i = p(
                                                                      null !==
                                                                        (o = (0,
                                                                        Xg.getStates)(
                                                                          null ==
                                                                            k
                                                                            ? void 0
                                                                            : k.customerStates
                                                                        )) &&
                                                                        void 0 !==
                                                                          o
                                                                        ? o
                                                                        : [],
                                                                      null !==
                                                                        (a =
                                                                          null ==
                                                                          k
                                                                            ? void 0
                                                                            : k.customerStates) &&
                                                                        void 0 !==
                                                                          a
                                                                        ? a
                                                                        : ""
                                                                    )) ||
                                                                  void 0 === i
                                                                  ? void 0
                                                                  : i.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          J_,
                                                                          eC(
                                                                            {
                                                                              value:
                                                                                t,
                                                                            },
                                                                            {
                                                                              children:
                                                                                t,
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    )
                                                                : null == M
                                                                ? void 0
                                                                : M.map(
                                                                    function (
                                                                      t,
                                                                      n
                                                                    ) {
                                                                      return (0,
                                                                      e.jsx)(
                                                                        J_,
                                                                        eC(
                                                                          {
                                                                            value:
                                                                              t,
                                                                          },
                                                                          {
                                                                            children:
                                                                              t,
                                                                          }
                                                                        ),
                                                                        n
                                                                      );
                                                                    }
                                                                  ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_city",
                                                label: D(
                                                  "addCustomer_companyCity"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_city,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "customer_pincode",
                                                label: D("Customer_pinCode"),
                                                value:
                                                  0 ===
                                                  (null == f
                                                    ? void 0
                                                    : f.customer_pincode)
                                                    ? ""
                                                    : null == f
                                                    ? void 0
                                                    : f.customer_pincode,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                error:
                                                  "" !==
                                                  (null == S
                                                    ? void 0
                                                    : S.customerPinCodeErrMsg),
                                                helperText:
                                                  null == S
                                                    ? void 0
                                                    : S.customerPinCodeErrMsg,
                                                disabled:
                                                  "" ===
                                                  (null == f
                                                    ? void 0
                                                    : f.customer_country),
                                                title:
                                                  "" ===
                                                  (null == f
                                                    ? void 0
                                                    : f.customer_country)
                                                    ? D("Customer_Info_Title")
                                                    : "",
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "business_name",
                                                label: D(
                                                  "addCustomer_companyName"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.business_name,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "cust_company_address",
                                                label: D(
                                                  "addCustomer_companyAddress"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.cust_company_address,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                yd,
                                                eC(
                                                  {
                                                    fullWidth: !0,
                                                    size: "small",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hd, {
                                                        children: D(
                                                          "myCustomer_company_country"
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Rc,
                                                        eC(
                                                          {
                                                            sx: Yo,
                                                            value:
                                                              null == f
                                                                ? void 0
                                                                : f.cust_company_country,
                                                            name: "cust_company_country",
                                                            label:
                                                              D(
                                                                "company_country"
                                                              ),
                                                            onChange: function (
                                                              e
                                                            ) {
                                                              return P(
                                                                e,
                                                                "cust_company_country"
                                                              );
                                                            },
                                                            MenuProps: {
                                                              PaperProps: {
                                                                sx: {
                                                                  maxHeight: 200,
                                                                },
                                                              },
                                                            },
                                                          },
                                                          {
                                                            children:
                                                              null ===
                                                                (s = m()) ||
                                                              void 0 === s
                                                                ? void 0
                                                                : s.map(
                                                                    function (
                                                                      t,
                                                                      n
                                                                    ) {
                                                                      return (0,
                                                                      e.jsx)(
                                                                        J_,
                                                                        eC(
                                                                          {
                                                                            value:
                                                                              t.name +
                                                                              "_" +
                                                                              t.code,
                                                                          },
                                                                          {
                                                                            children:
                                                                              t.name,
                                                                          }
                                                                        ),
                                                                        n
                                                                      );
                                                                    }
                                                                  ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                yd,
                                                eC(
                                                  {
                                                    fullWidth: !0,
                                                    size: "small",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(hd, {
                                                        children: D(
                                                          "myCustomer_company_state"
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Rc,
                                                        eC(
                                                          {
                                                            value:
                                                              null == f
                                                                ? void 0
                                                                : f.cust_company_state,
                                                            name: "cust_company_state",
                                                            label:
                                                              D(
                                                                "company_state"
                                                              ),
                                                            onChange: function (
                                                              e
                                                            ) {
                                                              return y(e);
                                                            },
                                                            MenuProps: {
                                                              PaperProps: {
                                                                sx: {
                                                                  maxHeight: 200,
                                                                },
                                                              },
                                                            },
                                                            sx: Yo,
                                                          },
                                                          {
                                                            children:
                                                              "" ===
                                                              (null == f
                                                                ? void 0
                                                                : f.cust_company_country)
                                                                ? (0, e.jsx)(
                                                                    J_,
                                                                    {
                                                                      children:
                                                                        D(
                                                                          "myCustomer_select_company_country"
                                                                        ),
                                                                    }
                                                                  )
                                                                : 0 ===
                                                                  (null == M
                                                                    ? void 0
                                                                    : M.length)
                                                                ? null ===
                                                                    (c = p(
                                                                      null !==
                                                                        (l = (0,
                                                                        Xg.getStates)(
                                                                          null ==
                                                                            k
                                                                            ? void 0
                                                                            : k.companyStates
                                                                        )) &&
                                                                        void 0 !==
                                                                          l
                                                                        ? l
                                                                        : [],
                                                                      null !==
                                                                        (d =
                                                                          null ==
                                                                          k
                                                                            ? void 0
                                                                            : k.companyStates) &&
                                                                        void 0 !==
                                                                          d
                                                                        ? d
                                                                        : ""
                                                                    )) ||
                                                                  void 0 === c
                                                                  ? void 0
                                                                  : c.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          J_,
                                                                          eC(
                                                                            {
                                                                              value:
                                                                                t,
                                                                            },
                                                                            {
                                                                              children:
                                                                                t,
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    )
                                                                : null == M
                                                                ? void 0
                                                                : M.map(
                                                                    function (
                                                                      t,
                                                                      n
                                                                    ) {
                                                                      return (0,
                                                                      e.jsx)(
                                                                        J_,
                                                                        eC(
                                                                          {
                                                                            value:
                                                                              t,
                                                                          },
                                                                          {
                                                                            children:
                                                                              t,
                                                                          }
                                                                        ),
                                                                        n
                                                                      );
                                                                    }
                                                                  ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "cust_company_city",
                                                label: D(
                                                  "addCustomer_companyCity"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.cust_company_city,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 6,
                                              md: 6,
                                              p: 1,
                                              hidden: !v || T,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "cust_company_pincode",
                                                label: D("Customer_pinCode"),
                                                value:
                                                  0 ===
                                                  (null == f
                                                    ? void 0
                                                    : f.cust_company_pincode)
                                                    ? ""
                                                    : null == f
                                                    ? void 0
                                                    : f.cust_company_pincode,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                error:
                                                  "" !==
                                                  (null == S
                                                    ? void 0
                                                    : S.companyPinCodeErrMsg),
                                                helperText:
                                                  null == S
                                                    ? void 0
                                                    : S.companyPinCodeErrMsg,
                                                disabled:
                                                  "" ===
                                                  (null == f
                                                    ? void 0
                                                    : f.cust_company_country),
                                                title:
                                                  "" ===
                                                  (null == f
                                                    ? void 0
                                                    : f.cust_company_country)
                                                    ? D("Customer_Info_Title")
                                                    : "",
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: v ? 12 : 6,
                                              p: 1,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                multiline: !0,
                                                rows: v ? 2 : 1,
                                                name: "customer_note",
                                                label: D(
                                                  "addCustomer_content4Placeholder"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.customer_note,
                                                fullWidth: !0,
                                                onChange: function (e) {
                                                  return y(e);
                                                },
                                                disabled: !v,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "subTotal",
                                                label: D(
                                                  "myCustomers_table2Row6"
                                                ),
                                                value:
                                                  null == f
                                                    ? void 0
                                                    : f.subTotal,
                                                fullWidth: !0,
                                                disabled: !0,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          eC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              md: 6,
                                              p: 1,
                                              hidden: v,
                                            },
                                            {
                                              children: (0, e.jsx)(Hc, {
                                                type: "text",
                                                size: "small",
                                                name: "tags",
                                                label: D(
                                                  "myCustomers_table2Row8"
                                                ),
                                                value:
                                                  null == f ? void 0 : f.tags,
                                                fullWidth: !0,
                                                disabled: !0,
                                                InputProps: {
                                                  style: {
                                                    borderRadius: "10px",
                                                  },
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        }
                      )
                    ),
                    (0, e.jsx)("hr", {
                      style: {
                        border: "0.3px solid #C4C4C4",
                        boxShadow: "none",
                      },
                    }),
                    (0, e.jsxs)(
                      Jp,
                      eC(
                        { style: { justifyContent: "space-between" } },
                        {
                          children: [
                            (0, e.jsx)(
                              qa,
                              eC(
                                {
                                  pr: 4,
                                  className:
                                    "" !== O
                                      ? "ST_MC_ErrMsg"
                                      : "" != j
                                      ? "ST_MC_SuceessMsg"
                                      : "",
                                  style: { display: "block" },
                                },
                                { children: "" != j ? j : "" !== O ? O : "" }
                              )
                            ),
                            (0, e.jsx)(
                              qa,
                              eC(
                                { pr: 1 },
                                {
                                  children: v
                                    ? (0, e.jsxs)(
                                        Ym,
                                        eC(
                                          {
                                            variant: "contained",
                                            onClick: C,
                                            sx: { textTransform: "capitalize" },
                                            disabled: !x,
                                            loading: N,
                                            className: N
                                              ? "ST_MC_No_Pointer"
                                              : "ST_MC_All_Pointer",
                                          },
                                          {
                                            children: [
                                              w,
                                              (0, e.jsx)(Qy, {
                                                fontSize: "small",
                                                style: { marginLeft: "5px" },
                                              }),
                                            ],
                                          }
                                        )
                                      )
                                    : "",
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  ],
                }),
              }
            )
          )
        );
      }
      var nC = function () {
        return (
          (nC =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          nC.apply(this, arguments)
        );
      };
      function rC(t) {
        var n,
          r,
          o,
          a,
          i,
          s,
          l,
          d = uy(),
          c = d.t,
          u = d.errors,
          p = d.getCountriesList,
          m = d.checkValidation,
          h = { mt: 2, ml: 0 },
          f = { backgroundColor: "white" },
          g = {
            height: 47,
            color: "#1976D2",
            ".MuiOutlinedInput-notchedOutline": { borderColor: "#1976D2" },
          },
          v = {
            cursor: "pointer",
            transition: "color 0.3s ease",
            "&:hover": { color: "rgba(0, 0, 0, 0.26)" },
          },
          b = function (n, r, o, a, i, s) {
            var l, d, p, m;
            return (
              void 0 === i && (i = !1),
              (0, e.jsxs)(
                Hc,
                nC(
                  {
                    label: n,
                    className: "ST_CI_textfield-details ".concat(
                      i ? "select-field" : ""
                    ),
                    sx: f,
                    name: r,
                    required:
                      "address2" !== r &&
                      "companyName" !== r &&
                      "mobileNumber" !== r &&
                      "isShippingAddress" ===
                        (null == t ? void 0 : t.addressType),
                    value: o,
                    onChange: a,
                    type: "search",
                    size: "small",
                    select: i,
                    InputProps: { style: { height: 47, borderRadius: "10px" } },
                    disabled:
                      ("zipNumber" === r &&
                        "" ===
                          (null === (l = null == t ? void 0 : t.customerInfo) ||
                          void 0 === l
                            ? void 0
                            : l.selectCountry)) ||
                      ("billing_zipNumber" === r &&
                        "" ===
                          (null === (d = null == t ? void 0 : t.customerInfo) ||
                          void 0 === d
                            ? void 0
                            : d.billing_selectCountry)),
                    title:
                      ("zipNumber" === r &&
                        "" ===
                          (null === (p = null == t ? void 0 : t.customerInfo) ||
                          void 0 === p
                            ? void 0
                            : p.selectCountry)) ||
                      ("billing_zipNumber" === r &&
                        "" ===
                          (null === (m = null == t ? void 0 : t.customerInfo) ||
                          void 0 === m
                            ? void 0
                            : m.billing_selectCountry))
                        ? c("Customer_Info_Title")
                        : "",
                    error: !!u[r],
                    helperText: u[r] ? u[r] : "",
                  },
                  {
                    children: [
                      i && (0, e.jsx)(J_, nC({ value: "" }, { children: n })),
                      s &&
                        (null == s
                          ? void 0
                          : s.map(function (t, n) {
                              return (0,
                              e.jsx)(J_, nC({ value: (null == t ? void 0 : t.value) || "" }, { children: (null == t ? void 0 : t.label) || "" }), n);
                            })),
                    ],
                  }
                )
              )
            );
          },
          _ = function (e) {
            var n = t.customerInfo,
              r = t.addressType;
            return null == n ? void 0 : n[r === Yg ? e : "billing_" + e];
          },
          y = function (e) {
            return (null == t ? void 0 : t.addressType) === Yg
              ? e
              : "billing_" + e;
          };
        return (0, e.jsx)(
          Hp,
          nC(
            {
              open: null == t ? void 0 : t.openPopUp,
              onClose: function () {
                return null == t ? void 0 : t.closeModal();
              },
              maxWidth: "md",
              fullWidth: !0,
            },
            {
              children: (0, e.jsxs)(mn, {
                children: [
                  (0, e.jsxs)(
                    qa,
                    nC(
                      {
                        container: !0,
                        spacing: 2,
                        className: "Product_Picker_Heading",
                      },
                      {
                        children: [
                          (0, e.jsx)(
                            qa,
                            nC(
                              { item: !0, xs: 10, md: 10 },
                              {
                                children: (0, e.jsx)(
                                  ni,
                                  nC(
                                    { variant: "h6", fontWeight: "bold" },
                                    {
                                      children:
                                        (null == t ? void 0 : t.addressType) ===
                                        Yg
                                          ? c("Edit_Shipping_Address")
                                          : c("Edit_Billing_Address"),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            qa,
                            nC(
                              {
                                item: !0,
                                xs: 2,
                                md: 2,
                                sx: { textAlign: "right" },
                              },
                              {
                                children: (0, e.jsx)(Io, {
                                  sx: v,
                                  onClick: function () {
                                    null == t ||
                                      t.cancelAddressModalPopup(
                                        null == t ? void 0 : t.addressType
                                      );
                                  },
                                }),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Gp,
                    nC(
                      { sx: { padding: "20px" } },
                      {
                        children: (0, e.jsxs)(
                          "form",
                          nC(
                            { className: "ST_MC_Disable_Form" },
                            {
                              children: [
                                (null ===
                                  (n =
                                    null == t
                                      ? void 0
                                      : t.customerAddressOptionsData) ||
                                void 0 === n
                                  ? void 0
                                  : n.length) > 0 &&
                                  (0, e.jsx)(
                                    qa,
                                    nC(
                                      {
                                        container: !0,
                                        spacing: 2,
                                        className: "ST_CI_textfield-details",
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 3,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: (0, e.jsx)(
                                                yd,
                                                nC(
                                                  {
                                                    fullWidth: !0,
                                                    size: "small",
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      Rc,
                                                      nC(
                                                        {
                                                          variant: "outlined",
                                                          labelId:
                                                            "demo-select-small",
                                                          value: "",
                                                          sx: nC(nC({}, f), g),
                                                          inputProps: {
                                                            "aria-label":
                                                              "Without label",
                                                          },
                                                          displayEmpty: !0,
                                                          onChange: function (
                                                            e
                                                          ) {
                                                            return null == t
                                                              ? void 0
                                                              : t.handleSelectAddressDropdown(
                                                                  e,
                                                                  null == t
                                                                    ? void 0
                                                                    : t.addressType
                                                                );
                                                          },
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              J_,
                                                              nC(
                                                                {
                                                                  value: "",
                                                                  sx: {
                                                                    display:
                                                                      "none",
                                                                  },
                                                                },
                                                                {
                                                                  children: c(
                                                                    "createOrderFromCartPage_selectCustomerAddressLabelForDropDown"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            null ===
                                                              (r =
                                                                null == t
                                                                  ? void 0
                                                                  : t.customerAddressOptionsData) ||
                                                            void 0 === r
                                                              ? void 0
                                                              : r.map(function (
                                                                  t,
                                                                  n
                                                                ) {
                                                                  return (null ==
                                                                  t
                                                                    ? void 0
                                                                    : t.address1) ||
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.address2) ||
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.city) ||
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.province) ||
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.country) ||
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.zip)
                                                                    ? (0,
                                                                      e.jsxs)(
                                                                        J_,
                                                                        nC(
                                                                          {
                                                                            value:
                                                                              (null ==
                                                                              t
                                                                                ? void 0
                                                                                : t.id) ||
                                                                              "",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.address1) ||
                                                                                  "",
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.address2) &&
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    "br",
                                                                                    {}
                                                                                  ),
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.address2) ||
                                                                                  "",
                                                                                " ",
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "br",
                                                                                  {}
                                                                                ),
                                                                                " ",
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.city) ||
                                                                                  "",
                                                                                " ",
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.province) ||
                                                                                  "",
                                                                                " ",
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "br",
                                                                                  {}
                                                                                ),
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.country) ||
                                                                                  "",
                                                                                " ",
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.zip) ||
                                                                                  "",
                                                                              ],
                                                                          }
                                                                        ),
                                                                        n
                                                                      )
                                                                    : "";
                                                                }),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                (0, e.jsxs)(
                                  qa,
                                  nC(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      sx: h,
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details",
                                            },
                                            {
                                              children: b(
                                                c("Customer_FirstName"),
                                                y("firstName"),
                                                _("firstName"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("firstName"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: b(
                                                c("Customer_lastName"),
                                                y("lastName"),
                                                _("lastName"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("lastName"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  qa,
                                  nC(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      sx: h,
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details",
                                            },
                                            {
                                              children: b(
                                                c("myCustomers_table2Row3"),
                                                y("address1"),
                                                _("address1"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("address1"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: b(
                                                c("Customer_Address_Apartment"),
                                                y("address2"),
                                                _("address2"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("address2"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  qa,
                                  nC(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      sx: h,
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details",
                                            },
                                            {
                                              children: b(
                                                c("Customer_Resion"),
                                                y("selectCountry"),
                                                _("selectCountry"),
                                                function (e) {
                                                  null == t ||
                                                    t.setCustomerInfo(function (
                                                      n
                                                    ) {
                                                      return nC(
                                                        nC({}, n),
                                                        (null == t
                                                          ? void 0
                                                          : t.addressType) ===
                                                          Yg
                                                          ? {
                                                              selectCountry:
                                                                e.target.value,
                                                              zipNumber: "",
                                                            }
                                                          : {
                                                              billing_selectCountry:
                                                                e.target.value,
                                                              billing_zipNumber:
                                                                "",
                                                            }
                                                      );
                                                    }),
                                                    null == t ||
                                                      t.SearchByCountry(
                                                        e.target.value
                                                      ),
                                                    null == t ||
                                                      t.setIsEditAddress(!0);
                                                },
                                                !0,
                                                null === (o = p()) ||
                                                  void 0 === o
                                                  ? void 0
                                                  : o.map(function (e, t) {
                                                      return {
                                                        value:
                                                          (null == e
                                                            ? void 0
                                                            : e.name) || "",
                                                        label:
                                                          (null == e
                                                            ? void 0
                                                            : e.name) || "",
                                                      };
                                                    })
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: b(
                                                c("addCustomer_customerState"),
                                                y("selectCountryState"),
                                                _("selectCountryState"),
                                                function (e) {
                                                  null == t ||
                                                    t.setCustomerInfo(function (
                                                      n
                                                    ) {
                                                      return nC(
                                                        nC({}, n),
                                                        (null == t
                                                          ? void 0
                                                          : t.addressType) ===
                                                          Yg
                                                          ? {
                                                              selectCountryState:
                                                                e.target.value,
                                                            }
                                                          : {
                                                              billing_selectCountryState:
                                                                e.target.value,
                                                            }
                                                      );
                                                    }),
                                                    null == t ||
                                                      t.setIsEditAddress(!0);
                                                },
                                                !0,
                                                (null == t
                                                  ? void 0
                                                  : t.addressType) === Yg
                                                  ? null ===
                                                      (i =
                                                        null ===
                                                          (a =
                                                            null == t
                                                              ? void 0
                                                              : t.customerInfo) ||
                                                        void 0 === a
                                                          ? void 0
                                                          : a.countriesStateData) ||
                                                    void 0 === i
                                                    ? void 0
                                                    : i.map(function (e, t) {
                                                        return {
                                                          value: e || "",
                                                          label: e || "",
                                                        };
                                                      })
                                                  : null ===
                                                      (l =
                                                        null ===
                                                          (s =
                                                            null == t
                                                              ? void 0
                                                              : t.customerInfo) ||
                                                        void 0 === s
                                                          ? void 0
                                                          : s.billing_countriesStateData) ||
                                                    void 0 === l
                                                  ? void 0
                                                  : l.map(function (e, t) {
                                                      return {
                                                        value: e || "",
                                                        label: e || "",
                                                      };
                                                    })
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  qa,
                                  nC(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      sx: h,
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details",
                                            },
                                            {
                                              children: b(
                                                c("addCustomer_companyCity"),
                                                y("city"),
                                                _("city"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("city"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: b(
                                                c("Customer_pinCode"),
                                                y("zipNumber"),
                                                _("zipNumber"),
                                                function (e) {
                                                  var n, r;
                                                  null == t ||
                                                    t.setCustomerInfo(function (
                                                      n
                                                    ) {
                                                      return nC(
                                                        nC({}, n),
                                                        (null == t
                                                          ? void 0
                                                          : t.addressType) ===
                                                          Yg
                                                          ? {
                                                              zipNumber:
                                                                e.target.value,
                                                            }
                                                          : {
                                                              billing_zipNumber:
                                                                e.target.value,
                                                            }
                                                      );
                                                    }),
                                                    m(
                                                      e,
                                                      "validateOnzipNumber",
                                                      (null == t
                                                        ? void 0
                                                        : t.addressType) === Yg
                                                        ? null ===
                                                            (n =
                                                              null == t
                                                                ? void 0
                                                                : t.customerInfo) ||
                                                          void 0 === n
                                                          ? void 0
                                                          : n.selectCountryCode
                                                        : null ===
                                                            (r =
                                                              null == t
                                                                ? void 0
                                                                : t.customerInfo) ||
                                                          void 0 === r
                                                        ? void 0
                                                        : r.billing_selectCountryCode
                                                    ),
                                                    null == t ||
                                                      t.setIsEditAddress(!0);
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  qa,
                                  nC(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      sx: { ml: 0, mt: "2px" },
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details",
                                            },
                                            {
                                              children: b(
                                                c("salesDetailsHeader_Company"),
                                                y("companyName"),
                                                _("companyName"),
                                                function (e) {
                                                  return null == t
                                                    ? void 0
                                                    : t.handleManualAddressChange(
                                                        y("companyName"),
                                                        e.target.value
                                                      );
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          nC(
                                            {
                                              item: !0,
                                              md: 6,
                                              className:
                                                "ST_CI_textfield-details ST_CI_responsive-textfield",
                                            },
                                            {
                                              children: b(
                                                c("Customer_phone"),
                                                y("mobileNumber"),
                                                _("mobileNumber"),
                                                function (e) {
                                                  null == t ||
                                                    t.setCustomerInfo(function (
                                                      n
                                                    ) {
                                                      return nC(
                                                        nC({}, n),
                                                        (null == t
                                                          ? void 0
                                                          : t.addressType) ===
                                                          Yg
                                                          ? {
                                                              mobileNumber:
                                                                e.target.value,
                                                            }
                                                          : {
                                                              billing_mobileNumber:
                                                                e.target.value,
                                                            }
                                                      );
                                                    }),
                                                    m(
                                                      e,
                                                      "validateOnmobileNumber"
                                                    ),
                                                    null == t ||
                                                      t.setIsEditAddress(!0);
                                                }
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)("hr", { className: "ST_Modal_Hr_Color" }),
                  (0, e.jsxs)(
                    Jp,
                    nC(
                      { sx: { padding: "12px" } },
                      {
                        children: [
                          (0, e.jsx)(
                            Ym,
                            nC(
                              {
                                onClick: function () {
                                  null == t ||
                                    t.cancelAddressModalPopup(
                                      null == t ? void 0 : t.addressType
                                    );
                                },
                                className:
                                  "ST_Modal_Btn_BorderRadious ST_Modal_Cancel_Btn_BorderColor",
                                variant: "outlined",
                              },
                              { children: "Cancel" }
                            )
                          ),
                          (0, e.jsx)(
                            Ym,
                            nC(
                              {
                                disabled: !(null == t
                                  ? void 0
                                  : t.isEditAddress),
                                onClick: function () {
                                  null == t || t.closeModal();
                                },
                                className: "ST_Modal_Btn_BorderRadious",
                                variant: "contained",
                              },
                              { children: "Save" }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                ],
              }),
            }
          )
        );
      }
      var oC = function () {
          return (
            (oC =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            oC.apply(this, arguments)
          );
        },
        aC = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function iC() {
        var n,
          r = uy(),
          o = r.t,
          a = r.customerInfo,
          i = r.salesRepData,
          s = r.setAddShippingAddressBtn,
          l = r.errors,
          d = r.EmptyFields,
          c = r.SearchByCustomer,
          u = r.SearchByCountry,
          p = r.checkValidation,
          m = r.customerAddressOptionsData,
          h = r.setCustomerAddressOptionsData,
          f = r.editOrderReduxData,
          g = r.handleCustomerChange,
          v = r.setCustomerInfo,
          b = r.handleManualAddressChange,
          _ = r.EmptyAllFieldsOnSuccess,
          y = r.orderCreatedSuccesfullyFlag,
          C = r.setOrderCreatedSuccesfullyFlag,
          x = r.handleUpdateReduxState,
          S = r.customerDefaultAddress,
          k = r.addressType,
          P = r.handleNewCustomerModal,
          w = r.handleMenuAction,
          O = r.newCustomerModal,
          T = r.addressModal,
          I = r.handleAddressModal,
          M = r.isEditAddress,
          j = r.cancelAddressModal,
          N = r.handleSelectAddress,
          D = r.handleAutoCountryStateSet,
          E = r.setIsEditAddress,
          R = r.manageMenuItems,
          L = r.getCustomerAddressData,
          B = r.isCustomerSelected,
          z = r.setIsCustomerSelected,
          Z = { backgroundColor: "white" },
          H = {
            customerInfo: a,
            setCustomerInfo: v,
            email_validation: l.email,
            mobile_validation: l.mobileNumber,
            zip_validation: l.zipNumber,
            customerAddressesList: m,
            setCustomerAddressOptionsData: h,
            EmptyAllFieldsOnSuccess: _,
            SearchByCustomer: c,
            handleAutoCountryStateSet: D,
            setIsCustomerSelected: z,
          },
          V = {
            customerInfo: a,
            setAddShippingAddressBtn: s,
            orderCreatedSuccesfullyFlag: y,
          };
        (0, t.useEffect)(
          function () {
            var e,
              t,
              n =
                null !==
                  (t =
                    null === (e = F.getState().salesRepData) || void 0 === e
                      ? void 0
                      : e.createOrderTab) && void 0 !== t
                  ? t
                  : {};
            x(
              oC(oC({}, n), { customerName: a.customerName }),
              A.CREATE_ORDER_TAB
            );
          },
          [
            a.customerName,
            null == a ? void 0 : a.emailId,
            null == a ? void 0 : a.mobileNumber,
          ]
        );
        var W = wv("(max-width:767px)");
        return (0, e.jsxs)(
          mn,
          oC(
            { className: "ST_Main_Card " },
            {
              children: [
                (0, e.jsxs)(
                  qa,
                  oC(
                    { sx: $o },
                    {
                      children: [
                        (0, e.jsx)(
                          ni,
                          oC(
                            { variant: Av, sx: Ko },
                            { children: o("customerInvoice_title") }
                          )
                        ),
                        (0, e.jsx)("hr", {
                          className: "ST_CI_Horizontal_Line",
                        }),
                      ],
                    }
                  )
                ),
                (0, e.jsxs)(
                  mn,
                  oC(
                    { sx: Jo },
                    {
                      children: [
                        (0, e.jsx)(
                          ni,
                          oC(
                            { sx: { marginBottom: "10px" }, variant: "h6" },
                            { children: o("customer") }
                          )
                        ),
                        (0, e.jsxs)(
                          qa,
                          oC(
                            {
                              container: !0,
                              spacing: 2,
                              ml: 0,
                              className: "ST_CI_textfield-details",
                            },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  oC(
                                    {
                                      item: !0,
                                      md: 3,
                                      className: "ST_CI_textfield-details",
                                    },
                                    {
                                      children: (0, e.jsx)(ju, {
                                        disabled:
                                          (null == f
                                            ? void 0
                                            : f.actionEvent) === Zg || B,
                                        value:
                                          null == a ? void 0 : a.customerName,
                                        id: "searchByCustomerName",
                                        freeSolo: !0,
                                        inputValue:
                                          null !==
                                            (n =
                                              null == a
                                                ? void 0
                                                : a.customerName) &&
                                          void 0 !== n
                                            ? n
                                            : "",
                                        onChange: function (e, t) {
                                          return g(e, t);
                                        },
                                        getOptionLabel: function (e) {
                                          return "string" == typeof e
                                            ? e
                                            : e.CustomerName ||
                                                e.CustomerMailid;
                                        },
                                        onInputChange: function (e, t) {
                                          v(function (e) {
                                            return oC(oC({}, e), {
                                              customerName: t,
                                            });
                                          }),
                                            ("" === t &&
                                              "" ===
                                                (null == a
                                                  ? void 0
                                                  : a.customerName)) ||
                                              d();
                                        },
                                        options: aC(
                                          [
                                            {
                                              isAction: !0,
                                              label: o(
                                                "New_Customer_Select_Msg"
                                              ),
                                            },
                                          ],
                                          i.baseData.repcustomers || [],
                                          !0
                                        ),
                                        renderOption: function (n, r) {
                                          var o;
                                          return r.isAction
                                            ? (0, e.jsxs)(
                                                J_,
                                                oC(
                                                  {},
                                                  n,
                                                  {
                                                    onClick: function () {
                                                      return P();
                                                    },
                                                    className:
                                                      "ST_CI_Select_Customer_Font",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(X_, {
                                                        sx: { marginRight: 1 },
                                                      }),
                                                      r.label,
                                                    ],
                                                  }
                                                )
                                              )
                                            : (0, t.createElement)(
                                                mn,
                                                oC({ component: "li" }, n, {
                                                  key: r.CustomerId || "",
                                                }),
                                                (null !==
                                                  (o = r.CustomerName) &&
                                                void 0 !== o
                                                  ? o
                                                  : ""
                                                ).trim()
                                                  ? r.CustomerName
                                                  : r.CustomerMailid
                                              );
                                        },
                                        renderInput: function (t) {
                                          return (0, e.jsx)(
                                            Hc,
                                            oC(
                                              {
                                                required: !0,
                                                className:
                                                  "ST_CI_textfield-details",
                                                sx: Z,
                                              },
                                              t,
                                              {
                                                label:
                                                  "Search or create a customer",
                                                InputProps: oC(
                                                  oC({}, t.InputProps),
                                                  {
                                                    style: {
                                                      height: 47,
                                                      paddingRight: 5,
                                                    },
                                                  }
                                                ),
                                                name: "customername",
                                                onChange: function (e) {
                                                  return p(
                                                    e,
                                                    "validateOnstring"
                                                  );
                                                },
                                                type: "text",
                                                error: l.customername,
                                              },
                                              l.customername && {
                                                error: !0,
                                                helperText: l.customername,
                                              }
                                            )
                                          );
                                        },
                                        size: "small",
                                      }),
                                    }
                                  )
                                ),
                                (null == a ? void 0 : a.emailId)
                                  ? (0, e.jsx)(
                                      qa,
                                      oC(
                                        {
                                          item: !0,
                                          md: 2,
                                          className:
                                            "ST_CI_textfield-details ST_CI_responsive-textfield",
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            yd,
                                            oC(
                                              { fullWidth: !0, size: "small" },
                                              {
                                                children: (0, e.jsxs)(
                                                  Rc,
                                                  oC(
                                                    {
                                                      labelId:
                                                        "demo-select-small",
                                                      value: "",
                                                      sx: oC(oC({}, Z), {
                                                        height: 47,
                                                      }),
                                                      inputProps: {
                                                        "aria-label":
                                                          "Without label",
                                                      },
                                                      displayEmpty: !0,
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          J_,
                                                          oC(
                                                            {
                                                              value: "",
                                                              sx: {
                                                                display: "none",
                                                              },
                                                            },
                                                            {
                                                              children: o(
                                                                "CreateOrder_Manage_Heading"
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        null == R
                                                          ? void 0
                                                          : R.map(function (
                                                              t,
                                                              n
                                                            ) {
                                                              return (0, e.jsx)(
                                                                J_,
                                                                oC(
                                                                  {
                                                                    onClick:
                                                                      function () {
                                                                        return w(
                                                                          t.action
                                                                        );
                                                                      },
                                                                    sx: t.sx,
                                                                  },
                                                                  {
                                                                    children:
                                                                      t.label,
                                                                  }
                                                                ),
                                                                n
                                                              );
                                                            }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    )
                                  : "",
                              ],
                            }
                          )
                        ),
                        (null == a ? void 0 : a.emailId)
                          ? (0, e.jsxs)(
                              qa,
                              oC(
                                {
                                  container: !0,
                                  spacing: 2,
                                  sx: { marginTop: "20px" },
                                },
                                {
                                  children: [
                                    (0, e.jsxs)(
                                      qa,
                                      oC(
                                        {
                                          item: !0,
                                          md: 3,
                                          className:
                                            "ST_CI_CustomerDetails_Padding",
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              ni,
                                              oC(
                                                {
                                                  variant: "subtitle1",
                                                  fontWeight: "bold",
                                                },
                                                {
                                                  children: o(
                                                    "addCustomer_content3"
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              ni,
                                              oC(
                                                { variant: "body1" },
                                                {
                                                  children:
                                                    null == a
                                                      ? void 0
                                                      : a.emailId,
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                    W
                                      ? (0, e.jsx)(
                                          qa,
                                          oC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              sm: 12,
                                              sx: { marginBottom: "10px" },
                                            },
                                            {
                                              children: (0, e.jsx)(Gt, {
                                                orientation: "horizontal",
                                                flexItem: !0,
                                                sx: {
                                                  border: "0.5px solid #D4D4D4",
                                                },
                                              }),
                                            }
                                          )
                                        )
                                      : (0, e.jsx)(Gt, {
                                          orientation: "vertical",
                                          flexItem: !0,
                                          className: "ST_CI_HR_Margin",
                                        }),
                                    (0, e.jsxs)(
                                      qa,
                                      oC(
                                        {
                                          item: !0,
                                          md: 3,
                                          className:
                                            "ST_CI_CustomerDetails_Padding",
                                          sx: {
                                            display: "inline-grid",
                                            justifyContent: "space-around",
                                          },
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              ni,
                                              oC(
                                                {
                                                  variant: "subtitle1",
                                                  fontWeight: "bold",
                                                },
                                                {
                                                  children: o(
                                                    "b2b_ShippingAddress"
                                                  ),
                                                }
                                              )
                                            ),
                                            L("isShippingAddress"),
                                          ],
                                        }
                                      )
                                    ),
                                    W
                                      ? (0, e.jsx)(
                                          qa,
                                          oC(
                                            {
                                              item: !0,
                                              xs: 12,
                                              sm: 12,
                                              sx: { marginBottom: "10px" },
                                            },
                                            {
                                              children: (0, e.jsx)(Gt, {
                                                orientation: "horizontal",
                                                flexItem: !0,
                                                sx: {
                                                  border: "0.5px solid #D4D4D4",
                                                },
                                              }),
                                            }
                                          )
                                        )
                                      : (0, e.jsx)(Gt, {
                                          orientation: "vertical",
                                          flexItem: !0,
                                          className: "ST_CI_HR_Margin",
                                        }),
                                    (0, e.jsxs)(
                                      qa,
                                      oC(
                                        {
                                          item: !0,
                                          md: 3,
                                          className:
                                            "ST_CI_CustomerDetails_Padding",
                                          sx: {
                                            display: "inline-grid",
                                            justifyContent: "space-around",
                                          },
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              ni,
                                              oC(
                                                {
                                                  variant: "subtitle1",
                                                  fontWeight: "bold",
                                                },
                                                {
                                                  children:
                                                    o("b2b_BillingAddress"),
                                                }
                                              )
                                            ),
                                            L("isBillingAddress"),
                                          ],
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            )
                          : "",
                      ],
                    }
                  )
                ),
                (0, e.jsx)("br", {}),
                O &&
                  (0, e.jsx)(tC, {
                    indexFrom: 1,
                    openPopUp: O,
                    closeModal: P,
                    isAddCustomer: !0,
                    EmptyAllFieldsOnSuccess: _,
                  }),
                T &&
                  (0, e.jsx)(rC, {
                    openPopUp: T,
                    closeModal: I,
                    customerAddressOptionsData: m,
                    addressType: k,
                    customerDefaultAddress: S,
                    customerInfo: a,
                    setCustomerInfo: v,
                    handleManualAddressChange: b,
                    isEditAddress: M,
                    cancelAddressModalPopup: j,
                    handleSelectAddressDropdown: N,
                    SearchByCountry: u,
                    setIsEditAddress: E,
                  }),
                (0, e.jsx)(ky, oC({}, V)),
                (0, e.jsx)(
                  qy,
                  oC({}, H, {
                    orderCreatedSuccesfullyFlag: y,
                    setOrderCreatedSuccesfullyFlag: C,
                  })
                ),
              ],
            }
          )
        );
      }
      function sC(e) {
        return (0, Zt.ZP)("MuiCardContent", e);
      }
      (0, Ft.Z)("MuiCardContent", ["root"]);
      const lC = ["className", "component"],
        dC = (0, Bt.ZP)("div", {
          name: "MuiCardContent",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(() => ({ padding: 16, "&:last-child": { paddingBottom: 24 } }));
      var cC = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiCardContent" }),
            { className: o, component: a = "div" } = r,
            i = (0, At.Z)(r, lC),
            s = (0, u.Z)({}, r, { component: a }),
            l = ((e) => {
              const { classes: t } = e;
              return (0, Rt.Z)({ root: ["root"] }, sC, t);
            })(s);
          return (0,
          e.jsx)(dC, (0, u.Z)({ as: a, className: (0, Et.Z)(l.root, o), ownerState: s, ref: n }, i));
        }),
        uC = sn({
          defaultClassName: (0, Ft.Z)("MuiBox", ["root"]).root,
          generateClassName: ln.Z.generate,
        });
      function pC() {}
      const mC = (function () {
        let e = 0;
        return function () {
          return e++;
        };
      })();
      function hC(e) {
        return null == e;
      }
      function fC(e) {
        if (Array.isArray && Array.isArray(e)) return !0;
        const t = Object.prototype.toString.call(e);
        return "[object" === t.slice(0, 7) && "Array]" === t.slice(-6);
      }
      function gC(e) {
        return (
          null !== e && "[object Object]" === Object.prototype.toString.call(e)
        );
      }
      const vC = (e) =>
        ("number" == typeof e || e instanceof Number) && isFinite(+e);
      function bC(e, t) {
        return vC(e) ? e : t;
      }
      function _C(e, t) {
        return void 0 === e ? t : e;
      }
      const yC = (e, t) =>
        "string" == typeof e && e.endsWith("%")
          ? (parseFloat(e) / 100) * t
          : +e;
      function CC(e, t, n) {
        if (e && "function" == typeof e.call) return e.apply(n, t);
      }
      function xC(e, t, n, r) {
        let o, a, i;
        if (fC(e))
          if (((a = e.length), r))
            for (o = a - 1; o >= 0; o--) t.call(n, e[o], o);
          else for (o = 0; o < a; o++) t.call(n, e[o], o);
        else if (gC(e))
          for (i = Object.keys(e), a = i.length, o = 0; o < a; o++)
            t.call(n, e[i[o]], i[o]);
      }
      function SC(e, t) {
        let n, r, o, a;
        if (!e || !t || e.length !== t.length) return !1;
        for (n = 0, r = e.length; n < r; ++n)
          if (
            ((o = e[n]),
            (a = t[n]),
            o.datasetIndex !== a.datasetIndex || o.index !== a.index)
          )
            return !1;
        return !0;
      }
      function kC(e) {
        if (fC(e)) return e.map(kC);
        if (gC(e)) {
          const t = Object.create(null),
            n = Object.keys(e),
            r = n.length;
          let o = 0;
          for (; o < r; ++o) t[n[o]] = kC(e[n[o]]);
          return t;
        }
        return e;
      }
      function PC(e) {
        return -1 === ["__proto__", "prototype", "constructor"].indexOf(e);
      }
      function wC(e, t, n, r) {
        if (!PC(e)) return;
        const o = t[e],
          a = n[e];
        gC(o) && gC(a) ? OC(o, a, r) : (t[e] = kC(a));
      }
      function OC(e, t, n) {
        const r = fC(t) ? t : [t],
          o = r.length;
        if (!gC(e)) return e;
        const a = (n = n || {}).merger || wC;
        for (let i = 0; i < o; ++i) {
          if (!gC((t = r[i]))) continue;
          const o = Object.keys(t);
          for (let r = 0, i = o.length; r < i; ++r) a(o[r], e, t, n);
        }
        return e;
      }
      function TC(e, t) {
        return OC(e, t, { merger: IC });
      }
      function IC(e, t, n) {
        if (!PC(e)) return;
        const r = t[e],
          o = n[e];
        gC(r) && gC(o)
          ? TC(r, o)
          : Object.prototype.hasOwnProperty.call(t, e) || (t[e] = kC(o));
      }
      const MC = { "": (e) => e, x: (e) => e.x, y: (e) => e.y };
      function jC(e, t) {
        const n =
          MC[t] ||
          (MC[t] = (function (e) {
            const t = (function (e) {
              const t = e.split("."),
                n = [];
              let r = "";
              for (const e of t)
                (r += e),
                  r.endsWith("\\")
                    ? (r = r.slice(0, -1) + ".")
                    : (n.push(r), (r = ""));
              return n;
            })(e);
            return (e) => {
              for (const n of t) {
                if ("" === n) break;
                e = e && e[n];
              }
              return e;
            };
          })(t));
        return n(e);
      }
      function NC(e) {
        return e.charAt(0).toUpperCase() + e.slice(1);
      }
      const DC = (e) => void 0 !== e,
        AC = (e) => "function" == typeof e,
        EC = (e, t) => {
          if (e.size !== t.size) return !1;
          for (const n of e) if (!t.has(n)) return !1;
          return !0;
        },
        RC = Math.PI,
        LC = 2 * RC,
        BC = LC + RC,
        zC = Number.POSITIVE_INFINITY,
        FC = RC / 180,
        ZC = RC / 2,
        HC = RC / 4,
        VC = (2 * RC) / 3,
        WC = Math.log10,
        UC = Math.sign;
      function $C(e) {
        const t = Math.round(e);
        e = GC(e, t, e / 1e3) ? t : e;
        const n = Math.pow(10, Math.floor(WC(e))),
          r = e / n;
        return (r <= 1 ? 1 : r <= 2 ? 2 : r <= 5 ? 5 : 10) * n;
      }
      function KC(e) {
        return !isNaN(parseFloat(e)) && isFinite(e);
      }
      function GC(e, t, n) {
        return Math.abs(e - t) < n;
      }
      function qC(e, t, n) {
        let r, o, a;
        for (r = 0, o = e.length; r < o; r++)
          (a = e[r][n]),
            isNaN(a) ||
              ((t.min = Math.min(t.min, a)), (t.max = Math.max(t.max, a)));
      }
      function QC(e) {
        return e * (RC / 180);
      }
      function YC(e) {
        return e * (180 / RC);
      }
      function JC(e) {
        if (!vC(e)) return;
        let t = 1,
          n = 0;
        for (; Math.round(e * t) / t !== e; ) (t *= 10), n++;
        return n;
      }
      function XC(e, t) {
        const n = t.x - e.x,
          r = t.y - e.y,
          o = Math.sqrt(n * n + r * r);
        let a = Math.atan2(r, n);
        return a < -0.5 * RC && (a += LC), { angle: a, distance: o };
      }
      function ex(e, t) {
        return Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2));
      }
      function tx(e, t) {
        return ((e - t + BC) % LC) - RC;
      }
      function nx(e) {
        return ((e % LC) + LC) % LC;
      }
      function rx(e, t, n, r) {
        const o = nx(e),
          a = nx(t),
          i = nx(n),
          s = nx(a - o),
          l = nx(i - o),
          d = nx(o - a),
          c = nx(o - i);
        return o === a || o === i || (r && a === i) || (s > l && d < c);
      }
      function ox(e, t, n) {
        return Math.max(t, Math.min(n, e));
      }
      function ax(e, t, n, r = 1e-6) {
        return e >= Math.min(t, n) - r && e <= Math.max(t, n) + r;
      }
      function ix(e, t, n) {
        n = n || ((n) => e[n] < t);
        let r,
          o = e.length - 1,
          a = 0;
        for (; o - a > 1; ) (r = (a + o) >> 1), n(r) ? (a = r) : (o = r);
        return { lo: a, hi: o };
      }
      const sx = (e, t, n, r) =>
          ix(e, n, r ? (r) => e[r][t] <= n : (r) => e[r][t] < n),
        lx = (e, t, n) => ix(e, n, (r) => e[r][t] >= n),
        dx = ["push", "pop", "shift", "splice", "unshift"];
      function cx(e, t) {
        const n = e._chartjs;
        if (!n) return;
        const r = n.listeners,
          o = r.indexOf(t);
        -1 !== o && r.splice(o, 1),
          r.length > 0 ||
            (dx.forEach((t) => {
              delete e[t];
            }),
            delete e._chartjs);
      }
      function ux(e) {
        const t = new Set();
        let n, r;
        for (n = 0, r = e.length; n < r; ++n) t.add(e[n]);
        return t.size === r ? e : Array.from(t);
      }
      const px =
        "undefined" == typeof window
          ? function (e) {
              return e();
            }
          : window.requestAnimationFrame;
      function mx(e, t, n) {
        const r = n || ((e) => Array.prototype.slice.call(e));
        let o = !1,
          a = [];
        return function (...n) {
          (a = r(n)),
            o ||
              ((o = !0),
              px.call(window, () => {
                (o = !1), e.apply(t, a);
              }));
        };
      }
      const hx = (e) =>
          "start" === e ? "left" : "end" === e ? "right" : "center",
        fx = (e, t, n) => ("start" === e ? t : "end" === e ? n : (t + n) / 2);
      function gx(e, t, n) {
        const r = t.length;
        let o = 0,
          a = r;
        if (e._sorted) {
          const { iScale: i, _parsed: s } = e,
            l = i.axis,
            {
              min: d,
              max: c,
              minDefined: u,
              maxDefined: p,
            } = i.getUserBounds();
          u &&
            (o = ox(
              Math.min(
                sx(s, i.axis, d).lo,
                n ? r : sx(t, l, i.getPixelForValue(d)).lo
              ),
              0,
              r - 1
            )),
            (a = p
              ? ox(
                  Math.max(
                    sx(s, i.axis, c, !0).hi + 1,
                    n ? 0 : sx(t, l, i.getPixelForValue(c), !0).hi + 1
                  ),
                  o,
                  r
                ) - o
              : r - o);
        }
        return { start: o, count: a };
      }
      function vx(e) {
        const { xScale: t, yScale: n, _scaleRanges: r } = e,
          o = { xmin: t.min, xmax: t.max, ymin: n.min, ymax: n.max };
        if (!r) return (e._scaleRanges = o), !0;
        const a =
          r.xmin !== t.min ||
          r.xmax !== t.max ||
          r.ymin !== n.min ||
          r.ymax !== n.max;
        return Object.assign(r, o), a;
      }
      const bx = (e) => 0 === e || 1 === e,
        _x = (e, t, n) =>
          -Math.pow(2, 10 * (e -= 1)) * Math.sin(((e - t) * LC) / n),
        yx = (e, t, n) =>
          Math.pow(2, -10 * e) * Math.sin(((e - t) * LC) / n) + 1,
        Cx = {
          linear: (e) => e,
          easeInQuad: (e) => e * e,
          easeOutQuad: (e) => -e * (e - 2),
          easeInOutQuad: (e) =>
            (e /= 0.5) < 1 ? 0.5 * e * e : -0.5 * (--e * (e - 2) - 1),
          easeInCubic: (e) => e * e * e,
          easeOutCubic: (e) => (e -= 1) * e * e + 1,
          easeInOutCubic: (e) =>
            (e /= 0.5) < 1 ? 0.5 * e * e * e : 0.5 * ((e -= 2) * e * e + 2),
          easeInQuart: (e) => e * e * e * e,
          easeOutQuart: (e) => -((e -= 1) * e * e * e - 1),
          easeInOutQuart: (e) =>
            (e /= 0.5) < 1
              ? 0.5 * e * e * e * e
              : -0.5 * ((e -= 2) * e * e * e - 2),
          easeInQuint: (e) => e * e * e * e * e,
          easeOutQuint: (e) => (e -= 1) * e * e * e * e + 1,
          easeInOutQuint: (e) =>
            (e /= 0.5) < 1
              ? 0.5 * e * e * e * e * e
              : 0.5 * ((e -= 2) * e * e * e * e + 2),
          easeInSine: (e) => 1 - Math.cos(e * ZC),
          easeOutSine: (e) => Math.sin(e * ZC),
          easeInOutSine: (e) => -0.5 * (Math.cos(RC * e) - 1),
          easeInExpo: (e) => (0 === e ? 0 : Math.pow(2, 10 * (e - 1))),
          easeOutExpo: (e) => (1 === e ? 1 : 1 - Math.pow(2, -10 * e)),
          easeInOutExpo: (e) =>
            bx(e)
              ? e
              : e < 0.5
              ? 0.5 * Math.pow(2, 10 * (2 * e - 1))
              : 0.5 * (2 - Math.pow(2, -10 * (2 * e - 1))),
          easeInCirc: (e) => (e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1)),
          easeOutCirc: (e) => Math.sqrt(1 - (e -= 1) * e),
          easeInOutCirc: (e) =>
            (e /= 0.5) < 1
              ? -0.5 * (Math.sqrt(1 - e * e) - 1)
              : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1),
          easeInElastic: (e) => (bx(e) ? e : _x(e, 0.075, 0.3)),
          easeOutElastic: (e) => (bx(e) ? e : yx(e, 0.075, 0.3)),
          easeInOutElastic(e) {
            const t = 0.1125;
            return bx(e)
              ? e
              : e < 0.5
              ? 0.5 * _x(2 * e, t, 0.45)
              : 0.5 + 0.5 * yx(2 * e - 1, t, 0.45);
          },
          easeInBack(e) {
            const t = 1.70158;
            return e * e * ((t + 1) * e - t);
          },
          easeOutBack(e) {
            const t = 1.70158;
            return (e -= 1) * e * ((t + 1) * e + t) + 1;
          },
          easeInOutBack(e) {
            let t = 1.70158;
            return (e /= 0.5) < 1
              ? e * e * ((1 + (t *= 1.525)) * e - t) * 0.5
              : 0.5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
          },
          easeInBounce: (e) => 1 - Cx.easeOutBounce(1 - e),
          easeOutBounce(e) {
            const t = 7.5625,
              n = 2.75;
            return e < 1 / n
              ? t * e * e
              : e < 2 / n
              ? t * (e -= 1.5 / n) * e + 0.75
              : e < 2.5 / n
              ? t * (e -= 2.25 / n) * e + 0.9375
              : t * (e -= 2.625 / n) * e + 0.984375;
          },
          easeInOutBounce: (e) =>
            e < 0.5
              ? 0.5 * Cx.easeInBounce(2 * e)
              : 0.5 * Cx.easeOutBounce(2 * e - 1) + 0.5,
        };
      function xx(e) {
        return (e + 0.5) | 0;
      }
      const Sx = (e, t, n) => Math.max(Math.min(e, n), t);
      function kx(e) {
        return Sx(xx(2.55 * e), 0, 255);
      }
      function Px(e) {
        return Sx(xx(255 * e), 0, 255);
      }
      function wx(e) {
        return Sx(xx(e / 2.55) / 100, 0, 1);
      }
      function Ox(e) {
        return Sx(xx(100 * e), 0, 100);
      }
      const Tx = {
          0: 0,
          1: 1,
          2: 2,
          3: 3,
          4: 4,
          5: 5,
          6: 6,
          7: 7,
          8: 8,
          9: 9,
          A: 10,
          B: 11,
          C: 12,
          D: 13,
          E: 14,
          F: 15,
          a: 10,
          b: 11,
          c: 12,
          d: 13,
          e: 14,
          f: 15,
        },
        Ix = [..."0123456789ABCDEF"],
        Mx = (e) => Ix[15 & e],
        jx = (e) => Ix[(240 & e) >> 4] + Ix[15 & e],
        Nx = (e) => (240 & e) >> 4 == (15 & e);
      const Dx =
        /^(hsla?|hwb|hsv)\(\s*([-+.e\d]+)(?:deg)?[\s,]+([-+.e\d]+)%[\s,]+([-+.e\d]+)%(?:[\s,]+([-+.e\d]+)(%)?)?\s*\)$/;
      function Ax(e, t, n) {
        const r = t * Math.min(n, 1 - n),
          o = (t, o = (t + e / 30) % 12) =>
            n - r * Math.max(Math.min(o - 3, 9 - o, 1), -1);
        return [o(0), o(8), o(4)];
      }
      function Ex(e, t, n) {
        const r = (r, o = (r + e / 60) % 6) =>
          n - n * t * Math.max(Math.min(o, 4 - o, 1), 0);
        return [r(5), r(3), r(1)];
      }
      function Rx(e, t, n) {
        const r = Ax(e, 1, 0.5);
        let o;
        for (
          t + n > 1 && ((o = 1 / (t + n)), (t *= o), (n *= o)), o = 0;
          o < 3;
          o++
        )
          (r[o] *= 1 - t - n), (r[o] += t);
        return r;
      }
      function Lx(e) {
        const t = e.r / 255,
          n = e.g / 255,
          r = e.b / 255,
          o = Math.max(t, n, r),
          a = Math.min(t, n, r),
          i = (o + a) / 2;
        let s, l, d;
        return (
          o !== a &&
            ((d = o - a),
            (l = i > 0.5 ? d / (2 - o - a) : d / (o + a)),
            (s = (function (e, t, n, r, o) {
              return e === o
                ? (t - n) / r + (t < n ? 6 : 0)
                : t === o
                ? (n - e) / r + 2
                : (e - t) / r + 4;
            })(t, n, r, d, o)),
            (s = 60 * s + 0.5)),
          [0 | s, l || 0, i]
        );
      }
      function Bx(e, t, n, r) {
        return (Array.isArray(t) ? e(t[0], t[1], t[2]) : e(t, n, r)).map(Px);
      }
      function zx(e, t, n) {
        return Bx(Ax, e, t, n);
      }
      function Fx(e) {
        return ((e % 360) + 360) % 360;
      }
      const Zx = {
          x: "dark",
          Z: "light",
          Y: "re",
          X: "blu",
          W: "gr",
          V: "medium",
          U: "slate",
          A: "ee",
          T: "ol",
          S: "or",
          B: "ra",
          C: "lateg",
          D: "ights",
          R: "in",
          Q: "turquois",
          E: "hi",
          P: "ro",
          O: "al",
          N: "le",
          M: "de",
          L: "yello",
          F: "en",
          K: "ch",
          G: "arks",
          H: "ea",
          I: "ightg",
          J: "wh",
        },
        Hx = {
          OiceXe: "f0f8ff",
          antiquewEte: "faebd7",
          aqua: "ffff",
          aquamarRe: "7fffd4",
          azuY: "f0ffff",
          beige: "f5f5dc",
          bisque: "ffe4c4",
          black: "0",
          blanKedOmond: "ffebcd",
          Xe: "ff",
          XeviTet: "8a2be2",
          bPwn: "a52a2a",
          burlywood: "deb887",
          caMtXe: "5f9ea0",
          KartYuse: "7fff00",
          KocTate: "d2691e",
          cSO: "ff7f50",
          cSnflowerXe: "6495ed",
          cSnsilk: "fff8dc",
          crimson: "dc143c",
          cyan: "ffff",
          xXe: "8b",
          xcyan: "8b8b",
          xgTMnPd: "b8860b",
          xWay: "a9a9a9",
          xgYF: "6400",
          xgYy: "a9a9a9",
          xkhaki: "bdb76b",
          xmagFta: "8b008b",
          xTivegYF: "556b2f",
          xSange: "ff8c00",
          xScEd: "9932cc",
          xYd: "8b0000",
          xsOmon: "e9967a",
          xsHgYF: "8fbc8f",
          xUXe: "483d8b",
          xUWay: "2f4f4f",
          xUgYy: "2f4f4f",
          xQe: "ced1",
          xviTet: "9400d3",
          dAppRk: "ff1493",
          dApskyXe: "bfff",
          dimWay: "696969",
          dimgYy: "696969",
          dodgerXe: "1e90ff",
          fiYbrick: "b22222",
          flSOwEte: "fffaf0",
          foYstWAn: "228b22",
          fuKsia: "ff00ff",
          gaRsbSo: "dcdcdc",
          ghostwEte: "f8f8ff",
          gTd: "ffd700",
          gTMnPd: "daa520",
          Way: "808080",
          gYF: "8000",
          gYFLw: "adff2f",
          gYy: "808080",
          honeyMw: "f0fff0",
          hotpRk: "ff69b4",
          RdianYd: "cd5c5c",
          Rdigo: "4b0082",
          ivSy: "fffff0",
          khaki: "f0e68c",
          lavFMr: "e6e6fa",
          lavFMrXsh: "fff0f5",
          lawngYF: "7cfc00",
          NmoncEffon: "fffacd",
          ZXe: "add8e6",
          ZcSO: "f08080",
          Zcyan: "e0ffff",
          ZgTMnPdLw: "fafad2",
          ZWay: "d3d3d3",
          ZgYF: "90ee90",
          ZgYy: "d3d3d3",
          ZpRk: "ffb6c1",
          ZsOmon: "ffa07a",
          ZsHgYF: "20b2aa",
          ZskyXe: "87cefa",
          ZUWay: "778899",
          ZUgYy: "778899",
          ZstAlXe: "b0c4de",
          ZLw: "ffffe0",
          lime: "ff00",
          limegYF: "32cd32",
          lRF: "faf0e6",
          magFta: "ff00ff",
          maPon: "800000",
          VaquamarRe: "66cdaa",
          VXe: "cd",
          VScEd: "ba55d3",
          VpurpN: "9370db",
          VsHgYF: "3cb371",
          VUXe: "7b68ee",
          VsprRggYF: "fa9a",
          VQe: "48d1cc",
          VviTetYd: "c71585",
          midnightXe: "191970",
          mRtcYam: "f5fffa",
          mistyPse: "ffe4e1",
          moccasR: "ffe4b5",
          navajowEte: "ffdead",
          navy: "80",
          Tdlace: "fdf5e6",
          Tive: "808000",
          TivedBb: "6b8e23",
          Sange: "ffa500",
          SangeYd: "ff4500",
          ScEd: "da70d6",
          pOegTMnPd: "eee8aa",
          pOegYF: "98fb98",
          pOeQe: "afeeee",
          pOeviTetYd: "db7093",
          papayawEp: "ffefd5",
          pHKpuff: "ffdab9",
          peru: "cd853f",
          pRk: "ffc0cb",
          plum: "dda0dd",
          powMrXe: "b0e0e6",
          purpN: "800080",
          YbeccapurpN: "663399",
          Yd: "ff0000",
          Psybrown: "bc8f8f",
          PyOXe: "4169e1",
          saddNbPwn: "8b4513",
          sOmon: "fa8072",
          sandybPwn: "f4a460",
          sHgYF: "2e8b57",
          sHshell: "fff5ee",
          siFna: "a0522d",
          silver: "c0c0c0",
          skyXe: "87ceeb",
          UXe: "6a5acd",
          UWay: "708090",
          UgYy: "708090",
          snow: "fffafa",
          sprRggYF: "ff7f",
          stAlXe: "4682b4",
          tan: "d2b48c",
          teO: "8080",
          tEstN: "d8bfd8",
          tomato: "ff6347",
          Qe: "40e0d0",
          viTet: "ee82ee",
          JHt: "f5deb3",
          wEte: "ffffff",
          wEtesmoke: "f5f5f5",
          Lw: "ffff00",
          LwgYF: "9acd32",
        };
      let Vx;
      const Wx =
          /^rgba?\(\s*([-+.\d]+)(%)?[\s,]+([-+.e\d]+)(%)?[\s,]+([-+.e\d]+)(%)?(?:[\s,/]+([-+.e\d]+)(%)?)?\s*\)$/,
        Ux = (e) =>
          e <= 0.0031308 ? 12.92 * e : 1.055 * Math.pow(e, 1 / 2.4) - 0.055,
        $x = (e) =>
          e <= 0.04045 ? e / 12.92 : Math.pow((e + 0.055) / 1.055, 2.4);
      function Kx(e, t, n) {
        if (e) {
          let r = Lx(e);
          (r[t] = Math.max(0, Math.min(r[t] + r[t] * n, 0 === t ? 360 : 1))),
            (r = zx(r)),
            (e.r = r[0]),
            (e.g = r[1]),
            (e.b = r[2]);
        }
      }
      function Gx(e, t) {
        return e ? Object.assign(t || {}, e) : e;
      }
      function qx(e) {
        var t = { r: 0, g: 0, b: 0, a: 255 };
        return (
          Array.isArray(e)
            ? e.length >= 3 &&
              ((t = { r: e[0], g: e[1], b: e[2], a: 255 }),
              e.length > 3 && (t.a = Px(e[3])))
            : ((t = Gx(e, { r: 0, g: 0, b: 0, a: 1 })).a = Px(t.a)),
          t
        );
      }
      function Qx(e) {
        return "r" === e.charAt(0)
          ? (function (e) {
              const t = Wx.exec(e);
              let n,
                r,
                o,
                a = 255;
              if (t) {
                if (t[7] !== n) {
                  const e = +t[7];
                  a = t[8] ? kx(e) : Sx(255 * e, 0, 255);
                }
                return (
                  (n = +t[1]),
                  (r = +t[3]),
                  (o = +t[5]),
                  (n = 255 & (t[2] ? kx(n) : Sx(n, 0, 255))),
                  (r = 255 & (t[4] ? kx(r) : Sx(r, 0, 255))),
                  (o = 255 & (t[6] ? kx(o) : Sx(o, 0, 255))),
                  { r: n, g: r, b: o, a: a }
                );
              }
            })(e)
          : (function (e) {
              const t = Dx.exec(e);
              let n,
                r = 255;
              if (!t) return;
              t[5] !== n && (r = t[6] ? kx(+t[5]) : Px(+t[5]));
              const o = Fx(+t[2]),
                a = +t[3] / 100,
                i = +t[4] / 100;
              return (
                (n =
                  "hwb" === t[1]
                    ? (function (e, t, n) {
                        return Bx(Rx, e, t, n);
                      })(o, a, i)
                    : "hsv" === t[1]
                    ? (function (e, t, n) {
                        return Bx(Ex, e, t, n);
                      })(o, a, i)
                    : zx(o, a, i)),
                { r: n[0], g: n[1], b: n[2], a: r }
              );
            })(e);
      }
      class Yx {
        constructor(e) {
          if (e instanceof Yx) return e;
          const t = typeof e;
          let n;
          var r, o, a;
          "object" === t
            ? (n = qx(e))
            : "string" === t &&
              ((a = (r = e).length),
              "#" === r[0] &&
                (4 === a || 5 === a
                  ? (o = {
                      r: 255 & (17 * Tx[r[1]]),
                      g: 255 & (17 * Tx[r[2]]),
                      b: 255 & (17 * Tx[r[3]]),
                      a: 5 === a ? 17 * Tx[r[4]] : 255,
                    })
                  : (7 !== a && 9 !== a) ||
                    (o = {
                      r: (Tx[r[1]] << 4) | Tx[r[2]],
                      g: (Tx[r[3]] << 4) | Tx[r[4]],
                      b: (Tx[r[5]] << 4) | Tx[r[6]],
                      a: 9 === a ? (Tx[r[7]] << 4) | Tx[r[8]] : 255,
                    })),
              (n =
                o ||
                (function (e) {
                  Vx ||
                    ((Vx = (function () {
                      const e = {},
                        t = Object.keys(Hx),
                        n = Object.keys(Zx);
                      let r, o, a, i, s;
                      for (r = 0; r < t.length; r++) {
                        for (i = s = t[r], o = 0; o < n.length; o++)
                          (a = n[o]), (s = s.replace(a, Zx[a]));
                        (a = parseInt(Hx[i], 16)),
                          (e[s] = [(a >> 16) & 255, (a >> 8) & 255, 255 & a]);
                      }
                      return e;
                    })()),
                    (Vx.transparent = [0, 0, 0, 0]));
                  const t = Vx[e.toLowerCase()];
                  return (
                    t && {
                      r: t[0],
                      g: t[1],
                      b: t[2],
                      a: 4 === t.length ? t[3] : 255,
                    }
                  );
                })(e) ||
                Qx(e))),
            (this._rgb = n),
            (this._valid = !!n);
        }
        get valid() {
          return this._valid;
        }
        get rgb() {
          var e = Gx(this._rgb);
          return e && (e.a = wx(e.a)), e;
        }
        set rgb(e) {
          this._rgb = qx(e);
        }
        rgbString() {
          return this._valid
            ? (e = this._rgb) &&
                (e.a < 255
                  ? `rgba(${e.r}, ${e.g}, ${e.b}, ${wx(e.a)})`
                  : `rgb(${e.r}, ${e.g}, ${e.b})`)
            : void 0;
          var e;
        }
        hexString() {
          return this._valid
            ? ((e = this._rgb),
              (t = ((e) => Nx(e.r) && Nx(e.g) && Nx(e.b) && Nx(e.a))(e)
                ? Mx
                : jx),
              e
                ? "#" +
                  t(e.r) +
                  t(e.g) +
                  t(e.b) +
                  ((e, t) => (e < 255 ? t(e) : ""))(e.a, t)
                : void 0)
            : void 0;
          var e, t;
        }
        hslString() {
          return this._valid
            ? (function (e) {
                if (!e) return;
                const t = Lx(e),
                  n = t[0],
                  r = Ox(t[1]),
                  o = Ox(t[2]);
                return e.a < 255
                  ? `hsla(${n}, ${r}%, ${o}%, ${wx(e.a)})`
                  : `hsl(${n}, ${r}%, ${o}%)`;
              })(this._rgb)
            : void 0;
        }
        mix(e, t) {
          if (e) {
            const n = this.rgb,
              r = e.rgb;
            let o;
            const a = t === o ? 0.5 : t,
              i = 2 * a - 1,
              s = n.a - r.a,
              l = ((i * s == -1 ? i : (i + s) / (1 + i * s)) + 1) / 2;
            (o = 1 - l),
              (n.r = 255 & (l * n.r + o * r.r + 0.5)),
              (n.g = 255 & (l * n.g + o * r.g + 0.5)),
              (n.b = 255 & (l * n.b + o * r.b + 0.5)),
              (n.a = a * n.a + (1 - a) * r.a),
              (this.rgb = n);
          }
          return this;
        }
        interpolate(e, t) {
          return (
            e &&
              (this._rgb = (function (e, t, n) {
                const r = $x(wx(e.r)),
                  o = $x(wx(e.g)),
                  a = $x(wx(e.b));
                return {
                  r: Px(Ux(r + n * ($x(wx(t.r)) - r))),
                  g: Px(Ux(o + n * ($x(wx(t.g)) - o))),
                  b: Px(Ux(a + n * ($x(wx(t.b)) - a))),
                  a: e.a + n * (t.a - e.a),
                };
              })(this._rgb, e._rgb, t)),
            this
          );
        }
        clone() {
          return new Yx(this.rgb);
        }
        alpha(e) {
          return (this._rgb.a = Px(e)), this;
        }
        clearer(e) {
          return (this._rgb.a *= 1 - e), this;
        }
        greyscale() {
          const e = this._rgb,
            t = xx(0.3 * e.r + 0.59 * e.g + 0.11 * e.b);
          return (e.r = e.g = e.b = t), this;
        }
        opaquer(e) {
          return (this._rgb.a *= 1 + e), this;
        }
        negate() {
          const e = this._rgb;
          return (e.r = 255 - e.r), (e.g = 255 - e.g), (e.b = 255 - e.b), this;
        }
        lighten(e) {
          return Kx(this._rgb, 2, e), this;
        }
        darken(e) {
          return Kx(this._rgb, 2, -e), this;
        }
        saturate(e) {
          return Kx(this._rgb, 1, e), this;
        }
        desaturate(e) {
          return Kx(this._rgb, 1, -e), this;
        }
        rotate(e) {
          return (
            (function (e, t) {
              var n = Lx(e);
              (n[0] = Fx(n[0] + t)),
                (n = zx(n)),
                (e.r = n[0]),
                (e.g = n[1]),
                (e.b = n[2]);
            })(this._rgb, e),
            this
          );
        }
      }
      function Jx(e) {
        return new Yx(e);
      }
      function Xx(e) {
        if (e && "object" == typeof e) {
          const t = e.toString();
          return (
            "[object CanvasPattern]" === t || "[object CanvasGradient]" === t
          );
        }
        return !1;
      }
      function eS(e) {
        return Xx(e) ? e : Jx(e);
      }
      function tS(e) {
        return Xx(e) ? e : Jx(e).saturate(0.5).darken(0.1).hexString();
      }
      const nS = Object.create(null),
        rS = Object.create(null);
      function oS(e, t) {
        if (!t) return e;
        const n = t.split(".");
        for (let t = 0, r = n.length; t < r; ++t) {
          const r = n[t];
          e = e[r] || (e[r] = Object.create(null));
        }
        return e;
      }
      function aS(e, t, n) {
        return "string" == typeof t ? OC(oS(e, t), n) : OC(oS(e, ""), t);
      }
      var iS = new (class {
        constructor(e) {
          (this.animation = void 0),
            (this.backgroundColor = "rgba(0,0,0,0.1)"),
            (this.borderColor = "rgba(0,0,0,0.1)"),
            (this.color = "#666"),
            (this.datasets = {}),
            (this.devicePixelRatio = (e) =>
              e.chart.platform.getDevicePixelRatio()),
            (this.elements = {}),
            (this.events = [
              "mousemove",
              "mouseout",
              "click",
              "touchstart",
              "touchmove",
            ]),
            (this.font = {
              family: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
              size: 12,
              style: "normal",
              lineHeight: 1.2,
              weight: null,
            }),
            (this.hover = {}),
            (this.hoverBackgroundColor = (e, t) => tS(t.backgroundColor)),
            (this.hoverBorderColor = (e, t) => tS(t.borderColor)),
            (this.hoverColor = (e, t) => tS(t.color)),
            (this.indexAxis = "x"),
            (this.interaction = {
              mode: "nearest",
              intersect: !0,
              includeInvisible: !1,
            }),
            (this.maintainAspectRatio = !0),
            (this.onHover = null),
            (this.onClick = null),
            (this.parsing = !0),
            (this.plugins = {}),
            (this.responsive = !0),
            (this.scale = void 0),
            (this.scales = {}),
            (this.showLine = !0),
            (this.drawActiveElementsOnTop = !0),
            this.describe(e);
        }
        set(e, t) {
          return aS(this, e, t);
        }
        get(e) {
          return oS(this, e);
        }
        describe(e, t) {
          return aS(rS, e, t);
        }
        override(e, t) {
          return aS(nS, e, t);
        }
        route(e, t, n, r) {
          const o = oS(this, e),
            a = oS(this, n),
            i = "_" + t;
          Object.defineProperties(o, {
            [i]: { value: o[t], writable: !0 },
            [t]: {
              enumerable: !0,
              get() {
                const e = this[i],
                  t = a[r];
                return gC(e) ? Object.assign({}, t, e) : _C(e, t);
              },
              set(e) {
                this[i] = e;
              },
            },
          });
        }
      })({
        _scriptable: (e) => !e.startsWith("on"),
        _indexable: (e) => "events" !== e,
        hover: { _fallback: "interaction" },
        interaction: { _scriptable: !1, _indexable: !1 },
      });
      function sS(e, t, n, r, o) {
        let a = t[o];
        return (
          a || ((a = t[o] = e.measureText(o).width), n.push(o)),
          a > r && (r = a),
          r
        );
      }
      function lS(e, t, n, r) {
        let o = ((r = r || {}).data = r.data || {}),
          a = (r.garbageCollect = r.garbageCollect || []);
        r.font !== t &&
          ((o = r.data = {}), (a = r.garbageCollect = []), (r.font = t)),
          e.save(),
          (e.font = t);
        let i = 0;
        const s = n.length;
        let l, d, c, u, p;
        for (l = 0; l < s; l++)
          if (((u = n[l]), null != u && !0 !== fC(u))) i = sS(e, o, a, i, u);
          else if (fC(u))
            for (d = 0, c = u.length; d < c; d++)
              (p = u[d]), null == p || fC(p) || (i = sS(e, o, a, i, p));
        e.restore();
        const m = a.length / 2;
        if (m > n.length) {
          for (l = 0; l < m; l++) delete o[a[l]];
          a.splice(0, m);
        }
        return i;
      }
      function dS(e, t, n) {
        const r = e.currentDevicePixelRatio,
          o = 0 !== n ? Math.max(n / 2, 0.5) : 0;
        return Math.round((t - o) * r) / r + o;
      }
      function cS(e, t) {
        (t = t || e.getContext("2d")).save(),
          t.resetTransform(),
          t.clearRect(0, 0, e.width, e.height),
          t.restore();
      }
      function uS(e, t, n, r) {
        pS(e, t, n, r, null);
      }
      function pS(e, t, n, r, o) {
        let a, i, s, l, d, c;
        const u = t.pointStyle,
          p = t.rotation,
          m = t.radius;
        let h = (p || 0) * FC;
        if (
          u &&
          "object" == typeof u &&
          ((a = u.toString()),
          "[object HTMLImageElement]" === a ||
            "[object HTMLCanvasElement]" === a)
        )
          return (
            e.save(),
            e.translate(n, r),
            e.rotate(h),
            e.drawImage(u, -u.width / 2, -u.height / 2, u.width, u.height),
            void e.restore()
          );
        if (!(isNaN(m) || m <= 0)) {
          switch ((e.beginPath(), u)) {
            default:
              o ? e.ellipse(n, r, o / 2, m, 0, 0, LC) : e.arc(n, r, m, 0, LC),
                e.closePath();
              break;
            case "triangle":
              e.moveTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                (h += VC),
                e.lineTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                (h += VC),
                e.lineTo(n + Math.sin(h) * m, r - Math.cos(h) * m),
                e.closePath();
              break;
            case "rectRounded":
              (d = 0.516 * m),
                (l = m - d),
                (i = Math.cos(h + HC) * l),
                (s = Math.sin(h + HC) * l),
                e.arc(n - i, r - s, d, h - RC, h - ZC),
                e.arc(n + s, r - i, d, h - ZC, h),
                e.arc(n + i, r + s, d, h, h + ZC),
                e.arc(n - s, r + i, d, h + ZC, h + RC),
                e.closePath();
              break;
            case "rect":
              if (!p) {
                (l = Math.SQRT1_2 * m),
                  (c = o ? o / 2 : l),
                  e.rect(n - c, r - l, 2 * c, 2 * l);
                break;
              }
              h += HC;
            case "rectRot":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + s, r - i),
                e.lineTo(n + i, r + s),
                e.lineTo(n - s, r + i),
                e.closePath();
              break;
            case "crossRot":
              h += HC;
            case "cross":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i);
              break;
            case "star":
              (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i),
                (h += HC),
                (i = Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s),
                e.moveTo(n + s, r - i),
                e.lineTo(n - s, r + i);
              break;
            case "line":
              (i = o ? o / 2 : Math.cos(h) * m),
                (s = Math.sin(h) * m),
                e.moveTo(n - i, r - s),
                e.lineTo(n + i, r + s);
              break;
            case "dash":
              e.moveTo(n, r),
                e.lineTo(n + Math.cos(h) * m, r + Math.sin(h) * m);
          }
          e.fill(), t.borderWidth > 0 && e.stroke();
        }
      }
      function mS(e, t, n) {
        return (
          (n = n || 0.5),
          !t ||
            (e &&
              e.x > t.left - n &&
              e.x < t.right + n &&
              e.y > t.top - n &&
              e.y < t.bottom + n)
        );
      }
      function hS(e, t) {
        e.save(),
          e.beginPath(),
          e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top),
          e.clip();
      }
      function fS(e) {
        e.restore();
      }
      function gS(e, t, n, r, o) {
        if (!t) return e.lineTo(n.x, n.y);
        if ("middle" === o) {
          const r = (t.x + n.x) / 2;
          e.lineTo(r, t.y), e.lineTo(r, n.y);
        } else ("after" === o) != !!r ? e.lineTo(t.x, n.y) : e.lineTo(n.x, t.y);
        e.lineTo(n.x, n.y);
      }
      function vS(e, t, n, r) {
        if (!t) return e.lineTo(n.x, n.y);
        e.bezierCurveTo(
          r ? t.cp1x : t.cp2x,
          r ? t.cp1y : t.cp2y,
          r ? n.cp2x : n.cp1x,
          r ? n.cp2y : n.cp1y,
          n.x,
          n.y
        );
      }
      function bS(e, t, n, r, o, a = {}) {
        const i = fC(t) ? t : [t],
          s = a.strokeWidth > 0 && "" !== a.strokeColor;
        let l, d;
        for (
          e.save(),
            e.font = o.string,
            (function (e, t) {
              t.translation && e.translate(t.translation[0], t.translation[1]),
                hC(t.rotation) || e.rotate(t.rotation),
                t.color && (e.fillStyle = t.color),
                t.textAlign && (e.textAlign = t.textAlign),
                t.textBaseline && (e.textBaseline = t.textBaseline);
            })(e, a),
            l = 0;
          l < i.length;
          ++l
        )
          (d = i[l]),
            s &&
              (a.strokeColor && (e.strokeStyle = a.strokeColor),
              hC(a.strokeWidth) || (e.lineWidth = a.strokeWidth),
              e.strokeText(d, n, r, a.maxWidth)),
            e.fillText(d, n, r, a.maxWidth),
            _S(e, n, r, d, a),
            (r += o.lineHeight);
        e.restore();
      }
      function _S(e, t, n, r, o) {
        if (o.strikethrough || o.underline) {
          const a = e.measureText(r),
            i = t - a.actualBoundingBoxLeft,
            s = t + a.actualBoundingBoxRight,
            l = n - a.actualBoundingBoxAscent,
            d = n + a.actualBoundingBoxDescent,
            c = o.strikethrough ? (l + d) / 2 : d;
          (e.strokeStyle = e.fillStyle),
            e.beginPath(),
            (e.lineWidth = o.decorationWidth || 2),
            e.moveTo(i, c),
            e.lineTo(s, c),
            e.stroke();
        }
      }
      function yS(e, t) {
        const { x: n, y: r, w: o, h: a, radius: i } = t;
        e.arc(n + i.topLeft, r + i.topLeft, i.topLeft, -ZC, RC, !0),
          e.lineTo(n, r + a - i.bottomLeft),
          e.arc(
            n + i.bottomLeft,
            r + a - i.bottomLeft,
            i.bottomLeft,
            RC,
            ZC,
            !0
          ),
          e.lineTo(n + o - i.bottomRight, r + a),
          e.arc(
            n + o - i.bottomRight,
            r + a - i.bottomRight,
            i.bottomRight,
            ZC,
            0,
            !0
          ),
          e.lineTo(n + o, r + i.topRight),
          e.arc(n + o - i.topRight, r + i.topRight, i.topRight, 0, -ZC, !0),
          e.lineTo(n + i.topLeft, r);
      }
      const CS = new RegExp(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/),
        xS = new RegExp(
          /^(normal|italic|initial|inherit|unset|(oblique( -?[0-9]?[0-9]deg)?))$/
        );
      function SS(e, t) {
        const n = ("" + e).match(CS);
        if (!n || "normal" === n[1]) return 1.2 * t;
        switch (((e = +n[2]), n[3])) {
          case "px":
            return e;
          case "%":
            e /= 100;
        }
        return t * e;
      }
      const kS = (e) => +e || 0;
      function PS(e, t) {
        const n = {},
          r = gC(t),
          o = r ? Object.keys(t) : t,
          a = gC(e) ? (r ? (n) => _C(e[n], e[t[n]]) : (t) => e[t]) : () => e;
        for (const e of o) n[e] = kS(a(e));
        return n;
      }
      function wS(e) {
        return PS(e, { top: "y", right: "x", bottom: "y", left: "x" });
      }
      function OS(e) {
        return PS(e, ["topLeft", "topRight", "bottomLeft", "bottomRight"]);
      }
      function TS(e) {
        const t = wS(e);
        return (t.width = t.left + t.right), (t.height = t.top + t.bottom), t;
      }
      function IS(e, t) {
        (e = e || {}), (t = t || iS.font);
        let n = _C(e.size, t.size);
        "string" == typeof n && (n = parseInt(n, 10));
        let r = _C(e.style, t.style);
        r &&
          !("" + r).match(xS) &&
          (console.warn('Invalid font style specified: "' + r + '"'), (r = ""));
        const o = {
          family: _C(e.family, t.family),
          lineHeight: SS(_C(e.lineHeight, t.lineHeight), n),
          size: n,
          style: r,
          weight: _C(e.weight, t.weight),
          string: "",
        };
        return (
          (o.string = (function (e) {
            return !e || hC(e.size) || hC(e.family)
              ? null
              : (e.style ? e.style + " " : "") +
                  (e.weight ? e.weight + " " : "") +
                  e.size +
                  "px " +
                  e.family;
          })(o)),
          o
        );
      }
      function MS(e, t, n, r) {
        let o,
          a,
          i,
          s = !0;
        for (o = 0, a = e.length; o < a; ++o)
          if (
            ((i = e[o]),
            void 0 !== i &&
              (void 0 !== t && "function" == typeof i && ((i = i(t)), (s = !1)),
              void 0 !== n && fC(i) && ((i = i[n % i.length]), (s = !1)),
              void 0 !== i))
          )
            return r && !s && (r.cacheable = !1), i;
      }
      function jS(e, t) {
        return Object.assign(Object.create(e), t);
      }
      function NS(e, t = [""], n = e, r, o = () => e[0]) {
        DC(r) || (r = VS("_fallback", e));
        const a = {
          [Symbol.toStringTag]: "Object",
          _cacheable: !0,
          _scopes: e,
          _rootScopes: n,
          _fallback: r,
          _getTarget: o,
          override: (o) => NS([o, ...e], t, n, r),
        };
        return new Proxy(a, {
          deleteProperty(t, n) {
            return delete t[n], delete t._keys, delete e[0][n], !0;
          },
          get(n, r) {
            return LS(n, r, () =>
              (function (e, t, n, r) {
                let o;
                for (const a of t)
                  if (((o = VS(ES(a, e), n)), DC(o)))
                    return RS(e, o) ? ZS(n, r, e, o) : o;
              })(r, t, e, n)
            );
          },
          getOwnPropertyDescriptor(e, t) {
            return Reflect.getOwnPropertyDescriptor(e._scopes[0], t);
          },
          getPrototypeOf() {
            return Reflect.getPrototypeOf(e[0]);
          },
          has(e, t) {
            return WS(e).includes(t);
          },
          ownKeys(e) {
            return WS(e);
          },
          set(e, t, n) {
            const r = e._storage || (e._storage = o());
            return (e[t] = r[t] = n), delete e._keys, !0;
          },
        });
      }
      function DS(e, t, n, r) {
        const o = {
          _cacheable: !1,
          _proxy: e,
          _context: t,
          _subProxy: n,
          _stack: new Set(),
          _descriptors: AS(e, r),
          setContext: (t) => DS(e, t, n, r),
          override: (o) => DS(e.override(o), t, n, r),
        };
        return new Proxy(o, {
          deleteProperty(t, n) {
            return delete t[n], delete e[n], !0;
          },
          get(e, t, n) {
            return LS(e, t, () =>
              (function (e, t, n) {
                const {
                  _proxy: r,
                  _context: o,
                  _subProxy: a,
                  _descriptors: i,
                } = e;
                let s = r[t];
                return (
                  AC(s) &&
                    i.isScriptable(t) &&
                    (s = (function (e, t, n, r) {
                      const {
                        _proxy: o,
                        _context: a,
                        _subProxy: i,
                        _stack: s,
                      } = n;
                      if (s.has(e))
                        throw new Error(
                          "Recursion detected: " +
                            Array.from(s).join("->") +
                            "->" +
                            e
                        );
                      return (
                        s.add(e),
                        (t = t(a, i || r)),
                        s.delete(e),
                        RS(e, t) && (t = ZS(o._scopes, o, e, t)),
                        t
                      );
                    })(t, s, e, n)),
                  fC(s) &&
                    s.length &&
                    (s = (function (e, t, n, r) {
                      const {
                        _proxy: o,
                        _context: a,
                        _subProxy: i,
                        _descriptors: s,
                      } = n;
                      if (DC(a.index) && r(e)) t = t[a.index % t.length];
                      else if (gC(t[0])) {
                        const n = t,
                          r = o._scopes.filter((e) => e !== n);
                        t = [];
                        for (const l of n) {
                          const n = ZS(r, o, e, l);
                          t.push(DS(n, a, i && i[e], s));
                        }
                      }
                      return t;
                    })(t, s, e, i.isIndexable)),
                  RS(t, s) && (s = DS(s, o, a && a[t], i)),
                  s
                );
              })(e, t, n)
            );
          },
          getOwnPropertyDescriptor(t, n) {
            return t._descriptors.allKeys
              ? Reflect.has(e, n)
                ? { enumerable: !0, configurable: !0 }
                : void 0
              : Reflect.getOwnPropertyDescriptor(e, n);
          },
          getPrototypeOf() {
            return Reflect.getPrototypeOf(e);
          },
          has(t, n) {
            return Reflect.has(e, n);
          },
          ownKeys() {
            return Reflect.ownKeys(e);
          },
          set(t, n, r) {
            return (e[n] = r), delete t[n], !0;
          },
        });
      }
      function AS(e, t = { scriptable: !0, indexable: !0 }) {
        const {
          _scriptable: n = t.scriptable,
          _indexable: r = t.indexable,
          _allKeys: o = t.allKeys,
        } = e;
        return {
          allKeys: o,
          scriptable: n,
          indexable: r,
          isScriptable: AC(n) ? n : () => n,
          isIndexable: AC(r) ? r : () => r,
        };
      }
      const ES = (e, t) => (e ? e + NC(t) : t),
        RS = (e, t) =>
          gC(t) &&
          "adapters" !== e &&
          (null === Object.getPrototypeOf(t) || t.constructor === Object);
      function LS(e, t, n) {
        if (Object.prototype.hasOwnProperty.call(e, t)) return e[t];
        const r = n();
        return (e[t] = r), r;
      }
      function BS(e, t, n) {
        return AC(e) ? e(t, n) : e;
      }
      const zS = (e, t) =>
        !0 === e ? t : "string" == typeof e ? jC(t, e) : void 0;
      function FS(e, t, n, r, o) {
        for (const a of t) {
          const t = zS(n, a);
          if (t) {
            e.add(t);
            const a = BS(t._fallback, n, o);
            if (DC(a) && a !== n && a !== r) return a;
          } else if (!1 === t && DC(r) && n !== r) return null;
        }
        return !1;
      }
      function ZS(e, t, n, r) {
        const o = t._rootScopes,
          a = BS(t._fallback, n, r),
          i = [...e, ...o],
          s = new Set();
        s.add(r);
        let l = HS(s, i, n, a || n, r);
        return (
          null !== l &&
          (!DC(a) || a === n || ((l = HS(s, i, a, l, r)), null !== l)) &&
          NS(Array.from(s), [""], o, a, () =>
            (function (e, t, n) {
              const r = e._getTarget();
              t in r || (r[t] = {});
              const o = r[t];
              return fC(o) && gC(n) ? n : o;
            })(t, n, r)
          )
        );
      }
      function HS(e, t, n, r, o) {
        for (; n; ) n = FS(e, t, n, r, o);
        return n;
      }
      function VS(e, t) {
        for (const n of t) {
          if (!n) continue;
          const t = n[e];
          if (DC(t)) return t;
        }
      }
      function WS(e) {
        let t = e._keys;
        return (
          t ||
            (t = e._keys =
              (function (e) {
                const t = new Set();
                for (const n of e)
                  for (const e of Object.keys(n).filter(
                    (e) => !e.startsWith("_")
                  ))
                    t.add(e);
                return Array.from(t);
              })(e._scopes)),
          t
        );
      }
      function US(e, t, n, r) {
        const { iScale: o } = e,
          { key: a = "r" } = this._parsing,
          i = new Array(r);
        let s, l, d, c;
        for (s = 0, l = r; s < l; ++s)
          (d = s + n), (c = t[d]), (i[s] = { r: o.parse(jC(c, a), d) });
        return i;
      }
      const $S = Number.EPSILON || 1e-14,
        KS = (e, t) => t < e.length && !e[t].skip && e[t],
        GS = (e) => ("x" === e ? "y" : "x");
      function qS(e, t, n, r) {
        const o = e.skip ? t : e,
          a = t,
          i = n.skip ? t : n,
          s = ex(a, o),
          l = ex(i, a);
        let d = s / (s + l),
          c = l / (s + l);
        (d = isNaN(d) ? 0 : d), (c = isNaN(c) ? 0 : c);
        const u = r * d,
          p = r * c;
        return {
          previous: { x: a.x - u * (i.x - o.x), y: a.y - u * (i.y - o.y) },
          next: { x: a.x + p * (i.x - o.x), y: a.y + p * (i.y - o.y) },
        };
      }
      function QS(e, t, n) {
        return Math.max(Math.min(e, n), t);
      }
      function YS(e, t, n, r, o) {
        let a, i, s, l;
        if (
          (t.spanGaps && (e = e.filter((e) => !e.skip)),
          "monotone" === t.cubicInterpolationMode)
        )
          !(function (e, t = "x") {
            const n = GS(t),
              r = e.length,
              o = Array(r).fill(0),
              a = Array(r);
            let i,
              s,
              l,
              d = KS(e, 0);
            for (i = 0; i < r; ++i)
              if (((s = l), (l = d), (d = KS(e, i + 1)), l)) {
                if (d) {
                  const e = d[t] - l[t];
                  o[i] = 0 !== e ? (d[n] - l[n]) / e : 0;
                }
                a[i] = s
                  ? d
                    ? UC(o[i - 1]) !== UC(o[i])
                      ? 0
                      : (o[i - 1] + o[i]) / 2
                    : o[i - 1]
                  : o[i];
              }
            !(function (e, t, n) {
              const r = e.length;
              let o,
                a,
                i,
                s,
                l,
                d = KS(e, 0);
              for (let c = 0; c < r - 1; ++c)
                (l = d),
                  (d = KS(e, c + 1)),
                  l &&
                    d &&
                    (GC(t[c], 0, $S)
                      ? (n[c] = n[c + 1] = 0)
                      : ((o = n[c] / t[c]),
                        (a = n[c + 1] / t[c]),
                        (s = Math.pow(o, 2) + Math.pow(a, 2)),
                        s <= 9 ||
                          ((i = 3 / Math.sqrt(s)),
                          (n[c] = o * i * t[c]),
                          (n[c + 1] = a * i * t[c]))));
            })(e, o, a),
              (function (e, t, n = "x") {
                const r = GS(n),
                  o = e.length;
                let a,
                  i,
                  s,
                  l = KS(e, 0);
                for (let d = 0; d < o; ++d) {
                  if (((i = s), (s = l), (l = KS(e, d + 1)), !s)) continue;
                  const o = s[n],
                    c = s[r];
                  i &&
                    ((a = (o - i[n]) / 3),
                    (s[`cp1${n}`] = o - a),
                    (s[`cp1${r}`] = c - a * t[d])),
                    l &&
                      ((a = (l[n] - o) / 3),
                      (s[`cp2${n}`] = o + a),
                      (s[`cp2${r}`] = c + a * t[d]));
                }
              })(e, a, t);
          })(e, o);
        else {
          let n = r ? e[e.length - 1] : e[0];
          for (a = 0, i = e.length; a < i; ++a)
            (s = e[a]),
              (l = qS(
                n,
                s,
                e[Math.min(a + 1, i - (r ? 0 : 1)) % i],
                t.tension
              )),
              (s.cp1x = l.previous.x),
              (s.cp1y = l.previous.y),
              (s.cp2x = l.next.x),
              (s.cp2y = l.next.y),
              (n = s);
        }
        t.capBezierPoints &&
          (function (e, t) {
            let n,
              r,
              o,
              a,
              i,
              s = mS(e[0], t);
            for (n = 0, r = e.length; n < r; ++n)
              (i = a),
                (a = s),
                (s = n < r - 1 && mS(e[n + 1], t)),
                a &&
                  ((o = e[n]),
                  i &&
                    ((o.cp1x = QS(o.cp1x, t.left, t.right)),
                    (o.cp1y = QS(o.cp1y, t.top, t.bottom))),
                  s &&
                    ((o.cp2x = QS(o.cp2x, t.left, t.right)),
                    (o.cp2y = QS(o.cp2y, t.top, t.bottom))));
          })(e, n);
      }
      function JS() {
        return "undefined" != typeof window && "undefined" != typeof document;
      }
      function XS(e) {
        let t = e.parentNode;
        return t && "[object ShadowRoot]" === t.toString() && (t = t.host), t;
      }
      function ek(e, t, n) {
        let r;
        return (
          "string" == typeof e
            ? ((r = parseInt(e, 10)),
              -1 !== e.indexOf("%") && (r = (r / 100) * t.parentNode[n]))
            : (r = e),
          r
        );
      }
      const tk = (e) => window.getComputedStyle(e, null),
        nk = ["top", "right", "bottom", "left"];
      function rk(e, t, n) {
        const r = {};
        n = n ? "-" + n : "";
        for (let o = 0; o < 4; o++) {
          const a = nk[o];
          r[a] = parseFloat(e[t + "-" + a + n]) || 0;
        }
        return (r.width = r.left + r.right), (r.height = r.top + r.bottom), r;
      }
      const ok = (e, t, n) => (e > 0 || t > 0) && (!n || !n.shadowRoot);
      function ak(e, t) {
        if ("native" in e) return e;
        const { canvas: n, currentDevicePixelRatio: r } = t,
          o = tk(n),
          a = "border-box" === o.boxSizing,
          i = rk(o, "padding"),
          s = rk(o, "border", "width"),
          {
            x: l,
            y: d,
            box: c,
          } = (function (e, t) {
            const n = e.touches,
              r = n && n.length ? n[0] : e,
              { offsetX: o, offsetY: a } = r;
            let i,
              s,
              l = !1;
            if (ok(o, a, e.target)) (i = o), (s = a);
            else {
              const e = t.getBoundingClientRect();
              (i = r.clientX - e.left), (s = r.clientY - e.top), (l = !0);
            }
            return { x: i, y: s, box: l };
          })(e, n),
          u = i.left + (c && s.left),
          p = i.top + (c && s.top);
        let { width: m, height: h } = t;
        return (
          a && ((m -= i.width + s.width), (h -= i.height + s.height)),
          {
            x: Math.round((((l - u) / m) * n.width) / r),
            y: Math.round((((d - p) / h) * n.height) / r),
          }
        );
      }
      const ik = (e) => Math.round(10 * e) / 10;
      function sk(e, t, n) {
        const r = t || 1,
          o = Math.floor(e.height * r),
          a = Math.floor(e.width * r);
        (e.height = o / r), (e.width = a / r);
        const i = e.canvas;
        return (
          i.style &&
            (n || (!i.style.height && !i.style.width)) &&
            ((i.style.height = `${e.height}px`),
            (i.style.width = `${e.width}px`)),
          (e.currentDevicePixelRatio !== r ||
            i.height !== o ||
            i.width !== a) &&
            ((e.currentDevicePixelRatio = r),
            (i.height = o),
            (i.width = a),
            e.ctx.setTransform(r, 0, 0, r, 0, 0),
            !0)
        );
      }
      const lk = (function () {
        let e = !1;
        try {
          const t = {
            get passive() {
              return (e = !0), !1;
            },
          };
          window.addEventListener("test", null, t),
            window.removeEventListener("test", null, t);
        } catch (e) {}
        return e;
      })();
      function dk(e, t) {
        const n = (function (e, t) {
            return tk(e).getPropertyValue(t);
          })(e, t),
          r = n && n.match(/^(\d+)(\.\d+)?px$/);
        return r ? +r[1] : void 0;
      }
      function ck(e, t, n, r) {
        return { x: e.x + n * (t.x - e.x), y: e.y + n * (t.y - e.y) };
      }
      function uk(e, t, n, r) {
        return {
          x: e.x + n * (t.x - e.x),
          y:
            "middle" === r
              ? n < 0.5
                ? e.y
                : t.y
              : "after" === r
              ? n < 1
                ? e.y
                : t.y
              : n > 0
              ? t.y
              : e.y,
        };
      }
      function pk(e, t, n, r) {
        const o = { x: e.cp2x, y: e.cp2y },
          a = { x: t.cp1x, y: t.cp1y },
          i = ck(e, o, n),
          s = ck(o, a, n),
          l = ck(a, t, n),
          d = ck(i, s, n),
          c = ck(s, l, n);
        return ck(d, c, n);
      }
      const mk = new Map();
      function hk(e, t, n) {
        return (function (e, t) {
          t = t || {};
          const n = e + JSON.stringify(t);
          let r = mk.get(n);
          return r || ((r = new Intl.NumberFormat(e, t)), mk.set(n, r)), r;
        })(t, n).format(e);
      }
      function fk(e, t, n) {
        return e
          ? (function (e, t) {
              return {
                x(n) {
                  return e + e + t - n;
                },
                setWidth(e) {
                  t = e;
                },
                textAlign(e) {
                  return "center" === e ? e : "right" === e ? "left" : "right";
                },
                xPlus(e, t) {
                  return e - t;
                },
                leftForLtr(e, t) {
                  return e - t;
                },
              };
            })(t, n)
          : {
              x(e) {
                return e;
              },
              setWidth(e) {},
              textAlign(e) {
                return e;
              },
              xPlus(e, t) {
                return e + t;
              },
              leftForLtr(e, t) {
                return e;
              },
            };
      }
      function gk(e, t) {
        let n, r;
        ("ltr" !== t && "rtl" !== t) ||
          ((n = e.canvas.style),
          (r = [
            n.getPropertyValue("direction"),
            n.getPropertyPriority("direction"),
          ]),
          n.setProperty("direction", t, "important"),
          (e.prevTextDirection = r));
      }
      function vk(e, t) {
        void 0 !== t &&
          (delete e.prevTextDirection,
          e.canvas.style.setProperty("direction", t[0], t[1]));
      }
      function bk(e) {
        return "angle" === e
          ? { between: rx, compare: tx, normalize: nx }
          : { between: ax, compare: (e, t) => e - t, normalize: (e) => e };
      }
      function _k({ start: e, end: t, count: n, loop: r, style: o }) {
        return {
          start: e % n,
          end: t % n,
          loop: r && (t - e + 1) % n == 0,
          style: o,
        };
      }
      function yk(e, t, n) {
        if (!n) return [e];
        const { property: r, start: o, end: a } = n,
          i = t.length,
          { compare: s, between: l, normalize: d } = bk(r),
          {
            start: c,
            end: u,
            loop: p,
            style: m,
          } = (function (e, t, n) {
            const { property: r, start: o, end: a } = n,
              { between: i, normalize: s } = bk(r),
              l = t.length;
            let d,
              c,
              { start: u, end: p, loop: m } = e;
            if (m) {
              for (
                u += l, p += l, d = 0, c = l;
                d < c && i(s(t[u % l][r]), o, a);
                ++d
              )
                u--, p--;
              (u %= l), (p %= l);
            }
            return (
              p < u && (p += l), { start: u, end: p, loop: m, style: e.style }
            );
          })(e, t, n),
          h = [];
        let f,
          g,
          v,
          b = !1,
          _ = null;
        for (let e = c, n = c; e <= u; ++e)
          (g = t[e % i]),
            g.skip ||
              ((f = d(g[r])),
              f !== v &&
                ((b = l(f, o, a)),
                null === _ &&
                  (b || (l(o, v, f) && 0 !== s(o, v))) &&
                  (_ = 0 === s(f, o) ? e : n),
                null !== _ &&
                  (!b || 0 === s(a, f) || l(a, v, f)) &&
                  (h.push(
                    _k({ start: _, end: e, loop: p, count: i, style: m })
                  ),
                  (_ = null)),
                (n = e),
                (v = f)));
        return (
          null !== _ &&
            h.push(_k({ start: _, end: u, loop: p, count: i, style: m })),
          h
        );
      }
      function Ck(e) {
        return {
          backgroundColor: e.backgroundColor,
          borderCapStyle: e.borderCapStyle,
          borderDash: e.borderDash,
          borderDashOffset: e.borderDashOffset,
          borderJoinStyle: e.borderJoinStyle,
          borderWidth: e.borderWidth,
          borderColor: e.borderColor,
        };
      }
      function xk(e, t) {
        return t && JSON.stringify(e) !== JSON.stringify(t);
      }
      var Sk = new (class {
        constructor() {
          (this._request = null),
            (this._charts = new Map()),
            (this._running = !1),
            (this._lastDate = void 0);
        }
        _notify(e, t, n, r) {
          const o = t.listeners[r],
            a = t.duration;
          o.forEach((r) =>
            r({
              chart: e,
              initial: t.initial,
              numSteps: a,
              currentStep: Math.min(n - t.start, a),
            })
          );
        }
        _refresh() {
          this._request ||
            ((this._running = !0),
            (this._request = px.call(window, () => {
              this._update(),
                (this._request = null),
                this._running && this._refresh();
            })));
        }
        _update(e = Date.now()) {
          let t = 0;
          this._charts.forEach((n, r) => {
            if (!n.running || !n.items.length) return;
            const o = n.items;
            let a,
              i = o.length - 1,
              s = !1;
            for (; i >= 0; --i)
              (a = o[i]),
                a._active
                  ? (a._total > n.duration && (n.duration = a._total),
                    a.tick(e),
                    (s = !0))
                  : ((o[i] = o[o.length - 1]), o.pop());
            s && (r.draw(), this._notify(r, n, e, "progress")),
              o.length ||
                ((n.running = !1),
                this._notify(r, n, e, "complete"),
                (n.initial = !1)),
              (t += o.length);
          }),
            (this._lastDate = e),
            0 === t && (this._running = !1);
        }
        _getAnims(e) {
          const t = this._charts;
          let n = t.get(e);
          return (
            n ||
              ((n = {
                running: !1,
                initial: !0,
                items: [],
                listeners: { complete: [], progress: [] },
              }),
              t.set(e, n)),
            n
          );
        }
        listen(e, t, n) {
          this._getAnims(e).listeners[t].push(n);
        }
        add(e, t) {
          t && t.length && this._getAnims(e).items.push(...t);
        }
        has(e) {
          return this._getAnims(e).items.length > 0;
        }
        start(e) {
          const t = this._charts.get(e);
          t &&
            ((t.running = !0),
            (t.start = Date.now()),
            (t.duration = t.items.reduce(
              (e, t) => Math.max(e, t._duration),
              0
            )),
            this._refresh());
        }
        running(e) {
          if (!this._running) return !1;
          const t = this._charts.get(e);
          return !!(t && t.running && t.items.length);
        }
        stop(e) {
          const t = this._charts.get(e);
          if (!t || !t.items.length) return;
          const n = t.items;
          let r = n.length - 1;
          for (; r >= 0; --r) n[r].cancel();
          (t.items = []), this._notify(e, t, Date.now(), "complete");
        }
        remove(e) {
          return this._charts.delete(e);
        }
      })();
      const kk = "transparent",
        Pk = {
          boolean(e, t, n) {
            return n > 0.5 ? t : e;
          },
          color(e, t, n) {
            const r = eS(e || kk),
              o = r.valid && eS(t || kk);
            return o && o.valid ? o.mix(r, n).hexString() : t;
          },
          number(e, t, n) {
            return e + (t - e) * n;
          },
        };
      class wk {
        constructor(e, t, n, r) {
          const o = t[n];
          r = MS([e.to, r, o, e.from]);
          const a = MS([e.from, o, r]);
          (this._active = !0),
            (this._fn = e.fn || Pk[e.type || typeof a]),
            (this._easing = Cx[e.easing] || Cx.linear),
            (this._start = Math.floor(Date.now() + (e.delay || 0))),
            (this._duration = this._total = Math.floor(e.duration)),
            (this._loop = !!e.loop),
            (this._target = t),
            (this._prop = n),
            (this._from = a),
            (this._to = r),
            (this._promises = void 0);
        }
        active() {
          return this._active;
        }
        update(e, t, n) {
          if (this._active) {
            this._notify(!1);
            const r = this._target[this._prop],
              o = n - this._start,
              a = this._duration - o;
            (this._start = n),
              (this._duration = Math.floor(Math.max(a, e.duration))),
              (this._total += o),
              (this._loop = !!e.loop),
              (this._to = MS([e.to, t, r, e.from])),
              (this._from = MS([e.from, r, t]));
          }
        }
        cancel() {
          this._active &&
            (this.tick(Date.now()), (this._active = !1), this._notify(!1));
        }
        tick(e) {
          const t = e - this._start,
            n = this._duration,
            r = this._prop,
            o = this._from,
            a = this._loop,
            i = this._to;
          let s;
          if (((this._active = o !== i && (a || t < n)), !this._active))
            return (this._target[r] = i), void this._notify(!0);
          t < 0
            ? (this._target[r] = o)
            : ((s = (t / n) % 2),
              (s = a && s > 1 ? 2 - s : s),
              (s = this._easing(Math.min(1, Math.max(0, s)))),
              (this._target[r] = this._fn(o, i, s)));
        }
        wait() {
          const e = this._promises || (this._promises = []);
          return new Promise((t, n) => {
            e.push({ res: t, rej: n });
          });
        }
        _notify(e) {
          const t = e ? "res" : "rej",
            n = this._promises || [];
          for (let e = 0; e < n.length; e++) n[e][t]();
        }
      }
      iS.set("animation", {
        delay: void 0,
        duration: 1e3,
        easing: "easeOutQuart",
        fn: void 0,
        from: void 0,
        loop: void 0,
        to: void 0,
        type: void 0,
      });
      const Ok = Object.keys(iS.animation);
      iS.describe("animation", {
        _fallback: !1,
        _indexable: !1,
        _scriptable: (e) =>
          "onProgress" !== e && "onComplete" !== e && "fn" !== e,
      }),
        iS.set("animations", {
          colors: {
            type: "color",
            properties: ["color", "borderColor", "backgroundColor"],
          },
          numbers: {
            type: "number",
            properties: ["x", "y", "borderWidth", "radius", "tension"],
          },
        }),
        iS.describe("animations", { _fallback: "animation" }),
        iS.set("transitions", {
          active: { animation: { duration: 400 } },
          resize: { animation: { duration: 0 } },
          show: {
            animations: {
              colors: { from: "transparent" },
              visible: { type: "boolean", duration: 0 },
            },
          },
          hide: {
            animations: {
              colors: { to: "transparent" },
              visible: { type: "boolean", easing: "linear", fn: (e) => 0 | e },
            },
          },
        });
      class Tk {
        constructor(e, t) {
          (this._chart = e), (this._properties = new Map()), this.configure(t);
        }
        configure(e) {
          if (!gC(e)) return;
          const t = this._properties;
          Object.getOwnPropertyNames(e).forEach((n) => {
            const r = e[n];
            if (!gC(r)) return;
            const o = {};
            for (const e of Ok) o[e] = r[e];
            ((fC(r.properties) && r.properties) || [n]).forEach((e) => {
              (e !== n && t.has(e)) || t.set(e, o);
            });
          });
        }
        _animateOptions(e, t) {
          const n = t.options,
            r = (function (e, t) {
              if (!t) return;
              let n = e.options;
              if (n)
                return (
                  n.$shared &&
                    (e.options = n =
                      Object.assign({}, n, { $shared: !1, $animations: {} })),
                  n
                );
              e.options = t;
            })(e, n);
          if (!r) return [];
          const o = this._createAnimations(r, n);
          return (
            n.$shared &&
              (function (e, t) {
                const n = [],
                  r = Object.keys(t);
                for (let t = 0; t < r.length; t++) {
                  const o = e[r[t]];
                  o && o.active() && n.push(o.wait());
                }
                return Promise.all(n);
              })(e.options.$animations, n).then(
                () => {
                  e.options = n;
                },
                () => {}
              ),
            o
          );
        }
        _createAnimations(e, t) {
          const n = this._properties,
            r = [],
            o = e.$animations || (e.$animations = {}),
            a = Object.keys(t),
            i = Date.now();
          let s;
          for (s = a.length - 1; s >= 0; --s) {
            const l = a[s];
            if ("$" === l.charAt(0)) continue;
            if ("options" === l) {
              r.push(...this._animateOptions(e, t));
              continue;
            }
            const d = t[l];
            let c = o[l];
            const u = n.get(l);
            if (c) {
              if (u && c.active()) {
                c.update(u, d, i);
                continue;
              }
              c.cancel();
            }
            u && u.duration
              ? ((o[l] = c = new wk(u, e, l, d)), r.push(c))
              : (e[l] = d);
          }
          return r;
        }
        update(e, t) {
          if (0 === this._properties.size) return void Object.assign(e, t);
          const n = this._createAnimations(e, t);
          return n.length ? (Sk.add(this._chart, n), !0) : void 0;
        }
      }
      function Ik(e, t) {
        const n = (e && e.options) || {},
          r = n.reverse,
          o = void 0 === n.min ? t : 0,
          a = void 0 === n.max ? t : 0;
        return { start: r ? a : o, end: r ? o : a };
      }
      function Mk(e, t) {
        const n = [],
          r = e._getSortedDatasetMetas(t);
        let o, a;
        for (o = 0, a = r.length; o < a; ++o) n.push(r[o].index);
        return n;
      }
      function jk(e, t, n, r = {}) {
        const o = e.keys,
          a = "single" === r.mode;
        let i, s, l, d;
        if (null !== t) {
          for (i = 0, s = o.length; i < s; ++i) {
            if (((l = +o[i]), l === n)) {
              if (r.all) continue;
              break;
            }
            (d = e.values[l]),
              vC(d) && (a || 0 === t || UC(t) === UC(d)) && (t += d);
          }
          return t;
        }
      }
      function Nk(e, t) {
        const n = e && e.options.stacked;
        return n || (void 0 === n && void 0 !== t.stack);
      }
      function Dk(e, t, n) {
        const r = e[t] || (e[t] = {});
        return r[n] || (r[n] = {});
      }
      function Ak(e, t, n, r) {
        for (const o of t.getMatchingVisibleMetas(r).reverse()) {
          const t = e[o.index];
          if ((n && t > 0) || (!n && t < 0)) return o.index;
        }
        return null;
      }
      function Ek(e, t) {
        const { chart: n, _cachedMeta: r } = e,
          o = n._stacks || (n._stacks = {}),
          { iScale: a, vScale: i, index: s } = r,
          l = a.axis,
          d = i.axis,
          c = (function (e, t, n) {
            return `${e.id}.${t.id}.${n.stack || n.type}`;
          })(a, i, r),
          u = t.length;
        let p;
        for (let e = 0; e < u; ++e) {
          const n = t[e],
            { [l]: a, [d]: u } = n;
          (p = (n._stacks || (n._stacks = {}))[d] = Dk(o, c, a)),
            (p[s] = u),
            (p._top = Ak(p, i, !0, r.type)),
            (p._bottom = Ak(p, i, !1, r.type));
        }
      }
      function Rk(e, t) {
        const n = e.scales;
        return Object.keys(n)
          .filter((e) => n[e].axis === t)
          .shift();
      }
      function Lk(e, t) {
        const n = e.controller.index,
          r = e.vScale && e.vScale.axis;
        if (r) {
          t = t || e._parsed;
          for (const e of t) {
            const t = e._stacks;
            if (!t || void 0 === t[r] || void 0 === t[r][n]) return;
            delete t[r][n];
          }
        }
      }
      const Bk = (e) => "reset" === e || "none" === e,
        zk = (e, t) => (t ? e : Object.assign({}, e));
      class Fk {
        constructor(e, t) {
          (this.chart = e),
            (this._ctx = e.ctx),
            (this.index = t),
            (this._cachedDataOpts = {}),
            (this._cachedMeta = this.getMeta()),
            (this._type = this._cachedMeta.type),
            (this.options = void 0),
            (this._parsing = !1),
            (this._data = void 0),
            (this._objectData = void 0),
            (this._sharedOptions = void 0),
            (this._drawStart = void 0),
            (this._drawCount = void 0),
            (this.enableOptionSharing = !1),
            (this.supportsDecimation = !1),
            (this.$context = void 0),
            (this._syncList = []),
            this.initialize();
        }
        initialize() {
          const e = this._cachedMeta;
          this.configure(),
            this.linkScales(),
            (e._stacked = Nk(e.vScale, e)),
            this.addElements();
        }
        updateIndex(e) {
          this.index !== e && Lk(this._cachedMeta), (this.index = e);
        }
        linkScales() {
          const e = this.chart,
            t = this._cachedMeta,
            n = this.getDataset(),
            r = (e, t, n, r) => ("x" === e ? t : "r" === e ? r : n),
            o = (t.xAxisID = _C(n.xAxisID, Rk(e, "x"))),
            a = (t.yAxisID = _C(n.yAxisID, Rk(e, "y"))),
            i = (t.rAxisID = _C(n.rAxisID, Rk(e, "r"))),
            s = t.indexAxis,
            l = (t.iAxisID = r(s, o, a, i)),
            d = (t.vAxisID = r(s, a, o, i));
          (t.xScale = this.getScaleForId(o)),
            (t.yScale = this.getScaleForId(a)),
            (t.rScale = this.getScaleForId(i)),
            (t.iScale = this.getScaleForId(l)),
            (t.vScale = this.getScaleForId(d));
        }
        getDataset() {
          return this.chart.data.datasets[this.index];
        }
        getMeta() {
          return this.chart.getDatasetMeta(this.index);
        }
        getScaleForId(e) {
          return this.chart.scales[e];
        }
        _getOtherScale(e) {
          const t = this._cachedMeta;
          return e === t.iScale ? t.vScale : t.iScale;
        }
        reset() {
          this._update("reset");
        }
        _destroy() {
          const e = this._cachedMeta;
          this._data && cx(this._data, this), e._stacked && Lk(e);
        }
        _dataCheck() {
          const e = this.getDataset(),
            t = e.data || (e.data = []),
            n = this._data;
          if (gC(t))
            this._data = (function (e) {
              const t = Object.keys(e),
                n = new Array(t.length);
              let r, o, a;
              for (r = 0, o = t.length; r < o; ++r)
                (a = t[r]), (n[r] = { x: a, y: e[a] });
              return n;
            })(t);
          else if (n !== t) {
            if (n) {
              cx(n, this);
              const e = this._cachedMeta;
              Lk(e), (e._parsed = []);
            }
            t &&
              Object.isExtensible(t) &&
              (this,
              (r = t)._chartjs
                ? r._chartjs.listeners.push(this)
                : (Object.defineProperty(r, "_chartjs", {
                    configurable: !0,
                    enumerable: !1,
                    value: { listeners: [this] },
                  }),
                  dx.forEach((e) => {
                    const t = "_onData" + NC(e),
                      n = r[e];
                    Object.defineProperty(r, e, {
                      configurable: !0,
                      enumerable: !1,
                      value(...e) {
                        const o = n.apply(this, e);
                        return (
                          r._chartjs.listeners.forEach((n) => {
                            "function" == typeof n[t] && n[t](...e);
                          }),
                          o
                        );
                      },
                    });
                  }))),
              (this._syncList = []),
              (this._data = t);
          }
          var r;
        }
        addElements() {
          const e = this._cachedMeta;
          this._dataCheck(),
            this.datasetElementType &&
              (e.dataset = new this.datasetElementType());
        }
        buildOrUpdateElements(e) {
          const t = this._cachedMeta,
            n = this.getDataset();
          let r = !1;
          this._dataCheck();
          const o = t._stacked;
          (t._stacked = Nk(t.vScale, t)),
            t.stack !== n.stack && ((r = !0), Lk(t), (t.stack = n.stack)),
            this._resyncElements(e),
            (r || o !== t._stacked) && Ek(this, t._parsed);
        }
        configure() {
          const e = this.chart.config,
            t = e.datasetScopeKeys(this._type),
            n = e.getOptionScopes(this.getDataset(), t, !0);
          (this.options = e.createResolver(n, this.getContext())),
            (this._parsing = this.options.parsing),
            (this._cachedDataOpts = {});
        }
        parse(e, t) {
          const { _cachedMeta: n, _data: r } = this,
            { iScale: o, _stacked: a } = n,
            i = o.axis;
          let s,
            l,
            d,
            c = (0 === e && t === r.length) || n._sorted,
            u = e > 0 && n._parsed[e - 1];
          if (!1 === this._parsing) (n._parsed = r), (n._sorted = !0), (d = r);
          else {
            d = fC(r[e])
              ? this.parseArrayData(n, r, e, t)
              : gC(r[e])
              ? this.parseObjectData(n, r, e, t)
              : this.parsePrimitiveData(n, r, e, t);
            const o = () => null === l[i] || (u && l[i] < u[i]);
            for (s = 0; s < t; ++s)
              (n._parsed[s + e] = l = d[s]), c && (o() && (c = !1), (u = l));
            n._sorted = c;
          }
          a && Ek(this, d);
        }
        parsePrimitiveData(e, t, n, r) {
          const { iScale: o, vScale: a } = e,
            i = o.axis,
            s = a.axis,
            l = o.getLabels(),
            d = o === a,
            c = new Array(r);
          let u, p, m;
          for (u = 0, p = r; u < p; ++u)
            (m = u + n),
              (c[u] = { [i]: d || o.parse(l[m], m), [s]: a.parse(t[m], m) });
          return c;
        }
        parseArrayData(e, t, n, r) {
          const { xScale: o, yScale: a } = e,
            i = new Array(r);
          let s, l, d, c;
          for (s = 0, l = r; s < l; ++s)
            (d = s + n),
              (c = t[d]),
              (i[s] = { x: o.parse(c[0], d), y: a.parse(c[1], d) });
          return i;
        }
        parseObjectData(e, t, n, r) {
          const { xScale: o, yScale: a } = e,
            { xAxisKey: i = "x", yAxisKey: s = "y" } = this._parsing,
            l = new Array(r);
          let d, c, u, p;
          for (d = 0, c = r; d < c; ++d)
            (u = d + n),
              (p = t[u]),
              (l[d] = { x: o.parse(jC(p, i), u), y: a.parse(jC(p, s), u) });
          return l;
        }
        getParsed(e) {
          return this._cachedMeta._parsed[e];
        }
        getDataElement(e) {
          return this._cachedMeta.data[e];
        }
        applyStack(e, t, n) {
          const r = this.chart,
            o = this._cachedMeta,
            a = t[e.axis];
          return jk(
            { keys: Mk(r, !0), values: t._stacks[e.axis] },
            a,
            o.index,
            { mode: n }
          );
        }
        updateRangeFromParsed(e, t, n, r) {
          const o = n[t.axis];
          let a = null === o ? NaN : o;
          const i = r && n._stacks[t.axis];
          r && i && ((r.values = i), (a = jk(r, o, this._cachedMeta.index))),
            (e.min = Math.min(e.min, a)),
            (e.max = Math.max(e.max, a));
        }
        getMinMax(e, t) {
          const n = this._cachedMeta,
            r = n._parsed,
            o = n._sorted && e === n.iScale,
            a = r.length,
            i = this._getOtherScale(e),
            s = ((e, t, n) =>
              e &&
              !t.hidden &&
              t._stacked && { keys: Mk(n, !0), values: null })(
              t,
              n,
              this.chart
            ),
            l = {
              min: Number.POSITIVE_INFINITY,
              max: Number.NEGATIVE_INFINITY,
            },
            { min: d, max: c } = (function (e) {
              const {
                min: t,
                max: n,
                minDefined: r,
                maxDefined: o,
              } = e.getUserBounds();
              return {
                min: r ? t : Number.NEGATIVE_INFINITY,
                max: o ? n : Number.POSITIVE_INFINITY,
              };
            })(i);
          let u, p;
          function m() {
            p = r[u];
            const t = p[i.axis];
            return !vC(p[e.axis]) || d > t || c < t;
          }
          for (
            u = 0;
            u < a && (m() || (this.updateRangeFromParsed(l, e, p, s), !o));
            ++u
          );
          if (o)
            for (u = a - 1; u >= 0; --u)
              if (!m()) {
                this.updateRangeFromParsed(l, e, p, s);
                break;
              }
          return l;
        }
        getAllParsedValues(e) {
          const t = this._cachedMeta._parsed,
            n = [];
          let r, o, a;
          for (r = 0, o = t.length; r < o; ++r)
            (a = t[r][e.axis]), vC(a) && n.push(a);
          return n;
        }
        getMaxOverflow() {
          return !1;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = t.iScale,
            r = t.vScale,
            o = this.getParsed(e);
          return {
            label: n ? "" + n.getLabelForValue(o[n.axis]) : "",
            value: r ? "" + r.getLabelForValue(o[r.axis]) : "",
          };
        }
        _update(e) {
          const t = this._cachedMeta;
          this.update(e || "default"),
            (t._clip = (function (e) {
              let t, n, r, o;
              return (
                gC(e)
                  ? ((t = e.top), (n = e.right), (r = e.bottom), (o = e.left))
                  : (t = n = r = o = e),
                { top: t, right: n, bottom: r, left: o, disabled: !1 === e }
              );
            })(
              _C(
                this.options.clip,
                (function (e, t, n) {
                  if (!1 === n) return !1;
                  const r = Ik(e, n),
                    o = Ik(t, n);
                  return {
                    top: o.end,
                    right: r.end,
                    bottom: o.start,
                    left: r.start,
                  };
                })(t.xScale, t.yScale, this.getMaxOverflow())
              )
            ));
        }
        update(e) {}
        draw() {
          const e = this._ctx,
            t = this.chart,
            n = this._cachedMeta,
            r = n.data || [],
            o = t.chartArea,
            a = [],
            i = this._drawStart || 0,
            s = this._drawCount || r.length - i,
            l = this.options.drawActiveElementsOnTop;
          let d;
          for (n.dataset && n.dataset.draw(e, o, i, s), d = i; d < i + s; ++d) {
            const t = r[d];
            t.hidden || (t.active && l ? a.push(t) : t.draw(e, o));
          }
          for (d = 0; d < a.length; ++d) a[d].draw(e, o);
        }
        getStyle(e, t) {
          const n = t ? "active" : "default";
          return void 0 === e && this._cachedMeta.dataset
            ? this.resolveDatasetElementOptions(n)
            : this.resolveDataElementOptions(e || 0, n);
        }
        getContext(e, t, n) {
          const r = this.getDataset();
          let o;
          if (e >= 0 && e < this._cachedMeta.data.length) {
            const t = this._cachedMeta.data[e];
            (o =
              t.$context ||
              (t.$context = (function (e, t, n) {
                return jS(e, {
                  active: !1,
                  dataIndex: t,
                  parsed: void 0,
                  raw: void 0,
                  element: n,
                  index: t,
                  mode: "default",
                  type: "data",
                });
              })(this.getContext(), e, t))),
              (o.parsed = this.getParsed(e)),
              (o.raw = r.data[e]),
              (o.index = o.dataIndex = e);
          } else
            (o =
              this.$context ||
              (this.$context = (function (e, t) {
                return jS(e, {
                  active: !1,
                  dataset: void 0,
                  datasetIndex: t,
                  index: t,
                  mode: "default",
                  type: "dataset",
                });
              })(this.chart.getContext(), this.index))),
              (o.dataset = r),
              (o.index = o.datasetIndex = this.index);
          return (o.active = !!t), (o.mode = n), o;
        }
        resolveDatasetElementOptions(e) {
          return this._resolveElementOptions(this.datasetElementType.id, e);
        }
        resolveDataElementOptions(e, t) {
          return this._resolveElementOptions(this.dataElementType.id, t, e);
        }
        _resolveElementOptions(e, t = "default", n) {
          const r = "active" === t,
            o = this._cachedDataOpts,
            a = e + "-" + t,
            i = o[a],
            s = this.enableOptionSharing && DC(n);
          if (i) return zk(i, s);
          const l = this.chart.config,
            d = l.datasetElementScopeKeys(this._type, e),
            c = r ? [`${e}Hover`, "hover", e, ""] : [e, ""],
            u = l.getOptionScopes(this.getDataset(), d),
            p = Object.keys(iS.elements[e]),
            m = l.resolveNamedOptions(u, p, () => this.getContext(n, r), c);
          return (
            m.$shared && ((m.$shared = s), (o[a] = Object.freeze(zk(m, s)))), m
          );
        }
        _resolveAnimations(e, t, n) {
          const r = this.chart,
            o = this._cachedDataOpts,
            a = `animation-${t}`,
            i = o[a];
          if (i) return i;
          let s;
          if (!1 !== r.options.animation) {
            const r = this.chart.config,
              o = r.datasetAnimationScopeKeys(this._type, t),
              a = r.getOptionScopes(this.getDataset(), o);
            s = r.createResolver(a, this.getContext(e, n, t));
          }
          const l = new Tk(r, s && s.animations);
          return s && s._cacheable && (o[a] = Object.freeze(l)), l;
        }
        getSharedOptions(e) {
          if (e.$shared)
            return (
              this._sharedOptions ||
              (this._sharedOptions = Object.assign({}, e))
            );
        }
        includeOptions(e, t) {
          return !t || Bk(e) || this.chart._animationsDisabled;
        }
        _getSharedOptions(e, t) {
          const n = this.resolveDataElementOptions(e, t),
            r = this._sharedOptions,
            o = this.getSharedOptions(n),
            a = this.includeOptions(t, o) || o !== r;
          return (
            this.updateSharedOptions(o, t, n),
            { sharedOptions: o, includeOptions: a }
          );
        }
        updateElement(e, t, n, r) {
          Bk(r)
            ? Object.assign(e, n)
            : this._resolveAnimations(t, r).update(e, n);
        }
        updateSharedOptions(e, t, n) {
          e && !Bk(t) && this._resolveAnimations(void 0, t).update(e, n);
        }
        _setStyle(e, t, n, r) {
          e.active = r;
          const o = this.getStyle(t, r);
          this._resolveAnimations(t, n, r).update(e, {
            options: (!r && this.getSharedOptions(o)) || o,
          });
        }
        removeHoverStyle(e, t, n) {
          this._setStyle(e, n, "active", !1);
        }
        setHoverStyle(e, t, n) {
          this._setStyle(e, n, "active", !0);
        }
        _removeDatasetHoverStyle() {
          const e = this._cachedMeta.dataset;
          e && this._setStyle(e, void 0, "active", !1);
        }
        _setDatasetHoverStyle() {
          const e = this._cachedMeta.dataset;
          e && this._setStyle(e, void 0, "active", !0);
        }
        _resyncElements(e) {
          const t = this._data,
            n = this._cachedMeta.data;
          for (const [e, t, n] of this._syncList) this[e](t, n);
          this._syncList = [];
          const r = n.length,
            o = t.length,
            a = Math.min(o, r);
          a && this.parse(0, a),
            o > r
              ? this._insertElements(r, o - r, e)
              : o < r && this._removeElements(o, r - o);
        }
        _insertElements(e, t, n = !0) {
          const r = this._cachedMeta,
            o = r.data,
            a = e + t;
          let i;
          const s = (e) => {
            for (e.length += t, i = e.length - 1; i >= a; i--) e[i] = e[i - t];
          };
          for (s(o), i = e; i < a; ++i) o[i] = new this.dataElementType();
          this._parsing && s(r._parsed),
            this.parse(e, t),
            n && this.updateElements(o, e, t, "reset");
        }
        updateElements(e, t, n, r) {}
        _removeElements(e, t) {
          const n = this._cachedMeta;
          if (this._parsing) {
            const r = n._parsed.splice(e, t);
            n._stacked && Lk(n, r);
          }
          n.data.splice(e, t);
        }
        _sync(e) {
          if (this._parsing) this._syncList.push(e);
          else {
            const [t, n, r] = e;
            this[t](n, r);
          }
          this.chart._dataChanges.push([this.index, ...e]);
        }
        _onDataPush() {
          const e = arguments.length;
          this._sync(["_insertElements", this.getDataset().data.length - e, e]);
        }
        _onDataPop() {
          this._sync(["_removeElements", this._cachedMeta.data.length - 1, 1]);
        }
        _onDataShift() {
          this._sync(["_removeElements", 0, 1]);
        }
        _onDataSplice(e, t) {
          t && this._sync(["_removeElements", e, t]);
          const n = arguments.length - 2;
          n && this._sync(["_insertElements", e, n]);
        }
        _onDataUnshift() {
          this._sync(["_insertElements", 0, arguments.length]);
        }
      }
      function Zk(e) {
        const t = e.iScale,
          n = (function (e, t) {
            if (!e._cache.$bar) {
              const n = e.getMatchingVisibleMetas(t);
              let r = [];
              for (let t = 0, o = n.length; t < o; t++)
                r = r.concat(n[t].controller.getAllParsedValues(e));
              e._cache.$bar = ux(r.sort((e, t) => e - t));
            }
            return e._cache.$bar;
          })(t, e.type);
        let r,
          o,
          a,
          i,
          s = t._length;
        const l = () => {
          32767 !== a &&
            -32768 !== a &&
            (DC(i) && (s = Math.min(s, Math.abs(a - i) || s)), (i = a));
        };
        for (r = 0, o = n.length; r < o; ++r)
          (a = t.getPixelForValue(n[r])), l();
        for (i = void 0, r = 0, o = t.ticks.length; r < o; ++r)
          (a = t.getPixelForTick(r)), l();
        return s;
      }
      function Hk(e, t, n, r) {
        return (
          fC(e)
            ? (function (e, t, n, r) {
                const o = n.parse(e[0], r),
                  a = n.parse(e[1], r),
                  i = Math.min(o, a),
                  s = Math.max(o, a);
                let l = i,
                  d = s;
                Math.abs(i) > Math.abs(s) && ((l = s), (d = i)),
                  (t[n.axis] = d),
                  (t._custom = {
                    barStart: l,
                    barEnd: d,
                    start: o,
                    end: a,
                    min: i,
                    max: s,
                  });
              })(e, t, n, r)
            : (t[n.axis] = n.parse(e, r)),
          t
        );
      }
      function Vk(e, t, n, r) {
        const o = e.iScale,
          a = e.vScale,
          i = o.getLabels(),
          s = o === a,
          l = [];
        let d, c, u, p;
        for (d = n, c = n + r; d < c; ++d)
          (p = t[d]),
            (u = {}),
            (u[o.axis] = s || o.parse(i[d], d)),
            l.push(Hk(p, u, a, d));
        return l;
      }
      function Wk(e) {
        return e && void 0 !== e.barStart && void 0 !== e.barEnd;
      }
      function Uk(e, t, n, r) {
        let o = t.borderSkipped;
        const a = {};
        if (!o) return void (e.borderSkipped = a);
        if (!0 === o)
          return void (e.borderSkipped = {
            top: !0,
            right: !0,
            bottom: !0,
            left: !0,
          });
        const {
          start: i,
          end: s,
          reverse: l,
          top: d,
          bottom: c,
        } = (function (e) {
          let t, n, r, o, a;
          return (
            e.horizontal
              ? ((t = e.base > e.x), (n = "left"), (r = "right"))
              : ((t = e.base < e.y), (n = "bottom"), (r = "top")),
            t ? ((o = "end"), (a = "start")) : ((o = "start"), (a = "end")),
            { start: n, end: r, reverse: t, top: o, bottom: a }
          );
        })(e);
        "middle" === o &&
          n &&
          ((e.enableBorderRadius = !0),
          (n._top || 0) === r
            ? (o = d)
            : (n._bottom || 0) === r
            ? (o = c)
            : ((a[$k(c, i, s, l)] = !0), (o = d))),
          (a[$k(o, i, s, l)] = !0),
          (e.borderSkipped = a);
      }
      function $k(e, t, n, r) {
        var o, a, i;
        return (
          r
            ? ((i = n),
              (e = Kk((e = (o = e) === (a = t) ? i : o === i ? a : o), n, t)))
            : (e = Kk(e, t, n)),
          e
        );
      }
      function Kk(e, t, n) {
        return "start" === e ? t : "end" === e ? n : e;
      }
      function Gk(e, { inflateAmount: t }, n) {
        e.inflateAmount = "auto" === t ? (1 === n ? 0.33 : 0) : t;
      }
      (Fk.defaults = {}),
        (Fk.prototype.datasetElementType = null),
        (Fk.prototype.dataElementType = null);
      class qk extends Fk {
        parsePrimitiveData(e, t, n, r) {
          return Vk(e, t, n, r);
        }
        parseArrayData(e, t, n, r) {
          return Vk(e, t, n, r);
        }
        parseObjectData(e, t, n, r) {
          const { iScale: o, vScale: a } = e,
            { xAxisKey: i = "x", yAxisKey: s = "y" } = this._parsing,
            l = "x" === o.axis ? i : s,
            d = "x" === a.axis ? i : s,
            c = [];
          let u, p, m, h;
          for (u = n, p = n + r; u < p; ++u)
            (h = t[u]),
              (m = {}),
              (m[o.axis] = o.parse(jC(h, l), u)),
              c.push(Hk(jC(h, d), m, a, u));
          return c;
        }
        updateRangeFromParsed(e, t, n, r) {
          super.updateRangeFromParsed(e, t, n, r);
          const o = n._custom;
          o &&
            t === this._cachedMeta.vScale &&
            ((e.min = Math.min(e.min, o.min)),
            (e.max = Math.max(e.max, o.max)));
        }
        getMaxOverflow() {
          return 0;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            { iScale: n, vScale: r } = t,
            o = this.getParsed(e),
            a = o._custom,
            i = Wk(a)
              ? "[" + a.start + ", " + a.end + "]"
              : "" + r.getLabelForValue(o[r.axis]);
          return { label: "" + n.getLabelForValue(o[n.axis]), value: i };
        }
        initialize() {
          (this.enableOptionSharing = !0),
            super.initialize(),
            (this._cachedMeta.stack = this.getDataset().stack);
        }
        update(e) {
          const t = this._cachedMeta;
          this.updateElements(t.data, 0, t.data.length, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              index: a,
              _cachedMeta: { vScale: i },
            } = this,
            s = i.getBasePixel(),
            l = i.isHorizontal(),
            d = this._getRuler(),
            { sharedOptions: c, includeOptions: u } = this._getSharedOptions(
              t,
              r
            );
          for (let p = t; p < t + n; p++) {
            const t = this.getParsed(p),
              n =
                o || hC(t[i.axis])
                  ? { base: s, head: s }
                  : this._calculateBarValuePixels(p),
              m = this._calculateBarIndexPixels(p, d),
              h = (t._stacks || {})[i.axis],
              f = {
                horizontal: l,
                base: n.base,
                enableBorderRadius:
                  !h || Wk(t._custom) || a === h._top || a === h._bottom,
                x: l ? n.head : m.center,
                y: l ? m.center : n.head,
                height: l ? m.size : Math.abs(n.size),
                width: l ? Math.abs(n.size) : m.size,
              };
            u &&
              (f.options =
                c ||
                this.resolveDataElementOptions(p, e[p].active ? "active" : r));
            const g = f.options || e[p].options;
            Uk(f, g, h, a),
              Gk(f, g, d.ratio),
              this.updateElement(e[p], p, f, r);
          }
        }
        _getStacks(e, t) {
          const { iScale: n } = this._cachedMeta,
            r = n
              .getMatchingVisibleMetas(this._type)
              .filter((e) => e.controller.options.grouped),
            o = n.options.stacked,
            a = [],
            i = (e) => {
              const n = e.controller.getParsed(t),
                r = n && n[e.vScale.axis];
              if (hC(r) || isNaN(r)) return !0;
            };
          for (const n of r)
            if (
              (void 0 === t || !i(n)) &&
              ((!1 === o ||
                -1 === a.indexOf(n.stack) ||
                (void 0 === o && void 0 === n.stack)) &&
                a.push(n.stack),
              n.index === e)
            )
              break;
          return a.length || a.push(void 0), a;
        }
        _getStackCount(e) {
          return this._getStacks(void 0, e).length;
        }
        _getStackIndex(e, t, n) {
          const r = this._getStacks(e, n),
            o = void 0 !== t ? r.indexOf(t) : -1;
          return -1 === o ? r.length - 1 : o;
        }
        _getRuler() {
          const e = this.options,
            t = this._cachedMeta,
            n = t.iScale,
            r = [];
          let o, a;
          for (o = 0, a = t.data.length; o < a; ++o)
            r.push(n.getPixelForValue(this.getParsed(o)[n.axis], o));
          const i = e.barThickness;
          return {
            min: i || Zk(t),
            pixels: r,
            start: n._startPixel,
            end: n._endPixel,
            stackCount: this._getStackCount(),
            scale: n,
            grouped: e.grouped,
            ratio: i ? 1 : e.categoryPercentage * e.barPercentage,
          };
        }
        _calculateBarValuePixels(e) {
          const {
              _cachedMeta: { vScale: t, _stacked: n },
              options: { base: r, minBarLength: o },
            } = this,
            a = r || 0,
            i = this.getParsed(e),
            s = i._custom,
            l = Wk(s);
          let d,
            c,
            u = i[t.axis],
            p = 0,
            m = n ? this.applyStack(t, i, n) : u;
          m !== u && ((p = m - u), (m = u)),
            l &&
              ((u = s.barStart),
              (m = s.barEnd - s.barStart),
              0 !== u && UC(u) !== UC(s.barEnd) && (p = 0),
              (p += u));
          const h = hC(r) || l ? p : r;
          let f = t.getPixelForValue(h);
          if (
            ((d = this.chart.getDataVisibility(e)
              ? t.getPixelForValue(p + m)
              : f),
            (c = d - f),
            Math.abs(c) < o)
          ) {
            (c =
              (function (e, t, n) {
                return 0 !== e
                  ? UC(e)
                  : (t.isHorizontal() ? 1 : -1) * (t.min >= n ? 1 : -1);
              })(c, t, a) * o),
              u === a && (f -= c / 2);
            const e = t.getPixelForDecimal(0),
              n = t.getPixelForDecimal(1),
              r = Math.min(e, n),
              i = Math.max(e, n);
            (f = Math.max(Math.min(f, i), r)), (d = f + c);
          }
          if (f === t.getPixelForValue(a)) {
            const e = (UC(c) * t.getLineWidthForValue(a)) / 2;
            (f += e), (c -= e);
          }
          return { size: c, base: f, head: d, center: d + c / 2 };
        }
        _calculateBarIndexPixels(e, t) {
          const n = t.scale,
            r = this.options,
            o = r.skipNull,
            a = _C(r.maxBarThickness, 1 / 0);
          let i, s;
          if (t.grouped) {
            const n = o ? this._getStackCount(e) : t.stackCount,
              l =
                "flex" === r.barThickness
                  ? (function (e, t, n, r) {
                      const o = t.pixels,
                        a = o[e];
                      let i = e > 0 ? o[e - 1] : null,
                        s = e < o.length - 1 ? o[e + 1] : null;
                      const l = n.categoryPercentage;
                      null === i &&
                        (i = a - (null === s ? t.end - t.start : s - a)),
                        null === s && (s = a + a - i);
                      const d = a - ((a - Math.min(i, s)) / 2) * l;
                      return {
                        chunk: ((Math.abs(s - i) / 2) * l) / r,
                        ratio: n.barPercentage,
                        start: d,
                      };
                    })(e, t, r, n)
                  : (function (e, t, n, r) {
                      const o = n.barThickness;
                      let a, i;
                      return (
                        hC(o)
                          ? ((a = t.min * n.categoryPercentage),
                            (i = n.barPercentage))
                          : ((a = o * r), (i = 1)),
                        { chunk: a / r, ratio: i, start: t.pixels[e] - a / 2 }
                      );
                    })(e, t, r, n),
              d = this._getStackIndex(
                this.index,
                this._cachedMeta.stack,
                o ? e : void 0
              );
            (i = l.start + l.chunk * d + l.chunk / 2),
              (s = Math.min(a, l.chunk * l.ratio));
          } else
            (i = n.getPixelForValue(this.getParsed(e)[n.axis], e)),
              (s = Math.min(a, t.min * t.ratio));
          return { base: i - s / 2, head: i + s / 2, center: i, size: s };
        }
        draw() {
          const e = this._cachedMeta,
            t = e.vScale,
            n = e.data,
            r = n.length;
          let o = 0;
          for (; o < r; ++o)
            null !== this.getParsed(o)[t.axis] && n[o].draw(this._ctx);
        }
      }
      (qk.id = "bar"),
        (qk.defaults = {
          datasetElementType: !1,
          dataElementType: "bar",
          categoryPercentage: 0.8,
          barPercentage: 0.9,
          grouped: !0,
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "base", "width", "height"],
            },
          },
        }),
        (qk.overrides = {
          scales: {
            _index_: { type: "category", offset: !0, grid: { offset: !0 } },
            _value_: { type: "linear", beginAtZero: !0 },
          },
        });
      class Qk extends Fk {
        initialize() {
          (this.enableOptionSharing = !0), super.initialize();
        }
        parsePrimitiveData(e, t, n, r) {
          const o = super.parsePrimitiveData(e, t, n, r);
          for (let e = 0; e < o.length; e++)
            o[e]._custom = this.resolveDataElementOptions(e + n).radius;
          return o;
        }
        parseArrayData(e, t, n, r) {
          const o = super.parseArrayData(e, t, n, r);
          for (let e = 0; e < o.length; e++) {
            const r = t[n + e];
            o[e]._custom = _C(
              r[2],
              this.resolveDataElementOptions(e + n).radius
            );
          }
          return o;
        }
        parseObjectData(e, t, n, r) {
          const o = super.parseObjectData(e, t, n, r);
          for (let e = 0; e < o.length; e++) {
            const r = t[n + e];
            o[e]._custom = _C(
              r && r.r && +r.r,
              this.resolveDataElementOptions(e + n).radius
            );
          }
          return o;
        }
        getMaxOverflow() {
          const e = this._cachedMeta.data;
          let t = 0;
          for (let n = e.length - 1; n >= 0; --n)
            t = Math.max(t, e[n].size(this.resolveDataElementOptions(n)) / 2);
          return t > 0 && t;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            { xScale: n, yScale: r } = t,
            o = this.getParsed(e),
            a = n.getLabelForValue(o.x),
            i = r.getLabelForValue(o.y),
            s = o._custom;
          return {
            label: t.label,
            value: "(" + a + ", " + i + (s ? ", " + s : "") + ")",
          };
        }
        update(e) {
          const t = this._cachedMeta.data;
          this.updateElements(t, 0, t.length, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            { iScale: a, vScale: i } = this._cachedMeta,
            { sharedOptions: s, includeOptions: l } = this._getSharedOptions(
              t,
              r
            ),
            d = a.axis,
            c = i.axis;
          for (let u = t; u < t + n; u++) {
            const t = e[u],
              n = !o && this.getParsed(u),
              p = {},
              m = (p[d] = o
                ? a.getPixelForDecimal(0.5)
                : a.getPixelForValue(n[d])),
              h = (p[c] = o ? i.getBasePixel() : i.getPixelForValue(n[c]));
            (p.skip = isNaN(m) || isNaN(h)),
              l &&
                ((p.options =
                  s ||
                  this.resolveDataElementOptions(u, t.active ? "active" : r)),
                o && (p.options.radius = 0)),
              this.updateElement(t, u, p, r);
          }
        }
        resolveDataElementOptions(e, t) {
          const n = this.getParsed(e);
          let r = super.resolveDataElementOptions(e, t);
          r.$shared && (r = Object.assign({}, r, { $shared: !1 }));
          const o = r.radius;
          return (
            "active" !== t && (r.radius = 0),
            (r.radius += _C(n && n._custom, o)),
            r
          );
        }
      }
      (Qk.id = "bubble"),
        (Qk.defaults = {
          datasetElementType: !1,
          dataElementType: "point",
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "borderWidth", "radius"],
            },
          },
        }),
        (Qk.overrides = {
          scales: { x: { type: "linear" }, y: { type: "linear" } },
          plugins: {
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
              },
            },
          },
        });
      class Yk extends Fk {
        constructor(e, t) {
          super(e, t),
            (this.enableOptionSharing = !0),
            (this.innerRadius = void 0),
            (this.outerRadius = void 0),
            (this.offsetX = void 0),
            (this.offsetY = void 0);
        }
        linkScales() {}
        parse(e, t) {
          const n = this.getDataset().data,
            r = this._cachedMeta;
          if (!1 === this._parsing) r._parsed = n;
          else {
            let o,
              a,
              i = (e) => +n[e];
            if (gC(n[e])) {
              const { key: e = "value" } = this._parsing;
              i = (t) => +jC(n[t], e);
            }
            for (o = e, a = e + t; o < a; ++o) r._parsed[o] = i(o);
          }
        }
        _getRotation() {
          return QC(this.options.rotation - 90);
        }
        _getCircumference() {
          return QC(this.options.circumference);
        }
        _getRotationExtents() {
          let e = LC,
            t = -LC;
          for (let n = 0; n < this.chart.data.datasets.length; ++n)
            if (this.chart.isDatasetVisible(n)) {
              const r = this.chart.getDatasetMeta(n).controller,
                o = r._getRotation(),
                a = r._getCircumference();
              (e = Math.min(e, o)), (t = Math.max(t, o + a));
            }
          return { rotation: e, circumference: t - e };
        }
        update(e) {
          const t = this.chart,
            { chartArea: n } = t,
            r = this._cachedMeta,
            o = r.data,
            a =
              this.getMaxBorderWidth() +
              this.getMaxOffset(o) +
              this.options.spacing,
            i = Math.max((Math.min(n.width, n.height) - a) / 2, 0),
            s = Math.min(
              ((d = i),
              "string" == typeof (l = this.options.cutout) && l.endsWith("%")
                ? parseFloat(l) / 100
                : l / d),
              1
            );
          var l, d;
          const c = this._getRingWeight(this.index),
            { circumference: u, rotation: p } = this._getRotationExtents(),
            {
              ratioX: m,
              ratioY: h,
              offsetX: f,
              offsetY: g,
            } = (function (e, t, n) {
              let r = 1,
                o = 1,
                a = 0,
                i = 0;
              if (t < LC) {
                const s = e,
                  l = s + t,
                  d = Math.cos(s),
                  c = Math.sin(s),
                  u = Math.cos(l),
                  p = Math.sin(l),
                  m = (e, t, r) =>
                    rx(e, s, l, !0) ? 1 : Math.max(t, t * n, r, r * n),
                  h = (e, t, r) =>
                    rx(e, s, l, !0) ? -1 : Math.min(t, t * n, r, r * n),
                  f = m(0, d, u),
                  g = m(ZC, c, p),
                  v = h(RC, d, u),
                  b = h(RC + ZC, c, p);
                (r = (f - v) / 2),
                  (o = (g - b) / 2),
                  (a = -(f + v) / 2),
                  (i = -(g + b) / 2);
              }
              return { ratioX: r, ratioY: o, offsetX: a, offsetY: i };
            })(p, u, s),
            v = (n.width - a) / m,
            b = (n.height - a) / h,
            _ = Math.max(Math.min(v, b) / 2, 0),
            y = yC(this.options.radius, _),
            C = (y - Math.max(y * s, 0)) / this._getVisibleDatasetWeightTotal();
          (this.offsetX = f * y),
            (this.offsetY = g * y),
            (r.total = this.calculateTotal()),
            (this.outerRadius = y - C * this._getRingWeightOffset(this.index)),
            (this.innerRadius = Math.max(this.outerRadius - C * c, 0)),
            this.updateElements(o, 0, o.length, e);
        }
        _circumference(e, t) {
          const n = this.options,
            r = this._cachedMeta,
            o = this._getCircumference();
          return (t && n.animation.animateRotate) ||
            !this.chart.getDataVisibility(e) ||
            null === r._parsed[e] ||
            r.data[e].hidden
            ? 0
            : this.calculateCircumference((r._parsed[e] * o) / LC);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            a = this.chart,
            i = a.chartArea,
            s = a.options.animation,
            l = (i.left + i.right) / 2,
            d = (i.top + i.bottom) / 2,
            c = o && s.animateScale,
            u = c ? 0 : this.innerRadius,
            p = c ? 0 : this.outerRadius,
            { sharedOptions: m, includeOptions: h } = this._getSharedOptions(
              t,
              r
            );
          let f,
            g = this._getRotation();
          for (f = 0; f < t; ++f) g += this._circumference(f, o);
          for (f = t; f < t + n; ++f) {
            const t = this._circumference(f, o),
              n = e[f],
              a = {
                x: l + this.offsetX,
                y: d + this.offsetY,
                startAngle: g,
                endAngle: g + t,
                circumference: t,
                outerRadius: p,
                innerRadius: u,
              };
            h &&
              (a.options =
                m ||
                this.resolveDataElementOptions(f, n.active ? "active" : r)),
              (g += t),
              this.updateElement(n, f, a, r);
          }
        }
        calculateTotal() {
          const e = this._cachedMeta,
            t = e.data;
          let n,
            r = 0;
          for (n = 0; n < t.length; n++) {
            const o = e._parsed[n];
            null === o ||
              isNaN(o) ||
              !this.chart.getDataVisibility(n) ||
              t[n].hidden ||
              (r += Math.abs(o));
          }
          return r;
        }
        calculateCircumference(e) {
          const t = this._cachedMeta.total;
          return t > 0 && !isNaN(e) ? LC * (Math.abs(e) / t) : 0;
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = this.chart,
            r = n.data.labels || [],
            o = hk(t._parsed[e], n.options.locale);
          return { label: r[e] || "", value: o };
        }
        getMaxBorderWidth(e) {
          let t = 0;
          const n = this.chart;
          let r, o, a, i, s;
          if (!e)
            for (r = 0, o = n.data.datasets.length; r < o; ++r)
              if (n.isDatasetVisible(r)) {
                (a = n.getDatasetMeta(r)), (e = a.data), (i = a.controller);
                break;
              }
          if (!e) return 0;
          for (r = 0, o = e.length; r < o; ++r)
            (s = i.resolveDataElementOptions(r)),
              "inner" !== s.borderAlign &&
                (t = Math.max(t, s.borderWidth || 0, s.hoverBorderWidth || 0));
          return t;
        }
        getMaxOffset(e) {
          let t = 0;
          for (let n = 0, r = e.length; n < r; ++n) {
            const e = this.resolveDataElementOptions(n);
            t = Math.max(t, e.offset || 0, e.hoverOffset || 0);
          }
          return t;
        }
        _getRingWeightOffset(e) {
          let t = 0;
          for (let n = 0; n < e; ++n)
            this.chart.isDatasetVisible(n) && (t += this._getRingWeight(n));
          return t;
        }
        _getRingWeight(e) {
          return Math.max(_C(this.chart.data.datasets[e].weight, 1), 0);
        }
        _getVisibleDatasetWeightTotal() {
          return (
            this._getRingWeightOffset(this.chart.data.datasets.length) || 1
          );
        }
      }
      (Yk.id = "doughnut"),
        (Yk.defaults = {
          datasetElementType: !1,
          dataElementType: "arc",
          animation: { animateRotate: !0, animateScale: !1 },
          animations: {
            numbers: {
              type: "number",
              properties: [
                "circumference",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "startAngle",
                "x",
                "y",
                "offset",
                "borderWidth",
                "spacing",
              ],
            },
          },
          cutout: "50%",
          rotation: 0,
          circumference: 360,
          radius: "100%",
          spacing: 0,
          indexAxis: "r",
        }),
        (Yk.descriptors = {
          _scriptable: (e) => "spacing" !== e,
          _indexable: (e) => "spacing" !== e,
        }),
        (Yk.overrides = {
          aspectRatio: 1,
          plugins: {
            legend: {
              labels: {
                generateLabels(e) {
                  const t = e.data;
                  if (t.labels.length && t.datasets.length) {
                    const {
                      labels: { pointStyle: n },
                    } = e.legend.options;
                    return t.labels.map((t, r) => {
                      const o = e.getDatasetMeta(0).controller.getStyle(r);
                      return {
                        text: t,
                        fillStyle: o.backgroundColor,
                        strokeStyle: o.borderColor,
                        lineWidth: o.borderWidth,
                        pointStyle: n,
                        hidden: !e.getDataVisibility(r),
                        index: r,
                      };
                    });
                  }
                  return [];
                },
              },
              onClick(e, t, n) {
                n.chart.toggleDataVisibility(t.index), n.chart.update();
              },
            },
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  let t = e.label;
                  const n = ": " + e.formattedValue;
                  return fC(t) ? ((t = t.slice()), (t[0] += n)) : (t += n), t;
                },
              },
            },
          },
        });
      class Jk extends Fk {
        initialize() {
          (this.enableOptionSharing = !0),
            (this.supportsDecimation = !0),
            super.initialize();
        }
        update(e) {
          const t = this._cachedMeta,
            { dataset: n, data: r = [], _dataset: o } = t,
            a = this.chart._animationsDisabled;
          let { start: i, count: s } = gx(t, r, a);
          (this._drawStart = i),
            (this._drawCount = s),
            vx(t) && ((i = 0), (s = r.length)),
            (n._chart = this.chart),
            (n._datasetIndex = this.index),
            (n._decimated = !!o._decimated),
            (n.points = r);
          const l = this.resolveDatasetElementOptions(e);
          this.options.showLine || (l.borderWidth = 0),
            (l.segment = this.options.segment),
            this.updateElement(n, void 0, { animated: !a, options: l }, e),
            this.updateElements(r, i, s, e);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              iScale: a,
              vScale: i,
              _stacked: s,
              _dataset: l,
            } = this._cachedMeta,
            { sharedOptions: d, includeOptions: c } = this._getSharedOptions(
              t,
              r
            ),
            u = a.axis,
            p = i.axis,
            { spanGaps: m, segment: h } = this.options,
            f = KC(m) ? m : Number.POSITIVE_INFINITY,
            g = this.chart._animationsDisabled || o || "none" === r;
          let v = t > 0 && this.getParsed(t - 1);
          for (let m = t; m < t + n; ++m) {
            const t = e[m],
              n = this.getParsed(m),
              b = g ? t : {},
              _ = hC(n[p]),
              y = (b[u] = a.getPixelForValue(n[u], m)),
              C = (b[p] =
                o || _
                  ? i.getBasePixel()
                  : i.getPixelForValue(s ? this.applyStack(i, n, s) : n[p], m));
            (b.skip = isNaN(y) || isNaN(C) || _),
              (b.stop = m > 0 && Math.abs(n[u] - v[u]) > f),
              h && ((b.parsed = n), (b.raw = l.data[m])),
              c &&
                (b.options =
                  d ||
                  this.resolveDataElementOptions(m, t.active ? "active" : r)),
              g || this.updateElement(t, m, b, r),
              (v = n);
          }
        }
        getMaxOverflow() {
          const e = this._cachedMeta,
            t = e.dataset,
            n = (t.options && t.options.borderWidth) || 0,
            r = e.data || [];
          if (!r.length) return n;
          const o = r[0].size(this.resolveDataElementOptions(0)),
            a = r[r.length - 1].size(
              this.resolveDataElementOptions(r.length - 1)
            );
          return Math.max(n, o, a) / 2;
        }
        draw() {
          const e = this._cachedMeta;
          e.dataset.updateControlPoints(this.chart.chartArea, e.iScale.axis),
            super.draw();
        }
      }
      (Jk.id = "line"),
        (Jk.defaults = {
          datasetElementType: "line",
          dataElementType: "point",
          showLine: !0,
          spanGaps: !1,
        }),
        (Jk.overrides = {
          scales: {
            _index_: { type: "category" },
            _value_: { type: "linear" },
          },
        });
      class Xk extends Fk {
        constructor(e, t) {
          super(e, t), (this.innerRadius = void 0), (this.outerRadius = void 0);
        }
        getLabelAndValue(e) {
          const t = this._cachedMeta,
            n = this.chart,
            r = n.data.labels || [],
            o = hk(t._parsed[e].r, n.options.locale);
          return { label: r[e] || "", value: o };
        }
        parseObjectData(e, t, n, r) {
          return US.bind(this)(e, t, n, r);
        }
        update(e) {
          const t = this._cachedMeta.data;
          this._updateRadius(), this.updateElements(t, 0, t.length, e);
        }
        getMinMax() {
          const e = this._cachedMeta,
            t = {
              min: Number.POSITIVE_INFINITY,
              max: Number.NEGATIVE_INFINITY,
            };
          return (
            e.data.forEach((e, n) => {
              const r = this.getParsed(n).r;
              !isNaN(r) &&
                this.chart.getDataVisibility(n) &&
                (r < t.min && (t.min = r), r > t.max && (t.max = r));
            }),
            t
          );
        }
        _updateRadius() {
          const e = this.chart,
            t = e.chartArea,
            n = e.options,
            r = Math.min(t.right - t.left, t.bottom - t.top),
            o = Math.max(r / 2, 0),
            a =
              (o -
                Math.max(
                  n.cutoutPercentage ? (o / 100) * n.cutoutPercentage : 1,
                  0
                )) /
              e.getVisibleDatasetCount();
          (this.outerRadius = o - a * this.index),
            (this.innerRadius = this.outerRadius - a);
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            a = this.chart,
            i = a.options.animation,
            s = this._cachedMeta.rScale,
            l = s.xCenter,
            d = s.yCenter,
            c = s.getIndexAngle(0) - 0.5 * RC;
          let u,
            p = c;
          const m = 360 / this.countVisibleElements();
          for (u = 0; u < t; ++u) p += this._computeAngle(u, r, m);
          for (u = t; u < t + n; u++) {
            const t = e[u];
            let n = p,
              h = p + this._computeAngle(u, r, m),
              f = a.getDataVisibility(u)
                ? s.getDistanceFromCenterForValue(this.getParsed(u).r)
                : 0;
            (p = h),
              o && (i.animateScale && (f = 0), i.animateRotate && (n = h = c));
            const g = {
              x: l,
              y: d,
              innerRadius: 0,
              outerRadius: f,
              startAngle: n,
              endAngle: h,
              options: this.resolveDataElementOptions(
                u,
                t.active ? "active" : r
              ),
            };
            this.updateElement(t, u, g, r);
          }
        }
        countVisibleElements() {
          const e = this._cachedMeta;
          let t = 0;
          return (
            e.data.forEach((e, n) => {
              !isNaN(this.getParsed(n).r) &&
                this.chart.getDataVisibility(n) &&
                t++;
            }),
            t
          );
        }
        _computeAngle(e, t, n) {
          return this.chart.getDataVisibility(e)
            ? QC(this.resolveDataElementOptions(e, t).angle || n)
            : 0;
        }
      }
      (Xk.id = "polarArea"),
        (Xk.defaults = {
          dataElementType: "arc",
          animation: { animateRotate: !0, animateScale: !0 },
          animations: {
            numbers: {
              type: "number",
              properties: [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
              ],
            },
          },
          indexAxis: "r",
          startAngle: 0,
        }),
        (Xk.overrides = {
          aspectRatio: 1,
          plugins: {
            legend: {
              labels: {
                generateLabels(e) {
                  const t = e.data;
                  if (t.labels.length && t.datasets.length) {
                    const {
                      labels: { pointStyle: n },
                    } = e.legend.options;
                    return t.labels.map((t, r) => {
                      const o = e.getDatasetMeta(0).controller.getStyle(r);
                      return {
                        text: t,
                        fillStyle: o.backgroundColor,
                        strokeStyle: o.borderColor,
                        lineWidth: o.borderWidth,
                        pointStyle: n,
                        hidden: !e.getDataVisibility(r),
                        index: r,
                      };
                    });
                  }
                  return [];
                },
              },
              onClick(e, t, n) {
                n.chart.toggleDataVisibility(t.index), n.chart.update();
              },
            },
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  return (
                    e.chart.data.labels[e.dataIndex] + ": " + e.formattedValue
                  );
                },
              },
            },
          },
          scales: {
            r: {
              type: "radialLinear",
              angleLines: { display: !1 },
              beginAtZero: !0,
              grid: { circular: !0 },
              pointLabels: { display: !1 },
              startAngle: 0,
            },
          },
        });
      class eP extends Yk {}
      (eP.id = "pie"),
        (eP.defaults = {
          cutout: 0,
          rotation: 0,
          circumference: 360,
          radius: "100%",
        });
      class tP extends Fk {
        getLabelAndValue(e) {
          const t = this._cachedMeta.vScale,
            n = this.getParsed(e);
          return {
            label: t.getLabels()[e],
            value: "" + t.getLabelForValue(n[t.axis]),
          };
        }
        parseObjectData(e, t, n, r) {
          return US.bind(this)(e, t, n, r);
        }
        update(e) {
          const t = this._cachedMeta,
            n = t.dataset,
            r = t.data || [],
            o = t.iScale.getLabels();
          if (((n.points = r), "resize" !== e)) {
            const t = this.resolveDatasetElementOptions(e);
            this.options.showLine || (t.borderWidth = 0);
            const a = {
              _loop: !0,
              _fullLoop: o.length === r.length,
              options: t,
            };
            this.updateElement(n, void 0, a, e);
          }
          this.updateElements(r, 0, r.length, e);
        }
        updateElements(e, t, n, r) {
          const o = this._cachedMeta.rScale,
            a = "reset" === r;
          for (let i = t; i < t + n; i++) {
            const t = e[i],
              n = this.resolveDataElementOptions(i, t.active ? "active" : r),
              s = o.getPointPositionForValue(i, this.getParsed(i).r),
              l = a ? o.xCenter : s.x,
              d = a ? o.yCenter : s.y,
              c = {
                x: l,
                y: d,
                angle: s.angle,
                skip: isNaN(l) || isNaN(d),
                options: n,
              };
            this.updateElement(t, i, c, r);
          }
        }
      }
      (tP.id = "radar"),
        (tP.defaults = {
          datasetElementType: "line",
          dataElementType: "point",
          indexAxis: "r",
          showLine: !0,
          elements: { line: { fill: "start" } },
        }),
        (tP.overrides = {
          aspectRatio: 1,
          scales: { r: { type: "radialLinear" } },
        });
      class nP {
        constructor() {
          (this.x = void 0),
            (this.y = void 0),
            (this.active = !1),
            (this.options = void 0),
            (this.$animations = void 0);
        }
        tooltipPosition(e) {
          const { x: t, y: n } = this.getProps(["x", "y"], e);
          return { x: t, y: n };
        }
        hasValue() {
          return KC(this.x) && KC(this.y);
        }
        getProps(e, t) {
          const n = this.$animations;
          if (!t || !n) return this;
          const r = {};
          return (
            e.forEach((e) => {
              r[e] = n[e] && n[e].active() ? n[e]._to : this[e];
            }),
            r
          );
        }
      }
      (nP.defaults = {}), (nP.defaultRoutes = void 0);
      const rP = {
        values(e) {
          return fC(e) ? e : "" + e;
        },
        numeric(e, t, n) {
          if (0 === e) return "0";
          const r = this.chart.options.locale;
          let o,
            a = e;
          if (n.length > 1) {
            const t = Math.max(
              Math.abs(n[0].value),
              Math.abs(n[n.length - 1].value)
            );
            (t < 1e-4 || t > 1e15) && (o = "scientific"),
              (a = (function (e, t) {
                let n =
                  t.length > 3
                    ? t[2].value - t[1].value
                    : t[1].value - t[0].value;
                return (
                  Math.abs(n) >= 1 &&
                    e !== Math.floor(e) &&
                    (n = e - Math.floor(e)),
                  n
                );
              })(e, n));
          }
          const i = WC(Math.abs(a)),
            s = Math.max(Math.min(-1 * Math.floor(i), 20), 0),
            l = {
              notation: o,
              minimumFractionDigits: s,
              maximumFractionDigits: s,
            };
          return Object.assign(l, this.options.ticks.format), hk(e, r, l);
        },
        logarithmic(e, t, n) {
          if (0 === e) return "0";
          const r = e / Math.pow(10, Math.floor(WC(e)));
          return 1 === r || 2 === r || 5 === r
            ? rP.numeric.call(this, e, t, n)
            : "";
        },
      };
      var oP = { formatters: rP };
      function aP(e, t, n, r, o) {
        const a = _C(r, 0),
          i = Math.min(_C(o, e.length), e.length);
        let s,
          l,
          d,
          c = 0;
        for (
          n = Math.ceil(n),
            o && ((s = o - r), (n = s / Math.floor(s / n))),
            d = a;
          d < 0;

        )
          c++, (d = Math.round(a + c * n));
        for (l = Math.max(a, 0); l < i; l++)
          l === d && (t.push(e[l]), c++, (d = Math.round(a + c * n)));
      }
      iS.set("scale", {
        display: !0,
        offset: !1,
        reverse: !1,
        beginAtZero: !1,
        bounds: "ticks",
        grace: 0,
        grid: {
          display: !0,
          lineWidth: 1,
          drawBorder: !0,
          drawOnChartArea: !0,
          drawTicks: !0,
          tickLength: 8,
          tickWidth: (e, t) => t.lineWidth,
          tickColor: (e, t) => t.color,
          offset: !1,
          borderDash: [],
          borderDashOffset: 0,
          borderWidth: 1,
        },
        title: { display: !1, text: "", padding: { top: 4, bottom: 4 } },
        ticks: {
          minRotation: 0,
          maxRotation: 50,
          mirror: !1,
          textStrokeWidth: 0,
          textStrokeColor: "",
          padding: 3,
          display: !0,
          autoSkip: !0,
          autoSkipPadding: 3,
          labelOffset: 0,
          callback: oP.formatters.values,
          minor: {},
          major: {},
          align: "center",
          crossAlign: "near",
          showLabelBackdrop: !1,
          backdropColor: "rgba(255, 255, 255, 0.75)",
          backdropPadding: 2,
        },
      }),
        iS.route("scale.ticks", "color", "", "color"),
        iS.route("scale.grid", "color", "", "borderColor"),
        iS.route("scale.grid", "borderColor", "", "borderColor"),
        iS.route("scale.title", "color", "", "color"),
        iS.describe("scale", {
          _fallback: !1,
          _scriptable: (e) =>
            !e.startsWith("before") &&
            !e.startsWith("after") &&
            "callback" !== e &&
            "parser" !== e,
          _indexable: (e) => "borderDash" !== e && "tickBorderDash" !== e,
        }),
        iS.describe("scales", { _fallback: "scale" }),
        iS.describe("scale.ticks", {
          _scriptable: (e) => "backdropPadding" !== e && "callback" !== e,
          _indexable: (e) => "backdropPadding" !== e,
        });
      const iP = (e, t, n) =>
        "top" === t || "left" === t ? e[t] + n : e[t] - n;
      function sP(e, t) {
        const n = [],
          r = e.length / t,
          o = e.length;
        let a = 0;
        for (; a < o; a += r) n.push(e[Math.floor(a)]);
        return n;
      }
      function lP(e, t, n) {
        const r = e.ticks.length,
          o = Math.min(t, r - 1),
          a = e._startPixel,
          i = e._endPixel,
          s = 1e-6;
        let l,
          d = e.getPixelForTick(o);
        if (
          !(
            n &&
            ((l =
              1 === r
                ? Math.max(d - a, i - d)
                : 0 === t
                ? (e.getPixelForTick(1) - d) / 2
                : (d - e.getPixelForTick(o - 1)) / 2),
            (d += o < t ? l : -l),
            d < a - s || d > i + s)
          )
        )
          return d;
      }
      function dP(e) {
        return e.drawTicks ? e.tickLength : 0;
      }
      function cP(e, t) {
        if (!e.display) return 0;
        const n = IS(e.font, t),
          r = TS(e.padding);
        return (fC(e.text) ? e.text.length : 1) * n.lineHeight + r.height;
      }
      function uP(e, t, n) {
        let r = hx(e);
        return (
          ((n && "right" !== t) || (!n && "right" === t)) &&
            (r = ((e) => ("left" === e ? "right" : "right" === e ? "left" : e))(
              r
            )),
          r
        );
      }
      class pP extends nP {
        constructor(e) {
          super(),
            (this.id = e.id),
            (this.type = e.type),
            (this.options = void 0),
            (this.ctx = e.ctx),
            (this.chart = e.chart),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this._margins = { left: 0, right: 0, top: 0, bottom: 0 }),
            (this.maxWidth = void 0),
            (this.maxHeight = void 0),
            (this.paddingTop = void 0),
            (this.paddingBottom = void 0),
            (this.paddingLeft = void 0),
            (this.paddingRight = void 0),
            (this.axis = void 0),
            (this.labelRotation = void 0),
            (this.min = void 0),
            (this.max = void 0),
            (this._range = void 0),
            (this.ticks = []),
            (this._gridLineItems = null),
            (this._labelItems = null),
            (this._labelSizes = null),
            (this._length = 0),
            (this._maxLength = 0),
            (this._longestTextCache = {}),
            (this._startPixel = void 0),
            (this._endPixel = void 0),
            (this._reversePixels = !1),
            (this._userMax = void 0),
            (this._userMin = void 0),
            (this._suggestedMax = void 0),
            (this._suggestedMin = void 0),
            (this._ticksLength = 0),
            (this._borderValue = 0),
            (this._cache = {}),
            (this._dataLimitsCached = !1),
            (this.$context = void 0);
        }
        init(e) {
          (this.options = e.setContext(this.getContext())),
            (this.axis = e.axis),
            (this._userMin = this.parse(e.min)),
            (this._userMax = this.parse(e.max)),
            (this._suggestedMin = this.parse(e.suggestedMin)),
            (this._suggestedMax = this.parse(e.suggestedMax));
        }
        parse(e, t) {
          return e;
        }
        getUserBounds() {
          let {
            _userMin: e,
            _userMax: t,
            _suggestedMin: n,
            _suggestedMax: r,
          } = this;
          return (
            (e = bC(e, Number.POSITIVE_INFINITY)),
            (t = bC(t, Number.NEGATIVE_INFINITY)),
            (n = bC(n, Number.POSITIVE_INFINITY)),
            (r = bC(r, Number.NEGATIVE_INFINITY)),
            {
              min: bC(e, n),
              max: bC(t, r),
              minDefined: vC(e),
              maxDefined: vC(t),
            }
          );
        }
        getMinMax(e) {
          let t,
            {
              min: n,
              max: r,
              minDefined: o,
              maxDefined: a,
            } = this.getUserBounds();
          if (o && a) return { min: n, max: r };
          const i = this.getMatchingVisibleMetas();
          for (let s = 0, l = i.length; s < l; ++s)
            (t = i[s].controller.getMinMax(this, e)),
              o || (n = Math.min(n, t.min)),
              a || (r = Math.max(r, t.max));
          return (
            (n = a && n > r ? r : n),
            (r = o && n > r ? n : r),
            { min: bC(n, bC(r, n)), max: bC(r, bC(n, r)) }
          );
        }
        getPadding() {
          return {
            left: this.paddingLeft || 0,
            top: this.paddingTop || 0,
            right: this.paddingRight || 0,
            bottom: this.paddingBottom || 0,
          };
        }
        getTicks() {
          return this.ticks;
        }
        getLabels() {
          const e = this.chart.data;
          return (
            this.options.labels ||
            (this.isHorizontal() ? e.xLabels : e.yLabels) ||
            e.labels ||
            []
          );
        }
        beforeLayout() {
          (this._cache = {}), (this._dataLimitsCached = !1);
        }
        beforeUpdate() {
          CC(this.options.beforeUpdate, [this]);
        }
        update(e, t, n) {
          const { beginAtZero: r, grace: o, ticks: a } = this.options,
            i = a.sampleSize;
          this.beforeUpdate(),
            (this.maxWidth = e),
            (this.maxHeight = t),
            (this._margins = n =
              Object.assign({ left: 0, right: 0, top: 0, bottom: 0 }, n)),
            (this.ticks = null),
            (this._labelSizes = null),
            (this._gridLineItems = null),
            (this._labelItems = null),
            this.beforeSetDimensions(),
            this.setDimensions(),
            this.afterSetDimensions(),
            (this._maxLength = this.isHorizontal()
              ? this.width + n.left + n.right
              : this.height + n.top + n.bottom),
            this._dataLimitsCached ||
              (this.beforeDataLimits(),
              this.determineDataLimits(),
              this.afterDataLimits(),
              (this._range = (function (e, t, n) {
                const { min: r, max: o } = e,
                  a = yC(t, (o - r) / 2),
                  i = (e, t) => (n && 0 === e ? 0 : e + t);
                return { min: i(r, -Math.abs(a)), max: i(o, a) };
              })(this, o, r)),
              (this._dataLimitsCached = !0)),
            this.beforeBuildTicks(),
            (this.ticks = this.buildTicks() || []),
            this.afterBuildTicks();
          const s = i < this.ticks.length;
          this._convertTicksToLabels(s ? sP(this.ticks, i) : this.ticks),
            this.configure(),
            this.beforeCalculateLabelRotation(),
            this.calculateLabelRotation(),
            this.afterCalculateLabelRotation(),
            a.display &&
              (a.autoSkip || "auto" === a.source) &&
              ((this.ticks = (function (e, t) {
                const n = e.options.ticks,
                  r =
                    n.maxTicksLimit ||
                    (function (e) {
                      const t = e.options.offset,
                        n = e._tickSize(),
                        r = e._length / n + (t ? 0 : 1),
                        o = e._maxLength / n;
                      return Math.floor(Math.min(r, o));
                    })(e),
                  o = n.major.enabled
                    ? (function (e) {
                        const t = [];
                        let n, r;
                        for (n = 0, r = e.length; n < r; n++)
                          e[n].major && t.push(n);
                        return t;
                      })(t)
                    : [],
                  a = o.length,
                  i = o[0],
                  s = o[a - 1],
                  l = [];
                if (a > r)
                  return (
                    (function (e, t, n, r) {
                      let o,
                        a = 0,
                        i = n[0];
                      for (r = Math.ceil(r), o = 0; o < e.length; o++)
                        o === i && (t.push(e[o]), a++, (i = n[a * r]));
                    })(t, l, o, a / r),
                    l
                  );
                const d = (function (e, t, n) {
                  const r = (function (e) {
                      const t = e.length;
                      let n, r;
                      if (t < 2) return !1;
                      for (r = e[0], n = 1; n < t; ++n)
                        if (e[n] - e[n - 1] !== r) return !1;
                      return r;
                    })(e),
                    o = t.length / n;
                  if (!r) return Math.max(o, 1);
                  const a = (function (e) {
                    const t = [],
                      n = Math.sqrt(e);
                    let r;
                    for (r = 1; r < n; r++)
                      e % r == 0 && (t.push(r), t.push(e / r));
                    return (
                      n === (0 | n) && t.push(n),
                      t.sort((e, t) => e - t).pop(),
                      t
                    );
                  })(r);
                  for (let e = 0, t = a.length - 1; e < t; e++) {
                    const t = a[e];
                    if (t > o) return t;
                  }
                  return Math.max(o, 1);
                })(o, t, r);
                if (a > 0) {
                  let e, n;
                  const r = a > 1 ? Math.round((s - i) / (a - 1)) : null;
                  for (
                    aP(t, l, d, hC(r) ? 0 : i - r, i), e = 0, n = a - 1;
                    e < n;
                    e++
                  )
                    aP(t, l, d, o[e], o[e + 1]);
                  return aP(t, l, d, s, hC(r) ? t.length : s + r), l;
                }
                return aP(t, l, d), l;
              })(this, this.ticks)),
              (this._labelSizes = null),
              this.afterAutoSkip()),
            s && this._convertTicksToLabels(this.ticks),
            this.beforeFit(),
            this.fit(),
            this.afterFit(),
            this.afterUpdate();
        }
        configure() {
          let e,
            t,
            n = this.options.reverse;
          this.isHorizontal()
            ? ((e = this.left), (t = this.right))
            : ((e = this.top), (t = this.bottom), (n = !n)),
            (this._startPixel = e),
            (this._endPixel = t),
            (this._reversePixels = n),
            (this._length = t - e),
            (this._alignToPixels = this.options.alignToPixels);
        }
        afterUpdate() {
          CC(this.options.afterUpdate, [this]);
        }
        beforeSetDimensions() {
          CC(this.options.beforeSetDimensions, [this]);
        }
        setDimensions() {
          this.isHorizontal()
            ? ((this.width = this.maxWidth),
              (this.left = 0),
              (this.right = this.width))
            : ((this.height = this.maxHeight),
              (this.top = 0),
              (this.bottom = this.height)),
            (this.paddingLeft = 0),
            (this.paddingTop = 0),
            (this.paddingRight = 0),
            (this.paddingBottom = 0);
        }
        afterSetDimensions() {
          CC(this.options.afterSetDimensions, [this]);
        }
        _callHooks(e) {
          this.chart.notifyPlugins(e, this.getContext()),
            CC(this.options[e], [this]);
        }
        beforeDataLimits() {
          this._callHooks("beforeDataLimits");
        }
        determineDataLimits() {}
        afterDataLimits() {
          this._callHooks("afterDataLimits");
        }
        beforeBuildTicks() {
          this._callHooks("beforeBuildTicks");
        }
        buildTicks() {
          return [];
        }
        afterBuildTicks() {
          this._callHooks("afterBuildTicks");
        }
        beforeTickToLabelConversion() {
          CC(this.options.beforeTickToLabelConversion, [this]);
        }
        generateTickLabels(e) {
          const t = this.options.ticks;
          let n, r, o;
          for (n = 0, r = e.length; n < r; n++)
            (o = e[n]), (o.label = CC(t.callback, [o.value, n, e], this));
        }
        afterTickToLabelConversion() {
          CC(this.options.afterTickToLabelConversion, [this]);
        }
        beforeCalculateLabelRotation() {
          CC(this.options.beforeCalculateLabelRotation, [this]);
        }
        calculateLabelRotation() {
          const e = this.options,
            t = e.ticks,
            n = this.ticks.length,
            r = t.minRotation || 0,
            o = t.maxRotation;
          let a,
            i,
            s,
            l = r;
          if (
            !this._isVisible() ||
            !t.display ||
            r >= o ||
            n <= 1 ||
            !this.isHorizontal()
          )
            return void (this.labelRotation = r);
          const d = this._getLabelSizes(),
            c = d.widest.width,
            u = d.highest.height,
            p = ox(this.chart.width - c, 0, this.maxWidth);
          (a = e.offset ? this.maxWidth / n : p / (n - 1)),
            c + 6 > a &&
              ((a = p / (n - (e.offset ? 0.5 : 1))),
              (i =
                this.maxHeight -
                dP(e.grid) -
                t.padding -
                cP(e.title, this.chart.options.font)),
              (s = Math.sqrt(c * c + u * u)),
              (l = YC(
                Math.min(
                  Math.asin(ox((d.highest.height + 6) / a, -1, 1)),
                  Math.asin(ox(i / s, -1, 1)) - Math.asin(ox(u / s, -1, 1))
                )
              )),
              (l = Math.max(r, Math.min(o, l)))),
            (this.labelRotation = l);
        }
        afterCalculateLabelRotation() {
          CC(this.options.afterCalculateLabelRotation, [this]);
        }
        afterAutoSkip() {}
        beforeFit() {
          CC(this.options.beforeFit, [this]);
        }
        fit() {
          const e = { width: 0, height: 0 },
            {
              chart: t,
              options: { ticks: n, title: r, grid: o },
            } = this,
            a = this._isVisible(),
            i = this.isHorizontal();
          if (a) {
            const a = cP(r, t.options.font);
            if (
              (i
                ? ((e.width = this.maxWidth), (e.height = dP(o) + a))
                : ((e.height = this.maxHeight), (e.width = dP(o) + a)),
              n.display && this.ticks.length)
            ) {
              const {
                  first: t,
                  last: r,
                  widest: o,
                  highest: a,
                } = this._getLabelSizes(),
                s = 2 * n.padding,
                l = QC(this.labelRotation),
                d = Math.cos(l),
                c = Math.sin(l);
              if (i) {
                const t = n.mirror ? 0 : c * o.width + d * a.height;
                e.height = Math.min(this.maxHeight, e.height + t + s);
              } else {
                const t = n.mirror ? 0 : d * o.width + c * a.height;
                e.width = Math.min(this.maxWidth, e.width + t + s);
              }
              this._calculatePadding(t, r, c, d);
            }
          }
          this._handleMargins(),
            i
              ? ((this.width = this._length =
                  t.width - this._margins.left - this._margins.right),
                (this.height = e.height))
              : ((this.width = e.width),
                (this.height = this._length =
                  t.height - this._margins.top - this._margins.bottom));
        }
        _calculatePadding(e, t, n, r) {
          const {
              ticks: { align: o, padding: a },
              position: i,
            } = this.options,
            s = 0 !== this.labelRotation,
            l = "top" !== i && "x" === this.axis;
          if (this.isHorizontal()) {
            const i = this.getPixelForTick(0) - this.left,
              d = this.right - this.getPixelForTick(this.ticks.length - 1);
            let c = 0,
              u = 0;
            s
              ? l
                ? ((c = r * e.width), (u = n * t.height))
                : ((c = n * e.height), (u = r * t.width))
              : "start" === o
              ? (u = t.width)
              : "end" === o
              ? (c = e.width)
              : "inner" !== o && ((c = e.width / 2), (u = t.width / 2)),
              (this.paddingLeft = Math.max(
                ((c - i + a) * this.width) / (this.width - i),
                0
              )),
              (this.paddingRight = Math.max(
                ((u - d + a) * this.width) / (this.width - d),
                0
              ));
          } else {
            let n = t.height / 2,
              r = e.height / 2;
            "start" === o
              ? ((n = 0), (r = e.height))
              : "end" === o && ((n = t.height), (r = 0)),
              (this.paddingTop = n + a),
              (this.paddingBottom = r + a);
          }
        }
        _handleMargins() {
          this._margins &&
            ((this._margins.left = Math.max(
              this.paddingLeft,
              this._margins.left
            )),
            (this._margins.top = Math.max(this.paddingTop, this._margins.top)),
            (this._margins.right = Math.max(
              this.paddingRight,
              this._margins.right
            )),
            (this._margins.bottom = Math.max(
              this.paddingBottom,
              this._margins.bottom
            )));
        }
        afterFit() {
          CC(this.options.afterFit, [this]);
        }
        isHorizontal() {
          const { axis: e, position: t } = this.options;
          return "top" === t || "bottom" === t || "x" === e;
        }
        isFullSize() {
          return this.options.fullSize;
        }
        _convertTicksToLabels(e) {
          let t, n;
          for (
            this.beforeTickToLabelConversion(),
              this.generateTickLabels(e),
              t = 0,
              n = e.length;
            t < n;
            t++
          )
            hC(e[t].label) && (e.splice(t, 1), n--, t--);
          this.afterTickToLabelConversion();
        }
        _getLabelSizes() {
          let e = this._labelSizes;
          if (!e) {
            const t = this.options.ticks.sampleSize;
            let n = this.ticks;
            t < n.length && (n = sP(n, t)),
              (this._labelSizes = e = this._computeLabelSizes(n, n.length));
          }
          return e;
        }
        _computeLabelSizes(e, t) {
          const { ctx: n, _longestTextCache: r } = this,
            o = [],
            a = [];
          let i,
            s,
            l,
            d,
            c,
            u,
            p,
            m,
            h,
            f,
            g,
            v = 0,
            b = 0;
          for (i = 0; i < t; ++i) {
            if (
              ((d = e[i].label),
              (c = this._resolveTickFontOptions(i)),
              (n.font = u = c.string),
              (p = r[u] = r[u] || { data: {}, gc: [] }),
              (m = c.lineHeight),
              (h = f = 0),
              hC(d) || fC(d))
            ) {
              if (fC(d))
                for (s = 0, l = d.length; s < l; ++s)
                  (g = d[s]),
                    hC(g) ||
                      fC(g) ||
                      ((h = sS(n, p.data, p.gc, h, g)), (f += m));
            } else (h = sS(n, p.data, p.gc, h, d)), (f = m);
            o.push(h), a.push(f), (v = Math.max(h, v)), (b = Math.max(f, b));
          }
          !(function (e, t) {
            xC(e, (e) => {
              const n = e.gc,
                r = n.length / 2;
              let o;
              if (r > t) {
                for (o = 0; o < r; ++o) delete e.data[n[o]];
                n.splice(0, r);
              }
            });
          })(r, t);
          const _ = o.indexOf(v),
            y = a.indexOf(b),
            C = (e) => ({ width: o[e] || 0, height: a[e] || 0 });
          return {
            first: C(0),
            last: C(t - 1),
            widest: C(_),
            highest: C(y),
            widths: o,
            heights: a,
          };
        }
        getLabelForValue(e) {
          return e;
        }
        getPixelForValue(e, t) {
          return NaN;
        }
        getValueForPixel(e) {}
        getPixelForTick(e) {
          const t = this.ticks;
          return e < 0 || e > t.length - 1
            ? null
            : this.getPixelForValue(t[e].value);
        }
        getPixelForDecimal(e) {
          this._reversePixels && (e = 1 - e);
          const t = this._startPixel + e * this._length;
          return ox(
            this._alignToPixels ? dS(this.chart, t, 0) : t,
            -32768,
            32767
          );
        }
        getDecimalForPixel(e) {
          const t = (e - this._startPixel) / this._length;
          return this._reversePixels ? 1 - t : t;
        }
        getBasePixel() {
          return this.getPixelForValue(this.getBaseValue());
        }
        getBaseValue() {
          const { min: e, max: t } = this;
          return e < 0 && t < 0 ? t : e > 0 && t > 0 ? e : 0;
        }
        getContext(e) {
          const t = this.ticks || [];
          if (e >= 0 && e < t.length) {
            const n = t[e];
            return (
              n.$context ||
              (n.$context = (function (e, t, n) {
                return jS(e, { tick: n, index: t, type: "tick" });
              })(this.getContext(), e, n))
            );
          }
          return (
            this.$context ||
            (this.$context = jS(this.chart.getContext(), {
              scale: this,
              type: "scale",
            }))
          );
        }
        _tickSize() {
          const e = this.options.ticks,
            t = QC(this.labelRotation),
            n = Math.abs(Math.cos(t)),
            r = Math.abs(Math.sin(t)),
            o = this._getLabelSizes(),
            a = e.autoSkipPadding || 0,
            i = o ? o.widest.width + a : 0,
            s = o ? o.highest.height + a : 0;
          return this.isHorizontal()
            ? s * n > i * r
              ? i / n
              : s / r
            : s * r < i * n
            ? s / n
            : i / r;
        }
        _isVisible() {
          const e = this.options.display;
          return "auto" !== e ? !!e : this.getMatchingVisibleMetas().length > 0;
        }
        _computeGridLineItems(e) {
          const t = this.axis,
            n = this.chart,
            r = this.options,
            { grid: o, position: a } = r,
            i = o.offset,
            s = this.isHorizontal(),
            l = this.ticks.length + (i ? 1 : 0),
            d = dP(o),
            c = [],
            u = o.setContext(this.getContext()),
            p = u.drawBorder ? u.borderWidth : 0,
            m = p / 2,
            h = function (e) {
              return dS(n, e, p);
            };
          let f, g, v, b, _, y, C, x, S, k, P, w;
          if ("top" === a)
            (f = h(this.bottom)),
              (y = this.bottom - d),
              (x = f - m),
              (k = h(e.top) + m),
              (w = e.bottom);
          else if ("bottom" === a)
            (f = h(this.top)),
              (k = e.top),
              (w = h(e.bottom) - m),
              (y = f + m),
              (x = this.top + d);
          else if ("left" === a)
            (f = h(this.right)),
              (_ = this.right - d),
              (C = f - m),
              (S = h(e.left) + m),
              (P = e.right);
          else if ("right" === a)
            (f = h(this.left)),
              (S = e.left),
              (P = h(e.right) - m),
              (_ = f + m),
              (C = this.left + d);
          else if ("x" === t) {
            if ("center" === a) f = h((e.top + e.bottom) / 2 + 0.5);
            else if (gC(a)) {
              const e = Object.keys(a)[0],
                t = a[e];
              f = h(this.chart.scales[e].getPixelForValue(t));
            }
            (k = e.top), (w = e.bottom), (y = f + m), (x = y + d);
          } else if ("y" === t) {
            if ("center" === a) f = h((e.left + e.right) / 2);
            else if (gC(a)) {
              const e = Object.keys(a)[0],
                t = a[e];
              f = h(this.chart.scales[e].getPixelForValue(t));
            }
            (_ = f - m), (C = _ - d), (S = e.left), (P = e.right);
          }
          const O = _C(r.ticks.maxTicksLimit, l),
            T = Math.max(1, Math.ceil(l / O));
          for (g = 0; g < l; g += T) {
            const e = o.setContext(this.getContext(g)),
              t = e.lineWidth,
              r = e.color,
              a = e.borderDash || [],
              l = e.borderDashOffset,
              d = e.tickWidth,
              u = e.tickColor,
              p = e.tickBorderDash || [],
              m = e.tickBorderDashOffset;
            (v = lP(this, g, i)),
              void 0 !== v &&
                ((b = dS(n, v, t)),
                s ? (_ = C = S = P = b) : (y = x = k = w = b),
                c.push({
                  tx1: _,
                  ty1: y,
                  tx2: C,
                  ty2: x,
                  x1: S,
                  y1: k,
                  x2: P,
                  y2: w,
                  width: t,
                  color: r,
                  borderDash: a,
                  borderDashOffset: l,
                  tickWidth: d,
                  tickColor: u,
                  tickBorderDash: p,
                  tickBorderDashOffset: m,
                }));
          }
          return (this._ticksLength = l), (this._borderValue = f), c;
        }
        _computeLabelItems(e) {
          const t = this.axis,
            n = this.options,
            { position: r, ticks: o } = n,
            a = this.isHorizontal(),
            i = this.ticks,
            { align: s, crossAlign: l, padding: d, mirror: c } = o,
            u = dP(n.grid),
            p = u + d,
            m = c ? -d : p,
            h = -QC(this.labelRotation),
            f = [];
          let g,
            v,
            b,
            _,
            y,
            C,
            x,
            S,
            k,
            P,
            w,
            O,
            T = "middle";
          if ("top" === r)
            (C = this.bottom - m), (x = this._getXAxisLabelAlignment());
          else if ("bottom" === r)
            (C = this.top + m), (x = this._getXAxisLabelAlignment());
          else if ("left" === r) {
            const e = this._getYAxisLabelAlignment(u);
            (x = e.textAlign), (y = e.x);
          } else if ("right" === r) {
            const e = this._getYAxisLabelAlignment(u);
            (x = e.textAlign), (y = e.x);
          } else if ("x" === t) {
            if ("center" === r) C = (e.top + e.bottom) / 2 + p;
            else if (gC(r)) {
              const e = Object.keys(r)[0],
                t = r[e];
              C = this.chart.scales[e].getPixelForValue(t) + p;
            }
            x = this._getXAxisLabelAlignment();
          } else if ("y" === t) {
            if ("center" === r) y = (e.left + e.right) / 2 - p;
            else if (gC(r)) {
              const e = Object.keys(r)[0],
                t = r[e];
              y = this.chart.scales[e].getPixelForValue(t);
            }
            x = this._getYAxisLabelAlignment(u).textAlign;
          }
          "y" === t &&
            ("start" === s ? (T = "top") : "end" === s && (T = "bottom"));
          const I = this._getLabelSizes();
          for (g = 0, v = i.length; g < v; ++g) {
            (b = i[g]), (_ = b.label);
            const e = o.setContext(this.getContext(g));
            (S = this.getPixelForTick(g) + o.labelOffset),
              (k = this._resolveTickFontOptions(g)),
              (P = k.lineHeight),
              (w = fC(_) ? _.length : 1);
            const t = w / 2,
              n = e.color,
              s = e.textStrokeColor,
              d = e.textStrokeWidth;
            let u,
              p = x;
            if (
              (a
                ? ((y = S),
                  "inner" === x &&
                    (p =
                      g === v - 1
                        ? this.options.reverse
                          ? "left"
                          : "right"
                        : 0 === g
                        ? this.options.reverse
                          ? "right"
                          : "left"
                        : "center"),
                  (O =
                    "top" === r
                      ? "near" === l || 0 !== h
                        ? -w * P + P / 2
                        : "center" === l
                        ? -I.highest.height / 2 - t * P + P
                        : -I.highest.height + P / 2
                      : "near" === l || 0 !== h
                      ? P / 2
                      : "center" === l
                      ? I.highest.height / 2 - t * P
                      : I.highest.height - w * P),
                  c && (O *= -1))
                : ((C = S), (O = ((1 - w) * P) / 2)),
              e.showLabelBackdrop)
            ) {
              const t = TS(e.backdropPadding),
                n = I.heights[g],
                r = I.widths[g];
              let o = C + O - t.top,
                a = y - t.left;
              switch (T) {
                case "middle":
                  o -= n / 2;
                  break;
                case "bottom":
                  o -= n;
              }
              switch (x) {
                case "center":
                  a -= r / 2;
                  break;
                case "right":
                  a -= r;
              }
              u = {
                left: a,
                top: o,
                width: r + t.width,
                height: n + t.height,
                color: e.backdropColor,
              };
            }
            f.push({
              rotation: h,
              label: _,
              font: k,
              color: n,
              strokeColor: s,
              strokeWidth: d,
              textOffset: O,
              textAlign: p,
              textBaseline: T,
              translation: [y, C],
              backdrop: u,
            });
          }
          return f;
        }
        _getXAxisLabelAlignment() {
          const { position: e, ticks: t } = this.options;
          if (-QC(this.labelRotation)) return "top" === e ? "left" : "right";
          let n = "center";
          return (
            "start" === t.align
              ? (n = "left")
              : "end" === t.align
              ? (n = "right")
              : "inner" === t.align && (n = "inner"),
            n
          );
        }
        _getYAxisLabelAlignment(e) {
          const {
              position: t,
              ticks: { crossAlign: n, mirror: r, padding: o },
            } = this.options,
            a = e + o,
            i = this._getLabelSizes().widest.width;
          let s, l;
          return (
            "left" === t
              ? r
                ? ((l = this.right + o),
                  "near" === n
                    ? (s = "left")
                    : "center" === n
                    ? ((s = "center"), (l += i / 2))
                    : ((s = "right"), (l += i)))
                : ((l = this.right - a),
                  "near" === n
                    ? (s = "right")
                    : "center" === n
                    ? ((s = "center"), (l -= i / 2))
                    : ((s = "left"), (l = this.left)))
              : "right" === t
              ? r
                ? ((l = this.left + o),
                  "near" === n
                    ? (s = "right")
                    : "center" === n
                    ? ((s = "center"), (l -= i / 2))
                    : ((s = "left"), (l -= i)))
                : ((l = this.left + a),
                  "near" === n
                    ? (s = "left")
                    : "center" === n
                    ? ((s = "center"), (l += i / 2))
                    : ((s = "right"), (l = this.right)))
              : (s = "right"),
            { textAlign: s, x: l }
          );
        }
        _computeLabelArea() {
          if (this.options.ticks.mirror) return;
          const e = this.chart,
            t = this.options.position;
          return "left" === t || "right" === t
            ? { top: 0, left: this.left, bottom: e.height, right: this.right }
            : "top" === t || "bottom" === t
            ? { top: this.top, left: 0, bottom: this.bottom, right: e.width }
            : void 0;
        }
        drawBackground() {
          const {
            ctx: e,
            options: { backgroundColor: t },
            left: n,
            top: r,
            width: o,
            height: a,
          } = this;
          t &&
            (e.save(), (e.fillStyle = t), e.fillRect(n, r, o, a), e.restore());
        }
        getLineWidthForValue(e) {
          const t = this.options.grid;
          if (!this._isVisible() || !t.display) return 0;
          const n = this.ticks.findIndex((t) => t.value === e);
          return n >= 0 ? t.setContext(this.getContext(n)).lineWidth : 0;
        }
        drawGrid(e) {
          const t = this.options.grid,
            n = this.ctx,
            r =
              this._gridLineItems ||
              (this._gridLineItems = this._computeGridLineItems(e));
          let o, a;
          const i = (e, t, r) => {
            r.width &&
              r.color &&
              (n.save(),
              (n.lineWidth = r.width),
              (n.strokeStyle = r.color),
              n.setLineDash(r.borderDash || []),
              (n.lineDashOffset = r.borderDashOffset),
              n.beginPath(),
              n.moveTo(e.x, e.y),
              n.lineTo(t.x, t.y),
              n.stroke(),
              n.restore());
          };
          if (t.display)
            for (o = 0, a = r.length; o < a; ++o) {
              const e = r[o];
              t.drawOnChartArea &&
                i({ x: e.x1, y: e.y1 }, { x: e.x2, y: e.y2 }, e),
                t.drawTicks &&
                  i(
                    { x: e.tx1, y: e.ty1 },
                    { x: e.tx2, y: e.ty2 },
                    {
                      color: e.tickColor,
                      width: e.tickWidth,
                      borderDash: e.tickBorderDash,
                      borderDashOffset: e.tickBorderDashOffset,
                    }
                  );
            }
        }
        drawBorder() {
          const {
              chart: e,
              ctx: t,
              options: { grid: n },
            } = this,
            r = n.setContext(this.getContext()),
            o = n.drawBorder ? r.borderWidth : 0;
          if (!o) return;
          const a = n.setContext(this.getContext(0)).lineWidth,
            i = this._borderValue;
          let s, l, d, c;
          this.isHorizontal()
            ? ((s = dS(e, this.left, o) - o / 2),
              (l = dS(e, this.right, a) + a / 2),
              (d = c = i))
            : ((d = dS(e, this.top, o) - o / 2),
              (c = dS(e, this.bottom, a) + a / 2),
              (s = l = i)),
            t.save(),
            (t.lineWidth = r.borderWidth),
            (t.strokeStyle = r.borderColor),
            t.beginPath(),
            t.moveTo(s, d),
            t.lineTo(l, c),
            t.stroke(),
            t.restore();
        }
        drawLabels(e) {
          if (!this.options.ticks.display) return;
          const t = this.ctx,
            n = this._computeLabelArea();
          n && hS(t, n);
          const r =
            this._labelItems || (this._labelItems = this._computeLabelItems(e));
          let o, a;
          for (o = 0, a = r.length; o < a; ++o) {
            const e = r[o],
              n = e.font,
              a = e.label;
            e.backdrop &&
              ((t.fillStyle = e.backdrop.color),
              t.fillRect(
                e.backdrop.left,
                e.backdrop.top,
                e.backdrop.width,
                e.backdrop.height
              )),
              bS(t, a, 0, e.textOffset, n, e);
          }
          n && fS(t);
        }
        drawTitle() {
          const {
            ctx: e,
            options: { position: t, title: n, reverse: r },
          } = this;
          if (!n.display) return;
          const o = IS(n.font),
            a = TS(n.padding),
            i = n.align;
          let s = o.lineHeight / 2;
          "bottom" === t || "center" === t || gC(t)
            ? ((s += a.bottom),
              fC(n.text) && (s += o.lineHeight * (n.text.length - 1)))
            : (s += a.top);
          const {
            titleX: l,
            titleY: d,
            maxWidth: c,
            rotation: u,
          } = (function (e, t, n, r) {
            const { top: o, left: a, bottom: i, right: s, chart: l } = e,
              { chartArea: d, scales: c } = l;
            let u,
              p,
              m,
              h = 0;
            const f = i - o,
              g = s - a;
            if (e.isHorizontal()) {
              if (((p = fx(r, a, s)), gC(n))) {
                const e = Object.keys(n)[0],
                  r = n[e];
                m = c[e].getPixelForValue(r) + f - t;
              } else
                m =
                  "center" === n ? (d.bottom + d.top) / 2 + f - t : iP(e, n, t);
              u = s - a;
            } else {
              if (gC(n)) {
                const e = Object.keys(n)[0],
                  r = n[e];
                p = c[e].getPixelForValue(r) - g + t;
              } else
                p =
                  "center" === n ? (d.left + d.right) / 2 - g + t : iP(e, n, t);
              (m = fx(r, i, o)), (h = "left" === n ? -ZC : ZC);
            }
            return { titleX: p, titleY: m, maxWidth: u, rotation: h };
          })(this, s, t, i);
          bS(e, n.text, 0, 0, o, {
            color: n.color,
            maxWidth: c,
            rotation: u,
            textAlign: uP(i, t, r),
            textBaseline: "middle",
            translation: [l, d],
          });
        }
        draw(e) {
          this._isVisible() &&
            (this.drawBackground(),
            this.drawGrid(e),
            this.drawBorder(),
            this.drawTitle(),
            this.drawLabels(e));
        }
        _layers() {
          const e = this.options,
            t = (e.ticks && e.ticks.z) || 0,
            n = _C(e.grid && e.grid.z, -1);
          return this._isVisible() && this.draw === pP.prototype.draw
            ? [
                {
                  z: n,
                  draw: (e) => {
                    this.drawBackground(), this.drawGrid(e), this.drawTitle();
                  },
                },
                {
                  z: n + 1,
                  draw: () => {
                    this.drawBorder();
                  },
                },
                {
                  z: t,
                  draw: (e) => {
                    this.drawLabels(e);
                  },
                },
              ]
            : [
                {
                  z: t,
                  draw: (e) => {
                    this.draw(e);
                  },
                },
              ];
        }
        getMatchingVisibleMetas(e) {
          const t = this.chart.getSortedVisibleDatasetMetas(),
            n = this.axis + "AxisID",
            r = [];
          let o, a;
          for (o = 0, a = t.length; o < a; ++o) {
            const a = t[o];
            a[n] !== this.id || (e && a.type !== e) || r.push(a);
          }
          return r;
        }
        _resolveTickFontOptions(e) {
          return IS(this.options.ticks.setContext(this.getContext(e)).font);
        }
        _maxDigits() {
          const e = this._resolveTickFontOptions(0).lineHeight;
          return (this.isHorizontal() ? this.width : this.height) / e;
        }
      }
      class mP {
        constructor(e, t, n) {
          (this.type = e),
            (this.scope = t),
            (this.override = n),
            (this.items = Object.create(null));
        }
        isForType(e) {
          return Object.prototype.isPrototypeOf.call(
            this.type.prototype,
            e.prototype
          );
        }
        register(e) {
          const t = Object.getPrototypeOf(e);
          let n;
          (function (e) {
            return "id" in e && "defaults" in e;
          })(t) && (n = this.register(t));
          const r = this.items,
            o = e.id,
            a = this.scope + "." + o;
          if (!o) throw new Error("class does not have id: " + e);
          return (
            o in r ||
              ((r[o] = e),
              (function (e, t, n) {
                const r = OC(Object.create(null), [
                  n ? iS.get(n) : {},
                  iS.get(t),
                  e.defaults,
                ]);
                iS.set(t, r),
                  e.defaultRoutes &&
                    (function (e, t) {
                      Object.keys(t).forEach((n) => {
                        const r = n.split("."),
                          o = r.pop(),
                          a = [e].concat(r).join("."),
                          i = t[n].split("."),
                          s = i.pop(),
                          l = i.join(".");
                        iS.route(a, o, l, s);
                      });
                    })(t, e.defaultRoutes),
                  e.descriptors && iS.describe(t, e.descriptors);
              })(e, a, n),
              this.override && iS.override(e.id, e.overrides)),
            a
          );
        }
        get(e) {
          return this.items[e];
        }
        unregister(e) {
          const t = this.items,
            n = e.id,
            r = this.scope;
          n in t && delete t[n],
            r && n in iS[r] && (delete iS[r][n], this.override && delete nS[n]);
        }
      }
      var hP = new (class {
        constructor() {
          (this.controllers = new mP(Fk, "datasets", !0)),
            (this.elements = new mP(nP, "elements")),
            (this.plugins = new mP(Object, "plugins")),
            (this.scales = new mP(pP, "scales")),
            (this._typedRegistries = [
              this.controllers,
              this.scales,
              this.elements,
            ]);
        }
        add(...e) {
          this._each("register", e);
        }
        remove(...e) {
          this._each("unregister", e);
        }
        addControllers(...e) {
          this._each("register", e, this.controllers);
        }
        addElements(...e) {
          this._each("register", e, this.elements);
        }
        addPlugins(...e) {
          this._each("register", e, this.plugins);
        }
        addScales(...e) {
          this._each("register", e, this.scales);
        }
        getController(e) {
          return this._get(e, this.controllers, "controller");
        }
        getElement(e) {
          return this._get(e, this.elements, "element");
        }
        getPlugin(e) {
          return this._get(e, this.plugins, "plugin");
        }
        getScale(e) {
          return this._get(e, this.scales, "scale");
        }
        removeControllers(...e) {
          this._each("unregister", e, this.controllers);
        }
        removeElements(...e) {
          this._each("unregister", e, this.elements);
        }
        removePlugins(...e) {
          this._each("unregister", e, this.plugins);
        }
        removeScales(...e) {
          this._each("unregister", e, this.scales);
        }
        _each(e, t, n) {
          [...t].forEach((t) => {
            const r = n || this._getRegistryForType(t);
            n || r.isForType(t) || (r === this.plugins && t.id)
              ? this._exec(e, r, t)
              : xC(t, (t) => {
                  const r = n || this._getRegistryForType(t);
                  this._exec(e, r, t);
                });
          });
        }
        _exec(e, t, n) {
          const r = NC(e);
          CC(n["before" + r], [], n), t[e](n), CC(n["after" + r], [], n);
        }
        _getRegistryForType(e) {
          for (let t = 0; t < this._typedRegistries.length; t++) {
            const n = this._typedRegistries[t];
            if (n.isForType(e)) return n;
          }
          return this.plugins;
        }
        _get(e, t, n) {
          const r = t.get(e);
          if (void 0 === r)
            throw new Error('"' + e + '" is not a registered ' + n + ".");
          return r;
        }
      })();
      class fP extends Fk {
        update(e) {
          const t = this._cachedMeta,
            { data: n = [] } = t,
            r = this.chart._animationsDisabled;
          let { start: o, count: a } = gx(t, n, r);
          if (
            ((this._drawStart = o),
            (this._drawCount = a),
            vx(t) && ((o = 0), (a = n.length)),
            this.options.showLine)
          ) {
            const { dataset: o, _dataset: a } = t;
            (o._chart = this.chart),
              (o._datasetIndex = this.index),
              (o._decimated = !!a._decimated),
              (o.points = n);
            const i = this.resolveDatasetElementOptions(e);
            (i.segment = this.options.segment),
              this.updateElement(o, void 0, { animated: !r, options: i }, e);
          }
          this.updateElements(n, o, a, e);
        }
        addElements() {
          const { showLine: e } = this.options;
          !this.datasetElementType &&
            e &&
            (this.datasetElementType = hP.getElement("line")),
            super.addElements();
        }
        updateElements(e, t, n, r) {
          const o = "reset" === r,
            {
              iScale: a,
              vScale: i,
              _stacked: s,
              _dataset: l,
            } = this._cachedMeta,
            d = this.resolveDataElementOptions(t, r),
            c = this.getSharedOptions(d),
            u = this.includeOptions(r, c),
            p = a.axis,
            m = i.axis,
            { spanGaps: h, segment: f } = this.options,
            g = KC(h) ? h : Number.POSITIVE_INFINITY,
            v = this.chart._animationsDisabled || o || "none" === r;
          let b = t > 0 && this.getParsed(t - 1);
          for (let d = t; d < t + n; ++d) {
            const t = e[d],
              n = this.getParsed(d),
              h = v ? t : {},
              _ = hC(n[m]),
              y = (h[p] = a.getPixelForValue(n[p], d)),
              C = (h[m] =
                o || _
                  ? i.getBasePixel()
                  : i.getPixelForValue(s ? this.applyStack(i, n, s) : n[m], d));
            (h.skip = isNaN(y) || isNaN(C) || _),
              (h.stop = d > 0 && Math.abs(n[p] - b[p]) > g),
              f && ((h.parsed = n), (h.raw = l.data[d])),
              u &&
                (h.options =
                  c ||
                  this.resolveDataElementOptions(d, t.active ? "active" : r)),
              v || this.updateElement(t, d, h, r),
              (b = n);
          }
          this.updateSharedOptions(c, r, d);
        }
        getMaxOverflow() {
          const e = this._cachedMeta,
            t = e.data || [];
          if (!this.options.showLine) {
            let e = 0;
            for (let n = t.length - 1; n >= 0; --n)
              e = Math.max(e, t[n].size(this.resolveDataElementOptions(n)) / 2);
            return e > 0 && e;
          }
          const n = e.dataset,
            r = (n.options && n.options.borderWidth) || 0;
          if (!t.length) return r;
          const o = t[0].size(this.resolveDataElementOptions(0)),
            a = t[t.length - 1].size(
              this.resolveDataElementOptions(t.length - 1)
            );
          return Math.max(r, o, a) / 2;
        }
      }
      function gP() {
        throw new Error(
          "This method is not implemented: Check that a complete date adapter is provided."
        );
      }
      (fP.id = "scatter"),
        (fP.defaults = {
          datasetElementType: !1,
          dataElementType: "point",
          showLine: !1,
          fill: !1,
        }),
        (fP.overrides = {
          interaction: { mode: "point" },
          plugins: {
            tooltip: {
              callbacks: {
                title() {
                  return "";
                },
                label(e) {
                  return "(" + e.label + ", " + e.formattedValue + ")";
                },
              },
            },
          },
          scales: { x: { type: "linear" }, y: { type: "linear" } },
        });
      class vP {
        constructor(e) {
          this.options = e || {};
        }
        init(e) {}
        formats() {
          return gP();
        }
        parse(e, t) {
          return gP();
        }
        format(e, t) {
          return gP();
        }
        add(e, t, n) {
          return gP();
        }
        diff(e, t, n) {
          return gP();
        }
        startOf(e, t, n) {
          return gP();
        }
        endOf(e, t) {
          return gP();
        }
      }
      vP.override = function (e) {
        Object.assign(vP.prototype, e);
      };
      var bP = { _date: vP };
      function _P(e, t, n, r) {
        const { controller: o, data: a, _sorted: i } = e,
          s = o._cachedMeta.iScale;
        if (s && t === s.axis && "r" !== t && i && a.length) {
          const e = s._reversePixels ? lx : sx;
          if (!r) return e(a, t, n);
          if (o._sharedOptions) {
            const r = a[0],
              o = "function" == typeof r.getRange && r.getRange(t);
            if (o) {
              const r = e(a, t, n - o),
                i = e(a, t, n + o);
              return { lo: r.lo, hi: i.hi };
            }
          }
        }
        return { lo: 0, hi: a.length - 1 };
      }
      function yP(e, t, n, r, o) {
        const a = e.getSortedVisibleDatasetMetas(),
          i = n[t];
        for (let e = 0, n = a.length; e < n; ++e) {
          const { index: n, data: s } = a[e],
            { lo: l, hi: d } = _P(a[e], t, i, o);
          for (let e = l; e <= d; ++e) {
            const t = s[e];
            t.skip || r(t, n, e);
          }
        }
      }
      function CP(e, t, n, r, o) {
        const a = [];
        return o || e.isPointInArea(t)
          ? (yP(
              e,
              n,
              t,
              function (n, i, s) {
                (o || mS(n, e.chartArea, 0)) &&
                  n.inRange(t.x, t.y, r) &&
                  a.push({ element: n, datasetIndex: i, index: s });
              },
              !0
            ),
            a)
          : a;
      }
      function xP(e, t, n, r, o, a) {
        return a || e.isPointInArea(t)
          ? "r" !== n || r
            ? (function (e, t, n, r, o, a) {
                let i = [];
                const s = (function (e) {
                  const t = -1 !== e.indexOf("x"),
                    n = -1 !== e.indexOf("y");
                  return function (e, r) {
                    const o = t ? Math.abs(e.x - r.x) : 0,
                      a = n ? Math.abs(e.y - r.y) : 0;
                    return Math.sqrt(Math.pow(o, 2) + Math.pow(a, 2));
                  };
                })(n);
                let l = Number.POSITIVE_INFINITY;
                return (
                  yP(e, n, t, function (n, d, c) {
                    const u = n.inRange(t.x, t.y, o);
                    if (r && !u) return;
                    const p = n.getCenterPoint(o);
                    if (!a && !e.isPointInArea(p) && !u) return;
                    const m = s(t, p);
                    m < l
                      ? ((i = [{ element: n, datasetIndex: d, index: c }]),
                        (l = m))
                      : m === l &&
                        i.push({ element: n, datasetIndex: d, index: c });
                  }),
                  i
                );
              })(e, t, n, r, o, a)
            : (function (e, t, n, r) {
                let o = [];
                return (
                  yP(e, n, t, function (e, n, a) {
                    const { startAngle: i, endAngle: s } = e.getProps(
                        ["startAngle", "endAngle"],
                        r
                      ),
                      { angle: l } = XC(e, { x: t.x, y: t.y });
                    rx(l, i, s) &&
                      o.push({ element: e, datasetIndex: n, index: a });
                  }),
                  o
                );
              })(e, t, n, o)
          : [];
      }
      function SP(e, t, n, r, o) {
        const a = [],
          i = "x" === n ? "inXRange" : "inYRange";
        let s = !1;
        return (
          yP(e, n, t, (e, r, l) => {
            e[i](t[n], o) &&
              (a.push({ element: e, datasetIndex: r, index: l }),
              (s = s || e.inRange(t.x, t.y, o)));
          }),
          r && !s ? [] : a
        );
      }
      var kP = {
        evaluateInteractionItems: yP,
        modes: {
          index(e, t, n, r) {
            const o = ak(t, e),
              a = n.axis || "x",
              i = n.includeInvisible || !1,
              s = n.intersect ? CP(e, o, a, r, i) : xP(e, o, a, !1, r, i),
              l = [];
            return s.length
              ? (e.getSortedVisibleDatasetMetas().forEach((e) => {
                  const t = s[0].index,
                    n = e.data[t];
                  n &&
                    !n.skip &&
                    l.push({ element: n, datasetIndex: e.index, index: t });
                }),
                l)
              : [];
          },
          dataset(e, t, n, r) {
            const o = ak(t, e),
              a = n.axis || "xy",
              i = n.includeInvisible || !1;
            let s = n.intersect ? CP(e, o, a, r, i) : xP(e, o, a, !1, r, i);
            if (s.length > 0) {
              const t = s[0].datasetIndex,
                n = e.getDatasetMeta(t).data;
              s = [];
              for (let e = 0; e < n.length; ++e)
                s.push({ element: n[e], datasetIndex: t, index: e });
            }
            return s;
          },
          point(e, t, n, r) {
            return CP(e, ak(t, e), n.axis || "xy", r, n.includeInvisible || !1);
          },
          nearest(e, t, n, r) {
            const o = ak(t, e),
              a = n.axis || "xy",
              i = n.includeInvisible || !1;
            return xP(e, o, a, n.intersect, r, i);
          },
          x(e, t, n, r) {
            return SP(e, ak(t, e), "x", n.intersect, r);
          },
          y(e, t, n, r) {
            return SP(e, ak(t, e), "y", n.intersect, r);
          },
        },
      };
      const PP = ["left", "top", "right", "bottom"];
      function wP(e, t) {
        return e.filter((e) => e.pos === t);
      }
      function OP(e, t) {
        return e.filter((e) => -1 === PP.indexOf(e.pos) && e.box.axis === t);
      }
      function TP(e, t) {
        return e.sort((e, n) => {
          const r = t ? n : e,
            o = t ? e : n;
          return r.weight === o.weight
            ? r.index - o.index
            : r.weight - o.weight;
        });
      }
      function IP(e, t, n, r) {
        return Math.max(e[n], t[n]) + Math.max(e[r], t[r]);
      }
      function MP(e, t) {
        (e.top = Math.max(e.top, t.top)),
          (e.left = Math.max(e.left, t.left)),
          (e.bottom = Math.max(e.bottom, t.bottom)),
          (e.right = Math.max(e.right, t.right));
      }
      function jP(e, t, n, r) {
        const { pos: o, box: a } = n,
          i = e.maxPadding;
        if (!gC(o)) {
          n.size && (e[o] -= n.size);
          const t = r[n.stack] || { size: 0, count: 1 };
          (t.size = Math.max(t.size, n.horizontal ? a.height : a.width)),
            (n.size = t.size / t.count),
            (e[o] += n.size);
        }
        a.getPadding && MP(i, a.getPadding());
        const s = Math.max(0, t.outerWidth - IP(i, e, "left", "right")),
          l = Math.max(0, t.outerHeight - IP(i, e, "top", "bottom")),
          d = s !== e.w,
          c = l !== e.h;
        return (
          (e.w = s),
          (e.h = l),
          n.horizontal ? { same: d, other: c } : { same: c, other: d }
        );
      }
      function NP(e, t) {
        const n = t.maxPadding;
        return (function (e) {
          const r = { left: 0, top: 0, right: 0, bottom: 0 };
          return (
            e.forEach((e) => {
              r[e] = Math.max(t[e], n[e]);
            }),
            r
          );
        })(e ? ["left", "right"] : ["top", "bottom"]);
      }
      function DP(e, t, n, r) {
        const o = [];
        let a, i, s, l, d, c;
        for (a = 0, i = e.length, d = 0; a < i; ++a) {
          (s = e[a]),
            (l = s.box),
            l.update(s.width || t.w, s.height || t.h, NP(s.horizontal, t));
          const { same: i, other: u } = jP(t, n, s, r);
          (d |= i && o.length), (c = c || u), l.fullSize || o.push(s);
        }
        return (d && DP(o, t, n, r)) || c;
      }
      function AP(e, t, n, r, o) {
        (e.top = n),
          (e.left = t),
          (e.right = t + r),
          (e.bottom = n + o),
          (e.width = r),
          (e.height = o);
      }
      function EP(e, t, n, r) {
        const o = n.padding;
        let { x: a, y: i } = t;
        for (const s of e) {
          const e = s.box,
            l = r[s.stack] || { count: 1, placed: 0, weight: 1 },
            d = s.stackWeight / l.weight || 1;
          if (s.horizontal) {
            const r = t.w * d,
              a = l.size || e.height;
            DC(l.start) && (i = l.start),
              e.fullSize
                ? AP(e, o.left, i, n.outerWidth - o.right - o.left, a)
                : AP(e, t.left + l.placed, i, r, a),
              (l.start = i),
              (l.placed += r),
              (i = e.bottom);
          } else {
            const r = t.h * d,
              i = l.size || e.width;
            DC(l.start) && (a = l.start),
              e.fullSize
                ? AP(e, a, o.top, i, n.outerHeight - o.bottom - o.top)
                : AP(e, a, t.top + l.placed, i, r),
              (l.start = a),
              (l.placed += r),
              (a = e.right);
          }
        }
        (t.x = a), (t.y = i);
      }
      iS.set("layout", {
        autoPadding: !0,
        padding: { top: 0, right: 0, bottom: 0, left: 0 },
      });
      var RP = {
        addBox(e, t) {
          e.boxes || (e.boxes = []),
            (t.fullSize = t.fullSize || !1),
            (t.position = t.position || "top"),
            (t.weight = t.weight || 0),
            (t._layers =
              t._layers ||
              function () {
                return [
                  {
                    z: 0,
                    draw(e) {
                      t.draw(e);
                    },
                  },
                ];
              }),
            e.boxes.push(t);
        },
        removeBox(e, t) {
          const n = e.boxes ? e.boxes.indexOf(t) : -1;
          -1 !== n && e.boxes.splice(n, 1);
        },
        configure(e, t, n) {
          (t.fullSize = n.fullSize),
            (t.position = n.position),
            (t.weight = n.weight);
        },
        update(e, t, n, r) {
          if (!e) return;
          const o = TS(e.options.layout.padding),
            a = Math.max(t - o.width, 0),
            i = Math.max(n - o.height, 0),
            s = (function (e) {
              const t = (function (e) {
                  const t = [];
                  let n, r, o, a, i, s;
                  for (n = 0, r = (e || []).length; n < r; ++n)
                    (o = e[n]),
                      ({
                        position: a,
                        options: { stack: i, stackWeight: s = 1 },
                      } = o),
                      t.push({
                        index: n,
                        box: o,
                        pos: a,
                        horizontal: o.isHorizontal(),
                        weight: o.weight,
                        stack: i && a + i,
                        stackWeight: s,
                      });
                  return t;
                })(e),
                n = TP(
                  t.filter((e) => e.box.fullSize),
                  !0
                ),
                r = TP(wP(t, "left"), !0),
                o = TP(wP(t, "right")),
                a = TP(wP(t, "top"), !0),
                i = TP(wP(t, "bottom")),
                s = OP(t, "x"),
                l = OP(t, "y");
              return {
                fullSize: n,
                leftAndTop: r.concat(a),
                rightAndBottom: o.concat(l).concat(i).concat(s),
                chartArea: wP(t, "chartArea"),
                vertical: r.concat(o).concat(l),
                horizontal: a.concat(i).concat(s),
              };
            })(e.boxes),
            l = s.vertical,
            d = s.horizontal;
          xC(e.boxes, (e) => {
            "function" == typeof e.beforeLayout && e.beforeLayout();
          });
          const c =
              l.reduce(
                (e, t) =>
                  t.box.options && !1 === t.box.options.display ? e : e + 1,
                0
              ) || 1,
            u = Object.freeze({
              outerWidth: t,
              outerHeight: n,
              padding: o,
              availableWidth: a,
              availableHeight: i,
              vBoxMaxWidth: a / 2 / c,
              hBoxMaxHeight: i / 2,
            }),
            p = Object.assign({}, o);
          MP(p, TS(r));
          const m = Object.assign(
              { maxPadding: p, w: a, h: i, x: o.left, y: o.top },
              o
            ),
            h = (function (e, t) {
              const n = (function (e) {
                  const t = {};
                  for (const n of e) {
                    const { stack: e, pos: r, stackWeight: o } = n;
                    if (!e || !PP.includes(r)) continue;
                    const a =
                      t[e] ||
                      (t[e] = { count: 0, placed: 0, weight: 0, size: 0 });
                    a.count++, (a.weight += o);
                  }
                  return t;
                })(e),
                { vBoxMaxWidth: r, hBoxMaxHeight: o } = t;
              let a, i, s;
              for (a = 0, i = e.length; a < i; ++a) {
                s = e[a];
                const { fullSize: i } = s.box,
                  l = n[s.stack],
                  d = l && s.stackWeight / l.weight;
                s.horizontal
                  ? ((s.width = d ? d * r : i && t.availableWidth),
                    (s.height = o))
                  : ((s.width = r),
                    (s.height = d ? d * o : i && t.availableHeight));
              }
              return n;
            })(l.concat(d), u);
          DP(s.fullSize, m, u, h),
            DP(l, m, u, h),
            DP(d, m, u, h) && DP(l, m, u, h),
            (function (e) {
              const t = e.maxPadding;
              function n(n) {
                const r = Math.max(t[n] - e[n], 0);
                return (e[n] += r), r;
              }
              (e.y += n("top")), (e.x += n("left")), n("right"), n("bottom");
            })(m),
            EP(s.leftAndTop, m, u, h),
            (m.x += m.w),
            (m.y += m.h),
            EP(s.rightAndBottom, m, u, h),
            (e.chartArea = {
              left: m.left,
              top: m.top,
              right: m.left + m.w,
              bottom: m.top + m.h,
              height: m.h,
              width: m.w,
            }),
            xC(s.chartArea, (t) => {
              const n = t.box;
              Object.assign(n, e.chartArea),
                n.update(m.w, m.h, { left: 0, top: 0, right: 0, bottom: 0 });
            });
        },
      };
      class LP {
        acquireContext(e, t) {}
        releaseContext(e) {
          return !1;
        }
        addEventListener(e, t, n) {}
        removeEventListener(e, t, n) {}
        getDevicePixelRatio() {
          return 1;
        }
        getMaximumSize(e, t, n, r) {
          return (
            (t = Math.max(0, t || e.width)),
            (n = n || e.height),
            { width: t, height: Math.max(0, r ? Math.floor(t / r) : n) }
          );
        }
        isAttached(e) {
          return !0;
        }
        updateConfig(e) {}
      }
      class BP extends LP {
        acquireContext(e) {
          return (e && e.getContext && e.getContext("2d")) || null;
        }
        updateConfig(e) {
          e.options.animation = !1;
        }
      }
      const zP = "$chartjs",
        FP = {
          touchstart: "mousedown",
          touchmove: "mousemove",
          touchend: "mouseup",
          pointerenter: "mouseenter",
          pointerdown: "mousedown",
          pointermove: "mousemove",
          pointerup: "mouseup",
          pointerleave: "mouseout",
          pointerout: "mouseout",
        },
        ZP = (e) => null === e || "" === e,
        HP = !!lk && { passive: !0 };
      function VP(e, t, n) {
        e.canvas.removeEventListener(t, n, HP);
      }
      function WP(e, t) {
        for (const n of e) if (n === t || n.contains(t)) return !0;
      }
      function UP(e, t, n) {
        const r = e.canvas,
          o = new MutationObserver((e) => {
            let t = !1;
            for (const n of e)
              (t = t || WP(n.addedNodes, r)), (t = t && !WP(n.removedNodes, r));
            t && n();
          });
        return o.observe(document, { childList: !0, subtree: !0 }), o;
      }
      function $P(e, t, n) {
        const r = e.canvas,
          o = new MutationObserver((e) => {
            let t = !1;
            for (const n of e)
              (t = t || WP(n.removedNodes, r)), (t = t && !WP(n.addedNodes, r));
            t && n();
          });
        return o.observe(document, { childList: !0, subtree: !0 }), o;
      }
      const KP = new Map();
      let GP = 0;
      function qP() {
        const e = window.devicePixelRatio;
        e !== GP &&
          ((GP = e),
          KP.forEach((t, n) => {
            n.currentDevicePixelRatio !== e && t();
          }));
      }
      function QP(e, t, n) {
        const r = e.canvas,
          o = r && XS(r);
        if (!o) return;
        const a = mx((e, t) => {
            const r = o.clientWidth;
            n(e, t), r < o.clientWidth && n();
          }, window),
          i = new ResizeObserver((e) => {
            const t = e[0],
              n = t.contentRect.width,
              r = t.contentRect.height;
            (0 === n && 0 === r) || a(n, r);
          });
        return (
          i.observe(o),
          (function (e, t) {
            KP.size || window.addEventListener("resize", qP), KP.set(e, t);
          })(e, a),
          i
        );
      }
      function YP(e, t, n) {
        n && n.disconnect(),
          "resize" === t &&
            (function (e) {
              KP.delete(e), KP.size || window.removeEventListener("resize", qP);
            })(e);
      }
      function JP(e, t, n) {
        const r = e.canvas,
          o = mx(
            (t) => {
              null !== e.ctx &&
                n(
                  (function (e, t) {
                    const n = FP[e.type] || e.type,
                      { x: r, y: o } = ak(e, t);
                    return {
                      type: n,
                      chart: t,
                      native: e,
                      x: void 0 !== r ? r : null,
                      y: void 0 !== o ? o : null,
                    };
                  })(t, e)
                );
            },
            e,
            (e) => {
              const t = e[0];
              return [t, t.offsetX, t.offsetY];
            }
          );
        return (
          (function (e, t, n) {
            e.addEventListener(t, n, HP);
          })(r, t, o),
          o
        );
      }
      class XP extends LP {
        acquireContext(e, t) {
          const n = e && e.getContext && e.getContext("2d");
          return n && n.canvas === e
            ? ((function (e, t) {
                const n = e.style,
                  r = e.getAttribute("height"),
                  o = e.getAttribute("width");
                if (
                  ((e[zP] = {
                    initial: {
                      height: r,
                      width: o,
                      style: {
                        display: n.display,
                        height: n.height,
                        width: n.width,
                      },
                    },
                  }),
                  (n.display = n.display || "block"),
                  (n.boxSizing = n.boxSizing || "border-box"),
                  ZP(o))
                ) {
                  const t = dk(e, "width");
                  void 0 !== t && (e.width = t);
                }
                if (ZP(r))
                  if ("" === e.style.height) e.height = e.width / (t || 2);
                  else {
                    const t = dk(e, "height");
                    void 0 !== t && (e.height = t);
                  }
              })(e, t),
              n)
            : null;
        }
        releaseContext(e) {
          const t = e.canvas;
          if (!t[zP]) return !1;
          const n = t[zP].initial;
          ["height", "width"].forEach((e) => {
            const r = n[e];
            hC(r) ? t.removeAttribute(e) : t.setAttribute(e, r);
          });
          const r = n.style || {};
          return (
            Object.keys(r).forEach((e) => {
              t.style[e] = r[e];
            }),
            (t.width = t.width),
            delete t[zP],
            !0
          );
        }
        addEventListener(e, t, n) {
          this.removeEventListener(e, t);
          const r = e.$proxies || (e.$proxies = {}),
            o = { attach: UP, detach: $P, resize: QP }[t] || JP;
          r[t] = o(e, t, n);
        }
        removeEventListener(e, t) {
          const n = e.$proxies || (e.$proxies = {}),
            r = n[t];
          r &&
            (({ attach: YP, detach: YP, resize: YP }[t] || VP)(e, t, r),
            (n[t] = void 0));
        }
        getDevicePixelRatio() {
          return window.devicePixelRatio;
        }
        getMaximumSize(e, t, n, r) {
          return (function (e, t, n, r) {
            const o = tk(e),
              a = rk(o, "margin"),
              i = ek(o.maxWidth, e, "clientWidth") || zC,
              s = ek(o.maxHeight, e, "clientHeight") || zC,
              l = (function (e, t, n) {
                let r, o;
                if (void 0 === t || void 0 === n) {
                  const a = XS(e);
                  if (a) {
                    const e = a.getBoundingClientRect(),
                      i = tk(a),
                      s = rk(i, "border", "width"),
                      l = rk(i, "padding");
                    (t = e.width - l.width - s.width),
                      (n = e.height - l.height - s.height),
                      (r = ek(i.maxWidth, a, "clientWidth")),
                      (o = ek(i.maxHeight, a, "clientHeight"));
                  } else (t = e.clientWidth), (n = e.clientHeight);
                }
                return {
                  width: t,
                  height: n,
                  maxWidth: r || zC,
                  maxHeight: o || zC,
                };
              })(e, t, n);
            let { width: d, height: c } = l;
            if ("content-box" === o.boxSizing) {
              const e = rk(o, "border", "width"),
                t = rk(o, "padding");
              (d -= t.width + e.width), (c -= t.height + e.height);
            }
            return (
              (d = Math.max(0, d - a.width)),
              (c = Math.max(0, r ? Math.floor(d / r) : c - a.height)),
              (d = ik(Math.min(d, i, l.maxWidth))),
              (c = ik(Math.min(c, s, l.maxHeight))),
              d && !c && (c = ik(d / 2)),
              { width: d, height: c }
            );
          })(e, t, n, r);
        }
        isAttached(e) {
          const t = XS(e);
          return !(!t || !t.isConnected);
        }
      }
      class ew {
        constructor() {
          this._init = [];
        }
        notify(e, t, n, r) {
          "beforeInit" === t &&
            ((this._init = this._createDescriptors(e, !0)),
            this._notify(this._init, e, "install"));
          const o = r ? this._descriptors(e).filter(r) : this._descriptors(e),
            a = this._notify(o, e, t, n);
          return (
            "afterDestroy" === t &&
              (this._notify(o, e, "stop"),
              this._notify(this._init, e, "uninstall")),
            a
          );
        }
        _notify(e, t, n, r) {
          r = r || {};
          for (const o of e) {
            const e = o.plugin;
            if (!1 === CC(e[n], [t, r, o.options], e) && r.cancelable)
              return !1;
          }
          return !0;
        }
        invalidate() {
          hC(this._cache) ||
            ((this._oldCache = this._cache), (this._cache = void 0));
        }
        _descriptors(e) {
          if (this._cache) return this._cache;
          const t = (this._cache = this._createDescriptors(e));
          return this._notifyStateChanges(e), t;
        }
        _createDescriptors(e, t) {
          const n = e && e.config,
            r = _C(n.options && n.options.plugins, {}),
            o = (function (e) {
              const t = {},
                n = [],
                r = Object.keys(hP.plugins.items);
              for (let e = 0; e < r.length; e++) n.push(hP.getPlugin(r[e]));
              const o = e.plugins || [];
              for (let e = 0; e < o.length; e++) {
                const r = o[e];
                -1 === n.indexOf(r) && (n.push(r), (t[r.id] = !0));
              }
              return { plugins: n, localIds: t };
            })(n);
          return !1 !== r || t
            ? (function (e, { plugins: t, localIds: n }, r, o) {
                const a = [],
                  i = e.getContext();
                for (const s of t) {
                  const t = s.id,
                    l = tw(r[t], o);
                  null !== l &&
                    a.push({
                      plugin: s,
                      options: nw(e.config, { plugin: s, local: n[t] }, l, i),
                    });
                }
                return a;
              })(e, o, r, t)
            : [];
        }
        _notifyStateChanges(e) {
          const t = this._oldCache || [],
            n = this._cache,
            r = (e, t) =>
              e.filter((e) => !t.some((t) => e.plugin.id === t.plugin.id));
          this._notify(r(t, n), e, "stop"), this._notify(r(n, t), e, "start");
        }
      }
      function tw(e, t) {
        return t || !1 !== e ? (!0 === e ? {} : e) : null;
      }
      function nw(e, { plugin: t, local: n }, r, o) {
        const a = e.pluginScopeKeys(t),
          i = e.getOptionScopes(r, a);
        return (
          n && t.defaults && i.push(t.defaults),
          e.createResolver(i, o, [""], {
            scriptable: !1,
            indexable: !1,
            allKeys: !0,
          })
        );
      }
      function rw(e, t) {
        const n = iS.datasets[e] || {};
        return (
          ((t.datasets || {})[e] || {}).indexAxis ||
          t.indexAxis ||
          n.indexAxis ||
          "x"
        );
      }
      function ow(e, t) {
        return "x" === e || "y" === e
          ? e
          : t.axis ||
              ("top" === (n = t.position) || "bottom" === n
                ? "x"
                : "left" === n || "right" === n
                ? "y"
                : void 0) ||
              e.charAt(0).toLowerCase();
        var n;
      }
      function aw(e) {
        const t = e.options || (e.options = {});
        (t.plugins = _C(t.plugins, {})),
          (t.scales = (function (e, t) {
            const n = nS[e.type] || { scales: {} },
              r = t.scales || {},
              o = rw(e.type, t),
              a = Object.create(null),
              i = Object.create(null);
            return (
              Object.keys(r).forEach((e) => {
                const t = r[e];
                if (!gC(t))
                  return console.error(
                    `Invalid scale configuration for scale: ${e}`
                  );
                if (t._proxy)
                  return console.warn(
                    `Ignoring resolver passed as options for scale: ${e}`
                  );
                const s = ow(e, t),
                  l = (function (e, t) {
                    return e === t ? "_index_" : "_value_";
                  })(s, o),
                  d = n.scales || {};
                (a[s] = a[s] || e),
                  (i[e] = TC(Object.create(null), [
                    { axis: s },
                    t,
                    d[s],
                    d[l],
                  ]));
              }),
              e.data.datasets.forEach((n) => {
                const o = n.type || e.type,
                  s = n.indexAxis || rw(o, t),
                  l = (nS[o] || {}).scales || {};
                Object.keys(l).forEach((e) => {
                  const t = (function (e, t) {
                      let n = e;
                      return (
                        "_index_" === e
                          ? (n = t)
                          : "_value_" === e && (n = "x" === t ? "y" : "x"),
                        n
                      );
                    })(e, s),
                    o = n[t + "AxisID"] || a[t] || t;
                  (i[o] = i[o] || Object.create(null)),
                    TC(i[o], [{ axis: t }, r[o], l[e]]);
                });
              }),
              Object.keys(i).forEach((e) => {
                const t = i[e];
                TC(t, [iS.scales[t.type], iS.scale]);
              }),
              i
            );
          })(e, t));
      }
      function iw(e) {
        return (
          ((e = e || {}).datasets = e.datasets || []),
          (e.labels = e.labels || []),
          e
        );
      }
      const sw = new Map(),
        lw = new Set();
      function dw(e, t) {
        let n = sw.get(e);
        return n || ((n = t()), sw.set(e, n), lw.add(n)), n;
      }
      const cw = (e, t, n) => {
        const r = jC(t, n);
        void 0 !== r && e.add(r);
      };
      class uw {
        constructor(e) {
          (this._config = (function (e) {
            return ((e = e || {}).data = iw(e.data)), aw(e), e;
          })(e)),
            (this._scopeCache = new Map()),
            (this._resolverCache = new Map());
        }
        get platform() {
          return this._config.platform;
        }
        get type() {
          return this._config.type;
        }
        set type(e) {
          this._config.type = e;
        }
        get data() {
          return this._config.data;
        }
        set data(e) {
          this._config.data = iw(e);
        }
        get options() {
          return this._config.options;
        }
        set options(e) {
          this._config.options = e;
        }
        get plugins() {
          return this._config.plugins;
        }
        update() {
          const e = this._config;
          this.clearCache(), aw(e);
        }
        clearCache() {
          this._scopeCache.clear(), this._resolverCache.clear();
        }
        datasetScopeKeys(e) {
          return dw(e, () => [[`datasets.${e}`, ""]]);
        }
        datasetAnimationScopeKeys(e, t) {
          return dw(`${e}.transition.${t}`, () => [
            [`datasets.${e}.transitions.${t}`, `transitions.${t}`],
            [`datasets.${e}`, ""],
          ]);
        }
        datasetElementScopeKeys(e, t) {
          return dw(`${e}-${t}`, () => [
            [
              `datasets.${e}.elements.${t}`,
              `datasets.${e}`,
              `elements.${t}`,
              "",
            ],
          ]);
        }
        pluginScopeKeys(e) {
          const t = e.id;
          return dw(`${this.type}-plugin-${t}`, () => [
            [`plugins.${t}`, ...(e.additionalOptionScopes || [])],
          ]);
        }
        _cachedScopes(e, t) {
          const n = this._scopeCache;
          let r = n.get(e);
          return (r && !t) || ((r = new Map()), n.set(e, r)), r;
        }
        getOptionScopes(e, t, n) {
          const { options: r, type: o } = this,
            a = this._cachedScopes(e, n),
            i = a.get(t);
          if (i) return i;
          const s = new Set();
          t.forEach((t) => {
            e && (s.add(e), t.forEach((t) => cw(s, e, t))),
              t.forEach((e) => cw(s, r, e)),
              t.forEach((e) => cw(s, nS[o] || {}, e)),
              t.forEach((e) => cw(s, iS, e)),
              t.forEach((e) => cw(s, rS, e));
          });
          const l = Array.from(s);
          return (
            0 === l.length && l.push(Object.create(null)),
            lw.has(t) && a.set(t, l),
            l
          );
        }
        chartOptionScopes() {
          const { options: e, type: t } = this;
          return [e, nS[t] || {}, iS.datasets[t] || {}, { type: t }, iS, rS];
        }
        resolveNamedOptions(e, t, n, r = [""]) {
          const o = { $shared: !0 },
            { resolver: a, subPrefixes: i } = pw(this._resolverCache, e, r);
          let s = a;
          (function (e, t) {
            const { isScriptable: n, isIndexable: r } = AS(e);
            for (const o of t) {
              const t = n(o),
                a = r(o),
                i = (a || t) && e[o];
              if ((t && (AC(i) || mw(i))) || (a && fC(i))) return !0;
            }
            return !1;
          })(a, t) &&
            ((o.$shared = !1),
            (s = DS(a, (n = AC(n) ? n() : n), this.createResolver(e, n, i))));
          for (const e of t) o[e] = s[e];
          return o;
        }
        createResolver(e, t, n = [""], r) {
          const { resolver: o } = pw(this._resolverCache, e, n);
          return gC(t) ? DS(o, t, void 0, r) : o;
        }
      }
      function pw(e, t, n) {
        let r = e.get(t);
        r || ((r = new Map()), e.set(t, r));
        const o = n.join();
        let a = r.get(o);
        return (
          a ||
            ((a = {
              resolver: NS(t, n),
              subPrefixes: n.filter((e) => !e.toLowerCase().includes("hover")),
            }),
            r.set(o, a)),
          a
        );
      }
      const mw = (e) =>
          gC(e) &&
          Object.getOwnPropertyNames(e).reduce((t, n) => t || AC(e[n]), !1),
        hw = ["top", "bottom", "left", "right", "chartArea"];
      function fw(e, t) {
        return (
          "top" === e || "bottom" === e || (-1 === hw.indexOf(e) && "x" === t)
        );
      }
      function gw(e, t) {
        return function (n, r) {
          return n[e] === r[e] ? n[t] - r[t] : n[e] - r[e];
        };
      }
      function vw(e) {
        const t = e.chart,
          n = t.options.animation;
        t.notifyPlugins("afterRender"), CC(n && n.onComplete, [e], t);
      }
      function bw(e) {
        const t = e.chart,
          n = t.options.animation;
        CC(n && n.onProgress, [e], t);
      }
      function _w(e) {
        return (
          JS() && "string" == typeof e
            ? (e = document.getElementById(e))
            : e && e.length && (e = e[0]),
          e && e.canvas && (e = e.canvas),
          e
        );
      }
      const yw = {},
        Cw = (e) => {
          const t = _w(e);
          return Object.values(yw)
            .filter((e) => e.canvas === t)
            .pop();
        };
      function xw(e, t, n) {
        const r = Object.keys(e);
        for (const o of r) {
          const r = +o;
          if (r >= t) {
            const a = e[o];
            delete e[o], (n > 0 || r > t) && (e[r + n] = a);
          }
        }
      }
      class Sw {
        constructor(e, t) {
          const n = (this.config = new uw(t)),
            r = _w(e),
            o = Cw(r);
          if (o)
            throw new Error(
              "Canvas is already in use. Chart with ID '" +
                o.id +
                "' must be destroyed before the canvas with ID '" +
                o.canvas.id +
                "' can be reused."
            );
          const a = n.createResolver(n.chartOptionScopes(), this.getContext());
          (this.platform = new (n.platform ||
            (function (e) {
              return !JS() ||
                ("undefined" != typeof OffscreenCanvas &&
                  e instanceof OffscreenCanvas)
                ? BP
                : XP;
            })(r))()),
            this.platform.updateConfig(n);
          const i = this.platform.acquireContext(r, a.aspectRatio),
            s = i && i.canvas,
            l = s && s.height,
            d = s && s.width;
          (this.id = mC()),
            (this.ctx = i),
            (this.canvas = s),
            (this.width = d),
            (this.height = l),
            (this._options = a),
            (this._aspectRatio = this.aspectRatio),
            (this._layers = []),
            (this._metasets = []),
            (this._stacks = void 0),
            (this.boxes = []),
            (this.currentDevicePixelRatio = void 0),
            (this.chartArea = void 0),
            (this._active = []),
            (this._lastEvent = void 0),
            (this._listeners = {}),
            (this._responsiveListeners = void 0),
            (this._sortedMetasets = []),
            (this.scales = {}),
            (this._plugins = new ew()),
            (this.$proxies = {}),
            (this._hiddenIndices = {}),
            (this.attached = !1),
            (this._animationsDisabled = void 0),
            (this.$context = void 0),
            (this._doResize = (function (e, t) {
              let n;
              return function (...r) {
                return (
                  t
                    ? (clearTimeout(n), (n = setTimeout(e, t, r)))
                    : e.apply(this, r),
                  t
                );
              };
            })((e) => this.update(e), a.resizeDelay || 0)),
            (this._dataChanges = []),
            (yw[this.id] = this),
            i && s
              ? (Sk.listen(this, "complete", vw),
                Sk.listen(this, "progress", bw),
                this._initialize(),
                this.attached && this.update())
              : console.error(
                  "Failed to create chart: can't acquire context from the given item"
                );
        }
        get aspectRatio() {
          const {
            options: { aspectRatio: e, maintainAspectRatio: t },
            width: n,
            height: r,
            _aspectRatio: o,
          } = this;
          return hC(e) ? (t && o ? o : r ? n / r : null) : e;
        }
        get data() {
          return this.config.data;
        }
        set data(e) {
          this.config.data = e;
        }
        get options() {
          return this._options;
        }
        set options(e) {
          this.config.options = e;
        }
        _initialize() {
          return (
            this.notifyPlugins("beforeInit"),
            this.options.responsive
              ? this.resize()
              : sk(this, this.options.devicePixelRatio),
            this.bindEvents(),
            this.notifyPlugins("afterInit"),
            this
          );
        }
        clear() {
          return cS(this.canvas, this.ctx), this;
        }
        stop() {
          return Sk.stop(this), this;
        }
        resize(e, t) {
          Sk.running(this)
            ? (this._resizeBeforeDraw = { width: e, height: t })
            : this._resize(e, t);
        }
        _resize(e, t) {
          const n = this.options,
            r = this.canvas,
            o = n.maintainAspectRatio && this.aspectRatio,
            a = this.platform.getMaximumSize(r, e, t, o),
            i = n.devicePixelRatio || this.platform.getDevicePixelRatio(),
            s = this.width ? "resize" : "attach";
          (this.width = a.width),
            (this.height = a.height),
            (this._aspectRatio = this.aspectRatio),
            sk(this, i, !0) &&
              (this.notifyPlugins("resize", { size: a }),
              CC(n.onResize, [this, a], this),
              this.attached && this._doResize(s) && this.render());
        }
        ensureScalesHaveIDs() {
          xC(this.options.scales || {}, (e, t) => {
            e.id = t;
          });
        }
        buildOrUpdateScales() {
          const e = this.options,
            t = e.scales,
            n = this.scales,
            r = Object.keys(n).reduce((e, t) => ((e[t] = !1), e), {});
          let o = [];
          t &&
            (o = o.concat(
              Object.keys(t).map((e) => {
                const n = t[e],
                  r = ow(e, n),
                  o = "r" === r,
                  a = "x" === r;
                return {
                  options: n,
                  dposition: o ? "chartArea" : a ? "bottom" : "left",
                  dtype: o ? "radialLinear" : a ? "category" : "linear",
                };
              })
            )),
            xC(o, (t) => {
              const o = t.options,
                a = o.id,
                i = ow(a, o),
                s = _C(o.type, t.dtype);
              (void 0 !== o.position &&
                fw(o.position, i) === fw(t.dposition)) ||
                (o.position = t.dposition),
                (r[a] = !0);
              let l = null;
              a in n && n[a].type === s
                ? (l = n[a])
                : ((l = new (hP.getScale(s))({
                    id: a,
                    type: s,
                    ctx: this.ctx,
                    chart: this,
                  })),
                  (n[l.id] = l)),
                l.init(o, e);
            }),
            xC(r, (e, t) => {
              e || delete n[t];
            }),
            xC(n, (e) => {
              RP.configure(this, e, e.options), RP.addBox(this, e);
            });
        }
        _updateMetasets() {
          const e = this._metasets,
            t = this.data.datasets.length,
            n = e.length;
          if ((e.sort((e, t) => e.index - t.index), n > t)) {
            for (let e = t; e < n; ++e) this._destroyDatasetMeta(e);
            e.splice(t, n - t);
          }
          this._sortedMetasets = e.slice(0).sort(gw("order", "index"));
        }
        _removeUnreferencedMetasets() {
          const {
            _metasets: e,
            data: { datasets: t },
          } = this;
          e.length > t.length && delete this._stacks,
            e.forEach((e, n) => {
              0 === t.filter((t) => t === e._dataset).length &&
                this._destroyDatasetMeta(n);
            });
        }
        buildOrUpdateControllers() {
          const e = [],
            t = this.data.datasets;
          let n, r;
          for (
            this._removeUnreferencedMetasets(), n = 0, r = t.length;
            n < r;
            n++
          ) {
            const r = t[n];
            let o = this.getDatasetMeta(n);
            const a = r.type || this.config.type;
            if (
              (o.type &&
                o.type !== a &&
                (this._destroyDatasetMeta(n), (o = this.getDatasetMeta(n))),
              (o.type = a),
              (o.indexAxis = r.indexAxis || rw(a, this.options)),
              (o.order = r.order || 0),
              (o.index = n),
              (o.label = "" + r.label),
              (o.visible = this.isDatasetVisible(n)),
              o.controller)
            )
              o.controller.updateIndex(n), o.controller.linkScales();
            else {
              const t = hP.getController(a),
                { datasetElementType: r, dataElementType: i } = iS.datasets[a];
              Object.assign(t.prototype, {
                dataElementType: hP.getElement(i),
                datasetElementType: r && hP.getElement(r),
              }),
                (o.controller = new t(this, n)),
                e.push(o.controller);
            }
          }
          return this._updateMetasets(), e;
        }
        _resetElements() {
          xC(
            this.data.datasets,
            (e, t) => {
              this.getDatasetMeta(t).controller.reset();
            },
            this
          );
        }
        reset() {
          this._resetElements(), this.notifyPlugins("reset");
        }
        update(e) {
          const t = this.config;
          t.update();
          const n = (this._options = t.createResolver(
              t.chartOptionScopes(),
              this.getContext()
            )),
            r = (this._animationsDisabled = !n.animation);
          if (
            (this._updateScales(),
            this._checkEventBindings(),
            this._updateHiddenIndices(),
            this._plugins.invalidate(),
            !1 ===
              this.notifyPlugins("beforeUpdate", { mode: e, cancelable: !0 }))
          )
            return;
          const o = this.buildOrUpdateControllers();
          this.notifyPlugins("beforeElementsUpdate");
          let a = 0;
          for (let e = 0, t = this.data.datasets.length; e < t; e++) {
            const { controller: t } = this.getDatasetMeta(e),
              n = !r && -1 === o.indexOf(t);
            t.buildOrUpdateElements(n), (a = Math.max(+t.getMaxOverflow(), a));
          }
          (a = this._minPadding = n.layout.autoPadding ? a : 0),
            this._updateLayout(a),
            r ||
              xC(o, (e) => {
                e.reset();
              }),
            this._updateDatasets(e),
            this.notifyPlugins("afterUpdate", { mode: e }),
            this._layers.sort(gw("z", "_idx"));
          const { _active: i, _lastEvent: s } = this;
          s
            ? this._eventHandler(s, !0)
            : i.length && this._updateHoverStyles(i, i, !0),
            this.render();
        }
        _updateScales() {
          xC(this.scales, (e) => {
            RP.removeBox(this, e);
          }),
            this.ensureScalesHaveIDs(),
            this.buildOrUpdateScales();
        }
        _checkEventBindings() {
          const e = this.options,
            t = new Set(Object.keys(this._listeners)),
            n = new Set(e.events);
          (EC(t, n) && !!this._responsiveListeners === e.responsive) ||
            (this.unbindEvents(), this.bindEvents());
        }
        _updateHiddenIndices() {
          const { _hiddenIndices: e } = this,
            t = this._getUniformDataChanges() || [];
          for (const { method: n, start: r, count: o } of t)
            xw(e, r, "_removeElements" === n ? -o : o);
        }
        _getUniformDataChanges() {
          const e = this._dataChanges;
          if (!e || !e.length) return;
          this._dataChanges = [];
          const t = this.data.datasets.length,
            n = (t) =>
              new Set(
                e
                  .filter((e) => e[0] === t)
                  .map((e, t) => t + "," + e.splice(1).join(","))
              ),
            r = n(0);
          for (let e = 1; e < t; e++) if (!EC(r, n(e))) return;
          return Array.from(r)
            .map((e) => e.split(","))
            .map((e) => ({ method: e[1], start: +e[2], count: +e[3] }));
        }
        _updateLayout(e) {
          if (!1 === this.notifyPlugins("beforeLayout", { cancelable: !0 }))
            return;
          RP.update(this, this.width, this.height, e);
          const t = this.chartArea,
            n = t.width <= 0 || t.height <= 0;
          (this._layers = []),
            xC(
              this.boxes,
              (e) => {
                (n && "chartArea" === e.position) ||
                  (e.configure && e.configure(),
                  this._layers.push(...e._layers()));
              },
              this
            ),
            this._layers.forEach((e, t) => {
              e._idx = t;
            }),
            this.notifyPlugins("afterLayout");
        }
        _updateDatasets(e) {
          if (
            !1 !==
            this.notifyPlugins("beforeDatasetsUpdate", {
              mode: e,
              cancelable: !0,
            })
          ) {
            for (let e = 0, t = this.data.datasets.length; e < t; ++e)
              this.getDatasetMeta(e).controller.configure();
            for (let t = 0, n = this.data.datasets.length; t < n; ++t)
              this._updateDataset(t, AC(e) ? e({ datasetIndex: t }) : e);
            this.notifyPlugins("afterDatasetsUpdate", { mode: e });
          }
        }
        _updateDataset(e, t) {
          const n = this.getDatasetMeta(e),
            r = { meta: n, index: e, mode: t, cancelable: !0 };
          !1 !== this.notifyPlugins("beforeDatasetUpdate", r) &&
            (n.controller._update(t),
            (r.cancelable = !1),
            this.notifyPlugins("afterDatasetUpdate", r));
        }
        render() {
          !1 !== this.notifyPlugins("beforeRender", { cancelable: !0 }) &&
            (Sk.has(this)
              ? this.attached && !Sk.running(this) && Sk.start(this)
              : (this.draw(), vw({ chart: this })));
        }
        draw() {
          let e;
          if (this._resizeBeforeDraw) {
            const { width: e, height: t } = this._resizeBeforeDraw;
            this._resize(e, t), (this._resizeBeforeDraw = null);
          }
          if ((this.clear(), this.width <= 0 || this.height <= 0)) return;
          if (!1 === this.notifyPlugins("beforeDraw", { cancelable: !0 }))
            return;
          const t = this._layers;
          for (e = 0; e < t.length && t[e].z <= 0; ++e)
            t[e].draw(this.chartArea);
          for (this._drawDatasets(); e < t.length; ++e)
            t[e].draw(this.chartArea);
          this.notifyPlugins("afterDraw");
        }
        _getSortedDatasetMetas(e) {
          const t = this._sortedMetasets,
            n = [];
          let r, o;
          for (r = 0, o = t.length; r < o; ++r) {
            const o = t[r];
            (e && !o.visible) || n.push(o);
          }
          return n;
        }
        getSortedVisibleDatasetMetas() {
          return this._getSortedDatasetMetas(!0);
        }
        _drawDatasets() {
          if (
            !1 === this.notifyPlugins("beforeDatasetsDraw", { cancelable: !0 })
          )
            return;
          const e = this.getSortedVisibleDatasetMetas();
          for (let t = e.length - 1; t >= 0; --t) this._drawDataset(e[t]);
          this.notifyPlugins("afterDatasetsDraw");
        }
        _drawDataset(e) {
          const t = this.ctx,
            n = e._clip,
            r = !n.disabled,
            o = this.chartArea,
            a = { meta: e, index: e.index, cancelable: !0 };
          !1 !== this.notifyPlugins("beforeDatasetDraw", a) &&
            (r &&
              hS(t, {
                left: !1 === n.left ? 0 : o.left - n.left,
                right: !1 === n.right ? this.width : o.right + n.right,
                top: !1 === n.top ? 0 : o.top - n.top,
                bottom: !1 === n.bottom ? this.height : o.bottom + n.bottom,
              }),
            e.controller.draw(),
            r && fS(t),
            (a.cancelable = !1),
            this.notifyPlugins("afterDatasetDraw", a));
        }
        isPointInArea(e) {
          return mS(e, this.chartArea, this._minPadding);
        }
        getElementsAtEventForMode(e, t, n, r) {
          const o = kP.modes[t];
          return "function" == typeof o ? o(this, e, n, r) : [];
        }
        getDatasetMeta(e) {
          const t = this.data.datasets[e],
            n = this._metasets;
          let r = n.filter((e) => e && e._dataset === t).pop();
          return (
            r ||
              ((r = {
                type: null,
                data: [],
                dataset: null,
                controller: null,
                hidden: null,
                xAxisID: null,
                yAxisID: null,
                order: (t && t.order) || 0,
                index: e,
                _dataset: t,
                _parsed: [],
                _sorted: !1,
              }),
              n.push(r)),
            r
          );
        }
        getContext() {
          return (
            this.$context ||
            (this.$context = jS(null, { chart: this, type: "chart" }))
          );
        }
        getVisibleDatasetCount() {
          return this.getSortedVisibleDatasetMetas().length;
        }
        isDatasetVisible(e) {
          const t = this.data.datasets[e];
          if (!t) return !1;
          const n = this.getDatasetMeta(e);
          return "boolean" == typeof n.hidden ? !n.hidden : !t.hidden;
        }
        setDatasetVisibility(e, t) {
          this.getDatasetMeta(e).hidden = !t;
        }
        toggleDataVisibility(e) {
          this._hiddenIndices[e] = !this._hiddenIndices[e];
        }
        getDataVisibility(e) {
          return !this._hiddenIndices[e];
        }
        _updateVisibility(e, t, n) {
          const r = n ? "show" : "hide",
            o = this.getDatasetMeta(e),
            a = o.controller._resolveAnimations(void 0, r);
          DC(t)
            ? ((o.data[t].hidden = !n), this.update())
            : (this.setDatasetVisibility(e, n),
              a.update(o, { visible: n }),
              this.update((t) => (t.datasetIndex === e ? r : void 0)));
        }
        hide(e, t) {
          this._updateVisibility(e, t, !1);
        }
        show(e, t) {
          this._updateVisibility(e, t, !0);
        }
        _destroyDatasetMeta(e) {
          const t = this._metasets[e];
          t && t.controller && t.controller._destroy(),
            delete this._metasets[e];
        }
        _stop() {
          let e, t;
          for (
            this.stop(), Sk.remove(this), e = 0, t = this.data.datasets.length;
            e < t;
            ++e
          )
            this._destroyDatasetMeta(e);
        }
        destroy() {
          this.notifyPlugins("beforeDestroy");
          const { canvas: e, ctx: t } = this;
          this._stop(),
            this.config.clearCache(),
            e &&
              (this.unbindEvents(),
              cS(e, t),
              this.platform.releaseContext(t),
              (this.canvas = null),
              (this.ctx = null)),
            this.notifyPlugins("destroy"),
            delete yw[this.id],
            this.notifyPlugins("afterDestroy");
        }
        toBase64Image(...e) {
          return this.canvas.toDataURL(...e);
        }
        bindEvents() {
          this.bindUserEvents(),
            this.options.responsive
              ? this.bindResponsiveEvents()
              : (this.attached = !0);
        }
        bindUserEvents() {
          const e = this._listeners,
            t = this.platform,
            n = (n, r) => {
              t.addEventListener(this, n, r), (e[n] = r);
            },
            r = (e, t, n) => {
              (e.offsetX = t), (e.offsetY = n), this._eventHandler(e);
            };
          xC(this.options.events, (e) => n(e, r));
        }
        bindResponsiveEvents() {
          this._responsiveListeners || (this._responsiveListeners = {});
          const e = this._responsiveListeners,
            t = this.platform,
            n = (n, r) => {
              t.addEventListener(this, n, r), (e[n] = r);
            },
            r = (n, r) => {
              e[n] && (t.removeEventListener(this, n, r), delete e[n]);
            },
            o = (e, t) => {
              this.canvas && this.resize(e, t);
            };
          let a;
          const i = () => {
            r("attach", i),
              (this.attached = !0),
              this.resize(),
              n("resize", o),
              n("detach", a);
          };
          (a = () => {
            (this.attached = !1),
              r("resize", o),
              this._stop(),
              this._resize(0, 0),
              n("attach", i);
          }),
            t.isAttached(this.canvas) ? i() : a();
        }
        unbindEvents() {
          xC(this._listeners, (e, t) => {
            this.platform.removeEventListener(this, t, e);
          }),
            (this._listeners = {}),
            xC(this._responsiveListeners, (e, t) => {
              this.platform.removeEventListener(this, t, e);
            }),
            (this._responsiveListeners = void 0);
        }
        updateHoverStyle(e, t, n) {
          const r = n ? "set" : "remove";
          let o, a, i, s;
          for (
            "dataset" === t &&
              ((o = this.getDatasetMeta(e[0].datasetIndex)),
              o.controller["_" + r + "DatasetHoverStyle"]()),
              i = 0,
              s = e.length;
            i < s;
            ++i
          ) {
            a = e[i];
            const t = a && this.getDatasetMeta(a.datasetIndex).controller;
            t && t[r + "HoverStyle"](a.element, a.datasetIndex, a.index);
          }
        }
        getActiveElements() {
          return this._active || [];
        }
        setActiveElements(e) {
          const t = this._active || [],
            n = e.map(({ datasetIndex: e, index: t }) => {
              const n = this.getDatasetMeta(e);
              if (!n) throw new Error("No dataset found at index " + e);
              return { datasetIndex: e, element: n.data[t], index: t };
            });
          !SC(n, t) &&
            ((this._active = n),
            (this._lastEvent = null),
            this._updateHoverStyles(n, t));
        }
        notifyPlugins(e, t, n) {
          return this._plugins.notify(this, e, t, n);
        }
        _updateHoverStyles(e, t, n) {
          const r = this.options.hover,
            o = (e, t) =>
              e.filter(
                (e) =>
                  !t.some(
                    (t) =>
                      e.datasetIndex === t.datasetIndex && e.index === t.index
                  )
              ),
            a = o(t, e),
            i = n ? e : o(e, t);
          a.length && this.updateHoverStyle(a, r.mode, !1),
            i.length && r.mode && this.updateHoverStyle(i, r.mode, !0);
        }
        _eventHandler(e, t) {
          const n = {
              event: e,
              replay: t,
              cancelable: !0,
              inChartArea: this.isPointInArea(e),
            },
            r = (t) =>
              (t.options.events || this.options.events).includes(e.native.type);
          if (!1 === this.notifyPlugins("beforeEvent", n, r)) return;
          const o = this._handleEvent(e, t, n.inChartArea);
          return (
            (n.cancelable = !1),
            this.notifyPlugins("afterEvent", n, r),
            (o || n.changed) && this.render(),
            this
          );
        }
        _handleEvent(e, t, n) {
          const { _active: r = [], options: o } = this,
            a = t,
            i = this._getActiveElements(e, r, n, a),
            s = (function (e) {
              return (
                "mouseup" === e.type ||
                "click" === e.type ||
                "contextmenu" === e.type
              );
            })(e),
            l = (function (e, t, n, r) {
              return n && "mouseout" !== e.type ? (r ? t : e) : null;
            })(e, this._lastEvent, n, s);
          n &&
            ((this._lastEvent = null),
            CC(o.onHover, [e, i, this], this),
            s && CC(o.onClick, [e, i, this], this));
          const d = !SC(i, r);
          return (
            (d || t) && ((this._active = i), this._updateHoverStyles(i, r, t)),
            (this._lastEvent = l),
            d
          );
        }
        _getActiveElements(e, t, n, r) {
          if ("mouseout" === e.type) return [];
          if (!n) return t;
          const o = this.options.hover;
          return this.getElementsAtEventForMode(e, o.mode, o, r);
        }
      }
      const kw = () => xC(Sw.instances, (e) => e._plugins.invalidate()),
        Pw = !0;
      function ww(e, t, n) {
        const {
          startAngle: r,
          pixelMargin: o,
          x: a,
          y: i,
          outerRadius: s,
          innerRadius: l,
        } = t;
        let d = o / s;
        e.beginPath(),
          e.arc(a, i, s, r - d, n + d),
          l > o
            ? ((d = o / l), e.arc(a, i, l, n + d, r - d, !0))
            : e.arc(a, i, o, n + ZC, r - ZC),
          e.closePath(),
          e.clip();
      }
      function Ow(e, t, n, r) {
        return { x: n + e * Math.cos(t), y: r + e * Math.sin(t) };
      }
      function Tw(e, t, n, r, o, a) {
        const { x: i, y: s, startAngle: l, pixelMargin: d, innerRadius: c } = t,
          u = Math.max(t.outerRadius + r + n - d, 0),
          p = c > 0 ? c + r + n + d : 0;
        let m = 0;
        const h = o - l;
        if (r) {
          const e = ((c > 0 ? c - r : 0) + (u > 0 ? u - r : 0)) / 2;
          m = (h - (0 !== e ? (h * e) / (e + r) : h)) / 2;
        }
        const f = (h - Math.max(0.001, h * u - n / RC) / u) / 2,
          g = l + f + m,
          v = o - f - m,
          {
            outerStart: b,
            outerEnd: _,
            innerStart: y,
            innerEnd: C,
          } = (function (e, t, n, r) {
            const o = PS(e.options.borderRadius, [
                "outerStart",
                "outerEnd",
                "innerStart",
                "innerEnd",
              ]),
              a = (n - t) / 2,
              i = Math.min(a, (r * t) / 2),
              s = (e) => {
                const t = ((n - Math.min(a, e)) * r) / 2;
                return ox(e, 0, Math.min(a, t));
              };
            return {
              outerStart: s(o.outerStart),
              outerEnd: s(o.outerEnd),
              innerStart: ox(o.innerStart, 0, i),
              innerEnd: ox(o.innerEnd, 0, i),
            };
          })(t, p, u, v - g),
          x = u - b,
          S = u - _,
          k = g + b / x,
          P = v - _ / S,
          w = p + y,
          O = p + C,
          T = g + y / w,
          I = v - C / O;
        if ((e.beginPath(), a)) {
          if ((e.arc(i, s, u, k, P), _ > 0)) {
            const t = Ow(S, P, i, s);
            e.arc(t.x, t.y, _, P, v + ZC);
          }
          const t = Ow(O, v, i, s);
          if ((e.lineTo(t.x, t.y), C > 0)) {
            const t = Ow(O, I, i, s);
            e.arc(t.x, t.y, C, v + ZC, I + Math.PI);
          }
          if ((e.arc(i, s, p, v - C / p, g + y / p, !0), y > 0)) {
            const t = Ow(w, T, i, s);
            e.arc(t.x, t.y, y, T + Math.PI, g - ZC);
          }
          const n = Ow(x, g, i, s);
          if ((e.lineTo(n.x, n.y), b > 0)) {
            const t = Ow(x, k, i, s);
            e.arc(t.x, t.y, b, g - ZC, k);
          }
        } else {
          e.moveTo(i, s);
          const t = Math.cos(k) * u + i,
            n = Math.sin(k) * u + s;
          e.lineTo(t, n);
          const r = Math.cos(P) * u + i,
            o = Math.sin(P) * u + s;
          e.lineTo(r, o);
        }
        e.closePath();
      }
      Object.defineProperties(Sw, {
        defaults: { enumerable: Pw, value: iS },
        instances: { enumerable: Pw, value: yw },
        overrides: { enumerable: Pw, value: nS },
        registry: { enumerable: Pw, value: hP },
        version: { enumerable: Pw, value: "3.9.1" },
        getChart: { enumerable: Pw, value: Cw },
        register: {
          enumerable: Pw,
          value: (...e) => {
            hP.add(...e), kw();
          },
        },
        unregister: {
          enumerable: Pw,
          value: (...e) => {
            hP.remove(...e), kw();
          },
        },
      });
      class Iw extends nP {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.circumference = void 0),
            (this.startAngle = void 0),
            (this.endAngle = void 0),
            (this.innerRadius = void 0),
            (this.outerRadius = void 0),
            (this.pixelMargin = 0),
            (this.fullCircles = 0),
            e && Object.assign(this, e);
        }
        inRange(e, t, n) {
          const r = this.getProps(["x", "y"], n),
            { angle: o, distance: a } = XC(r, { x: e, y: t }),
            {
              startAngle: i,
              endAngle: s,
              innerRadius: l,
              outerRadius: d,
              circumference: c,
            } = this.getProps(
              [
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference",
              ],
              n
            ),
            u = this.options.spacing / 2,
            p = _C(c, s - i) >= LC || rx(o, i, s),
            m = ax(a, l + u, d + u);
          return p && m;
        }
        getCenterPoint(e) {
          const {
              x: t,
              y: n,
              startAngle: r,
              endAngle: o,
              innerRadius: a,
              outerRadius: i,
            } = this.getProps(
              [
                "x",
                "y",
                "startAngle",
                "endAngle",
                "innerRadius",
                "outerRadius",
                "circumference",
              ],
              e
            ),
            { offset: s, spacing: l } = this.options,
            d = (r + o) / 2,
            c = (a + i + l + s) / 2;
          return { x: t + Math.cos(d) * c, y: n + Math.sin(d) * c };
        }
        tooltipPosition(e) {
          return this.getCenterPoint(e);
        }
        draw(e) {
          const { options: t, circumference: n } = this,
            r = (t.offset || 0) / 2,
            o = (t.spacing || 0) / 2,
            a = t.circular;
          if (
            ((this.pixelMargin = "inner" === t.borderAlign ? 0.33 : 0),
            (this.fullCircles = n > LC ? Math.floor(n / LC) : 0),
            0 === n || this.innerRadius < 0 || this.outerRadius < 0)
          )
            return;
          e.save();
          let i = 0;
          if (r) {
            i = r / 2;
            const t = (this.startAngle + this.endAngle) / 2;
            e.translate(Math.cos(t) * i, Math.sin(t) * i),
              this.circumference >= RC && (i = r);
          }
          (e.fillStyle = t.backgroundColor), (e.strokeStyle = t.borderColor);
          const s = (function (e, t, n, r, o) {
            const { fullCircles: a, startAngle: i, circumference: s } = t;
            let l = t.endAngle;
            if (a) {
              Tw(e, t, n, r, i + LC, o);
              for (let t = 0; t < a; ++t) e.fill();
              isNaN(s) || ((l = i + (s % LC)), s % LC == 0 && (l += LC));
            }
            return Tw(e, t, n, r, l, o), e.fill(), l;
          })(e, this, i, o, a);
          (function (e, t, n, r, o, a) {
            const { options: i } = t,
              { borderWidth: s, borderJoinStyle: l } = i,
              d = "inner" === i.borderAlign;
            s &&
              (d
                ? ((e.lineWidth = 2 * s), (e.lineJoin = l || "round"))
                : ((e.lineWidth = s), (e.lineJoin = l || "bevel")),
              t.fullCircles &&
                (function (e, t, n) {
                  const {
                      x: r,
                      y: o,
                      startAngle: a,
                      pixelMargin: i,
                      fullCircles: s,
                    } = t,
                    l = Math.max(t.outerRadius - i, 0),
                    d = t.innerRadius + i;
                  let c;
                  for (
                    n && ww(e, t, a + LC),
                      e.beginPath(),
                      e.arc(r, o, d, a + LC, a, !0),
                      c = 0;
                    c < s;
                    ++c
                  )
                    e.stroke();
                  for (
                    e.beginPath(), e.arc(r, o, l, a, a + LC), c = 0;
                    c < s;
                    ++c
                  )
                    e.stroke();
                })(e, t, d),
              d && ww(e, t, o),
              Tw(e, t, n, r, o, a),
              e.stroke());
          })(e, this, i, o, s, a),
            e.restore();
        }
      }
      function Mw(e, t, n = t) {
        (e.lineCap = _C(n.borderCapStyle, t.borderCapStyle)),
          e.setLineDash(_C(n.borderDash, t.borderDash)),
          (e.lineDashOffset = _C(n.borderDashOffset, t.borderDashOffset)),
          (e.lineJoin = _C(n.borderJoinStyle, t.borderJoinStyle)),
          (e.lineWidth = _C(n.borderWidth, t.borderWidth)),
          (e.strokeStyle = _C(n.borderColor, t.borderColor));
      }
      function jw(e, t, n) {
        e.lineTo(n.x, n.y);
      }
      function Nw(e, t, n = {}) {
        const r = e.length,
          { start: o = 0, end: a = r - 1 } = n,
          { start: i, end: s } = t,
          l = Math.max(o, i),
          d = Math.min(a, s),
          c = (o < i && a < i) || (o > s && a > s);
        return {
          count: r,
          start: l,
          loop: t.loop,
          ilen: d < l && !c ? r + d - l : d - l,
        };
      }
      function Dw(e, t, n, r) {
        const { points: o, options: a } = t,
          { count: i, start: s, loop: l, ilen: d } = Nw(o, n, r),
          c = (function (e) {
            return e.stepped
              ? gS
              : e.tension || "monotone" === e.cubicInterpolationMode
              ? vS
              : jw;
          })(a);
        let u,
          p,
          m,
          { move: h = !0, reverse: f } = r || {};
        for (u = 0; u <= d; ++u)
          (p = o[(s + (f ? d - u : u)) % i]),
            p.skip ||
              (h ? (e.moveTo(p.x, p.y), (h = !1)) : c(e, m, p, f, a.stepped),
              (m = p));
        return (
          l && ((p = o[(s + (f ? d : 0)) % i]), c(e, m, p, f, a.stepped)), !!l
        );
      }
      function Aw(e, t, n, r) {
        const o = t.points,
          { count: a, start: i, ilen: s } = Nw(o, n, r),
          { move: l = !0, reverse: d } = r || {};
        let c,
          u,
          p,
          m,
          h,
          f,
          g = 0,
          v = 0;
        const b = (e) => (i + (d ? s - e : e)) % a,
          _ = () => {
            m !== h && (e.lineTo(g, h), e.lineTo(g, m), e.lineTo(g, f));
          };
        for (l && ((u = o[b(0)]), e.moveTo(u.x, u.y)), c = 0; c <= s; ++c) {
          if (((u = o[b(c)]), u.skip)) continue;
          const t = u.x,
            n = u.y,
            r = 0 | t;
          r === p
            ? (n < m ? (m = n) : n > h && (h = n), (g = (v * g + t) / ++v))
            : (_(), e.lineTo(t, n), (p = r), (v = 0), (m = h = n)),
            (f = n);
        }
        _();
      }
      function Ew(e) {
        const t = e.options,
          n = t.borderDash && t.borderDash.length;
        return e._decimated ||
          e._loop ||
          t.tension ||
          "monotone" === t.cubicInterpolationMode ||
          t.stepped ||
          n
          ? Dw
          : Aw;
      }
      (Iw.id = "arc"),
        (Iw.defaults = {
          borderAlign: "center",
          borderColor: "#fff",
          borderJoinStyle: void 0,
          borderRadius: 0,
          borderWidth: 2,
          offset: 0,
          spacing: 0,
          angle: void 0,
          circular: !0,
        }),
        (Iw.defaultRoutes = { backgroundColor: "backgroundColor" });
      const Rw = "function" == typeof Path2D;
      class Lw extends nP {
        constructor(e) {
          super(),
            (this.animated = !0),
            (this.options = void 0),
            (this._chart = void 0),
            (this._loop = void 0),
            (this._fullLoop = void 0),
            (this._path = void 0),
            (this._points = void 0),
            (this._segments = void 0),
            (this._decimated = !1),
            (this._pointsUpdated = !1),
            (this._datasetIndex = void 0),
            e && Object.assign(this, e);
        }
        updateControlPoints(e, t) {
          const n = this.options;
          if (
            (n.tension || "monotone" === n.cubicInterpolationMode) &&
            !n.stepped &&
            !this._pointsUpdated
          ) {
            const r = n.spanGaps ? this._loop : this._fullLoop;
            YS(this._points, n, e, r, t), (this._pointsUpdated = !0);
          }
        }
        set points(e) {
          (this._points = e),
            delete this._segments,
            delete this._path,
            (this._pointsUpdated = !1);
        }
        get points() {
          return this._points;
        }
        get segments() {
          return (
            this._segments ||
            (this._segments = (function (e, t) {
              const n = e.points,
                r = e.options.spanGaps,
                o = n.length;
              if (!o) return [];
              const a = !!e._loop,
                { start: i, end: s } = (function (e, t, n, r) {
                  let o = 0,
                    a = t - 1;
                  if (n && !r) for (; o < t && !e[o].skip; ) o++;
                  for (; o < t && e[o].skip; ) o++;
                  for (o %= t, n && (a += o); a > o && e[a % t].skip; ) a--;
                  return (a %= t), { start: o, end: a };
                })(n, o, a, r);
              return (function (e, t, n, r) {
                return r && r.setContext && n
                  ? (function (e, t, n, r) {
                      const o = e._chart.getContext(),
                        a = Ck(e.options),
                        {
                          _datasetIndex: i,
                          options: { spanGaps: s },
                        } = e,
                        l = n.length,
                        d = [];
                      let c = a,
                        u = t[0].start,
                        p = u;
                      function m(e, t, r, o) {
                        const a = s ? -1 : 1;
                        if (e !== t) {
                          for (e += l; n[e % l].skip; ) e -= a;
                          for (; n[t % l].skip; ) t += a;
                          e % l != t % l &&
                            (d.push({
                              start: e % l,
                              end: t % l,
                              loop: r,
                              style: o,
                            }),
                            (c = o),
                            (u = t % l));
                        }
                      }
                      for (const e of t) {
                        u = s ? u : e.start;
                        let t,
                          a = n[u % l];
                        for (p = u + 1; p <= e.end; p++) {
                          const s = n[p % l];
                          (t = Ck(
                            r.setContext(
                              jS(o, {
                                type: "segment",
                                p0: a,
                                p1: s,
                                p0DataIndex: (p - 1) % l,
                                p1DataIndex: p % l,
                                datasetIndex: i,
                              })
                            )
                          )),
                            xk(t, c) && m(u, p - 1, e.loop, c),
                            (a = s),
                            (c = t);
                        }
                        u < p - 1 && m(u, p - 1, e.loop, c);
                      }
                      return d;
                    })(e, t, n, r)
                  : t;
              })(
                e,
                !0 === r
                  ? [{ start: i, end: s, loop: a }]
                  : (function (e, t, n, r) {
                      const o = e.length,
                        a = [];
                      let i,
                        s = t,
                        l = e[t];
                      for (i = t + 1; i <= n; ++i) {
                        const n = e[i % o];
                        n.skip || n.stop
                          ? l.skip ||
                            ((r = !1),
                            a.push({ start: t % o, end: (i - 1) % o, loop: r }),
                            (t = s = n.stop ? i : null))
                          : ((s = i), l.skip && (t = i)),
                          (l = n);
                      }
                      return (
                        null !== s &&
                          a.push({ start: t % o, end: s % o, loop: r }),
                        a
                      );
                    })(
                      n,
                      i,
                      s < i ? s + o : s,
                      !!e._fullLoop && 0 === i && s === o - 1
                    ),
                n,
                t
              );
            })(this, this.options.segment))
          );
        }
        first() {
          const e = this.segments,
            t = this.points;
          return e.length && t[e[0].start];
        }
        last() {
          const e = this.segments,
            t = this.points,
            n = e.length;
          return n && t[e[n - 1].end];
        }
        interpolate(e, t) {
          const n = this.options,
            r = e[t],
            o = this.points,
            a = (function (e, t) {
              const n = [],
                r = e.segments;
              for (let o = 0; o < r.length; o++) {
                const a = yk(r[o], e.points, t);
                a.length && n.push(...a);
              }
              return n;
            })(this, { property: t, start: r, end: r });
          if (!a.length) return;
          const i = [],
            s = (function (e) {
              return e.stepped
                ? uk
                : e.tension || "monotone" === e.cubicInterpolationMode
                ? pk
                : ck;
            })(n);
          let l, d;
          for (l = 0, d = a.length; l < d; ++l) {
            const { start: d, end: c } = a[l],
              u = o[d],
              p = o[c];
            if (u === p) {
              i.push(u);
              continue;
            }
            const m = s(u, p, Math.abs((r - u[t]) / (p[t] - u[t])), n.stepped);
            (m[t] = e[t]), i.push(m);
          }
          return 1 === i.length ? i[0] : i;
        }
        pathSegment(e, t, n) {
          return Ew(this)(e, this, t, n);
        }
        path(e, t, n) {
          const r = this.segments,
            o = Ew(this);
          let a = this._loop;
          (t = t || 0), (n = n || this.points.length - t);
          for (const i of r) a &= o(e, this, i, { start: t, end: t + n - 1 });
          return !!a;
        }
        draw(e, t, n, r) {
          const o = this.options || {};
          (this.points || []).length &&
            o.borderWidth &&
            (e.save(),
            (function (e, t, n, r) {
              Rw && !t.options.segment
                ? (function (e, t, n, r) {
                    let o = t._path;
                    o ||
                      ((o = t._path = new Path2D()),
                      t.path(o, n, r) && o.closePath()),
                      Mw(e, t.options),
                      e.stroke(o);
                  })(e, t, n, r)
                : (function (e, t, n, r) {
                    const { segments: o, options: a } = t,
                      i = Ew(t);
                    for (const s of o)
                      Mw(e, a, s.style),
                        e.beginPath(),
                        i(e, t, s, { start: n, end: n + r - 1 }) &&
                          e.closePath(),
                        e.stroke();
                  })(e, t, n, r);
            })(e, this, n, r),
            e.restore()),
            this.animated &&
              ((this._pointsUpdated = !1), (this._path = void 0));
        }
      }
      function Bw(e, t, n, r) {
        const o = e.options,
          { [n]: a } = e.getProps([n], r);
        return Math.abs(t - a) < o.radius + o.hitRadius;
      }
      (Lw.id = "line"),
        (Lw.defaults = {
          borderCapStyle: "butt",
          borderDash: [],
          borderDashOffset: 0,
          borderJoinStyle: "miter",
          borderWidth: 3,
          capBezierPoints: !0,
          cubicInterpolationMode: "default",
          fill: !1,
          spanGaps: !1,
          stepped: !1,
          tension: 0,
        }),
        (Lw.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        }),
        (Lw.descriptors = {
          _scriptable: !0,
          _indexable: (e) => "borderDash" !== e && "fill" !== e,
        });
      class zw extends nP {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.parsed = void 0),
            (this.skip = void 0),
            (this.stop = void 0),
            e && Object.assign(this, e);
        }
        inRange(e, t, n) {
          const r = this.options,
            { x: o, y: a } = this.getProps(["x", "y"], n);
          return (
            Math.pow(e - o, 2) + Math.pow(t - a, 2) <
            Math.pow(r.hitRadius + r.radius, 2)
          );
        }
        inXRange(e, t) {
          return Bw(this, e, "x", t);
        }
        inYRange(e, t) {
          return Bw(this, e, "y", t);
        }
        getCenterPoint(e) {
          const { x: t, y: n } = this.getProps(["x", "y"], e);
          return { x: t, y: n };
        }
        size(e) {
          let t = (e = e || this.options || {}).radius || 0;
          return (
            (t = Math.max(t, (t && e.hoverRadius) || 0)),
            2 * (t + ((t && e.borderWidth) || 0))
          );
        }
        draw(e, t) {
          const n = this.options;
          this.skip ||
            n.radius < 0.1 ||
            !mS(this, t, this.size(n) / 2) ||
            ((e.strokeStyle = n.borderColor),
            (e.lineWidth = n.borderWidth),
            (e.fillStyle = n.backgroundColor),
            uS(e, n, this.x, this.y));
        }
        getRange() {
          const e = this.options || {};
          return e.radius + e.hitRadius;
        }
      }
      function Fw(e, t) {
        const {
          x: n,
          y: r,
          base: o,
          width: a,
          height: i,
        } = e.getProps(["x", "y", "base", "width", "height"], t);
        let s, l, d, c, u;
        return (
          e.horizontal
            ? ((u = i / 2),
              (s = Math.min(n, o)),
              (l = Math.max(n, o)),
              (d = r - u),
              (c = r + u))
            : ((u = a / 2),
              (s = n - u),
              (l = n + u),
              (d = Math.min(r, o)),
              (c = Math.max(r, o))),
          { left: s, top: d, right: l, bottom: c }
        );
      }
      function Zw(e, t, n, r) {
        return e ? 0 : ox(t, n, r);
      }
      function Hw(e, t, n, r) {
        const o = null === t,
          a = null === n,
          i = e && !(o && a) && Fw(e, r);
        return (
          i && (o || ax(t, i.left, i.right)) && (a || ax(n, i.top, i.bottom))
        );
      }
      function Vw(e, t) {
        e.rect(t.x, t.y, t.w, t.h);
      }
      function Ww(e, t, n = {}) {
        const r = e.x !== n.x ? -t : 0,
          o = e.y !== n.y ? -t : 0,
          a = (e.x + e.w !== n.x + n.w ? t : 0) - r,
          i = (e.y + e.h !== n.y + n.h ? t : 0) - o;
        return {
          x: e.x + r,
          y: e.y + o,
          w: e.w + a,
          h: e.h + i,
          radius: e.radius,
        };
      }
      (zw.id = "point"),
        (zw.defaults = {
          borderWidth: 1,
          hitRadius: 1,
          hoverBorderWidth: 1,
          hoverRadius: 4,
          pointStyle: "circle",
          radius: 3,
          rotation: 0,
        }),
        (zw.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        });
      class Uw extends nP {
        constructor(e) {
          super(),
            (this.options = void 0),
            (this.horizontal = void 0),
            (this.base = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this.inflateAmount = void 0),
            e && Object.assign(this, e);
        }
        draw(e) {
          const {
              inflateAmount: t,
              options: { borderColor: n, backgroundColor: r },
            } = this,
            { inner: o, outer: a } = (function (e) {
              const t = Fw(e),
                n = t.right - t.left,
                r = t.bottom - t.top,
                o = (function (e, t, n) {
                  const r = e.options.borderWidth,
                    o = e.borderSkipped,
                    a = wS(r);
                  return {
                    t: Zw(o.top, a.top, 0, n),
                    r: Zw(o.right, a.right, 0, t),
                    b: Zw(o.bottom, a.bottom, 0, n),
                    l: Zw(o.left, a.left, 0, t),
                  };
                })(e, n / 2, r / 2),
                a = (function (e, t, n) {
                  const { enableBorderRadius: r } = e.getProps([
                      "enableBorderRadius",
                    ]),
                    o = e.options.borderRadius,
                    a = OS(o),
                    i = Math.min(t, n),
                    s = e.borderSkipped,
                    l = r || gC(o);
                  return {
                    topLeft: Zw(!l || s.top || s.left, a.topLeft, 0, i),
                    topRight: Zw(!l || s.top || s.right, a.topRight, 0, i),
                    bottomLeft: Zw(
                      !l || s.bottom || s.left,
                      a.bottomLeft,
                      0,
                      i
                    ),
                    bottomRight: Zw(
                      !l || s.bottom || s.right,
                      a.bottomRight,
                      0,
                      i
                    ),
                  };
                })(e, n / 2, r / 2);
              return {
                outer: { x: t.left, y: t.top, w: n, h: r, radius: a },
                inner: {
                  x: t.left + o.l,
                  y: t.top + o.t,
                  w: n - o.l - o.r,
                  h: r - o.t - o.b,
                  radius: {
                    topLeft: Math.max(0, a.topLeft - Math.max(o.t, o.l)),
                    topRight: Math.max(0, a.topRight - Math.max(o.t, o.r)),
                    bottomLeft: Math.max(0, a.bottomLeft - Math.max(o.b, o.l)),
                    bottomRight: Math.max(
                      0,
                      a.bottomRight - Math.max(o.b, o.r)
                    ),
                  },
                },
              };
            })(this),
            i =
              (s = a.radius).topLeft ||
              s.topRight ||
              s.bottomLeft ||
              s.bottomRight
                ? yS
                : Vw;
          var s;
          e.save(),
            (a.w === o.w && a.h === o.h) ||
              (e.beginPath(),
              i(e, Ww(a, t, o)),
              e.clip(),
              i(e, Ww(o, -t, a)),
              (e.fillStyle = n),
              e.fill("evenodd")),
            e.beginPath(),
            i(e, Ww(o, t)),
            (e.fillStyle = r),
            e.fill(),
            e.restore();
        }
        inRange(e, t, n) {
          return Hw(this, e, t, n);
        }
        inXRange(e, t) {
          return Hw(this, e, null, t);
        }
        inYRange(e, t) {
          return Hw(this, null, e, t);
        }
        getCenterPoint(e) {
          const {
            x: t,
            y: n,
            base: r,
            horizontal: o,
          } = this.getProps(["x", "y", "base", "horizontal"], e);
          return { x: o ? (t + r) / 2 : t, y: o ? n : (n + r) / 2 };
        }
        getRange(e) {
          return "x" === e ? this.width / 2 : this.height / 2;
        }
      }
      (Uw.id = "bar"),
        (Uw.defaults = {
          borderSkipped: "start",
          borderWidth: 0,
          borderRadius: 0,
          inflateAmount: "auto",
          pointStyle: void 0,
        }),
        (Uw.defaultRoutes = {
          backgroundColor: "backgroundColor",
          borderColor: "borderColor",
        });
      const $w = (e, t) => {
        let { boxHeight: n = t, boxWidth: r = t } = e;
        return (
          e.usePointStyle &&
            ((n = Math.min(n, t)), (r = e.pointStyleWidth || Math.min(r, t))),
          { boxWidth: r, boxHeight: n, itemHeight: Math.max(t, n) }
        );
      };
      class Kw extends nP {
        constructor(e) {
          super(),
            (this._added = !1),
            (this.legendHitBoxes = []),
            (this._hoveredItem = null),
            (this.doughnutMode = !1),
            (this.chart = e.chart),
            (this.options = e.options),
            (this.ctx = e.ctx),
            (this.legendItems = void 0),
            (this.columnSizes = void 0),
            (this.lineWidths = void 0),
            (this.maxHeight = void 0),
            (this.maxWidth = void 0),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.height = void 0),
            (this.width = void 0),
            (this._margins = void 0),
            (this.position = void 0),
            (this.weight = void 0),
            (this.fullSize = void 0);
        }
        update(e, t, n) {
          (this.maxWidth = e),
            (this.maxHeight = t),
            (this._margins = n),
            this.setDimensions(),
            this.buildLabels(),
            this.fit();
        }
        setDimensions() {
          this.isHorizontal()
            ? ((this.width = this.maxWidth),
              (this.left = this._margins.left),
              (this.right = this.width))
            : ((this.height = this.maxHeight),
              (this.top = this._margins.top),
              (this.bottom = this.height));
        }
        buildLabels() {
          const e = this.options.labels || {};
          let t = CC(e.generateLabels, [this.chart], this) || [];
          e.filter && (t = t.filter((t) => e.filter(t, this.chart.data))),
            e.sort && (t = t.sort((t, n) => e.sort(t, n, this.chart.data))),
            this.options.reverse && t.reverse(),
            (this.legendItems = t);
        }
        fit() {
          const { options: e, ctx: t } = this;
          if (!e.display) return void (this.width = this.height = 0);
          const n = e.labels,
            r = IS(n.font),
            o = r.size,
            a = this._computeTitleHeight(),
            { boxWidth: i, itemHeight: s } = $w(n, o);
          let l, d;
          (t.font = r.string),
            this.isHorizontal()
              ? ((l = this.maxWidth), (d = this._fitRows(a, o, i, s) + 10))
              : ((d = this.maxHeight), (l = this._fitCols(a, o, i, s) + 10)),
            (this.width = Math.min(l, e.maxWidth || this.maxWidth)),
            (this.height = Math.min(d, e.maxHeight || this.maxHeight));
        }
        _fitRows(e, t, n, r) {
          const {
              ctx: o,
              maxWidth: a,
              options: {
                labels: { padding: i },
              },
            } = this,
            s = (this.legendHitBoxes = []),
            l = (this.lineWidths = [0]),
            d = r + i;
          let c = e;
          (o.textAlign = "left"), (o.textBaseline = "middle");
          let u = -1,
            p = -d;
          return (
            this.legendItems.forEach((e, m) => {
              const h = n + t / 2 + o.measureText(e.text).width;
              (0 === m || l[l.length - 1] + h + 2 * i > a) &&
                ((c += d), (l[l.length - (m > 0 ? 0 : 1)] = 0), (p += d), u++),
                (s[m] = { left: 0, top: p, row: u, width: h, height: r }),
                (l[l.length - 1] += h + i);
            }),
            c
          );
        }
        _fitCols(e, t, n, r) {
          const {
              ctx: o,
              maxHeight: a,
              options: {
                labels: { padding: i },
              },
            } = this,
            s = (this.legendHitBoxes = []),
            l = (this.columnSizes = []),
            d = a - e;
          let c = i,
            u = 0,
            p = 0,
            m = 0,
            h = 0;
          return (
            this.legendItems.forEach((e, a) => {
              const f = n + t / 2 + o.measureText(e.text).width;
              a > 0 &&
                p + r + 2 * i > d &&
                ((c += u + i),
                l.push({ width: u, height: p }),
                (m += u + i),
                h++,
                (u = p = 0)),
                (s[a] = { left: m, top: p, col: h, width: f, height: r }),
                (u = Math.max(u, f)),
                (p += r + i);
            }),
            (c += u),
            l.push({ width: u, height: p }),
            c
          );
        }
        adjustHitBoxes() {
          if (!this.options.display) return;
          const e = this._computeTitleHeight(),
            {
              legendHitBoxes: t,
              options: {
                align: n,
                labels: { padding: r },
                rtl: o,
              },
            } = this,
            a = fk(o, this.left, this.width);
          if (this.isHorizontal()) {
            let o = 0,
              i = fx(n, this.left + r, this.right - this.lineWidths[o]);
            for (const s of t)
              o !== s.row &&
                ((o = s.row),
                (i = fx(n, this.left + r, this.right - this.lineWidths[o]))),
                (s.top += this.top + e + r),
                (s.left = a.leftForLtr(a.x(i), s.width)),
                (i += s.width + r);
          } else {
            let o = 0,
              i = fx(
                n,
                this.top + e + r,
                this.bottom - this.columnSizes[o].height
              );
            for (const s of t)
              s.col !== o &&
                ((o = s.col),
                (i = fx(
                  n,
                  this.top + e + r,
                  this.bottom - this.columnSizes[o].height
                ))),
                (s.top = i),
                (s.left += this.left + r),
                (s.left = a.leftForLtr(a.x(s.left), s.width)),
                (i += s.height + r);
          }
        }
        isHorizontal() {
          return (
            "top" === this.options.position ||
            "bottom" === this.options.position
          );
        }
        draw() {
          if (this.options.display) {
            const e = this.ctx;
            hS(e, this), this._draw(), fS(e);
          }
        }
        _draw() {
          const { options: e, columnSizes: t, lineWidths: n, ctx: r } = this,
            { align: o, labels: a } = e,
            i = iS.color,
            s = fk(e.rtl, this.left, this.width),
            l = IS(a.font),
            { color: d, padding: c } = a,
            u = l.size,
            p = u / 2;
          let m;
          this.drawTitle(),
            (r.textAlign = s.textAlign("left")),
            (r.textBaseline = "middle"),
            (r.lineWidth = 0.5),
            (r.font = l.string);
          const { boxWidth: h, boxHeight: f, itemHeight: g } = $w(a, u),
            v = this.isHorizontal(),
            b = this._computeTitleHeight();
          (m = v
            ? {
                x: fx(o, this.left + c, this.right - n[0]),
                y: this.top + c + b,
                line: 0,
              }
            : {
                x: this.left + c,
                y: fx(o, this.top + b + c, this.bottom - t[0].height),
                line: 0,
              }),
            gk(this.ctx, e.textDirection);
          const _ = g + c;
          this.legendItems.forEach((y, C) => {
            (r.strokeStyle = y.fontColor || d),
              (r.fillStyle = y.fontColor || d);
            const x = r.measureText(y.text).width,
              S = s.textAlign(y.textAlign || (y.textAlign = a.textAlign)),
              k = h + p + x;
            let P = m.x,
              w = m.y;
            s.setWidth(this.width),
              v
                ? C > 0 &&
                  P + k + c > this.right &&
                  ((w = m.y += _),
                  m.line++,
                  (P = m.x = fx(o, this.left + c, this.right - n[m.line])))
                : C > 0 &&
                  w + _ > this.bottom &&
                  ((P = m.x = P + t[m.line].width + c),
                  m.line++,
                  (w = m.y =
                    fx(o, this.top + b + c, this.bottom - t[m.line].height))),
              (function (e, t, n) {
                if (isNaN(h) || h <= 0 || isNaN(f) || f < 0) return;
                r.save();
                const o = _C(n.lineWidth, 1);
                if (
                  ((r.fillStyle = _C(n.fillStyle, i)),
                  (r.lineCap = _C(n.lineCap, "butt")),
                  (r.lineDashOffset = _C(n.lineDashOffset, 0)),
                  (r.lineJoin = _C(n.lineJoin, "miter")),
                  (r.lineWidth = o),
                  (r.strokeStyle = _C(n.strokeStyle, i)),
                  r.setLineDash(_C(n.lineDash, [])),
                  a.usePointStyle)
                ) {
                  const i = {
                      radius: (f * Math.SQRT2) / 2,
                      pointStyle: n.pointStyle,
                      rotation: n.rotation,
                      borderWidth: o,
                    },
                    l = s.xPlus(e, h / 2);
                  pS(r, i, l, t + p, a.pointStyleWidth && h);
                } else {
                  const a = t + Math.max((u - f) / 2, 0),
                    i = s.leftForLtr(e, h),
                    l = OS(n.borderRadius);
                  r.beginPath(),
                    Object.values(l).some((e) => 0 !== e)
                      ? yS(r, { x: i, y: a, w: h, h: f, radius: l })
                      : r.rect(i, a, h, f),
                    r.fill(),
                    0 !== o && r.stroke();
                }
                r.restore();
              })(s.x(P), w, y),
              (P = ((e, t, n, r) =>
                e === (r ? "left" : "right")
                  ? n
                  : "center" === e
                  ? (t + n) / 2
                  : t)(S, P + h + p, v ? P + k : this.right, e.rtl)),
              (function (e, t, n) {
                bS(r, n.text, e, t + g / 2, l, {
                  strikethrough: n.hidden,
                  textAlign: s.textAlign(n.textAlign),
                });
              })(s.x(P), w, y),
              v ? (m.x += k + c) : (m.y += _);
          }),
            vk(this.ctx, e.textDirection);
        }
        drawTitle() {
          const e = this.options,
            t = e.title,
            n = IS(t.font),
            r = TS(t.padding);
          if (!t.display) return;
          const o = fk(e.rtl, this.left, this.width),
            a = this.ctx,
            i = t.position,
            s = n.size / 2,
            l = r.top + s;
          let d,
            c = this.left,
            u = this.width;
          if (this.isHorizontal())
            (u = Math.max(...this.lineWidths)),
              (d = this.top + l),
              (c = fx(e.align, c, this.right - u));
          else {
            const t = this.columnSizes.reduce(
              (e, t) => Math.max(e, t.height),
              0
            );
            d =
              l +
              fx(
                e.align,
                this.top,
                this.bottom - t - e.labels.padding - this._computeTitleHeight()
              );
          }
          const p = fx(i, c, c + u);
          (a.textAlign = o.textAlign(hx(i))),
            (a.textBaseline = "middle"),
            (a.strokeStyle = t.color),
            (a.fillStyle = t.color),
            (a.font = n.string),
            bS(a, t.text, p, d, n);
        }
        _computeTitleHeight() {
          const e = this.options.title,
            t = IS(e.font),
            n = TS(e.padding);
          return e.display ? t.lineHeight + n.height : 0;
        }
        _getLegendItemAt(e, t) {
          let n, r, o;
          if (ax(e, this.left, this.right) && ax(t, this.top, this.bottom))
            for (o = this.legendHitBoxes, n = 0; n < o.length; ++n)
              if (
                ((r = o[n]),
                ax(e, r.left, r.left + r.width) &&
                  ax(t, r.top, r.top + r.height))
              )
                return this.legendItems[n];
          return null;
        }
        handleEvent(e) {
          const t = this.options;
          if (
            !(function (e, t) {
              return (
                !(
                  ("mousemove" !== e && "mouseout" !== e) ||
                  (!t.onHover && !t.onLeave)
                ) || !(!t.onClick || ("click" !== e && "mouseup" !== e))
              );
            })(e.type, t)
          )
            return;
          const n = this._getLegendItemAt(e.x, e.y);
          if ("mousemove" === e.type || "mouseout" === e.type) {
            const a = this._hoveredItem,
              i =
                ((o = n),
                null !== (r = a) &&
                  null !== o &&
                  r.datasetIndex === o.datasetIndex &&
                  r.index === o.index);
            a && !i && CC(t.onLeave, [e, a, this], this),
              (this._hoveredItem = n),
              n && !i && CC(t.onHover, [e, n, this], this);
          } else n && CC(t.onClick, [e, n, this], this);
          var r, o;
        }
      }
      var Gw = {
        id: "legend",
        _element: Kw,
        start(e, t, n) {
          const r = (e.legend = new Kw({ ctx: e.ctx, options: n, chart: e }));
          RP.configure(e, r, n), RP.addBox(e, r);
        },
        stop(e) {
          RP.removeBox(e, e.legend), delete e.legend;
        },
        beforeUpdate(e, t, n) {
          const r = e.legend;
          RP.configure(e, r, n), (r.options = n);
        },
        afterUpdate(e) {
          const t = e.legend;
          t.buildLabels(), t.adjustHitBoxes();
        },
        afterEvent(e, t) {
          t.replay || e.legend.handleEvent(t.event);
        },
        defaults: {
          display: !0,
          position: "top",
          align: "center",
          fullSize: !0,
          reverse: !1,
          weight: 1e3,
          onClick(e, t, n) {
            const r = t.datasetIndex,
              o = n.chart;
            o.isDatasetVisible(r)
              ? (o.hide(r), (t.hidden = !0))
              : (o.show(r), (t.hidden = !1));
          },
          onHover: null,
          onLeave: null,
          labels: {
            color: (e) => e.chart.options.color,
            boxWidth: 40,
            padding: 10,
            generateLabels(e) {
              const t = e.data.datasets,
                {
                  labels: {
                    usePointStyle: n,
                    pointStyle: r,
                    textAlign: o,
                    color: a,
                  },
                } = e.legend.options;
              return e._getSortedDatasetMetas().map((e) => {
                const i = e.controller.getStyle(n ? 0 : void 0),
                  s = TS(i.borderWidth);
                return {
                  text: t[e.index].label,
                  fillStyle: i.backgroundColor,
                  fontColor: a,
                  hidden: !e.visible,
                  lineCap: i.borderCapStyle,
                  lineDash: i.borderDash,
                  lineDashOffset: i.borderDashOffset,
                  lineJoin: i.borderJoinStyle,
                  lineWidth: (s.width + s.height) / 4,
                  strokeStyle: i.borderColor,
                  pointStyle: r || i.pointStyle,
                  rotation: i.rotation,
                  textAlign: o || i.textAlign,
                  borderRadius: 0,
                  datasetIndex: e.index,
                };
              }, this);
            },
          },
          title: {
            color: (e) => e.chart.options.color,
            display: !1,
            position: "center",
            text: "",
          },
        },
        descriptors: {
          _scriptable: (e) => !e.startsWith("on"),
          labels: {
            _scriptable: (e) =>
              !["generateLabels", "filter", "sort"].includes(e),
          },
        },
      };
      class qw extends nP {
        constructor(e) {
          super(),
            (this.chart = e.chart),
            (this.options = e.options),
            (this.ctx = e.ctx),
            (this._padding = void 0),
            (this.top = void 0),
            (this.bottom = void 0),
            (this.left = void 0),
            (this.right = void 0),
            (this.width = void 0),
            (this.height = void 0),
            (this.position = void 0),
            (this.weight = void 0),
            (this.fullSize = void 0);
        }
        update(e, t) {
          const n = this.options;
          if (((this.left = 0), (this.top = 0), !n.display))
            return void (this.width =
              this.height =
              this.right =
              this.bottom =
                0);
          (this.width = this.right = e), (this.height = this.bottom = t);
          const r = fC(n.text) ? n.text.length : 1;
          this._padding = TS(n.padding);
          const o = r * IS(n.font).lineHeight + this._padding.height;
          this.isHorizontal() ? (this.height = o) : (this.width = o);
        }
        isHorizontal() {
          const e = this.options.position;
          return "top" === e || "bottom" === e;
        }
        _drawArgs(e) {
          const { top: t, left: n, bottom: r, right: o, options: a } = this,
            i = a.align;
          let s,
            l,
            d,
            c = 0;
          return (
            this.isHorizontal()
              ? ((l = fx(i, n, o)), (d = t + e), (s = o - n))
              : ("left" === a.position
                  ? ((l = n + e), (d = fx(i, r, t)), (c = -0.5 * RC))
                  : ((l = o - e), (d = fx(i, t, r)), (c = 0.5 * RC)),
                (s = r - t)),
            { titleX: l, titleY: d, maxWidth: s, rotation: c }
          );
        }
        draw() {
          const e = this.ctx,
            t = this.options;
          if (!t.display) return;
          const n = IS(t.font),
            r = n.lineHeight / 2 + this._padding.top,
            {
              titleX: o,
              titleY: a,
              maxWidth: i,
              rotation: s,
            } = this._drawArgs(r);
          bS(e, t.text, 0, 0, n, {
            color: t.color,
            maxWidth: i,
            rotation: s,
            textAlign: hx(t.align),
            textBaseline: "middle",
            translation: [o, a],
          });
        }
      }
      var Qw = {
        id: "title",
        _element: qw,
        start(e, t, n) {
          !(function (e, t) {
            const n = new qw({ ctx: e.ctx, options: t, chart: e });
            RP.configure(e, n, t), RP.addBox(e, n), (e.titleBlock = n);
          })(e, n);
        },
        stop(e) {
          const t = e.titleBlock;
          RP.removeBox(e, t), delete e.titleBlock;
        },
        beforeUpdate(e, t, n) {
          const r = e.titleBlock;
          RP.configure(e, r, n), (r.options = n);
        },
        defaults: {
          align: "center",
          display: !1,
          font: { weight: "bold" },
          fullSize: !0,
          padding: 10,
          position: "top",
          text: "",
          weight: 2e3,
        },
        defaultRoutes: { color: "color" },
        descriptors: { _scriptable: !0, _indexable: !1 },
      };
      new WeakMap();
      const Yw = {
        average(e) {
          if (!e.length) return !1;
          let t,
            n,
            r = 0,
            o = 0,
            a = 0;
          for (t = 0, n = e.length; t < n; ++t) {
            const n = e[t].element;
            if (n && n.hasValue()) {
              const e = n.tooltipPosition();
              (r += e.x), (o += e.y), ++a;
            }
          }
          return { x: r / a, y: o / a };
        },
        nearest(e, t) {
          if (!e.length) return !1;
          let n,
            r,
            o,
            a = t.x,
            i = t.y,
            s = Number.POSITIVE_INFINITY;
          for (n = 0, r = e.length; n < r; ++n) {
            const r = e[n].element;
            if (r && r.hasValue()) {
              const e = ex(t, r.getCenterPoint());
              e < s && ((s = e), (o = r));
            }
          }
          if (o) {
            const e = o.tooltipPosition();
            (a = e.x), (i = e.y);
          }
          return { x: a, y: i };
        },
      };
      function Jw(e, t) {
        return t && (fC(t) ? Array.prototype.push.apply(e, t) : e.push(t)), e;
      }
      function Xw(e) {
        return ("string" == typeof e || e instanceof String) &&
          e.indexOf("\n") > -1
          ? e.split("\n")
          : e;
      }
      function eO(e, t) {
        const { element: n, datasetIndex: r, index: o } = t,
          a = e.getDatasetMeta(r).controller,
          { label: i, value: s } = a.getLabelAndValue(o);
        return {
          chart: e,
          label: i,
          parsed: a.getParsed(o),
          raw: e.data.datasets[r].data[o],
          formattedValue: s,
          dataset: a.getDataset(),
          dataIndex: o,
          datasetIndex: r,
          element: n,
        };
      }
      function tO(e, t) {
        const n = e.chart.ctx,
          { body: r, footer: o, title: a } = e,
          { boxWidth: i, boxHeight: s } = t,
          l = IS(t.bodyFont),
          d = IS(t.titleFont),
          c = IS(t.footerFont),
          u = a.length,
          p = o.length,
          m = r.length,
          h = TS(t.padding);
        let f = h.height,
          g = 0,
          v = r.reduce(
            (e, t) => e + t.before.length + t.lines.length + t.after.length,
            0
          );
        (v += e.beforeBody.length + e.afterBody.length),
          u &&
            (f +=
              u * d.lineHeight +
              (u - 1) * t.titleSpacing +
              t.titleMarginBottom),
          v &&
            (f +=
              m * (t.displayColors ? Math.max(s, l.lineHeight) : l.lineHeight) +
              (v - m) * l.lineHeight +
              (v - 1) * t.bodySpacing),
          p &&
            (f +=
              t.footerMarginTop + p * c.lineHeight + (p - 1) * t.footerSpacing);
        let b = 0;
        const _ = function (e) {
          g = Math.max(g, n.measureText(e).width + b);
        };
        return (
          n.save(),
          (n.font = d.string),
          xC(e.title, _),
          (n.font = l.string),
          xC(e.beforeBody.concat(e.afterBody), _),
          (b = t.displayColors ? i + 2 + t.boxPadding : 0),
          xC(r, (e) => {
            xC(e.before, _), xC(e.lines, _), xC(e.after, _);
          }),
          (b = 0),
          (n.font = c.string),
          xC(e.footer, _),
          n.restore(),
          (g += h.width),
          { width: g, height: f }
        );
      }
      function nO(e, t, n, r) {
        const { x: o, width: a } = n,
          {
            width: i,
            chartArea: { left: s, right: l },
          } = e;
        let d = "center";
        return (
          "center" === r
            ? (d = o <= (s + l) / 2 ? "left" : "right")
            : o <= a / 2
            ? (d = "left")
            : o >= i - a / 2 && (d = "right"),
          (function (e, t, n, r) {
            const { x: o, width: a } = r,
              i = n.caretSize + n.caretPadding;
            return (
              ("left" === e && o + a + i > t.width) ||
              ("right" === e && o - a - i < 0) ||
              void 0
            );
          })(d, e, t, n) && (d = "center"),
          d
        );
      }
      function rO(e, t, n) {
        const r =
          n.yAlign ||
          t.yAlign ||
          (function (e, t) {
            const { y: n, height: r } = t;
            return n < r / 2
              ? "top"
              : n > e.height - r / 2
              ? "bottom"
              : "center";
          })(e, n);
        return { xAlign: n.xAlign || t.xAlign || nO(e, t, n, r), yAlign: r };
      }
      function oO(e, t, n, r) {
        const { caretSize: o, caretPadding: a, cornerRadius: i } = e,
          { xAlign: s, yAlign: l } = n,
          d = o + a,
          { topLeft: c, topRight: u, bottomLeft: p, bottomRight: m } = OS(i);
        let h = (function (e, t) {
          let { x: n, width: r } = e;
          return "right" === t ? (n -= r) : "center" === t && (n -= r / 2), n;
        })(t, s);
        const f = (function (e, t, n) {
          let { y: r, height: o } = e;
          return (
            "top" === t ? (r += n) : (r -= "bottom" === t ? o + n : o / 2), r
          );
        })(t, l, d);
        return (
          "center" === l
            ? "left" === s
              ? (h += d)
              : "right" === s && (h -= d)
            : "left" === s
            ? (h -= Math.max(c, p) + o)
            : "right" === s && (h += Math.max(u, m) + o),
          { x: ox(h, 0, r.width - t.width), y: ox(f, 0, r.height - t.height) }
        );
      }
      function aO(e, t, n) {
        const r = TS(n.padding);
        return "center" === t
          ? e.x + e.width / 2
          : "right" === t
          ? e.x + e.width - r.right
          : e.x + r.left;
      }
      function iO(e) {
        return Jw([], Xw(e));
      }
      function sO(e, t) {
        const n =
          t && t.dataset && t.dataset.tooltip && t.dataset.tooltip.callbacks;
        return n ? e.override(n) : e;
      }
      class lO extends nP {
        constructor(e) {
          super(),
            (this.opacity = 0),
            (this._active = []),
            (this._eventPosition = void 0),
            (this._size = void 0),
            (this._cachedAnimations = void 0),
            (this._tooltipItems = []),
            (this.$animations = void 0),
            (this.$context = void 0),
            (this.chart = e.chart || e._chart),
            (this._chart = this.chart),
            (this.options = e.options),
            (this.dataPoints = void 0),
            (this.title = void 0),
            (this.beforeBody = void 0),
            (this.body = void 0),
            (this.afterBody = void 0),
            (this.footer = void 0),
            (this.xAlign = void 0),
            (this.yAlign = void 0),
            (this.x = void 0),
            (this.y = void 0),
            (this.height = void 0),
            (this.width = void 0),
            (this.caretX = void 0),
            (this.caretY = void 0),
            (this.labelColors = void 0),
            (this.labelPointStyles = void 0),
            (this.labelTextColors = void 0);
        }
        initialize(e) {
          (this.options = e),
            (this._cachedAnimations = void 0),
            (this.$context = void 0);
        }
        _resolveAnimations() {
          const e = this._cachedAnimations;
          if (e) return e;
          const t = this.chart,
            n = this.options.setContext(this.getContext()),
            r = n.enabled && t.options.animation && n.animations,
            o = new Tk(this.chart, r);
          return r._cacheable && (this._cachedAnimations = Object.freeze(o)), o;
        }
        getContext() {
          return (
            this.$context ||
            (this.$context =
              (this,
              jS(this.chart.getContext(), {
                tooltip: this,
                tooltipItems: this._tooltipItems,
                type: "tooltip",
              })))
          );
        }
        getTitle(e, t) {
          const { callbacks: n } = t,
            r = n.beforeTitle.apply(this, [e]),
            o = n.title.apply(this, [e]),
            a = n.afterTitle.apply(this, [e]);
          let i = [];
          return (i = Jw(i, Xw(r))), (i = Jw(i, Xw(o))), (i = Jw(i, Xw(a))), i;
        }
        getBeforeBody(e, t) {
          return iO(t.callbacks.beforeBody.apply(this, [e]));
        }
        getBody(e, t) {
          const { callbacks: n } = t,
            r = [];
          return (
            xC(e, (e) => {
              const t = { before: [], lines: [], after: [] },
                o = sO(n, e);
              Jw(t.before, Xw(o.beforeLabel.call(this, e))),
                Jw(t.lines, o.label.call(this, e)),
                Jw(t.after, Xw(o.afterLabel.call(this, e))),
                r.push(t);
            }),
            r
          );
        }
        getAfterBody(e, t) {
          return iO(t.callbacks.afterBody.apply(this, [e]));
        }
        getFooter(e, t) {
          const { callbacks: n } = t,
            r = n.beforeFooter.apply(this, [e]),
            o = n.footer.apply(this, [e]),
            a = n.afterFooter.apply(this, [e]);
          let i = [];
          return (i = Jw(i, Xw(r))), (i = Jw(i, Xw(o))), (i = Jw(i, Xw(a))), i;
        }
        _createItems(e) {
          const t = this._active,
            n = this.chart.data,
            r = [],
            o = [],
            a = [];
          let i,
            s,
            l = [];
          for (i = 0, s = t.length; i < s; ++i) l.push(eO(this.chart, t[i]));
          return (
            e.filter && (l = l.filter((t, r, o) => e.filter(t, r, o, n))),
            e.itemSort && (l = l.sort((t, r) => e.itemSort(t, r, n))),
            xC(l, (t) => {
              const n = sO(e.callbacks, t);
              r.push(n.labelColor.call(this, t)),
                o.push(n.labelPointStyle.call(this, t)),
                a.push(n.labelTextColor.call(this, t));
            }),
            (this.labelColors = r),
            (this.labelPointStyles = o),
            (this.labelTextColors = a),
            (this.dataPoints = l),
            l
          );
        }
        update(e, t) {
          const n = this.options.setContext(this.getContext()),
            r = this._active;
          let o,
            a = [];
          if (r.length) {
            const e = Yw[n.position].call(this, r, this._eventPosition);
            (a = this._createItems(n)),
              (this.title = this.getTitle(a, n)),
              (this.beforeBody = this.getBeforeBody(a, n)),
              (this.body = this.getBody(a, n)),
              (this.afterBody = this.getAfterBody(a, n)),
              (this.footer = this.getFooter(a, n));
            const t = (this._size = tO(this, n)),
              i = Object.assign({}, e, t),
              s = rO(this.chart, n, i),
              l = oO(n, i, s, this.chart);
            (this.xAlign = s.xAlign),
              (this.yAlign = s.yAlign),
              (o = {
                opacity: 1,
                x: l.x,
                y: l.y,
                width: t.width,
                height: t.height,
                caretX: e.x,
                caretY: e.y,
              });
          } else 0 !== this.opacity && (o = { opacity: 0 });
          (this._tooltipItems = a),
            (this.$context = void 0),
            o && this._resolveAnimations().update(this, o),
            e &&
              n.external &&
              n.external.call(this, {
                chart: this.chart,
                tooltip: this,
                replay: t,
              });
        }
        drawCaret(e, t, n, r) {
          const o = this.getCaretPosition(e, n, r);
          t.lineTo(o.x1, o.y1), t.lineTo(o.x2, o.y2), t.lineTo(o.x3, o.y3);
        }
        getCaretPosition(e, t, n) {
          const { xAlign: r, yAlign: o } = this,
            { caretSize: a, cornerRadius: i } = n,
            { topLeft: s, topRight: l, bottomLeft: d, bottomRight: c } = OS(i),
            { x: u, y: p } = e,
            { width: m, height: h } = t;
          let f, g, v, b, _, y;
          return (
            "center" === o
              ? ((_ = p + h / 2),
                "left" === r
                  ? ((f = u), (g = f - a), (b = _ + a), (y = _ - a))
                  : ((f = u + m), (g = f + a), (b = _ - a), (y = _ + a)),
                (v = f))
              : ((g =
                  "left" === r
                    ? u + Math.max(s, d) + a
                    : "right" === r
                    ? u + m - Math.max(l, c) - a
                    : this.caretX),
                "top" === o
                  ? ((b = p), (_ = b - a), (f = g - a), (v = g + a))
                  : ((b = p + h), (_ = b + a), (f = g + a), (v = g - a)),
                (y = b)),
            { x1: f, x2: g, x3: v, y1: b, y2: _, y3: y }
          );
        }
        drawTitle(e, t, n) {
          const r = this.title,
            o = r.length;
          let a, i, s;
          if (o) {
            const l = fk(n.rtl, this.x, this.width);
            for (
              e.x = aO(this, n.titleAlign, n),
                t.textAlign = l.textAlign(n.titleAlign),
                t.textBaseline = "middle",
                a = IS(n.titleFont),
                i = n.titleSpacing,
                t.fillStyle = n.titleColor,
                t.font = a.string,
                s = 0;
              s < o;
              ++s
            )
              t.fillText(r[s], l.x(e.x), e.y + a.lineHeight / 2),
                (e.y += a.lineHeight + i),
                s + 1 === o && (e.y += n.titleMarginBottom - i);
          }
        }
        _drawColorBox(e, t, n, r, o) {
          const a = this.labelColors[n],
            i = this.labelPointStyles[n],
            { boxHeight: s, boxWidth: l, boxPadding: d } = o,
            c = IS(o.bodyFont),
            u = aO(this, "left", o),
            p = r.x(u),
            m = s < c.lineHeight ? (c.lineHeight - s) / 2 : 0,
            h = t.y + m;
          if (o.usePointStyle) {
            const t = {
                radius: Math.min(l, s) / 2,
                pointStyle: i.pointStyle,
                rotation: i.rotation,
                borderWidth: 1,
              },
              n = r.leftForLtr(p, l) + l / 2,
              d = h + s / 2;
            (e.strokeStyle = o.multiKeyBackground),
              (e.fillStyle = o.multiKeyBackground),
              uS(e, t, n, d),
              (e.strokeStyle = a.borderColor),
              (e.fillStyle = a.backgroundColor),
              uS(e, t, n, d);
          } else {
            (e.lineWidth = gC(a.borderWidth)
              ? Math.max(...Object.values(a.borderWidth))
              : a.borderWidth || 1),
              (e.strokeStyle = a.borderColor),
              e.setLineDash(a.borderDash || []),
              (e.lineDashOffset = a.borderDashOffset || 0);
            const t = r.leftForLtr(p, l - d),
              n = r.leftForLtr(r.xPlus(p, 1), l - d - 2),
              i = OS(a.borderRadius);
            Object.values(i).some((e) => 0 !== e)
              ? (e.beginPath(),
                (e.fillStyle = o.multiKeyBackground),
                yS(e, { x: t, y: h, w: l, h: s, radius: i }),
                e.fill(),
                e.stroke(),
                (e.fillStyle = a.backgroundColor),
                e.beginPath(),
                yS(e, { x: n, y: h + 1, w: l - 2, h: s - 2, radius: i }),
                e.fill())
              : ((e.fillStyle = o.multiKeyBackground),
                e.fillRect(t, h, l, s),
                e.strokeRect(t, h, l, s),
                (e.fillStyle = a.backgroundColor),
                e.fillRect(n, h + 1, l - 2, s - 2));
          }
          e.fillStyle = this.labelTextColors[n];
        }
        drawBody(e, t, n) {
          const { body: r } = this,
            {
              bodySpacing: o,
              bodyAlign: a,
              displayColors: i,
              boxHeight: s,
              boxWidth: l,
              boxPadding: d,
            } = n,
            c = IS(n.bodyFont);
          let u = c.lineHeight,
            p = 0;
          const m = fk(n.rtl, this.x, this.width),
            h = function (n) {
              t.fillText(n, m.x(e.x + p), e.y + u / 2), (e.y += u + o);
            },
            f = m.textAlign(a);
          let g, v, b, _, y, C, x;
          for (
            t.textAlign = a,
              t.textBaseline = "middle",
              t.font = c.string,
              e.x = aO(this, f, n),
              t.fillStyle = n.bodyColor,
              xC(this.beforeBody, h),
              p =
                i && "right" !== f
                  ? "center" === a
                    ? l / 2 + d
                    : l + 2 + d
                  : 0,
              _ = 0,
              C = r.length;
            _ < C;
            ++_
          ) {
            for (
              g = r[_],
                v = this.labelTextColors[_],
                t.fillStyle = v,
                xC(g.before, h),
                b = g.lines,
                i &&
                  b.length &&
                  (this._drawColorBox(t, e, _, m, n),
                  (u = Math.max(c.lineHeight, s))),
                y = 0,
                x = b.length;
              y < x;
              ++y
            )
              h(b[y]), (u = c.lineHeight);
            xC(g.after, h);
          }
          (p = 0), (u = c.lineHeight), xC(this.afterBody, h), (e.y -= o);
        }
        drawFooter(e, t, n) {
          const r = this.footer,
            o = r.length;
          let a, i;
          if (o) {
            const s = fk(n.rtl, this.x, this.width);
            for (
              e.x = aO(this, n.footerAlign, n),
                e.y += n.footerMarginTop,
                t.textAlign = s.textAlign(n.footerAlign),
                t.textBaseline = "middle",
                a = IS(n.footerFont),
                t.fillStyle = n.footerColor,
                t.font = a.string,
                i = 0;
              i < o;
              ++i
            )
              t.fillText(r[i], s.x(e.x), e.y + a.lineHeight / 2),
                (e.y += a.lineHeight + n.footerSpacing);
          }
        }
        drawBackground(e, t, n, r) {
          const { xAlign: o, yAlign: a } = this,
            { x: i, y: s } = e,
            { width: l, height: d } = n,
            {
              topLeft: c,
              topRight: u,
              bottomLeft: p,
              bottomRight: m,
            } = OS(r.cornerRadius);
          (t.fillStyle = r.backgroundColor),
            (t.strokeStyle = r.borderColor),
            (t.lineWidth = r.borderWidth),
            t.beginPath(),
            t.moveTo(i + c, s),
            "top" === a && this.drawCaret(e, t, n, r),
            t.lineTo(i + l - u, s),
            t.quadraticCurveTo(i + l, s, i + l, s + u),
            "center" === a && "right" === o && this.drawCaret(e, t, n, r),
            t.lineTo(i + l, s + d - m),
            t.quadraticCurveTo(i + l, s + d, i + l - m, s + d),
            "bottom" === a && this.drawCaret(e, t, n, r),
            t.lineTo(i + p, s + d),
            t.quadraticCurveTo(i, s + d, i, s + d - p),
            "center" === a && "left" === o && this.drawCaret(e, t, n, r),
            t.lineTo(i, s + c),
            t.quadraticCurveTo(i, s, i + c, s),
            t.closePath(),
            t.fill(),
            r.borderWidth > 0 && t.stroke();
        }
        _updateAnimationTarget(e) {
          const t = this.chart,
            n = this.$animations,
            r = n && n.x,
            o = n && n.y;
          if (r || o) {
            const n = Yw[e.position].call(
              this,
              this._active,
              this._eventPosition
            );
            if (!n) return;
            const a = (this._size = tO(this, e)),
              i = Object.assign({}, n, this._size),
              s = rO(t, e, i),
              l = oO(e, i, s, t);
            (r._to === l.x && o._to === l.y) ||
              ((this.xAlign = s.xAlign),
              (this.yAlign = s.yAlign),
              (this.width = a.width),
              (this.height = a.height),
              (this.caretX = n.x),
              (this.caretY = n.y),
              this._resolveAnimations().update(this, l));
          }
        }
        _willRender() {
          return !!this.opacity;
        }
        draw(e) {
          const t = this.options.setContext(this.getContext());
          let n = this.opacity;
          if (!n) return;
          this._updateAnimationTarget(t);
          const r = { width: this.width, height: this.height },
            o = { x: this.x, y: this.y };
          n = Math.abs(n) < 0.001 ? 0 : n;
          const a = TS(t.padding),
            i =
              this.title.length ||
              this.beforeBody.length ||
              this.body.length ||
              this.afterBody.length ||
              this.footer.length;
          t.enabled &&
            i &&
            (e.save(),
            (e.globalAlpha = n),
            this.drawBackground(o, e, r, t),
            gk(e, t.textDirection),
            (o.y += a.top),
            this.drawTitle(o, e, t),
            this.drawBody(o, e, t),
            this.drawFooter(o, e, t),
            vk(e, t.textDirection),
            e.restore());
        }
        getActiveElements() {
          return this._active || [];
        }
        setActiveElements(e, t) {
          const n = this._active,
            r = e.map(({ datasetIndex: e, index: t }) => {
              const n = this.chart.getDatasetMeta(e);
              if (!n) throw new Error("Cannot find a dataset at index " + e);
              return { datasetIndex: e, element: n.data[t], index: t };
            }),
            o = !SC(n, r),
            a = this._positionChanged(r, t);
          (o || a) &&
            ((this._active = r),
            (this._eventPosition = t),
            (this._ignoreReplayEvents = !0),
            this.update(!0));
        }
        handleEvent(e, t, n = !0) {
          if (t && this._ignoreReplayEvents) return !1;
          this._ignoreReplayEvents = !1;
          const r = this.options,
            o = this._active || [],
            a = this._getActiveElements(e, o, t, n),
            i = this._positionChanged(a, e),
            s = t || !SC(a, o) || i;
          return (
            s &&
              ((this._active = a),
              (r.enabled || r.external) &&
                ((this._eventPosition = { x: e.x, y: e.y }),
                this.update(!0, t))),
            s
          );
        }
        _getActiveElements(e, t, n, r) {
          const o = this.options;
          if ("mouseout" === e.type) return [];
          if (!r) return t;
          const a = this.chart.getElementsAtEventForMode(e, o.mode, o, n);
          return o.reverse && a.reverse(), a;
        }
        _positionChanged(e, t) {
          const { caretX: n, caretY: r, options: o } = this,
            a = Yw[o.position].call(this, e, t);
          return !1 !== a && (n !== a.x || r !== a.y);
        }
      }
      lO.positioners = Yw;
      var dO = {
        id: "tooltip",
        _element: lO,
        positioners: Yw,
        afterInit(e, t, n) {
          n && (e.tooltip = new lO({ chart: e, options: n }));
        },
        beforeUpdate(e, t, n) {
          e.tooltip && e.tooltip.initialize(n);
        },
        reset(e, t, n) {
          e.tooltip && e.tooltip.initialize(n);
        },
        afterDraw(e) {
          const t = e.tooltip;
          if (t && t._willRender()) {
            const n = { tooltip: t };
            if (!1 === e.notifyPlugins("beforeTooltipDraw", n)) return;
            t.draw(e.ctx), e.notifyPlugins("afterTooltipDraw", n);
          }
        },
        afterEvent(e, t) {
          if (e.tooltip) {
            const n = t.replay;
            e.tooltip.handleEvent(t.event, n, t.inChartArea) &&
              (t.changed = !0);
          }
        },
        defaults: {
          enabled: !0,
          external: null,
          position: "average",
          backgroundColor: "rgba(0,0,0,0.8)",
          titleColor: "#fff",
          titleFont: { weight: "bold" },
          titleSpacing: 2,
          titleMarginBottom: 6,
          titleAlign: "left",
          bodyColor: "#fff",
          bodySpacing: 2,
          bodyFont: {},
          bodyAlign: "left",
          footerColor: "#fff",
          footerSpacing: 2,
          footerMarginTop: 6,
          footerFont: { weight: "bold" },
          footerAlign: "left",
          padding: 6,
          caretPadding: 2,
          caretSize: 5,
          cornerRadius: 6,
          boxHeight: (e, t) => t.bodyFont.size,
          boxWidth: (e, t) => t.bodyFont.size,
          multiKeyBackground: "#fff",
          displayColors: !0,
          boxPadding: 0,
          borderColor: "rgba(0,0,0,0)",
          borderWidth: 0,
          animation: { duration: 400, easing: "easeOutQuart" },
          animations: {
            numbers: {
              type: "number",
              properties: ["x", "y", "width", "height", "caretX", "caretY"],
            },
            opacity: { easing: "linear", duration: 200 },
          },
          callbacks: {
            beforeTitle: pC,
            title(e) {
              if (e.length > 0) {
                const t = e[0],
                  n = t.chart.data.labels,
                  r = n ? n.length : 0;
                if (this && this.options && "dataset" === this.options.mode)
                  return t.dataset.label || "";
                if (t.label) return t.label;
                if (r > 0 && t.dataIndex < r) return n[t.dataIndex];
              }
              return "";
            },
            afterTitle: pC,
            beforeBody: pC,
            beforeLabel: pC,
            label(e) {
              if (this && this.options && "dataset" === this.options.mode)
                return e.label + ": " + e.formattedValue || e.formattedValue;
              let t = e.dataset.label || "";
              t && (t += ": ");
              const n = e.formattedValue;
              return hC(n) || (t += n), t;
            },
            labelColor(e) {
              const t = e.chart
                .getDatasetMeta(e.datasetIndex)
                .controller.getStyle(e.dataIndex);
              return {
                borderColor: t.borderColor,
                backgroundColor: t.backgroundColor,
                borderWidth: t.borderWidth,
                borderDash: t.borderDash,
                borderDashOffset: t.borderDashOffset,
                borderRadius: 0,
              };
            },
            labelTextColor() {
              return this.options.bodyColor;
            },
            labelPointStyle(e) {
              const t = e.chart
                .getDatasetMeta(e.datasetIndex)
                .controller.getStyle(e.dataIndex);
              return { pointStyle: t.pointStyle, rotation: t.rotation };
            },
            afterLabel: pC,
            afterBody: pC,
            beforeFooter: pC,
            footer: pC,
            afterFooter: pC,
          },
        },
        defaultRoutes: {
          bodyFont: "font",
          footerFont: "font",
          titleFont: "font",
        },
        descriptors: {
          _scriptable: (e) =>
            "filter" !== e && "itemSort" !== e && "external" !== e,
          _indexable: !1,
          callbacks: { _scriptable: !1, _indexable: !1 },
          animation: { _fallback: !1 },
          animations: { _fallback: "animation" },
        },
        additionalOptionScopes: ["interaction"],
      };
      class cO extends pP {
        constructor(e) {
          super(e),
            (this._startValue = void 0),
            (this._valueRange = 0),
            (this._addedLabels = []);
        }
        init(e) {
          const t = this._addedLabels;
          if (t.length) {
            const e = this.getLabels();
            for (const { index: n, label: r } of t)
              e[n] === r && e.splice(n, 1);
            this._addedLabels = [];
          }
          super.init(e);
        }
        parse(e, t) {
          if (hC(e)) return null;
          const n = this.getLabels();
          return ((e, t) => (null === e ? null : ox(Math.round(e), 0, t)))(
            (t =
              isFinite(t) && n[t] === e
                ? t
                : (function (e, t, n, r) {
                    const o = e.indexOf(t);
                    return -1 === o
                      ? ((e, t, n, r) => (
                          "string" == typeof t
                            ? ((n = e.push(t) - 1),
                              r.unshift({ index: n, label: t }))
                            : isNaN(t) && (n = null),
                          n
                        ))(e, t, n, r)
                      : o !== e.lastIndexOf(t)
                      ? n
                      : o;
                  })(n, e, _C(t, e), this._addedLabels)),
            n.length - 1
          );
        }
        determineDataLimits() {
          const { minDefined: e, maxDefined: t } = this.getUserBounds();
          let { min: n, max: r } = this.getMinMax(!0);
          "ticks" === this.options.bounds &&
            (e || (n = 0), t || (r = this.getLabels().length - 1)),
            (this.min = n),
            (this.max = r);
        }
        buildTicks() {
          const e = this.min,
            t = this.max,
            n = this.options.offset,
            r = [];
          let o = this.getLabels();
          (o = 0 === e && t === o.length - 1 ? o : o.slice(e, t + 1)),
            (this._valueRange = Math.max(o.length - (n ? 0 : 1), 1)),
            (this._startValue = this.min - (n ? 0.5 : 0));
          for (let n = e; n <= t; n++) r.push({ value: n });
          return r;
        }
        getLabelForValue(e) {
          const t = this.getLabels();
          return e >= 0 && e < t.length ? t[e] : e;
        }
        configure() {
          super.configure(),
            this.isHorizontal() || (this._reversePixels = !this._reversePixels);
        }
        getPixelForValue(e) {
          return (
            "number" != typeof e && (e = this.parse(e)),
            null === e
              ? NaN
              : this.getPixelForDecimal(
                  (e - this._startValue) / this._valueRange
                )
          );
        }
        getPixelForTick(e) {
          const t = this.ticks;
          return e < 0 || e > t.length - 1
            ? null
            : this.getPixelForValue(t[e].value);
        }
        getValueForPixel(e) {
          return Math.round(
            this._startValue + this.getDecimalForPixel(e) * this._valueRange
          );
        }
        getBasePixel() {
          return this.bottom;
        }
      }
      function uO(e, t, { horizontal: n, minRotation: r }) {
        const o = QC(r),
          a = (n ? Math.sin(o) : Math.cos(o)) || 0.001,
          i = 0.75 * t * ("" + e).length;
        return Math.min(t / a, i);
      }
      (cO.id = "category"),
        (cO.defaults = { ticks: { callback: cO.prototype.getLabelForValue } });
      class pO extends pP {
        constructor(e) {
          super(e),
            (this.start = void 0),
            (this.end = void 0),
            (this._startValue = void 0),
            (this._endValue = void 0),
            (this._valueRange = 0);
        }
        parse(e, t) {
          return hC(e) ||
            (("number" == typeof e || e instanceof Number) && !isFinite(+e))
            ? null
            : +e;
        }
        handleTickRangeOptions() {
          const { beginAtZero: e } = this.options,
            { minDefined: t, maxDefined: n } = this.getUserBounds();
          let { min: r, max: o } = this;
          const a = (e) => (r = t ? r : e),
            i = (e) => (o = n ? o : e);
          if (e) {
            const e = UC(r),
              t = UC(o);
            e < 0 && t < 0 ? i(0) : e > 0 && t > 0 && a(0);
          }
          if (r === o) {
            let t = 1;
            (o >= Number.MAX_SAFE_INTEGER || r <= Number.MIN_SAFE_INTEGER) &&
              (t = Math.abs(0.05 * o)),
              i(o + t),
              e || a(r - t);
          }
          (this.min = r), (this.max = o);
        }
        getTickLimit() {
          const e = this.options.ticks;
          let t,
            { maxTicksLimit: n, stepSize: r } = e;
          return (
            r
              ? ((t = Math.ceil(this.max / r) - Math.floor(this.min / r) + 1),
                t > 1e3 &&
                  (console.warn(
                    `scales.${this.id}.ticks.stepSize: ${r} would result generating up to ${t} ticks. Limiting to 1000.`
                  ),
                  (t = 1e3)))
              : ((t = this.computeTickLimit()), (n = n || 11)),
            n && (t = Math.min(n, t)),
            t
          );
        }
        computeTickLimit() {
          return Number.POSITIVE_INFINITY;
        }
        buildTicks() {
          const e = this.options,
            t = e.ticks;
          let n = this.getTickLimit();
          n = Math.max(2, n);
          const r = (function (e, t) {
            const n = [],
              {
                bounds: r,
                step: o,
                min: a,
                max: i,
                precision: s,
                count: l,
                maxTicks: d,
                maxDigits: c,
                includeBounds: u,
              } = e,
              p = o || 1,
              m = d - 1,
              { min: h, max: f } = t,
              g = !hC(a),
              v = !hC(i),
              b = !hC(l),
              _ = (f - h) / (c + 1);
            let y,
              C,
              x,
              S,
              k = $C((f - h) / m / p) * p;
            if (k < 1e-14 && !g && !v) return [{ value: h }, { value: f }];
            (S = Math.ceil(f / k) - Math.floor(h / k)),
              S > m && (k = $C((S * k) / m / p) * p),
              hC(s) || ((y = Math.pow(10, s)), (k = Math.ceil(k * y) / y)),
              "ticks" === r
                ? ((C = Math.floor(h / k) * k), (x = Math.ceil(f / k) * k))
                : ((C = h), (x = f)),
              g &&
              v &&
              o &&
              (function (e, t) {
                const n = Math.round(e);
                return n - t <= e && n + t >= e;
              })((i - a) / o, k / 1e3)
                ? ((S = Math.round(Math.min((i - a) / k, d))),
                  (k = (i - a) / S),
                  (C = a),
                  (x = i))
                : b
                ? ((C = g ? a : C),
                  (x = v ? i : x),
                  (S = l - 1),
                  (k = (x - C) / S))
                : ((S = (x - C) / k),
                  (S = GC(S, Math.round(S), k / 1e3)
                    ? Math.round(S)
                    : Math.ceil(S)));
            const P = Math.max(JC(k), JC(C));
            (y = Math.pow(10, hC(s) ? P : s)),
              (C = Math.round(C * y) / y),
              (x = Math.round(x * y) / y);
            let w = 0;
            for (
              g &&
              (u && C !== a
                ? (n.push({ value: a }),
                  C < a && w++,
                  GC(Math.round((C + w * k) * y) / y, a, uO(a, _, e)) && w++)
                : C < a && w++);
              w < S;
              ++w
            )
              n.push({ value: Math.round((C + w * k) * y) / y });
            return (
              v && u && x !== i
                ? n.length && GC(n[n.length - 1].value, i, uO(i, _, e))
                  ? (n[n.length - 1].value = i)
                  : n.push({ value: i })
                : (v && x !== i) || n.push({ value: x }),
              n
            );
          })(
            {
              maxTicks: n,
              bounds: e.bounds,
              min: e.min,
              max: e.max,
              precision: t.precision,
              step: t.stepSize,
              count: t.count,
              maxDigits: this._maxDigits(),
              horizontal: this.isHorizontal(),
              minRotation: t.minRotation || 0,
              includeBounds: !1 !== t.includeBounds,
            },
            this._range || this
          );
          return (
            "ticks" === e.bounds && qC(r, this, "value"),
            e.reverse
              ? (r.reverse(), (this.start = this.max), (this.end = this.min))
              : ((this.start = this.min), (this.end = this.max)),
            r
          );
        }
        configure() {
          const e = this.ticks;
          let t = this.min,
            n = this.max;
          if ((super.configure(), this.options.offset && e.length)) {
            const r = (n - t) / Math.max(e.length - 1, 1) / 2;
            (t -= r), (n += r);
          }
          (this._startValue = t),
            (this._endValue = n),
            (this._valueRange = n - t);
        }
        getLabelForValue(e) {
          return hk(e, this.chart.options.locale, this.options.ticks.format);
        }
      }
      class mO extends pO {
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!0);
          (this.min = vC(e) ? e : 0),
            (this.max = vC(t) ? t : 1),
            this.handleTickRangeOptions();
        }
        computeTickLimit() {
          const e = this.isHorizontal(),
            t = e ? this.width : this.height,
            n = QC(this.options.ticks.minRotation),
            r = (e ? Math.sin(n) : Math.cos(n)) || 0.001,
            o = this._resolveTickFontOptions(0);
          return Math.ceil(t / Math.min(40, o.lineHeight / r));
        }
        getPixelForValue(e) {
          return null === e
            ? NaN
            : this.getPixelForDecimal(
                (e - this._startValue) / this._valueRange
              );
        }
        getValueForPixel(e) {
          return (
            this._startValue + this.getDecimalForPixel(e) * this._valueRange
          );
        }
      }
      function hO(e) {
        return 1 == e / Math.pow(10, Math.floor(WC(e)));
      }
      (mO.id = "linear"),
        (mO.defaults = { ticks: { callback: oP.formatters.numeric } });
      class fO extends pP {
        constructor(e) {
          super(e),
            (this.start = void 0),
            (this.end = void 0),
            (this._startValue = void 0),
            (this._valueRange = 0);
        }
        parse(e, t) {
          const n = pO.prototype.parse.apply(this, [e, t]);
          if (0 !== n) return vC(n) && n > 0 ? n : null;
          this._zero = !0;
        }
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!0);
          (this.min = vC(e) ? Math.max(0, e) : null),
            (this.max = vC(t) ? Math.max(0, t) : null),
            this.options.beginAtZero && (this._zero = !0),
            this.handleTickRangeOptions();
        }
        handleTickRangeOptions() {
          const { minDefined: e, maxDefined: t } = this.getUserBounds();
          let n = this.min,
            r = this.max;
          const o = (t) => (n = e ? n : t),
            a = (e) => (r = t ? r : e),
            i = (e, t) => Math.pow(10, Math.floor(WC(e)) + t);
          n === r && (n <= 0 ? (o(1), a(10)) : (o(i(n, -1)), a(i(r, 1)))),
            n <= 0 && o(i(r, -1)),
            r <= 0 && a(i(n, 1)),
            this._zero &&
              this.min !== this._suggestedMin &&
              n === i(this.min, 0) &&
              o(i(n, -1)),
            (this.min = n),
            (this.max = r);
        }
        buildTicks() {
          const e = this.options,
            t = (function (e, t) {
              const n = Math.floor(WC(t.max)),
                r = Math.ceil(t.max / Math.pow(10, n)),
                o = [];
              let a = bC(e.min, Math.pow(10, Math.floor(WC(t.min)))),
                i = Math.floor(WC(a)),
                s = Math.floor(a / Math.pow(10, i)),
                l = i < 0 ? Math.pow(10, Math.abs(i)) : 1;
              do {
                o.push({ value: a, major: hO(a) }),
                  ++s,
                  10 === s && ((s = 1), ++i, (l = i >= 0 ? 1 : l)),
                  (a = Math.round(s * Math.pow(10, i) * l) / l);
              } while (i < n || (i === n && s < r));
              const d = bC(e.max, a);
              return o.push({ value: d, major: hO(a) }), o;
            })({ min: this._userMin, max: this._userMax }, this);
          return (
            "ticks" === e.bounds && qC(t, this, "value"),
            e.reverse
              ? (t.reverse(), (this.start = this.max), (this.end = this.min))
              : ((this.start = this.min), (this.end = this.max)),
            t
          );
        }
        getLabelForValue(e) {
          return void 0 === e
            ? "0"
            : hk(e, this.chart.options.locale, this.options.ticks.format);
        }
        configure() {
          const e = this.min;
          super.configure(),
            (this._startValue = WC(e)),
            (this._valueRange = WC(this.max) - WC(e));
        }
        getPixelForValue(e) {
          return (
            (void 0 !== e && 0 !== e) || (e = this.min),
            null === e || isNaN(e)
              ? NaN
              : this.getPixelForDecimal(
                  e === this.min
                    ? 0
                    : (WC(e) - this._startValue) / this._valueRange
                )
          );
        }
        getValueForPixel(e) {
          const t = this.getDecimalForPixel(e);
          return Math.pow(10, this._startValue + t * this._valueRange);
        }
      }
      function gO(e) {
        const t = e.ticks;
        if (t.display && e.display) {
          const e = TS(t.backdropPadding);
          return _C(t.font && t.font.size, iS.font.size) + e.height;
        }
        return 0;
      }
      function vO(e, t, n, r, o) {
        return e === r || e === o
          ? { start: t - n / 2, end: t + n / 2 }
          : e < r || e > o
          ? { start: t - n, end: t }
          : { start: t, end: t + n };
      }
      function bO(e, t, n, r, o) {
        const a = Math.abs(Math.sin(n)),
          i = Math.abs(Math.cos(n));
        let s = 0,
          l = 0;
        r.start < t.l
          ? ((s = (t.l - r.start) / a), (e.l = Math.min(e.l, t.l - s)))
          : r.end > t.r &&
            ((s = (r.end - t.r) / a), (e.r = Math.max(e.r, t.r + s))),
          o.start < t.t
            ? ((l = (t.t - o.start) / i), (e.t = Math.min(e.t, t.t - l)))
            : o.end > t.b &&
              ((l = (o.end - t.b) / i), (e.b = Math.max(e.b, t.b + l)));
      }
      function _O(e) {
        return 0 === e || 180 === e ? "center" : e < 180 ? "left" : "right";
      }
      function yO(e, t, n) {
        return (
          90 === n || 270 === n
            ? (e -= t / 2)
            : (n > 270 || n < 90) && (e -= t),
          e
        );
      }
      function CO(e, t, n, r) {
        const { ctx: o } = e;
        if (n) o.arc(e.xCenter, e.yCenter, t, 0, LC);
        else {
          let n = e.getPointPosition(0, t);
          o.moveTo(n.x, n.y);
          for (let a = 1; a < r; a++)
            (n = e.getPointPosition(a, t)), o.lineTo(n.x, n.y);
        }
      }
      (fO.id = "logarithmic"),
        (fO.defaults = {
          ticks: {
            callback: oP.formatters.logarithmic,
            major: { enabled: !0 },
          },
        });
      class xO extends pO {
        constructor(e) {
          super(e),
            (this.xCenter = void 0),
            (this.yCenter = void 0),
            (this.drawingArea = void 0),
            (this._pointLabels = []),
            (this._pointLabelItems = []);
        }
        setDimensions() {
          const e = (this._padding = TS(gO(this.options) / 2)),
            t = (this.width = this.maxWidth - e.width),
            n = (this.height = this.maxHeight - e.height);
          (this.xCenter = Math.floor(this.left + t / 2 + e.left)),
            (this.yCenter = Math.floor(this.top + n / 2 + e.top)),
            (this.drawingArea = Math.floor(Math.min(t, n) / 2));
        }
        determineDataLimits() {
          const { min: e, max: t } = this.getMinMax(!1);
          (this.min = vC(e) && !isNaN(e) ? e : 0),
            (this.max = vC(t) && !isNaN(t) ? t : 0),
            this.handleTickRangeOptions();
        }
        computeTickLimit() {
          return Math.ceil(this.drawingArea / gO(this.options));
        }
        generateTickLabels(e) {
          pO.prototype.generateTickLabels.call(this, e),
            (this._pointLabels = this.getLabels()
              .map((e, t) => {
                const n = CC(this.options.pointLabels.callback, [e, t], this);
                return n || 0 === n ? n : "";
              })
              .filter((e, t) => this.chart.getDataVisibility(t)));
        }
        fit() {
          const e = this.options;
          e.display && e.pointLabels.display
            ? (function (e) {
                const t = {
                    l: e.left + e._padding.left,
                    r: e.right - e._padding.right,
                    t: e.top + e._padding.top,
                    b: e.bottom - e._padding.bottom,
                  },
                  n = Object.assign({}, t),
                  r = [],
                  o = [],
                  a = e._pointLabels.length,
                  i = e.options.pointLabels,
                  s = i.centerPointLabels ? RC / a : 0;
                for (let u = 0; u < a; u++) {
                  const a = i.setContext(e.getPointLabelContext(u));
                  o[u] = a.padding;
                  const p = e.getPointPosition(u, e.drawingArea + o[u], s),
                    m = IS(a.font),
                    h =
                      ((l = e.ctx),
                      (d = m),
                      (c = fC((c = e._pointLabels[u])) ? c : [c]),
                      { w: lS(l, d.string, c), h: c.length * d.lineHeight });
                  r[u] = h;
                  const f = nx(e.getIndexAngle(u) + s),
                    g = Math.round(YC(f));
                  bO(
                    n,
                    t,
                    f,
                    vO(g, p.x, h.w, 0, 180),
                    vO(g, p.y, h.h, 90, 270)
                  );
                }
                var l, d, c;
                e.setCenterPoint(t.l - n.l, n.r - t.r, t.t - n.t, n.b - t.b),
                  (e._pointLabelItems = (function (e, t, n) {
                    const r = [],
                      o = e._pointLabels.length,
                      a = e.options,
                      i = gO(a) / 2,
                      s = e.drawingArea,
                      l = a.pointLabels.centerPointLabels ? RC / o : 0;
                    for (let a = 0; a < o; a++) {
                      const o = e.getPointPosition(a, s + i + n[a], l),
                        p = Math.round(YC(nx(o.angle + ZC))),
                        m = t[a],
                        h = yO(o.y, m.h, p),
                        f = _O(p),
                        g =
                          ((d = o.x),
                          (c = m.w),
                          "right" === (u = f)
                            ? (d -= c)
                            : "center" === u && (d -= c / 2),
                          d);
                      r.push({
                        x: o.x,
                        y: h,
                        textAlign: f,
                        left: g,
                        top: h,
                        right: g + m.w,
                        bottom: h + m.h,
                      });
                    }
                    var d, c, u;
                    return r;
                  })(e, r, o));
              })(this)
            : this.setCenterPoint(0, 0, 0, 0);
        }
        setCenterPoint(e, t, n, r) {
          (this.xCenter += Math.floor((e - t) / 2)),
            (this.yCenter += Math.floor((n - r) / 2)),
            (this.drawingArea -= Math.min(
              this.drawingArea / 2,
              Math.max(e, t, n, r)
            ));
        }
        getIndexAngle(e) {
          return nx(
            e * (LC / (this._pointLabels.length || 1)) +
              QC(this.options.startAngle || 0)
          );
        }
        getDistanceFromCenterForValue(e) {
          if (hC(e)) return NaN;
          const t = this.drawingArea / (this.max - this.min);
          return this.options.reverse ? (this.max - e) * t : (e - this.min) * t;
        }
        getValueForDistanceFromCenter(e) {
          if (hC(e)) return NaN;
          const t = e / (this.drawingArea / (this.max - this.min));
          return this.options.reverse ? this.max - t : this.min + t;
        }
        getPointLabelContext(e) {
          const t = this._pointLabels || [];
          if (e >= 0 && e < t.length) {
            const n = t[e];
            return (function (e, t, n) {
              return jS(e, { label: n, index: t, type: "pointLabel" });
            })(this.getContext(), e, n);
          }
        }
        getPointPosition(e, t, n = 0) {
          const r = this.getIndexAngle(e) - ZC + n;
          return {
            x: Math.cos(r) * t + this.xCenter,
            y: Math.sin(r) * t + this.yCenter,
            angle: r,
          };
        }
        getPointPositionForValue(e, t) {
          return this.getPointPosition(
            e,
            this.getDistanceFromCenterForValue(t)
          );
        }
        getBasePosition(e) {
          return this.getPointPositionForValue(e || 0, this.getBaseValue());
        }
        getPointLabelPosition(e) {
          const {
            left: t,
            top: n,
            right: r,
            bottom: o,
          } = this._pointLabelItems[e];
          return { left: t, top: n, right: r, bottom: o };
        }
        drawBackground() {
          const {
            backgroundColor: e,
            grid: { circular: t },
          } = this.options;
          if (e) {
            const n = this.ctx;
            n.save(),
              n.beginPath(),
              CO(
                this,
                this.getDistanceFromCenterForValue(this._endValue),
                t,
                this._pointLabels.length
              ),
              n.closePath(),
              (n.fillStyle = e),
              n.fill(),
              n.restore();
          }
        }
        drawGrid() {
          const e = this.ctx,
            t = this.options,
            { angleLines: n, grid: r } = t,
            o = this._pointLabels.length;
          let a, i, s;
          if (
            (t.pointLabels.display &&
              (function (e, t) {
                const {
                  ctx: n,
                  options: { pointLabels: r },
                } = e;
                for (let o = t - 1; o >= 0; o--) {
                  const t = r.setContext(e.getPointLabelContext(o)),
                    a = IS(t.font),
                    {
                      x: i,
                      y: s,
                      textAlign: l,
                      left: d,
                      top: c,
                      right: u,
                      bottom: p,
                    } = e._pointLabelItems[o],
                    { backdropColor: m } = t;
                  if (!hC(m)) {
                    const e = OS(t.borderRadius),
                      r = TS(t.backdropPadding);
                    n.fillStyle = m;
                    const o = d - r.left,
                      a = c - r.top,
                      i = u - d + r.width,
                      s = p - c + r.height;
                    Object.values(e).some((e) => 0 !== e)
                      ? (n.beginPath(),
                        yS(n, { x: o, y: a, w: i, h: s, radius: e }),
                        n.fill())
                      : n.fillRect(o, a, i, s);
                  }
                  bS(n, e._pointLabels[o], i, s + a.lineHeight / 2, a, {
                    color: t.color,
                    textAlign: l,
                    textBaseline: "middle",
                  });
                }
              })(this, o),
            r.display &&
              this.ticks.forEach((e, t) => {
                0 !== t &&
                  ((i = this.getDistanceFromCenterForValue(e.value)),
                  (function (e, t, n, r) {
                    const o = e.ctx,
                      a = t.circular,
                      { color: i, lineWidth: s } = t;
                    (!a && !r) ||
                      !i ||
                      !s ||
                      n < 0 ||
                      (o.save(),
                      (o.strokeStyle = i),
                      (o.lineWidth = s),
                      o.setLineDash(t.borderDash),
                      (o.lineDashOffset = t.borderDashOffset),
                      o.beginPath(),
                      CO(e, n, a, r),
                      o.closePath(),
                      o.stroke(),
                      o.restore());
                  })(this, r.setContext(this.getContext(t - 1)), i, o));
              }),
            n.display)
          ) {
            for (e.save(), a = o - 1; a >= 0; a--) {
              const r = n.setContext(this.getPointLabelContext(a)),
                { color: o, lineWidth: l } = r;
              l &&
                o &&
                ((e.lineWidth = l),
                (e.strokeStyle = o),
                e.setLineDash(r.borderDash),
                (e.lineDashOffset = r.borderDashOffset),
                (i = this.getDistanceFromCenterForValue(
                  t.ticks.reverse ? this.min : this.max
                )),
                (s = this.getPointPosition(a, i)),
                e.beginPath(),
                e.moveTo(this.xCenter, this.yCenter),
                e.lineTo(s.x, s.y),
                e.stroke());
            }
            e.restore();
          }
        }
        drawBorder() {}
        drawLabels() {
          const e = this.ctx,
            t = this.options,
            n = t.ticks;
          if (!n.display) return;
          const r = this.getIndexAngle(0);
          let o, a;
          e.save(),
            e.translate(this.xCenter, this.yCenter),
            e.rotate(r),
            (e.textAlign = "center"),
            (e.textBaseline = "middle"),
            this.ticks.forEach((r, i) => {
              if (0 === i && !t.reverse) return;
              const s = n.setContext(this.getContext(i)),
                l = IS(s.font);
              if (
                ((o = this.getDistanceFromCenterForValue(this.ticks[i].value)),
                s.showLabelBackdrop)
              ) {
                (e.font = l.string),
                  (a = e.measureText(r.label).width),
                  (e.fillStyle = s.backdropColor);
                const t = TS(s.backdropPadding);
                e.fillRect(
                  -a / 2 - t.left,
                  -o - l.size / 2 - t.top,
                  a + t.width,
                  l.size + t.height
                );
              }
              bS(e, r.label, 0, -o, l, { color: s.color });
            }),
            e.restore();
        }
        drawTitle() {}
      }
      (xO.id = "radialLinear"),
        (xO.defaults = {
          display: !0,
          animate: !0,
          position: "chartArea",
          angleLines: {
            display: !0,
            lineWidth: 1,
            borderDash: [],
            borderDashOffset: 0,
          },
          grid: { circular: !1 },
          startAngle: 0,
          ticks: { showLabelBackdrop: !0, callback: oP.formatters.numeric },
          pointLabels: {
            backdropColor: void 0,
            backdropPadding: 2,
            display: !0,
            font: { size: 10 },
            callback(e) {
              return e;
            },
            padding: 5,
            centerPointLabels: !1,
          },
        }),
        (xO.defaultRoutes = {
          "angleLines.color": "borderColor",
          "pointLabels.color": "color",
          "ticks.color": "color",
        }),
        (xO.descriptors = { angleLines: { _fallback: "grid" } });
      const SO = {
          millisecond: { common: !0, size: 1, steps: 1e3 },
          second: { common: !0, size: 1e3, steps: 60 },
          minute: { common: !0, size: 6e4, steps: 60 },
          hour: { common: !0, size: 36e5, steps: 24 },
          day: { common: !0, size: 864e5, steps: 30 },
          week: { common: !1, size: 6048e5, steps: 4 },
          month: { common: !0, size: 2628e6, steps: 12 },
          quarter: { common: !1, size: 7884e6, steps: 4 },
          year: { common: !0, size: 3154e7 },
        },
        kO = Object.keys(SO);
      function PO(e, t) {
        return e - t;
      }
      function wO(e, t) {
        if (hC(t)) return null;
        const n = e._adapter,
          { parser: r, round: o, isoWeekday: a } = e._parseOpts;
        let i = t;
        return (
          "function" == typeof r && (i = r(i)),
          vC(i) || (i = "string" == typeof r ? n.parse(i, r) : n.parse(i)),
          null === i
            ? null
            : (o &&
                (i =
                  "week" !== o || (!KC(a) && !0 !== a)
                    ? n.startOf(i, o)
                    : n.startOf(i, "isoWeek", a)),
              +i)
        );
      }
      function OO(e, t, n, r) {
        const o = kO.length;
        for (let a = kO.indexOf(e); a < o - 1; ++a) {
          const e = SO[kO[a]],
            o = e.steps ? e.steps : Number.MAX_SAFE_INTEGER;
          if (e.common && Math.ceil((n - t) / (o * e.size)) <= r) return kO[a];
        }
        return kO[o - 1];
      }
      function TO(e, t, n) {
        if (n) {
          if (n.length) {
            const { lo: r, hi: o } = ix(n, t);
            e[n[r] >= t ? n[r] : n[o]] = !0;
          }
        } else e[t] = !0;
      }
      function IO(e, t, n) {
        const r = [],
          o = {},
          a = t.length;
        let i, s;
        for (i = 0; i < a; ++i)
          (s = t[i]), (o[s] = i), r.push({ value: s, major: !1 });
        return 0 !== a && n
          ? (function (e, t, n, r) {
              const o = e._adapter,
                a = +o.startOf(t[0].value, r),
                i = t[t.length - 1].value;
              let s, l;
              for (s = a; s <= i; s = +o.add(s, 1, r))
                (l = n[s]), l >= 0 && (t[l].major = !0);
              return t;
            })(e, r, o, n)
          : r;
      }
      class MO extends pP {
        constructor(e) {
          super(e),
            (this._cache = { data: [], labels: [], all: [] }),
            (this._unit = "day"),
            (this._majorUnit = void 0),
            (this._offsets = {}),
            (this._normalized = !1),
            (this._parseOpts = void 0);
        }
        init(e, t) {
          const n = e.time || (e.time = {}),
            r = (this._adapter = new bP._date(e.adapters.date));
          r.init(t),
            TC(n.displayFormats, r.formats()),
            (this._parseOpts = {
              parser: n.parser,
              round: n.round,
              isoWeekday: n.isoWeekday,
            }),
            super.init(e),
            (this._normalized = t.normalized);
        }
        parse(e, t) {
          return void 0 === e ? null : wO(this, e);
        }
        beforeLayout() {
          super.beforeLayout(),
            (this._cache = { data: [], labels: [], all: [] });
        }
        determineDataLimits() {
          const e = this.options,
            t = this._adapter,
            n = e.time.unit || "day";
          let {
            min: r,
            max: o,
            minDefined: a,
            maxDefined: i,
          } = this.getUserBounds();
          function s(e) {
            a || isNaN(e.min) || (r = Math.min(r, e.min)),
              i || isNaN(e.max) || (o = Math.max(o, e.max));
          }
          (a && i) ||
            (s(this._getLabelBounds()),
            ("ticks" === e.bounds && "labels" === e.ticks.source) ||
              s(this.getMinMax(!1))),
            (r = vC(r) && !isNaN(r) ? r : +t.startOf(Date.now(), n)),
            (o = vC(o) && !isNaN(o) ? o : +t.endOf(Date.now(), n) + 1),
            (this.min = Math.min(r, o - 1)),
            (this.max = Math.max(r + 1, o));
        }
        _getLabelBounds() {
          const e = this.getLabelTimestamps();
          let t = Number.POSITIVE_INFINITY,
            n = Number.NEGATIVE_INFINITY;
          return (
            e.length && ((t = e[0]), (n = e[e.length - 1])), { min: t, max: n }
          );
        }
        buildTicks() {
          const e = this.options,
            t = e.time,
            n = e.ticks,
            r =
              "labels" === n.source
                ? this.getLabelTimestamps()
                : this._generate();
          "ticks" === e.bounds &&
            r.length &&
            ((this.min = this._userMin || r[0]),
            (this.max = this._userMax || r[r.length - 1]));
          const o = this.min,
            a = (function (e, t, n) {
              let r = 0,
                o = e.length;
              for (; r < o && e[r] < t; ) r++;
              for (; o > r && e[o - 1] > n; ) o--;
              return r > 0 || o < e.length ? e.slice(r, o) : e;
            })(r, o, this.max);
          return (
            (this._unit =
              t.unit ||
              (n.autoSkip
                ? OO(t.minUnit, this.min, this.max, this._getLabelCapacity(o))
                : (function (e, t, n, r, o) {
                    for (let a = kO.length - 1; a >= kO.indexOf(n); a--) {
                      const n = kO[a];
                      if (SO[n].common && e._adapter.diff(o, r, n) >= t - 1)
                        return n;
                    }
                    return kO[n ? kO.indexOf(n) : 0];
                  })(this, a.length, t.minUnit, this.min, this.max))),
            (this._majorUnit =
              n.major.enabled && "year" !== this._unit
                ? (function (e) {
                    for (let t = kO.indexOf(e) + 1, n = kO.length; t < n; ++t)
                      if (SO[kO[t]].common) return kO[t];
                  })(this._unit)
                : void 0),
            this.initOffsets(r),
            e.reverse && a.reverse(),
            IO(this, a, this._majorUnit)
          );
        }
        afterAutoSkip() {
          this.options.offsetAfterAutoskip &&
            this.initOffsets(this.ticks.map((e) => +e.value));
        }
        initOffsets(e) {
          let t,
            n,
            r = 0,
            o = 0;
          this.options.offset &&
            e.length &&
            ((t = this.getDecimalForValue(e[0])),
            (r =
              1 === e.length ? 1 - t : (this.getDecimalForValue(e[1]) - t) / 2),
            (n = this.getDecimalForValue(e[e.length - 1])),
            (o =
              1 === e.length
                ? n
                : (n - this.getDecimalForValue(e[e.length - 2])) / 2));
          const a = e.length < 3 ? 0.5 : 0.25;
          (r = ox(r, 0, a)),
            (o = ox(o, 0, a)),
            (this._offsets = { start: r, end: o, factor: 1 / (r + 1 + o) });
        }
        _generate() {
          const e = this._adapter,
            t = this.min,
            n = this.max,
            r = this.options,
            o = r.time,
            a = o.unit || OO(o.minUnit, t, n, this._getLabelCapacity(t)),
            i = _C(o.stepSize, 1),
            s = "week" === a && o.isoWeekday,
            l = KC(s) || !0 === s,
            d = {};
          let c,
            u,
            p = t;
          if (
            (l && (p = +e.startOf(p, "isoWeek", s)),
            (p = +e.startOf(p, l ? "day" : a)),
            e.diff(n, t, a) > 1e5 * i)
          )
            throw new Error(
              t +
                " and " +
                n +
                " are too far apart with stepSize of " +
                i +
                " " +
                a
            );
          const m = "data" === r.ticks.source && this.getDataTimestamps();
          for (c = p, u = 0; c < n; c = +e.add(c, i, a), u++) TO(d, c, m);
          return (
            (c !== n && "ticks" !== r.bounds && 1 !== u) || TO(d, c, m),
            Object.keys(d)
              .sort((e, t) => e - t)
              .map((e) => +e)
          );
        }
        getLabelForValue(e) {
          const t = this._adapter,
            n = this.options.time;
          return n.tooltipFormat
            ? t.format(e, n.tooltipFormat)
            : t.format(e, n.displayFormats.datetime);
        }
        _tickFormatFunction(e, t, n, r) {
          const o = this.options,
            a = o.time.displayFormats,
            i = this._unit,
            s = this._majorUnit,
            l = i && a[i],
            d = s && a[s],
            c = n[t],
            u = s && d && c && c.major,
            p = this._adapter.format(e, r || (u ? d : l)),
            m = o.ticks.callback;
          return m ? CC(m, [p, t, n], this) : p;
        }
        generateTickLabels(e) {
          let t, n, r;
          for (t = 0, n = e.length; t < n; ++t)
            (r = e[t]), (r.label = this._tickFormatFunction(r.value, t, e));
        }
        getDecimalForValue(e) {
          return null === e ? NaN : (e - this.min) / (this.max - this.min);
        }
        getPixelForValue(e) {
          const t = this._offsets,
            n = this.getDecimalForValue(e);
          return this.getPixelForDecimal((t.start + n) * t.factor);
        }
        getValueForPixel(e) {
          const t = this._offsets,
            n = this.getDecimalForPixel(e) / t.factor - t.end;
          return this.min + n * (this.max - this.min);
        }
        _getLabelSize(e) {
          const t = this.options.ticks,
            n = this.ctx.measureText(e).width,
            r = QC(this.isHorizontal() ? t.maxRotation : t.minRotation),
            o = Math.cos(r),
            a = Math.sin(r),
            i = this._resolveTickFontOptions(0).size;
          return { w: n * o + i * a, h: n * a + i * o };
        }
        _getLabelCapacity(e) {
          const t = this.options.time,
            n = t.displayFormats,
            r = n[t.unit] || n.millisecond,
            o = this._tickFormatFunction(
              e,
              0,
              IO(this, [e], this._majorUnit),
              r
            ),
            a = this._getLabelSize(o),
            i =
              Math.floor(
                this.isHorizontal() ? this.width / a.w : this.height / a.h
              ) - 1;
          return i > 0 ? i : 1;
        }
        getDataTimestamps() {
          let e,
            t,
            n = this._cache.data || [];
          if (n.length) return n;
          const r = this.getMatchingVisibleMetas();
          if (this._normalized && r.length)
            return (this._cache.data =
              r[0].controller.getAllParsedValues(this));
          for (e = 0, t = r.length; e < t; ++e)
            n = n.concat(r[e].controller.getAllParsedValues(this));
          return (this._cache.data = this.normalize(n));
        }
        getLabelTimestamps() {
          const e = this._cache.labels || [];
          let t, n;
          if (e.length) return e;
          const r = this.getLabels();
          for (t = 0, n = r.length; t < n; ++t) e.push(wO(this, r[t]));
          return (this._cache.labels = this._normalized
            ? e
            : this.normalize(e));
        }
        normalize(e) {
          return ux(e.sort(PO));
        }
      }
      function jO(e, t, n) {
        let r,
          o,
          a,
          i,
          s = 0,
          l = e.length - 1;
        n
          ? (t >= e[s].pos &&
              t <= e[l].pos &&
              ({ lo: s, hi: l } = sx(e, "pos", t)),
            ({ pos: r, time: a } = e[s]),
            ({ pos: o, time: i } = e[l]))
          : (t >= e[s].time &&
              t <= e[l].time &&
              ({ lo: s, hi: l } = sx(e, "time", t)),
            ({ time: r, pos: a } = e[s]),
            ({ time: o, pos: i } = e[l]));
        const d = o - r;
        return d ? a + ((i - a) * (t - r)) / d : a;
      }
      (MO.id = "time"),
        (MO.defaults = {
          bounds: "data",
          adapters: {},
          time: {
            parser: !1,
            unit: !1,
            round: !1,
            isoWeekday: !1,
            minUnit: "millisecond",
            displayFormats: {},
          },
          ticks: { source: "auto", major: { enabled: !1 } },
        });
      class NO extends MO {
        constructor(e) {
          super(e),
            (this._table = []),
            (this._minPos = void 0),
            (this._tableRange = void 0);
        }
        initOffsets() {
          const e = this._getTimestampsForTable(),
            t = (this._table = this.buildLookupTable(e));
          (this._minPos = jO(t, this.min)),
            (this._tableRange = jO(t, this.max) - this._minPos),
            super.initOffsets(e);
        }
        buildLookupTable(e) {
          const { min: t, max: n } = this,
            r = [],
            o = [];
          let a, i, s, l, d;
          for (a = 0, i = e.length; a < i; ++a)
            (l = e[a]), l >= t && l <= n && r.push(l);
          if (r.length < 2)
            return [
              { time: t, pos: 0 },
              { time: n, pos: 1 },
            ];
          for (a = 0, i = r.length; a < i; ++a)
            (d = r[a + 1]),
              (s = r[a - 1]),
              (l = r[a]),
              Math.round((d + s) / 2) !== l &&
                o.push({ time: l, pos: a / (i - 1) });
          return o;
        }
        _getTimestampsForTable() {
          let e = this._cache.all || [];
          if (e.length) return e;
          const t = this.getDataTimestamps(),
            n = this.getLabelTimestamps();
          return (
            (e =
              t.length && n.length
                ? this.normalize(t.concat(n))
                : t.length
                ? t
                : n),
            (e = this._cache.all = e),
            e
          );
        }
        getDecimalForValue(e) {
          return (jO(this._table, e) - this._minPos) / this._tableRange;
        }
        getValueForPixel(e) {
          const t = this._offsets,
            n = this.getDecimalForPixel(e) / t.factor - t.end;
          return jO(this._table, n * this._tableRange + this._minPos, !0);
        }
      }
      (NO.id = "timeseries"), (NO.defaults = MO.defaults);
      var DO = function () {
          return (
            (DO =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            DO.apply(this, arguments)
          );
        },
        AO = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function EO() {
        var n,
          r,
          o,
          a,
          i,
          s,
          l = this,
          d = y(function (e) {
            return e.salesRepData.baseData;
          }),
          c = F.getState().salesRepData.baseData.select
            ? F.getState().salesRepData.baseData.select
            : {},
          u = g(),
          p = ee().t,
          m = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          h = F.getState().salesRepData.loggedInRepDetails.currency,
          f = wv("(min-width: 1360px)"),
          v = F.getState().salesRepData.loggedInRepDetails,
          b =
            null !==
              (r =
                null === (n = F.getState().salesRepData) || void 0 === n
                  ? void 0
                  : n.baseData) && void 0 !== r
              ? r
              : {},
          _ =
            null !==
              (a =
                null === (o = F.getState().salesRepData.baseData) ||
                void 0 === o
                  ? void 0
                  : o.ShopBusinessName) && void 0 !== a
              ? a
              : null === (i = null == v ? void 0 : v.shopName) || void 0 === i
              ? void 0
              : i.replace(/.myshopify.com/g, ""),
          C = [
            p("ClientInvoice"),
            p("AffiliateOrder"),
            p("ReturnCustomerOrder"),
            p("CouponOrder"),
            p("SharedCart"),
            p("AdminTaggedOrder"),
          ],
          x = (null == c ? void 0 : c.CreateB2BOrder)
            ? AO(AO([], C, !0), [p("TaggedCompanyLocationOrder")], !1)
            : C,
          S = [
            { name: p("Dashboard_Month"), hide: !1 },
            { name: p("Dashboard_Orders_Total"), hide: !1 },
            { name: p("Dashboard_Total_Sale"), hide: !1 },
            { name: p("Dashboard_Commission"), hide: !1 },
            {
              name: p("Dashboard_Bonus"),
              hide: !(null == c ? void 0 : c.Bonus),
            },
          ],
          k = (0, t.useState)({
            commissionMonthLabels: [],
            commissionMonthPoints: [],
          }),
          P = k[0],
          w = k[1],
          O = (0, t.useState)({ orderMonthLabels: [], orderMonthPoints: [] }),
          T = O[0],
          I = O[1],
          M = (0, t.useState)({ salesMonthLabels: [], salesMonthPoints: [] }),
          j = M[0],
          N = M[1],
          D = (0, t.useState)([]),
          A = D[0],
          E = D[1],
          R = (0, t.useState)([]),
          L = R[0],
          B = R[1],
          z = (0, t.useState)([]),
          Z = z[0],
          H = z[1],
          V = (0, t.useState)(b || ""),
          W = V[0],
          U = V[1],
          $ = (0, t.useState)(!1),
          K = $[0],
          G = $[1],
          q = (0, t.useState)({
            orderFeatureLabels: 0,
            commissionFeatureLabels: 0,
            salesFeatureLabels: 0,
          }),
          Q = q[0],
          Y = q[1],
          J = (0, t.useState)("-"),
          X = J[0],
          te = J[1],
          ne = (0, t.useState)(!1),
          re = ne[0],
          oe = ne[1],
          ae = (0, t.useState)([]),
          ie = ae[0],
          se = ae[1],
          le = (0, t.useState)(!1),
          de = le[0],
          ce = le[1],
          ue = (0, t.useState)([]),
          pe = ue[0],
          me = ue[1],
          he =
            null === (s = null == W ? void 0 : W.CommissionDiscountOn) ||
            void 0 === s
              ? void 0
              : s.CommissionDiscountType,
          fe = Tv(),
          ge = {
            labels: T.orderMonthLabels,
            datasets: [
              {
                type: "line",
                data: T.orderMonthPoints,
                borderColor: "#4ED8DA",
                borderWidth: 3,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          ve = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: p("Graph_SalesRepOrders_YAxisTitle"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              x: {
                title: {
                  display: !0,
                  text: p("Graph_SalesRep_XAxisTitle_ForMonth"),
                },
              },
            },
          },
          be = {
            labels: P.commissionMonthLabels,
            datasets: [
              {
                data: P.commissionMonthPoints,
                backgroundColor: "#36A2EB",
                barThickness: 35,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          _e = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: p("Graph_SalesRepCommissions_YAxisTitle"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              x: {
                title: {
                  display: !0,
                  text: p("Graph_SalesRep_XAxisTitle_ForMonth"),
                },
                grid: { display: !1 },
              },
            },
          },
          ye = {
            type: "horizontalBar",
            labels: j.salesMonthLabels,
            datasets: [
              {
                data: j.salesMonthPoints,
                backgroundColor: "#2371CB",
                barThickness: 25,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "right",
                  anchor: "end",
                },
              },
            ],
          },
          Ce = {
            indexAxis: "y",
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: p("dashboard_sales_of_last_six_months"),
              },
              legend: { display: !1 },
            },
            scales: {
              x: { title: { display: !0, text: p("dashboar_cardHeading3") } },
              y: { title: { display: !1 }, grid: { display: !1 } },
            },
          },
          xe = {
            labels: Q.orderFeatureLabels > 0 ? x : [],
            datasets: [
              {
                data: A,
                backgroundColor: "#8566FB",
                barThickness: 35,
                datalabels: {
                  display: !0,
                  color: "black",
                  align: "top",
                  anchor: "end",
                },
              },
            ],
          },
          Se = {
            responsive: !0,
            maintainAspectRatio: !1,
            plugins: {
              title: {
                display: !0,
                text: p("Graph_FeatureWiseOrder_title"),
                padding: { bottom: 20 },
              },
              legend: { display: !1 },
            },
            scales: {
              y: {
                title: {
                  display: !0,
                  text: p("Graph_SalesRepOrders_YAxisTitle"),
                },
                ticks: {
                  callback: function (e) {
                    return e;
                  },
                },
              },
              x: {
                title: {
                  display: !0,
                  text: p("Graph_FeatureWiseOrder_XAxisTitle"),
                },
              },
            },
          },
          ke = {
            type: "pie",
            labels: Q.commissionFeatureLabels > 0 ? x : [],
            datasets: [
              {
                data: L,
                backgroundColor: [
                  "#4ED8DA",
                  "#EAF0B7",
                  "#36A2EB",
                  "#FAD9FF",
                  "#F9A48E",
                  "#73BF53",
                  "#FFA500",
                ],
                borderWidth: 2,
              },
            ],
          },
          Pe = {
            responsive: !0,
            maintainAspectRatio: !1,
            title: { display: !0, position: "top", padding: { bottom: 20 } },
            plugins: {
              title: {
                display: !0,
                position: "top",
                text: p("Graph_featureWiseCommission_title"),
                padding: { bottom: 20 },
              },
              legend: {
                display: (null == Q ? void 0 : Q.commissionFeatureLabels) > 0,
                position: fe ? "bottom" : "left",
                labels: {
                  usePointStyle: !0,
                  PointStyle: "rect",
                  filter: function (e, t) {
                    return 0 !== t.datasets[0].data[e.index];
                  },
                  border: "1px solid",
                },
                title: {
                  display: !0,
                  position: "center",
                  text: p("Graph_FeatureWiseOrder_XAxisTitle"),
                  padding: { top: 20 },
                  fontWeight: 500,
                },
              },
            },
          };
        (0, t.useEffect)(
          function () {
            var e;
            Fh.subscribe(function (e) {
              oe(e);
            }),
              me(
                (null == W ? void 0 : W.SalesRepMonthlyCommission) &&
                  (null ===
                    (e = Object.keys(
                      (null == W ? void 0 : W.SalesRepMonthlyCommission) || {}
                    )) || void 0 === e
                    ? void 0
                    : e.map(function (e) {
                        return null == W
                          ? void 0
                          : W.SalesRepMonthlyCommission[e];
                      }))
              ),
              we();
          },
          [re, W]
        ),
          (0, t.useEffect)(
            function () {
              var e;
              d &&
                (null === (e = Object.keys(d)) || void 0 === e
                  ? void 0
                  : e.length) > 0 &&
                Oe();
            },
            [d]
          );
        var we = function () {
            var e,
              t,
              n,
              r =
                null === (e = F.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.baseData,
              o =
                (null == r ? void 0 : r.salesrepCustomerOrders) &&
                null !==
                  (n =
                    null ===
                      (t = null == r ? void 0 : r.salesrepCustomerOrders[0]) ||
                    void 0 === t
                      ? void 0
                      : t.Month) &&
                void 0 !== n
                  ? n
                  : "-";
            se(
              "-" != o
                ? null == r
                  ? void 0
                  : r.SalesRepMonthlyCommission[o]
                : []
            );
          },
          Oe = function () {
            var e,
              t,
              n,
              r,
              o,
              a,
              i,
              s,
              l,
              u,
              p,
              m,
              h,
              f,
              g,
              v,
              _,
              y,
              C,
              x,
              S,
              k,
              P,
              O,
              T,
              M,
              j,
              D,
              A,
              R,
              L,
              z,
              Z,
              V,
              W,
              $,
              K,
              G,
              q,
              Q,
              J,
              X,
              ee,
              ne,
              re,
              oe,
              ae,
              ie,
              se,
              le,
              de,
              ce,
              ue,
              pe,
              me;
            if (
              d &&
              (null === (e = Object.keys(d)) || void 0 === e
                ? void 0
                : e.length) > 0 &&
              ((b =
                null === (t = F.getState().salesRepData) || void 0 === t
                  ? void 0
                  : t.baseData),
              te(
                (null == b ? void 0 : b.salesrepCustomerOrders) &&
                  null !==
                    (r =
                      null ===
                        (n =
                          null == b ? void 0 : b.salesrepCustomerOrders[0]) ||
                      void 0 === n
                        ? void 0
                        : n.Month) &&
                  void 0 !== r
                  ? r
                  : "-"
              ),
              U(b),
              b)
            ) {
              var he = [],
                fe = [],
                ge = [],
                ve = [],
                be = [],
                _e = [];
              if (
                ((null == b ? void 0 : b.SalesRepMonthlyCommission) &&
                  (null ===
                    (o = Object.entries(
                      null == b ? void 0 : b.SalesRepMonthlyCommission
                    )) ||
                    void 0 === o ||
                    o.forEach(function (e) {
                      var t,
                        n = e[0],
                        r = e[1];
                      he.push(n),
                        fe.push(n),
                        ge.push(n),
                        ve.push(
                          null ===
                            (t = null == r ? void 0 : r.TotalCommission) ||
                            void 0 === t
                            ? void 0
                            : t.toFixed(2)
                        ),
                        be.push(null == r ? void 0 : r.TotalNoOfOrders),
                        _e.push(null == r ? void 0 : r.TotalSale);
                    })),
                w({
                  commissionMonthLabels: he.reverse(),
                  commissionMonthPoints: ve.reverse(),
                }),
                I({
                  orderMonthLabels: fe.reverse(),
                  orderMonthPoints: be.reverse(),
                }),
                N({
                  salesMonthLabels: ge.reverse(),
                  salesMonthPoints:
                    null == _e
                      ? void 0
                      : _e
                          .map(function (e) {
                            return parseFloat(e.toFixed(2));
                          })
                          .reverse(),
                }),
                b &&
                  (null === (a = Object.keys(b)) || void 0 === a
                    ? void 0
                    : a.length) > 0)
              ) {
                var ye =
                    null !==
                      (s =
                        null ===
                          (i =
                            null == b ? void 0 : b.salesrepCustomerOrders[0]) ||
                        void 0 === i
                          ? void 0
                          : i.CustomerOrderCount) && void 0 !== s
                      ? s
                      : 0,
                  Ce =
                    null !==
                      (u =
                        null ===
                          (l =
                            null == b
                              ? void 0
                              : b.salesrepAffiliateOrders[0]) || void 0 === l
                          ? void 0
                          : l.AffiliateOrderCount) && void 0 !== u
                      ? u
                      : 0,
                  xe =
                    null !==
                      (m =
                        null ===
                          (p =
                            null == b
                              ? void 0
                              : b.TaggedCustomerOrdersDetails[0]) ||
                        void 0 === p
                          ? void 0
                          : p.TagCustomerOrderCount) && void 0 !== m
                      ? m
                      : 0,
                  Se =
                    null !==
                      (f =
                        null ===
                          (h =
                            null == b ? void 0 : b.salesrepCouponOrders[0]) ||
                        void 0 === h
                          ? void 0
                          : h.CouponCodeOrderCount) && void 0 !== f
                      ? f
                      : 0,
                  ke =
                    null !==
                      (v =
                        null ===
                          (g = null == b ? void 0 : b.salesrepSharedCart[0]) ||
                        void 0 === g
                          ? void 0
                          : g.OrderCount) && void 0 !== v
                      ? v
                      : 0,
                  Pe =
                    null !==
                      (y =
                        null ===
                          (_ =
                            null == b
                              ? void 0
                              : b.AdminTaggedOrdersDetails[0]) || void 0 === _
                          ? void 0
                          : _.TagOrderCount) && void 0 !== y
                      ? y
                      : 0,
                  we =
                    null !==
                      (x =
                        null ===
                          (C =
                            null == b
                              ? void 0
                              : b.TaggedCompanyLocationOrdersDetails[0]) ||
                        void 0 === C
                          ? void 0
                          : C.OrderCount) && void 0 !== x
                      ? x
                      : 0,
                  Oe = ye + Ce + xe + Se + ke + Pe,
                  Te = [ye, Ce, xe, Se, ke, Pe];
                (null == c ? void 0 : c.CreateB2BOrder) &&
                  ((Oe += we), Te.push(we)),
                  Y(function (e) {
                    return DO(DO({}, e), { orderFeatureLabels: Oe });
                  }),
                  E(Te);
                var Ie = parseFloat(
                    null !==
                      (P =
                        null ===
                          (k =
                            null ===
                              (S =
                                null == b
                                  ? void 0
                                  : b.salesrepCustomerOrders[0]) || void 0 === S
                              ? void 0
                              : S.CustomerOrderCommission) || void 0 === k
                          ? void 0
                          : k.toFixed(2)) && void 0 !== P
                      ? P
                      : 0
                  ),
                  Me = parseFloat(
                    null !==
                      (M =
                        null ===
                          (T =
                            null ===
                              (O =
                                null == b
                                  ? void 0
                                  : b.salesrepAffiliateOrders[0]) ||
                            void 0 === O
                              ? void 0
                              : O.AffiliateOrderCommission) || void 0 === T
                          ? void 0
                          : T.toFixed(2)) && void 0 !== M
                      ? M
                      : 0
                  ),
                  je = parseFloat(
                    null !==
                      (A =
                        null ===
                          (D =
                            null ===
                              (j =
                                null == b
                                  ? void 0
                                  : b.TaggedCustomerOrdersDetails[0]) ||
                            void 0 === j
                              ? void 0
                              : j.TagCustomerCommission) || void 0 === D
                          ? void 0
                          : D.toFixed(2)) && void 0 !== A
                      ? A
                      : 0
                  ),
                  Ne = parseFloat(
                    null !==
                      (z =
                        null ===
                          (L =
                            null ===
                              (R =
                                null == b
                                  ? void 0
                                  : b.salesrepCouponOrders[0]) || void 0 === R
                              ? void 0
                              : R.CouponCodeOrderCommission) || void 0 === L
                          ? void 0
                          : L.toFixed(2)) && void 0 !== z
                      ? z
                      : 0
                  ),
                  De = parseFloat(
                    null !==
                      (W =
                        null ===
                          (V =
                            null ===
                              (Z =
                                null == b ? void 0 : b.salesrepSharedCart[0]) ||
                            void 0 === Z
                              ? void 0
                              : Z.OrderCommission) || void 0 === V
                          ? void 0
                          : V.toFixed(2)) && void 0 !== W
                      ? W
                      : 0
                  ),
                  Ae = parseFloat(
                    null !==
                      (G =
                        null ===
                          (K =
                            null ===
                              ($ =
                                null == b
                                  ? void 0
                                  : b.AdminTaggedOrdersDetails[0]) ||
                            void 0 === $
                              ? void 0
                              : $.TagOrderCommission) || void 0 === K
                          ? void 0
                          : K.toFixed(2)) && void 0 !== G
                      ? G
                      : 0
                  ),
                  Ee = parseFloat(
                    null !==
                      (J =
                        null ===
                          (Q =
                            null ===
                              (q =
                                null == b
                                  ? void 0
                                  : b.TaggedCompanyLocationOrdersDetails[0]) ||
                            void 0 === q
                              ? void 0
                              : q.OrderCommission) || void 0 === Q
                          ? void 0
                          : Q.toFixed(2)) && void 0 !== J
                      ? J
                      : 0
                  ),
                  Re = Ie + Me + je + Ne + De + Ae,
                  Le = [Ie, Me, je, Ne, De, Ae];
                (null == c ? void 0 : c.CreateB2BOrder) &&
                  ((Re += Ee), Le.push(Ee)),
                  Y(function (e) {
                    return DO(DO({}, e), { commissionFeatureLabels: Re });
                  }),
                  B(Le);
                var Be =
                    null !==
                      (ee =
                        null ===
                          (X =
                            null == b ? void 0 : b.salesrepCustomerOrders[0]) ||
                        void 0 === X
                          ? void 0
                          : X.CustomerOrderSubtotal) && void 0 !== ee
                      ? ee
                      : 0,
                  ze =
                    null !==
                      (re =
                        null ===
                          (ne =
                            null == b
                              ? void 0
                              : b.salesrepAffiliateOrders[0]) || void 0 === ne
                          ? void 0
                          : ne.AffiliateOrderSubTotal) && void 0 !== re
                      ? re
                      : 0,
                  Fe =
                    null !==
                      (ae =
                        null ===
                          (oe =
                            null == b
                              ? void 0
                              : b.TaggedCustomerOrdersDetails[0]) ||
                        void 0 === oe
                          ? void 0
                          : oe.TagCustomerSubTotal) && void 0 !== ae
                      ? ae
                      : 0,
                  Ze =
                    null !==
                      (se =
                        null ===
                          (ie =
                            null == b ? void 0 : b.salesrepCouponOrders[0]) ||
                        void 0 === ie
                          ? void 0
                          : ie.CouponCodeOrderSubtotal) && void 0 !== se
                      ? se
                      : 0,
                  He =
                    null !==
                      (de =
                        null ===
                          (le = null == b ? void 0 : b.salesrepSharedCart[0]) ||
                        void 0 === le
                          ? void 0
                          : le.OrderSubTotal) && void 0 !== de
                      ? de
                      : 0,
                  Ve =
                    null !==
                      (ue =
                        null ===
                          (ce =
                            null == b
                              ? void 0
                              : b.AdminTaggedOrdersDetails[0]) || void 0 === ce
                          ? void 0
                          : ce.TagOrderSubTotal) && void 0 !== ue
                      ? ue
                      : 0,
                  We =
                    null !==
                      (me =
                        null ===
                          (pe =
                            null == b
                              ? void 0
                              : b.TaggedCompanyLocationOrdersDetails[0]) ||
                        void 0 === pe
                          ? void 0
                          : pe.OrderSubTotal) && void 0 !== me
                      ? me
                      : 0,
                  Ue = Be + ze + Fe + Ze + He + Ve,
                  $e = [Be, ze, Fe, Ze, He, Ve];
                (null == c ? void 0 : c.CreateB2BOrder) &&
                  ((Ue += We), $e.push(We)),
                  Y(function (e) {
                    return DO(DO({}, e), { salesFeatureLabels: Ue });
                  }),
                  H($e);
              }
            }
          },
          Te =
            null == L
              ? void 0
              : L.reduce(function (e, t) {
                  return e + (null != t ? t : 0);
                }, 0),
          Ie =
            null == j
              ? void 0
              : j.salesMonthPoints.reduce(function (e, t) {
                  return e + (null != t ? t : 0);
                }, 0),
          Me =
            Ie /
              (null == T
                ? void 0
                : T.orderMonthPoints.reduce(function (e, t) {
                    return e + (null != t ? t : 0);
                  }, 0)) || 0;
        return {
          callDefaultFunctions: function () {
            return (
              (e = l),
              (t = void 0),
              (r = function () {
                var e;
                return (function (e, t) {
                  var n,
                    r,
                    o,
                    a,
                    i = {
                      label: 0,
                      sent: function () {
                        if (1 & o[0]) throw o[1];
                        return o[1];
                      },
                      trys: [],
                      ops: [],
                    };
                  return (
                    (a = { next: s(0), throw: s(1), return: s(2) }),
                    "function" == typeof Symbol &&
                      (a[Symbol.iterator] = function () {
                        return this;
                      }),
                    a
                  );
                  function s(s) {
                    return function (l) {
                      return (function (s) {
                        if (n)
                          throw new TypeError(
                            "Generator is already executing."
                          );
                        for (; a && ((a = 0), s[0] && (i = 0)), i; )
                          try {
                            if (
                              ((n = 1),
                              r &&
                                (o =
                                  2 & s[0]
                                    ? r.return
                                    : s[0]
                                    ? r.throw ||
                                      ((o = r.return) && o.call(r), 0)
                                    : r.next) &&
                                !(o = o.call(r, s[1])).done)
                            )
                              return o;
                            switch (
                              ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                            ) {
                              case 0:
                              case 1:
                                o = s;
                                break;
                              case 4:
                                return i.label++, { value: s[1], done: !1 };
                              case 5:
                                i.label++, (r = s[1]), (s = [0]);
                                continue;
                              case 7:
                                (s = i.ops.pop()), i.trys.pop();
                                continue;
                              default:
                                if (
                                  !(
                                    (o =
                                      (o = i.trys).length > 0 &&
                                      o[o.length - 1]) ||
                                    (6 !== s[0] && 2 !== s[0])
                                  )
                                ) {
                                  i = 0;
                                  continue;
                                }
                                if (
                                  3 === s[0] &&
                                  (!o || (s[1] > o[0] && s[1] < o[3]))
                                ) {
                                  i.label = s[1];
                                  break;
                                }
                                if (6 === s[0] && i.label < o[1]) {
                                  (i.label = o[1]), (o = s);
                                  break;
                                }
                                if (o && i.label < o[2]) {
                                  (i.label = o[2]), i.ops.push(s);
                                  break;
                                }
                                o[2] && i.ops.pop(), i.trys.pop();
                                continue;
                            }
                            s = t.call(e, i);
                          } catch (e) {
                            (s = [6, e]), (r = 0);
                          } finally {
                            n = o = 0;
                          }
                        if (5 & s[0]) throw s[1];
                        return { value: s[0] ? s[1] : void 0, done: !0 };
                      })([s, l]);
                    };
                  }
                })(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return 0 ===
                        (null === (e = Object.keys(d)) || void 0 === e
                          ? void 0
                          : e.length) || re
                        ? (Bh.next(!0), [4, u(eg())])
                        : [3, 5];
                    case 1:
                      return (
                        t.sent(),
                        we(),
                        Bh.next(!1),
                        (F.getState().salesRepData.baseData.select
                          ? F.getState().salesRepData.baseData.select
                          : {}
                        ).PriceList
                          ? [4, u(Sg())]
                          : [3, 3]
                      );
                    case 2:
                      t.sent(), (t.label = 3);
                    case 3:
                      return [4, u(tg())];
                    case 4:
                      t.sent(), (t.label = 5);
                    case 5:
                      return [2];
                  }
                });
              }),
              new ((n = void 0) || (n = Promise))(function (o, a) {
                function i(e) {
                  try {
                    l(r.next(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function s(e) {
                  try {
                    l(r.throw(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function l(e) {
                  var t;
                  e.done
                    ? o(e.value)
                    : ((t = e.value),
                      t instanceof n
                        ? t
                        : new n(function (e) {
                            e(t);
                          })).then(i, s);
                }
                l((r = r.apply(e, t || [])).next());
              })
            );
            var e, t, n, r;
          },
          currentMonth: X,
          dataLine: ge,
          optionsLine: ve,
          sixMonthsBar: ye,
          optionSixMonthsBar: Ce,
          commissionMonthBar: be,
          optionsCommissionMonthBar: _e,
          ordersFeatureBar: xe,
          optionsOrdersFeatureBar: Se,
          commisionFeaturePie: ke,
          optionsCommisionFeaturePie: Pe,
          salesRepData: W,
          openCommissionDialog: K,
          setOpenCommissionDialog: G,
          getCommissionStructure: function (t, n, r) {
            var o =
              t && (null == t ? void 0 : t.length) > 0
                ? null == t
                  ? void 0
                  : t.map(function (t, o) {
                      var a, i;
                      return (
                        void 0 === o && (o = 0),
                        (0, e.jsx)(Dp, {
                          children: (0, e.jsxs)(
                            Cp,
                            {
                              children: [
                                (0, e.jsx)(Op, { children: t[n] }),
                                (0, e.jsx)(
                                  Op,
                                  DO(
                                    {
                                      align: "center",
                                      className: "ST_White_Space",
                                    },
                                    {
                                      children:
                                        "FixedDollarAmount" === he
                                          ? m +
                                            (null === (a = t[r]) || void 0 === a
                                              ? void 0
                                              : a.toFixed(2))
                                          : (null === (i = t[r]) || void 0 === i
                                              ? void 0
                                              : i.toFixed(2)) + "%",
                                    }
                                  )
                                ),
                              ],
                            },
                            o
                          ),
                        })
                      );
                    })
                : (0, e.jsx)(Dp, {
                    children: (0, e.jsx)(Cp, {
                      children: (0, e.jsx)(
                        Op,
                        DO(
                          { colSpan: 2 },
                          {
                            children: p(
                              "Graph_SalesRepCommission_nocommissiontitle"
                            ),
                          }
                        )
                      ),
                    }),
                  });
            return o;
          },
          loggedInRepData: v,
          getTimeZone: function () {
            var e = new Date().getHours();
            return p(
              e < 12
                ? "dashboard_morningMsg"
                : e < 18
                ? "dashboard_afternoonMsg"
                : "dashboard_eveningMsg"
            );
          },
          showNoDataMessage: function (t) {
            var n,
              r = [];
            switch (t) {
              case 1:
                r = A;
                break;
              case 2:
                r = L;
                break;
              case 3:
                r = T.orderMonthPoints;
                break;
              case 4:
                r = P.commissionMonthPoints;
                break;
              case 5:
                r = j.salesMonthPoints;
                break;
              case 6:
                r = Z;
            }
            return (0, e.jsx)(
              ni,
              DO(
                {
                  variant: "body2",
                  className: "ST_DB_No_Data",
                  hidden:
                    ((n = r),
                    0 !== (null == n ? void 0 : n.length) &&
                      0 !=
                        n.reduce(function (e, t) {
                          return parseFloat(e) + parseFloat(t);
                        }, 0)),
                },
                { children: p("dashboard_no_data") }
              )
            );
          },
          t: p,
          shopCurrency: m,
          currentMonthCommissionDetails: ie,
          totalCommissionPie: Te,
          totalRevenue: Ie,
          avgTicketSize: Me,
          isDesktop: f,
          performanceDetailsPopup: de,
          setPerformanceDetailsPopup: ce,
          handlePerformanceDetailsPopup: function () {
            ce(!de);
          },
          salesRepMonthlyPerformance: pe,
          performance_Details_Headers: S,
          selectFeatures: c,
          ShopBusinessName: _,
          currency: h,
        };
      }
      function RO() {
        var e = wv("(min-width: 1360px)");
        return {
          ST_DB_Min_Cards: {
            p: "0px !important",
            height: "140px",
            boxShadow: "none",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
          ST_DB_Graph_Cards: {
            backgroundColor: "white",
            p: 2,
            borderRadius: "5px",
            position: "relative",
            border: "1px solid #B6DAF3",
          },
          ST_DB_Horizontal_Line: {
            flexGrow: 1,
            background: "#DBDEE0",
            height: "auto !important",
          },
          ST_DB_Information_Box: {
            backgroundColor: "#EBF9FC",
            alignItems: "center",
            borderRadius: "5px",
            border: "1px solid #98C6CD",
          },
          ST_DB_Min_Cards_Graph: {
            mb: 2,
            p: "0px !important",
            height: "150px",
            boxShadow: "none",
          },
          ST_DB_Graph_CardTotal: {
            fontSize: 18,
            fontWeight: "bold",
            marginLeft: "0.6rem",
          },
          ST_DB_cardText_Font: {
            fontSize: 16,
            fontWeight: "bold",
            alignItems: "center",
          },
          ST_DB_Graph_catrdTotal_Text: {
            color: "#ffffff",
            display: "inline-flex",
            justifyContent: "center",
            alignItems: "center",
            width: "14rem",
            height: "3rem",
            fontSize: "2rem",
          },
          ST_DB_HowItWorksButton: {
            border: " 1px solid #C9CCCF",
            height: "33px",
            padding: "5px",
            borderRadius: "5px ",
            backgroundColor: "#FFFFFF",
            alignItems: "center",
            display: "flex",
            marginLeft: e ? "0px" : "auto",
            fontSize: "14px",
            marginTop: e ? "0px" : "15px",
          },
          ST_CI_VirticalLine: {
            borderRight: "1px solid #98C6CD",
            height: "100%",
          },
          ST_CI_VirticalLineGrid: {
            display: "flex",
            alignItems: "center",
            marginRight: "1rem",
          },
        };
      }
      iS.font.size = 12;
      const LO = "label";
      function BO(e, t) {
        "function" == typeof e ? e(t) : e && (e.current = t);
      }
      function zO(e, t) {
        e.labels = t;
      }
      function FO(e, t) {
        let n =
          arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : LO;
        const r = [];
        e.datasets = t.map((t) => {
          const o = e.datasets.find((e) => e[n] === t[n]);
          return o && t.data && !r.includes(o)
            ? (r.push(o), Object.assign(o, t), o)
            : { ...t };
        });
      }
      function ZO(e) {
        let t =
          arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : LO;
        const n = { labels: [], datasets: [] };
        return zO(n, e.labels), FO(n, e.datasets, t), n;
      }
      function HO(e, n) {
        let {
          height: r = 150,
          width: o = 300,
          redraw: a = !1,
          datasetIdKey: i,
          type: s,
          data: l,
          options: d,
          plugins: c = [],
          fallbackContent: u,
          updateMode: p,
          ...m
        } = e;
        const h = (0, t.useRef)(null),
          f = (0, t.useRef)(),
          g = () => {
            h.current &&
              ((f.current = new Sw(h.current, {
                type: s,
                data: ZO(l, i),
                options: d && { ...d },
                plugins: c,
              })),
              BO(n, f.current));
          },
          v = () => {
            BO(n, null), f.current && (f.current.destroy(), (f.current = null));
          };
        return (
          (0, t.useEffect)(() => {
            var e, t;
            !a &&
              f.current &&
              d &&
              ((e = f.current), (t = d), Object.assign(e.options, t));
          }, [a, d]),
          (0, t.useEffect)(() => {
            !a && f.current && zO(f.current.config.data, l.labels);
          }, [a, l.labels]),
          (0, t.useEffect)(() => {
            !a &&
              f.current &&
              l.datasets &&
              FO(f.current.config.data, l.datasets, i);
          }, [a, l.datasets]),
          (0, t.useEffect)(() => {
            f.current && (a ? (v(), setTimeout(g)) : f.current.update(p));
          }, [a, d, l.labels, l.datasets, p]),
          (0, t.useEffect)(() => {
            f.current && (v(), setTimeout(g));
          }, [s]),
          (0, t.useEffect)(() => (g(), () => v()), []),
          t.createElement(
            "canvas",
            Object.assign({ ref: h, role: "img", height: r, width: o }, m),
            u
          )
        );
      }
      const VO = (0, t.forwardRef)(HO);
      function WO(e, n) {
        return (
          Sw.register(n),
          (0, t.forwardRef)((n, r) =>
            t.createElement(VO, Object.assign({}, n, { ref: r, type: e }))
          )
        );
      }
      const UO = WO("line", Jk),
        $O = WO("bar", qk),
        KO = WO("pie", eP);
      var GO = (function () {
          if ("undefined" != typeof window) {
            if (window.devicePixelRatio) return window.devicePixelRatio;
            var e = window.screen;
            if (e) return (e.deviceXDPI || 1) / (e.logicalXDPI || 1);
          }
          return 1;
        })(),
        qO = function (e, t, n) {
          var r,
            o = [].concat(t),
            a = o.length,
            i = e.font,
            s = 0;
          for (e.font = n.string, r = 0; r < a; ++r)
            s = Math.max(e.measureText(o[r]).width, s);
          return (e.font = i), { height: a * n.lineHeight, width: s };
        };
      function QO(e, t) {
        var n = t.x,
          r = t.y;
        if (null === n) return { x: 0, y: -1 };
        if (null === r) return { x: 1, y: 0 };
        var o = e.x - n,
          a = e.y - r,
          i = Math.sqrt(o * o + a * a);
        return { x: i ? o / i : 0, y: i ? a / i : -1 };
      }
      var YO = 0,
        JO = 1,
        XO = 2,
        eT = 4,
        tT = 8;
      function nT(e, t, n) {
        var r = YO;
        return (
          e < n.left ? (r |= JO) : e > n.right && (r |= XO),
          t < n.top ? (r |= tT) : t > n.bottom && (r |= eT),
          r
        );
      }
      function rT(e, t) {
        var n,
          r,
          o = t.anchor,
          a = e;
        return (
          t.clamp &&
            (a = (function (e, t) {
              for (
                var n,
                  r,
                  o,
                  a = e.x0,
                  i = e.y0,
                  s = e.x1,
                  l = e.y1,
                  d = nT(a, i, t),
                  c = nT(s, l, t);
                d | c && !(d & c);

              )
                (n = d || c) & tT
                  ? ((r = a + ((s - a) * (t.top - i)) / (l - i)), (o = t.top))
                  : n & eT
                  ? ((r = a + ((s - a) * (t.bottom - i)) / (l - i)),
                    (o = t.bottom))
                  : n & XO
                  ? ((o = i + ((l - i) * (t.right - a)) / (s - a)),
                    (r = t.right))
                  : n & JO &&
                    ((o = i + ((l - i) * (t.left - a)) / (s - a)),
                    (r = t.left)),
                  n === d
                    ? (d = nT((a = r), (i = o), t))
                    : (c = nT((s = r), (l = o), t));
              return { x0: a, x1: s, y0: i, y1: l };
            })(a, t.area)),
          "start" === o
            ? ((n = a.x0), (r = a.y0))
            : "end" === o
            ? ((n = a.x1), (r = a.y1))
            : ((n = (a.x0 + a.x1) / 2), (r = (a.y0 + a.y1) / 2)),
          (function (e, t, n, r, o) {
            switch (o) {
              case "center":
                n = r = 0;
                break;
              case "bottom":
                (n = 0), (r = 1);
                break;
              case "right":
                (n = 1), (r = 0);
                break;
              case "left":
                (n = -1), (r = 0);
                break;
              case "top":
                (n = 0), (r = -1);
                break;
              case "start":
                (n = -n), (r = -r);
                break;
              case "end":
                break;
              default:
                (o *= Math.PI / 180), (n = Math.cos(o)), (r = Math.sin(o));
            }
            return { x: e, y: t, vx: n, vy: r };
          })(n, r, e.vx, e.vy, t.align)
        );
      }
      var oT = function (e, t) {
          var n = (e.startAngle + e.endAngle) / 2,
            r = Math.cos(n),
            o = Math.sin(n),
            a = e.innerRadius,
            i = e.outerRadius;
          return rT(
            {
              x0: e.x + r * a,
              y0: e.y + o * a,
              x1: e.x + r * i,
              y1: e.y + o * i,
              vx: r,
              vy: o,
            },
            t
          );
        },
        aT = function (e, t) {
          var n = QO(e, t.origin),
            r = n.x * e.options.radius,
            o = n.y * e.options.radius;
          return rT(
            {
              x0: e.x - r,
              y0: e.y - o,
              x1: e.x + r,
              y1: e.y + o,
              vx: n.x,
              vy: n.y,
            },
            t
          );
        },
        iT = function (e, t) {
          var n = QO(e, t.origin),
            r = e.x,
            o = e.y,
            a = 0,
            i = 0;
          return (
            e.horizontal
              ? ((r = Math.min(e.x, e.base)), (a = Math.abs(e.base - e.x)))
              : ((o = Math.min(e.y, e.base)), (i = Math.abs(e.base - e.y))),
            rT({ x0: r, y0: o + i, x1: r + a, y1: o, vx: n.x, vy: n.y }, t)
          );
        },
        sT = function (e, t) {
          var n = QO(e, t.origin);
          return rT(
            {
              x0: e.x,
              y0: e.y,
              x1: e.x + (e.width || 0),
              y1: e.y + (e.height || 0),
              vx: n.x,
              vy: n.y,
            },
            t
          );
        },
        lT = function (e) {
          return Math.round(e * GO) / GO;
        };
      function dT(e, t) {
        var n = t.chart.getDatasetMeta(t.datasetIndex).vScale;
        if (!n) return null;
        if (void 0 !== n.xCenter && void 0 !== n.yCenter)
          return { x: n.xCenter, y: n.yCenter };
        var r = n.getBasePixel();
        return e.horizontal ? { x: r, y: null } : { x: null, y: r };
      }
      function cT(e, t, n) {
        var r = e.shadowBlur,
          o = n.stroked,
          a = lT(n.x),
          i = lT(n.y),
          s = lT(n.w);
        o && e.strokeText(t, a, i, s),
          n.filled &&
            (r && o && (e.shadowBlur = 0),
            e.fillText(t, a, i, s),
            r && o && (e.shadowBlur = r));
      }
      var uT = function (e, t, n, r) {
        var o = this;
        (o._config = e),
          (o._index = r),
          (o._model = null),
          (o._rects = null),
          (o._ctx = t),
          (o._el = n);
      };
      OC(uT.prototype, {
        _modelize: function (e, t, n, r) {
          var o,
            a = this,
            i = a._index,
            s = IS(MS([n.font, {}], r, i)),
            l = MS([n.color, iS.color], r, i);
          return {
            align: MS([n.align, "center"], r, i),
            anchor: MS([n.anchor, "center"], r, i),
            area: r.chart.chartArea,
            backgroundColor: MS([n.backgroundColor, null], r, i),
            borderColor: MS([n.borderColor, null], r, i),
            borderRadius: MS([n.borderRadius, 0], r, i),
            borderWidth: MS([n.borderWidth, 0], r, i),
            clamp: MS([n.clamp, !1], r, i),
            clip: MS([n.clip, !1], r, i),
            color: l,
            display: e,
            font: s,
            lines: t,
            offset: MS([n.offset, 4], r, i),
            opacity: MS([n.opacity, 1], r, i),
            origin: dT(a._el, r),
            padding: TS(MS([n.padding, 4], r, i)),
            positioner:
              ((o = a._el),
              o instanceof Iw
                ? oT
                : o instanceof zw
                ? aT
                : o instanceof Uw
                ? iT
                : sT),
            rotation: MS([n.rotation, 0], r, i) * (Math.PI / 180),
            size: qO(a._ctx, t, s),
            textAlign: MS([n.textAlign, "start"], r, i),
            textShadowBlur: MS([n.textShadowBlur, 0], r, i),
            textShadowColor: MS([n.textShadowColor, l], r, i),
            textStrokeColor: MS([n.textStrokeColor, l], r, i),
            textStrokeWidth: MS([n.textStrokeWidth, 0], r, i),
          };
        },
        update: function (e) {
          var t,
            n,
            r,
            o = this,
            a = null,
            i = null,
            s = o._index,
            l = o._config,
            d = MS([l.display, !0], e, s);
          d &&
            ((t = e.dataset.data[s]),
            (r = hC((n = _C(CC(l.formatter, [t, e]), t)))
              ? []
              : (function (e) {
                  var t,
                    n = [];
                  for (e = [].concat(e); e.length; )
                    "string" == typeof (t = e.pop())
                      ? n.unshift.apply(n, t.split("\n"))
                      : Array.isArray(t)
                      ? e.push.apply(e, t)
                      : hC(e) || n.unshift("" + t);
                  return n;
                })(n)).length &&
              (i = (function (e) {
                var t = e.borderWidth || 0,
                  n = e.padding,
                  r = e.size.height,
                  o = e.size.width,
                  a = -o / 2,
                  i = -r / 2;
                return {
                  frame: {
                    x: a - n.left - t,
                    y: i - n.top - t,
                    w: o + n.width + 2 * t,
                    h: r + n.height + 2 * t,
                  },
                  text: { x: a, y: i, w: o, h: r },
                };
              })((a = o._modelize(d, r, l, e))))),
            (o._model = a),
            (o._rects = i);
        },
        geometry: function () {
          return this._rects ? this._rects.frame : {};
        },
        rotation: function () {
          return this._model ? this._model.rotation : 0;
        },
        visible: function () {
          return this._model && this._model.opacity;
        },
        model: function () {
          return this._model;
        },
        draw: function (e, t) {
          var n,
            r,
            o,
            a,
            i = e.ctx,
            s = this._model,
            l = this._rects;
          this.visible() &&
            (i.save(),
            s.clip &&
              ((n = s.area),
              i.beginPath(),
              i.rect(n.left, n.top, n.right - n.left, n.bottom - n.top),
              i.clip()),
            (i.globalAlpha =
              ((r = 0), (o = s.opacity), (a = 1), Math.max(r, Math.min(o, a)))),
            i.translate(lT(t.x), lT(t.y)),
            i.rotate(s.rotation),
            (function (e, t, n) {
              var r = n.backgroundColor,
                o = n.borderColor,
                a = n.borderWidth;
              (r || (o && a)) &&
                (e.beginPath(),
                (function (e, t, n, r, o, a) {
                  var i = Math.PI / 2;
                  if (a) {
                    var s = Math.min(a, o / 2, r / 2),
                      l = t + s,
                      d = n + s,
                      c = t + r - s,
                      u = n + o - s;
                    e.moveTo(t, d),
                      l < c && d < u
                        ? (e.arc(l, d, s, -Math.PI, -i),
                          e.arc(c, d, s, -i, 0),
                          e.arc(c, u, s, 0, i),
                          e.arc(l, u, s, i, Math.PI))
                        : l < c
                        ? (e.moveTo(l, n),
                          e.arc(c, d, s, -i, i),
                          e.arc(l, d, s, i, Math.PI + i))
                        : d < u
                        ? (e.arc(l, d, s, -Math.PI, 0),
                          e.arc(l, u, s, 0, Math.PI))
                        : e.arc(l, d, s, -Math.PI, Math.PI),
                      e.closePath(),
                      e.moveTo(t, n);
                  } else e.rect(t, n, r, o);
                })(
                  e,
                  lT(t.x) + a / 2,
                  lT(t.y) + a / 2,
                  lT(t.w) - a,
                  lT(t.h) - a,
                  n.borderRadius
                ),
                e.closePath(),
                r && ((e.fillStyle = r), e.fill()),
                o &&
                  a &&
                  ((e.strokeStyle = o),
                  (e.lineWidth = a),
                  (e.lineJoin = "miter"),
                  e.stroke()));
            })(i, l.frame, s),
            (function (e, t, n, r) {
              var o,
                a = r.textAlign,
                i = r.color,
                s = !!i,
                l = r.font,
                d = t.length,
                c = r.textStrokeColor,
                u = r.textStrokeWidth,
                p = c && u;
              if (d && (s || p))
                for (
                  n = (function (e, t, n) {
                    var r = n.lineHeight,
                      o = e.w,
                      a = e.x;
                    return (
                      "center" === t
                        ? (a += o / 2)
                        : ("end" !== t && "right" !== t) || (a += o),
                      { h: r, w: o, x: a, y: e.y + r / 2 }
                    );
                  })(n, a, l),
                    e.font = l.string,
                    e.textAlign = a,
                    e.textBaseline = "middle",
                    e.shadowBlur = r.textShadowBlur,
                    e.shadowColor = r.textShadowColor,
                    s && (e.fillStyle = i),
                    p &&
                      ((e.lineJoin = "round"),
                      (e.lineWidth = u),
                      (e.strokeStyle = c)),
                    o = 0,
                    d = t.length;
                  o < d;
                  ++o
                )
                  cT(e, t[o], {
                    stroked: p,
                    filled: s,
                    w: n.w,
                    x: n.x,
                    y: n.y + n.h * o,
                  });
            })(i, s.lines, l.text, s),
            i.restore());
        },
      });
      var pT = Number.MIN_SAFE_INTEGER || -9007199254740991,
        mT = Number.MAX_SAFE_INTEGER || 9007199254740991;
      function hT(e, t, n) {
        var r = Math.cos(n),
          o = Math.sin(n),
          a = t.x,
          i = t.y;
        return {
          x: a + r * (e.x - a) - o * (e.y - i),
          y: i + o * (e.x - a) + r * (e.y - i),
        };
      }
      function fT(e, t) {
        var n,
          r,
          o,
          a,
          i,
          s = mT,
          l = pT,
          d = t.origin;
        for (n = 0; n < e.length; ++n)
          (o = (r = e[n]).x - d.x),
            (a = r.y - d.y),
            (i = t.vx * o + t.vy * a),
            (s = Math.min(s, i)),
            (l = Math.max(l, i));
        return { min: s, max: l };
      }
      function gT(e, t) {
        var n = t.x - e.x,
          r = t.y - e.y,
          o = Math.sqrt(n * n + r * r);
        return { vx: (t.x - e.x) / o, vy: (t.y - e.y) / o, origin: e, ln: o };
      }
      var vT = function () {
        (this._rotation = 0), (this._rect = { x: 0, y: 0, w: 0, h: 0 });
      };
      function bT(e, t, n) {
        var r = t.positioner(e, t),
          o = r.vx,
          a = r.vy;
        if (!o && !a) return { x: r.x, y: r.y };
        var i = n.w,
          s = n.h,
          l = t.rotation,
          d = Math.abs((i / 2) * Math.cos(l)) + Math.abs((s / 2) * Math.sin(l)),
          c = Math.abs((i / 2) * Math.sin(l)) + Math.abs((s / 2) * Math.cos(l)),
          u = 1 / Math.max(Math.abs(o), Math.abs(a));
        return (
          (d *= o * u),
          (c *= a * u),
          (d += t.offset * o),
          (c += t.offset * a),
          { x: r.x + d, y: r.y + c }
        );
      }
      OC(vT.prototype, {
        center: function () {
          var e = this._rect;
          return { x: e.x + e.w / 2, y: e.y + e.h / 2 };
        },
        update: function (e, t, n) {
          (this._rotation = n),
            (this._rect = { x: t.x + e.x, y: t.y + e.y, w: t.w, h: t.h });
        },
        contains: function (e) {
          var t = this,
            n = t._rect;
          return !(
            (e = hT(e, t.center(), -t._rotation)).x < n.x - 1 ||
            e.y < n.y - 1 ||
            e.x > n.x + n.w + 2 ||
            e.y > n.y + n.h + 2
          );
        },
        intersects: function (e) {
          var t,
            n,
            r,
            o = this._points(),
            a = e._points(),
            i = [gT(o[0], o[1]), gT(o[0], o[3])];
          for (
            this._rotation !== e._rotation &&
              i.push(gT(a[0], a[1]), gT(a[0], a[3])),
              t = 0;
            t < i.length;
            ++t
          )
            if (
              ((n = fT(o, i[t])),
              (r = fT(a, i[t])),
              n.max < r.min || r.max < n.min)
            )
              return !1;
          return !0;
        },
        _points: function () {
          var e = this,
            t = e._rect,
            n = e._rotation,
            r = e.center();
          return [
            hT({ x: t.x, y: t.y }, r, n),
            hT({ x: t.x + t.w, y: t.y }, r, n),
            hT({ x: t.x + t.w, y: t.y + t.h }, r, n),
            hT({ x: t.x, y: t.y + t.h }, r, n),
          ];
        },
      });
      var _T = {
          prepare: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i = [];
            for (t = 0, r = e.length; t < r; ++t)
              for (n = 0, o = e[t].length; n < o; ++n)
                (a = e[t][n]),
                  i.push(a),
                  (a.$layout = {
                    _box: new vT(),
                    _hidable: !1,
                    _visible: !0,
                    _set: t,
                    _idx: a._index,
                  });
            return (
              i.sort(function (e, t) {
                var n = e.$layout,
                  r = t.$layout;
                return n._idx === r._idx ? r._set - n._set : r._idx - n._idx;
              }),
              this.update(i),
              i
            );
          },
          update: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i = !1;
            for (t = 0, n = e.length; t < n; ++t)
              (o = (r = e[t]).model()),
                ((a = r.$layout)._hidable = o && "auto" === o.display),
                (a._visible = r.visible()),
                (i |= a._hidable);
            i &&
              (function (e) {
                var t, n, r, o, a, i, s;
                for (t = 0, n = e.length; t < n; ++t)
                  (o = (r = e[t]).$layout)._visible &&
                    ((s = new Proxy(r._el, {
                      get: (e, t) => e.getProps([t], !0)[t],
                    })),
                    (a = r.geometry()),
                    (i = bT(s, r.model(), a)),
                    o._box.update(i, a, r.rotation()));
                !(function (e, t) {
                  var n, r, o, a;
                  for (n = e.length - 1; n >= 0; --n)
                    for (o = e[n].$layout, r = n - 1; r >= 0 && o._visible; --r)
                      (a = e[r].$layout)._visible &&
                        o._box.intersects(a._box) &&
                        t(o, a);
                })(e, function (e, t) {
                  var n = e._hidable,
                    r = t._hidable;
                  (n && r) || r ? (t._visible = !1) : n && (e._visible = !1);
                });
              })(e);
          },
          lookup: function (e, t) {
            var n, r;
            for (n = e.length - 1; n >= 0; --n)
              if ((r = e[n].$layout) && r._visible && r._box.contains(t))
                return e[n];
            return null;
          },
          draw: function (e, t) {
            var n, r, o, a, i, s;
            for (n = 0, r = t.length; n < r; ++n)
              (a = (o = t[n]).$layout)._visible &&
                ((i = o.geometry()),
                (s = bT(o._el, o.model(), i)),
                a._box.update(s, i, o.rotation()),
                o.draw(e, s));
          },
        },
        yT = "$datalabels",
        CT = "$default";
      function xT(e, t, n, r) {
        if (t) {
          var o,
            a = n.$context,
            i = n.$groups;
          t[i._set] &&
            (o = t[i._set][i._key]) &&
            !0 === CC(o, [a, r]) &&
            ((e[yT]._dirty = !0), n.update(a));
        }
      }
      var ST = {
          id: "datalabels",
          defaults: {
            align: "center",
            anchor: "center",
            backgroundColor: null,
            borderColor: null,
            borderRadius: 0,
            borderWidth: 0,
            clamp: !1,
            clip: !1,
            color: void 0,
            display: !0,
            font: {
              family: void 0,
              lineHeight: 1.2,
              size: void 0,
              style: void 0,
              weight: null,
            },
            formatter: function (e) {
              if (hC(e)) return null;
              var t,
                n,
                r,
                o = e;
              if (gC(e))
                if (hC(e.label))
                  if (hC(e.r))
                    for (
                      o = "", r = 0, n = (t = Object.keys(e)).length;
                      r < n;
                      ++r
                    )
                      o += (0 !== r ? ", " : "") + t[r] + ": " + e[t[r]];
                  else o = e.r;
                else o = e.label;
              return "" + o;
            },
            labels: void 0,
            listeners: {},
            offset: 4,
            opacity: 1,
            padding: { top: 4, right: 4, bottom: 4, left: 4 },
            rotation: 0,
            textAlign: "start",
            textStrokeColor: void 0,
            textStrokeWidth: 0,
            textShadowBlur: 0,
            textShadowColor: void 0,
          },
          beforeInit: function (e) {
            e[yT] = { _actives: [] };
          },
          beforeUpdate: function (e) {
            var t = e[yT];
            (t._listened = !1),
              (t._listeners = {}),
              (t._datasets = []),
              (t._labels = []);
          },
          afterDatasetUpdate: function (e, t, n) {
            var r,
              o,
              a,
              i,
              s,
              l,
              d,
              c,
              u = t.index,
              p = e[yT],
              m = (p._datasets[u] = []),
              h = e.isDatasetVisible(u),
              f = e.data.datasets[u],
              g = (function (e, t) {
                var n,
                  r,
                  o,
                  a = e.datalabels,
                  i = [];
                return !1 === a
                  ? null
                  : (!0 === a && (a = {}),
                    (t = OC({}, [t, a])),
                    (r = t.labels || {}),
                    (o = Object.keys(r)),
                    delete t.labels,
                    o.length
                      ? o.forEach(function (e) {
                          r[e] && i.push(OC({}, [t, r[e], { _key: e }]));
                        })
                      : i.push(t),
                    (n = i.reduce(function (e, t) {
                      return (
                        xC(t.listeners || {}, function (n, r) {
                          (e[r] = e[r] || {}), (e[r][t._key || CT] = n);
                        }),
                        delete t.listeners,
                        e
                      );
                    }, {})),
                    { labels: i, listeners: n });
              })(f, n),
              v = t.meta.data || [],
              b = e.ctx;
            for (b.save(), r = 0, a = v.length; r < a; ++r)
              if (
                (((d = v[r])[yT] = []),
                h && d && e.getDataVisibility(r) && !d.skip)
              )
                for (o = 0, i = g.labels.length; o < i; ++o)
                  (l = (s = g.labels[o])._key),
                    ((c = new uT(s, b, d, r)).$groups = {
                      _set: u,
                      _key: l || CT,
                    }),
                    (c.$context = {
                      active: !1,
                      chart: e,
                      dataIndex: r,
                      dataset: f,
                      datasetIndex: u,
                    }),
                    c.update(c.$context),
                    d[yT].push(c),
                    m.push(c);
            b.restore(),
              OC(p._listeners, g.listeners, {
                merger: function (e, n, r) {
                  (n[e] = n[e] || {}),
                    (n[e][t.index] = r[e]),
                    (p._listened = !0);
                },
              });
          },
          afterUpdate: function (e) {
            e[yT]._labels = _T.prepare(e[yT]._datasets);
          },
          afterDatasetsDraw: function (e) {
            _T.draw(e, e[yT]._labels);
          },
          beforeEvent: function (e, t) {
            if (e[yT]._listened) {
              var n = t.event;
              switch (n.type) {
                case "mousemove":
                case "mouseout":
                  !(function (e, t) {
                    var n,
                      r,
                      o = e[yT],
                      a = o._listeners;
                    if (a.enter || a.leave) {
                      if ("mousemove" === t.type) r = _T.lookup(o._labels, t);
                      else if ("mouseout" !== t.type) return;
                      (n = o._hovered),
                        (o._hovered = r),
                        (function (e, t, n, r, o) {
                          var a, i;
                          (n || r) &&
                            (n
                              ? r
                                ? n !== r && (i = a = !0)
                                : (i = !0)
                              : (a = !0),
                            i && xT(e, t.leave, n, o),
                            a && xT(e, t.enter, r, o));
                        })(e, a, n, r, t);
                    }
                  })(e, n);
                  break;
                case "click":
                  !(function (e, t) {
                    var n = e[yT],
                      r = n._listeners.click,
                      o = r && _T.lookup(n._labels, t);
                    o && xT(e, r, o, t);
                  })(e, n);
              }
            }
          },
          afterEvent: function (e) {
            var t,
              n,
              r,
              o,
              a,
              i,
              s,
              l = e[yT],
              d = (function (e, t) {
                var n,
                  r,
                  o,
                  a,
                  i = e.slice(),
                  s = [];
                for (n = 0, o = t.length; n < o; ++n)
                  (a = t[n]),
                    -1 === (r = i.indexOf(a)) ? s.push([a, 1]) : i.splice(r, 1);
                for (n = 0, o = i.length; n < o; ++n) s.push([i[n], -1]);
                return s;
              })(l._actives, (l._actives = e.getActiveElements()));
            for (t = 0, n = d.length; t < n; ++t)
              if ((a = d[t])[1])
                for (r = 0, o = (s = a[0].element[yT] || []).length; r < o; ++r)
                  ((i = s[r]).$context.active = 1 === a[1]),
                    i.update(i.$context);
            (l._dirty || d.length) && (_T.update(l._labels), e.render()),
              delete l._dirty;
          },
        },
        kT = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-6h2zm0-8h-2V7h2z",
          }),
          "Info"
        ),
        PT = function () {
          return (
            (PT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            PT.apply(this, arguments)
          );
        },
        wT = function () {
          var n,
            r,
            o,
            a,
            i,
            s,
            l,
            d,
            c,
            u = RO(),
            p = u.ST_DB_Min_Cards,
            m = u.ST_DB_Graph_Cards,
            h = u.ST_DB_Horizontal_Line,
            f = u.ST_DB_Information_Box,
            g = u.ST_DB_Min_Cards_Graph,
            v = u.ST_DB_Graph_CardTotal,
            b = u.ST_DB_cardText_Font,
            _ = u.ST_DB_Graph_catrdTotal_Text,
            y = u.ST_CI_VirticalLine,
            C = u.ST_CI_VirticalLineGrid,
            x = EO(),
            S = x.callDefaultFunctions,
            k = x.currentMonth,
            P = x.dataLine,
            w = x.optionsLine,
            O = x.sixMonthsBar,
            T = x.optionSixMonthsBar,
            I = x.commissionMonthBar,
            M = x.optionsCommissionMonthBar,
            j = x.ordersFeatureBar,
            N = x.optionsOrdersFeatureBar,
            D = x.commisionFeaturePie,
            A = x.optionsCommisionFeaturePie,
            E = x.salesRepData,
            R = x.openCommissionDialog,
            L = x.setOpenCommissionDialog,
            B = x.getCommissionStructure,
            z = x.getTimeZone,
            F = x.showNoDataMessage,
            Z = x.t,
            H = x.shopCurrency,
            V = x.currentMonthCommissionDetails,
            W = x.totalCommissionPie,
            U = x.totalRevenue,
            $ = x.avgTicketSize,
            K = x.isDesktop,
            G = x.performanceDetailsPopup,
            q = x.setPerformanceDetailsPopup,
            Q = x.handlePerformanceDetailsPopup,
            Y = x.salesRepMonthlyPerformance,
            J = x.performance_Details_Headers,
            X = x.selectFeatures,
            ee = x.ShopBusinessName,
            te = x.currency;
          Sw.register(Lw, zw, mO, Qw, cO, dO, Iw, Gw, Uw, ST);
          var ne =
            null === (n = null == E ? void 0 : E.CommissionDiscountOn) ||
            void 0 === n
              ? void 0
              : n.CommissionDiscountOn;
          (0, t.useEffect)(function () {
            S();
          }, []);
          var re = af(),
            oe = re.SalesRepName,
            ae = re.SalesRepLastName;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(
                uC,
                PT(
                  { className: "ST_Main_Card" },
                  {
                    children: [
                      (0, e.jsxs)(
                        qa,
                        PT(
                          {
                            container: !0,
                            spacing: 2,
                            mb: 1,
                            justifyContent: "space-between",
                            alignItems: "center",
                          },
                          {
                            children: [
                              K
                                ? null
                                : (0, e.jsx)(
                                    qa,
                                    PT(
                                      { item: !0, xs: 12, md: 12 },
                                      {
                                        children: (0, e.jsxs)(
                                          uC,
                                          PT(
                                            { sx: { textAlign: "center" } },
                                            {
                                              children: [
                                                z(),
                                                " ",
                                                oe,
                                                " ",
                                                ae,
                                                "!",
                                                ee
                                                  ? " "
                                                      .concat(
                                                        Z(
                                                          "dashboard_welcomeMsg"
                                                        ),
                                                        " "
                                                      )
                                                      .concat(ee)
                                                  : "",
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 6, md: 3 },
                                  {
                                    children: (0, e.jsxs)(
                                      ni,
                                      PT(
                                        {
                                          variant: K ? "body2" : "body1",
                                          sx: {
                                            fontWeight: "bold",
                                            fontSize: "1.1rem",
                                            mt: K ? 1 : 0,
                                            mb: K ? 0 : 1,
                                            textAlign: "left",
                                          },
                                        },
                                        {
                                          children: [
                                            Z("dashboard_subTitle1"),
                                            " : ",
                                            k,
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              K
                                ? null
                                : (0, e.jsxs)(e.Fragment, {
                                    children: [
                                      (0, e.jsx)(
                                        qa,
                                        PT(
                                          {
                                            item: !0,
                                            xs: 6,
                                            textAlign: "right",
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              rl,
                                              PT(
                                                {
                                                  className:
                                                    "ST_link_FontColor",
                                                  target: "_blank",
                                                  href: "https://youtu.be/-p3GxLRxpIU?si=V5srtDDLzzQRzhzd",
                                                  sx: { fontSize: "1rem" },
                                                },
                                                {
                                                  children:
                                                    Z("dashbord_Msg_New"),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        qa,
                                        PT(
                                          { item: !0, xs: 12 },
                                          {
                                            children: (0, e.jsx)(
                                              ni,
                                              PT(
                                                { sx: f },
                                                {
                                                  children: (0, e.jsx)(
                                                    qa,
                                                    PT(
                                                      {
                                                        container: !0,
                                                        style: PT(PT({}, Mo), {
                                                          margin: "0px",
                                                          flexDirection: K
                                                            ? "unset"
                                                            : "column",
                                                          paddingInlineStart: K
                                                            ? "1rem"
                                                            : "0.7rem",
                                                          lineHeight: K
                                                            ? "3rem"
                                                            : "1.5rem",
                                                        }),
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          qa,
                                                          PT(
                                                            {
                                                              container: !0,
                                                              style: PT(
                                                                PT({}, Mo),
                                                                {
                                                                  margin: "0px",
                                                                  flexDirection:
                                                                    K
                                                                      ? "unset"
                                                                      : "column",
                                                                  paddingInlineStart:
                                                                    K
                                                                      ? ""
                                                                      : "0px",
                                                                }
                                                              ),
                                                            },
                                                            {
                                                              children: [
                                                                (0, e.jsxs)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      style: PT(
                                                                        PT(
                                                                          {},
                                                                          Mo
                                                                        ),
                                                                        {
                                                                          fontSize:
                                                                            K
                                                                              ? "15px"
                                                                              : "14px",
                                                                          marginRight:
                                                                            "20px",
                                                                          marginTop:
                                                                            K
                                                                              ? "0rem"
                                                                              : "0.5rem",
                                                                        }
                                                                      ),
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            "span",
                                                                            PT(
                                                                              {
                                                                                className:
                                                                                  "ST_DB_InformationText",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    kT,
                                                                                    {
                                                                                      sx: {
                                                                                        color:
                                                                                          "rgb(0, 160, 172)",
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          " ",
                                                                          (0,
                                                                          e.jsx)(
                                                                            "span",
                                                                            PT(
                                                                              {
                                                                                style:
                                                                                  {
                                                                                    fontSize:
                                                                                      K
                                                                                        ? "15px"
                                                                                        : "14px",
                                                                                    marginTop:
                                                                                      "0.25rem",
                                                                                  },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    "dashbord_informationMsg"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                                K
                                                                  ? (0, e.jsx)(
                                                                      qa,
                                                                      PT(
                                                                        {
                                                                          item: !0,
                                                                          sx: C,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              qa,
                                                                              {
                                                                                sx: y,
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    )
                                                                  : "",
                                                                (0, e.jsx)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      component:
                                                                        "li",
                                                                      className:
                                                                        "ST_DB_DashboardMsg",
                                                                    },
                                                                    {
                                                                      children:
                                                                        Z(
                                                                          "dashboard_BannerMsg"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      component:
                                                                        "li",
                                                                      className:
                                                                        "ST_DB_DashboardMsg",
                                                                      sx: {
                                                                        marginBottom:
                                                                          K
                                                                            ? "0rem"
                                                                            : "0.6rem",
                                                                      },
                                                                    },
                                                                    {
                                                                      children:
                                                                        Z(
                                                                          "dashboard_Information_Message"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    ],
                                  }),
                              K
                                ? (0, e.jsxs)(e.Fragment, {
                                    children: [
                                      (0, e.jsx)(
                                        qa,
                                        PT(
                                          { item: !0, md: 7 },
                                          {
                                            children: (0, e.jsx)(
                                              ni,
                                              PT(
                                                { sx: f },
                                                {
                                                  children: (0, e.jsx)(
                                                    qa,
                                                    PT(
                                                      {
                                                        container: !0,
                                                        style: PT(PT({}, Mo), {
                                                          margin: "0px",
                                                          flexDirection: K
                                                            ? "unset"
                                                            : "column",
                                                          paddingInlineStart: K
                                                            ? "1rem"
                                                            : "0.7rem",
                                                          lineHeight: K
                                                            ? "2.3rem"
                                                            : "1.5rem",
                                                        }),
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          qa,
                                                          PT(
                                                            {
                                                              container: !0,
                                                              style: PT(
                                                                PT({}, Mo),
                                                                {
                                                                  margin: "0px",
                                                                  flexDirection:
                                                                    K
                                                                      ? "unset"
                                                                      : "column",
                                                                  paddingInlineStart:
                                                                    K
                                                                      ? ""
                                                                      : "0px",
                                                                }
                                                              ),
                                                            },
                                                            {
                                                              children: [
                                                                (0, e.jsxs)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      style: PT(
                                                                        PT(
                                                                          {},
                                                                          Mo
                                                                        ),
                                                                        {
                                                                          fontSize:
                                                                            K
                                                                              ? "15px"
                                                                              : "14px",
                                                                          marginRight:
                                                                            "20px",
                                                                          marginTop:
                                                                            K
                                                                              ? "0rem"
                                                                              : "0.5rem",
                                                                        }
                                                                      ),
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            "span",
                                                                            PT(
                                                                              {
                                                                                className:
                                                                                  "ST_DB_InformationText",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    kT,
                                                                                    {
                                                                                      sx: {
                                                                                        color:
                                                                                          "rgb(0, 160, 172)",
                                                                                      },
                                                                                    }
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                          " ",
                                                                          (0,
                                                                          e.jsx)(
                                                                            "span",
                                                                            PT(
                                                                              {
                                                                                style:
                                                                                  {
                                                                                    fontSize:
                                                                                      K
                                                                                        ? "15px"
                                                                                        : "14px",
                                                                                    marginTop:
                                                                                      "0.25rem",
                                                                                  },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    "dashbord_informationMsg"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                                K
                                                                  ? (0, e.jsx)(
                                                                      qa,
                                                                      PT(
                                                                        {
                                                                          item: !0,
                                                                          sx: C,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              qa,
                                                                              {
                                                                                sx: y,
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    )
                                                                  : "",
                                                                (0, e.jsx)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      component:
                                                                        "li",
                                                                      className:
                                                                        "ST_DB_DashboardMsg",
                                                                    },
                                                                    {
                                                                      children:
                                                                        Z(
                                                                          "dashboard_BannerMsg"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  qa,
                                                                  PT(
                                                                    {
                                                                      item: !0,
                                                                      component:
                                                                        "li",
                                                                      className:
                                                                        "ST_DB_DashboardMsg",
                                                                      sx: {
                                                                        marginBottom:
                                                                          K
                                                                            ? "0rem"
                                                                            : "0.6rem",
                                                                      },
                                                                    },
                                                                    {
                                                                      children:
                                                                        Z(
                                                                          "dashboard_Information_Message"
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        qa,
                                        PT(
                                          {
                                            item: !0,
                                            md: 2,
                                            sx: { textAlign: "end" },
                                          },
                                          {
                                            children: (0, e.jsx)(
                                              Qu,
                                              PT(
                                                {
                                                  className:
                                                    "ST_B2B_HowItWorksButton",
                                                  variant: "outlined",
                                                  target: "_blank",
                                                  href: "https://youtu.be/fEg2amo8qS8?si=9B76PqOqZEqs9Fur",
                                                  startIcon: O_,
                                                  sx: { marginLeft: "0px" },
                                                },
                                                {
                                                  children:
                                                    Z("dashbord_Msg_New"),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    ],
                                  })
                                : null,
                              (
                                null ===
                                  (r =
                                    null == X
                                      ? void 0
                                      : X.featuresAdditionalSettings) ||
                                void 0 === r
                                  ? void 0
                                  : r.showCommissionList
                              )
                                ? (0, e.jsx)(
                                    qa,
                                    PT(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 2,
                                        className: "ST_DB_Min_Class",
                                      },
                                      {
                                        children: (0, e.jsx)(
                                          ii,
                                          PT(
                                            {
                                              sx: PT(PT({}, p), {
                                                border: "0.5px solid #2371CB",
                                                borderBottom:
                                                  "3px solid #2371CB",
                                              }),
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                cC,
                                                PT(
                                                  {
                                                    sx: { textAlign: "center" },
                                                  },
                                                  {
                                                    children: [
                                                      f_,
                                                      "SalesRep" === ne
                                                        ? (0, e.jsxs)(
                                                            ni,
                                                            PT(
                                                              {
                                                                variant:
                                                                  "body2",
                                                                sx: b,
                                                              },
                                                              {
                                                                children: [
                                                                  ((null ===
                                                                    (o =
                                                                      null == E
                                                                        ? void 0
                                                                        : E.SalesRepCommissionModel) ||
                                                                  void 0 === o
                                                                    ? void 0
                                                                    : o.Commissionforsalerep) &&
                                                                    (
                                                                      100 *
                                                                      (null ===
                                                                        (a =
                                                                          null ==
                                                                          E
                                                                            ? void 0
                                                                            : E.SalesRepCommissionModel) ||
                                                                      void 0 ===
                                                                        a
                                                                        ? void 0
                                                                        : a.Commissionforsalerep)
                                                                    ).toFixed(
                                                                      2
                                                                    )) ||
                                                                    0,
                                                                  "%",
                                                                  (0, e.jsx)(
                                                                    ni,
                                                                    PT(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                        mb: 1,
                                                                        align:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          Z(
                                                                            "dashboard_CardTitle1"
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          )
                                                        : "ProfitMargin" === ne
                                                        ? (0, e.jsx)(
                                                            ni,
                                                            PT(
                                                              {
                                                                variant:
                                                                  "body2",
                                                                align: "center",
                                                              },
                                                              {
                                                                children: Z(
                                                                  "dashboard_commissionOn_profitMargin"
                                                                ),
                                                              }
                                                            )
                                                          )
                                                        : "ProductType" ===
                                                            ne ||
                                                          "Product" === ne
                                                        ? (0, e.jsx)(
                                                            ni,
                                                            PT(
                                                              {
                                                                variant:
                                                                  "body2",
                                                                mt: 2,
                                                                className:
                                                                  "ST_link_FontColor",
                                                                sx: PT(
                                                                  {
                                                                    whiteSpace:
                                                                      "nowrap",
                                                                  },
                                                                  Lo
                                                                ),
                                                                align: "center",
                                                                onClick:
                                                                  function () {
                                                                    L(!0);
                                                                  },
                                                              },
                                                              {
                                                                children: Z(
                                                                  "show_commission_list"
                                                                ),
                                                              }
                                                            )
                                                          )
                                                        : (0, e.jsx)(
                                                            ni,
                                                            PT(
                                                              {
                                                                variant:
                                                                  "body2",
                                                                align: "center",
                                                              },
                                                              { children: "-" }
                                                            )
                                                          ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  )
                                : null,
                              (0, e.jsx)(
                                qa,
                                PT(
                                  {
                                    item: !0,
                                    xs: 12,
                                    md: 2,
                                    className: "ST_DB_Min_Class",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      ii,
                                      PT(
                                        {
                                          sx: PT(PT({}, p), {
                                            border: "0.5px solid #8566FB",
                                            borderBottom: "3px solid #8566FB",
                                          }),
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            cC,
                                            PT(
                                              { sx: { textAlign: "center" } },
                                              {
                                                children: [
                                                  v_,
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        sx: b,
                                                      },
                                                      {
                                                        children:
                                                          null !==
                                                            (i =
                                                              null == V
                                                                ? void 0
                                                                : V.TotalNoOfOrders) &&
                                                          void 0 !== i
                                                            ? i
                                                            : "0",
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        mb: 1,
                                                        align: "center",
                                                      },
                                                      {
                                                        children: Z(
                                                          "dashboar_cardHeading1"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  {
                                    item: !0,
                                    xs: 12,
                                    md: 2,
                                    className: "ST_DB_Min_Class",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      ii,
                                      PT(
                                        {
                                          sx: PT(PT({}, p), {
                                            border: "0.5px solid #4ED8DA",
                                            borderBottom: "3px solid #4ED8DA",
                                          }),
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            cC,
                                            PT(
                                              { sx: { textAlign: "center" } },
                                              {
                                                children: [
                                                  b_,
                                                  (0, e.jsxs)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        sx: b,
                                                        className:
                                                          "ST_White_Space",
                                                      },
                                                      {
                                                        children: [
                                                          H,
                                                          " ",
                                                          (
                                                            null == V
                                                              ? void 0
                                                              : V.TotalCommission
                                                          )
                                                            ? V.TotalCommission.toFixed(
                                                                2
                                                              )
                                                            : "0.00",
                                                          " ",
                                                          " " +
                                                            (null != te
                                                              ? te
                                                              : ""),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        mb: 1,
                                                        align: "center",
                                                      },
                                                      {
                                                        children: Z(
                                                          "dashboard_CardTitle3"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  {
                                    item: !0,
                                    xs: 12,
                                    md: 2,
                                    className: "ST_DB_Min_Class",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      ii,
                                      PT(
                                        {
                                          sx: PT(PT({}, p), {
                                            border: "0.5px solid #28B433",
                                            borderBottom: "3px solid #28B433",
                                          }),
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            cC,
                                            PT(
                                              { sx: { textAlign: "center" } },
                                              {
                                                children: [
                                                  g_,
                                                  (0, e.jsxs)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        sx: b,
                                                        className:
                                                          "ST_White_Space",
                                                      },
                                                      {
                                                        children: [
                                                          H,
                                                          " ",
                                                          (
                                                            null == V
                                                              ? void 0
                                                              : V.TotalSale
                                                          )
                                                            ? null ===
                                                                (s =
                                                                  null == V
                                                                    ? void 0
                                                                    : V.TotalSale) ||
                                                              void 0 === s
                                                              ? void 0
                                                              : s.toFixed(2)
                                                            : "0.00",
                                                          " ",
                                                          " " + te,
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "body2",
                                                        mb: 1,
                                                        align: "center",
                                                      },
                                                      {
                                                        children: Z(
                                                          "dashboard_CardTitle4"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  {
                                    item: !0,
                                    xs: 12,
                                    md: 2,
                                    className: "ST_DB_Min_Class",
                                  },
                                  {
                                    children: (0, e.jsx)(
                                      ii,
                                      PT(
                                        {
                                          sx: PT(PT({}, p), {
                                            border: "0.5px solid #4ED8DA",
                                            borderBottom: "3px solid #4ED8DA",
                                          }),
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            cC,
                                            PT(
                                              { sx: { textAlign: "center" } },
                                              {
                                                children: [
                                                  __,
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "h6",
                                                        sx: {
                                                          fontSize: "14px",
                                                        },
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          "b",
                                                          {
                                                            children: [
                                                              " ",
                                                              Z(
                                                                "Performance_Details"
                                                              ),
                                                            ],
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ni,
                                                    PT(
                                                      {
                                                        variant: "subtitle2",
                                                        className:
                                                          "ST_link_FontColor",
                                                        sx: PT(
                                                          {
                                                            whiteSpace:
                                                              "nowrap",
                                                          },
                                                          Lo
                                                        ),
                                                        align: "center",
                                                        onClick: function () {
                                                          Q();
                                                        },
                                                      },
                                                      {
                                                        children: Z(
                                                          "Show_Performance_Details"
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                      (0, e.jsxs)(
                        qa,
                        PT(
                          { container: !0, spacing: 2, mb: 1 },
                          {
                            children: [
                              (0, e.jsx)(
                                qa,
                                PT(
                                  {
                                    item: !0,
                                    xs: 12,
                                    md: 12,
                                    sx: { textAlign: "center" },
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      qa,
                                      PT(
                                        {
                                          sx: PT(PT({}, Mo), {
                                            alignItems: "center",
                                          }),
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)("hr", {
                                              className: "ST_DB_HorizontalLine",
                                              style: h,
                                            }),
                                            (0, e.jsx)(
                                              "span",
                                              PT(
                                                {
                                                  className:
                                                    "ST_DB_Dashboard_GraphHeading",
                                                },
                                                {
                                                  children: Z(
                                                    "dashboard_graphHeading1"
                                                  ),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)("hr", {
                                              className: "ST_DB_HorizontalLine",
                                              style: h,
                                            }),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: 6 },
                                  {
                                    children: (0, e.jsxs)(
                                      uC,
                                      PT(
                                        { sx: m },
                                        {
                                          children: [
                                            (0, e.jsx)(UO, {
                                              data: P,
                                              options: w,
                                              className: "ST_DB_Graph",
                                            }),
                                            F(3),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: 6 },
                                  {
                                    children: (0, e.jsxs)(
                                      uC,
                                      PT(
                                        { sx: m },
                                        {
                                          children: [
                                            (0, e.jsx)($O, {
                                              data: I,
                                              options: M,
                                              className: "ST_DB_Graph",
                                            }),
                                            F(4),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: K ? 8 : 6 },
                                  {
                                    children: (0, e.jsx)(
                                      uC,
                                      PT(
                                        {
                                          sx: PT(PT({}, m), Mo),
                                          justifyContent: "center",
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            uC,
                                            PT(
                                              {
                                                sx: {
                                                  width: K ? "77%" : "100%",
                                                },
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)($O, {
                                                    data: O,
                                                    options: T,
                                                    className: "ST_DB_Graph",
                                                  }),
                                                  F(5),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: K ? 4 : 6 },
                                  {
                                    children: (0, e.jsx)(
                                      uC,
                                      PT(
                                        { sx: Mo, justifyContent: "center" },
                                        {
                                          children: (0, e.jsxs)(
                                            uC,
                                            PT(
                                              { sx: { width: "100%" } },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    ii,
                                                    PT(
                                                      {
                                                        sx: PT(PT({}, g), {
                                                          border:
                                                            "0.5px solid #4ED8DA",
                                                          borderBottom:
                                                            "3px solid #4ED8DA",
                                                          mb: K ? 5 : 2,
                                                        }),
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          cC,
                                                          PT(
                                                            {
                                                              sx: {
                                                                textAlign:
                                                                  "center",
                                                              },
                                                            },
                                                            {
                                                              children: [
                                                                (0, e.jsxs)(
                                                                  uC,
                                                                  PT(
                                                                    {
                                                                      sx: {
                                                                        display:
                                                                          "inline-flex",
                                                                        paddingTop:
                                                                          "2rem",
                                                                      },
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            {
                                                                              children:
                                                                                y_,
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            PT(
                                                                              {
                                                                                variant:
                                                                                  "body2",
                                                                                sx: v,
                                                                              },
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    "dashboard_TotalRevenue"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  ni,
                                                                  PT(
                                                                    {
                                                                      variant:
                                                                        "body2",
                                                                      align:
                                                                        "center",
                                                                      mb: 1,
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsxs)(
                                                                          uC,
                                                                          PT(
                                                                            {
                                                                              sx: PT(
                                                                                PT(
                                                                                  {},
                                                                                  _
                                                                                ),
                                                                                {
                                                                                  backgroundColor:
                                                                                    "#4ED8DA",
                                                                                }
                                                                              ),
                                                                              className:
                                                                                "ST_White_Space",
                                                                            },
                                                                            {
                                                                              children:
                                                                                [
                                                                                  H,
                                                                                  null !==
                                                                                    (l =
                                                                                      null ==
                                                                                      U
                                                                                        ? void 0
                                                                                        : U.toFixed(
                                                                                            2
                                                                                          )) &&
                                                                                  void 0 !==
                                                                                    l
                                                                                    ? l
                                                                                    : 0,
                                                                                  " " +
                                                                                    te,
                                                                                ],
                                                                            }
                                                                          )
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    ii,
                                                    PT(
                                                      {
                                                        sx: PT(PT({}, g), {
                                                          border:
                                                            "0.5px solid #9C6ADE",
                                                          borderBottom:
                                                            "3px solid #9C6ADE",
                                                        }),
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          cC,
                                                          PT(
                                                            {
                                                              sx: {
                                                                textAlign:
                                                                  "center",
                                                              },
                                                            },
                                                            {
                                                              children: [
                                                                (0, e.jsxs)(
                                                                  uC,
                                                                  PT(
                                                                    {
                                                                      sx: {
                                                                        display:
                                                                          "inline-flex",
                                                                        paddingTop:
                                                                          "2rem",
                                                                      },
                                                                    },
                                                                    {
                                                                      children:
                                                                        [
                                                                          (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            {
                                                                              children:
                                                                                C_,
                                                                            }
                                                                          ),
                                                                          (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            PT(
                                                                              {
                                                                                variant:
                                                                                  "body2",
                                                                                sx: v,
                                                                              },
                                                                              {
                                                                                children:
                                                                                  Z(
                                                                                    "dashboard_TotalAvg_Ticket_Size"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                        ],
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  ni,
                                                                  PT(
                                                                    {
                                                                      variant:
                                                                        "body2",
                                                                      align:
                                                                        "center",
                                                                      mb: 1,
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsxs)(
                                                                          uC,
                                                                          PT(
                                                                            {
                                                                              sx: PT(
                                                                                PT(
                                                                                  {},
                                                                                  _
                                                                                ),
                                                                                {
                                                                                  backgroundColor:
                                                                                    "#9C6ADE",
                                                                                }
                                                                              ),
                                                                              className:
                                                                                "ST_White_Space",
                                                                            },
                                                                            {
                                                                              children:
                                                                                [
                                                                                  H,
                                                                                  null !==
                                                                                    (d =
                                                                                      null ==
                                                                                      $
                                                                                        ? void 0
                                                                                        : $.toFixed(
                                                                                            2
                                                                                          )) &&
                                                                                  void 0 !==
                                                                                    d
                                                                                    ? d
                                                                                    : 0,
                                                                                  " " +
                                                                                    (null !=
                                                                                    te
                                                                                      ? te
                                                                                      : ""),
                                                                                ],
                                                                            }
                                                                          )
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: 12 },
                                  {
                                    children: (0, e.jsx)(
                                      qa,
                                      PT(
                                        {
                                          sx: PT(PT({}, Mo), {
                                            alignItems: "center",
                                          }),
                                        },
                                        {
                                          children: (0, e.jsxs)(
                                            "span",
                                            PT(
                                              {
                                                className:
                                                  "ST_DB_Dashboard_GraphHeading",
                                              },
                                              {
                                                children: [
                                                  Z("dashboard_graphHeading2"),
                                                  " : ",
                                                  k,
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: 6 },
                                  {
                                    children: (0, e.jsxs)(
                                      uC,
                                      PT(
                                        { sx: m },
                                        {
                                          children: [
                                            (0, e.jsx)($O, {
                                              data: j,
                                              options: N,
                                              className: "ST_DB_Graph",
                                            }),
                                            F(1),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)(
                                qa,
                                PT(
                                  { item: !0, xs: 12, md: 6 },
                                  {
                                    children: (0, e.jsxs)(
                                      uC,
                                      PT(
                                        { sx: m },
                                        {
                                          children: [
                                            (0, e.jsx)(KO, {
                                              data: D,
                                              options: A,
                                              className: "ST_DB_Graph",
                                            }),
                                            F(2),
                                            (0, e.jsx)(
                                              ni,
                                              PT(
                                                { mt: 0 },
                                                {
                                                  children: (0, e.jsxs)("b", {
                                                    children: [
                                                      " ",
                                                      Z("dashboard_CardTitle3"),
                                                      " : ",
                                                      null !==
                                                        (c =
                                                          null == W
                                                            ? void 0
                                                            : W.toFixed(2)) &&
                                                      void 0 !== c
                                                        ? c
                                                        : 0,
                                                    ],
                                                  }),
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                    ],
                  }
                )
              ),
              (0, e.jsx)(
                Hp,
                PT(
                  {
                    open: R,
                    onClose: function () {
                      return L(!1);
                    },
                    maxWidth: "sm",
                    fullWidth: !0,
                  },
                  {
                    children: (0, e.jsxs)(
                      uC,
                      PT(
                        { className: "ST_DB_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              PT(
                                { container: !0, spacing: 2, mb: 2, pl: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      PT(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            PT(
                                              { variant: "h6" },
                                              { children: Z("commission_list") }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      PT(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                          pr: 1,
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              L(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsx)(
                              Gp,
                              PT(
                                { sx: { padding: "0px" } },
                                {
                                  children: (0, e.jsx)(
                                    ep,
                                    PT(
                                      { sx: { maxHeight: 500, mt: 3 } },
                                      {
                                        children: (0, e.jsxs)(
                                          sp,
                                          PT(
                                            { stickyHeader: !0 },
                                            {
                                              children: [
                                                (0, e.jsx)(hp, {
                                                  children: (0, e.jsxs)(Cp, {
                                                    children: [
                                                      (0, e.jsx)(
                                                        Op,
                                                        PT(
                                                          {
                                                            className:
                                                              "ST_DC_Thead",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("b", {
                                                              children:
                                                                "ProductType" ===
                                                                ne
                                                                  ? "Product Type"
                                                                  : "Product Name",
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        Op,
                                                        PT(
                                                          {
                                                            className:
                                                              "ST_DC_Thead",
                                                            align: "center",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)("b", {
                                                              children: Z(
                                                                "dashboar_cardHeading2"
                                                              ),
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }),
                                                }),
                                                ne && "ProductType" === ne
                                                  ? B(
                                                      null == E
                                                        ? void 0
                                                        : E.CommissionandDiscountPerProductType,
                                                      "productType",
                                                      "ClientCommission"
                                                    )
                                                  : B(
                                                      null == E
                                                        ? void 0
                                                        : E.CommissionandDiscountPerProduct,
                                                      "ProductName",
                                                      "CommissionForCustomerOrder"
                                                    ),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                Hp,
                PT(
                  {
                    open: G,
                    onClose: function () {
                      return q(!1);
                    },
                    maxWidth: "sm",
                    fullWidth: !0,
                  },
                  {
                    children: (0, e.jsxs)(
                      uC,
                      PT(
                        { className: "ST_DB_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              PT(
                                { container: !0, spacing: 2, mb: 2, pl: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      PT(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            PT(
                                              { variant: "h6" },
                                              {
                                                children: (0, e.jsx)("b", {
                                                  children: Z(
                                                    "Performance_Details"
                                                  ),
                                                }),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      PT(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                          pr: 1,
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              q(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsx)("hr", { className: "ST_DB_Hr" }),
                            (0, e.jsx)(
                              Gp,
                              PT(
                                { sx: { padding: "0px" } },
                                {
                                  children: (0, e.jsx)(
                                    ep,
                                    PT(
                                      {
                                        style: { maxHeight: "400px" },
                                        component: go,
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          sp,
                                          PT(
                                            { stickyHeader: !0 },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  hp,
                                                  PT(
                                                    {
                                                      className:
                                                        "stickyHeaderRow",
                                                    },
                                                    {
                                                      children:
                                                        null == J
                                                          ? void 0
                                                          : J.map(function (
                                                              t,
                                                              n
                                                            ) {
                                                              return (0, e.jsx)(
                                                                Op,
                                                                PT(
                                                                  {
                                                                    className:
                                                                      "ST_PerformanceDetailsTable",
                                                                    sx: (
                                                                      null == t
                                                                        ? void 0
                                                                        : t.hide
                                                                    )
                                                                      ? {
                                                                          display:
                                                                            "none",
                                                                        }
                                                                      : {
                                                                          display:
                                                                            "table-cell",
                                                                        },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              " ",
                                                                              null ==
                                                                              t
                                                                                ? void 0
                                                                                : t.name,
                                                                            ],
                                                                        }
                                                                      ),
                                                                  }
                                                                ),
                                                                n
                                                              );
                                                            }),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(Dp, {
                                                  children:
                                                    (null == Y
                                                      ? void 0
                                                      : Y.length) > 0
                                                      ? null == Y
                                                        ? void 0
                                                        : Y.map(function (t) {
                                                            var n, r, o;
                                                            return (0,
                                                            e.jsxs)(Cp, { children: [(0, e.jsx)(Op, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.Month }) }), (0, e.jsx)(Op, { children: null == t ? void 0 : t.TotalNoOfOrders }), (0, e.jsx)(Op, { children: null === (n = null == t ? void 0 : t.TotalSale) || void 0 === n ? void 0 : n.toFixed(2) }), (0, e.jsx)(Op, { children: null === (r = null == t ? void 0 : t.TotalCommission) || void 0 === r ? void 0 : r.toFixed(2) }), (null == X ? void 0 : X.Bonus) ? (0, e.jsx)(Op, { children: null === (o = null == t ? void 0 : t.TotalBonus) || void 0 === o ? void 0 : o.toFixed(2) }) : (0, e.jsx)(e.Fragment, {})] });
                                                          })
                                                      : (0, e.jsx)(Cp, {
                                                          children: (0, e.jsx)(
                                                            Op,
                                                            PT(
                                                              {
                                                                colSpan: (
                                                                  null == X
                                                                    ? void 0
                                                                    : X.Bonus
                                                                )
                                                                  ? 5
                                                                  : 4,
                                                                align: "center",
                                                              },
                                                              {
                                                                children:
                                                                  Z(
                                                                    "dashboard_no_data"
                                                                  ),
                                                              }
                                                            )
                                                          ),
                                                        }),
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        OT = (0, Oo.Z)(
          [
            (0, e.jsx)(
              "path",
              {
                d: "M12.79 21 3 11.21v2c0 .53.21 1.04.59 1.41l7.79 7.79c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83z",
              },
              "0"
            ),
            (0, e.jsx)(
              "path",
              {
                d: "M11.38 17.41c.78.78 2.05.78 2.83 0l6.21-6.21c.78-.78.78-2.05 0-2.83L12.63.58C12.25.21 11.74 0 11.21 0H5C3.9 0 3 .9 3 2v6.21c0 .53.21 1.04.59 1.41zM7.25 3c.69 0 1.25.56 1.25 1.25S7.94 5.5 7.25 5.5 6 4.94 6 4.25 6.56 3 7.25 3",
              },
              "1"
            ),
          ],
          "DiscountRounded"
        ),
        TT = function () {
          return (
            (TT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            TT.apply(this, arguments)
          );
        },
        IT = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        MT = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        jT = function () {
          return (
            (jT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            jT.apply(this, arguments)
          );
        },
        NT = function () {
          var n,
            r,
            o,
            a,
            i,
            s,
            l,
            d,
            c,
            u,
            p,
            m,
            h,
            f,
            v,
            b,
            _,
            y,
            C,
            x,
            S,
            k,
            P,
            w = xv(),
            O = w.copyTextFunction,
            T = w.copyIconSuccessColor,
            I = (function () {
              var e,
                n,
                r = this,
                o = ee().t,
                a = g(),
                i = (0, t.useState)(!1),
                s = i[0],
                l = i[1],
                d = (0, t.useState)([]),
                c = d[0],
                u = d[1],
                p = (0, t.useState)(!1),
                m = p[0],
                h = p[1],
                f = (0, t.useState)(o("discountCoupon_button3")),
                v = f[0],
                b = f[1],
                _ = (0, t.useState)(!1),
                y = _[0],
                C = _[1],
                x = (0, t.useState)(0),
                S = x[0],
                k = x[1],
                P = (0, t.useState)("ST_DC_Pointer_Events_All"),
                w = P[0],
                O = P[1],
                T = (0, t.useState)({
                  discountCode: "",
                  discountCodeErrMsg: "",
                  discountValue: "",
                  discountValueErrMsg: "",
                }),
                I = T[0],
                M = T[1],
                j = F.getState().salesRepData.baseData,
                N = (0, t.useState)(o("discountCoupon_button1")),
                D = N[0],
                A =
                  (N[1],
                  (0, t.useState)(
                    o("discountCoupon_contentHeading4PlaceHolder1") +
                      " " +
                      (j &&
                      0 !==
                        (null === (e = Object.keys(j)) || void 0 === e
                          ? void 0
                          : e.length) &&
                      null !== (null == j ? void 0 : j.CouponCodeForSalesRep)
                        ? null ===
                            (n =
                              null == j ? void 0 : j.CouponCodeForSalesRep) ||
                          void 0 === n
                          ? void 0
                          : n.DiscountCode
                        : "-") +
                      " " +
                      o("discountCoupon_contentHeading4PlaceHolder2")
                  )),
                E = A[0],
                R = A[1],
                L = "" != I.discountCode && "" != I.discountValue,
                B = (0, t.useState)(j ? j.select.SalesrepCoupon : {}),
                z = B[0],
                Z = (B[1], (0, t.useState)({ msg: "", open: !1 })),
                H = Z[0],
                V = Z[1],
                W = (0, t.useState)(!1),
                U = W[0],
                $ = W[1],
                K = Tv();
              return (
                (0, t.useEffect)(
                  function () {
                    var e, t;
                    b(o("discountCoupon_button3")),
                      R(
                        o("discountCoupon_contentHeading4PlaceHolder1") +
                          " " +
                          (j &&
                          0 !==
                            (null === (e = Object.keys(j)) || void 0 === e
                              ? void 0
                              : e.length) &&
                          null !==
                            (null == j ? void 0 : j.CouponCodeForSalesRep)
                            ? null ===
                                (t =
                                  null == j
                                    ? void 0
                                    : j.CouponCodeForSalesRep) || void 0 === t
                              ? void 0
                              : t.DiscountCode
                            : "-") +
                          " " +
                          o("discountCoupon_contentHeading4PlaceHolder2")
                      );
                  },
                  [o]
                ),
                {
                  checkViewCoupon: s,
                  viewCouponData: c,
                  copyDisocuntCode: D,
                  openViewCoupon: m,
                  isDelete: y,
                  removeIndex: S,
                  pointerEvents: w,
                  handleViewCouponOpen: function () {
                    return IT(r, void 0, void 0, function () {
                      return MT(this, function (e) {
                        switch (e.label) {
                          case 0:
                            return l(!0), [4, a(og())];
                          case 1:
                            return (
                              Ov(e.sent()) ||
                                (u(F.getState().salesRepData.viewCouponData),
                                h(!0)),
                              l(!1),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  handleViewCouponClose: function () {
                    return h(!1);
                  },
                  changeValue: function (e) {
                    var t;
                    "discountCode" === e.target.name
                      ? (M(function (t) {
                          return TT(TT({}, t), {
                            discountCode: e.target.value,
                          });
                        }),
                        "" === e.target.value
                          ? M(function (e) {
                              return TT(TT({}, e), {
                                discountCodeErrMsg: o(
                                  "addCustomer_leadEmptyErrrorMsg"
                                ),
                              });
                            })
                          : M(function (e) {
                              return TT(TT({}, e), { discountCodeErrMsg: "" });
                            }))
                      : (M(function (t) {
                          return TT(TT({}, t), {
                            discountValue: e.target.value,
                          });
                        }),
                        e.target.value >
                        (null ===
                          (t =
                            null == j
                              ? void 0
                              : j.DiscountAndCommissionForCoupon) ||
                        void 0 === t
                          ? void 0
                          : t.SalesRepMaxDiscount)
                          ? M(function (e) {
                              return TT(TT({}, e), {
                                discountValueErrMsg: o(
                                  "discountCoupon_contentHeading8PlaceHolder"
                                ),
                              });
                            })
                          : M(function (e) {
                              return TT(TT({}, e), { discountValueErrMsg: "" });
                            }));
                  },
                  createCoupon: function () {
                    return IT(r, void 0, void 0, function () {
                      var e, t;
                      return MT(this, function (n) {
                        switch (n.label) {
                          case 0:
                            return (
                              (e = {
                                discountCode: I.discountCode,
                                discountValue: I.discountValue,
                              }),
                              b(o("createCoupon_btnlbl1")),
                              O("ST_DC_Pointer_Events_None"),
                              [4, a(ag(e))]
                            );
                          case 1:
                            return (
                              "Coupon Created" === (t = n.sent())
                                ? (b(o("createCoupon_btnlbl2")),
                                  V({
                                    msg: o("createCoupon_btnlbl2"),
                                    open: !0,
                                    severity: "success",
                                  }),
                                  setTimeout(function () {
                                    O("ST_DC_Pointer_Events_All"),
                                      b(o("discountCoupon_button3")),
                                      M({
                                        discountCode: "",
                                        discountCodeErrMsg: "",
                                        discountValue: "",
                                        discountValueErrMsg: "",
                                      });
                                  }, 3e3))
                                : (V({ msg: t, open: !0, severity: "error" }),
                                  O("ST_DC_Pointer_Events_All"),
                                  b(o("discountCoupon_button3"))),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  removeCoupon: function (e, t) {
                    return IT(r, void 0, void 0, function () {
                      var n;
                      return MT(this, function (r) {
                        switch (r.label) {
                          case 0:
                            return (
                              (n = {
                                coupon: e.CouponeCode,
                                customerId: e.SalesRepId,
                                couponid: e.couponId,
                              }),
                              C(!0),
                              k(t),
                              [4, a(ig(n))]
                            );
                          case 1:
                            return (
                              Ov(r.sent())
                                ? C(!1)
                                : (C(!1),
                                  setTimeout(function () {
                                    k(0),
                                      u(
                                        F.getState().salesRepData.viewCouponData
                                      );
                                  }, 2e3)),
                              [2]
                            );
                        }
                      });
                    });
                  },
                  t: o,
                  inputState: I,
                  discountCouponData: j,
                  copyDiscountText: E,
                  setcopyDiscountText: R,
                  createOneCoupon: v,
                  createCouponBtnEnabled: L,
                  oneTimeCouponCode: z,
                  handleAlertMsgClose: function (e, t) {
                    "clickaway" !== t && V({ msg: "", open: !1 });
                  },
                  alertMsg: H,
                  openCommissionDialog: U,
                  setOpenCommissionDialog: $,
                  isMobile: K,
                }
              );
            })(),
            M = I.checkViewCoupon,
            j = I.viewCouponData,
            N = I.copyDisocuntCode,
            D = I.openViewCoupon,
            A = I.isDelete,
            E = I.removeIndex,
            R = I.pointerEvents,
            L = I.handleViewCouponOpen,
            B = I.handleViewCouponClose,
            z = I.changeValue,
            Z = I.createCoupon,
            H = I.removeCoupon,
            V = I.t,
            W = I.inputState,
            U = I.discountCouponData,
            $ = I.copyDiscountText,
            K = I.setcopyDiscountText,
            G = I.createOneCoupon,
            q = I.createCouponBtnEnabled,
            Q = I.oneTimeCouponCode,
            Y = I.handleAlertMsgClose,
            J = I.alertMsg,
            X = I.openCommissionDialog,
            te = I.setOpenCommissionDialog,
            ne = I.isMobile,
            re = {
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              width: "50%",
              boxShadow: 24,
              p: 3,
            },
            oe = {
              display: "flex",
              backgroundColor: "#F5F5F5",
              borderRadius: "4px",
              width: "100%",
              height: "auto !important",
              minHeight: "auto !important",
              justifyContent: "center",
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "transparent" },
              },
            },
            ae = EO().getCommissionStructure,
            ie =
              null ===
                (o =
                  null ===
                    (r =
                      null === (n = F.getState().salesRepData) || void 0 === n
                        ? void 0
                        : n.baseData) || void 0 === r
                    ? void 0
                    : r.CommissionDiscountOn) || void 0 === o
                ? void 0
                : o.CommissionDiscountOn,
            se =
              null === (a = F.getState().salesRepData) || void 0 === a
                ? void 0
                : a.baseData;
          return (0, e.jsxs)(
            mn,
            jT(
              { className: "ST_Main_Card" },
              {
                children: [
                  (
                    null === (i = null == U ? void 0 : U.select) || void 0 === i
                      ? void 0
                      : i.CouponeCode
                  )
                    ? (0, e.jsxs)(e.Fragment, {
                        children: [
                          (0, e.jsxs)(
                            qa,
                            jT(
                              {
                                sx: jT(jT({}, $o), { marginBottom: "1.5rem" }),
                              },
                              {
                                children: [
                                  (0, e.jsx)(
                                    ni,
                                    jT(
                                      { variant: Av, sx: Ko },
                                      { children: V("discountCoupon_titleOne") }
                                    )
                                  ),
                                  (0, e.jsx)("hr", {
                                    className: "ST_CI_Horizontal_Line",
                                  }),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            ii,
                            jT(
                              { className: "ST_DC_Card1Color" },
                              {
                                children: [
                                  (0, e.jsx)(
                                    ni,
                                    jT(
                                      { variant: "body2", mb: 2, fontSize: 16 },
                                      {
                                        children: V(
                                          "discountCoupon_contentHeading1"
                                        ),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(mn, {
                                    children: (0, e.jsxs)(
                                      "div",
                                      jT(
                                        {
                                          className: "ST_DC_DiscountCouponBox",
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(mn, {
                                              children: (0, e.jsx)(
                                                "div",
                                                jT(
                                                  {
                                                    className:
                                                      "ST_DC_DiscountCoupon",
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      ni,
                                                      jT(
                                                        {
                                                          className:
                                                            "ST_DC_CouponCopyTextBox",
                                                          variant: "body2",
                                                          color: "black",
                                                          fontSize: 14,
                                                          textAlign: "center",
                                                        },
                                                        {
                                                          children: [
                                                            V(
                                                              "discountCoupon_contentHeading2"
                                                            ),
                                                            ": ",
                                                            (0, e.jsx)("b", {
                                                              children:
                                                                null ===
                                                                  (s =
                                                                    null == U
                                                                      ? void 0
                                                                      : U.CouponCodeForSalesRep) ||
                                                                void 0 === s
                                                                  ? void 0
                                                                  : s.DiscountCode,
                                                            }),
                                                            (0, e.jsx)(
                                                              Gs,
                                                              jT(
                                                                {
                                                                  TransitionComponent:
                                                                    pb,
                                                                  title:
                                                                    "#05bf05" ===
                                                                    T.copyDiscountCode
                                                                      ? V(
                                                                          "affiliateLink_searchColumn8"
                                                                        )
                                                                      : V(
                                                                          "click_to_copy"
                                                                        ),
                                                                  placement:
                                                                    "bottom",
                                                                  arrow: !0,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(Tb, {
                                                                    onClick:
                                                                      function () {
                                                                        var e,
                                                                          t;
                                                                        O(
                                                                          0 !==
                                                                            (null ===
                                                                              (e =
                                                                                Object.keys(
                                                                                  U
                                                                                )) ||
                                                                            void 0 ===
                                                                              e
                                                                              ? void 0
                                                                              : e.length) &&
                                                                            null !==
                                                                              (null ==
                                                                              U
                                                                                ? void 0
                                                                                : U.CouponCodeForSalesRep)
                                                                            ? null ===
                                                                                (t =
                                                                                  null ==
                                                                                  U
                                                                                    ? void 0
                                                                                    : U.CouponCodeForSalesRep) ||
                                                                              void 0 ===
                                                                                t
                                                                              ? void 0
                                                                              : t.DiscountCode
                                                                            : "-",
                                                                          "copyDiscountCode"
                                                                        );
                                                                      },
                                                                    style: {
                                                                      cursor:
                                                                        "pointer",
                                                                      marginLeft:
                                                                        "10px",
                                                                      color:
                                                                        T.copyDiscountCode,
                                                                    },
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                            (0, e.jsx)(mn, {
                                              children: (0, e.jsx)(
                                                "div",
                                                jT(
                                                  {
                                                    className:
                                                      "ST_DC_DiscountCoupon",
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      ni,
                                                      jT(
                                                        {
                                                          variant: "body2",
                                                          color: "black",
                                                          fontSize: 14,
                                                          textAlign: "center",
                                                        },
                                                        {
                                                          children: [
                                                            V(
                                                              "discountCoupon_contentHeading3"
                                                            ),
                                                            ": ",
                                                            (0, e.jsxs)("b", {
                                                              children: [
                                                                null ===
                                                                  (l =
                                                                    null == U
                                                                      ? void 0
                                                                      : U.CouponCodeForSalesRep) ||
                                                                void 0 === l
                                                                  ? void 0
                                                                  : l.CustomerDiscount,
                                                                "%",
                                                              ],
                                                            }),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                            (0, e.jsx)(mn, {
                                              children: (0, e.jsx)(
                                                "div",
                                                jT(
                                                  {
                                                    className:
                                                      "ST_DC_DiscountCoupon",
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      ni,
                                                      jT(
                                                        {
                                                          variant: "body2",
                                                          color: "black",
                                                          fontSize: 14,
                                                          textAlign: "center",
                                                        },
                                                        {
                                                          children: [
                                                            "ProductType" ===
                                                              ie ||
                                                            "Product" === ie
                                                              ? (0, e.jsx)(
                                                                  ni,
                                                                  jT(
                                                                    {
                                                                      className:
                                                                        "ST_DC_ShowCommissionList",
                                                                      variant:
                                                                        "body2",
                                                                      mt: 2,
                                                                      sx: {
                                                                        ST_CustName_TableCell:
                                                                          Lo,
                                                                      },
                                                                      align:
                                                                        "center",
                                                                      onClick:
                                                                        function () {
                                                                          te(
                                                                            !0
                                                                          );
                                                                        },
                                                                    },
                                                                    {
                                                                      children:
                                                                        V(
                                                                          "show_commission_list"
                                                                        ),
                                                                    }
                                                                  )
                                                                )
                                                              : (0, e.jsxs)(
                                                                  e.Fragment,
                                                                  {
                                                                    children: [
                                                                      V(
                                                                        "discountCoupon_contentHeading4"
                                                                      ),
                                                                      ": ",
                                                                      (0,
                                                                      e.jsxs)(
                                                                        "b",
                                                                        {
                                                                          children:
                                                                            [
                                                                              null ===
                                                                                (d =
                                                                                  null ==
                                                                                  U
                                                                                    ? void 0
                                                                                    : U.CouponCodeForSalesRep) ||
                                                                              void 0 ===
                                                                                d
                                                                                ? void 0
                                                                                : d.SalesRepCommission,
                                                                              "%",
                                                                            ],
                                                                        }
                                                                      ),
                                                                    ],
                                                                  }
                                                                ),
                                                            " ",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                          ],
                                        }
                                      )
                                    ),
                                  }),
                                  (0, e.jsx)(
                                    mn,
                                    jT(
                                      {
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                      },
                                      {
                                        children: (0, e.jsx)(Hc, {
                                          multiline: ne,
                                          minRows: ne ? 3 : 1,
                                          maxRows: ne ? 4 : 1,
                                          sx: oe,
                                          value: $,
                                          id: "ST_DC_Discount_Code",
                                          hiddenLabel: !0,
                                          size: "small",
                                          onChange: function (e) {
                                            return K(e.target.value);
                                          },
                                          InputProps: {
                                            style: { fontSize: "15px" },
                                            startAdornment: (0, e.jsx)(
                                              Bu,
                                              jT(
                                                {
                                                  position: "end",
                                                  title: N,
                                                  onClick: function () {
                                                    O($, "copyDiscountText");
                                                  },
                                                },
                                                {
                                                  children: (0, e.jsx)(Tb, {
                                                    style: {
                                                      color: T.copyDiscountText,
                                                    },
                                                    className:
                                                      "ST_DC_Discount_Copy",
                                                  }),
                                                }
                                              )
                                            ),
                                          },
                                        }),
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    "div",
                                    jT(
                                      { className: "ST_DC_Icons" },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            rl,
                                            jT(
                                              {
                                                target: "_blank",
                                                href:
                                                  "http://www.facebook.com/sharer.php?u=https://" +
                                                  (null ===
                                                    (c =
                                                      null == U
                                                        ? void 0
                                                        : U.CouponCodeForSalesRep) ||
                                                  void 0 === c
                                                    ? void 0
                                                    : c.ShopName),
                                              },
                                              {
                                                children: (0, e.jsx)(E_, {
                                                  sx: {
                                                    mr: 2,
                                                    color: "#00007e",
                                                    fontSize: "25px",
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            rl,
                                            jT(
                                              {
                                                target: "_blank",
                                                href:
                                                  "https://www.instagram.com/###?ref=https://" +
                                                  (null ===
                                                    (u =
                                                      null == U
                                                        ? void 0
                                                        : U.CouponCodeForSalesRep) ||
                                                  void 0 === u
                                                    ? void 0
                                                    : u.ShopName),
                                              },
                                              {
                                                children: (0, e.jsx)(D_, {
                                                  sx: {
                                                    mr: 2,
                                                    color: "#c54e63",
                                                    fontSize: "25px",
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            rl,
                                            jT(
                                              {
                                                target: "_blank",
                                                href:
                                                  "https://twitter.com/share?url=https://" +
                                                  (null ===
                                                    (p =
                                                      null == U
                                                        ? void 0
                                                        : U.CouponCodeForSalesRep) ||
                                                  void 0 === p
                                                    ? void 0
                                                    : p.ShopName),
                                              },
                                              {
                                                children: (0, e.jsx)(A_, {
                                                  sx: {
                                                    mr: 2,
                                                    color: "#00a7eb",
                                                    fontSize: "25px",
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            rl,
                                            jT(
                                              {
                                                target: "_blank",
                                                href:
                                                  "http://pinterest.com/pin/create/bookmarklet/?is_video=false&url=https://" +
                                                  (null ===
                                                    (m =
                                                      null == U
                                                        ? void 0
                                                        : U.CouponCodeForSalesRep) ||
                                                  void 0 === m
                                                    ? void 0
                                                    : m.ShopName),
                                              },
                                              {
                                                children: (0, e.jsx)(N_, {
                                                  sx: {
                                                    color: "#d01313",
                                                    fontSize: "25px",
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      })
                    : null,
                  (0, e.jsxs)(
                    qa,
                    jT(
                      { hidden: !Q },
                      {
                        children: [
                          (0, e.jsxs)(
                            qa,
                            jT(
                              { container: !0, spacing: 2 },
                              {
                                children: [
                                  (0, e.jsx)(
                                    qa,
                                    jT(
                                      { item: !0, xs: 12, md: 8, mb: 3 },
                                      {
                                        children: (0, e.jsx)(
                                          ni,
                                          jT(
                                            { variant: Av, sx: Ko },
                                            {
                                              children: V(
                                                "discountCoupon_titleTwo"
                                              ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    qa,
                                    jT(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 4,
                                        mb: 1,
                                        className: "ST_DC_Card_Grid",
                                        sx: { textAlign: "right" },
                                      },
                                      {
                                        children: (0, e.jsxs)(
                                          Qu,
                                          jT(
                                            {
                                              variant: "contained",
                                              onClick: L,
                                              className: "ST_DC_ViewCoupon",
                                            },
                                            {
                                              children: [
                                                V(
                                                  M
                                                    ? "showCouponTable_txt1"
                                                    : "discountCoupon_button2"
                                                ),
                                                (0, e.jsx)(OT, {
                                                  fontSize: "small",
                                                  style: { marginLeft: "5px" },
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            ii,
                            jT(
                              { className: "ST_DC_Card2Color" },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    mn,
                                    jT(
                                      { display: ne ? "block" : "flex", mb: 3 },
                                      {
                                        children: [
                                          (0, e.jsxs)(
                                            ni,
                                            jT(
                                              {
                                                variant: "body2",
                                                marginRight: 15,
                                                fontSize: 15,
                                              },
                                              {
                                                children: [
                                                  V(
                                                    "discountCoupon_contentHeading5"
                                                  ),
                                                  ":",
                                                  " ",
                                                  (0, e.jsx)("b", {
                                                    children: (
                                                      null ===
                                                        (h =
                                                          null == U
                                                            ? void 0
                                                            : U.DiscountAndCommissionForCoupon) ||
                                                      void 0 === h
                                                        ? void 0
                                                        : h.SalesRepMaxDiscount
                                                    )
                                                      ? (null ===
                                                          (f =
                                                            null == U
                                                              ? void 0
                                                              : U.DiscountAndCommissionForCoupon) ||
                                                        void 0 === f
                                                          ? void 0
                                                          : f.SalesRepMaxDiscount) +
                                                        "%"
                                                      : V(
                                                          "discount_couponErrorMsg"
                                                        ),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                          (0, e.jsxs)(
                                            ni,
                                            jT(
                                              {
                                                variant: "body2",
                                                alignContent: "center",
                                                fontSize: 15,
                                              },
                                              {
                                                children: [
                                                  V(
                                                    "discountCoupon_contentHeading6"
                                                  ),
                                                  ":",
                                                  " ",
                                                  (0, e.jsx)("b", {
                                                    children: (
                                                      null ===
                                                        (v =
                                                          null == U
                                                            ? void 0
                                                            : U.DiscountAndCommissionForCoupon) ||
                                                      void 0 === v
                                                        ? void 0
                                                        : v.SalesRepCommission
                                                    )
                                                      ? (null ===
                                                          (b =
                                                            null == U
                                                              ? void 0
                                                              : U.DiscountAndCommissionForCoupon) ||
                                                        void 0 === b
                                                          ? void 0
                                                          : b.SalesRepCommission) +
                                                        "%"
                                                      : V(
                                                          "discount_couponErrorMsg2"
                                                        ),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(Hc, {
                                    size: ne ? "medium" : "small",
                                    type: "text",
                                    name: "discountCode",
                                    label: V("discountCoupon_contentHeading7"),
                                    value: null == W ? void 0 : W.discountCode,
                                    fullWidth: !0,
                                    onChange: function (e) {
                                      return z(e);
                                    },
                                    error:
                                      "" !==
                                      (null == W
                                        ? void 0
                                        : W.discountCodeErrMsg),
                                    helperText:
                                      null == W ? void 0 : W.discountCodeErrMsg,
                                    disabled:
                                      !(null ===
                                        (_ =
                                          null == U
                                            ? void 0
                                            : U.DiscountAndCommissionForCoupon) ||
                                      void 0 === _
                                        ? void 0
                                        : _.SalesRepMaxDiscount) ||
                                      !(null ===
                                        (y =
                                          null == U
                                            ? void 0
                                            : U.DiscountAndCommissionForCoupon) ||
                                      void 0 === y
                                        ? void 0
                                        : y.SalesRepCommission),
                                  }),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)(Hc, {
                                    size: ne ? "medium" : "small",
                                    type: "number",
                                    onKeyDown: jb,
                                    name: "discountValue",
                                    label: V("discountCoupon_contentHeading8"),
                                    value: null == W ? void 0 : W.discountValue,
                                    fullWidth: !0,
                                    onChange: function (e) {
                                      return z(e);
                                    },
                                    error:
                                      "" !==
                                      (null == W
                                        ? void 0
                                        : W.discountValueErrMsg),
                                    helperText:
                                      null == W
                                        ? void 0
                                        : W.discountValueErrMsg,
                                    disabled:
                                      !(null ===
                                        (C =
                                          null == U
                                            ? void 0
                                            : U.DiscountAndCommissionForCoupon) ||
                                      void 0 === C
                                        ? void 0
                                        : C.SalesRepMaxDiscount) ||
                                      !(null ===
                                        (x =
                                          null == U
                                            ? void 0
                                            : U.DiscountAndCommissionForCoupon) ||
                                      void 0 === x
                                        ? void 0
                                        : x.SalesRepCommission),
                                  }),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsx)("br", {}),
                                  (0, e.jsxs)(
                                    Qu,
                                    jT(
                                      {
                                        size: ne ? "large" : "medium",
                                        variant: "contained",
                                        onClick: Z,
                                        className: R,
                                        disabled:
                                          !q ||
                                          !(
                                            (null ===
                                              (S =
                                                null == U
                                                  ? void 0
                                                  : U.DiscountAndCommissionForCoupon) ||
                                            void 0 === S
                                              ? void 0
                                              : S.SalesRepMaxDiscount) ||
                                            (null ===
                                              (k =
                                                null == U
                                                  ? void 0
                                                  : U.DiscountAndCommissionForCoupon) ||
                                            void 0 === k
                                              ? void 0
                                              : k.SalesRepCommission)
                                          ),
                                        sx: {
                                          textTransform: "capitalize",
                                          width: ne
                                            ? "100% !important"
                                            : "auto !important",
                                        },
                                      },
                                      {
                                        children: [
                                          G,
                                          (0, e.jsx)(OT, {
                                            fontSize: "small",
                                            style: { marginLeft: "5px" },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    ni,
                                    jT(
                                      {
                                        variant: "body2",
                                        sx: { mt: 2, mr: 1, display: "block" },
                                        className: "ST_Error_SuccessMsg_Color",
                                      },
                                      {
                                        children:
                                          G === V("createCoupon_btnlbl2")
                                            ? G
                                            : "",
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    oo,
                    jT(
                      { open: D, onClose: B },
                      {
                        children: (0, e.jsxs)(
                          mn,
                          jT(
                            { sx: re, className: "ST_DC_Modal_CSS" },
                            {
                              children: [
                                (0, e.jsxs)(
                                  qa,
                                  jT(
                                    { container: !0, spacing: 2 },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          jT(
                                            { item: !0, xs: 10, md: 10 },
                                            {
                                              children: (0, e.jsx)(
                                                ni,
                                                jT(
                                                  { variant: "h6" },
                                                  {
                                                    children: V(
                                                      "discountCoupons_header"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          jT(
                                            {
                                              item: !0,
                                              xs: 2,
                                              md: 2,
                                              sx: { textAlign: "right" },
                                            },
                                            {
                                              children: (0, e.jsx)(Fg, {
                                                sx: {
                                                  cursor: "pointer",
                                                  color: "grey",
                                                },
                                                onClick: B,
                                              }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                0 !== (null == j ? void 0 : j.length)
                                  ? (0, e.jsx)(
                                      ep,
                                      jT(
                                        { className: "View_Coupon_Popup" },
                                        {
                                          children: (0, e.jsxs)(
                                            sp,
                                            jT(
                                              {
                                                stickyHeader: !0,
                                                style: {
                                                  border: "1px solid #dadada",
                                                },
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)(hp, {
                                                    children: (0, e.jsxs)(
                                                      Cp,
                                                      jT(
                                                        {
                                                          className:
                                                            "stickyHeaderRow",
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: V(
                                                                      "discountCoupons_tblColumn1"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: V(
                                                                      "discountCoupons_tblColumn2"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: V(
                                                                      "discount_code_copy_coupon"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: V(
                                                                      "discountCoupons_tblColumn3"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }),
                                                  (0, e.jsx)(Dp, {
                                                    children:
                                                      null == j
                                                        ? void 0
                                                        : j.map(function (
                                                            t,
                                                            n
                                                          ) {
                                                            return (0, e.jsxs)(
                                                              Cp,
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Op,
                                                                    jT(
                                                                      {
                                                                        sx: {
                                                                          width:
                                                                            "40%",
                                                                        },
                                                                      },
                                                                      {
                                                                        children:
                                                                          t.CouponeCode,
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsxs)(
                                                                    Op,
                                                                    jT(
                                                                      {
                                                                        sx: {
                                                                          width:
                                                                            "25%",
                                                                        },
                                                                        align:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            t.Discount,
                                                                            "%",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Op,
                                                                    jT(
                                                                      {
                                                                        sx: {
                                                                          width:
                                                                            "10%",
                                                                        },
                                                                        align:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            Gs,
                                                                            jT(
                                                                              {
                                                                                TransitionComponent:
                                                                                  pb,
                                                                                title:
                                                                                  "#05bf05" ===
                                                                                  T[
                                                                                    ""
                                                                                      .concat(
                                                                                        "couponcode",
                                                                                        " "
                                                                                      )
                                                                                      .concat(
                                                                                        n
                                                                                      )
                                                                                  ]
                                                                                    ? V(
                                                                                        "affiliateLink_searchColumn8"
                                                                                      )
                                                                                    : V(
                                                                                        "click_to_copy"
                                                                                      ),
                                                                                placement:
                                                                                  "bottom",
                                                                                arrow:
                                                                                  !0,
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Tb,
                                                                                    {
                                                                                      onClick:
                                                                                        function () {
                                                                                          O(
                                                                                            t.CouponeCode,
                                                                                            ""
                                                                                              .concat(
                                                                                                "couponcode",
                                                                                                " "
                                                                                              )
                                                                                              .concat(
                                                                                                n
                                                                                              )
                                                                                          );
                                                                                        },
                                                                                      style:
                                                                                        {
                                                                                          cursor:
                                                                                            "pointer",
                                                                                          color:
                                                                                            T[
                                                                                              ""
                                                                                                .concat(
                                                                                                  "couponcode",
                                                                                                  " "
                                                                                                )
                                                                                                .concat(
                                                                                                  n
                                                                                                )
                                                                                            ],
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                      }
                                                                    )
                                                                  ),
                                                                  (0, e.jsx)(
                                                                    Op,
                                                                    jT(
                                                                      {
                                                                        sx: {
                                                                          width:
                                                                            "25%",
                                                                        },
                                                                        align:
                                                                          "center",
                                                                      },
                                                                      {
                                                                        children:
                                                                          A &&
                                                                          E ===
                                                                            n
                                                                            ? V(
                                                                                "deleteCoupon_btnlbl"
                                                                              )
                                                                            : (0,
                                                                              e.jsx)(
                                                                                Ev,
                                                                                {
                                                                                  sx: {
                                                                                    cursor:
                                                                                      "pointer",
                                                                                  },
                                                                                  onClick:
                                                                                    function () {
                                                                                      return H(
                                                                                        t,
                                                                                        n
                                                                                      );
                                                                                    },
                                                                                }
                                                                              ),
                                                                      }
                                                                    )
                                                                  ),
                                                                ],
                                                              },
                                                              n
                                                            );
                                                          }),
                                                  }),
                                                ],
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    )
                                  : (0, e.jsx)(
                                      ni,
                                      jT(
                                        {
                                          variant: "body2",
                                          mt: 3,
                                          className: "ST_Error_Msg_Color",
                                        },
                                        {
                                          children: V(
                                            "discountCoupons_nodiscountcoupon"
                                          ),
                                        }
                                      )
                                    ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    um,
                    jT(
                      {
                        anchorOrigin: {
                          vertical: "bottom",
                          horizontal: "center",
                        },
                        open: J.open,
                        autoHideDuration: 4e3,
                        onClose: Y,
                      },
                      {
                        children: (0, e.jsx)(
                          Im,
                          jT(
                            {
                              onClose: Y,
                              severity:
                                null !==
                                  (P = null == J ? void 0 : J.severity) &&
                                void 0 !== P
                                  ? P
                                  : "error",
                              variant: "filled",
                              sx: { width: "100%" },
                            },
                            { children: J.msg }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    Hp,
                    jT(
                      {
                        open: X,
                        onClose: function () {
                          return te(!1);
                        },
                        maxWidth: "sm",
                        fullWidth: !0,
                      },
                      {
                        children: (0, e.jsxs)(
                          mn,
                          jT(
                            { className: "ST_DB_Dialog_Box" },
                            {
                              children: [
                                (0, e.jsxs)(
                                  qa,
                                  jT(
                                    { container: !0, spacing: 2, mb: 2, pl: 2 },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          jT(
                                            { item: !0, xs: 10, md: 10 },
                                            {
                                              children: (0, e.jsx)(
                                                ni,
                                                jT(
                                                  { variant: "h6" },
                                                  {
                                                    children:
                                                      V("commission_list"),
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsx)(
                                          qa,
                                          jT(
                                            {
                                              item: !0,
                                              xs: 2,
                                              md: 2,
                                              sx: { textAlign: "right" },
                                              pr: 1,
                                            },
                                            {
                                              children: (0, e.jsx)(Fg, {
                                                sx: { cursor: "pointer" },
                                                onClick: function () {
                                                  te(!1);
                                                },
                                              }),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Gp,
                                  jT(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: (0, e.jsx)(
                                        ep,
                                        jT(
                                          { sx: { maxHeight: 500, mt: 3 } },
                                          {
                                            children: (0, e.jsxs)(
                                              sp,
                                              jT(
                                                { stickyHeader: !0 },
                                                {
                                                  children: [
                                                    (0, e.jsx)(hp, {
                                                      children: (0, e.jsxs)(
                                                        Cp,
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children:
                                                                      "ProductType" ===
                                                                      ie
                                                                        ? "Product Type"
                                                                        : "Product Name",
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              Op,
                                                              jT(
                                                                {
                                                                  className:
                                                                    "ST_DC_Thead",
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)("b", {
                                                                    children: V(
                                                                      "dashboar_cardHeading2"
                                                                    ),
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      ),
                                                    }),
                                                    ie && "ProductType" === ie
                                                      ? ae(
                                                          null == se
                                                            ? void 0
                                                            : se.CommissionandDiscountPerProductType,
                                                          "productType",
                                                          "ClientCommission"
                                                        )
                                                      : ae(
                                                          null == se
                                                            ? void 0
                                                            : se.CommissionandDiscountPerProduct,
                                                          "ProductName",
                                                          "CommissionForCustomerOrder"
                                                        ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        DT = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z",
          }),
          "ArrowDownward"
        );
      function AT(e) {
        return (0, Zt.ZP)("MuiTableSortLabel", e);
      }
      var ET = (0, Ft.Z)("MuiTableSortLabel", [
        "root",
        "active",
        "icon",
        "iconDirectionDesc",
        "iconDirectionAsc",
      ]);
      const RT = [
          "active",
          "children",
          "className",
          "direction",
          "hideSortIcon",
          "IconComponent",
        ],
        LT = (0, Bt.ZP)(Un, {
          name: "MuiTableSortLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, n.active && t.active];
          },
        })(({ theme: e }) => ({
          cursor: "pointer",
          display: "inline-flex",
          justifyContent: "flex-start",
          flexDirection: "inherit",
          alignItems: "center",
          "&:focus": { color: (e.vars || e).palette.text.secondary },
          "&:hover": {
            color: (e.vars || e).palette.text.secondary,
            [`& .${ET.icon}`]: { opacity: 0.5 },
          },
          [`&.${ET.active}`]: {
            color: (e.vars || e).palette.text.primary,
            [`& .${ET.icon}`]: {
              opacity: 1,
              color: (e.vars || e).palette.text.secondary,
            },
          },
        })),
        BT = (0, Bt.ZP)("span", {
          name: "MuiTableSortLabel",
          slot: "Icon",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.icon, t[`iconDirection${(0, $n.Z)(n.direction)}`]];
          },
        })(({ theme: e, ownerState: t }) =>
          (0, u.Z)(
            {
              fontSize: 18,
              marginRight: 4,
              marginLeft: 4,
              opacity: 0,
              transition: e.transitions.create(["opacity", "transform"], {
                duration: e.transitions.duration.shorter,
              }),
              userSelect: "none",
            },
            "desc" === t.direction && { transform: "rotate(0deg)" },
            "asc" === t.direction && { transform: "rotate(180deg)" }
          )
        );
      var zT = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiTableSortLabel" }),
            {
              active: o = !1,
              children: a,
              className: i,
              direction: s = "asc",
              hideSortIcon: l = !1,
              IconComponent: d = DT,
            } = r,
            c = (0, At.Z)(r, RT),
            p = (0, u.Z)({}, r, {
              active: o,
              direction: s,
              hideSortIcon: l,
              IconComponent: d,
            }),
            m = ((e) => {
              const { classes: t, direction: n, active: r } = e,
                o = {
                  root: ["root", r && "active"],
                  icon: ["icon", `iconDirection${(0, $n.Z)(n)}`],
                };
              return (0, Rt.Z)(o, AT, t);
            })(p);
          return (0,
          e.jsxs)(LT, (0, u.Z)({ className: (0, Et.Z)(m.root, i), component: "span", disableRipple: !0, ownerState: p, ref: n }, c, { children: [a, l && !o ? null : (0, e.jsx)(BT, { as: d, className: (0, Et.Z)(m.icon), ownerState: p })] }));
        }),
        FT = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        ZT = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function HT() {
        var e,
          n,
          r,
          o,
          a,
          i = this,
          s = g(),
          l = ee().t,
          d = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          c = F.getState().salesRepData.loggedInRepDetails.currency,
          u = Tv(),
          p = [
            {
              id: "ClientName",
              label: l("myCustomers_table1Column1"),
              inlineCSS: { width: "30%" },
            },
            {
              id: "companyName",
              label: l("myCustomers_table1Column2"),
              inlineCSS: { width: "25%" },
            },
            {
              id: "CustomerMailid",
              label: l("myCustomers_table1Column3"),
              inlineCSS: { width: "30%" },
            },
            {
              id: "shopifyOrdersCount",
              label: l("myCustomers_table1Column4"),
              inlineCSS: { width: "15%", textAlign: "center" },
            },
          ],
          m = [
            { label: l("myOrders_table1Column1") },
            { label: l("myOrders_table1Column2") },
            { label: l("myOrders_table1Column4") },
            { label: l("myOrders_table1Column5") },
            { label: l("myOrders_content1") + "(" + d + ")" },
            { label: l("myOrders_content3") + "(" + d + ")" },
            { label: l("myOrders_content2") + "(" + d + ")" },
            { label: l("myOrders_content4") + "(" + d + ")" },
          ],
          h = [
            { label: l("myOrders_table2Column1") },
            { label: l("myOrders_table2Column2") },
            { label: l("variant_title") },
            { label: "SKU" },
            { label: l("myOrders_table2Column3") },
            { label: l("myOrders_table2Column4") + "(" + d + ")" },
            { label: l("viewProductModelColumn6") + "(" + d + ")" },
            { label: l("myOrders_table2Column5") },
            { label: l("myOrders_table2Column6") },
            { label: l("myOrders_table2Column7") + "(" + d + ")" },
          ],
          f = F.getState().salesRepData.baseData.ClientOrders,
          v = (0, t.useState)("asc"),
          b = v[0],
          _ = v[1],
          y = (0, t.useState)("name"),
          C = y[0],
          S = y[1],
          k = (0, t.useState)(""),
          P = k[0],
          w = k[1],
          O = (0, t.useState)(f),
          T = O[0],
          I = O[1],
          M = (0, t.useState)(!1),
          j = M[0],
          N = M[1],
          D = (0, t.useState)(!1),
          A = D[0],
          E = D[1],
          R = (0, t.useState)(!0),
          L = R[0],
          B = R[1],
          z = (0, t.useState)(!0),
          Z = z[0],
          H = z[1],
          V = (0, t.useState)([]),
          W = V[0],
          U = V[1],
          $ = (0, t.useState)([]),
          K = $[0],
          G = $[1],
          q = (0, t.useState)(),
          Q = q[0],
          Y = q[1],
          J = (0, t.useState)(!1),
          X = J[0],
          te = J[1],
          ne = (0, t.useState)(
            null !==
              (o =
                null ===
                  (r =
                    null ===
                      (n =
                        null === (e = F.getState().salesRepData) || void 0 === e
                          ? void 0
                          : e.baseData) || void 0 === n
                      ? void 0
                      : n.ClientOrders) || void 0 === r
                  ? void 0
                  : r.length) && void 0 !== o
              ? o
              : 0
          ),
          re = ne[0],
          oe = ne[1],
          ae = (0, t.useState)(""),
          ie = ae[0],
          se = ae[1],
          le = (function (e, t, n) {
            if (n || 2 === arguments.length)
              for (var r, o = 0, a = t.length; o < a; o++)
                (!r && o in t) ||
                  (r || (r = Array.prototype.slice.call(t, 0, o)),
                  (r[o] = t[o]));
            return e.concat(r || Array.prototype.slice.call(t));
          })([], f, !0),
          de = "",
          ce = (0, t.useState)(
            F.getState().salesRepData.baseData.hideCompanyAddressInAddCustomer
          ),
          ue = ce[0];
        ce[1],
          Bh.subscribe(function (e) {
            e !== X && te(e);
          }),
          (0, t.useEffect)(function () {
            pe("");
          }, []);
        var pe = function (e) {
            e === C
              ? _((de = "asc" === b ? "desc" : "asc"))
              : (_((de = "asc")), S(e)),
              me(e);
          },
          me = function (e) {
            var t, n;
            "asc" === de
              ? T.sort(function (r, o) {
                  return x(r[e]) && "string" == typeof o[e]
                    ? (void 0 !== r[e] &&
                        null !== r[e] &&
                        "" !== r[e] &&
                        void 0 !== o[e] &&
                        null !== o[e] &&
                        "" !== o[e] &&
                        ((t = r[e].toLowerCase()), (n = o[e].toLowerCase())),
                      t > n ? 1 : -1)
                    : r[e] - o[e];
                })
              : T.sort(function (r, o) {
                  return x(r[e]) && "string" == typeof o[e]
                    ? (void 0 !== r[e] &&
                        null !== r[e] &&
                        "" !== r[e] &&
                        void 0 !== o[e] &&
                        null !== o[e] &&
                        "" !== o[e] &&
                        ((t = r[e].toLowerCase()), (n = o[e].toLowerCase())),
                      t < n ? 1 : -1)
                    : o[e] - r[e];
                }),
              I(T);
          };
        return {
          openDialog: j,
          handleNewCustomerModal: function () {
            N(!j);
          },
          filterState: P,
          applyFilter: function (e) {
            w(e.target.value),
              (le =
                null == le
                  ? void 0
                  : le.filter(function (t) {
                      var n,
                        r,
                        o,
                        a,
                        i = (null !== (n = null == t ? void 0 : t.ClientName) &&
                        void 0 !== n
                          ? n
                          : ""
                        ).trim()
                          ? null == t
                            ? void 0
                            : t.ClientName
                          : null !==
                              (r = null == t ? void 0 : t.CustomerMailid) &&
                            void 0 !== r
                          ? r
                          : "";
                      return (
                        (null === (o = null == i ? void 0 : i.toLowerCase()) ||
                        void 0 === o
                          ? void 0
                          : o.includes(e.target.value.toLowerCase())) ||
                        (void 0 !== t.companyName &&
                          null !== t.companyName &&
                          "" !== t.companyName &&
                          (null === (a = t.companyName.toLowerCase()) ||
                          void 0 === a
                            ? void 0
                            : a.includes(e.target.value.toLowerCase())))
                      );
                    })),
              I(le);
          },
          HeaderNames: p,
          sortHeaderData: pe,
          byColumnName: C,
          orderType: b,
          customerArray: T,
          setOpenDialog: N,
          isAddCustomer: L,
          setIsAddCustomer: B,
          getOrderCountDetails: function (e) {
            return FT(i, void 0, void 0, function () {
              var t;
              return ZT(this, function (n) {
                switch (n.label) {
                  case 0:
                    return (a = e), Bh.next(!0), [4, s(dg(e))];
                  case 1:
                    return (
                      (t = n.sent()),
                      H(!0),
                      U(t.clientallorders ? t.clientallorders : []),
                      Bh.next(!1),
                      E(!0),
                      [2]
                    );
                }
              });
            });
          },
          orderCountDialog: A,
          setOrderCountDialog: E,
          OrderDetailsHeaderNames: m,
          getOrderWiseProductsData: function (e) {
            return FT(i, void 0, void 0, function () {
              var t, n;
              return ZT(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      (t = { order_id: e.order_id, clientId: a }),
                      Bh.next(!0),
                      Y(e),
                      [4, s(cg(t))]
                    );
                  case 1:
                    return (
                      (n = r.sent()),
                      H(!1),
                      G(n.ProductDetails),
                      Bh.next(!1),
                      [2]
                    );
                }
              });
            });
          },
          orderDetailsArray: W,
          orderWiseProductDetailsArray: K,
          orderCountFlag: Z,
          setOrderCountFlag: H,
          ProductDetailsHeaderNames: h,
          activeClientObj: Q,
          loadingDisabled: X,
          t: l,
          shopCurrency: d,
          hideCompanySection: ue,
          isMobile: u,
          allCustomerCounts: re,
          setAllCustomerCounts: oe,
          setCustomerArray: I,
          singleCustomerId: ie,
          OpenAddCustomerModal: function () {
            N(!0), B(!0);
          },
          handleSingleCustomerId: function (e) {
            se(e), N(!0), B(!1);
          },
          currency: c,
        };
      }
      var VT = o(6693),
        WT = function () {
          return (
            (WT =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            WT.apply(this, arguments)
          );
        },
        UT = function (n) {
          var r = n.tableType,
            o = n.headerArray,
            a = n.dataArray,
            i = n.getProductData,
            s = HT(),
            l = s.shopCurrency,
            d = s.t,
            c = xv().getDateFormat,
            u = function (t, n) {
              var r;
              switch (t) {
                case 0:
                  r = (0, e.jsx)(
                    Op,
                    WT(
                      {
                        sx: WT(WT({}, Lo), { padding: "8px !important" }),
                        onClick: function () {
                          return i(n);
                        },
                      },
                      { children: n.order_number }
                    )
                  );
                  break;
                case 1:
                  r = (0, e.jsx)(Op, {
                    children: c(null == n ? void 0 : n.created_at),
                  });
                  break;
                case 2:
                  r = (0, e.jsx)(Op, { children: n.financial_status || "-" });
                  break;
                case 3:
                  r = (0, e.jsx)(Op, { children: n.fulfillment_status || "-" });
                  break;
                case 4:
                  r = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      { children: l + " " + n.subtotal_price.toFixed(2) }
                    )
                  );
                  break;
                case 5:
                  r = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      { children: l + " " + n.shippingCharges || "0.00" }
                    )
                  );
                  break;
                case 6:
                  r = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      { children: l + " " + n.total_tax }
                    )
                  );
                  break;
                case 7:
                  r = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      { children: l + " " + n.total_price.toFixed(2) }
                    )
                  );
              }
              return r;
            },
            p = function (t, n) {
              var r, o, a;
              switch (t) {
                case 0:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.Image)
                      ? (0, e.jsx)(mn, {
                          component: "img",
                          sx: Vo,
                          src: null == n ? void 0 : n.Image,
                        })
                      : (0, e.jsx)(VT.Z, { sx: { height: 50, width: 50 } }),
                  });
                  break;
                case 1:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.Title) || "-",
                  });
                  break;
                case 2:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.variantTitle) || "-",
                  });
                  break;
                case 3:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.SKU) || "-",
                  });
                  break;
                case 4:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.quantity) || "-",
                  });
                  break;
                case 5:
                  a = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      {
                        children:
                          l +
                            " " +
                            (null === (r = null == n ? void 0 : n.ItemPrice) ||
                            void 0 === r
                              ? void 0
                              : r.toFixed(2)) || "0.00",
                      }
                    )
                  );
                  break;
                case 6:
                  a = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      {
                        children:
                          l +
                            " " +
                            (null ===
                              (o = null == n ? void 0 : n.discountedPrice) ||
                            void 0 === o
                              ? void 0
                              : o.toFixed(2)) || "0.00",
                      }
                    )
                  );
                  break;
                case 7:
                  a = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      {
                        children:
                          l + " " + (null == n ? void 0 : n.trackingNumber) ||
                          "-",
                      }
                    )
                  );
                  break;
                case 8:
                  a = (0, e.jsx)(Op, {
                    children: c(null == n ? void 0 : n.ShipDate),
                  });
                  break;
                case 9:
                  a = (0, e.jsx)(
                    Op,
                    WT(
                      { className: "ST_White_Space" },
                      {
                        children:
                          l + " " + (null == n ? void 0 : n.Subtotal) || "-",
                      }
                    )
                  );
              }
              return a;
            };
          return "1" === r
            ? (0, e.jsx)(
                ep,
                WT(
                  { sx: { borderRadius: "0px !important" } },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      WT(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return (0,
                                                      e.jsxs)(Cp, WT({ className: "MobileViewTableCell" }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [null == t ? void 0 : t.label, " :"] }) }), u(r, n)] }), t.label + r);
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  WT(
                                    { className: "BorderBottom" },
                                    { children: d("no_orders_to_show") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              )
            : (0, e.jsx)(
                ep,
                WT(
                  { sx: { borderRadius: "0px !important" } },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      WT(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return (0,
                                                      e.jsxs)(Cp, WT({ className: "MobileViewTableCell" }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), p(r, n)] }), t.label + r);
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  WT(
                                    { className: "BorderBottom" },
                                    { children: d("no_product_details") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              );
        },
        $T = function () {
          return (
            ($T =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            $T.apply(this, arguments)
          );
        },
        KT = function () {
          var t = HT(),
            n = t.openDialog,
            r = t.handleNewCustomerModal,
            o = t.filterState,
            a = t.applyFilter,
            i = t.HeaderNames,
            s = t.sortHeaderData,
            l = t.byColumnName,
            d = t.orderType,
            c = t.customerArray,
            u = t.isAddCustomer,
            p = t.getOrderCountDetails,
            m = t.orderCountDialog,
            h = t.setOrderCountDialog,
            f = t.OrderDetailsHeaderNames,
            g = t.getOrderWiseProductsData,
            v = t.orderDetailsArray,
            b = t.orderWiseProductDetailsArray,
            _ = t.orderCountFlag,
            y = t.setOrderCountFlag,
            C = t.ProductDetailsHeaderNames,
            x = t.activeClientObj,
            S = t.loadingDisabled,
            k = t.t,
            P = t.shopCurrency,
            w = t.hideCompanySection,
            O = t.isMobile,
            T = t.allCustomerCounts,
            I = t.setAllCustomerCounts,
            M = t.setCustomerArray,
            j = t.singleCustomerId,
            N = t.OpenAddCustomerModal,
            D = t.handleSingleCustomerId,
            A = t.currency,
            E = { padding: "10px", fontSize: "12px", whiteSpace: "nowrap" },
            R = xv().getDateFormat;
          return (0, e.jsxs)(
            uC,
            $T(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    qa,
                    $T(
                      { container: !0, spacing: 2 },
                      {
                        children: [
                          (0, e.jsx)(
                            qa,
                            $T(
                              { item: !0, xs: 6, md: 8, mb: 2, sx: $o },
                              {
                                children: (0, e.jsx)(
                                  ni,
                                  $T(
                                    { variant: Av, mb: 4, sx: $T({}, Ko) },
                                    { children: k("tab_MyCustomers") }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            qa,
                            $T(
                              {
                                item: !0,
                                xs: 12,
                                md: 4,
                                sx: { textAlign: "right" },
                              },
                              {
                                children: [
                                  (0, e.jsx)(
                                    Qu,
                                    $T(
                                      {
                                        className: "ST_B2B_HowItWorksButton",
                                        variant: "outlined",
                                        target: "_blank",
                                        href: "https://youtu.be/vnBMqQ4miXc?si=hKS92TyqvrjPwndn",
                                        startIcon: O_,
                                      },
                                      { children: k("dashbord_Msg_New") }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    Qu,
                                    $T(
                                      {
                                        variant: "contained",
                                        onClick: function () {
                                          N();
                                        },
                                        sx: {
                                          textTransform: "capitalize",
                                          whiteSpace: "nowrap",
                                          height: "40px",
                                          marginLeft: "20px",
                                          padding: "9px 15px",
                                        },
                                      },
                                      {
                                        children: [
                                          k("tab9_AddCustomer"),
                                          (0, e.jsx)(Ob, {
                                            fontSize: "small",
                                            style: { marginLeft: "5px" },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                          (0, e.jsx)(
                            qa,
                            $T(
                              { item: !0, xs: 12, md: 6, mb: 3 },
                              {
                                children: (0, e.jsx)(Hc, {
                                  sx: {
                                    display: "flex",
                                    backgroundColor: "white",
                                  },
                                  id: "ST_MC_Search",
                                  placeholder: k(
                                    "myCustomers_searchByCustomerOrCompanyName"
                                  ),
                                  value: o,
                                  hiddenLabel: !0,
                                  variant: "outlined",
                                  onChange: function (e) {
                                    return a(e);
                                  },
                                  InputProps: {
                                    startAdornment: (0, e.jsx)(
                                      Bu,
                                      $T(
                                        {
                                          position: "end",
                                          title: k("myCustomers_searchButton"),
                                        },
                                        {
                                          children: (0, e.jsx)(Rv, {
                                            className: "ST_MC_Search_Icon",
                                          }),
                                        }
                                      )
                                    ),
                                  },
                                }),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    qa,
                    $T(
                      {
                        item: !0,
                        xs: 12,
                        container: !0,
                        justifyContent: "flex-end",
                      },
                      {
                        children: (0, e.jsx)(
                          "span",
                          $T(
                            {
                              className: "text-gray-600",
                              style: { margin: "10px" },
                            },
                            {
                              children: o
                                ? "Showing "
                                    .concat(
                                      null == c ? void 0 : c.length,
                                      " out of "
                                    )
                                    .concat(T, " customers")
                                : ""
                                    .concat(k("showing"), " ")
                                    .concat(T, " ")
                                    .concat(k("customers")),
                            }
                          )
                        ),
                      }
                    )
                  ),
                  (0, e.jsx)(
                    ep,
                    $T(
                      { sx: Ho },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          $T(
                            { stickyHeader: !0 },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsx)(Cp, {
                                    children:
                                      null == i
                                        ? void 0
                                        : i.map(function (t, n) {
                                            return (0, e.jsx)(
                                              Op,
                                              $T(
                                                {
                                                  onClick: function () {
                                                    return s(
                                                      null == t ? void 0 : t.id
                                                    );
                                                  },
                                                  sx: $T(
                                                    $T(
                                                      { whiteSpace: "nowrap" },
                                                      t.inlineCSS
                                                    ),
                                                    {
                                                      display:
                                                        w &&
                                                        "companyName" === t.id
                                                          ? "none"
                                                          : "",
                                                      fontSize: "13px",
                                                    }
                                                  ),
                                                },
                                                {
                                                  children: (0, e.jsx)(
                                                    zT,
                                                    $T(
                                                      {
                                                        active:
                                                          l ===
                                                          (null == t
                                                            ? void 0
                                                            : t.id),
                                                        direction: d,
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "b",
                                                          { children: t.label }
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                }
                                              ),
                                              null == t ? void 0 : t.id
                                            );
                                          }),
                                  }),
                                }),
                                (0, e.jsx)(
                                  Dp,
                                  $T(
                                    { className: "ST_MC_Thead" },
                                    {
                                      children:
                                        (null == c ? void 0 : c.length) > 0
                                          ? null == c
                                            ? void 0
                                            : c.map(function (t, n) {
                                                var r;
                                                return (0, e.jsxs)(
                                                  Cp,
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        Op,
                                                        $T(
                                                          {
                                                            sx: Lo,
                                                            onClick:
                                                              function () {
                                                                return D(
                                                                  null == t
                                                                    ? void 0
                                                                    : t.CustomerId
                                                                );
                                                              },
                                                          },
                                                          {
                                                            children: (null !==
                                                              (r =
                                                                null == t
                                                                  ? void 0
                                                                  : t.ClientName) &&
                                                            void 0 !== r
                                                              ? r
                                                              : ""
                                                            ).trim()
                                                              ? null == t
                                                                ? void 0
                                                                : t.ClientName
                                                              : null == t
                                                              ? void 0
                                                              : t.CustomerMailid,
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        Op,
                                                        $T(
                                                          {
                                                            sx: {
                                                              textTransform:
                                                                "capitalize",
                                                              display: w
                                                                ? "none"
                                                                : "",
                                                            },
                                                          },
                                                          {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.companyName) ||
                                                              "-",
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(Op, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.CustomerMailid) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsx)(
                                                        Op,
                                                        $T(
                                                          {
                                                            align: "center",
                                                            sx:
                                                              (null == t
                                                                ? void 0
                                                                : t.shopifyOrdersCount) >
                                                              0
                                                                ? Lo
                                                                : void 0,
                                                            onClick:
                                                              function () {
                                                                return (null ==
                                                                t
                                                                  ? void 0
                                                                  : t.shopifyOrdersCount) >
                                                                  0
                                                                  ? p(
                                                                      null == t
                                                                        ? void 0
                                                                        : t.CustomerId
                                                                    )
                                                                  : "";
                                                              },
                                                          },
                                                          {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.shopifyOrdersCount) >
                                                              0
                                                                ? "View"
                                                                : "-",
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  },
                                                  n
                                                );
                                              })
                                          : (0, e.jsx)(Cp, {
                                              children: (0, e.jsx)(
                                                Op,
                                                $T(
                                                  {
                                                    align: "center",
                                                    colSpan: 4,
                                                  },
                                                  {
                                                    children: k(
                                                      "myCustomer_no_salesRep_details"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                  n &&
                    (0, e.jsx)(tC, {
                      indexFrom: 2,
                      openPopUp: n,
                      closeModal: r,
                      singleCustomerId: j,
                      isAddCustomer: u,
                      setAllCustomerCounts: I,
                      setCustomerArray: M,
                    }),
                  (0, e.jsxs)(
                    Hp,
                    $T(
                      {
                        open: m,
                        onClose: function () {
                          h(!1), y(!1);
                        },
                        maxWidth: "xl",
                        fullWidth: !0,
                        sx: { pointerEvents: S ? "none" : "all" },
                      },
                      {
                        children: [
                          (0, e.jsxs)(
                            uC,
                            $T(
                              { className: "ST_MC_Dialog_Box", hidden: !_ },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    qa,
                                    $T(
                                      { container: !0, spacing: 2, mb: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            $T(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  $T(
                                                    { variant: "h6" },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "b",
                                                        {
                                                          children:
                                                            k("client_orders"),
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            $T(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                              },
                                              {
                                                children: (0, e.jsx)(Fg, {
                                                  sx: {
                                                    cursor: "pointer",
                                                    color: "#9b9999",
                                                  },
                                                  onClick: function () {
                                                    h(!1);
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (null == v ? void 0 : v.length) > 0
                                    ? (0, e.jsx)(
                                        Gp,
                                        $T(
                                          { sx: { padding: "0px" } },
                                          {
                                            children: O
                                              ? (0, e.jsx)(UT, {
                                                  tableType: "1",
                                                  headerArray: f,
                                                  dataArray: v,
                                                  getProductData: g,
                                                })
                                              : (0, e.jsx)(
                                                  ep,
                                                  $T(
                                                    { sx: $T({ mt: 1 }, Ho) },
                                                    {
                                                      children: (0, e.jsxs)(
                                                        sp,
                                                        $T(
                                                          { stickyHeader: !0 },
                                                          {
                                                            children: [
                                                              (0, e.jsx)(hp, {
                                                                children: (0,
                                                                e.jsx)(
                                                                  Cp,
                                                                  $T(
                                                                    {
                                                                      className:
                                                                        "stickyHeaderRow",
                                                                    },
                                                                    {
                                                                      children:
                                                                        null ==
                                                                        f
                                                                          ? void 0
                                                                          : f.map(
                                                                              function (
                                                                                t,
                                                                                n
                                                                              ) {
                                                                                return (0,
                                                                                e.jsx)(
                                                                                  Op,
                                                                                  $T(
                                                                                    {
                                                                                      sx: {
                                                                                        whiteSpace:
                                                                                          "nowrap",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          "b",
                                                                                          {
                                                                                            children:
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.label,
                                                                                          }
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                  (null ==
                                                                                  t
                                                                                    ? void 0
                                                                                    : t.label) +
                                                                                    "_" +
                                                                                    n
                                                                                );
                                                                              }
                                                                            ),
                                                                    }
                                                                  )
                                                                ),
                                                              }),
                                                              (0, e.jsx)(
                                                                Dp,
                                                                $T(
                                                                  {
                                                                    className:
                                                                      "ST_MC_Thead",
                                                                  },
                                                                  {
                                                                    children:
                                                                      null == v
                                                                        ? void 0
                                                                        : v.map(
                                                                            function (
                                                                              t,
                                                                              n
                                                                            ) {
                                                                              return (0,
                                                                              e.jsxs)(
                                                                                Cp,
                                                                                {
                                                                                  children:
                                                                                    [
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Op,
                                                                                        $T(
                                                                                          {
                                                                                            component:
                                                                                              "th",
                                                                                            scope:
                                                                                              "row",
                                                                                            sx: Lo,
                                                                                            onClick:
                                                                                              function () {
                                                                                                return g(
                                                                                                  t
                                                                                                );
                                                                                              },
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.order_number,
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Op,
                                                                                        {
                                                                                          children:
                                                                                            R(
                                                                                              null ==
                                                                                                t
                                                                                                ? void 0
                                                                                                : t.created_at
                                                                                            ),
                                                                                        }
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Op,
                                                                                        {
                                                                                          children:
                                                                                            (null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.financial_status) ||
                                                                                            "-",
                                                                                        }
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Op,
                                                                                        {
                                                                                          children:
                                                                                            (null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.fulfillment_status) ||
                                                                                            "-",
                                                                                        }
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        Op,
                                                                                        $T(
                                                                                          {
                                                                                            className:
                                                                                              "ST_White_Space",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                P +
                                                                                                  " ",
                                                                                                null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.subtotal_price.toFixed(
                                                                                                      2
                                                                                                    ),
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        Op,
                                                                                        $T(
                                                                                          {
                                                                                            className:
                                                                                              "ST_White_Space",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                P +
                                                                                                  " ",
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.shippingCharges) ||
                                                                                                  "0.00",
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        Op,
                                                                                        $T(
                                                                                          {
                                                                                            className:
                                                                                              "ST_White_Space",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                P +
                                                                                                  " ",
                                                                                                null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.total_tax,
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        Op,
                                                                                        $T(
                                                                                          {
                                                                                            className:
                                                                                              "ST_White_Space",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                P +
                                                                                                  " ",
                                                                                                null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.total_price.toFixed(
                                                                                                      2
                                                                                                    ),
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                    ],
                                                                                },
                                                                                n
                                                                              );
                                                                            }
                                                                          ),
                                                                  }
                                                                )
                                                              ),
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                          }
                                        )
                                      )
                                    : (0, e.jsx)(
                                        Gp,
                                        $T(
                                          { sx: { padding: "0px" } },
                                          { children: k("no_orders_to_show") }
                                        )
                                      ),
                                ],
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            uC,
                            $T(
                              { className: "ST_MC_Dialog_Box", hidden: _ },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    qa,
                                    $T(
                                      { container: !0, spacing: 2, mb: 2 },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            qa,
                                            $T(
                                              { item: !0, xs: 10, md: 10 },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  $T(
                                                    { variant: "h6" },
                                                    {
                                                      children: k(
                                                        "viewRepClientOrdersDetails_column5"
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            qa,
                                            $T(
                                              {
                                                item: !0,
                                                xs: 2,
                                                md: 2,
                                                sx: { textAlign: "right" },
                                              },
                                              {
                                                children: (0, e.jsx)(Fg, {
                                                  sx: { cursor: "pointer" },
                                                  onClick: function () {
                                                    y(!0);
                                                  },
                                                }),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  b && (null == b ? void 0 : b.length) > 0
                                    ? (0, e.jsxs)(
                                        Gp,
                                        $T(
                                          { sx: { padding: "0px" } },
                                          {
                                            children: [
                                              x
                                                ? (0, e.jsx)(uC, {
                                                    children: (0, e.jsxs)(
                                                      qa,
                                                      $T(
                                                        {
                                                          container: !0,
                                                          spacing: 2,
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "viewRepClientOrdersDetails_column1"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.order_number,
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "viewRepClientOrdersDetails_column3"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            P +
                                                                              " ",
                                                                            (null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.subtotal_price.toFixed(
                                                                                  2
                                                                                )) ||
                                                                              "0.00",
                                                                            " ",
                                                                            " " +
                                                                              (null !=
                                                                              A
                                                                                ? A
                                                                                : ""),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "myOrders_content3"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            P +
                                                                              " ",
                                                                            (null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.shippingCharges) ||
                                                                              "0.00",
                                                                            " ",
                                                                            " " +
                                                                              (null !=
                                                                              A
                                                                                ? A
                                                                                : ""),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "myOrders_content2"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            P +
                                                                              " ",
                                                                            (null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.total_tax) ||
                                                                              "0.00",
                                                                            " ",
                                                                            " " +
                                                                              (null !=
                                                                              A
                                                                                ? A
                                                                                : ""),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "myOrders_table2Column7"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            P +
                                                                              " ",
                                                                            (null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.total_price.toFixed(
                                                                                  2
                                                                                )) ||
                                                                              "0.00",
                                                                            " ",
                                                                            " " +
                                                                              (null !=
                                                                              A
                                                                                ? A
                                                                                : ""),
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              qa,
                                                              $T(
                                                                {
                                                                  item: !0,
                                                                  xs: 12,
                                                                  md: 4,
                                                                  mb: 1,
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsxs)(
                                                                    ni,
                                                                    $T(
                                                                      {
                                                                        variant:
                                                                          "body2",
                                                                      },
                                                                      {
                                                                        children:
                                                                          [
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "b",
                                                                              {
                                                                                children:
                                                                                  [
                                                                                    k(
                                                                                      "myOrders_content5"
                                                                                    ),
                                                                                    " :",
                                                                                  ],
                                                                              }
                                                                            ),
                                                                            " ",
                                                                            (null ==
                                                                            x
                                                                              ? void 0
                                                                              : x.note) ||
                                                                              "-",
                                                                          ],
                                                                      }
                                                                    )
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  })
                                                : "",
                                              O
                                                ? (0, e.jsx)(UT, {
                                                    tableType: "2",
                                                    headerArray: C,
                                                    dataArray: b,
                                                  })
                                                : (0, e.jsx)(
                                                    ep,
                                                    $T(
                                                      {
                                                        sx: $T(
                                                          $T({ mt: 1 }, Ho),
                                                          {
                                                            borderTop:
                                                              "1px solid #dadada",
                                                          }
                                                        ),
                                                      },
                                                      {
                                                        children: (0, e.jsxs)(
                                                          sp,
                                                          $T(
                                                            {
                                                              stickyHeader: !0,
                                                            },
                                                            {
                                                              children: [
                                                                (0, e.jsx)(hp, {
                                                                  children: (0,
                                                                  e.jsx)(Cp, {
                                                                    children:
                                                                      null == C
                                                                        ? void 0
                                                                        : C.map(
                                                                            function (
                                                                              t,
                                                                              n
                                                                            ) {
                                                                              return (0,
                                                                              e.jsx)(
                                                                                Op,
                                                                                $T(
                                                                                  {
                                                                                    sx: E,
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        "b",
                                                                                        {
                                                                                          children:
                                                                                            null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.label,
                                                                                        }
                                                                                      ),
                                                                                  }
                                                                                ),
                                                                                (null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.label) +
                                                                                  "_" +
                                                                                  n
                                                                              );
                                                                            }
                                                                          ),
                                                                  }),
                                                                }),
                                                                (0, e.jsx)(
                                                                  Dp,
                                                                  $T(
                                                                    {
                                                                      className:
                                                                        "ST_MC_Thead",
                                                                    },
                                                                    {
                                                                      children:
                                                                        null ==
                                                                        b
                                                                          ? void 0
                                                                          : b.map(
                                                                              function (
                                                                                t,
                                                                                n
                                                                              ) {
                                                                                return (0,
                                                                                e.jsxs)(
                                                                                  Cp,
                                                                                  {
                                                                                    children:
                                                                                      [
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              component:
                                                                                                "th",
                                                                                              scope:
                                                                                                "row",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (
                                                                                                  null ==
                                                                                                  t
                                                                                                    ? void 0
                                                                                                    : t.Image
                                                                                                )
                                                                                                  ? (0,
                                                                                                    e.jsx)(
                                                                                                      uC,
                                                                                                      {
                                                                                                        component:
                                                                                                          "img",
                                                                                                        sx: Vo,
                                                                                                        src:
                                                                                                          null ==
                                                                                                          t
                                                                                                            ? void 0
                                                                                                            : t.Image,
                                                                                                      }
                                                                                                    )
                                                                                                  : (0,
                                                                                                    e.jsx)(
                                                                                                      VT.Z,
                                                                                                      {
                                                                                                        sx: {
                                                                                                          height: 50,
                                                                                                          width: 50,
                                                                                                        },
                                                                                                      }
                                                                                                    ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              sx: {
                                                                                                width:
                                                                                                  "10%",
                                                                                              },
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.Title) ||
                                                                                                "-",
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              sx: {
                                                                                                width:
                                                                                                  "10%",
                                                                                              },
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (null ==
                                                                                                t
                                                                                                  ? void 0
                                                                                                  : t.variantTitle) ||
                                                                                                "-",
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          {
                                                                                            children:
                                                                                              (null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.SKU) ||
                                                                                              "-",
                                                                                          }
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          {
                                                                                            children:
                                                                                              null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.quantity,
                                                                                          }
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsxs)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              className:
                                                                                                "ST_White_Space",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                [
                                                                                                  P +
                                                                                                    " ",
                                                                                                  (null ==
                                                                                                  t
                                                                                                    ? void 0
                                                                                                    : t.ItemPrice.toFixed(
                                                                                                        2
                                                                                                      )) ||
                                                                                                    "0.00",
                                                                                                ],
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsxs)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              className:
                                                                                                "ST_White_Space",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                [
                                                                                                  P +
                                                                                                    " ",
                                                                                                  (null ==
                                                                                                  t
                                                                                                    ? void 0
                                                                                                    : t.discountedPrice.toFixed(
                                                                                                        2
                                                                                                      )) ||
                                                                                                    "0.00",
                                                                                                ],
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          {
                                                                                            children:
                                                                                              (null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.trackingNumber) ||
                                                                                              "-",
                                                                                          }
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              sx: {
                                                                                                width:
                                                                                                  "9%",
                                                                                              },
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                R(
                                                                                                  null ==
                                                                                                    t
                                                                                                    ? void 0
                                                                                                    : t.ShipDate
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                        (0,
                                                                                        e.jsxs)(
                                                                                          Op,
                                                                                          $T(
                                                                                            {
                                                                                              sx: {
                                                                                                width:
                                                                                                  "9%",
                                                                                              },
                                                                                              className:
                                                                                                "ST_White_Space",
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                [
                                                                                                  P +
                                                                                                    " ",
                                                                                                  (null ==
                                                                                                  t
                                                                                                    ? void 0
                                                                                                    : t.Subtotal.toFixed(
                                                                                                        2
                                                                                                      )) ||
                                                                                                    "0.00",
                                                                                                ],
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                      ],
                                                                                  },
                                                                                  n
                                                                                );
                                                                              }
                                                                            ),
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                            ],
                                          }
                                        )
                                      )
                                    : (0, e.jsxs)(
                                        Gp,
                                        $T(
                                          { sx: { padding: "0px" } },
                                          {
                                            children: [
                                              k("no_product_details"),
                                              ".",
                                            ],
                                          }
                                        )
                                      ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        GT = o(3162),
        qT = o.n(GT),
        QT = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        YT = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        };
      function JT() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s,
          l = this,
          d = ee().t,
          c = g(),
          u = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          p = F.getState().salesRepData.loggedInRepDetails.currency,
          m =
            null !== (e = F.getState().salesRepData.baseData.select) &&
            void 0 !== e
              ? e
              : {},
          h = [
            { label: d("draftOrder_OrderNumber") },
            { label: d("draftOrder_CustName") },
            {
              label: d("salesDetailsHeader_Company"),
              hidden: !(null == m ? void 0 : m.CreateB2BOrder),
            },
            {
              label: d("salesDetailsHeader_Location"),
              hidden: !(null == m ? void 0 : m.CreateB2BOrder),
            },
            { label: d("draftOrder_OrderDate") },
            {
              label: d("draftOrder_SubTotal") + "(" + u + ")",
              inlineCSS: { textAlign: "center" },
            },
            {
              label: d("draftOrder_Status"),
              inlineCSS: { textAlign: "center" },
            },
            {
              label: d("draftOrder_Invoice"),
              inlineCSS: { textAlign: "center" },
            },
          ],
          f = [
            { label: d("draftOrder_Product") },
            { label: d("draftOrder_ProductName") },
            { label: d("draftOrder_Size") },
            { label: d("draftOrder_Quantity") },
            { label: d("draftOrder_Price") },
            { label: d("draftOrder_Status") },
            { label: d("draftOrder_SubTotal") },
          ],
          v = function (e) {
            var t;
            return null !==
              (t =
                null == e
                  ? void 0
                  : e.filter(function (e) {
                      return (
                        "open" === (null == e ? void 0 : e.status) ||
                        "voided" === (null == e ? void 0 : e.status)
                      );
                    })) && void 0 !== t
              ? t
              : [];
          },
          b = (0, t.useState)(!1),
          _ = b[0],
          y = b[1],
          C = (0, t.useState)(
            null !==
              (o = v(
                null ===
                  (r =
                    null === (n = null == F ? void 0 : F.getState()) ||
                    void 0 === n
                      ? void 0
                      : n.salesRepData) || void 0 === r
                  ? void 0
                  : r.draftOrderData
              )) && void 0 !== o
              ? o
              : []
          ),
          x = C[0],
          S = C[1],
          k = (0, t.useState)(),
          P = k[0],
          w = k[1],
          O = (0, t.useState)([]),
          T = O[0],
          I = O[1],
          M = (0, t.useState)(0),
          j = M[0],
          N = M[1],
          D = (0, t.useState)(!1),
          E = D[0],
          R = D[1],
          L = (0, t.useState)(0),
          B = L[0],
          z = L[1],
          Z = (0, t.useState)(!1),
          H = Z[0],
          V = Z[1],
          W = (0, t.useState)(!1),
          U = W[0],
          $ = W[1],
          K = (0, t.useState)(null),
          G = K[0],
          q = K[1],
          Q = (0, t.useState)({ itemOrderId: 0, index: 0 }),
          Y = Q[0],
          J = Q[1],
          X = (0, t.useState)(
            null !==
              (s = v(
                null ===
                  (i =
                    null === (a = null == F ? void 0 : F.getState()) ||
                    void 0 === a
                      ? void 0
                      : a.salesRepData) || void 0 === i
                  ? void 0
                  : i.draftOrderData
              )) && void 0 !== s
              ? s
              : []
          ),
          te = X[0],
          ne = X[1],
          re = (0, t.useState)(""),
          oe = re[0],
          ae = re[1];
        (0, t.useEffect)(function () {
          ie();
        }, []),
          (0, t.useEffect)(
            function () {
              var e =
                null == Hh
                  ? void 0
                  : Hh.subscribe(function (e) {
                      if (
                        "Draft" === (null == e ? void 0 : e.orderTab) &&
                        (null == e ? void 0 : e.searchText) !== oe
                      ) {
                        ae(null == e ? void 0 : e.searchText);
                        var t = (function (e, t, n) {
                            if (n || 2 === arguments.length)
                              for (var r, o = 0, a = t.length; o < a; o++)
                                (!r && o in t) ||
                                  (r ||
                                    (r = Array.prototype.slice.call(t, 0, o)),
                                  (r[o] = t[o]));
                            return e.concat(r || Array.prototype.slice.call(t));
                          })([], te, !0),
                          n =
                            null == t
                              ? void 0
                              : t.filter(function (t) {
                                  var n, r, o, a, i, s;
                                  return (
                                    (null ===
                                      (r =
                                        null ===
                                          (n =
                                            null == t
                                              ? void 0
                                              : t.customername) || void 0 === n
                                          ? void 0
                                          : n.toLowerCase()) || void 0 === r
                                      ? void 0
                                      : r.includes(
                                          null ===
                                            (o =
                                              null == e
                                                ? void 0
                                                : e.searchText) || void 0 === o
                                            ? void 0
                                            : o.toLowerCase()
                                        )) ||
                                    (null ===
                                      (i =
                                        null ===
                                          (a =
                                            null == t ? void 0 : t.orderName) ||
                                        void 0 === a
                                          ? void 0
                                          : a.toLowerCase()) || void 0 === i
                                      ? void 0
                                      : i.includes(
                                          null ===
                                            (s =
                                              null == e
                                                ? void 0
                                                : e.searchText) || void 0 === s
                                            ? void 0
                                            : s.toLowerCase()
                                        ))
                                  );
                                });
                        S(n);
                      }
                    });
              return function () {
                return e.unsubscribe();
              };
            },
            [x, oe, S]
          );
        var ie = function () {
            return QT(l, void 0, void 0, function () {
              var e, t, n, r, o, a, i;
              return YT(this, function (s) {
                switch (s.label) {
                  case 0:
                    return Bh.next(!0), [4, c(ug())];
                  case 1:
                    return (
                      (e = s.sent()),
                      Bh.next(!1),
                      e &&
                        F.getState().salesRepData.draftOrderData &&
                        (S(
                          v(
                            null !==
                              (r =
                                null ===
                                  (n =
                                    null === (t = F.getState()) || void 0 === t
                                      ? void 0
                                      : t.salesRepData) || void 0 === n
                                  ? void 0
                                  : n.draftOrderData) && void 0 !== r
                              ? r
                              : []
                          )
                        ),
                        ne(
                          v(
                            null !==
                              (i =
                                null ===
                                  (a =
                                    null === (o = F.getState()) || void 0 === o
                                      ? void 0
                                      : o.salesRepData) || void 0 === a
                                  ? void 0
                                  : a.draftOrderData) && void 0 !== i
                              ? i
                              : []
                          )
                        )),
                      [2]
                    );
                }
              });
            });
          },
          se = function (e, t) {
            return (
              void 0 === t && (t = ""),
              QT(l, void 0, void 0, function () {
                var n, r, o, a;
                return YT(this, function (i) {
                  switch (i.label) {
                    case 0:
                      return (
                        Bh.next(!0),
                        (n = { order_id: e.orderid }),
                        [4, c(vg(n, t))]
                      );
                    case 1:
                      return (
                        (r = i.sent()),
                        t !== Zg && y(!0),
                        I(
                          null !==
                            (o = null == r ? void 0 : r.ProductDetails) &&
                            void 0 !== o
                            ? o
                            : []
                        ),
                        w(
                          null !== (a = null == r ? void 0 : r.draftOrder) &&
                            void 0 !== a
                            ? a
                            : {}
                        ),
                        Bh.next(!1),
                        [2]
                      );
                  }
                });
              })
            );
          };
        return {
          DraftOrdersHeaderNames: h,
          DraftOrderProductHeaderNames: f,
          openDraftProductDataDialog: _,
          setOpenDraftProductDataDialog: y,
          draftOrderArray: x,
          getDraftOrderDetails: se,
          activeClientObj: P,
          draftOrderProductDetailsArray: T,
          t: d,
          sendInvoice: function (e, t) {
            return QT(l, void 0, void 0, function () {
              var n;
              return YT(this, function (r) {
                switch (r.label) {
                  case 0:
                    return (
                      N(t),
                      R(!0),
                      (n = { orderid: e.orderid, emailid: e.emailid }),
                      [4, c(bg(n))]
                    );
                  case 1:
                    return (
                      r.sent() &&
                        ($(!0),
                        setTimeout(function () {
                          $(!1);
                        }, 3e3)),
                      R(!1),
                      [2]
                    );
                }
              });
            });
          },
          openDeleteInvoiceConfirmation: function (e, t, n) {
            q(e.currentTarget), J({ itemOrderId: t.orderid, index: n });
          },
          sendInvoiceIndex: j,
          sendInvoiceFlag: E,
          deleteInvoiceFlag: H,
          setDeleteInvoiceFlag: V,
          deleteInvoiceIndex: B,
          successFlag: U,
          deleteConfirmation: G,
          setDeleteConfirmation: q,
          deleteInvoice: function () {
            return QT(l, void 0, void 0, function () {
              var e, t, n, r;
              return YT(this, function (o) {
                switch (o.label) {
                  case 0:
                    return z(Y.index), V(!0), [4, c(_g(Y.itemOrderId))];
                  case 1:
                    return (
                      (e = o.sent()) &&
                        null !== e &&
                        (z(0),
                        S(
                          null !==
                            (r = v(
                              null ===
                                (n =
                                  null === (t = F.getState()) || void 0 === t
                                    ? void 0
                                    : t.salesRepData) || void 0 === n
                                ? void 0
                                : n.draftOrderData
                            )) && void 0 !== r
                            ? r
                            : []
                        ),
                        q(null)),
                      V(!1),
                      [2]
                    );
                }
              });
            });
          },
          shopCurrency: u,
          getDraftOrder: ie,
          handleEditOrder: function (e) {
            return QT(l, void 0, void 0, function () {
              var t, n, r, o, a, i;
              return YT(this, function (s) {
                switch (s.label) {
                  case 0:
                    return [4, se(e, Zg)];
                  case 1:
                    return (
                      s.sent(),
                      (null ==
                      (t =
                        null !==
                          (o =
                            null === (r = F.getState().salesRepData) ||
                            void 0 === r
                              ? void 0
                              : r.editDraftOrder) && void 0 !== o
                          ? o
                          : {})
                        ? void 0
                        : t.draftOrderObj) &&
                        0 !==
                          (null ===
                            (a = Object.keys(
                              null == t ? void 0 : t.draftOrderObj
                            )) || void 0 === a
                            ? void 0
                            : a.length) &&
                        (null ===
                          (i = null == t ? void 0 : t.productDetailsArray) ||
                        void 0 === i
                          ? void 0
                          : i.length) > 0 &&
                        ((n = {
                          payload: { activeTabIndex: 1, actionEvent: Zg },
                          type: A.ACTIVE_TAB,
                        }),
                        c(n)),
                      [2]
                    );
                }
              });
            });
          },
          selectFeatures: m,
          currency: p,
        };
      }
      var XT = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        },
        eI =
          Number.isNaN ||
          function (e) {
            return "number" == typeof e && e != e;
          };
      function tI(e, t) {
        if (e.length !== t.length) return !1;
        for (var n = 0; n < e.length; n++)
          if (!((r = e[n]) === (o = t[n]) || (eI(r) && eI(o)))) return !1;
        var r, o;
        return !0;
      }
      var nI = function (e, t) {
          var n;
          void 0 === t && (t = tI);
          var r,
            o = [],
            a = !1;
          return function () {
            for (var i = [], s = 0; s < arguments.length; s++)
              i[s] = arguments[s];
            return (
              (a && n === this && t(i, o)) ||
                ((r = e.apply(this, i)), (a = !0), (n = this), (o = i)),
              r
            );
          };
        },
        rI =
          "object" == typeof performance && "function" == typeof performance.now
            ? function () {
                return performance.now();
              }
            : function () {
                return Date.now();
              };
      function oI(e) {
        cancelAnimationFrame(e.id);
      }
      var aI = -1;
      function iI(e) {
        if ((void 0 === e && (e = !1), -1 === aI || e)) {
          var t = document.createElement("div"),
            n = t.style;
          (n.width = "50px"),
            (n.height = "50px"),
            (n.overflow = "scroll"),
            document.body.appendChild(t),
            (aI = t.offsetWidth - t.clientWidth),
            document.body.removeChild(t);
        }
        return aI;
      }
      var sI = null;
      function lI(e) {
        if ((void 0 === e && (e = !1), null === sI || e)) {
          var t = document.createElement("div"),
            n = t.style;
          (n.width = "50px"),
            (n.height = "50px"),
            (n.overflow = "scroll"),
            (n.direction = "rtl");
          var r = document.createElement("div"),
            o = r.style;
          return (
            (o.width = "100px"),
            (o.height = "100px"),
            t.appendChild(r),
            document.body.appendChild(t),
            t.scrollLeft > 0
              ? (sI = "positive-descending")
              : ((t.scrollLeft = 1),
                (sI = 0 === t.scrollLeft ? "negative" : "positive-ascending")),
            document.body.removeChild(t),
            sI
          );
        }
        return sI;
      }
      var dI = function (e, t) {
        return e;
      };
      function cI(e) {
        var n,
          r = e.getItemOffset,
          o = e.getEstimatedTotalSize,
          a = e.getItemSize,
          i = e.getOffsetForIndexAndAlignment,
          s = e.getStartIndexForOffset,
          l = e.getStopIndexForStartIndex,
          d = e.initInstanceProps,
          c = e.shouldResetStyleCacheOnItemSizeChange,
          p = e.validateProps;
        return (
          (n = (function (e) {
            function n(t) {
              var n;
              return (
                ((n = e.call(this, t) || this)._instanceProps = d(
                  n.props,
                  ae(n)
                )),
                (n._outerRef = void 0),
                (n._resetIsScrollingTimeoutId = null),
                (n.state = {
                  instance: ae(n),
                  isScrolling: !1,
                  scrollDirection: "forward",
                  scrollOffset:
                    "number" == typeof n.props.initialScrollOffset
                      ? n.props.initialScrollOffset
                      : 0,
                  scrollUpdateWasRequested: !1,
                }),
                (n._callOnItemsRendered = void 0),
                (n._callOnItemsRendered = nI(function (e, t, r, o) {
                  return n.props.onItemsRendered({
                    overscanStartIndex: e,
                    overscanStopIndex: t,
                    visibleStartIndex: r,
                    visibleStopIndex: o,
                  });
                })),
                (n._callOnScroll = void 0),
                (n._callOnScroll = nI(function (e, t, r) {
                  return n.props.onScroll({
                    scrollDirection: e,
                    scrollOffset: t,
                    scrollUpdateWasRequested: r,
                  });
                })),
                (n._getItemStyle = void 0),
                (n._getItemStyle = function (e) {
                  var t,
                    o = n.props,
                    i = o.direction,
                    s = o.itemSize,
                    l = o.layout,
                    d = n._getItemStyleCache(c && s, c && l, c && i);
                  if (d.hasOwnProperty(e)) t = d[e];
                  else {
                    var u = r(n.props, e, n._instanceProps),
                      p = a(n.props, e, n._instanceProps),
                      m = "horizontal" === i || "horizontal" === l,
                      h = "rtl" === i,
                      f = m ? u : 0;
                    d[e] = t = {
                      position: "absolute",
                      left: h ? void 0 : f,
                      right: h ? f : void 0,
                      top: m ? 0 : u,
                      height: m ? "100%" : p,
                      width: m ? p : "100%",
                    };
                  }
                  return t;
                }),
                (n._getItemStyleCache = void 0),
                (n._getItemStyleCache = nI(function (e, t, n) {
                  return {};
                })),
                (n._onScrollHorizontal = function (e) {
                  var t = e.currentTarget,
                    r = t.clientWidth,
                    o = t.scrollLeft,
                    a = t.scrollWidth;
                  n.setState(function (e) {
                    if (e.scrollOffset === o) return null;
                    var t = n.props.direction,
                      i = o;
                    if ("rtl" === t)
                      switch (lI()) {
                        case "negative":
                          i = -o;
                          break;
                        case "positive-descending":
                          i = a - r - o;
                      }
                    return (
                      (i = Math.max(0, Math.min(i, a - r))),
                      {
                        isScrolling: !0,
                        scrollDirection:
                          e.scrollOffset < i ? "forward" : "backward",
                        scrollOffset: i,
                        scrollUpdateWasRequested: !1,
                      }
                    );
                  }, n._resetIsScrollingDebounced);
                }),
                (n._onScrollVertical = function (e) {
                  var t = e.currentTarget,
                    r = t.clientHeight,
                    o = t.scrollHeight,
                    a = t.scrollTop;
                  n.setState(function (e) {
                    if (e.scrollOffset === a) return null;
                    var t = Math.max(0, Math.min(a, o - r));
                    return {
                      isScrolling: !0,
                      scrollDirection:
                        e.scrollOffset < t ? "forward" : "backward",
                      scrollOffset: t,
                      scrollUpdateWasRequested: !1,
                    };
                  }, n._resetIsScrollingDebounced);
                }),
                (n._outerRefSetter = function (e) {
                  var t = n.props.outerRef;
                  (n._outerRef = e),
                    "function" == typeof t
                      ? t(e)
                      : null != t &&
                        "object" == typeof t &&
                        t.hasOwnProperty("current") &&
                        (t.current = e);
                }),
                (n._resetIsScrollingDebounced = function () {
                  null !== n._resetIsScrollingTimeoutId &&
                    oI(n._resetIsScrollingTimeoutId),
                    (n._resetIsScrollingTimeoutId = (function (e, t) {
                      var n = rI(),
                        r = {
                          id: requestAnimationFrame(function o() {
                            rI() - n >= t
                              ? e.call(null)
                              : (r.id = requestAnimationFrame(o));
                          }),
                        };
                      return r;
                    })(n._resetIsScrolling, 150));
                }),
                (n._resetIsScrolling = function () {
                  (n._resetIsScrollingTimeoutId = null),
                    n.setState({ isScrolling: !1 }, function () {
                      n._getItemStyleCache(-1, null);
                    });
                }),
                n
              );
            }
            vn(n, e),
              (n.getDerivedStateFromProps = function (e, t) {
                return uI(e, t), p(e), null;
              });
            var m = n.prototype;
            return (
              (m.scrollTo = function (e) {
                (e = Math.max(0, e)),
                  this.setState(function (t) {
                    return t.scrollOffset === e
                      ? null
                      : {
                          scrollDirection:
                            t.scrollOffset < e ? "forward" : "backward",
                          scrollOffset: e,
                          scrollUpdateWasRequested: !0,
                        };
                  }, this._resetIsScrollingDebounced);
              }),
              (m.scrollToItem = function (e, t) {
                void 0 === t && (t = "auto");
                var n = this.props,
                  r = n.itemCount,
                  o = n.layout,
                  a = this.state.scrollOffset;
                e = Math.max(0, Math.min(e, r - 1));
                var s = 0;
                if (this._outerRef) {
                  var l = this._outerRef;
                  s =
                    "vertical" === o
                      ? l.scrollWidth > l.clientWidth
                        ? iI()
                        : 0
                      : l.scrollHeight > l.clientHeight
                      ? iI()
                      : 0;
                }
                this.scrollTo(i(this.props, e, t, a, this._instanceProps, s));
              }),
              (m.componentDidMount = function () {
                var e = this.props,
                  t = e.direction,
                  n = e.initialScrollOffset,
                  r = e.layout;
                if ("number" == typeof n && null != this._outerRef) {
                  var o = this._outerRef;
                  "horizontal" === t || "horizontal" === r
                    ? (o.scrollLeft = n)
                    : (o.scrollTop = n);
                }
                this._callPropsCallbacks();
              }),
              (m.componentDidUpdate = function () {
                var e = this.props,
                  t = e.direction,
                  n = e.layout,
                  r = this.state,
                  o = r.scrollOffset;
                if (r.scrollUpdateWasRequested && null != this._outerRef) {
                  var a = this._outerRef;
                  if ("horizontal" === t || "horizontal" === n)
                    if ("rtl" === t)
                      switch (lI()) {
                        case "negative":
                          a.scrollLeft = -o;
                          break;
                        case "positive-ascending":
                          a.scrollLeft = o;
                          break;
                        default:
                          var i = a.clientWidth,
                            s = a.scrollWidth;
                          a.scrollLeft = s - i - o;
                      }
                    else a.scrollLeft = o;
                  else a.scrollTop = o;
                }
                this._callPropsCallbacks();
              }),
              (m.componentWillUnmount = function () {
                null !== this._resetIsScrollingTimeoutId &&
                  oI(this._resetIsScrollingTimeoutId);
              }),
              (m.render = function () {
                var e = this.props,
                  n = e.children,
                  r = e.className,
                  a = e.direction,
                  i = e.height,
                  s = e.innerRef,
                  l = e.innerElementType,
                  d = e.innerTagName,
                  c = e.itemCount,
                  p = e.itemData,
                  m = e.itemKey,
                  h = void 0 === m ? dI : m,
                  f = e.layout,
                  g = e.outerElementType,
                  v = e.outerTagName,
                  b = e.style,
                  _ = e.useIsScrolling,
                  y = e.width,
                  C = this.state.isScrolling,
                  x = "horizontal" === a || "horizontal" === f,
                  S = x ? this._onScrollHorizontal : this._onScrollVertical,
                  k = this._getRangeToRender(),
                  P = k[0],
                  w = k[1],
                  O = [];
                if (c > 0)
                  for (var T = P; T <= w; T++)
                    O.push(
                      (0, t.createElement)(n, {
                        data: p,
                        key: h(T, p),
                        index: T,
                        isScrolling: _ ? C : void 0,
                        style: this._getItemStyle(T),
                      })
                    );
                var I = o(this.props, this._instanceProps);
                return (0, t.createElement)(
                  g || v || "div",
                  {
                    className: r,
                    onScroll: S,
                    ref: this._outerRefSetter,
                    style: (0, u.Z)(
                      {
                        position: "relative",
                        height: i,
                        width: y,
                        overflow: "auto",
                        WebkitOverflowScrolling: "touch",
                        willChange: "transform",
                        direction: a,
                      },
                      b
                    ),
                  },
                  (0, t.createElement)(l || d || "div", {
                    children: O,
                    ref: s,
                    style: {
                      height: x ? "100%" : I,
                      pointerEvents: C ? "none" : void 0,
                      width: x ? I : "100%",
                    },
                  })
                );
              }),
              (m._callPropsCallbacks = function () {
                if (
                  "function" == typeof this.props.onItemsRendered &&
                  this.props.itemCount > 0
                ) {
                  var e = this._getRangeToRender(),
                    t = e[0],
                    n = e[1],
                    r = e[2],
                    o = e[3];
                  this._callOnItemsRendered(t, n, r, o);
                }
                if ("function" == typeof this.props.onScroll) {
                  var a = this.state,
                    i = a.scrollDirection,
                    s = a.scrollOffset,
                    l = a.scrollUpdateWasRequested;
                  this._callOnScroll(i, s, l);
                }
              }),
              (m._getRangeToRender = function () {
                var e = this.props,
                  t = e.itemCount,
                  n = e.overscanCount,
                  r = this.state,
                  o = r.isScrolling,
                  a = r.scrollDirection,
                  i = r.scrollOffset;
                if (0 === t) return [0, 0, 0, 0];
                var d = s(this.props, i, this._instanceProps),
                  c = l(this.props, d, i, this._instanceProps),
                  u = o && "backward" !== a ? 1 : Math.max(1, n),
                  p = o && "forward" !== a ? 1 : Math.max(1, n);
                return [
                  Math.max(0, d - u),
                  Math.max(0, Math.min(t - 1, c + p)),
                  d,
                  c,
                ];
              }),
              n
            );
          })(t.PureComponent)),
          (n.defaultProps = {
            direction: "ltr",
            itemData: void 0,
            layout: "vertical",
            overscanCount: 2,
            useIsScrolling: !1,
          }),
          n
        );
      }
      var uI = function (e, t) {
          e.children,
            e.direction,
            e.height,
            e.layout,
            e.innerTagName,
            e.outerTagName,
            e.width,
            t.instance;
        },
        pI = cI({
          getItemOffset: function (e, t) {
            return t * e.itemSize;
          },
          getItemSize: function (e, t) {
            return e.itemSize;
          },
          getEstimatedTotalSize: function (e) {
            var t = e.itemCount;
            return e.itemSize * t;
          },
          getOffsetForIndexAndAlignment: function (e, t, n, r, o, a) {
            var i = e.direction,
              s = e.height,
              l = e.itemCount,
              d = e.itemSize,
              c = e.layout,
              u = e.width,
              p = "horizontal" === i || "horizontal" === c ? u : s,
              m = Math.max(0, l * d - p),
              h = Math.min(m, t * d),
              f = Math.max(0, t * d - p + d + a);
            switch (
              ("smart" === n &&
                (n = r >= f - p && r <= h + p ? "auto" : "center"),
              n)
            ) {
              case "start":
                return h;
              case "end":
                return f;
              case "center":
                var g = Math.round(f + (h - f) / 2);
                return g < Math.ceil(p / 2)
                  ? 0
                  : g > m + Math.floor(p / 2)
                  ? m
                  : g;
              default:
                return r >= f && r <= h ? r : r < f ? f : h;
            }
          },
          getStartIndexForOffset: function (e, t) {
            var n = e.itemCount,
              r = e.itemSize;
            return Math.max(0, Math.min(n - 1, Math.floor(t / r)));
          },
          getStopIndexForStartIndex: function (e, t, n) {
            var r = e.direction,
              o = e.height,
              a = e.itemCount,
              i = e.itemSize,
              s = e.layout,
              l = e.width,
              d = t * i,
              c = "horizontal" === r || "horizontal" === s ? l : o,
              u = Math.ceil((c + n - d) / i);
            return Math.max(0, Math.min(a - 1, t + u - 1));
          },
          initInstanceProps: function (e) {},
          shouldResetStyleCacheOnItemSizeChange: !0,
          validateProps: function (e) {
            e.itemSize;
          },
        }),
        mI = o(5137),
        hI = o(3486),
        fI = o(7036),
        gI = "#ffc107",
        vI = o(6949),
        bI = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function _I() {
        var e,
          n = ee().t,
          r = rf(),
          o = r.shopCurrency,
          a = r.shopName,
          i = F.getState().salesRepData.baseData.salesRepUrl
            ? F.getState().salesRepData.baseData.salesRepUrl
            : "",
          s = F.getState().salesRepData.baseData.hmac
            ? F.getState().salesRepData.baseData.hmac
            : "",
          l =
            null !== (e = F.getState().salesRepData.baseData.select) &&
            void 0 !== e
              ? e
              : {},
          d = y(function (e) {
            var t;
            return e.salesRepData
              ? null === (t = e.salesRepData) || void 0 === t
                ? void 0
                : t.ordersData
              : {};
          }),
          c = (0, t.useState)([]),
          u = c[0],
          p = c[1],
          m = (0, t.useState)([]),
          h = m[0],
          f = m[1],
          g = (0, t.useState)(""),
          v = g[0],
          b = g[1];
        (0, t.useEffect)(
          function () {
            var e, t, n, r, o, a;
            (void 0 !== (null == d ? void 0 : d.isPaidUnPaidOrdersLoaded) &&
              void 0 !== (null == d ? void 0 : d.isDraftOrdersLoaded)) ||
              Bh.next(!0),
              (null == d ? void 0 : d.isPaidUnPaidOrdersLoaded) &&
                (null == d ? void 0 : d.isDraftOrdersLoaded) &&
                (p(
                  bI(
                    bI(
                      bI(
                        [],
                        null !==
                          (e = null == d ? void 0 : d.AllOrdersCommission) &&
                          void 0 !== e
                          ? e
                          : [],
                        !0
                      ),
                      null !==
                        (t = null == d ? void 0 : d.draftOrdersDetails) &&
                        void 0 !== t
                        ? t
                        : [],
                      !0
                    ),
                    null !== (n = null == d ? void 0 : d.refundOrdersDetails) &&
                      void 0 !== n
                      ? n
                      : [],
                    !0
                  )
                ),
                f(
                  bI(
                    bI(
                      bI(
                        [],
                        null !==
                          (r = null == d ? void 0 : d.AllOrdersCommission) &&
                          void 0 !== r
                          ? r
                          : [],
                        !0
                      ),
                      null !==
                        (o = null == d ? void 0 : d.draftOrdersDetails) &&
                        void 0 !== o
                        ? o
                        : [],
                      !0
                    ),
                    null !== (a = null == d ? void 0 : d.refundOrdersDetails) &&
                      void 0 !== a
                      ? a
                      : [],
                    !0
                  )
                ),
                Bh.next(!1));
          },
          [d]
        ),
          (0, t.useEffect)(
            function () {
              var e = Hh.subscribe(function (e) {
                if ("All" === e.orderTab && e.searchText !== v) {
                  b(e.searchText);
                  var t = bI([], h, !0),
                    n =
                      null == t
                        ? void 0
                        : t.filter(function (t) {
                            var n, r, o, a, i, s, l;
                            return (
                              ((null == t ? void 0 : t.CustomerName) &&
                                (null ===
                                  (r =
                                    null ===
                                      (n =
                                        null == t ? void 0 : t.CustomerName) ||
                                    void 0 === n
                                      ? void 0
                                      : n.toLowerCase()) || void 0 === r
                                  ? void 0
                                  : r.includes(
                                      null ===
                                        (o =
                                          null == e ? void 0 : e.searchText) ||
                                        void 0 === o
                                        ? void 0
                                        : o.toLowerCase()
                                    ))) ||
                              (null ===
                                (s = (
                                  "0" != (null == t ? void 0 : t.orderNumber)
                                    ? null !==
                                        (a =
                                          null == t ? void 0 : t.orderNumber) &&
                                      void 0 !== a
                                      ? a
                                      : ""
                                    : null !==
                                        (i =
                                          null == t ? void 0 : t.orderName) &&
                                      void 0 !== i
                                    ? i
                                    : ""
                                ).toLowerCase()) || void 0 === s
                                ? void 0
                                : s.includes(
                                    null ===
                                      (l = null == e ? void 0 : e.searchText) ||
                                      void 0 === l
                                      ? void 0
                                      : l.toLowerCase()
                                  ))
                            );
                          });
                  p(n);
                }
              });
              return function () {
                return e.unsubscribe();
              };
            },
            [u, v, p]
          );
        var _ = [
            {
              label: n("yourSales_table1Column1"),
              inlineCSS: { flex: 1, minWidth: "60px" },
            },
            {
              label: n("yourSales_table1Column2"),
              inlineCSS: { flex: 1, minWidth: "60px" },
            },
            { label: n("PaidDate"), inlineCSS: { flex: 1, minWidth: "60px" } },
            { label: n("customer"), inlineCSS: { flex: 1, minWidth: "60px" } },
            {
              label: n("salesDetailsHeader_Company"),
              hidden: !(null == l ? void 0 : l.CreateB2BOrder),
              inlineCSS: { flex: 1, minWidth: "60px" },
            },
            {
              label: n("salesDetailsHeader_Location"),
              hidden: !(null == l ? void 0 : l.CreateB2BOrder),
              inlineCSS: { flex: 1, minWidth: "60px" },
            },
            {
              label: n("yourSales_table1Column4"),
              inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
            },
            {
              label: n("yourSales_table1Column5"),
              inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
            },
            {
              label: n("draftOrder_Status"),
              inlineCSS: { textAlign: "center", flex: 1, minWidth: "80px" },
            },
            {
              label: n("customerInvoice_OrderType"),
              inlineCSS: { textAlign: "center", flex: 1, minWidth: "105px" },
            },
            {
              label: n("draftOrder_Invoice"),
              inlineCSS: { textAlign: "center", flex: 1, minWidth: "60px" },
            },
          ],
          C = function (e) {
            var t = null == e ? void 0 : e.split("/");
            if (3 === (null == t ? void 0 : t.length))
              return new Date(
                parseInt(t[2]),
                parseInt(t[0]) - 1,
                parseInt(t[1])
              );
            throw new Error("Invalid date format");
          };
        return {
          shopName: a,
          getPrintOrderDetails: function (e) {
            return (
              i +
              "/SalesRepTenant/PrintInvoicesBySalesRep?hmac=" +
              s +
              "&customerName=" +
              e.CustomerName +
              "&orderId=" +
              (null == e ? void 0 : e.OrderId) +
              "&shop=" +
              a
            );
          },
          orders: u,
          handleOrderStatusColor: function (e, t, n, r) {
            var o,
              a,
              i = mI.Z[100];
            return (
              t
                ? (i = hI.Z[500])
                : n
                ? (i = fI.Z[500])
                : r
                ? (i = gI)
                : !(null == e ? void 0 : e.OrderStatus) ||
                  ("open" !==
                    (null === (o = null == e ? void 0 : e.OrderStatus) ||
                    void 0 === o
                      ? void 0
                      : o.toLowerCase()) &&
                    "voided" !==
                      (null === (a = null == e ? void 0 : e.OrderStatus) ||
                      void 0 === a
                        ? void 0
                        : a.toLowerCase())) ||
                  (i = vI.Z[500]),
              i
            );
          },
          HeaderSalesNames: _,
          shopCurrency: o,
          handleSort: function (e) {
            var t = e;
            try {
              null == t ||
                t.sort(function (e, t) {
                  if (
                    (null == e ? void 0 : e.orderDate) &&
                    (null == t ? void 0 : t.orderDate)
                  ) {
                    var n = C(e.orderDate),
                      r = C(t.orderDate);
                    return (
                      (null == r ? void 0 : r.getTime()) -
                      (null == n ? void 0 : n.getTime())
                    );
                  }
                });
            } catch (e) {}
            return t;
          },
          selectFeatures: l,
        };
      }
      var yI = (0, Oo.Z)(
        (0, e.jsx)("path", {
          d: "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3m-3 11H8v-5h8zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1m-1-9H6v4h12z",
        }),
        "Print"
      );
      function CI() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s,
          l,
          d,
          c = this,
          u = ee().t,
          p = g(),
          m = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          h = (0, t.useState)(
            null !==
              (n =
                null === (e = null == m ? void 0 : m.ordersData) || void 0 === e
                  ? void 0
                  : e.AllOrdersCommission) && void 0 !== n
              ? n
              : []
          ),
          f = h[0],
          v = h[1],
          b = (0, t.useState)(
            !(
              (null ===
                (o =
                  null === (r = null == m ? void 0 : m.ordersData) ||
                  void 0 === r
                    ? void 0
                    : r.AllOrdersCommission) || void 0 === o
                ? void 0
                : o.length) > 0
            )
          ),
          _ = b[0],
          C = b[1],
          x = (0, t.useState)(0),
          S = (x[0], x[1]),
          k =
            null !== (a = F.getState().salesRepData.baseData.select) &&
            void 0 !== a
              ? a
              : {},
          P = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          w = F.getState().salesRepData.loggedInRepDetails.currency,
          O = (0, t.useState)(
            null !==
              (s =
                null === (i = null == m ? void 0 : m.ordersData) || void 0 === i
                  ? void 0
                  : i.AllOrdersCommission) && void 0 !== s
              ? s
              : []
          ),
          T = O[0],
          I = O[1],
          M = (0, t.useState)(""),
          j = M[0],
          N = M[1];
        (0, t.useEffect)(function () {
          var e, t, n, r;
          Bh.next(!0),
            (null ===
              (t =
                null === (e = null == m ? void 0 : m.ordersData) || void 0 === e
                  ? void 0
                  : e.AllOrdersCommission) || void 0 === t
              ? void 0
              : t.length) > 0 && Bh.next(!1),
            0 === (null == f ? void 0 : f.length) &&
              0 ===
                (null ===
                  (r =
                    null === (n = null == m ? void 0 : m.ordersData) ||
                    void 0 === n
                      ? void 0
                      : n.AllOrdersCommission) || void 0 === r
                  ? void 0
                  : r.length) &&
              (Bh.next(!1), C(!1));
        }, []),
          (0, t.useEffect)(
            function () {
              var e, t, n, r;
              0 === (null == f ? void 0 : f.length) &&
                (null ===
                  (t =
                    null === (e = null == m ? void 0 : m.ordersData) ||
                    void 0 === e
                      ? void 0
                      : e.AllOrdersCommission) || void 0 === t
                  ? void 0
                  : t.length) > 0 &&
                (v(
                  null === (n = null == m ? void 0 : m.ordersData) ||
                    void 0 === n
                    ? void 0
                    : n.AllOrdersCommission
                ),
                I(
                  null === (r = null == m ? void 0 : m.ordersData) ||
                    void 0 === r
                    ? void 0
                    : r.AllOrdersCommission
                )),
                S(function (e) {
                  return 1 === e && (Bh.next(!1), C(!1)), e + 1;
                });
            },
            [m.ordersData]
          ),
          (0, t.useEffect)(
            function () {
              var e = Hh.subscribe(function (e) {
                if (
                  "Paid" === (null == e ? void 0 : e.orderTab) &&
                  (null == e ? void 0 : e.searchText) !== j
                ) {
                  N(null == e ? void 0 : e.searchText);
                  var t = (function (e, t, n) {
                      if (n || 2 === arguments.length)
                        for (var r, o = 0, a = t.length; o < a; o++)
                          (!r && o in t) ||
                            (r || (r = Array.prototype.slice.call(t, 0, o)),
                            (r[o] = t[o]));
                      return e.concat(r || Array.prototype.slice.call(t));
                    })([], T, !0),
                    n =
                      null == t
                        ? void 0
                        : t.filter(function (t) {
                            var n, r, o, a, i, s;
                            return (
                              (null ===
                                (r =
                                  null ===
                                    (n = null == t ? void 0 : t.CustomerName) ||
                                  void 0 === n
                                    ? void 0
                                    : n.toLowerCase()) || void 0 === r
                                ? void 0
                                : r.includes(
                                    null ===
                                      (o = null == e ? void 0 : e.searchText) ||
                                      void 0 === o
                                      ? void 0
                                      : o.toLowerCase()
                                  )) ||
                              (null ===
                                (i =
                                  null ===
                                    (a = null == t ? void 0 : t.orderNumber) ||
                                  void 0 === a
                                    ? void 0
                                    : a.toLowerCase()) || void 0 === i
                                ? void 0
                                : i.includes(
                                    null ===
                                      (s = null == e ? void 0 : e.searchText) ||
                                      void 0 === s
                                      ? void 0
                                      : s.toLowerCase()
                                  ))
                            );
                          });
                  v(n);
                }
              });
              return function () {
                return e.unsubscribe();
              };
            },
            [f, j, v]
          );
        var D = [
            { label: u("yourSales_table1Column1") },
            { label: u("yourSales_table1Column2") },
            { label: u("yourSales_PaidOrders_PaidDate") },
            { label: u("yourSales_table1Column3") },
            {
              label: u("salesDetailsHeader_Company"),
              hidden: !(null == k ? void 0 : k.CreateB2BOrder),
            },
            {
              label: u("salesDetailsHeader_Location"),
              hidden: !(null == k ? void 0 : k.CreateB2BOrder),
            },
            {
              label: u("yourSales_table1Column4") + "(" + P + ")",
              inlineCSS: { textAlign: "center" },
            },
            {
              label: u("yourSales_table1Column5") + "(" + P + ")",
              inlineCSS: { textAlign: "center" },
            },
            { label: u("team_column8") },
            {
              label: u("yourSales_table1Column7"),
              inlineCSS: { textAlign: "center" },
            },
          ],
          A = [
            { label: u("yourSales_column1") },
            { label: u("yourSales_column2") },
            { label: u("variant_title") },
            { label: "SKU" },
            { label: u("yourSales_column3") },
            { label: u("yourSales_column4") + "(" + P + ")" },
            { label: u("viewProductModelColumn6") + "(" + P + ")" },
            { label: u("yourSales_column5") },
            { label: u("yourSales_column6") },
            { label: u("yourSales_column7") + "(" + P + ")" },
          ],
          E =
            null !==
              (l =
                null == f
                  ? void 0
                  : f.filter(function (e) {
                      return (
                        "paid" === e.OrderStatus ||
                        "partially_refunded" === e.OrderStatus ||
                        "completed" === e.OrderStatus
                      );
                    })) && void 0 !== l
              ? l
              : [],
          R = (0, t.useState)(!1),
          L = R[0],
          B = R[1],
          z = (0, t.useState)(),
          Z = z[0],
          H = z[1],
          V = (0, t.useState)([]),
          W = V[0],
          U = V[1],
          $ =
            null !== (d = F.getState().salesRepData.baseData.ShopName) &&
            void 0 !== d
              ? d
              : null;
        return {
          HeaderSalesNames: D,
          getYourSalesProductsData: function (e) {
            return (
              (t = c),
              (n = void 0),
              (o = function () {
                var t, n;
                return (function (e, t) {
                  var n,
                    r,
                    o,
                    a,
                    i = {
                      label: 0,
                      sent: function () {
                        if (1 & o[0]) throw o[1];
                        return o[1];
                      },
                      trys: [],
                      ops: [],
                    };
                  return (
                    (a = { next: s(0), throw: s(1), return: s(2) }),
                    "function" == typeof Symbol &&
                      (a[Symbol.iterator] = function () {
                        return this;
                      }),
                    a
                  );
                  function s(s) {
                    return function (l) {
                      return (function (s) {
                        if (n)
                          throw new TypeError(
                            "Generator is already executing."
                          );
                        for (; a && ((a = 0), s[0] && (i = 0)), i; )
                          try {
                            if (
                              ((n = 1),
                              r &&
                                (o =
                                  2 & s[0]
                                    ? r.return
                                    : s[0]
                                    ? r.throw ||
                                      ((o = r.return) && o.call(r), 0)
                                    : r.next) &&
                                !(o = o.call(r, s[1])).done)
                            )
                              return o;
                            switch (
                              ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                            ) {
                              case 0:
                              case 1:
                                o = s;
                                break;
                              case 4:
                                return i.label++, { value: s[1], done: !1 };
                              case 5:
                                i.label++, (r = s[1]), (s = [0]);
                                continue;
                              case 7:
                                (s = i.ops.pop()), i.trys.pop();
                                continue;
                              default:
                                if (
                                  !(
                                    (o =
                                      (o = i.trys).length > 0 &&
                                      o[o.length - 1]) ||
                                    (6 !== s[0] && 2 !== s[0])
                                  )
                                ) {
                                  i = 0;
                                  continue;
                                }
                                if (
                                  3 === s[0] &&
                                  (!o || (s[1] > o[0] && s[1] < o[3]))
                                ) {
                                  i.label = s[1];
                                  break;
                                }
                                if (6 === s[0] && i.label < o[1]) {
                                  (i.label = o[1]), (o = s);
                                  break;
                                }
                                if (o && i.label < o[2]) {
                                  (i.label = o[2]), i.ops.push(s);
                                  break;
                                }
                                o[2] && i.ops.pop(), i.trys.pop();
                                continue;
                            }
                            s = t.call(e, i);
                          } catch (e) {
                            (s = [6, e]), (r = 0);
                          } finally {
                            n = o = 0;
                          }
                        if (5 & s[0]) throw s[1];
                        return { value: s[0] ? s[1] : void 0, done: !0 };
                      })([s, l]);
                    };
                  }
                })(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return (
                        (t = { order_id: e.OrderId }),
                        Bh.next(!0),
                        [4, p(cg(t))]
                      );
                    case 1:
                      return (
                        (n = r.sent()),
                        B(!0),
                        U(n ? n.ProductDetails : []),
                        H(n.singleOrderDetailsFromShopify),
                        Bh.next(!1),
                        [2]
                      );
                  }
                });
              }),
              new ((r = void 0) || (r = Promise))(function (e, a) {
                function i(e) {
                  try {
                    l(o.next(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function s(e) {
                  try {
                    l(o.throw(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function l(t) {
                  var n;
                  t.done
                    ? e(t.value)
                    : ((n = t.value),
                      n instanceof r
                        ? n
                        : new r(function (e) {
                            e(n);
                          })).then(i, s);
                }
                l((o = o.apply(t, n || [])).next());
              })
            );
            var t, n, r, o;
          },
          ProductSalesDetailsHeaderNames: A,
          openProductDataDialog: L,
          setOpenProductDataDialog: B,
          yorSalesArray: E,
          activeClientObj: Z,
          yorSalesProductArray: W,
          t: u,
          getPrintOrderDetails: function (e) {
            return (
              (F.getState().salesRepData.baseData.salesRepUrl
                ? F.getState().salesRepData.baseData.salesRepUrl
                : "") +
              "/SalesRepTenant/PrintInvoicesBySalesRep?hmac=" +
              (F.getState().salesRepData.baseData.hmac
                ? F.getState().salesRepData.baseData.hmac
                : "") +
              "&customerName=" +
              e.CustomerName +
              "&orderId=" +
              e.OrderId +
              "&shop=" +
              $
            );
          },
          shopCurrency: P,
          shopName: $,
          orderesLoading: _,
          selectFeatures: k,
          currency: w,
        };
      }
      var xI = function () {
          return (
            (xI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            xI.apply(this, arguments)
          );
        },
        SI = function (n) {
          var r = n.tableType,
            o = n.headerArray,
            a = n.dataArray,
            i = n.getProductData,
            s = CI(),
            l = s.shopName,
            d = s.shopCurrency,
            c = s.getPrintOrderDetails,
            u = s.t,
            p = xv().getDateFormat,
            m = function (t, n) {
              var r, o, a;
              switch (t) {
                case 0:
                  a = (0, e.jsx)(
                    Op,
                    xI(
                      {
                        sx: Lo,
                        onClick: function () {
                          return i(n);
                        },
                      },
                      { children: null == n ? void 0 : n.orderNumber }
                    )
                  );
                  break;
                case 1:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.orderDate) || "-",
                  });
                  break;
                case 2:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.OrderPaidDate) || "-",
                  });
                  break;
                case 3:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.CustomerName) || "-",
                  });
                  break;
                case 4:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BCompanyName) || "-",
                  });
                  break;
                case 5:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BLocationName) || "-",
                  });
                  break;
                case 6:
                  a = (0, e.jsxs)(
                    Op,
                    xI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          d + " ",
                          " ",
                          (null === (r = null == n ? void 0 : n.subtotal) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 7:
                  a = (0, e.jsxs)(
                    Op,
                    xI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          d + " ",
                          " ",
                          (null === (o = null == n ? void 0 : n.commission) ||
                          void 0 === o
                            ? void 0
                            : o.toFixed(2)) || "0",
                        ],
                      }
                    )
                  );
                  break;
                case 8:
                  a = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.CommissionType) || "-",
                  });
                  break;
                case 9:
                  a = (0, e.jsx)(
                    Op,
                    xI(
                      { sx: { cursor: null === l ? "not-allowed" : "curosr" } },
                      {
                        children: (0, e.jsx)(
                          rl,
                          xI(
                            {
                              className: "ST_link_FontColor",
                              href: c(n),
                              target: "_blank",
                              sx: {
                                pointerEvents: null === l ? "none" : "all",
                              },
                            },
                            {
                              children: (0, e.jsx)(yI, {
                                sx: { cursor: "pointer", color: "#1976d2" },
                              }),
                            }
                          )
                        ),
                      }
                    )
                  );
              }
              return a;
            },
            h = function (t, n) {
              var r, o, a, i;
              switch (t) {
                case 0:
                  i = (0, e.jsx)(
                    Op,
                    xI(
                      { scope: "row" },
                      {
                        children: (null == n ? void 0 : n.Image)
                          ? (0, e.jsx)(mn, {
                              component: "img",
                              sx: Vo,
                              src: n.Image,
                            })
                          : (0, e.jsx)(VT.Z, { sx: { height: 50, width: 50 } }),
                      }
                    )
                  );
                  break;
                case 1:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.Title) || "-",
                  });
                  break;
                case 2:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.variantTitle) || "-",
                  });
                  break;
                case 3:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.SKU) || "-",
                  });
                  break;
                case 4:
                  i = (0, e.jsx)(Op, {
                    children: null == n ? void 0 : n.quantity,
                  });
                  break;
                case 5:
                  i = (0, e.jsxs)(
                    Op,
                    xI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          d + " ",
                          (null === (r = null == n ? void 0 : n.ItemPrice) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 6:
                  i = (0, e.jsxs)(
                    Op,
                    xI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          d + " ",
                          (null ===
                            (o = null == n ? void 0 : n.discountedPrice) ||
                          void 0 === o
                            ? void 0
                            : o.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 7:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.trackingNumber) || "-",
                  });
                  break;
                case 8:
                  i = (0, e.jsx)(Op, {
                    children: p(null == n ? void 0 : n.ShipDate),
                  });
                  break;
                case 9:
                  i = (0, e.jsxs)(
                    Op,
                    xI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          d + " ",
                          (null === (a = n.Subtotal) || void 0 === a
                            ? void 0
                            : a.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
              }
              return i;
            };
          return "1" === r
            ? (0, e.jsx)(
                ep,
                xI(
                  { sx: Ho, className: "Table_Container_Margin" },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      xI(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return "open" !==
                                                        n.OrderStatus
                                                        ? (0, e.jsxs)(
                                                            Cp,
                                                            xI(
                                                              {
                                                                className:
                                                                  "MobileViewTableCell",
                                                                sx: {
                                                                  display: (
                                                                    null == t
                                                                      ? void 0
                                                                      : t.hidden
                                                                  )
                                                                    ? "none"
                                                                    : "table-row",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Op,
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsxs)(
                                                                          "b",
                                                                          {
                                                                            children:
                                                                              [
                                                                                t.label,
                                                                                " :",
                                                                              ],
                                                                          }
                                                                        ),
                                                                    }
                                                                  ),
                                                                  m(r, n),
                                                                ],
                                                              }
                                                            ),
                                                            t.label + r
                                                          )
                                                        : "";
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  xI(
                                    { className: "BorderBottom" },
                                    { children: u("no_orders_to_show") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              )
            : (0, e.jsx)(ep, {
                children: (0, e.jsx)(sp, {
                  children:
                    null != a && (null == a ? void 0 : a.length) > 0
                      ? null == a
                        ? void 0
                        : a.map(function (n, r) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  xI(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == o
                                              ? void 0
                                              : o.map(function (t, r) {
                                                  return (0,
                                                  e.jsxs)(Cp, xI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), h(r, n)] }), t.label + r);
                                                }),
                                        },
                                        r
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              xI(
                                { className: "BorderBottom" },
                                { children: u("no_product_details") }
                              )
                            ),
                          }),
                        }),
                }),
              });
        },
        kI = function () {
          return (
            (kI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            kI.apply(this, arguments)
          );
        },
        PI = function () {
          var t,
            n,
            r,
            o = CI(),
            a = o.HeaderSalesNames,
            i = o.getYourSalesProductsData,
            s = o.ProductSalesDetailsHeaderNames,
            l = o.openProductDataDialog,
            d = o.setOpenProductDataDialog,
            c = o.yorSalesArray,
            u = o.activeClientObj,
            p = o.yorSalesProductArray,
            m = o.t,
            h = o.getPrintOrderDetails,
            f = o.shopCurrency,
            g = o.shopName,
            v = o.orderesLoading,
            b = o.selectFeatures,
            _ = o.currency,
            y = xv().getDateFormat,
            C = Tv();
          return (0, e.jsxs)(e.Fragment, {
            children: [
              C
                ? (0, e.jsx)(SI, {
                    tableType: "1",
                    headerArray: a,
                    dataArray: c,
                    getProductData: i,
                  })
                : (0, e.jsx)(
                    ep,
                    kI(
                      { sx: Ho },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          kI(
                            { stickyHeader: !0 },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsx)(
                                    Cp,
                                    kI(
                                      { className: "stickyHeaderRow" },
                                      {
                                        children:
                                          null == a
                                            ? void 0
                                            : a.map(function (t, n) {
                                                return (0,
                                                e.jsx)(Op, kI({ sx: { whiteSpace: "nowrap", fontSize: "13px", display: (null == t ? void 0 : t.hidden) ? "none" : "table-cell" } }, { children: (0, e.jsx)("b", { children: t.label }) }), n);
                                              }),
                                      }
                                    )
                                  ),
                                }),
                                (0, e.jsx)(
                                  Dp,
                                  kI(
                                    { className: "ST_SO_Thead" },
                                    {
                                      children:
                                        (null == c ? void 0 : c.length) > 0
                                          ? null == c
                                            ? void 0
                                            : c.map(function (t, n) {
                                                var r, o;
                                                return "open" !== t.OrderStatus
                                                  ? (0, e.jsxs)(
                                                      Cp,
                                                      {
                                                        children: [
                                                          (0, e.jsx)(
                                                            Op,
                                                            kI(
                                                              {
                                                                sx: Lo,
                                                                onClick:
                                                                  function () {
                                                                    return i(t);
                                                                  },
                                                              },
                                                              {
                                                                children:
                                                                  null == t
                                                                    ? void 0
                                                                    : t.orderNumber,
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(Op, {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.orderDate) ||
                                                              "-",
                                                          }),
                                                          (0, e.jsx)(Op, {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.OrderPaidDate) ||
                                                              "-",
                                                          }),
                                                          (0, e.jsx)(
                                                            Op,
                                                            kI(
                                                              {
                                                                sx: {
                                                                  width: "15%",
                                                                },
                                                              },
                                                              {
                                                                children:
                                                                  (null == t
                                                                    ? void 0
                                                                    : t.CustomerName) ||
                                                                  "-",
                                                              }
                                                            )
                                                          ),
                                                          (
                                                            null == b
                                                              ? void 0
                                                              : b.CreateB2BOrder
                                                          )
                                                            ? (0, e.jsxs)(
                                                                e.Fragment,
                                                                {
                                                                  children: [
                                                                    (0, e.jsx)(
                                                                      Op,
                                                                      kI(
                                                                        {
                                                                          className:
                                                                            "ST_SOD_TableCellWordWrap",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (null ==
                                                                            t
                                                                              ? void 0
                                                                              : t.b2BCompanyName) ||
                                                                            "-",
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      Op,
                                                                      kI(
                                                                        {
                                                                          className:
                                                                            "ST_SOD_TableCellWordWrap",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (null ==
                                                                            t
                                                                              ? void 0
                                                                              : t.b2BLocationName) ||
                                                                            "-",
                                                                        }
                                                                      )
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            : null,
                                                          (0, e.jsxs)(
                                                            Op,
                                                            kI(
                                                              {
                                                                align: "center",
                                                                className:
                                                                  "ST_White_Space",
                                                              },
                                                              {
                                                                children: [
                                                                  f + " ",
                                                                  " ",
                                                                  (null ===
                                                                    (r =
                                                                      null == t
                                                                        ? void 0
                                                                        : t.subtotal) ||
                                                                  void 0 === r
                                                                    ? void 0
                                                                    : r.toFixed(
                                                                        2
                                                                      )) ||
                                                                    "0.00",
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsxs)(
                                                            Op,
                                                            kI(
                                                              {
                                                                align: "center",
                                                                className:
                                                                  "ST_White_Space",
                                                              },
                                                              {
                                                                children: [
                                                                  f + " ",
                                                                  " ",
                                                                  (null ===
                                                                    (o =
                                                                      null == t
                                                                        ? void 0
                                                                        : t.commission) ||
                                                                  void 0 === o
                                                                    ? void 0
                                                                    : o.toFixed(
                                                                        2
                                                                      )) || "0",
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(Op, {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.CommissionType) ||
                                                              "-",
                                                          }),
                                                          (0, e.jsx)(
                                                            Op,
                                                            kI(
                                                              {
                                                                align: "center",
                                                                sx: {
                                                                  cursor:
                                                                    null === g
                                                                      ? "not-allowed"
                                                                      : "curosr",
                                                                },
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsx)(
                                                                  rl,
                                                                  kI(
                                                                    {
                                                                      className:
                                                                        "ST_link_FontColor",
                                                                      href: h(
                                                                        t
                                                                      ),
                                                                      target:
                                                                        "_blank",
                                                                      sx: {
                                                                        pointerEvents:
                                                                          null ===
                                                                          g
                                                                            ? "none"
                                                                            : "all",
                                                                      },
                                                                    },
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsx)(
                                                                          yI,
                                                                          {
                                                                            sx: {
                                                                              cursor:
                                                                                "pointer",
                                                                              color:
                                                                                "#1976d2",
                                                                            },
                                                                          }
                                                                        ),
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      },
                                                      n
                                                    )
                                                  : "";
                                              })
                                          : (0, e.jsx)(Cp, {
                                              children: (0, e.jsx)(
                                                Op,
                                                kI(
                                                  {
                                                    align: "center",
                                                    colSpan: (
                                                      null == b
                                                        ? void 0
                                                        : b.CreateB2BOrder
                                                    )
                                                      ? 9
                                                      : 8,
                                                  },
                                                  {
                                                    children: m(
                                                      v
                                                        ? "ordersLoading"
                                                        : "no_orders_to_show"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
              (0, e.jsx)(
                Hp,
                kI(
                  {
                    open: l,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return d(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      mn,
                      kI(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              kI(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      kI(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            kI(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: m(
                                                  "yourSales_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      kI(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              d(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (null == p ? void 0 : p.length) > 0
                              ? (0, e.jsxs)(
                                  Gp,
                                  kI(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        u
                                          ? (0, e.jsx)(mn, {
                                              children: (0, e.jsxs)(
                                                qa,
                                                kI(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_table1Column1"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == u
                                                                      ? void 0
                                                                      : u.order_number,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_table1Column4"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    f + " ",
                                                                    (null ===
                                                                      (t =
                                                                        null ==
                                                                        u
                                                                          ? void 0
                                                                          : u.subtotal_price) ||
                                                                    void 0 === t
                                                                      ? void 0
                                                                      : t.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    "  ",
                                                                    " " +
                                                                      (null != _
                                                                        ? _
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_content3"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    f + " ",
                                                                    (null ===
                                                                      (n =
                                                                        null ==
                                                                        u
                                                                          ? void 0
                                                                          : u.shippingCharges) ||
                                                                    void 0 === n
                                                                      ? void 0
                                                                      : n.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    "  ",
                                                                    " " +
                                                                      (null != _
                                                                        ? _
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_content2"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    f + " ",
                                                                    (null == u
                                                                      ? void 0
                                                                      : u.total_tax) ||
                                                                      "0.00",
                                                                    "  ",
                                                                    " " +
                                                                      (null != _
                                                                        ? _
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_column7"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    f + " ",
                                                                    (null ===
                                                                      (r =
                                                                        null ==
                                                                        u
                                                                          ? void 0
                                                                          : u.total_price) ||
                                                                    void 0 === r
                                                                      ? void 0
                                                                      : r.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    "  ",
                                                                    " " +
                                                                      (null != _
                                                                        ? _
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        kI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              kI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            m(
                                                                              "yourSales_content5"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == u
                                                                      ? void 0
                                                                      : u.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : "",
                                        C
                                          ? (0, e.jsx)(SI, {
                                              tableType: "2",
                                              headerArray: s,
                                              dataArray: p,
                                            })
                                          : (0, e.jsx)(
                                              ep,
                                              kI(
                                                {
                                                  sx: kI(kI({ mt: 1 }, Ho), {
                                                    borderTop:
                                                      "1px solid #dadada",
                                                  }),
                                                },
                                                {
                                                  children: (0, e.jsxs)(
                                                    sp,
                                                    kI(
                                                      { stickyHeader: !0 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(hp, {
                                                            children: (0,
                                                            e.jsx)(Cp, {
                                                              children:
                                                                null == s
                                                                  ? void 0
                                                                  : s.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          kI(
                                                                            {
                                                                              sx: zo,
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      t.label,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }),
                                                          }),
                                                          (0, e.jsx)(
                                                            Dp,
                                                            kI(
                                                              {
                                                                className:
                                                                  "ST_SO_Thead",
                                                              },
                                                              {
                                                                children:
                                                                  null == p
                                                                    ? void 0
                                                                    : p.map(
                                                                        function (
                                                                          t,
                                                                          n
                                                                        ) {
                                                                          var r,
                                                                            o,
                                                                            a;
                                                                          return (0,
                                                                          e.jsxs)(
                                                                            Cp,
                                                                            {
                                                                              children:
                                                                                [
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        component:
                                                                                          "th",
                                                                                        scope:
                                                                                          "row",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Image
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                mn,
                                                                                                {
                                                                                                  component:
                                                                                                    "img",
                                                                                                  sx: Vo,
                                                                                                  src: t.Image,
                                                                                                }
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                Sb,
                                                                                                {
                                                                                                  sx: {
                                                                                                    height: 50,
                                                                                                    width: 50,
                                                                                                  },
                                                                                                }
                                                                                              ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "10%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Title ||
                                                                                          "-",
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "10%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.variantTitle ||
                                                                                          "-",
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.SKU ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.quantity,
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            f +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (r =
                                                                                                t.ItemPrice) ||
                                                                                            void 0 ===
                                                                                              r
                                                                                              ? void 0
                                                                                              : r.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            f +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (o =
                                                                                                t.discountedPrice) ||
                                                                                            void 0 ===
                                                                                              o
                                                                                              ? void 0
                                                                                              : o.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.trackingNumber ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "9%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          y(
                                                                                            null ==
                                                                                              t
                                                                                              ? void 0
                                                                                              : t.ShipDate
                                                                                          ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    kI(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "9%",
                                                                                        },
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            f +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (a =
                                                                                                t.Subtotal) ||
                                                                                            void 0 ===
                                                                                              a
                                                                                              ? void 0
                                                                                              : a.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                ],
                                                                            },
                                                                            n
                                                                          );
                                                                        }
                                                                      ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsxs)(Gp, {
                                  children: [m("no_product_details"), "."],
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        };
      function wI() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s,
          l,
          d = this,
          c = ee().t,
          u = g(),
          p = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          m = F.getState().salesRepData.loggedInRepDetails.currency,
          h = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          f = (0, t.useState)(
            (
              null === (e = null == h ? void 0 : h.ordersData) || void 0 === e
                ? void 0
                : e.AllOrdersCommission
            )
              ? null === (n = null == h ? void 0 : h.ordersData) || void 0 === n
                ? void 0
                : n.AllOrdersCommission
              : []
          ),
          v = f[0],
          b = f[1],
          _ = (0, t.useState)(
            !(
              (null ===
                (o =
                  null === (r = null == h ? void 0 : h.ordersData) ||
                  void 0 === r
                    ? void 0
                    : r.AllOrdersCommission) || void 0 === o
                ? void 0
                : o.length) > 0
            )
          ),
          C = _[0],
          x = _[1],
          S =
            null !== (a = F.getState().salesRepData.baseData.select) &&
            void 0 !== a
              ? a
              : {},
          k = [
            { label: c("draftOrder_OrderNumber") },
            { label: c("draftOrder_CustName") },
            {
              label: c("salesDetailsHeader_Company"),
              hidden: !(null == S ? void 0 : S.CreateB2BOrder),
            },
            {
              label: c("salesDetailsHeader_Location"),
              hidden: !(null == S ? void 0 : S.CreateB2BOrder),
            },
            { label: c("draftOrder_OrderDate") },
            { label: c("draftOrder_SubTotal") + "(" + p + ")" },
            { label: c("draftOrder_Status") },
          ],
          P = [
            { label: c("yourSales_column1") },
            { label: c("yourSales_column2") },
            { label: c("variant_title") },
            { label: "SKU" },
            { label: c("yourSales_column3") },
            { label: c("yourSales_column4") + "(" + p + ")" },
            { label: c("viewProductModelColumn6") + "(" + p + ")" },
            { label: c("yourSales_column5") },
            { label: c("yourSales_column6") },
            { label: c("yourSales_column7") + "(" + p + ")" },
          ],
          w = (0, t.useState)(
            (
              null === (i = null == h ? void 0 : h.ordersData) || void 0 === i
                ? void 0
                : i.AllOrdersCommission
            )
              ? null === (s = null == h ? void 0 : h.ordersData) || void 0 === s
                ? void 0
                : s.AllOrdersCommission
              : []
          ),
          O = w[0],
          T = w[1],
          I = (0, t.useState)(""),
          M = I[0],
          j = I[1];
        (0, t.useEffect)(function () {
          var e, t;
          0 === (null == v ? void 0 : v.length) &&
            0 ===
              (null ===
                (t =
                  null === (e = null == h ? void 0 : h.ordersData) ||
                  void 0 === e
                    ? void 0
                    : e.AllOrdersCommission) || void 0 === t
                ? void 0
                : t.length) &&
            x(!1);
        }, []),
          (0, t.useEffect)(
            function () {
              var e, t, n, r;
              0 === (null == v ? void 0 : v.length) &&
                (null ===
                  (t =
                    null === (e = null == h ? void 0 : h.ordersData) ||
                    void 0 === e
                      ? void 0
                      : e.AllOrdersCommission) || void 0 === t
                  ? void 0
                  : t.length) > 0 &&
                (b(
                  null === (n = null == h ? void 0 : h.ordersData) ||
                    void 0 === n
                    ? void 0
                    : n.AllOrdersCommission
                ),
                T(
                  null === (r = null == h ? void 0 : h.ordersData) ||
                    void 0 === r
                    ? void 0
                    : r.AllOrdersCommission
                ),
                x(!1));
            },
            [null == h ? void 0 : h.ordersData]
          ),
          (0, t.useEffect)(
            function () {
              var e =
                null == Hh
                  ? void 0
                  : Hh.subscribe(function (e) {
                      if (
                        "Unpaid" === (null == e ? void 0 : e.orderTab) &&
                        (null == e ? void 0 : e.searchText) !== M
                      ) {
                        j(null == e ? void 0 : e.searchText);
                        var t = (function (e, t, n) {
                            if (n || 2 === arguments.length)
                              for (var r, o = 0, a = t.length; o < a; o++)
                                (!r && o in t) ||
                                  (r ||
                                    (r = Array.prototype.slice.call(t, 0, o)),
                                  (r[o] = t[o]));
                            return e.concat(r || Array.prototype.slice.call(t));
                          })([], O, !0),
                          n =
                            null == t
                              ? void 0
                              : t.filter(function (t) {
                                  var n, r, o, a, i, s;
                                  return (
                                    (null ===
                                      (r =
                                        null ===
                                          (n =
                                            null == t
                                              ? void 0
                                              : t.CustomerName) || void 0 === n
                                          ? void 0
                                          : n.toLowerCase()) || void 0 === r
                                      ? void 0
                                      : r.includes(
                                          null ===
                                            (o =
                                              null == e
                                                ? void 0
                                                : e.searchText) || void 0 === o
                                            ? void 0
                                            : o.toLowerCase()
                                        )) ||
                                    (null ===
                                      (i =
                                        null ===
                                          (a =
                                            null == t
                                              ? void 0
                                              : t.orderNumber) || void 0 === a
                                          ? void 0
                                          : a.toLowerCase()) || void 0 === i
                                      ? void 0
                                      : i.includes(
                                          null ===
                                            (s =
                                              null == e
                                                ? void 0
                                                : e.searchText) || void 0 === s
                                            ? void 0
                                            : s.toLowerCase()
                                        ))
                                  );
                                });
                        b(n);
                      }
                    });
              return function () {
                return e.unsubscribe();
              };
            },
            [v, M, b]
          );
        var N =
            null !==
              (l =
                null == v
                  ? void 0
                  : v.filter(function (e) {
                      return "pending" === e.OrderStatus;
                    })) && void 0 !== l
              ? l
              : [],
          D = (0, t.useState)(!1),
          A = D[0],
          E = D[1],
          R = (0, t.useState)(),
          L = R[0],
          B = R[1],
          z = (0, t.useState)([]),
          Z = z[0],
          H = z[1];
        return {
          PendingOrdersHeaderNames: k,
          pendingOrdersArray: N,
          t: c,
          getPendingProductsData: function (e) {
            return (
              (t = d),
              (n = void 0),
              (o = function () {
                var t, n;
                return (function (e, t) {
                  var n,
                    r,
                    o,
                    a,
                    i = {
                      label: 0,
                      sent: function () {
                        if (1 & o[0]) throw o[1];
                        return o[1];
                      },
                      trys: [],
                      ops: [],
                    };
                  return (
                    (a = { next: s(0), throw: s(1), return: s(2) }),
                    "function" == typeof Symbol &&
                      (a[Symbol.iterator] = function () {
                        return this;
                      }),
                    a
                  );
                  function s(s) {
                    return function (l) {
                      return (function (s) {
                        if (n)
                          throw new TypeError(
                            "Generator is already executing."
                          );
                        for (; a && ((a = 0), s[0] && (i = 0)), i; )
                          try {
                            if (
                              ((n = 1),
                              r &&
                                (o =
                                  2 & s[0]
                                    ? r.return
                                    : s[0]
                                    ? r.throw ||
                                      ((o = r.return) && o.call(r), 0)
                                    : r.next) &&
                                !(o = o.call(r, s[1])).done)
                            )
                              return o;
                            switch (
                              ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                            ) {
                              case 0:
                              case 1:
                                o = s;
                                break;
                              case 4:
                                return i.label++, { value: s[1], done: !1 };
                              case 5:
                                i.label++, (r = s[1]), (s = [0]);
                                continue;
                              case 7:
                                (s = i.ops.pop()), i.trys.pop();
                                continue;
                              default:
                                if (
                                  !(
                                    (o =
                                      (o = i.trys).length > 0 &&
                                      o[o.length - 1]) ||
                                    (6 !== s[0] && 2 !== s[0])
                                  )
                                ) {
                                  i = 0;
                                  continue;
                                }
                                if (
                                  3 === s[0] &&
                                  (!o || (s[1] > o[0] && s[1] < o[3]))
                                ) {
                                  i.label = s[1];
                                  break;
                                }
                                if (6 === s[0] && i.label < o[1]) {
                                  (i.label = o[1]), (o = s);
                                  break;
                                }
                                if (o && i.label < o[2]) {
                                  (i.label = o[2]), i.ops.push(s);
                                  break;
                                }
                                o[2] && i.ops.pop(), i.trys.pop();
                                continue;
                            }
                            s = t.call(e, i);
                          } catch (e) {
                            (s = [6, e]), (r = 0);
                          } finally {
                            n = o = 0;
                          }
                        if (5 & s[0]) throw s[1];
                        return { value: s[0] ? s[1] : void 0, done: !0 };
                      })([s, l]);
                    };
                  }
                })(this, function (r) {
                  switch (r.label) {
                    case 0:
                      return (
                        (t = { order_id: e.OrderId }),
                        Bh.next(!0),
                        [4, u(cg(t))]
                      );
                    case 1:
                      return (
                        (n = r.sent()),
                        E(!0),
                        H(n ? n.ProductDetails : []),
                        B(n.singleOrderDetailsFromShopify),
                        Bh.next(!1),
                        [2]
                      );
                  }
                });
              }),
              new ((r = void 0) || (r = Promise))(function (e, a) {
                function i(e) {
                  try {
                    l(o.next(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function s(e) {
                  try {
                    l(o.throw(e));
                  } catch (e) {
                    a(e);
                  }
                }
                function l(t) {
                  var n;
                  t.done
                    ? e(t.value)
                    : ((n = t.value),
                      n instanceof r
                        ? n
                        : new r(function (e) {
                            e(n);
                          })).then(i, s);
                }
                l((o = o.apply(t, n || [])).next());
              })
            );
            var t, n, r, o;
          },
          openProductDataDialog: A,
          activeClientObj: L,
          pendingProductArray: Z,
          setOpenProductDataDialog: E,
          shopCurrency: p,
          ProductSalesDetailsHeaderNames: P,
          orderesLoading: C,
          selectFeatures: S,
          currency: m,
        };
      }
      var OI = function () {
          return (
            (OI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            OI.apply(this, arguments)
          );
        },
        TI = function (n) {
          var r = n.tableType,
            o = n.headerArray,
            a = n.dataArray,
            i = n.getProductData,
            s = wI(),
            l = s.shopCurrency,
            d = s.t,
            c = xv().getDateFormat,
            u = function (t, n) {
              var r, o;
              switch (t) {
                case 0:
                  o = (0, e.jsx)(
                    Op,
                    OI(
                      {
                        sx: Lo,
                        onClick: function () {
                          i(n);
                        },
                      },
                      { children: null == n ? void 0 : n.orderNumber }
                    )
                  );
                  break;
                case 1:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.CustomerName) || "-",
                  });
                  break;
                case 2:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BCompanyName) || "-",
                  });
                  break;
                case 3:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BLocationName) || "-",
                  });
                  break;
                case 4:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.orderDate) || "-",
                  });
                  break;
                case 5:
                  o = (0, e.jsxs)(
                    Op,
                    OI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          " ",
                          (null === (r = null == n ? void 0 : n.subtotal) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0",
                        ],
                      }
                    )
                  );
                  break;
                case 6:
                  o = (0, e.jsx)(Op, { children: "Unpaid" });
              }
              return o;
            },
            p = function (t, n) {
              var r, o, a, i;
              switch (t) {
                case 0:
                  i = (0, e.jsx)(
                    Op,
                    OI(
                      { scope: "row" },
                      {
                        children: (null == n ? void 0 : n.Image)
                          ? (0, e.jsx)(mn, {
                              component: "img",
                              sx: Vo,
                              src: n.Image,
                            })
                          : (0, e.jsx)(VT.Z, { sx: { height: 50, width: 50 } }),
                      }
                    )
                  );
                  break;
                case 1:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.Title) || "-",
                  });
                  break;
                case 2:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.variantTitle) || "-",
                  });
                  break;
                case 3:
                  i = (0, e.jsx)(Op, { children: n.SKU || "-" });
                  break;
                case 4:
                  i = (0, e.jsx)(Op, { children: n.quantity });
                  break;
                case 5:
                  i = (0, e.jsxs)(
                    Op,
                    OI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          (null === (r = null == n ? void 0 : n.ItemPrice) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 6:
                  i = (0, e.jsxs)(
                    Op,
                    OI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          (null ===
                            (o = null == n ? void 0 : n.discountedPrice) ||
                          void 0 === o
                            ? void 0
                            : o.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 7:
                  i = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.trackingNumber) || "-",
                  });
                  break;
                case 8:
                  i = (0, e.jsx)(Op, {
                    children: c(null == n ? void 0 : n.ShipDate),
                  });
                  break;
                case 9:
                  i = (0, e.jsxs)(
                    Op,
                    OI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          (null === (a = null == n ? void 0 : n.Subtotal) ||
                          void 0 === a
                            ? void 0
                            : a.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
              }
              return i;
            };
          return "1" === r
            ? (0, e.jsx)(
                ep,
                OI(
                  { sx: Ho, className: "Table_Container_Margin" },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      OI(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return (0,
                                                      e.jsxs)(Cp, OI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), u(r, n)] }), t.label + r);
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  OI(
                                    { className: "BorderBottom" },
                                    { children: d("no_orders_to_show") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              )
            : (0, e.jsx)(ep, {
                children: (0, e.jsx)(sp, {
                  children:
                    null != a && (null == a ? void 0 : a.length) > 0
                      ? null == a
                        ? void 0
                        : a.map(function (n, r) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  OI(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == o
                                              ? void 0
                                              : o.map(function (t, r) {
                                                  return (0,
                                                  e.jsxs)(Cp, OI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), p(r, n)] }), t.label + r);
                                                }),
                                        },
                                        r
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              OI(
                                { className: "BorderBottom" },
                                { children: d("no_product_details") }
                              )
                            ),
                          }),
                        }),
                }),
              });
        },
        II = function () {
          return (
            (II =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            II.apply(this, arguments)
          );
        },
        MI = function () {
          var t,
            n,
            r,
            o = wI(),
            a = o.PendingOrdersHeaderNames,
            i = o.pendingOrdersArray,
            s = o.t,
            l = o.getPendingProductsData,
            d = o.openProductDataDialog,
            c = o.activeClientObj,
            u = o.pendingProductArray,
            p = o.setOpenProductDataDialog,
            m = o.shopCurrency,
            h = o.ProductSalesDetailsHeaderNames,
            f = o.orderesLoading,
            g = o.selectFeatures,
            v = o.currency,
            b = xv().getDateFormat,
            _ = Tv();
          return (0, e.jsxs)(e.Fragment, {
            children: [
              _
                ? (0, e.jsx)(TI, {
                    tableType: "1",
                    headerArray: a,
                    dataArray: i,
                    getProductData: l,
                  })
                : (0, e.jsx)(
                    ep,
                    II(
                      { sx: Ho },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          II(
                            { stickyHeader: !0 },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsx)(Cp, {
                                    children:
                                      null == a
                                        ? void 0
                                        : a.map(function (t, n) {
                                            return (0,
                                            e.jsx)(Op, II({ sx: { whiteSpace: "nowrap", fontSize: "13px", display: (null == t ? void 0 : t.hidden) ? "none" : "table-cell" } }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                          }),
                                  }),
                                }),
                                (0, e.jsx)(
                                  Dp,
                                  II(
                                    { className: "ST_SO_Thead" },
                                    {
                                      children:
                                        (null == i ? void 0 : i.length) > 0
                                          ? null == i
                                            ? void 0
                                            : i.map(function (t, n) {
                                                var r;
                                                return (0, e.jsxs)(
                                                  Cp,
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        Op,
                                                        II(
                                                          {
                                                            sx: Lo,
                                                            onClick:
                                                              function () {
                                                                l(t);
                                                              },
                                                          },
                                                          {
                                                            children:
                                                              null == t
                                                                ? void 0
                                                                : t.orderNumber,
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        Op,
                                                        II(
                                                          {
                                                            sx: {
                                                              width: "15%",
                                                            },
                                                          },
                                                          {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.CustomerName) ||
                                                              "-",
                                                          }
                                                        )
                                                      ),
                                                      (
                                                        null == g
                                                          ? void 0
                                                          : g.CreateB2BOrder
                                                      )
                                                        ? (0, e.jsxs)(
                                                            e.Fragment,
                                                            {
                                                              children: [
                                                                (0, e.jsx)(
                                                                  Op,
                                                                  II(
                                                                    {
                                                                      className:
                                                                        "ST_SOD_TableCellWordWrap",
                                                                    },
                                                                    {
                                                                      children:
                                                                        (null ==
                                                                        t
                                                                          ? void 0
                                                                          : t.b2BCompanyName) ||
                                                                        "-",
                                                                    }
                                                                  )
                                                                ),
                                                                (0, e.jsx)(
                                                                  Op,
                                                                  II(
                                                                    {
                                                                      className:
                                                                        "ST_SOD_TableCellWordWrap",
                                                                    },
                                                                    {
                                                                      children:
                                                                        (null ==
                                                                        t
                                                                          ? void 0
                                                                          : t.b2BLocationName) ||
                                                                        "-",
                                                                    }
                                                                  )
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        : null,
                                                      (0, e.jsx)(Op, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.orderDate) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsxs)(
                                                        Op,
                                                        II(
                                                          {
                                                            className:
                                                              "ST_White_Space",
                                                          },
                                                          {
                                                            children: [
                                                              m + " ",
                                                              " ",
                                                              (null ===
                                                                (r =
                                                                  null == t
                                                                    ? void 0
                                                                    : t.subtotal) ||
                                                              void 0 === r
                                                                ? void 0
                                                                : r.toFixed(
                                                                    2
                                                                  )) || "0",
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(Op, {
                                                        children: "Unpaid",
                                                      }),
                                                    ],
                                                  },
                                                  n
                                                );
                                              })
                                          : (0, e.jsx)(Cp, {
                                              children: (0, e.jsx)(
                                                Op,
                                                II(
                                                  {
                                                    align: "center",
                                                    colSpan: (
                                                      null == g
                                                        ? void 0
                                                        : g.CreateB2BOrder
                                                    )
                                                      ? 7
                                                      : 5,
                                                  },
                                                  {
                                                    children: s(
                                                      f
                                                        ? "ordersLoading"
                                                        : "no_orders_to_show"
                                                    ),
                                                  }
                                                )
                                              ),
                                            }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
              (0, e.jsx)(
                Hp,
                II(
                  {
                    open: d,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return p(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      mn,
                      II(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              II(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      II(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            II(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: s(
                                                  "yourSales_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      II(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              p(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (null == u ? void 0 : u.length) > 0
                              ? (0, e.jsxs)(
                                  Gp,
                                  II(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        c
                                          ? (0, e.jsx)(mn, {
                                              children: (0, e.jsxs)(
                                                qa,
                                                II(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_table1Column1"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == c
                                                                      ? void 0
                                                                      : c.order_number,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_table1Column4"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    m + " ",
                                                                    (null ===
                                                                      (t =
                                                                        null ==
                                                                        c
                                                                          ? void 0
                                                                          : c.subtotal_price) ||
                                                                    void 0 === t
                                                                      ? void 0
                                                                      : t.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    " " +
                                                                      (null != v
                                                                        ? v
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_content3"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    m + " ",
                                                                    (null ===
                                                                      (n =
                                                                        null ==
                                                                        c
                                                                          ? void 0
                                                                          : c.shippingCharges) ||
                                                                    void 0 === n
                                                                      ? void 0
                                                                      : n.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    " " +
                                                                      (null != v
                                                                        ? v
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_content2"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    m + " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.total_tax) ||
                                                                      "0.00",
                                                                    " ",
                                                                    " " +
                                                                      (null != v
                                                                        ? v
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_column7"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    m + " ",
                                                                    (null ===
                                                                      (r =
                                                                        null ==
                                                                        c
                                                                          ? void 0
                                                                          : c.total_price) ||
                                                                    void 0 === r
                                                                      ? void 0
                                                                      : r.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    " " +
                                                                      (null != v
                                                                        ? v
                                                                        : ""),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        II(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              II(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            s(
                                                                              "yourSales_content5"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == c
                                                                      ? void 0
                                                                      : c.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : "",
                                        _
                                          ? (0, e.jsx)(TI, {
                                              tableType: "2",
                                              headerArray: h,
                                              dataArray: u,
                                            })
                                          : (0, e.jsx)(
                                              ep,
                                              II(
                                                {
                                                  sx: II(II({ mt: 1 }, Ho), {
                                                    borderTop:
                                                      "1px solid #dadada",
                                                  }),
                                                },
                                                {
                                                  children: (0, e.jsxs)(
                                                    sp,
                                                    II(
                                                      { stickyHeader: !0 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(hp, {
                                                            children: (0,
                                                            e.jsx)(Cp, {
                                                              children:
                                                                null == h
                                                                  ? void 0
                                                                  : h.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          II(
                                                                            {
                                                                              sx: zo,
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      t.label,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }),
                                                          }),
                                                          (0, e.jsx)(
                                                            Dp,
                                                            II(
                                                              {
                                                                className:
                                                                  "ST_SO_Thead",
                                                              },
                                                              {
                                                                children:
                                                                  null == u
                                                                    ? void 0
                                                                    : u.map(
                                                                        function (
                                                                          t,
                                                                          n
                                                                        ) {
                                                                          var r,
                                                                            o,
                                                                            a;
                                                                          return (0,
                                                                          e.jsxs)(
                                                                            Cp,
                                                                            {
                                                                              children:
                                                                                [
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        component:
                                                                                          "th",
                                                                                        scope:
                                                                                          "row",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Image
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                mn,
                                                                                                {
                                                                                                  component:
                                                                                                    "img",
                                                                                                  sx: Vo,
                                                                                                  src: t.Image,
                                                                                                }
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                Sb,
                                                                                                {
                                                                                                  sx: {
                                                                                                    height: 50,
                                                                                                    width: 50,
                                                                                                  },
                                                                                                }
                                                                                              ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "10%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Title ||
                                                                                          "-",
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "10%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.variantTitle ||
                                                                                          "-",
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.SKU ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.quantity,
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            m +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (r =
                                                                                                t.ItemPrice) ||
                                                                                            void 0 ===
                                                                                              r
                                                                                              ? void 0
                                                                                              : r.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            m +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (o =
                                                                                                t.discountedPrice) ||
                                                                                            void 0 ===
                                                                                              o
                                                                                              ? void 0
                                                                                              : o.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.trackingNumber ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "9%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          "Not Fulfilled" ===
                                                                                          (null ==
                                                                                          t
                                                                                            ? void 0
                                                                                            : t.fulfillmentStatus)
                                                                                            ? "-"
                                                                                            : b(
                                                                                                null ==
                                                                                                  t
                                                                                                  ? void 0
                                                                                                  : t.ShipDate
                                                                                              ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    II(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "9%",
                                                                                        },
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            m +
                                                                                              " ",
                                                                                            (null ===
                                                                                              (a =
                                                                                                t.Subtotal) ||
                                                                                            void 0 ===
                                                                                              a
                                                                                              ? void 0
                                                                                              : a.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                ],
                                                                            },
                                                                            n
                                                                          );
                                                                        }
                                                                      ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsxs)(Gp, {
                                  children: [s("no_product_details"), "."],
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        };
      function jI() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s = this,
          l = g(),
          d = ee().t,
          c = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
          u = [
            { label: d("refundOrders_column1") },
            { label: d("refundOrders_column2") },
            { label: d("refundOrders_column3") },
            { label: d("refundOrders_column5") + "(" + c + ")" },
            { label: d("refundOrders_column6") + "(" + c + ")" },
            { label: d("refundOrders_column8") + "(" + c + ")" },
            { label: d("refundOrders_column9") },
            { label: d("refundOrders_column10") },
          ],
          p = [
            { label: d("refundOrderNumber_column1") },
            { label: d("refundOrderNumber_column3") },
            { label: d("refundOrderNumber_column4") + "(" + c + ")" },
            { label: d("refundOrderNumber_column5") + "(" + c + ")" },
          ],
          m = (0, t.useState)(
            null !==
              (r =
                null ===
                  (n =
                    null === (e = F.getState().salesRepData) || void 0 === e
                      ? void 0
                      : e.ordersData) || void 0 === n
                  ? void 0
                  : n.allRefundOrdersDetails) && void 0 !== r
              ? r
              : []
          ),
          h = m[0],
          f = m[1],
          v = (0, t.useState)([]),
          b = v[0],
          _ = v[1],
          y = (0, t.useState)(!1),
          C = y[0],
          x = y[1],
          S = (0, t.useState)(
            null !==
              (i =
                null ===
                  (a =
                    null === (o = F.getState().salesRepData) || void 0 === o
                      ? void 0
                      : o.ordersData) || void 0 === a
                  ? void 0
                  : a.allRefundOrdersDetails) && void 0 !== i
              ? i
              : []
          ),
          k = S[0],
          P = (S[1], (0, t.useState)("")),
          w = P[0],
          O = P[1];
        return (
          (0, t.useEffect)(
            function () {
              var e = Hh.subscribe(function (e) {
                if ("Refunded" === e.orderTab && e.searchText !== w) {
                  O(null == e ? void 0 : e.searchText);
                  var t = (function (e, t, n) {
                      if (n || 2 === arguments.length)
                        for (var r, o = 0, a = t.length; o < a; o++)
                          (!r && o in t) ||
                            (r || (r = Array.prototype.slice.call(t, 0, o)),
                            (r[o] = t[o]));
                      return e.concat(r || Array.prototype.slice.call(t));
                    })([], k, !0),
                    n =
                      null == t
                        ? void 0
                        : t.filter(function (t) {
                            var n, r;
                            return null ===
                              (r =
                                null ===
                                  (n =
                                    null == t
                                      ? void 0
                                      : t.ShopifyOrderNumber) || void 0 === n
                                  ? void 0
                                  : n.toLowerCase()) || void 0 === r
                              ? void 0
                              : r.includes(null == e ? void 0 : e.searchText);
                          });
                  f(n);
                }
              });
              return function () {
                return null == e ? void 0 : e.unsubscribe();
              };
            },
            [h, w, f]
          ),
          {
            RefundOrdersHeaderNames: u,
            refundOrderArray: h,
            RefundOrdersProductHeaderNames: p,
            refundOrderProductArray: b,
            openRefundProductDataDialog: C,
            setRefundDraftProductDataDialog: x,
            getRefundOrderProducts: function (e) {
              return (
                (t = s),
                (n = void 0),
                (o = function () {
                  var t, n;
                  return (function (e, t) {
                    var n,
                      r,
                      o,
                      a,
                      i = {
                        label: 0,
                        sent: function () {
                          if (1 & o[0]) throw o[1];
                          return o[1];
                        },
                        trys: [],
                        ops: [],
                      };
                    return (
                      (a = { next: s(0), throw: s(1), return: s(2) }),
                      "function" == typeof Symbol &&
                        (a[Symbol.iterator] = function () {
                          return this;
                        }),
                      a
                    );
                    function s(s) {
                      return function (l) {
                        return (function (s) {
                          if (n)
                            throw new TypeError(
                              "Generator is already executing."
                            );
                          for (; a && ((a = 0), s[0] && (i = 0)), i; )
                            try {
                              if (
                                ((n = 1),
                                r &&
                                  (o =
                                    2 & s[0]
                                      ? r.return
                                      : s[0]
                                      ? r.throw ||
                                        ((o = r.return) && o.call(r), 0)
                                      : r.next) &&
                                  !(o = o.call(r, s[1])).done)
                              )
                                return o;
                              switch (
                                ((r = 0), o && (s = [2 & s[0], o.value]), s[0])
                              ) {
                                case 0:
                                case 1:
                                  o = s;
                                  break;
                                case 4:
                                  return i.label++, { value: s[1], done: !1 };
                                case 5:
                                  i.label++, (r = s[1]), (s = [0]);
                                  continue;
                                case 7:
                                  (s = i.ops.pop()), i.trys.pop();
                                  continue;
                                default:
                                  if (
                                    !(
                                      (o =
                                        (o = i.trys).length > 0 &&
                                        o[o.length - 1]) ||
                                      (6 !== s[0] && 2 !== s[0])
                                    )
                                  ) {
                                    i = 0;
                                    continue;
                                  }
                                  if (
                                    3 === s[0] &&
                                    (!o || (s[1] > o[0] && s[1] < o[3]))
                                  ) {
                                    i.label = s[1];
                                    break;
                                  }
                                  if (6 === s[0] && i.label < o[1]) {
                                    (i.label = o[1]), (o = s);
                                    break;
                                  }
                                  if (o && i.label < o[2]) {
                                    (i.label = o[2]), i.ops.push(s);
                                    break;
                                  }
                                  o[2] && i.ops.pop(), i.trys.pop();
                                  continue;
                              }
                              s = t.call(e, i);
                            } catch (e) {
                              (s = [6, e]), (r = 0);
                            } finally {
                              n = o = 0;
                            }
                          if (5 & s[0]) throw s[1];
                          return { value: s[0] ? s[1] : void 0, done: !0 };
                        })([s, l]);
                      };
                    }
                  })(this, function (r) {
                    switch (r.label) {
                      case 0:
                        return (
                          Bh.next(!0),
                          (t = { refundId: e.RefundId, orderId: e.orderId }),
                          [4, l(yg(t))]
                        );
                      case 1:
                        return (
                          (n = r.sent()).refunds.refund_line_items &&
                            (x(!0),
                            _(n.refunds.refund_line_items),
                            Bh.next(!1)),
                          [2]
                        );
                    }
                  });
                }),
                new ((r = void 0) || (r = Promise))(function (e, a) {
                  function i(e) {
                    try {
                      l(o.next(e));
                    } catch (e) {
                      a(e);
                    }
                  }
                  function s(e) {
                    try {
                      l(o.throw(e));
                    } catch (e) {
                      a(e);
                    }
                  }
                  function l(t) {
                    var n;
                    t.done
                      ? e(t.value)
                      : ((n = t.value),
                        n instanceof r
                          ? n
                          : new r(function (e) {
                              e(n);
                            })).then(i, s);
                  }
                  l((o = o.apply(t, n || [])).next());
                })
              );
              var t, n, r, o;
            },
            t: d,
            shopCurrency: c,
          }
        );
      }
      var NI = function () {
          return (
            (NI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            NI.apply(this, arguments)
          );
        },
        DI = function (n) {
          var r = n.tableType,
            o = n.headerArray,
            a = n.dataArray,
            i = n.getProductData,
            s = jI(),
            l = s.shopCurrency,
            d = s.t,
            c = xv().getDateFormat,
            u = function (t, n) {
              var r, o, a, s;
              switch (t) {
                case 0:
                  s = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.RefundId) || "-",
                  });
                  break;
                case 1:
                  s = (0, e.jsx)(Op, {
                    children: c(null == n ? void 0 : n.OrderDate),
                  });
                  break;
                case 2:
                  s = (0, e.jsx)(
                    Op,
                    NI(
                      {
                        sx:
                          "refunded" === (null == n ? void 0 : n.OrderStatus) ||
                          "partially_refunded" ===
                            (null == n ? void 0 : n.OrderStatus)
                            ? Lo
                            : Bo,
                        onClick: function () {
                          return i(n);
                        },
                      },
                      {
                        children:
                          (null == n ? void 0 : n.ShopifyOrderNumber) || "-",
                      }
                    )
                  );
                  break;
                case 3:
                  s = (0, e.jsxs)(
                    Op,
                    NI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          " ",
                          (null === (r = null == n ? void 0 : n.Commission) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 4:
                  s = (0, e.jsxs)(
                    Op,
                    NI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          " ",
                          (null ===
                            (o =
                              null == n ? void 0 : n.TeamManagerCommission) ||
                          void 0 === o
                            ? void 0
                            : o.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 5:
                  s = (0, e.jsxs)(
                    Op,
                    NI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l + " ",
                          " ",
                          (null ===
                            (a = null == n ? void 0 : n.RefundSubTotal) ||
                          void 0 === a
                            ? void 0
                            : a.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 6:
                  s = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.OrderStatus) || "-",
                  });
                  break;
                case 7:
                  s = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.OrderType) || "-",
                  });
              }
              return s;
            },
            p = function (t, n) {
              var r, o, a, i;
              switch (t) {
                case 0:
                  i = (0, e.jsx)(Op, {
                    children:
                      (null === (r = null == n ? void 0 : n.line_item) ||
                      void 0 === r
                        ? void 0
                        : r.title) || "-",
                  });
                  break;
                case 1:
                  i = (0, e.jsx)(Op, {
                    children:
                      null === (o = null == n ? void 0 : n.line_item) ||
                      void 0 === o
                        ? void 0
                        : o.quantity,
                  });
                  break;
                case 2:
                  i = (0, e.jsxs)(
                    Op,
                    NI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l,
                          " ",
                          (null == n ? void 0 : n.line_item.total_discount) ||
                            "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 3:
                  i = (0, e.jsxs)(
                    Op,
                    NI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          l,
                          " ",
                          (null === (a = null == n ? void 0 : n.subtotal) ||
                          void 0 === a
                            ? void 0
                            : a.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
              }
              return i;
            };
          return "1" === r
            ? (0, e.jsx)(
                ep,
                NI(
                  { sx: Ho, className: "Table_Container_Margin" },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      NI(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return (0,
                                                      e.jsxs)(Cp, NI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), u(r, n)] }), t.label + r);
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  NI(
                                    { className: "BorderBottom" },
                                    { children: d("no_orders_to_show") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              )
            : (0, e.jsx)(ep, {
                children: (0, e.jsx)(sp, {
                  children:
                    null != a && (null == a ? void 0 : a.length) > 0
                      ? null == a
                        ? void 0
                        : a.map(function (n, r) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  NI(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == o
                                              ? void 0
                                              : o.map(function (t, r) {
                                                  return (0,
                                                  e.jsxs)(Cp, NI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), p(r, n)] }), t.label + r);
                                                }),
                                        },
                                        r
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              NI(
                                { className: "BorderBottom" },
                                { children: d("no_product_details") }
                              )
                            ),
                          }),
                        }),
                }),
              });
        },
        AI = function () {
          return (
            (AI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            AI.apply(this, arguments)
          );
        },
        EI = function () {
          var t = jI(),
            n = t.RefundOrdersHeaderNames,
            r = t.refundOrderArray,
            o = t.RefundOrdersProductHeaderNames,
            a = t.refundOrderProductArray,
            i = t.openRefundProductDataDialog,
            s = t.setRefundDraftProductDataDialog,
            l = t.getRefundOrderProducts,
            d = t.t,
            c = t.shopCurrency,
            u = xv().getDateFormat,
            p = Tv();
          return (0, e.jsxs)(e.Fragment, {
            children: [
              p
                ? (0, e.jsx)(DI, {
                    tableType: "1",
                    headerArray: n,
                    dataArray: r,
                    getProductData: l,
                  })
                : (0, e.jsx)(
                    ep,
                    AI(
                      { sx: Ho },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          AI(
                            { stickyHeader: !0 },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsx)(Cp, {
                                    children:
                                      null == n
                                        ? void 0
                                        : n.map(function (t, n) {
                                            return (0,
                                            e.jsx)(Op, AI({ sx: { fontSize: "13px" } }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                          }),
                                  }),
                                }),
                                (0, e.jsx)(
                                  Dp,
                                  AI(
                                    { className: "ST_SO_Thead" },
                                    {
                                      children:
                                        (null == r ? void 0 : r.length) > 0
                                          ? null == r
                                            ? void 0
                                            : r.map(function (t, n) {
                                                var r, o, a;
                                                return (0, e.jsxs)(
                                                  Cp,
                                                  {
                                                    children: [
                                                      (0, e.jsx)(Op, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.RefundId) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsx)(Op, {
                                                        children: u(
                                                          null == t
                                                            ? void 0
                                                            : t.OrderDate
                                                        ),
                                                      }),
                                                      (0, e.jsx)(
                                                        Op,
                                                        AI(
                                                          {
                                                            sx:
                                                              "refunded" ===
                                                                (null == t
                                                                  ? void 0
                                                                  : t.OrderStatus) ||
                                                              "partially_refunded" ===
                                                                (null == t
                                                                  ? void 0
                                                                  : t.OrderStatus)
                                                                ? Lo
                                                                : Bo,
                                                            onClick:
                                                              function () {
                                                                return l(t);
                                                              },
                                                          },
                                                          {
                                                            children:
                                                              (null == t
                                                                ? void 0
                                                                : t.ShopifyOrderNumber) ||
                                                              "-",
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsxs)(
                                                        Op,
                                                        AI(
                                                          {
                                                            className:
                                                              "ST_White_Space",
                                                          },
                                                          {
                                                            children: [
                                                              c + " ",
                                                              " ",
                                                              (null ===
                                                                (r =
                                                                  null == t
                                                                    ? void 0
                                                                    : t.Commission) ||
                                                              void 0 === r
                                                                ? void 0
                                                                : r.toFixed(
                                                                    2
                                                                  )) || "0.00",
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsxs)(
                                                        Op,
                                                        AI(
                                                          {
                                                            className:
                                                              "ST_White_Space",
                                                          },
                                                          {
                                                            children: [
                                                              c + " ",
                                                              " ",
                                                              (null ===
                                                                (o =
                                                                  null == t
                                                                    ? void 0
                                                                    : t.TeamManagerCommission) ||
                                                              void 0 === o
                                                                ? void 0
                                                                : o.toFixed(
                                                                    2
                                                                  )) || "0.00",
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsxs)(
                                                        Op,
                                                        AI(
                                                          {
                                                            className:
                                                              "ST_White_Space",
                                                          },
                                                          {
                                                            children: [
                                                              c + " ",
                                                              " ",
                                                              (null ===
                                                                (a =
                                                                  null == t
                                                                    ? void 0
                                                                    : t.RefundSubTotal) ||
                                                              void 0 === a
                                                                ? void 0
                                                                : a.toFixed(
                                                                    2
                                                                  )) || "0.00",
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(Op, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.OrderStatus) ||
                                                          "-",
                                                      }),
                                                      (0, e.jsx)(Op, {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.OrderType) ||
                                                          "-",
                                                      }),
                                                    ],
                                                  },
                                                  n
                                                );
                                              })
                                          : (0, e.jsx)(Cp, {
                                              children: (0, e.jsx)(
                                                Op,
                                                AI(
                                                  {
                                                    align: "center",
                                                    colSpan: 8,
                                                  },
                                                  {
                                                    children:
                                                      d("tableDataError"),
                                                  }
                                                )
                                              ),
                                            }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
              (0, e.jsx)(
                Hp,
                AI(
                  {
                    open: i,
                    maxWidth: "md",
                    fullWidth: !0,
                    onClose: function () {
                      return s(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      mn,
                      AI(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              AI(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      AI(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            AI(
                                              { variant: "h6" },
                                              {
                                                children: d(
                                                  "refundOrderNumber_title"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      AI(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              s(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (null == a ? void 0 : a.length) > 0
                              ? (0, e.jsx)(
                                  Gp,
                                  AI(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: p
                                        ? (0, e.jsx)(DI, {
                                            tableType: "2",
                                            headerArray: o,
                                            dataArray: a,
                                          })
                                        : (0, e.jsx)(
                                            ep,
                                            AI(
                                              { sx: AI({ mt: 2 }, Ho) },
                                              {
                                                children: (0, e.jsxs)(
                                                  sp,
                                                  AI(
                                                    { stickyHeader: !0 },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(hp, {
                                                          children: (0, e.jsx)(
                                                            Cp,
                                                            {
                                                              children:
                                                                null == o
                                                                  ? void 0
                                                                  : o.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          AI(
                                                                            {
                                                                              sx: zo,
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      t.label,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }
                                                          ),
                                                        }),
                                                        (0, e.jsx)(
                                                          Dp,
                                                          AI(
                                                            {
                                                              className:
                                                                "ST_SO_Thead",
                                                            },
                                                            {
                                                              children:
                                                                null == a
                                                                  ? void 0
                                                                  : a.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        var r;
                                                                        return (0,
                                                                        e.jsxs)(
                                                                          Cp,
                                                                          {
                                                                            children:
                                                                              [
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Op,
                                                                                  AI(
                                                                                    {
                                                                                      sx: {
                                                                                        width:
                                                                                          "25%",
                                                                                      },
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        t
                                                                                          .line_item
                                                                                          .title ||
                                                                                        "-",
                                                                                    }
                                                                                  )
                                                                                ),
                                                                                (0,
                                                                                e.jsx)(
                                                                                  Op,
                                                                                  {
                                                                                    children:
                                                                                      t
                                                                                        .line_item
                                                                                        .quantity,
                                                                                  }
                                                                                ),
                                                                                (0,
                                                                                e.jsxs)(
                                                                                  Op,
                                                                                  AI(
                                                                                    {
                                                                                      className:
                                                                                        "ST_White_Space",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          c,
                                                                                          " ",
                                                                                          t
                                                                                            .line_item
                                                                                            .total_discount ||
                                                                                            "0.00",
                                                                                        ],
                                                                                    }
                                                                                  )
                                                                                ),
                                                                                (0,
                                                                                e.jsxs)(
                                                                                  Op,
                                                                                  AI(
                                                                                    {
                                                                                      className:
                                                                                        "ST_White_Space",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        [
                                                                                          c,
                                                                                          " ",
                                                                                          (null ===
                                                                                            (r =
                                                                                              t.subtotal) ||
                                                                                          void 0 ===
                                                                                            r
                                                                                            ? void 0
                                                                                            : r.toFixed(
                                                                                                2
                                                                                              )) ||
                                                                                            "0.00",
                                                                                        ],
                                                                                    }
                                                                                  )
                                                                                ),
                                                                              ],
                                                                          },
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                    }
                                  )
                                )
                              : (0, e.jsx)(Gp, {
                                  children: d("noRefundOrderProduct"),
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        RI = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 0 0-1.41 0l-1.83 1.83 3.75 3.75z",
          }),
          "Edit"
        ),
        LI = (0, Oo.Z)(
          (0, e.jsx)("path", { d: "M2.01 21 23 12 2.01 3 2 10l15 2-15 2z" }),
          "Send"
        ),
        BI = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M9 16.17 4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z",
          }),
          "Check"
        ),
        zI = function () {
          return (
            (zI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            zI.apply(this, arguments)
          );
        },
        FI = function (n) {
          var r = n.tableType,
            o = n.headerArray,
            a = n.dataArray,
            i = n.getProductData,
            s = JT(),
            l = s.t,
            d = s.sendInvoice,
            c = s.openDeleteInvoiceConfirmation,
            u = s.sendInvoiceIndex,
            p = s.sendInvoiceFlag,
            m = s.deleteInvoiceFlag,
            h = s.setDeleteInvoiceFlag,
            f = s.successFlag,
            g = s.deleteConfirmation,
            v = s.setDeleteConfirmation,
            b = s.deleteInvoice,
            _ = s.shopCurrency,
            y = s.handleEditOrder,
            C = s.selectFeatures,
            x = function (t, n) {
              var r, o;
              switch (t) {
                case 0:
                  o = (0, e.jsx)(
                    Op,
                    zI(
                      {
                        sx:
                          "voided" === (null == n ? void 0 : n.status)
                            ? Bo
                            : Lo,
                        onClick: function () {
                          return i(n);
                        },
                      },
                      { children: null == n ? void 0 : n.orderName }
                    )
                  );
                  break;
                case 1:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.customername) || "-",
                  });
                  break;
                case 2:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BCompanyName) || "-",
                  });
                  break;
                case 3:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.b2BLocationName) || "-",
                  });
                  break;
                case 4:
                  o = (0, e.jsx)(Op, {
                    children: (null == n ? void 0 : n.orderDate) || "-",
                  });
                  break;
                case 5:
                  o = (0, e.jsxs)(
                    Op,
                    zI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          _,
                          " ",
                          (null == n ? void 0 : n.subtotalprice.toFixed(2)) ||
                            "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 6:
                  o = (0, e.jsx)(Op, {
                    children:
                      "open" === n.status
                        ? "Draft"
                        : null !== (r = null == n ? void 0 : n.status) &&
                          void 0 !== r
                        ? r
                        : "-",
                  });
                  break;
                case 7:
                  o = (0, e.jsxs)(
                    Op,
                    zI(
                      { sx: { display: "flex", justifyContent: "flex-start" } },
                      {
                        children: [
                          (null == C ? void 0 : C.CustomerInvoice) &&
                            (0, e.jsx)(
                              Gs,
                              zI(
                                {
                                  title:
                                    (null == C ? void 0 : C.CreateInvoice) ||
                                    (null == C ? void 0 : C.CreateOrder) ||
                                    (null == C ? void 0 : C.CreateCheckout)
                                      ? "Edit Order"
                                      : "Create order feature is turned off by Admin",
                                },
                                {
                                  children: (0, e.jsx)(
                                    Qu,
                                    zI(
                                      {
                                        disabled:
                                          "open" !==
                                            (null == n ? void 0 : n.status) ||
                                          ((null == n
                                            ? void 0
                                            : n.b2BCompanyName) &&
                                            (null == n
                                              ? void 0
                                              : n.b2BLocationName)) ||
                                          (!(null == C
                                            ? void 0
                                            : C.CreateInvoice) &&
                                            !(null == C
                                              ? void 0
                                              : C.CreateOrder) &&
                                            !(null == C
                                              ? void 0
                                              : C.CreateCheckout)),
                                        sx:
                                          "voided" ===
                                          (null == n ? void 0 : n.status)
                                            ? Bo
                                            : Lo,
                                        onClick: function () {
                                          y(n);
                                        },
                                      },
                                      {
                                        children: (0, e.jsx)(RI, {
                                          sx: { cursor: "pointer" },
                                        }),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          (0, e.jsx)(
                            Ym,
                            zI(
                              {
                                sx:
                                  "voided" === (null == n ? void 0 : n.status)
                                    ? Bo
                                    : Lo,
                                loading: u === t && p,
                                size: "large",
                              },
                              {
                                children:
                                  p || f
                                    ? u === t && f
                                      ? (0, e.jsx)(BI, {})
                                      : (0, e.jsx)(LI, {
                                          sx: zI(
                                            zI(zI({}, Zo), u === t ? Fo : null),
                                            "voided" ===
                                              (null == n ? void 0 : n.status)
                                              ? Bo
                                              : null
                                          ),
                                        })
                                    : (0, e.jsx)(
                                        Gs,
                                        zI(
                                          { title: "Send Invoice" },
                                          {
                                            children: (0, e.jsx)(LI, {
                                              sx:
                                                "voided" ===
                                                (null == n ? void 0 : n.status)
                                                  ? Bo
                                                  : Lo,
                                              onClick: function () {
                                                return d(n, t);
                                              },
                                            }),
                                          }
                                        )
                                      ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            Qu,
                            zI(
                              {
                                sx:
                                  "voided" === (null == n ? void 0 : n.status)
                                    ? Bo
                                    : Lo,
                                onClick: function (e) {
                                  c(e, n, t);
                                },
                              },
                              {
                                children: (0, e.jsx)(
                                  Gs,
                                  zI(
                                    { title: "Delete" },
                                    {
                                      children: (0, e.jsx)(Ev, {
                                        sx: {
                                          cursor: "pointer",
                                          color: "black",
                                        },
                                      }),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            Jd,
                            zI(
                              {
                                open: Boolean(g),
                                anchorEl: g,
                                onClose: function () {
                                  v(null), h(!1);
                                },
                                anchorOrigin: {
                                  vertical: "bottom",
                                  horizontal: "left",
                                },
                              },
                              {
                                children: (0, e.jsxs)(
                                  "div",
                                  zI(
                                    { className: "ST_DO_DeleteConfirmPopup" },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          ni,
                                          zI(
                                            { pb: 2 },
                                            {
                                              children: l(
                                                "delete_confirmation_text"
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsxs)(
                                          "div",
                                          zI(
                                            { className: "ST_DO_TextRight" },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  Ym,
                                                  zI(
                                                    { loading: m },
                                                    {
                                                      children: m
                                                        ? null
                                                        : (0, e.jsx)(BI, {
                                                            sx: {
                                                              color: "green",
                                                              paddingRight:
                                                                "10px",
                                                              cursor: "pointer",
                                                            },
                                                            onClick:
                                                              function () {
                                                                b();
                                                              },
                                                          }),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(Fg, {
                                                  sx: { ursor: "pointer" },
                                                  className:
                                                    "ST_Error_Msg_Color",
                                                  onClick: function () {
                                                    v(null), h(!1);
                                                  },
                                                }),
                                              ],
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  );
              }
              return o;
            },
            S = function (t, n) {
              var r, o, a, i;
              switch (t) {
                case 0:
                  i = (0, e.jsx)(
                    Op,
                    zI(
                      { scope: "row" },
                      {
                        children: n.Image
                          ? (0, e.jsx)(mn, {
                              component: "img",
                              sx: Vo,
                              src: n.Image,
                            })
                          : (0, e.jsx)(Sb, { sx: { height: 50, width: 50 } }),
                      }
                    )
                  );
                  break;
                case 1:
                  i = (0, e.jsx)(Op, { children: n.Title || "-" });
                  break;
                case 2:
                  i = (0, e.jsx)(Op, { children: n.size || "-" });
                  break;
                case 3:
                  i = (0, e.jsx)(Op, { children: n.quantity });
                  break;
                case 4:
                  i = (0, e.jsxs)(
                    Op,
                    zI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          _,
                          " ",
                          (null === (r = n.ItemPrice) || void 0 === r
                            ? void 0
                            : r.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 5:
                  i = (0, e.jsx)(Op, { children: n.fulfillmentStatus || "-" });
                  break;
                case 6:
                  i = (0, e.jsxs)(
                    Op,
                    zI(
                      { className: "ST_White_Space" },
                      {
                        children: [
                          _,
                          " ",
                          (null === (o = n.quantity) || void 0 === o
                            ? void 0
                            : o.toFixed(2)) *
                            (null === (a = n.ItemPrice) || void 0 === a
                              ? void 0
                              : a.toFixed(2)) || "0.00",
                        ],
                      }
                    )
                  );
              }
              return i;
            };
          return "1" === r
            ? (0, e.jsx)(
                ep,
                zI(
                  { sx: Ho, className: "Table_Container_Margin" },
                  {
                    children: (0, e.jsx)(sp, {
                      children:
                        null != a && (null == a ? void 0 : a.length) > 0
                          ? null == a
                            ? void 0
                            : a.map(function (n, r) {
                                return (0, e.jsxs)(e.Fragment, {
                                  children: [
                                    (0, e.jsx)(
                                      Dp,
                                      zI(
                                        {
                                          sx: { backgroundColor: "whitesmoke" },
                                        },
                                        {
                                          children: (0, e.jsx)(
                                            t.Fragment,
                                            {
                                              children:
                                                null == o
                                                  ? void 0
                                                  : o.map(function (t, r) {
                                                      return "open" ===
                                                        n.status ||
                                                        "voided" === n.status
                                                        ? (0, e.jsxs)(
                                                            Cp,
                                                            zI(
                                                              {
                                                                className:
                                                                  "MobileViewTableCell",
                                                                sx: {
                                                                  display: (
                                                                    null == t
                                                                      ? void 0
                                                                      : t.hidden
                                                                  )
                                                                    ? "none"
                                                                    : "table-row",
                                                                  background:
                                                                    "voided" ===
                                                                    (null == n
                                                                      ? void 0
                                                                      : n.status)
                                                                      ? "#FBEAE5"
                                                                      : "none",
                                                                  opacity:
                                                                    "voided" ===
                                                                    (null == n
                                                                      ? void 0
                                                                      : n.status)
                                                                      ? "39%"
                                                                      : "1",
                                                                },
                                                              },
                                                              {
                                                                children: [
                                                                  (0, e.jsx)(
                                                                    Op,
                                                                    {
                                                                      children:
                                                                        (0,
                                                                        e.jsxs)(
                                                                          "b",
                                                                          {
                                                                            children:
                                                                              [
                                                                                t.label,
                                                                                " :",
                                                                              ],
                                                                          }
                                                                        ),
                                                                    }
                                                                  ),
                                                                  x(r, n),
                                                                ],
                                                              }
                                                            ),
                                                            t.label + r
                                                          )
                                                        : "";
                                                    }),
                                            },
                                            r
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)("br", {}),
                                  ],
                                });
                              })
                          : (0, e.jsx)(Dp, {
                              children: (0, e.jsx)(Cp, {
                                children: (0, e.jsx)(
                                  Op,
                                  zI(
                                    { className: "BorderBottom" },
                                    { children: l("no_orders_to_show") }
                                  )
                                ),
                              }),
                            }),
                    }),
                  }
                )
              )
            : (0, e.jsx)(ep, {
                children: (0, e.jsx)(sp, {
                  children:
                    null != a && (null == a ? void 0 : a.length) > 0
                      ? null == a
                        ? void 0
                        : a.map(function (n, r) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  zI(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == o
                                              ? void 0
                                              : o.map(function (t, r) {
                                                  return "open" !==
                                                    n.OrderStatus
                                                    ? (0, e.jsxs)(
                                                        Cp,
                                                        zI(
                                                          {
                                                            className:
                                                              "MobileViewTableCell",
                                                            sx: {
                                                              display: (
                                                                null == t
                                                                  ? void 0
                                                                  : t.hidden
                                                              )
                                                                ? "none"
                                                                : "table-row",
                                                            },
                                                          },
                                                          {
                                                            children: [
                                                              (0, e.jsx)(Op, {
                                                                children: (0,
                                                                e.jsxs)("b", {
                                                                  children: [
                                                                    t.label,
                                                                    " :",
                                                                  ],
                                                                }),
                                                              }),
                                                              S(r, n),
                                                            ],
                                                          }
                                                        ),
                                                        t.label + r
                                                      )
                                                    : "";
                                                }),
                                        },
                                        r
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              zI(
                                { className: "BorderBottom" },
                                { children: l("no_product_details") }
                              )
                            ),
                          }),
                        }),
                }),
              });
        },
        ZI = function () {
          return (
            (ZI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            ZI.apply(this, arguments)
          );
        },
        HI = function () {
          var t,
            n = JT(),
            r = n.DraftOrdersHeaderNames,
            o = n.DraftOrderProductHeaderNames,
            a = n.openDraftProductDataDialog,
            i = n.setOpenDraftProductDataDialog,
            s = n.draftOrderArray,
            l = n.getDraftOrderDetails,
            d = n.activeClientObj,
            c = n.draftOrderProductDetailsArray,
            u = n.t,
            p = n.sendInvoice,
            m = n.openDeleteInvoiceConfirmation,
            h = n.sendInvoiceIndex,
            f = n.sendInvoiceFlag,
            g = n.deleteInvoiceFlag,
            v = n.setDeleteInvoiceFlag,
            b = n.successFlag,
            _ = n.deleteConfirmation,
            y = n.setDeleteConfirmation,
            C = n.deleteInvoice,
            x = n.shopCurrency,
            S = n.handleEditOrder,
            k = n.selectFeatures,
            P = n.currency,
            w = Tv();
          return (0, e.jsxs)(e.Fragment, {
            children: [
              w
                ? (0, e.jsx)(FI, {
                    tableType: "1",
                    headerArray: r,
                    dataArray: s,
                    getProductData: l,
                  })
                : (0, e.jsx)(
                    ep,
                    ZI(
                      { sx: Ho },
                      {
                        children: (0, e.jsxs)(
                          sp,
                          ZI(
                            { stickyHeader: !0 },
                            {
                              children: [
                                (0, e.jsx)(hp, {
                                  children: (0, e.jsx)(Cp, {
                                    children:
                                      null == r
                                        ? void 0
                                        : r.map(function (t, n) {
                                            return (0,
                                            e.jsx)(Op, ZI({ sx: ZI(ZI({ whiteSpace: "nowrap" }, null == t ? void 0 : t.inlineCSS), { fontSize: "13px", display: (null == t ? void 0 : t.hidden) ? "none" : "table-cell" }) }, { children: (0, e.jsx)("b", { children: null == t ? void 0 : t.label }) }), n);
                                          }),
                                  }),
                                }),
                                (0, e.jsx)(
                                  Dp,
                                  ZI(
                                    { className: "ST_SO_Thead" },
                                    {
                                      children:
                                        (null == s ? void 0 : s.length) > 0
                                          ? null == s
                                            ? void 0
                                            : s.map(function (t, n) {
                                                var r;
                                                return "open" === t.status ||
                                                  "voided" === t.status
                                                  ? (0, e.jsxs)(
                                                      Cp,
                                                      ZI(
                                                        {
                                                          sx:
                                                            "voided" ===
                                                            (null == t
                                                              ? void 0
                                                              : t.status)
                                                              ? {
                                                                  background:
                                                                    "#FBEAE5",
                                                                  opacity:
                                                                    "39%",
                                                                }
                                                              : {
                                                                  background:
                                                                    "none",
                                                                  opacity: "1",
                                                                },
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              Op,
                                                              ZI(
                                                                {
                                                                  sx:
                                                                    "voided" ===
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.status)
                                                                      ? Bo
                                                                      : Lo,
                                                                  onClick:
                                                                    function () {
                                                                      return l(
                                                                        t
                                                                      );
                                                                    },
                                                                },
                                                                {
                                                                  children:
                                                                    null == t
                                                                      ? void 0
                                                                      : t.orderName,
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(Op, {
                                                              children:
                                                                (null == t
                                                                  ? void 0
                                                                  : t.customername) ||
                                                                "-",
                                                            }),
                                                            (
                                                              null == k
                                                                ? void 0
                                                                : k.CreateB2BOrder
                                                            )
                                                              ? (0, e.jsxs)(
                                                                  e.Fragment,
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        ZI(
                                                                          {
                                                                            className:
                                                                              "ST_SOD_TableCellWordWrap",
                                                                          },
                                                                          {
                                                                            children:
                                                                              (null ==
                                                                              t
                                                                                ? void 0
                                                                                : t.b2BCompanyName) ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        Op,
                                                                        ZI(
                                                                          {
                                                                            className:
                                                                              "ST_SOD_TableCellWordWrap",
                                                                          },
                                                                          {
                                                                            children:
                                                                              (null ==
                                                                              t
                                                                                ? void 0
                                                                                : t.b2BLocationName) ||
                                                                              "-",
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  }
                                                                )
                                                              : null,
                                                            (0, e.jsx)(Op, {
                                                              children:
                                                                (null == t
                                                                  ? void 0
                                                                  : t.orderDate) ||
                                                                "-",
                                                            }),
                                                            (0, e.jsxs)(
                                                              Op,
                                                              ZI(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  className:
                                                                    "ST_White_Space",
                                                                },
                                                                {
                                                                  children: [
                                                                    x,
                                                                    " ",
                                                                    (null == t
                                                                      ? void 0
                                                                      : t.subtotalprice.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsx)(
                                                              Op,
                                                              ZI(
                                                                {
                                                                  align:
                                                                    "center",
                                                                },
                                                                {
                                                                  children:
                                                                    "open" ===
                                                                    t.status
                                                                      ? "Draft"
                                                                      : null !==
                                                                          (r =
                                                                            null ==
                                                                            t
                                                                              ? void 0
                                                                              : t.status) &&
                                                                        void 0 !==
                                                                          r
                                                                      ? r
                                                                      : "-",
                                                                }
                                                              )
                                                            ),
                                                            (0, e.jsxs)(
                                                              Op,
                                                              ZI(
                                                                {
                                                                  sx: {
                                                                    display:
                                                                      "flex",
                                                                    justifyContent:
                                                                      "center",
                                                                  },
                                                                },
                                                                {
                                                                  children: [
                                                                    (null == k
                                                                      ? void 0
                                                                      : k.CustomerInvoice) &&
                                                                      (0,
                                                                      e.jsx)(
                                                                        Gs,
                                                                        ZI(
                                                                          {
                                                                            title:
                                                                              (null ==
                                                                              k
                                                                                ? void 0
                                                                                : k.CreateInvoice) ||
                                                                              (null ==
                                                                              k
                                                                                ? void 0
                                                                                : k.CreateOrder) ||
                                                                              (null ==
                                                                              k
                                                                                ? void 0
                                                                                : k.CreateCheckout)
                                                                                ? "Edit Order"
                                                                                : "Create order feature is turned off by Admin",
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsx)(
                                                                                Qu,
                                                                                ZI(
                                                                                  {
                                                                                    disabled:
                                                                                      "open" !==
                                                                                        (null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.status) ||
                                                                                      ((null ==
                                                                                      t
                                                                                        ? void 0
                                                                                        : t.b2BCompanyName) &&
                                                                                        (null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.b2BLocationName)) ||
                                                                                      (!(null ==
                                                                                      k
                                                                                        ? void 0
                                                                                        : k.CreateInvoice) &&
                                                                                        !(null ==
                                                                                        k
                                                                                          ? void 0
                                                                                          : k.CreateOrder) &&
                                                                                        !(null ==
                                                                                        k
                                                                                          ? void 0
                                                                                          : k.CreateCheckout)),
                                                                                    sx:
                                                                                      "voided" ===
                                                                                      (null ==
                                                                                      t
                                                                                        ? void 0
                                                                                        : t.status)
                                                                                        ? Bo
                                                                                        : Lo,
                                                                                    onClick:
                                                                                      function () {
                                                                                        S(
                                                                                          t
                                                                                        );
                                                                                      },
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        RI,
                                                                                        {
                                                                                          sx: {
                                                                                            cursor:
                                                                                              "pointer",
                                                                                          },
                                                                                        }
                                                                                      ),
                                                                                  }
                                                                                )
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                    (0, e.jsx)(
                                                                      Ym,
                                                                      ZI(
                                                                        {
                                                                          sx:
                                                                            "voided" ===
                                                                            (null ==
                                                                            t
                                                                              ? void 0
                                                                              : t.status)
                                                                              ? Bo
                                                                              : Lo,
                                                                          loading:
                                                                            h ===
                                                                              n &&
                                                                            f,
                                                                          size: "large",
                                                                        },
                                                                        {
                                                                          children:
                                                                            f ||
                                                                            b
                                                                              ? h ===
                                                                                  n &&
                                                                                b
                                                                                ? (0,
                                                                                  e.jsx)(
                                                                                    BI,
                                                                                    {}
                                                                                  )
                                                                                : (0,
                                                                                  e.jsx)(
                                                                                    LI,
                                                                                    {
                                                                                      sx: ZI(
                                                                                        ZI(
                                                                                          ZI(
                                                                                            {},
                                                                                            Zo
                                                                                          ),
                                                                                          h ===
                                                                                            n
                                                                                            ? Fo
                                                                                            : null
                                                                                        ),
                                                                                        "voided" ===
                                                                                          (null ==
                                                                                          t
                                                                                            ? void 0
                                                                                            : t.status)
                                                                                          ? Bo
                                                                                          : null
                                                                                      ),
                                                                                    }
                                                                                  )
                                                                              : (0,
                                                                                e.jsx)(
                                                                                  Gs,
                                                                                  ZI(
                                                                                    {
                                                                                      title:
                                                                                        "Send Invoice",
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (0,
                                                                                        e.jsx)(
                                                                                          LI,
                                                                                          {
                                                                                            sx:
                                                                                              "voided" ===
                                                                                              (null ==
                                                                                              t
                                                                                                ? void 0
                                                                                                : t.status)
                                                                                                ? Bo
                                                                                                : Lo,
                                                                                            onClick:
                                                                                              function () {
                                                                                                return p(
                                                                                                  t,
                                                                                                  n
                                                                                                );
                                                                                              },
                                                                                          }
                                                                                        ),
                                                                                    }
                                                                                  )
                                                                                ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      Qu,
                                                                      ZI(
                                                                        {
                                                                          sx:
                                                                            "voided" ===
                                                                            (null ==
                                                                            t
                                                                              ? void 0
                                                                              : t.status)
                                                                              ? Bo
                                                                              : Lo,
                                                                          onClick:
                                                                            function (
                                                                              e
                                                                            ) {
                                                                              m(
                                                                                e,
                                                                                t,
                                                                                n
                                                                              );
                                                                            },
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Gs,
                                                                              ZI(
                                                                                {
                                                                                  title:
                                                                                    "Delete",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (0,
                                                                                    e.jsx)(
                                                                                      Ev,
                                                                                      {
                                                                                        sx: {
                                                                                          cursor:
                                                                                            "pointer",
                                                                                          color:
                                                                                            "black",
                                                                                        },
                                                                                      }
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      Jd,
                                                                      ZI(
                                                                        {
                                                                          open: Boolean(
                                                                            _
                                                                          ),
                                                                          anchorEl:
                                                                            _,
                                                                          onClose:
                                                                            function () {
                                                                              y(
                                                                                null
                                                                              ),
                                                                                v(
                                                                                  !1
                                                                                );
                                                                            },
                                                                          anchorOrigin:
                                                                            {
                                                                              vertical:
                                                                                "bottom",
                                                                              horizontal:
                                                                                "left",
                                                                            },
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsxs)(
                                                                              "div",
                                                                              ZI(
                                                                                {
                                                                                  className:
                                                                                    "ST_DO_DeleteConfirmPopup",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    [
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        ni,
                                                                                        ZI(
                                                                                          {
                                                                                            pb: 2,
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              u(
                                                                                                "delete_confirmation_text"
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                      (0,
                                                                                      e.jsxs)(
                                                                                        "div",
                                                                                        ZI(
                                                                                          {
                                                                                            className:
                                                                                              "ST_DO_TextRight",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              [
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  Ym,
                                                                                                  ZI(
                                                                                                    {
                                                                                                      loading:
                                                                                                        g,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        g
                                                                                                          ? null
                                                                                                          : (0,
                                                                                                            e.jsx)(
                                                                                                              BI,
                                                                                                              {
                                                                                                                sx: {
                                                                                                                  color:
                                                                                                                    "green",
                                                                                                                  paddingRight:
                                                                                                                    "10px",
                                                                                                                  cursor:
                                                                                                                    "pointer",
                                                                                                                },
                                                                                                                onClick:
                                                                                                                  function () {
                                                                                                                    C();
                                                                                                                  },
                                                                                                              }
                                                                                                            ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  Fg,
                                                                                                  {
                                                                                                    className:
                                                                                                      "ST_Error_Msg_Color",
                                                                                                    sx: {
                                                                                                      cursor:
                                                                                                        "pointer",
                                                                                                    },
                                                                                                    onClick:
                                                                                                      function () {
                                                                                                        y(
                                                                                                          null
                                                                                                        ),
                                                                                                          v(
                                                                                                            !1
                                                                                                          );
                                                                                                      },
                                                                                                  }
                                                                                                ),
                                                                                              ],
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                    ],
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      ),
                                                      n
                                                    )
                                                  : null;
                                              })
                                          : (0, e.jsx)(Cp, {
                                              children: (0, e.jsxs)(
                                                Op,
                                                ZI(
                                                  {
                                                    align: "center",
                                                    colSpan: (
                                                      null == k
                                                        ? void 0
                                                        : k.CreateB2BOrder
                                                    )
                                                      ? 8
                                                      : 6,
                                                  },
                                                  {
                                                    children: [
                                                      u("no_draft_to_show"),
                                                      ".",
                                                    ],
                                                  }
                                                )
                                              ),
                                            }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
              (0, e.jsx)(
                Hp,
                ZI(
                  {
                    open: a,
                    maxWidth: "xl",
                    fullWidth: !0,
                    onClose: function () {
                      return i(!1);
                    },
                  },
                  {
                    children: (0, e.jsxs)(
                      mn,
                      ZI(
                        { className: "ST_SO_Dialog_Box" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              ZI(
                                { container: !0, spacing: 2, mb: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      ZI(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)(
                                            ni,
                                            ZI(
                                              {
                                                variant: "h6",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children: u(
                                                  "yourSalesDraft_tableTitle"
                                                ),
                                              }
                                            )
                                          ),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      ZI(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              i(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                            (null == c ? void 0 : c.length) > 0
                              ? (0, e.jsxs)(
                                  Gp,
                                  ZI(
                                    { sx: { padding: "0px" } },
                                    {
                                      children: [
                                        d
                                          ? (0, e.jsx)(mn, {
                                              children: (0, e.jsxs)(
                                                qa,
                                                ZI(
                                                  { container: !0, spacing: 2 },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_DraftId"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    null == d
                                                                      ? void 0
                                                                      : d.id,
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_SubTotal"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    x,
                                                                    " ",
                                                                    (null == d
                                                                      ? void 0
                                                                      : d.subtotal_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    null != P
                                                                      ? P
                                                                      : "",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_ShippingCost"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    x,
                                                                    " ",
                                                                    (null ===
                                                                      (t =
                                                                        null ==
                                                                        d
                                                                          ? void 0
                                                                          : d.shipping_line) ||
                                                                    void 0 === t
                                                                      ? void 0
                                                                      : t.price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    null != P
                                                                      ? P
                                                                      : "",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_Tax"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    x,
                                                                    " ",
                                                                    (null == d
                                                                      ? void 0
                                                                      : d.total_tax) ||
                                                                      "0.00",
                                                                    " ",
                                                                    null != P
                                                                      ? P
                                                                      : "",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_TotalPrice"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    x,
                                                                    " ",
                                                                    (null == d
                                                                      ? void 0
                                                                      : d.total_price.toFixed(
                                                                          2
                                                                        )) ||
                                                                      "0.00",
                                                                    " ",
                                                                    null != P
                                                                      ? P
                                                                      : "",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        qa,
                                                        ZI(
                                                          {
                                                            item: !0,
                                                            xs: 6,
                                                            md: 4,
                                                            mb: 1,
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              ZI(
                                                                {
                                                                  variant:
                                                                    "body2",
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsxs)(
                                                                      "b",
                                                                      {
                                                                        children:
                                                                          [
                                                                            u(
                                                                              "draftOrder_Note"
                                                                            ),
                                                                            " :",
                                                                          ],
                                                                      }
                                                                    ),
                                                                    " ",
                                                                    (null == d
                                                                      ? void 0
                                                                      : d.note) ||
                                                                      "-",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    ],
                                                  }
                                                )
                                              ),
                                            })
                                          : null,
                                        w
                                          ? (0, e.jsx)(FI, {
                                              tableType: "2",
                                              headerArray: o,
                                              dataArray: c,
                                            })
                                          : (0, e.jsx)(
                                              ep,
                                              ZI(
                                                {
                                                  sx: ZI(ZI({ mt: 1 }, Ho), {
                                                    borderTop:
                                                      "1px solid #dadada",
                                                  }),
                                                },
                                                {
                                                  children: (0, e.jsxs)(
                                                    sp,
                                                    ZI(
                                                      { stickyHeader: !0 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)(hp, {
                                                            children: (0,
                                                            e.jsx)(Cp, {
                                                              children:
                                                                null == o
                                                                  ? void 0
                                                                  : o.map(
                                                                      function (
                                                                        t,
                                                                        n
                                                                      ) {
                                                                        return (0,
                                                                        e.jsx)(
                                                                          Op,
                                                                          ZI(
                                                                            {
                                                                              sx: zo,
                                                                            },
                                                                            {
                                                                              children:
                                                                                (0,
                                                                                e.jsx)(
                                                                                  "b",
                                                                                  {
                                                                                    children:
                                                                                      t.label,
                                                                                  }
                                                                                ),
                                                                            }
                                                                          ),
                                                                          n
                                                                        );
                                                                      }
                                                                    ),
                                                            }),
                                                          }),
                                                          (0, e.jsx)(
                                                            Dp,
                                                            ZI(
                                                              {
                                                                className:
                                                                  "ST_SO_Thead",
                                                              },
                                                              {
                                                                children:
                                                                  null == c
                                                                    ? void 0
                                                                    : c.map(
                                                                        function (
                                                                          t,
                                                                          n
                                                                        ) {
                                                                          var r,
                                                                            o,
                                                                            a;
                                                                          return (0,
                                                                          e.jsxs)(
                                                                            Cp,
                                                                            {
                                                                              children:
                                                                                [
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    ZI(
                                                                                      {
                                                                                        component:
                                                                                          "th",
                                                                                        scope:
                                                                                          "row",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Image
                                                                                            ? (0,
                                                                                              e.jsx)(
                                                                                                mn,
                                                                                                {
                                                                                                  component:
                                                                                                    "img",
                                                                                                  sx: Vo,
                                                                                                  src: t.Image,
                                                                                                }
                                                                                              )
                                                                                            : (0,
                                                                                              e.jsx)(
                                                                                                VT.Z,
                                                                                                {
                                                                                                  sx: {
                                                                                                    height: 50,
                                                                                                    width: 50,
                                                                                                  },
                                                                                                }
                                                                                              ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    ZI(
                                                                                      {
                                                                                        sx: {
                                                                                          width:
                                                                                            "20%",
                                                                                        },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          t.Title ||
                                                                                          "-",
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.size ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.quantity,
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    ZI(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            x,
                                                                                            " ",
                                                                                            (null ===
                                                                                              (r =
                                                                                                t.ItemPrice) ||
                                                                                            void 0 ===
                                                                                              r
                                                                                              ? void 0
                                                                                              : r.toFixed(
                                                                                                  2
                                                                                                )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    Op,
                                                                                    {
                                                                                      children:
                                                                                        t.fulfillmentStatus ||
                                                                                        "-",
                                                                                    }
                                                                                  ),
                                                                                  (0,
                                                                                  e.jsxs)(
                                                                                    Op,
                                                                                    ZI(
                                                                                      {
                                                                                        className:
                                                                                          "ST_White_Space",
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          [
                                                                                            x,
                                                                                            " ",
                                                                                            (null ===
                                                                                              (o =
                                                                                                t.quantity) ||
                                                                                            void 0 ===
                                                                                              o
                                                                                              ? void 0
                                                                                              : o.toFixed(
                                                                                                  2
                                                                                                )) *
                                                                                              (null ===
                                                                                                (a =
                                                                                                  t.ItemPrice) ||
                                                                                              void 0 ===
                                                                                                a
                                                                                                ? void 0
                                                                                                : a.toFixed(
                                                                                                    2
                                                                                                  )) ||
                                                                                              "0.00",
                                                                                          ],
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                                ],
                                                                            },
                                                                            n
                                                                          );
                                                                        }
                                                                      ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }
                                              )
                                            ),
                                      ],
                                    }
                                  )
                                )
                              : (0, e.jsx)(Gp, {
                                  children: u("noDraftOrderProducts"),
                                }),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        VI = function () {
          return (
            (VI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            VI.apply(this, arguments)
          );
        },
        WI = function (n) {
          var r = n.headerArray,
            o = n.dataArray,
            a = _I(),
            i = a.shopCurrency,
            s = a.handleOrderStatusColor,
            l = a.getPrintOrderDetails,
            d = a.shopName,
            c = ee().t,
            u = function (t, n) {
              var r,
                o,
                a,
                c,
                u,
                p,
                m,
                h,
                f,
                g,
                v,
                b,
                _,
                y,
                C,
                x,
                S,
                k = n,
                P = {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  wordBreak: "keep-all",
                },
                w = (null == k ? void 0 : k.OrderStatus)
                  ? null === (r = null == k ? void 0 : k.OrderStatus) ||
                    void 0 === r
                    ? void 0
                    : r.toLowerCase()
                  : "",
                O =
                  !0 !== (null == k ? void 0 : k.isRefundedOrders) &&
                  (null === (o = ["paid", "partially_refunded", "completed"]) ||
                  void 0 === o
                    ? void 0
                    : o.includes(w)),
                T =
                  null === (a = ["open", "voided"]) || void 0 === a
                    ? void 0
                    : a.includes(w),
                I =
                  !0 === (null == k ? void 0 : k.isRefundedOrders) &&
                  (null === (c = ["refunded", "partially_refunded"]) ||
                  void 0 === c
                    ? void 0
                    : c.includes(w)),
                M = "pending" === w;
              switch (
                ((S = O
                  ? "Paid"
                  : M
                  ? "Unpaid"
                  : "open" ===
                    (null === (u = null == k ? void 0 : k.OrderStatus) ||
                    void 0 === u
                      ? void 0
                      : u.toLowerCase())
                  ? "Draft"
                  : (null == k ? void 0 : k.OrderStatus)
                  ? (null ===
                      (m =
                        null === (p = k.OrderStatus) || void 0 === p
                          ? void 0
                          : p.charAt(0)) || void 0 === m
                      ? void 0
                      : m.toUpperCase()) +
                    (null === (h = k.OrderStatus) || void 0 === h
                      ? void 0
                      : h.slice(1))
                  : "-"),
                t)
              ) {
                case 0:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { style: P },
                      {
                        children: T
                          ? null !== (f = null == k ? void 0 : k.orderName) &&
                            void 0 !== f
                            ? f
                            : "-"
                          : null !== (g = null == k ? void 0 : k.orderNumber) &&
                            void 0 !== g
                          ? g
                          : "-",
                      }
                    )
                  );
                  break;
                case 1:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { style: P },
                      {
                        children:
                          null !== (v = null == k ? void 0 : k.orderDate) &&
                          void 0 !== v
                            ? v
                            : "-",
                      }
                    )
                  );
                  break;
                case 2:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { style: P },
                      {
                        children:
                          O &&
                          null !== (b = null == k ? void 0 : k.OrderPaidDate) &&
                          void 0 !== b
                            ? b
                            : "-",
                      }
                    )
                  );
                  break;
                case 3:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { className: "ST_toolTip", style: P },
                      {
                        children: (0, e.jsx)(
                          Gs,
                          VI(
                            { title: null == k ? void 0 : k.CustomerName },
                            {
                              children:
                                (null == k ? void 0 : k.CustomerName) &&
                                "" !==
                                  (null ===
                                    (_ = null == k ? void 0 : k.CustomerName) ||
                                  void 0 === _
                                    ? void 0
                                    : _.trim())
                                  ? null == k
                                    ? void 0
                                    : k.CustomerName
                                  : "-",
                            }
                          )
                        ),
                      }
                    )
                  );
                  break;
                case 4:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { style: P },
                      {
                        children: (null == k ? void 0 : k.b2BCompanyName)
                          ? null == k
                            ? void 0
                            : k.b2BCompanyName
                          : "-",
                      }
                    )
                  );
                  break;
                case 5:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { style: P },
                      {
                        children: (null == k ? void 0 : k.b2BLocationName)
                          ? null == k
                            ? void 0
                            : k.b2BLocationName
                          : "-",
                      }
                    )
                  );
                  break;
                case 6:
                  x = (0, e.jsxs)(
                    Op,
                    VI(
                      { style: P, className: "ST_White_Space" },
                      {
                        children: [
                          i + " ",
                          " ",
                          (null == k ? void 0 : k.subtotal)
                            ? null === (y = null == k ? void 0 : k.subtotal) ||
                              void 0 === y
                              ? void 0
                              : y.toFixed(2)
                            : "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 7:
                  x = (0, e.jsxs)(
                    Op,
                    VI(
                      { style: P, className: "ST_White_Space" },
                      {
                        children: [
                          i + " ",
                          " ",
                          (O || I) && (null == k ? void 0 : k.commission)
                            ? null === (C = k.commission) || void 0 === C
                              ? void 0
                              : C.toFixed(2)
                            : "0.00",
                        ],
                      }
                    )
                  );
                  break;
                case 8:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { className: "ST_ChipTagTableCell ST_toolTip", style: P },
                      {
                        children: (0, e.jsx)(
                          Gs,
                          VI(
                            { title: S },
                            {
                              children: (0, e.jsx)(du, {
                                className: "ST_ChipTag",
                                label: S,
                                sx: { bgcolor: s(k, O, M, I), color: "white" },
                              }),
                            }
                          )
                        ),
                      }
                    )
                  );
                  break;
                case 9:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { className: "ST_toolTip", style: P },
                      {
                        children: (0, e.jsx)(
                          Gs,
                          VI(
                            { title: null == k ? void 0 : k.CommissionType },
                            { children: null == k ? void 0 : k.CommissionType }
                          )
                        ),
                      }
                    )
                  );
                  break;
                case 10:
                  x = (0, e.jsx)(
                    Op,
                    VI(
                      { className: "ST_PrintTableCell", style: P },
                      {
                        children: O
                          ? (0, e.jsx)(
                              rl,
                              VI(
                                {
                                  className: "ST_link_FontColor",
                                  href: l(k),
                                  target: "_blank",
                                  sx: {
                                    pointerEvents: null === d ? "none" : "all",
                                  },
                                },
                                {
                                  children: (0, e.jsx)(yI, {
                                    sx: { cursor: "pointer", color: "#1976d2" },
                                  }),
                                }
                              )
                            )
                          : (0, e.jsx)(
                              "div",
                              VI(
                                { className: "ST_emptyInvoiceIcon" },
                                { children: "-" }
                              )
                            ),
                      }
                    )
                  );
              }
              return x;
            };
          return (0, e.jsx)(
            ep,
            VI(
              { sx: Ho, className: "Table_Container_Margin" },
              {
                children: (0, e.jsx)(sp, {
                  children:
                    null != o && (null == o ? void 0 : o.length) > 0
                      ? null == o
                        ? void 0
                        : o.map(function (n, o) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  VI(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == r
                                              ? void 0
                                              : r.map(function (t, r) {
                                                  return (0,
                                                  e.jsxs)(Cp, VI({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, " :"] }) }), u(r, n)] }), t.label + r);
                                                }),
                                        },
                                        o
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              VI(
                                { className: "BorderBottom" },
                                { children: c("no_orders_to_show") }
                              )
                            ),
                          }),
                        }),
                }),
              }
            )
          );
        },
        UI = function () {
          return (
            (UI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            UI.apply(this, arguments)
          );
        },
        $I = function (n) {
          var r = ee().t,
            o = (0, t.useState)(),
            a = o[0],
            i = o[1],
            s = Tv();
          (0, t.useEffect)(
            function () {
              i(""), l("");
            },
            [n.orderStatus]
          );
          var l = function (e) {
            i(e),
              Hh.next({
                searchText: e,
                orderTab: null == n ? void 0 : n.orderStatus,
              });
          };
          return (0, e.jsxs)(
            go,
            UI(
              {
                className: "SO_SearchBox",
                sx: {
                  width: s ? "100%" : "25%",
                  marginBottom: s ? "10px" : "",
                },
              },
              {
                children: [
                  (0, e.jsx)(Ml, {
                    autoFocus: !0,
                    value: a,
                    onChange: function (e) {
                      return l(e.target.value);
                    },
                    sx: { ml: 2, flex: 1 },
                    size: "small",
                    placeholder: r("myCustomers_radioButton1"),
                    inputProps: { "aria-label": "searchProducts" },
                  }),
                  (0, e.jsx)(
                    Jn,
                    UI(
                      {
                        type: "button",
                        sx: { p: "10px" },
                        "aria-label": "search",
                      },
                      {
                        children: a
                          ? (0, e.jsx)(Fg, {
                              onClick: function () {
                                i(""),
                                  Hh.next({
                                    searchText: "",
                                    orderTab:
                                      null == n ? void 0 : n.orderStatus,
                                  });
                              },
                            })
                          : (0, e.jsx)(Rv, {}),
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        KI = function () {
          return (
            (KI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            KI.apply(this, arguments)
          );
        },
        GI = t.forwardRef(function (t, n) {
          return (0,
          e.jsx)("div", KI({ ref: n }, t, { style: KI(KI({}, null == t ? void 0 : t.style), { overflowX: "hidden" }) }));
        }),
        qI = function () {
          var n = ee().t,
            r = _I(),
            o = r.shopName,
            a = r.getPrintOrderDetails,
            i = r.orders,
            s = r.handleOrderStatusColor,
            l = r.HeaderSalesNames,
            d = r.shopCurrency,
            c = r.handleSort,
            u = r.selectFeatures,
            p = t.useState("All"),
            m = p[0],
            h = p[1],
            f = t.useRef(null),
            g = Tv(),
            v = function (t) {
              var n,
                r,
                i,
                l,
                c,
                p,
                m,
                h,
                f,
                g,
                v,
                b,
                _,
                y,
                C,
                x,
                S = t.index,
                k = t.style,
                P = t.data[S],
                w = {
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  textOverflow: "ellipsis",
                  wordBreak: "keep-all",
                },
                O = (null == P ? void 0 : P.OrderStatus)
                  ? null === (n = null == P ? void 0 : P.OrderStatus) ||
                    void 0 === n
                    ? void 0
                    : n.toLowerCase()
                  : "",
                T =
                  !0 !== (null == P ? void 0 : P.isRefundedOrders) &&
                  (null === (r = ["paid", "partially_refunded", "completed"]) ||
                  void 0 === r
                    ? void 0
                    : r.includes(O)),
                I =
                  null === (i = ["open", "voided"]) || void 0 === i
                    ? void 0
                    : i.includes(O),
                M =
                  !0 === (null == P ? void 0 : P.isRefundedOrders) &&
                  (null === (l = ["refunded", "partially_refunded"]) ||
                  void 0 === l
                    ? void 0
                    : l.includes(O)),
                j = "pending" === O;
              return (
                (x = T
                  ? "Paid"
                  : j
                  ? "Unpaid"
                  : "open" ===
                    (null === (c = null == P ? void 0 : P.OrderStatus) ||
                    void 0 === c
                      ? void 0
                      : c.toLowerCase())
                  ? "Draft"
                  : (null == P ? void 0 : P.OrderStatus)
                  ? (null ===
                      (m =
                        null === (p = P.OrderStatus) || void 0 === p
                          ? void 0
                          : p.charAt(0)) || void 0 === m
                      ? void 0
                      : m.toUpperCase()) +
                    (null === (h = P.OrderStatus) || void 0 === h
                      ? void 0
                      : h.slice(1))
                  : "-"),
                (0, e.jsxs)(
                  Cp,
                  KI(
                    {
                      component: "div",
                      style: KI(KI({}, k), {
                        display: "flex",
                        alignItems: "center",
                      }),
                    },
                    {
                      children: [
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                            },
                            {
                              children: I
                                ? null !==
                                    (f = null == P ? void 0 : P.orderName) &&
                                  void 0 !== f
                                  ? f
                                  : "-"
                                : null !==
                                    (g = null == P ? void 0 : P.orderNumber) &&
                                  void 0 !== g
                                ? g
                                : "-",
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                            },
                            {
                              children:
                                null !==
                                  (v = null == P ? void 0 : P.orderDate) &&
                                void 0 !== v
                                  ? v
                                  : "-",
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                            },
                            {
                              children:
                                T &&
                                null !==
                                  (b = null == P ? void 0 : P.OrderPaidDate) &&
                                void 0 !== b
                                  ? b
                                  : "-",
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              className: "ST_toolTip",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                            },
                            {
                              children: (0, e.jsx)(
                                Gs,
                                KI(
                                  {
                                    title: null == P ? void 0 : P.CustomerName,
                                  },
                                  {
                                    children:
                                      (null == P ? void 0 : P.CustomerName) &&
                                      "" !==
                                        (null ===
                                          (_ =
                                            null == P
                                              ? void 0
                                              : P.CustomerName) || void 0 === _
                                          ? void 0
                                          : _.trim())
                                        ? null == P
                                          ? void 0
                                          : P.CustomerName
                                        : "-",
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (null == u ? void 0 : u.CreateB2BOrder)
                          ? (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Op,
                                  KI(
                                    {
                                      align: "center",
                                      component: "div",
                                      style: KI(
                                        { flex: 1, minWidth: "60px" },
                                        w
                                      ),
                                    },
                                    {
                                      children: (
                                        null == P ? void 0 : P.b2BCompanyName
                                      )
                                        ? null == P
                                          ? void 0
                                          : P.b2BCompanyName
                                        : "-",
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Op,
                                  KI(
                                    {
                                      align: "center",
                                      component: "div",
                                      style: KI(
                                        { flex: 1, minWidth: "60px" },
                                        w
                                      ),
                                    },
                                    {
                                      children: (
                                        null == P ? void 0 : P.b2BLocationName
                                      )
                                        ? null == P
                                          ? void 0
                                          : P.b2BLocationName
                                        : "-",
                                    }
                                  )
                                ),
                              ],
                            })
                          : null,
                        (0, e.jsxs)(
                          Op,
                          KI(
                            {
                              align: "center",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                              className: "ST_White_Space",
                            },
                            {
                              children: [
                                d + " ",
                                " ",
                                (null == P ? void 0 : P.subtotal)
                                  ? null ===
                                      (y = null == P ? void 0 : P.subtotal) ||
                                    void 0 === y
                                    ? void 0
                                    : y.toFixed(2)
                                  : "0.00",
                              ],
                            }
                          )
                        ),
                        (0, e.jsxs)(
                          Op,
                          KI(
                            {
                              align: "center",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                              className: "ST_White_Space",
                            },
                            {
                              children: [
                                d + " ",
                                " ",
                                (T || M) && (null == P ? void 0 : P.commission)
                                  ? null === (C = P.commission) || void 0 === C
                                    ? void 0
                                    : C.toFixed(2)
                                  : "0.00",
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              className: "ST_ChipTagTableCell ST_toolTip",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "80px" }, w),
                            },
                            {
                              children: (0, e.jsx)(
                                Gs,
                                KI(
                                  { title: x },
                                  {
                                    children: (0, e.jsx)(du, {
                                      className: "ST_ChipTag",
                                      label: x,
                                      sx: {
                                        bgcolor: s(P, T, j, M),
                                        color: "white",
                                      },
                                    }),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              className: "ST_toolTip",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "105px" }, w),
                            },
                            {
                              children: (0, e.jsx)(
                                Gs,
                                KI(
                                  {
                                    title:
                                      null == P ? void 0 : P.CommissionType,
                                  },
                                  {
                                    children:
                                      null == P ? void 0 : P.CommissionType,
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          Op,
                          KI(
                            {
                              align: "center",
                              className: "ST_PrintTableCell",
                              component: "div",
                              style: KI({ flex: 1, minWidth: "60px" }, w),
                            },
                            {
                              children: T
                                ? (0, e.jsx)(
                                    rl,
                                    KI(
                                      {
                                        className: "ST_link_FontColor",
                                        href: a(P),
                                        target: "_blank",
                                        sx: {
                                          pointerEvents:
                                            null === o ? "none" : "all",
                                        },
                                      },
                                      {
                                        children: (0, e.jsx)(yI, {
                                          sx: {
                                            cursor: "pointer",
                                            color: "#1976d2",
                                          },
                                        }),
                                      }
                                    )
                                  )
                                : (0, e.jsx)(
                                    "div",
                                    KI(
                                      { className: "ST_emptyInvoiceIcon" },
                                      { children: "-" }
                                    )
                                  ),
                            }
                          )
                        ),
                      ],
                    }
                  ),
                  P.id
                )
              );
            };
          return (0, e.jsxs)(e.Fragment, {
            children: [
              g ? (0, e.jsx)($I, { orderStatus: m, mb: 1 }) : null,
              (0, e.jsxs)(
                go,
                KI(
                  { sx: { width: "100%", overflow: "hidden" } },
                  {
                    children: [
                      (0, e.jsxs)(
                        mn,
                        KI(
                          { className: "Sales_Order_Details_Tab_Box" },
                          {
                            children: [
                              (0, e.jsxs)(
                                Oa,
                                KI(
                                  {
                                    value: m,
                                    onChange: function (e, t) {
                                      h(t);
                                    },
                                    "aria-label": "order tabs",
                                    variant: "scrollable",
                                    TabIndicatorProps: {
                                      style: { display: "none" },
                                    },
                                    sx: {
                                      ".MuiTabs-flexContainer": {
                                        borderBottom: "1px solid #e8e8e8",
                                      },
                                      ".Mui-selected >.ST_TabLabel": {
                                        color: "black !important",
                                        backgroundColor: "#e0e0e0",
                                        borderRadius: "6px",
                                        padding: "5px 10px",
                                        fontSize: "13px",
                                        fontWeight: 600,
                                      },
                                      ".MuiButtonBase-root": {
                                        textTransform: "none",
                                        margin: "4px",
                                        borderRadius: "20px",
                                      },
                                    },
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)(Na, {
                                        label: (0, e.jsx)(
                                          "span",
                                          KI(
                                            { className: "ST_TabLabel" },
                                            { children: n("all") }
                                          )
                                        ),
                                        value: "All",
                                      }),
                                      (0, e.jsx)(Na, {
                                        label: (0, e.jsx)(
                                          "span",
                                          KI(
                                            { className: "ST_TabLabel" },
                                            { children: n("paid") }
                                          )
                                        ),
                                        value: "Paid",
                                      }),
                                      (0, e.jsx)(Na, {
                                        label: (0, e.jsx)(
                                          "span",
                                          KI(
                                            { className: "ST_TabLabel" },
                                            { children: n("unpaid") }
                                          )
                                        ),
                                        value: "Unpaid",
                                      }),
                                      (0, e.jsx)(Na, {
                                        label: (0, e.jsx)(
                                          "span",
                                          KI(
                                            { className: "ST_TabLabel" },
                                            { children: n("draft") }
                                          )
                                        ),
                                        value: "Draft",
                                      }),
                                      (0, e.jsx)(Na, {
                                        label: (0, e.jsx)(
                                          "span",
                                          KI(
                                            { className: "ST_TabLabel" },
                                            { children: n("refunded") }
                                          )
                                        ),
                                        value: "Refunded",
                                      }),
                                    ],
                                  }
                                )
                              ),
                              g ? null : (0, e.jsx)($I, { orderStatus: m }),
                            ],
                          }
                        )
                      ),
                      "All" === m &&
                        (0, e.jsx)(function () {
                          var t;
                          return (0, e.jsx)(e.Fragment, {
                            children: g
                              ? (0, e.jsx)(WI, { headerArray: l, dataArray: i })
                              : (0, e.jsx)(
                                  ep,
                                  KI(
                                    { sx: Ho, ref: f },
                                    {
                                      children: (0, e.jsxs)(
                                        sp,
                                        KI(
                                          {
                                            stickyHeader: !0,
                                            component: "div",
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                hp,
                                                KI(
                                                  { component: "div" },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Cp,
                                                      KI(
                                                        {
                                                          component: "div",
                                                          style: {
                                                            display: "flex",
                                                          },
                                                          className:
                                                            "stickyHeaderRow",
                                                        },
                                                        {
                                                          children:
                                                            null == l
                                                              ? void 0
                                                              : l.map(function (
                                                                  t,
                                                                  n
                                                                ) {
                                                                  return (0,
                                                                  e.jsx)(
                                                                    Op,
                                                                    KI(
                                                                      {
                                                                        align:
                                                                          "center",
                                                                        sx: KI(
                                                                          KI(
                                                                            {
                                                                              whiteSpace:
                                                                                "nowrap",
                                                                            },
                                                                            null ==
                                                                              t
                                                                              ? void 0
                                                                              : t.inlineCSS
                                                                          ),
                                                                          {
                                                                            fontSize:
                                                                              "13px",
                                                                            display:
                                                                              (
                                                                                null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.hidden
                                                                              )
                                                                                ? "none"
                                                                                : "table-cell",
                                                                          }
                                                                        ),
                                                                      },
                                                                      {
                                                                        children:
                                                                          (0,
                                                                          e.jsx)(
                                                                            "b",
                                                                            {
                                                                              children:
                                                                                t.label,
                                                                            }
                                                                          ),
                                                                      }
                                                                    ),
                                                                    n
                                                                  );
                                                                }),
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                Dp,
                                                KI(
                                                  { component: "div" },
                                                  {
                                                    children:
                                                      (null == i
                                                        ? void 0
                                                        : i.length) > 0
                                                        ? (0, e.jsx)(
                                                            pI,
                                                            KI(
                                                              {
                                                                height: 300,
                                                                width: "100%",
                                                                itemSize: 60,
                                                                itemCount:
                                                                  null !==
                                                                    (t =
                                                                      null == i
                                                                        ? void 0
                                                                        : i.length) &&
                                                                  void 0 !== t
                                                                    ? t
                                                                    : 0,
                                                                itemData: c(i),
                                                                outerElementType:
                                                                  GI,
                                                              },
                                                              { children: v }
                                                            )
                                                          )
                                                        : (0, e.jsx)(Cp, {
                                                            children: (0,
                                                            e.jsx)(
                                                              Op,
                                                              KI(
                                                                {
                                                                  align:
                                                                    "center",
                                                                  colSpan: (
                                                                    null == u
                                                                      ? void 0
                                                                      : u.CreateB2BOrder
                                                                  )
                                                                    ? 12
                                                                    : 10,
                                                                },
                                                                {
                                                                  children:
                                                                    n(
                                                                      "no_orders_to_show"
                                                                    ),
                                                                }
                                                              )
                                                            ),
                                                          }),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                          });
                        }, {}),
                      "Paid" === m && (0, e.jsx)(PI, {}),
                      "Unpaid" === m && (0, e.jsx)(MI, {}),
                      "Draft" === m && (0, e.jsx)(HI, {}),
                      "Refunded" === m && (0, e.jsx)(EI, {}),
                    ],
                  }
                )
              ),
            ],
          });
        },
        QI = function () {
          return (
            (QI =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            QI.apply(this, arguments)
          );
        },
        YI = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a,
                i,
                s = this,
                l = (0, t.useState)(null),
                d = l[0],
                c = l[1],
                u = Boolean(d),
                p = u ? "simple-popover" : void 0,
                m = wv("(min-width: 960px)"),
                h = Tv(),
                f =
                  null !== (e = F.getState().salesRepData.baseData.select) &&
                  void 0 !== e
                    ? e
                    : {},
                g = (0, t.useState)(!1),
                v = g[0],
                b = g[1],
                _ = (0, t.useState)("1"),
                y = _[0],
                C = _[1],
                x = ee().t,
                S =
                  null !==
                    (n =
                      F.getState().salesRepData.ordersData
                        .allRefundOrdersDetails) && void 0 !== n
                    ? n
                    : [],
                k =
                  null !==
                    (i =
                      null ===
                        (a =
                          null ===
                            (o =
                              null === (r = F.getState().salesRepData) ||
                              void 0 === r
                                ? void 0
                                : r.ordersData) || void 0 === o
                            ? void 0
                            : o.AllOrdersCommission) || void 0 === a
                        ? void 0
                        : a.filter(function (e) {
                            return (
                              "pending" === e.OrderStatus ||
                              "paid" === e.OrderStatus ||
                              "partially_refunded" === e.OrderStatus ||
                              "completed" === e.OrderStatus
                            );
                          })) && void 0 !== i
                    ? i
                    : [],
                P = JT().getDraftOrder;
              return {
                tabValue: y,
                setTabValue: C,
                handleTabChange: function (e, t) {
                  C(t);
                },
                t: x,
                handleClick: function (e) {
                  c(e.currentTarget);
                },
                handleClose: function () {
                  c(null);
                },
                open: u,
                id: p,
                anchorEl: d,
                ExportOrderCSV: function (e) {
                  return (
                    (t = s),
                    (n = void 0),
                    (o = function () {
                      var t, n, r, o, a, i;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (s) {
                        switch (s.label) {
                          case 0:
                            switch ((b(!0), (t = ""), (n = {}), e)) {
                              case "PaidOrPendingOrder":
                                return [3, 1];
                              case "DraftOrder":
                                return [3, 2];
                              case "RefundOrder":
                                return [3, 5];
                            }
                            return [3, 6];
                          case 1:
                            return (
                              (n = (null == f ? void 0 : f.CreateB2BOrder)
                                ? XT(
                                    [
                                      [
                                        "Order No",
                                        "Order Date",
                                        "Customer Name",
                                        "Company name",
                                        "Company Location",
                                        "SubTotal",
                                        "Commission",
                                        "Sales Method",
                                        "Order Status",
                                      ].join(","),
                                    ],
                                    null == k
                                      ? void 0
                                      : k.map(function (e) {
                                          var t, n, r, o, a, i, s, l, d;
                                          return [
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.orderNumber) &&
                                            void 0 !== t
                                              ? t
                                              : "",
                                            null !==
                                              (n =
                                                null == e
                                                  ? void 0
                                                  : e.orderDate) && void 0 !== n
                                              ? n
                                              : "",
                                            null !==
                                              (r =
                                                null == e
                                                  ? void 0
                                                  : e.CustomerName) &&
                                            void 0 !== r
                                              ? r
                                              : "",
                                            (
                                              null == f
                                                ? void 0
                                                : f.CreateB2BOrder
                                            )
                                              ? e.b2BCompanyName
                                                ? e.b2BCompanyName
                                                : "-"
                                              : null,
                                            (
                                              null == f
                                                ? void 0
                                                : f.CreateB2BOrder
                                            )
                                              ? e.b2BLocationName
                                                ? e.b2BLocationName
                                                : "-"
                                              : null,
                                            null !==
                                              (a =
                                                null ===
                                                  (o =
                                                    null == e
                                                      ? void 0
                                                      : e.subtotal) ||
                                                void 0 === o
                                                  ? void 0
                                                  : o.toFixed(2)) &&
                                            void 0 !== a
                                              ? a
                                              : "0.00",
                                            null !==
                                              (s =
                                                null ===
                                                  (i =
                                                    null == e
                                                      ? void 0
                                                      : e.commission) ||
                                                void 0 === i
                                                  ? void 0
                                                  : i.toFixed(2)) &&
                                            void 0 !== s
                                              ? s
                                              : "0.00",
                                            null !==
                                              (l =
                                                null == e
                                                  ? void 0
                                                  : e.CommissionType) &&
                                            void 0 !== l
                                              ? l
                                              : "",
                                            null !==
                                              (d =
                                                null == e
                                                  ? void 0
                                                  : e.OrderStatus) &&
                                            void 0 !== d
                                              ? d
                                              : "",
                                          ].join(",");
                                        }),
                                    !0
                                  ).join("\n")
                                : XT(
                                    [
                                      [
                                        "Order No",
                                        "Order Date",
                                        "Customer Name",
                                        "SubTotal",
                                        "Commission",
                                        "Sales Method",
                                        "Order Status",
                                      ].join(","),
                                    ],
                                    null == k
                                      ? void 0
                                      : k.map(function (e) {
                                          var t, n, r, o, a, i, s, l, d;
                                          return [
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.orderNumber) &&
                                            void 0 !== t
                                              ? t
                                              : "",
                                            null !==
                                              (n =
                                                null == e
                                                  ? void 0
                                                  : e.orderDate) && void 0 !== n
                                              ? n
                                              : "",
                                            null !==
                                              (r =
                                                null == e
                                                  ? void 0
                                                  : e.CustomerName) &&
                                            void 0 !== r
                                              ? r
                                              : "",
                                            null !==
                                              (a =
                                                null ===
                                                  (o =
                                                    null == e
                                                      ? void 0
                                                      : e.subtotal) ||
                                                void 0 === o
                                                  ? void 0
                                                  : o.toFixed(2)) &&
                                            void 0 !== a
                                              ? a
                                              : "0.00",
                                            null !==
                                              (s =
                                                null ===
                                                  (i =
                                                    null == e
                                                      ? void 0
                                                      : e.commission) ||
                                                void 0 === i
                                                  ? void 0
                                                  : i.toFixed(2)) &&
                                            void 0 !== s
                                              ? s
                                              : "0.00",
                                            null !==
                                              (l =
                                                null == e
                                                  ? void 0
                                                  : e.CommissionType) &&
                                            void 0 !== l
                                              ? l
                                              : "",
                                            null !==
                                              (d =
                                                null == e
                                                  ? void 0
                                                  : e.OrderStatus) &&
                                            void 0 !== d
                                              ? d
                                              : "",
                                          ].join(",");
                                        }),
                                    !0
                                  ).join("\n")),
                              (t = "Paid/Pending Order.csv"),
                              [3, 7]
                            );
                          case 2:
                            return F.getState().salesRepData.draftOrderData
                              ? [3, 4]
                              : [4, P()];
                          case 3:
                            s.sent(), (s.label = 4);
                          case 4:
                            return (
                              (r =
                                null !==
                                  (i =
                                    null ===
                                      (a =
                                        F.getState().salesRepData
                                          .draftOrderData) || void 0 === a
                                      ? void 0
                                      : a.filter(function (e) {
                                          return "open" === e.status;
                                        })) && void 0 !== i
                                  ? i
                                  : []),
                              (n = (null == f ? void 0 : f.CreateB2BOrder)
                                ? XT(
                                    [
                                      [
                                        "Order No",
                                        "Customer Name",
                                        "Company name",
                                        "Company Location",
                                        "Order Date",
                                        "Sub Total",
                                        "Status",
                                      ].join(","),
                                    ],
                                    null == r
                                      ? void 0
                                      : r.map(function (e) {
                                          var t, n, r, o, a, i;
                                          return [
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.orderName) && void 0 !== t
                                              ? t
                                              : "",
                                            null !==
                                              (n =
                                                null == e
                                                  ? void 0
                                                  : e.customername) &&
                                            void 0 !== n
                                              ? n
                                              : "",
                                            (
                                              null == f
                                                ? void 0
                                                : f.CreateB2BOrder
                                            )
                                              ? e.b2BCompanyName
                                                ? e.b2BCompanyName
                                                : "-"
                                              : "",
                                            (
                                              null == f
                                                ? void 0
                                                : f.CreateB2BOrder
                                            )
                                              ? e.b2BLocationName
                                                ? e.b2BLocationName
                                                : "-"
                                              : "",
                                            null !== (r = e.orderDate) &&
                                            void 0 !== r
                                              ? r
                                              : "",
                                            null !==
                                              (a =
                                                null ===
                                                  (o = e.subtotalprice) ||
                                                void 0 === o
                                                  ? void 0
                                                  : o.toFixed(2)) &&
                                            void 0 !== a
                                              ? a
                                              : "0.00",
                                            null !== (i = e.status) &&
                                            void 0 !== i
                                              ? i
                                              : "",
                                          ].join(",");
                                        }),
                                    !0
                                  ).join("\n")
                                : XT(
                                    [
                                      [
                                        "Order Number",
                                        "Customer Name",
                                        "Order Date",
                                        "Sub Total",
                                        "Status",
                                      ].join(","),
                                    ],
                                    null == r
                                      ? void 0
                                      : r.map(function (e) {
                                          var t, n, r, o, a, i;
                                          return [
                                            null !==
                                              (t =
                                                null == e
                                                  ? void 0
                                                  : e.orderName) && void 0 !== t
                                              ? t
                                              : "",
                                            null !==
                                              (n =
                                                null == e
                                                  ? void 0
                                                  : e.customername) &&
                                            void 0 !== n
                                              ? n
                                              : "",
                                            null !==
                                              (r =
                                                null == e
                                                  ? void 0
                                                  : e.orderDate) && void 0 !== r
                                              ? r
                                              : "",
                                            null !==
                                              (a =
                                                null ===
                                                  (o =
                                                    null == e
                                                      ? void 0
                                                      : e.subtotalprice) ||
                                                void 0 === o
                                                  ? void 0
                                                  : o.toFixed(2)) &&
                                            void 0 !== a
                                              ? a
                                              : "0.00",
                                            null !==
                                              (i =
                                                null == e
                                                  ? void 0
                                                  : e.status) && void 0 !== i
                                              ? i
                                              : "",
                                          ].join(",");
                                        }),
                                    !0
                                  ).join("\n")),
                              (t = "Draft Order.csv"),
                              [3, 7]
                            );
                          case 5:
                            return (
                              (n = XT(
                                [
                                  [
                                    "Refund Id",
                                    "Order Date",
                                    "Order No",
                                    "Commission",
                                    "Team Manager Commission",
                                    "Refund SubTotal",
                                    "Order Status",
                                    "Sales Method",
                                  ].join(","),
                                ],
                                null == S
                                  ? void 0
                                  : S.map(function (e) {
                                      var t, n, r, o, a, i, s, l, d, c, u, p;
                                      return [
                                        null !==
                                          (t =
                                            null == e ? void 0 : e.RefundId) &&
                                        void 0 !== t
                                          ? t
                                          : "",
                                        null !==
                                          ((p = e.OrderDate),
                                          (n = (
                                            null == p ? void 0 : p.includes("-")
                                          )
                                            ? "-"
                                            : new Date(
                                                parseInt(
                                                  p.replace("/Date(", "")
                                                )
                                              ).toLocaleDateString())) &&
                                        void 0 !== n
                                          ? n
                                          : "",
                                        null !== (r = e.ShopifyOrderNumber) &&
                                        void 0 !== r
                                          ? r
                                          : "",
                                        null !==
                                          (a =
                                            null === (o = e.Commission) ||
                                            void 0 === o
                                              ? void 0
                                              : o.toFixed(2)) && void 0 !== a
                                          ? a
                                          : "0.00",
                                        null !==
                                          (s =
                                            null ===
                                              (i = e.TeamManagerCommission) ||
                                            void 0 === i
                                              ? void 0
                                              : i.toFixed(2)) && void 0 !== s
                                          ? s
                                          : "0.00",
                                        null !==
                                          (d =
                                            null === (l = e.RefundSubTotal) ||
                                            void 0 === l
                                              ? void 0
                                              : l.toFixed(2)) && void 0 !== d
                                          ? d
                                          : "0.00",
                                        null !== (c = e.OrderStatus) &&
                                        void 0 !== c
                                          ? c
                                          : "",
                                        null !== (u = e.OrderType) &&
                                        void 0 !== u
                                          ? u
                                          : "",
                                      ].join(",");
                                    }),
                                !0
                              ).join("\n")),
                              (t = "Refund Order.csv"),
                              [3, 7]
                            );
                          case 6:
                            return b(!1), [2, null];
                          case 7:
                            return (
                              (o = new Blob([n], {
                                type: "text/csv;charset=utf-8;",
                              })),
                              qT().saveAs(o, t),
                              c(null),
                              b(!1),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((r = void 0) || (r = Promise))(function (e, a) {
                      function i(e) {
                        try {
                          l(o.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(o.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof r
                              ? n
                              : new r(function (e) {
                                  e(n);
                                })).then(i, s);
                      }
                      l((o = o.apply(t, n || [])).next());
                    })
                  );
                  var t, n, r, o;
                },
                isDesktop: m,
                isMobile: h,
                isCsvExporting: v,
              };
            })(),
            r = n.t,
            o = n.handleClick,
            a = n.handleClose,
            i = n.open,
            s = n.id,
            l = n.anchorEl,
            d = n.ExportOrderCSV,
            c = n.isDesktop,
            u = n.isMobile,
            p = n.isCsvExporting,
            m = RO().ST_DB_Information_Box;
          return (0, e.jsxs)(
            mn,
            QI(
              { className: "ST_Main_Card" },
              {
                children: [
                  (0, e.jsxs)(
                    qa,
                    QI(
                      {
                        item: !0,
                        xs: 12,
                        md: 12,
                        mb: 2,
                        sx: QI(QI({}, Mo), {
                          justifyContent: c ? "space-between" : "flex-start",
                          flexDirection: c ? "row" : "column",
                        }),
                      },
                      {
                        children: [
                          (0, e.jsx)(
                            qa,
                            QI(
                              { item: !0, xs: 6, md: 6 },
                              {
                                children: (0, e.jsxs)("div", {
                                  children: [
                                    (0, e.jsx)(e.Fragment, {
                                      children: (0, e.jsxs)(
                                        ni,
                                        QI(
                                          {
                                            variant: c ? "body2" : "body1",
                                            sx: {
                                              fontWeight: "bold",
                                              fontSize: c ? "1.4rem" : "1rem",
                                              mt: c ? 1 : 0,
                                              mb: c ? 0 : 1,
                                            },
                                          },
                                          {
                                            children: [
                                              r(
                                                "yourSales_SalesOrderDetailsTitle"
                                              ),
                                              (0, e.jsx)(
                                                ni,
                                                QI(
                                                  {
                                                    variant: "subtitle1",
                                                    mb: 2,
                                                  },
                                                  {
                                                    children:
                                                      r("yourSales_title"),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }),
                                    u
                                      ? (0, e.jsxs)(e.Fragment, {
                                          children: [
                                            " ",
                                            (0, e.jsx)(
                                              Qu,
                                              QI(
                                                {
                                                  className: "ST_DO_ExportCsv",
                                                  "aria-describedby": s,
                                                  variant: "contained",
                                                  onClick: o,
                                                  sx: { marginBottom: "10px" },
                                                },
                                                { children: r("exportCsv") }
                                              )
                                            ),
                                            (0, e.jsxs)(
                                              Jd,
                                              QI(
                                                {
                                                  id: s,
                                                  open: i,
                                                  anchorEl: l,
                                                  onClose: a,
                                                  anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                  },
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      J_,
                                                      QI(
                                                        {
                                                          onClick: function () {
                                                            return d(
                                                              "PaidOrPendingOrder"
                                                            );
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            "Paid/Pending Order",
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      J_,
                                                      QI(
                                                        {
                                                          onClick: function () {
                                                            return d(
                                                              "DraftOrder"
                                                            );
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            "Draft Order",
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      J_,
                                                      QI(
                                                        {
                                                          onClick: function () {
                                                            return d(
                                                              "RefundOrder"
                                                            );
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            "Refund Order",
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          ],
                                        })
                                      : null,
                                  ],
                                }),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            qa,
                            QI(
                              { item: !0, xs: 6, md: 6 },
                              {
                                children: (0, e.jsx)(
                                  ni,
                                  QI(
                                    { sx: m },
                                    {
                                      children: (0, e.jsx)(
                                        qa,
                                        QI(
                                          {
                                            container: !0,
                                            style: QI(QI({}, Mo), {
                                              margin: "0px",
                                              flexDirection: c
                                                ? "unset"
                                                : "column",
                                              paddingInlineStart: c
                                                ? "1rem"
                                                : "0.7rem",
                                              lineHeight: c
                                                ? "2.3rem"
                                                : "1.5rem",
                                            }),
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              qa,
                                              QI(
                                                {
                                                  container: !0,
                                                  style: QI(QI({}, Mo), {
                                                    margin: "0px",
                                                    flexDirection: c
                                                      ? "unset"
                                                      : "column",
                                                    paddingInlineStart: c
                                                      ? ""
                                                      : "0px",
                                                  }),
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsxs)(
                                                      qa,
                                                      QI(
                                                        {
                                                          item: !0,
                                                          style: QI(
                                                            QI({}, Mo),
                                                            {
                                                              fontSize: c
                                                                ? "15px"
                                                                : "14px",
                                                              marginRight:
                                                                "20px",
                                                              marginTop: c
                                                                ? "0rem"
                                                                : "0.5rem",
                                                            }
                                                          ),
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(
                                                              "span",
                                                              QI(
                                                                {
                                                                  className:
                                                                    "ST_DB_InformationText",
                                                                },
                                                                {
                                                                  children: (0,
                                                                  e.jsx)(kT, {
                                                                    sx: {
                                                                      color:
                                                                        "rgb(0, 160, 172)",
                                                                    },
                                                                  }),
                                                                }
                                                              )
                                                            ),
                                                            " ",
                                                            (0, e.jsx)(
                                                              "span",
                                                              QI(
                                                                {
                                                                  style: {
                                                                    fontSize: c
                                                                      ? "15px"
                                                                      : "14px",
                                                                    marginTop:
                                                                      "0.25rem",
                                                                  },
                                                                },
                                                                {
                                                                  children: r(
                                                                    "dashbord_informationMsg"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                    c
                                                      ? (0, e.jsx)(
                                                          qa,
                                                          QI(
                                                            {
                                                              item: !0,
                                                              sx: {
                                                                display: "flex",
                                                                alignItems:
                                                                  "center",
                                                                marginRight:
                                                                  "1rem",
                                                              },
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(qa, {
                                                                sx: {
                                                                  borderRight:
                                                                    "1px solid #98C6CD",
                                                                  height:
                                                                    "100%",
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        )
                                                      : "",
                                                    (0, e.jsx)(
                                                      qa,
                                                      QI(
                                                        {
                                                          item: !0,
                                                          component: "li",
                                                          className:
                                                            "ST_DB_DashboardMsg",
                                                        },
                                                        {
                                                          children: r(
                                                            "dashboard_BannerMsg"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      qa,
                                                      QI(
                                                        {
                                                          item: !0,
                                                          component: "li",
                                                          className:
                                                            "ST_DB_DashboardMsg",
                                                          sx: {
                                                            marginBottom: c
                                                              ? "0rem"
                                                              : "0.6rem",
                                                          },
                                                        },
                                                        {
                                                          children: r(
                                                            "dashboard_Information_Message"
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          u
                            ? null
                            : (0, e.jsxs)(
                                qa,
                                QI(
                                  { item: !0, xs: 6, md: 6, mb: 1 },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        Qu,
                                        QI(
                                          {
                                            className:
                                              "ST_B2B_HowItWorksButton",
                                            variant: "outlined",
                                            target: "_blank",
                                            href: "https://youtu.be/t_Ouc-_UGbE?si=Mkm7tj_NhdxPx9az",
                                            startIcon: O_,
                                            sx: { marginRight: "20px" },
                                          },
                                          { children: r("dashbord_Msg_New") }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        Qu,
                                        QI(
                                          {
                                            className: "ST_DO_ExportCsv",
                                            "aria-describedby": s,
                                            variant: "contained",
                                            onClick: o,
                                            disabled: p,
                                          },
                                          {
                                            children: p
                                              ? (0, e.jsx)(Um, {
                                                  size: 24,
                                                  color: "primary",
                                                })
                                              : r("exportCsv"),
                                          }
                                        )
                                      ),
                                      (0, e.jsxs)(
                                        Jd,
                                        QI(
                                          {
                                            id: s,
                                            open: i,
                                            anchorEl: l,
                                            onClose: a,
                                            anchorOrigin: {
                                              vertical: "bottom",
                                              horizontal: "left",
                                            },
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                J_,
                                                QI(
                                                  {
                                                    onClick: function () {
                                                      return d(
                                                        "PaidOrPendingOrder"
                                                      );
                                                    },
                                                  },
                                                  {
                                                    children:
                                                      "Paid/Pending Order",
                                                  }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                J_,
                                                QI(
                                                  {
                                                    onClick: function () {
                                                      return d("DraftOrder");
                                                    },
                                                  },
                                                  { children: "Draft Order" }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                J_,
                                                QI(
                                                  {
                                                    onClick: function () {
                                                      return d("RefundOrder");
                                                    },
                                                  },
                                                  { children: "Refund Order" }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    mn,
                    QI(
                      { sx: { width: "100%", typography: "body1" } },
                      { children: (0, e.jsx)(qI, {}) }
                    )
                  ),
                ],
              }
            )
          );
        },
        JI = o(4142);
      const XI = [
          "className",
          "component",
          "disableGutters",
          "fixed",
          "maxWidth",
          "classes",
        ],
        eM = (0, en.Z)(),
        tM = Jb("div", {
          name: "MuiContainer",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`maxWidth${(0, JI.Z)(String(n.maxWidth))}`],
              n.fixed && t.fixed,
              n.disableGutters && t.disableGutters,
            ];
          },
        }),
        nM = (e) => jm({ props: e, name: "MuiContainer", defaultTheme: eM }),
        rM = (function (n = {}) {
          const {
              createStyledComponent: r = tM,
              useThemeProps: o = nM,
              componentName: a = "MuiContainer",
            } = n,
            i = r(
              ({ theme: e, ownerState: t }) =>
                (0, u.Z)(
                  {
                    width: "100%",
                    marginLeft: "auto",
                    boxSizing: "border-box",
                    marginRight: "auto",
                    display: "block",
                  },
                  !t.disableGutters && {
                    paddingLeft: e.spacing(2),
                    paddingRight: e.spacing(2),
                    [e.breakpoints.up("sm")]: {
                      paddingLeft: e.spacing(3),
                      paddingRight: e.spacing(3),
                    },
                  }
                ),
              ({ theme: e, ownerState: t }) =>
                t.fixed &&
                Object.keys(e.breakpoints.values).reduce((t, n) => {
                  const r = n,
                    o = e.breakpoints.values[r];
                  return (
                    0 !== o &&
                      (t[e.breakpoints.up(r)] = {
                        maxWidth: `${o}${e.breakpoints.unit}`,
                      }),
                    t
                  );
                }, {}),
              ({ theme: e, ownerState: t }) =>
                (0, u.Z)(
                  {},
                  "xs" === t.maxWidth && {
                    [e.breakpoints.up("xs")]: {
                      maxWidth: Math.max(e.breakpoints.values.xs, 444),
                    },
                  },
                  t.maxWidth &&
                    "xs" !== t.maxWidth && {
                      [e.breakpoints.up(t.maxWidth)]: {
                        maxWidth: `${e.breakpoints.values[t.maxWidth]}${
                          e.breakpoints.unit
                        }`,
                      },
                    }
                )
            ),
            s = t.forwardRef(function (t, n) {
              const r = o(t),
                {
                  className: s,
                  component: l = "div",
                  disableGutters: d = !1,
                  fixed: c = !1,
                  maxWidth: p = "lg",
                } = r,
                m = (0, At.Z)(r, XI),
                h = (0, u.Z)({}, r, {
                  component: l,
                  disableGutters: d,
                  fixed: c,
                  maxWidth: p,
                }),
                f = ((e, t) => {
                  const {
                      classes: n,
                      fixed: r,
                      disableGutters: o,
                      maxWidth: a,
                    } = e,
                    i = {
                      root: [
                        "root",
                        a && `maxWidth${(0, JI.Z)(String(a))}`,
                        r && "fixed",
                        o && "disableGutters",
                      ],
                    };
                  return (0, Rt.Z)(i, (e) => (0, Zt.ZP)(t, e), n);
                })(h, a);
              return (0,
              e.jsx)(i, (0, u.Z)({ as: l, ownerState: h, className: Qt(f.root, s), ref: n }, m));
            });
          return s;
        })({
          createStyledComponent: (0, Bt.ZP)("div", {
            name: "MuiContainer",
            slot: "Root",
            overridesResolver: (e, t) => {
              const { ownerState: n } = e;
              return [
                t.root,
                t[`maxWidth${(0, $n.Z)(String(n.maxWidth))}`],
                n.fixed && t.fixed,
                n.disableGutters && t.disableGutters,
              ];
            },
          }),
          useThemeProps: (e) => (0, zt.i)({ props: e, name: "MuiContainer" }),
        });
      var oM = rM,
        aM = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M15.39 14.56C13.71 13.7 11.53 13 9 13s-4.71.7-6.39 1.56C1.61 15.07 1 16.1 1 17.22V20h16v-2.78c0-1.12-.61-2.15-1.61-2.66M9 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4m11-3V6h-2v3h-3v2h3v3h2v-3h3V9z",
          }),
          "PersonAddAltSharp"
        ),
        iM = function () {
          return (
            (iM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            iM.apply(this, arguments)
          );
        },
        sM = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        lM = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        dM = function () {
          var n,
            r,
            o,
            a = y(function (e) {
              return e.salesRepData;
            }),
            i = g(),
            s = ee().t,
            l = (0, t.useState)(),
            d = l[0],
            c = l[1],
            u =
              null === (n = null == a ? void 0 : a.baseData) || void 0 === n
                ? void 0
                : n.teammemberdetails,
            p =
              null == u
                ? void 0
                : u.map(function (e) {
                    return e.Name;
                  }),
            m = F.getState().salesRepData.loggedInRepDetails.shopCurrency,
            h = (0, t.useState)(""),
            f = h[0],
            v = h[1],
            b = (0, t.useState)(!1),
            _ = b[0],
            C = b[1],
            x = (0, t.useState)(!1),
            S = x[0],
            k = x[1],
            P = (0, t.useState)(!1),
            w = P[0],
            O = P[1],
            T = (0, t.useState)(!1),
            I = T[0],
            M = T[1],
            j = (0, t.useState)(!1),
            N = j[0],
            D = j[1],
            A = (0, t.useState)({
              repFirstName: "",
              repEmail: "",
              repLastName: "",
            }),
            E = A[0],
            R = A[1],
            L = (0, t.useState)({ firstName: !1, email: !1, lastName: !1 }),
            B = L[0],
            z = L[1],
            Z = Db,
            H = /^[a-zA-Z\s]*$/,
            V =
              null === (r = null == a ? void 0 : a.loggedInRepDetails) ||
              void 0 === r
                ? void 0
                : r.shopName,
            W =
              void 0 !== a.baseData.SingleSalesRep &&
              null !== a.baseData.SingleSalesRep &&
              void 0 !== a.baseData.SingleSalesRep.SalesRepAffiliateUrl &&
              null !== a.baseData.SingleSalesRep.SalesRepAffiliateUrl
                ? null ===
                    (o = a.baseData.SingleSalesRep.SalesRepAffiliateUrl) ||
                  void 0 === o
                  ? void 0
                  : o.split("?")[1]
                : "ambassador=",
            U =
              "https://" +
              V +
              "/pages/sales-representative-sign-up?manager=" +
              new URLSearchParams(W).get("ambassador");
          Bh.subscribe(function (e) {
            e !== I && M(e);
          });
          var $ = [
            { id: "order_number", label: s("team_column1") },
            { id: "order_date", label: s("team_column2") },
            { id: "customer_name", label: s("team_column3") },
            { id: "sub_total", label: s("team_column5") },
            { id: "sales_rep_commission", label: s("team_column6") },
            { id: "team_manager_commission", label: s("team_column7") },
            { id: "commission_type", label: s("team_column8") },
          ];
          return {
            saveRepInvite: !!(
              Ov(E.repFirstName, E.repEmail) ||
              !E.repEmail.match(Z) ||
              E.repEmail.indexOf(" ") >= 0
            ),
            shopCurrency: m,
            rep: f,
            openRepDropDown: function (e) {
              return sM(this, void 0, void 0, function () {
                var t, n, r, o, a;
                return lM(this, function (i) {
                  switch (i.label) {
                    case 0:
                      return (
                        v(e.target.value),
                        "None" === e.target.value ||
                        "" === e.target.value ||
                        null === e.target.value
                          ? [3, 2]
                          : ((t =
                              null == u
                                ? void 0
                                : u.filter(function (t) {
                                    return t.Name === e.target.value;
                                  })),
                            (n = { repName: e.target.value, repId: t[0].Id }),
                            Bh.next(!0),
                            [4, Pf(n)])
                      );
                    case 1:
                      return (
                        null != (r = i.sent()) &&
                          ((o = r.AllOrdersCommission),
                          (a =
                            null == o
                              ? void 0
                              : o.map(function (e) {
                                  var t = {};
                                  return (
                                    Object.assign(t, {
                                      orderNumber: e.orderNumber,
                                      orderDate: e.orderDate,
                                      orderName: e.orderName,
                                      CustomerName: e.CustomerName,
                                      subtotal: e.subtotal,
                                      commission: e.commission,
                                      TeamManagerCommission:
                                        e.TeamManagerCommission,
                                      CommissionType: e.CommissionType,
                                    }),
                                    t
                                  );
                                })),
                          c(a)),
                        [3, 3]
                      );
                    case 2:
                      v(e.target.value), c(null), (i.label = 3);
                    case 3:
                      return Bh.next(!1), [2];
                  }
                });
              });
            },
            sendRepInvite: function () {
              return sM(this, void 0, void 0, function () {
                var e;
                return lM(this, function (t) {
                  switch (t.label) {
                    case 0:
                      return (
                        C(!0),
                        z(iM(iM({}, B), { email: !1 })),
                        Ov(E.repFirstName, E.repEmail)
                          ? [3, 2]
                          : [
                              4,
                              kf({
                                firstName: E.repFirstName,
                                lastName: E.repLastName,
                                email: E.repEmail,
                              }),
                            ]
                      );
                    case 1:
                      return (
                        !0 === (e = t.sent()) ||
                        (void 0 !== e.StatusCode &&
                          null !== e.StatusCode &&
                          200 === e.StatusCode)
                          ? (i(eg()),
                            C(!1),
                            k(!0),
                            R({
                              repFirstName: "",
                              repEmail: "",
                              repLastName: "",
                            }))
                          : (C(!1), O(!0)),
                        setTimeout(function () {
                          D(!1),
                            k(!1),
                            O(!1),
                            R({
                              repFirstName: "",
                              repEmail: "",
                              repLastName: "",
                            });
                        }, 8e3),
                        [3, 3]
                      );
                    case 2:
                      z(iM(iM({}, B), { email: !0 })), (t.label = 3);
                    case 3:
                      return [2];
                  }
                });
              });
            },
            createHeaders: function (t) {
              return null == t
                ? void 0
                : t.map(function (t, n) {
                    return (0,
                    e.jsx)(Op, iM({ align: "center" }, { children: (0, e.jsx)("b", { children: t.label }) }), n);
                  });
            },
            orderRows: d,
            orderTableColumns: $,
            showRepForm: function () {
              return D(!0);
            },
            newRepForm: E,
            inputChange: function (e) {
              var t,
                n = e.target,
                r = n.name,
                o = n.value;
              "repEmail" === e.target.name
                ? e.target.value.match(Z)
                  ? z(iM(iM({}, B), { email: !1 }))
                  : z(iM(iM({}, B), { email: !0 }))
                : "repFirstName" === e.target.name &&
                  (H.test(e.target.value)
                    ? z(iM(iM({}, B), { firstName: !1 }))
                    : z(iM(iM({}, B), { firstName: !0 }))),
                R(iM(iM({}, E), (((t = {})[r] = o), t)));
            },
            signupUrl: U,
            Names: p,
            loadingBtn: _,
            isError: B,
            successMsg: S,
            failureMsg: w,
            addRep: N,
            setAddRep: D,
          };
        },
        cM = function () {
          return (
            (cM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            cM.apply(this, arguments)
          );
        },
        uM = function (n) {
          var r = n.headerArray,
            o = n.dataArray,
            a = dM().shopCurrency,
            i = ee().t,
            s = function (t, n) {
              var r, o, i, s;
              switch (t) {
                case 0:
                  s = (0, e.jsx)(Op, {
                    children: null == n ? void 0 : n.orderNumber,
                  });
                  break;
                case 1:
                  s = (0, e.jsx)(Op, {
                    children: null == n ? void 0 : n.orderDate,
                  });
                  break;
                case 2:
                  s = (0, e.jsx)(Op, {
                    children: null == n ? void 0 : n.CustomerName,
                  });
                  break;
                case 3:
                  s = (0, e.jsx)(
                    Op,
                    cM(
                      { className: "ST_White_Space" },
                      {
                        children:
                          a +
                          " " +
                          (null === (r = null == n ? void 0 : n.subtotal) ||
                          void 0 === r
                            ? void 0
                            : r.toFixed(2)),
                      }
                    )
                  );
                  break;
                case 4:
                  s = (0, e.jsx)(
                    Op,
                    cM(
                      { className: "ST_White_Space" },
                      {
                        children:
                          a +
                          " " +
                          (null === (o = null == n ? void 0 : n.commission) ||
                          void 0 === o
                            ? void 0
                            : o.toFixed(2)),
                      }
                    )
                  );
                  break;
                case 5:
                  s = (0, e.jsx)(
                    Op,
                    cM(
                      { className: "ST_White_Space" },
                      {
                        children:
                          a +
                          " " +
                          (null ===
                            (i =
                              null == n ? void 0 : n.TeamManagerCommission) ||
                          void 0 === i
                            ? void 0
                            : i.toFixed(2)),
                      }
                    )
                  );
                  break;
                case 6:
                  s = (0, e.jsx)(Op, {
                    children: null == n ? void 0 : n.CommissionType,
                  });
              }
              return s;
            };
          return (0, e.jsx)(
            ep,
            cM(
              { sx: Ho, className: "Table_Container_Margin" },
              {
                children: (0, e.jsx)(sp, {
                  children:
                    null != o && (null == o ? void 0 : o.length) > 0
                      ? null == o
                        ? void 0
                        : o.map(function (n, o) {
                            return (0, e.jsxs)(e.Fragment, {
                              children: [
                                (0, e.jsx)(
                                  Dp,
                                  cM(
                                    { sx: { backgroundColor: "whitesmoke" } },
                                    {
                                      children: (0, e.jsx)(
                                        t.Fragment,
                                        {
                                          children:
                                            null == r
                                              ? void 0
                                              : r.map(function (t, r) {
                                                  return (0,
                                                  e.jsxs)(Cp, cM({ className: "MobileViewTableCell", sx: { display: (null == t ? void 0 : t.hidden) ? "none" : "table-row" } }, { children: [(0, e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [t.label, ":"] }) }), s(r, n)] }), t.label + r);
                                                }),
                                        },
                                        o
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                              ],
                            });
                          })
                      : (0, e.jsx)(Dp, {
                          children: (0, e.jsx)(Cp, {
                            children: (0, e.jsx)(
                              Op,
                              cM(
                                { className: "BorderBottom" },
                                { children: i("no_orders_to_show") }
                              )
                            ),
                          }),
                        }),
                }),
              }
            )
          );
        },
        pM = function () {
          return (
            (pM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            pM.apply(this, arguments)
          );
        },
        mM = function () {
          var t = ee().t,
            n = dM(),
            r = n.saveRepInvite,
            o = n.shopCurrency,
            a = n.rep,
            i = n.openRepDropDown,
            s = n.sendRepInvite,
            l = n.createHeaders,
            d = n.orderRows,
            c = n.orderTableColumns,
            u = n.showRepForm,
            p = n.newRepForm,
            m = n.inputChange,
            h = (n.signupUrl, n.Names),
            f = n.loadingBtn,
            g = n.isError,
            v = n.successMsg,
            b = n.failureMsg,
            _ = n.addRep,
            y = n.setAddRep,
            C = Tv();
          return (0, e.jsx)(oM, {
            children: (0, e.jsxs)(
              ii,
              pM(
                { className: "ST_MC_Dialog_Box" },
                {
                  children: [
                    (0, e.jsxs)(
                      qa,
                      pM(
                        { container: !0, spacing: 2 },
                        {
                          children: [
                            (0, e.jsx)(
                              qa,
                              pM(
                                { item: !0, xs: 6, md: 8, mb: 2 },
                                {
                                  children: (0, e.jsx)(
                                    ni,
                                    pM(
                                      { variant: "h6", mt: 0.5 },
                                      { children: t("team_title2") }
                                    )
                                  ),
                                }
                              )
                            ),
                            (0, e.jsx)(
                              qa,
                              pM(
                                {
                                  item: !0,
                                  xs: 6,
                                  md: 4,
                                  sx: { textAlign: "right" },
                                },
                                {
                                  children: (0, e.jsx)(
                                    Qu,
                                    pM(
                                      {
                                        endIcon: (0, e.jsx)(aM, {}),
                                        variant: "contained",
                                        sx: { textTransform: "capitalize" },
                                        onClick: function () {
                                          return u();
                                        },
                                      },
                                      { children: t("addSalesRep_txt1") }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    (0, e.jsxs)(
                      qa,
                      pM(
                        { item: !0, xs: 6, md: 8, mb: 3 },
                        {
                          children: [
                            (0, e.jsx)("br", {}),
                            (0, e.jsxs)(
                              yd,
                              pM(
                                { fullWidth: !0, size: "small" },
                                {
                                  children: [
                                    (0, e.jsx)(hd, {
                                      children: t("team_content5"),
                                    }),
                                    (0, e.jsxs)(
                                      Rc,
                                      pM(
                                        {
                                          labelId: "select-name",
                                          label: t("team_content5"),
                                          value: a,
                                          onChange: i,
                                        },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              J_,
                                              pM(
                                                { value: "" },
                                                {
                                                  children: (0, e.jsx)("em", {
                                                    children: "None",
                                                  }),
                                                }
                                              )
                                            ),
                                            null == h
                                              ? void 0
                                              : h.map(function (t, n) {
                                                  return (0,
                                                  e.jsx)(J_, pM({ value: t }, { children: t }), n);
                                                }),
                                          ],
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                    C
                      ? (0, e.jsx)(uM, { headerArray: c, dataArray: d })
                      : (0, e.jsx)(
                          ep,
                          pM(
                            { component: go },
                            {
                              children: (0, e.jsxs)(
                                sp,
                                pM(
                                  { stickyHeader: !0 },
                                  {
                                    children: [
                                      (0, e.jsx)(hp, {
                                        children: (0, e.jsx)(
                                          Cp,
                                          pM(
                                            { className: "stickyHeaderRow" },
                                            { children: l(c) }
                                          )
                                        ),
                                      }),
                                      (0, e.jsx)(Dp, {
                                        children:
                                          null != d &&
                                          (null == d ? void 0 : d.length) > 0
                                            ? null == d
                                              ? void 0
                                              : d.map(function (t, n) {
                                                  var r, a, i;
                                                  return (0,
                                                  e.jsxs)(Cp, { children: [(0, e.jsx)(Op, pM({ align: "center" }, { children: null == t ? void 0 : t.orderNumber })), (0, e.jsx)(Op, pM({ align: "center" }, { children: null == t ? void 0 : t.orderDate })), (0, e.jsx)(Op, pM({ align: "center" }, { children: null == t ? void 0 : t.CustomerName })), (0, e.jsx)(Op, pM({ align: "center", className: "ST_White_Space" }, { children: o + " " + (null === (r = null == t ? void 0 : t.subtotal) || void 0 === r ? void 0 : r.toFixed(2)) })), (0, e.jsx)(Op, pM({ align: "center", className: "ST_White_Space" }, { children: o + " " + (null === (a = null == t ? void 0 : t.commission) || void 0 === a ? void 0 : a.toFixed(2)) })), (0, e.jsx)(Op, pM({ align: "center", className: "ST_White_Space" }, { children: o + " " + (null === (i = null == t ? void 0 : t.TeamManagerCommission) || void 0 === i ? void 0 : i.toFixed(2)) })), (0, e.jsx)(Op, pM({ align: "center" }, { children: null == t ? void 0 : t.CommissionType }))] }, n);
                                                })
                                            : (0, e.jsx)(Cp, {
                                                children: (0, e.jsx)(
                                                  Op,
                                                  pM(
                                                    {
                                                      align: "center",
                                                      colSpan: 7,
                                                    },
                                                    {
                                                      children: (0, e.jsx)(ni, {
                                                        children:
                                                          t(
                                                            "no_orders_to_show"
                                                          ),
                                                      }),
                                                    }
                                                  )
                                                ),
                                              }),
                                      }),
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                    (0, e.jsx)(
                      Hp,
                      pM(
                        {
                          open: _,
                          onClose: function () {
                            return y(!1);
                          },
                          maxWidth: "sm",
                          fullWidth: !0,
                          className: "Dialog_Border_Radius",
                        },
                        {
                          children: (0, e.jsxs)(mn, {
                            children: [
                              (0, e.jsxs)(
                                qa,
                                pM(
                                  {
                                    container: !0,
                                    className: "ST_Dialog_Box_Padding",
                                  },
                                  {
                                    children: [
                                      (0, e.jsx)(
                                        qa,
                                        pM(
                                          { item: !0, xs: 10, md: 10 },
                                          {
                                            children: (0, e.jsx)(
                                              ni,
                                              pM(
                                                { variant: "h6" },
                                                {
                                                  children:
                                                    t("addSalesRep_txt1"),
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                      (0, e.jsx)(
                                        qa,
                                        pM(
                                          {
                                            item: !0,
                                            xs: 2,
                                            md: 2,
                                            sx: { textAlign: "right" },
                                          },
                                          {
                                            children: (0, e.jsx)(Fg, {
                                              sx: { cursor: "pointer" },
                                              onClick: function () {
                                                y(!1);
                                              },
                                            }),
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                              (0, e.jsx)("hr", {}),
                              (0, e.jsx)(
                                Gp,
                                pM(
                                  { className: "ST_Dialog_Box_Padding" },
                                  {
                                    children: (0, e.jsxs)(
                                      qa,
                                      pM(
                                        { container: !0 },
                                        {
                                          children: [
                                            (0, e.jsx)(
                                              qa,
                                              pM(
                                                {
                                                  item: !0,
                                                  xs: 12,
                                                  md: 12,
                                                  mb: 3,
                                                },
                                                {
                                                  children: (0, e.jsx)(Hc, {
                                                    placeholder: t(
                                                      "team_content1PlaceHolder"
                                                    ),
                                                    label: t("team_content1"),
                                                    value: p.repEmail,
                                                    name: "repEmail",
                                                    onChange: function (e) {
                                                      return m(e);
                                                    },
                                                    error: g.email,
                                                    helperText: g.email
                                                      ? t("team_emailerrorMsg")
                                                      : "",
                                                    required: !0,
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              qa,
                                              pM(
                                                {
                                                  item: !0,
                                                  xs: 12,
                                                  md: 12,
                                                  mb: 3,
                                                },
                                                {
                                                  children: (0, e.jsx)(Hc, {
                                                    type: "text",
                                                    placeholder: t(
                                                      "team_content2PlaceHolder"
                                                    ),
                                                    label: t("team_content2"),
                                                    name: "repFirstName",
                                                    value: p.repFirstName,
                                                    onChange: function (e) {
                                                      return m(e);
                                                    },
                                                    error: g.firstName,
                                                    required: !0,
                                                    helperText: g.firstName
                                                      ? t("team_fnameerrorMsg")
                                                      : "",
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                            (0, e.jsx)(
                                              qa,
                                              pM(
                                                { item: !0, xs: 12, md: 12 },
                                                {
                                                  children: (0, e.jsx)(Hc, {
                                                    type: "text",
                                                    placeholder: t(
                                                      "team_content3PlaceHolder"
                                                    ),
                                                    label: t("team_content3"),
                                                    value: p.repLastName,
                                                    name: "repLastName",
                                                    onChange: function (e) {
                                                      return m(e);
                                                    },
                                                    fullWidth: !0,
                                                  }),
                                                }
                                              )
                                            ),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                              (0, e.jsx)("hr", {}),
                              (0, e.jsxs)(
                                Jp,
                                pM(
                                  {
                                    style: { alignItems: "stretch" },
                                    className: "ST_Dialog_Box_Padding",
                                  },
                                  {
                                    children: [
                                      (0, e.jsxs)(qa, {
                                        children: [
                                          v
                                            ? (0, e.jsx)(
                                                ni,
                                                pM(
                                                  {
                                                    variant: "caption",
                                                    display: "block",
                                                    gutterBottom: !0,
                                                    className:
                                                      "ST_Error_SuccessMsg_Color",
                                                  },
                                                  {
                                                    children:
                                                      t("team_successmsg"),
                                                  }
                                                )
                                              )
                                            : (0, e.jsx)(ni, {
                                                style: { visibility: "hidden" },
                                              }),
                                          b
                                            ? (0, e.jsx)(
                                                ni,
                                                pM(
                                                  {
                                                    variant: "caption",
                                                    display: "block",
                                                    className:
                                                      "ST_Error_Msg_Color",
                                                    gutterBottom: !0,
                                                  },
                                                  {
                                                    children:
                                                      t("team_errorsmsg"),
                                                  }
                                                )
                                              )
                                            : (0, e.jsx)(ni, {
                                                style: { visibility: "hidden" },
                                              }),
                                        ],
                                      }),
                                      (0, e.jsx)(qa, {
                                        children:
                                          p.repEmail && p.repFirstName
                                            ? (0, e.jsxs)(
                                                Ym,
                                                pM(
                                                  {
                                                    style: {
                                                      textTransform:
                                                        "capitalize",
                                                    },
                                                    loading: f,
                                                    disabled: r,
                                                    loadingPosition: "end",
                                                    endIcon: (0, e.jsx)(aM, {}),
                                                    variant: "contained",
                                                    onClick: function () {
                                                      return s();
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      " ",
                                                      t(
                                                        f
                                                          ? "addSalesRep_txt2"
                                                          : "team_button1"
                                                      ),
                                                    ],
                                                  }
                                                )
                                              )
                                            : (0, e.jsx)(
                                                Qu,
                                                pM(
                                                  {
                                                    style: {
                                                      textTransform:
                                                        "capitalize",
                                                    },
                                                    variant: "contained",
                                                    disabled: !0,
                                                    endIcon: (0, e.jsx)(aM, {}),
                                                  },
                                                  {
                                                    children: t("team_button1"),
                                                  }
                                                )
                                              ),
                                      }),
                                    ],
                                  }
                                )
                              ),
                            ],
                          }),
                        }
                      )
                    ),
                  ],
                }
              )
            ),
          });
        },
        hM = (0, Oo.Z)(
          [
            (0, e.jsx)(
              "path",
              {
                d: "M3 8c0 .55.45 1 1 1s1-.45 1-1V6h2c.55 0 1-.45 1-1s-.45-1-1-1H5V2c0-.55-.45-1-1-1s-1 .45-1 1v2H1c-.55 0-1 .45-1 1s.45 1 1 1h2z",
              },
              "0"
            ),
            (0, e.jsx)("circle", { cx: "13", cy: "14", r: "3" }, "1"),
            (0, e.jsx)(
              "path",
              {
                d: "M21 6h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65h-6.4c.17.3.28.63.28 1 0 1.1-.9 2-2 2H6v1c0 1.1-.9 2-2 2-.37 0-.7-.11-1-.28V20c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2m-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5",
              },
              "2"
            ),
          ],
          "AddAPhotoRounded"
        ),
        fM = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M18 15v3H6v-3H4v3c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-3zM7 9l1.41 1.41L11 7.83V16h2V7.83l2.59 2.58L17 9l-5-5z",
          }),
          "FileUploadOutlined"
        ),
        gM = function () {
          return (
            (gM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            gM.apply(this, arguments)
          );
        },
        vM = function (n) {
          var r,
            o,
            a,
            i,
            s = vb(),
            l = s.ST_CI_MediaCart,
            d = s.isMobile,
            c = s.ST_CI_HorizontalLine,
            u = xv(),
            p = u.copyTextFunction,
            m = u.copyIconSuccessColor,
            h = u.SnackbarAlertMsg,
            f = gb(),
            g = f.affiliateIsConfirmOpen,
            v = f.handleAffiliateOpenConfirm,
            b = f.handleDoNotShowState,
            _ = f.CheckPopUpInitialValue,
            C = f.handleAlertMsgClose,
            x = f.affiliateAlertMsg,
            S = f.linkError,
            k = f.helperTextLink,
            P = f.linkTextValidation,
            w = f.saveState,
            O = f.repProfile,
            T = f.saveBtn,
            I = f.profile,
            M = f.setImage,
            j = f.setLinkText,
            N = f.linkText,
            D = f.savingLinkBio,
            A = f.saveAffiliateInfo,
            E = f.salesRepUniqueLink,
            R = f.showToasterSuccessMsg,
            L = ee().t,
            B = y(function (e) {
              return e.salesRepData;
            }),
            z =
              null !==
                (o =
                  null === (r = B.baseData) || void 0 === r
                    ? void 0
                    : r.ShopDomainName) && void 0 !== o
                ? o
                : null === (a = B.baseData) || void 0 === a
                ? void 0
                : a.ShopName;
          return (
            (0, t.useEffect)(function () {
              var e;
              if (
                ((
                  null === (e = O.baseData) || void 0 === e
                    ? void 0
                    : e.completedGetProductApi
                )
                  ? Bh.next(!1)
                  : Bh.next(!0),
                !Ov(I))
              ) {
                var t = null == I ? void 0 : I.ProfileImagePath;
                M(function (e) {
                  return gM(gM({}, e), { imagePreview: t, isLoading: !1 });
                }),
                  Ov(null == I ? void 0 : I.SalesRepUniqueLink)
                    ? j("")
                    : j(null == I ? void 0 : I.SalesRepUniqueLink);
              }
              setTimeout(function () {
                Bh.next(!1);
              }, 5e3);
            }, []),
            (0, e.jsxs)(e.Fragment, {
              children: [
                (0, e.jsxs)(
                  mn,
                  gM(
                    { className: "ST_Main_Card" },
                    {
                      children: [
                        (0, e.jsx)(
                          qa,
                          gM(
                            {
                              sx: {
                                ST_CI_Heading: $o,
                                ST_CI_HorizontalLine: c,
                                marginBottom: "1rem",
                              },
                            },
                            {
                              children: (0, e.jsx)(
                                ni,
                                gM(
                                  { variant: Av, sx: Ko },
                                  { children: L("affiliateLink_searchColumn5") }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          ii,
                          gM(
                            {
                              sx: gM(gM({}, l), { padding: 1 }),
                              className: "ST_CI_ContactCard",
                            },
                            {
                              children: (0, e.jsx)(
                                qa,
                                gM(
                                  {
                                    container: !0,
                                    direction: "row",
                                    spacing: 1,
                                    justifyContent: "center",
                                    alignItems: "center",
                                  },
                                  {
                                    children: (0, e.jsxs)(
                                      qa,
                                      gM(
                                        {
                                          item: !0,
                                          xs: 10,
                                          md: 12,
                                          sm: 12,
                                          lg: 10,
                                          justifyContent: "space-between",
                                          alignItems: "center",
                                          m: 2,
                                        },
                                        {
                                          children: [
                                            (0, e.jsxs)(
                                              ni,
                                              gM(
                                                {
                                                  mt: 1,
                                                  p: 1,
                                                  className:
                                                    "Font_Properties Work_Break",
                                                },
                                                {
                                                  children: [
                                                    L(
                                                      "affiliateLink_searchColumn5"
                                                    ),
                                                    " -",
                                                    " ",
                                                    (0, e.jsx)(
                                                      rl,
                                                      gM(
                                                        {
                                                          href: E,
                                                          target: "_blank",
                                                          className:
                                                            "ST_AL_UniqLink_Text ST_link_FontColor",
                                                          variant: "body2",
                                                        },
                                                        { children: E }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      Gs,
                                                      gM(
                                                        {
                                                          TransitionComponent:
                                                            pb,
                                                          title:
                                                            "#05bf05" ===
                                                            m.affiliateUrl
                                                              ? L(
                                                                  "affiliateLink_searchColumn8"
                                                                )
                                                              : L(
                                                                  "affiliateLink_searchColumn7"
                                                                ),
                                                          placement: "bottom",
                                                          arrow: !0,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Tb,
                                                            {
                                                              onClick:
                                                                function () {
                                                                  return _
                                                                    ? p(
                                                                        E,
                                                                        "affiliateUrl"
                                                                      )
                                                                    : v();
                                                                },
                                                              style: {
                                                                color:
                                                                  null !==
                                                                    (i =
                                                                      m.affiliateUrl) &&
                                                                  void 0 !== i
                                                                    ? i
                                                                    : "#757575",
                                                              },
                                                              className:
                                                                "ST_CI_UniqueLink",
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    g &&
                                                      (0, e.jsx)(I_, {
                                                        closeModal: v,
                                                        popUpType:
                                                          "affiliatePopUp",
                                                        openPopUp: !0,
                                                        CallMethod: b,
                                                        uniqueLink: E,
                                                        affiliateLinkType:
                                                          "affiliateUrl",
                                                        showToasterMsg: R,
                                                      }),
                                                  ],
                                                }
                                              )
                                            ),
                                            (0, e.jsxs)(
                                              qa,
                                              gM(
                                                { container: !0, spacing: 2 },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      qa,
                                                      gM(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 7,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Hc,
                                                            {
                                                              fullWidth: !0,
                                                              size: "small",
                                                              className:
                                                                "ST_CI_AffiliateLink_TextBox",
                                                              error: S,
                                                              helperText: S
                                                                ? (0, e.jsx)(
                                                                    e.Fragment,
                                                                    {
                                                                      children:
                                                                        k,
                                                                    }
                                                                  )
                                                                : "",
                                                              onChange:
                                                                function (e) {
                                                                  return P(e);
                                                                },
                                                              value: N,
                                                              label:
                                                                L(
                                                                  "yourBio_content2"
                                                                ),
                                                              InputProps: {
                                                                inputProps: {
                                                                  style: {
                                                                    height: d
                                                                      ? 50
                                                                      : 35,
                                                                  },
                                                                },
                                                              },
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      qa,
                                                      gM(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 4,
                                                          style: {
                                                            width: "inherit",
                                                          },
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            Ym,
                                                            gM(
                                                              {
                                                                sx: { mt: 3 },
                                                                className:
                                                                  "ST_CI_SaveBtn",
                                                                loading: D,
                                                                disabled: T,
                                                                variant:
                                                                  "contained",
                                                                onClick:
                                                                  function () {
                                                                    return A(
                                                                      "affiliateUrl"
                                                                    );
                                                                  },
                                                              },
                                                              { children: w }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                            (0, e.jsx)("hr", {
                                              className:
                                                "ST_CI_Horizontal_LineForAfiliate",
                                            }),
                                            (0, e.jsxs)(
                                              qa,
                                              gM(
                                                { container: !0, spacing: 2 },
                                                {
                                                  children: [
                                                    (0, e.jsx)(
                                                      qa,
                                                      gM(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 8,
                                                          mb: 3,
                                                          mt: 1,
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            ni,
                                                            gM(
                                                              {
                                                                className:
                                                                  "Font_Properties",
                                                                variant:
                                                                  "body1",
                                                              },
                                                              {
                                                                children: L(
                                                                  "Affiliate_Link_Info_Msg"
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                    (0, e.jsx)(
                                                      qa,
                                                      gM(
                                                        {
                                                          item: !0,
                                                          xs: 12,
                                                          md: 4,
                                                          mb: 1,
                                                          className:
                                                            "ST_DC_Card_Grid",
                                                          sx: {
                                                            textAlign: "right",
                                                          },
                                                        },
                                                        {
                                                          children: (0, e.jsx)(
                                                            L_,
                                                            {
                                                              url:
                                                                "https://" + z,
                                                            }
                                                          ),
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }
                                              )
                                            ),
                                            d
                                              ? (0, e.jsx)(z_, {
                                                  activeTabIndex: 3,
                                                })
                                              : (0, e.jsx)(j_, {
                                                  activeTabIndex: 3,
                                                }),
                                          ],
                                        }
                                      )
                                    ),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
                h(x, C),
              ],
            })
          );
        },
        bM = (0, t.memo)(vM),
        _M = function () {
          return (
            (_M =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            _M.apply(this, arguments)
          );
        },
        yM = function () {
          var n,
            r,
            o = xv().SnackbarAlertMsg,
            a = gb(),
            i = a.isImageInput,
            s = a.repProfile,
            l = a.saveBtn,
            d = a.imagePreview,
            c = a.profile,
            u = a.setImage,
            p = a.setLinkText,
            m = a.uploadInputImage,
            h = a.bio,
            f = a.uploadImageState,
            g = a.imageLoading,
            v = a.showNewImage,
            b = a.cardSaveState,
            _ = a.updatedLink,
            y = a.savingLinkBio,
            C = a.handleUploadImage,
            x = a.uploadImage,
            S = a.bioTextValidation,
            k = a.saveAffiliateInfo,
            P = a.helperImage,
            w = a.imageError,
            O = a.contactCardCharLength,
            T = a.charMaxLength,
            I = a.handleAlertMsgClose,
            M = a.affiliateAlertMsg,
            j = ee().t,
            N = vb(),
            D = N.ST_CI_ContactCart,
            A = N.ST_CI_HorizontalLine;
          (0, t.useEffect)(function () {
            var e;
            if (
              ((
                null === (e = s.baseData) || void 0 === e
                  ? void 0
                  : e.completedGetProductApi
              )
                ? Bh.next(!1)
                : Bh.next(!0),
              !Ov(c))
            ) {
              var t = null == c ? void 0 : c.ProfileImagePath;
              u(function (e) {
                return _M(_M({}, e), { imagePreview: t, isLoading: !1 });
              }),
                Ov(null == c ? void 0 : c.SalesRepUniqueLink)
                  ? p("")
                  : p(null == c ? void 0 : c.SalesRepUniqueLink);
            }
            setTimeout(function () {
              Bh.next(!1);
            }, 5e3);
          }, []);
          var E = s.baseData.SingleSalesRep;
          return (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(bM, { affiliateLink: _ }),
              (
                null ===
                  (r =
                    null === (n = null == s ? void 0 : s.baseData) ||
                    void 0 === n
                      ? void 0
                      : n.select) || void 0 === r
                  ? void 0
                  : r.microsites
              )
                ? (0, e.jsxs)(
                    mn,
                    _M(
                      { className: "ST_Main_Card" },
                      {
                        children: [
                          (0, e.jsx)(
                            qa,
                            _M(
                              { sx: [$o, A] },
                              {
                                children: (0, e.jsx)(
                                  ni,
                                  _M(
                                    { variant: Av, sx: Ko },
                                    { children: j("contact_Cart_Heading") }
                                  )
                                ),
                              }
                            )
                          ),
                          (0, e.jsx)(
                            ii,
                            _M(
                              { sx: _M(_M({}, D), { padding: 3 }) },
                              {
                                children: (0, e.jsxs)(
                                  qa,
                                  _M(
                                    {
                                      container: !0,
                                      spacing: 2,
                                      justifyContent: "space-evenly",
                                      alignItems: "center",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          qa,
                                          _M(
                                            { item: !0, xs: 12, md: 5 },
                                            {
                                              children: (0, e.jsxs)(
                                                ii,
                                                _M(
                                                  {
                                                    className:
                                                      "ST_CI_ContactCart",
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsxs)(
                                                        mn,
                                                        _M(
                                                          {
                                                            className:
                                                              "ST_CI_ContactCart_Header",
                                                          },
                                                          {
                                                            children: [
                                                              (0, e.jsxs)(
                                                                mn,
                                                                _M(
                                                                  {
                                                                    className:
                                                                      "ST_CI_AvetarBox",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        "input",
                                                                        {
                                                                          accept:
                                                                            "image/jpeg,image/gif,image/png",
                                                                          style:
                                                                            {
                                                                              display:
                                                                                "none",
                                                                            },
                                                                          disabled:
                                                                            i,
                                                                          id: "inputUploadFile",
                                                                          type: "file",
                                                                          ref: m,
                                                                          onChange:
                                                                            C,
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        "label",
                                                                        _M(
                                                                          {
                                                                            htmlFor:
                                                                              "inputUploadFile",
                                                                            style:
                                                                              {
                                                                                cursor:
                                                                                  "pointer",
                                                                              },
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                {
                                                                                  children:
                                                                                    d
                                                                                      ? (0,
                                                                                        e.jsx)(
                                                                                          e.Fragment,
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                zg,
                                                                                                _M(
                                                                                                  {
                                                                                                    overlap:
                                                                                                      "circular",
                                                                                                    anchorOrigin:
                                                                                                      {
                                                                                                        vertical:
                                                                                                          "bottom",
                                                                                                        horizontal:
                                                                                                          "right",
                                                                                                      },
                                                                                                    badgeContent:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "div",
                                                                                                        _M(
                                                                                                          {
                                                                                                            style:
                                                                                                              qo,
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                hM,
                                                                                                                {
                                                                                                                  className:
                                                                                                                    "ST_CI_Avetar_ImageColor",
                                                                                                                  fontSize:
                                                                                                                    "small",
                                                                                                                }
                                                                                                              ),
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        lb,
                                                                                                        {
                                                                                                          alt: "CSS",
                                                                                                          src: d,
                                                                                                          className:
                                                                                                            "ST_CI_Avetar",
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      : (0,
                                                                                        e.jsx)(
                                                                                          zg,
                                                                                          _M(
                                                                                            {
                                                                                              overlap:
                                                                                                "circular",
                                                                                              anchorOrigin:
                                                                                                {
                                                                                                  vertical:
                                                                                                    "bottom",
                                                                                                  horizontal:
                                                                                                    "right",
                                                                                                },
                                                                                              badgeContent:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  "div",
                                                                                                  _M(
                                                                                                    {
                                                                                                      style:
                                                                                                        qo,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        (0,
                                                                                                        e.jsx)(
                                                                                                          hM,
                                                                                                          {
                                                                                                            className:
                                                                                                              "ST_CI_Avetar_ImageColor",
                                                                                                            fontSize:
                                                                                                              "small",
                                                                                                          }
                                                                                                        ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  lb,
                                                                                                  {
                                                                                                    alt: "CSS",
                                                                                                    className:
                                                                                                      "ST_CI_Avetar",
                                                                                                  }
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                }
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        mn,
                                                                        _M(
                                                                          {
                                                                            sx: {
                                                                              ml: 2,
                                                                            },
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsxs)(
                                                                                ni,
                                                                                _M(
                                                                                  {
                                                                                    variant:
                                                                                      "h6",
                                                                                    className:
                                                                                      "ST_CI_TextFont ST_CI_TextColor",
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      [
                                                                                        null ==
                                                                                        E
                                                                                          ? void 0
                                                                                          : E.SalesRepName,
                                                                                        " ",
                                                                                        null ==
                                                                                        E
                                                                                          ? void 0
                                                                                          : E.SalesRepLastName,
                                                                                      ],
                                                                                  }
                                                                                )
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                              (0, e.jsx)(
                                                                mn,
                                                                _M(
                                                                  {
                                                                    sx: {
                                                                      marginTop: 1,
                                                                      display:
                                                                        "flex",
                                                                      justifyContent:
                                                                        "start",
                                                                    },
                                                                  },
                                                                  {
                                                                    children:
                                                                      v &&
                                                                      (0,
                                                                      e.jsx)(
                                                                        Ym,
                                                                        _M(
                                                                          {
                                                                            loading:
                                                                              g,
                                                                            disabled:
                                                                              !v,
                                                                            endIcon:
                                                                              (0,
                                                                              e.jsx)(
                                                                                fM,
                                                                                {}
                                                                              ),
                                                                            variant:
                                                                              "contained",
                                                                            style:
                                                                              {
                                                                                textTransform:
                                                                                  "capitalize",
                                                                              },
                                                                            onClick:
                                                                              x,
                                                                          },
                                                                          {
                                                                            children:
                                                                              f,
                                                                          }
                                                                        )
                                                                      ),
                                                                  }
                                                                )
                                                              ),
                                                              w &&
                                                                (0, e.jsx)(
                                                                  ni,
                                                                  _M(
                                                                    {
                                                                      variant:
                                                                        "body2",
                                                                      className:
                                                                        "ST_CI_Image_Error",
                                                                    },
                                                                    {
                                                                      children:
                                                                        P,
                                                                    }
                                                                  )
                                                                ),
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsxs)(cC, {
                                                        children: [
                                                          (0, e.jsx)(Hc, {
                                                            fullWidth: !0,
                                                            size: "small",
                                                            className:
                                                              "ST_CI_Card_TextBox",
                                                            multiline: !0,
                                                            inputProps: {
                                                              maxLength: T,
                                                            },
                                                            onChange: S,
                                                            value: h,
                                                            label:
                                                              j(
                                                                "yourBio_content3"
                                                              ),
                                                            rows: 4,
                                                          }),
                                                          (0, e.jsxs)(
                                                            ni,
                                                            _M(
                                                              {
                                                                className:
                                                                  "ST_CI_ContantLength",
                                                              },
                                                              {
                                                                children: [
                                                                  O &&
                                                                  (null == h
                                                                    ? void 0
                                                                    : h.length) <
                                                                    100
                                                                    ? O
                                                                    : 0,
                                                                  " ",
                                                                  j(
                                                                    "charsLeft"
                                                                  ),
                                                                ],
                                                              }
                                                            )
                                                          ),
                                                          (0, e.jsx)(
                                                            qa,
                                                            _M(
                                                              {
                                                                container: !0,
                                                                justifyContent:
                                                                  "flex-start",
                                                                sx: { mt: 3 },
                                                              },
                                                              {
                                                                children: (0,
                                                                e.jsx)(
                                                                  Ym,
                                                                  _M(
                                                                    {
                                                                      className:
                                                                        "ST_CI_SaveBtn",
                                                                      loading:
                                                                        y,
                                                                      disabled:
                                                                        l,
                                                                      loadingPosition:
                                                                        "center",
                                                                      variant:
                                                                        "contained",
                                                                      onClick:
                                                                        function () {
                                                                          return k(
                                                                            "contactCard"
                                                                          );
                                                                        },
                                                                    },
                                                                    {
                                                                      children:
                                                                        b,
                                                                    }
                                                                  )
                                                                ),
                                                              }
                                                            )
                                                          ),
                                                        ],
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                        (0, e.jsxs)(
                                          qa,
                                          _M(
                                            { item: !0, xs: 12, md: 5 },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  ni,
                                                  _M(
                                                    {
                                                      variant: "h6",
                                                      className:
                                                        "ST_CI_TextFont",
                                                    },
                                                    {
                                                      children: j(
                                                        "contact_Cart_Heading"
                                                      ),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  ni,
                                                  _M(
                                                    {
                                                      className:
                                                        "ST_CI_CartInfoText",
                                                      align: "justify",
                                                    },
                                                    {
                                                      children: j(
                                                        "ContactCard_Info_Msg"
                                                      ),
                                                    }
                                                  )
                                                ),
                                              ],
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  )
                : null,
              o(M, I),
            ],
          });
        },
        CM = function () {
          return (
            (CM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            CM.apply(this, arguments)
          );
        },
        xM = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        SM = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        kM = function () {
          return (
            (kM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            kM.apply(this, arguments)
          );
        };
      function PM() {
        var n = (function () {
            var e = this,
              n = (0, t.useState)(!1),
              r = n[0],
              o = n[1],
              a = (0, t.useState)(!1),
              i = a[0],
              s = a[1],
              l = (0, t.useState)({}),
              d = l[0],
              c = l[1],
              u = (0, t.useState)({
                companyId: "",
                companyName: "",
                locationId: "",
                locationName: "",
                customerEmail: "",
                customerId: "",
                customerName: "",
                shippingAddress: {},
                billingAddress: {},
              }),
              p = u[0],
              m = u[1],
              h = (0, t.useState)(),
              f = h[0],
              v = h[1],
              b = g(),
              _ = F.getState().salesRepData.baseData.repCompanies;
            return {
              handleSelectChange: function (e) {
                var t, n, r, o, a, i;
                try {
                  var s = e.target,
                    l = s.value,
                    c = s.name,
                    u =
                      null == d
                        ? void 0
                        : d.find(function (e) {
                            return (null == e ? void 0 : e.locationId) === l;
                          });
                  if ("locationAddress" === c && void 0 !== u)
                    m(
                      CM(CM({}, p), {
                        locationId: l,
                        locationName:
                          null !== (t = null == u ? void 0 : u.locationName) &&
                          void 0 !== t
                            ? t
                            : "",
                        shippingAddress:
                          null !==
                            (n = null == u ? void 0 : u.shippingAddress) &&
                          void 0 !== n
                            ? n
                            : "",
                        billingAddress:
                          null !==
                            (r = null == u ? void 0 : u.billingAddress) &&
                          void 0 !== r
                            ? r
                            : "",
                        customerId: "",
                      })
                    ),
                      v(null == u ? void 0 : u.customerDetails);
                  else {
                    var h =
                      null == f
                        ? void 0
                        : f.find(function (e) {
                            return (null == e ? void 0 : e.customerId) === l;
                          });
                    m(
                      CM(CM({}, p), {
                        customerId: l,
                        customerName: ""
                          .concat(
                            null !==
                              (o = null == h ? void 0 : h.customerFirstName) &&
                              void 0 !== o
                              ? o
                              : "",
                            " "
                          )
                          .concat(
                            null !==
                              (a = null == h ? void 0 : h.customerLastName) &&
                              void 0 !== a
                              ? a
                              : ""
                          )
                          .trim(),
                        customerEmail:
                          null !== (i = null == h ? void 0 : h.customerEmail) &&
                          void 0 !== i
                            ? i
                            : "",
                      })
                    );
                  }
                } catch (e) {
                  return;
                }
              },
              companyDetails: p,
              companytableHeaders: [
                "CreateOrder_Company",
                "Create_Order_TotalLocations",
                "Create_Order_MainContact",
              ],
              handleOpenSelectCustomerPopup: function (e, t) {
                try {
                  e
                    ? (c(null == t ? void 0 : t.assignedLocations),
                      m(
                        CM(CM({}, p), {
                          companyName: null == t ? void 0 : t.companyName,
                          companyId: null == t ? void 0 : t.companyId,
                        })
                      ),
                      o(!0))
                    : (m(
                        CM(CM({}, p), {
                          companyName: "",
                          locationName: "",
                          locationId: "",
                          companyId: "",
                          customerEmail: "",
                          customerName: "",
                          customerId: "",
                        })
                      ),
                      o(!1));
                } catch (e) {
                  return null;
                }
              },
              openSelectCustomerPopup: r,
              setOpenSelectCustomerPopup: o,
              saveDetailsFetchCatalog: function () {
                return xM(e, void 0, void 0, function () {
                  var e;
                  return SM(this, function (t) {
                    return (
                      s(!0),
                      (e = {
                        payload: p,
                        type: A.CUSTOMER_DETAILS_CREATE_INVOICE,
                      }),
                      b(e),
                      s(!1),
                      [2]
                    );
                  });
                });
              },
              saveDetailsLoadingFlag: i,
              companyData: _,
              selectedCompanyAddresses: d,
              customerDetailsForSelectedCompany: f,
            };
          })(),
          r = n.companytableHeaders,
          o = n.handleOpenSelectCustomerPopup,
          a = n.saveDetailsLoadingFlag,
          i = n.openSelectCustomerPopup,
          s = n.handleSelectChange,
          l = n.companyDetails,
          d = n.saveDetailsFetchCatalog,
          c = n.companyData,
          u = n.selectedCompanyAddresses,
          p = n.customerDetailsForSelectedCompany,
          m = ee().t;
        return (0, e.jsxs)(e.Fragment, {
          children: [
            (0, e.jsxs)(
              Im,
              kM(
                {
                  className: "ST_B2BShowInfo_Msg",
                  variant: "outlined",
                  severity: "info",
                },
                {
                  children: [
                    m("Beta_Version_msg1"),
                    ",",
                    "",
                    (0, e.jsxs)(
                      rl,
                      kM(
                        {
                          color: "inherit",
                          href: "mailto:support@chiefss.com",
                        },
                        { children: ["", " ", m("Beta_Version_msg2")] }
                      )
                    ),
                  ],
                }
              )
            ),
            (0, e.jsx)(
              qa,
              kM(
                { sx: { display: "flex", justifyContent: "space-between" } },
                {
                  children: (0, e.jsx)(
                    ni,
                    kM(
                      { variant: Av, sx: Ko },
                      { children: m("tab_CreateB2BOrder") }
                    )
                  ),
                }
              )
            ),
            (0, e.jsx)("br", {}),
            (0, e.jsxs)(e.Fragment, {
              children: [
                (0, e.jsx)(
                  qa,
                  kM(
                    { sx: $o },
                    {
                      children: (0, e.jsx)(
                        ni,
                        kM(
                          { variant: "body1", sx: { fontWeight: "600" } },
                          { children: m("b2b_select_company") }
                        )
                      ),
                    }
                  )
                ),
                (0, e.jsx)("br", {}),
                (0, e.jsx)(
                  ep,
                  kM(
                    { className: "ST_b2b_companyTable", sx: kM({}, Ho) },
                    {
                      children: (0, e.jsxs)(
                        sp,
                        kM(
                          { stickyHeader: !0 },
                          {
                            children: [
                              (0, e.jsx)(hp, {
                                children: (0, e.jsx)(Cp, {
                                  children:
                                    null == r
                                      ? void 0
                                      : r.map(function (t, n) {
                                          return (0,
                                          e.jsx)(Op, { children: (0, e.jsxs)("b", { children: [" ", m(t)] }) }, t + "_" + n);
                                        }),
                                }),
                              }),
                              (0, e.jsx)(Dp, {
                                children:
                                  (null == c ? void 0 : c.length) > 0
                                    ? null == c
                                      ? void 0
                                      : c.map(function (t, n) {
                                          var r, a;
                                          return (0, e.jsxs)(
                                            Cp,
                                            {
                                              children: [
                                                (0, e.jsx)(Op, {
                                                  children: (0, e.jsx)(
                                                    ni,
                                                    kM(
                                                      {
                                                        onClick: function () {
                                                          o(!0, t);
                                                        },
                                                        variant: "subtitle2",
                                                        className:
                                                          "ST_CompanyName_Color",
                                                      },
                                                      {
                                                        children:
                                                          null !==
                                                            (r =
                                                              null == t
                                                                ? void 0
                                                                : t.companyName) &&
                                                          void 0 !== r
                                                            ? r
                                                            : "-",
                                                      }
                                                    )
                                                  ),
                                                }),
                                                (0, e.jsx)(Op, {
                                                  children: (0, e.jsxs)(
                                                    ni,
                                                    kM(
                                                      { variant: "subtitle2" },
                                                      {
                                                        children: [
                                                          " ",
                                                          null !==
                                                            (a =
                                                              null == t
                                                                ? void 0
                                                                : t.assignedLocationCount) &&
                                                          void 0 !== a
                                                            ? a
                                                            : 0,
                                                          " ",
                                                        ],
                                                      }
                                                    )
                                                  ),
                                                }),
                                                (0, e.jsx)(Op, {
                                                  children: (0, e.jsx)(
                                                    ni,
                                                    kM(
                                                      { variant: "subtitle2" },
                                                      {
                                                        children:
                                                          (null == t
                                                            ? void 0
                                                            : t.locationMainContactName) &&
                                                          " " !==
                                                            (null == t
                                                              ? void 0
                                                              : t.locationMainContactName)
                                                            ? null == t
                                                              ? void 0
                                                              : t.locationMainContactName
                                                            : m(
                                                                "b2b_companyTable_noMainContact"
                                                              ),
                                                      }
                                                    )
                                                  ),
                                                }),
                                              ],
                                            },
                                            (null == t
                                              ? void 0
                                              : t.companyName) +
                                              "_" +
                                              n
                                          );
                                        })
                                    : (0, e.jsx)(Cp, {
                                        children: (0, e.jsx)(
                                          Op,
                                          kM(
                                            { align: "center", colSpan: 3 },
                                            {
                                              children: m(
                                                "b2b_no_company_data_available"
                                              ),
                                            }
                                          )
                                        ),
                                      }),
                              }),
                            ],
                          }
                        )
                      ),
                    }
                  )
                ),
              ],
            }),
            (0, e.jsx)(
              Hp,
              kM(
                {
                  open: i,
                  onClose: function () {
                    return o(!1);
                  },
                  fullWidth: !0,
                },
                {
                  children: (0, e.jsxs)(mn, {
                    children: [
                      (0, e.jsx)(
                        "div",
                        kM(
                          { style: { margin: "16px" } },
                          {
                            children: (0, e.jsxs)(
                              qa,
                              kM(
                                { container: !0, spacing: 2, mb: 2, pl: 2 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      qa,
                                      kM(
                                        { item: !0, xs: 10, md: 10 },
                                        {
                                          children: (0, e.jsx)("b", {
                                            children: m(
                                              "b2b_select_location_customer"
                                            ),
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(
                                      qa,
                                      kM(
                                        {
                                          item: !0,
                                          xs: 2,
                                          md: 2,
                                          sx: { textAlign: "right" },
                                          pr: 1,
                                        },
                                        {
                                          children: (0, e.jsx)(Fg, {
                                            sx: { cursor: "pointer" },
                                            onClick: function () {
                                              o(!1);
                                            },
                                          }),
                                        }
                                      )
                                    ),
                                  ],
                                }
                              )
                            ),
                          }
                        )
                      ),
                      (0, e.jsx)(Gt, { variant: "middle" }),
                      (0, e.jsx)(
                        Gp,
                        kM(
                          { sx: { padding: "0px" } },
                          {
                            children: (0, e.jsx)(
                              "div",
                              kM(
                                { style: { margin: "16px" } },
                                {
                                  children: (0, e.jsx)(
                                    qa,
                                    kM(
                                      { item: !0, xs: 6, md: 6 },
                                      {
                                        children: (0, e.jsxs)(
                                          qa,
                                          kM(
                                            {
                                              container: !0,
                                              spacing: {
                                                xs: 2,
                                                sm: 2,
                                                md: 2,
                                                lg: 2,
                                                xl: 2,
                                              },
                                              columnSpacing: {
                                                xs: 2,
                                                sm: 2,
                                                md: 2,
                                                lg: 2,
                                                xl: 2,
                                              },
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  qa,
                                                  kM(
                                                    {
                                                      item: !0,
                                                      xs: 12,
                                                      md: 12,
                                                      lg: 12,
                                                      xl: 12,
                                                    },
                                                    {
                                                      children: (0, e.jsxs)(
                                                        yd,
                                                        kM(
                                                          {
                                                            fullWidth: !0,
                                                            size: "small",
                                                          },
                                                          {
                                                            children: [
                                                              (0, e.jsx)(hd, {
                                                                children: m(
                                                                  "b2b_select_location"
                                                                ),
                                                              }),
                                                              (0, e.jsx)(
                                                                Rc,
                                                                kM(
                                                                  {
                                                                    fullWidth:
                                                                      !0,
                                                                    value:
                                                                      null == l
                                                                        ? void 0
                                                                        : l.locationId,
                                                                    name: "locationAddress",
                                                                    label: m(
                                                                      "b2b_select_location"
                                                                    ),
                                                                    onChange:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return s(
                                                                          e
                                                                        );
                                                                      },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (null == u
                                                                        ? void 0
                                                                        : u.length) >
                                                                      0
                                                                        ? null ==
                                                                          u
                                                                          ? void 0
                                                                          : u.map(
                                                                              function (
                                                                                t,
                                                                                n
                                                                              ) {
                                                                                return (0,
                                                                                e.jsx)(
                                                                                  J_,
                                                                                  kM(
                                                                                    {
                                                                                      sx: {
                                                                                        maxWidth:
                                                                                          "568px",
                                                                                        whiteSpace:
                                                                                          "pre-wrap",
                                                                                      },
                                                                                      value:
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.locationId,
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.locationName,
                                                                                    }
                                                                                  ),
                                                                                  n
                                                                                );
                                                                              }
                                                                            )
                                                                        : (0,
                                                                          e.jsx)(
                                                                            J_,
                                                                            kM(
                                                                              {
                                                                                value:
                                                                                  "",
                                                                              },
                                                                              {
                                                                                children:
                                                                                  (0,
                                                                                  e.jsx)(
                                                                                    "em",
                                                                                    kM(
                                                                                      {
                                                                                        style:
                                                                                          {
                                                                                            textAlign:
                                                                                              "center",
                                                                                          },
                                                                                      },
                                                                                      {
                                                                                        children:
                                                                                          m(
                                                                                            "b2b_no_location_data"
                                                                                          ),
                                                                                      }
                                                                                    )
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                  }
                                                                )
                                                              ),
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                                (0, e.jsx)(
                                                  qa,
                                                  kM(
                                                    {
                                                      item: !0,
                                                      xs: 12,
                                                      md: 12,
                                                      lg: 12,
                                                      xl: 12,
                                                    },
                                                    {
                                                      children: (0, e.jsxs)(
                                                        yd,
                                                        kM(
                                                          {
                                                            fullWidth: !0,
                                                            size: "small",
                                                          },
                                                          {
                                                            children: [
                                                              (0, e.jsx)(hd, {
                                                                children: m(
                                                                  "b2b_select_customer"
                                                                ),
                                                              }),
                                                              (0, e.jsx)(
                                                                Rc,
                                                                kM(
                                                                  {
                                                                    disabled:
                                                                      !(null ==
                                                                      l
                                                                        ? void 0
                                                                        : l.locationId),
                                                                    fullWidth:
                                                                      !0,
                                                                    value:
                                                                      null == l
                                                                        ? void 0
                                                                        : l.customerId,
                                                                    name: "customerName",
                                                                    label: m(
                                                                      "b2b_select_customer"
                                                                    ),
                                                                    onChange:
                                                                      function (
                                                                        e
                                                                      ) {
                                                                        return s(
                                                                          e
                                                                        );
                                                                      },
                                                                  },
                                                                  {
                                                                    children:
                                                                      (null == p
                                                                        ? void 0
                                                                        : p.length) >
                                                                      0
                                                                        ? null ==
                                                                          p
                                                                          ? void 0
                                                                          : p.map(
                                                                              function (
                                                                                t,
                                                                                n
                                                                              ) {
                                                                                return (0,
                                                                                e.jsx)(
                                                                                  J_,
                                                                                  kM(
                                                                                    {
                                                                                      value:
                                                                                        null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.customerId,
                                                                                    },
                                                                                    {
                                                                                      children:
                                                                                        (null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.customerFirstName) ||
                                                                                        (null ==
                                                                                        t
                                                                                          ? void 0
                                                                                          : t.customerLastName)
                                                                                          ? (null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.customerFirstName) +
                                                                                            " " +
                                                                                            (null ==
                                                                                            t
                                                                                              ? void 0
                                                                                              : t.customerLastName)
                                                                                          : null ==
                                                                                            t
                                                                                          ? void 0
                                                                                          : t.customerEmail,
                                                                                    }
                                                                                  ),
                                                                                  n
                                                                                );
                                                                              }
                                                                            )
                                                                        : (0,
                                                                          e.jsx)(
                                                                            "em",
                                                                            kM(
                                                                              {
                                                                                style:
                                                                                  {
                                                                                    textAlign:
                                                                                      "center",
                                                                                  },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  m(
                                                                                    "b2b_no_customer_data"
                                                                                  ),
                                                                              }
                                                                            )
                                                                          ),
                                                                  }
                                                                )
                                                              ),
                                                            ],
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                      (0, e.jsx)(Gt, { variant: "middle" }),
                      (0, e.jsx)(Jp, {
                        children: (0, e.jsx)(qa, {
                          children: (0, e.jsx)(
                            Ym,
                            kM(
                              {
                                disabled: !l.customerId || !l.locationId,
                                loading: a,
                                variant: "contained",
                                sx: { textTransform: "capitalize" },
                                onClick: d,
                              },
                              { children: m("CreateOrder_doneBtn") }
                            )
                          ),
                        }),
                      }),
                    ],
                  }),
                }
              )
            ),
          ],
        });
      }
      function wM() {
        var e = g(),
          n = ee().t,
          r = (0, t.useState)({}),
          o = r[0],
          a = r[1],
          i = (0, t.useState)(""),
          s = i[0],
          l = i[1],
          d = (0, t.useState)(""),
          c = d[0],
          u = d[1],
          p = (0, t.useState)(!1),
          m = p[0],
          h = p[1];
        (0, t.useEffect)(
          function () {
            var e, t;
            a(F.getState().salesRepData.customerDetailsCreateInvoice);
            var n =
                null ===
                  (e =
                    F.getState().salesRepData.customerDetailsCreateInvoice) ||
                void 0 === e
                  ? void 0
                  : e.shippingAddress,
              r =
                null ===
                  (t =
                    F.getState().salesRepData.customerDetailsCreateInvoice) ||
                void 0 === t
                  ? void 0
                  : t.billingAddress;
            l(f(n)), u(f(r));
          },
          [o]
        );
        var f = function (e) {
          var t;
          return e
            ? null === (t = null == Object ? void 0 : Object.values(e)) ||
              void 0 === t
              ? void 0
              : t
                  .filter(function (e) {
                    return null != e;
                  })
                  .join(" ")
            : "";
        };
        return {
          selectedCustomerDetails: o,
          removeSelectedCustomer: function () {
            try {
              var t = { payload: "", type: A.CUSTOMER_DETAILS_CREATE_INVOICE };
              e(t), a("");
            } catch (e) {
              return;
            }
          },
          shippingAddress: s,
          billingAddress: c,
          selectedCustDetails: [
            { label: n("b2b_companyName"), key: "companyName" },
            { label: n("b2b_customerName"), key: "customerName" },
            { label: n("b2b_emailId"), key: "customerEmail" },
          ],
          orderCreatedSuccesfullyFlag: m,
          setOrderCreatedSuccesfullyFlag: h,
        };
      }
      var OM = function () {
        return (
          (OM =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          OM.apply(this, arguments)
        );
      };
      function TM() {
        var t = ee().t,
          n = wM(),
          r = n.selectedCustomerDetails,
          o = n.removeSelectedCustomer,
          a = n.shippingAddress,
          i = n.billingAddress,
          s = n.selectedCustDetails,
          l = function (t, n) {
            return (0, e.jsx)(
              qa,
              OM(
                { item: !0, xs: 12, md: 12 },
                {
                  children: (0, e.jsxs)(
                    ni,
                    OM(
                      { sx: { maxWidth: "80%" }, variant: "body2" },
                      {
                        children: [
                          (0, e.jsx)("b", { children: t }),
                          " :",
                          (0, e.jsx)("br", {}),
                          n && (null == n ? void 0 : n.length) > 0
                            ? n
                            : "No ".concat(t),
                        ],
                      }
                    )
                  ),
                }
              )
            );
          };
        return (0, e.jsx)(
          mn,
          OM(
            { p: 1 },
            {
              children: (0, e.jsx)(
                oM,
                OM(
                  { className: "ST_CD_Card2Color" },
                  {
                    children: (0, e.jsxs)(mn, {
                      children: [
                        (0, e.jsxs)(
                          qa,
                          OM(
                            {
                              container: !0,
                              spacing: 3,
                              columnSpacing: 3,
                              alignItems: "center",
                              pb: 2,
                            },
                            {
                              children: [
                                (0, e.jsx)(
                                  qa,
                                  OM(
                                    { item: !0, xs: 9, md: 9 },
                                    {
                                      children: (0, e.jsx)("b", {
                                        children: t(
                                          "b2b_SelectedCompanyDetails"
                                        ),
                                      }),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  qa,
                                  OM(
                                    {
                                      item: !0,
                                      xs: 3,
                                      md: 3,
                                      sx: { textAlign: "right" },
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        Qu,
                                        OM(
                                          {
                                            sx: {
                                              textTransform: "capitalize",
                                              color: "#C55555",
                                              fontSize: "12px",
                                            },
                                            onClick: function () {
                                              o();
                                            },
                                          },
                                          {
                                            children: t(
                                              "b2b_removeSelectedCustomer"
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(Gt, { variant: "middle" }),
                        (0, e.jsxs)(
                          qa,
                          OM(
                            {
                              container: !0,
                              spacing: 3,
                              columnSpacing: 3,
                              pt: 2,
                            },
                            {
                              children: [
                                s &&
                                  (null == s
                                    ? void 0
                                    : s.map(function (t, n) {
                                        return (0,
                                        e.jsx)(qa, OM({ item: !0, xs: 12, md: 4 }, { children: (0, e.jsxs)(ni, OM({ variant: "body2" }, { children: [(0, e.jsx)("b", { children: t.label }), ": ", null == r ? void 0 : r[t.key]] })) }), n);
                                      })),
                                l(t("b2b_ShippingAddress"), a),
                                l(t("b2b_BillingAddress"), i),
                              ],
                            }
                          )
                        ),
                      ],
                    }),
                  }
                )
              ),
            }
          )
        );
      }
      var IM = function () {
          return (
            (IM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            IM.apply(this, arguments)
          );
        },
        MM = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        jM = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        NM = function (e, t, n) {
          if (n || 2 === arguments.length)
            for (var r, o = 0, a = t.length; o < a; o++)
              (!r && o in t) ||
                (r || (r = Array.prototype.slice.call(t, 0, o)), (r[o] = t[o]));
          return e.concat(r || Array.prototype.slice.call(t));
        };
      function DM() {
        var e,
          n,
          r,
          o,
          a,
          i,
          s = this,
          l = g(),
          d = ee().t,
          c = xv().debounce,
          u = rf().shopCurrency,
          p = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          m = (0, t.useState)(""),
          h = m[0],
          f = m[1],
          v = (0, t.useState)(!1),
          b = v[0],
          _ = v[1],
          C = (0, t.useState)(!1),
          x = C[0],
          S = C[1],
          k = (0, t.useState)(""),
          P = k[0],
          w = k[1],
          O = (0, t.useState)(""),
          T = O[0],
          I = O[1],
          M = (0, t.useState)(!1),
          j = M[0],
          N = M[1],
          D = (0, t.useState)([]),
          E = D[0],
          R = D[1],
          L = (0, t.useState)([]),
          B = L[0],
          z = L[1],
          Z = (0, t.useState)([]),
          H = Z[0],
          V = Z[1],
          W = (0, t.useState)([]),
          U = W[0],
          $ = W[1],
          K = (0, t.useState)({}),
          G = K[0],
          q = K[1],
          Q = (0, t.useState)(0),
          Y = Q[0],
          J = Q[1],
          X = (0, t.useState)([]),
          te = X[0],
          ne = X[1],
          re = (0, t.useState)(!1),
          oe = re[0],
          ae = re[1],
          ie =
            null ===
              (e = F.getState().salesRepData.customerDetailsCreateInvoice) ||
            void 0 === e
              ? void 0
              : e.locationId,
          se = (0, t.useState)(),
          le = se[0],
          de = se[1],
          ce =
            null === (n = null == p ? void 0 : p.editDraftOrder) || void 0 === n
              ? void 0
              : n.isUpdatedCart,
          ue =
            null !==
              (r = y(function () {
                return F.getState().salesRepData.createOrderTab;
              })) && void 0 !== r
              ? r
              : {},
          pe = (0, t.useState)({ msg: "", open: !1, severity: "error" }),
          me = pe[0],
          he = pe[1],
          fe = (0, t.useState)({}),
          ge = fe[0],
          ve = fe[1],
          be =
            null === (o = F.getState().salesRepData.baseData) || void 0 === o
              ? void 0
              : o.storefrontAccessToken,
          _e =
            null !==
              (a = y(function () {
                var e, t;
                return null ===
                  (t =
                    null === (e = F.getState()) || void 0 === e
                      ? void 0
                      : e.salesRepData) || void 0 === t
                  ? void 0
                  : t.locationPricelistData;
              })) && void 0 !== a
              ? a
              : {},
          ye = null === (i = _e[ie]) || void 0 === i ? void 0 : i.priceList,
          Ce = (0, t.useState)([]),
          xe = Ce[0],
          Se = Ce[1],
          ke = (0, t.useState)(!1),
          Pe = ke[0],
          we = ke[1],
          Oe = (0, t.useState)(!1),
          Te = Oe[0],
          Ie = Oe[1],
          Me = (0, t.useState)(!1),
          je = Me[0],
          Ne = Me[1],
          De = 0,
          Ae = (0, t.useRef)(null),
          Ee = function (e, t, n) {
            return MM(s, void 0, void 0, function () {
              var r, o, a, i, s, c, u, p, m, h, f, g;
              return jM(this, function (v) {
                switch (v.label) {
                  case 0:
                    switch (t) {
                      case "add.js":
                        return [3, 1];
                      case "update.js":
                        return [3, 3];
                      case "change.js":
                        return [3, 4];
                      case "clear.js":
                        return [3, 5];
                    }
                    return [3, 6];
                  case 1:
                    return [4, l(Ig())];
                  case 2:
                    return (
                      (o = v.sent()),
                      (a =
                        null ===
                          (p =
                            null === (u = null == o ? void 0 : o.data) ||
                            void 0 === u
                              ? void 0
                              : u.items) || void 0 === p
                          ? void 0
                          : p.map(function (e) {
                              return null == e ? void 0 : e.variant_id;
                            })),
                      (i = new Set(a)),
                      (r =
                        null == e
                          ? void 0
                          : e.reduce(function (e, t) {
                              var n,
                                r = Number(
                                  null ===
                                    (n = null == t ? void 0 : t.variantId) ||
                                    void 0 === n
                                    ? void 0
                                    : n.split(
                                        "gid://shopify/ProductVariant/"
                                      )[1]
                                );
                              return (
                                (null == i ? void 0 : i.has(r)) ||
                                  e.push({
                                    id: r,
                                    quantity:
                                      (null == t ? void 0 : t.quantity) || 1,
                                  }),
                                e
                              );
                            }, [])),
                      [3, 7]
                    );
                  case 3:
                    return (r = n), [3, 7];
                  case 4:
                    return (
                      (s = Number(
                        null === (m = null == n ? void 0 : n.variantId) ||
                          void 0 === m
                          ? void 0
                          : m.split("gid://shopify/ProductVariant/")[1]
                      )),
                      (r = {
                        id: null == s ? void 0 : s.toString(),
                        quantity: null == n ? void 0 : n.quantity,
                      }),
                      [3, 7]
                    );
                  case 5:
                    return (r = {}), [3, 7];
                  case 6:
                    (r = {}), (v.label = 7);
                  case 7:
                    if (
                      (Bh.next(!0),
                      !(
                        (r &&
                          (null === (h = Object.keys(r)) || void 0 === h
                            ? void 0
                            : h.length) > 0) ||
                        "clear.js" === t
                      ))
                    )
                      return [3, 11];
                    v.label = 8;
                  case 8:
                    return v.trys.push([8, 10, , 11]), [4, l(Og(r, t))];
                  case 9:
                    return (
                      (c = v.sent()),
                      Bh.next(!1),
                      "boolean" == typeof c && c
                        ? [2, !0]
                        : ((
                            null ===
                              (f = null == c ? void 0 : c.toLowerCase()) ||
                            void 0 === f
                              ? void 0
                              : f.includes("can't add more")
                          )
                            ? he({
                                msg: d("createOrder_ErrorMsgForQuantityLimit"),
                                open: !0,
                              })
                            : (
                                null ===
                                  (g = null == c ? void 0 : c.toLowerCase()) ||
                                void 0 === g
                                  ? void 0
                                  : g.includes("cannot find")
                              )
                            ? he({
                                msg: d("ST_Producttable_CartResponse"),
                                open: !0,
                              })
                            : he({ msg: c, open: !0 }),
                          [2, !1])
                    );
                  case 10:
                    return v.sent(), [2, !1];
                  case 11:
                    return Bh.next(!1), [2];
                }
              });
            });
          },
          Re = (0, t.useCallback)(c(Ee, 600), []);
        (0, t.useEffect)(function () {
          ce || Qe();
        }, []),
          (0, t.useEffect)(
            function () {
              ne(B);
            },
            [oe]
          ),
          (0, t.useEffect)(
            function () {
              b || ((De = Ze(G)), J(De));
            },
            [G, te]
          ),
          (0, t.useEffect)(
            function () {
              ne([]),
                ne(function (e) {
                  var t = NM(NM([], e, !0), B, !0);
                  return Re(U, "add.js", t), t;
                });
            },
            [B, Re]
          ),
          (0, t.useEffect)(
            function () {
              var e, t;
              G &&
                (null === (e = Object.keys(G)) || void 0 === e
                  ? void 0
                  : e.length) > 0 &&
                (null === (t = Object.keys(G)) ||
                  void 0 === t ||
                  t.forEach(function (e) {
                    var t = U.find(function (t) {
                      return e === (null == t ? void 0 : t.variantId);
                    });
                    !(function (e, t) {
                      var n = Le(e, t);
                      if (n && null != n) {
                        var r = n.variantMinQuantity,
                          o = n.updatedVariantSubTotal,
                          a = n.B2BCatalogPrice || t;
                        q(function (t) {
                          var n;
                          return IM(
                            IM({}, t),
                            (((n = {})[e] = IM(IM({}, t[e]), {
                              price: a,
                              quantity: r,
                              subtotal: o,
                              QuantityPriceBreaks: We(e),
                              QuantityRule: $e(e),
                            })),
                            n)
                          );
                        });
                      }
                    })(e, null == t ? void 0 : t.variantPrice);
                  }));
            },
            [ue]
          ),
          (0, t.useEffect)(
            function () {
              He();
            },
            [G, ge]
          );
        var Le = function (e, t) {
            var n, r;
            if (
              _e &&
              (null === (n = Object.keys(_e)) || void 0 === n
                ? void 0
                : n.length) > 0
            ) {
              var o =
                  (null === (r = G[e]) || void 0 === r ? void 0 : r.quantity) ||
                  1,
                a = Number(o) * t,
                i = We(e),
                s = $e(e),
                l = Ue(e);
              return (
                null != s && (o = Ke(s, o)),
                i && (null == i ? void 0 : i.length) > 0 && (a = Ge(o, i, a)),
                {
                  variantMinQuantity: o,
                  updatedVariantSubTotal: a,
                  B2BCatalogPrice: l,
                }
              );
            }
            return null;
          },
          Be = function (e) {
            return MM(s, void 0, void 0, function () {
              var t, n, r, o, a, i, s, l, d, c, u, p, m;
              return jM(this, function (f) {
                switch (f.label) {
                  case 0:
                    return (
                      f.trys.push([0, 2, , 3]),
                      N(!0),
                      (t =
                        (null === (d = F.getState().salesRepData) ||
                        void 0 === d
                          ? void 0
                          : d.locationPricelistData) || {}),
                      (n =
                        null === (c = t[e]) || void 0 === c
                          ? void 0
                          : c.companyLocationCatalogCursorDetails),
                      (r =
                        null === (u = t[e]) || void 0 === u
                          ? void 0
                          : u.priceList),
                      (o = r
                        ? Array.from(
                            new Set(
                              null === (p = Object.values(r)) || void 0 === p
                                ? void 0
                                : p.map(function (e) {
                                    return null == e ? void 0 : e.productId;
                                  })
                            )
                          )
                        : []),
                      [4, Wf(h, be, "", "", void 0, o)]
                    );
                  case 1:
                    return (
                      (a = f.sent()),
                      (i = a.products),
                      (s = void 0 === i ? [] : i),
                      a.pageInfo,
                      (l = NM(
                        NM([], E, !0),
                        null == s
                          ? void 0
                          : s.filter(function (e) {
                              return !E.some(function (t) {
                                return t.productId === e.productId;
                              });
                            }),
                        !0
                      )),
                      _e &&
                        (null === (m = Object.keys(_e)) || void 0 === m
                          ? void 0
                          : m.length) > 0 &&
                        Fe(l),
                      n &&
                        de(function (e) {
                          return IM(IM({}, e), {
                            endCursor:
                              (null == n ? void 0 : n.ProductsEndCursor) || "",
                            quantityEndCursor:
                              (null == n ? void 0 : n.QuantityEndCursor) || "",
                            pricesEndCursor:
                              (null == n ? void 0 : n.PricesEndCursor) || "",
                          });
                        }),
                      N(!1),
                      [2, l]
                    );
                  case 2:
                    return f.sent(), N(!1), [2, []];
                  case 3:
                    return [2];
                }
              });
            });
          },
          ze = (0, t.useCallback)(
            c(function (e, t, n, r) {
              return MM(s, void 0, void 0, function () {
                var o, a, i, d, c, u, p, m, h, f, g, v, b;
                return jM(this, function (_) {
                  switch (_.label) {
                    case 0:
                      if (
                        (_.trys.push([0, 9, , 10]),
                        !(
                          (null == (e = null == e ? void 0 : e.trim())
                            ? void 0
                            : e.length) > 2
                        ))
                      )
                        return [3, 7];
                      N(!0),
                        (o =
                          (null === (g = F.getState().salesRepData) ||
                          void 0 === g
                            ? void 0
                            : g.locationPricelistData) || {}),
                        (a =
                          null === (v = o[ie]) || void 0 === v
                            ? void 0
                            : v.companyLocationCatalogCursorDetails),
                        (i = []),
                        (d = !0),
                        (c = n),
                        (_.label = 1);
                    case 1:
                      return d && (null == i ? void 0 : i.length) < 30
                        ? [
                            4,
                            Wf("" === r ? r : e, be, t, c).then(function (e) {
                              return e;
                            }),
                          ]
                        : [3, 3];
                    case 2:
                      return (
                        (u = _.sent()),
                        (p = u.products),
                        (m = u.pageInfo),
                        (i = NM(NM([], i, !0), p, !0)),
                        (d =
                          (null == m ? void 0 : m.hasNextPage) &&
                          (null == m ? void 0 : m.endCursor) !== c),
                        (c = null == m ? void 0 : m.endCur),
                        [3, 1]
                      );
                    case 3:
                      return o &&
                        (null === (b = Object.keys(o)) || void 0 === b
                          ? void 0
                          : b.length) > 0
                        ? ((h =
                            null == i
                              ? void 0
                              : i.map(function (e) {
                                  var t;
                                  return null ===
                                    (t = null == e ? void 0 : e.productId) ||
                                    void 0 === t
                                    ? void 0
                                    : t.replace("gid://shopify/Product/", "");
                                })),
                          R([]),
                          h && (null == h ? void 0 : h.length) > 0
                            ? (Se(h),
                              Ne(!1),
                              (a = IM(IM({}, a), { SearchedProductIds: h })),
                              (f = JSON.stringify(a)),
                              [4, l(Mg(ie, f, !0, !1))])
                            : [3, 5])
                        : [3, 6];
                    case 4:
                      return (
                        _.sent(),
                        (function (e, t) {
                          MM(s, void 0, void 0, function () {
                            var n, r, o, a, i, s, l, d, c;
                            return jM(this, function (u) {
                              return (
                                (n =
                                  (null === (s = F.getState().salesRepData) ||
                                  void 0 === s
                                    ? void 0
                                    : s.locationPricelistData) || {}),
                                (r =
                                  null === (l = n[e]) || void 0 === l
                                    ? void 0
                                    : l.companyLocationCatalogCursorDetails),
                                (o =
                                  null === (d = n[ie]) || void 0 === d
                                    ? void 0
                                    : d.priceList),
                                (a = o
                                  ? Array.from(
                                      new Set(
                                        null === (c = Object.values(o)) ||
                                        void 0 === c
                                          ? void 0
                                          : c.map(function (e) {
                                              return null == e
                                                ? void 0
                                                : e.productId;
                                            })
                                      )
                                    )
                                  : []),
                                (i = t.filter(function (e) {
                                  return null == a
                                    ? void 0
                                    : a.includes(
                                        null == e ? void 0 : e.productId
                                      );
                                })),
                                Fe(i),
                                R(i),
                                r &&
                                  de(function (e) {
                                    return IM(IM({}, e), {
                                      SearchPricesEndCursor:
                                        null == r
                                          ? void 0
                                          : r.SearchPricesEndCursor,
                                    });
                                  }),
                                [2]
                              );
                            });
                          });
                        })(ie, i),
                        [3, 6]
                      );
                    case 5:
                      Se([]), (_.label = 6);
                    case 6:
                      return N(!1), [3, 8];
                    case 7:
                      Se([]), (_.label = 8);
                    case 8:
                      return [3, 10];
                    case 9:
                      return _.sent(), N(!1), [2, []];
                    case 10:
                      return [2];
                  }
                });
              });
            }, 1e3),
            []
          ),
          Fe = function (e) {
            var t,
              n,
              r = null === (t = _e[ie]) || void 0 === t ? void 0 : t.priceList;
            return (
              e &&
              (null ===
                (n =
                  null == e
                    ? void 0
                    : e.filter(function (e) {
                        return (
                          r &&
                          Object.values(r).some(function (t) {
                            return (
                              (null == t ? void 0 : t.productId) ===
                              (null == e ? void 0 : e.productId)
                            );
                          })
                        );
                      })) || void 0 === n
                ? void 0
                : n.map(function (e) {
                    var t;
                    return IM(IM({}, e), {
                      variants:
                        null === (t = null == e ? void 0 : e.variants) ||
                        void 0 === t
                          ? void 0
                          : t.map(function (e) {
                              var t,
                                n =
                                  null ===
                                    (t = null == r ? void 0 : r[e.variantId]) ||
                                  void 0 === t
                                    ? void 0
                                    : t.price;
                              return IM(IM({}, e), {
                                variantPrice:
                                  n || (null == e ? void 0 : e.variantPrice),
                              });
                            }),
                    });
                  }))
            );
          },
          Ze = function (e) {
            var t =
              null == U
                ? void 0
                : U.reduce(function (t, n) {
                    var r,
                      o,
                      a,
                      i,
                      s,
                      l,
                      d =
                        (null === (r = e[null == n ? void 0 : n.variantId]) ||
                        void 0 === r
                          ? void 0
                          : r.quantity) || 1,
                      c =
                        (null ===
                          (o =
                            null == ye
                              ? void 0
                              : ye[null == n ? void 0 : n.variantId]) ||
                        void 0 === o
                          ? void 0
                          : o.price) ||
                        (null === (a = G[null == n ? void 0 : n.variantId]) ||
                        void 0 === a
                          ? void 0
                          : a.price) ||
                        (null == n ? void 0 : n.variantPrice);
                    if (
                      _e &&
                      (null === (i = Object.keys(_e)) || void 0 === i
                        ? void 0
                        : i.length) > 0
                    ) {
                      var u =
                          (null ===
                            (s =
                              null == ye
                                ? void 0
                                : ye[null == n ? void 0 : n.variantId]) ||
                          void 0 === s
                            ? void 0
                            : s.price) ||
                          (null === (l = G[null == n ? void 0 : n.variantId]) ||
                          void 0 === l
                            ? void 0
                            : l.price),
                        p = $e(null == n ? void 0 : n.variantId),
                        m = We(null == n ? void 0 : n.variantId);
                      if (
                        (p &&
                          (null == p ? void 0 : p.Minimum) &&
                          (null == p ? void 0 : p.Minimum) === d &&
                          u &&
                          (c = u),
                        m && (null == m ? void 0 : m.length) > 0)
                      ) {
                        m.sort(function (e, t) {
                          return (
                            (null == t ? void 0 : t.MinimumQuantity) -
                            (null == e ? void 0 : e.MinimumQuantity)
                          );
                        });
                        for (var h = 0, f = m; h < f.length; h++) {
                          var g = f[h];
                          if (d >= (null == g ? void 0 : g.MinimumQuantity)) {
                            c = null == g ? void 0 : g.Price;
                            break;
                          }
                        }
                      }
                    }
                    return t + c * d;
                  }, 0);
            return t;
          },
          He = function () {
            $(function (e) {
              var t =
                  null == e
                    ? void 0
                    : e.map(function (e) {
                        var t,
                          n,
                          r =
                            (null ===
                              (t = G[null == e ? void 0 : e.variantId]) ||
                            void 0 === t
                              ? void 0
                              : t.quantity) || 1;
                        if (
                          _e &&
                          (null === (n = Object.keys(_e)) || void 0 === n
                            ? void 0
                            : n.length) > 0
                        ) {
                          var o = $e(null == e ? void 0 : e.variantId);
                          null != o && (r = Ke(o, r));
                        }
                        return IM(IM({}, e), { quantity: r });
                      }),
                n = {
                  payload: { selectedProductData: t, isQuantityError: ge },
                  type: A.PRODUCT_TABLE_DATA,
                };
              return l(n), t;
            });
          };
        function Ve(e, t, n, r, o) {
          var a, i;
          return (
            void 0 === o && (o = ""),
            MM(this, void 0, void 0, function () {
              var s, l, c, u, p, m, h, f, g, v, b, _, y, C, x, S, k;
              return jM(this, function (P) {
                switch (P.label) {
                  case 0:
                    (s =
                      null !==
                        (i =
                          _e &&
                          (null === (a = Object.keys(_e)) || void 0 === a
                            ? void 0
                            : a.length) > 0) &&
                      void 0 !== i &&
                      i),
                      (P.label = 1);
                  case 1:
                    return (
                      P.trys.push([1, 7, , 8]),
                      s
                        ? ((l = $e(t)),
                          (c = (null == l ? void 0 : l.Minimum)
                            ? null == l
                              ? void 0
                              : l.Minimum
                            : 0),
                          (u = (null == l ? void 0 : l.Maximum)
                            ? null == l
                              ? void 0
                              : l.Maximum
                            : null),
                          (p = (null == l ? void 0 : l.Increment)
                            ? null == l
                              ? void 0
                              : l.Increment
                            : null),
                          (m =
                            Number(e) >= c && (null === u || Number(e) <= u)),
                          (h = null === p || Number(e) % p == 0),
                          "" !== e && "0" !== e && m && h
                            ? ((f = We(t)),
                              (v = 1),
                              (b = null),
                              (_ = 1),
                              (y = {}),
                              ve(function (e) {
                                var n;
                                return IM(IM({}, e), (((n = {})[t] = !1), n));
                              }),
                              (C = function () {
                                var o,
                                  a,
                                  i,
                                  s = G[t],
                                  d = null == s ? void 0 : s.quantity,
                                  c =
                                    (null ===
                                      (a = null == ye ? void 0 : ye[t]) ||
                                    void 0 === a
                                      ? void 0
                                      : a.price) ||
                                    (null === (i = G[t]) || void 0 === i
                                      ? void 0
                                      : i.price) ||
                                    n,
                                  u = null == s ? void 0 : s.quantity;
                                if (
                                  (l &&
                                    ((v = null == l ? void 0 : l.Minimum),
                                    (b = null == l ? void 0 : l.Maximum),
                                    (_ = null == l ? void 0 : l.Increment)),
                                  "increaseQty" === r)
                                )
                                  u = b
                                    ? Math.min(Number(d) + _, b)
                                    : Number(d) + _;
                                else if ("decreaseQty" === r)
                                  u = Math.max(Number(d) - _, v);
                                else {
                                  var p = Math.max(Number(e), v);
                                  u = b ? Math.min(p, b) : p;
                                }
                                (g = Number(u) * c),
                                  f &&
                                    (null == f ? void 0 : f.length) > 0 &&
                                    (g = Ge(u, f, g));
                                var m = IM(
                                  IM({}, G),
                                  (((o = {})[t] = {
                                    price: c,
                                    quantity: u,
                                    subtotal: g,
                                    QuantityPriceBreaks: f,
                                    QuantityRule: l,
                                  }),
                                  o)
                                );
                                return (y = { variantId: t, quantity: u }), m;
                              }),
                              (x = C()),
                              "isReadCartData" === o
                                ? [3, 3]
                                : [4, Ee({}, "change.js", y)])
                            : [3, 5])
                        : [3, 6]
                    );
                  case 2:
                    return (S = P.sent()), [3, 4];
                  case 3:
                    (S = !0), (P.label = 4);
                  case 4:
                    return (
                      S &&
                        q(function (e) {
                          return IM(IM({}, e), x);
                        }),
                      [3, 6]
                    );
                  case 5:
                    return (
                      he(
                        0 != c || null != u
                          ? { msg: d("B2B_QtyRule_Error_Msg"), open: !0 }
                          : { msg: d("productTable_error_AlertMsg"), open: !0 }
                      ),
                      ve(IM(IM({}, ge), (((k = {})[t] = !0), k))),
                      q(function (n) {
                        var r;
                        return IM(
                          IM({}, n),
                          (((r = {})[t] = IM(IM({}, n[t]), {
                            quantity: e,
                            subtotal: 0,
                          })),
                          r)
                        );
                      }),
                      [2]
                    );
                  case 6:
                    return [3, 8];
                  case 7:
                    return P.sent(), [2];
                  case 8:
                    return [2];
                }
              });
            })
          );
        }
        var We = function (e) {
            var t,
              n,
              r,
              o,
              a =
                null ===
                  (n = ((null === (t = F.getState().salesRepData) ||
                  void 0 === t
                    ? void 0
                    : t.locationPricelistData) || {})[ie]) || void 0 === n
                  ? void 0
                  : n.priceList;
            return (
              (null === (r = null == a ? void 0 : a[e]) || void 0 === r
                ? void 0
                : r.QuantityPriceBreaks) ||
              (null === (o = G[e]) || void 0 === o
                ? void 0
                : o.QuantityPriceBreaks) ||
              []
            );
          },
          Ue = function (e) {
            var t,
              n,
              r,
              o,
              a =
                null ===
                  (n = ((null === (t = F.getState().salesRepData) ||
                  void 0 === t
                    ? void 0
                    : t.locationPricelistData) || {})[ie]) || void 0 === n
                  ? void 0
                  : n.priceList;
            return (
              (null === (r = null == a ? void 0 : a[e]) || void 0 === r
                ? void 0
                : r.price) ||
              (null === (o = G[e]) || void 0 === o ? void 0 : o.price) ||
              0
            );
          },
          $e = function (e) {
            var t,
              n,
              r,
              o,
              a =
                null ===
                  (n = ((null === (t = F.getState().salesRepData) ||
                  void 0 === t
                    ? void 0
                    : t.locationPricelistData) || {})[ie]) || void 0 === n
                  ? void 0
                  : n.priceList;
            return (
              (null === (r = null == a ? void 0 : a[e]) || void 0 === r
                ? void 0
                : r.QuantityRule) ||
              (null === (o = G[e]) || void 0 === o ? void 0 : o.QuantityRule) ||
              null
            );
          },
          Ke = function (e, t) {
            return (
              e &&
                (null == e ? void 0 : e.Minimum) &&
                t < (null == e ? void 0 : e.Minimum) &&
                (t = null == e ? void 0 : e.Minimum),
              t
            );
          },
          Ge = function (e, t, n) {
            if (t && (null == t ? void 0 : t.length) > 0) {
              t.sort(function (e, t) {
                return t.MinimumQuantity - e.MinimumQuantity;
              });
              for (var r = 0, o = t; r < o.length; r++) {
                var a = o[r];
                if (e >= (null == a ? void 0 : a.MinimumQuantity)) {
                  n = Number(e) * (null == a ? void 0 : a.Price);
                  break;
                }
              }
            }
            return n;
          },
          qe = function (e, t) {
            var n, r, o;
            if (
              _e &&
              (null === (n = Object.keys(_e)) || void 0 === n
                ? void 0
                : n.length) > 0
            ) {
              var a =
                null ===
                  (o = ((null === (r = F.getState().salesRepData) ||
                  void 0 === r
                    ? void 0
                    : r.locationPricelistData) || {})[ie]) || void 0 === o
                  ? void 0
                  : o.priceList;
              null == t ||
                t.forEach(function (t) {
                  var n,
                    r,
                    o = null == t ? void 0 : t.variantId,
                    i =
                      (null === (n = null == a ? void 0 : a[o]) || void 0 === n
                        ? void 0
                        : n.price) ||
                      (null === (r = e[o]) || void 0 === r
                        ? void 0
                        : r.price) ||
                      (null == t ? void 0 : t.variantPrice),
                    s = 1;
                  if ((null == a ? void 0 : a[o]) || e[o]) {
                    var l = $e(o),
                      d = We(o);
                    null != l && (s = Ke(l, s)),
                      (e[o] = {
                        price: i,
                        quantity: s,
                        subtotal: Number(s) * i,
                        QuantityPriceBreaks: d,
                        QuantityRule: l,
                      });
                  }
                });
            }
            return e;
          },
          Qe = function () {
            return MM(s, void 0, void 0, function () {
              var e, t, n, r, o, a, i;
              return jM(this, function (s) {
                switch (s.label) {
                  case 0:
                    return (
                      Bh.next(!0),
                      _e &&
                      (null === (r = Object.keys(_e)) || void 0 === r
                        ? void 0
                        : r.length) > 0
                        ? [4, l(Ig())]
                        : [3, 2]
                    );
                  case 1:
                    200 === (null == (e = s.sent()) ? void 0 : e.status) &&
                      (null ===
                        (a =
                          null === (o = null == e ? void 0 : e.data) ||
                          void 0 === o
                            ? void 0
                            : o.items) || void 0 === a
                        ? void 0
                        : a.length) > 0 &&
                      (N(!0),
                      (t = Ye(
                        null === (i = null == e ? void 0 : e.data) ||
                          void 0 === i
                          ? void 0
                          : i.items
                      )),
                      ne(t),
                      z(t),
                      (n =
                        null == t
                          ? void 0
                          : t.map(function (e) {
                              return e.productId;
                            })),
                      V(n),
                      He()),
                      Bh.next(!1),
                      N(!1),
                      (s.label = 2);
                  case 2:
                    return [2];
                }
              });
            });
          },
          Ye = function (e) {
            var t = [],
              n = [],
              r = 0,
              o = 0;
            null == e ||
              e.forEach(function (e) {
                var a,
                  i,
                  s,
                  l =
                    "gid://shopify/ProductVariant/" +
                    (null == e ? void 0 : e.variant_id);
                _e &&
                  (null === (a = Object.keys(_e)) || void 0 === a
                    ? void 0
                    : a.length) > 0 &&
                  (null == ye ? void 0 : ye[l]) &&
                  ((r = (function (e, t) {
                    var n,
                      r,
                      o =
                        (null === (n = null == ye ? void 0 : ye[t]) ||
                        void 0 === n
                          ? void 0
                          : n.price) ||
                        (null === (r = G[null == e ? void 0 : e.variantId]) ||
                        void 0 === r
                          ? void 0
                          : r.price),
                      a = We(t),
                      i = null == e ? void 0 : e.quantity,
                      s = o || 1;
                    if (a && (null == a ? void 0 : a.length) > 0) {
                      a.sort(function (e, t) {
                        return t.MinimumQuantity - e.MinimumQuantity;
                      });
                      for (var l = 0, d = a; l < d.length; l++) {
                        var c = d[l];
                        if (i >= c.MinimumQuantity) {
                          s = null == c ? void 0 : c.Price;
                          break;
                        }
                      }
                    }
                    return s;
                  })(e, l)),
                  (o = (function (e, t) {
                    var n = null == e ? void 0 : e.quantity,
                      r = $e(t);
                    if (r) {
                      var o = null == r ? void 0 : r.Increment;
                      n % o != 0 && (n += o - (n % o));
                    }
                    return n;
                  })(e, l)));
                var d = t.findIndex(function (t) {
                    return (
                      t.productId === "gid://shopify/Product/" + e.product_id
                    );
                  }),
                  c = {
                    variantId: l,
                    variantPrice: 0 != r ? r : e.final_price / 100,
                    imageUrl:
                      (null === (i = null == e ? void 0 : e.featured_image) ||
                      void 0 === i
                        ? void 0
                        : i.url) || "",
                    currency: u,
                    inventoryQuantity: null == e ? void 0 : e.quantity,
                    sku: null == e ? void 0 : e.sku,
                    title: e.variant_title || "Default Title",
                    quantityAvailable: "NA",
                    availableForSale: !0,
                    quantity: 0 != o ? o : null == e ? void 0 : e.quantity,
                    wholesalePrice: e.final_price / 100,
                  };
                if (-1 !== d) t[d].variants.push(c);
                else {
                  var p = {
                    productId: "gid://shopify/Product/" + e.product_id,
                    title: e.title,
                    variants: [c],
                    imageUrl:
                      (null === (s = e.featured_image) || void 0 === s
                        ? void 0
                        : s.url) || null,
                  };
                  t.push(p);
                }
                n.push(c);
              });
            var a = Fe(t);
            return (
              $(function (e) {
                return NM(NM([], e, !0), n, !0);
              }),
              z(a),
              null == n ||
                n.forEach(function (e) {
                  var t;
                  if (
                    _e &&
                    (null === (t = Object.keys(_e)) || void 0 === t
                      ? void 0
                      : t.length) > 0
                  ) {
                    var n = (null == e ? void 0 : e.quantity) || 1,
                      r = null == e ? void 0 : e.variantId,
                      o = null == e ? void 0 : e.variantPrice,
                      a = $e(r);
                    null != a && (n = Ke(a, n)),
                      Ve(n, r, o, "manual", "isReadCartData");
                  }
                }),
              a
            );
          };
        return {
          totalOrderAmount: Y,
          handleSearchProductData: Be,
          makeFieldsEmpty: function () {
            return MM(s, void 0, void 0, function () {
              return jM(this, function (e) {
                return (
                  f(""),
                  Se([]),
                  "" != h &&
                    (R([]),
                    MM(s, void 0, void 0, function () {
                      var e;
                      return jM(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return N(!0), [4, l(Mg(ie, "", !1, je))];
                          case 1:
                            return t.sent(), [4, Be(ie)];
                          case 2:
                            return (e = t.sent()), R(e), N(!1), Ne(!0), [2];
                        }
                      });
                    })),
                  [2]
                );
              });
            });
          },
          productSearchText: h,
          handleKeyDown: function (e) {
            "Enter" === e.key &&
              13 === e.keyCode &&
              (null == h ? void 0 : h.length) > 2 &&
              ze(h);
          },
          handleProductTableSearchPopup: function () {
            return MM(s, void 0, void 0, function () {
              var e;
              return jM(this, function (t) {
                switch (t.label) {
                  case 0:
                    return N(!0), _(!0), [4, l(Mg(ie, "", !1, je))];
                  case 1:
                    return t.sent(), [4, Be(ie)];
                  case 2:
                    return (e = t.sent()), R(e), N(!1), Ne(!0), [2];
                }
              });
            });
          },
          shopCurrency: u,
          handleSearchTextChange: function (e) {
            return MM(s, void 0, void 0, function () {
              var t;
              return jM(this, function (n) {
                return (
                  (t = e.target.value),
                  f(t),
                  (null == t ? void 0 : t.length) > 2 && ze(t),
                  [2]
                );
              });
            });
          },
          searchTablePopupOpen: b,
          productsArray: E,
          getProductsLoading: j,
          selectedProductArray: B,
          checkUncheckProductVariant: function (e, t, n, r, o) {
            var a, i, s, l;
            return MM(this, void 0, void 0, function () {
              var d,
                c,
                u,
                p,
                m,
                h,
                f,
                g,
                v,
                b,
                _,
                y,
                C,
                x,
                S,
                k,
                P = this;
              return jM(this, function (w) {
                switch (w.label) {
                  case 0:
                    return (
                      w.trys.push([0, 6, , 7]),
                      (d = (null == e ? void 0 : e.target).checked),
                      "isProduct" !== t
                        ? [3, 4]
                        : ((c = null == n ? void 0 : n.variants),
                          d
                            ? ((u =
                                null == c
                                  ? void 0
                                  : c.filter(function (e) {
                                      return e.availableForSale;
                                    })),
                              (
                                null == B
                                  ? void 0
                                  : B.some(function (e) {
                                      return e.productId === n.productId;
                                    })
                              )
                                ? -1 !==
                                    (p = B.findIndex(function (e) {
                                      return e.productId === n.productId;
                                    })) &&
                                  (((m = NM([], B, !0))[p].variants = u), z(m))
                                : (z(
                                    NM(
                                      NM([], B, !0),
                                      [IM(IM({}, n), { variants: u })],
                                      !1
                                    )
                                  ),
                                  V(NM(NM([], H, !0), [n.productId], !1))),
                              $(NM(NM([], U, !0), u, !0)),
                              (x = IM({}, G)),
                              q(qe(x, u)),
                              [3, 3])
                            : [3, 1])
                    );
                  case 1:
                    return (
                      ae(!oe),
                      z(
                        null == B
                          ? void 0
                          : B.filter(function (e) {
                              return (
                                e.productId !==
                                (null == n ? void 0 : n.productId)
                              );
                            })
                      ),
                      V(
                        null == H
                          ? void 0
                          : H.filter(function (e) {
                              return e !== n.productId;
                            })
                      ),
                      (h =
                        null == U
                          ? void 0
                          : U.filter(function (e) {
                              return !(null == c
                                ? void 0
                                : c.some(function (t) {
                                    return (
                                      (null == t ? void 0 : t.variantId) ===
                                      (null == e ? void 0 : e.variantId)
                                    );
                                  }));
                            })),
                      $(h),
                      o
                        ? ((f = IM({}, G)),
                          (g = {}),
                          null == c ||
                            c.forEach(function (e) {
                              var t;
                              delete f[null == e ? void 0 : e.variantId];
                              var n = Number(
                                null ===
                                  (t = null == e ? void 0 : e.variantId) ||
                                  void 0 === t
                                  ? void 0
                                  : t.split("gid://shopify/ProductVariant/")[1]
                              );
                              g[n] = 0;
                            }),
                          [4, Ee("", "update.js", g)])
                        : [3, 3]
                    );
                  case 2:
                    w.sent(), q(f), (w.label = 3);
                  case 3:
                    return [3, 5];
                  case 4:
                    d
                      ? ((
                          null == B
                            ? void 0
                            : B.some(function (e) {
                                return (
                                  (null == e ? void 0 : e.productId) ===
                                  (null == n ? void 0 : n.productId)
                                );
                              })
                        )
                          ? z(function (e) {
                              return null == e
                                ? void 0
                                : e.map(function (e) {
                                    return e.productId === n.productId
                                      ? IM(IM({}, e), {
                                          variants: NM(
                                            NM([], e.variants, !0),
                                            [r],
                                            !1
                                          ),
                                        })
                                      : e;
                                  });
                            })
                          : (z(
                              NM(
                                NM([], B, !0),
                                [IM(IM({}, n), { variants: [r] })],
                                !1
                              )
                            ),
                            V(NM(NM([], H, !0), [n.productId], !1))),
                        $(NM(NM([], U, !0), [r], !1)),
                        _e &&
                          (null === (a = Object.keys(_e)) || void 0 === a
                            ? void 0
                            : a.length) > 0 &&
                          ((v = 1),
                          (b =
                            null !==
                              (s =
                                null ===
                                  (i =
                                    null == ye
                                      ? void 0
                                      : ye[null == r ? void 0 : r.variantId]) ||
                                void 0 === i
                                  ? void 0
                                  : i.price) && void 0 !== s
                              ? s
                              : null == r
                              ? void 0
                              : r.variantPrice),
                          (_ = $e(null == r ? void 0 : r.variantId)),
                          (y = We(null == r ? void 0 : r.variantId)),
                          null != _ && (v = Ke(_, v)),
                          q(function (e) {
                            var t;
                            return IM(
                              IM({}, e),
                              (((t = {})[null == r ? void 0 : r.variantId] = {
                                price: b,
                                quantity: v,
                                subtotal: Number(v) * b,
                                QuantityPriceBreaks: y,
                                QuantityRule: _,
                              }),
                              t)
                            );
                          })))
                      : (ae(!oe),
                        $(function (e) {
                          return null == e
                            ? void 0
                            : e.filter(function (e) {
                                return e.variantId !== r.variantId;
                              });
                        }),
                        z(function (e) {
                          return null == e
                            ? void 0
                            : e.map(function (e) {
                                var t;
                                return e.productId === n.productId
                                  ? IM(IM({}, e), {
                                      variants:
                                        null === (t = e.variants) ||
                                        void 0 === t
                                          ? void 0
                                          : t.filter(function (e) {
                                              return (
                                                e.variantId !== r.variantId
                                              );
                                            }),
                                    })
                                  : e;
                              });
                        }),
                        (C = null == n ? void 0 : n.variants),
                        $(function (e) {
                          return (
                            (null == C
                              ? void 0
                              : C.some(function (t) {
                                  return null == e
                                    ? void 0
                                    : e.some(function (e) {
                                        return e.variantId === t.variantId;
                                      });
                                })) ||
                              (V(function (e) {
                                return null == e
                                  ? void 0
                                  : e.filter(function (e) {
                                      return e !== n.productId;
                                    });
                              }),
                              z(function (e) {
                                return null == e
                                  ? void 0
                                  : e.filter(function (e) {
                                      return e.productId !== n.productId;
                                    });
                              })),
                            null == e
                              ? void 0
                              : e.filter(function (e) {
                                  return e.variantId !== r.variantId;
                                })
                          );
                        }),
                        o &&
                          ((x = IM({}, G)),
                          (S = {}),
                          delete x[r.variantId],
                          (k = Number(
                            null === (l = r.variantId) || void 0 === l
                              ? void 0
                              : l.split("gid://shopify/ProductVariant/")[1]
                          )),
                          (S[k] = 0),
                          setTimeout(function () {
                            return MM(P, void 0, void 0, function () {
                              return jM(this, function (e) {
                                switch (e.label) {
                                  case 0:
                                    return [4, Ee("", "update.js", S)];
                                  case 1:
                                    return e.sent(), [2];
                                }
                              });
                            });
                          }, 800),
                          q(x))),
                      (w.label = 5);
                  case 5:
                    return [3, 7];
                  case 6:
                    return w.sent(), [2];
                  case 7:
                    return [2];
                }
              });
            });
          },
          selectedVariantArray: U,
          selectedProductIdArray: H,
          showSelectedProduct: function () {
            return MM(s, void 0, void 0, function () {
              var e, t, n, r, o, a, i, s, d, c, u;
              return jM(this, function (p) {
                switch (p.label) {
                  case 0:
                    return (
                      p.trys.push([0, 4, , 5]),
                      (e =
                        (null === (d = F.getState().salesRepData) ||
                        void 0 === d
                          ? void 0
                          : d.locationPricelistData) || {}),
                      (t =
                        null === (c = e[ie]) || void 0 === c
                          ? void 0
                          : c.priceList),
                      ne([]),
                      ne(B),
                      _(!1),
                      Ie(!0),
                      (null == B ? void 0 : B.length) > 0
                        ? ((n = B.flatMap(function (e) {
                            return (null == e ? void 0 : e.variants) || [];
                          })),
                          (r = {}),
                          (o = Object.values(t)),
                          (a = []),
                          null == n ||
                            n.forEach(function (e) {
                              var t =
                                null == o
                                  ? void 0
                                  : o.find(function (t) {
                                      var n, r;
                                      return (
                                        (null ===
                                          (n =
                                            null == t ? void 0 : t.variantId) ||
                                        void 0 === n
                                          ? void 0
                                          : n.trim()) ===
                                        (null ===
                                          (r =
                                            null == e ? void 0 : e.variantId) ||
                                        void 0 === r
                                          ? void 0
                                          : r.trim())
                                      );
                                    });
                              t &&
                                t.catalogId &&
                                (r[t.catalogId] || (r[t.catalogId] = []),
                                r[t.catalogId].push(e.variantId),
                                a.push(e));
                            }),
                          (null === (u = Object.keys(r)) || void 0 === u
                            ? void 0
                            : u.length) > 0 &&
                          "" !== h &&
                          (null == xe ? void 0 : xe.length) > 0
                            ? ((i = JSON.stringify(r)), [4, l(jg(ie, i))])
                            : [3, 2])
                        : [3, 3]
                    );
                  case 1:
                    p.sent(), (s = IM({}, G)), q(qe(s, a)), (p.label = 2);
                  case 2:
                    Ie(!1), (p.label = 3);
                  case 3:
                    return f(""), Se([]), Ee(U, "add.js"), [3, 5];
                  case 4:
                    return p.sent(), [2];
                  case 5:
                    return [2];
                }
              });
            });
          },
          netQuantitySubtotal: G,
          updateNetQuantitySubtotal: Ve,
          finalSelectedProducts: te,
          closePopupForSearchProductData: function () {
            _(!1), N(!1), f(""), Se([]);
          },
          removeAllSelectedProducts: function () {
            try {
              ne([]), q({}), V([]), $([]), z([]), J(0), Ee({}, "clear.js");
            } catch (e) {
              return;
            }
          },
          handleNextClick: function () {
            return MM(s, void 0, void 0, function () {
              var e, t, n, r, o, a, i, s;
              return jM(this, function (d) {
                switch (d.label) {
                  case 0:
                    if (
                      !le.endCursor &&
                      !(null == le ? void 0 : le.SearchPricesEndCursor)
                    )
                      return [3, 6];
                    d.label = 1;
                  case 1:
                    return (
                      d.trys.push([1, 4, 5, 6]),
                      N(!0),
                      (e =
                        (null === (i = F.getState().salesRepData) ||
                        void 0 === i
                          ? void 0
                          : i.locationPricelistData) || {}),
                      (t =
                        null === (s = e[ie]) || void 0 === s
                          ? void 0
                          : s.companyLocationCatalogCursorDetails),
                      (n = !1),
                      "" !== h &&
                      (null == xe ? void 0 : xe.length) > 0 &&
                      (null == t ? void 0 : t.SearchPricesEndCursor)
                        ? ((n = !0),
                          (t = IM(IM({}, t), { SearchedProductIds: xe })))
                        : (n = !1),
                      (r = JSON.stringify(t)),
                      [4, l(Mg(ie, r, n, !1))]
                    );
                  case 2:
                    return d.sent(), [4, Be(ie)];
                  case 3:
                    return (o = d.sent()), R(o), [3, 6];
                  case 4:
                    return (
                      (a = d.sent()),
                      console.error("Error in handleNextClick:", a),
                      [3, 6]
                    );
                  case 5:
                    return N(!1), [7];
                  case 6:
                    return [2];
                }
              });
            });
          },
          handlePrevClick: function () {
            var e;
            null === (e = Ae.current) || void 0 === e || e.scrollTo(0, 0);
          },
          pageInfo: le,
          handleAlertMsgClose: function (e, t) {
            "clickaway" !== t && he({ msg: "", open: !1 });
          },
          alertErrorMsg: me,
          isQuantityError: ge,
          t: d,
          handleViewPricingPopup: function (e, t) {
            w(e), I(t), S(!x);
          },
          viewPricingPopupOpen: x,
          setViewPricingPopupOpen: S,
          productName: P,
          productVariantID: T,
          showB2BQtyCataloguePrice: function (e, t, n) {
            var r;
            if (
              _e &&
              (null === (r = Object.keys(_e)) || void 0 === r
                ? void 0
                : r.length) > 0
            ) {
              var o = We(e);
              if (o && (null == o ? void 0 : o.length) > 0) {
                var a =
                  null == o
                    ? void 0
                    : o
                        .filter(function (e) {
                          return (null == e ? void 0 : e.MinimumQuantity) <= t;
                        })
                        .sort(function (e, t) {
                          return (
                            (null == t ? void 0 : t.MinimumQuantity) -
                            (null == e ? void 0 : e.MinimumQuantity)
                          );
                        })[0];
                if (a) return null == a ? void 0 : a.Price.toFixed(2);
                if (n) return n;
              } else if (n) return n;
            }
            return null;
          },
          propsFromCreateOrderParentTab: !0,
          locationPricelistData: _e,
          tableContainerRef: Ae,
          isUpdatedCart: ce,
          readCartProducts: Qe,
          isRemoveCartPopup: Pe,
          setIsRemoveCartPopup: we,
          loadMoreBtnDisable: Te,
        };
      }
      var AM = function () {
        return (
          (AM =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          AM.apply(this, arguments)
        );
      };
      function EM(n) {
        var r,
          o,
          a = DM(),
          i = a.totalOrderAmount,
          s = a.handleSearchProductData,
          l = a.makeFieldsEmpty,
          d = a.productSearchText,
          c = a.handleKeyDown,
          u = a.handleProductTableSearchPopup,
          p = a.shopCurrency,
          m = a.handleSearchTextChange,
          h = a.searchTablePopupOpen,
          f = a.productsArray,
          g = a.getProductsLoading,
          v = a.selectedProductArray,
          b = a.checkUncheckProductVariant,
          _ = a.selectedVariantArray,
          y = a.selectedProductIdArray,
          C = a.showSelectedProduct,
          x = a.netQuantitySubtotal,
          S = a.updateNetQuantitySubtotal,
          k = a.finalSelectedProducts,
          P = a.closePopupForSearchProductData,
          w = a.removeAllSelectedProducts,
          O = a.handleNextClick,
          T = a.handlePrevClick,
          I = a.pageInfo,
          M = a.handleAlertMsgClose,
          j = a.alertErrorMsg,
          N = a.isQuantityError,
          D = a.t,
          A = a.handleViewPricingPopup,
          E = a.viewPricingPopupOpen,
          R = a.setViewPricingPopupOpen,
          L = a.productName,
          B = a.productVariantID,
          z = a.showB2BQtyCataloguePrice,
          F = a.propsFromCreateOrderParentTab,
          Z = a.tableContainerRef,
          H = a.isRemoveCartPopup,
          V = a.setIsRemoveCartPopup,
          W = a.loadMoreBtnDisable,
          U = xv().SnackbarAlertMsg,
          $ = _y(),
          K = $.productTableSearchBar,
          G = $.searchProductTablePopUp,
          q = $.selectedProductTable,
          Q = $.productTable_SubTotal,
          Y = xy(),
          J = Y.productTableSearchBar_mobile,
          X = Y.searchProductTablePopUp_mobile,
          ee = Y.selectedProductTable_mobile,
          te = Y.productTable_SubTotal_mobile,
          ne = Tv();
        return (
          (0, t.useEffect)(
            function () {
              (null == n ? void 0 : n.orderCreatedSuccesfullyFlag) && w();
            },
            [null == n ? void 0 : n.orderCreatedSuccesfullyFlag]
          ),
          (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsxs)(
                mn,
                AM(
                  { p: 1 },
                  {
                    children: [
                      (0, e.jsx)(
                        "div",
                        AM(
                          { className: "headingDivider" },
                          {
                            children: (0, e.jsx)(
                              Gt,
                              AM(
                                {
                                  textAlign: "left",
                                  className: "PT_Search_Text_Divider",
                                },
                                {
                                  children: (0, e.jsx)(
                                    ni,
                                    AM(
                                      { variant: Av, sx: Ko },
                                      {
                                        children: D(
                                          "createOrder_select_product"
                                        ),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                      (0, e.jsx)(
                        Hp,
                        AM(
                          {
                            open: E,
                            onClose: function () {
                              return R(!1);
                            },
                            fullWidth: !0,
                          },
                          {
                            children: (0, e.jsxs)(mn, {
                              children: [
                                (0, e.jsx)(
                                  "div",
                                  AM(
                                    {
                                      className:
                                        "ST_B2B_viewPricing_tableTitle_margin",
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        qa,
                                        AM(
                                          { container: !0, spacing: 2, mb: 1 },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                qa,
                                                AM(
                                                  {
                                                    item: !0,
                                                    xs: 10,
                                                    md: 10,
                                                    className:
                                                      "ST_B2B_viewPricing_tableTitle_font",
                                                  },
                                                  { children: L }
                                                )
                                              ),
                                              (0, e.jsx)(
                                                qa,
                                                AM(
                                                  {
                                                    item: !0,
                                                    xs: 2,
                                                    md: 2,
                                                    className:
                                                      "ST_B2B_viewPricing_tableTitle_CancleIcon",
                                                    pr: 1,
                                                  },
                                                  {
                                                    children: (0, e.jsx)(Fg, {
                                                      sx: { cursor: "pointer" },
                                                      onClick: function () {
                                                        return R(!1);
                                                      },
                                                    }),
                                                  }
                                                )
                                              ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)(Gt, { variant: "middle" }),
                                (0, e.jsx)(
                                  ep,
                                  AM(
                                    {
                                      component: go,
                                      className:
                                        "ST_B2B_viewPricing_TableContainer",
                                    },
                                    {
                                      children: (0, e.jsx)(
                                        "div",
                                        AM(
                                          {
                                            className:
                                              "ST_B2B_viewPricing_tablebody",
                                          },
                                          {
                                            children: (0, e.jsxs)(
                                              sp,
                                              AM(
                                                {
                                                  stickyHeader: !0,
                                                  "aria-label":
                                                    "customized table",
                                                },
                                                {
                                                  children: [
                                                    (0, e.jsx)(hp, {
                                                      children: (0, e.jsx)(
                                                        Cp,
                                                        AM(
                                                          {
                                                            className:
                                                              "ST_B2B_viewPricing_tableHeadRow",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(Op, {
                                                              children: D(
                                                                "ST_Producttable_VolumePricing"
                                                              ),
                                                            }),
                                                          }
                                                        )
                                                      ),
                                                    }),
                                                    (0, e.jsx)(Dp, {
                                                      children:
                                                        null ===
                                                          (o =
                                                            null ===
                                                              (r = x[B]) ||
                                                            void 0 === r
                                                              ? void 0
                                                              : r.QuantityPriceBreaks) ||
                                                        void 0 === o
                                                          ? void 0
                                                          : o.map(function (
                                                              t,
                                                              n
                                                            ) {
                                                              var r;
                                                              return (0,
                                                              e.jsxs)(
                                                                Cp,
                                                                AM(
                                                                  {
                                                                    sx: {
                                                                      "&:nth-of-type(odd)":
                                                                        {
                                                                          backgroundColor:
                                                                            "action.hover",
                                                                        },
                                                                      "&:last-child td, &:last-child th":
                                                                        {
                                                                          border: 0,
                                                                        },
                                                                    },
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsxs)(
                                                                        Op,
                                                                        AM(
                                                                          {
                                                                            scope:
                                                                              "row",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                null ==
                                                                                t
                                                                                  ? void 0
                                                                                  : t.MinimumQuantity,
                                                                                "+",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                      (0,
                                                                      e.jsxs)(
                                                                        Op,
                                                                        AM(
                                                                          {
                                                                            align:
                                                                              "right",
                                                                            className:
                                                                              "ST_B2B_viewPricing_tableCell ST_White_Space",
                                                                          },
                                                                          {
                                                                            children:
                                                                              [
                                                                                p,
                                                                                null ===
                                                                                  (r =
                                                                                    null ==
                                                                                    t
                                                                                      ? void 0
                                                                                      : t.Price) ||
                                                                                void 0 ===
                                                                                  r
                                                                                  ? void 0
                                                                                  : r.toFixed(
                                                                                      2
                                                                                    ),
                                                                                "/ea",
                                                                              ],
                                                                          }
                                                                        )
                                                                      ),
                                                                    ],
                                                                  }
                                                                ),
                                                                n
                                                              );
                                                            }),
                                                    }),
                                                  ],
                                                }
                                              )
                                            ),
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsx)("br", {}),
                                (0, e.jsx)(Gt, { variant: "middle" }),
                                (0, e.jsx)(Jp, {
                                  children: (0, e.jsx)(qa, {
                                    children: (0, e.jsx)(
                                      Ym,
                                      AM(
                                        {
                                          sx: {
                                            border: "1px solid #E0E0E0",
                                            mt: "8px",
                                            color: "black",
                                            textTransform: "capitalize",
                                          },
                                          onClick: function () {
                                            return R(!1);
                                          },
                                        },
                                        {
                                          children: D(
                                            "ST_B2BPriceBreack_CloseBtn"
                                          ),
                                        }
                                      )
                                    ),
                                  }),
                                }),
                              ],
                            }),
                          }
                        )
                      ),
                      ne
                        ? (0, e.jsxs)(e.Fragment, {
                            children: [
                              J({
                                handleProductTableSearchPopup: u,
                                removeAllSelectedProducts: w,
                                finalSelectedProducts: k,
                                isRemoveCartPopup: H,
                                setIsRemoveCartPopup: V,
                              }),
                              X({
                                searchTablePopupOpen: h,
                                closePopupForSearchProductData: P,
                                handleKeyDown: c,
                                handleSearchTextChange: m,
                                makeFieldsEmpty: l,
                                handleSearchProductData: s,
                                checkUncheckProductVariant: b,
                                handlePrevClick: T,
                                handleNextClick: O,
                                showSelectedProduct: C,
                                productsArray: f,
                                selectedProductIdArray: y,
                                selectedVariantArray: _,
                                pageInfo: I,
                                getProductsLoading: g,
                                productSearchText: d,
                                selectedProductArray: v,
                                propsFromCreateOrderParentTab: F,
                                tableContainerRef: Z,
                                loadMoreBtnDisable: W,
                              }),
                              ee({
                                checkUncheckProductVariant: b,
                                selectedProductIdArray: y,
                                selectedVariantArray: _,
                                getProductsLoading: g,
                                finalSelectedProducts: k,
                                updateNetQuantitySubtotal: S,
                                netQuantitySubtotal: x,
                                isQuantityError: N,
                                handleProductTableSearchPopup: u,
                                showB2BQtyCataloguePrice: z,
                                handleViewPricingPopup: A,
                                propsFromCreateOrderParentTab: F,
                              }),
                              te(i),
                            ],
                          })
                        : (0, e.jsxs)(e.Fragment, {
                            children: [
                              K({
                                handleProductTableSearchPopup: u,
                                removeAllSelectedProducts: w,
                                finalSelectedProducts: k,
                                isRemoveCartPopup: H,
                                setIsRemoveCartPopup: V,
                              }),
                              G({
                                searchTablePopupOpen: h,
                                closePopupForSearchProductData: P,
                                handleKeyDown: c,
                                handleSearchTextChange: m,
                                makeFieldsEmpty: l,
                                handleSearchProductData: s,
                                checkUncheckProductVariant: b,
                                handlePrevClick: T,
                                handleNextClick: O,
                                showSelectedProduct: C,
                                productsArray: f,
                                selectedProductIdArray: y,
                                selectedVariantArray: _,
                                pageInfo: I,
                                getProductsLoading: g,
                                productSearchText: d,
                                selectedProductArray: v,
                                propsFromCreateOrderParentTab: F,
                                tableContainerRef: Z,
                                loadMoreBtnDisable: W,
                              }),
                              q({
                                checkUncheckProductVariant: b,
                                selectedProductIdArray: y,
                                selectedVariantArray: _,
                                getProductsLoading: g,
                                finalSelectedProducts: k,
                                updateNetQuantitySubtotal: S,
                                netQuantitySubtotal: x,
                                isQuantityError: N,
                                handleProductTableSearchPopup: u,
                                showB2BQtyCataloguePrice: z,
                                handleViewPricingPopup: A,
                                propsFromCreateOrderParentTab: F,
                                loadMoreBtnDisable: W,
                              }),
                              Q(i),
                            ],
                          }),
                    ],
                  }
                )
              ),
              U(j, M),
            ],
          })
        );
      }
      var RM = function () {
          return (
            (RM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            RM.apply(this, arguments)
          );
        },
        LM = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        BM = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        zM = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5m13.5-9 1.96 2.5H17V9.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5",
          }),
          "LocalShipping"
        ),
        FM = function () {
          return (
            (FM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            FM.apply(this, arguments)
          );
        };
      function ZM(n) {
        var r,
          o = (function (e) {
            var n,
              r,
              o,
              a = this,
              i = (0, t.useState)(""),
              s = i[0],
              l = i[1],
              d = (0, t.useState)(""),
              c = d[0],
              u = d[1],
              p = y(function (e) {
                return e.salesRepData ? e.salesRepData : {};
              }),
              m = (0, t.useState)(),
              h = m[0],
              f = m[1],
              v = (0, t.useState)([]),
              b = v[0],
              _ = v[1],
              C = (0, t.useState)(),
              x = C[0],
              S = C[1],
              k = (0, t.useState)([]),
              P = k[0],
              w = k[1],
              O = (0, t.useState)(""),
              T = O[0],
              I = O[1],
              M = (0, t.useState)(!1),
              j = M[0],
              N = M[1],
              D = (0, t.useState)(""),
              E = D[0],
              R = D[1],
              L = (0, t.useState)({ msg: "", color: "blue" }),
              B = L[0],
              z = L[1],
              Z = (0, t.useState)({ msg: "", open: !1 }),
              H = Z[0],
              V = Z[1],
              W = new Date(),
              U =
                W.getFullYear() +
                "-" +
                (W.getMonth() + 1).toString().padStart(2, "0") +
                "-" +
                W.getDate().toString().padStart(2, "0"),
              $ = y(function (e) {
                var t, n;
                return null ===
                  (n =
                    null === (t = null == e ? void 0 : e.salesRepData) ||
                    void 0 === t
                      ? void 0
                      : t.customerDetailsCreateInvoice) || void 0 === n
                  ? void 0
                  : n.locationId;
              }),
              K =
                null ===
                  (r =
                    null === (n = F.getState().salesRepData) || void 0 === n
                      ? void 0
                      : n.baseData) || void 0 === r
                  ? void 0
                  : r.PaymentTermsTemplates,
              G = y(function () {
                var e, t;
                return null !==
                  (t =
                    null === (e = F.getState().salesRepData) || void 0 === e
                      ? void 0
                      : e.productTableData) && void 0 !== t
                  ? t
                  : {};
              }),
              q = G.selectedProductData,
              Q = G.isQuantityError,
              Y = ee().t,
              J = g();
            function X(e, t) {
              return LM(this, void 0, void 0, function () {
                return BM(this, function (n) {
                  return J({ payload: e, type: t }), [2];
                });
              });
            }
            (0, t.useEffect)(
              function () {
                var e,
                  t,
                  n,
                  r,
                  o,
                  a,
                  i =
                    null !==
                      (e = null == p ? void 0 : p.locationPricelistData) &&
                    void 0 !== e
                      ? e
                      : {};
                if (
                  $ &&
                  i &&
                  (null === (t = null == Object ? void 0 : Object.keys(i)) ||
                  void 0 === t
                    ? void 0
                    : t.length) > 0
                ) {
                  var s =
                    null !==
                      (r =
                        null === (n = i[$]) || void 0 === n
                          ? void 0
                          : n.paymentTermsTemplateName) && void 0 !== r
                      ? r
                      : "";
                  if (
                    s &&
                    null != K &&
                    (null === (o = Object.keys(K)) || void 0 === o
                      ? void 0
                      : o.length) > 0
                  ) {
                    var l = Object.values(K).find(function (e) {
                      return (null == e ? void 0 : e.name) === s;
                    });
                    l && null != l && null != l && f(l);
                  }
                  _(
                    null === (a = i[$]) || void 0 === a
                      ? void 0
                      : a.taxExemptions
                  );
                }
              },
              [p, $]
            );
            var te =
                q &&
                (null == q ? void 0 : q.length) > 0 &&
                p.customerDetailsCreateInvoice &&
                0 !==
                  (null ===
                    (o = Object.keys(
                      null == p ? void 0 : p.customerDetailsCreateInvoice
                    )) || void 0 === o
                    ? void 0
                    : o.length) &&
                Q &&
                Object.values(Q).every(function (e) {
                  return !1 === e;
                }),
              ne = "FIXED" === (null == h ? void 0 : h.paymentTermsType) && !x;
            return {
              orderPlacedMsg: B,
              handleAlertMsgClose: function (e, t) {
                "clickaway" !== t && V({ msg: "", open: !1 });
              },
              handlePaymentTermsPeriod: function (e) {
                var t = e.target.value;
                f(t);
              },
              durationTypesOfPayment: K,
              handleDateSelection: function (e) {
                if ("" !== e.target.value) {
                  var t = new Date(e.target.value).toISOString();
                  S(t);
                } else S("");
              },
              selectedPaymentTerm: h,
              orderNotes: s,
              orderPONumber: c,
              todayDateString: U,
              setOrderNotes: l,
              setOrderPONumber: u,
              taxExemptionDetails: b,
              GetShippingRatesOnSelectedAddress: function () {
                return LM(a, void 0, void 0, function () {
                  var e, t, n, r, o, a, i;
                  return BM(this, function (s) {
                    switch (s.label) {
                      case 0:
                        R(""),
                          w([]),
                          I(""),
                          N(!1),
                          (e =
                            null !==
                              (a =
                                null ===
                                  (o =
                                    null === (r = F.getState().salesRepData) ||
                                    void 0 === r
                                      ? void 0
                                      : r.customerDetailsCreateInvoice) ||
                                void 0 === o
                                  ? void 0
                                  : o.shippingAddress) && void 0 !== a
                              ? a
                              : {}),
                          (t = {
                            customerCountry:
                              "Great Britain (UK)" ===
                              (null == e ? void 0 : e.country)
                                ? "United Kingdom"
                                : "United States of America" ===
                                  (null == e ? void 0 : e.country)
                                ? "United States"
                                : (null == e ? void 0 : e.country) || "",
                            customerProvince:
                              (null == e ? void 0 : e.province) ||
                              (null == e ? void 0 : e.city) ||
                              "",
                            customerZip: (null == e ? void 0 : e.zip) || "",
                          }),
                          R(Y("customerInvoice_CalculatingShippingRates_Msg")),
                          (s.label = 1);
                      case 1:
                        return s.trys.push([1, 3, , 4]), [4, Ff(t)];
                      case 2:
                        return (
                          (n = s.sent()),
                          R(""),
                          0 ===
                          (null ===
                            (i = null == n ? void 0 : n.shipping_rates) ||
                          void 0 === i
                            ? void 0
                            : i.length)
                            ? (V({
                                msg: Y("ShippingCost_AddressError"),
                                open: !0,
                                severity: "warning",
                              }),
                              I("No"),
                              N(!0),
                              [2, !1])
                            : "Success" !== (null == n ? void 0 : n.message)
                            ? (V({
                                msg:
                                  "Success" === (null == n ? void 0 : n.message)
                                    ? Y(
                                        "customerInvoice_ShippingCostErrorMsg_TryAgain"
                                      )
                                    : null == n
                                    ? void 0
                                    : n.message,
                                open: !0,
                              }),
                              [2, !1])
                            : (w((null == n ? void 0 : n.shipping_rates) || []),
                              [2, !0])
                        );
                      case 3:
                        return (
                          s.sent(),
                          R(""),
                          V({
                            msg: Y(
                              "customerInvoice_ShippingCostErrorMsg_TryAgain"
                            ),
                            open: !0,
                          }),
                          [2, !1]
                        );
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              shippingCost: E,
              setShippingCost: R,
              setApplyShippingCost: I,
              isDisabledShippingCostRadioBtn_No: !1,
              applyShippingCost: T,
              shippingCostRadioBtnDisable: j,
              handleShippingCostApply: function (e) {
                I(e), e === $g && (R(""), w([]));
              },
              shippingCostData: P,
              CreateB2BOrder: function () {
                return LM(a, void 0, void 0, function () {
                  var t, n, r, o, a, i, l, d, u, p, m, f, g, v, b;
                  return BM(this, function (_) {
                    switch (_.label) {
                      case 0:
                        return (
                          _.trys.push([0, 3, , 4]),
                          (t = af()),
                          (n = t.CustomerId),
                          (r = t.email),
                          (o = r),
                          (a = n),
                          (i =
                            F.getState().salesRepData
                              .customerDetailsCreateInvoice),
                          (l = null == i ? void 0 : i.shippingAddress),
                          (d = null == i ? void 0 : i.billingAddress),
                          (u = null == E ? void 0 : E.split("/")),
                          (p = "" !== u[0] ? u[0] : null),
                          (m = "" !== u[1] ? u[1] : null),
                          "" === T &&
                            V({
                              msg: Y(
                                "customerInvoice_ShippingCostAddOrNot_Msg"
                              ),
                              open: !0,
                            }),
                          T !== $g && "" === E
                            ? [3, 2]
                            : ((f = null != q ? q : []),
                              (g = RM({
                                prods: JSON.stringify(f),
                                shippingAddress: JSON.stringify(l),
                                billingAddress: JSON.stringify(d),
                                email: o,
                                cusemail: null == i ? void 0 : i.customerEmail,
                                customerId: a,
                                customer_gid: null == i ? void 0 : i.customerId,
                                companyContactId:
                                  null == i ? void 0 : i.customerId,
                                companyLocationId:
                                  null == i ? void 0 : i.locationId,
                                companyName: null == i ? void 0 : i.companyName,
                                companyId: null == i ? void 0 : i.companyId,
                                ponumber: c,
                                message: s,
                                paymentTermsTemplateId:
                                  null == h ? void 0 : h.id,
                                paymentTermType:
                                  null == h ? void 0 : h.dueInDays,
                                dueDateInput:
                                  "FIXED" ===
                                  (null == h ? void 0 : h.paymentTermsType)
                                    ? x
                                    : "",
                                shippingprice: m,
                                shippingtitle: p,
                              })),
                              z({
                                msg: Y("customerInvoice_Sending_Msg"),
                                color: "blue",
                              }),
                              null == e || e.setOrderCreatedSuccesfullyFlag(!1),
                              [4, Ng(g)])
                        );
                      case 1:
                        "boolean" == typeof (v = _.sent())
                          ? (z({
                              msg: Y(
                                "customerInvoice_InvoiceSentSuccessfullyMsg"
                              ),
                              color: "green",
                            }),
                            V({
                              msg: Y(
                                "customerInvoice_InvoiceSentSuccessfullyMsg"
                              ),
                              open: !0,
                              severity: "success",
                            }),
                            setTimeout(function () {
                              z({ msg: "", color: "" }),
                                X("", A.CUSTOMER_DETAILS_CREATE_INVOICE);
                            }, 3e3),
                            null == e || e.setOrderCreatedSuccesfullyFlag(!0),
                            X({}, A.PRODUCT_TABLE_DATA),
                            X([], A.DRAFT_ORDER_DATA))
                          : ((b =
                              "string" == typeof v
                                ? v
                                : Y("customerInvoice_ErrorMsgTryAgain")),
                            V({ msg: b, open: !0, severity: "error" }),
                            z({ msg: b, color: "red" })),
                          setTimeout(function () {
                            z({ msg: "", color: "" });
                          }, 2e3),
                          (_.label = 2);
                      case 2:
                        return [3, 4];
                      case 3:
                        return (
                          _.sent(),
                          (b = Y("customerInvoice_ErrorMsgTryAgain")),
                          V({ msg: b, open: !0, severity: "error" }),
                          z({ msg: b, color: "red" }),
                          [3, 4]
                        );
                      case 4:
                        return [2];
                    }
                  });
                });
              },
              alertErrorMsg: H,
              b2borderCreateBtnDisabled: te,
              B2BCreateOrderButtonDisable: ne,
            };
          })(n),
          a = o.handlePaymentTermsPeriod,
          i = o.durationTypesOfPayment,
          s = o.handleDateSelection,
          l = o.selectedPaymentTerm,
          d = o.orderNotes,
          c = o.orderPONumber,
          u = o.todayDateString,
          p = o.setOrderNotes,
          m = o.setOrderPONumber,
          h = o.taxExemptionDetails,
          f = o.GetShippingRatesOnSelectedAddress,
          v = o.shippingCost,
          b = o.setShippingCost,
          _ = o.setApplyShippingCost,
          C = o.isDisabledShippingCostRadioBtn_No,
          x = o.applyShippingCost,
          S = o.shippingCostRadioBtnDisable,
          k = o.handleShippingCostApply,
          P = o.shippingCostData,
          w = o.CreateB2BOrder,
          O = o.alertErrorMsg,
          T = o.handleAlertMsgClose,
          I = o.orderPlacedMsg,
          M = o.b2borderCreateBtnDisabled,
          j = o.B2BCreateOrderButtonDisable,
          N = { minWidth: 200, backgroundColor: "white" },
          D = { width: 135, height: 36, fontSize: 12 },
          E = ee().t;
        return (0, e.jsxs)(
          mn,
          FM(
            { className: "B2B_Action_Buttons" },
            {
              children: [
                (0, e.jsxs)(
                  qa,
                  FM(
                    { container: !0, spacing: 2, mb: 2 },
                    {
                      children: [
                        (0, e.jsx)(
                          qa,
                          FM(
                            { item: !0, xs: 4, sm: 4, md: 4, lg: 3, xl: 2 },
                            {
                              children: (0, e.jsx)(Hc, {
                                label: E(
                                  "customerInvoice_contentHeading2Title3"
                                ),
                                value: d,
                                onChange: function (e) {
                                  return p(e.target.value);
                                },
                                className: "ST_CO_TextFields",
                                size: "small",
                              }),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          qa,
                          FM(
                            { item: !0, xs: 4, sm: 4, md: 4, lg: 3, xl: 2 },
                            {
                              children: (0, e.jsx)(Hc, {
                                label: E("CreateOrder_EnterPoNumber"),
                                value: c,
                                onChange: function (e) {
                                  return m(e.target.value);
                                },
                                className: "ST_CO_TextFields",
                                size: "small",
                              }),
                            }
                          )
                        ),
                        (0, e.jsx)(
                          qa,
                          FM(
                            { item: !0, xs: 4, md: 4, lg: 3, xl: 2 },
                            {
                              children: (0, e.jsx)(
                                Gs,
                                FM(
                                  {
                                    title: "Tax Excemptions will show here",
                                    arrow: !0,
                                  },
                                  {
                                    children: (0, e.jsx)(Hc, {
                                      disabled: !0,
                                      label: E("CreateOrder_TaxExemption"),
                                      value: h,
                                      className:
                                        "ST_CO_TextFields ST_taxExemptBtn",
                                      size: "small",
                                    }),
                                  }
                                )
                              ),
                            }
                          )
                        ),
                        (0, e.jsxs)(
                          qa,
                          FM(
                            { item: !0, xs: 4, sm: 4, md: 4, lg: 3, xl: 6 },
                            {
                              children: [
                                (0, e.jsxs)(
                                  yd,
                                  FM(
                                    { sx: N, size: "small" },
                                    {
                                      children: [
                                        (0, e.jsx)(hd, {
                                          children: E(
                                            "Create_Order_PaymentDueLater"
                                          ),
                                        }),
                                        (0, e.jsxs)(
                                          Rc,
                                          FM(
                                            {
                                              sx: { border: "2px solid white" },
                                              value: l || "",
                                              onChange: function (e) {
                                                return a(e);
                                              },
                                            },
                                            {
                                              children: [
                                                (0, e.jsx)(
                                                  J_,
                                                  FM(
                                                    { value: "" },
                                                    {
                                                      children: (0, e.jsx)(
                                                        "em",
                                                        {
                                                          children:
                                                            E("ST_none"),
                                                        }
                                                      ),
                                                    }
                                                  )
                                                ),
                                                null == i
                                                  ? void 0
                                                  : i.map(function (t, n) {
                                                      var r;
                                                      return (0,
                                                      e.jsx)(J_, FM({ value: t }, { children: null !== (r = null == t ? void 0 : t.description) && void 0 !== r ? r : "" }), n);
                                                    }),
                                              ],
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  "div",
                                  FM(
                                    {
                                      style:
                                        "FIXED" ===
                                        (null == l
                                          ? void 0
                                          : l.paymentTermsType)
                                          ? { display: "contents" }
                                          : { display: "none" },
                                    },
                                    {
                                      children: (0, e.jsx)(Hc, {
                                        required: !0,
                                        id: "date",
                                        label: E("CreateOrder_chooseDateMsg"),
                                        type: "date",
                                        sx: {
                                          cursor: "pointer",
                                          backgroundColor: "white",
                                          mt: "5px",
                                        },
                                        InputLabelProps: { shrink: !0 },
                                        inputProps: { min: u },
                                        size: "small",
                                        onChange: function (e) {
                                          s(e);
                                        },
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
                (0, e.jsxs)(
                  qa,
                  FM(
                    { container: !0, spacing: 2, mb: 2 },
                    {
                      children: [
                        (0, e.jsxs)(
                          qa,
                          FM(
                            { item: !0, xs: 12, md: 12, lg: 6, xl: 6 },
                            {
                              children: [
                                (0, e.jsx)(
                                  Gs,
                                  FM(
                                    {
                                      title:
                                        E(
                                          "customerInvoice_CalculateShippingCost_Btn"
                                        ) || "",
                                      arrow: !0,
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        Qu,
                                        FM(
                                          {
                                            sx: [Dv],
                                            size: "small",
                                            variant: "outlined",
                                            onClick: function () {
                                              return f();
                                            },
                                            className:
                                              "B2B_Calculate_Shipping_Cost",
                                          },
                                          {
                                            children: [
                                              E(
                                                "customerInvoice_CalculateShippingCost_Btn"
                                              ),
                                              (0, e.jsx)(zM, {
                                                color: "primary",
                                                sx: { ml: 1, fontSize: 30 },
                                              }),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  Hc,
                                  FM(
                                    {
                                      className: "shippingCostTextField",
                                      sx: {
                                        "& .MuiOutlinedInput-root": {
                                          "& fieldset": {
                                            borderColor:
                                              x === Ug && "" === v
                                                ? "red"
                                                : "none",
                                          },
                                        },
                                      },
                                      id: "outlined-select-shippingCost",
                                      select: !0,
                                      label: E(
                                        "customerInvoice_selectShippingCost"
                                      ),
                                      value: v,
                                      onChange: function (e) {
                                        return b(e.target.value), _("Yes");
                                      },
                                      type: "search",
                                      size: "small",
                                    },
                                    {
                                      children: [
                                        (0, e.jsx)(
                                          J_,
                                          FM(
                                            {
                                              disabled: !0,
                                              value:
                                                v ===
                                                E(
                                                  "customerInvoice_CalculatingShippingRates_Msg"
                                                )
                                                  ? v
                                                  : "",
                                            },
                                            {
                                              children:
                                                v ===
                                                E(
                                                  "customerInvoice_CalculatingShippingRates_Msg"
                                                )
                                                  ? v
                                                  : E(
                                                      "customerInvoice_selectShippingCost"
                                                    ),
                                            }
                                          )
                                        ),
                                        (null == P ? void 0 : P.length) > 0
                                          ? null == P
                                            ? void 0
                                            : P.map(function (t, n) {
                                                return (0,
                                                e.jsxs)(J_, FM({ value: t.name + "/" + t.price }, { children: [t.name, " / ", t.price] }), n);
                                              })
                                          : null,
                                      ],
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                        (0, e.jsx)(
                          qa,
                          FM(
                            { item: !0, xs: 12, md: 12, lg: 6, xl: 6 },
                            {
                              children: (0, e.jsxs)("div", {
                                children: [
                                  (0, e.jsx)(
                                    "div",
                                    FM(
                                      { className: "sendInvoiceBtn_options" },
                                      {
                                        children: (0, e.jsxs)(
                                          ni,
                                          FM(
                                            { variant: "subtitle1" },
                                            {
                                              children: [
                                                E(
                                                  "customerInvoice_ShippingCostAddOrNot_Msg"
                                                ),
                                                (0, e.jsx)("br", {}),
                                                (0, e.jsxs)(
                                                  "span",
                                                  FM(
                                                    {
                                                      style: {
                                                        marginLeft: "0.5rem",
                                                        cursor: "pointer",
                                                        color:
                                                          x === Ug
                                                            ? "green"
                                                            : "blue",
                                                      },
                                                      onClick: function () {
                                                        return S
                                                          ? null
                                                          : k("Yes");
                                                      },
                                                    },
                                                    {
                                                      children: [
                                                        E(
                                                          "customerInvoice_ShippingCostAddOrNot_Yes"
                                                        ),
                                                        (0, e.jsx)(Fy, {
                                                          sx: { mr: "0.5rem" },
                                                          checked: x === Ug,
                                                          value: Ug,
                                                          disabled: S,
                                                          inputProps: {
                                                            "aria-label": Ug,
                                                          },
                                                          size: "small",
                                                          color: "success",
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                                "/",
                                                (0, e.jsxs)(
                                                  "span",
                                                  FM(
                                                    {
                                                      style: {
                                                        marginLeft: "0.5rem",
                                                        cursor: "pointer",
                                                        color:
                                                          x === $g
                                                            ? "green"
                                                            : "blue",
                                                        pointerEvents: C
                                                          ? "none"
                                                          : "auto",
                                                      },
                                                      onClick: function () {
                                                        return S
                                                          ? null
                                                          : k("No");
                                                      },
                                                    },
                                                    {
                                                      children: [
                                                        E(
                                                          "customerInvoice_ShippingCostAddOrNot_No"
                                                        ),
                                                        (0, e.jsx)(Fy, {
                                                          checked: x === $g,
                                                          value: "No",
                                                          disabled: S || C,
                                                          inputProps: {
                                                            "aria-label": "No",
                                                          },
                                                          size: "small",
                                                          color: "success",
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              ],
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                  (0, e.jsx)(
                                    "div",
                                    FM(
                                      { className: "sendInvoiceBtn" },
                                      {
                                        children: (0, e.jsx)(
                                          Qu,
                                          FM(
                                            {
                                              disabled: !M || j,
                                              sx: [{ ml: 1 }, Dv, D],
                                              variant: "contained",
                                              endIcon: (0, e.jsx)(LI, {}),
                                              onClick: function () {
                                                return w();
                                              },
                                            },
                                            {
                                              children:
                                                I.msg ===
                                                E("customerInvoice_Sending_Msg")
                                                  ? I.msg
                                                  : E(
                                                      "customerInvoice_SendInvoiceBtn"
                                                    ),
                                            }
                                          )
                                        ),
                                      }
                                    )
                                  ),
                                ],
                              }),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
                (0, e.jsx)(
                  ni,
                  FM(
                    {
                      variant: "body2",
                      sx: { mt: 2, mr: 1, display: " block", color: I.color },
                      align: "right",
                    },
                    {
                      children:
                        I.msg ===
                        E("customerInvoice_InvoiceSentSuccessfullyMsg")
                          ? I.msg
                          : "",
                    }
                  )
                ),
                (0, e.jsx)(
                  um,
                  FM(
                    {
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "center",
                      },
                      open: O.open,
                      autoHideDuration: 4e3,
                      onClose: T,
                    },
                    {
                      children: (0, e.jsx)(
                        Im,
                        FM(
                          {
                            onClose: T,
                            severity:
                              null !== (r = null == O ? void 0 : O.severity) &&
                              void 0 !== r
                                ? r
                                : "error",
                            variant: "filled",
                            sx: { width: "100%" },
                          },
                          { children: O.msg }
                        )
                      ),
                    }
                  )
                ),
              ],
            }
          )
        );
      }
      var HM = function () {
        return (
          (HM =
            Object.assign ||
            function (e) {
              for (var t, n = 1, r = arguments.length; n < r; n++)
                for (var o in (t = arguments[n]))
                  Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
              return e;
            }),
          HM.apply(this, arguments)
        );
      };
      function VM() {
        var t,
          n,
          r,
          o = y(function () {
            var e;
            return null === (e = F.getState().salesRepData) || void 0 === e
              ? void 0
              : e.customerDetailsCreateInvoice;
          }),
          a =
            0 ===
            (null === (t = null == Object ? void 0 : Object.keys(o)) ||
            void 0 === t
              ? void 0
              : t.length),
          i = ee().t,
          s =
            null !==
              (n = y(function () {
                var e;
                return null === (e = F.getState().salesRepData) || void 0 === e
                  ? void 0
                  : e.locationPricelistData;
              })) && void 0 !== n
              ? n
              : {},
          l = (null === (r = Object.keys(s)) || void 0 === r || r.length, wM()),
          d = l.orderCreatedSuccesfullyFlag,
          c = l.setOrderCreatedSuccesfullyFlag,
          u = { orderCreatedSuccesfullyFlag: d };
        return (0, e.jsx)(
          mn,
          HM(
            { className: "ST_Main_Card" },
            {
              children: a
                ? (0, e.jsx)(PM, {})
                : !a &&
                  (0, e.jsxs)(e.Fragment, {
                    children: [
                      (0, e.jsxs)(
                        Im,
                        HM(
                          {
                            className: "ST_B2BShowInfo_Msg",
                            variant: "outlined",
                            severity: "info",
                          },
                          {
                            children: [
                              i("Beta_Version_msg1"),
                              ",",
                              " ",
                              (0, e.jsxs)(
                                rl,
                                HM(
                                  {
                                    color: "inherit",
                                    href: "mailto:support@chiefss.com",
                                  },
                                  { children: [" ", i("Beta_Version_msg2")] }
                                )
                              ),
                            ],
                          }
                        )
                      ),
                      (0, e.jsx)(
                        "div",
                        HM(
                          { className: "headingDivider" },
                          {
                            children: (0, e.jsx)(
                              Gt,
                              HM(
                                { textAlign: "left" },
                                {
                                  children: (0, e.jsx)(
                                    ni,
                                    HM(
                                      { variant: Av, sx: Ko },
                                      { children: i("tab_CreateB2BOrder") }
                                    )
                                  ),
                                }
                              )
                            ),
                          }
                        )
                      ),
                      (0, e.jsx)(TM, {}),
                      (0, e.jsx)(EM, HM({}, u)),
                      (0, e.jsx)(ZM, {
                        orderCreatedSuccesfullyFlag: d,
                        setOrderCreatedSuccesfullyFlag: c,
                      }),
                    ],
                  }),
            }
          )
        );
      }
      function WM() {
        var t = ee().t,
          n = y(function (e) {
            return e.salesRepData ? e.salesRepData : {};
          }),
          r = n.baseData.select ? n.baseData.select : {},
          o = n.baseData,
          a =
            "SalesManager" ===
            (o && o.SingleSalesRep && o.SingleSalesRep.RepType);
        return [
          {
            index: 0,
            isActive: !0,
            icon: (0, e.jsx)(Da, {}),
            label: t("dashbord_Tab"),
            component: (0, e.jsx)(wT, {}),
          },
          {
            index: 1,
            isActive: r.CreateInvoice || r.CreateCheckout || r.CreateOrder,
            icon: (0, e.jsx)(Aa, {}),
            label: t("tab_CustomerInvoice"),
            component: (0, e.jsx)(iC, {}),
          },
          {
            index: 2,
            isActive: r.CreateB2BOrder,
            icon: w_,
            label: t("tab_CreateB2BOrder"),
            component: (0, e.jsx)(VM, {}),
          },
          {
            index: 3,
            isActive: r.AffiliateLink,
            icon: x_,
            label: r.microsites
              ? t("tab7_YourBio") + " & " + t("tab_AffiliateLink")
              : t("tab_AffiliateLink"),
            component: (0, e.jsx)(yM, {}),
          },
          {
            index: 4,
            isActive: r.CartSharing,
            icon: k_,
            label: t("tab_CartSharing"),
            component: (0, e.jsx)(V_, {}),
          },
          {
            index: 5,
            isActive: r.CouponeCode || r.SalesrepCoupon,
            icon: S_,
            label: t("tab_DiscountCoupon"),
            component: (0, e.jsx)(NT, {}),
          },
          {
            index: 6,
            isActive: !!r.referralpage && !!a,
            icon: (0, e.jsx)(Ea, {}),
            label: t("tab8_Team"),
            component: (0, e.jsx)(mM, {}),
          },
          {
            index: 7,
            isActive: r.Tagcustomer,
            icon: (0, e.jsx)(Ra, {}),
            label: t("tab_MyCustomers"),
            component: (0, e.jsx)(KT, {}),
          },
          {
            index: 8,
            isActive: !0,
            icon: (0, e.jsx)(La, {}),
            label: t("tab_YourSalesOrderDetails"),
            component: (0, e.jsx)(YI, {}),
          },
        ];
      }
      var UM = function () {
          return (
            (UM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            UM.apply(this, arguments)
          );
        },
        $M = function (n) {
          var r = g(),
            o = ee().t,
            a = function (e, t) {
              r({ payload: e, type: t });
            },
            i = function () {
              null == n || n.setOpenAlertBox(!1);
            };
          return (0, e.jsx)(t.Fragment, {
            children: (0, e.jsxs)(
              Hp,
              UM(
                {
                  open: null == n ? void 0 : n.openAlertBox,
                  onClose: i,
                  "aria-labelledby": "alert-dialog-title",
                  "aria-describedby": "alert-dialog-description",
                },
                {
                  children: [
                    (0, e.jsx)(
                      Lb,
                      UM(
                        { id: "alert-dialog-title" },
                        { children: o("alertBoxTitle") }
                      )
                    ),
                    (0, e.jsx)(Gp, {
                      children: (0, e.jsx)(
                        Zb,
                        UM(
                          { id: "alert-dialog-description" },
                          { children: o("alertMessage") }
                        )
                      ),
                    }),
                    (0, e.jsxs)(Jp, {
                      children: [
                        (0, e.jsx)(
                          Qu,
                          UM({ onClick: i }, { children: o("stayOnPageBtn") })
                        ),
                        (0, e.jsx)(
                          Qu,
                          UM(
                            {
                              onClick: function () {
                                a({}, A.CREATE_ORDER_TAB),
                                  a(
                                    {
                                      activeTabIndex:
                                        null == n ? void 0 : n.redirectTabIndex,
                                      actionEvent: Wg,
                                    },
                                    A.ACTIVE_TAB
                                  ),
                                  null == n || n.setOpenAlertBox(!1);
                              },
                            },
                            { children: o("leaveOnPageBtn") }
                          )
                        ),
                      ],
                    }),
                  ],
                }
              )
            ),
          });
        },
        KM = function () {
          return (
            (KM =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            KM.apply(this, arguments)
          );
        };
      function GM(n) {
        var r = (function (e) {
            var n,
              r,
              o,
              a,
              i,
              s,
              l,
              d,
              c = g(),
              u = (0, t.useState)(0),
              p = u[0],
              m = u[1],
              h =
                null !==
                  (r =
                    null === (n = F.getState().salesRepData) || void 0 === n
                      ? void 0
                      : n.activeTab) && void 0 !== r
                  ? r
                  : {},
              f =
                null !==
                  (a =
                    null === (o = F.getState().salesRepData) || void 0 === o
                      ? void 0
                      : o.editDraftOrder) && void 0 !== a
                  ? a
                  : {},
              v =
                null !==
                  (s =
                    null === (i = F.getState().salesRepData) || void 0 === i
                      ? void 0
                      : i.createOrderTab) && void 0 !== s
                  ? s
                  : {},
              b = (0, t.useState)(!1),
              _ = b[0],
              y = b[1],
              C = (0, t.useState)(0),
              x = C[0],
              S = C[1],
              k = (
                null !== (l = F.getState().salesRepData.productTableData) &&
                void 0 !== l
                  ? l
                  : []
              ).selectedProductData,
              P =
                null === (d = WM()) || void 0 === d
                  ? void 0
                  : d.filter(function (e) {
                      return e.isActive;
                    });
            (0, t.useEffect)(
              function () {
                1 === (null == h ? void 0 : h.activeTabIndex) &&
                  (null == h ? void 0 : h.actionEvent) === Zg &&
                  w(h.activeTabIndex),
                  1 !== (null == h ? void 0 : h.activeTabIndex) &&
                    (null == h ? void 0 : h.actionEvent) === Wg &&
                    w(h.activeTabIndex);
              },
              [h]
            );
            var w = function (t) {
                if (
                  (null == f ? void 0 : f.actionEvent) !== Zg &&
                  1 === (null == h ? void 0 : h.activeTabIndex) &&
                  ((null == v ? void 0 : v.customerName) ||
                    (null == v ? void 0 : v.productSelectedArrayLength) > 0 ||
                    (null == k ? void 0 : k.length) > 0)
                )
                  return S(t), y(!0);
                null == e || e.setActiveTab(P[t]),
                  m(t),
                  S(t),
                  ((null == f ? void 0 : f.actionEvent) === Zg && 1 === t) ||
                    O({}, A.EDIT_DRAFT_ORDER),
                  O({ activeTabIndex: t, actionEvent: "" }, A.ACTIVE_TAB);
              },
              O = function (e, t) {
                c({ payload: e, type: t });
              };
            return {
              handleChange: function () {
                null == e || e.setMobileOpen(!1);
              },
              componentIndex: p,
              handleChangeTab: w,
              tabsArray: P,
              a11yProps: function (e) {
                return {
                  id: "vertical-tab-".concat(e),
                  "aria-controls": "vertical-tabpanel-".concat(e),
                };
              },
              openAlertBox: _,
              setOpenAlertBox: y,
              redirectTabIndex: x,
            };
          })(n),
          o = r.handleChange,
          a = r.componentIndex,
          i = r.handleChangeTab,
          s = r.tabsArray,
          l = r.a11yProps,
          d = r.openAlertBox,
          c = r.setOpenAlertBox,
          u = r.redirectTabIndex;
        return (0, e.jsxs)(e.Fragment, {
          children: [
            (0, e.jsx)(
              Oa,
              KM(
                {
                  className: "navigation-Tabs",
                  orientation: "vertical",
                  variant: "scrollable",
                  value: a,
                  onChange: o,
                  "aria-label": "Vertical tabs example",
                },
                {
                  children:
                    null == s
                      ? void 0
                      : s.map(function (t, n) {
                          if (t.isActive)
                            return (0, e.jsx)(
                              Na,
                              KM(
                                {
                                  sx: {
                                    justifyContent: "wrap",
                                    textAlign: "left",
                                  },
                                  onClick: function () {
                                    i(n);
                                  },
                                  className: "navigation-Tab",
                                  icon: t.icon,
                                  iconPosition: "start",
                                  label: t.label,
                                },
                                l(t.index)
                              ),
                              t.index
                            );
                        }),
                }
              )
            ),
            (0, e.jsx)($M, {
              openAlertBox: d,
              setOpenAlertBox: c,
              redirectTabIndex: u,
            }),
          ],
        });
      }
      function qM(e) {
        return (0, Zt.ZP)("MuiAppBar", e);
      }
      (0, Ft.Z)("MuiAppBar", [
        "root",
        "positionFixed",
        "positionAbsolute",
        "positionSticky",
        "positionStatic",
        "positionRelative",
        "colorDefault",
        "colorPrimary",
        "colorSecondary",
        "colorInherit",
        "colorTransparent",
        "colorError",
        "colorInfo",
        "colorSuccess",
        "colorWarning",
      ]);
      const QM = ["className", "color", "enableColorOnDark", "position"],
        YM = (e, t) =>
          e ? `${null == e ? void 0 : e.replace(")", "")}, ${t})` : t,
        JM = (0, Bt.ZP)(go, {
          name: "MuiAppBar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[`position${(0, $n.Z)(n.position)}`],
              t[`color${(0, $n.Z)(n.color)}`],
            ];
          },
        })(({ theme: e, ownerState: t }) => {
          const n =
            "light" === e.palette.mode
              ? e.palette.grey[100]
              : e.palette.grey[900];
          return (0, u.Z)(
            {
              display: "flex",
              flexDirection: "column",
              width: "100%",
              boxSizing: "border-box",
              flexShrink: 0,
            },
            "fixed" === t.position && {
              position: "fixed",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
              "@media print": { position: "absolute" },
            },
            "absolute" === t.position && {
              position: "absolute",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
            },
            "sticky" === t.position && {
              position: "sticky",
              zIndex: (e.vars || e).zIndex.appBar,
              top: 0,
              left: "auto",
              right: 0,
            },
            "static" === t.position && { position: "static" },
            "relative" === t.position && { position: "relative" },
            !e.vars &&
              (0, u.Z)(
                {},
                "default" === t.color && {
                  backgroundColor: n,
                  color: e.palette.getContrastText(n),
                },
                t.color &&
                  "default" !== t.color &&
                  "inherit" !== t.color &&
                  "transparent" !== t.color && {
                    backgroundColor: e.palette[t.color].main,
                    color: e.palette[t.color].contrastText,
                  },
                "inherit" === t.color && { color: "inherit" },
                "dark" === e.palette.mode &&
                  !t.enableColorOnDark && {
                    backgroundColor: null,
                    color: null,
                  },
                "transparent" === t.color &&
                  (0, u.Z)(
                    { backgroundColor: "transparent", color: "inherit" },
                    "dark" === e.palette.mode && { backgroundImage: "none" }
                  )
              ),
            e.vars &&
              (0, u.Z)(
                {},
                "default" === t.color && {
                  "--AppBar-background": t.enableColorOnDark
                    ? e.vars.palette.AppBar.defaultBg
                    : YM(
                        e.vars.palette.AppBar.darkBg,
                        e.vars.palette.AppBar.defaultBg
                      ),
                  "--AppBar-color": t.enableColorOnDark
                    ? e.vars.palette.text.primary
                    : YM(
                        e.vars.palette.AppBar.darkColor,
                        e.vars.palette.text.primary
                      ),
                },
                t.color &&
                  !t.color.match(/^(default|inherit|transparent)$/) && {
                    "--AppBar-background": t.enableColorOnDark
                      ? e.vars.palette[t.color].main
                      : YM(
                          e.vars.palette.AppBar.darkBg,
                          e.vars.palette[t.color].main
                        ),
                    "--AppBar-color": t.enableColorOnDark
                      ? e.vars.palette[t.color].contrastText
                      : YM(
                          e.vars.palette.AppBar.darkColor,
                          e.vars.palette[t.color].contrastText
                        ),
                  },
                !["inherit", "transparent"].includes(t.color) && {
                  backgroundColor: "var(--AppBar-background)",
                },
                {
                  color:
                    "inherit" === t.color ? "inherit" : "var(--AppBar-color)",
                },
                "transparent" === t.color && {
                  backgroundImage: "none",
                  backgroundColor: "transparent",
                  color: "inherit",
                }
              )
          );
        }),
        XM = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiAppBar" }),
            {
              className: o,
              color: a = "primary",
              enableColorOnDark: i = !1,
              position: s = "fixed",
            } = r,
            l = (0, At.Z)(r, QM),
            d = (0, u.Z)({}, r, {
              color: a,
              position: s,
              enableColorOnDark: i,
            }),
            c = ((e) => {
              const { color: t, position: n, classes: r } = e,
                o = {
                  root: [
                    "root",
                    `color${(0, $n.Z)(t)}`,
                    `position${(0, $n.Z)(n)}`,
                  ],
                };
              return (0, Rt.Z)(o, qM, r);
            })(d);
          return (0,
          e.jsx)(JM, (0, u.Z)({ square: !0, component: "header", ownerState: d, elevation: 4, className: (0, Et.Z)(c.root, o, "fixed" === s && "mui-fixed"), ref: n }, l));
        });
      var ej = XM;
      function tj(e) {
        return (0, Zt.ZP)("MuiToolbar", e);
      }
      (0, Ft.Z)("MuiToolbar", ["root", "gutters", "regular", "dense"]);
      const nj = ["className", "component", "disableGutters", "variant"],
        rj = (0, Bt.ZP)("div", {
          name: "MuiToolbar",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, !n.disableGutters && t.gutters, t[n.variant]];
          },
        })(
          ({ theme: e, ownerState: t }) =>
            (0, u.Z)(
              { position: "relative", display: "flex", alignItems: "center" },
              !t.disableGutters && {
                paddingLeft: e.spacing(2),
                paddingRight: e.spacing(2),
                [e.breakpoints.up("sm")]: {
                  paddingLeft: e.spacing(3),
                  paddingRight: e.spacing(3),
                },
              },
              "dense" === t.variant && { minHeight: 48 }
            ),
          ({ theme: e, ownerState: t }) =>
            "regular" === t.variant && e.mixins.toolbar
        );
      var oj = t.forwardRef(function (t, n) {
          const r = (0, zt.i)({ props: t, name: "MuiToolbar" }),
            {
              className: o,
              component: a = "div",
              disableGutters: i = !1,
              variant: s = "regular",
            } = r,
            l = (0, At.Z)(r, nj),
            d = (0, u.Z)({}, r, {
              component: a,
              disableGutters: i,
              variant: s,
            }),
            c = ((e) => {
              const { classes: t, disableGutters: n, variant: r } = e,
                o = { root: ["root", !n && "gutters", r] };
              return (0, Rt.Z)(o, tj, t);
            })(d);
          return (0,
          e.jsx)(rj, (0, u.Z)({ as: a, className: (0, Et.Z)(c.root, o), ref: n, ownerState: d }, l));
        }),
        aj = [
          { name: "Eng (US)", code: "en" },
          { name: "Spanish", code: "es" },
          { name: "French", code: "fr" },
          { name: "Italian", code: "it" },
          { name: "Malay", code: "ms" },
          { name: "Swedish", code: "sv" },
          { name: "Portuguese", code: "pt" },
          { name: "German", code: "de" },
        ];
      function ij() {
        return (
          (ij = Object.assign
            ? Object.assign.bind()
            : function (e) {
                for (var t = 1; t < arguments.length; t++) {
                  var n = arguments[t];
                  for (var r in n)
                    Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
              }),
          ij.apply(this, arguments)
        );
      }
      var sj = ["cdnSuffix", "cdnUrl", "countryCode", "style", "svg"],
        lj = function (e) {
          var n = e.cdnSuffix,
            r = void 0 === n ? "svg" : n,
            o = e.cdnUrl,
            a =
              void 0 === o
                ? "https://cdn.jsdelivr.net/gh/lipis/flag-icons/flags/4x3/"
                : o,
            i = e.countryCode,
            s = e.style,
            l = e.svg,
            d = void 0 !== l && l,
            c = (function (e, t) {
              if (null == e) return {};
              var n,
                r,
                o = {},
                a = Object.keys(e);
              for (r = 0; r < a.length; r++)
                (n = a[r]), t.indexOf(n) >= 0 || (o[n] = e[n]);
              return o;
            })(e, sj);
          if ("string" != typeof i) return null;
          if (d) {
            var u = "" + a + i.toLowerCase() + "." + r;
            return (0, t.createElement)(
              "img",
              Object.assign({}, c, {
                src: u,
                style: ij(
                  {
                    display: "inline-block",
                    width: "1em",
                    height: "1em",
                    verticalAlign: "middle",
                  },
                  s
                ),
              })
            );
          }
          var p = i.toUpperCase().replace(/./g, function (e) {
            return String.fromCodePoint(e.charCodeAt(0) + 127397);
          });
          return (0, t.createElement)(
            "span",
            Object.assign({ role: "img" }, c, {
              style: ij(
                {
                  display: "inline-block",
                  fontSize: "1em",
                  lineHeight: "1em",
                  verticalAlign: "middle",
                },
                s
              ),
            }),
            p
          );
        },
        dj = function () {
          return (
            (dj =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            dj.apply(this, arguments)
          );
        };
      function cj(n) {
        var r,
          o,
          a = (0, t.useState)(
            (
              null === (r = Dt.language) || void 0 === r
                ? void 0
                : r.includes("-")
            )
              ? null === (o = Dt.language) || void 0 === o
                ? void 0
                : o.split("-")[0]
              : Dt.language
          ),
          i = a[0],
          s = a[1],
          l = Tv();
        return (0, e.jsx)(
          te,
          dj(
            { i18n: Dt },
            {
              children: (0, e.jsx)(mn, {
                children: (0, e.jsxs)(
                  yd,
                  dj(
                    {
                      fullWidth: !0,
                      sx: { mt: 1, minWidth: l ? 40 : 120 },
                      size: "small",
                    },
                    {
                      children: [
                        !i &&
                          (0, e.jsx)(
                            hd,
                            dj(
                              { htmlFor: "demo-select-small" },
                              { children: "Select Language" }
                            )
                          ),
                        (0, e.jsx)(
                          Rc,
                          dj(
                            {
                              labelId: "demo-select-small",
                              sx: dj(
                                { color: n.color, backgroundColor: "#F5F5F5" },
                                Uo
                              ),
                              onChange: function (e) {
                                s(e.target.value),
                                  Dt.changeLanguage(e.target.value);
                              },
                              value: i,
                            },
                            {
                              children:
                                null == aj
                                  ? void 0
                                  : aj.map(function (t, n) {
                                      return (0,
                                      e.jsx)(J_, dj({ value: null == t ? void 0 : t.code }, { children: (0, e.jsxs)(mn, dj({ sx: { display: "flex", alignItems: "center" } }, { children: [(0, e.jsx)(lj, { style: { marginRight: 8 }, countryCode: "en" === (null == t ? void 0 : t.code) ? "gb" : null == t ? void 0 : t.code, svg: !0 }), (0, e.jsx)(ni, { children: null == t ? void 0 : t.name })] })) }), n);
                                    }),
                            }
                          )
                        ),
                      ],
                    }
                  )
                ),
              }),
            }
          )
        );
      }
      var uj = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7M2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2m4.31-.78 3.15 3.15.02-.16c0-1.66-1.34-3-3-3z",
          }),
          "VisibilityOff"
        ),
        pj = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5M12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5m0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3",
          }),
          "Visibility"
        ),
        mj = function () {
          return (
            (mj =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            mj.apply(this, arguments)
          );
        },
        hj = function (e, t, n, r) {
          return new (n || (n = Promise))(function (o, a) {
            function i(e) {
              try {
                l(r.next(e));
              } catch (e) {
                a(e);
              }
            }
            function s(e) {
              try {
                l(r.throw(e));
              } catch (e) {
                a(e);
              }
            }
            function l(e) {
              var t;
              e.done
                ? o(e.value)
                : ((t = e.value),
                  t instanceof n
                    ? t
                    : new n(function (e) {
                        e(t);
                      })).then(i, s);
            }
            l((r = r.apply(e, t || [])).next());
          });
        },
        fj = function (e, t) {
          var n,
            r,
            o,
            a,
            i = {
              label: 0,
              sent: function () {
                if (1 & o[0]) throw o[1];
                return o[1];
              },
              trys: [],
              ops: [],
            };
          return (
            (a = { next: s(0), throw: s(1), return: s(2) }),
            "function" == typeof Symbol &&
              (a[Symbol.iterator] = function () {
                return this;
              }),
            a
          );
          function s(s) {
            return function (l) {
              return (function (s) {
                if (n) throw new TypeError("Generator is already executing.");
                for (; a && ((a = 0), s[0] && (i = 0)), i; )
                  try {
                    if (
                      ((n = 1),
                      r &&
                        (o =
                          2 & s[0]
                            ? r.return
                            : s[0]
                            ? r.throw || ((o = r.return) && o.call(r), 0)
                            : r.next) &&
                        !(o = o.call(r, s[1])).done)
                    )
                      return o;
                    switch (((r = 0), o && (s = [2 & s[0], o.value]), s[0])) {
                      case 0:
                      case 1:
                        o = s;
                        break;
                      case 4:
                        return i.label++, { value: s[1], done: !1 };
                      case 5:
                        i.label++, (r = s[1]), (s = [0]);
                        continue;
                      case 7:
                        (s = i.ops.pop()), i.trys.pop();
                        continue;
                      default:
                        if (
                          !(
                            (o = (o = i.trys).length > 0 && o[o.length - 1]) ||
                            (6 !== s[0] && 2 !== s[0])
                          )
                        ) {
                          i = 0;
                          continue;
                        }
                        if (
                          3 === s[0] &&
                          (!o || (s[1] > o[0] && s[1] < o[3]))
                        ) {
                          i.label = s[1];
                          break;
                        }
                        if (6 === s[0] && i.label < o[1]) {
                          (i.label = o[1]), (o = s);
                          break;
                        }
                        if (o && i.label < o[2]) {
                          (i.label = o[2]), i.ops.push(s);
                          break;
                        }
                        o[2] && i.ops.pop(), i.trys.pop();
                        continue;
                    }
                    s = t.call(e, i);
                  } catch (e) {
                    (s = [6, e]), (r = 0);
                  } finally {
                    n = o = 0;
                  }
                if (5 & s[0]) throw s[1];
                return { value: s[0] ? s[1] : void 0, done: !0 };
              })([s, l]);
            };
          }
        },
        gj = function () {
          return (
            (gj =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            gj.apply(this, arguments)
          );
        },
        vj = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a,
                i,
                s,
                l,
                d,
                c,
                u,
                p,
                m,
                h,
                f,
                v,
                b = this,
                _ = ee().t,
                C = EO(),
                x = C.loggedInRepData,
                S = C.getTimeZone,
                k = Tv(),
                P = g(),
                w = y(function (e) {
                  return e.salesRepData;
                }),
                O =
                  null === (e = null == w ? void 0 : w.loggedInRepDetails) ||
                  void 0 === e
                    ? void 0
                    : e.customerName,
                T = {
                  currentPassword: "",
                  newPassword: "",
                  confirmPassword: "",
                },
                I = (0, t.useState)(!1),
                M = I[0],
                j = I[1],
                N =
                  null ===
                    (r =
                      null === (n = w.baseData) || void 0 === n
                        ? void 0
                        : n.SingleSalesRep) || void 0 === r
                    ? void 0
                    : r.ProfileImagePath,
                D =
                  null ===
                    (a =
                      null === (o = null == w ? void 0 : w.baseData) ||
                      void 0 === o
                        ? void 0
                        : o.SingleSalesRep) || void 0 === a
                    ? void 0
                    : a.RepType,
                E =
                  null ===
                    (s =
                      null === (i = null == w ? void 0 : w.baseData) ||
                      void 0 === i
                        ? void 0
                        : i.SingleSalesRep) || void 0 === s
                    ? void 0
                    : s.SalesRepName,
                R =
                  null ===
                    (d =
                      null === (l = null == w ? void 0 : w.baseData) ||
                      void 0 === l
                        ? void 0
                        : l.SingleSalesRep) || void 0 === d
                    ? void 0
                    : d.SalesRepLastName,
                L = "".concat(E || "", " ").concat(R || ""),
                B =
                  null === (c = null == w ? void 0 : w.baseData) || void 0 === c
                    ? void 0
                    : c.SingleSalesRep,
                z = (0, t.useState)(T),
                F = z[0],
                Z = z[1],
                H = (0, t.useState)({
                  currentPasswordErrMsg: "",
                  newPasswordErrMsg: "",
                  confirmPasswordErrMsg: "",
                }),
                V = H[0],
                W = H[1],
                U =
                  (null === (u = F.currentPassword) || void 0 === u
                    ? void 0
                    : u.length) > 0 &&
                  (null === (p = F.newPassword) || void 0 === p
                    ? void 0
                    : p.length) > 0 &&
                  (null === (m = F.confirmPassword) || void 0 === m
                    ? void 0
                    : m.length) > 0 &&
                  "" === V.currentPasswordErrMsg &&
                  "" === V.newPasswordErrMsg &&
                  "" === V.confirmPasswordErrMsg,
                $ = (0, t.useState)(!1),
                K = $[0],
                G = $[1],
                q = (0, t.useState)(!1),
                Q = q[0],
                Y = q[1],
                J = (0, t.useState)({ successMsg: "", errorMsg: "" }),
                X = J[0],
                te = J[1],
                ne = {
                  isLoading: !1,
                  imageName: "",
                  imagePreview: Ov(null == B ? void 0 : B.ProfileImagePath)
                    ? ""
                    : B.ProfileImagePath,
                  imageSize: 0,
                },
                re = (0, t.useState)({
                  currentPassword: !1,
                  newPassword: !1,
                  confirmPassword: !1,
                }),
                oe = re[0],
                ae = re[1],
                ie = (0, t.useRef)(null),
                se = (0, t.useState)(""),
                le = se[0],
                de = se[1],
                ce = (0, t.useState)(!1),
                ue = ce[0],
                pe = ce[1],
                me = (0, t.useState)(!1),
                he = me[0],
                fe = me[1],
                ge = (0, t.useState)(),
                ve = ge[0],
                be = ge[1],
                _e = (0, t.useState)(!1),
                ye = _e[0],
                Ce = _e[1],
                xe = (0, t.useState)(ne),
                Se = xe[0],
                ke = xe[1],
                Pe = (0, t.useState)(_("yourBio_button2")),
                we = Pe[0],
                Oe = Pe[1],
                Te = (0, t.useState)(!1),
                Ie = Te[0],
                Me = Te[1],
                je = (0, t.useState)(!1),
                Ne = je[0],
                De = je[1],
                Ae = Se.imagePreview,
                Ee =
                  null !==
                    (f =
                      null === (h = w.baseData) || void 0 === h
                        ? void 0
                        : h.ShopBusinessName) && void 0 !== f
                    ? f
                    : null === (v = null == x ? void 0 : x.shopName) ||
                      void 0 === v
                    ? void 0
                    : v.replace(/.myshopify.com/g, ""),
                Re = function () {
                  return hj(b, void 0, void 0, function () {
                    var e;
                    return fj(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return Y(!0), [4, P(Tg(F))];
                        case 1:
                          return (
                            200 == (null == (e = t.sent()) ? void 0 : e.status)
                              ? (G(!0),
                                te({ errorMsg: "", successMsg: e.message }),
                                W({
                                  currentPasswordErrMsg: "",
                                  newPasswordErrMsg: "",
                                  confirmPasswordErrMsg: "",
                                }),
                                Z(T))
                              : te({ successMsg: "", errorMsg: e.message }),
                            Y(!1),
                            [2]
                          );
                      }
                    });
                  });
                };
              return {
                loggedInRepData: x,
                getTimeZone: S,
                repName: O,
                propsColor: { color: "black" },
                passwordDialog: M,
                profileSrc: N,
                updatePasswordSuccess: K,
                restLoadingFlag: Q,
                passwordErrMsg: X,
                userLogout: function () {
                  return hj(b, void 0, void 0, function () {
                    var e;
                    return fj(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return (
                            sessionStorage.setItem("Authorization", ""),
                            Zh.next(!1),
                            sessionStorage.clear(),
                            (e = { payload: "", type: A.RESET_INITIAL_STATE }),
                            [4, P(e)]
                          );
                        case 1:
                          return t.sent(), [2];
                      }
                    });
                  });
                },
                stringAvatar: function (e) {
                  return {
                    sx: {
                      bgcolor: "#d0f4ff",
                      color: "#1976d2",
                      fontSize: "1rem",
                      borderRadius: "50%",
                    },
                    children: ""
                      .concat(null == e ? void 0 : e.split(" ")[0][0])
                      .concat(null == e ? void 0 : e.split(" ")[1][0]),
                  };
                },
                changeFormValue: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  Z(mj(mj({}, F), (((t = {})[r] = o), t))),
                    (function (e, t) {
                      var n;
                      switch (e) {
                        case "":
                          "" === t
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  currentPasswordErrMsg: _(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : t.match(Mb)
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  currentPasswordErrMsg: "",
                                });
                              })
                            : W(function (e) {
                                return mj(mj({}, e), {
                                  currentPasswordErrMsg: _(
                                    "resetPassword_validation_Msg2"
                                  ),
                                });
                              });
                          break;
                        case "newPassword":
                          "" === t
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  newPasswordErrMsg: _(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : Ab.test(t)
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  newPasswordErrMsg: _(
                                    "Special characters like @,#,!,$,& are not allowed in the password"
                                  ),
                                });
                              })
                            : t.match(Mb)
                            ? W(function (e) {
                                return mj(mj({}, e), { newPasswordErrMsg: "" });
                              })
                            : W(function (e) {
                                return mj(mj({}, e), {
                                  newPasswordErrMsg: _(
                                    "resetPassword_validation_Msg2"
                                  ),
                                });
                              }),
                            t !== F.confirmPassword &&
                            (null === (n = F.confirmPassword) || void 0 === n
                              ? void 0
                              : n.length) > 0
                              ? W(function (e) {
                                  return mj(mj({}, e), {
                                    confirmPasswordErrMsg: _(
                                      "resetPassword_validation_Msg3"
                                    ),
                                  });
                                })
                              : W(function (e) {
                                  return mj(mj({}, e), {
                                    confirmPasswordErrMsg: "",
                                  });
                                });
                          break;
                        case "confirmPassword":
                          "" === t
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  confirmPasswordErrMsg: _(
                                    "resetPassword_validation_Msg"
                                  ),
                                });
                              })
                            : t === F.newPassword
                            ? W(function (e) {
                                return mj(mj({}, e), {
                                  confirmPasswordErrMsg: "",
                                });
                              })
                            : W(function (e) {
                                return mj(mj({}, e), {
                                  confirmPasswordErrMsg: _(
                                    "resetPassword_validation_Msg3"
                                  ),
                                });
                              });
                      }
                    })(r, o);
                },
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && U && Re();
                },
                resetPassword: Re,
                clearFormValues: function () {
                  j(!1),
                    Z(T),
                    G(!1),
                    te({ successMsg: "", errorMsg: "" }),
                    W({
                      currentPasswordErrMsg: "",
                      newPasswordErrMsg: "",
                      confirmPasswordErrMsg: "",
                    });
                },
                viewProps: {
                  noWrap: !0,
                  flexGrow: 1,
                  sx: {
                    fontWeight: k ? 700 : 610,
                    textDecoration: "none",
                    display: k
                      ? { xs: "flex", md: "none" }
                      : { xs: "none", md: "flex" },
                    fontSize: k ? "14px" : "16px",
                    fontFamily: "Segoe UI",
                    backgroundColor: "#FFF",
                  },
                },
                handlePasswordDialogOpen: function () {
                  j(!0);
                },
                passwordForm: F,
                resetBtnEnabled: U,
                formErrMsg: V,
                t: _,
                isMobile: k,
                repFullName: L,
                repType: D,
                openCommissionDialog: Ne,
                setOpenCommissionDialog: De,
                isImageInput: he,
                showNewImage: ye,
                profile: w,
                uploadInputImage: ie,
                setImage: ke,
                image: Se,
                uploadImageState: we,
                imageLoading: Ie,
                handleUploadImage: function (e) {
                  var t = e.target.files;
                  return hj(b, void 0, void 0, function () {
                    var e;
                    return fj(this, function (n) {
                      return (
                        de(""),
                        pe(!1),
                        Ov((e = t[0])) ||
                          (e.size < 5e6
                            ? (ke(function (e) {
                                return mj(mj({}, e), { isLoading: !0 });
                              }),
                              be(e),
                              Ce(!0),
                              ke(function (t) {
                                return mj(mj({}, t), {
                                  imageName: e.name,
                                  imagePreview: URL.createObjectURL(e),
                                  imageSize: e.size,
                                  isLoading: !1,
                                });
                              }))
                            : (setTimeout(function () {
                                pe(!1);
                              }, 3e3),
                              pe(!0),
                              de(_("yourBio_error_image_size")),
                              ke(ne),
                              (ie.current.value = null))),
                        [2]
                      );
                    });
                  });
                },
                uploadImage: function () {
                  return hj(b, void 0, void 0, function () {
                    var e;
                    return fj(this, function (t) {
                      switch (t.label) {
                        case 0:
                          return (
                            Oe(_("yourBio_Uploadbtn1")),
                            Me(!0),
                            de(""),
                            pe(!1),
                            fe(!0),
                            !Ov(ve) &&
                            Se.imageSize < 5e6 &&
                            "" !== Se.imagePreview
                              ? (e = ve)
                                ? [4, P(xg(ve))]
                                : [3, 2]
                              : [3, 3]
                          );
                        case 1:
                          (e = t.sent()), (t.label = 2);
                        case 2:
                          return (
                            e
                              ? (Oe(_("yourBio_Uploadbtn2")),
                                ke(function (e) {
                                  return mj(mj({}, e), { isLoading: !1 });
                                }),
                                de(""),
                                pe(!1))
                              : (pe(!0),
                                ke(ne),
                                (ie.current.value = null),
                                Oe(_("yourBio_button2")),
                                de(_("addCustomer_leadErrrorMsg"))),
                            [3, 4]
                          );
                        case 3:
                          de(_("yourBio_error_image_size")),
                            pe(!0),
                            Ce(!1),
                            ke(ne),
                            (ie.current.value = null),
                            (t.label = 4);
                        case 4:
                          return (
                            setTimeout(function () {
                              pe(!1);
                            }, 3e3),
                            Ce(!1),
                            Me(!1),
                            fe(!1),
                            [2]
                          );
                      }
                    });
                  });
                },
                helperImage: le,
                imageError: ue,
                imagePreview: Ae,
                profilePic: B,
                showPassword: oe,
                handleTogglePassword: function (e) {
                  ae(function (t) {
                    var n;
                    return mj(mj({}, t), (((n = {})[e] = !t[e]), n));
                  });
                },
                ShopBusinessName: Ee,
              };
            })(),
            r = (n.loggedInRepData, n.getTimeZone),
            o = n.propsColor,
            a = n.passwordDialog,
            i = n.profileSrc,
            s = n.updatePasswordSuccess,
            l = n.restLoadingFlag,
            d = n.passwordErrMsg,
            c = n.userLogout,
            u = n.stringAvatar,
            p = n.changeFormValue,
            m = n.handleKeyDown,
            h = n.resetPassword,
            f = n.clearFormValues,
            v = n.viewProps,
            b = n.handlePasswordDialogOpen,
            _ = n.passwordForm,
            C = n.resetBtnEnabled,
            x = n.formErrMsg,
            S = n.t,
            k = n.isMobile,
            P = n.repFullName,
            w = n.repType,
            O = n.openCommissionDialog,
            T = n.setOpenCommissionDialog,
            I = n.isImageInput,
            M = n.showNewImage,
            j = n.uploadInputImage,
            N = n.setImage,
            D = n.uploadImageState,
            E = n.imageLoading,
            R = n.handleUploadImage,
            L = n.uploadImage,
            B = n.helperImage,
            z = n.imageError,
            F = n.imagePreview,
            Z = n.profilePic,
            H = n.showPassword,
            V = n.handleTogglePassword,
            W = n.ShopBusinessName,
            U = af(),
            $ = U.SalesRepName,
            K = U.SalesRepLastName;
          return (
            (0, t.useEffect)(function () {
              if (!Ov(Z)) {
                var e = null == Z ? void 0 : Z.ProfileImagePath;
                N(function (t) {
                  return gj(gj({}, t), { imagePreview: e, isLoading: !1 });
                });
              }
            }, []),
            (0, e.jsx)(
              ej,
              gj(
                {
                  position: "absolute",
                  elevation: 0,
                  sx: {
                    backgroundColor: "#FFF",
                    borderBottom: "0.7px solid #ccc",
                    zIndex: 10,
                  },
                },
                {
                  children: (0, e.jsx)(
                    oM,
                    gj(
                      { maxWidth: "xl" },
                      {
                        children: (0, e.jsxs)(
                          oj,
                          gj(
                            { disableGutters: !0 },
                            {
                              children: [
                                (0, e.jsxs)(
                                  ni,
                                  gj(
                                    {},
                                    v,
                                    { className: "ST_link_FontColor" },
                                    { children: [S("tab_Dashboard"), " "] }
                                  )
                                ),
                                (0, e.jsxs)(
                                  mn,
                                  gj(
                                    { className: "Language_Selector", sx: Wo },
                                    {
                                      children: [
                                        " ",
                                        (0, e.jsx)(cj, gj({}, o)),
                                        " ",
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  mn,
                                  gj(
                                    { className: "Welcome_Message", sx: Wo },
                                    {
                                      children: [
                                        r(),
                                        " ",
                                        $,
                                        " ",
                                        K,
                                        " ! ",
                                        W
                                          ? " "
                                              .concat(
                                                S("dashboard_welcomeMsg"),
                                                " "
                                              )
                                              .concat(W)
                                          : "",
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsxs)(
                                  mn,
                                  gj(
                                    {
                                      sx: {
                                        flexGrow: 0,
                                        display: "flex",
                                        alignItems: "center",
                                        mt: k ? 0 : 1,
                                      },
                                    },
                                    {
                                      children: [
                                        i
                                          ? (0, e.jsx)(lb, {
                                              sx: {
                                                borderRadius: "50%",
                                                width: "30px",
                                                height: "30px",
                                              },
                                              alt: "",
                                              src: i,
                                            })
                                          : P
                                          ? (0, e.jsx)(lb, gj({}, u(P)))
                                          : (0, e.jsx)(lb, {
                                              src: "/broken-image.jpg",
                                            }),
                                        !k &&
                                          (0, e.jsxs)(
                                            mn,
                                            gj(
                                              { sx: { ml: 0.5 } },
                                              {
                                                children: [
                                                  " ",
                                                  (0, e.jsx)(
                                                    ni,
                                                    gj(
                                                      {
                                                        sx: {
                                                          fontSize: k
                                                            ? "10px"
                                                            : "14px",
                                                          width: k
                                                            ? "70px"
                                                            : "auto",
                                                          overflow: "hidden",
                                                          whiteSpace: "nowrap",
                                                        },
                                                        className:
                                                          "ST_Nav_FullNameColor",
                                                      },
                                                      { children: P }
                                                    )
                                                  ),
                                                  " ",
                                                  (0, e.jsx)(
                                                    ni,
                                                    gj(
                                                      {
                                                        sx: {
                                                          fontSize: k
                                                            ? "8px"
                                                            : "10px",
                                                        },
                                                        className:
                                                          "ST_Nav_repNameColor",
                                                      },
                                                      { children: w }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                        (0, e.jsx)(
                                          yd,
                                          gj(
                                            {
                                              fullWidth: !0,
                                              sx: { maxWidth: k ? 25 : 30 },
                                              size: k ? "small" : "medium",
                                            },
                                            {
                                              children: (0, e.jsxs)(
                                                Rc,
                                                gj(
                                                  {
                                                    sx: gj(
                                                      {
                                                        py: k ? 1 : 0,
                                                        pl: k ? 1 : 0,
                                                        pr: k ? 0 : 1,
                                                      },
                                                      Uo
                                                    ),
                                                    MenuProps: {
                                                      PaperProps: {
                                                        style: { width: 150 },
                                                      },
                                                    },
                                                  },
                                                  {
                                                    children: [
                                                      (0, e.jsx)(
                                                        J_,
                                                        gj(
                                                          {
                                                            className:
                                                              "ST_NAVBAR_Menu",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              ni,
                                                              gj(
                                                                {
                                                                  className:
                                                                    "ST_NAVBAR_Menu_Items",
                                                                  onClick: b,
                                                                },
                                                                {
                                                                  children: [
                                                                    " ",
                                                                    S(
                                                                      "profile_Change_Password"
                                                                    ),
                                                                    " ",
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(
                                                        J_,
                                                        gj(
                                                          {
                                                            className:
                                                              "ST_NAVBAR_Menu",
                                                          },
                                                          {
                                                            children: (0,
                                                            e.jsx)(
                                                              ni,
                                                              gj(
                                                                {
                                                                  className:
                                                                    "ST_NAVBAR_Menu_Items",
                                                                  onClick:
                                                                    function () {
                                                                      T(!0);
                                                                    },
                                                                },
                                                                {
                                                                  children: S(
                                                                    "dashbord_profile_pic"
                                                                  ),
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                      (0, e.jsx)(J_, {
                                                        children: (0, e.jsxs)(
                                                          ni,
                                                          gj(
                                                            {
                                                              onClick: c,
                                                              className:
                                                                "ST_NAVBAR_Menu_Items",
                                                            },
                                                            {
                                                              children: [
                                                                " ",
                                                                S(
                                                                  "tab13_Logout"
                                                                ),
                                                                " ",
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      }),
                                                    ],
                                                  }
                                                )
                                              ),
                                            }
                                          )
                                        ),
                                      ],
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Hp,
                                  gj(
                                    {
                                      open: a,
                                      onClose: f,
                                      maxWidth: "sm",
                                      fullWidth: !0,
                                      className: "Dialog_Border_Radius",
                                    },
                                    {
                                      children: (0, e.jsxs)(mn, {
                                        children: [
                                          (0, e.jsxs)(
                                            qa,
                                            gj(
                                              {
                                                container: !0,
                                                spacing: 2,
                                                className:
                                                  "ST_Dialog_Box_Padding",
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    qa,
                                                    gj(
                                                      {
                                                        item: !0,
                                                        xs: 10,
                                                        md: 10,
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          ni,
                                                          gj(
                                                            { variant: "h6" },
                                                            {
                                                              children: (0,
                                                              e.jsx)("b", {
                                                                children: S(
                                                                  "profile_Change_Password"
                                                                ),
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    qa,
                                                    gj(
                                                      {
                                                        item: !0,
                                                        xs: 2,
                                                        md: 2,
                                                        sx: {
                                                          textAlign: "right",
                                                        },
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          Fg,
                                                          {
                                                            sx: {
                                                              cursor: "pointer",
                                                              fill: "grey",
                                                            },
                                                            onClick: f,
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                          (0, e.jsx)("hr", {}),
                                          (0, e.jsx)(
                                            Gp,
                                            gj(
                                              {
                                                hidden: s,
                                                className:
                                                  "ST_Dialog_Box_Padding",
                                              },
                                              {
                                                children: (0, e.jsxs)(
                                                  qa,
                                                  gj(
                                                    { container: !0 },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          qa,
                                                          gj(
                                                            {
                                                              item: !0,
                                                              xs: 12,
                                                              md: 12,
                                                              mb: 3,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Hc, {
                                                                type: (
                                                                  null == H
                                                                    ? void 0
                                                                    : H.currentPassword
                                                                )
                                                                  ? "text"
                                                                  : "password",
                                                                name: "currentPassword",
                                                                label:
                                                                  "Current Password",
                                                                value:
                                                                  null == _
                                                                    ? void 0
                                                                    : _.currentPassword,
                                                                fullWidth: !0,
                                                                onChange: p,
                                                                error:
                                                                  "" !==
                                                                  (null == x
                                                                    ? void 0
                                                                    : x.currentPasswordErrMsg),
                                                                helperText:
                                                                  null == x
                                                                    ? void 0
                                                                    : x.currentPasswordErrMsg,
                                                                onKeyDown: m,
                                                                required: !0,
                                                                InputProps: {
                                                                  endAdornment:
                                                                    (null == _
                                                                      ? void 0
                                                                      : _.currentPassword) &&
                                                                    (0, e.jsx)(
                                                                      Bu,
                                                                      gj(
                                                                        {
                                                                          position:
                                                                            "end",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Jn,
                                                                              gj(
                                                                                {
                                                                                  "aria-label":
                                                                                    "toggle password visibility",
                                                                                  onClick:
                                                                                    function () {
                                                                                      return V(
                                                                                        "currentPassword"
                                                                                      );
                                                                                    },
                                                                                  edge: "end",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (
                                                                                      null ==
                                                                                      H
                                                                                        ? void 0
                                                                                        : H.currentPassword
                                                                                    )
                                                                                      ? (0,
                                                                                        e.jsx)(
                                                                                          uj,
                                                                                          {}
                                                                                        )
                                                                                      : (0,
                                                                                        e.jsx)(
                                                                                          pj,
                                                                                          {}
                                                                                        ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          qa,
                                                          gj(
                                                            {
                                                              item: !0,
                                                              xs: 12,
                                                              md: 12,
                                                              mb: 3,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Hc, {
                                                                type: (
                                                                  null == H
                                                                    ? void 0
                                                                    : H.newPassword
                                                                )
                                                                  ? "text"
                                                                  : "password",
                                                                name: "newPassword",
                                                                label:
                                                                  "New Password",
                                                                value:
                                                                  null == _
                                                                    ? void 0
                                                                    : _.newPassword,
                                                                fullWidth: !0,
                                                                onChange: p,
                                                                error:
                                                                  "" !==
                                                                  (null == x
                                                                    ? void 0
                                                                    : x.newPasswordErrMsg),
                                                                helperText:
                                                                  null == x
                                                                    ? void 0
                                                                    : x.newPasswordErrMsg,
                                                                onKeyDown: m,
                                                                required: !0,
                                                                InputProps: {
                                                                  endAdornment:
                                                                    (null == _
                                                                      ? void 0
                                                                      : _.newPassword) &&
                                                                    (0, e.jsx)(
                                                                      Bu,
                                                                      gj(
                                                                        {
                                                                          position:
                                                                            "end",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Jn,
                                                                              gj(
                                                                                {
                                                                                  "aria-label":
                                                                                    "toggle password visibility",
                                                                                  onClick:
                                                                                    function () {
                                                                                      return V(
                                                                                        "newPassword"
                                                                                      );
                                                                                    },
                                                                                  edge: "end",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (
                                                                                      null ==
                                                                                      H
                                                                                        ? void 0
                                                                                        : H.newPassword
                                                                                    )
                                                                                      ? (0,
                                                                                        e.jsx)(
                                                                                          uj,
                                                                                          {}
                                                                                        )
                                                                                      : (0,
                                                                                        e.jsx)(
                                                                                          pj,
                                                                                          {}
                                                                                        ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          qa,
                                                          gj(
                                                            {
                                                              item: !0,
                                                              xs: 12,
                                                              md: 12,
                                                              mb: 1,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(Hc, {
                                                                type: (
                                                                  null == H
                                                                    ? void 0
                                                                    : H.confirmPassword
                                                                )
                                                                  ? "text"
                                                                  : "password",
                                                                name: "confirmPassword",
                                                                label:
                                                                  "Confirm Password",
                                                                value:
                                                                  null == _
                                                                    ? void 0
                                                                    : _.confirmPassword,
                                                                fullWidth: !0,
                                                                onChange: p,
                                                                error:
                                                                  "" !==
                                                                  (null == x
                                                                    ? void 0
                                                                    : x.confirmPasswordErrMsg),
                                                                helperText:
                                                                  null == x
                                                                    ? void 0
                                                                    : x.confirmPasswordErrMsg,
                                                                onKeyDown: m,
                                                                required: !0,
                                                                InputProps: {
                                                                  endAdornment:
                                                                    (null == _
                                                                      ? void 0
                                                                      : _.confirmPassword) &&
                                                                    (0, e.jsx)(
                                                                      Bu,
                                                                      gj(
                                                                        {
                                                                          position:
                                                                            "end",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Jn,
                                                                              gj(
                                                                                {
                                                                                  "aria-label":
                                                                                    "toggle password visibility",
                                                                                  onClick:
                                                                                    function () {
                                                                                      return V(
                                                                                        "confirmPassword"
                                                                                      );
                                                                                    },
                                                                                  edge: "end",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    (
                                                                                      null ==
                                                                                      H
                                                                                        ? void 0
                                                                                        : H.confirmPassword
                                                                                    )
                                                                                      ? (0,
                                                                                        e.jsx)(
                                                                                          uj,
                                                                                          {}
                                                                                        )
                                                                                      : (0,
                                                                                        e.jsx)(
                                                                                          pj,
                                                                                          {}
                                                                                        ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          !s &&
                                            (0, e.jsxs)(e.Fragment, {
                                              children: [
                                                (0, e.jsx)("hr", {}),
                                                (0, e.jsx)(
                                                  Jp,
                                                  gj(
                                                    {
                                                      className:
                                                        "ST_Dialog_Box_Padding",
                                                    },
                                                    {
                                                      children: (0, e.jsx)(
                                                        ni,
                                                        gj(
                                                          { component: "div" },
                                                          {
                                                            children: (0,
                                                            e.jsx)(
                                                              Ym,
                                                              gj(
                                                                {
                                                                  loading: l,
                                                                  disabled: !C,
                                                                  variant:
                                                                    "contained",
                                                                  style: {
                                                                    textTransform:
                                                                      "capitalize",
                                                                  },
                                                                  onClick: h,
                                                                },
                                                                {
                                                                  children:
                                                                    S(
                                                                      "forgotPwd_ResetBtn"
                                                                    ),
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              ],
                                            }),
                                          (0, e.jsx)(
                                            "div",
                                            gj(
                                              { className: "ST_Text_Right" },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  gj(
                                                    {
                                                      variant: "subtitle1",
                                                      className:
                                                        "ST_Dialog_Box_Padding ST_Error_Msg_Color",
                                                      hidden: "" === d.errorMsg,
                                                    },
                                                    { children: d.errorMsg }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Gp,
                                            gj(
                                              {
                                                className:
                                                  "ST_Dialog_Box_Padding ST_ResetPassword",
                                                hidden: "" === d.successMsg,
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  gj(
                                                    {
                                                      variant: "body1",
                                                      sx: {
                                                        padding: "0px 17px",
                                                      },
                                                      className:
                                                        "ST_Error_SuccessMsg_Color",
                                                    },
                                                    { children: d.successMsg }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }),
                                    }
                                  )
                                ),
                                (0, e.jsx)(
                                  Hp,
                                  gj(
                                    {
                                      open: O,
                                      onClose: function () {
                                        return T(!1);
                                      },
                                      maxWidth: "sm",
                                      fullWidth: !0,
                                      className: "Dialog_Border_Radius",
                                    },
                                    {
                                      children: (0, e.jsxs)(mn, {
                                        children: [
                                          (0, e.jsxs)(
                                            qa,
                                            gj(
                                              {
                                                container: !0,
                                                spacing: 2,
                                                className:
                                                  "ST_Dialog_Box_Padding",
                                              },
                                              {
                                                children: [
                                                  (0, e.jsx)(
                                                    qa,
                                                    gj(
                                                      {
                                                        item: !0,
                                                        xs: 10,
                                                        md: 10,
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          ni,
                                                          gj(
                                                            { variant: "h6" },
                                                            {
                                                              children: (0,
                                                              e.jsx)("b", {
                                                                children: S(
                                                                  "dashbord_profile_pic"
                                                                ),
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                  (0, e.jsx)(
                                                    qa,
                                                    gj(
                                                      {
                                                        item: !0,
                                                        xs: 2,
                                                        md: 2,
                                                        sx: {
                                                          textAlign: "right",
                                                        },
                                                      },
                                                      {
                                                        children: (0, e.jsx)(
                                                          Fg,
                                                          {
                                                            sx: {
                                                              cursor: "pointer",
                                                              fill: "grey",
                                                            },
                                                            onClick:
                                                              function () {
                                                                T(!1);
                                                              },
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  ),
                                                ],
                                              }
                                            )
                                          ),
                                          (0, e.jsx)("hr", {}),
                                          (0, e.jsx)(
                                            Gp,
                                            gj(
                                              {
                                                className:
                                                  "ST_Dialog_Box_Padding",
                                              },
                                              {
                                                children: (0, e.jsxs)(
                                                  qa,
                                                  gj(
                                                    {
                                                      container: !0,
                                                      direction: "column",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          qa,
                                                          gj(
                                                            {
                                                              item: !0,
                                                              columns: {
                                                                lg: 3,
                                                              },
                                                              justifyContent:
                                                                "center",
                                                              alignItems:
                                                                "center",
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsxs)(
                                                                qa,
                                                                gj(
                                                                  {
                                                                    container:
                                                                      !0,
                                                                    direction:
                                                                      "column",
                                                                    justifyContent:
                                                                      "center",
                                                                    alignItems:
                                                                      "center",
                                                                  },
                                                                  {
                                                                    children: [
                                                                      (0,
                                                                      e.jsx)(
                                                                        "input",
                                                                        {
                                                                          accept:
                                                                            "image/jpeg,image/gif,image/png",
                                                                          style:
                                                                            {
                                                                              display:
                                                                                "none",
                                                                            },
                                                                          disabled:
                                                                            I,
                                                                          id: "button-file",
                                                                          type: "file",
                                                                          ref: j,
                                                                          onChange:
                                                                            R,
                                                                        }
                                                                      ),
                                                                      (0,
                                                                      e.jsx)(
                                                                        "label",
                                                                        gj(
                                                                          {
                                                                            htmlFor:
                                                                              "button-file",
                                                                            style:
                                                                              {
                                                                                cursor:
                                                                                  "pointer",
                                                                              },
                                                                          },
                                                                          {
                                                                            children:
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                {
                                                                                  children:
                                                                                    F
                                                                                      ? (0,
                                                                                        e.jsx)(
                                                                                          e.Fragment,
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                zg,
                                                                                                gj(
                                                                                                  {
                                                                                                    overlap:
                                                                                                      "circular",
                                                                                                    anchorOrigin:
                                                                                                      {
                                                                                                        vertical:
                                                                                                          "bottom",
                                                                                                        horizontal:
                                                                                                          "right",
                                                                                                      },
                                                                                                    badgeContent:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "div",
                                                                                                        gj(
                                                                                                          {
                                                                                                            style:
                                                                                                              Go,
                                                                                                          },
                                                                                                          {
                                                                                                            children:
                                                                                                              (0,
                                                                                                              e.jsx)(
                                                                                                                hM,
                                                                                                                {
                                                                                                                  style:
                                                                                                                    {
                                                                                                                      color:
                                                                                                                        "#1976d2",
                                                                                                                    },
                                                                                                                  fontSize:
                                                                                                                    "large",
                                                                                                                }
                                                                                                              ),
                                                                                                          }
                                                                                                        )
                                                                                                      ),
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        lb,
                                                                                                        {
                                                                                                          alt: "CSS",
                                                                                                          src: F,
                                                                                                          sx: {
                                                                                                            width: 200,
                                                                                                            height: 200,
                                                                                                          },
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      : (0,
                                                                                        e.jsx)(
                                                                                          zg,
                                                                                          gj(
                                                                                            {
                                                                                              overlap:
                                                                                                "circular",
                                                                                              anchorOrigin:
                                                                                                {
                                                                                                  vertical:
                                                                                                    "bottom",
                                                                                                  horizontal:
                                                                                                    "right",
                                                                                                },
                                                                                              badgeContent:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  "div",
                                                                                                  gj(
                                                                                                    {
                                                                                                      style:
                                                                                                        Go,
                                                                                                    },
                                                                                                    {
                                                                                                      children:
                                                                                                        (0,
                                                                                                        e.jsx)(
                                                                                                          hM,
                                                                                                          {
                                                                                                            style:
                                                                                                              {
                                                                                                                color:
                                                                                                                  "#1976d2",
                                                                                                              },
                                                                                                            fontSize:
                                                                                                              "large",
                                                                                                          }
                                                                                                        ),
                                                                                                    }
                                                                                                  )
                                                                                                ),
                                                                                            },
                                                                                            {
                                                                                              children:
                                                                                                (0,
                                                                                                e.jsx)(
                                                                                                  lb,
                                                                                                  {
                                                                                                    alt: "CSS",
                                                                                                    sx: {
                                                                                                      width: 200,
                                                                                                      height: 200,
                                                                                                    },
                                                                                                  }
                                                                                                ),
                                                                                            }
                                                                                          )
                                                                                        ),
                                                                                }
                                                                              ),
                                                                          }
                                                                        )
                                                                      ),
                                                                      z
                                                                        ? (0,
                                                                          e.jsx)(
                                                                            ni,
                                                                            gj(
                                                                              {
                                                                                variant:
                                                                                  "body2",
                                                                                className:
                                                                                  "ST_Error_Msg_Color",
                                                                                style:
                                                                                  {
                                                                                    marginTop:
                                                                                      "revert",
                                                                                  },
                                                                              },
                                                                              {
                                                                                children:
                                                                                  B,
                                                                              }
                                                                            )
                                                                          )
                                                                        : "",
                                                                    ],
                                                                  }
                                                                )
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsxs)(
                                                          ni,
                                                          gj(
                                                            {
                                                              variant: "h6",
                                                              mt: 1,
                                                            },
                                                            {
                                                              children: [
                                                                " ",
                                                                S(
                                                                  "uploadImage"
                                                                ),
                                                              ],
                                                            }
                                                          )
                                                        ),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)("hr", {}),
                                          (0, e.jsx)(
                                            Jp,
                                            gj(
                                              {
                                                className:
                                                  "ST_Dialog_Box_Padding",
                                                sx: {
                                                  justifyContent: "center",
                                                },
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  ni,
                                                  gj(
                                                    { component: "div" },
                                                    {
                                                      children: (0, e.jsx)(
                                                        Ym,
                                                        gj(
                                                          {
                                                            loading: E,
                                                            disabled: !M,
                                                            loadingPosition:
                                                              "end",
                                                            endIcon: (0, e.jsx)(
                                                              fM,
                                                              {}
                                                            ),
                                                            variant:
                                                              "contained",
                                                            style: {
                                                              textTransform:
                                                                "capitalize",
                                                            },
                                                            onClick: L,
                                                          },
                                                          { children: D }
                                                        )
                                                      ),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }),
                                    }
                                  )
                                ),
                              ],
                            }
                          )
                        ),
                      }
                    )
                  ),
                }
              )
            )
          );
        },
        bj = function () {
          return (
            (bj =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            bj.apply(this, arguments)
          );
        };
      function _j(n) {
        var r = (0, t.useState)(!1),
          o = r[0],
          a = r[1],
          i = (0, t.useState)(WM()[0]),
          s = i[0],
          l = i[1],
          d = n.window,
          c =
            void 0 !== d
              ? function () {
                  return d().document.body;
                }
              : void 0,
          u = function () {
            a(!o);
          },
          p = Tv(),
          m = (0, e.jsxs)(e.Fragment, {
            children: [
              (0, e.jsx)(GM, { setActiveTab: l, setMobileOpen: a }),
              (0, e.jsx)(Gt, {}),
            ],
          });
        return (0, e.jsxs)(e.Fragment, {
          children: [
            (0, e.jsx)(vj, {}),
            (0, e.jsxs)(
              mn,
              bj(
                { sx: { paddingTop: "65px !important" } },
                {
                  children: [
                    (0, e.jsx)(
                      "div",
                      bj(
                        { className: "isMobileDrawerToggle" },
                        {
                          children: (0, e.jsx)(
                            Jn,
                            bj(
                              {
                                color: "inherit",
                                className: p
                                  ? "ST-Mobile-Menu"
                                  : "ST-Desktop-Menu",
                                "aria-label": "open drawer",
                                onClick: u,
                                sx: jo,
                              },
                              {
                                children: o
                                  ? (0, e.jsx)(Io, {})
                                  : (0, e.jsx)(To, {}),
                              }
                            )
                          ),
                        }
                      )
                    ),
                    (0, e.jsxs)(
                      mn,
                      bj(
                        { sx: Mo },
                        {
                          children: [
                            (0, e.jsxs)(
                              mn,
                              bj(
                                {
                                  component: "nav",
                                  sx: No,
                                  "aria-label": "mailbox folders",
                                },
                                {
                                  children: [
                                    p &&
                                      (0, e.jsx)(
                                        wo,
                                        bj(
                                          {
                                            anchor: "right",
                                            container: c,
                                            variant: "temporary",
                                            open: o,
                                            onClose: u,
                                            ModalProps: { keepMounted: !0 },
                                            sx: Do,
                                          },
                                          { children: m }
                                        )
                                      ),
                                    !p &&
                                      (0, e.jsx)(
                                        wo,
                                        bj(
                                          {
                                            variant: "permanent",
                                            open: !0,
                                            sx: Ao,
                                          },
                                          { children: m }
                                        )
                                      ),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsx)(
                              mn,
                              bj(
                                {
                                  component: "main",
                                  sx: Eo,
                                  style: { marginTop: "0.1px" },
                                },
                                {
                                  children: (0, e.jsx)(
                                    "div",
                                    bj(
                                      {
                                        role: "tabpanel",
                                        hidden: !1,
                                        id: "vertical-tabpanel-".concat(
                                          s.index
                                        ),
                                        "aria-labelledby":
                                          "vertical-tab-".concat(s.index),
                                      },
                                      {
                                        children: (0, e.jsx)(mn, {
                                          children: s.component,
                                        }),
                                      }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  ],
                }
              )
            ),
          ],
        });
      }
      var yj = t.createContext(null);
      function Cj() {
        return t.useContext(yj);
      }
      var xj =
          "function" == typeof Symbol && Symbol.for
            ? Symbol.for("mui.nested")
            : "__THEME_NESTED__",
        Sj = function (n) {
          const { children: r, theme: o } = n,
            a = Cj(),
            i = t.useMemo(() => {
              const e =
                null === a
                  ? o
                  : (function (e, t) {
                      return "function" == typeof t ? t(e) : (0, u.Z)({}, e, t);
                    })(a, o);
              return null != e && (e[xj] = null !== a), e;
            }, [o, a]);
          return (0, e.jsx)(yj.Provider, { value: i, children: r });
        },
        kj = o(2842);
      const Pj = {};
      function wj(e, n, r, o = !1) {
        return t.useMemo(() => {
          const t = (e && n[e]) || n;
          if ("function" == typeof r) {
            const a = r(t),
              i = e ? (0, u.Z)({}, n, { [e]: a }) : a;
            return o ? () => i : i;
          }
          return e ? (0, u.Z)({}, n, { [e]: r }) : (0, u.Z)({}, n, r);
        }, [e, n, r, o]);
      }
      var Oj = function (t) {
        const { children: n, theme: r, themeId: o } = t,
          a = nn(Pj),
          i = Cj() || Pj,
          s = wj(o, a, r),
          l = wj(o, i, r, !0),
          d = "rtl" === s.direction;
        return (0, e.jsx)(Sj, {
          theme: l,
          children: (0, e.jsx)(tn.T.Provider, {
            value: s,
            children: (0, e.jsx)(nr, {
              value: d,
              children: (0, e.jsx)(kj.Z, {
                value: null == s ? void 0 : s.components,
                children: n,
              }),
            }),
          }),
        });
      };
      const Tj = ["theme"];
      function Ij(t) {
        let { theme: n } = t,
          r = (0, At.Z)(t, Tj);
        const o = n[cn.Z];
        return (0, e.jsx)(
          Oj,
          (0, u.Z)({}, r, { themeId: o ? cn.Z : void 0, theme: o || n })
        );
      }
      var Mj;
      !(function (e) {
        (e.Pop = "POP"), (e.Push = "PUSH"), (e.Replace = "REPLACE");
      })(Mj || (Mj = {}));
      var jj = "beforeunload";
      function Nj(e) {
        e.preventDefault(), (e.returnValue = "");
      }
      function Dj() {
        var e = [];
        return {
          get length() {
            return e.length;
          },
          push: function (t) {
            return (
              e.push(t),
              function () {
                e = e.filter(function (e) {
                  return e !== t;
                });
              }
            );
          },
          call: function (t) {
            e.forEach(function (e) {
              return e && e(t);
            });
          },
        };
      }
      var Aj = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3m-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3m0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5m8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5",
          }),
          "People"
        ),
        Ej = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z",
          }),
          "ChevronLeft"
        ),
        Rj = function () {
          return (
            (Rj =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            Rj.apply(this, arguments)
          );
        };
      function Lj(e) {
        return (0, Zt.ZP)("MuiStepper", e);
      }
      (0, Ft.Z)("MuiStepper", [
        "root",
        "horizontal",
        "vertical",
        "nonLinear",
        "alternativeLabel",
      ]);
      var Bj = t.createContext({});
      var zj = t.createContext({});
      function Fj(e) {
        return (0, Zt.ZP)("MuiStepConnector", e);
      }
      (0, Ft.Z)("MuiStepConnector", [
        "root",
        "horizontal",
        "vertical",
        "alternativeLabel",
        "active",
        "completed",
        "disabled",
        "line",
        "lineHorizontal",
        "lineVertical",
      ]);
      const Zj = ["className"],
        Hj = (0, Bt.ZP)("div", {
          name: "MuiStepConnector",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
              n.completed && t.completed,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { flex: "1 1 auto" },
            "vertical" === e.orientation && { marginLeft: 12 },
            e.alternativeLabel && {
              position: "absolute",
              top: 12,
              left: "calc(-50% + 20px)",
              right: "calc(50% + 20px)",
            }
          )
        ),
        Vj = (0, Bt.ZP)("span", {
          name: "MuiStepConnector",
          slot: "Line",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.line, t[`line${(0, $n.Z)(n.orientation)}`]];
          },
        })(({ ownerState: e, theme: t }) => {
          const n =
            "light" === t.palette.mode
              ? t.palette.grey[400]
              : t.palette.grey[600];
          return (0, u.Z)(
            {
              display: "block",
              borderColor: t.vars ? t.vars.palette.StepConnector.border : n,
            },
            "horizontal" === e.orientation && {
              borderTopStyle: "solid",
              borderTopWidth: 1,
            },
            "vertical" === e.orientation && {
              borderLeftStyle: "solid",
              borderLeftWidth: 1,
              minHeight: 24,
            }
          );
        });
      var Wj = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiStepConnector" }),
          { className: a } = o,
          i = (0, At.Z)(o, Zj),
          { alternativeLabel: s, orientation: l = "horizontal" } =
            t.useContext(Bj),
          { active: d, disabled: c, completed: p } = t.useContext(zj),
          m = (0, u.Z)({}, o, {
            alternativeLabel: s,
            orientation: l,
            active: d,
            completed: p,
            disabled: c,
          }),
          h = ((e) => {
            const {
                classes: t,
                orientation: n,
                alternativeLabel: r,
                active: o,
                completed: a,
                disabled: i,
              } = e,
              s = {
                root: [
                  "root",
                  n,
                  r && "alternativeLabel",
                  o && "active",
                  a && "completed",
                  i && "disabled",
                ],
                line: ["line", `line${(0, $n.Z)(n)}`],
              };
            return (0, Rt.Z)(s, Fj, t);
          })(m);
        return (0,
        e.jsx)(Hj, (0, u.Z)({ className: (0, Et.Z)(h.root, a), ref: r, ownerState: m }, i, { children: (0, e.jsx)(Vj, { className: h.line, ownerState: m }) }));
      });
      const Uj = [
          "activeStep",
          "alternativeLabel",
          "children",
          "className",
          "component",
          "connector",
          "nonLinear",
          "orientation",
        ],
        $j = (0, Bt.ZP)("div", {
          name: "MuiStepper",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
              n.nonLinear && t.nonLinear,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            { display: "flex" },
            "horizontal" === e.orientation && {
              flexDirection: "row",
              alignItems: "center",
            },
            "vertical" === e.orientation && { flexDirection: "column" },
            e.alternativeLabel && { alignItems: "flex-start" }
          )
        ),
        Kj = (0, e.jsx)(Wj, {});
      var Gj = t.forwardRef(function (n, r) {
        const o = (0, zt.i)({ props: n, name: "MuiStepper" }),
          {
            activeStep: a = 0,
            alternativeLabel: i = !1,
            children: s,
            className: l,
            component: d = "div",
            connector: c = Kj,
            nonLinear: p = !1,
            orientation: m = "horizontal",
          } = o,
          h = (0, At.Z)(o, Uj),
          f = (0, u.Z)({}, o, {
            nonLinear: p,
            alternativeLabel: i,
            orientation: m,
            component: d,
          }),
          g = ((e) => {
            const {
                orientation: t,
                nonLinear: n,
                alternativeLabel: r,
                classes: o,
              } = e,
              a = {
                root: ["root", t, n && "nonLinear", r && "alternativeLabel"],
              };
            return (0, Rt.Z)(a, Lj, o);
          })(f),
          v = t.Children.toArray(s).filter(Boolean),
          b = v.map((e, n) =>
            t.cloneElement(
              e,
              (0, u.Z)({ index: n, last: n + 1 === v.length }, e.props)
            )
          ),
          _ = t.useMemo(
            () => ({
              activeStep: a,
              alternativeLabel: i,
              connector: c,
              nonLinear: p,
              orientation: m,
            }),
            [a, i, c, p, m]
          );
        return (0,
        e.jsx)(Bj.Provider, { value: _, children: (0, e.jsx)($j, (0, u.Z)({ as: d, ownerState: f, className: (0, Et.Z)(g.root, l), ref: r }, h, { children: b })) });
      });
      function qj(e) {
        return (0, Zt.ZP)("MuiStep", e);
      }
      (0, Ft.Z)("MuiStep", [
        "root",
        "horizontal",
        "vertical",
        "alternativeLabel",
        "completed",
      ]);
      const Qj = [
          "active",
          "children",
          "className",
          "component",
          "completed",
          "disabled",
          "expanded",
          "index",
          "last",
        ],
        Yj = (0, Bt.ZP)("div", {
          name: "MuiStep",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [
              t.root,
              t[n.orientation],
              n.alternativeLabel && t.alternativeLabel,
              n.completed && t.completed,
            ];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {},
            "horizontal" === e.orientation && {
              paddingLeft: 8,
              paddingRight: 8,
            },
            e.alternativeLabel && { flex: 1, position: "relative" }
          )
        );
      var Jj = t.forwardRef(function (n, r) {
          const o = (0, zt.i)({ props: n, name: "MuiStep" }),
            {
              active: a,
              children: i,
              className: s,
              component: l = "div",
              completed: d,
              disabled: c,
              expanded: p = !1,
              index: m,
              last: h,
            } = o,
            f = (0, At.Z)(o, Qj),
            {
              activeStep: g,
              connector: v,
              alternativeLabel: b,
              orientation: _,
              nonLinear: y,
            } = t.useContext(Bj);
          let [C = !1, x = !1, S = !1] = [a, d, c];
          g === m
            ? (C = void 0 === a || a)
            : !y && g > m
            ? (x = void 0 === d || d)
            : !y && g < m && (S = void 0 === c || c);
          const k = t.useMemo(
              () => ({
                index: m,
                last: h,
                expanded: p,
                icon: m + 1,
                active: C,
                completed: x,
                disabled: S,
              }),
              [m, h, p, C, x, S]
            ),
            P = (0, u.Z)({}, o, {
              active: C,
              orientation: _,
              alternativeLabel: b,
              completed: x,
              disabled: S,
              expanded: p,
              component: l,
            }),
            w = ((e) => {
              const {
                  classes: t,
                  orientation: n,
                  alternativeLabel: r,
                  completed: o,
                } = e,
                a = {
                  root: ["root", n, r && "alternativeLabel", o && "completed"],
                };
              return (0, Rt.Z)(a, qj, t);
            })(P),
            O = (0, e.jsxs)(
              Yj,
              (0, u.Z)(
                {
                  as: l,
                  className: (0, Et.Z)(w.root, s),
                  ref: r,
                  ownerState: P,
                },
                f,
                { children: [v && b && 0 !== m ? v : null, i] }
              )
            );
          return (0,
          e.jsx)(zj.Provider, { value: k, children: v && !b && 0 !== m ? (0, e.jsxs)(t.Fragment, { children: [v, O] }) : O });
        }),
        Xj = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z",
          }),
          "CheckCircle"
        ),
        eN = (0, Oo.Z)(
          (0, e.jsx)("path", {
            d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z",
          }),
          "Warning"
        ),
        tN = o(3502);
      function nN(e) {
        return (0, Zt.ZP)("MuiStepIcon", e);
      }
      var rN,
        oN = (0, Ft.Z)("MuiStepIcon", [
          "root",
          "active",
          "completed",
          "error",
          "text",
        ]);
      const aN = ["active", "className", "completed", "error", "icon"],
        iN = (0, Bt.ZP)(tN.Z, {
          name: "MuiStepIcon",
          slot: "Root",
          overridesResolver: (e, t) => t.root,
        })(({ theme: e }) => ({
          display: "block",
          transition: e.transitions.create("color", {
            duration: e.transitions.duration.shortest,
          }),
          color: (e.vars || e).palette.text.disabled,
          [`&.${oN.completed}`]: { color: (e.vars || e).palette.primary.main },
          [`&.${oN.active}`]: { color: (e.vars || e).palette.primary.main },
          [`&.${oN.error}`]: { color: (e.vars || e).palette.error.main },
        })),
        sN = (0, Bt.ZP)("text", {
          name: "MuiStepIcon",
          slot: "Text",
          overridesResolver: (e, t) => t.text,
        })(({ theme: e }) => ({
          fill: (e.vars || e).palette.primary.contrastText,
          fontSize: e.typography.caption.fontSize,
          fontFamily: e.typography.fontFamily,
        }));
      var lN = t.forwardRef(function (t, n) {
        const r = (0, zt.i)({ props: t, name: "MuiStepIcon" }),
          {
            active: o = !1,
            className: a,
            completed: i = !1,
            error: s = !1,
            icon: l,
          } = r,
          d = (0, At.Z)(r, aN),
          c = (0, u.Z)({}, r, { active: o, completed: i, error: s }),
          p = ((e) => {
            const { classes: t, active: n, completed: r, error: o } = e,
              a = {
                root: ["root", n && "active", r && "completed", o && "error"],
                text: ["text"],
              };
            return (0, Rt.Z)(a, nN, t);
          })(c);
        if ("number" == typeof l || "string" == typeof l) {
          const t = (0, Et.Z)(a, p.root);
          return s
            ? (0, e.jsx)(
                iN,
                (0, u.Z)({ as: eN, className: t, ref: n, ownerState: c }, d)
              )
            : i
            ? (0, e.jsx)(
                iN,
                (0, u.Z)({ as: Xj, className: t, ref: n, ownerState: c }, d)
              )
            : (0, e.jsxs)(
                iN,
                (0, u.Z)({ className: t, ref: n, ownerState: c }, d, {
                  children: [
                    rN ||
                      (rN = (0, e.jsx)("circle", {
                        cx: "12",
                        cy: "12",
                        r: "12",
                      })),
                    (0, e.jsx)(sN, {
                      className: p.text,
                      x: "12",
                      y: "12",
                      textAnchor: "middle",
                      dominantBaseline: "central",
                      ownerState: c,
                      children: l,
                    }),
                  ],
                })
              );
        }
        return l;
      });
      function dN(e) {
        return (0, Zt.ZP)("MuiStepLabel", e);
      }
      var cN = (0, Ft.Z)("MuiStepLabel", [
        "root",
        "horizontal",
        "vertical",
        "label",
        "active",
        "completed",
        "error",
        "disabled",
        "iconContainer",
        "alternativeLabel",
        "labelContainer",
      ]);
      const uN = [
          "children",
          "className",
          "componentsProps",
          "error",
          "icon",
          "optional",
          "slotProps",
          "StepIconComponent",
          "StepIconProps",
        ],
        pN = (0, Bt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "Root",
          overridesResolver: (e, t) => {
            const { ownerState: n } = e;
            return [t.root, t[n.orientation]];
          },
        })(({ ownerState: e }) =>
          (0, u.Z)(
            {
              display: "flex",
              alignItems: "center",
              [`&.${cN.alternativeLabel}`]: { flexDirection: "column" },
              [`&.${cN.disabled}`]: { cursor: "default" },
            },
            "vertical" === e.orientation && {
              textAlign: "left",
              padding: "8px 0",
            }
          )
        ),
        mN = (0, Bt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "Label",
          overridesResolver: (e, t) => t.label,
        })(({ theme: e }) =>
          (0, u.Z)({}, e.typography.body2, {
            display: "block",
            transition: e.transitions.create("color", {
              duration: e.transitions.duration.shortest,
            }),
            [`&.${cN.active}`]: {
              color: (e.vars || e).palette.text.primary,
              fontWeight: 500,
            },
            [`&.${cN.completed}`]: {
              color: (e.vars || e).palette.text.primary,
              fontWeight: 500,
            },
            [`&.${cN.alternativeLabel}`]: { marginTop: 16 },
            [`&.${cN.error}`]: { color: (e.vars || e).palette.error.main },
          })
        ),
        hN = (0, Bt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "IconContainer",
          overridesResolver: (e, t) => t.iconContainer,
        })(() => ({
          flexShrink: 0,
          display: "flex",
          paddingRight: 8,
          [`&.${cN.alternativeLabel}`]: { paddingRight: 0 },
        })),
        fN = (0, Bt.ZP)("span", {
          name: "MuiStepLabel",
          slot: "LabelContainer",
          overridesResolver: (e, t) => t.labelContainer,
        })(({ theme: e }) => ({
          width: "100%",
          color: (e.vars || e).palette.text.secondary,
          [`&.${cN.alternativeLabel}`]: { textAlign: "center" },
        })),
        gN = t.forwardRef(function (n, r) {
          var o;
          const a = (0, zt.i)({ props: n, name: "MuiStepLabel" }),
            {
              children: i,
              className: s,
              componentsProps: l = {},
              error: d = !1,
              icon: c,
              optional: p,
              slotProps: m = {},
              StepIconComponent: h,
              StepIconProps: f,
            } = a,
            g = (0, At.Z)(a, uN),
            { alternativeLabel: v, orientation: b } = t.useContext(Bj),
            {
              active: _,
              disabled: y,
              completed: C,
              icon: x,
            } = t.useContext(zj),
            S = c || x;
          let k = h;
          S && !k && (k = lN);
          const P = (0, u.Z)({}, a, {
              active: _,
              alternativeLabel: v,
              completed: C,
              disabled: y,
              error: d,
              orientation: b,
            }),
            w = ((e) => {
              const {
                  classes: t,
                  orientation: n,
                  active: r,
                  completed: o,
                  error: a,
                  disabled: i,
                  alternativeLabel: s,
                } = e,
                l = {
                  root: [
                    "root",
                    n,
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  label: [
                    "label",
                    r && "active",
                    o && "completed",
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  iconContainer: [
                    "iconContainer",
                    r && "active",
                    o && "completed",
                    a && "error",
                    i && "disabled",
                    s && "alternativeLabel",
                  ],
                  labelContainer: ["labelContainer", s && "alternativeLabel"],
                };
              return (0, Rt.Z)(l, dN, t);
            })(P),
            O = null != (o = m.label) ? o : l.label;
          return (0,
          e.jsxs)(pN, (0, u.Z)({ className: (0, Et.Z)(w.root, s), ref: r, ownerState: P }, g, { children: [S || k ? (0, e.jsx)(hN, { className: w.iconContainer, ownerState: P, children: (0, e.jsx)(k, (0, u.Z)({ completed: C, active: _, error: d, icon: S }, f)) }) : null, (0, e.jsxs)(fN, { className: w.labelContainer, ownerState: P, children: [i ? (0, e.jsx)(mN, (0, u.Z)({ ownerState: P }, O, { className: (0, Et.Z)(w.label, null == O ? void 0 : O.className), children: i })) : null, p] })] }));
        });
      gN.muiName = "StepLabel";
      var vN = gN,
        bN = function () {
          return (
            (bN =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            bN.apply(this, arguments)
          );
        },
        _N = function () {
          return (
            (_N =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            _N.apply(this, arguments)
          );
        },
        yN = function () {
          var n = (function () {
              var e,
                n,
                r,
                o,
                a = this,
                i = g(),
                s = (0, t.useState)(0),
                l = s[0],
                d = s[1],
                c = (0, t.useState)({
                  fileName: "",
                  filePath: "",
                  fileSize: "",
                }),
                u = c[0],
                p = c[1],
                m = (0, t.useState)({
                  firstName: "",
                  lastName: "",
                  emailId: "",
                  phoneNumber: "",
                  fbHandle: "",
                  instHandle: "",
                }),
                h = m[0],
                f = m[1],
                v = (0, t.useState)({
                  firstNameErrMsg: "",
                  lastNameErrMsg: "",
                  emailIdErrMsg: "",
                  phoneNumberErrMsg: "",
                  fileSizeErrMsg: "",
                }),
                b = v[0],
                _ = v[1],
                y =
                  (null === (e = h.firstName) || void 0 === e
                    ? void 0
                    : e.length) > 0 &&
                  (null === (n = h.lastName) || void 0 === n
                    ? void 0
                    : n.length) > 0 &&
                  (null === (r = h.emailId) || void 0 === r
                    ? void 0
                    : r.length) > 0 &&
                  (null === (o = h.phoneNumber) || void 0 === o
                    ? void 0
                    : o.length) > 0 &&
                  "" === b.firstNameErrMsg &&
                  "" === b.lastNameErrMsg &&
                  "" === b.emailIdErrMsg &&
                  "" === b.phoneNumberErrMsg &&
                  "" === b.fileSizeErrMsg,
                C = (0, t.useState)(),
                x = C[0],
                S = C[1],
                k = (0, t.useState)(!1),
                P = k[0],
                w = k[1],
                O = (0, t.useState)(!1),
                T = O[0],
                I = O[1],
                M = (0, t.useState)(),
                j = M[0],
                N = M[1],
                D = ee().t,
                A = (0, t.useState)(!1),
                E = A[0],
                R = A[1],
                L = function () {
                  p({ fileName: "", filePath: "", fileSize: "" });
                };
              return {
                stepper: ["", "", "", ""],
                activeStep: l,
                handleNext: function () {
                  d(function (e) {
                    return e + 1;
                  });
                },
                handleBack: function () {
                  d(function (e) {
                    return e - 1;
                  });
                },
                getUploadedFileDetails: function (e) {
                  e.target.files &&
                  e.target.files[0] &&
                  e.target.files[0].size <= 5e6
                    ? (p({
                        fileName: e.target.files[0].name,
                        filePath: URL.createObjectURL(e.target.files[0]),
                        fileSize: e.target.files[0].size,
                      }),
                      S(e.target.files[0]),
                      _(function (e) {
                        return bN(bN({}, e), { fileSizeErrMsg: "" });
                      }))
                    : e.target.files[0].size > 5e6 &&
                      (L(),
                      _(function (e) {
                        return bN(bN({}, e), {
                          fileSizeErrMsg: D("signup_fileSizeError"),
                        });
                      }));
                },
                selectFile: u,
                signupBtnEnabled: y,
                requiredFields: h,
                errMsgFields: b,
                changeFormValue: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    o = n.value;
                  f(bN(bN({}, h), (((t = {})[r] = o), t))),
                    (function (e, t) {
                      switch (e) {
                        case "firstName":
                          _(
                            "" === t
                              ? function (e) {
                                  return bN(bN({}, e), {
                                    firstNameErrMsg: D("required_ErrorMsg"),
                                  });
                                }
                              : function (e) {
                                  return bN(bN({}, e), { firstNameErrMsg: "" });
                                }
                          );
                          break;
                        case "lastName":
                          _(
                            "" === t
                              ? function (e) {
                                  return bN(bN({}, e), {
                                    lastNameErrMsg: D("required_ErrorMsg"),
                                  });
                                }
                              : function (e) {
                                  return bN(bN({}, e), { lastNameErrMsg: "" });
                                }
                          );
                          break;
                        case "emailId":
                          "" === t
                            ? _(function (e) {
                                return bN(bN({}, e), {
                                  emailIdErrMsg: D("required_ErrorMsg"),
                                });
                              })
                            : oy(t.trim())
                            ? _(function (e) {
                                return bN(bN({}, e), {
                                  emailIdErrMsg: D("emailValidation_ErrorMsg"),
                                });
                              })
                            : _(function (e) {
                                return bN(bN({}, e), { emailIdErrMsg: "" });
                              });
                          break;
                        case "phoneNumber":
                          "" === t
                            ? _(function (e) {
                                return bN(bN({}, e), {
                                  phoneNumberErrMsg: D("required_ErrorMsg"),
                                });
                              })
                            : (null == t ? void 0 : t.length) < 10
                            ? _(function (e) {
                                return bN(bN({}, e), {
                                  phoneNumberErrMsg: D(
                                    "signup_phone_number_Error"
                                  ),
                                });
                              })
                            : _(function (e) {
                                return bN(bN({}, e), { phoneNumberErrMsg: "" });
                              });
                      }
                    })(r, o);
                },
                removeSelectedFile: L,
                saveDetails: function () {
                  return (
                    (e = a),
                    (t = void 0),
                    (r = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return (
                              w(!0),
                              [4, i(kg({ fileUpload: x, userDetails: h }))]
                            );
                          case 1:
                            return (
                              200 === (e = t.sent()).StatusCode ? R(!0) : R(!1),
                              I(!0),
                              N(e.StatusDescription),
                              w(!1),
                              f({
                                firstName: "",
                                lastName: "",
                                emailId: "",
                                phoneNumber: "",
                                fbHandle: "",
                                instHandle: "",
                              }),
                              p({ fileName: "", filePath: "", fileSize: "" }),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((n = void 0) || (n = Promise))(function (o, a) {
                      function i(e) {
                        try {
                          l(r.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(r.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(e) {
                        var t;
                        e.done
                          ? o(e.value)
                          : ((t = e.value),
                            t instanceof n
                              ? t
                              : new n(function (e) {
                                  e(t);
                                })).then(i, s);
                      }
                      l((r = r.apply(e, t || [])).next());
                    })
                  );
                  var e, t, n, r;
                },
                saveDetailsFlag: T,
                loadingFlag: P,
                onInputClick: function (e) {
                  (e.target.value = ""),
                    _(function (e) {
                      return bN(bN({}, e), { fileSizeErrMsg: "" });
                    });
                },
                responseMessage: j,
                successFlag: E,
              };
            })(),
            r = n.stepper,
            o = n.activeStep,
            a = n.handleNext,
            i = n.handleBack,
            s = n.getUploadedFileDetails,
            l = n.selectFile,
            d = n.signupBtnEnabled,
            c = n.requiredFields,
            u = n.errMsgFields,
            p = n.changeFormValue,
            m = n.removeSelectedFile,
            h = n.saveDetails,
            f = n.saveDetailsFlag,
            v = n.loadingFlag,
            b = n.onInputClick,
            _ = n.responseMessage,
            y = n.successFlag,
            C = ee().t;
          return (0, e.jsxs)(
            uC,
            _N(
              { p: 2 },
              {
                children: [
                  (0, e.jsxs)(
                    ni,
                    _N(
                      { component: "div", hidden: f },
                      {
                        children: [
                          (0, e.jsx)(
                            Gj,
                            _N(
                              { activeStep: o },
                              {
                                children:
                                  null == r
                                    ? void 0
                                    : r.map(function (t, n) {
                                        return (0,
                                        e.jsx)(Jj, { children: (0, e.jsx)(vN, { children: t }) }, t + "_" + n);
                                      }),
                              }
                            )
                          ),
                          (0, e.jsxs)(
                            qa,
                            _N(
                              { container: !0, mt: 3 },
                              {
                                children: [
                                  (0, e.jsxs)(
                                    qa,
                                    _N(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 0 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(Hc, {
                                            type: "text",
                                            fullWidth: !0,
                                            required: !0,
                                            label: C("signup_firstName"),
                                            name: "firstName",
                                            sx: { mb: 5 },
                                            value: c.firstName,
                                            error:
                                              "" !==
                                              (null == u
                                                ? void 0
                                                : u.firstNameErrMsg),
                                            helperText:
                                              null == u
                                                ? void 0
                                                : u.firstNameErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Hc, {
                                            type: "text",
                                            fullWidth: !0,
                                            required: !0,
                                            label: C("signup_lastName"),
                                            name: "lastName",
                                            sx: { mb: 3 },
                                            value: c.lastName,
                                            error:
                                              "" !==
                                              (null == u
                                                ? void 0
                                                : u.lastNameErrMsg),
                                            helperText:
                                              null == u
                                                ? void 0
                                                : u.lastNameErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    _N(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 1 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(Hc, {
                                            type: "email",
                                            fullWidth: !0,
                                            required: !0,
                                            label: C("login_email"),
                                            name: "emailId",
                                            sx: { mb: 5 },
                                            value: c.emailId,
                                            error:
                                              "" !==
                                              (null == u
                                                ? void 0
                                                : u.emailIdErrMsg),
                                            helperText:
                                              null == u
                                                ? void 0
                                                : u.emailIdErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Hc, {
                                            type: "number",
                                            fullWidth: !0,
                                            onKeyDown: jb,
                                            required: !0,
                                            label: C("signup_phone_number"),
                                            name: "phoneNumber",
                                            sx: { mb: 3 },
                                            value: c.phoneNumber,
                                            error:
                                              "" !==
                                              (null == u
                                                ? void 0
                                                : u.phoneNumberErrMsg),
                                            helperText:
                                              null == u
                                                ? void 0
                                                : u.phoneNumberErrMsg,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    _N(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 2 != o,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            "div",
                                            _N(
                                              { className: "ST_SU_Display" },
                                              {
                                                children: (0, e.jsxs)(
                                                  Qu,
                                                  _N(
                                                    {
                                                      component: "label",
                                                      sx: {
                                                        height: "100px",
                                                        width: "50%",
                                                        border: "1px dashed",
                                                        textTransform:
                                                          "capitalize",
                                                      },
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(
                                                          ni,
                                                          _N(
                                                            {
                                                              component: "span",
                                                              hidden:
                                                                l.filePath,
                                                            },
                                                            {
                                                              children: C(
                                                                "signup_uploadPicture"
                                                              ),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)(
                                                          ni,
                                                          _N(
                                                            {
                                                              component: "span",
                                                              hidden:
                                                                !l.filePath,
                                                            },
                                                            {
                                                              children: (0,
                                                              e.jsx)(lb, {
                                                                alt: "image",
                                                                src: l.filePath,
                                                                variant:
                                                                  "rounded",
                                                                sx: {
                                                                  width: "100%",
                                                                  height:
                                                                    "85px",
                                                                },
                                                              }),
                                                            }
                                                          )
                                                        ),
                                                        (0, e.jsx)("input", {
                                                          type: "file",
                                                          hidden: !0,
                                                          onChange: s,
                                                          onClick: b,
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            ni,
                                            _N(
                                              {
                                                component: "div",
                                                p: 2,
                                                className:
                                                  "ST_SU_TextField ST_SU_TextColor",
                                              },
                                              {
                                                children: (0, e.jsxs)("b", {
                                                  children: [
                                                    " ",
                                                    C("signup_filePath_lable"),
                                                    " :",
                                                    (0, e.jsxs)(
                                                      ni,
                                                      _N(
                                                        {
                                                          component: "span",
                                                          hidden:
                                                            "" !==
                                                            (null == u
                                                              ? void 0
                                                              : u.fileSizeErrMsg),
                                                        },
                                                        {
                                                          children: [
                                                            " ",
                                                            (null == l
                                                              ? void 0
                                                              : l.fileName) ||
                                                              "  -",
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  ],
                                                }),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            ni,
                                            _N(
                                              {
                                                align: "center",
                                                hidden:
                                                  "" ===
                                                  (null == u
                                                    ? void 0
                                                    : u.fileSizeErrMsg),
                                                className: "ST_Error_Msg_Color",
                                              },
                                              { children: u.fileSizeErrMsg }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            ni,
                                            _N(
                                              {
                                                component: "div",
                                                className: "ST_SU_TextField",
                                              },
                                              {
                                                children: (0, e.jsx)(
                                                  Qu,
                                                  _N(
                                                    {
                                                      disabled:
                                                        "" === l.filePath,
                                                    },
                                                    {
                                                      children: (0, e.jsx)(Ev, {
                                                        sx: {
                                                          cursor: "pointer",
                                                        },
                                                        onClick: function () {
                                                          return m();
                                                        },
                                                      }),
                                                    }
                                                  )
                                                ),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    _N(
                                      {
                                        xs: 12,
                                        md: 12,
                                        item: !0,
                                        hidden: 3 != o,
                                        p: 2,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            ni,
                                            _N(
                                              {
                                                variant: "subtitle1",
                                                sx: { mb: 3 },
                                              },
                                              {
                                                children:
                                                  C("signup_MediaTitle2"),
                                              }
                                            )
                                          ),
                                          (0, e.jsx)(Hc, {
                                            type: "text",
                                            fullWidth: !0,
                                            label: C("signup_facebookHandle"),
                                            name: "fbHandle",
                                            sx: { mb: 3 },
                                            value: c.fbHandle,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                          (0, e.jsx)(Hc, {
                                            type: "text",
                                            fullWidth: !0,
                                            label: C("signup_InstaHandle"),
                                            name: "instHandle",
                                            sx: { mb: 3 },
                                            value: c.instHandle,
                                            onChange: function (e) {
                                              return p(e);
                                            },
                                          }),
                                        ],
                                      }
                                    )
                                  ),
                                  (0, e.jsxs)(
                                    qa,
                                    _N(
                                      {
                                        item: !0,
                                        xs: 12,
                                        md: 12,
                                        display: "flex",
                                        justifyContent: "space-between",
                                        mt: 3,
                                      },
                                      {
                                        children: [
                                          (0, e.jsx)(
                                            Qu,
                                            _N(
                                              {
                                                disabled: 0 === o,
                                                onClick: i,
                                                variant: "contained",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              { children: C("signup_BackBtn") }
                                            )
                                          ),
                                          (0, e.jsx)(
                                            Ym,
                                            _N(
                                              {
                                                loading: v,
                                                size: "large",
                                                disabled:
                                                  o ===
                                                    (null == r
                                                      ? void 0
                                                      : r.length) -
                                                      1 && !d,
                                                onClick:
                                                  o ===
                                                  (null == r
                                                    ? void 0
                                                    : r.length) -
                                                    1
                                                    ? h
                                                    : a,
                                                variant: "contained",
                                                sx: {
                                                  textTransform: "capitalize",
                                                },
                                              },
                                              {
                                                children:
                                                  o ===
                                                  (null == r
                                                    ? void 0
                                                    : r.length) -
                                                    1
                                                    ? C("submit_btn_text")
                                                    : C("signup_NextBtn"),
                                              }
                                            )
                                          ),
                                        ],
                                      }
                                    )
                                  ),
                                ],
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                  (0, e.jsx)(
                    ni,
                    _N(
                      {
                        variant: "h6",
                        hidden: !f,
                        className: y
                          ? "ST_Error_SuccessMsg_Color"
                          : "ST_Error_Msg_Color",
                        sx: { wordBreak: "keep-all", whiteSpace: "normal" },
                      },
                      { children: _ }
                    )
                  ),
                ],
              }
            )
          );
        },
        CN = function () {
          return (
            (CN =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            CN.apply(this, arguments)
          );
        },
        xN = function () {
          return (
            (xN =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            xN.apply(this, arguments)
          );
        },
        SN = function () {
          var n = (function () {
              var e = this,
                n = g(),
                r = (0, t.useState)(!1),
                o = r[0],
                a = r[1],
                i = (0, t.useState)(""),
                s = i[0],
                l = i[1],
                d = (0, t.useState)({ emailErrMsg: "" }),
                c = d[0],
                u = d[1],
                p = (null == s ? void 0 : s.length) > 0 && "" === c.emailErrMsg,
                m = (0, t.useState)(""),
                h = m[0],
                f = m[1],
                v = (0, t.useState)(!1),
                b = v[0],
                _ = v[1],
                y = ee().t,
                C = function () {
                  return (
                    (t = e),
                    (r = void 0),
                    (i = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return a(!0), [4, n(wg(s))];
                          case 1:
                            return (
                              200 == (e = t.sent()).status
                                ? (_(!0), a(!1), l(""))
                                : 500 == e.status
                                ? (_(!1), a(!1), f(e.message))
                                : (_(!1), a(!1)),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((o = void 0) || (o = Promise))(function (e, n) {
                      function a(e) {
                        try {
                          l(i.next(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(i.throw(e));
                        } catch (e) {
                          n(e);
                        }
                      }
                      function l(t) {
                        var n;
                        t.done
                          ? e(t.value)
                          : ((n = t.value),
                            n instanceof o
                              ? n
                              : new o(function (e) {
                                  e(n);
                                })).then(a, s);
                      }
                      l((i = i.apply(t, r || [])).next());
                    })
                  );
                  var t, r, o, i;
                };
              return {
                errorMessage: c,
                isLoadingFlag: o,
                resetPasswordErrMsg: h,
                resetBtnEnabled: p,
                emailField: s,
                emailValidFlag: b,
                handleEmailChange: function (e) {
                  var t = e.target.value;
                  (function (e) {
                    "" === e
                      ? u(function (e) {
                          return CN(CN({}, e), {
                            emailErrMsg: y("required_ErrorMsg"),
                          });
                        })
                      : oy(e.trim())
                      ? u(function (e) {
                          return CN(CN({}, e), {
                            emailErrMsg: y("emailValidation_ErrorMsg"),
                          });
                        })
                      : u(function (e) {
                          return CN(CN({}, e), { emailErrMsg: "" });
                        });
                  })(t),
                    l(t),
                    f("");
                },
                resetPassword: C,
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && p && C();
                },
              };
            })(),
            r = n.errorMessage,
            o = n.resetPasswordErrMsg,
            a = n.resetBtnEnabled,
            i = n.isLoadingFlag,
            s = n.handleEmailChange,
            l = n.resetPassword,
            d = n.emailValidFlag,
            c = n.handleKeyDown,
            u = ee().t;
          return (0, e.jsxs)(uC, {
            children: [
              (0, e.jsx)(
                ni,
                xN(
                  { component: "div", hidden: d },
                  {
                    children: (0, e.jsxs)(
                      qa,
                      xN(
                        { container: !0, p: 3, display: "flex" },
                        {
                          children: [
                            (0, e.jsxs)(
                              qa,
                              xN(
                                { item: !0, xs: 12, md: 12 },
                                {
                                  children: [
                                    (0, e.jsx)(
                                      ni,
                                      xN(
                                        { variant: "subtitle1", mb: 2 },
                                        {
                                          children: (0, e.jsx)("b", {
                                            children:
                                              "Enter your email to receive new password",
                                          }),
                                        }
                                      )
                                    ),
                                    (0, e.jsx)(Hc, {
                                      type: "email",
                                      fullWidth: !0,
                                      label: u("login_email"),
                                      name: "emailid",
                                      error: null == r ? void 0 : r.emailErrMsg,
                                      helperText:
                                        null == r ? void 0 : r.emailErrMsg,
                                      onChange: function (e) {
                                        return s(e);
                                      },
                                      onKeyDown: c,
                                    }),
                                  ],
                                }
                              )
                            ),
                            (0, e.jsx)(
                              qa,
                              xN(
                                {
                                  item: !0,
                                  xs: 12,
                                  mt: 5,
                                  display: "flex",
                                  justifyContent: "center",
                                },
                                {
                                  children: (0, e.jsx)(
                                    Ym,
                                    xN(
                                      {
                                        size: "large",
                                        variant: "contained",
                                        disabled: !a,
                                        loading: i,
                                        sx: {
                                          fontSize: "16px",
                                          textTransform: "capitalize",
                                          cursor: "pointer",
                                        },
                                        onClick: l,
                                      },
                                      { children: u("forgotPwd_ResetBtn") }
                                    )
                                  ),
                                }
                              )
                            ),
                          ],
                        }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                qa,
                xN(
                  {
                    item: !0,
                    xs: 12,
                    display: "flex",
                    justifyContent: "center",
                  },
                  {
                    children: (0, e.jsx)(
                      ni,
                      xN(
                        {
                          variant: "h6",
                          justifyContent: "center",
                          my: 5,
                          hidden: !d,
                          sx: { margin: "2rem" },
                          className: "ST_Error_SuccessMsg_Color",
                        },
                        { children: u("forgotPwd_SuccessMsg") }
                      )
                    ),
                  }
                )
              ),
              (0, e.jsx)(
                qa,
                xN(
                  {
                    item: !0,
                    xs: 12,
                    display: "flex",
                    justifyContent: "center",
                  },
                  {
                    children: (0, e.jsx)(
                      ni,
                      xN(
                        {
                          variant: "subtitle1",
                          my: 3,
                          hidden: "" === o,
                          className: "ST_Error_Msg_Color",
                        },
                        { children: o }
                      )
                    ),
                  }
                )
              ),
            ],
          });
        },
        kN = function () {
          return (
            (kN =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            kN.apply(this, arguments)
          );
        },
        PN = function () {
          var n = (function () {
              var e,
                n,
                r = this,
                o = ee().t,
                a = [
                  { description: o("login_sliderContent_1") },
                  { description: o("login_sliderContent_2") },
                  { description: o("login_sliderContent_3") },
                  { description: o("login_sliderContent_4") },
                  { description: o("login_sliderContent_5") },
                  { description: o("login_sliderContent_6") },
                ],
                i = g(),
                s = (0, t.useState)(0),
                l = s[0],
                d = s[1],
                c = (0, t.useState)({ emailField: "", passwordField: "" }),
                u = c[0],
                p = c[1],
                m = (0, t.useState)({ emailErrMsg: "", passwordErrMsg: "" }),
                h = m[0],
                f = m[1],
                v = (0, t.useState)(!0),
                b = v[0],
                _ = v[1],
                y = (0, t.useState)(!1),
                C = y[0],
                x = y[1],
                S = (0, t.useState)(!1),
                k = S[0],
                P = S[1],
                w =
                  (null === (e = u.emailField) || void 0 === e
                    ? void 0
                    : e.length) > 0 &&
                  (null === (n = u.passwordField) || void 0 === n
                    ? void 0
                    : n.length) > 0 &&
                  "" === h.emailErrMsg &&
                  "" === h.passwordErrMsg,
                O = (0, t.useState)(""),
                T = O[0],
                I = O[1],
                M = (0, t.useState)(!1),
                j = M[0],
                N = M[1],
                D = (0, t.useState)(!1),
                A = D[0],
                E = D[1],
                R = function () {
                  return (
                    (e = r),
                    (t = void 0),
                    (o = function () {
                      var e;
                      return (function (e, t) {
                        var n,
                          r,
                          o,
                          a,
                          i = {
                            label: 0,
                            sent: function () {
                              if (1 & o[0]) throw o[1];
                              return o[1];
                            },
                            trys: [],
                            ops: [],
                          };
                        return (
                          (a = { next: s(0), throw: s(1), return: s(2) }),
                          "function" == typeof Symbol &&
                            (a[Symbol.iterator] = function () {
                              return this;
                            }),
                          a
                        );
                        function s(s) {
                          return function (l) {
                            return (function (s) {
                              if (n)
                                throw new TypeError(
                                  "Generator is already executing."
                                );
                              for (; a && ((a = 0), s[0] && (i = 0)), i; )
                                try {
                                  if (
                                    ((n = 1),
                                    r &&
                                      (o =
                                        2 & s[0]
                                          ? r.return
                                          : s[0]
                                          ? r.throw ||
                                            ((o = r.return) && o.call(r), 0)
                                          : r.next) &&
                                      !(o = o.call(r, s[1])).done)
                                  )
                                    return o;
                                  switch (
                                    ((r = 0),
                                    o && (s = [2 & s[0], o.value]),
                                    s[0])
                                  ) {
                                    case 0:
                                    case 1:
                                      o = s;
                                      break;
                                    case 4:
                                      return (
                                        i.label++, { value: s[1], done: !1 }
                                      );
                                    case 5:
                                      i.label++, (r = s[1]), (s = [0]);
                                      continue;
                                    case 7:
                                      (s = i.ops.pop()), i.trys.pop();
                                      continue;
                                    default:
                                      if (
                                        !(
                                          (o =
                                            (o = i.trys).length > 0 &&
                                            o[o.length - 1]) ||
                                          (6 !== s[0] && 2 !== s[0])
                                        )
                                      ) {
                                        i = 0;
                                        continue;
                                      }
                                      if (
                                        3 === s[0] &&
                                        (!o || (s[1] > o[0] && s[1] < o[3]))
                                      ) {
                                        i.label = s[1];
                                        break;
                                      }
                                      if (6 === s[0] && i.label < o[1]) {
                                        (i.label = o[1]), (o = s);
                                        break;
                                      }
                                      if (o && i.label < o[2]) {
                                        (i.label = o[2]), i.ops.push(s);
                                        break;
                                      }
                                      o[2] && i.ops.pop(), i.trys.pop();
                                      continue;
                                  }
                                  s = t.call(e, i);
                                } catch (e) {
                                  (s = [6, e]), (r = 0);
                                } finally {
                                  n = o = 0;
                                }
                              if (5 & s[0]) throw s[1];
                              return { value: s[0] ? s[1] : void 0, done: !0 };
                            })([s, l]);
                          };
                        }
                      })(this, function (t) {
                        switch (t.label) {
                          case 0:
                            return N(!0), [4, i(Pg(u))];
                          case 1:
                            return (
                              200 == (e = t.sent()).status
                                ? (sessionStorage.setItem(
                                    "Authorization",
                                    btoa(JSON.stringify(e))
                                  ),
                                  N(!1),
                                  p({ emailField: "", passwordField: "" }),
                                  Zh.next(!0))
                                : 500 == e.status &&
                                  (I(e.message),
                                  N(!1),
                                  setTimeout(function () {
                                    I("");
                                  }, 15e3)),
                              N(!1),
                              [2]
                            );
                        }
                      });
                    }),
                    new ((n = void 0) || (n = Promise))(function (r, a) {
                      function i(e) {
                        try {
                          l(o.next(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function s(e) {
                        try {
                          l(o.throw(e));
                        } catch (e) {
                          a(e);
                        }
                      }
                      function l(e) {
                        var t;
                        e.done
                          ? r(e.value)
                          : ((t = e.value),
                            t instanceof n
                              ? t
                              : new n(function (e) {
                                  e(t);
                                })).then(i, s);
                      }
                      l((o = o.apply(e, t || [])).next());
                    })
                  );
                  var e, t, n, o;
                },
                L = wv("(min-width:930px");
              return {
                sliderContent: a,
                index: l,
                setIndex: d,
                handleChange: function (e) {
                  d(e);
                },
                formFields: u,
                errorMessage: h,
                changeFieldsValue: function (e) {
                  var t,
                    n = e.target,
                    r = n.name,
                    a = n.value;
                  p(Rj(Rj({}, u), (((t = {})[r] = a), t))),
                    (function (e, t) {
                      "emailField" === e &&
                        ("" === t
                          ? f(function (e) {
                              return Rj(Rj({}, e), {
                                emailErrMsg: o("required_ErrorMsg"),
                              });
                            })
                          : oy(t.trim())
                          ? f(function (e) {
                              return Rj(Rj({}, e), {
                                emailErrMsg: o("emailValidation_ErrorMsg"),
                              });
                            })
                          : f(function (e) {
                              return Rj(Rj({}, e), { emailErrMsg: "" });
                            })),
                        "passwordField" === e &&
                          ("" === t
                            ? f(function (e) {
                                return Rj(Rj({}, e), {
                                  passwordErrMsg: o("required_ErrorMsg"),
                                });
                              })
                            : t.match(Mb)
                            ? f(function (e) {
                                return Rj(Rj({}, e), { passwordErrMsg: "" });
                              })
                            : f(function (e) {
                                return Rj(Rj({}, e), {
                                  passwordErrMsg:
                                    "Password should contain minimum 8 characters,1 uppercase,1 lowercase,1 digit etc.",
                                });
                              }));
                    })(r, a);
                },
                userLogin: R,
                loginBtnEnabled: w,
                loginUI: b,
                signupUI: C,
                forgotPasswordUI: k,
                toggleUI: function (e) {
                  switch (e) {
                    case 1:
                      p({ emailField: "", passwordField: "" }),
                        f({ emailErrMsg: "", passwordErrMsg: "" }),
                        _(!0),
                        x(!1),
                        P(!1);
                      break;
                    case 2:
                      x(!0), _(!1), P(!1);
                      break;
                    case 3:
                      P(!0), _(!1), x(!1);
                  }
                },
                userLoginErrMsg: T,
                loginLoadingFlag: j,
                matchWidth: L,
                handleKeyDown: function (e) {
                  "Enter" === e.key && 13 === e.keyCode && w && R();
                },
                showPassword: A,
                handleClickShowPassword: function () {
                  E(!A);
                },
              };
            })(),
            r = n.formFields,
            o = n.errorMessage,
            a = n.changeFieldsValue,
            i = n.userLogin,
            s = n.loginBtnEnabled,
            l = n.loginUI,
            d = n.signupUI,
            c = n.toggleUI,
            u = n.userLoginErrMsg,
            p = n.loginLoadingFlag,
            m = n.matchWidth,
            h = n.handleKeyDown,
            f = n.showPassword,
            v = n.handleClickShowPassword,
            b = ee().t,
            _ = { color: "black" };
          return (0, e.jsxs)(
            uC,
            kN(
              { sx: { backgroundColor: "#004aab", height: "100vh" } },
              {
                children: [
                  (0, e.jsx)(
                    qa,
                    kN(
                      {
                        item: !0,
                        md: 1,
                        mt: 2,
                        hidden: !m,
                        sx: { textAlign: "center" },
                        position: "absolute",
                        right: "15px",
                      },
                      { children: (0, e.jsx)(cj, kN({}, _)) }
                    )
                  ),
                  (0, e.jsxs)(
                    oM,
                    kN(
                      { sx: { backgroundColor: "#004aab" } },
                      {
                        children: [
                          (0, e.jsx)(
                            qa,
                            kN(
                              { container: !0, p: 3, alignItems: "center" },
                              {
                                children: (0, e.jsx)(
                                  qa,
                                  kN(
                                    { item: !0, xs: 12, md: 12 },
                                    {
                                      children: (0, e.jsx)(
                                        ni,
                                        kN(
                                          {
                                            variant: "h4",
                                            pt: 2,
                                            className: "ST_Login_Header_Color",
                                          },
                                          { children: b("login_welcome_Msg") }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                          !m &&
                            (0, e.jsx)(
                              uC,
                              kN(
                                {
                                  sx: {
                                    position: "absolute",
                                    right: "1px",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    width: "100%",
                                  },
                                },
                                { children: (0, e.jsx)(cj, kN({}, _)) }
                              )
                            ),
                          (0, e.jsx)(
                            qa,
                            kN(
                              {
                                mt: 4,
                                container: !0,
                                p: 3,
                                alignItems: "center",
                              },
                              {
                                children: (0, e.jsx)(
                                  qa,
                                  kN(
                                    {
                                      item: !0,
                                      xs: 12,
                                      md: 12,
                                      display: "flex",
                                      justifyContent: "center",
                                    },
                                    {
                                      children: (0, e.jsxs)(
                                        qa,
                                        kN(
                                          {
                                            item: !0,
                                            mt: 3,
                                            xs: 12,
                                            md: 6,
                                            sx: {
                                              backgroundColor: "white",
                                              borderRadius: "22px",
                                            },
                                          },
                                          {
                                            children: [
                                              (0, e.jsx)("div", {
                                                children: (0, e.jsxs)(
                                                  ni,
                                                  kN(
                                                    {
                                                      variant: "h5",
                                                      p: 1,
                                                      mt: 2,
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      className:
                                                        "ST_Login_IconColor",
                                                    },
                                                    {
                                                      children: [
                                                        (0, e.jsx)(Aj, {
                                                          sx: {
                                                            fontSize: "2.8rem",
                                                            mr: 2,
                                                          },
                                                        }),
                                                        " ",
                                                        (0, e.jsx)("b", {
                                                          children: b(
                                                            l
                                                              ? "login_title"
                                                              : d
                                                              ? "signup_title"
                                                              : "forgotPwd_title"
                                                          ),
                                                        }),
                                                      ],
                                                    }
                                                  )
                                                ),
                                              }),
                                              (0, e.jsx)(
                                                ni,
                                                kN(
                                                  {
                                                    component: "div",
                                                    hidden: l,
                                                  },
                                                  {
                                                    children: (0, e.jsxs)(
                                                      ni,
                                                      kN(
                                                        {
                                                          variant: "subtitle1",
                                                          className:
                                                            "ST_CursorCss ST_Login_IconColor",
                                                          p: 1,
                                                          mt: 2,
                                                          display: "flex",
                                                          justifyContent:
                                                            "flex-start",
                                                          sx: {
                                                            textDecoration:
                                                              "underline",
                                                          },
                                                          onClick: function () {
                                                            c(1);
                                                          },
                                                        },
                                                        {
                                                          children: [
                                                            (0, e.jsx)(Ej, {
                                                              sx: {
                                                                fontSize:
                                                                  "2rem",
                                                              },
                                                            }),
                                                            b(
                                                              "signup_BackTo_login"
                                                            ),
                                                          ],
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              l
                                                ? (0, e.jsx)(
                                                    uC,
                                                    kN(
                                                      { mt: 1 },
                                                      {
                                                        children: (0, e.jsx)(
                                                          "div",
                                                          {
                                                            children: (0,
                                                            e.jsxs)(
                                                              qa,
                                                              kN(
                                                                {
                                                                  container: !0,
                                                                  p: 3,
                                                                },
                                                                {
                                                                  children: [
                                                                    (0, e.jsx)(
                                                                      qa,
                                                                      kN(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          md: 12,
                                                                          mt: 2,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Hc,
                                                                              {
                                                                                type: "email",
                                                                                fullWidth:
                                                                                  !0,
                                                                                required:
                                                                                  !0,
                                                                                label:
                                                                                  b(
                                                                                    "login_email"
                                                                                  ),
                                                                                name: "emailField",
                                                                                value:
                                                                                  null ==
                                                                                  r
                                                                                    ? void 0
                                                                                    : r.emailField,
                                                                                error:
                                                                                  "" !==
                                                                                  (null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.emailErrMsg),
                                                                                helperText:
                                                                                  null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.emailErrMsg,
                                                                                onChange:
                                                                                  function (
                                                                                    e
                                                                                  ) {
                                                                                    return a(
                                                                                      e
                                                                                    );
                                                                                  },
                                                                                onKeyDown:
                                                                                  h,
                                                                                autoComplete:
                                                                                  "new-password",
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      qa,
                                                                      kN(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          md: 12,
                                                                          mt: 5,
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Hc,
                                                                              {
                                                                                type: f
                                                                                  ? "text"
                                                                                  : "password",
                                                                                fullWidth:
                                                                                  !0,
                                                                                required:
                                                                                  !0,
                                                                                label:
                                                                                  b(
                                                                                    "login_password"
                                                                                  ),
                                                                                name: "passwordField",
                                                                                value:
                                                                                  null ==
                                                                                  r
                                                                                    ? void 0
                                                                                    : r.passwordField,
                                                                                error:
                                                                                  "" !==
                                                                                  (null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.passwordErrMsg),
                                                                                helperText:
                                                                                  null ==
                                                                                  o
                                                                                    ? void 0
                                                                                    : o.passwordErrMsg,
                                                                                onChange:
                                                                                  a,
                                                                                autoComplete:
                                                                                  "new-password",
                                                                                onKeyDown:
                                                                                  h,
                                                                                InputProps:
                                                                                  {
                                                                                    endAdornment:
                                                                                      (null ==
                                                                                      r
                                                                                        ? void 0
                                                                                        : r.passwordField) &&
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        Bu,
                                                                                        kN(
                                                                                          {
                                                                                            position:
                                                                                              "end",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                Jn,
                                                                                                kN(
                                                                                                  {
                                                                                                    "aria-label":
                                                                                                      "toggle password visibility",
                                                                                                    onClick:
                                                                                                      v,
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      f
                                                                                                        ? (0,
                                                                                                          e.jsx)(
                                                                                                            uj,
                                                                                                            {}
                                                                                                          )
                                                                                                        : (0,
                                                                                                          e.jsx)(
                                                                                                            pj,
                                                                                                            {}
                                                                                                          ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  },
                                                                              }
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsxs)(
                                                                      "div",
                                                                      kN(
                                                                        {
                                                                          style:
                                                                            {
                                                                              display:
                                                                                "flex",
                                                                              justifyContent:
                                                                                "space-between",
                                                                              width:
                                                                                "100%",
                                                                              flexDirection:
                                                                                m
                                                                                  ? "row"
                                                                                  : "column",
                                                                              paddingTop:
                                                                                m
                                                                                  ? "10px"
                                                                                  : "24px",
                                                                            },
                                                                        },
                                                                        {
                                                                          children:
                                                                            [
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                kN(
                                                                                  {
                                                                                    style:
                                                                                      {
                                                                                        paddingTop:
                                                                                          "10px",
                                                                                      },
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        ni,
                                                                                        kN(
                                                                                          {
                                                                                            component:
                                                                                              "div",
                                                                                            variant:
                                                                                              "subtitle1",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsxs)(
                                                                                                rl,
                                                                                                kN(
                                                                                                  {
                                                                                                    className:
                                                                                                      "ST_CursorCss ST_link_FontColor",
                                                                                                    onClick:
                                                                                                      function () {
                                                                                                        c(
                                                                                                          2
                                                                                                        );
                                                                                                      },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      [
                                                                                                        b(
                                                                                                          "login_newUser"
                                                                                                        ),
                                                                                                        (0,
                                                                                                        e.jsxs)(
                                                                                                          "b",
                                                                                                          {
                                                                                                            children:
                                                                                                              [
                                                                                                                " ",
                                                                                                                b(
                                                                                                                  "login_SignUp"
                                                                                                                ),
                                                                                                              ],
                                                                                                          }
                                                                                                        ),
                                                                                                      ],
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  }
                                                                                )
                                                                              ),
                                                                              (0,
                                                                              e.jsx)(
                                                                                "div",
                                                                                kN(
                                                                                  {
                                                                                    style:
                                                                                      {
                                                                                        paddingTop:
                                                                                          "10px",
                                                                                      },
                                                                                  },
                                                                                  {
                                                                                    children:
                                                                                      (0,
                                                                                      e.jsx)(
                                                                                        ni,
                                                                                        kN(
                                                                                          {
                                                                                            component:
                                                                                              "div",
                                                                                            variant:
                                                                                              "subtitle1",
                                                                                          },
                                                                                          {
                                                                                            children:
                                                                                              (0,
                                                                                              e.jsx)(
                                                                                                rl,
                                                                                                kN(
                                                                                                  {
                                                                                                    className:
                                                                                                      "ST_CursorCss ST_link_FontColor",
                                                                                                    onClick:
                                                                                                      function () {
                                                                                                        c(
                                                                                                          3
                                                                                                        );
                                                                                                      },
                                                                                                  },
                                                                                                  {
                                                                                                    children:
                                                                                                      (0,
                                                                                                      e.jsx)(
                                                                                                        "b",
                                                                                                        {
                                                                                                          children:
                                                                                                            b(
                                                                                                              "login_forgotPassword_link"
                                                                                                            ),
                                                                                                        }
                                                                                                      ),
                                                                                                  }
                                                                                                )
                                                                                              ),
                                                                                          }
                                                                                        )
                                                                                      ),
                                                                                  }
                                                                                )
                                                                              ),
                                                                            ],
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      qa,
                                                                      kN(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          mt: 5,
                                                                          display:
                                                                            "flex",
                                                                          justifyContent:
                                                                            "center",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              Ym,
                                                                              kN(
                                                                                {
                                                                                  loading:
                                                                                    p,
                                                                                  size: "large",
                                                                                  disabled:
                                                                                    !s,
                                                                                  onClick:
                                                                                    i,
                                                                                  variant:
                                                                                    "contained",
                                                                                  sx: {
                                                                                    fontSize:
                                                                                      "16px",
                                                                                    textTransform:
                                                                                      "capitalize",
                                                                                    cursor:
                                                                                      "pointer",
                                                                                  },
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    b(
                                                                                      "login_LogInBtn"
                                                                                    ),
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                    (0, e.jsx)(
                                                                      qa,
                                                                      kN(
                                                                        {
                                                                          item: !0,
                                                                          xs: 12,
                                                                          display:
                                                                            "flex",
                                                                          justifyContent:
                                                                            "center",
                                                                        },
                                                                        {
                                                                          children:
                                                                            (0,
                                                                            e.jsx)(
                                                                              ni,
                                                                              kN(
                                                                                {
                                                                                  variant:
                                                                                    "subtitle1",
                                                                                  mt: 2,
                                                                                  hidden:
                                                                                    "" ===
                                                                                    u,
                                                                                  className:
                                                                                    "ST_Error_Msg_Color",
                                                                                },
                                                                                {
                                                                                  children:
                                                                                    u,
                                                                                }
                                                                              )
                                                                            ),
                                                                        }
                                                                      )
                                                                    ),
                                                                  ],
                                                                }
                                                              )
                                                            ),
                                                          }
                                                        ),
                                                      }
                                                    )
                                                  )
                                                : d
                                                ? (0, e.jsx)(
                                                    uC,
                                                    kN(
                                                      { mt: 1 },
                                                      {
                                                        children: (0, e.jsx)(
                                                          yN,
                                                          {}
                                                        ),
                                                      }
                                                    )
                                                  )
                                                : (0, e.jsxs)(
                                                    uC,
                                                    kN(
                                                      { mt: 1 },
                                                      {
                                                        children: [
                                                          (0, e.jsx)("div", {
                                                            onClick:
                                                              function () {
                                                                c(1);
                                                              },
                                                          }),
                                                          (0, e.jsx)(SN, {}),
                                                        ],
                                                      }
                                                    )
                                                  ),
                                            ],
                                          }
                                        )
                                      ),
                                    }
                                  )
                                ),
                              }
                            )
                          ),
                        ],
                      }
                    )
                  ),
                ],
              }
            )
          );
        },
        wN = function () {
          return (
            (wN =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            wN.apply(this, arguments)
          );
        },
        ON = function () {
          return (
            (ON =
              Object.assign ||
              function (e) {
                for (var t, n = 1, r = arguments.length; n < r; n++)
                  for (var o in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
                return e;
              }),
            ON.apply(this, arguments)
          );
        },
        TN = document.getElementById("css-backoffice");
      (0, r.s)(TN).render(
        (0, e.jsx)(t.StrictMode, {
          children: (0, e.jsx)(
            function (e) {
              var n = e.store,
                r = e.context,
                o = e.children,
                i = (0, t.useMemo)(
                  function () {
                    var e = d(n);
                    return { store: n, subscription: e };
                  },
                  [n]
                ),
                s = (0, t.useMemo)(
                  function () {
                    return n.getState();
                  },
                  [n]
                );
              c(
                function () {
                  var e = i.subscription;
                  return (
                    (e.onStateChange = e.notifyNestedSubs),
                    e.trySubscribe(),
                    s !== n.getState() && e.notifyNestedSubs(),
                    function () {
                      e.tryUnsubscribe(), (e.onStateChange = null);
                    }
                  );
                },
                [i, s]
              );
              var l = r || a;
              return t.createElement(l.Provider, { value: i }, o);
            },
            ON(
              { store: F },
              {
                children: (0, e.jsx)(function () {
                  var n = (0, t.useState)(!1),
                    r = n[0],
                    o = n[1],
                    a = (0, t.useState)(!1),
                    i = a[0],
                    s = a[1],
                    l = (0, t.useState)(!1),
                    d = l[0],
                    c = l[1],
                    p = (0, t.useState)(""),
                    m = p[0],
                    h = p[1],
                    f = (0, dn.Z)({
                      zIndex: {
                        modal: 99999,
                        tooltip: 99999,
                        snackbar: 99999,
                        drawer: 99999,
                      },
                    });
                  Bh.subscribe(function (e) {
                    e !== r && o(e);
                  }),
                    zh.subscribe(function (e) {
                      e !== i && s(e);
                    }),
                    (0, t.useEffect)(
                      function () {
                        Zh.subscribe(function (e) {
                          var t = sessionStorage.getItem("Authorization");
                          h(t ? JSON.parse(atob(t)) : "");
                        });
                      },
                      [Zh]
                    ),
                    (0, t.useEffect)(function () {
                      !(function (e) {
                        var t;
                        null ===
                          (t =
                            document.querySelectorAll('[href$="/account"]')) ||
                          void 0 === t ||
                          t.forEach(function (t) {
                            t.addEventListener("click", function (n) {
                              var r = t.getAttribute("href");
                              r &&
                                (null == r
                                  ? void 0
                                  : r.split("?")[0].indexOf("/account")) > -1 &&
                                (n.preventDefault(), e(!0));
                            });
                          });
                      })(c);
                    }),
                    (0, t.useEffect)(
                      function () {
                        d ? v() : b(), Fh.next(d);
                      },
                      [d]
                    );
                  var g = (function (e) {
                    void 0 === e && (e = {});
                    var t = e.window,
                      n = void 0 === t ? document.defaultView : t,
                      r = n.history;
                    function o() {
                      var e = n.location,
                        t = e.pathname,
                        o = e.search,
                        a = e.hash,
                        i = r.state || {};
                      return [
                        i.idx,
                        {
                          pathname: t,
                          search: o,
                          hash: a,
                          state: i.usr || null,
                          key: i.key || "default",
                        },
                      ];
                    }
                    var a = null;
                    n.addEventListener("popstate", function () {
                      if (a) p.call(a), (a = null);
                      else {
                        var e = Mj.Pop,
                          t = o(),
                          n = t[0],
                          r = t[1];
                        if (p.length) {
                          if (null != n) {
                            var i = l - n;
                            i &&
                              ((a = {
                                action: e,
                                location: r,
                                retry: function () {
                                  b(-1 * i);
                                },
                              }),
                              b(i));
                          }
                        } else v(e);
                      }
                    });
                    var i = Mj.Pop,
                      s = o(),
                      l = s[0],
                      d = s[1],
                      c = Dj(),
                      p = Dj();
                    function m(e) {
                      return "string" == typeof e
                        ? e
                        : (function (e) {
                            var t = e.pathname,
                              n = void 0 === t ? "/" : t,
                              r = e.search,
                              o = void 0 === r ? "" : r,
                              a = e.hash,
                              i = void 0 === a ? "" : a;
                            return (
                              o &&
                                "?" !== o &&
                                (n += "?" === o.charAt(0) ? o : "?" + o),
                              i &&
                                "#" !== i &&
                                (n += "#" === i.charAt(0) ? i : "#" + i),
                              n
                            );
                          })(e);
                    }
                    function h(e, t) {
                      return (
                        void 0 === t && (t = null),
                        (0, u.Z)(
                          { pathname: d.pathname, hash: "", search: "" },
                          "string" == typeof e
                            ? (function (e) {
                                var t = {};
                                if (e) {
                                  var n = e.indexOf("#");
                                  n >= 0 &&
                                    ((t.hash = e.substr(n)),
                                    (e = e.substr(0, n)));
                                  var r = e.indexOf("?");
                                  r >= 0 &&
                                    ((t.search = e.substr(r)),
                                    (e = e.substr(0, r))),
                                    e && (t.pathname = e);
                                }
                                return t;
                              })(e)
                            : e,
                          {
                            state: t,
                            key: Math.random().toString(36).substr(2, 8),
                          }
                        )
                      );
                    }
                    function f(e, t) {
                      return [{ usr: e.state, key: e.key, idx: t }, m(e)];
                    }
                    function g(e, t, n) {
                      return (
                        !p.length ||
                        (p.call({ action: e, location: t, retry: n }), !1)
                      );
                    }
                    function v(e) {
                      i = e;
                      var t = o();
                      (l = t[0]),
                        (d = t[1]),
                        c.call({ action: i, location: d });
                    }
                    function b(e) {
                      r.go(e);
                    }
                    null == l &&
                      ((l = 0),
                      r.replaceState((0, u.Z)({}, r.state, { idx: l }), ""));
                    var _ = {
                      get action() {
                        return i;
                      },
                      get location() {
                        return d;
                      },
                      createHref: m,
                      push: function e(t, o) {
                        var a = Mj.Push,
                          i = h(t, o);
                        if (
                          g(a, i, function () {
                            e(t, o);
                          })
                        ) {
                          var s = f(i, l + 1),
                            d = s[0],
                            c = s[1];
                          try {
                            r.pushState(d, "", c);
                          } catch (e) {
                            n.location.assign(c);
                          }
                          v(a);
                        }
                      },
                      replace: function e(t, n) {
                        var o = Mj.Replace,
                          a = h(t, n);
                        if (
                          g(o, a, function () {
                            e(t, n);
                          })
                        ) {
                          var i = f(a, l),
                            s = i[0],
                            d = i[1];
                          r.replaceState(s, "", d), v(o);
                        }
                      },
                      go: b,
                      back: function () {
                        b(-1);
                      },
                      forward: function () {
                        b(1);
                      },
                      listen: function (e) {
                        return c.push(e);
                      },
                      block: function (e) {
                        var t = p.push(e);
                        return (
                          1 === p.length && n.addEventListener(jj, Nj),
                          function () {
                            t(), p.length || n.removeEventListener(jj, Nj);
                          }
                        );
                      },
                    };
                    return _;
                  })();
                  (0, t.useEffect)(
                    function () {
                      var e = window.location.href,
                        t = "/account";
                      (null == e ? void 0 : e.includes(t)) &&
                        e.substring(e.indexOf(t)) === t &&
                        c(!0);
                    },
                    [g]
                  ),
                    (0, t.useEffect)(
                      function () {
                        (document.getElementsByTagName(
                          "body"
                        )[0].style.overflow = d ? "hidden" : "auto"),
                          Fh.next(d);
                      },
                      [d]
                    ),
                    (0, t.useEffect)(function () {
                      navigator.userAgent.toLowerCase(),
                        navigator.vendor.includes("Apple")
                          ? document.documentElement.classList.add(
                              "safari-browser"
                            )
                          : document.documentElement.classList.remove(
                              "safari-browser"
                            );
                    }, []);
                  var v = function () {
                      document.getElementsByTagName("html")[0].style.fontSize =
                        "14px";
                    },
                    b = function () {
                      document.getElementsByTagName("html")[0].style.fontSize =
                        "small";
                    };
                  return (0, e.jsx)(
                    te,
                    wN(
                      { i18n: Dt },
                      {
                        children: (0, e.jsx)(
                          Ij,
                          wN(
                            { theme: f },
                            {
                              children: (0, e.jsxs)(
                                "div",
                                wN(
                                  {
                                    style: r
                                      ? {
                                          pointerEvents: "none",
                                          overflow: "hidden",
                                          position: "relative",
                                        }
                                      : { pointerEvents: "all" },
                                  },
                                  {
                                    children: [
                                      r ? (0, e.jsx)(Um, { sx: Ro }) : "",
                                      (0, e.jsxs)(
                                        "div",
                                        wN(
                                          { style: { position: "relative" } },
                                          {
                                            children: [
                                              (0, e.jsx)(
                                                um,
                                                wN(
                                                  {
                                                    autoHideDuration: 2e3,
                                                    anchorOrigin: {
                                                      vertical: "bottom",
                                                      horizontal: "right",
                                                    },
                                                    open: i,
                                                  },
                                                  {
                                                    children: (0, e.jsx)(
                                                      Im,
                                                      wN(
                                                        {
                                                          severity: "error",
                                                          onClose: function () {
                                                            zh.next(!1);
                                                          },
                                                        },
                                                        {
                                                          children:
                                                            "Error while processing your request...!!!",
                                                        }
                                                      )
                                                    ),
                                                  }
                                                )
                                              ),
                                              m && "" !== m.token
                                                ? (0, e.jsx)(_j, {
                                                    setIsDrawerOpen: c,
                                                  })
                                                : (0, e.jsx)(PN, {}),
                                            ],
                                          }
                                        )
                                      ),
                                    ],
                                  }
                                )
                              ),
                            }
                          )
                        ),
                      }
                    )
                  );
                }, {}),
              }
            )
          ),
        })
      );
    })();
})();
